(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire13c5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire13c5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7gZDx", function(module, exports) {

var $6gBIz = parcelRequire("6gBIz");
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if ((0, $6gBIz._)(module.exports) === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : undefined, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function flat(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return (typeof obj === "undefined" ? "undefined" : (0, $6gBIz._)(obj)) === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj === "undefined" ? "undefined" : (0, $6gBIz._)(obj);
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function jQuery1(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function toArray() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function get(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function pushStack(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function each(callback) {
            return jQuery.each(this, callback);
        },
        map: function map(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function slice1() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function first() {
            return this.eq(0);
        },
        last: function last() {
            return this.eq(-1);
        },
        even: function even() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function odd() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function eq(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function end() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if ((typeof target === "undefined" ? "undefined" : (0, $6gBIz._)(target)) !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function error(msg) {
            throw new Error(msg);
        },
        noop: function noop() {},
        isPlainObject: function isPlainObject(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function isEmptyObject(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function globalEval(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function each(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function text(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function makeArray(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function inArray(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function isXMLDoc(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function merge(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function grep(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function map(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function sortOrder(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function funescape(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function unloadHandler() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function apply(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function call(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var _$node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return _$node && _$node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var _$node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            _$node = elem.getAttributeNode("id");
                            if (_$node && _$node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                _$node = elem.getAttributeNode("id");
                                if (_$node && _$node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function sortOrder(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function ATTR(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function CHILD(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function PSEUDO(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function TAG(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function CLASS(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function ATTR(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function CHILD(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function PSEUDO(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function target(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function root(elem) {
                    return elem === documentElement;
                },
                focus: function focus(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function checked(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function selected(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function empty(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function parent(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function header(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function input(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function button(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function text(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function superMatcher(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, _$find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (_$find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = _$find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function dir(elem, _dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[_dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function siblings(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function find(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function filter(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function not(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function is(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function init(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function has(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function closest(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function index(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function add(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function addBack(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function parent(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function parents(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function parentsUntil(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function next(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function prev(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function nextAll(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function prevAll(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function nextUntil(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function prevUntil(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function siblings1(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function children(elem) {
            return siblings(elem.firstChild);
        },
        contents: function contents(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function fire() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function add() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function remove() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function has(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function empty() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function disable() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function disabled() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function lock() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function locked1() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function fireWith(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function fire() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function fired1() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function Deferred(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function state1() {
                    return state;
                },
                always: function always() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function pipe() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function then(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function mightThrow() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                ((typeof returned === "undefined" ? "undefined" : (0, $6gBIz._)(returned)) === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function process1() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function promise1(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function when(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function updateFunc(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)["catch"](function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function ready(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function access1(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function fn(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function acceptData(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function cache(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function set(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function get(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function access(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function remove(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function hasData(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function hasData(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function data(elem, name, _data) {
            return dataUser.access(elem, name, _data);
        },
        removeData: function removeData(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function _data(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function _removeData(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function data(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if ((typeof key === "undefined" ? "undefined" : (0, $6gBIz._)(key)) === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function removeData(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function queue(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function dequeue(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function next() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function _queueHooks(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function queue(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function dequeue(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function clearQueue(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function promise(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function resolve() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function isAttached(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function isAttached(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function isHiddenWithinTree(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function currentValue() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, _$nodeName = elem.nodeName, display = defaultDisplayMap[_$nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(_$nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[_$nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function show() {
            return showHide(this, true);
        },
        hide: function hide() {
            return showHide(this);
        },
        toggle: function toggle(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if ((typeof types === "undefined" ? "undefined" : (0, $6gBIz._)(types)) === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function fn(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function add(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function eventHandle(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function remove(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function dispatch(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function handlers(event, _handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = _handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = _handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < _handlers.length) handlerQueue.push({
                elem: cur,
                handlers: _handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function addProp(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function set(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function fix(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function setup(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function trigger(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function _default(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function postDispatch(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function handler(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function preventDefault() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function stopPropagation() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function stopImmediatePropagation() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        char: true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function setup() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function trigger() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function teardown() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function _default(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function setup() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function teardown() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function handle(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function on1(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function one(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function off(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if ((typeof types === "undefined" ? "undefined" : (0, $6gBIz._)(types)) === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var _$nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (_$nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (_$nodeName === "input" || _$nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function htmlPrefilter(html) {
            return html;
        },
        clone: function clone(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function cleanData(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function detach(selector) {
            return remove(this, selector, true);
        },
        remove: function remove1(selector) {
            return remove(this, selector);
        },
        text: function text(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function append() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function prepend() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function before() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function after() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function empty() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function clone(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function html(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function replaceWith() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function getStyles(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function swap(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function boxSizingReliable() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function pixelBoxStyles() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function pixelPosition() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function reliableMarginLeft() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function scrollboxSize() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function reliableTrDimensions() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function get() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var _final = jQuery.cssProps[name] || vendorProps[name];
        if (_final) return _final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function get(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function style(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value === "undefined" ? "undefined" : (0, $6gBIz._)(value);
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function css(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function get(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function set(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function expand(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function css(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function init(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function cur() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function run(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function get(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function set(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function set(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function linear(p) {
            return p;
        },
        swing: function swing(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function tick() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function createTween(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function stop(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function tweener(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function prefilter(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && (typeof speed === "undefined" ? "undefined" : (0, $6gBIz._)(speed)) === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function fadeTo(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function animate(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function doAnimation() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function stop(type, clearQueue, gotoEnd) {
            var stopQueue = function stopQueue(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function finish(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function attr(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function removeAttr(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function attr(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function set(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function removeAttr(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function set(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function prop(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function removeProp(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function prop(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function get(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function get(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function set(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function addClass(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function removeClass(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function toggleClass(value, stateVal) {
            var classNames, className, i, self, type = typeof value === "undefined" ? "undefined" : (0, $6gBIz._)(value), isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function hasClass(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function val(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function get(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function get(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function set(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function set(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function stopPropagationCallback(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function trigger(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, (typeof event === "undefined" ? "undefined" : (0, $6gBIz._)(event)) === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function simulate(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function trigger(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function triggerHandler(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + ((typeof v === "undefined" ? "undefined" : (0, $6gBIz._)(v)) === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function add(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function serialize() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function serializeArray() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s["throws"]) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function ajaxSetup(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function ajax(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if ((typeof url === "undefined" ? "undefined" : (0, $6gBIz._)(url)) === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            _$completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function getResponseHeader(key) {
                    var match;
                    if (_$completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function getAllResponseHeaders() {
                    return _$completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function setRequestHeader(name, value) {
                    if (_$completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function overrideMimeType(type) {
                    if (_$completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function statusCode1(map) {
                    var code;
                    if (map) {
                        if (_$completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function abort(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (_$completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || _$completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (_$completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    _$completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (_$completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (_$completed) return;
                _$completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function getJSON(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function getScript(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function dataFilter(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function wrapAll(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function wrapInner(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function wrap(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function unwrap(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function send(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function abort() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function send(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function abort() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function jsonpCallback() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && (typeof params === "undefined" ? "undefined" : (0, $6gBIz._)(params)) === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function setOffset(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function offset(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function position() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function offsetParent() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function bind(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function unbind(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function delegate(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function undelegate(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function hover(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function proxy() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});
parcelRegister("6gBIz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $49017eb1eb79ae78$export$71511d61b312f219; });
function $49017eb1eb79ae78$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});


parcelRegister("5SVJi", function(module, exports) {

$parcel$export(module.exports, "iframeResizer", function () { return $448ec6cd9b34adc5$export$b6962bfb5a91d43; }, function (v) { return $448ec6cd9b34adc5$export$b6962bfb5a91d43 = v; });
$parcel$export(module.exports, "iframeResizerContentWindow", function () { return $448ec6cd9b34adc5$export$1aafc108bc1f168c; }, function (v) { return $448ec6cd9b34adc5$export$1aafc108bc1f168c = v; });
var $448ec6cd9b34adc5$export$b6962bfb5a91d43;
var $448ec6cd9b34adc5$export$1aafc108bc1f168c;

$448ec6cd9b34adc5$export$b6962bfb5a91d43 = (parcelRequire("9oAvR"));

$448ec6cd9b34adc5$export$1aafc108bc1f168c = (parcelRequire("47u65"));

});
parcelRegister("9oAvR", function(module, exports) {

var $6gBIz = parcelRequire("6gBIz");
/*
 * File: iframeResizer.js
 * Desc: Force iframes to size to content.
 * Requires: iframeResizer.contentWindow.js to be loaded into the target frame.
 * Doc: https://github.com/davidjbradshaw/iframe-resizer
 * Author: David J. Bradshaw - dave@bradshaw.net
 * Contributor: Jure Mav - jure.mav@gmail.com
 * Contributor: Reed Dadoune - reed@dadoune.com
 */ (function(undefined) {
    'use strict';
    if (typeof window === 'undefined') return; // don't run for server side render
    var count = 0, logEnabled = false, hiddenCheckEnabled = false, msgHeader = 'message', msgHeaderLen = msgHeader.length, msgId = '[iFrameSizer]', msgIdLen = msgId.length, pagePosition = null, requestAnimationFrame = window.requestAnimationFrame, resetRequiredMethods = {
        max: 1,
        scroll: 1,
        bodyScroll: 1,
        documentElementScroll: 1
    }, settings = {}, timer = null, logId = 'Host Page', defaults = {
        autoResize: true,
        bodyBackground: null,
        bodyMargin: null,
        bodyMarginV1: 8,
        bodyPadding: null,
        checkOrigin: true,
        inPageLinks: false,
        enablePublicMethods: true,
        heightCalculationMethod: 'bodyOffset',
        id: 'iFrameResizer',
        interval: 32,
        log: false,
        maxHeight: Infinity,
        maxWidth: Infinity,
        minHeight: 0,
        minWidth: 0,
        resizeFrom: 'parent',
        scrolling: false,
        sizeHeight: true,
        sizeWidth: false,
        warningTimeout: 5000,
        tolerance: 0,
        widthCalculationMethod: 'scroll',
        closedCallback: function closedCallback() {},
        initCallback: function initCallback() {},
        messageCallback: function messageCallback() {
            warn('MessageCallback function not defined');
        },
        resizedCallback: function resizedCallback() {},
        scrollCallback: function scrollCallback() {
            return true;
        }
    };
    function getMutationObserver() {
        return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    }
    function addEventListener(obj, evt, func) {
        /* istanbul ignore else */ // Not testable in PhantonJS
        if ('addEventListener' in window) obj.addEventListener(evt, func, false);
        else if ('attachEvent' in window) //IE
        obj.attachEvent('on' + evt, func);
    }
    function removeEventListener(el, evt, func) {
        /* istanbul ignore else */ // Not testable in phantonJS
        if ('removeEventListener' in window) el.removeEventListener(evt, func, false);
        else if ('detachEvent' in window) //IE
        el.detachEvent('on' + evt, func);
    }
    function setupRequestAnimationFrame() {
        var vendors = [
            'moz',
            'webkit',
            'o',
            'ms'
        ], x;
        // Remove vendor prefixing if prefixed and break early if not
        for(x = 0; x < vendors.length && !requestAnimationFrame; x += 1)requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        if (!requestAnimationFrame) log('setup', 'RequestAnimationFrame not supported');
    }
    function getMyID(iframeId) {
        var retStr = 'Host page: ' + iframeId;
        if (window.top !== window.self) {
            if (window.parentIFrame && window.parentIFrame.getId) retStr = window.parentIFrame.getId() + ': ' + iframeId;
            else retStr = 'Nested host page: ' + iframeId;
        }
        return retStr;
    }
    function formatLogHeader(iframeId) {
        return msgId + '[' + getMyID(iframeId) + ']';
    }
    function isLogEnabled(iframeId) {
        return settings[iframeId] ? settings[iframeId].log : logEnabled;
    }
    function log(iframeId, msg) {
        output('log', iframeId, msg, isLogEnabled(iframeId));
    }
    function info(iframeId, msg) {
        output('info', iframeId, msg, isLogEnabled(iframeId));
    }
    function warn(iframeId, msg) {
        output('warn', iframeId, msg, true);
    }
    function output(type, iframeId, msg, enabled) {
        if (true === enabled && 'object' === (0, $6gBIz._)(window.console)) console[type](formatLogHeader(iframeId), msg);
    }
    function iFrameListener(event) {
        function resizeIFrame() {
            function resize() {
                setSize(messageData);
                setPagePosition(iframeId);
                callback('resizedCallback', messageData);
            }
            ensureInRange('Height');
            ensureInRange('Width');
            syncResize(resize, messageData, 'init');
        }
        function processMsg() {
            var data = msg.substr(msgIdLen).split(':');
            return {
                iframe: settings[data[0]] && settings[data[0]].iframe,
                id: data[0],
                height: data[1],
                width: data[2],
                type: data[3]
            };
        }
        function ensureInRange(Dimension) {
            var max = Number(settings[iframeId]['max' + Dimension]), min = Number(settings[iframeId]['min' + Dimension]), dimension = Dimension.toLowerCase(), size = Number(messageData[dimension]);
            log(iframeId, 'Checking ' + dimension + ' is in range ' + min + '-' + max);
            if (size < min) {
                size = min;
                log(iframeId, 'Set ' + dimension + ' to min value');
            }
            if (size > max) {
                size = max;
                log(iframeId, 'Set ' + dimension + ' to max value');
            }
            messageData[dimension] = '' + size;
        }
        function isMessageFromIFrame() {
            function checkAllowedOrigin() {
                function checkList() {
                    var i = 0, retCode = false;
                    log(iframeId, 'Checking connection is from allowed list of origins: ' + checkOrigin);
                    for(; i < checkOrigin.length; i++)if (checkOrigin[i] === origin) {
                        retCode = true;
                        break;
                    }
                    return retCode;
                }
                function checkSingle() {
                    var remoteHost = settings[iframeId] && settings[iframeId].remoteHost;
                    log(iframeId, 'Checking connection is from: ' + remoteHost);
                    return origin === remoteHost;
                }
                return checkOrigin.constructor === Array ? checkList() : checkSingle();
            }
            var origin = event.origin, checkOrigin = settings[iframeId] && settings[iframeId].checkOrigin;
            if (checkOrigin && '' + origin !== 'null' && !checkAllowedOrigin()) throw new Error('Unexpected message received from: ' + origin + ' for ' + messageData.iframe.id + '. Message was: ' + event.data + '. This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains.');
            return true;
        }
        function isMessageForUs() {
            return msgId === ('' + msg).substr(0, msgIdLen) && msg.substr(msgIdLen).split(':')[0] in settings; //''+Protects against non-string msg
        }
        function isMessageFromMetaParent() {
            //Test if this message is from a parent above us. This is an ugly test, however, updating
            //the message format would break backwards compatibity.
            var retCode = messageData.type in {
                "true": 1,
                "false": 1,
                undefined: 1
            };
            if (retCode) log(iframeId, 'Ignoring init message from meta parent page');
            return retCode;
        }
        function getMsgBody(offset) {
            return msg.substr(msg.indexOf(':') + msgHeaderLen + offset);
        }
        function forwardMsgFromIFrame(msgBody) {
            log(iframeId, 'MessageCallback passed: {iframe: ' + messageData.iframe.id + ', message: ' + msgBody + '}');
            callback('messageCallback', {
                iframe: messageData.iframe,
                message: JSON.parse(msgBody)
            });
            log(iframeId, '--');
        }
        function getPageInfo() {
            var bodyPosition = document.body.getBoundingClientRect(), iFramePosition = messageData.iframe.getBoundingClientRect();
            return JSON.stringify({
                iframeHeight: iFramePosition.height,
                iframeWidth: iFramePosition.width,
                clientHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
                clientWidth: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
                offsetTop: parseInt(iFramePosition.top - bodyPosition.top, 10),
                offsetLeft: parseInt(iFramePosition.left - bodyPosition.left, 10),
                scrollTop: window.pageYOffset,
                scrollLeft: window.pageXOffset
            });
        }
        function sendPageInfoToIframe(iframe, iframeId) {
            function debouncedTrigger() {
                trigger('Send Page Info', 'pageInfo:' + getPageInfo(), iframe, iframeId);
            }
            debounceFrameEvents(debouncedTrigger, 32, iframeId);
        }
        function startPageInfoMonitor() {
            function setListener(type, func) {
                function sendPageInfo() {
                    if (settings[id]) sendPageInfoToIframe(settings[id].iframe, id);
                    else stop();
                }
                [
                    'scroll',
                    'resize'
                ].forEach(function(evt) {
                    log(id, type + evt + ' listener for sendPageInfo');
                    func(window, evt, sendPageInfo);
                });
            }
            function stop() {
                setListener('Remove ', removeEventListener);
            }
            function start() {
                setListener('Add ', addEventListener);
            }
            var id = iframeId; //Create locally scoped copy of iFrame ID
            start();
            if (settings[id]) settings[id].stopPageInfo = stop;
        }
        function stopPageInfoMonitor() {
            if (settings[iframeId] && settings[iframeId].stopPageInfo) {
                settings[iframeId].stopPageInfo();
                delete settings[iframeId].stopPageInfo;
            }
        }
        function checkIFrameExists() {
            var retBool = true;
            if (null === messageData.iframe) {
                warn(iframeId, 'IFrame (' + messageData.id + ') not found');
                retBool = false;
            }
            return retBool;
        }
        function getElementPosition(target) {
            var iFramePosition = target.getBoundingClientRect();
            getPagePosition(iframeId);
            return {
                x: Math.floor(Number(iFramePosition.left) + Number(pagePosition.x)),
                y: Math.floor(Number(iFramePosition.top) + Number(pagePosition.y))
            };
        }
        function scrollRequestFromChild(addOffset) {
            /* istanbul ignore next */ //Not testable in Karma
            function reposition() {
                pagePosition = newPosition;
                scrollTo();
                log(iframeId, '--');
            }
            function calcOffset() {
                return {
                    x: Number(messageData.width) + offset.x,
                    y: Number(messageData.height) + offset.y
                };
            }
            function scrollParent() {
                if (window.parentIFrame) window.parentIFrame['scrollTo' + (addOffset ? 'Offset' : '')](newPosition.x, newPosition.y);
                else warn(iframeId, 'Unable to scroll to requested position, window.parentIFrame not found');
            }
            var offset = addOffset ? getElementPosition(messageData.iframe) : {
                x: 0,
                y: 0
            }, newPosition = calcOffset();
            log(iframeId, 'Reposition requested from iFrame (offset x:' + offset.x + ' y:' + offset.y + ')');
            if (window.top !== window.self) scrollParent();
            else reposition();
        }
        function scrollTo() {
            if (false !== callback('scrollCallback', pagePosition)) setPagePosition(iframeId);
            else unsetPagePosition();
        }
        function findTarget(location) {
            function jumpToTarget() {
                var jumpPosition = getElementPosition(target);
                log(iframeId, 'Moving to in page link (#' + hash + ') at x: ' + jumpPosition.x + ' y: ' + jumpPosition.y);
                pagePosition = {
                    x: jumpPosition.x,
                    y: jumpPosition.y
                };
                scrollTo();
                log(iframeId, '--');
            }
            function jumpToParent() {
                if (window.parentIFrame) window.parentIFrame.moveToAnchor(hash);
                else log(iframeId, 'In page link #' + hash + ' not found and window.parentIFrame not found');
            }
            var hash = location.split('#')[1] || '', hashData = decodeURIComponent(hash), target = document.getElementById(hashData) || document.getElementsByName(hashData)[0];
            if (target) jumpToTarget();
            else if (window.top !== window.self) jumpToParent();
            else log(iframeId, 'In page link #' + hash + ' not found');
        }
        function callback(funcName, val) {
            return chkCallback(iframeId, funcName, val);
        }
        function actionMsg() {
            if (settings[iframeId] && settings[iframeId].firstRun) firstRun();
            switch(messageData.type){
                case 'close':
                    if (settings[iframeId].closeRequestCallback) chkCallback(iframeId, 'closeRequestCallback', settings[iframeId].iframe);
                    else closeIFrame(messageData.iframe);
                    break;
                case 'message':
                    forwardMsgFromIFrame(getMsgBody(6));
                    break;
                case 'scrollTo':
                    scrollRequestFromChild(false);
                    break;
                case 'scrollToOffset':
                    scrollRequestFromChild(true);
                    break;
                case 'pageInfo':
                    sendPageInfoToIframe(settings[iframeId] && settings[iframeId].iframe, iframeId);
                    startPageInfoMonitor();
                    break;
                case 'pageInfoStop':
                    stopPageInfoMonitor();
                    break;
                case 'inPageLink':
                    findTarget(getMsgBody(9));
                    break;
                case 'reset':
                    resetIFrame(messageData);
                    break;
                case 'init':
                    resizeIFrame();
                    callback('initCallback', messageData.iframe);
                    break;
                default:
                    resizeIFrame();
            }
        }
        function hasSettings(iframeId) {
            var retBool = true;
            if (!settings[iframeId]) {
                retBool = false;
                warn(messageData.type + ' No settings for ' + iframeId + '. Message was: ' + msg);
            }
            return retBool;
        }
        function iFrameReadyMsgReceived() {
            for(var iframeId in settings)trigger('iFrame requested init', createOutgoingMsg(iframeId), document.getElementById(iframeId), iframeId);
        }
        function firstRun() {
            if (settings[iframeId]) settings[iframeId].firstRun = false;
        }
        function clearWarningTimeout() {
            if (settings[iframeId]) {
                clearTimeout(settings[iframeId].msgTimeout);
                settings[iframeId].warningTimeout = 0;
            }
        }
        var msg = event.data, messageData = {}, iframeId = null;
        if ('[iFrameResizerChild]Ready' === msg) iFrameReadyMsgReceived();
        else if (isMessageForUs()) {
            messageData = processMsg();
            iframeId = logId = messageData.id;
            if (settings[iframeId]) settings[iframeId].loaded = true;
            if (!isMessageFromMetaParent() && hasSettings(iframeId)) {
                log(iframeId, 'Received: ' + msg);
                if (checkIFrameExists() && isMessageFromIFrame()) actionMsg();
            }
        } else info(iframeId, 'Ignored: ' + msg);
    }
    function chkCallback(iframeId, funcName, val) {
        var func = null, retVal = null;
        if (settings[iframeId]) {
            func = settings[iframeId][funcName];
            if ('function' === typeof func) retVal = func(val);
            else throw new TypeError(funcName + ' on iFrame[' + iframeId + '] is not a function');
        }
        return retVal;
    }
    function removeIframeListeners(iframe) {
        var iframeId = iframe.id;
        delete settings[iframeId];
    }
    function closeIFrame(iframe) {
        var iframeId = iframe.id;
        log(iframeId, 'Removing iFrame: ' + iframeId);
        try {
            // Catch race condition error with React
            if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
        } catch (e) {}
        chkCallback(iframeId, 'closedCallback', iframeId);
        log(iframeId, '--');
        removeIframeListeners(iframe);
    }
    function getPagePosition(iframeId) {
        if (null === pagePosition) {
            pagePosition = {
                x: window.pageXOffset !== undefined ? window.pageXOffset : document.documentElement.scrollLeft,
                y: window.pageYOffset !== undefined ? window.pageYOffset : document.documentElement.scrollTop
            };
            log(iframeId, 'Get page position: ' + pagePosition.x + ',' + pagePosition.y);
        }
    }
    function setPagePosition(iframeId) {
        if (null !== pagePosition) {
            window.scrollTo(pagePosition.x, pagePosition.y);
            log(iframeId, 'Set page position: ' + pagePosition.x + ',' + pagePosition.y);
            unsetPagePosition();
        }
    }
    function unsetPagePosition() {
        pagePosition = null;
    }
    function resetIFrame(messageData) {
        function reset() {
            setSize(messageData);
            trigger('reset', 'reset', messageData.iframe, messageData.id);
        }
        log(messageData.id, 'Size reset requested by ' + ('init' === messageData.type ? 'host page' : 'iFrame'));
        getPagePosition(messageData.id);
        syncResize(reset, messageData, 'reset');
    }
    function setSize(messageData) {
        function setDimension(dimension) {
            if (!messageData.id) {
                log('undefined', 'messageData id not set');
                return;
            }
            messageData.iframe.style[dimension] = messageData[dimension] + 'px';
            log(messageData.id, 'IFrame (' + iframeId + ') ' + dimension + ' set to ' + messageData[dimension] + 'px');
        }
        function chkZero(dimension) {
            //FireFox sets dimension of hidden iFrames to zero.
            //So if we detect that set up an event to check for
            //when iFrame becomes visible.
            /* istanbul ignore next */ //Not testable in PhantomJS
            if (!hiddenCheckEnabled && '0' === messageData[dimension]) {
                hiddenCheckEnabled = true;
                log(iframeId, 'Hidden iFrame detected, creating visibility listener');
                fixHiddenIFrames();
            }
        }
        function processDimension(dimension) {
            setDimension(dimension);
            chkZero(dimension);
        }
        var iframeId = messageData.iframe.id;
        if (settings[iframeId]) {
            if (settings[iframeId].sizeHeight) processDimension('height');
            if (settings[iframeId].sizeWidth) processDimension('width');
        }
    }
    function syncResize(func, messageData, doNotSync) {
        /* istanbul ignore if */ //Not testable in PhantomJS
        if (doNotSync !== messageData.type && requestAnimationFrame) {
            log(messageData.id, 'Requesting animation frame');
            requestAnimationFrame(func);
        } else func();
    }
    function trigger(calleeMsg, msg, iframe, id, noResponseWarning) {
        function postMessageToIFrame() {
            var target = settings[id] && settings[id].targetOrigin;
            log(id, '[' + calleeMsg + '] Sending msg to iframe[' + id + '] (' + msg + ') targetOrigin: ' + target);
            iframe.contentWindow.postMessage(msgId + msg, target);
        }
        function iFrameNotFound() {
            warn(id, '[' + calleeMsg + '] IFrame(' + id + ') not found');
        }
        function chkAndSend() {
            if (iframe && 'contentWindow' in iframe && null !== iframe.contentWindow) //Null test for PhantomJS
            postMessageToIFrame();
            else iFrameNotFound();
        }
        function warnOnNoResponse() {
            function warning() {
                if (settings[id] && !settings[id].loaded && !errorShown) {
                    errorShown = true;
                    warn(id, 'IFrame has not responded within ' + settings[id].warningTimeout / 1000 + ' seconds. Check iFrameResizer.contentWindow.js has been loaded in iFrame. This message can be ignored if everything is working, or you can set the warningTimeout option to a higher value or zero to suppress this warning.');
                }
            }
            if (!!noResponseWarning && settings[id] && !!settings[id].warningTimeout) settings[id].msgTimeout = setTimeout(warning, settings[id].warningTimeout);
        }
        var errorShown = false;
        id = id || iframe.id;
        if (settings[id]) {
            chkAndSend();
            warnOnNoResponse();
        }
    }
    function createOutgoingMsg(iframeId) {
        return iframeId + ':' + settings[iframeId].bodyMarginV1 + ':' + settings[iframeId].sizeWidth + ':' + settings[iframeId].log + ':' + settings[iframeId].interval + ':' + settings[iframeId].enablePublicMethods + ':' + settings[iframeId].autoResize + ':' + settings[iframeId].bodyMargin + ':' + settings[iframeId].heightCalculationMethod + ':' + settings[iframeId].bodyBackground + ':' + settings[iframeId].bodyPadding + ':' + settings[iframeId].tolerance + ':' + settings[iframeId].inPageLinks + ':' + settings[iframeId].resizeFrom + ':' + settings[iframeId].widthCalculationMethod;
    }
    function setupIFrame(iframe, options) {
        function setLimits() {
            function addStyle(style) {
                if (Infinity !== settings[iframeId][style] && 0 !== settings[iframeId][style]) {
                    iframe.style[style] = settings[iframeId][style] + 'px';
                    log(iframeId, 'Set ' + style + ' = ' + settings[iframeId][style] + 'px');
                }
            }
            function chkMinMax(dimension) {
                if (settings[iframeId]['min' + dimension] > settings[iframeId]['max' + dimension]) throw new Error('Value for min' + dimension + ' can not be greater than max' + dimension);
            }
            chkMinMax('Height');
            chkMinMax('Width');
            addStyle('maxHeight');
            addStyle('minHeight');
            addStyle('maxWidth');
            addStyle('minWidth');
        }
        function newId() {
            var id = options && options.id || defaults.id + count++;
            if (null !== document.getElementById(id)) id = id + count++;
            return id;
        }
        function ensureHasId(iframeId) {
            logId = iframeId;
            if ('' === iframeId) {
                iframe.id = iframeId = newId();
                logEnabled = (options || {}).log;
                logId = iframeId;
                log(iframeId, 'Added missing iframe ID: ' + iframeId + ' (' + iframe.src + ')');
            }
            return iframeId;
        }
        function setScrolling() {
            log(iframeId, 'IFrame scrolling ' + (settings[iframeId] && settings[iframeId].scrolling ? 'enabled' : 'disabled') + ' for ' + iframeId);
            iframe.style.overflow = false === (settings[iframeId] && settings[iframeId].scrolling) ? 'hidden' : 'auto';
            switch(settings[iframeId] && settings[iframeId].scrolling){
                case 'omit':
                    break;
                case true:
                    iframe.scrolling = 'yes';
                    break;
                case false:
                    iframe.scrolling = 'no';
                    break;
                default:
                    iframe.scrolling = settings[iframeId] ? settings[iframeId].scrolling : 'no';
            }
        }
        //The V1 iFrame script expects an int, where as in V2 expects a CSS
        //string value such as '1px 3em', so if we have an int for V2, set V1=V2
        //and then convert V2 to a string PX value.
        function setupBodyMarginValues() {
            if ('number' === typeof (settings[iframeId] && settings[iframeId].bodyMargin) || '0' === (settings[iframeId] && settings[iframeId].bodyMargin)) {
                settings[iframeId].bodyMarginV1 = settings[iframeId].bodyMargin;
                settings[iframeId].bodyMargin = '' + settings[iframeId].bodyMargin + 'px';
            }
        }
        function checkReset() {
            // Reduce scope of firstRun to function, because IE8's JS execution
            // context stack is borked and this value gets externally
            // changed midway through running this function!!!
            var firstRun = settings[iframeId] && settings[iframeId].firstRun, resetRequertMethod = settings[iframeId] && settings[iframeId].heightCalculationMethod in resetRequiredMethods;
            if (!firstRun && resetRequertMethod) resetIFrame({
                iframe: iframe,
                height: 0,
                width: 0,
                type: 'init'
            });
        }
        function setupIFrameObject() {
            if (Function.prototype.bind && settings[iframeId]) //Ignore unpolyfilled IE8.
            settings[iframeId].iframe.iFrameResizer = {
                close: closeIFrame.bind(null, settings[iframeId].iframe),
                removeListeners: removeIframeListeners.bind(null, settings[iframeId].iframe),
                resize: trigger.bind(null, 'Window resize', 'resize', settings[iframeId].iframe),
                moveToAnchor: function moveToAnchor(anchor) {
                    trigger('Move to anchor', 'moveToAnchor:' + anchor, settings[iframeId].iframe, iframeId);
                },
                sendMessage: function sendMessage(message) {
                    message = JSON.stringify(message);
                    trigger('Send Message', 'message:' + message, settings[iframeId].iframe, iframeId);
                }
            };
        }
        //We have to call trigger twice, as we can not be sure if all
        //iframes have completed loading when this code runs. The
        //event listener also catches the page changing in the iFrame.
        function init(msg) {
            function iFrameLoaded() {
                trigger('iFrame.onload', msg, iframe, undefined, true);
                checkReset();
            }
            function createDestroyObserver(MutationObserver) {
                if (!iframe.parentNode) return;
                var destroyObserver = new MutationObserver(function(mutations) {
                    mutations.forEach(function(mutation) {
                        var removedNodes = Array.prototype.slice.call(mutation.removedNodes); // Transform NodeList into an Array
                        removedNodes.forEach(function(removedNode) {
                            if (removedNode === iframe) closeIFrame(iframe);
                        });
                    });
                });
                destroyObserver.observe(iframe.parentNode, {
                    childList: true
                });
            }
            var MutationObserver = getMutationObserver();
            if (MutationObserver) createDestroyObserver(MutationObserver);
            addEventListener(iframe, 'load', iFrameLoaded);
            trigger('init', msg, iframe, undefined, true);
        }
        function checkOptions(options) {
            if ('object' !== (typeof options === "undefined" ? "undefined" : (0, $6gBIz._)(options))) throw new TypeError('Options is not an object');
        }
        function copyOptions(options) {
            for(var option in defaults)if (defaults.hasOwnProperty(option)) settings[iframeId][option] = options.hasOwnProperty(option) ? options[option] : defaults[option];
        }
        function getTargetOrigin(remoteHost) {
            return '' === remoteHost || 'file://' === remoteHost ? '*' : remoteHost;
        }
        function processOptions(options) {
            options = options || {};
            settings[iframeId] = {
                firstRun: true,
                iframe: iframe,
                remoteHost: iframe.src.split('/').slice(0, 3).join('/')
            };
            checkOptions(options);
            copyOptions(options);
            if (settings[iframeId]) settings[iframeId].targetOrigin = true === settings[iframeId].checkOrigin ? getTargetOrigin(settings[iframeId].remoteHost) : '*';
        }
        function beenHere() {
            return iframeId in settings && 'iFrameResizer' in iframe;
        }
        var iframeId = ensureHasId(iframe.id);
        if (!beenHere()) {
            processOptions(options);
            setScrolling();
            setLimits();
            setupBodyMarginValues();
            init(createOutgoingMsg(iframeId));
            setupIFrameObject();
        } else warn(iframeId, 'Ignored iFrame, already setup.');
    }
    function debouce(fn, time) {
        if (null === timer) timer = setTimeout(function() {
            timer = null;
            fn();
        }, time);
    }
    var frameTimer = {};
    function debounceFrameEvents(fn, time, frameId) {
        if (!frameTimer[frameId]) frameTimer[frameId] = setTimeout(function() {
            frameTimer[frameId] = null;
            fn();
        }, time);
    } //Not testable in PhantomJS
    /* istanbul ignore next */ function fixHiddenIFrames() {
        function checkIFrames() {
            function checkIFrame(settingId) {
                function chkDimension(dimension) {
                    return '0px' === (settings[settingId] && settings[settingId].iframe.style[dimension]);
                }
                function isVisible(el) {
                    return null !== el.offsetParent;
                }
                if (settings[settingId] && isVisible(settings[settingId].iframe) && (chkDimension('height') || chkDimension('width'))) trigger('Visibility change', 'resize', settings[settingId].iframe, settingId);
            }
            for(var settingId in settings)checkIFrame(settingId);
        }
        function mutationObserved(mutations) {
            log('window', 'Mutation observed: ' + mutations[0].target + ' ' + mutations[0].type);
            debouce(checkIFrames, 16);
        }
        function createMutationObserver() {
            var target = document.querySelector('body'), config = {
                attributes: true,
                attributeOldValue: false,
                characterData: true,
                characterDataOldValue: false,
                childList: true,
                subtree: true
            }, observer = new MutationObserver(mutationObserved);
            observer.observe(target, config);
        }
        var MutationObserver = getMutationObserver();
        if (MutationObserver) createMutationObserver();
    }
    function resizeIFrames(event) {
        function resize() {
            sendTriggerMsg('Window ' + event, 'resize');
        }
        log('window', 'Trigger event: ' + event);
        debouce(resize, 16);
    } //Not testable in PhantomJS
    /* istanbul ignore next */ function tabVisible() {
        function resize() {
            sendTriggerMsg('Tab Visable', 'resize');
        }
        if ('hidden' !== document.visibilityState) {
            log('document', 'Trigger event: Visiblity change');
            debouce(resize, 16);
        }
    }
    function sendTriggerMsg(eventName, event) {
        function isIFrameResizeEnabled(iframeId) {
            return settings[iframeId] && 'parent' === settings[iframeId].resizeFrom && settings[iframeId].autoResize && !settings[iframeId].firstRun;
        }
        for(var iframeId in settings)if (isIFrameResizeEnabled(iframeId)) trigger(eventName, event, document.getElementById(iframeId), iframeId);
    }
    function setupEventListeners() {
        addEventListener(window, 'message', iFrameListener);
        addEventListener(window, 'resize', function() {
            resizeIFrames('resize');
        });
        addEventListener(document, 'visibilitychange', tabVisible);
        addEventListener(document, '-webkit-visibilitychange', tabVisible); //Andriod 4.4
        addEventListener(window, 'focusin', function() {
            resizeIFrames('focus');
        }); //IE8-9
        addEventListener(window, 'focus', function() {
            resizeIFrames('focus');
        });
    }
    function factory() {
        function init(options, element) {
            function chkType() {
                if (!element.tagName) throw new TypeError('Object is not a valid DOM element');
                else if ('IFRAME' !== element.tagName.toUpperCase()) throw new TypeError('Expected <IFRAME> tag, found <' + element.tagName + '>');
            }
            if (element) {
                chkType();
                setupIFrame(element, options);
                iFrames.push(element);
            }
        }
        function warnDeprecatedOptions(options) {
            if (options && options.enablePublicMethods) warn('enablePublicMethods option has been removed, public methods are now always available in the iFrame');
        }
        var iFrames;
        setupRequestAnimationFrame();
        setupEventListeners();
        return function iFrameResizeF(options, target) {
            iFrames = []; //Only return iFrames past in on this call
            warnDeprecatedOptions(options);
            switch(typeof target === "undefined" ? "undefined" : (0, $6gBIz._)(target)){
                case 'undefined':
                case 'string':
                    Array.prototype.forEach.call(document.querySelectorAll(target || 'iframe'), init.bind(undefined, options));
                    break;
                case 'object':
                    init(options, target);
                    break;
                default:
                    throw new TypeError('Unexpected data type (' + (typeof target === "undefined" ? "undefined" : (0, $6gBIz._)(target)) + ')');
            }
            return iFrames;
        };
    }
    function createJQueryPublicMethod($) {
        if (!$.fn) info('', 'Unable to bind to jQuery, it is not fully loaded.');
        else if (!$.fn.iFrameResize) $.fn.iFrameResize = function $iFrameResizeF(options) {
            function init(index, element) {
                setupIFrame(element, options);
            }
            return this.filter('iframe').each(init).end();
        };
    }
    if (window.jQuery) createJQueryPublicMethod(window.jQuery);
    if (typeof define === 'function' && define.amd) define([], factory);
    else if ((0, $6gBIz._)(module.exports) === 'object') //Node for browserfy
    module.exports = factory();
    window.iFrameResize = window.iFrameResize || factory();
})();

});

parcelRegister("47u65", function(module, exports) {

var $6gBIz = parcelRequire("6gBIz");
/*
 * File: iframeResizer.contentWindow.js
 * Desc: Include this file in any page being loaded into an iframe
 *       to force the iframe to resize to the content size.
 * Requires: iframeResizer.js on host page.
 * Doc: https://github.com/davidjbradshaw/iframe-resizer
 * Author: David J. Bradshaw - dave@bradshaw.net
 * Contributor: Jure Mav - jure.mav@gmail.com
 * Contributor: Ian Caunce - ian@hallnet.co.uk
 */ (function(undefined) {
    'use strict';
    if (typeof window === 'undefined') return; // don't run for server side render
    var autoResize = true, base = 10, bodyBackground = '', bodyMargin = 0, bodyMarginStr = '', bodyObserver = null, bodyPadding = '', calculateWidth = false, doubleEventList = {
        resize: 1,
        click: 1
    }, eventCancelTimer = 128, firstRun = true, height = 1, heightCalcModeDefault = 'bodyOffset', heightCalcMode = heightCalcModeDefault, initLock = true, initMsg = '', inPageLinks = {}, interval = 32, intervalTimer = null, logging = false, msgID = '[iFrameSizer]', msgIdLen = msgID.length, myID = '', observer = null, resetRequiredMethods = {
        max: 1,
        min: 1,
        bodyScroll: 1,
        documentElementScroll: 1
    }, resizeFrom = 'child', sendPermit = true, target = window.parent, targetOriginDefault = '*', tolerance = 0, triggerLocked = false, triggerLockedTimer = null, throttledTimer = 16, width = 1, widthCalcModeDefault = 'scroll', widthCalcMode = widthCalcModeDefault, win = window, messageCallback = function messageCallback() {
        warn('MessageCallback function not defined');
    }, readyCallback = function readyCallback() {}, pageInfoCallback = function pageInfoCallback() {}, customCalcMethods = {
        height: function height() {
            warn('Custom height calculation function not defined');
            return document.documentElement.offsetHeight;
        },
        width: function width() {
            warn('Custom width calculation function not defined');
            return document.body.scrollWidth;
        }
    }, eventHandlersByName = {}, passiveSupported = false, onceSupported = false;
    function noop() {}
    try {
        var options = Object.create({}, {
            passive: {
                get: function get() {
                    passiveSupported = true;
                }
            },
            once: {
                get: function get() {
                    onceSupported = true;
                }
            }
        });
        window.addEventListener('test', noop, options);
        window.removeEventListener('test', noop, options);
    } catch (e) {
    /* */ }
    function addEventListener(el, evt, func, options) {
        /* istanbul ignore else */ // Not testable in phantomJS
        if ('addEventListener' in window) el.addEventListener(evt, func, passiveSupported ? options || {} : false);
        else if ('attachEvent' in window) //IE
        el.attachEvent('on' + evt, func);
    }
    function removeEventListener(el, evt, func) {
        /* istanbul ignore else */ // Not testable in phantomJS
        if ('removeEventListener' in window) el.removeEventListener(evt, func, false);
        else if ('detachEvent' in window) //IE
        el.detachEvent('on' + evt, func);
    }
    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    //Based on underscore.js
    function throttle(func) {
        var context, args, result, timeout = null, previous = 0, later = function later() {
            previous = getNow();
            timeout = null;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        };
        return function() {
            var now = getNow();
            if (!previous) previous = now;
            var remaining = throttledTimer - (now - previous);
            context = this;
            args = arguments;
            if (remaining <= 0 || remaining > throttledTimer) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
                previous = now;
                result = func.apply(context, args);
                if (!timeout) context = args = null;
            } else if (!timeout) timeout = setTimeout(later, remaining);
            return result;
        };
    }
    var getNow = Date.now || function() {
        /* istanbul ignore next */ // Not testable in PhantonJS
        return new Date().getTime();
    };
    function formatLogMsg(msg) {
        return msgID + '[' + myID + ']' + ' ' + msg;
    }
    function log(msg) {
        if (logging && 'object' === (0, $6gBIz._)(window.console)) console.log(formatLogMsg(msg));
    }
    function warn(msg) {
        if ('object' === (0, $6gBIz._)(window.console)) console.warn(formatLogMsg(msg));
    }
    function init() {
        readDataFromParent();
        log('Initialising iFrame (' + location.href + ')');
        readDataFromPage();
        setMargin();
        setBodyStyle('background', bodyBackground);
        setBodyStyle('padding', bodyPadding);
        injectClearFixIntoBodyElement();
        checkHeightMode();
        checkWidthMode();
        stopInfiniteResizingOfIFrame();
        setupPublicMethods();
        startEventListeners();
        inPageLinks = setupInPageLinks();
        sendSize('init', 'Init message from host page');
        readyCallback();
    }
    function readDataFromParent() {
        function strBool(str) {
            return 'true' === str ? true : false;
        }
        var data = initMsg.substr(msgIdLen).split(':');
        myID = data[0];
        bodyMargin = undefined !== data[1] ? Number(data[1]) : bodyMargin; //For V1 compatibility
        calculateWidth = undefined !== data[2] ? strBool(data[2]) : calculateWidth;
        logging = undefined !== data[3] ? strBool(data[3]) : logging;
        interval = undefined !== data[4] ? Number(data[4]) : interval;
        autoResize = undefined !== data[6] ? strBool(data[6]) : autoResize;
        bodyMarginStr = data[7];
        heightCalcMode = undefined !== data[8] ? data[8] : heightCalcMode;
        bodyBackground = data[9];
        bodyPadding = data[10];
        tolerance = undefined !== data[11] ? Number(data[11]) : tolerance;
        inPageLinks.enable = undefined !== data[12] ? strBool(data[12]) : false;
        resizeFrom = undefined !== data[13] ? data[13] : resizeFrom;
        widthCalcMode = undefined !== data[14] ? data[14] : widthCalcMode;
    }
    function readDataFromPage() {
        function readData() {
            var data = window.iFrameResizer;
            log('Reading data from page: ' + JSON.stringify(data));
            messageCallback = 'messageCallback' in data ? data.messageCallback : messageCallback;
            readyCallback = 'readyCallback' in data ? data.readyCallback : readyCallback;
            targetOriginDefault = 'targetOrigin' in data ? data.targetOrigin : targetOriginDefault;
            heightCalcMode = 'heightCalculationMethod' in data ? data.heightCalculationMethod : heightCalcMode;
            widthCalcMode = 'widthCalculationMethod' in data ? data.widthCalculationMethod : widthCalcMode;
        }
        function setupCustomCalcMethods(calcMode, calcFunc) {
            if ('function' === typeof calcMode) {
                log('Setup custom ' + calcFunc + 'CalcMethod');
                customCalcMethods[calcFunc] = calcMode;
                calcMode = 'custom';
            }
            return calcMode;
        }
        if ('iFrameResizer' in window && Object === window.iFrameResizer.constructor) {
            readData();
            heightCalcMode = setupCustomCalcMethods(heightCalcMode, 'height');
            widthCalcMode = setupCustomCalcMethods(widthCalcMode, 'width');
        }
        log('TargetOrigin for parent set to: ' + targetOriginDefault);
    }
    function chkCSS(attr, value) {
        if (-1 !== value.indexOf('-')) {
            warn('Negative CSS value ignored for ' + attr);
            value = '';
        }
        return value;
    }
    function setBodyStyle(attr, value) {
        if (undefined !== value && '' !== value && 'null' !== value) {
            document.body.style[attr] = value;
            log('Body ' + attr + ' set to "' + value + '"');
        }
    }
    function setMargin() {
        //If called via V1 script, convert bodyMargin from int to str
        if (undefined === bodyMarginStr) bodyMarginStr = bodyMargin + 'px';
        setBodyStyle('margin', chkCSS('margin', bodyMarginStr));
    }
    function stopInfiniteResizingOfIFrame() {
        document.documentElement.style.height = '';
        document.body.style.height = '';
        log('HTML & body height set to "auto"');
    }
    function manageTriggerEvent(options) {
        var listener = {
            add: function add(eventName) {
                function handleEvent() {
                    sendSize(options.eventName, options.eventType);
                }
                eventHandlersByName[eventName] = handleEvent;
                addEventListener(window, eventName, handleEvent, {
                    passive: true
                });
            },
            remove: function remove(eventName) {
                var handleEvent = eventHandlersByName[eventName];
                delete eventHandlersByName[eventName];
                removeEventListener(window, eventName, handleEvent);
            }
        };
        if (options.eventNames && Array.prototype.map) {
            options.eventName = options.eventNames[0];
            options.eventNames.map(listener[options.method]);
        } else listener[options.method](options.eventName);
        log(capitalizeFirstLetter(options.method) + ' event listener: ' + options.eventType);
    }
    function manageEventListeners(method) {
        manageTriggerEvent({
            method: method,
            eventType: 'Animation Start',
            eventNames: [
                'animationstart',
                'webkitAnimationStart'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Animation Iteration',
            eventNames: [
                'animationiteration',
                'webkitAnimationIteration'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Animation End',
            eventNames: [
                'animationend',
                'webkitAnimationEnd'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Input',
            eventName: 'input'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Mouse Up',
            eventName: 'mouseup'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Mouse Down',
            eventName: 'mousedown'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Orientation Change',
            eventName: 'orientationchange'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Print',
            eventName: [
                'afterprint',
                'beforeprint'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Ready State Change',
            eventName: 'readystatechange'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Touch Start',
            eventName: 'touchstart'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Touch End',
            eventName: 'touchend'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Touch Cancel',
            eventName: 'touchcancel'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Transition Start',
            eventNames: [
                'transitionstart',
                'webkitTransitionStart',
                'MSTransitionStart',
                'oTransitionStart',
                'otransitionstart'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Transition Iteration',
            eventNames: [
                'transitioniteration',
                'webkitTransitionIteration',
                'MSTransitionIteration',
                'oTransitionIteration',
                'otransitioniteration'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Transition End',
            eventNames: [
                'transitionend',
                'webkitTransitionEnd',
                'MSTransitionEnd',
                'oTransitionEnd',
                'otransitionend'
            ]
        });
        if ('child' === resizeFrom) manageTriggerEvent({
            method: method,
            eventType: 'IFrame Resized',
            eventName: 'resize'
        });
    }
    function checkCalcMode(calcMode, calcModeDefault, modes, type) {
        if (calcModeDefault !== calcMode) {
            if (!(calcMode in modes)) {
                warn(calcMode + ' is not a valid option for ' + type + 'CalculationMethod.');
                calcMode = calcModeDefault;
            }
            log(type + ' calculation method set to "' + calcMode + '"');
        }
        return calcMode;
    }
    function checkHeightMode() {
        heightCalcMode = checkCalcMode(heightCalcMode, heightCalcModeDefault, getHeight, 'height');
    }
    function checkWidthMode() {
        widthCalcMode = checkCalcMode(widthCalcMode, widthCalcModeDefault, getWidth, 'width');
    }
    function startEventListeners() {
        if (true === autoResize) {
            manageEventListeners('add');
            setupMutationObserver();
        } else log('Auto Resize disabled');
    }
    function stopMsgsToParent() {
        log('Disable outgoing messages');
        sendPermit = false;
    }
    function removeMsgListener() {
        log('Remove event listener: Message');
        removeEventListener(window, 'message', receiver);
    }
    function disconnectMutationObserver() {
        if (null !== bodyObserver) /* istanbul ignore next */ // Not testable in PhantonJS
        bodyObserver.disconnect();
    }
    function stopEventListeners() {
        manageEventListeners('remove');
        disconnectMutationObserver();
        clearInterval(intervalTimer);
    }
    function teardown() {
        stopMsgsToParent();
        removeMsgListener();
        if (true === autoResize) stopEventListeners();
    }
    function injectClearFixIntoBodyElement() {
        var clearFix = document.createElement('div');
        clearFix.style.clear = 'both';
        clearFix.style.display = 'block'; //Guard against this having been globally redefined in CSS.
        document.body.appendChild(clearFix);
    }
    function setupInPageLinks() {
        function getPagePosition() {
            return {
                x: window.pageXOffset !== undefined ? window.pageXOffset : document.documentElement.scrollLeft,
                y: window.pageYOffset !== undefined ? window.pageYOffset : document.documentElement.scrollTop
            };
        }
        function getElementPosition(el) {
            var elPosition = el.getBoundingClientRect(), pagePosition = getPagePosition();
            return {
                x: parseInt(elPosition.left, 10) + parseInt(pagePosition.x, 10),
                y: parseInt(elPosition.top, 10) + parseInt(pagePosition.y, 10)
            };
        }
        function findTarget(location1) {
            function jumpToTarget(target) {
                var jumpPosition = getElementPosition(target);
                log('Moving to in page link (#' + hash + ') at x: ' + jumpPosition.x + ' y: ' + jumpPosition.y);
                sendMsg(jumpPosition.y, jumpPosition.x, 'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
            }
            var hash = location1.split('#')[1] || location1, hashData = decodeURIComponent(hash), target = document.getElementById(hashData) || document.getElementsByName(hashData)[0];
            if (undefined !== target) jumpToTarget(target);
            else {
                log('In page link (#' + hash + ') not found in iFrame, so sending to parent');
                sendMsg(0, 0, 'inPageLink', '#' + hash);
            }
        }
        function checkLocationHash() {
            if ('' !== location.hash && '#' !== location.hash) findTarget(location.href);
        }
        function bindAnchors() {
            function setupLink(el) {
                function linkClicked(e) {
                    e.preventDefault();
                    /*jshint validthis:true */ findTarget(this.getAttribute('href'));
                }
                if ('#' !== el.getAttribute('href')) addEventListener(el, 'click', linkClicked);
            }
            Array.prototype.forEach.call(document.querySelectorAll('a[href^="#"]'), setupLink);
        }
        function bindLocationHash() {
            addEventListener(window, 'hashchange', checkLocationHash);
        }
        function initCheck() {
            //check if page loaded with location hash after init resize
            setTimeout(checkLocationHash, eventCancelTimer);
        }
        function enableInPageLinks() {
            /* istanbul ignore else */ // Not testable in phantonJS
            if (Array.prototype.forEach && document.querySelectorAll) {
                log('Setting up location.hash handlers');
                bindAnchors();
                bindLocationHash();
                initCheck();
            } else warn('In page linking not fully supported in this browser! (See README.md for IE8 workaround)');
        }
        if (inPageLinks.enable) enableInPageLinks();
        else log('In page linking not enabled');
        return {
            findTarget: findTarget
        };
    }
    function setupPublicMethods() {
        log('Enable public methods');
        win.parentIFrame = {
            autoResize: function autoResizeF(resize) {
                if (true === resize && false === autoResize) {
                    autoResize = true;
                    startEventListeners();
                //sendSize('autoResize','Auto Resize enabled');
                } else if (false === resize && true === autoResize) {
                    autoResize = false;
                    stopEventListeners();
                }
                return autoResize;
            },
            close: function closeF() {
                sendMsg(0, 0, 'close');
                teardown();
            },
            getId: function getIdF() {
                return myID;
            },
            getPageInfo: function getPageInfoF(callback) {
                if ('function' === typeof callback) {
                    pageInfoCallback = callback;
                    sendMsg(0, 0, 'pageInfo');
                } else {
                    pageInfoCallback = function pageInfoCallback() {};
                    sendMsg(0, 0, 'pageInfoStop');
                }
            },
            moveToAnchor: function moveToAnchorF(hash) {
                inPageLinks.findTarget(hash);
            },
            reset: function resetF() {
                resetIFrame('parentIFrame.reset');
            },
            scrollTo: function scrollToF(x, y) {
                sendMsg(y, x, 'scrollTo'); // X&Y reversed at sendMsg uses height/width
            },
            scrollToOffset: function scrollToF(x, y) {
                sendMsg(y, x, 'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
            },
            sendMessage: function sendMessageF(msg, targetOrigin) {
                sendMsg(0, 0, 'message', JSON.stringify(msg), targetOrigin);
            },
            setHeightCalculationMethod: function setHeightCalculationMethodF(heightCalculationMethod) {
                heightCalcMode = heightCalculationMethod;
                checkHeightMode();
            },
            setWidthCalculationMethod: function setWidthCalculationMethodF(widthCalculationMethod) {
                widthCalcMode = widthCalculationMethod;
                checkWidthMode();
            },
            setTargetOrigin: function setTargetOriginF(targetOrigin) {
                log('Set targetOrigin: ' + targetOrigin);
                targetOriginDefault = targetOrigin;
            },
            size: function sizeF(customHeight, customWidth) {
                var valString = '' + (customHeight ? customHeight : '') + (customWidth ? ',' + customWidth : '');
                //lockTrigger();
                sendSize('size', 'parentIFrame.size(' + valString + ')', customHeight, customWidth);
            }
        };
    }
    function initInterval() {
        if (0 !== interval) {
            log('setInterval: ' + interval + 'ms');
            intervalTimer = setInterval(function() {
                sendSize('interval', 'setInterval: ' + interval);
            }, Math.abs(interval));
        }
    } //Not testable in PhantomJS
    /* istanbul ignore next */ function setupBodyMutationObserver() {
        function addImageLoadListners(mutation) {
            function addImageLoadListener(element) {
                if (false === element.complete) {
                    log('Attach listeners to ' + element.src);
                    element.addEventListener('load', imageLoaded, false);
                    element.addEventListener('error', imageError, false);
                    elements.push(element);
                }
            }
            if (mutation.type === 'attributes' && mutation.attributeName === 'src') addImageLoadListener(mutation.target);
            else if (mutation.type === 'childList') Array.prototype.forEach.call(mutation.target.querySelectorAll('img'), addImageLoadListener);
        }
        function removeFromArray(element) {
            elements.splice(elements.indexOf(element), 1);
        }
        function removeImageLoadListener(element) {
            log('Remove listeners from ' + element.src);
            element.removeEventListener('load', imageLoaded, false);
            element.removeEventListener('error', imageError, false);
            removeFromArray(element);
        }
        function imageEventTriggered(event, type, typeDesc) {
            removeImageLoadListener(event.target);
            sendSize(type, typeDesc + ': ' + event.target.src, undefined, undefined);
        }
        function imageLoaded(event) {
            imageEventTriggered(event, 'imageLoad', 'Image loaded');
        }
        function imageError(event) {
            imageEventTriggered(event, 'imageLoadFailed', 'Image load failed');
        }
        function mutationObserved(mutations) {
            sendSize('mutationObserver', 'mutationObserver: ' + mutations[0].target + ' ' + mutations[0].type);
            //Deal with WebKit asyncing image loading when tags are injected into the page
            mutations.forEach(addImageLoadListners);
        }
        function createMutationObserver() {
            var target = document.querySelector('body'), config = {
                attributes: true,
                attributeOldValue: false,
                characterData: true,
                characterDataOldValue: false,
                childList: true,
                subtree: true
            };
            observer = new MutationObserver(mutationObserved);
            log('Create body MutationObserver');
            observer.observe(target, config);
            return observer;
        }
        var elements = [], MutationObserver = window.MutationObserver || window.WebKitMutationObserver, observer = createMutationObserver();
        return {
            disconnect: function disconnect() {
                if ('disconnect' in observer) {
                    log('Disconnect body MutationObserver');
                    observer.disconnect();
                    elements.forEach(removeImageLoadListener);
                }
            }
        };
    }
    function setupMutationObserver() {
        var forceIntervalTimer = 0 > interval; // Not testable in PhantomJS
        /* istanbul ignore if */ if (window.MutationObserver || window.WebKitMutationObserver) {
            if (forceIntervalTimer) initInterval();
            else bodyObserver = setupBodyMutationObserver();
        } else {
            log('MutationObserver not supported in this browser!');
            initInterval();
        }
    }
    // document.documentElement.offsetHeight is not reliable, so
    // we have to jump through hoops to get a better value.
    function getComputedStyle(prop, el) {
        /* istanbul ignore next */ //Not testable in PhantomJS
        function convertUnitsToPxForIE8(value) {
            var PIXEL = /^\d+(px)?$/i;
            if (PIXEL.test(value)) return parseInt(value, base);
            var style = el.style.left, runtimeStyle = el.runtimeStyle.left;
            el.runtimeStyle.left = el.currentStyle.left;
            el.style.left = value || 0;
            value = el.style.pixelLeft;
            el.style.left = style;
            el.runtimeStyle.left = runtimeStyle;
            return value;
        }
        var retVal = 0;
        el = el || document.body; // Not testable in phantonJS
        /* istanbul ignore else */ if ('defaultView' in document && 'getComputedStyle' in document.defaultView) {
            retVal = document.defaultView.getComputedStyle(el, null);
            retVal = null !== retVal ? retVal[prop] : 0;
        } else //IE8
        retVal = convertUnitsToPxForIE8(el.currentStyle[prop]);
        return parseInt(retVal, base);
    }
    function chkEventThottle(timer) {
        if (timer > throttledTimer / 2) {
            throttledTimer = 2 * timer;
            log('Event throttle increased to ' + throttledTimer + 'ms');
        }
    }
    //Idea from https://github.com/guardian/iframe-messenger
    function getMaxElement(side, elements) {
        var elementsLength = elements.length, elVal = 0, maxVal = 0, Side = capitalizeFirstLetter(side), timer = getNow();
        for(var i = 0; i < elementsLength; i++){
            elVal = elements[i].getBoundingClientRect()[side] + getComputedStyle('margin' + Side, elements[i]);
            if (elVal > maxVal) maxVal = elVal;
        }
        timer = getNow() - timer;
        log('Parsed ' + elementsLength + ' HTML elements');
        log('Element position calculated in ' + timer + 'ms');
        chkEventThottle(timer);
        return maxVal;
    }
    function getAllMeasurements(dimention) {
        return [
            dimention.bodyOffset(),
            dimention.bodyScroll(),
            dimention.documentElementOffset(),
            dimention.documentElementScroll()
        ];
    }
    function getTaggedElements(side, tag) {
        function noTaggedElementsFound() {
            warn('No tagged elements (' + tag + ') found on page');
            return document.querySelectorAll('body *');
        }
        var elements = document.querySelectorAll('[' + tag + ']');
        if (0 === elements.length) noTaggedElementsFound();
        return getMaxElement(side, elements);
    }
    function getAllElements() {
        return document.querySelectorAll('body *');
    }
    var getHeight = {
        bodyOffset: function getBodyOffsetHeight() {
            return document.body.offsetHeight + getComputedStyle('marginTop') + getComputedStyle('marginBottom');
        },
        offset: function offset() {
            return getHeight.bodyOffset(); //Backwards compatability
        },
        bodyScroll: function getBodyScrollHeight() {
            return document.body.scrollHeight;
        },
        custom: function getCustomWidth() {
            return customCalcMethods.height();
        },
        documentElementOffset: function getDEOffsetHeight() {
            return document.documentElement.offsetHeight;
        },
        documentElementScroll: function getDEScrollHeight() {
            return document.documentElement.scrollHeight;
        },
        max: function getMaxHeight() {
            return Math.max.apply(null, getAllMeasurements(getHeight));
        },
        min: function getMinHeight() {
            return Math.min.apply(null, getAllMeasurements(getHeight));
        },
        grow: function growHeight() {
            return getHeight.max(); //Run max without the forced downsizing
        },
        lowestElement: function getBestHeight() {
            return Math.max(getHeight.bodyOffset() || getHeight.documentElementOffset(), getMaxElement('bottom', getAllElements()));
        },
        taggedElement: function getTaggedElementsHeight() {
            return getTaggedElements('bottom', 'data-iframe-height');
        }
    }, getWidth = {
        bodyScroll: function getBodyScrollWidth() {
            return document.body.scrollWidth;
        },
        bodyOffset: function getBodyOffsetWidth() {
            return document.body.offsetWidth;
        },
        custom: function getCustomWidth() {
            return customCalcMethods.width();
        },
        documentElementScroll: function getDEScrollWidth() {
            return document.documentElement.scrollWidth;
        },
        documentElementOffset: function getDEOffsetWidth() {
            return document.documentElement.offsetWidth;
        },
        scroll: function getMaxWidth() {
            return Math.max(getWidth.bodyScroll(), getWidth.documentElementScroll());
        },
        max: function getMaxWidth() {
            return Math.max.apply(null, getAllMeasurements(getWidth));
        },
        min: function getMinWidth() {
            return Math.min.apply(null, getAllMeasurements(getWidth));
        },
        rightMostElement: function rightMostElement() {
            return getMaxElement('right', getAllElements());
        },
        taggedElement: function getTaggedElementsWidth() {
            return getTaggedElements('right', 'data-iframe-width');
        }
    };
    function sizeIFrame(triggerEvent, triggerEventDesc, customHeight, customWidth) {
        function resizeIFrame() {
            height = currentHeight;
            width = currentWidth;
            sendMsg(height, width, triggerEvent);
        }
        function isSizeChangeDetected() {
            function checkTolarance(a, b) {
                var retVal = Math.abs(a - b) <= tolerance;
                return !retVal;
            }
            currentHeight = undefined !== customHeight ? customHeight : getHeight[heightCalcMode]();
            currentWidth = undefined !== customWidth ? customWidth : getWidth[widthCalcMode]();
            return checkTolarance(height, currentHeight) || calculateWidth && checkTolarance(width, currentWidth);
        }
        function isForceResizableEvent() {
            return !(triggerEvent in {
                init: 1,
                interval: 1,
                size: 1
            });
        }
        function isForceResizableCalcMode() {
            return heightCalcMode in resetRequiredMethods || calculateWidth && widthCalcMode in resetRequiredMethods;
        }
        function logIgnored() {
            log('No change in size detected');
        }
        function checkDownSizing() {
            if (isForceResizableEvent() && isForceResizableCalcMode()) resetIFrame(triggerEventDesc);
            else if (!(triggerEvent in {
                interval: 1
            })) logIgnored();
        }
        var currentHeight, currentWidth;
        if (isSizeChangeDetected() || 'init' === triggerEvent) {
            lockTrigger();
            resizeIFrame();
        } else checkDownSizing();
    }
    var sizeIFrameThrottled = throttle(sizeIFrame);
    function sendSize(triggerEvent, triggerEventDesc, customHeight, customWidth) {
        function recordTrigger() {
            if (!(triggerEvent in {
                reset: 1,
                resetPage: 1,
                init: 1
            })) log('Trigger event: ' + triggerEventDesc);
        }
        function isDoubleFiredEvent() {
            return triggerLocked && triggerEvent in doubleEventList;
        }
        if (!isDoubleFiredEvent()) {
            recordTrigger();
            if (triggerEvent === 'init') sizeIFrame(triggerEvent, triggerEventDesc, customHeight, customWidth);
            else sizeIFrameThrottled(triggerEvent, triggerEventDesc, customHeight, customWidth);
        } else log('Trigger event cancelled: ' + triggerEvent);
    }
    function lockTrigger() {
        if (!triggerLocked) {
            triggerLocked = true;
            log('Trigger event lock on');
        }
        clearTimeout(triggerLockedTimer);
        triggerLockedTimer = setTimeout(function() {
            triggerLocked = false;
            log('Trigger event lock off');
            log('--');
        }, eventCancelTimer);
    }
    function triggerReset(triggerEvent) {
        height = getHeight[heightCalcMode]();
        width = getWidth[widthCalcMode]();
        sendMsg(height, width, triggerEvent);
    }
    function resetIFrame(triggerEventDesc) {
        var hcm = heightCalcMode;
        heightCalcMode = heightCalcModeDefault;
        log('Reset trigger event: ' + triggerEventDesc);
        lockTrigger();
        triggerReset('reset');
        heightCalcMode = hcm;
    }
    function sendMsg(height, width, triggerEvent, msg, targetOrigin) {
        function setTargetOrigin() {
            if (undefined === targetOrigin) targetOrigin = targetOriginDefault;
            else log('Message targetOrigin: ' + targetOrigin);
        }
        function sendToParent() {
            var size = height + ':' + width, message = myID + ':' + size + ':' + triggerEvent + (undefined !== msg ? ':' + msg : '');
            log('Sending message to host page (' + message + ')');
            target.postMessage(msgID + message, targetOrigin);
        }
        if (true === sendPermit) {
            setTargetOrigin();
            sendToParent();
        }
    }
    function receiver(event) {
        var processRequestFromParent = {
            init: function initFromParent() {
                initMsg = event.data;
                target = event.source;
                init();
                firstRun = false;
                setTimeout(function() {
                    initLock = false;
                }, eventCancelTimer);
            },
            reset: function resetFromParent() {
                if (!initLock) {
                    log('Page size reset by host page');
                    triggerReset('resetPage');
                } else log('Page reset ignored by init');
            },
            resize: function resizeFromParent() {
                sendSize('resizeParent', 'Parent window requested size check');
            },
            moveToAnchor: function moveToAnchorF() {
                inPageLinks.findTarget(getData());
            },
            inPageLink: function inPageLinkF() {
                this.moveToAnchor();
            },
            pageInfo: function pageInfoFromParent() {
                var msgBody = getData();
                log('PageInfoFromParent called from parent: ' + msgBody);
                pageInfoCallback(JSON.parse(msgBody));
                log(' --');
            },
            message: function messageFromParent() {
                var msgBody = getData();
                log('MessageCallback called from parent: ' + msgBody);
                messageCallback(JSON.parse(msgBody));
                log(' --');
            }
        };
        function isMessageForUs() {
            return msgID === ('' + event.data).substr(0, msgIdLen); //''+ Protects against non-string messages
        }
        function getMessageType() {
            return event.data.split(']')[1].split(':')[0];
        }
        function getData() {
            return event.data.substr(event.data.indexOf(':') + 1);
        }
        function isMiddleTier() {
            return !module.exports && 'iFrameResize' in window || 'jQuery' in window && 'iFrameResize' in window.jQuery.prototype;
        }
        function isInitMsg() {
            //Test if this message is from a child below us. This is an ugly test, however, updating
            //the message format would break backwards compatibity.
            return event.data.split(':')[2] in {
                "true": 1,
                "false": 1
            };
        }
        function callFromParent() {
            var messageType = getMessageType();
            if (messageType in processRequestFromParent) processRequestFromParent[messageType]();
            else if (!isMiddleTier() && !isInitMsg()) warn('Unexpected message (' + event.data + ')');
        }
        function processMessage() {
            if (false === firstRun) callFromParent();
            else if (isInitMsg()) processRequestFromParent.init();
            else log('Ignored message of type "' + getMessageType() + '". Received before initialization.');
        }
        if (isMessageForUs()) processMessage();
    }
    //Normally the parent kicks things off when it detects the iFrame has loaded.
    //If this script is async-loaded, then tell parent page to retry init.
    function chkLateLoaded() {
        if ('loading' !== document.readyState) window.parent.postMessage('[iFrameResizerChild]Ready', '*');
    }
    addEventListener(window, 'message', receiver);
    addEventListener(window, 'readystatechange', chkLateLoaded);
    chkLateLoaded();
})();

});


parcelRegister("2Aaz3", function(module, exports) {

$parcel$export(module.exports, "_config", function () { return _config; });
$parcel$export(module.exports, "_isString", function () { return _isString; });
$parcel$export(module.exports, "_isUndefined", function () { return _isUndefined; });
$parcel$export(module.exports, "_numExp", function () { return _numExp; });
$parcel$export(module.exports, "_numWithUnitExp", function () { return _numWithUnitExp; });
$parcel$export(module.exports, "_relExp", function () { return _relExp; });
$parcel$export(module.exports, "gsap", function () { return gsap; });
$parcel$export(module.exports, "_missingPlugin", function () { return _missingPlugin; });
$parcel$export(module.exports, "_plugins", function () { return _plugins; });
$parcel$export(module.exports, "GSCache", function () { return GSCache; });
$parcel$export(module.exports, "_getCache", function () { return _getCache; });
$parcel$export(module.exports, "_getProperty", function () { return _getProperty; });
$parcel$export(module.exports, "_forEachName", function () { return _forEachName; });
$parcel$export(module.exports, "_round", function () { return _round; });
$parcel$export(module.exports, "_parseRelative", function () { return _parseRelative; });
$parcel$export(module.exports, "_ticker", function () { return _ticker; });
$parcel$export(module.exports, "getUnit", function () { return getUnit; });
$parcel$export(module.exports, "_replaceRandom", function () { return _replaceRandom; });
$parcel$export(module.exports, "_getSetter", function () { return _getSetter; });
$parcel$export(module.exports, "PropTween", function () { return PropTween; });
$parcel$export(module.exports, "_colorExp", function () { return _colorExp; });
$parcel$export(module.exports, "_colorStringFilter", function () { return _colorStringFilter; });
$parcel$export(module.exports, "_renderComplexString", function () { return _renderComplexString; });
$parcel$export(module.exports, "_checkPlugin", function () { return _checkPlugin; });
$parcel$export(module.exports, "_sortPropTweensByPriority", function () { return _sortPropTweensByPriority; });
$parcel$export(module.exports, "TimelineMax", function () { return Timeline; });

var $6gBIz = parcelRequire("6gBIz");
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.13.0
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $6gBIz._)(value)) === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _isRevertWorthy = function _isRevertWorthy(animation) {
    return !!(animation._initted || animation._startAt || animation.add);
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || !!(_reverting && time < 0 && _isRevertWorthy(animation)));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime = _roundPrecise(tTime / cycleDuration));
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = (Math.random() * i) | 0, v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt < l && wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
        s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function func(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (!config) return;
    config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    if (_windowExists() || config.headless) {
        // edge case: some build tools may pass in a null/undefined value
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function Plugin() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function func1(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof Timeline) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function ease(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function ease(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return Math.pow(2, 10 * (p - 1)) * p + p * p * p * p * p * p * (1 - p);
}); // previously 2 ** (10 * (p - 1)) but that doesn't end up with the value quite at the right spot so we do a blended ease to ensure it lands where it should perfectly.
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value, suppressEvents) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this.totalDuration(), tTime), suppressEvents !== false);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
         // possible future addition - if an animation is removed from its parent and then .restart() or .play() or .resume() is called, perhaps we should force it back into the globalTimeline but be careful because what if it's already at its end? We don't want it to just persist forever and not get released for GC.
        // !this.parent && !value && this._tTime < this._tDur && this !== _globalTimeline && _globalTimeline.add(this);
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = value;
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (_isRevertWorthy(this)) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (Math.abs(animation._ts) || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
        this._dur || (this._zTime = -_tinyNum); // ensures onComplete fires on a zero-duration animation that gets restarted.
        return this;
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    _propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && tTime && !suppressEvents && !prevIteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && _isRevertWorthy(child)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        child.parent === this && _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate && function() {
                    return _callback(tween, "onUpdate");
                },
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return skipRecursion ? _warn(property + " not eligible for reset") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative || this._lazy) {
            // this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    } else if (time > dur) time = dur;
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted && iteration === prevIteration) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock && time !== cycleDuration && this._initted) {
                        // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (!prevTime && tTime && !suppressEvents && !prevIteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            this.parent ? _interrupt(this) : this.scrollTrigger && this.scrollTrigger.kill(!!_reverting);
            return this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c, function(func) {
                return c.add(null, func);
            });
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self, function(func) {
            return self.add(null, func);
        }) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) (function() {
            var tweens = _this4.getTweens(), i = _this4.data.length, t;
            while(i--){
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                t = _this4.data[i];
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            i = _this4.data.length;
            while(i--){
                // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
                t = _this4.data[i];
                if (t instanceof Timeline) {
                    if (t.data !== "nested") {
                        t.scrollTrigger && t.scrollTrigger.revert();
                        t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
                    }
                } else !(t instanceof Tween) && t.revert && t.revert(revert);
            }
            _this4._r.forEach(function(f) {
                return f(revert, _this4);
            });
            _this4.isReverted = true;
        })();
        else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    } // killWithCleanup() {
    ;
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
        _context && _context.data.push(this);
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context, function(f) {
            return context.add(null, f);
        });
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function setter(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _setDefaults2;
        var tween = gsap.to(target, _setDefaults((_setDefaults2 = {}, _setDefaults2[property] = "+=0.1", _setDefaults2.paused = true, _setDefaults2.stagger = 0, _setDefaults2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        headless: 1,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    headless: 1,
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.13.0";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});

parcelRegister("1X8yh", function(module, exports) {

$parcel$export(module.exports, "createChat", function () { return oWe; });

var $5VAZB = parcelRequire("5VAZB");

var $1mRNr = parcelRequire("1mRNr");

var $1UdHD = parcelRequire("1UdHD");

var $iH1wO = parcelRequire("iH1wO");

var $aRIHe = parcelRequire("aRIHe");

var $h4SHl = parcelRequire("h4SHl");

var $6869c = parcelRequire("6869c");

var $bnFl0 = parcelRequire("bnFl0");

var $9tk0W = parcelRequire("9tk0W");

var $kf9Kn = parcelRequire("kf9Kn");

var $6gBIz = parcelRequire("6gBIz");

var $gOgNZ = parcelRequire("gOgNZ");

var $e0qXa = parcelRequire("e0qXa");
parcelRequire("kTPvz");
var $8B0Dy = parcelRequire("8B0Dy");
var $5wB2C = parcelRequire("5wB2C");
var $kRi7Z = parcelRequire("kRi7Z");
var $3ZJCa = parcelRequire("3ZJCa");
var bv = Object.defineProperty;
var yv = function(e, t, n) {
    return t in e ? bv(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : e[t] = n;
};
var bo = function(e, t, n) {
    return yv(e, (typeof t === "undefined" ? "undefined" : (0, $6gBIz._)(t)) != "symbol" ? t + "" : t, n);
};
/*! Package version @n8n/chat@0.50.0 */ var Pr = {
    webhookUrl: "http://localhost:5678",
    webhookConfig: {
        method: "POST",
        headers: {}
    },
    target: "#n8n-chat",
    mode: "window",
    loadPreviousSession: !0,
    chatInputKey: "chatInput",
    chatSessionKey: "sessionId",
    defaultLanguage: "en",
    showWelcomeScreen: !1,
    initialMessages: [
        "Hi there! \uD83D\uDC4B",
        "My name is Nathan. How can I assist you today?"
    ],
    i18n: {
        en: {
            title: "Hi there! \uD83D\uDC4B",
            subtitle: "Start a chat. We're here to help you 24/7.",
            footer: "",
            getStarted: "New Conversation",
            inputPlaceholder: "Type your question..",
            closeButtonTooltip: "Close chat"
        }
    },
    theme: {},
    enableStreaming: !1
}, Tv = "#n8n-chat", Lv = "n8n-chat", Xl = "".concat(Lv, "/sessionId"), Rp = "Chat", Pp = "ChatOptions";
var at = [];
for(var Ps = 0; Ps < 256; ++Ps)at.push((Ps + 256).toString(16).slice(1));
function Ov(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return (at[e[t + 0]] + at[e[t + 1]] + at[e[t + 2]] + at[e[t + 3]] + "-" + at[e[t + 4]] + at[e[t + 5]] + "-" + at[e[t + 6]] + at[e[t + 7]] + "-" + at[e[t + 8]] + at[e[t + 9]] + "-" + at[e[t + 10]] + at[e[t + 11]] + at[e[t + 12]] + at[e[t + 13]] + at[e[t + 14]] + at[e[t + 15]]).toLowerCase();
}
var yo, Rv = new Uint8Array(16);
function Pv() {
    if (!yo && (yo = (typeof crypto === "undefined" ? "undefined" : (0, $6gBIz._)(crypto)) < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !yo)) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return yo(Rv);
}
var Bv = (typeof crypto === "undefined" ? "undefined" : (0, $6gBIz._)(crypto)) < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var Yl = {
    randomUUID: Bv
};
function Xn(e, t, n) {
    if (Yl.randomUUID && !e) return Yl.randomUUID();
    e = e || {};
    var r = e.random || (e.rng || Pv)();
    return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, Ov(r);
}
function zv() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
        return (0, $e0qXa.__generator)(this, function(_state) {
            return [
                2,
                ""
            ];
        });
    })();
}
function Xc() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
        var i, a, t, n, r, s, o, e1;
        return (0, $e0qXa.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        zv()
                    ];
                case 1:
                    t = _state.sent(), n = (i = e[1]) == null ? void 0 : i.body, r = (0, $6869c._)({}, t ? {
                        authorization: "Bearer ".concat(t)
                    } : {}, (a = e[1]) == null ? void 0 : a.headers);
                    n instanceof FormData ? delete r["Content-Type"] : r["Content-Type"] = "application/json";
                    return [
                        4,
                        fetch(e[0], (0, $bnFl0._)((0, $6869c._)({}, e[1]), {
                            mode: "cors",
                            cache: "no-cache",
                            headers: r
                        }))
                    ];
                case 2:
                    s = _state.sent();
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        5,
                        ,
                        7
                    ]);
                    return [
                        4,
                        s.clone().json()
                    ];
                case 4:
                    o = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 5:
                    e1 = _state.sent();
                    return [
                        4,
                        s.text()
                    ];
                case 6:
                    o = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        2,
                        o
                    ];
            }
        });
    })();
}
function Bp(_0) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function(e) {
        var t, n, r;
        var _arguments = arguments;
        return (0, $e0qXa.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    t = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, n = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                    r = e;
                    Object.keys(t).length > 0 && (r = "".concat(r, "?").concat(new URLSearchParams(t).toString()));
                    return [
                        4,
                        Xc(r, (0, $bnFl0._)((0, $6869c._)({}, n), {
                            method: "GET"
                        }))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    }).apply(this, arguments);
}
function zp(_0) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function(e) {
        var t, n;
        var _arguments = arguments;
        return (0, $e0qXa.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    t = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, n = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                    return [
                        4,
                        Xc(e, (0, $bnFl0._)((0, $6869c._)({}, n), {
                            method: "POST",
                            body: JSON.stringify(t)
                        }))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    }).apply(this, arguments);
}
function Dv(_0) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function(e) {
        var t, n, r, s, o, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, o1;
        var _arguments = arguments;
        return (0, $e0qXa.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    t = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, n = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : [], r = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : {};
                    s = new FormData();
                    for(var o in t)s.append(o, t[o]);
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = n[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            o1 = _step.value;
                            s.append("files", o1);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        4,
                        Xc(e, (0, $bnFl0._)((0, $6869c._)({}, r), {
                            method: "POST",
                            body: s
                        }))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    }).apply(this, arguments);
}
function Nv(e, t) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
        var r, s;
        return (0, $e0qXa.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (((r = t.webhookConfig) == null ? void 0 : r.method) === "POST" ? zp : Bp)("".concat(t.webhookUrl), (0, $6869c._)((0, $aRIHe._)({
                            action: "loadPreviousSession"
                        }, t.chatSessionKey, e), t.metadata ? {
                            metadata: t.metadata
                        } : {}), {
                            headers: (s = t.webhookConfig) == null ? void 0 : s.headers
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    })();
}
function qv(e, t, n, r) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
        var o, i, a, _obj, _obj1, _tmp;
        return (0, $e0qXa.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(t.length > 0)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        Dv("".concat(r.webhookUrl), (0, $6869c._)((_obj = {
                            action: "sendMessage"
                        }, (0, $aRIHe._)(_obj, r.chatSessionKey, n), (0, $aRIHe._)(_obj, r.chatInputKey, e), _obj), r.metadata ? {
                            metadata: r.metadata
                        } : {}), t, {
                            headers: (o = r.webhookConfig) == null ? void 0 : o.headers
                        })
                    ];
                case 1:
                    _tmp = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        (((i = r.webhookConfig) == null ? void 0 : i.method) === "POST" ? zp : Bp)("".concat(r.webhookUrl), (0, $6869c._)((_obj1 = {
                            action: "sendMessage"
                        }, (0, $aRIHe._)(_obj1, r.chatSessionKey, n), (0, $aRIHe._)(_obj1, r.chatInputKey, e), _obj1), r.metadata ? {
                            metadata: r.metadata
                        } : {}), {
                            headers: (a = r.webhookConfig) == null ? void 0 : a.headers
                        })
                    ];
                case 3:
                    _tmp = _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        _tmp
                    ];
            }
        });
    })();
}
function Fv() {
    var e = "";
    var t = new TextDecoder();
    return new TransformStream({
        transform: function(n, r) {
            e += t.decode(n, {
                stream: !0
            });
            var s = e.split("\n");
            var _s_pop;
            e = (_s_pop = s.pop()) !== null && _s_pop !== void 0 ? _s_pop : "";
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = s[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var o = _step.value;
                    if (o.trim()) try {
                        var i = JSON.parse(o);
                        r.enqueue(i);
                    } catch (e) {
                        r.enqueue({
                            type: "item",
                            content: o
                        });
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        flush: function(n) {
            if (e.trim()) try {
                var r = JSON.parse(e);
                n.enqueue(r);
            } catch (e1) {
                n.enqueue({
                    type: "item",
                    content: e
                });
            }
        }
    });
}
function Hv(e, t, n, r, s) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
        var c, u, o, d, i, a, _ref, d1, l, m, f, _l_content, _l_content1;
        return (0, $e0qXa.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        t.length > 0 ? jv(e, t, n, r) : Uv(e, n, r)
                    ];
                case 1:
                    o = _state.sent();
                    if (!!o.ok) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        o.text()
                    ];
                case 2:
                    d = _state.sent();
                    throw console.error("HTTP error response:", o.status, d), new Error("Error while sending message. Error: ".concat(d));
                case 3:
                    if (!o.body) throw new Error("Response body is not readable");
                    i = o.body.pipeThrough(Fv()).getReader();
                    a = !1;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        ,
                        9,
                        10
                    ]);
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        i.read()
                    ];
                case 6:
                    _ref = _state.sent(), d1 = _ref.done, l = _ref.value;
                    if (d1) return [
                        3,
                        8
                    ];
                    m = ((c = l.metadata) == null ? void 0 : c.nodeId) || "unknown", f = (u = l.metadata) == null ? void 0 : u.runIndex;
                    switch(l.type){
                        case "begin":
                            s.onBeginMessage(m, f);
                            break;
                        case "item":
                            ;
                            a = !0, s.onChunk((_l_content = l.content) !== null && _l_content !== void 0 ? _l_content : "", m, f);
                            break;
                        case "end":
                            s.onEndMessage(m, f);
                            break;
                        case "error":
                            ;
                            a = !0, s.onChunk("Error: ".concat((_l_content1 = l.content) !== null && _l_content1 !== void 0 ? _l_content1 : "Unknown error"), m, f), s.onEndMessage(m, f);
                            break;
                    }
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        5
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    i.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2,
                        {
                            hasReceivedChunks: a
                        }
                    ];
            }
        });
    })();
}
function jv(e, t, n, r) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
        var o, s, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i;
        return (0, $e0qXa.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    s = new FormData();
                    s.append("action", "sendMessage"), s.append(r.chatSessionKey, n), s.append(r.chatInputKey, e), r.metadata && s.append("metadata", JSON.stringify(r.metadata));
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = t[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            i = _step.value;
                            s.append("files", i);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        4,
                        fetch(r.webhookUrl, {
                            method: "POST",
                            headers: (0, $6869c._)({
                                Accept: "text/plain"
                            }, (o = r.webhookConfig) == null ? void 0 : o.headers),
                            body: s
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    })();
}
function Uv(e, t, n) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
        var s, _obj, r;
        return (0, $e0qXa.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = (0, $6869c._)((_obj = {
                        action: "sendMessage"
                    }, (0, $aRIHe._)(_obj, n.chatSessionKey, t), (0, $aRIHe._)(_obj, n.chatInputKey, e), _obj), n.metadata ? {
                        metadata: n.metadata
                    } : {});
                    return [
                        4,
                        fetch(n.webhookUrl, {
                            method: "POST",
                            headers: (0, $6869c._)({
                                "Content-Type": "application/json",
                                Accept: "text/plain"
                            }, (s = n.webhookConfig) == null ? void 0 : s.headers),
                            body: JSON.stringify(r)
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    })();
}
function Vv() {
    var e = /* @__PURE__ */ new Map();
    function t(s, o) {
        var i = e.get(s);
        i && i.splice(i.indexOf(o) >>> 0, 1);
    }
    function n(s, o) {
        var i = e.get(s);
        return i ? i.push(o) : i = [
            o
        ], e.set(s, i), function() {
            return t(s, o);
        };
    }
    function r(s, o) {
        var i = e.get(s);
        i && i.slice().forEach(function(a) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
                return (0, $e0qXa.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                a(o)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        });
    }
    return {
        on: n,
        off: t,
        emit: r
    };
}
function Zv(e) {
    if (!document.querySelector(e)) {
        var n = document.createElement("div");
        e.startsWith("#") && (n.id = e.replace("#", "")), e.startsWith(".") && n.classList.add(e.replace(".", "")), document.body.appendChild(n);
    }
}
function Wv(e, t, n, r) {
    var s = new URL(e).origin, o = s.startsWith("https") ? "wss" : "ws";
    return "".concat(s.replace(/^https?/, o), "/chat?sessionId=").concat(n, "&executionId=").concat(t, "&isPublic=true");
}
var _t = Vv();
var Gv = /*#__PURE__*/ function() {
    "use strict";
    function Gv() {
        (0, $1UdHD._)(this, Gv);
        bo(this, "nodeRuns", /* @__PURE__ */ new Map());
        bo(this, "runOrder", []);
        bo(this, "activeRuns", /* @__PURE__ */ new Set());
    }
    (0, $iH1wO._)(Gv, [
        {
            key: "getRunKey",
            value: function getRunKey(t, n) {
                return n !== void 0 ? "".concat(t, "-").concat(n) : t;
            }
        },
        {
            key: "initializeRun",
            value: function initializeRun(t, n) {
                var r = this.getRunKey(t, n);
                if (!this.nodeRuns.has(r)) {
                    var s = vr();
                    return this.nodeRuns.set(r, {
                        content: "",
                        isComplete: !1,
                        message: s
                    }), this.runOrder.push(r), s;
                }
                return this.nodeRuns.get(r).message;
            }
        },
        {
            key: "registerRunStart",
            value: function registerRunStart(t, n) {
                var r = this.getRunKey(t, n);
                this.activeRuns.add(r);
            }
        },
        {
            key: "addRunToActive",
            value: function addRunToActive(t, n) {
                var r = this.getRunKey(t, n);
                return this.activeRuns.add(r), this.initializeRun(t, n);
            }
        },
        {
            key: "removeRunFromActive",
            value: function removeRunFromActive(t, n) {
                var r = this.getRunKey(t, n);
                this.activeRuns["delete"](r);
                var s = this.nodeRuns.get(r);
                s && (s.isComplete = !0);
            }
        },
        {
            key: "addChunkToRun",
            value: function addChunkToRun(t, n, r) {
                var s = this.getRunKey(t, r), o = this.nodeRuns.get(s);
                if (o) {
                    o.content += n;
                    var i = (0, $bnFl0._)((0, $6869c._)({}, o.message), {
                        text: o.content
                    });
                    return o.message = i, i;
                }
                return null;
            }
        },
        {
            key: "getRunMessage",
            value: function getRunMessage(t, n) {
                var r = this.getRunKey(t, n), s = this.nodeRuns.get(r);
                var _ref;
                return (_ref = s == null ? void 0 : s.message) !== null && _ref !== void 0 ? _ref : null;
            }
        },
        {
            key: "areAllRunsComplete",
            value: function areAllRunsComplete() {
                return Array.from(this.nodeRuns.values()).every(function(t) {
                    return t.isComplete;
                });
            }
        },
        {
            key: "getRunCount",
            value: function getRunCount() {
                return this.runOrder.length;
            }
        },
        {
            key: "getActiveRunCount",
            value: function getActiveRunCount() {
                return this.activeRuns.size;
            }
        },
        {
            key: "getAllMessages",
            value: function getAllMessages() {
                var _this = this;
                return this.runOrder.map(function(t) {
                    var n;
                    return (n = _this.nodeRuns.get(t)) == null ? void 0 : n.message;
                }).filter(function(t) {
                    return t !== void 0;
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.nodeRuns.clear(), this.runOrder = [], this.activeRuns.clear();
            }
        }
    ]);
    return Gv;
}();
function vr(e) {
    return {
        id: e !== null && e !== void 0 ? e : Xn(),
        type: "text",
        text: "",
        sender: "bot"
    };
}
function Jl(e, t, n) {
    var r = e.findIndex(function(s) {
        return s.id === t;
    });
    if (r === -1) throw new Error("Can't update message. No message with id ".concat(t, " found"));
    e[r] = n;
}
function Kv(e, t, n, r, s, o) {
    try {
        if (e === "") return;
        if (t) {
            var _$i = n.getRunMessage(t, o);
            _$i || (_$i = n.addRunToActive(t, o), s.value.push(_$i));
            var a = n.addChunkToRun(t, e, o);
            a && Jl(s.value, a.id, a);
        } else {
            r.value || (r.value = vr(), s.value.push(r.value));
            var _$i1 = (0, $bnFl0._)((0, $6869c._)({}, r.value), {
                text: r.value.text + e
            });
            Jl(s.value, r.value.id, _$i1), r.value = _$i1;
        }
        (0, $8B0Dy.nextTick)(function() {
            _t.emit("scrollToBottom");
        });
    } catch (i) {
        console.error("Error handling stream chunk:", i);
    }
}
function Xv(e, t, n) {
    try {
        t.registerRunStart(e, n);
    } catch (r) {
        console.error("Error handling node start:", r);
    }
}
function Yv(e, t, n) {
    try {
        t.removeRunFromActive(e, n);
    } catch (r) {
        console.error("Error handling node complete:", r);
    }
}
function Jv(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return {
        id: Xn(),
        text: e,
        sender: "user",
        files: t
    };
}
function Qv(e) {
    var _e_output, _ref, _ref1;
    var t = (_ref1 = (_ref = (_e_output = e.output) !== null && _e_output !== void 0 ? _e_output : e.text) !== null && _ref !== void 0 ? _ref : e.message) !== null && _ref1 !== void 0 ? _ref1 : "";
    if (t === "" && Object.keys(e).length > 0) try {
        t = JSON.stringify(e, null, 2);
    } catch (e) {}
    return t;
}
function e_(e) {
    var t = e.receivedMessage, n = e.messages;
    t.value && n.value.some(function(s) {
        return s.sender === "bot" && "text" in s && s.text.trim().length > 0;
    }) || (t.value = vr(), n.value.push(t.value)), t.value.text = "[No response received. This could happen if streaming is enabled in the trigger but disabled in agent node(s)]";
}
function t_(e) {
    var t = e.error, n = e.receivedMessage, r = e.messages;
    var _n_value;
    (_n_value = n.value) !== null && _n_value !== void 0 ? _n_value : n.value = vr(), n.value.text = "Error: Failed to receive response", r.value.includes(n.value) || r.value.push(n.value), console.error("Chat API error:", t);
}
function n_(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
        var t, n, r, s, o, i, a, c, _ref, u;
        return (0, $e0qXa.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    t = e.text, n = e.files, r = e.sessionId, s = e.options, o = e.messages, i = e.receivedMessage, a = e.streamingManager, c = {
                        onChunk: function(d, l, m) {
                            Kv(d, l, a, i, o, m);
                        },
                        onBeginMessage: function(d, l) {
                            Xv(d, a, l);
                        },
                        onEndMessage: function(d, l) {
                            Yv(d, a, l);
                        }
                    };
                    return [
                        4,
                        Hv(t, n, r, s, c)
                    ];
                case 1:
                    _ref = _state.sent(), u = _ref.hasReceivedChunks;
                    u || e_({
                        receivedMessage: i,
                        messages: o
                    });
                    return [
                        2
                    ];
            }
        });
    })();
}
function r_(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
        var t, n, r, s, o, i;
        return (0, $e0qXa.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    t = e.text, n = e.files, r = e.sessionId, s = e.options;
                    return [
                        4,
                        qv(t, n, r, s)
                    ];
                case 1:
                    o = _state.sent();
                    if (o != null && o.executionStarted) return [
                        2,
                        {
                            response: o
                        }
                    ];
                    i = vr();
                    return [
                        2,
                        (i.text = Qv(o), {
                            botMessage: i
                        })
                    ];
            }
        });
    })();
}
var o_ = {
    install: function(e, t) {
        e.provide(Pp, t);
        var n = (0, $5wB2C.ref)([]), r = (0, $5wB2C.ref)(null), s = (0, $5wB2C.ref)(!1), o = (0, $5wB2C.computed)(function() {
            var _t_initialMessages;
            return ((_t_initialMessages = t.initialMessages) !== null && _t_initialMessages !== void 0 ? _t_initialMessages : []).map(function(d) {
                return {
                    id: Xn(),
                    text: d,
                    sender: "bot"
                };
            });
        });
        function i(_0) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function(d) {
                var l, g, m, f, v, _$b, b;
                var _arguments = arguments;
                return (0, $e0qXa.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            l = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : [];
                            m = Jv(d, l);
                            n.value.push(m), s.value = !0, (0, $8B0Dy.nextTick)(function() {
                                _t.emit("scrollToBottom");
                            });
                            f = (0, $5wB2C.ref)(null), v = new Gv();
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            if (!(t != null && t.enableStreaming)) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                n_({
                                    text: d,
                                    files: l,
                                    sessionId: r.value,
                                    options: t,
                                    messages: n,
                                    receivedMessage: f,
                                    streamingManager: v
                                })
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 3:
                            return [
                                4,
                                r_({
                                    text: d,
                                    files: l,
                                    sessionId: r.value,
                                    options: t
                                })
                            ];
                        case 4:
                            _$b = _state.sent();
                            if ((g = _$b.response) != null && g.executionStarted) return [
                                2,
                                (s.value = !1, _$b.response)
                            ];
                            _$b.botMessage && (f.value = _$b.botMessage, n.value.push(_$b.botMessage));
                            _state.label = 5;
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            b = _state.sent();
                            t_({
                                error: b,
                                receivedMessage: f,
                                messages: n
                            });
                            return [
                                3,
                                8
                            ];
                        case 7:
                            s.value = !1;
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2,
                                ((0, $8B0Dy.nextTick)(function() {
                                    _t.emit("scrollToBottom");
                                }), null)
                            ];
                    }
                });
            }).apply(this, arguments);
        }
        function a() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
                var _localStorage_getItem, d, l;
                return (0, $e0qXa.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!t.loadPreviousSession) return [
                                2
                            ];
                            d = (_localStorage_getItem = localStorage.getItem(Xl)) !== null && _localStorage_getItem !== void 0 ? _localStorage_getItem : Xn();
                            return [
                                4,
                                Nv(d, t)
                            ];
                        case 1:
                            l = _state.sent();
                            return [
                                2,
                                (n.value = ((l == null ? void 0 : l.data) || []).map(function(m, f) {
                                    return {
                                        id: "".concat(f),
                                        text: m.kwargs.content,
                                        sender: m.id.includes("HumanMessage") ? "user" : "bot"
                                    };
                                }), n.value.length && (r.value = d), d)
                            ];
                    }
                });
            })();
        }
        function c() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
                return (0, $e0qXa.__generator)(this, function(_state) {
                    r.value = Xn(), localStorage.setItem(Xl, r.value);
                    return [
                        2
                    ];
                });
            })();
        }
        var u = {
            initialMessages: o,
            messages: n,
            currentSessionId: r,
            waitingForResponse: s,
            loadPreviousSession: a,
            startNewSession: c,
            sendMessage: i
        };
        e.provide(Rp, u), e.config.globalProperties.$chat = u;
    }
};
var pr = (typeof globalThis === "undefined" ? "undefined" : (0, $6gBIz._)(globalThis)) < "u" ? globalThis : (typeof window === "undefined" ? "undefined" : (0, $6gBIz._)(window)) < "u" ? window : (typeof $parcel$global === "undefined" ? "undefined" : (0, $6gBIz._)($parcel$global)) < "u" ? $parcel$global : (typeof self === "undefined" ? "undefined" : (0, $6gBIz._)(self)) < "u" ? self : {};
function Er(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e["default"] : e;
}
var Bs, Ql;
function s_() {
    if (Ql) return Bs;
    Ql = 1;
    function e(E) {
        return E instanceof Map ? E.clear = E["delete"] = E.set = function() {
            throw new Error("map is read-only");
        } : E instanceof Set && (E.add = E.clear = E["delete"] = function() {
            throw new Error("set is read-only");
        }), Object.freeze(E), Object.getOwnPropertyNames(E).forEach(function(L) {
            var q = E[L], ce = typeof q === "undefined" ? "undefined" : (0, $6gBIz._)(q);
            (ce === "object" || ce === "function") && !Object.isFrozen(q) && e(q);
        }), E;
    }
    var t = /*#__PURE__*/ function() {
        "use strict";
        function t(L) {
            (0, $1UdHD._)(this, t);
            L.data === void 0 && (L.data = {}), this.data = L.data, this.isMatchIgnored = !1;
        }
        (0, $iH1wO._)(t, [
            {
                key: "ignoreMatch",
                value: function ignoreMatch() {
                    this.isMatchIgnored = !0;
                }
            }
        ]);
        return t;
    }();
    function n(E) {
        return E.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
    }
    function r(E) {
        for(var _len = arguments.length, L = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            L[_key - 1] = arguments[_key];
        }
        var q = /* @__PURE__ */ Object.create(null);
        for(var ce in E)q[ce] = E[ce];
        return L.forEach(function(ce) {
            for(var xe in ce)q[xe] = ce[xe];
        }), /** @type {T} */ q;
    }
    var s = "</span>", o = function(E) {
        return !!E.scope;
    }, i = function(E, param) {
        var L = param.prefix;
        if (E.startsWith("language:")) return E.replace("language:", "language-");
        if (E.includes(".")) {
            var q = E.split(".");
            return [
                "".concat(L).concat(q.shift())
            ].concat((0, $kf9Kn._)(q.map(function(ce, xe) {
                return "".concat(ce).concat("_".repeat(xe + 1));
            }))).join(" ");
        }
        return "".concat(L).concat(E);
    };
    var a = /*#__PURE__*/ function() {
        "use strict";
        function a(L, q) {
            (0, $1UdHD._)(this, a);
            this.buffer = "", this.classPrefix = q.classPrefix, L.walk(this);
        }
        (0, $iH1wO._)(a, [
            {
                /**
     * Adds texts to the output stream
     *
     * @param {string} text */ key: "addText",
                value: function addText(L) {
                    this.buffer += n(L);
                }
            },
            {
                /**
     * Adds a node open to the output stream (if needed)
     *
     * @param {Node} node */ key: "openNode",
                value: function openNode(L) {
                    if (!o(L)) return;
                    var q = i(L.scope, {
                        prefix: this.classPrefix
                    });
                    this.span(q);
                }
            },
            {
                /**
     * Adds a node close to the output stream (if needed)
     *
     * @param {Node} node */ key: "closeNode",
                value: function closeNode(L) {
                    o(L) && (this.buffer += s);
                }
            },
            {
                /**
     * returns the accumulated buffer
    */ key: "value",
                value: function value() {
                    return this.buffer;
                }
            },
            {
                // helpers
                /**
     * Builds a span element
     *
     * @param {string} className */ key: "span",
                value: function span(L) {
                    this.buffer += '<span class="'.concat(L, '">');
                }
            }
        ]);
        return a;
    }();
    var c = function() {
        var E = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var L = {
            children: []
        };
        return Object.assign(L, E), L;
    };
    var u = /*#__PURE__*/ function() {
        "use strict";
        function u() {
            (0, $1UdHD._)(this, u);
            this.rootNode = c(), this.stack = [
                this.rootNode
            ];
        }
        (0, $iH1wO._)(u, [
            {
                key: "top",
                get: function get() {
                    return this.stack[this.stack.length - 1];
                }
            },
            {
                key: "root",
                get: function get() {
                    return this.rootNode;
                }
            },
            {
                /** @param {Node} node */ key: "add",
                value: function add(L) {
                    this.top.children.push(L);
                }
            },
            {
                /** @param {string} scope */ key: "openNode",
                value: function openNode(L) {
                    var q = c({
                        scope: L
                    });
                    this.add(q), this.stack.push(q);
                }
            },
            {
                key: "closeNode",
                value: function closeNode() {
                    if (this.stack.length > 1) return this.stack.pop();
                }
            },
            {
                key: "closeAllNodes",
                value: function closeAllNodes() {
                    for(; this.closeNode(););
                }
            },
            {
                key: "toJSON",
                value: function toJSON() {
                    return JSON.stringify(this.rootNode, null, 4);
                }
            },
            {
                /**
     * @typedef { import("./html_renderer").Renderer } Renderer
     * @param {Renderer} builder
     */ key: "walk",
                value: function walk(L) {
                    return this.constructor._walk(L, this.rootNode);
                }
            }
        ], [
            {
                key: "_walk",
                value: /**
     * @param {Renderer} builder
     * @param {Node} node
     */ function _walk(L, q) {
                    var _this = this;
                    return typeof q == "string" ? L.addText(q) : q.children && (L.openNode(q), q.children.forEach(function(ce) {
                        return _this._walk(L, ce);
                    }), L.closeNode(q)), L;
                }
            },
            {
                key: "_collapse",
                value: /**
     * @param {Node} node
     */ function _collapse(L) {
                    typeof L != "string" && L.children && (L.children.every(function(q) {
                        return typeof q == "string";
                    }) ? L.children = [
                        L.children.join("")
                    ] : L.children.forEach(function(q) {
                        u._collapse(q);
                    }));
                }
            }
        ]);
        return u;
    }();
    var d = /*#__PURE__*/ function(u) {
        "use strict";
        (0, $h4SHl._)(d, u);
        function d(L) {
            (0, $1UdHD._)(this, d);
            var _this;
            _this = (0, $1mRNr._)(this, d), _this.options = L;
            return _this;
        }
        (0, $iH1wO._)(d, [
            {
                /**
     * @param {string} text
     */ key: "addText",
                value: function addText(L) {
                    L !== "" && this.add(L);
                }
            },
            {
                /** @param {string} scope */ key: "startScope",
                value: function startScope(L) {
                    this.openNode(L);
                }
            },
            {
                key: "endScope",
                value: function endScope() {
                    this.closeNode();
                }
            },
            {
                /**
     * @param {Emitter & {root: DataNode}} emitter
     * @param {string} name
     */ key: "__addSublanguage",
                value: function __addSublanguage(L, q) {
                    var ce = L.root;
                    q && (ce.scope = "language:".concat(q)), this.add(ce);
                }
            },
            {
                key: "toHTML",
                value: function toHTML() {
                    return new a(this, this.options).value();
                }
            },
            {
                key: "finalize",
                value: function finalize() {
                    return this.closeAllNodes(), !0;
                }
            }
        ]);
        return d;
    }(u);
    function l(E) {
        return E ? typeof E == "string" ? E : E.source : null;
    }
    function m(E) {
        return g("(?=", E, ")");
    }
    function f(E) {
        return g("(?:", E, ")*");
    }
    function v(E) {
        return g("(?:", E, ")?");
    }
    function g() {
        for(var _len = arguments.length, E = new Array(_len), _key = 0; _key < _len; _key++){
            E[_key] = arguments[_key];
        }
        return E.map(function(q) {
            return l(q);
        }).join("");
    }
    function b(E) {
        var L = E[E.length - 1];
        return (typeof L === "undefined" ? "undefined" : (0, $6gBIz._)(L)) == "object" && L.constructor === Object ? (E.splice(E.length - 1, 1), L) : {};
    }
    function h() {
        for(var _len = arguments.length, E = new Array(_len), _key = 0; _key < _len; _key++){
            E[_key] = arguments[_key];
        }
        return "(" + (b(E).capture ? "" : "?:") + E.map(function(ce) {
            return l(ce);
        }).join("|") + ")";
    }
    function w(E) {
        return new RegExp(E.toString() + "|").exec("").length - 1;
    }
    function k(E, L) {
        var q = E && E.exec(L);
        return q && q.index === 0;
    }
    var x = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;
    function A(E, param) {
        var L = param.joinWith;
        var q = 0;
        return E.map(function(ce) {
            q += 1;
            var xe = q;
            var Ae = l(ce), oe = "";
            for(; Ae.length > 0;){
                var ee = x.exec(Ae);
                if (!ee) {
                    oe += Ae;
                    break;
                }
                oe += Ae.substring(0, ee.index), Ae = Ae.substring(ee.index + ee[0].length), ee[0][0] === "\\" && ee[1] ? oe += "\\" + String(Number(ee[1]) + xe) : (oe += ee[0], ee[0] === "(" && q++);
            }
            return oe;
        }).map(function(ce) {
            return "(".concat(ce, ")");
        }).join(L);
    }
    var S = /\b\B/, $ = "[a-zA-Z]\\w*", M = "[a-zA-Z_]\\w*", P = "\\b\\d+(\\.\\d+)?", R = "(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)", B = "\\b(0b[01]+)", H = "!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~", ie = function() {
        var E = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var L = /^#![ ]*\//;
        return E.binary && (E.begin = g(L, /.*\b/, E.binary, /\b.*/)), r({
            scope: "meta",
            begin: L,
            end: /$/,
            relevance: 0,
            /** @type {ModeCallback} */ "on:begin": function(q, ce) {
                q.index !== 0 && ce.ignoreMatch();
            }
        }, E);
    }, z = {
        begin: "\\\\[\\s\\S]",
        relevance: 0
    }, Q = {
        scope: "string",
        begin: "'",
        end: "'",
        illegal: "\\n",
        contains: [
            z
        ]
    }, N = {
        scope: "string",
        begin: '"',
        end: '"',
        illegal: "\\n",
        contains: [
            z
        ]
    }, j = {
        begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
    }, U = function U(E, L) {
        var q = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var ce = r({
            scope: "comment",
            begin: E,
            end: L,
            contains: []
        }, q);
        ce.contains.push({
            scope: "doctag",
            // hack to avoid the space from being included. the space is necessary to
            // match here to prevent the plain text rule below from gobbling up doctags
            begin: "[ ]*(?=(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):)",
            end: /(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):/,
            excludeBegin: !0,
            relevance: 0
        });
        var xe = h(// list of common 1 and 2 letter words in English
        "I", "a", "is", "so", "us", "to", "at", "if", "in", "it", "on", // note: this is not an exhaustive list of contractions, just popular ones
        /[A-Za-z]+['](d|ve|re|ll|t|s|n)/, // contractions - can't we'd they're let's, etc
        /[A-Za-z]+[-][a-z]+/, // `no-way`, etc.
        /[A-Za-z][a-z]{2,}/);
        return ce.contains.push({
            // TODO: how to include ", (, ) without breaking grammars that use these for
            // comment delimiters?
            // begin: /[ ]+([()"]?([A-Za-z'-]{3,}|is|a|I|so|us|[tT][oO]|at|if|in|it|on)[.]?[()":]?([.][ ]|[ ]|\))){3}/
            // ---
            // this tries to find sequences of 3 english words in a row (without any
            // "programming" type syntax) this gives us a strong signal that we've
            // TRULY found a comment - vs perhaps scanning with the wrong language.
            // It's possible to find something that LOOKS like the start of the
            // comment - but then if there is no readable text - good chance it is a
            // false match and not a comment.
            //
            // for a visual example please see:
            // https://github.com/highlightjs/highlight.js/issues/2827
            begin: g(/[ ]+/, // necessary to prevent us gobbling up doctags like /* @author Bob Mcgill */
            "(", xe, /[.]?[:]?([.][ ]|[ ])/, "){3}")
        }), ce;
    }, G = U("//", "$"), T = U("/\\*", "\\*/"), W = U("#", "$"), V = {
        scope: "number",
        begin: P,
        relevance: 0
    }, se = {
        scope: "number",
        begin: R,
        relevance: 0
    }, de = {
        scope: "number",
        begin: B,
        relevance: 0
    }, ve = {
        scope: "regexp",
        begin: /\/(?=[^/\n]*\/)/,
        end: /\/[gimuy]*/,
        contains: [
            z,
            {
                begin: /\[/,
                end: /\]/,
                relevance: 0,
                contains: [
                    z
                ]
            }
        ]
    }, we = {
        scope: "title",
        begin: $,
        relevance: 0
    }, Be = {
        scope: "title",
        begin: M,
        relevance: 0
    }, Oe = {
        // excludes method names from keyword processing
        begin: "\\.\\s*" + M,
        relevance: 0
    };
    var re = /* @__PURE__ */ Object.freeze({
        __proto__: null,
        APOS_STRING_MODE: Q,
        BACKSLASH_ESCAPE: z,
        BINARY_NUMBER_MODE: de,
        BINARY_NUMBER_RE: B,
        COMMENT: U,
        C_BLOCK_COMMENT_MODE: T,
        C_LINE_COMMENT_MODE: G,
        C_NUMBER_MODE: se,
        C_NUMBER_RE: R,
        END_SAME_AS_BEGIN: function END_SAME_AS_BEGIN(E) {
            return Object.assign(E, {
                /** @type {ModeCallback} */ "on:begin": function(L, q) {
                    q.data._beginMatch = L[1];
                },
                /** @type {ModeCallback} */ "on:end": function(L, q) {
                    q.data._beginMatch !== L[1] && q.ignoreMatch();
                }
            });
        },
        HASH_COMMENT_MODE: W,
        IDENT_RE: $,
        MATCH_NOTHING_RE: S,
        METHOD_GUARD: Oe,
        NUMBER_MODE: V,
        NUMBER_RE: P,
        PHRASAL_WORDS_MODE: j,
        QUOTE_STRING_MODE: N,
        REGEXP_MODE: ve,
        RE_STARTERS_RE: H,
        SHEBANG: ie,
        TITLE_MODE: we,
        UNDERSCORE_IDENT_RE: M,
        UNDERSCORE_TITLE_MODE: Be
    });
    function fe(E, L) {
        E.input[E.index - 1] === "." && L.ignoreMatch();
    }
    function Se(E, L) {
        E.className !== void 0 && (E.scope = E.className, delete E.className);
    }
    function ze(E, L) {
        L && E.beginKeywords && (E.begin = "\\b(" + E.beginKeywords.split(" ").join("|") + ")(?!\\.)(?=\\b|\\s)", E.__beforeBegin = fe, E.keywords = E.keywords || E.beginKeywords, delete E.beginKeywords, E.relevance === void 0 && (E.relevance = 0));
    }
    function Ge(E, L) {
        Array.isArray(E.illegal) && (E.illegal = h.apply(void 0, (0, $kf9Kn._)(E.illegal)));
    }
    function Je(E, L) {
        if (E.match) {
            if (E.begin || E.end) throw new Error("begin & end are not supported with match");
            E.begin = E.match, delete E.match;
        }
    }
    function st(E, L) {
        E.relevance === void 0 && (E.relevance = 1);
    }
    var rn = function(E, L) {
        if (!E.beforeMatch) return;
        if (E.starts) throw new Error("beforeMatch cannot be used with starts");
        var q = Object.assign({}, E);
        Object.keys(E).forEach(function(ce) {
            delete E[ce];
        }), E.keywords = q.keywords, E.begin = g(q.beforeMatch, m(q.begin)), E.starts = {
            relevance: 0,
            contains: [
                Object.assign(q, {
                    endsParent: !0
                })
            ]
        }, E.relevance = 0, delete q.beforeMatch;
    }, Et = [
        "of",
        "and",
        "for",
        "in",
        "not",
        "or",
        "if",
        "then",
        "parent",
        // common variable name
        "list",
        // common variable name
        "value"
    ], Ut = "keyword";
    function ut(E, L) {
        var q = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Ut;
        var ce = /* @__PURE__ */ Object.create(null);
        return typeof E == "string" ? xe(q, E.split(" ")) : Array.isArray(E) ? xe(q, E) : Object.keys(E).forEach(function(Ae) {
            Object.assign(ce, ut(E[Ae], L, Ae));
        }), ce;
        function xe(Ae, oe) {
            L && (oe = oe.map(function(ee) {
                return ee.toLowerCase();
            })), oe.forEach(function(ee) {
                var me = ee.split("|");
                ce[me[0]] = [
                    Ae,
                    Ot(me[0], me[1])
                ];
            });
        }
    }
    function Ot(E, L) {
        return L ? Number(L) : At(E) ? 0 : 1;
    }
    function At(E) {
        return Et.includes(E.toLowerCase());
    }
    var Vt = {}, nt = function(E) {
        console.error(E);
    }, K = function(E) {
        for(var _len = arguments.length, L = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            L[_key - 1] = arguments[_key];
        }
        var _console;
        (_console = console).log.apply(_console, [
            "WARN: ".concat(E)
        ].concat((0, $kf9Kn._)(L)));
    }, ge = function(E, L) {
        Vt["".concat(E, "/").concat(L)] || (console.log("Deprecated as of ".concat(E, ". ").concat(L)), Vt["".concat(E, "/").concat(L)] = !0);
    }, De = new Error();
    function Xe(E, L, param) {
        var q = param.key;
        var ce = 0;
        var xe = E[q], Ae = {}, oe = {};
        for(var ee = 1; ee <= L.length; ee++)oe[ee + ce] = xe[ee], Ae[ee + ce] = !0, ce += w(L[ee - 1]);
        E[q] = oe, E[q]._emit = Ae, E[q]._multi = !0;
    }
    function Zt(E) {
        if (Array.isArray(E.begin)) {
            if (E.skip || E.excludeBegin || E.returnBegin) throw nt("skip, excludeBegin, returnBegin not compatible with beginScope: {}"), De;
            if ((0, $6gBIz._)(E.beginScope) != "object" || E.beginScope === null) throw nt("beginScope must be object"), De;
            Xe(E, E.begin, {
                key: "beginScope"
            }), E.begin = A(E.begin, {
                joinWith: ""
            });
        }
    }
    function qn(E) {
        if (Array.isArray(E.end)) {
            if (E.skip || E.excludeEnd || E.returnEnd) throw nt("skip, excludeEnd, returnEnd not compatible with endScope: {}"), De;
            if ((0, $6gBIz._)(E.endScope) != "object" || E.endScope === null) throw nt("endScope must be object"), De;
            Xe(E, E.end, {
                key: "endScope"
            }), E.end = A(E.end, {
                joinWith: ""
            });
        }
    }
    function Fn(E) {
        E.scope && (0, $6gBIz._)(E.scope) == "object" && E.scope !== null && (E.beginScope = E.scope, delete E.scope);
    }
    function or(E) {
        Fn(E), typeof E.beginScope == "string" && (E.beginScope = {
            _wrap: E.beginScope
        }), typeof E.endScope == "string" && (E.endScope = {
            _wrap: E.endScope
        }), Zt(E), qn(E);
    }
    function Tr(E) {
        function L(oe, ee) {
            return new RegExp(l(oe), "m" + (E.case_insensitive ? "i" : "") + (E.unicodeRegex ? "u" : "") + (ee ? "g" : ""));
        }
        var q = /*#__PURE__*/ function() {
            "use strict";
            function q() {
                (0, $1UdHD._)(this, q);
                this.matchIndexes = {}, this.regexes = [], this.matchAt = 1, this.position = 0;
            }
            (0, $iH1wO._)(q, [
                {
                    // @ts-ignore
                    key: "addRule",
                    value: function addRule(ee, me) {
                        me.position = this.position++, this.matchIndexes[this.matchAt] = me, this.regexes.push([
                            me,
                            ee
                        ]), this.matchAt += w(ee) + 1;
                    }
                },
                {
                    key: "compile",
                    value: function compile() {
                        this.regexes.length === 0 && (this.exec = function() {
                            return null;
                        });
                        var ee = this.regexes.map(function(me) {
                            return me[1];
                        });
                        this.matcherRe = L(A(ee, {
                            joinWith: "|"
                        }), !0), this.lastIndex = 0;
                    }
                },
                {
                    /** @param {string} s */ key: "exec",
                    value: function exec(ee) {
                        this.matcherRe.lastIndex = this.lastIndex;
                        var me = this.matcherRe.exec(ee);
                        if (!me) return null;
                        var Qe = me.findIndex(function($t, Ms) {
                            return Ms > 0 && $t !== void 0;
                        }), $e = this.matchIndexes[Qe];
                        return me.splice(0, Qe), Object.assign(me, $e);
                    }
                }
            ]);
            return q;
        }();
        var ce = /*#__PURE__*/ function() {
            "use strict";
            function ce() {
                (0, $1UdHD._)(this, ce);
                this.rules = [], this.multiRegexes = [], this.count = 0, this.lastIndex = 0, this.regexIndex = 0;
            }
            (0, $iH1wO._)(ce, [
                {
                    // @ts-ignore
                    key: "getMatcher",
                    value: function getMatcher(ee) {
                        if (this.multiRegexes[ee]) return this.multiRegexes[ee];
                        var me = new q();
                        return this.rules.slice(ee).forEach(function(param) {
                            var _param = (0, $9tk0W._)(param, 2), Qe = _param[0], $e = _param[1];
                            return me.addRule(Qe, $e);
                        }), me.compile(), this.multiRegexes[ee] = me, me;
                    }
                },
                {
                    key: "resumingScanAtSamePosition",
                    value: function resumingScanAtSamePosition() {
                        return this.regexIndex !== 0;
                    }
                },
                {
                    key: "considerAll",
                    value: function considerAll() {
                        this.regexIndex = 0;
                    }
                },
                {
                    // @ts-ignore
                    key: "addRule",
                    value: function addRule(ee, me) {
                        this.rules.push([
                            ee,
                            me
                        ]), me.type === "begin" && this.count++;
                    }
                },
                {
                    /** @param {string} s */ key: "exec",
                    value: function exec(ee) {
                        var me = this.getMatcher(this.regexIndex);
                        me.lastIndex = this.lastIndex;
                        var Qe = me.exec(ee);
                        if (this.resumingScanAtSamePosition() && !(Qe && Qe.index === this.lastIndex)) {
                            var $e = this.getMatcher(0);
                            $e.lastIndex = this.lastIndex + 1, Qe = $e.exec(ee);
                        }
                        return Qe && (this.regexIndex += Qe.position + 1, this.regexIndex === this.count && this.considerAll()), Qe;
                    }
                }
            ]);
            return ce;
        }();
        function xe(oe) {
            var ee = new ce();
            return oe.contains.forEach(function(me) {
                return ee.addRule(me.begin, {
                    rule: me,
                    type: "begin"
                });
            }), oe.terminatorEnd && ee.addRule(oe.terminatorEnd, {
                type: "end"
            }), oe.illegal && ee.addRule(oe.illegal, {
                type: "illegal"
            }), ee;
        }
        function Ae(oe, ee) {
            var _instance;
            var me = /** @type CompiledMode */ oe;
            if (oe.isCompiled) return me;
            [
                Se,
                // do this early so compiler extensions generally don't have to worry about
                // the distinction between match/begin
                Je,
                or,
                rn
            ].forEach(function($e) {
                return $e(oe, ee);
            }), E.compilerExtensions.forEach(function($e) {
                return $e(oe, ee);
            }), oe.__beforeBegin = null, [
                ze,
                // do this later so compiler extensions that come earlier have access to the
                // raw array if they wanted to perhaps manipulate it, etc.
                Ge,
                // default to 1 relevance if not specified
                st
            ].forEach(function($e) {
                return $e(oe, ee);
            }), oe.isCompiled = !0;
            var Qe = null;
            return (0, $6gBIz._)(oe.keywords) == "object" && oe.keywords.$pattern && (oe.keywords = Object.assign({}, oe.keywords), Qe = oe.keywords.$pattern, delete oe.keywords.$pattern), Qe = Qe || /\w+/, oe.keywords && (oe.keywords = ut(oe.keywords, E.case_insensitive)), me.keywordPatternRe = L(Qe, !0), ee && (oe.begin || (oe.begin = /\B|\b/), me.beginRe = L(me.begin), !oe.end && !oe.endsWithParent && (oe.end = /\B|\b/), oe.end && (me.endRe = L(me.end)), me.terminatorEnd = l(me.end) || "", oe.endsWithParent && ee.terminatorEnd && (me.terminatorEnd += (oe.end ? "|" : "") + ee.terminatorEnd)), oe.illegal && (me.illegalRe = L(/** @type {RegExp | string} */ oe.illegal)), oe.contains || (oe.contains = []), oe.contains = (_instance = []).concat.apply(_instance, (0, $kf9Kn._)(oe.contains.map(function($e) {
                return sr($e === "self" ? oe : $e);
            }))), oe.contains.forEach(function($e) {
                Ae(/** @type Mode */ $e, me);
            }), oe.starts && Ae(oe.starts, ee), me.matcher = xe(me), me;
        }
        if (E.compilerExtensions || (E.compilerExtensions = []), E.contains && E.contains.includes("self")) throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
        return E.classNameAliases = r(E.classNameAliases || {}), Ae(/** @type Mode */ E);
    }
    function dn(E) {
        return E ? E.endsWithParent || dn(E.starts) : !1;
    }
    function sr(E) {
        return E.variants && !E.cachedVariants && (E.cachedVariants = E.variants.map(function(L) {
            return r(E, {
                variants: null
            }, L);
        })), E.cachedVariants ? E.cachedVariants : dn(E) ? r(E, {
            starts: E.starts ? r(E.starts) : null
        }) : Object.isFrozen(E) ? r(E) : E;
    }
    var Lr = "11.9.0";
    var Hn = /*#__PURE__*/ function(Error1) {
        "use strict";
        (0, $h4SHl._)(Hn, Error1);
        function Hn(L, q) {
            (0, $1UdHD._)(this, Hn);
            var _this;
            _this = (0, $1mRNr._)(this, Hn, [
                L
            ]), _this.name = "HTMLInjectionError", _this.html = q;
            return _this;
        }
        return Hn;
    }((0, $gOgNZ._)(Error));
    var Sn = n, ir = r, jn = Symbol("nomatch"), Or = 7, ar = function ar(E) {
        var L = /* @__PURE__ */ Object.create(null), q = /* @__PURE__ */ Object.create(null), ce = [];
        var xe = !0;
        var Ae = "Could not find the language '{}', did you forget to load/include a language module?", oe = {
            disableAutodetect: !0,
            name: "Plain text",
            contains: []
        };
        var ee = {
            ignoreUnescapedHTML: !1,
            throwUnescapedHTML: !1,
            noHighlightRe: /^(no-?highlight)$/i,
            languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
            classPrefix: "hljs-",
            cssSelector: "pre code",
            languages: null,
            // beta configuration options, subject to change, welcome to discuss
            // https://github.com/highlightjs/highlight.js/issues/1086
            __emitter: d
        };
        function me(X) {
            return ee.noHighlightRe.test(X);
        }
        function Qe(X) {
            var pe = X.className + " ";
            pe += X.parentNode ? X.parentNode.className : "";
            var Ee = ee.languageDetectRe.exec(pe);
            if (Ee) {
                var qe = En(Ee[1]);
                return qe || (K(Ae.replace("{}", Ee[1])), K("Falling back to no-highlight mode for this block.", X)), qe ? Ee[1] : "no-highlight";
            }
            return pe.split(/\s+/).find(function(qe) {
                return me(qe) || En(qe);
            });
        }
        function $e(X, pe, Ee) {
            var qe = "", et = "";
            (typeof pe === "undefined" ? "undefined" : (0, $6gBIz._)(pe)) == "object" ? (qe = X, Ee = pe.ignoreIllegals, et = pe.language) : (ge("10.7.0", "highlight(lang, code, ...args) has been deprecated."), ge("10.7.0", "Please use highlight(code, options) instead.\nhttps://github.com/highlightjs/highlight.js/issues/2277"), et = X, qe = pe), Ee === void 0 && (Ee = !0);
            var Wt = {
                code: qe,
                language: et
            };
            go("before:highlight", Wt);
            var An = Wt.result ? Wt.result : $t(Wt.language, Wt.code, Ee);
            return An.code = Wt.code, go("after:highlight", An), An;
        }
        function $t(X, pe, Ee, qe) {
            var et = /* @__PURE__ */ Object.create(null);
            function Wt(ne, le) {
                return ne.keywords[le];
            }
            function An() {
                if (!_e.keywords) {
                    it.addText(je);
                    return;
                }
                var _$ne = 0;
                _e.keywordPatternRe.lastIndex = 0;
                var le = _e.keywordPatternRe.exec(je), ye = "";
                for(; le;){
                    ye += je.substring(_$ne, le.index);
                    var Ne = sn.case_insensitive ? le[0].toLowerCase() : le[0], dt = Wt(_e, Ne);
                    if (dt) {
                        var _dt = (0, $9tk0W._)(dt, 2), fn = _dt[0], vv = _dt[1];
                        if (it.addText(ye), ye = "", et[Ne] = (et[Ne] || 0) + 1, et[Ne] <= Or && (_o += vv), fn.startsWith("_")) ye += le[0];
                        else {
                            var _v = sn.classNameAliases[fn] || fn;
                            on(le[0], _v);
                        }
                    } else ye += le[0];
                    _$ne = _e.keywordPatternRe.lastIndex, le = _e.keywordPatternRe.exec(je);
                }
                ye += je.substring(_$ne), it.addText(ye);
            }
            function mo() {
                if (je === "") return;
                var _$ne = null;
                if (typeof _e.subLanguage == "string") {
                    if (!L[_e.subLanguage]) {
                        it.addText(je);
                        return;
                    }
                    _$ne = $t(_e.subLanguage, je, !0, Kl[_e.subLanguage]), Kl[_e.subLanguage] = /** @type {CompiledMode} */ _$ne._top;
                } else _$ne = Is(je, _e.subLanguage.length ? _e.subLanguage : null);
                _e.relevance > 0 && (_o += _$ne.relevance), it.__addSublanguage(_$ne._emitter, _$ne.language);
            }
            function Mt() {
                _e.subLanguage != null ? mo() : An(), je = "";
            }
            function on(ne, le) {
                ne !== "" && (it.startScope(le), it.addText(ne), it.endScope());
            }
            function Vl(ne, le) {
                var ye = 1;
                var Ne = le.length - 1;
                for(; ye <= Ne;){
                    if (!ne._emit[ye]) {
                        ye++;
                        continue;
                    }
                    var dt = sn.classNameAliases[ne[ye]] || ne[ye], fn = le[ye];
                    dt ? on(fn, dt) : (je = fn, An(), je = ""), ye++;
                }
            }
            function Zl(ne, le) {
                return ne.scope && typeof ne.scope == "string" && it.openNode(sn.classNameAliases[ne.scope] || ne.scope), ne.beginScope && (ne.beginScope._wrap ? (on(je, sn.classNameAliases[ne.beginScope._wrap] || ne.beginScope._wrap), je = "") : ne.beginScope._multi && (Vl(ne.beginScope, le), je = "")), _e = Object.create(ne, {
                    parent: {
                        value: _e
                    }
                }), _e;
            }
            function Wl(ne, le, ye) {
                var Ne = k(ne.endRe, ye);
                if (Ne) {
                    if (ne["on:end"]) {
                        var dt = new t(ne);
                        ne["on:end"](le, dt), dt.isMatchIgnored && (Ne = !1);
                    }
                    if (Ne) {
                        for(; ne.endsParent && ne.parent;)ne = ne.parent;
                        return ne;
                    }
                }
                if (ne.endsWithParent) return Wl(ne.parent, le, ye);
            }
            function fv(ne) {
                return _e.matcher.regexIndex === 0 ? (je += ne[0], 1) : (Rs = !0, 0);
            }
            function pv(ne) {
                var le = ne[0], ye = ne.rule, Ne = new t(ye), dt = [
                    ye.__beforeBegin,
                    ye["on:begin"]
                ];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = dt[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var fn = _step.value;
                        if (fn && (fn(ne, Ne), Ne.isMatchIgnored)) return fv(le);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return ye.skip ? je += le : (ye.excludeBegin && (je += le), Mt(), !ye.returnBegin && !ye.excludeBegin && (je = le)), Zl(ye, ne), ye.returnBegin ? 0 : le.length;
            }
            function hv(ne) {
                var le = ne[0], ye = pe.substring(ne.index), Ne = Wl(_e, ne, ye);
                if (!Ne) return jn;
                var dt = _e;
                _e.endScope && _e.endScope._wrap ? (Mt(), on(le, _e.endScope._wrap)) : _e.endScope && _e.endScope._multi ? (Mt(), Vl(_e.endScope, ne)) : dt.skip ? je += le : (dt.returnEnd || dt.excludeEnd || (je += le), Mt(), dt.excludeEnd && (je = le));
                do _e.scope && it.closeNode(), !_e.skip && !_e.subLanguage && (_o += _e.relevance), _e = _e.parent;
                while (_e !== Ne.parent);
                return Ne.starts && Zl(Ne.starts, ne), dt.returnEnd ? 0 : le.length;
            }
            function gv() {
                var _$ne = [];
                for(var le = _e; le !== sn; le = le.parent)le.scope && _$ne.unshift(le.scope);
                _$ne.forEach(function(le) {
                    return it.openNode(le);
                });
            }
            var vo = {};
            function Gl(ne, le) {
                var ye = le && le[0];
                if (je += ne, ye == null) return Mt(), 0;
                if (vo.type === "begin" && le.type === "end" && vo.index === le.index && ye === "") {
                    if (je += pe.slice(le.index, le.index + 1), !xe) {
                        var Ne = new Error("0 width match regex (".concat(X, ")"));
                        throw Ne.languageName = X, Ne.badRule = vo.rule, Ne;
                    }
                    return 1;
                }
                if (vo = le, le.type === "begin") return pv(le);
                if (le.type === "illegal" && !Ee) {
                    var Ne1 = new Error('Illegal lexeme "' + ye + '" for mode "' + (_e.scope || "<unnamed>") + '"');
                    throw Ne1.mode = _e, Ne1;
                } else if (le.type === "end") {
                    var Ne2 = hv(le);
                    if (Ne2 !== jn) return Ne2;
                }
                if (le.type === "illegal" && ye === "") return 1;
                if (Os > 1e5 && Os > le.index * 3) throw new Error("potential infinite loop, way more iterations than matches");
                return je += ye, ye.length;
            }
            var sn = En(X);
            if (!sn) throw nt(Ae.replace("{}", X)), new Error('Unknown language: "' + X + '"');
            var mv = Tr(sn);
            var Ls = "", _e = qe || mv;
            var Kl = {}, it = new ee.__emitter(ee);
            gv();
            var je = "", _o = 0, Un = 0, Os = 0, Rs = !1;
            try {
                if (sn.__emitTokens) sn.__emitTokens(pe, it);
                else {
                    for(_e.matcher.considerAll();;){
                        Os++, Rs ? Rs = !1 : _e.matcher.considerAll(), _e.matcher.lastIndex = Un;
                        var _$ne = _e.matcher.exec(pe);
                        if (!_$ne) break;
                        var le = pe.substring(Un, _$ne.index), ye = Gl(le, _$ne);
                        Un = _$ne.index + ye;
                    }
                    Gl(pe.substring(Un));
                }
                return it.finalize(), Ls = it.toHTML(), {
                    language: X,
                    value: Ls,
                    relevance: _o,
                    illegal: !1,
                    _emitter: it,
                    _top: _e
                };
            } catch (ne) {
                if (ne.message && ne.message.includes("Illegal")) return {
                    language: X,
                    value: Sn(pe),
                    illegal: !0,
                    relevance: 0,
                    _illegalBy: {
                        message: ne.message,
                        index: Un,
                        context: pe.slice(Un - 100, Un + 100),
                        mode: ne.mode,
                        resultSoFar: Ls
                    },
                    _emitter: it
                };
                if (xe) return {
                    language: X,
                    value: Sn(pe),
                    illegal: !1,
                    relevance: 0,
                    errorRaised: ne,
                    _emitter: it,
                    _top: _e
                };
                throw ne;
            }
        }
        function Ms(X) {
            var pe = {
                value: Sn(X),
                illegal: !1,
                relevance: 0,
                _top: oe,
                _emitter: new ee.__emitter(ee)
            };
            return pe._emitter.addText(X), pe;
        }
        function Is(X, pe) {
            pe = pe || ee.languages || Object.keys(L);
            var Ee = Ms(X), qe = pe.filter(En).filter(Ul).map(function(Mt) {
                return $t(Mt, X, !1);
            });
            qe.unshift(Ee);
            var et = qe.sort(function(Mt, on) {
                if (Mt.relevance !== on.relevance) return on.relevance - Mt.relevance;
                if (Mt.language && on.language) {
                    if (En(Mt.language).supersetOf === on.language) return 1;
                    if (En(on.language).supersetOf === Mt.language) return -1;
                }
                return 0;
            }), _et = (0, $9tk0W._)(et, 2), Wt = _et[0], An = _et[1], mo = Wt;
            return mo.secondBest = An, mo;
        }
        function ev(X, pe, Ee) {
            var qe = pe && q[pe] || Ee;
            X.classList.add("hljs"), X.classList.add("language-".concat(qe));
        }
        function Ts(X) {
            var pe = null;
            var Ee = Qe(X);
            if (me(Ee)) return;
            if (go("before:highlightElement", {
                el: X,
                language: Ee
            }), X.dataset.highlighted) {
                console.log("Element previously highlighted. To highlight again, first unset `dataset.highlighted`.", X);
                return;
            }
            if (X.children.length > 0 && (ee.ignoreUnescapedHTML || (console.warn("One of your code blocks includes unescaped HTML. This is a potentially serious security risk."), console.warn("https://github.com/highlightjs/highlight.js/wiki/security"), console.warn("The element with unescaped HTML:"), console.warn(X)), ee.throwUnescapedHTML)) throw new Hn("One of your code blocks includes unescaped HTML.", X.innerHTML);
            pe = X;
            var qe = pe.textContent, et = Ee ? $e(qe, {
                language: Ee,
                ignoreIllegals: !0
            }) : Is(qe);
            X.innerHTML = et.value, X.dataset.highlighted = "yes", ev(X, Ee, et.language), X.result = {
                language: et.language,
                // TODO: remove with version 11.0
                re: et.relevance,
                relevance: et.relevance
            }, et.secondBest && (X.secondBest = {
                language: et.secondBest.language,
                relevance: et.secondBest.relevance
            }), go("after:highlightElement", {
                el: X,
                result: et,
                text: qe
            });
        }
        function tv(X) {
            ee = ir(ee, X);
        }
        var nv = function() {
            ho(), ge("10.6.0", "initHighlighting() deprecated.  Use highlightAll() now.");
        };
        function rv() {
            ho(), ge("10.6.0", "initHighlightingOnLoad() deprecated.  Use highlightAll() now.");
        }
        var Hl = !1;
        function ho() {
            if (document.readyState === "loading") {
                Hl = !0;
                return;
            }
            document.querySelectorAll(ee.cssSelector).forEach(Ts);
        }
        function ov() {
            Hl && ho();
        }
        (typeof window === "undefined" ? "undefined" : (0, $6gBIz._)(window)) < "u" && window.addEventListener && window.addEventListener("DOMContentLoaded", ov, !1);
        function sv(X, pe) {
            var Ee = null;
            try {
                Ee = pe(E);
            } catch (qe) {
                if (nt("Language definition for '{}' could not be registered.".replace("{}", X)), xe) nt(qe);
                else throw qe;
                Ee = oe;
            }
            Ee.name || (Ee.name = X), L[X] = Ee, Ee.rawDefinition = pe.bind(null, E), Ee.aliases && jl(Ee.aliases, {
                languageName: X
            });
        }
        function iv(X) {
            delete L[X];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.keys(q)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var pe = _step.value;
                    q[pe] === X && delete q[pe];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        function av() {
            return Object.keys(L);
        }
        function En(X) {
            return X = (X || "").toLowerCase(), L[X] || L[q[X]];
        }
        function jl(X, param) {
            var pe = param.languageName;
            typeof X == "string" && (X = [
                X
            ]), X.forEach(function(Ee) {
                q[Ee.toLowerCase()] = pe;
            });
        }
        function Ul(X) {
            var pe = En(X);
            return pe && !pe.disableAutodetect;
        }
        function cv(X) {
            X["before:highlightBlock"] && !X["before:highlightElement"] && (X["before:highlightElement"] = function(pe) {
                X["before:highlightBlock"](Object.assign({
                    block: pe.el
                }, pe));
            }), X["after:highlightBlock"] && !X["after:highlightElement"] && (X["after:highlightElement"] = function(pe) {
                X["after:highlightBlock"](Object.assign({
                    block: pe.el
                }, pe));
            });
        }
        function lv(X) {
            cv(X), ce.push(X);
        }
        function uv(X) {
            var pe = ce.indexOf(X);
            pe !== -1 && ce.splice(pe, 1);
        }
        function go(X, pe) {
            var Ee = X;
            ce.forEach(function(qe) {
                qe[Ee] && qe[Ee](pe);
            });
        }
        function dv(X) {
            return ge("10.7.0", "highlightBlock will be removed entirely in v12.0"), ge("10.7.0", "Please use highlightElement now."), Ts(X);
        }
        Object.assign(E, {
            highlight: $e,
            highlightAuto: Is,
            highlightAll: ho,
            highlightElement: Ts,
            // TODO: Remove with v12 API
            highlightBlock: dv,
            configure: tv,
            initHighlighting: nv,
            initHighlightingOnLoad: rv,
            registerLanguage: sv,
            unregisterLanguage: iv,
            listLanguages: av,
            getLanguage: En,
            registerAliases: jl,
            autoDetection: Ul,
            inherit: ir,
            addPlugin: lv,
            removePlugin: uv
        }), E.debugMode = function() {
            xe = !1;
        }, E.safeMode = function() {
            xe = !0;
        }, E.versionString = Lr, E.regex = {
            concat: g,
            lookahead: m,
            either: h,
            optional: v,
            anyNumberOfTimes: f
        };
        for(var X in re)(0, $6gBIz._)(re[X]) == "object" && e(re[X]);
        return Object.assign(E, re), E;
    }, O = ar({});
    return O.newInstance = function() {
        return ar({});
    }, Bs = O, O.HighlightJS = O, O["default"] = O, Bs;
}
var i_ = /* @__PURE__ */ s_();
var hn = /* @__PURE__ */ Er(i_), eu = "[A-Za-z$_][0-9A-Za-z$_]*", a_ = [
    "as",
    // for exports
    "in",
    "of",
    "if",
    "for",
    "while",
    "finally",
    "var",
    "new",
    "function",
    "do",
    "return",
    "void",
    "else",
    "break",
    "catch",
    "instanceof",
    "with",
    "throw",
    "case",
    "default",
    "try",
    "switch",
    "continue",
    "typeof",
    "delete",
    "let",
    "yield",
    "const",
    "class",
    // JS handles these with a special rule
    // "get",
    // "set",
    "debugger",
    "async",
    "await",
    "static",
    "import",
    "from",
    "export",
    "extends"
], c_ = [
    "true",
    "false",
    "null",
    "undefined",
    "NaN",
    "Infinity"
], Dp = [
    // Fundamental objects
    "Object",
    "Function",
    "Boolean",
    "Symbol",
    // numbers and dates
    "Math",
    "Date",
    "Number",
    "BigInt",
    // text
    "String",
    "RegExp",
    // Indexed collections
    "Array",
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Int16Array",
    "Int32Array",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array",
    // Keyed collections
    "Set",
    "Map",
    "WeakSet",
    "WeakMap",
    // Structured data
    "ArrayBuffer",
    "SharedArrayBuffer",
    "Atomics",
    "DataView",
    "JSON",
    // Control abstraction objects
    "Promise",
    "Generator",
    "GeneratorFunction",
    "AsyncFunction",
    // Reflection
    "Reflect",
    "Proxy",
    // Internationalization
    "Intl",
    // WebAssembly
    "WebAssembly"
], Np = [
    "Error",
    "EvalError",
    "InternalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
], qp = [
    "setInterval",
    "setTimeout",
    "clearInterval",
    "clearTimeout",
    "require",
    "exports",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "unescape"
], l_ = [
    "arguments",
    "this",
    "super",
    "console",
    "window",
    "document",
    "localStorage",
    "sessionStorage",
    "module",
    "global"
], u_ = [].concat(qp, Dp, Np);
function Fp(e) {
    var t = e.regex, n = function(U, param) {
        var G = param.after;
        var T = "</" + U[0].slice(1);
        return U.input.indexOf(T, G) !== -1;
    }, r = eu, s = {
        begin: "<>",
        end: "</>"
    }, o = /<[A-Za-z0-9\\._:-]+\s*\/>/, i = {
        begin: /<[A-Za-z0-9\\._:-]+/,
        end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
        /**
     * @param {RegExpMatchArray} match
     * @param {CallbackResponse} response
     */ isTrulyOpeningTag: function(U, G) {
            var T = U[0].length + U.index, W = U.input[T];
            if (// HTML should not include another raw `<` inside a tag
            // nested type?
            // `<Array<Array<number>>`, etc.
            W === "<" || // the , gives away that this is not HTML
            // `<T, A extends keyof T, V>`
            W === ",") {
                G.ignoreMatch();
                return;
            }
            W === ">" && (n(U, {
                after: T
            }) || G.ignoreMatch());
            var V;
            var se = U.input.substring(T);
            if (V = se.match(/^\s*=/)) {
                G.ignoreMatch();
                return;
            }
            if ((V = se.match(/^\s+extends\s+/)) && V.index === 0) {
                G.ignoreMatch();
                return;
            }
        }
    }, a = {
        $pattern: eu,
        keyword: a_,
        literal: c_,
        built_in: u_,
        "variable.language": l_
    }, c = "[0-9](_?[0-9])*", u = "\\.(".concat(c, ")"), d = "0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*", l = {
        className: "number",
        variants: [
            // DecimalLiteral
            {
                begin: "(\\b(".concat(d, ")((").concat(u, ")|\\.)?|(").concat(u, "))[eE][+-]?(").concat(c, ")\\b")
            },
            {
                begin: "\\b(".concat(d, ")\\b((").concat(u, ")\\b|\\.)?|(").concat(u, ")\\b")
            },
            // DecimalBigIntegerLiteral
            {
                begin: "\\b(0|[1-9](_?[0-9])*)n\\b"
            },
            // NonDecimalIntegerLiteral
            {
                begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b"
            },
            {
                begin: "\\b0[bB][0-1](_?[0-1])*n?\\b"
            },
            {
                begin: "\\b0[oO][0-7](_?[0-7])*n?\\b"
            },
            // LegacyOctalIntegerLiteral (does not include underscore separators)
            // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
            {
                begin: "\\b0[0-7]+n?\\b"
            }
        ],
        relevance: 0
    }, m = {
        className: "subst",
        begin: "\\$\\{",
        end: "\\}",
        keywords: a,
        contains: []
    }, f = {
        begin: "html`",
        end: "",
        starts: {
            end: "`",
            returnEnd: !1,
            contains: [
                e.BACKSLASH_ESCAPE,
                m
            ],
            subLanguage: "xml"
        }
    }, v = {
        begin: "css`",
        end: "",
        starts: {
            end: "`",
            returnEnd: !1,
            contains: [
                e.BACKSLASH_ESCAPE,
                m
            ],
            subLanguage: "css"
        }
    }, g = {
        begin: "gql`",
        end: "",
        starts: {
            end: "`",
            returnEnd: !1,
            contains: [
                e.BACKSLASH_ESCAPE,
                m
            ],
            subLanguage: "graphql"
        }
    }, b = {
        className: "string",
        begin: "`",
        end: "`",
        contains: [
            e.BACKSLASH_ESCAPE,
            m
        ]
    }, w = {
        className: "comment",
        variants: [
            e.COMMENT(/\/\*\*(?!\/)/, "\\*/", {
                relevance: 0,
                contains: [
                    {
                        begin: "(?=@[A-Za-z]+)",
                        relevance: 0,
                        contains: [
                            {
                                className: "doctag",
                                begin: "@[A-Za-z]+"
                            },
                            {
                                className: "type",
                                begin: "\\{",
                                end: "\\}",
                                excludeEnd: !0,
                                excludeBegin: !0,
                                relevance: 0
                            },
                            {
                                className: "variable",
                                begin: r + "(?=\\s*(-)|$)",
                                endsParent: !0,
                                relevance: 0
                            },
                            // eat spaces (not newlines) so we can find
                            // types or variables
                            {
                                begin: /(?=[^\n])\s/,
                                relevance: 0
                            }
                        ]
                    }
                ]
            }),
            e.C_BLOCK_COMMENT_MODE,
            e.C_LINE_COMMENT_MODE
        ]
    }, k = [
        e.APOS_STRING_MODE,
        e.QUOTE_STRING_MODE,
        f,
        v,
        g,
        b,
        // Skip numbers when they are part of a variable name
        {
            match: /\$\d+/
        },
        l
    ];
    m.contains = k.concat({
        // we need to pair up {} inside our subst to prevent
        // it from ending too early by matching another }
        begin: /\{/,
        end: /\}/,
        keywords: a,
        contains: [
            "self"
        ].concat(k)
    });
    var x = [].concat(w, m.contains), A = x.concat([
        // eat recursive parens in sub expressions
        {
            begin: /\(/,
            end: /\)/,
            keywords: a,
            contains: [
                "self"
            ].concat(x)
        }
    ]), S = {
        className: "params",
        begin: /\(/,
        end: /\)/,
        excludeBegin: !0,
        excludeEnd: !0,
        keywords: a,
        contains: A
    }, $ = {
        variants: [
            // class Car extends vehicle
            {
                match: [
                    /class/,
                    /\s+/,
                    r,
                    /\s+/,
                    /extends/,
                    /\s+/,
                    t.concat(r, "(", t.concat(/\./, r), ")*")
                ],
                scope: {
                    1: "keyword",
                    3: "title.class",
                    5: "keyword",
                    7: "title.class.inherited"
                }
            },
            // class Car
            {
                match: [
                    /class/,
                    /\s+/,
                    r
                ],
                scope: {
                    1: "keyword",
                    3: "title.class"
                }
            }
        ]
    }, M = {
        relevance: 0,
        match: t.either(// Hard coded exceptions
        /\bJSON/, // Float32Array, OutT
        /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/, // CSSFactory, CSSFactoryT
        /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/, // FPs, FPsT
        /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/),
        className: "title.class",
        keywords: {
            _: // se we still get relevance credit for JS library classes
            (0, $kf9Kn._)(Dp).concat((0, $kf9Kn._)(Np))
        }
    }, P = {
        label: "use_strict",
        className: "meta",
        relevance: 10,
        begin: /^\s*['"]use (strict|asm)['"]/
    }, R = {
        variants: [
            {
                match: [
                    /function/,
                    /\s+/,
                    r,
                    /(?=\s*\()/
                ]
            },
            // anonymous function
            {
                match: [
                    /function/,
                    /\s*(?=\()/
                ]
            }
        ],
        className: {
            1: "keyword",
            3: "title.function"
        },
        label: "func.def",
        contains: [
            S
        ],
        illegal: /%/
    }, B = {
        relevance: 0,
        match: /\b[A-Z][A-Z_0-9]+\b/,
        className: "variable.constant"
    };
    function H(U) {
        return t.concat("(?!", U.join("|"), ")");
    }
    var ie = {
        match: t.concat(/\b/, H((0, $kf9Kn._)(qp).concat([
            "super",
            "import"
        ])), r, t.lookahead(/\(/)),
        className: "title.function",
        relevance: 0
    }, z = {
        begin: t.concat(/\./, t.lookahead(t.concat(r, /(?![0-9A-Za-z$_(])/))),
        end: r,
        excludeBegin: !0,
        keywords: "prototype",
        className: "property",
        relevance: 0
    }, Q = {
        match: [
            /get|set/,
            /\s+/,
            r,
            /(?=\()/
        ],
        className: {
            1: "keyword",
            3: "title.function"
        },
        contains: [
            {
                // eat to avoid empty params
                begin: /\(\)/
            },
            S
        ]
    }, N = "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + e.UNDERSCORE_IDENT_RE + ")\\s*=>", j = {
        match: [
            /const|var|let/,
            /\s+/,
            r,
            /\s*/,
            /=\s*/,
            /(async\s*)?/,
            // async is optional
            t.lookahead(N)
        ],
        keywords: "async",
        className: {
            1: "keyword",
            3: "title.function"
        },
        contains: [
            S
        ]
    };
    return {
        name: "JavaScript",
        aliases: [
            "js",
            "jsx",
            "mjs",
            "cjs"
        ],
        keywords: a,
        // this will be extended by TypeScript
        exports: {
            PARAMS_CONTAINS: A,
            CLASS_REFERENCE: M
        },
        illegal: /#(?![$_A-z])/,
        contains: [
            e.SHEBANG({
                label: "shebang",
                binary: "node",
                relevance: 5
            }),
            P,
            e.APOS_STRING_MODE,
            e.QUOTE_STRING_MODE,
            f,
            v,
            g,
            b,
            w,
            // Skip numbers when they are part of a variable name
            {
                match: /\$\d+/
            },
            l,
            M,
            {
                className: "attr",
                begin: r + t.lookahead(":"),
                relevance: 0
            },
            j,
            {
                // "value" container
                begin: "(" + e.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
                keywords: "return throw case",
                relevance: 0,
                contains: [
                    w,
                    e.REGEXP_MODE,
                    {
                        className: "function",
                        // we have to count the parens to make sure we actually have the
                        // correct bounding ( ) before the =>.  There could be any number of
                        // sub-expressions inside also surrounded by parens.
                        begin: N,
                        returnBegin: !0,
                        end: "\\s*=>",
                        contains: [
                            {
                                className: "params",
                                variants: [
                                    {
                                        begin: e.UNDERSCORE_IDENT_RE,
                                        relevance: 0
                                    },
                                    {
                                        className: null,
                                        begin: /\(\s*\)/,
                                        skip: !0
                                    },
                                    {
                                        begin: /\(/,
                                        end: /\)/,
                                        excludeBegin: !0,
                                        excludeEnd: !0,
                                        keywords: a,
                                        contains: A
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        // could be a comma delimited list of params to a function call
                        begin: /,/,
                        relevance: 0
                    },
                    {
                        match: /\s+/,
                        relevance: 0
                    },
                    {
                        // JSX
                        variants: [
                            {
                                begin: s.begin,
                                end: s.end
                            },
                            {
                                match: o
                            },
                            {
                                begin: i.begin,
                                // we carefully check the opening tag to see if it truly
                                // is a tag and not a false positive
                                "on:begin": i.isTrulyOpeningTag,
                                end: i.end
                            }
                        ],
                        subLanguage: "xml",
                        contains: [
                            {
                                begin: i.begin,
                                end: i.end,
                                skip: !0,
                                contains: [
                                    "self"
                                ]
                            }
                        ]
                    }
                ]
            },
            R,
            {
                // prevent this from getting swallowed up by function
                // since they appear "function like"
                beginKeywords: "while if switch catch for"
            },
            {
                // we have to count the parens to make sure we actually have the correct
                // bounding ( ).  There could be any number of sub-expressions inside
                // also surrounded by parens.
                begin: "\\b(?!function)" + e.UNDERSCORE_IDENT_RE + "\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{",
                // end parens
                returnBegin: !0,
                label: "func.def",
                contains: [
                    S,
                    e.inherit(e.TITLE_MODE, {
                        begin: r,
                        className: "title.function"
                    })
                ]
            },
            // catch ... so it won't trigger the property rule below
            {
                match: /\.\.\./,
                relevance: 0
            },
            z,
            // hack: prevents detection of keywords in some circumstances
            // .keyword()
            // $keyword = x
            {
                match: "\\$" + r,
                relevance: 0
            },
            {
                match: [
                    /\bconstructor(?=\s*\()/
                ],
                className: {
                    1: "title.function"
                },
                contains: [
                    S
                ]
            },
            ie,
            B,
            $,
            Q,
            {
                match: /\$[(.]/
            }
        ]
    };
}
function Hp(e) {
    var t = e.regex, n = t.concat(RegExp("[\\p{L}_]", "u"), t.optional(RegExp("[\\p{L}0-9_.-]*:", "u")), RegExp("[\\p{L}0-9_.-]*", "u")), r = RegExp("[\\p{L}0-9._:-]+", "u"), s = {
        className: "symbol",
        begin: /&[a-z]+;|&#[0-9]+;|&#x[a-f0-9]+;/
    }, o = {
        begin: /\s/,
        contains: [
            {
                className: "keyword",
                begin: /#?[a-z_][a-z1-9_-]+/,
                illegal: /\n/
            }
        ]
    }, i = e.inherit(o, {
        begin: /\(/,
        end: /\)/
    }), a = e.inherit(e.APOS_STRING_MODE, {
        className: "string"
    }), c = e.inherit(e.QUOTE_STRING_MODE, {
        className: "string"
    }), u = {
        endsWithParent: !0,
        illegal: /</,
        relevance: 0,
        contains: [
            {
                className: "attr",
                begin: r,
                relevance: 0
            },
            {
                begin: /=\s*/,
                relevance: 0,
                contains: [
                    {
                        className: "string",
                        endsParent: !0,
                        variants: [
                            {
                                begin: /"/,
                                end: /"/,
                                contains: [
                                    s
                                ]
                            },
                            {
                                begin: /'/,
                                end: /'/,
                                contains: [
                                    s
                                ]
                            },
                            {
                                begin: /[^\s"'=<>`]+/
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        name: "HTML, XML",
        aliases: [
            "html",
            "xhtml",
            "rss",
            "atom",
            "xjb",
            "xsd",
            "xsl",
            "plist",
            "wsf",
            "svg"
        ],
        case_insensitive: !0,
        unicodeRegex: !0,
        contains: [
            {
                className: "meta",
                begin: /<![a-z]/,
                end: />/,
                relevance: 10,
                contains: [
                    o,
                    c,
                    a,
                    i,
                    {
                        begin: /\[/,
                        end: /\]/,
                        contains: [
                            {
                                className: "meta",
                                begin: /<![a-z]/,
                                end: />/,
                                contains: [
                                    o,
                                    i,
                                    c,
                                    a
                                ]
                            }
                        ]
                    }
                ]
            },
            e.COMMENT(/<!--/, /-->/, {
                relevance: 10
            }),
            {
                begin: /<!\[CDATA\[/,
                end: /\]\]>/,
                relevance: 10
            },
            s,
            // xml processing instructions
            {
                className: "meta",
                end: /\?>/,
                variants: [
                    {
                        begin: /<\?xml/,
                        relevance: 10,
                        contains: [
                            c
                        ]
                    },
                    {
                        begin: /<\?[a-z][a-z0-9]+/
                    }
                ]
            },
            {
                className: "tag",
                /*
        The lookahead pattern (?=...) ensures that 'begin' only matches
        '<style' as a single word, followed by a whitespace or an
        ending bracket.
        */ begin: /<style(?=\s|>)/,
                end: />/,
                keywords: {
                    name: "style"
                },
                contains: [
                    u
                ],
                starts: {
                    end: /<\/style>/,
                    returnEnd: !0,
                    subLanguage: [
                        "css",
                        "xml"
                    ]
                }
            },
            {
                className: "tag",
                // See the comment in the <style tag about the lookahead pattern
                begin: /<script(?=\s|>)/,
                end: />/,
                keywords: {
                    name: "script"
                },
                contains: [
                    u
                ],
                starts: {
                    end: /<\/script>/,
                    returnEnd: !0,
                    subLanguage: [
                        "javascript",
                        "handlebars",
                        "xml"
                    ]
                }
            },
            // we need this for now for jSX
            {
                className: "tag",
                begin: /<>|<\/>/
            },
            // open tag
            {
                className: "tag",
                begin: t.concat(/</, t.lookahead(t.concat(n, // <tag/>
                // <tag>
                // <tag ...
                t.either(/\/>/, />/, /\s/)))),
                end: /\/?>/,
                contains: [
                    {
                        className: "name",
                        begin: n,
                        relevance: 0,
                        starts: u
                    }
                ]
            },
            // close tag
            {
                className: "tag",
                begin: t.concat(/<\//, t.lookahead(t.concat(n, />/))),
                contains: [
                    {
                        className: "name",
                        begin: n,
                        relevance: 0
                    },
                    {
                        begin: />/,
                        relevance: 0,
                        endsParent: !0
                    }
                ]
            }
        ]
    };
}
var d_ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function f_(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", d_, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "currentColor",
            d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z"
        }, null, -1)
    ]));
}
var p_ = {
    name: "mdi-close",
    render: f_
}, Ht = function(e, t) {
    var n = e.__vccOpts || e;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $9tk0W._)(_step.value, 2), r = _step_value[0], s = _step_value[1];
            n[r] = s;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return n;
}, h_ = {}, g_ = {
    "class": "chat-button"
};
function m_(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("button", g_, [
        (0, $8B0Dy.renderSlot)(e.$slots, "default")
    ]);
}
var v_ = /* @__PURE__ */ Ht(h_, [
    [
        "render",
        m_
    ]
]);
function Yc() {
    return (0, $8B0Dy.inject)(Rp);
}
function co() {
    return {
        options: (0, $8B0Dy.inject)(Pp)
    };
}
function as() {
    var _ref;
    var _co = co(), e = _co.options, t = (_ref = e == null ? void 0 : e.defaultLanguage) !== null && _ref !== void 0 ? _ref : "en";
    function n(s) {
        var i, a;
        var o = (a = (i = e == null ? void 0 : e.i18n) == null ? void 0 : i[t]) == null ? void 0 : a[s];
        return (0, $5wB2C.isRef)(o) ? o.value : o !== null && o !== void 0 ? o : s;
    }
    function r(s) {
        var o, i;
        return !!((i = (o = e == null ? void 0 : e.i18n) == null ? void 0 : o[t]) != null && i[s]);
    }
    return {
        t: n,
        te: r
    };
}
var __ = {
    "class": "chat-get-started"
}, b_ = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    __name: "GetStarted",
    setup: function(e) {
        var t = as().t;
        return function(n, r) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", __, [
                (0, $8B0Dy.createVNode)(v_, {
                    onClick: r[0] || (r[0] = function(s) {
                        return n.$emit("click:button");
                    })
                }, {
                    "default": (0, $8B0Dy.withCtx)(function() {
                        return [
                            (0, $8B0Dy.createTextVNode)((0, $3ZJCa.toDisplayString)((0, $5wB2C.unref)(t)("getStarted")), 1)
                        ];
                    }),
                    _: 1
                })
            ]);
        };
    }
}), y_ = {}, w_ = {
    "class": "chat-powered-by"
};
function k_(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", w_, t[0] || (t[0] = [
        (0, $8B0Dy.createTextVNode)(" Powered by "),
        (0, $8B0Dy.createElementVNode)("a", {
            href: "https://n8n.io?utm_source=n8n-external&utm_medium=widget-powered-by"
        }, "n8n", -1)
    ]));
}
var x_ = /* @__PURE__ */ Ht(y_, [
    [
        "render",
        k_
    ]
]), C_ = {
    "class": "chat-get-started-footer"
}, S_ = {
    key: 0
}, E_ = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    __name: "GetStartedFooter",
    setup: function(e) {
        var _as = as(), t = _as.t, n = _as.te;
        return function(r, s) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", C_, [
                (0, $5wB2C.unref)(n)("footer") ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", S_, (0, $3ZJCa.toDisplayString)((0, $5wB2C.unref)(t)("footer")), 1)) : (0, $8B0Dy.createCommentVNode)("", !0),
                (0, $8B0Dy.createVNode)(x_)
            ]);
        };
    }
});
function A_(e) {
    return (0, $5wB2C.getCurrentScope)() ? ((0, $5wB2C.onScopeDispose)(e), !0) : !1;
}
function $_() {
    var e = /* @__PURE__ */ new Set(), t = function(s) {
        e["delete"](s);
    };
    return {
        on: function(s) {
            e.add(s);
            var o = function() {
                return t(s);
            };
            return A_(o), {
                off: o
            };
        },
        off: t,
        trigger: function() {
            for(var _len = arguments.length, s = new Array(_len), _key = 0; _key < _len; _key++){
                s[_key] = arguments[_key];
            }
            return Promise.all(Array.from(e).map(function(o) {
                return o.apply(void 0, (0, $kf9Kn._)(s));
            }));
        }
    };
}
var M_ = (typeof window === "undefined" ? "undefined" : (0, $6gBIz._)(window)) < "u" && (typeof document === "undefined" ? "undefined" : (0, $6gBIz._)(document)) < "u";
(typeof WorkerGlobalScope === "undefined" ? "undefined" : (0, $6gBIz._)(WorkerGlobalScope)) < "u" && (globalThis, WorkerGlobalScope);
var I_ = function(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
}, T_ = M_ ? window.document : void 0, L_ = {
    multiple: !0,
    accept: "*",
    reset: !1,
    directory: !1
};
function O_() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var tmp = e.document, t = tmp === void 0 ? T_ : tmp, n = (0, $5wB2C.ref)(null), _$_ = $_(), r = _$_.on, s = _$_.trigger;
    var o;
    t && (o = t.createElement("input"), o.type = "file", o.onchange = function(c) {
        var u = c.target;
        n.value = u.files, s(n.value);
    });
    var i = function() {
        n.value = null, o && o.value && (o.value = "", s(null));
    }, a = function(c) {
        if (!o) return;
        var u = (0, $6869c._)({}, L_, e, c);
        o.multiple = u.multiple, o.accept = u.accept, o.webkitdirectory = u.directory, I_(u, "capture") && (o.capture = u.capture), u.reset && i(), o.click();
    };
    return {
        files: (0, $5wB2C.readonly)(n),
        open: a,
        reset: i,
        onChange: r
    };
}
var R_ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function P_(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", R_, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "currentColor",
            d: "M16.5 6v11.5a4 4 0 0 1-4 4a4 4 0 0 1-4-4V5A2.5 2.5 0 0 1 11 2.5A2.5 2.5 0 0 1 13.5 5v10.5a1 1 0 0 1-1 1a1 1 0 0 1-1-1V6H10v9.5a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5V5a4 4 0 0 0-4-4a4 4 0 0 0-4 4v12.5a5.5 5.5 0 0 0 5.5 5.5a5.5 5.5 0 0 0 5.5-5.5V6z"
        }, null, -1)
    ]));
}
var B_ = {
    name: "mdi-paperclip",
    render: P_
}, z_ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function D_(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", z_, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "currentColor",
            d: "m2 21l21-9L2 3v7l15 2l-15 2z"
        }, null, -1)
    ]));
}
var N_ = {
    name: "mdi-send",
    render: D_
}, q_ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function F_(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", q_, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "currentColor",
            d: "M20 6.91L17.09 4L12 9.09L6.91 4L4 6.91L9.09 12L4 17.09L6.91 20L12 14.91L17.09 20L20 17.09L14.91 12z"
        }, null, -1)
    ]));
}
var H_ = {
    name: "mdi-closeThick",
    render: F_
}, j_ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function U_(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", j_, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "currentColor",
            d: "M13 9h5.5L13 3.5zM6 2h8l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2m0 18h12v-8l-4 4l-2-2zM8 9a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2"
        }, null, -1)
    ]));
}
var V_ = {
    name: "mdi-fileImage",
    render: U_
}, Z_ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function W_(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", Z_, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "currentColor",
            d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zm-1 11h-2v5a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2c.4 0 .7.1 1 .3V11h3zm0-4V3.5L18.5 9z"
        }, null, -1)
    ]));
}
var G_ = {
    name: "mdi-fileMusic",
    render: W_
}, K_ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function X_(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", K_, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "currentColor",
            d: "M13 9h5.5L13 3.5zM6 2h8l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2m9 16v-2H6v2zm3-4v-2H6v2z"
        }, null, -1)
    ]));
}
var tu = {
    name: "mdi-fileText",
    render: X_
}, Y_ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function J_(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", Y_, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "currentColor",
            d: "M13 9h5.5L13 3.5zM6 2h8l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2m11 17v-6l-3 2.2V13H7v6h7v-2.2z"
        }, null, -1)
    ]));
}
var Q_ = {
    name: "mdi-fileVideo",
    render: J_
}, eb = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function tb(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", eb, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "currentColor",
            d: "M14 3v2h3.59l-9.83 9.83l1.41 1.41L19 6.41V10h2V3m-2 16H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7h-2z"
        }, null, -1)
    ]));
}
var nb = {
    name: "mdi-openInNew",
    render: tb
}, rb = {
    "class": "chat-file-name"
}, ob = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    __name: "ChatFile",
    props: {
        file: {},
        isRemovable: {
            type: Boolean
        },
        isPreviewable: {
            type: Boolean
        }
    },
    emits: [
        "remove"
    ],
    setup: function(e, param) {
        var t = param.emit;
        var n = e, r = t, s = {
            document: tu,
            audio: G_,
            image: V_,
            video: Q_
        }, o = (0, $5wB2C.computed)(function() {
            var u;
            var c = (u = n.file) == null ? void 0 : u.type.split("/")[0];
            return s[c] || tu;
        });
        function i() {
            n.isPreviewable && window.open(URL.createObjectURL(n.file));
        }
        function a() {
            r("remove", n.file);
        }
        return function(c, u) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
                "class": "chat-file",
                onClick: i
            }, [
                (0, $8B0Dy.createVNode)((0, $5wB2C.unref)(o)),
                (0, $8B0Dy.createElementVNode)("p", rb, (0, $3ZJCa.toDisplayString)(c.file.name), 1),
                c.isRemovable ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("span", {
                    key: 0,
                    "class": "chat-file-delete",
                    onClick: (0, $kRi7Z.withModifiers)(a, [
                        "stop"
                    ])
                }, [
                    (0, $8B0Dy.createVNode)((0, $5wB2C.unref)(H_))
                ])) : c.isPreviewable ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(nb), {
                    key: 1,
                    "class": "chat-file-preview"
                })) : (0, $8B0Dy.createCommentVNode)("", !0)
            ]);
        };
    }
}), jp = /* @__PURE__ */ Ht(ob, [
    [
        "__scopeId",
        "data-v-e0d57af7"
    ]
]), sb = {
    "class": "chat-inputs"
}, ib = {
    key: 0,
    "class": "chat-input-left-panel"
}, ab = [
    "disabled",
    "placeholder"
], cb = {
    "class": "chat-inputs-controls"
}, lb = [
    "disabled"
], ub = [
    "disabled"
], db = {
    key: 0,
    "class": "chat-files"
}, fb = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    __name: "Input",
    props: {
        placeholder: {
            "default": "inputPlaceholder"
        }
    },
    emits: [
        "arrowKeyDown"
    ],
    setup: function(e, param) {
        var t = param.emit;
        var n = e, _as = as(), r = _as.t, s = t, _co = co(), o = _co.options, i = Yc(), a = i.waitingForResponse, c = (0, $5wB2C.ref)(null), u = (0, $5wB2C.ref)(null), d = (0, $5wB2C.ref)(""), l = (0, $5wB2C.ref)(!1), m = (0, $5wB2C.ref)(null), f = (0, $5wB2C.ref)(!1), v = (0, $5wB2C.computed)(function() {
            var T;
            return f.value ? !1 : d.value === "" || (0, $5wB2C.unref)(a) || ((T = o.disabled) == null ? void 0 : T.value) === !0;
        }), g = (0, $5wB2C.computed)(function() {
            var T;
            return ((T = o.disabled) == null ? void 0 : T.value) === !0;
        }), b = (0, $5wB2C.computed)(function() {
            var T;
            return h.value && (0, $5wB2C.unref)(a) && !((T = o.disabled) != null && T.value);
        }), h = (0, $5wB2C.computed)(function() {
            return (0, $5wB2C.unref)(o.allowFileUploads) === !0;
        }), w = (0, $5wB2C.computed)(function() {
            return (0, $5wB2C.unref)(o.allowedFilesMimeTypes);
        }), k = (0, $5wB2C.computed)(function() {
            return {
                "--controls-count": h.value ? 2 : 1
            };
        }), _O_ = O_({
            multiple: !0,
            reset: !1
        }), x = _O_.open, A = _O_.reset, S = _O_.onChange;
        S(function(T) {
            if (!T) return;
            var W = new DataTransfer();
            if (c.value) for(var V = 0; V < c.value.length; V++)W.items.add(c.value[V]);
            for(var V1 = 0; V1 < T.length; V1++)W.items.add(T[V1]);
            c.value = W.files;
        }), (0, $8B0Dy.onMounted)(function() {
            _t.on("focusInput", M), _t.on("blurInput", $), _t.on("setInputValue", P), u.value && (m.value = new ResizeObserver(function(T) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = T[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var W = _step.value;
                        W.target === u.value && G();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }), m.value.observe(u.value));
        }), (0, $8B0Dy.onUnmounted)(function() {
            _t.off("focusInput", M), _t.off("blurInput", $), _t.off("setInputValue", P), m.value && (m.value.disconnect(), m.value = null);
        });
        function $() {
            u.value && u.value.blur();
        }
        function M() {
            u.value && u.value.focus();
        }
        function P(T) {
            d.value = T, M();
        }
        function R() {
            if (c.value) {
                var T = Array.from(c.value);
                return A(), c.value = null, T;
            }
            return [];
        }
        function B(T) {
            if (o.webhookUrl && i.currentSessionId.value) try {
                var _$W = Wv(o.webhookUrl, T, i.currentSessionId.value, !0);
                i.ws = new WebSocket(_$W), i.ws.onmessage = function(V) {
                    var de;
                    if (V.data === "n8n|heartbeat") {
                        (de = i.ws) == null || de.send("n8n|heartbeat-ack");
                        return;
                    }
                    if (V.data === "n8n|continue") {
                        f.value = !1, i.waitingForResponse.value = !0;
                        return;
                    }
                    var se = {
                        id: Xn(),
                        text: V.data,
                        sender: "bot"
                    };
                    i.messages.value.push(se), f.value = !0, i.waitingForResponse.value = !1;
                }, i.ws.onclose = function() {
                    i.ws = null, f.value = !1, i.waitingForResponse.value = !1;
                };
            } catch (W) {
                console.error("Error setting up websocket connection", W);
            }
        }
        function H(T) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
                var W;
                return (0, $e0qXa.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!T || T.length === 0) return [
                                2,
                                []
                            ];
                            W = T.map(function(V) {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
                                    return (0, $e0qXa.__generator)(this, function(_state) {
                                        return [
                                            2,
                                            new Promise(function(se, de) {
                                                var ve = new FileReader();
                                                ve.onload = function() {
                                                    return se({
                                                        name: V.name,
                                                        type: V.type,
                                                        data: ve.result
                                                    });
                                                }, ve.onerror = function() {
                                                    var we;
                                                    var _ref;
                                                    return de(new Error("Error reading file: ".concat((_ref = (we = ve.error) == null ? void 0 : we.message) !== null && _ref !== void 0 ? _ref : "Unknown error")));
                                                }, ve.readAsDataURL(V);
                                            })
                                        ];
                                    });
                                })();
                            });
                            return [
                                4,
                                Promise.all(W)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            })();
        }
        function ie(T, W) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
                var V, _, _1, _tmp;
                return (0, $e0qXa.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            V = {
                                id: Xn(),
                                text: W,
                                sender: "user",
                                files: c.value ? R() : void 0
                            };
                            i.messages.value.push(V);
                            _ = T.send;
                            _1 = JSON.stringify;
                            _tmp = {
                                sessionId: i.currentSessionId.value,
                                action: "sendMessage",
                                chatInput: W
                            };
                            return [
                                4,
                                H(V.files)
                            ];
                        case 1:
                            _.apply(T, [
                                _1.apply(JSON, [
                                    (_tmp.files = _state.sent(), _tmp)
                                ])
                            ]), i.waitingForResponse.value = !0, f.value = !1;
                            return [
                                2
                            ];
                    }
                });
            })();
        }
        function z(T) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
                var W, V;
                return (0, $e0qXa.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (T.preventDefault(), v.value) return [
                                2
                            ];
                            W = d.value;
                            if (!(d.value = "", l.value = !0, i.ws && f.value)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                ie(i.ws, W)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                        case 2:
                            return [
                                4,
                                i.sendMessage(W, R())
                            ];
                        case 3:
                            V = _state.sent();
                            V != null && V.executionId && B(V.executionId), l.value = !1;
                            return [
                                2
                            ];
                    }
                });
            })();
        }
        function Q(T) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
                var _tmp;
                return (0, $e0qXa.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _tmp = T.shiftKey || T.isComposing;
                            if (_tmp) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                z(T)
                            ];
                        case 1:
                            _tmp = (_state.sent(), G());
                            _state.label = 2;
                        case 2:
                            _tmp;
                            return [
                                2
                            ];
                    }
                });
            })();
        }
        function N(T) {
            if (!c.value) return;
            var W = new DataTransfer();
            for(var V = 0; V < c.value.length; V++){
                var se = c.value[V];
                T.name !== se.name && W.items.add(se);
            }
            A(), c.value = W.files;
        }
        function j(T) {
            (T.key === "ArrowUp" || T.key === "ArrowDown") && (T.preventDefault(), s("arrowKeyDown", {
                key: T.key,
                currentInputValue: d.value
            }));
        }
        function U() {
            b.value || x({
                accept: (0, $5wB2C.unref)(w)
            });
        }
        function G() {
            var T = u.value;
            if (!T) return;
            T.style.height = "var(--chat--textarea--height)";
            var W = Math.min(T.scrollHeight, 480);
            T.style.height = "".concat(W, "px");
        }
        return function(T, W) {
            var V;
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
                "class": "chat-input",
                style: (0, $3ZJCa.normalizeStyle)(k.value),
                onKeydown: (0, $kRi7Z.withModifiers)(j, [
                    "stop"
                ])
            }, [
                (0, $8B0Dy.createElementVNode)("div", sb, [
                    T.$slots.leftPanel ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", ib, [
                        (0, $8B0Dy.renderSlot)(T.$slots, "leftPanel", {}, void 0, !0)
                    ])) : (0, $8B0Dy.createCommentVNode)("", !0),
                    (0, $8B0Dy.withDirectives)((0, $8B0Dy.createElementVNode)("textarea", {
                        ref_key: "chatTextArea",
                        ref: u,
                        "onUpdate:modelValue": W[0] || (W[0] = function(se) {
                            return d.value = se;
                        }),
                        "data-test-id": "chat-input",
                        disabled: g.value,
                        placeholder: (0, $5wB2C.unref)(r)(n.placeholder),
                        onKeydown: (0, $kRi7Z.withKeys)(Q, [
                            "enter"
                        ]),
                        onInput: G,
                        onMousedown: G,
                        onFocus: G
                    }, null, 40, ab), [
                        [
                            (0, $kRi7Z.vModelText),
                            d.value
                        ]
                    ]),
                    (0, $8B0Dy.createElementVNode)("div", cb, [
                        h.value ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("button", {
                            key: 0,
                            disabled: b.value,
                            "class": "chat-input-file-button",
                            "data-test-id": "chat-attach-file-button",
                            onClick: U
                        }, [
                            (0, $8B0Dy.createVNode)((0, $5wB2C.unref)(B_), {
                                height: "24",
                                width: "24"
                            })
                        ], 8, lb)) : (0, $8B0Dy.createCommentVNode)("", !0),
                        (0, $8B0Dy.createElementVNode)("button", {
                            disabled: v.value,
                            "class": "chat-input-send-button",
                            onClick: z
                        }, [
                            (0, $8B0Dy.createVNode)((0, $5wB2C.unref)(N_), {
                                height: "24",
                                width: "24"
                            })
                        ], 8, ub)
                    ])
                ]),
                (V = c.value) != null && V.length && (!l.value || f.value) ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", db, [
                    ((0, $8B0Dy.openBlock)(!0), (0, $8B0Dy.createElementBlock)((0, $8B0Dy.Fragment), null, (0, $8B0Dy.renderList)(c.value, function(se) {
                        return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)(jp, {
                            key: se.name,
                            file: se,
                            "is-removable": !0,
                            "is-previewable": !0,
                            onRemove: N
                        }, null, 8, [
                            "file"
                        ]);
                    }), 128))
                ])) : (0, $8B0Dy.createCommentVNode)("", !0)
            ], 36);
        };
    }
}), pb = /* @__PURE__ */ Ht(fb, [
    [
        "__scopeId",
        "data-v-de5e7961"
    ]
]), hb = {
    "class": "chat-layout"
}, gb = {
    key: 0,
    "class": "chat-header"
}, mb = {
    key: 2,
    "class": "chat-footer"
}, vb = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    __name: "Layout",
    setup: function(e) {
        var t = (0, $5wB2C.ref)(null);
        function n() {
            var r = t.value;
            r && (r.scrollTop = r.scrollHeight);
        }
        return (0, $8B0Dy.onMounted)(function() {
            _t.on("scrollToBottom", n), window.addEventListener("resize", n);
        }), (0, $8B0Dy.onBeforeUnmount)(function() {
            _t.off("scrollToBottom", n), window.removeEventListener("resize", n);
        }), function(r, s) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("main", hb, [
                r.$slots.header ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", gb, [
                    (0, $8B0Dy.renderSlot)(r.$slots, "header")
                ])) : (0, $8B0Dy.createCommentVNode)("", !0),
                r.$slots["default"] ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
                    key: 1,
                    ref_key: "chatBodyRef",
                    ref: t,
                    "class": "chat-body"
                }, [
                    (0, $8B0Dy.renderSlot)(r.$slots, "default")
                ], 512)) : (0, $8B0Dy.createCommentVNode)("", !0),
                r.$slots.footer ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", mb, [
                    (0, $8B0Dy.renderSlot)(r.$slots, "footer")
                ])) : (0, $8B0Dy.createCommentVNode)("", !0)
            ]);
        };
    }
}), _b = /(%|)\{([0-9a-zA-Z_]+)\}/g;
function bb() {
    var e = function(n, r) {
        return r in n;
    };
    function t(n) {
        for(var _len = arguments.length, r = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            r[_key - 1] = arguments[_key];
        }
        if (typeof n == "function") return n(r);
        var s = n;
        var o = r;
        return r.length === 1 && (0, $6gBIz._)(r[0]) == "object" && (o = r[0]), o != null && o.hasOwnProperty || (o = {}), s.replace(_b, function(i, a, c, u) {
            var d;
            return s[u - 1] === "{" && s[u + i.length] === "}" ? "".concat(c) : (d = e(o, c) ? "".concat(o[c]) : null, d !== null && d !== void 0 ? d : "");
        });
    }
    return t;
}
var yb = {
    "generic.retry": "Retry",
    "generic.cancel": "Cancel",
    "nds.auth.roles.owner": "Owner",
    "nds.userInfo.you": "(you)",
    "nds.userSelect.selectUser": "Select User",
    "nds.userSelect.noMatchingUsers": "No matching users",
    "notice.showMore": "Show more",
    "notice.showLess": "Show less",
    "formInput.validator.fieldRequired": "This field is required",
    "formInput.validator.minCharactersRequired": "Must be at least {minimum} characters",
    "formInput.validator.maxCharactersRequired": "Must be at most {maximum} characters",
    "formInput.validator.oneNumbersRequired": function(e) {
        return "Must have at least ".concat(e.minimum, " number").concat(e.minimum > 1 ? "s" : "");
    },
    "formInput.validator.validEmailRequired": "Must be a valid email",
    "formInput.validator.uppercaseCharsRequired": function(e) {
        return "Must have at least ".concat(e.minimum, " uppercase character").concat(e.minimum > 1 ? "s" : "");
    },
    "formInput.validator.defaultPasswordRequirements": "8+ characters, at least 1 number and 1 capital letter",
    "sticky.markdownHint": 'You can style with <a href="https://docs.n8n.io/workflows/sticky-notes/" target="_blank">Markdown</a>',
    "tags.showMore": function(e) {
        return "+".concat(e, " more");
    },
    "datatable.pageSize": "Page size",
    "codeDiff.couldNotReplace": "Could not replace code",
    "codeDiff.codeReplaced": "Code replaced",
    "codeDiff.replaceMyCode": "Replace my code",
    "codeDiff.replacing": "Replacing...",
    "codeDiff.undo": "Undo",
    "betaTag.beta": "beta",
    "askAssistantButton.askAssistant": "Ask Assistant",
    "assistantChat.builder.name": "AI Builder",
    "assistantChat.builder.generatingFinalWorkflow": "Generating final workflow...",
    "assistantChat.builder.configuredNodes": "Configured nodes",
    "assistantChat.builder.thumbsUp": "Helpful",
    "assistantChat.builder.thumbsDown": "Not helpful",
    "assistantChat.builder.feedbackPlaceholder": "Tell us about your experience",
    "assistantChat.builder.success": "Thank you for your feedback!",
    "assistantChat.builder.submit": "Submit feedback",
    "assistantChat.builder.workflowGenerated1": "Your workflow was created successfully!",
    "assistantChat.builder.workflowGenerated2": "Fix any missing credentials before testing it.",
    "assistantChat.builder.configuringNodes": "Configuring nodes...",
    "assistantChat.builder.selectedNodes": "Selected workflow nodes",
    "assistantChat.builder.selectingNodes": "Selecting nodes...",
    "assistantChat.builder.generatedNodes": "Generated workflow nodes",
    "assistantChat.builder.toolRunning": "Tool running",
    "assistantChat.builder.toolCompleted": "Tool completed",
    "assistantChat.builder.toolError": "Tool completed with error",
    "assistantChat.errorParsingMarkdown": "Error parsing markdown content",
    "assistantChat.aiAssistantLabel": "AI Assistant",
    "assistantChat.aiAssistantName": "Assistant",
    "assistantChat.sessionEndMessage.1": "This Assistant session has ended. To start a new session with the Assistant, click an",
    "assistantChat.sessionEndMessage.2": "button in n8n",
    "assistantChat.you": "You",
    "assistantChat.quickRepliesTitle": "Quick reply \uD83D\uDC47",
    "assistantChat.placeholder.1": function() {
        return "I can answer most questions about building workflows in n8n.";
    },
    "assistantChat.placeholder.2": "For specific tasks, you\u2019ll see the",
    "assistantChat.placeholder.3": "button in the UI.",
    "assistantChat.placeholder.4": "How can I help?",
    "assistantChat.inputPlaceholder": "Enter your response...",
    "assistantChat.copy": "Copy",
    "assistantChat.copied": "Copied",
    "inlineAskAssistantButton.asked": "Asked",
    "iconPicker.button.defaultToolTip": "Choose icon",
    "iconPicker.tabs.icons": "Icons",
    "iconPicker.tabs.emojis": "Emojis",
    "selectableList.addDefault": "+ Add a",
    "auth.changePassword.passwordsMustMatchError": "Passwords must match",
    "tableControlsButton.display": "Display",
    "tableControlsButton.shown": "Shown",
    "tableControlsButton.hidden": "Hidden"
}, wb = bb();
var nu = yb;
var kb = function kb(e, t) {
    return nu[e] !== void 0 ? wb.apply(void 0, [
        nu[e]
    ].concat((0, $kf9Kn._)(t ? [
        t
    ] : []))) : "";
}, gn = function(e, t) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, tmp = _ref.checkForDefaultPrevented, n = tmp === void 0 ? !0 : tmp;
    return function(s) {
        var o = e == null ? void 0 : e(s);
        if (n === !1 || !o) return t == null ? void 0 : t(s);
    };
};
var ru;
var gt = (typeof window === "undefined" ? "undefined" : (0, $6gBIz._)(window)) < "u", xb = function(e) {
    return typeof e == "string";
}, Up = function() {}, Vp = gt && ((ru = window == null ? void 0 : window.navigator) == null ? void 0 : ru.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function Zp(e) {
    return typeof e == "function" ? e() : (0, $5wB2C.unref)(e);
}
function Cb(e) {
    return e;
}
function Jc(e) {
    return (0, $5wB2C.getCurrentScope)() ? ((0, $5wB2C.onScopeDispose)(e), !0) : !1;
}
function Sb(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    (0, $8B0Dy.getCurrentInstance)() ? (0, $8B0Dy.onMounted)(e) : t ? e() : (0, $8B0Dy.nextTick)(e);
}
function On(e) {
    var t;
    var n = Zp(e);
    return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
var Qc = gt ? window : void 0;
function Yn() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    var t, n, r, s;
    var ref, ref1;
    if (xb(e[0]) || Array.isArray(e[0]) ? (ref = (0, $9tk0W._)(e, 3), n = ref[0], r = ref[1], s = ref[2], ref, t = Qc) : (ref1 = (0, $9tk0W._)(e, 4), t = ref1[0], n = ref1[1], r = ref1[2], s = ref1[3], ref1), !t) return Up;
    Array.isArray(n) || (n = [
        n
    ]), Array.isArray(r) || (r = [
        r
    ]);
    var o = [], i = function() {
        o.forEach(function(d) {
            return d();
        }), o.length = 0;
    }, a = function(d, l, m, f) {
        return d.addEventListener(l, m, f), function() {
            return d.removeEventListener(l, m, f);
        };
    }, c = (0, $5wB2C.watch)(function() {
        return [
            On(t),
            Zp(s)
        ];
    }, function(param) {
        var _param = (0, $9tk0W._)(param, 2), d = _param[0], l = _param[1];
        var _o;
        i(), d && (_o = o).push.apply(_o, (0, $kf9Kn._)(n.flatMap(function(m) {
            return r.map(function(f) {
                return a(d, m, f, l);
            });
        })));
    }, {
        immediate: !0,
        flush: "post"
    }), u = function() {
        c(), i();
    };
    return Jc(u), u;
}
var ou = !1;
function Eb(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var tmp = n.window, r = tmp === void 0 ? Qc : tmp, tmp1 = n.ignore, s = tmp1 === void 0 ? [] : tmp1, tmp2 = n.capture, o = tmp2 === void 0 ? !0 : tmp2, tmp3 = n.detectIframe, i = tmp3 === void 0 ? !1 : tmp3;
    if (!r) return;
    Vp && !ou && (ou = !0, Array.from(r.document.body.children).forEach(function(m) {
        return m.addEventListener("click", Up);
    }));
    var a = !0;
    var c = function(m) {
        return s.some(function(f) {
            if (typeof f == "string") return Array.from(r.document.querySelectorAll(f)).some(function(v) {
                return v === m.target || m.composedPath().includes(v);
            });
            {
                var v = On(f);
                return v && (m.target === v || m.composedPath().includes(v));
            }
        });
    }, d = [
        Yn(r, "click", function(m) {
            var f = On(e);
            if (!(!f || f === m.target || m.composedPath().includes(f))) {
                if (m.detail === 0 && (a = !c(m)), !a) {
                    a = !0;
                    return;
                }
                t(m);
            }
        }, {
            passive: !0,
            capture: o
        }),
        Yn(r, "pointerdown", function(m) {
            var f = On(e);
            f && (a = !m.composedPath().includes(f) && !c(m));
        }, {
            passive: !0
        }),
        i && Yn(r, "blur", function(m) {
            var f;
            var v = On(e);
            ((f = r.document.activeElement) == null ? void 0 : f.tagName) === "IFRAME" && !(v != null && v.contains(r.document.activeElement)) && t(m);
        })
    ].filter(Boolean);
    return function() {
        return d.forEach(function(m) {
            return m();
        });
    };
}
function Ab(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    var n = (0, $5wB2C.ref)(), r = function() {
        return n.value = !!e();
    };
    return r(), Sb(r, t), n;
}
var su = (typeof globalThis === "undefined" ? "undefined" : (0, $6gBIz._)(globalThis)) < "u" ? globalThis : (typeof window === "undefined" ? "undefined" : (0, $6gBIz._)(window)) < "u" ? window : (typeof $parcel$global === "undefined" ? "undefined" : (0, $6gBIz._)($parcel$global)) < "u" ? $parcel$global : (typeof self === "undefined" ? "undefined" : (0, $6gBIz._)(self)) < "u" ? self : {}, iu = "__vueuse_ssr_handlers__";
su[iu] = su[iu] || {};
var au = Object.getOwnPropertySymbols, $b = Object.prototype.hasOwnProperty, Mb = Object.prototype.propertyIsEnumerable, Ib = function(e, t) {
    var n = {};
    for(var r in e)$b.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (e != null && au) try {
        for(var _iterator = au(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var r = _step.value;
            t.indexOf(r) < 0 && Mb.call(e, r) && (n[r] = e[r]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return n;
};
function cs(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var r = n, tmp = r.window, s = tmp === void 0 ? Qc : tmp, o = Ib(r, [
        "window"
    ]);
    var i;
    var a = Ab(function() {
        return s && "ResizeObserver" in s;
    }), c = function() {
        i && (i.disconnect(), i = void 0);
    }, u = (0, $5wB2C.watch)(function() {
        return On(e);
    }, function(l) {
        c(), a.value && s && l && (i = new ResizeObserver(t), i.observe(l, o));
    }, {
        immediate: !0,
        flush: "post"
    }), d = function() {
        c(), u();
    };
    return Jc(d), {
        isSupported: a,
        stop: d
    };
}
var cu;
(function(e) {
    e.UP = "UP", e.RIGHT = "RIGHT", e.DOWN = "DOWN", e.LEFT = "LEFT", e.NONE = "NONE";
})(cu || (cu = {}));
var Tb = Object.defineProperty, lu = Object.getOwnPropertySymbols, Lb = Object.prototype.hasOwnProperty, Ob = Object.prototype.propertyIsEnumerable, uu = function(e, t, n) {
    return t in e ? Tb(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : e[t] = n;
}, Rb = function(e, t) {
    for(var n in t || (t = {}))Lb.call(t, n) && uu(e, n, t[n]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (lu) try {
        for(var _iterator = lu(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var n = _step.value;
            Ob.call(t, n) && uu(e, n, t[n]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return e;
};
var Pb = {
    easeInSine: [
        0.12,
        0,
        0.39,
        0
    ],
    easeOutSine: [
        0.61,
        1,
        0.88,
        1
    ],
    easeInOutSine: [
        0.37,
        0,
        0.63,
        1
    ],
    easeInQuad: [
        0.11,
        0,
        0.5,
        0
    ],
    easeOutQuad: [
        0.5,
        1,
        0.89,
        1
    ],
    easeInOutQuad: [
        0.45,
        0,
        0.55,
        1
    ],
    easeInCubic: [
        0.32,
        0,
        0.67,
        0
    ],
    easeOutCubic: [
        0.33,
        1,
        0.68,
        1
    ],
    easeInOutCubic: [
        0.65,
        0,
        0.35,
        1
    ],
    easeInQuart: [
        0.5,
        0,
        0.75,
        0
    ],
    easeOutQuart: [
        0.25,
        1,
        0.5,
        1
    ],
    easeInOutQuart: [
        0.76,
        0,
        0.24,
        1
    ],
    easeInQuint: [
        0.64,
        0,
        0.78,
        0
    ],
    easeOutQuint: [
        0.22,
        1,
        0.36,
        1
    ],
    easeInOutQuint: [
        0.83,
        0,
        0.17,
        1
    ],
    easeInExpo: [
        0.7,
        0,
        0.84,
        0
    ],
    easeOutExpo: [
        0.16,
        1,
        0.3,
        1
    ],
    easeInOutExpo: [
        0.87,
        0,
        0.13,
        1
    ],
    easeInCirc: [
        0.55,
        0,
        1,
        0.45
    ],
    easeOutCirc: [
        0,
        0.55,
        0.45,
        1
    ],
    easeInOutCirc: [
        0.85,
        0,
        0.15,
        1
    ],
    easeInBack: [
        0.36,
        0,
        0.66,
        -0.56
    ],
    easeOutBack: [
        0.34,
        1.56,
        0.64,
        1
    ],
    easeInOutBack: [
        0.68,
        -0.6,
        0.32,
        1.6
    ]
};
Rb({
    linear: Cb
}, Pb);
var Bb = function() {
    return gt && /firefox/i.test(window.navigator.userAgent);
}, el = function(e) {
    var t, n;
    return e.type === "touchend" ? (n = e.changedTouches[0].clientY, t = e.changedTouches[0].clientX) : e.type.startsWith("touch") ? (n = e.touches[0].clientY, t = e.touches[0].clientX) : (n = e.clientY, t = e.clientX), {
        clientX: t,
        clientY: n
    };
};
/**
* @vue/shared v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ var Yr = function() {}, zb = Object.prototype.hasOwnProperty, Vo = function(e, t) {
    return zb.call(e, t);
}, Db = Array.isArray, Pt = function(e) {
    return typeof e == "function";
}, Yt = function(e) {
    return typeof e == "string";
}, Jt = function(e) {
    return e !== null && (typeof e === "undefined" ? "undefined" : (0, $6gBIz._)(e)) == "object";
}, Nb = Object.prototype.toString, qb = function(e) {
    return Nb.call(e);
}, zs = function(e) {
    return qb(e).slice(8, -1);
};
var Wp = (typeof $parcel$global === "undefined" ? "undefined" : (0, $6gBIz._)($parcel$global)) == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global, Fb = (typeof self === "undefined" ? "undefined" : (0, $6gBIz._)(self)) == "object" && self && self.Object === Object && self, un = Wp || Fb || Function("return this")(), Bn = un.Symbol, Gp = Object.prototype, Hb = Gp.hasOwnProperty, jb = Gp.toString, Br = Bn ? Bn.toStringTag : void 0;
function Ub(e) {
    var t = Hb.call(e, Br), n = e[Br];
    try {
        e[Br] = void 0;
        var r = !0;
    } catch (e) {}
    var s = jb.call(e);
    return r && (t ? e[Br] = n : delete e[Br]), s;
}
var Vb = Object.prototype, Zb = Vb.toString;
function Wb(e) {
    return Zb.call(e);
}
var Gb = "[object Null]", Kb = "[object Undefined]", du = Bn ? Bn.toStringTag : void 0;
function Ar(e) {
    return e == null ? e === void 0 ? Kb : Gb : du && du in Object(e) ? Ub(e) : Wb(e);
}
function _r(e) {
    return e != null && (typeof e === "undefined" ? "undefined" : (0, $6gBIz._)(e)) == "object";
}
var Xb = "[object Symbol]";
function ls(e) {
    return (typeof e === "undefined" ? "undefined" : (0, $6gBIz._)(e)) == "symbol" || _r(e) && Ar(e) == Xb;
}
function Yb(e, t) {
    for(var n = -1, r = e == null ? 0 : e.length, s = Array(r); ++n < r;)s[n] = t(e[n], n, e);
    return s;
}
var bn = Array.isArray, fu = Bn ? Bn.prototype : void 0, pu = fu ? fu.toString : void 0;
function Kp(e) {
    if (typeof e == "string") return e;
    if (bn(e)) return Yb(e, Kp) + "";
    if (ls(e)) return pu ? pu.call(e) : "";
    var t = e + "";
    return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var Jb = /\s/;
function Qb(e) {
    for(var t = e.length; t-- && Jb.test(e.charAt(t)););
    return t;
}
var ey = /^\s+/;
function ty(e) {
    return e && e.slice(0, Qb(e) + 1).replace(ey, "");
}
function br(e) {
    var t = typeof e === "undefined" ? "undefined" : (0, $6gBIz._)(e);
    return e != null && (t == "object" || t == "function");
}
var hu = NaN, ny = /^[-+]0x[0-9a-f]+$/i, ry = /^0b[01]+$/i, oy = /^0o[0-7]+$/i, sy = parseInt;
function gu(e) {
    if (typeof e == "number") return e;
    if (ls(e)) return hu;
    if (br(e)) {
        var t = typeof e.valueOf == "function" ? e.valueOf() : e;
        e = br(t) ? t + "" : t;
    }
    if (typeof e != "string") return e === 0 ? e : +e;
    e = ty(e);
    var n = ry.test(e);
    return n || oy.test(e) ? sy(e.slice(2), n ? 2 : 8) : ny.test(e) ? hu : +e;
}
function iy(e) {
    return e;
}
var ay = "[object AsyncFunction]", cy = "[object Function]", ly = "[object GeneratorFunction]", uy = "[object Proxy]";
function Xp(e) {
    if (!br(e)) return !1;
    var t = Ar(e);
    return t == cy || t == ly || t == ay || t == uy;
}
var Ds = un["__core-js_shared__"], mu = function() {
    var e = /[^.]+$/.exec(Ds && Ds.keys && Ds.keys.IE_PROTO || "");
    return e ? "Symbol(src)_1." + e : "";
}();
function dy(e) {
    return !!mu && mu in e;
}
var fy = Function.prototype, py = fy.toString;
function rr(e) {
    if (e != null) {
        try {
            return py.call(e);
        } catch (e) {}
        try {
            return e + "";
        } catch (e) {}
    }
    return "";
}
var hy = /[\\^$.*+?()[\]{}|]/g, gy = /^\[object .+?Constructor\]$/, my = Function.prototype, vy = Object.prototype, _y = my.toString, by = vy.hasOwnProperty, yy = RegExp("^" + _y.call(by).replace(hy, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function wy(e) {
    if (!br(e) || dy(e)) return !1;
    var t = Xp(e) ? yy : gy;
    return t.test(rr(e));
}
function ky(e, t) {
    return e == null ? void 0 : e[t];
}
function $r(e, t) {
    var n = ky(e, t);
    return wy(n) ? n : void 0;
}
var _c = $r(un, "WeakMap");
function xy(e, t, n, r) {
    e.length;
    for(var s = n + 1; s--;)if (t(e[s], s, e)) return s;
    return -1;
}
var Cy = 9007199254740991, Sy = /^(?:0|[1-9]\d*)$/;
function Yp(e, t) {
    var n = typeof e === "undefined" ? "undefined" : (0, $6gBIz._)(e);
    return t = t !== null && t !== void 0 ? t : Cy, !!t && (n == "number" || n != "symbol" && Sy.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function Jp(e, t) {
    return e === t || e !== e && t !== t;
}
var Ey = 9007199254740991;
function tl(e) {
    return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Ey;
}
function Ay(e) {
    return e != null && tl(e.length) && !Xp(e);
}
var $y = Object.prototype;
function My(e) {
    var t = e && e.constructor, n = typeof t == "function" && t.prototype || $y;
    return e === n;
}
function Iy(e, t) {
    for(var n = -1, r = Array(e); ++n < e;)r[n] = t(n);
    return r;
}
var Ty = "[object Arguments]";
function vu(e) {
    return _r(e) && Ar(e) == Ty;
}
var Qp = Object.prototype, Ly = Qp.hasOwnProperty, Oy = Qp.propertyIsEnumerable, eh = vu(/* @__PURE__ */ function() {
    return arguments;
}()) ? vu : function eh(e) {
    return _r(e) && Ly.call(e, "callee") && !Oy.call(e, "callee");
};
function Ry() {
    return !1;
}
var th = exports && !exports.nodeType && exports, _u = th && true && module && !module.nodeType && module, Py = _u && _u.exports === th, bu = Py ? un.Buffer : void 0, By = bu ? bu.isBuffer : void 0, bc = By || Ry, zy = "[object Arguments]", Dy = "[object Array]", Ny = "[object Boolean]", qy = "[object Date]", Fy = "[object Error]", Hy = "[object Function]", jy = "[object Map]", Uy = "[object Number]", Vy = "[object Object]", Zy = "[object RegExp]", Wy = "[object Set]", Gy = "[object String]", Ky = "[object WeakMap]", Xy = "[object ArrayBuffer]", Yy = "[object DataView]", Jy = "[object Float32Array]", Qy = "[object Float64Array]", ew = "[object Int8Array]", tw = "[object Int16Array]", nw = "[object Int32Array]", rw = "[object Uint8Array]", ow = "[object Uint8ClampedArray]", sw = "[object Uint16Array]", iw = "[object Uint32Array]", Ue = {};
Ue[Jy] = Ue[Qy] = Ue[ew] = Ue[tw] = Ue[nw] = Ue[rw] = Ue[ow] = Ue[sw] = Ue[iw] = !0;
Ue[zy] = Ue[Dy] = Ue[Xy] = Ue[Ny] = Ue[Yy] = Ue[qy] = Ue[Fy] = Ue[Hy] = Ue[jy] = Ue[Uy] = Ue[Vy] = Ue[Zy] = Ue[Wy] = Ue[Gy] = Ue[Ky] = !1;
function aw(e) {
    return _r(e) && tl(e.length) && !!Ue[Ar(e)];
}
function cw(e) {
    return function(t) {
        return e(t);
    };
}
var nh = exports && !exports.nodeType && exports, jr = nh && true && module && !module.nodeType && module, lw = jr && jr.exports === nh, Ns = lw && Wp.process, yu = function() {
    try {
        var e = jr && jr.require && jr.require("util").types;
        return e || Ns && Ns.binding && Ns.binding("util");
    } catch (e) {}
}(), wu = yu && yu.isTypedArray, rh = wu ? cw(wu) : aw, uw = Object.prototype, dw = uw.hasOwnProperty;
function fw(e, t) {
    var n = bn(e), r = !n && eh(e), s = !n && !r && bc(e), o = !n && !r && !s && rh(e), i = n || r || s || o, a = i ? Iy(e.length, String) : [], c = a.length;
    for(var u in e)dw.call(e, u) && !(i && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    s && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    Yp(u, c))) && a.push(u);
    return a;
}
function pw(e, t) {
    return function(n) {
        return e(t(n));
    };
}
var hw = pw(Object.keys, Object), gw = Object.prototype, mw = gw.hasOwnProperty;
function vw(e) {
    if (!My(e)) return hw(e);
    var t = [];
    for(var n in Object(e))mw.call(e, n) && n != "constructor" && t.push(n);
    return t;
}
function oh(e) {
    return Ay(e) ? fw(e) : vw(e);
}
var _w = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, bw = /^\w*$/;
function nl(e, t) {
    if (bn(e)) return !1;
    var n = typeof e === "undefined" ? "undefined" : (0, $6gBIz._)(e);
    return n == "number" || n == "symbol" || n == "boolean" || e == null || ls(e) ? !0 : bw.test(e) || !_w.test(e) || t != null && e in Object(t);
}
var Jr = $r(Object, "create");
function yw() {
    this.__data__ = Jr ? Jr(null) : {}, this.size = 0;
}
function ww(e) {
    var t = this.has(e) && delete this.__data__[e];
    return this.size -= t ? 1 : 0, t;
}
var kw = "__lodash_hash_undefined__", xw = Object.prototype, Cw = xw.hasOwnProperty;
function Sw(e) {
    var t = this.__data__;
    if (Jr) {
        var n = t[e];
        return n === kw ? void 0 : n;
    }
    return Cw.call(t, e) ? t[e] : void 0;
}
var Ew = Object.prototype, Aw = Ew.hasOwnProperty;
function $w(e) {
    var t = this.__data__;
    return Jr ? t[e] !== void 0 : Aw.call(t, e);
}
var Mw = "__lodash_hash_undefined__";
function Iw(e, t) {
    var n = this.__data__;
    return this.size += this.has(e) ? 0 : 1, n[e] = Jr && t === void 0 ? Mw : t, this;
}
function tr(e) {
    var t = -1, n = e == null ? 0 : e.length;
    for(this.clear(); ++t < n;){
        var r = e[t];
        this.set(r[0], r[1]);
    }
}
tr.prototype.clear = yw;
tr.prototype["delete"] = ww;
tr.prototype.get = Sw;
tr.prototype.has = $w;
tr.prototype.set = Iw;
function Tw() {
    this.__data__ = [], this.size = 0;
}
function us(e, t) {
    for(var n = e.length; n--;)if (Jp(e[n][0], t)) return n;
    return -1;
}
var Lw = Array.prototype, Ow = Lw.splice;
function Rw(e) {
    var t = this.__data__, n = us(t, e);
    if (n < 0) return !1;
    var r = t.length - 1;
    return n == r ? t.pop() : Ow.call(t, n, 1), --this.size, !0;
}
function Pw(e) {
    var t = this.__data__, n = us(t, e);
    return n < 0 ? void 0 : t[n][1];
}
function Bw(e) {
    return us(this.__data__, e) > -1;
}
function zw(e, t) {
    var n = this.__data__, r = us(n, e);
    return r < 0 ? (++this.size, n.push([
        e,
        t
    ])) : n[r][1] = t, this;
}
function xn(e) {
    var t = -1, n = e == null ? 0 : e.length;
    for(this.clear(); ++t < n;){
        var r = e[t];
        this.set(r[0], r[1]);
    }
}
xn.prototype.clear = Tw;
xn.prototype["delete"] = Rw;
xn.prototype.get = Pw;
xn.prototype.has = Bw;
xn.prototype.set = zw;
var Qr = $r(un, "Map");
function Dw() {
    this.size = 0, this.__data__ = {
        hash: new tr(),
        map: new (Qr || xn)(),
        string: new tr()
    };
}
function Nw(e) {
    var t = typeof e === "undefined" ? "undefined" : (0, $6gBIz._)(e);
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function ds(e, t) {
    var n = e.__data__;
    return Nw(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function qw(e) {
    var t = ds(this, e)["delete"](e);
    return this.size -= t ? 1 : 0, t;
}
function Fw(e) {
    return ds(this, e).get(e);
}
function Hw(e) {
    return ds(this, e).has(e);
}
function jw(e, t) {
    var n = ds(this, e), r = n.size;
    return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
function Cn(e) {
    var t = -1, n = e == null ? 0 : e.length;
    for(this.clear(); ++t < n;){
        var r = e[t];
        this.set(r[0], r[1]);
    }
}
Cn.prototype.clear = Dw;
Cn.prototype["delete"] = qw;
Cn.prototype.get = Fw;
Cn.prototype.has = Hw;
Cn.prototype.set = jw;
var Uw = "Expected a function";
function rl(e, t) {
    if (typeof e != "function" || t != null && typeof t != "function") throw new TypeError(Uw);
    var n = function n1() {
        var r = arguments, s = t ? t.apply(this, r) : r[0], o = n.cache;
        if (o.has(s)) return o.get(s);
        var i = e.apply(this, r);
        return n.cache = o.set(s, i) || o, i;
    };
    return n.cache = new (rl.Cache || Cn)(), n;
}
rl.Cache = Cn;
var Vw = 500;
function Zw(e) {
    var t = rl(e, function(r) {
        return n.size === Vw && n.clear(), r;
    }), n = t.cache;
    return t;
}
var Ww = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Gw = /\\(\\)?/g, Kw = Zw(function(e) {
    var t = [];
    return e.charCodeAt(0) === 46 && t.push(""), e.replace(Ww, function(n, r, s, o) {
        t.push(s ? o.replace(Gw, "$1") : r || n);
    }), t;
});
function Xw(e) {
    return e == null ? "" : Kp(e);
}
function sh(e, t) {
    return bn(e) ? e : nl(e, t) ? [
        e
    ] : Kw(Xw(e));
}
function fs(e) {
    if (typeof e == "string" || ls(e)) return e;
    var t = e + "";
    return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function ih(e, t) {
    t = sh(t, e);
    for(var n = 0, r = t.length; e != null && n < r;)e = e[fs(t[n++])];
    return n && n == r ? e : void 0;
}
function Lt(e, t, n) {
    var r = e == null ? void 0 : ih(e, t);
    return r === void 0 ? n : r;
}
function Yw(e, t) {
    for(var n = -1, r = t.length, s = e.length; ++n < r;)e[s + n] = t[n];
    return e;
}
function Jw() {
    this.__data__ = new xn(), this.size = 0;
}
function Qw(e) {
    var t = this.__data__, n = t["delete"](e);
    return this.size = t.size, n;
}
function ek(e) {
    return this.__data__.get(e);
}
function tk(e) {
    return this.__data__.has(e);
}
var nk = 200;
function rk(e, t) {
    var n = this.__data__;
    if (n instanceof xn) {
        var r = n.__data__;
        if (!Qr || r.length < nk - 1) return r.push([
            e,
            t
        ]), this.size = ++n.size, this;
        n = this.__data__ = new Cn(r);
    }
    return n.set(e, t), this.size = n.size, this;
}
function vn(e) {
    var t = this.__data__ = new xn(e);
    this.size = t.size;
}
vn.prototype.clear = Jw;
vn.prototype["delete"] = Qw;
vn.prototype.get = ek;
vn.prototype.has = tk;
vn.prototype.set = rk;
function ok(e, t) {
    for(var n = -1, r = e == null ? 0 : e.length, s = 0, o = []; ++n < r;){
        var i = e[n];
        t(i, n, e) && (o[s++] = i);
    }
    return o;
}
function sk() {
    return [];
}
var ik = Object.prototype, ak = ik.propertyIsEnumerable, ku = Object.getOwnPropertySymbols, ck = ku ? function ck(e) {
    return e == null ? [] : (e = Object(e), ok(ku(e), function(t) {
        return ak.call(e, t);
    }));
} : sk;
function lk(e, t, n) {
    var r = t(e);
    return bn(e) ? r : Yw(r, n(e));
}
function xu(e) {
    return lk(e, oh, ck);
}
var yc = $r(un, "DataView"), wc = $r(un, "Promise"), kc = $r(un, "Set"), Cu = "[object Map]", uk = "[object Object]", Su = "[object Promise]", Eu = "[object Set]", Au = "[object WeakMap]", $u = "[object DataView]", dk = rr(yc), fk = rr(Qr), pk = rr(wc), hk = rr(kc), gk = rr(_c), Ln = Ar;
(yc && Ln(new yc(new ArrayBuffer(1))) != $u || Qr && Ln(new Qr()) != Cu || wc && Ln(wc.resolve()) != Su || kc && Ln(new kc()) != Eu || _c && Ln(new _c()) != Au) && (Ln = function Ln(e) {
    var t = Ar(e), n = t == uk ? e.constructor : void 0, r = n ? rr(n) : "";
    if (r) switch(r){
        case dk:
            return $u;
        case fk:
            return Cu;
        case pk:
            return Su;
        case hk:
            return Eu;
        case gk:
            return Au;
    }
    return t;
});
var Mu = un.Uint8Array, mk = "__lodash_hash_undefined__";
function vk(e) {
    return this.__data__.set(e, mk), this;
}
function _k(e) {
    return this.__data__.has(e);
}
function Zo(e) {
    var t = -1, n = e == null ? 0 : e.length;
    for(this.__data__ = new Cn(); ++t < n;)this.add(e[t]);
}
Zo.prototype.add = Zo.prototype.push = vk;
Zo.prototype.has = _k;
function bk(e, t) {
    for(var n = -1, r = e == null ? 0 : e.length; ++n < r;)if (t(e[n], n, e)) return !0;
    return !1;
}
function yk(e, t) {
    return e.has(t);
}
var wk = 1, kk = 2;
function ah(e, t, n, r, s, o) {
    var i = n & wk, a = e.length, c = t.length;
    if (a != c && !(i && c > a)) return !1;
    var u = o.get(e), d = o.get(t);
    if (u && d) return u == t && d == e;
    var l = -1, m = !0, f = n & kk ? new Zo() : void 0;
    for(o.set(e, t), o.set(t, e); ++l < a;){
        var v = e[l], g = t[l];
        if (r) var b = i ? r(g, v, l, t, e, o) : r(v, g, l, e, t, o);
        if (b !== void 0) {
            if (b) continue;
            m = !1;
            break;
        }
        if (f) {
            if (!bk(t, function(h, w) {
                if (!yk(f, w) && (v === h || s(v, h, n, r, o))) return f.push(w);
            })) {
                m = !1;
                break;
            }
        } else if (!(v === g || s(v, g, n, r, o))) {
            m = !1;
            break;
        }
    }
    return o["delete"](e), o["delete"](t), m;
}
function xk(e) {
    var t = -1, n = Array(e.size);
    return e.forEach(function(r, s) {
        n[++t] = [
            s,
            r
        ];
    }), n;
}
function Ck(e) {
    var t = -1, n = Array(e.size);
    return e.forEach(function(r) {
        n[++t] = r;
    }), n;
}
var Sk = 1, Ek = 2, Ak = "[object Boolean]", $k = "[object Date]", Mk = "[object Error]", Ik = "[object Map]", Tk = "[object Number]", Lk = "[object RegExp]", Ok = "[object Set]", Rk = "[object String]", Pk = "[object Symbol]", Bk = "[object ArrayBuffer]", zk = "[object DataView]", Iu = Bn ? Bn.prototype : void 0, qs = Iu ? Iu.valueOf : void 0;
function Dk(e, t, n, r, s, o, i) {
    switch(n){
        case zk:
            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
            e = e.buffer, t = t.buffer;
        case Bk:
            return !(e.byteLength != t.byteLength || !o(new Mu(e), new Mu(t)));
        case Ak:
        case $k:
        case Tk:
            return Jp(+e, +t);
        case Mk:
            return e.name == t.name && e.message == t.message;
        case Lk:
        case Rk:
            return e == t + "";
        case Ik:
            var a = xk;
        case Ok:
            var c = r & Sk;
            if (a || (a = Ck), e.size != t.size && !c) return !1;
            var u = i.get(e);
            if (u) return u == t;
            r |= Ek, i.set(e, t);
            var d = ah(a(e), a(t), r, s, o, i);
            return i["delete"](e), d;
        case Pk:
            if (qs) return qs.call(e) == qs.call(t);
    }
    return !1;
}
var Nk = 1, qk = Object.prototype, Fk = qk.hasOwnProperty;
function Hk(e, t, n, r, s, o) {
    var i = n & Nk, a = xu(e), c = a.length, u = xu(t), d = u.length;
    if (c != d && !i) return !1;
    for(var l = c; l--;){
        var m = a[l];
        if (!(i ? m in t : Fk.call(t, m))) return !1;
    }
    var f = o.get(e), v = o.get(t);
    if (f && v) return f == t && v == e;
    var g = !0;
    o.set(e, t), o.set(t, e);
    for(var b = i; ++l < c;){
        m = a[l];
        var h = e[m], w = t[m];
        if (r) var k = i ? r(w, h, m, t, e, o) : r(h, w, m, e, t, o);
        if (!(k === void 0 ? h === w || s(h, w, n, r, o) : k)) {
            g = !1;
            break;
        }
        b || (b = m == "constructor");
    }
    if (g && !b) {
        var x = e.constructor, A = t.constructor;
        x != A && "constructor" in e && "constructor" in t && !(typeof x == "function" && x instanceof x && typeof A == "function" && A instanceof A) && (g = !1);
    }
    return o["delete"](e), o["delete"](t), g;
}
var jk = 1, Tu = "[object Arguments]", Lu = "[object Array]", wo = "[object Object]", Uk = Object.prototype, Ou = Uk.hasOwnProperty;
function Vk(e, t, n, r, s, o) {
    var i = bn(e), a = bn(t), c = i ? Lu : Ln(e), u = a ? Lu : Ln(t);
    c = c == Tu ? wo : c, u = u == Tu ? wo : u;
    var d = c == wo, l = u == wo, m = c == u;
    if (m && bc(e)) {
        if (!bc(t)) return !1;
        i = !0, d = !1;
    }
    if (m && !d) return o || (o = new vn()), i || rh(e) ? ah(e, t, n, r, s, o) : Dk(e, t, c, n, r, s, o);
    if (!(n & jk)) {
        var f = d && Ou.call(e, "__wrapped__"), v = l && Ou.call(t, "__wrapped__");
        if (f || v) {
            var g = f ? e.value() : e, b = v ? t.value() : t;
            return o || (o = new vn()), s(g, b, n, r, o);
        }
    }
    return m ? (o || (o = new vn()), Hk(e, t, n, r, s, o)) : !1;
}
function ps(e, t, n, r, s) {
    return e === t ? !0 : e == null || t == null || !_r(e) && !_r(t) ? e !== e && t !== t : Vk(e, t, n, r, ps, s);
}
var Zk = 1, Wk = 2;
function Gk(e, t, n, r) {
    var s = n.length, o = s;
    if (e == null) return !o;
    for(e = Object(e); s--;){
        var i = n[s];
        if (i[2] ? i[1] !== e[i[0]] : !(i[0] in e)) return !1;
    }
    for(; ++s < o;){
        i = n[s];
        var a = i[0], c = e[a], u = i[1];
        if (i[2]) {
            if (c === void 0 && !(a in e)) return !1;
        } else {
            var d = new vn(), l;
            if (!(l === void 0 ? ps(u, c, Zk | Wk, r, d) : l)) return !1;
        }
    }
    return !0;
}
function ch(e) {
    return e === e && !br(e);
}
function Kk(e) {
    for(var t = oh(e), n = t.length; n--;){
        var r = t[n], s = e[r];
        t[n] = [
            r,
            s,
            ch(s)
        ];
    }
    return t;
}
function lh(e, t) {
    return function(n) {
        return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
    };
}
function Xk(e) {
    var t = Kk(e);
    return t.length == 1 && t[0][2] ? lh(t[0][0], t[0][1]) : function(n) {
        return n === e || Gk(n, e, t);
    };
}
function Yk(e, t) {
    return e != null && t in Object(e);
}
function Jk(e, t, n) {
    t = sh(t, e);
    for(var r = -1, s = t.length, o = !1; ++r < s;){
        var i = fs(t[r]);
        if (!(o = e != null && n(e, i))) break;
        e = e[i];
    }
    return o || ++r != s ? o : (s = e == null ? 0 : e.length, !!s && tl(s) && Yp(i, s) && (bn(e) || eh(e)));
}
function Qk(e, t) {
    return e != null && Jk(e, t, Yk);
}
var e4 = 1, t4 = 2;
function n4(e, t) {
    return nl(e) && ch(t) ? lh(fs(e), t) : function(n) {
        var r = Lt(n, e);
        return r === void 0 && r === t ? Qk(n, e) : ps(t, r, e4 | t4);
    };
}
function r4(e) {
    return function(t) {
        return t == null ? void 0 : t[e];
    };
}
function o4(e) {
    return function(t) {
        return ih(t, e);
    };
}
function s4(e) {
    return nl(e) ? r4(fs(e)) : o4(e);
}
function i4(e) {
    return typeof e == "function" ? e : e == null ? iy : (typeof e === "undefined" ? "undefined" : (0, $6gBIz._)(e)) == "object" ? bn(e) ? n4(e[0], e[1]) : Xk(e) : s4(e);
}
var Fs = function Fs() {
    return un.Date.now();
}, a4 = "Expected a function", c4 = Math.max, l4 = Math.min;
function xc(e, t, n) {
    var r, s, o, i, a, c, u = 0, d = !1, l = !1, m = !0;
    if (typeof e != "function") throw new TypeError(a4);
    t = gu(t) || 0, br(n) && (d = !!n.leading, l = "maxWait" in n, o = l ? c4(gu(n.maxWait) || 0, t) : o, m = "trailing" in n ? !!n.trailing : m);
    function f(S) {
        var $ = r, M = s;
        return r = s = void 0, u = S, i = e.apply(M, $), i;
    }
    function v(S) {
        return u = S, a = setTimeout(h, t), d ? f(S) : i;
    }
    function g(S) {
        var $ = S - c, M = S - u, P = t - $;
        return l ? l4(P, o - M) : P;
    }
    function b(S) {
        var $ = S - c, M = S - u;
        return c === void 0 || $ >= t || $ < 0 || l && M >= o;
    }
    function h() {
        var S = Fs();
        if (b(S)) return w(S);
        a = setTimeout(h, g(S));
    }
    function w(S) {
        return a = void 0, m && r ? f(S) : (r = s = void 0, i);
    }
    function k() {
        a !== void 0 && clearTimeout(a), u = 0, r = c = s = a = void 0;
    }
    function x() {
        return a === void 0 ? i : w(Fs());
    }
    function A() {
        var S = Fs(), $ = b(S);
        if (r = arguments, s = this, c = S, $) {
            if (a === void 0) return v(c);
            if (l) return clearTimeout(a), a = setTimeout(h, t), f(c);
        }
        return a === void 0 && (a = setTimeout(h, t)), i;
    }
    return A.cancel = k, A.flush = x, A;
}
function u4(e, t, n) {
    var r = e == null ? 0 : e.length;
    if (!r) return -1;
    var s = r - 1;
    return xy(e, i4(t), s);
}
function Wo(e) {
    for(var t = -1, n = e == null ? 0 : e.length, r = {}; ++t < n;){
        var s = e[t];
        r[s[0]] = s[1];
    }
    return r;
}
function Cc(e, t) {
    return ps(e, t);
}
function Jn(e) {
    return e == null;
}
function d4(e) {
    return e === void 0;
}
var uh = function(e) {
    return e === void 0;
}, ol = function(e) {
    return typeof e == "boolean";
}, Ye = function(e) {
    return typeof e == "number";
}, eo = function(e) {
    return (typeof Element === "undefined" ? "undefined" : (0, $6gBIz._)(Element)) > "u" ? !1 : e instanceof Element;
}, f4 = function(e) {
    return Yt(e) ? !Number.isNaN(Number(e)) : !1;
}, p4 = function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};
var h4 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $h4SHl._)(h4, Error1);
    function h4(t) {
        (0, $1UdHD._)(this, h4);
        var _this;
        _this = (0, $1mRNr._)(this, h4, [
            t
        ]), _this.name = "ElementPlusError";
        return _this;
    }
    return h4;
}((0, $gOgNZ._)(Error));
function g4(e, t) {
    throw new h4("[".concat(e, "] ").concat(t));
}
function yr(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "px";
    if (!e) return "";
    if (Ye(e) || f4(e)) return "".concat(e).concat(t);
    if (Yt(e)) return e;
}
function m4(e, t) {
    if (!gt) return;
    if (!t) {
        e.scrollTop = 0;
        return;
    }
    var n = [];
    var r = t.offsetParent;
    for(; r !== null && e !== r && e.contains(r);)n.push(r), r = r.offsetParent;
    var s = t.offsetTop + n.reduce(function(c, u) {
        return c + u.offsetTop;
    }, 0), o = s + t.offsetHeight, i = e.scrollTop, a = i + e.clientHeight;
    s < i ? e.scrollTop = s : o > a && (e.scrollTop = o - e.clientHeight);
}
/*! Element Plus Icons Vue v2.3.1 */ var v4 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    name: "ArrowDown",
    __name: "arrow-down",
    setup: function(e) {
        return function(t, n) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $8B0Dy.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z"
                })
            ]);
        };
    }
}), dh = v4, _4 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    name: "ArrowLeft",
    __name: "arrow-left",
    setup: function(e) {
        return function(t, n) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $8B0Dy.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M609.408 149.376 277.76 489.6a32 32 0 0 0 0 44.672l331.648 340.352a29.12 29.12 0 0 0 41.728 0 30.592 30.592 0 0 0 0-42.752L339.264 511.936l311.872-319.872a30.592 30.592 0 0 0 0-42.688 29.12 29.12 0 0 0-41.728 0z"
                })
            ]);
        };
    }
}), b4 = _4, y4 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    name: "ArrowRight",
    __name: "arrow-right",
    setup: function(e) {
        return function(t, n) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $8B0Dy.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M340.864 149.312a30.592 30.592 0 0 0 0 42.752L652.736 512 340.864 831.872a30.592 30.592 0 0 0 0 42.752 29.12 29.12 0 0 0 41.728 0L714.24 534.336a32 32 0 0 0 0-44.672L382.592 149.376a29.12 29.12 0 0 0-41.728 0z"
                })
            ]);
        };
    }
}), w4 = y4, k4 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    name: "CircleCheck",
    __name: "circle-check",
    setup: function(e) {
        return function(t, n) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $8B0Dy.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
                }),
                (0, $8B0Dy.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M745.344 361.344a32 32 0 0 1 45.312 45.312l-288 288a32 32 0 0 1-45.312 0l-160-160a32 32 0 1 1 45.312-45.312L480 626.752l265.344-265.408z"
                })
            ]);
        };
    }
}), x4 = k4, C4 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    name: "CircleClose",
    __name: "circle-close",
    setup: function(e) {
        return function(t, n) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $8B0Dy.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m466.752 512-90.496-90.496a32 32 0 0 1 45.248-45.248L512 466.752l90.496-90.496a32 32 0 1 1 45.248 45.248L557.248 512l90.496 90.496a32 32 0 1 1-45.248 45.248L512 557.248l-90.496 90.496a32 32 0 0 1-45.248-45.248z"
                }),
                (0, $8B0Dy.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
                })
            ]);
        };
    }
}), sl = C4, S4 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    name: "Close",
    __name: "close",
    setup: function(e) {
        return function(t, n) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $8B0Dy.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"
                })
            ]);
        };
    }
}), Sc = S4, E4 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    name: "DArrowLeft",
    __name: "d-arrow-left",
    setup: function(e) {
        return function(t, n) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $8B0Dy.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M529.408 149.376a29.12 29.12 0 0 1 41.728 0 30.592 30.592 0 0 1 0 42.688L259.264 511.936l311.872 319.936a30.592 30.592 0 0 1-.512 43.264 29.12 29.12 0 0 1-41.216-.512L197.76 534.272a32 32 0 0 1 0-44.672l331.648-340.224zm256 0a29.12 29.12 0 0 1 41.728 0 30.592 30.592 0 0 1 0 42.688L515.264 511.936l311.872 319.936a30.592 30.592 0 0 1-.512 43.264 29.12 29.12 0 0 1-41.216-.512L453.76 534.272a32 32 0 0 1 0-44.672l331.648-340.224z"
                })
            ]);
        };
    }
}), A4 = E4, $4 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    name: "DArrowRight",
    __name: "d-arrow-right",
    setup: function(e) {
        return function(t, n) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $8B0Dy.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M452.864 149.312a29.12 29.12 0 0 1 41.728.064L826.24 489.664a32 32 0 0 1 0 44.672L494.592 874.624a29.12 29.12 0 0 1-41.728 0 30.592 30.592 0 0 1 0-42.752L764.736 512 452.864 192a30.592 30.592 0 0 1 0-42.688m-256 0a29.12 29.12 0 0 1 41.728.064L570.24 489.664a32 32 0 0 1 0 44.672L238.592 874.624a29.12 29.12 0 0 1-41.728 0 30.592 30.592 0 0 1 0-42.752L508.736 512 196.864 192a30.592 30.592 0 0 1 0-42.688z"
                })
            ]);
        };
    }
}), M4 = $4, I4 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    name: "Hide",
    __name: "hide",
    setup: function(e) {
        return function(t, n) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $8B0Dy.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M876.8 156.8c0-9.6-3.2-16-9.6-22.4-6.4-6.4-12.8-9.6-22.4-9.6-9.6 0-16 3.2-22.4 9.6L736 220.8c-64-32-137.6-51.2-224-60.8-160 16-288 73.6-377.6 176C44.8 438.4 0 496 0 512s48 73.6 134.4 176c22.4 25.6 44.8 48 73.6 67.2l-86.4 89.6c-6.4 6.4-9.6 12.8-9.6 22.4 0 9.6 3.2 16 9.6 22.4 6.4 6.4 12.8 9.6 22.4 9.6 9.6 0 16-3.2 22.4-9.6l704-710.4c3.2-6.4 6.4-12.8 6.4-22.4Zm-646.4 528c-76.8-70.4-128-128-153.6-172.8 28.8-48 80-105.6 153.6-172.8C304 272 400 230.4 512 224c64 3.2 124.8 19.2 176 44.8l-54.4 54.4C598.4 300.8 560 288 512 288c-64 0-115.2 22.4-160 64s-64 96-64 160c0 48 12.8 89.6 35.2 124.8L256 707.2c-9.6-6.4-19.2-16-25.6-22.4Zm140.8-96c-12.8-22.4-19.2-48-19.2-76.8 0-44.8 16-83.2 48-112 32-28.8 67.2-48 112-48 28.8 0 54.4 6.4 73.6 19.2zM889.599 336c-12.8-16-28.8-28.8-41.6-41.6l-48 48c73.6 67.2 124.8 124.8 150.4 169.6-28.8 48-80 105.6-153.6 172.8-73.6 67.2-172.8 108.8-284.8 115.2-51.2-3.2-99.2-12.8-140.8-28.8l-48 48c57.6 22.4 118.4 38.4 188.8 44.8 160-16 288-73.6 377.6-176C979.199 585.6 1024 528 1024 512s-48.001-73.6-134.401-176Z"
                }),
                (0, $8B0Dy.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M511.998 672c-12.8 0-25.6-3.2-38.4-6.4l-51.2 51.2c28.8 12.8 57.6 19.2 89.6 19.2 64 0 115.2-22.4 160-64 41.6-41.6 64-96 64-160 0-32-6.4-64-19.2-89.6l-51.2 51.2c3.2 12.8 6.4 25.6 6.4 38.4 0 44.8-16 83.2-48 112-32 28.8-67.2 48-112 48Z"
                })
            ]);
        };
    }
}), T4 = I4, L4 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    name: "Loading",
    __name: "loading",
    setup: function(e) {
        return function(t, n) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $8B0Dy.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 64a32 32 0 0 1 32 32v192a32 32 0 0 1-64 0V96a32 32 0 0 1 32-32m0 640a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V736a32 32 0 0 1 32-32m448-192a32 32 0 0 1-32 32H736a32 32 0 1 1 0-64h192a32 32 0 0 1 32 32m-640 0a32 32 0 0 1-32 32H96a32 32 0 0 1 0-64h192a32 32 0 0 1 32 32M195.2 195.2a32 32 0 0 1 45.248 0L376.32 331.008a32 32 0 0 1-45.248 45.248L195.2 240.448a32 32 0 0 1 0-45.248zm452.544 452.544a32 32 0 0 1 45.248 0L828.8 783.552a32 32 0 0 1-45.248 45.248L647.744 692.992a32 32 0 0 1 0-45.248zM828.8 195.264a32 32 0 0 1 0 45.184L692.992 376.32a32 32 0 0 1-45.248-45.248l135.808-135.808a32 32 0 0 1 45.248 0m-452.544 452.48a32 32 0 0 1 0 45.248L240.448 828.8a32 32 0 0 1-45.248-45.248l135.808-135.808a32 32 0 0 1 45.248 0z"
                })
            ]);
        };
    }
}), fh = L4, O4 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    name: "MoreFilled",
    __name: "more-filled",
    setup: function(e) {
        return function(t, n) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $8B0Dy.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M176 416a112 112 0 1 1 0 224 112 112 0 0 1 0-224m336 0a112 112 0 1 1 0 224 112 112 0 0 1 0-224m336 0a112 112 0 1 1 0 224 112 112 0 0 1 0-224"
                })
            ]);
        };
    }
}), Ru = O4, R4 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    name: "PictureFilled",
    __name: "picture-filled",
    setup: function(e) {
        return function(t, n) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $8B0Dy.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M96 896a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32h832a32 32 0 0 1 32 32v704a32 32 0 0 1-32 32zm315.52-228.48-68.928-68.928a32 32 0 0 0-45.248 0L128 768.064h778.688l-242.112-290.56a32 32 0 0 0-49.216 0L458.752 665.408a32 32 0 0 1-47.232 2.112M256 384a96 96 0 1 0 192.064-.064A96 96 0 0 0 256 384"
                })
            ]);
        };
    }
}), P4 = R4, B4 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    name: "View",
    __name: "view",
    setup: function(e) {
        return function(t, n) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $8B0Dy.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 160c320 0 512 352 512 352S832 864 512 864 0 512 0 512s192-352 512-352m0 64c-225.28 0-384.128 208.064-436.8 288 52.608 79.872 211.456 288 436.8 288 225.28 0 384.128-208.064 436.8-288-52.608-79.872-211.456-288-436.8-288zm0 64a224 224 0 1 1 0 448 224 224 0 0 1 0-448m0 64a160.192 160.192 0 0 0-160 160c0 88.192 71.744 160 160 160s160-71.808 160-160-71.744-160-160-160"
                })
            ]);
        };
    }
}), z4 = B4;
var ph = "__epPropKey", be = function(e) {
    return e;
}, D4 = function(e) {
    return Jt(e) && !!e[ph];
}, hs = function(e, t) {
    if (!Jt(e) || D4(e)) return e;
    var n = e.values, r = e.required, s = e["default"], o = e.type, i = e.validator, c = (0, $aRIHe._)({
        type: o,
        required: !!r,
        validator: n || i ? function(u) {
            var d = !1, l = [];
            if (n && (l = Array.from(n), Vo(e, "default") && l.push(s), d || (d = l.includes(u))), i && (d || (d = i(u))), !d && l.length > 0) {
                var m = (0, $kf9Kn._)(new Set(l)).map(function(f) {
                    return JSON.stringify(f);
                }).join(", ");
                (0, $8B0Dy.warn)("Invalid prop: validation failed".concat(t ? ' for prop "'.concat(t, '"') : "", ". Expected one of [").concat(m, "], got value ").concat(JSON.stringify(u), "."));
            }
            return d;
        } : void 0
    }, ph, !0);
    return Vo(e, "default") && (c["default"] = s), c;
}, Re = function(e) {
    return Wo(Object.entries(e).map(function(param) {
        var _param = (0, $9tk0W._)(param, 2), t = _param[0], n = _param[1];
        return [
            t,
            hs(n, t)
        ];
    }));
}, en = be([
    String,
    Object,
    Function
]), hh = {
    validating: fh,
    success: x4,
    error: sl
}, jt = function(e, t) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (e.install = function(n) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = [
                e
            ].concat((0, $kf9Kn._)(Object.values(t !== null && t !== void 0 ? t : {})))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var r = _step.value;
                n.component(r.name, r);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }, t) try {
        for(var _iterator = Object.entries(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $9tk0W._)(_step.value, 2), n = _step_value[0], r = _step_value[1];
            e[n] = r;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return e;
}, N4 = function(e, t) {
    return e.install = function(n) {
        n.directive(t, e);
    }, e;
}, gs = function(e) {
    return e.install = Yr, e;
}, _n = {
    tab: "Tab",
    enter: "Enter",
    space: "Space",
    esc: "Escape",
    "delete": "Delete",
    backspace: "Backspace"
}, wt = "update:modelValue", il = "change", lo = [
    "",
    "default",
    "small",
    "large"
], q4 = {
    large: 40,
    "default": 32,
    small: 24
}, F4 = function(e) {
    return q4[e || "default"];
}, H4 = function(e) {
    return [
        ""
    ].concat((0, $kf9Kn._)(lo)).includes(e);
}, gh = function(e) {
    return /([\uAC00-\uD7AF\u3130-\u318F])+/gi.test(e);
}, al = function(e) {
    return e;
}, j4 = [
    "class",
    "style"
], U4 = /^on[A-Z]/, V4 = function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var tmp = e.excludeListeners, t = tmp === void 0 ? !1 : tmp, n = e.excludeKeys, r = (0, $5wB2C.computed)(function() {
        return ((n == null ? void 0 : n.value) || []).concat(j4);
    }), s = (0, $8B0Dy.getCurrentInstance)();
    return s ? (0, $5wB2C.computed)(function() {
        var o;
        return Wo(Object.entries((o = s.proxy) == null ? void 0 : o.$attrs).filter(function(param) {
            var _param = (0, $9tk0W._)(param, 1), i = _param[0];
            return !r.value.includes(i) && !(t && U4.test(i));
        }));
    }) : (0, $5wB2C.computed)(function() {
        return {};
    });
}, mh = function(param, i) {
    var e = param.from, t = param.replacement, n = param.scope, r = param.version, s = param.ref, tmp = param.type, o = tmp === void 0 ? "API" : tmp;
    (0, $5wB2C.watch)(function() {
        return (0, $5wB2C.unref)(i);
    }, function(a) {}, {
        immediate: !0
    });
};
var Z4 = {
    name: "en",
    el: {
        colorpicker: {
            confirm: "OK",
            clear: "Clear",
            defaultLabel: "color picker",
            description: "current color is {color}. press enter to select a new color."
        },
        datepicker: {
            now: "Now",
            today: "Today",
            cancel: "Cancel",
            clear: "Clear",
            confirm: "OK",
            dateTablePrompt: "Use the arrow keys and enter to select the day of the month",
            monthTablePrompt: "Use the arrow keys and enter to select the month",
            yearTablePrompt: "Use the arrow keys and enter to select the year",
            selectedDate: "Selected date",
            selectDate: "Select date",
            selectTime: "Select time",
            startDate: "Start Date",
            startTime: "Start Time",
            endDate: "End Date",
            endTime: "End Time",
            prevYear: "Previous Year",
            nextYear: "Next Year",
            prevMonth: "Previous Month",
            nextMonth: "Next Month",
            year: "",
            month1: "January",
            month2: "February",
            month3: "March",
            month4: "April",
            month5: "May",
            month6: "June",
            month7: "July",
            month8: "August",
            month9: "September",
            month10: "October",
            month11: "November",
            month12: "December",
            week: "week",
            weeks: {
                sun: "Sun",
                mon: "Mon",
                tue: "Tue",
                wed: "Wed",
                thu: "Thu",
                fri: "Fri",
                sat: "Sat"
            },
            weeksFull: {
                sun: "Sunday",
                mon: "Monday",
                tue: "Tuesday",
                wed: "Wednesday",
                thu: "Thursday",
                fri: "Friday",
                sat: "Saturday"
            },
            months: {
                jan: "Jan",
                feb: "Feb",
                mar: "Mar",
                apr: "Apr",
                may: "May",
                jun: "Jun",
                jul: "Jul",
                aug: "Aug",
                sep: "Sep",
                oct: "Oct",
                nov: "Nov",
                dec: "Dec"
            }
        },
        inputNumber: {
            decrease: "decrease number",
            increase: "increase number"
        },
        select: {
            loading: "Loading",
            noMatch: "No matching data",
            noData: "No data",
            placeholder: "Select"
        },
        dropdown: {
            toggleDropdown: "Toggle Dropdown"
        },
        cascader: {
            noMatch: "No matching data",
            loading: "Loading",
            placeholder: "Select",
            noData: "No data"
        },
        pagination: {
            goto: "Go to",
            pagesize: "/page",
            total: "Total {total}",
            pageClassifier: "",
            page: "Page",
            prev: "Go to previous page",
            next: "Go to next page",
            currentPage: "page {pager}",
            prevPages: "Previous {pager} pages",
            nextPages: "Next {pager} pages",
            deprecationWarning: "Deprecated usages detected, please refer to the el-pagination documentation for more details"
        },
        dialog: {
            close: "Close this dialog"
        },
        drawer: {
            close: "Close this dialog"
        },
        messagebox: {
            title: "Message",
            confirm: "OK",
            cancel: "Cancel",
            error: "Illegal input",
            close: "Close this dialog"
        },
        upload: {
            deleteTip: "press delete to remove",
            "delete": "Delete",
            preview: "Preview",
            "continue": "Continue"
        },
        slider: {
            defaultLabel: "slider between {min} and {max}",
            defaultRangeStartLabel: "pick start value",
            defaultRangeEndLabel: "pick end value"
        },
        table: {
            emptyText: "No Data",
            confirmFilter: "Confirm",
            resetFilter: "Reset",
            clearFilter: "All",
            sumText: "Sum"
        },
        tree: {
            emptyText: "No Data"
        },
        transfer: {
            noMatch: "No matching data",
            noData: "No data",
            titles: [
                "List 1",
                "List 2"
            ],
            filterPlaceholder: "Enter keyword",
            noCheckedFormat: "{total} items",
            hasCheckedFormat: "{checked}/{total} checked"
        },
        image: {
            error: "FAILED"
        },
        pageHeader: {
            title: "Back"
        },
        popconfirm: {
            confirmButtonText: "Yes",
            cancelButtonText: "No"
        }
    }
};
var W4 = function(e) {
    return function(t, n) {
        return G4(t, n, (0, $5wB2C.unref)(e));
    };
}, G4 = function(e, t, n) {
    return Lt(n, e, e).replace(/\{(\w+)\}/g, function(r, s) {
        var o;
        return "".concat((o = t == null ? void 0 : t[s]) != null ? o : "{".concat(s, "}"));
    });
}, K4 = function(e) {
    var t = (0, $5wB2C.computed)(function() {
        return (0, $5wB2C.unref)(e).name;
    }), n = (0, $5wB2C.isRef)(e) ? e : (0, $5wB2C.ref)(e);
    return {
        lang: t,
        locale: n,
        t: W4(e)
    };
}, X4 = Symbol("localeContextKey"), tn = function(e) {
    var t = (0, $8B0Dy.inject)(X4, (0, $5wB2C.ref)());
    return K4((0, $5wB2C.computed)(function() {
        return t.value || Z4;
    }));
}, Hs = "el", Y4 = "is-", Vn = function(e, t, n, r, s) {
    var o = "".concat(e, "-").concat(t);
    return n && (o += "-".concat(n)), r && (o += "__".concat(r)), s && (o += "--".concat(s)), o;
}, J4 = Symbol("namespaceContextKey"), cl = function(e) {
    var t = (0, $8B0Dy.getCurrentInstance)() ? (0, $8B0Dy.inject)(J4, (0, $5wB2C.ref)(Hs)) : (0, $5wB2C.ref)(Hs);
    return (0, $5wB2C.computed)(function() {
        return (0, $5wB2C.unref)(t) || Hs;
    });
}, Te = function(e, t) {
    var n = cl();
    return {
        namespace: n,
        b: function() {
            var g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
            return Vn(n.value, e, g, "", "");
        },
        e: function(g) {
            return g ? Vn(n.value, e, "", g, "") : "";
        },
        m: function(g) {
            return g ? Vn(n.value, e, "", "", g) : "";
        },
        be: function(g, b) {
            return g && b ? Vn(n.value, e, g, b, "") : "";
        },
        em: function(g, b) {
            return g && b ? Vn(n.value, e, "", g, b) : "";
        },
        bm: function(g, b) {
            return g && b ? Vn(n.value, e, g, "", b) : "";
        },
        bem: function(g, b, h) {
            return g && b && h ? Vn(n.value, e, g, b, h) : "";
        },
        is: function(g) {
            for(var _len = arguments.length, b = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                b[_key - 1] = arguments[_key];
            }
            var h = b.length >= 1 ? b[0] : !0;
            return g && h ? "".concat(Y4).concat(g) : "";
        },
        cssVar: function(g) {
            var b = {};
            for(var h in g)g[h] && (b["--".concat(n.value, "-").concat(h)] = g[h]);
            return b;
        },
        cssVarName: function(g) {
            return "--".concat(n.value, "-").concat(g);
        },
        cssVarBlock: function(g) {
            var b = {};
            for(var h in g)g[h] && (b["--".concat(n.value, "-").concat(e, "-").concat(h)] = g[h]);
            return b;
        },
        cssVarBlockName: function(g) {
            return "--".concat(n.value, "-").concat(e, "-").concat(g);
        }
    };
}, Q4 = hs({
    type: be(Boolean),
    "default": null
}), e3 = hs({
    type: be(Function)
}), t3 = function(e) {
    var _obj;
    var t = "update:".concat(e), n = "onUpdate:".concat(e), r = [
        t
    ], s = (_obj = {}, (0, $aRIHe._)(_obj, e, Q4), (0, $aRIHe._)(_obj, n, e3), _obj);
    return {
        useModelToggle: function(param) {
            var i = param.indicator, a = param.toggleReason, c = param.shouldHideWhenRouteChanges, u = param.shouldProceed, d = param.onShow, l = param.onHide;
            var m = (0, $8B0Dy.getCurrentInstance)(), f = m.emit, v = m.props, g = (0, $5wB2C.computed)(function() {
                return Pt(v[n]);
            }), b = (0, $5wB2C.computed)(function() {
                return v[e] === null;
            }), h = function($) {
                i.value !== !0 && (i.value = !0, a && (a.value = $), Pt(d) && d($));
            }, w = function($) {
                i.value !== !1 && (i.value = !1, a && (a.value = $), Pt(l) && l($));
            }, k = function($) {
                if (v.disabled === !0 || Pt(u) && !u()) return;
                var M = g.value && gt;
                M && f(t, !0), (b.value || !M) && h($);
            }, x = function($) {
                if (v.disabled === !0 || !gt) return;
                var M = g.value && gt;
                M && f(t, !1), (b.value || !M) && w($);
            }, A = function($) {
                ol($) && (v.disabled && $ ? g.value && f(t, !1) : i.value !== $ && ($ ? h() : w()));
            }, S = function() {
                i.value ? x() : k();
            };
            return (0, $5wB2C.watch)(function() {
                return v[e];
            }, A), c && m.appContext.config.globalProperties.$route !== void 0 && (0, $5wB2C.watch)(function() {
                return (0, $6869c._)({}, m.proxy.$route);
            }, function() {
                c.value && i.value && x();
            }), (0, $8B0Dy.onMounted)(function() {
                A(v[e]);
            }), {
                hide: x,
                show: k,
                toggle: S,
                hasUpdateHandler: g
            };
        },
        useModelToggleProps: s,
        useModelToggleEmits: r
    };
}, vh = function(e) {
    var t = (0, $8B0Dy.getCurrentInstance)();
    return (0, $5wB2C.computed)(function() {
        var n, r;
        return (r = (n = t == null ? void 0 : t.proxy) == null ? void 0 : n.$props) == null ? void 0 : r[e];
    });
};
var xt = "top", Nt = "bottom", qt = "right", Ct = "left", ll = "auto", uo = [
    xt,
    Nt,
    qt,
    Ct
], wr = "start", to = "end", n3 = "clippingParents", _h = "viewport", zr = "popper", r3 = "reference", Pu = uo.reduce(function(e, t) {
    return e.concat([
        t + "-" + wr,
        t + "-" + to
    ]);
}, []), ms = [].concat(uo, [
    ll
]).reduce(function(e, t) {
    return e.concat([
        t,
        t + "-" + wr,
        t + "-" + to
    ]);
}, []), o3 = "beforeRead", s3 = "read", i3 = "afterRead", a3 = "beforeMain", c3 = "main", l3 = "afterMain", u3 = "beforeWrite", d3 = "write", f3 = "afterWrite", p3 = [
    o3,
    s3,
    i3,
    a3,
    c3,
    l3,
    u3,
    d3,
    f3
];
function ln(e) {
    return e ? (e.nodeName || "").toLowerCase() : null;
}
function nn(e) {
    if (e == null) return window;
    if (e.toString() !== "[object Window]") {
        var t = e.ownerDocument;
        return t && t.defaultView || window;
    }
    return e;
}
function kr(e) {
    var t = nn(e).Element;
    return e instanceof t || e instanceof Element;
}
function zt(e) {
    var t = nn(e).HTMLElement;
    return e instanceof t || e instanceof HTMLElement;
}
function ul(e) {
    if ((typeof ShadowRoot === "undefined" ? "undefined" : (0, $6gBIz._)(ShadowRoot)) > "u") return !1;
    var t = nn(e).ShadowRoot;
    return e instanceof t || e instanceof ShadowRoot;
}
function h3(e) {
    var t = e.state;
    Object.keys(t.elements).forEach(function(n) {
        var r = t.styles[n] || {}, s = t.attributes[n] || {}, o = t.elements[n];
        !zt(o) || !ln(o) || (Object.assign(o.style, r), Object.keys(s).forEach(function(i) {
            var a = s[i];
            a === !1 ? o.removeAttribute(i) : o.setAttribute(i, a === !0 ? "" : a);
        }));
    });
}
function g3(e) {
    var t = e.state, n = {
        popper: {
            position: t.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
        Object.keys(t.elements).forEach(function(r) {
            var s = t.elements[r], o = t.attributes[r] || {}, i = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), a = i.reduce(function(c, u) {
                return c[u] = "", c;
            }, {});
            !zt(s) || !ln(s) || (Object.assign(s.style, a), Object.keys(o).forEach(function(c) {
                s.removeAttribute(c);
            }));
        });
    };
}
var bh = {
    name: "applyStyles",
    enabled: !0,
    phase: "write",
    fn: h3,
    effect: g3,
    requires: [
        "computeStyles"
    ]
};
function cn(e) {
    return e.split("-")[0];
}
var Qn = Math.max, Go = Math.min, xr = Math.round;
function Cr(e, t) {
    t === void 0 && (t = !1);
    var n = e.getBoundingClientRect(), r = 1, s = 1;
    if (zt(e) && t) {
        var o = e.offsetHeight, i = e.offsetWidth;
        i > 0 && (r = xr(n.width) / i || 1), o > 0 && (s = xr(n.height) / o || 1);
    }
    return {
        width: n.width / r,
        height: n.height / s,
        top: n.top / s,
        right: n.right / r,
        bottom: n.bottom / s,
        left: n.left / r,
        x: n.left / r,
        y: n.top / s
    };
}
function dl(e) {
    var t = Cr(e), n = e.offsetWidth, r = e.offsetHeight;
    return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
        x: e.offsetLeft,
        y: e.offsetTop,
        width: n,
        height: r
    };
}
function yh(e, t) {
    var n = t.getRootNode && t.getRootNode();
    if (e.contains(t)) return !0;
    if (n && ul(n)) {
        var r = t;
        do {
            if (r && e.isSameNode(r)) return !0;
            r = r.parentNode || r.host;
        }while (r);
    }
    return !1;
}
function yn(e) {
    return nn(e).getComputedStyle(e);
}
function m3(e) {
    return [
        "table",
        "td",
        "th"
    ].indexOf(ln(e)) >= 0;
}
function Nn(e) {
    return ((kr(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function vs(e) {
    return ln(e) === "html" ? e : e.assignedSlot || e.parentNode || (ul(e) ? e.host : null) || Nn(e);
}
function Bu(e) {
    return !zt(e) || yn(e).position === "fixed" ? null : e.offsetParent;
}
function v3(e) {
    var t = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1, n = navigator.userAgent.indexOf("Trident") !== -1;
    if (n && zt(e)) {
        var r = yn(e);
        if (r.position === "fixed") return null;
    }
    var s = vs(e);
    for(ul(s) && (s = s.host); zt(s) && [
        "html",
        "body"
    ].indexOf(ln(s)) < 0;){
        var o = yn(s);
        if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(o.willChange) !== -1 || t && o.willChange === "filter" || t && o.filter && o.filter !== "none") return s;
        s = s.parentNode;
    }
    return null;
}
function fo(e) {
    for(var t = nn(e), n = Bu(e); n && m3(n) && yn(n).position === "static";)n = Bu(n);
    return n && (ln(n) === "html" || ln(n) === "body" && yn(n).position === "static") ? t : n || v3(e) || t;
}
function fl(e) {
    return [
        "top",
        "bottom"
    ].indexOf(e) >= 0 ? "x" : "y";
}
function Ur(e, t, n) {
    return Qn(e, Go(t, n));
}
function _3(e, t, n) {
    var r = Ur(e, t, n);
    return r > n ? n : r;
}
function wh() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}
function kh(e) {
    return Object.assign({}, wh(), e);
}
function xh(e, t) {
    return t.reduce(function(n, r) {
        return n[r] = e, n;
    }, {});
}
var b3 = function b3(e, t) {
    return e = typeof e == "function" ? e(Object.assign({}, t.rects, {
        placement: t.placement
    })) : e, kh(typeof e != "number" ? e : xh(e, uo));
};
function y3(e) {
    var t, n = e.state, r = e.name, s = e.options, o = n.elements.arrow, i = n.modifiersData.popperOffsets, a = cn(n.placement), c = fl(a), u = [
        Ct,
        qt
    ].indexOf(a) >= 0, d = u ? "height" : "width";
    if (!(!o || !i)) {
        var l = b3(s.padding, n), m = dl(o), f = c === "y" ? xt : Ct, v = c === "y" ? Nt : qt, g = n.rects.reference[d] + n.rects.reference[c] - i[c] - n.rects.popper[d], b = i[c] - n.rects.reference[c], h = fo(o), w = h ? c === "y" ? h.clientHeight || 0 : h.clientWidth || 0 : 0, k = g / 2 - b / 2, x = l[f], A = w - m[d] - l[v], S = w / 2 - m[d] / 2 + k, $ = Ur(x, S, A), M = c;
        n.modifiersData[r] = (t = {}, t[M] = $, t.centerOffset = $ - S, t);
    }
}
function w3(e) {
    var t = e.state, n = e.options, r = n.element, s = r === void 0 ? "[data-popper-arrow]" : r;
    s != null && (typeof s == "string" && (s = t.elements.popper.querySelector(s), !s) || !yh(t.elements.popper, s) || (t.elements.arrow = s));
}
var k3 = {
    name: "arrow",
    enabled: !0,
    phase: "main",
    fn: y3,
    effect: w3,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};
function Sr(e) {
    return e.split("-")[1];
}
var x3 = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
};
function C3(e) {
    var t = e.x, n = e.y, r = window, s = r.devicePixelRatio || 1;
    return {
        x: xr(t * s) / s || 0,
        y: xr(n * s) / s || 0
    };
}
function zu(e) {
    var t, n = e.popper, r = e.popperRect, s = e.placement, o = e.variation, i = e.offsets, a = e.position, c = e.gpuAcceleration, u = e.adaptive, d = e.roundOffsets, l = e.isFixed, m = i.x, f = m === void 0 ? 0 : m, v = i.y, g = v === void 0 ? 0 : v, b = typeof d == "function" ? d({
        x: f,
        y: g
    }) : {
        x: f,
        y: g
    };
    f = b.x, g = b.y;
    var h = i.hasOwnProperty("x"), w = i.hasOwnProperty("y"), k = Ct, x = xt, A = window;
    if (u) {
        var S = fo(n), $ = "clientHeight", M = "clientWidth";
        if (S === nn(n) && (S = Nn(n), yn(S).position !== "static" && a === "absolute" && ($ = "scrollHeight", M = "scrollWidth")), S, s === xt || (s === Ct || s === qt) && o === to) {
            x = Nt;
            var P = l && S === A && A.visualViewport ? A.visualViewport.height : S[$];
            g -= P - r.height, g *= c ? 1 : -1;
        }
        if (s === Ct || (s === xt || s === Nt) && o === to) {
            k = qt;
            var R = l && S === A && A.visualViewport ? A.visualViewport.width : S[M];
            f -= R - r.width, f *= c ? 1 : -1;
        }
    }
    var B = Object.assign({
        position: a
    }, u && x3), H = d === !0 ? C3({
        x: f,
        y: g
    }) : {
        x: f,
        y: g
    };
    if (f = H.x, g = H.y, c) {
        var ie;
        return Object.assign({}, B, (ie = {}, ie[x] = w ? "0" : "", ie[k] = h ? "0" : "", ie.transform = (A.devicePixelRatio || 1) <= 1 ? "translate(" + f + "px, " + g + "px)" : "translate3d(" + f + "px, " + g + "px, 0)", ie));
    }
    return Object.assign({}, B, (t = {}, t[x] = w ? g + "px" : "", t[k] = h ? f + "px" : "", t.transform = "", t));
}
function S3(e) {
    var t = e.state, n = e.options, r = n.gpuAcceleration, s = r === void 0 ? !0 : r, o = n.adaptive, i = o === void 0 ? !0 : o, a = n.roundOffsets, c = a === void 0 ? !0 : a, u = {
        placement: cn(t.placement),
        variation: Sr(t.placement),
        popper: t.elements.popper,
        popperRect: t.rects.popper,
        gpuAcceleration: s,
        isFixed: t.options.strategy === "fixed"
    };
    t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, zu(Object.assign({}, u, {
        offsets: t.modifiersData.popperOffsets,
        position: t.options.strategy,
        adaptive: i,
        roundOffsets: c
    })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, zu(Object.assign({}, u, {
        offsets: t.modifiersData.arrow,
        position: "absolute",
        adaptive: !1,
        roundOffsets: c
    })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
        "data-popper-placement": t.placement
    });
}
var Ch = {
    name: "computeStyles",
    enabled: !0,
    phase: "beforeWrite",
    fn: S3,
    data: {}
}, ko = {
    passive: !0
};
function E3(e) {
    var t = e.state, n = e.instance, r = e.options, s = r.scroll, o = s === void 0 ? !0 : s, i = r.resize, a = i === void 0 ? !0 : i, c = nn(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
    return o && u.forEach(function(d) {
        d.addEventListener("scroll", n.update, ko);
    }), a && c.addEventListener("resize", n.update, ko), function() {
        o && u.forEach(function(d) {
            d.removeEventListener("scroll", n.update, ko);
        }), a && c.removeEventListener("resize", n.update, ko);
    };
}
var Sh = {
    name: "eventListeners",
    enabled: !0,
    phase: "write",
    fn: function fn() {},
    effect: E3,
    data: {}
}, A3 = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function Po(e) {
    return e.replace(/left|right|bottom|top/g, function(t) {
        return A3[t];
    });
}
var $3 = {
    start: "end",
    end: "start"
};
function Du(e) {
    return e.replace(/start|end/g, function(t) {
        return $3[t];
    });
}
function pl(e) {
    var t = nn(e), n = t.pageXOffset, r = t.pageYOffset;
    return {
        scrollLeft: n,
        scrollTop: r
    };
}
function hl(e) {
    return Cr(Nn(e)).left + pl(e).scrollLeft;
}
function M3(e) {
    var t = nn(e), n = Nn(e), r = t.visualViewport, s = n.clientWidth, o = n.clientHeight, i = 0, a = 0;
    return r && (s = r.width, o = r.height, /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (i = r.offsetLeft, a = r.offsetTop)), {
        width: s,
        height: o,
        x: i + hl(e),
        y: a
    };
}
function I3(e) {
    var t, n = Nn(e), r = pl(e), s = (t = e.ownerDocument) == null ? void 0 : t.body, o = Qn(n.scrollWidth, n.clientWidth, s ? s.scrollWidth : 0, s ? s.clientWidth : 0), i = Qn(n.scrollHeight, n.clientHeight, s ? s.scrollHeight : 0, s ? s.clientHeight : 0), a = -r.scrollLeft + hl(e), c = -r.scrollTop;
    return yn(s || n).direction === "rtl" && (a += Qn(n.clientWidth, s ? s.clientWidth : 0) - o), {
        width: o,
        height: i,
        x: a,
        y: c
    };
}
function gl(e) {
    var t = yn(e), n = t.overflow, r = t.overflowX, s = t.overflowY;
    return /auto|scroll|overlay|hidden/.test(n + s + r);
}
function Eh(e) {
    return [
        "html",
        "body",
        "#document"
    ].indexOf(ln(e)) >= 0 ? e.ownerDocument.body : zt(e) && gl(e) ? e : Eh(vs(e));
}
function Vr(e, t) {
    var n;
    t === void 0 && (t = []);
    var r = Eh(e), s = r === ((n = e.ownerDocument) == null ? void 0 : n.body), o = nn(r), i = s ? [
        o
    ].concat(o.visualViewport || [], gl(r) ? r : []) : r, a = t.concat(i);
    return s ? a : a.concat(Vr(vs(i)));
}
function Ec(e) {
    return Object.assign({}, e, {
        left: e.x,
        top: e.y,
        right: e.x + e.width,
        bottom: e.y + e.height
    });
}
function T3(e) {
    var t = Cr(e);
    return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
}
function Nu(e, t) {
    return t === _h ? Ec(M3(e)) : kr(t) ? T3(t) : Ec(I3(Nn(e)));
}
function L3(e) {
    var t = Vr(vs(e)), n = [
        "absolute",
        "fixed"
    ].indexOf(yn(e).position) >= 0, r = n && zt(e) ? fo(e) : e;
    return kr(r) ? t.filter(function(s) {
        return kr(s) && yh(s, r) && ln(s) !== "body";
    }) : [];
}
function O3(e, t, n) {
    var r = t === "clippingParents" ? L3(e) : [].concat(t), s = [].concat(r, [
        n
    ]), o = s[0], i = s.reduce(function(a, c) {
        var u = Nu(e, c);
        return a.top = Qn(u.top, a.top), a.right = Go(u.right, a.right), a.bottom = Go(u.bottom, a.bottom), a.left = Qn(u.left, a.left), a;
    }, Nu(e, o));
    return i.width = i.right - i.left, i.height = i.bottom - i.top, i.x = i.left, i.y = i.top, i;
}
function Ah(e) {
    var t = e.reference, n = e.element, r = e.placement, s = r ? cn(r) : null, o = r ? Sr(r) : null, i = t.x + t.width / 2 - n.width / 2, a = t.y + t.height / 2 - n.height / 2, c;
    switch(s){
        case xt:
            c = {
                x: i,
                y: t.y - n.height
            };
            break;
        case Nt:
            c = {
                x: i,
                y: t.y + t.height
            };
            break;
        case qt:
            c = {
                x: t.x + t.width,
                y: a
            };
            break;
        case Ct:
            c = {
                x: t.x - n.width,
                y: a
            };
            break;
        default:
            c = {
                x: t.x,
                y: t.y
            };
    }
    var u = s ? fl(s) : null;
    if (u != null) {
        var d = u === "y" ? "height" : "width";
        switch(o){
            case wr:
                c[u] = c[u] - (t[d] / 2 - n[d] / 2);
                break;
            case to:
                c[u] = c[u] + (t[d] / 2 - n[d] / 2);
                break;
        }
    }
    return c;
}
function no(e, t) {
    t === void 0 && (t = {});
    var n = t, r = n.placement, s = r === void 0 ? e.placement : r, o = n.boundary, i = o === void 0 ? n3 : o, a = n.rootBoundary, c = a === void 0 ? _h : a, u = n.elementContext, d = u === void 0 ? zr : u, l = n.altBoundary, m = l === void 0 ? !1 : l, f = n.padding, v = f === void 0 ? 0 : f, g = kh(typeof v != "number" ? v : xh(v, uo)), b = d === zr ? r3 : zr, h = e.rects.popper, w = e.elements[m ? b : d], k = O3(kr(w) ? w : w.contextElement || Nn(e.elements.popper), i, c), x = Cr(e.elements.reference), A = Ah({
        reference: x,
        element: h,
        placement: s
    }), S = Ec(Object.assign({}, h, A)), $ = d === zr ? S : x, M = {
        top: k.top - $.top + g.top,
        bottom: $.bottom - k.bottom + g.bottom,
        left: k.left - $.left + g.left,
        right: $.right - k.right + g.right
    }, P = e.modifiersData.offset;
    if (d === zr && P) {
        var R = P[s];
        Object.keys(M).forEach(function(B) {
            var H = [
                qt,
                Nt
            ].indexOf(B) >= 0 ? 1 : -1, ie = [
                xt,
                Nt
            ].indexOf(B) >= 0 ? "y" : "x";
            M[B] += R[ie] * H;
        });
    }
    return M;
}
function R3(e, t) {
    t === void 0 && (t = {});
    var n = t, r = n.placement, s = n.boundary, o = n.rootBoundary, i = n.padding, a = n.flipVariations, c = n.allowedAutoPlacements, u = c === void 0 ? ms : c, d = Sr(r), l = d ? a ? Pu : Pu.filter(function(v) {
        return Sr(v) === d;
    }) : uo, m = l.filter(function(v) {
        return u.indexOf(v) >= 0;
    });
    m.length === 0 && (m = l);
    var f = m.reduce(function(v, g) {
        return v[g] = no(e, {
            placement: g,
            boundary: s,
            rootBoundary: o,
            padding: i
        })[cn(g)], v;
    }, {});
    return Object.keys(f).sort(function(v, g) {
        return f[v] - f[g];
    });
}
function P3(e) {
    if (cn(e) === ll) return [];
    var t = Po(e);
    return [
        Du(e),
        t,
        Du(t)
    ];
}
function B3(e) {
    var t = e.state, n = e.options, r = e.name;
    if (!t.modifiersData[r]._skip) {
        for(var s = n.mainAxis, o = s === void 0 ? !0 : s, i = n.altAxis, a = i === void 0 ? !0 : i, c = n.fallbackPlacements, u = n.padding, d = n.boundary, l = n.rootBoundary, m = n.altBoundary, f = n.flipVariations, v = f === void 0 ? !0 : f, g = n.allowedAutoPlacements, b = t.options.placement, h = cn(b), w = h === b, k = c || (w || !v ? [
            Po(b)
        ] : P3(b)), x = [
            b
        ].concat(k).reduce(function(de, ve) {
            return de.concat(cn(ve) === ll ? R3(t, {
                placement: ve,
                boundary: d,
                rootBoundary: l,
                padding: u,
                flipVariations: v,
                allowedAutoPlacements: g
            }) : ve);
        }, []), A = t.rects.reference, S = t.rects.popper, $ = /* @__PURE__ */ new Map(), M = !0, P = x[0], R = 0; R < x.length; R++){
            var B = x[R], H = cn(B), ie = Sr(B) === wr, z = [
                xt,
                Nt
            ].indexOf(H) >= 0, Q = z ? "width" : "height", N = no(t, {
                placement: B,
                boundary: d,
                rootBoundary: l,
                altBoundary: m,
                padding: u
            }), j = z ? ie ? qt : Ct : ie ? Nt : xt;
            A[Q] > S[Q] && (j = Po(j));
            var U = Po(j), G = [];
            if (o && G.push(N[H] <= 0), a && G.push(N[j] <= 0, N[U] <= 0), G.every(function(de) {
                return de;
            })) {
                P = B, M = !1;
                break;
            }
            $.set(B, G);
        }
        if (M) for(var T = v ? 3 : 1, W = function W(de) {
            var ve = x.find(function(we) {
                var Be = $.get(we);
                if (Be) return Be.slice(0, de).every(function(Oe) {
                    return Oe;
                });
            });
            if (ve) return P = ve, "break";
        }, V = T; V > 0; V--){
            var se = W(V);
            if (se === "break") break;
        }
        t.placement !== P && (t.modifiersData[r]._skip = !0, t.placement = P, t.reset = !0);
    }
}
var z3 = {
    name: "flip",
    enabled: !0,
    phase: "main",
    fn: B3,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: !1
    }
};
function qu(e, t, n) {
    return n === void 0 && (n = {
        x: 0,
        y: 0
    }), {
        top: e.top - t.height - n.y,
        right: e.right - t.width + n.x,
        bottom: e.bottom - t.height + n.y,
        left: e.left - t.width - n.x
    };
}
function Fu(e) {
    return [
        xt,
        qt,
        Nt,
        Ct
    ].some(function(t) {
        return e[t] >= 0;
    });
}
function D3(e) {
    var t = e.state, n = e.name, r = t.rects.reference, s = t.rects.popper, o = t.modifiersData.preventOverflow, i = no(t, {
        elementContext: "reference"
    }), a = no(t, {
        altBoundary: !0
    }), c = qu(i, r), u = qu(a, s, o), d = Fu(c), l = Fu(u);
    t.modifiersData[n] = {
        referenceClippingOffsets: c,
        popperEscapeOffsets: u,
        isReferenceHidden: d,
        hasPopperEscaped: l
    }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
        "data-popper-reference-hidden": d,
        "data-popper-escaped": l
    });
}
var N3 = {
    name: "hide",
    enabled: !0,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: D3
};
function q3(e, t, n) {
    var r = cn(e), s = [
        Ct,
        xt
    ].indexOf(r) >= 0 ? -1 : 1, o = typeof n == "function" ? n(Object.assign({}, t, {
        placement: e
    })) : n, i = o[0], a = o[1];
    return i = i || 0, a = (a || 0) * s, [
        Ct,
        qt
    ].indexOf(r) >= 0 ? {
        x: a,
        y: i
    } : {
        x: i,
        y: a
    };
}
function F3(e) {
    var t = e.state, n = e.options, r = e.name, s = n.offset, o = s === void 0 ? [
        0,
        0
    ] : s, i = ms.reduce(function(d, l) {
        return d[l] = q3(l, t.rects, o), d;
    }, {}), a = i[t.placement], c = a.x, u = a.y;
    t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += c, t.modifiersData.popperOffsets.y += u), t.modifiersData[r] = i;
}
var H3 = {
    name: "offset",
    enabled: !0,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: F3
};
function j3(e) {
    var t = e.state, n = e.name;
    t.modifiersData[n] = Ah({
        reference: t.rects.reference,
        element: t.rects.popper,
        placement: t.placement
    });
}
var $h = {
    name: "popperOffsets",
    enabled: !0,
    phase: "read",
    fn: j3,
    data: {}
};
function U3(e) {
    return e === "x" ? "y" : "x";
}
function V3(e) {
    var t = e.state, n = e.options, r = e.name, s = n.mainAxis, o = s === void 0 ? !0 : s, i = n.altAxis, a = i === void 0 ? !1 : i, c = n.boundary, u = n.rootBoundary, d = n.altBoundary, l = n.padding, m = n.tether, f = m === void 0 ? !0 : m, v = n.tetherOffset, g = v === void 0 ? 0 : v, b = no(t, {
        boundary: c,
        rootBoundary: u,
        padding: l,
        altBoundary: d
    }), h = cn(t.placement), w = Sr(t.placement), k = !w, x = fl(h), A = U3(x), S = t.modifiersData.popperOffsets, $ = t.rects.reference, M = t.rects.popper, P = typeof g == "function" ? g(Object.assign({}, t.rects, {
        placement: t.placement
    })) : g, R = typeof P == "number" ? {
        mainAxis: P,
        altAxis: P
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, P), B = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, H = {
        x: 0,
        y: 0
    };
    if (S) {
        if (o) {
            var ie, z = x === "y" ? xt : Ct, Q = x === "y" ? Nt : qt, N = x === "y" ? "height" : "width", j = S[x], U = j + b[z], G = j - b[Q], T = f ? -M[N] / 2 : 0, W = w === wr ? $[N] : M[N], V = w === wr ? -M[N] : -$[N], se = t.elements.arrow, de = f && se ? dl(se) : {
                width: 0,
                height: 0
            }, ve = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : wh(), we = ve[z], Be = ve[Q], Oe = Ur(0, $[N], de[N]), Ke = k ? $[N] / 2 - T - Oe - we - R.mainAxis : W - Oe - we - R.mainAxis, re = k ? -$[N] / 2 + T + Oe + Be + R.mainAxis : V + Oe + Be + R.mainAxis, fe = t.elements.arrow && fo(t.elements.arrow), Se = fe ? x === "y" ? fe.clientTop || 0 : fe.clientLeft || 0 : 0, ze = (ie = B == null ? void 0 : B[x]) != null ? ie : 0, Ge = j + Ke - ze - Se, Je = j + re - ze, st = Ur(f ? Go(U, Ge) : U, j, f ? Qn(G, Je) : G);
            S[x] = st, H[x] = st - j;
        }
        if (a) {
            var rn, Et = x === "x" ? xt : Ct, Ut = x === "x" ? Nt : qt, ut = S[A], Ot = A === "y" ? "height" : "width", At = ut + b[Et], Vt = ut - b[Ut], nt = [
                xt,
                Ct
            ].indexOf(h) !== -1, K = (rn = B == null ? void 0 : B[A]) != null ? rn : 0, ge = nt ? At : ut - $[Ot] - M[Ot] - K + R.altAxis, De = nt ? ut + $[Ot] + M[Ot] - K - R.altAxis : Vt, Xe = f && nt ? _3(ge, ut, De) : Ur(f ? ge : At, ut, f ? De : Vt);
            S[A] = Xe, H[A] = Xe - ut;
        }
        t.modifiersData[r] = H;
    }
}
var Z3 = {
    name: "preventOverflow",
    enabled: !0,
    phase: "main",
    fn: V3,
    requiresIfExists: [
        "offset"
    ]
};
function W3(e) {
    return {
        scrollLeft: e.scrollLeft,
        scrollTop: e.scrollTop
    };
}
function G3(e) {
    return e === nn(e) || !zt(e) ? pl(e) : W3(e);
}
function K3(e) {
    var t = e.getBoundingClientRect(), n = xr(t.width) / e.offsetWidth || 1, r = xr(t.height) / e.offsetHeight || 1;
    return n !== 1 || r !== 1;
}
function X3(e, t, n) {
    n === void 0 && (n = !1);
    var r = zt(t), s = zt(t) && K3(t), o = Nn(t), i = Cr(e, s), a = {
        scrollLeft: 0,
        scrollTop: 0
    }, c = {
        x: 0,
        y: 0
    };
    return (r || !r && !n) && ((ln(t) !== "body" || gl(o)) && (a = G3(t)), zt(t) ? (c = Cr(t, !0), c.x += t.clientLeft, c.y += t.clientTop) : o && (c.x = hl(o))), {
        x: i.left + a.scrollLeft - c.x,
        y: i.top + a.scrollTop - c.y,
        width: i.width,
        height: i.height
    };
}
function Y3(e) {
    var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
    e.forEach(function(o) {
        t.set(o.name, o);
    });
    function s(o) {
        n.add(o.name);
        var i = [].concat(o.requires || [], o.requiresIfExists || []);
        i.forEach(function(a) {
            if (!n.has(a)) {
                var c = t.get(a);
                c && s(c);
            }
        }), r.push(o);
    }
    return e.forEach(function(o) {
        n.has(o.name) || s(o);
    }), r;
}
function J3(e) {
    var t = Y3(e);
    return p3.reduce(function(n, r) {
        return n.concat(t.filter(function(s) {
            return s.phase === r;
        }));
    }, []);
}
function Q3(e) {
    var t;
    return function() {
        return t || (t = new Promise(function(n) {
            Promise.resolve().then(function() {
                t = void 0, n(e());
            });
        })), t;
    };
}
function ex(e) {
    var t = e.reduce(function(n, r) {
        var s = n[r.name];
        return n[r.name] = s ? Object.assign({}, s, r, {
            options: Object.assign({}, s.options, r.options),
            data: Object.assign({}, s.data, r.data)
        }) : r, n;
    }, {});
    return Object.keys(t).map(function(n) {
        return t[n];
    });
}
var Hu = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function ju() {
    for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
    return !t.some(function(r) {
        return !(r && typeof r.getBoundingClientRect == "function");
    });
}
function ml(e) {
    e === void 0 && (e = {});
    var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, s = t.defaultOptions, o = s === void 0 ? Hu : s;
    return function(i, a, c) {
        c === void 0 && (c = o);
        var u = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, Hu, o),
            modifiersData: {},
            elements: {
                reference: i,
                popper: a
            },
            attributes: {},
            styles: {}
        }, d = [], l = !1, m = {
            state: u,
            setOptions: function setOptions(g) {
                var b = typeof g == "function" ? g(u.options) : g;
                v(), u.options = Object.assign({}, o, u.options, b), u.scrollParents = {
                    reference: kr(i) ? Vr(i) : i.contextElement ? Vr(i.contextElement) : [],
                    popper: Vr(a)
                };
                var h = J3(ex([].concat(r, u.options.modifiers)));
                return u.orderedModifiers = h.filter(function(w) {
                    return w.enabled;
                }), f(), m.update();
            },
            forceUpdate: function forceUpdate() {
                if (!l) {
                    var g = u.elements, b = g.reference, h = g.popper;
                    if (ju(b, h)) {
                        u.rects = {
                            reference: X3(b, fo(h), u.options.strategy === "fixed"),
                            popper: dl(h)
                        }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(M) {
                            return u.modifiersData[M.name] = Object.assign({}, M.data);
                        });
                        for(var w = 0; w < u.orderedModifiers.length; w++){
                            if (u.reset === !0) {
                                u.reset = !1, w = -1;
                                continue;
                            }
                            var k = u.orderedModifiers[w], x = k.fn, A = k.options, S = A === void 0 ? {} : A, $ = k.name;
                            typeof x == "function" && (u = x({
                                state: u,
                                options: S,
                                name: $,
                                instance: m
                            }) || u);
                        }
                    }
                }
            },
            update: Q3(function() {
                return new Promise(function(g) {
                    m.forceUpdate(), g(u);
                });
            }),
            destroy: function destroy() {
                v(), l = !0;
            }
        };
        if (!ju(i, a)) return m;
        m.setOptions(c).then(function(g) {
            !l && c.onFirstUpdate && c.onFirstUpdate(g);
        });
        function f() {
            u.orderedModifiers.forEach(function(g) {
                var b = g.name, h = g.options, w = h === void 0 ? {} : h, k = g.effect;
                if (typeof k == "function") {
                    var x = k({
                        state: u,
                        name: b,
                        instance: m,
                        options: w
                    }), A = function A() {};
                    d.push(x || A);
                }
            });
        }
        function v() {
            d.forEach(function(g) {
                return g();
            }), d = [];
        }
        return m;
    };
}
ml();
var tx = [
    Sh,
    $h,
    Ch,
    bh
];
ml({
    defaultModifiers: tx
});
var nx = [
    Sh,
    $h,
    Ch,
    bh,
    H3,
    z3,
    Z3,
    k3,
    N3
], rx = ml({
    defaultModifiers: nx
});
var ox = function(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var r = {
        name: "updateState",
        enabled: !0,
        phase: "write",
        fn: function(param) {
            var c = param.state;
            var u = sx(c);
            Object.assign(i.value, u);
        },
        requires: [
            "computeStyles"
        ]
    }, s = (0, $5wB2C.computed)(function() {
        var _$_ = (0, $5wB2C.unref)(n), c = _$_.onFirstUpdate, u = _$_.placement, d = _$_.strategy, l = _$_.modifiers;
        return {
            onFirstUpdate: c,
            placement: u || "bottom",
            strategy: d || "absolute",
            modifiers: (0, $kf9Kn._)(l || []).concat([
                r,
                {
                    name: "applyStyles",
                    enabled: !1
                }
            ])
        };
    }), o = (0, $5wB2C.shallowRef)(), i = (0, $5wB2C.ref)({
        styles: {
            popper: {
                position: (0, $5wB2C.unref)(s).strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), a = function() {
        o.value && (o.value.destroy(), o.value = void 0);
    };
    return (0, $5wB2C.watch)(s, function(c) {
        var u = (0, $5wB2C.unref)(o);
        u && u.setOptions(c);
    }, {
        deep: !0
    }), (0, $5wB2C.watch)([
        e,
        t
    ], function(param) {
        var _param = (0, $9tk0W._)(param, 2), c = _param[0], u = _param[1];
        a(), !(!c || !u) && (o.value = rx(c, u, (0, $5wB2C.unref)(s)));
    }), (0, $8B0Dy.onBeforeUnmount)(function() {
        a();
    }), {
        state: (0, $5wB2C.computed)(function() {
            var c;
            return (0, $6869c._)({}, ((c = (0, $5wB2C.unref)(o)) == null ? void 0 : c.state) || {});
        }),
        styles: (0, $5wB2C.computed)(function() {
            return (0, $5wB2C.unref)(i).styles;
        }),
        attributes: (0, $5wB2C.computed)(function() {
            return (0, $5wB2C.unref)(i).attributes;
        }),
        update: function() {
            var c;
            return (c = (0, $5wB2C.unref)(o)) == null ? void 0 : c.update();
        },
        forceUpdate: function() {
            var c;
            return (c = (0, $5wB2C.unref)(o)) == null ? void 0 : c.forceUpdate();
        },
        instanceRef: (0, $5wB2C.computed)(function() {
            return (0, $5wB2C.unref)(o);
        })
    };
};
function sx(e) {
    var t = Object.keys(e.elements), n = Wo(t.map(function(s) {
        return [
            s,
            e.styles[s] || {}
        ];
    })), r = Wo(t.map(function(s) {
        return [
            s,
            e.attributes[s]
        ];
    }));
    return {
        styles: n,
        attributes: r
    };
}
var ix = function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (t === 0) return e;
    var n = (0, $5wB2C.ref)(!1);
    var r = 0;
    var s = function() {
        r && clearTimeout(r), r = window.setTimeout(function() {
            n.value = e.value;
        }, t);
    };
    return (0, $8B0Dy.onMounted)(s), (0, $5wB2C.watch)(function() {
        return e.value;
    }, function(o) {
        o ? s() : n.value = o;
    }), n;
};
function Uu() {
    var e;
    var t = function(r, s) {
        n(), e = window.setTimeout(r, s);
    }, n = function() {
        return window.clearTimeout(e);
    };
    return Jc(function() {
        return n();
    }), {
        registerTimeout: t,
        cancelTimeout: n
    };
}
var Vu = {
    prefix: Math.floor(Math.random() * 1e4),
    current: 0
}, ax = Symbol("elIdInjection"), Mh = function() {
    return (0, $8B0Dy.getCurrentInstance)() ? (0, $8B0Dy.inject)(ax, Vu) : Vu;
}, _s = function(e) {
    var t = Mh(), n = cl();
    return (0, $5wB2C.computed)(function() {
        return (0, $5wB2C.unref)(e) || "".concat(n.value, "-id-").concat(t.prefix, "-").concat(t.current++);
    });
};
var dr = [];
var Zu = function(e) {
    var t = e;
    t.key === _n.esc && dr.forEach(function(n) {
        return n(t);
    });
}, cx = function(e) {
    (0, $8B0Dy.onMounted)(function() {
        dr.length === 0 && document.addEventListener("keydown", Zu), gt && dr.push(e);
    }), (0, $8B0Dy.onBeforeUnmount)(function() {
        dr = dr.filter(function(t) {
            return t !== e;
        }), dr.length === 0 && gt && document.removeEventListener("keydown", Zu);
    });
};
var Wu;
var Ih = function() {
    var e = cl(), t = Mh(), n = (0, $5wB2C.computed)(function() {
        return "".concat(e.value, "-popper-container-").concat(t.prefix);
    }), r = (0, $5wB2C.computed)(function() {
        return "#".concat(n.value);
    });
    return {
        id: n,
        selector: r
    };
}, lx = function(e) {
    var t = document.createElement("div");
    return t.id = e, document.body.appendChild(t), t;
}, ux = function() {
    var _Ih = Ih(), e = _Ih.id, t = _Ih.selector;
    return (0, $8B0Dy.onBeforeMount)(function() {
        gt && !Wu && !document.body.querySelector(t.value) && (Wu = lx(e.value));
    }), {
        id: e,
        selector: t
    };
}, dx = Re({
    showAfter: {
        type: Number,
        "default": 0
    },
    hideAfter: {
        type: Number,
        "default": 200
    },
    autoClose: {
        type: Number,
        "default": 0
    }
}), fx = function(param) {
    var e = param.showAfter, t = param.hideAfter, n = param.autoClose, r = param.open, s = param.close;
    var _Uu = Uu(), o = _Uu.registerTimeout, _Uu1 = Uu(), i = _Uu1.registerTimeout, a = _Uu1.cancelTimeout;
    return {
        onOpen: function(d) {
            o(function() {
                r(d);
                var l = (0, $5wB2C.unref)(n);
                Ye(l) && l > 0 && i(function() {
                    s(d);
                }, l);
            }, (0, $5wB2C.unref)(e));
        },
        onClose: function(d) {
            a(), o(function() {
                s(d);
            }, (0, $5wB2C.unref)(t));
        }
    };
}, Th = Symbol("elForwardRef"), px = function(e) {
    (0, $8B0Dy.provide)(Th, {
        setForwardRef: function(n) {
            e.value = n;
        }
    });
}, hx = function(e) {
    return {
        mounted: function(t) {
            e(t);
        },
        updated: function(t) {
            e(t);
        },
        unmounted: function() {
            e(null);
        }
    };
}, Gu = (0, $5wB2C.ref)(0), gx = 2e3, mx = Symbol("zIndexContextKey"), vx = function(e) {
    var t = (0, $8B0Dy.getCurrentInstance)() ? (0, $8B0Dy.inject)(mx, void 0) : void 0, n = (0, $5wB2C.computed)(function() {
        var o = (0, $5wB2C.unref)(t);
        return Ye(o) ? o : gx;
    }), r = (0, $5wB2C.computed)(function() {
        return n.value + Gu.value;
    });
    return {
        initialZIndex: n,
        currentZIndex: r,
        nextZIndex: function() {
            return Gu.value++, r.value;
        }
    };
};
function _x(e) {
    var t = (0, $5wB2C.ref)();
    function n() {
        if (e.value == null) return;
        var _e_value = e.value, s = _e_value.selectionStart, o = _e_value.selectionEnd, i = _e_value.value;
        if (s == null || o == null) return;
        var a = i.slice(0, Math.max(0, s)), c = i.slice(Math.max(0, o));
        t.value = {
            selectionStart: s,
            selectionEnd: o,
            value: i,
            beforeTxt: a,
            afterTxt: c
        };
    }
    function r() {
        if (e.value == null || t.value == null) return;
        var _e_value = e.value, s = _e_value.value, _t_value = t.value, o = _t_value.beforeTxt, i = _t_value.afterTxt, a = _t_value.selectionStart;
        if (o == null || i == null || a == null) return;
        var c = s.length;
        if (s.endsWith(i)) c = s.length - i.length;
        else if (s.startsWith(o)) c = o.length;
        else {
            var u = o[a - 1], d = s.indexOf(u, a - 1);
            d !== -1 && (c = d + 1);
        }
        e.value.setSelectionRange(c, c);
    }
    return [
        n,
        r
    ];
}
var vl = hs({
    type: String,
    values: lo,
    required: !1
}), bx = Symbol("size"), yx = function() {
    var e = (0, $8B0Dy.inject)(bx, {});
    return (0, $5wB2C.computed)(function() {
        return (0, $5wB2C.unref)(e.size) || "";
    });
};
function Lh(e) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = _ref.afterFocus, n = _ref.beforeBlur, r = _ref.afterBlur;
    var s = (0, $8B0Dy.getCurrentInstance)(), o = s.emit, i = (0, $5wB2C.shallowRef)(), a = (0, $5wB2C.ref)(!1), c = function(l) {
        a.value || (a.value = !0, o("focus", l), t == null || t());
    }, u = function(l) {
        var m;
        Pt(n) && n(l) || l.relatedTarget && (m = i.value) != null && m.contains(l.relatedTarget) || (a.value = !1, o("blur", l), r == null || r());
    }, d = function() {
        var l;
        (l = e.value) == null || l.focus();
    };
    return (0, $5wB2C.watch)(i, function(l) {
        l && l.setAttribute("tabindex", "-1");
    }), Yn(i, "click", d), {
        wrapperRef: i,
        isFocused: a,
        handleFocus: c,
        handleBlur: u
    };
}
var wx = Symbol(), Ku = (0, $5wB2C.ref)();
function kx(e, t) {
    var n = (0, $8B0Dy.getCurrentInstance)() ? (0, $8B0Dy.inject)(wx, Ku) : Ku;
    return (0, $5wB2C.computed)(function() {
        var r, s;
        return (s = (r = n.value) == null ? void 0 : r[e]) != null ? s : t;
    });
}
var Ce = function(e, t) {
    var n = e.__vccOpts || e;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $9tk0W._)(_step.value, 2), r = _step_value[0], s = _step_value[1];
            n[r] = s;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return n;
};
var xx = Re({
    size: {
        type: be([
            Number,
            String
        ])
    },
    color: {
        type: String
    }
}), Cx = (0, $8B0Dy.defineComponent)({
    name: "ElIcon",
    inheritAttrs: !1
}), Sx = /* @__PURE__ */ (0, $8B0Dy.defineComponent)((0, $bnFl0._)((0, $6869c._)({}, Cx), {
    props: xx,
    setup: function(e) {
        var t = e, n = Te("icon"), r = (0, $5wB2C.computed)(function() {
            var s = t.size, o = t.color;
            return !s && !o ? {} : {
                fontSize: uh(s) ? void 0 : yr(s),
                "--color": o
            };
        });
        return function(s, o) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("i", (0, $8B0Dy.mergeProps)({
                "class": (0, $5wB2C.unref)(n).b(),
                style: (0, $5wB2C.unref)(r)
            }, s.$attrs), [
                (0, $8B0Dy.renderSlot)(s.$slots, "default")
            ], 16);
        };
    }
}));
var Ex = /* @__PURE__ */ Ce(Sx, [
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/icon/src/icon.vue"
    ]
]);
var kt = jt(Ex), _l = Symbol("formContextKey"), Ko = Symbol("formItemContextKey"), po = function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var n = (0, $5wB2C.ref)(void 0), r = t.prop ? n : vh("size"), s = t.global ? n : yx(), o = t.form ? {
        size: void 0
    } : (0, $8B0Dy.inject)(_l, void 0), i = t.formItem ? {
        size: void 0
    } : (0, $8B0Dy.inject)(Ko, void 0);
    return (0, $5wB2C.computed)(function() {
        return r.value || (0, $5wB2C.unref)(e) || (i == null ? void 0 : i.size) || (o == null ? void 0 : o.size) || s.value || "";
    });
}, bs = function(e) {
    var t = vh("disabled"), n = (0, $8B0Dy.inject)(_l, void 0);
    return (0, $5wB2C.computed)(function() {
        return t.value || (0, $5wB2C.unref)(e) || (n == null ? void 0 : n.disabled) || !1;
    });
}, ys = function() {
    var e = (0, $8B0Dy.inject)(_l, void 0), t = (0, $8B0Dy.inject)(Ko, void 0);
    return {
        form: e,
        formItem: t
    };
}, Oh = function(e, param) {
    var t = param.formItemContext, n = param.disableIdGeneration, r = param.disableIdManagement;
    n || (n = (0, $5wB2C.ref)(!1)), r || (r = (0, $5wB2C.ref)(!1));
    var s = (0, $5wB2C.ref)();
    var o;
    var i = (0, $5wB2C.computed)(function() {
        var a;
        return !!(!e.label && t && t.inputIds && ((a = t.inputIds) == null ? void 0 : a.length) <= 1);
    });
    return (0, $8B0Dy.onMounted)(function() {
        o = (0, $5wB2C.watch)([
            (0, $5wB2C.toRef)(e, "id"),
            n
        ], function(param) {
            var _param = (0, $9tk0W._)(param, 2), a = _param[0], c = _param[1];
            var u = a !== null && a !== void 0 ? a : c ? void 0 : _s().value;
            u !== s.value && (t != null && t.removeInputId && (s.value && t.removeInputId(s.value), !(r != null && r.value) && !c && u && t.addInputId(u)), s.value = u);
        }, {
            immediate: !0
        });
    }), (0, $8B0Dy.onUnmounted)(function() {
        o && o(), t != null && t.removeInputId && s.value && t.removeInputId(s.value);
    }), {
        isLabeledByFormItem: i,
        inputId: s
    };
};
var Gt;
var Ax = "\n  height:0 !important;\n  visibility:hidden !important;\n  ".concat(Bb() ? "" : "overflow:hidden !important;", "\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important;\n"), $x = [
    "letter-spacing",
    "line-height",
    "padding-top",
    "padding-bottom",
    "font-family",
    "font-weight",
    "font-size",
    "text-rendering",
    "text-transform",
    "width",
    "text-indent",
    "padding-left",
    "padding-right",
    "border-width",
    "box-sizing"
];
function Mx(e) {
    var t = window.getComputedStyle(e), n = t.getPropertyValue("box-sizing"), r = Number.parseFloat(t.getPropertyValue("padding-bottom")) + Number.parseFloat(t.getPropertyValue("padding-top")), s = Number.parseFloat(t.getPropertyValue("border-bottom-width")) + Number.parseFloat(t.getPropertyValue("border-top-width"));
    return {
        contextStyle: $x.map(function(i) {
            return "".concat(i, ":").concat(t.getPropertyValue(i));
        }).join(";"),
        paddingSize: r,
        borderSize: s,
        boxSizing: n
    };
}
function Xu(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, n = arguments.length > 2 ? arguments[2] : void 0;
    var r;
    Gt || (Gt = document.createElement("textarea"), document.body.appendChild(Gt));
    var _Mx = Mx(e), s = _Mx.paddingSize, o = _Mx.borderSize, i = _Mx.boxSizing, a = _Mx.contextStyle;
    Gt.setAttribute("style", "".concat(a, ";").concat(Ax)), Gt.value = e.value || e.placeholder || "";
    var c = Gt.scrollHeight;
    var u = {};
    i === "border-box" ? c = c + o : i === "content-box" && (c = c - s), Gt.value = "";
    var d = Gt.scrollHeight - s;
    if (Ye(t)) {
        var l = d * t;
        i === "border-box" && (l = l + s + o), c = Math.max(l, c), u.minHeight = "".concat(l, "px");
    }
    if (Ye(n)) {
        var l1 = d * n;
        i === "border-box" && (l1 = l1 + s + o), c = Math.min(l1, c);
    }
    return u.height = "".concat(c, "px"), (r = Gt.parentNode) == null || r.removeChild(Gt), Gt = void 0, u;
}
var _obj;
var Ix = Re({
    id: {
        type: String,
        "default": void 0
    },
    size: vl,
    disabled: Boolean,
    modelValue: {
        type: be([
            String,
            Number,
            Object
        ]),
        "default": ""
    },
    type: {
        type: String,
        "default": "text"
    },
    resize: {
        type: String,
        values: [
            "none",
            "both",
            "horizontal",
            "vertical"
        ]
    },
    autosize: {
        type: be([
            Boolean,
            Object
        ]),
        "default": !1
    },
    autocomplete: {
        type: String,
        "default": "off"
    },
    formatter: {
        type: Function
    },
    parser: {
        type: Function
    },
    placeholder: {
        type: String
    },
    form: {
        type: String
    },
    readonly: {
        type: Boolean,
        "default": !1
    },
    clearable: {
        type: Boolean,
        "default": !1
    },
    showPassword: {
        type: Boolean,
        "default": !1
    },
    showWordLimit: {
        type: Boolean,
        "default": !1
    },
    suffixIcon: {
        type: en
    },
    prefixIcon: {
        type: en
    },
    containerRole: {
        type: String,
        "default": void 0
    },
    label: {
        type: String,
        "default": void 0
    },
    tabindex: {
        type: [
            String,
            Number
        ],
        "default": 0
    },
    validateEvent: {
        type: Boolean,
        "default": !0
    },
    inputStyle: {
        type: be([
            Object,
            Array,
            String
        ]),
        "default": function() {
            return al({});
        }
    },
    autofocus: {
        type: Boolean,
        "default": !1
    }
}), Tx = (_obj = {}, (0, $aRIHe._)(_obj, wt, function(e) {
    return Yt(e);
}), (0, $aRIHe._)(_obj, "input", function(e) {
    return Yt(e);
}), (0, $aRIHe._)(_obj, "change", function(e) {
    return Yt(e);
}), (0, $aRIHe._)(_obj, "focus", function(e) {
    return e instanceof FocusEvent;
}), (0, $aRIHe._)(_obj, "blur", function(e) {
    return e instanceof FocusEvent;
}), (0, $aRIHe._)(_obj, "clear", function() {
    return !0;
}), (0, $aRIHe._)(_obj, "mouseleave", function(e) {
    return e instanceof MouseEvent;
}), (0, $aRIHe._)(_obj, "mouseenter", function(e) {
    return e instanceof MouseEvent;
}), (0, $aRIHe._)(_obj, "keydown", function(e) {
    return e instanceof Event;
}), (0, $aRIHe._)(_obj, "compositionstart", function(e) {
    return e instanceof CompositionEvent;
}), (0, $aRIHe._)(_obj, "compositionupdate", function(e) {
    return e instanceof CompositionEvent;
}), (0, $aRIHe._)(_obj, "compositionend", function(e) {
    return e instanceof CompositionEvent;
}), _obj), Lx = [
    "role"
], Ox = [
    "id",
    "type",
    "disabled",
    "formatter",
    "parser",
    "readonly",
    "autocomplete",
    "tabindex",
    "aria-label",
    "placeholder",
    "form",
    "autofocus"
], Rx = [
    "id",
    "tabindex",
    "disabled",
    "readonly",
    "autocomplete",
    "aria-label",
    "placeholder",
    "form",
    "autofocus"
], Px = (0, $8B0Dy.defineComponent)({
    name: "ElInput",
    inheritAttrs: !1
}), Bx = /* @__PURE__ */ (0, $8B0Dy.defineComponent)((0, $bnFl0._)((0, $6869c._)({}, Px), {
    props: Ix,
    emits: Tx,
    setup: function(e, param) {
        var _this = this;
        var t = param.expose, n = param.emit;
        var r = e, s = (0, $8B0Dy.useAttrs)(), o = (0, $8B0Dy.useSlots)(), i = (0, $5wB2C.computed)(function() {
            var K = {};
            return r.containerRole === "combobox" && (K["aria-haspopup"] = s["aria-haspopup"], K["aria-owns"] = s["aria-owns"], K["aria-expanded"] = s["aria-expanded"]), K;
        }), a = (0, $5wB2C.computed)(function() {
            var _obj;
            return [
                r.type === "textarea" ? b.b() : g.b(),
                g.m(f.value),
                g.is("disabled", v.value),
                g.is("exceed", de.value),
                (_obj = {}, (0, $aRIHe._)(_obj, g.b("group"), o.prepend || o.append), (0, $aRIHe._)(_obj, g.bm("group", "append"), o.append), (0, $aRIHe._)(_obj, g.bm("group", "prepend"), o.prepend), (0, $aRIHe._)(_obj, g.m("prefix"), o.prefix || r.prefixIcon), (0, $aRIHe._)(_obj, g.m("suffix"), o.suffix || r.suffixIcon || r.clearable || r.showPassword), (0, $aRIHe._)(_obj, g.bm("suffix", "password-clear"), T.value && W.value), _obj),
                s["class"]
            ];
        }), c = (0, $5wB2C.computed)(function() {
            return [
                g.e("wrapper"),
                g.is("focus", R.value)
            ];
        }), u = V4({
            excludeKeys: (0, $5wB2C.computed)(function() {
                return Object.keys(i.value);
            })
        }), _ys = ys(), d = _ys.form, l = _ys.formItem, _Oh = Oh(r, {
            formItemContext: l
        }), m = _Oh.inputId, f = po(), v = bs(), g = Te("input"), b = Te("textarea"), h = (0, $5wB2C.shallowRef)(), w = (0, $5wB2C.shallowRef)(), k = (0, $5wB2C.ref)(!1), x = (0, $5wB2C.ref)(!1), A = (0, $5wB2C.ref)(!1), S = (0, $5wB2C.ref)(), $ = (0, $5wB2C.shallowRef)(r.inputStyle), M = (0, $5wB2C.computed)(function() {
            return h.value || w.value;
        }), _Lh = Lh(M, {
            afterBlur: function() {
                var K;
                r.validateEvent && ((K = l == null ? void 0 : l.validate) == null || K.call(l, "blur")["catch"](function(ge) {
                    return void 0;
                }));
            }
        }), P = _Lh.wrapperRef, R = _Lh.isFocused, B = _Lh.handleFocus, H = _Lh.handleBlur, ie = (0, $5wB2C.computed)(function() {
            var K;
            return (K = d == null ? void 0 : d.statusIcon) != null ? K : !1;
        }), z = (0, $5wB2C.computed)(function() {
            return (l == null ? void 0 : l.validateState) || "";
        }), Q = (0, $5wB2C.computed)(function() {
            return z.value && hh[z.value];
        }), N = (0, $5wB2C.computed)(function() {
            return A.value ? z4 : T4;
        }), j = (0, $5wB2C.computed)(function() {
            return [
                s.style,
                r.inputStyle
            ];
        }), U = (0, $5wB2C.computed)(function() {
            return [
                r.inputStyle,
                $.value,
                {
                    resize: r.resize
                }
            ];
        }), G = (0, $5wB2C.computed)(function() {
            return Jn(r.modelValue) ? "" : String(r.modelValue);
        }), T = (0, $5wB2C.computed)(function() {
            return r.clearable && !v.value && !r.readonly && !!G.value && (R.value || k.value);
        }), W = (0, $5wB2C.computed)(function() {
            return r.showPassword && !v.value && !r.readonly && !!G.value && (!!G.value || R.value);
        }), V = (0, $5wB2C.computed)(function() {
            return r.showWordLimit && !!u.value.maxlength && (r.type === "text" || r.type === "textarea") && !v.value && !r.readonly && !r.showPassword;
        }), se = (0, $5wB2C.computed)(function() {
            return G.value.length;
        }), de = (0, $5wB2C.computed)(function() {
            return !!V.value && se.value > Number(u.value.maxlength);
        }), ve = (0, $5wB2C.computed)(function() {
            return !!o.suffix || !!r.suffixIcon || T.value || r.showPassword || V.value || !!z.value && ie.value;
        }), _$_x = (0, $9tk0W._)(_x(h), 2), we = _$_x[0], Be = _$_x[1];
        cs(w, function(K) {
            if (re(), !V.value || r.resize !== "both") return;
            var ge = K[0], _ge_contentRect = ge.contentRect, De = _ge_contentRect.width;
            S.value = {
                right: "calc(100% - ".concat(De + 15 + 6, "px)")
            };
        });
        var Oe = function() {
            var K = r.type, ge = r.autosize;
            if (!(!gt || K !== "textarea" || !w.value)) {
                if (ge) {
                    var De = Jt(ge) ? ge.minRows : void 0, Xe = Jt(ge) ? ge.maxRows : void 0, Zt = Xu(w.value, De, Xe);
                    $.value = (0, $6869c._)({
                        overflowY: "hidden"
                    }, Zt), (0, $8B0Dy.nextTick)(function() {
                        w.value.offsetHeight, $.value = Zt;
                    });
                } else $.value = {
                    minHeight: Xu(w.value).minHeight
                };
            }
        }, re = function(K) {
            var ge = !1;
            return function() {
                var De;
                if (ge || !r.autosize) return;
                ((De = w.value) == null ? void 0 : De.offsetParent) === null || (K(), ge = !0);
            };
        }(Oe), fe = function() {
            var K = M.value, ge = r.formatter ? r.formatter(G.value) : G.value;
            !K || K.value === ge || (K.value = ge);
        }, Se = function(K) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
                var _K_target, ge;
                return (0, $e0qXa.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            we();
                            _K_target = K.target, ge = _K_target.value;
                            if (!(r.formatter && (ge = r.parser ? r.parser(ge) : ge), !x.value)) return [
                                3,
                                2
                            ];
                            if (ge === G.value) {
                                fe();
                                return [
                                    2
                                ];
                            }
                            n(wt, ge), n("input", ge);
                            return [
                                4,
                                (0, $8B0Dy.nextTick)()
                            ];
                        case 1:
                            _state.sent(), fe(), Be();
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            })();
        }, ze = function(K) {
            n("change", K.target.value);
        }, Ge = function(K) {
            n("compositionstart", K), x.value = !0;
        }, Je = function(K) {
            var ge;
            n("compositionupdate", K);
            var De = (ge = K.target) == null ? void 0 : ge.value, Xe = De[De.length - 1] || "";
            x.value = !gh(Xe);
        }, st = function(K) {
            n("compositionend", K), x.value && (x.value = !1, Se(K));
        }, rn = function() {
            A.value = !A.value, Et();
        }, Et = function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
                var K;
                return (0, $e0qXa.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0, $8B0Dy.nextTick)()
                            ];
                        case 1:
                            _state.sent(), (K = M.value) == null || K.focus();
                            return [
                                2
                            ];
                    }
                });
            })();
        }, Ut = function() {
            var K;
            return (K = M.value) == null ? void 0 : K.blur();
        }, ut = function(K) {
            k.value = !1, n("mouseleave", K);
        }, Ot = function(K) {
            k.value = !0, n("mouseenter", K);
        }, At = function(K) {
            n("keydown", K);
        }, Vt = function() {
            var K;
            (K = M.value) == null || K.select();
        }, nt = function() {
            n(wt, ""), n("change", ""), n("clear"), n("input", "");
        };
        return (0, $5wB2C.watch)(function() {
            return r.modelValue;
        }, function() {
            var K;
            (0, $8B0Dy.nextTick)(function() {
                return Oe();
            }), r.validateEvent && ((K = l == null ? void 0 : l.validate) == null || K.call(l, "change")["catch"](function(ge) {
                return void 0;
            }));
        }), (0, $5wB2C.watch)(G, function() {
            return fe();
        }), (0, $5wB2C.watch)(function() {
            return r.type;
        }, function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
                return (0, $e0qXa.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0, $8B0Dy.nextTick)()
                            ];
                        case 1:
                            _state.sent(), fe(), Oe();
                            return [
                                2
                            ];
                    }
                });
            })();
        }), (0, $8B0Dy.onMounted)(function() {
            !r.formatter && r.parser, fe(), (0, $8B0Dy.nextTick)(Oe);
        }), t({
            input: h,
            textarea: w,
            ref: M,
            textareaStyle: U,
            autosize: (0, $5wB2C.toRef)(r, "autosize"),
            focus: Et,
            blur: Ut,
            select: Vt,
            clear: nt,
            resizeTextarea: Oe
        }), function(K, ge) {
            var _this1 = _this;
            return (0, $8B0Dy.withDirectives)(((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", (0, $8B0Dy.mergeProps)((0, $5wB2C.unref)(i), {
                "class": (0, $5wB2C.unref)(a),
                style: (0, $5wB2C.unref)(j),
                role: K.containerRole,
                onMouseenter: Ot,
                onMouseleave: ut
            }), [
                (0, $8B0Dy.createCommentVNode)(" input "),
                K.type !== "textarea" ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)((0, $8B0Dy.Fragment), {
                    key: 0
                }, [
                    (0, $8B0Dy.createCommentVNode)(" prepend slot "),
                    K.$slots.prepend ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
                        key: 0,
                        "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(g).be("group", "prepend"))
                    }, [
                        (0, $8B0Dy.renderSlot)(K.$slots, "prepend")
                    ], 2)) : (0, $8B0Dy.createCommentVNode)("v-if", !0),
                    (0, $8B0Dy.createElementVNode)("div", {
                        ref_key: "wrapperRef",
                        ref: P,
                        "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(c))
                    }, [
                        (0, $8B0Dy.createCommentVNode)(" prefix slot "),
                        K.$slots.prefix || K.prefixIcon ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("span", {
                            key: 0,
                            "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(g).e("prefix"))
                        }, [
                            (0, $8B0Dy.createElementVNode)("span", {
                                "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(g).e("prefix-inner"))
                            }, [
                                (0, $8B0Dy.renderSlot)(K.$slots, "prefix"),
                                K.prefixIcon ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(kt), {
                                    key: 0,
                                    "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(g).e("icon"))
                                }, {
                                    "default": (0, $8B0Dy.withCtx)(function() {
                                        return [
                                            ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $8B0Dy.resolveDynamicComponent)(K.prefixIcon)))
                                        ];
                                    }),
                                    _: 1
                                }, 8, [
                                    "class"
                                ])) : (0, $8B0Dy.createCommentVNode)("v-if", !0)
                            ], 2)
                        ], 2)) : (0, $8B0Dy.createCommentVNode)("v-if", !0),
                        (0, $8B0Dy.createElementVNode)("input", (0, $8B0Dy.mergeProps)({
                            id: (0, $5wB2C.unref)(m),
                            ref_key: "input",
                            ref: h,
                            "class": (0, $5wB2C.unref)(g).e("inner")
                        }, (0, $5wB2C.unref)(u), {
                            type: K.showPassword ? A.value ? "text" : "password" : K.type,
                            disabled: (0, $5wB2C.unref)(v),
                            formatter: K.formatter,
                            parser: K.parser,
                            readonly: K.readonly,
                            autocomplete: K.autocomplete,
                            tabindex: K.tabindex,
                            "aria-label": K.label,
                            placeholder: K.placeholder,
                            style: K.inputStyle,
                            form: r.form,
                            autofocus: r.autofocus,
                            onCompositionstart: Ge,
                            onCompositionupdate: Je,
                            onCompositionend: st,
                            onInput: Se,
                            onFocus: ge[0] || (ge[0] = function() {
                                for(var _len = arguments.length, De = new Array(_len), _key = 0; _key < _len; _key++){
                                    De[_key] = arguments[_key];
                                }
                                return (0, $5wB2C.unref)(B) && (0, $5wB2C.unref)(B).apply(_this1, (0, $kf9Kn._)(De));
                            }),
                            onBlur: ge[1] || (ge[1] = function() {
                                for(var _len = arguments.length, De = new Array(_len), _key = 0; _key < _len; _key++){
                                    De[_key] = arguments[_key];
                                }
                                return (0, $5wB2C.unref)(H) && (0, $5wB2C.unref)(H).apply(_this1, (0, $kf9Kn._)(De));
                            }),
                            onChange: ze,
                            onKeydown: At
                        }), null, 16, Ox),
                        (0, $8B0Dy.createCommentVNode)(" suffix slot "),
                        (0, $5wB2C.unref)(ve) ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("span", {
                            key: 1,
                            "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(g).e("suffix"))
                        }, [
                            (0, $8B0Dy.createElementVNode)("span", {
                                "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(g).e("suffix-inner"))
                            }, [
                                !(0, $5wB2C.unref)(T) || !(0, $5wB2C.unref)(W) || !(0, $5wB2C.unref)(V) ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)((0, $8B0Dy.Fragment), {
                                    key: 0
                                }, [
                                    (0, $8B0Dy.renderSlot)(K.$slots, "suffix"),
                                    K.suffixIcon ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(kt), {
                                        key: 0,
                                        "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(g).e("icon"))
                                    }, {
                                        "default": (0, $8B0Dy.withCtx)(function() {
                                            return [
                                                ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $8B0Dy.resolveDynamicComponent)(K.suffixIcon)))
                                            ];
                                        }),
                                        _: 1
                                    }, 8, [
                                        "class"
                                    ])) : (0, $8B0Dy.createCommentVNode)("v-if", !0)
                                ], 64)) : (0, $8B0Dy.createCommentVNode)("v-if", !0),
                                (0, $5wB2C.unref)(T) ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(kt), {
                                    key: 1,
                                    "class": (0, $3ZJCa.normalizeClass)([
                                        (0, $5wB2C.unref)(g).e("icon"),
                                        (0, $5wB2C.unref)(g).e("clear")
                                    ]),
                                    onMousedown: (0, $kRi7Z.withModifiers)((0, $5wB2C.unref)(Yr), [
                                        "prevent"
                                    ]),
                                    onClick: nt
                                }, {
                                    "default": (0, $8B0Dy.withCtx)(function() {
                                        return [
                                            (0, $8B0Dy.createVNode)((0, $5wB2C.unref)(sl))
                                        ];
                                    }),
                                    _: 1
                                }, 8, [
                                    "class",
                                    "onMousedown"
                                ])) : (0, $8B0Dy.createCommentVNode)("v-if", !0),
                                (0, $5wB2C.unref)(W) ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(kt), {
                                    key: 2,
                                    "class": (0, $3ZJCa.normalizeClass)([
                                        (0, $5wB2C.unref)(g).e("icon"),
                                        (0, $5wB2C.unref)(g).e("password")
                                    ]),
                                    onClick: rn
                                }, {
                                    "default": (0, $8B0Dy.withCtx)(function() {
                                        return [
                                            ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $8B0Dy.resolveDynamicComponent)((0, $5wB2C.unref)(N))))
                                        ];
                                    }),
                                    _: 1
                                }, 8, [
                                    "class"
                                ])) : (0, $8B0Dy.createCommentVNode)("v-if", !0),
                                (0, $5wB2C.unref)(V) ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("span", {
                                    key: 3,
                                    "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(g).e("count"))
                                }, [
                                    (0, $8B0Dy.createElementVNode)("span", {
                                        "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(g).e("count-inner"))
                                    }, (0, $3ZJCa.toDisplayString)((0, $5wB2C.unref)(se)) + " / " + (0, $3ZJCa.toDisplayString)((0, $5wB2C.unref)(u).maxlength), 3)
                                ], 2)) : (0, $8B0Dy.createCommentVNode)("v-if", !0),
                                (0, $5wB2C.unref)(z) && (0, $5wB2C.unref)(Q) && (0, $5wB2C.unref)(ie) ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(kt), {
                                    key: 4,
                                    "class": (0, $3ZJCa.normalizeClass)([
                                        (0, $5wB2C.unref)(g).e("icon"),
                                        (0, $5wB2C.unref)(g).e("validateIcon"),
                                        (0, $5wB2C.unref)(g).is("loading", (0, $5wB2C.unref)(z) === "validating")
                                    ])
                                }, {
                                    "default": (0, $8B0Dy.withCtx)(function() {
                                        return [
                                            ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $8B0Dy.resolveDynamicComponent)((0, $5wB2C.unref)(Q))))
                                        ];
                                    }),
                                    _: 1
                                }, 8, [
                                    "class"
                                ])) : (0, $8B0Dy.createCommentVNode)("v-if", !0)
                            ], 2)
                        ], 2)) : (0, $8B0Dy.createCommentVNode)("v-if", !0)
                    ], 2),
                    (0, $8B0Dy.createCommentVNode)(" append slot "),
                    K.$slots.append ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
                        key: 1,
                        "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(g).be("group", "append"))
                    }, [
                        (0, $8B0Dy.renderSlot)(K.$slots, "append")
                    ], 2)) : (0, $8B0Dy.createCommentVNode)("v-if", !0)
                ], 64)) : ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)((0, $8B0Dy.Fragment), {
                    key: 1
                }, [
                    (0, $8B0Dy.createCommentVNode)(" textarea "),
                    (0, $8B0Dy.createElementVNode)("textarea", (0, $8B0Dy.mergeProps)({
                        id: (0, $5wB2C.unref)(m),
                        ref_key: "textarea",
                        ref: w,
                        "class": (0, $5wB2C.unref)(b).e("inner")
                    }, (0, $5wB2C.unref)(u), {
                        tabindex: K.tabindex,
                        disabled: (0, $5wB2C.unref)(v),
                        readonly: K.readonly,
                        autocomplete: K.autocomplete,
                        style: (0, $5wB2C.unref)(U),
                        "aria-label": K.label,
                        placeholder: K.placeholder,
                        form: r.form,
                        autofocus: r.autofocus,
                        onCompositionstart: Ge,
                        onCompositionupdate: Je,
                        onCompositionend: st,
                        onInput: Se,
                        onFocus: ge[2] || (ge[2] = function() {
                            for(var _len = arguments.length, De = new Array(_len), _key = 0; _key < _len; _key++){
                                De[_key] = arguments[_key];
                            }
                            return (0, $5wB2C.unref)(B) && (0, $5wB2C.unref)(B).apply(_this1, (0, $kf9Kn._)(De));
                        }),
                        onBlur: ge[3] || (ge[3] = function() {
                            for(var _len = arguments.length, De = new Array(_len), _key = 0; _key < _len; _key++){
                                De[_key] = arguments[_key];
                            }
                            return (0, $5wB2C.unref)(H) && (0, $5wB2C.unref)(H).apply(_this1, (0, $kf9Kn._)(De));
                        }),
                        onChange: ze,
                        onKeydown: At
                    }), null, 16, Rx),
                    (0, $5wB2C.unref)(V) ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("span", {
                        key: 0,
                        style: (0, $3ZJCa.normalizeStyle)(S.value),
                        "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(g).e("count"))
                    }, (0, $3ZJCa.toDisplayString)((0, $5wB2C.unref)(se)) + " / " + (0, $3ZJCa.toDisplayString)((0, $5wB2C.unref)(u).maxlength), 7)) : (0, $8B0Dy.createCommentVNode)("v-if", !0)
                ], 64))
            ], 16, Lx)), [
                [
                    (0, $kRi7Z.vShow),
                    K.type !== "hidden"
                ]
            ]);
        };
    }
}));
var zx = /* @__PURE__ */ Ce(Bx, [
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/input/src/input.vue"
    ]
]);
var ws = jt(zx), hr = 4, Dx = {
    vertical: {
        offset: "offsetHeight",
        scroll: "scrollTop",
        scrollSize: "scrollHeight",
        size: "height",
        key: "vertical",
        axis: "Y",
        client: "clientY",
        direction: "top"
    },
    horizontal: {
        offset: "offsetWidth",
        scroll: "scrollLeft",
        scrollSize: "scrollWidth",
        size: "width",
        key: "horizontal",
        axis: "X",
        client: "clientX",
        direction: "left"
    }
}, Nx = function(param) {
    var e = param.move, t = param.size, n = param.bar;
    var _obj;
    return _obj = {}, (0, $aRIHe._)(_obj, n.size, t), (0, $aRIHe._)(_obj, "transform", "translate".concat(n.axis, "(").concat(e, "%)")), _obj;
}, Rh = Symbol("scrollbarContextKey"), qx = Re({
    vertical: Boolean,
    size: String,
    move: Number,
    ratio: {
        type: Number,
        required: !0
    },
    always: Boolean
}), Fx = "Thumb", Hx = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    __name: "thumb",
    props: qx,
    setup: function(e) {
        var t = e, n = (0, $8B0Dy.inject)(Rh), r = Te("scrollbar");
        n || g4(Fx, "can not inject scrollbar context");
        var s = (0, $5wB2C.ref)(), o = (0, $5wB2C.ref)(), i = (0, $5wB2C.ref)({}), a = (0, $5wB2C.ref)(!1);
        var c = !1, u = !1, d = gt ? document.onselectstart : null;
        var l = (0, $5wB2C.computed)(function() {
            return Dx[t.vertical ? "vertical" : "horizontal"];
        }), m = (0, $5wB2C.computed)(function() {
            return Nx({
                size: t.size,
                move: t.move,
                bar: l.value
            });
        }), f = (0, $5wB2C.computed)(function() {
            return Math.pow(s.value[l.value.offset], 2) / n.wrapElement[l.value.scrollSize] / t.ratio / o.value[l.value.offset];
        }), v = function(S) {
            var $;
            if (S.stopPropagation(), S.ctrlKey || [
                1,
                2
            ].includes(S.button)) return;
            ($ = window.getSelection()) == null || $.removeAllRanges(), b(S);
            var M = S.currentTarget;
            M && (i.value[l.value.axis] = M[l.value.offset] - (S[l.value.client] - M.getBoundingClientRect()[l.value.direction]));
        }, g = function(S) {
            if (!o.value || !s.value || !n.wrapElement) return;
            var $ = Math.abs(S.target.getBoundingClientRect()[l.value.direction] - S[l.value.client]), M = o.value[l.value.offset] / 2, P = ($ - M) * 100 * f.value / s.value[l.value.offset];
            n.wrapElement[l.value.scroll] = P * n.wrapElement[l.value.scrollSize] / 100;
        }, b = function(S) {
            S.stopImmediatePropagation(), c = !0, document.addEventListener("mousemove", h), document.addEventListener("mouseup", w), d = document.onselectstart, document.onselectstart = function() {
                return !1;
            };
        }, h = function(S) {
            if (!s.value || !o.value || c === !1) return;
            var $ = i.value[l.value.axis];
            if (!$) return;
            var M = (s.value.getBoundingClientRect()[l.value.direction] - S[l.value.client]) * -1, P = o.value[l.value.offset] - $, R = (M - P) * 100 * f.value / s.value[l.value.offset];
            n.wrapElement[l.value.scroll] = R * n.wrapElement[l.value.scrollSize] / 100;
        }, w = function() {
            c = !1, i.value[l.value.axis] = 0, document.removeEventListener("mousemove", h), document.removeEventListener("mouseup", w), A(), u && (a.value = !1);
        }, k = function() {
            u = !1, a.value = !!t.size;
        }, x = function() {
            u = !0, a.value = c;
        };
        (0, $8B0Dy.onBeforeUnmount)(function() {
            A(), document.removeEventListener("mouseup", w);
        });
        var A = function() {
            document.onselectstart !== d && (document.onselectstart = d);
        };
        return Yn((0, $5wB2C.toRef)(n, "scrollbarElement"), "mousemove", k), Yn((0, $5wB2C.toRef)(n, "scrollbarElement"), "mouseleave", x), function(S, $) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $kRi7Z.Transition), {
                name: (0, $5wB2C.unref)(r).b("fade"),
                persisted: ""
            }, {
                "default": (0, $8B0Dy.withCtx)(function() {
                    return [
                        (0, $8B0Dy.withDirectives)((0, $8B0Dy.createElementVNode)("div", {
                            ref_key: "instance",
                            ref: s,
                            "class": (0, $3ZJCa.normalizeClass)([
                                (0, $5wB2C.unref)(r).e("bar"),
                                (0, $5wB2C.unref)(r).is((0, $5wB2C.unref)(l).key)
                            ]),
                            onMousedown: g
                        }, [
                            (0, $8B0Dy.createElementVNode)("div", {
                                ref_key: "thumb",
                                ref: o,
                                "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(r).e("thumb")),
                                style: (0, $3ZJCa.normalizeStyle)((0, $5wB2C.unref)(m)),
                                onMousedown: v
                            }, null, 38)
                        ], 34), [
                            [
                                (0, $kRi7Z.vShow),
                                S.always || a.value
                            ]
                        ])
                    ];
                }),
                _: 1
            }, 8, [
                "name"
            ]);
        };
    }
});
var Yu = /* @__PURE__ */ Ce(Hx, [
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/scrollbar/src/thumb.vue"
    ]
]);
var jx = Re({
    always: {
        type: Boolean,
        "default": !0
    },
    width: String,
    height: String,
    ratioX: {
        type: Number,
        "default": 1
    },
    ratioY: {
        type: Number,
        "default": 1
    }
}), Ux = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    __name: "bar",
    props: jx,
    setup: function(e, param) {
        var t = param.expose;
        var n = e, r = (0, $5wB2C.ref)(0), s = (0, $5wB2C.ref)(0);
        return t({
            handleScroll: function(i) {
                if (i) {
                    var a = i.offsetHeight - hr, c = i.offsetWidth - hr;
                    s.value = i.scrollTop * 100 / a * n.ratioY, r.value = i.scrollLeft * 100 / c * n.ratioX;
                }
            }
        }), function(i, a) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)((0, $8B0Dy.Fragment), null, [
                (0, $8B0Dy.createVNode)(Yu, {
                    move: r.value,
                    ratio: i.ratioX,
                    size: i.width,
                    always: i.always
                }, null, 8, [
                    "move",
                    "ratio",
                    "size",
                    "always"
                ]),
                (0, $8B0Dy.createVNode)(Yu, {
                    move: s.value,
                    ratio: i.ratioY,
                    size: i.height,
                    vertical: "",
                    always: i.always
                }, null, 8, [
                    "move",
                    "ratio",
                    "size",
                    "always"
                ])
            ], 64);
        };
    }
});
var Vx = /* @__PURE__ */ Ce(Ux, [
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/scrollbar/src/bar.vue"
    ]
]);
var Zx = Re({
    height: {
        type: [
            String,
            Number
        ],
        "default": ""
    },
    maxHeight: {
        type: [
            String,
            Number
        ],
        "default": ""
    },
    native: {
        type: Boolean,
        "default": !1
    },
    wrapStyle: {
        type: be([
            String,
            Object,
            Array
        ]),
        "default": ""
    },
    wrapClass: {
        type: [
            String,
            Array
        ],
        "default": ""
    },
    viewClass: {
        type: [
            String,
            Array
        ],
        "default": ""
    },
    viewStyle: {
        type: [
            String,
            Array,
            Object
        ],
        "default": ""
    },
    noresize: Boolean,
    tag: {
        type: String,
        "default": "div"
    },
    always: Boolean,
    minSize: {
        type: Number,
        "default": 20
    },
    id: String,
    role: String,
    ariaLabel: String,
    ariaOrientation: {
        type: String,
        values: [
            "horizontal",
            "vertical"
        ]
    }
}), Wx = {
    scroll: function(param) {
        var e = param.scrollTop, t = param.scrollLeft;
        return [
            e,
            t
        ].every(Ye);
    }
}, Gx = "ElScrollbar", Kx = (0, $8B0Dy.defineComponent)({
    name: Gx
}), Xx = /* @__PURE__ */ (0, $8B0Dy.defineComponent)((0, $bnFl0._)((0, $6869c._)({}, Kx), {
    props: Zx,
    emits: Wx,
    setup: function(e, param) {
        var t = param.expose, n = param.emit;
        var r = e, s = Te("scrollbar");
        var o, i;
        var a = (0, $5wB2C.ref)(), c = (0, $5wB2C.ref)(), u = (0, $5wB2C.ref)(), d = (0, $5wB2C.ref)("0"), l = (0, $5wB2C.ref)("0"), m = (0, $5wB2C.ref)(), f = (0, $5wB2C.ref)(1), v = (0, $5wB2C.ref)(1), g = (0, $5wB2C.computed)(function() {
            var $ = {};
            return r.height && ($.height = yr(r.height)), r.maxHeight && ($.maxHeight = yr(r.maxHeight)), [
                r.wrapStyle,
                $
            ];
        }), b = (0, $5wB2C.computed)(function() {
            return [
                r.wrapClass,
                s.e("wrap"),
                (0, $aRIHe._)({}, s.em("wrap", "hidden-default"), !r["native"])
            ];
        }), h = (0, $5wB2C.computed)(function() {
            return [
                s.e("view"),
                r.viewClass
            ];
        }), w = function() {
            var $;
            c.value && (($ = m.value) == null || $.handleScroll(c.value), n("scroll", {
                scrollTop: c.value.scrollTop,
                scrollLeft: c.value.scrollLeft
            }));
        };
        function k($, M) {
            Jt($) ? c.value.scrollTo($) : Ye($) && Ye(M) && c.value.scrollTo($, M);
        }
        var x = function($) {
            Ye($) && (c.value.scrollTop = $);
        }, A = function($) {
            Ye($) && (c.value.scrollLeft = $);
        }, S = function() {
            if (!c.value) return;
            var $ = c.value.offsetHeight - hr, M = c.value.offsetWidth - hr, P = Math.pow($, 2) / c.value.scrollHeight, R = Math.pow(M, 2) / c.value.scrollWidth, B = Math.max(P, r.minSize), H = Math.max(R, r.minSize);
            f.value = P / ($ - P) / (B / ($ - B)), v.value = R / (M - R) / (H / (M - H)), l.value = B + hr < $ ? "".concat(B, "px") : "", d.value = H + hr < M ? "".concat(H, "px") : "";
        };
        return (0, $5wB2C.watch)(function() {
            return r.noresize;
        }, function($) {
            var ref;
            $ ? (o == null || o(), i == null || i()) : (ref = cs(u, S), o = ref.stop, ref, i = Yn("resize", S));
        }, {
            immediate: !0
        }), (0, $5wB2C.watch)(function() {
            return [
                r.maxHeight,
                r.height
            ];
        }, function() {
            r["native"] || (0, $8B0Dy.nextTick)(function() {
                var $;
                S(), c.value && (($ = m.value) == null || $.handleScroll(c.value));
            });
        }), (0, $8B0Dy.provide)(Rh, (0, $5wB2C.reactive)({
            scrollbarElement: a,
            wrapElement: c
        })), (0, $8B0Dy.onMounted)(function() {
            r["native"] || (0, $8B0Dy.nextTick)(function() {
                S();
            });
        }), (0, $8B0Dy.onUpdated)(function() {
            return S();
        }), t({
            wrapRef: c,
            update: S,
            scrollTo: k,
            setScrollTop: x,
            setScrollLeft: A,
            handleScroll: w
        }), function($, M) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
                ref_key: "scrollbarRef",
                ref: a,
                "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(s).b())
            }, [
                (0, $8B0Dy.createElementVNode)("div", {
                    ref_key: "wrapRef",
                    ref: c,
                    "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(b)),
                    style: (0, $3ZJCa.normalizeStyle)((0, $5wB2C.unref)(g)),
                    onScroll: w
                }, [
                    ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $8B0Dy.resolveDynamicComponent)($.tag), {
                        id: $.id,
                        ref_key: "resizeRef",
                        ref: u,
                        "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(h)),
                        style: (0, $3ZJCa.normalizeStyle)($.viewStyle),
                        role: $.role,
                        "aria-label": $.ariaLabel,
                        "aria-orientation": $.ariaOrientation
                    }, {
                        "default": (0, $8B0Dy.withCtx)(function() {
                            return [
                                (0, $8B0Dy.renderSlot)($.$slots, "default")
                            ];
                        }),
                        _: 3
                    }, 8, [
                        "id",
                        "class",
                        "style",
                        "role",
                        "aria-label",
                        "aria-orientation"
                    ]))
                ], 38),
                $["native"] ? (0, $8B0Dy.createCommentVNode)("v-if", !0) : ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)(Vx, {
                    key: 0,
                    ref_key: "barRef",
                    ref: m,
                    height: l.value,
                    width: d.value,
                    always: $.always,
                    "ratio-x": v.value,
                    "ratio-y": f.value
                }, null, 8, [
                    "height",
                    "width",
                    "always",
                    "ratio-x",
                    "ratio-y"
                ]))
            ], 2);
        };
    }
}));
var Yx = /* @__PURE__ */ Ce(Xx, [
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/scrollbar/src/scrollbar.vue"
    ]
]);
var Jx = jt(Yx), bl = Symbol("popper"), Ph = Symbol("popperContent"), Qx = [
    "dialog",
    "grid",
    "group",
    "listbox",
    "menu",
    "navigation",
    "tooltip",
    "tree"
], Bh = Re({
    role: {
        type: String,
        values: Qx,
        "default": "tooltip"
    }
}), eC = (0, $8B0Dy.defineComponent)({
    name: "ElPopper",
    inheritAttrs: !1
}), tC = /* @__PURE__ */ (0, $8B0Dy.defineComponent)((0, $bnFl0._)((0, $6869c._)({}, eC), {
    props: Bh,
    setup: function(e, param) {
        var t = param.expose;
        var n = e, r = (0, $5wB2C.ref)(), s = (0, $5wB2C.ref)(), o = (0, $5wB2C.ref)(), i = (0, $5wB2C.ref)(), a = (0, $5wB2C.computed)(function() {
            return n.role;
        }), c = {
            triggerRef: r,
            popperInstanceRef: s,
            contentRef: o,
            referenceRef: i,
            role: a
        };
        return t(c), (0, $8B0Dy.provide)(bl, c), function(u, d) {
            return (0, $8B0Dy.renderSlot)(u.$slots, "default");
        };
    }
}));
var nC = /* @__PURE__ */ Ce(tC, [
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/popper/src/popper.vue"
    ]
]);
var zh = Re({
    arrowOffset: {
        type: Number,
        "default": 5
    }
}), rC = (0, $8B0Dy.defineComponent)({
    name: "ElPopperArrow",
    inheritAttrs: !1
}), oC = /* @__PURE__ */ (0, $8B0Dy.defineComponent)((0, $bnFl0._)((0, $6869c._)({}, rC), {
    props: zh,
    setup: function(e, param) {
        var t = param.expose;
        var n = e, r = Te("popper"), _Le = (0, $8B0Dy.inject)(Ph, void 0), s = _Le.arrowOffset, o = _Le.arrowRef, i = _Le.arrowStyle;
        return (0, $5wB2C.watch)(function() {
            return n.arrowOffset;
        }, function(a) {
            s.value = a;
        }), (0, $8B0Dy.onBeforeUnmount)(function() {
            o.value = void 0;
        }), t({
            arrowRef: o
        }), function(a, c) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("span", {
                ref_key: "arrowRef",
                ref: o,
                "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(r).e("arrow")),
                style: (0, $3ZJCa.normalizeStyle)((0, $5wB2C.unref)(i)),
                "data-popper-arrow": ""
            }, null, 6);
        };
    }
}));
var sC = /* @__PURE__ */ Ce(oC, [
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/popper/src/arrow.vue"
    ]
]);
var iC = "ElOnlyChild", aC = (0, $8B0Dy.defineComponent)({
    name: iC,
    setup: function(e, param) {
        var t = param.slots, n = param.attrs;
        var r;
        var s = (0, $8B0Dy.inject)(Th), o = hx((r = s == null ? void 0 : s.setForwardRef) != null ? r : Yr);
        return function() {
            var i;
            var a = (i = t["default"]) == null ? void 0 : i.call(t, n);
            if (!a || a.length > 1) return null;
            var c = Dh(a);
            return c ? (0, $8B0Dy.withDirectives)((0, $8B0Dy.cloneVNode)(c, n), [
                [
                    o
                ]
            ]) : null;
        };
    }
});
function Dh(e) {
    if (!e) return null;
    var t = e;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var n = _step.value;
            if (Jt(n)) switch(n.type){
                case 0, $8B0Dy.Comment:
                    continue;
                case 0, $8B0Dy.Text:
                case "svg":
                    return Ju(n);
                case 0, $8B0Dy.Fragment:
                    return Dh(n.children);
                default:
                    return n;
            }
            return Ju(n);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
function Ju(e) {
    var t = Te("only-child");
    return (0, $8B0Dy.createVNode)("span", {
        "class": t.e("content")
    }, [
        e
    ]);
}
var Nh = Re({
    virtualRef: {
        type: be(Object)
    },
    virtualTriggering: Boolean,
    onMouseenter: {
        type: be(Function)
    },
    onMouseleave: {
        type: be(Function)
    },
    onClick: {
        type: be(Function)
    },
    onKeydown: {
        type: be(Function)
    },
    onFocus: {
        type: be(Function)
    },
    onBlur: {
        type: be(Function)
    },
    onContextmenu: {
        type: be(Function)
    },
    id: String,
    open: Boolean
}), cC = (0, $8B0Dy.defineComponent)({
    name: "ElPopperTrigger",
    inheritAttrs: !1
}), lC = /* @__PURE__ */ (0, $8B0Dy.defineComponent)((0, $bnFl0._)((0, $6869c._)({}, cC), {
    props: Nh,
    setup: function(e, param) {
        var t = param.expose;
        var n = e, _Le = (0, $8B0Dy.inject)(bl, void 0), r = _Le.role, s = _Le.triggerRef;
        px(s);
        var o = (0, $5wB2C.computed)(function() {
            return a.value ? n.id : void 0;
        }), i = (0, $5wB2C.computed)(function() {
            if (r && r.value === "tooltip") return n.open && n.id ? n.id : void 0;
        }), a = (0, $5wB2C.computed)(function() {
            if (r && r.value !== "tooltip") return r.value;
        }), c = (0, $5wB2C.computed)(function() {
            return a.value ? "".concat(n.open) : void 0;
        });
        var u;
        return (0, $8B0Dy.onMounted)(function() {
            (0, $5wB2C.watch)(function() {
                return n.virtualRef;
            }, function(d) {
                d && (s.value = On(d));
            }, {
                immediate: !0
            }), (0, $5wB2C.watch)(s, function(d, l) {
                u == null || u(), u = void 0, eo(d) && ([
                    "onMouseenter",
                    "onMouseleave",
                    "onClick",
                    "onKeydown",
                    "onFocus",
                    "onBlur",
                    "onContextmenu"
                ].forEach(function(m) {
                    var f;
                    var v = n[m];
                    v && (d.addEventListener(m.slice(2).toLowerCase(), v), (f = l == null ? void 0 : l.removeEventListener) == null || f.call(l, m.slice(2).toLowerCase(), v));
                }), u = (0, $5wB2C.watch)([
                    o,
                    i,
                    a,
                    c
                ], function(m) {
                    [
                        "aria-controls",
                        "aria-describedby",
                        "aria-haspopup",
                        "aria-expanded"
                    ].forEach(function(f, v) {
                        Jn(m[v]) ? d.removeAttribute(f) : d.setAttribute(f, m[v]);
                    });
                }, {
                    immediate: !0
                })), eo(l) && [
                    "aria-controls",
                    "aria-describedby",
                    "aria-haspopup",
                    "aria-expanded"
                ].forEach(function(m) {
                    return l.removeAttribute(m);
                });
            }, {
                immediate: !0
            });
        }), (0, $8B0Dy.onBeforeUnmount)(function() {
            u == null || u(), u = void 0;
        }), t({
            triggerRef: s
        }), function(d, l) {
            return d.virtualTriggering ? (0, $8B0Dy.createCommentVNode)("v-if", !0) : ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(aC), (0, $8B0Dy.mergeProps)({
                key: 0
            }, d.$attrs, {
                "aria-controls": (0, $5wB2C.unref)(o),
                "aria-describedby": (0, $5wB2C.unref)(i),
                "aria-expanded": (0, $5wB2C.unref)(c),
                "aria-haspopup": (0, $5wB2C.unref)(a)
            }), {
                "default": (0, $8B0Dy.withCtx)(function() {
                    return [
                        (0, $8B0Dy.renderSlot)(d.$slots, "default")
                    ];
                }),
                _: 3
            }, 16, [
                "aria-controls",
                "aria-describedby",
                "aria-expanded",
                "aria-haspopup"
            ]));
        };
    }
}));
var uC = /* @__PURE__ */ Ce(lC, [
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/popper/src/trigger.vue"
    ]
]);
var js = "focus-trap.focus-after-trapped", Us = "focus-trap.focus-after-released", dC = "focus-trap.focusout-prevented", Qu = {
    cancelable: !0,
    bubbles: !1
}, fC = {
    cancelable: !0,
    bubbles: !1
}, ed = "focusAfterTrapped", td = "focusAfterReleased", pC = Symbol("elFocusTrap"), yl = (0, $5wB2C.ref)(), ks = (0, $5wB2C.ref)(0), wl = (0, $5wB2C.ref)(0);
var xo = 0;
var qh = function(e) {
    var t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
        acceptNode: function(r) {
            var s = r.tagName === "INPUT" && r.type === "hidden";
            return r.disabled || r.hidden || s ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 || r === document.activeElement ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    for(; n.nextNode();)t.push(n.currentNode);
    return t;
}, nd = function(e, t) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var n = _step.value;
            if (!hC(n, t)) return n;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}, hC = function(e, t) {
    if (getComputedStyle(e).visibility === "hidden") return !0;
    for(; e;){
        if (t && e === t) return !1;
        if (getComputedStyle(e).display === "none") return !0;
        e = e.parentElement;
    }
    return !1;
}, gC = function(e) {
    var t = qh(e), n = nd(t, e), r = nd(t.reverse(), e);
    return [
        n,
        r
    ];
}, mC = function(e) {
    return e instanceof HTMLInputElement && "select" in e;
}, In = function(e, t) {
    if (e && e.focus) {
        var n = document.activeElement;
        e.focus({
            preventScroll: !0
        }), wl.value = window.performance.now(), e !== n && mC(e) && t && e.select();
    }
};
function rd(e, t) {
    var n = (0, $kf9Kn._)(e), r = e.indexOf(t);
    return r !== -1 && n.splice(r, 1), n;
}
var vC = function() {
    var e = [];
    return {
        push: function(r) {
            var s = e[0];
            s && r !== s && s.pause(), e = rd(e, r), e.unshift(r);
        },
        remove: function(r) {
            var s, o;
            e = rd(e, r), (o = (s = e[0]) == null ? void 0 : s.resume) == null || o.call(s);
        }
    };
}, _C = function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    var n = document.activeElement;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var r = _step.value;
            if (In(r, t), document.activeElement !== n) return;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}, od = vC(), bC = function() {
    return ks.value > wl.value;
}, Co = function() {
    yl.value = "pointer", ks.value = window.performance.now();
}, sd = function() {
    yl.value = "keyboard", ks.value = window.performance.now();
}, yC = function() {
    return (0, $8B0Dy.onMounted)(function() {
        xo === 0 && (document.addEventListener("mousedown", Co), document.addEventListener("touchstart", Co), document.addEventListener("keydown", sd)), xo++;
    }), (0, $8B0Dy.onBeforeUnmount)(function() {
        xo--, xo <= 0 && (document.removeEventListener("mousedown", Co), document.removeEventListener("touchstart", Co), document.removeEventListener("keydown", sd));
    }), {
        focusReason: yl,
        lastUserFocusTimestamp: ks,
        lastAutomatedFocusTimestamp: wl
    };
}, So = function(e) {
    return new CustomEvent(dC, (0, $bnFl0._)((0, $6869c._)({}, fC), {
        detail: e
    }));
}, wC = (0, $8B0Dy.defineComponent)({
    name: "ElFocusTrap",
    inheritAttrs: !1,
    props: {
        loop: Boolean,
        trapped: Boolean,
        focusTrapEl: Object,
        focusStartEl: {
            type: [
                Object,
                String
            ],
            "default": "first"
        }
    },
    emits: [
        ed,
        td,
        "focusin",
        "focusout",
        "focusout-prevented",
        "release-requested"
    ],
    setup: function(e, param) {
        var t = param.emit;
        var n = (0, $5wB2C.ref)();
        var r, s;
        var _yC = yC(), o = _yC.focusReason;
        cx(function(v) {
            e.trapped && !i.paused && t("release-requested", v);
        });
        var i = {
            paused: !1,
            pause: function() {
                this.paused = !0;
            },
            resume: function() {
                this.paused = !1;
            }
        }, a = function(v) {
            if (!e.loop && !e.trapped || i.paused) return;
            var g = v.key, b = v.altKey, h = v.ctrlKey, w = v.metaKey, k = v.currentTarget, x = v.shiftKey, A = e.loop, S = g === _n.tab && !b && !h && !w, $ = document.activeElement;
            if (S && $) {
                var M = k, _gC = (0, $9tk0W._)(gC(M), 2), P = _gC[0], R = _gC[1];
                if (P && R) {
                    if (!x && $ === R) {
                        var H = So({
                            focusReason: o.value
                        });
                        t("focusout-prevented", H), H.defaultPrevented || (v.preventDefault(), A && In(P, !0));
                    } else if (x && [
                        P,
                        M
                    ].includes($)) {
                        var H1 = So({
                            focusReason: o.value
                        });
                        t("focusout-prevented", H1), H1.defaultPrevented || (v.preventDefault(), A && In(R, !0));
                    }
                } else if ($ === M) {
                    var H2 = So({
                        focusReason: o.value
                    });
                    t("focusout-prevented", H2), H2.defaultPrevented || v.preventDefault();
                }
            }
        };
        (0, $8B0Dy.provide)(pC, {
            focusTrapRef: n,
            onKeydown: a
        }), (0, $5wB2C.watch)(function() {
            return e.focusTrapEl;
        }, function(v) {
            v && (n.value = v);
        }, {
            immediate: !0
        }), (0, $5wB2C.watch)([
            n
        ], function(param, param1) {
            var _param = (0, $9tk0W._)(param, 1), v = _param[0], _param1 = (0, $9tk0W._)(param1, 1), g = _param1[0];
            v && (v.addEventListener("keydown", a), v.addEventListener("focusin", d), v.addEventListener("focusout", l)), g && (g.removeEventListener("keydown", a), g.removeEventListener("focusin", d), g.removeEventListener("focusout", l));
        });
        var c = function(v) {
            t(ed, v);
        }, u = function(v) {
            return t(td, v);
        }, d = function(v) {
            var g = (0, $5wB2C.unref)(n);
            if (!g) return;
            var b = v.target, h = v.relatedTarget, w = b && g.contains(b);
            e.trapped || h && g.contains(h) || (r = h), w && t("focusin", v), !i.paused && e.trapped && (w ? s = b : In(s, !0));
        }, l = function(v) {
            var g = (0, $5wB2C.unref)(n);
            if (!(i.paused || !g)) {
                if (e.trapped) {
                    var b = v.relatedTarget;
                    !Jn(b) && !g.contains(b) && setTimeout(function() {
                        if (!i.paused && e.trapped) {
                            var h = So({
                                focusReason: o.value
                            });
                            t("focusout-prevented", h), h.defaultPrevented || In(s, !0);
                        }
                    }, 0);
                } else {
                    var b1 = v.target;
                    b1 && g.contains(b1) || t("focusout", v);
                }
            }
        };
        function m() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
                var v, g, h;
                return (0, $e0qXa.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0, $8B0Dy.nextTick)()
                            ];
                        case 1:
                            _state.sent();
                            v = (0, $5wB2C.unref)(n);
                            if (v) {
                                od.push(i);
                                g = v.contains(document.activeElement) ? r : document.activeElement;
                                if (r = g, !v.contains(g)) {
                                    h = new Event(js, Qu);
                                    v.addEventListener(js, c), v.dispatchEvent(h), h.defaultPrevented || (0, $8B0Dy.nextTick)(function() {
                                        var w = e.focusStartEl;
                                        Yt(w) || (In(w), document.activeElement !== w && (w = "first")), w === "first" && _C(qh(v), !0), (document.activeElement === g || w === "container") && In(v);
                                    });
                                }
                            }
                            return [
                                2
                            ];
                    }
                });
            })();
        }
        function f() {
            var v = (0, $5wB2C.unref)(n);
            if (v) {
                v.removeEventListener(js, c);
                var g = new CustomEvent(Us, (0, $bnFl0._)((0, $6869c._)({}, Qu), {
                    detail: {
                        focusReason: o.value
                    }
                }));
                v.addEventListener(Us, u), v.dispatchEvent(g), !g.defaultPrevented && (o.value == "keyboard" || !bC() || v.contains(document.activeElement)) && In(r !== null && r !== void 0 ? r : document.body), v.removeEventListener(Us, u), od.remove(i);
            }
        }
        return (0, $8B0Dy.onMounted)(function() {
            e.trapped && m(), (0, $5wB2C.watch)(function() {
                return e.trapped;
            }, function(v) {
                v ? m() : f();
            });
        }), (0, $8B0Dy.onBeforeUnmount)(function() {
            e.trapped && f();
        }), {
            onKeydown: a
        };
    }
});
function kC(e, t, n, r, s, o) {
    return (0, $8B0Dy.renderSlot)(e.$slots, "default", {
        handleKeydown: e.onKeydown
    });
}
var xC = /* @__PURE__ */ Ce(wC, [
    [
        "render",
        kC
    ],
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/focus-trap/src/focus-trap.vue"
    ]
]);
var CC = [
    "fixed",
    "absolute"
], SC = Re({
    boundariesPadding: {
        type: Number,
        "default": 0
    },
    fallbackPlacements: {
        type: be(Array),
        "default": void 0
    },
    gpuAcceleration: {
        type: Boolean,
        "default": !0
    },
    offset: {
        type: Number,
        "default": 12
    },
    placement: {
        type: String,
        values: ms,
        "default": "bottom"
    },
    popperOptions: {
        type: be(Object),
        "default": function() {
            return {};
        }
    },
    strategy: {
        type: String,
        values: CC,
        "default": "absolute"
    }
}), Fh = Re((0, $bnFl0._)((0, $6869c._)({}, SC), {
    id: String,
    style: {
        type: be([
            String,
            Array,
            Object
        ])
    },
    className: {
        type: be([
            String,
            Array,
            Object
        ])
    },
    effect: {
        type: String,
        "default": "dark"
    },
    visible: Boolean,
    enterable: {
        type: Boolean,
        "default": !0
    },
    pure: Boolean,
    focusOnShow: {
        type: Boolean,
        "default": !1
    },
    trapping: {
        type: Boolean,
        "default": !1
    },
    popperClass: {
        type: be([
            String,
            Array,
            Object
        ])
    },
    popperStyle: {
        type: be([
            String,
            Array,
            Object
        ])
    },
    referenceEl: {
        type: be(Object)
    },
    triggerTargetEl: {
        type: be(Object)
    },
    stopPopperMouseEvent: {
        type: Boolean,
        "default": !0
    },
    ariaLabel: {
        type: String,
        "default": void 0
    },
    virtualTriggering: Boolean,
    zIndex: Number
})), EC = {
    mouseenter: function(e) {
        return e instanceof MouseEvent;
    },
    mouseleave: function(e) {
        return e instanceof MouseEvent;
    },
    focus: function() {
        return !0;
    },
    blur: function() {
        return !0;
    },
    close: function() {
        return !0;
    }
}, AC = function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var n = e.placement, r = e.strategy, s = e.popperOptions, o = (0, $bnFl0._)((0, $6869c._)({
        placement: n,
        strategy: r
    }, s), {
        modifiers: (0, $kf9Kn._)(MC(e)).concat((0, $kf9Kn._)(t))
    });
    return IC(o, s == null ? void 0 : s.modifiers), o;
}, $C = function(e) {
    if (gt) return On(e);
};
function MC(e) {
    var t = e.offset, n = e.gpuAcceleration, r = e.fallbackPlacements;
    return [
        {
            name: "offset",
            options: {
                offset: [
                    0,
                    t !== null && t !== void 0 ? t : 12
                ]
            }
        },
        {
            name: "preventOverflow",
            options: {
                padding: {
                    top: 2,
                    bottom: 2,
                    left: 5,
                    right: 5
                }
            }
        },
        {
            name: "flip",
            options: {
                padding: 5,
                fallbackPlacements: r
            }
        },
        {
            name: "computeStyles",
            options: {
                gpuAcceleration: n
            }
        }
    ];
}
function IC(e, t) {
    t && (e.modifiers = (0, $kf9Kn._)(e.modifiers).concat((0, $kf9Kn._)(t !== null && t !== void 0 ? t : [])));
}
var TC = 0, LC = function(e) {
    var _Le = (0, $8B0Dy.inject)(bl, void 0), t = _Le.popperInstanceRef, n = _Le.contentRef, r = _Le.triggerRef, s = _Le.role, o = (0, $5wB2C.ref)(), i = (0, $5wB2C.ref)(), a = (0, $5wB2C.computed)(function() {
        return {
            name: "eventListeners",
            enabled: !!e.visible
        };
    }), c = (0, $5wB2C.computed)(function() {
        var h;
        var w = (0, $5wB2C.unref)(o), k = (h = (0, $5wB2C.unref)(i)) != null ? h : TC;
        return {
            name: "arrow",
            enabled: !d4(w),
            options: {
                element: w,
                padding: k
            }
        };
    }), u = (0, $5wB2C.computed)(function() {
        return (0, $6869c._)({
            onFirstUpdate: function() {
                v();
            }
        }, AC(e, [
            (0, $5wB2C.unref)(c),
            (0, $5wB2C.unref)(a)
        ]));
    }), d = (0, $5wB2C.computed)(function() {
        return $C(e.referenceEl) || (0, $5wB2C.unref)(r);
    }), _ox = ox(d, n, u), l = _ox.attributes, m = _ox.state, f = _ox.styles, v = _ox.update, g = _ox.forceUpdate, b = _ox.instanceRef;
    return (0, $5wB2C.watch)(b, function(h) {
        return t.value = h;
    }), (0, $8B0Dy.onMounted)(function() {
        (0, $5wB2C.watch)(function() {
            var h;
            return (h = (0, $5wB2C.unref)(d)) == null ? void 0 : h.getBoundingClientRect();
        }, function() {
            v();
        });
    }), {
        attributes: l,
        arrowRef: o,
        contentRef: n,
        instanceRef: b,
        state: m,
        styles: f,
        role: s,
        forceUpdate: g,
        update: v
    };
}, OC = function(e, param) {
    var t = param.attributes, n = param.styles, r = param.role;
    var _vx = vx(), s = _vx.nextZIndex, o = Te("popper"), i = (0, $5wB2C.computed)(function() {
        return (0, $5wB2C.unref)(t).popper;
    }), a = (0, $5wB2C.ref)(Ye(e.zIndex) ? e.zIndex : s()), c = (0, $5wB2C.computed)(function() {
        return [
            o.b(),
            o.is("pure", e.pure),
            o.is(e.effect),
            e.popperClass
        ];
    }), u = (0, $5wB2C.computed)(function() {
        return [
            {
                zIndex: (0, $5wB2C.unref)(a)
            },
            (0, $5wB2C.unref)(n).popper,
            e.popperStyle || {}
        ];
    }), d = (0, $5wB2C.computed)(function() {
        return r.value === "dialog" ? "false" : void 0;
    }), l = (0, $5wB2C.computed)(function() {
        return (0, $5wB2C.unref)(n).arrow || {};
    });
    return {
        ariaModal: d,
        arrowStyle: l,
        contentAttrs: i,
        contentClass: c,
        contentStyle: u,
        contentZIndex: a,
        updateZIndex: function() {
            a.value = Ye(e.zIndex) ? e.zIndex : s();
        }
    };
}, RC = function(e, t) {
    var n = (0, $5wB2C.ref)(!1), r = (0, $5wB2C.ref)();
    return {
        focusStartRef: r,
        trapped: n,
        onFocusAfterReleased: function(u) {
            var d;
            ((d = u.detail) == null ? void 0 : d.focusReason) !== "pointer" && (r.value = "first", t("blur"));
        },
        onFocusAfterTrapped: function() {
            t("focus");
        },
        onFocusInTrap: function(u) {
            e.visible && !n.value && (u.target && (r.value = u.target), n.value = !0);
        },
        onFocusoutPrevented: function(u) {
            e.trapping || (u.detail.focusReason === "pointer" && u.preventDefault(), n.value = !1);
        },
        onReleaseRequested: function() {
            n.value = !1, t("close");
        }
    };
}, PC = (0, $8B0Dy.defineComponent)({
    name: "ElPopperContent"
}), BC = /* @__PURE__ */ (0, $8B0Dy.defineComponent)((0, $bnFl0._)((0, $6869c._)({}, PC), {
    props: Fh,
    emits: EC,
    setup: function(e, param) {
        var t = param.expose, n = param.emit;
        var r = e, _RC = RC(r, n), s = _RC.focusStartRef, o = _RC.trapped, i = _RC.onFocusAfterReleased, a = _RC.onFocusAfterTrapped, c = _RC.onFocusInTrap, u = _RC.onFocusoutPrevented, d = _RC.onReleaseRequested, _LC = LC(r), l = _LC.attributes, m = _LC.arrowRef, f = _LC.contentRef, v = _LC.styles, g = _LC.instanceRef, b = _LC.role, h = _LC.update, _OC = OC(r, {
            styles: v,
            attributes: l,
            role: b
        }), w = _OC.ariaModal, k = _OC.arrowStyle, x = _OC.contentAttrs, A = _OC.contentClass, S = _OC.contentStyle, $ = _OC.updateZIndex, M = (0, $8B0Dy.inject)(Ko, void 0), P = (0, $5wB2C.ref)();
        (0, $8B0Dy.provide)(Ph, {
            arrowStyle: k,
            arrowRef: m,
            arrowOffset: P
        }), M && (M.addInputId || M.removeInputId) && (0, $8B0Dy.provide)(Ko, (0, $bnFl0._)((0, $6869c._)({}, M), {
            addInputId: Yr,
            removeInputId: Yr
        }));
        var R;
        var B = function() {
            var ie = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
            h(), ie && $();
        }, H = function() {
            B(!1), r.visible && r.focusOnShow ? o.value = !0 : r.visible === !1 && (o.value = !1);
        };
        return (0, $8B0Dy.onMounted)(function() {
            (0, $5wB2C.watch)(function() {
                return r.triggerTargetEl;
            }, function(ie, z) {
                R == null || R(), R = void 0;
                var Q = (0, $5wB2C.unref)(ie || f.value), N = (0, $5wB2C.unref)(z || f.value);
                eo(Q) && (R = (0, $5wB2C.watch)([
                    b,
                    function() {
                        return r.ariaLabel;
                    },
                    w,
                    function() {
                        return r.id;
                    }
                ], function(j) {
                    [
                        "role",
                        "aria-label",
                        "aria-modal",
                        "id"
                    ].forEach(function(U, G) {
                        Jn(j[G]) ? Q.removeAttribute(U) : Q.setAttribute(U, j[G]);
                    });
                }, {
                    immediate: !0
                })), N !== Q && eo(N) && [
                    "role",
                    "aria-label",
                    "aria-modal",
                    "id"
                ].forEach(function(j) {
                    N.removeAttribute(j);
                });
            }, {
                immediate: !0
            }), (0, $5wB2C.watch)(function() {
                return r.visible;
            }, H, {
                immediate: !0
            });
        }), (0, $8B0Dy.onBeforeUnmount)(function() {
            R == null || R(), R = void 0;
        }), t({
            popperContentRef: f,
            popperInstanceRef: g,
            updatePopper: B,
            contentStyle: S
        }), function(ie, z) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", (0, $8B0Dy.mergeProps)({
                ref_key: "contentRef",
                ref: f
            }, (0, $5wB2C.unref)(x), {
                style: (0, $5wB2C.unref)(S),
                "class": (0, $5wB2C.unref)(A),
                tabindex: "-1",
                onMouseenter: z[0] || (z[0] = function(Q) {
                    return ie.$emit("mouseenter", Q);
                }),
                onMouseleave: z[1] || (z[1] = function(Q) {
                    return ie.$emit("mouseleave", Q);
                })
            }), [
                (0, $8B0Dy.createVNode)((0, $5wB2C.unref)(xC), {
                    trapped: (0, $5wB2C.unref)(o),
                    "trap-on-focus-in": !0,
                    "focus-trap-el": (0, $5wB2C.unref)(f),
                    "focus-start-el": (0, $5wB2C.unref)(s),
                    onFocusAfterTrapped: (0, $5wB2C.unref)(a),
                    onFocusAfterReleased: (0, $5wB2C.unref)(i),
                    onFocusin: (0, $5wB2C.unref)(c),
                    onFocusoutPrevented: (0, $5wB2C.unref)(u),
                    onReleaseRequested: (0, $5wB2C.unref)(d)
                }, {
                    "default": (0, $8B0Dy.withCtx)(function() {
                        return [
                            (0, $8B0Dy.renderSlot)(ie.$slots, "default")
                        ];
                    }),
                    _: 3
                }, 8, [
                    "trapped",
                    "focus-trap-el",
                    "focus-start-el",
                    "onFocusAfterTrapped",
                    "onFocusAfterReleased",
                    "onFocusin",
                    "onFocusoutPrevented",
                    "onReleaseRequested"
                ])
            ], 16);
        };
    }
}));
var zC = /* @__PURE__ */ Ce(BC, [
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/popper/src/content.vue"
    ]
]);
var DC = jt(nC), kl = Symbol("elTooltip"), Tt = Re((0, $bnFl0._)((0, $6869c._)({}, dx, Fh), {
    appendTo: {
        type: be([
            String,
            Object
        ])
    },
    content: {
        type: String,
        "default": ""
    },
    rawContent: {
        type: Boolean,
        "default": !1
    },
    persistent: Boolean,
    ariaLabel: String,
    visible: {
        type: be(Boolean),
        "default": null
    },
    transition: String,
    teleported: {
        type: Boolean,
        "default": !0
    },
    disabled: Boolean
})), ro = Re((0, $bnFl0._)((0, $6869c._)({}, Nh), {
    disabled: Boolean,
    trigger: {
        type: be([
            String,
            Array
        ]),
        "default": "hover"
    },
    triggerKeys: {
        type: be(Array),
        "default": function() {
            return [
                _n.enter,
                _n.space
            ];
        }
    }
})), _t3 = t3("visible"), NC = _t3.useModelToggleProps, qC = _t3.useModelToggleEmits, FC = _t3.useModelToggle, HC = Re((0, $bnFl0._)((0, $6869c._)({}, Bh, NC, Tt, ro, zh), {
    showArrow: {
        type: Boolean,
        "default": !0
    }
})), jC = (0, $kf9Kn._)(qC).concat([
    "before-show",
    "before-hide",
    "show",
    "hide",
    "open",
    "close"
]), UC = function(e, t) {
    return Db(e) ? e.includes(t) : e === t;
}, cr = function(e, t, n) {
    return function(r) {
        UC((0, $5wB2C.unref)(e), t) && n(r);
    };
}, VC = (0, $8B0Dy.defineComponent)({
    name: "ElTooltipTrigger"
}), ZC = /* @__PURE__ */ (0, $8B0Dy.defineComponent)((0, $bnFl0._)((0, $6869c._)({}, VC), {
    props: ro,
    setup: function(e, param) {
        var t = param.expose;
        var n = e, r = Te("tooltip"), _Le = (0, $8B0Dy.inject)(kl, void 0), s = _Le.controlled, o = _Le.id, i = _Le.open, a = _Le.onOpen, c = _Le.onClose, u = _Le.onToggle, d = (0, $5wB2C.ref)(null), l = function() {
            if ((0, $5wB2C.unref)(s) || n.disabled) return !0;
        }, m = (0, $5wB2C.toRef)(n, "trigger"), f = gn(l, cr(m, "hover", a)), v = gn(l, cr(m, "hover", c)), g = gn(l, cr(m, "click", function(x) {
            x.button === 0 && u(x);
        })), b = gn(l, cr(m, "focus", a)), h = gn(l, cr(m, "focus", c)), w = gn(l, cr(m, "contextmenu", function(x) {
            x.preventDefault(), u(x);
        })), k = gn(l, function(x) {
            var A = x.code;
            n.triggerKeys.includes(A) && (x.preventDefault(), u(x));
        });
        return t({
            triggerRef: d
        }), function(x, A) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(uC), {
                id: (0, $5wB2C.unref)(o),
                "virtual-ref": x.virtualRef,
                open: (0, $5wB2C.unref)(i),
                "virtual-triggering": x.virtualTriggering,
                "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(r).e("trigger")),
                onBlur: (0, $5wB2C.unref)(h),
                onClick: (0, $5wB2C.unref)(g),
                onContextmenu: (0, $5wB2C.unref)(w),
                onFocus: (0, $5wB2C.unref)(b),
                onMouseenter: (0, $5wB2C.unref)(f),
                onMouseleave: (0, $5wB2C.unref)(v),
                onKeydown: (0, $5wB2C.unref)(k)
            }, {
                "default": (0, $8B0Dy.withCtx)(function() {
                    return [
                        (0, $8B0Dy.renderSlot)(x.$slots, "default")
                    ];
                }),
                _: 3
            }, 8, [
                "id",
                "virtual-ref",
                "open",
                "virtual-triggering",
                "class",
                "onBlur",
                "onClick",
                "onContextmenu",
                "onFocus",
                "onMouseenter",
                "onMouseleave",
                "onKeydown"
            ]);
        };
    }
}));
var WC = /* @__PURE__ */ Ce(ZC, [
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/tooltip/src/trigger.vue"
    ]
]);
var GC = (0, $8B0Dy.defineComponent)({
    name: "ElTooltipContent",
    inheritAttrs: !1
}), KC = /* @__PURE__ */ (0, $8B0Dy.defineComponent)((0, $bnFl0._)((0, $6869c._)({}, GC), {
    props: Tt,
    setup: function(e, param) {
        var t = param.expose;
        var n = e, _Ih = Ih(), r = _Ih.selector, s = Te("tooltip"), o = (0, $5wB2C.ref)(null), i = (0, $5wB2C.ref)(!1), _Le = (0, $8B0Dy.inject)(kl, void 0), a = _Le.controlled, c = _Le.id, u = _Le.open, d = _Le.trigger, l = _Le.onClose, m = _Le.onOpen, f = _Le.onShow, v = _Le.onHide, g = _Le.onBeforeShow, b = _Le.onBeforeHide, h = (0, $5wB2C.computed)(function() {
            return n.transition || "".concat(s.namespace.value, "-fade-in-linear");
        }), w = (0, $5wB2C.computed)(function() {
            return n.persistent;
        });
        (0, $8B0Dy.onBeforeUnmount)(function() {
            i.value = !0;
        });
        var k = (0, $5wB2C.computed)(function() {
            return (0, $5wB2C.unref)(w) ? !0 : (0, $5wB2C.unref)(u);
        }), x = (0, $5wB2C.computed)(function() {
            return n.disabled ? !1 : (0, $5wB2C.unref)(u);
        }), A = (0, $5wB2C.computed)(function() {
            return n.appendTo || r.value;
        }), S = (0, $5wB2C.computed)(function() {
            var j;
            return (j = n.style) != null ? j : {};
        }), $ = (0, $5wB2C.computed)(function() {
            return !(0, $5wB2C.unref)(u);
        }), M = function() {
            v();
        }, P = function() {
            if ((0, $5wB2C.unref)(a)) return !0;
        }, R = gn(P, function() {
            n.enterable && (0, $5wB2C.unref)(d) === "hover" && m();
        }), B = gn(P, function() {
            (0, $5wB2C.unref)(d) === "hover" && l();
        }), H = function() {
            var j, U;
            (U = (j = o.value) == null ? void 0 : j.updatePopper) == null || U.call(j), g == null || g();
        }, ie = function() {
            b == null || b();
        }, z = function() {
            f(), N = Eb((0, $5wB2C.computed)(function() {
                var j;
                return (j = o.value) == null ? void 0 : j.popperContentRef;
            }), function() {
                if ((0, $5wB2C.unref)(a)) return;
                (0, $5wB2C.unref)(d) !== "hover" && l();
            });
        }, Q = function() {
            n.virtualTriggering || l();
        };
        var N;
        return (0, $5wB2C.watch)(function() {
            return (0, $5wB2C.unref)(u);
        }, function(j) {
            j || N == null || N();
        }, {
            flush: "post"
        }), (0, $5wB2C.watch)(function() {
            return n.content;
        }, function() {
            var j, U;
            (U = (j = o.value) == null ? void 0 : j.updatePopper) == null || U.call(j);
        }), t({
            contentRef: o
        }), function(j, U) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $8B0Dy.Teleport), {
                disabled: !j.teleported,
                to: (0, $5wB2C.unref)(A)
            }, [
                (0, $8B0Dy.createVNode)((0, $kRi7Z.Transition), {
                    name: (0, $5wB2C.unref)(h),
                    onAfterLeave: M,
                    onBeforeEnter: H,
                    onAfterEnter: z,
                    onBeforeLeave: ie
                }, {
                    "default": (0, $8B0Dy.withCtx)(function() {
                        return [
                            (0, $5wB2C.unref)(k) ? (0, $8B0Dy.withDirectives)(((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(zC), (0, $8B0Dy.mergeProps)({
                                key: 0,
                                id: (0, $5wB2C.unref)(c),
                                ref_key: "contentRef",
                                ref: o
                            }, j.$attrs, {
                                "aria-label": j.ariaLabel,
                                "aria-hidden": (0, $5wB2C.unref)($),
                                "boundaries-padding": j.boundariesPadding,
                                "fallback-placements": j.fallbackPlacements,
                                "gpu-acceleration": j.gpuAcceleration,
                                offset: j.offset,
                                placement: j.placement,
                                "popper-options": j.popperOptions,
                                strategy: j.strategy,
                                effect: j.effect,
                                enterable: j.enterable,
                                pure: j.pure,
                                "popper-class": j.popperClass,
                                "popper-style": [
                                    j.popperStyle,
                                    (0, $5wB2C.unref)(S)
                                ],
                                "reference-el": j.referenceEl,
                                "trigger-target-el": j.triggerTargetEl,
                                visible: (0, $5wB2C.unref)(x),
                                "z-index": j.zIndex,
                                onMouseenter: (0, $5wB2C.unref)(R),
                                onMouseleave: (0, $5wB2C.unref)(B),
                                onBlur: Q,
                                onClose: (0, $5wB2C.unref)(l)
                            }), {
                                "default": (0, $8B0Dy.withCtx)(function() {
                                    return [
                                        i.value ? (0, $8B0Dy.createCommentVNode)("v-if", !0) : (0, $8B0Dy.renderSlot)(j.$slots, "default", {
                                            key: 0
                                        })
                                    ];
                                }),
                                _: 3
                            }, 16, [
                                "id",
                                "aria-label",
                                "aria-hidden",
                                "boundaries-padding",
                                "fallback-placements",
                                "gpu-acceleration",
                                "offset",
                                "placement",
                                "popper-options",
                                "strategy",
                                "effect",
                                "enterable",
                                "pure",
                                "popper-class",
                                "popper-style",
                                "reference-el",
                                "trigger-target-el",
                                "visible",
                                "z-index",
                                "onMouseenter",
                                "onMouseleave",
                                "onClose"
                            ])), [
                                [
                                    (0, $kRi7Z.vShow),
                                    (0, $5wB2C.unref)(x)
                                ]
                            ]) : (0, $8B0Dy.createCommentVNode)("v-if", !0)
                        ];
                    }),
                    _: 3
                }, 8, [
                    "name"
                ])
            ], 8, [
                "disabled",
                "to"
            ]);
        };
    }
}));
var XC = /* @__PURE__ */ Ce(KC, [
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/tooltip/src/content.vue"
    ]
]);
var YC = [
    "innerHTML"
], JC = {
    key: 1
}, QC = (0, $8B0Dy.defineComponent)({
    name: "ElTooltip"
}), e6 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)((0, $bnFl0._)((0, $6869c._)({}, QC), {
    props: HC,
    emits: jC,
    setup: function(e, param) {
        var t = param.expose, n = param.emit;
        var r = e;
        ux();
        var s = _s(), o = (0, $5wB2C.ref)(), i = (0, $5wB2C.ref)(), a = function() {
            var h;
            var w = (0, $5wB2C.unref)(o);
            w && ((h = w.popperInstanceRef) == null || h.update());
        }, c = (0, $5wB2C.ref)(!1), u = (0, $5wB2C.ref)(), _FC = FC({
            indicator: c,
            toggleReason: u
        }), d = _FC.show, l = _FC.hide, m = _FC.hasUpdateHandler, _fx = fx({
            showAfter: (0, $5wB2C.toRef)(r, "showAfter"),
            hideAfter: (0, $5wB2C.toRef)(r, "hideAfter"),
            autoClose: (0, $5wB2C.toRef)(r, "autoClose"),
            open: d,
            close: l
        }), f = _fx.onOpen, v = _fx.onClose, g = (0, $5wB2C.computed)(function() {
            return ol(r.visible) && !m.value;
        });
        (0, $8B0Dy.provide)(kl, {
            controlled: g,
            id: s,
            open: (0, $5wB2C.readonly)(c),
            trigger: (0, $5wB2C.toRef)(r, "trigger"),
            onOpen: function(h) {
                f(h);
            },
            onClose: function(h) {
                v(h);
            },
            onToggle: function(h) {
                (0, $5wB2C.unref)(c) ? v(h) : f(h);
            },
            onShow: function() {
                n("show", u.value);
            },
            onHide: function() {
                n("hide", u.value);
            },
            onBeforeShow: function() {
                n("before-show", u.value);
            },
            onBeforeHide: function() {
                n("before-hide", u.value);
            },
            updatePopper: a
        }), (0, $5wB2C.watch)(function() {
            return r.disabled;
        }, function(h) {
            h && c.value && (c.value = !1);
        });
        var b = function(h) {
            var w, k;
            var x = (k = (w = i.value) == null ? void 0 : w.contentRef) == null ? void 0 : k.popperContentRef, A = (h == null ? void 0 : h.relatedTarget) || document.activeElement;
            return x && x.contains(A);
        };
        return (0, $8B0Dy.onDeactivated)(function() {
            return c.value && l();
        }), t({
            popperRef: o,
            contentRef: i,
            isFocusInsideContent: b,
            updatePopper: a,
            onOpen: f,
            onClose: v,
            hide: l
        }), function(h, w) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(DC), {
                ref_key: "popperRef",
                ref: o,
                role: h.role
            }, {
                "default": (0, $8B0Dy.withCtx)(function() {
                    return [
                        (0, $8B0Dy.createVNode)(WC, {
                            disabled: h.disabled,
                            trigger: h.trigger,
                            "trigger-keys": h.triggerKeys,
                            "virtual-ref": h.virtualRef,
                            "virtual-triggering": h.virtualTriggering
                        }, {
                            "default": (0, $8B0Dy.withCtx)(function() {
                                return [
                                    h.$slots["default"] ? (0, $8B0Dy.renderSlot)(h.$slots, "default", {
                                        key: 0
                                    }) : (0, $8B0Dy.createCommentVNode)("v-if", !0)
                                ];
                            }),
                            _: 3
                        }, 8, [
                            "disabled",
                            "trigger",
                            "trigger-keys",
                            "virtual-ref",
                            "virtual-triggering"
                        ]),
                        (0, $8B0Dy.createVNode)(XC, {
                            ref_key: "contentRef",
                            ref: i,
                            "aria-label": h.ariaLabel,
                            "boundaries-padding": h.boundariesPadding,
                            content: h.content,
                            disabled: h.disabled,
                            effect: h.effect,
                            enterable: h.enterable,
                            "fallback-placements": h.fallbackPlacements,
                            "hide-after": h.hideAfter,
                            "gpu-acceleration": h.gpuAcceleration,
                            offset: h.offset,
                            persistent: h.persistent,
                            "popper-class": h.popperClass,
                            "popper-style": h.popperStyle,
                            placement: h.placement,
                            "popper-options": h.popperOptions,
                            pure: h.pure,
                            "raw-content": h.rawContent,
                            "reference-el": h.referenceEl,
                            "trigger-target-el": h.triggerTargetEl,
                            "show-after": h.showAfter,
                            strategy: h.strategy,
                            teleported: h.teleported,
                            transition: h.transition,
                            "virtual-triggering": h.virtualTriggering,
                            "z-index": h.zIndex,
                            "append-to": h.appendTo
                        }, {
                            "default": (0, $8B0Dy.withCtx)(function() {
                                return [
                                    (0, $8B0Dy.renderSlot)(h.$slots, "content", {}, function() {
                                        return [
                                            h.rawContent ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("span", {
                                                key: 0,
                                                innerHTML: h.content
                                            }, null, 8, YC)) : ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("span", JC, (0, $3ZJCa.toDisplayString)(h.content), 1))
                                        ];
                                    }),
                                    h.showArrow ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(sC), {
                                        key: 0,
                                        "arrow-offset": h.arrowOffset
                                    }, null, 8, [
                                        "arrow-offset"
                                    ])) : (0, $8B0Dy.createCommentVNode)("v-if", !0)
                                ];
                            }),
                            _: 3
                        }, 8, [
                            "aria-label",
                            "boundaries-padding",
                            "content",
                            "disabled",
                            "effect",
                            "enterable",
                            "fallback-placements",
                            "hide-after",
                            "gpu-acceleration",
                            "offset",
                            "persistent",
                            "popper-class",
                            "popper-style",
                            "placement",
                            "popper-options",
                            "pure",
                            "raw-content",
                            "reference-el",
                            "trigger-target-el",
                            "show-after",
                            "strategy",
                            "teleported",
                            "transition",
                            "virtual-triggering",
                            "z-index",
                            "append-to"
                        ])
                    ];
                }),
                _: 3
            }, 8, [
                "role"
            ]);
        };
    }
}));
var t6 = /* @__PURE__ */ Ce(e6, [
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/tooltip/src/tooltip.vue"
    ]
]);
var oo = jt(t6), Hh = Symbol("buttonGroupContextKey"), n6 = function(e, t) {
    mh({
        from: "type.text",
        replacement: "link",
        version: "3.0.0",
        scope: "props",
        ref: "https://element-plus.org/en-US/component/button.html#button-attributes"
    }, (0, $5wB2C.computed)(function() {
        return e.type === "text";
    }));
    var n = (0, $8B0Dy.inject)(Hh, void 0), r = kx("button"), _ys = ys(), s = _ys.form, o = po((0, $5wB2C.computed)(function() {
        return n == null ? void 0 : n.size;
    })), i = bs(), a = (0, $5wB2C.ref)(), c = (0, $8B0Dy.useSlots)(), u = (0, $5wB2C.computed)(function() {
        return e.type || (n == null ? void 0 : n.type) || "";
    }), d = (0, $5wB2C.computed)(function() {
        var v, g, b;
        return (b = (g = e.autoInsertSpace) != null ? g : (v = r.value) == null ? void 0 : v.autoInsertSpace) != null ? b : !1;
    }), l = (0, $5wB2C.computed)(function() {
        return e.tag === "button" ? {
            ariaDisabled: i.value || e.loading,
            disabled: i.value || e.loading,
            autofocus: e.autofocus,
            type: e.nativeType
        } : {};
    }), m = (0, $5wB2C.computed)(function() {
        var v;
        var g = (v = c["default"]) == null ? void 0 : v.call(c);
        if (d.value && (g == null ? void 0 : g.length) === 1) {
            var b = g[0];
            if ((b == null ? void 0 : b.type) === (0, $8B0Dy.Text)) {
                var h = b.children;
                return new RegExp("^\\p{Unified_Ideograph}{2}$", "u").test(h.trim());
            }
        }
        return !1;
    });
    return {
        _disabled: i,
        _size: o,
        _type: u,
        _ref: a,
        _props: l,
        shouldAddSpace: m,
        handleClick: function(v) {
            e.nativeType === "reset" && (s == null || s.resetFields()), t("click", v);
        }
    };
}, r6 = [
    "default",
    "primary",
    "success",
    "warning",
    "info",
    "danger",
    "text",
    ""
], o6 = [
    "button",
    "submit",
    "reset"
], Ac = Re({
    size: vl,
    disabled: Boolean,
    type: {
        type: String,
        values: r6,
        "default": ""
    },
    icon: {
        type: en
    },
    nativeType: {
        type: String,
        values: o6,
        "default": "button"
    },
    loading: Boolean,
    loadingIcon: {
        type: en,
        "default": function() {
            return fh;
        }
    },
    plain: Boolean,
    text: Boolean,
    link: Boolean,
    bg: Boolean,
    autofocus: Boolean,
    round: Boolean,
    circle: Boolean,
    color: String,
    dark: Boolean,
    autoInsertSpace: {
        type: Boolean,
        "default": void 0
    },
    tag: {
        type: be([
            String,
            Object
        ]),
        "default": "button"
    }
}), s6 = {
    click: function(e) {
        return e instanceof MouseEvent;
    }
};
function ct(e, t) {
    i6(e) && (e = "100%");
    var n = a6(e);
    return e = t === 360 ? e : Math.min(t, Math.max(0, parseFloat(e))), n && (e = parseInt(String(e * t), 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : (t === 360 ? e = (e < 0 ? e % t + t : e % t) / parseFloat(String(t)) : e = e % t / parseFloat(String(t)), e);
}
function Eo(e) {
    return Math.min(1, Math.max(0, e));
}
function i6(e) {
    return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function a6(e) {
    return typeof e == "string" && e.indexOf("%") !== -1;
}
function jh(e) {
    return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function Ao(e) {
    return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function Kn(e) {
    return e.length === 1 ? "0" + e : String(e);
}
function c6(e, t, n) {
    return {
        r: ct(e, 255) * 255,
        g: ct(t, 255) * 255,
        b: ct(n, 255) * 255
    };
}
function id(e, t, n) {
    e = ct(e, 255), t = ct(t, 255), n = ct(n, 255);
    var r = Math.max(e, t, n), s = Math.min(e, t, n), o = 0, i = 0, a = (r + s) / 2;
    if (r === s) i = 0, o = 0;
    else {
        var c = r - s;
        switch(i = a > 0.5 ? c / (2 - r - s) : c / (r + s), r){
            case e:
                o = (t - n) / c + (t < n ? 6 : 0);
                break;
            case t:
                o = (n - e) / c + 2;
                break;
            case n:
                o = (e - t) / c + 4;
                break;
        }
        o /= 6;
    }
    return {
        h: o,
        s: i,
        l: a
    };
}
function Vs(e, t, n) {
    return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * (6 * n) : n < 0.5 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function l6(e, t, n) {
    var r, s, o;
    if (e = ct(e, 360), t = ct(t, 100), n = ct(n, 100), t === 0) s = n, o = n, r = n;
    else {
        var i = n < 0.5 ? n * (1 + t) : n + t - n * t, a = 2 * n - i;
        r = Vs(a, i, e + 1 / 3), s = Vs(a, i, e), o = Vs(a, i, e - 1 / 3);
    }
    return {
        r: r * 255,
        g: s * 255,
        b: o * 255
    };
}
function ad(e, t, n) {
    e = ct(e, 255), t = ct(t, 255), n = ct(n, 255);
    var r = Math.max(e, t, n), s = Math.min(e, t, n), o = 0, i = r, a = r - s, c = r === 0 ? 0 : a / r;
    if (r === s) o = 0;
    else {
        switch(r){
            case e:
                o = (t - n) / a + (t < n ? 6 : 0);
                break;
            case t:
                o = (n - e) / a + 2;
                break;
            case n:
                o = (e - t) / a + 4;
                break;
        }
        o /= 6;
    }
    return {
        h: o,
        s: c,
        v: i
    };
}
function u6(e, t, n) {
    e = ct(e, 360) * 6, t = ct(t, 100), n = ct(n, 100);
    var r = Math.floor(e), s = e - r, o = n * (1 - t), i = n * (1 - s * t), a = n * (1 - (1 - s) * t), c = r % 6, u = [
        n,
        i,
        o,
        o,
        a,
        n
    ][c], d = [
        a,
        n,
        n,
        i,
        o,
        o
    ][c], l = [
        o,
        o,
        a,
        n,
        n,
        i
    ][c];
    return {
        r: u * 255,
        g: d * 255,
        b: l * 255
    };
}
function cd(e, t, n, r) {
    var s = [
        Kn(Math.round(e).toString(16)),
        Kn(Math.round(t).toString(16)),
        Kn(Math.round(n).toString(16))
    ];
    return r && s[0].startsWith(s[0].charAt(1)) && s[1].startsWith(s[1].charAt(1)) && s[2].startsWith(s[2].charAt(1)) ? s[0].charAt(0) + s[1].charAt(0) + s[2].charAt(0) : s.join("");
}
function d6(e, t, n, r, s) {
    var o = [
        Kn(Math.round(e).toString(16)),
        Kn(Math.round(t).toString(16)),
        Kn(Math.round(n).toString(16)),
        Kn(f6(r))
    ];
    return s && o[0].startsWith(o[0].charAt(1)) && o[1].startsWith(o[1].charAt(1)) && o[2].startsWith(o[2].charAt(1)) && o[3].startsWith(o[3].charAt(1)) ? o[0].charAt(0) + o[1].charAt(0) + o[2].charAt(0) + o[3].charAt(0) : o.join("");
}
function f6(e) {
    return Math.round(parseFloat(e) * 255).toString(16);
}
function ld(e) {
    return It(e) / 255;
}
function It(e) {
    return parseInt(e, 16);
}
function p6(e) {
    return {
        r: e >> 16,
        g: (e & 65280) >> 8,
        b: e & 255
    };
}
var $c = {
    aliceblue: "#f0f8ff",
    antiquewhite: "#faebd7",
    aqua: "#00ffff",
    aquamarine: "#7fffd4",
    azure: "#f0ffff",
    beige: "#f5f5dc",
    bisque: "#ffe4c4",
    black: "#000000",
    blanchedalmond: "#ffebcd",
    blue: "#0000ff",
    blueviolet: "#8a2be2",
    brown: "#a52a2a",
    burlywood: "#deb887",
    cadetblue: "#5f9ea0",
    chartreuse: "#7fff00",
    chocolate: "#d2691e",
    coral: "#ff7f50",
    cornflowerblue: "#6495ed",
    cornsilk: "#fff8dc",
    crimson: "#dc143c",
    cyan: "#00ffff",
    darkblue: "#00008b",
    darkcyan: "#008b8b",
    darkgoldenrod: "#b8860b",
    darkgray: "#a9a9a9",
    darkgreen: "#006400",
    darkgrey: "#a9a9a9",
    darkkhaki: "#bdb76b",
    darkmagenta: "#8b008b",
    darkolivegreen: "#556b2f",
    darkorange: "#ff8c00",
    darkorchid: "#9932cc",
    darkred: "#8b0000",
    darksalmon: "#e9967a",
    darkseagreen: "#8fbc8f",
    darkslateblue: "#483d8b",
    darkslategray: "#2f4f4f",
    darkslategrey: "#2f4f4f",
    darkturquoise: "#00ced1",
    darkviolet: "#9400d3",
    deeppink: "#ff1493",
    deepskyblue: "#00bfff",
    dimgray: "#696969",
    dimgrey: "#696969",
    dodgerblue: "#1e90ff",
    firebrick: "#b22222",
    floralwhite: "#fffaf0",
    forestgreen: "#228b22",
    fuchsia: "#ff00ff",
    gainsboro: "#dcdcdc",
    ghostwhite: "#f8f8ff",
    goldenrod: "#daa520",
    gold: "#ffd700",
    gray: "#808080",
    green: "#008000",
    greenyellow: "#adff2f",
    grey: "#808080",
    honeydew: "#f0fff0",
    hotpink: "#ff69b4",
    indianred: "#cd5c5c",
    indigo: "#4b0082",
    ivory: "#fffff0",
    khaki: "#f0e68c",
    lavenderblush: "#fff0f5",
    lavender: "#e6e6fa",
    lawngreen: "#7cfc00",
    lemonchiffon: "#fffacd",
    lightblue: "#add8e6",
    lightcoral: "#f08080",
    lightcyan: "#e0ffff",
    lightgoldenrodyellow: "#fafad2",
    lightgray: "#d3d3d3",
    lightgreen: "#90ee90",
    lightgrey: "#d3d3d3",
    lightpink: "#ffb6c1",
    lightsalmon: "#ffa07a",
    lightseagreen: "#20b2aa",
    lightskyblue: "#87cefa",
    lightslategray: "#778899",
    lightslategrey: "#778899",
    lightsteelblue: "#b0c4de",
    lightyellow: "#ffffe0",
    lime: "#00ff00",
    limegreen: "#32cd32",
    linen: "#faf0e6",
    magenta: "#ff00ff",
    maroon: "#800000",
    mediumaquamarine: "#66cdaa",
    mediumblue: "#0000cd",
    mediumorchid: "#ba55d3",
    mediumpurple: "#9370db",
    mediumseagreen: "#3cb371",
    mediumslateblue: "#7b68ee",
    mediumspringgreen: "#00fa9a",
    mediumturquoise: "#48d1cc",
    mediumvioletred: "#c71585",
    midnightblue: "#191970",
    mintcream: "#f5fffa",
    mistyrose: "#ffe4e1",
    moccasin: "#ffe4b5",
    navajowhite: "#ffdead",
    navy: "#000080",
    oldlace: "#fdf5e6",
    olive: "#808000",
    olivedrab: "#6b8e23",
    orange: "#ffa500",
    orangered: "#ff4500",
    orchid: "#da70d6",
    palegoldenrod: "#eee8aa",
    palegreen: "#98fb98",
    paleturquoise: "#afeeee",
    palevioletred: "#db7093",
    papayawhip: "#ffefd5",
    peachpuff: "#ffdab9",
    peru: "#cd853f",
    pink: "#ffc0cb",
    plum: "#dda0dd",
    powderblue: "#b0e0e6",
    purple: "#800080",
    rebeccapurple: "#663399",
    red: "#ff0000",
    rosybrown: "#bc8f8f",
    royalblue: "#4169e1",
    saddlebrown: "#8b4513",
    salmon: "#fa8072",
    sandybrown: "#f4a460",
    seagreen: "#2e8b57",
    seashell: "#fff5ee",
    sienna: "#a0522d",
    silver: "#c0c0c0",
    skyblue: "#87ceeb",
    slateblue: "#6a5acd",
    slategray: "#708090",
    slategrey: "#708090",
    snow: "#fffafa",
    springgreen: "#00ff7f",
    steelblue: "#4682b4",
    tan: "#d2b48c",
    teal: "#008080",
    thistle: "#d8bfd8",
    tomato: "#ff6347",
    turquoise: "#40e0d0",
    violet: "#ee82ee",
    wheat: "#f5deb3",
    white: "#ffffff",
    whitesmoke: "#f5f5f5",
    yellow: "#ffff00",
    yellowgreen: "#9acd32"
};
function h6(e) {
    var t = {
        r: 0,
        g: 0,
        b: 0
    }, n = 1, r = null, s = null, o = null, i = !1, a = !1;
    return typeof e == "string" && (e = v6(e)), (typeof e === "undefined" ? "undefined" : (0, $6gBIz._)(e)) == "object" && (pn(e.r) && pn(e.g) && pn(e.b) ? (t = c6(e.r, e.g, e.b), i = !0, a = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : pn(e.h) && pn(e.s) && pn(e.v) ? (r = Ao(e.s), s = Ao(e.v), t = u6(e.h, r, s), i = !0, a = "hsv") : pn(e.h) && pn(e.s) && pn(e.l) && (r = Ao(e.s), o = Ao(e.l), t = l6(e.h, r, o), i = !0, a = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (n = e.a)), n = jh(n), {
        ok: i,
        format: e.format || a,
        r: Math.min(255, Math.max(t.r, 0)),
        g: Math.min(255, Math.max(t.g, 0)),
        b: Math.min(255, Math.max(t.b, 0)),
        a: n
    };
}
var g6 = "[-\\+]?\\d+%?", m6 = "[-\\+]?\\d*\\.\\d+%?", Rn = "(?:".concat(m6, ")|(?:").concat(g6, ")"), Zs = "[\\s|\\(]+(".concat(Rn, ")[,|\\s]+(").concat(Rn, ")[,|\\s]+(").concat(Rn, ")\\s*\\)?"), Ws = "[\\s|\\(]+(".concat(Rn, ")[,|\\s]+(").concat(Rn, ")[,|\\s]+(").concat(Rn, ")[,|\\s]+(").concat(Rn, ")\\s*\\)?"), Kt = {
    CSS_UNIT: new RegExp(Rn),
    rgb: new RegExp("rgb" + Zs),
    rgba: new RegExp("rgba" + Ws),
    hsl: new RegExp("hsl" + Zs),
    hsla: new RegExp("hsla" + Ws),
    hsv: new RegExp("hsv" + Zs),
    hsva: new RegExp("hsva" + Ws),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function v6(e) {
    if (e = e.trim().toLowerCase(), e.length === 0) return !1;
    var t = !1;
    if ($c[e]) e = $c[e], t = !0;
    else if (e === "transparent") return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
    };
    var n = Kt.rgb.exec(e);
    return n ? {
        r: n[1],
        g: n[2],
        b: n[3]
    } : (n = Kt.rgba.exec(e), n ? {
        r: n[1],
        g: n[2],
        b: n[3],
        a: n[4]
    } : (n = Kt.hsl.exec(e), n ? {
        h: n[1],
        s: n[2],
        l: n[3]
    } : (n = Kt.hsla.exec(e), n ? {
        h: n[1],
        s: n[2],
        l: n[3],
        a: n[4]
    } : (n = Kt.hsv.exec(e), n ? {
        h: n[1],
        s: n[2],
        v: n[3]
    } : (n = Kt.hsva.exec(e), n ? {
        h: n[1],
        s: n[2],
        v: n[3],
        a: n[4]
    } : (n = Kt.hex8.exec(e), n ? {
        r: It(n[1]),
        g: It(n[2]),
        b: It(n[3]),
        a: ld(n[4]),
        format: t ? "name" : "hex8"
    } : (n = Kt.hex6.exec(e), n ? {
        r: It(n[1]),
        g: It(n[2]),
        b: It(n[3]),
        format: t ? "name" : "hex"
    } : (n = Kt.hex4.exec(e), n ? {
        r: It(n[1] + n[1]),
        g: It(n[2] + n[2]),
        b: It(n[3] + n[3]),
        a: ld(n[4] + n[4]),
        format: t ? "name" : "hex8"
    } : (n = Kt.hex3.exec(e), n ? {
        r: It(n[1] + n[1]),
        g: It(n[2] + n[2]),
        b: It(n[3] + n[3]),
        format: t ? "name" : "hex"
    } : !1)))))))));
}
function pn(e) {
    return !!Kt.CSS_UNIT.exec(String(e));
}
var _6 = /** @class */ function() {
    function e(t, n) {
        t === void 0 && (t = ""), n === void 0 && (n = {});
        var r;
        if (t instanceof e) return t;
        typeof t == "number" && (t = p6(t)), this.originalInput = t;
        var s = h6(t);
        this.originalInput = t, this.r = s.r, this.g = s.g, this.b = s.b, this.a = s.a, this.roundA = Math.round(100 * this.a) / 100, this.format = (r = n.format) !== null && r !== void 0 ? r : s.format, this.gradientType = n.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = s.ok;
    }
    return e.prototype.isDark = function() {
        return this.getBrightness() < 128;
    }, e.prototype.isLight = function() {
        return !this.isDark();
    }, e.prototype.getBrightness = function() {
        var t = this.toRgb();
        return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
    }, e.prototype.getLuminance = function() {
        var t = this.toRgb(), n, r, s, o = t.r / 255, i = t.g / 255, a = t.b / 255;
        return o <= 0.03928 ? n = o / 12.92 : n = Math.pow((o + 0.055) / 1.055, 2.4), i <= 0.03928 ? r = i / 12.92 : r = Math.pow((i + 0.055) / 1.055, 2.4), a <= 0.03928 ? s = a / 12.92 : s = Math.pow((a + 0.055) / 1.055, 2.4), 0.2126 * n + 0.7152 * r + 0.0722 * s;
    }, e.prototype.getAlpha = function() {
        return this.a;
    }, e.prototype.setAlpha = function(t) {
        return this.a = jh(t), this.roundA = Math.round(100 * this.a) / 100, this;
    }, e.prototype.isMonochrome = function() {
        var t = this.toHsl().s;
        return t === 0;
    }, e.prototype.toHsv = function() {
        var t = ad(this.r, this.g, this.b);
        return {
            h: t.h * 360,
            s: t.s,
            v: t.v,
            a: this.a
        };
    }, e.prototype.toHsvString = function() {
        var t = ad(this.r, this.g, this.b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), s = Math.round(t.v * 100);
        return this.a === 1 ? "hsv(".concat(n, ", ").concat(r, "%, ").concat(s, "%)") : "hsva(".concat(n, ", ").concat(r, "%, ").concat(s, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHsl = function() {
        var t = id(this.r, this.g, this.b);
        return {
            h: t.h * 360,
            s: t.s,
            l: t.l,
            a: this.a
        };
    }, e.prototype.toHslString = function() {
        var t = id(this.r, this.g, this.b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), s = Math.round(t.l * 100);
        return this.a === 1 ? "hsl(".concat(n, ", ").concat(r, "%, ").concat(s, "%)") : "hsla(".concat(n, ", ").concat(r, "%, ").concat(s, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHex = function(t) {
        return t === void 0 && (t = !1), cd(this.r, this.g, this.b, t);
    }, e.prototype.toHexString = function(t) {
        return t === void 0 && (t = !1), "#" + this.toHex(t);
    }, e.prototype.toHex8 = function(t) {
        return t === void 0 && (t = !1), d6(this.r, this.g, this.b, this.a, t);
    }, e.prototype.toHex8String = function(t) {
        return t === void 0 && (t = !1), "#" + this.toHex8(t);
    }, e.prototype.toHexShortString = function(t) {
        return t === void 0 && (t = !1), this.a === 1 ? this.toHexString(t) : this.toHex8String(t);
    }, e.prototype.toRgb = function() {
        return {
            r: Math.round(this.r),
            g: Math.round(this.g),
            b: Math.round(this.b),
            a: this.a
        };
    }, e.prototype.toRgbString = function() {
        var t = Math.round(this.r), n = Math.round(this.g), r = Math.round(this.b);
        return this.a === 1 ? "rgb(".concat(t, ", ").concat(n, ", ").concat(r, ")") : "rgba(".concat(t, ", ").concat(n, ", ").concat(r, ", ").concat(this.roundA, ")");
    }, e.prototype.toPercentageRgb = function() {
        var t = function t(n) {
            return "".concat(Math.round(ct(n, 255) * 100), "%");
        };
        return {
            r: t(this.r),
            g: t(this.g),
            b: t(this.b),
            a: this.a
        };
    }, e.prototype.toPercentageRgbString = function() {
        var t = function t(n) {
            return Math.round(ct(n, 255) * 100);
        };
        return this.a === 1 ? "rgb(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%)") : "rgba(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%, ").concat(this.roundA, ")");
    }, e.prototype.toName = function() {
        if (this.a === 0) return "transparent";
        if (this.a < 1) return !1;
        for(var t = "#" + cd(this.r, this.g, this.b, !1), n = 0, r = Object.entries($c); n < r.length; n++){
            var s = r[n], o = s[0], i = s[1];
            if (t === i) return o;
        }
        return !1;
    }, e.prototype.toString = function(t) {
        var n = !!t;
        t = t !== null && t !== void 0 ? t : this.format;
        var r = !1, s = this.a < 1 && this.a >= 0, o = !n && s && (t.startsWith("hex") || t === "name");
        return o ? t === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (r = this.toRgbString()), t === "prgb" && (r = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (r = this.toHexString()), t === "hex3" && (r = this.toHexString(!0)), t === "hex4" && (r = this.toHex8String(!0)), t === "hex8" && (r = this.toHex8String()), t === "name" && (r = this.toName()), t === "hsl" && (r = this.toHslString()), t === "hsv" && (r = this.toHsvString()), r || this.toHexString());
    }, e.prototype.toNumber = function() {
        return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }, e.prototype.clone = function() {
        return new e(this.toString());
    }, e.prototype.lighten = function(t) {
        t === void 0 && (t = 10);
        var n = this.toHsl();
        return n.l += t / 100, n.l = Eo(n.l), new e(n);
    }, e.prototype.brighten = function(t) {
        t === void 0 && (t = 10);
        var n = this.toRgb();
        return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(t / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(t / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(t / 100)))), new e(n);
    }, e.prototype.darken = function(t) {
        t === void 0 && (t = 10);
        var n = this.toHsl();
        return n.l -= t / 100, n.l = Eo(n.l), new e(n);
    }, e.prototype.tint = function(t) {
        return t === void 0 && (t = 10), this.mix("white", t);
    }, e.prototype.shade = function(t) {
        return t === void 0 && (t = 10), this.mix("black", t);
    }, e.prototype.desaturate = function(t) {
        t === void 0 && (t = 10);
        var n = this.toHsl();
        return n.s -= t / 100, n.s = Eo(n.s), new e(n);
    }, e.prototype.saturate = function(t) {
        t === void 0 && (t = 10);
        var n = this.toHsl();
        return n.s += t / 100, n.s = Eo(n.s), new e(n);
    }, e.prototype.greyscale = function() {
        return this.desaturate(100);
    }, e.prototype.spin = function(t) {
        var n = this.toHsl(), r = (n.h + t) % 360;
        return n.h = r < 0 ? 360 + r : r, new e(n);
    }, e.prototype.mix = function(t, n) {
        n === void 0 && (n = 50);
        var r = this.toRgb(), s = new e(t).toRgb(), o = n / 100, i = {
            r: (s.r - r.r) * o + r.r,
            g: (s.g - r.g) * o + r.g,
            b: (s.b - r.b) * o + r.b,
            a: (s.a - r.a) * o + r.a
        };
        return new e(i);
    }, e.prototype.analogous = function(t, n) {
        t === void 0 && (t = 6), n === void 0 && (n = 30);
        var r = this.toHsl(), s = 360 / n, o = [
            this
        ];
        for(r.h = (r.h - (s * t >> 1) + 720) % 360; --t;)r.h = (r.h + s) % 360, o.push(new e(r));
        return o;
    }, e.prototype.complement = function() {
        var t = this.toHsl();
        return t.h = (t.h + 180) % 360, new e(t);
    }, e.prototype.monochromatic = function(t) {
        t === void 0 && (t = 6);
        for(var n = this.toHsv(), r = n.h, s = n.s, o = n.v, i = [], a = 1 / t; t--;)i.push(new e({
            h: r,
            s: s,
            v: o
        })), o = (o + a) % 1;
        return i;
    }, e.prototype.splitcomplement = function() {
        var t = this.toHsl(), n = t.h;
        return [
            this,
            new e({
                h: (n + 72) % 360,
                s: t.s,
                l: t.l
            }),
            new e({
                h: (n + 216) % 360,
                s: t.s,
                l: t.l
            })
        ];
    }, e.prototype.onBackground = function(t) {
        var n = this.toRgb(), r = new e(t).toRgb(), s = n.a + r.a * (1 - n.a);
        return new e({
            r: (n.r * n.a + r.r * r.a * (1 - n.a)) / s,
            g: (n.g * n.a + r.g * r.a * (1 - n.a)) / s,
            b: (n.b * n.a + r.b * r.a * (1 - n.a)) / s,
            a: s
        });
    }, e.prototype.triad = function() {
        return this.polyad(3);
    }, e.prototype.tetrad = function() {
        return this.polyad(4);
    }, e.prototype.polyad = function(t) {
        for(var n = this.toHsl(), r = n.h, s = [
            this
        ], o = 360 / t, i = 1; i < t; i++)s.push(new e({
            h: (r + i * o) % 360,
            s: n.s,
            l: n.l
        }));
        return s;
    }, e.prototype.equals = function(t) {
        return this.toRgbString() === new e(t).toRgbString();
    }, e;
}();
function Mn(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 20;
    return e.mix("#141414", t).toString();
}
function b6(e) {
    var t = bs(), n = Te("button");
    return (0, $5wB2C.computed)(function() {
        var r = {};
        var s = e.color;
        if (s) {
            var o = new _6(s), i = e.dark ? o.tint(20).toString() : Mn(o, 20);
            if (e.plain) r = n.cssVarBlock({
                "bg-color": e.dark ? Mn(o, 90) : o.tint(90).toString(),
                "text-color": s,
                "border-color": e.dark ? Mn(o, 50) : o.tint(50).toString(),
                "hover-text-color": "var(".concat(n.cssVarName("color-white"), ")"),
                "hover-bg-color": s,
                "hover-border-color": s,
                "active-bg-color": i,
                "active-text-color": "var(".concat(n.cssVarName("color-white"), ")"),
                "active-border-color": i
            }), t.value && (r[n.cssVarBlockName("disabled-bg-color")] = e.dark ? Mn(o, 90) : o.tint(90).toString(), r[n.cssVarBlockName("disabled-text-color")] = e.dark ? Mn(o, 50) : o.tint(50).toString(), r[n.cssVarBlockName("disabled-border-color")] = e.dark ? Mn(o, 80) : o.tint(80).toString());
            else {
                var a = e.dark ? Mn(o, 30) : o.tint(30).toString(), c = o.isDark() ? "var(".concat(n.cssVarName("color-white"), ")") : "var(".concat(n.cssVarName("color-black"), ")");
                if (r = n.cssVarBlock({
                    "bg-color": s,
                    "text-color": c,
                    "border-color": s,
                    "hover-bg-color": a,
                    "hover-text-color": c,
                    "hover-border-color": a,
                    "active-bg-color": i,
                    "active-border-color": i
                }), t.value) {
                    var u = e.dark ? Mn(o, 50) : o.tint(50).toString();
                    r[n.cssVarBlockName("disabled-bg-color")] = u, r[n.cssVarBlockName("disabled-text-color")] = e.dark ? "rgba(255, 255, 255, 0.5)" : "var(".concat(n.cssVarName("color-white"), ")"), r[n.cssVarBlockName("disabled-border-color")] = u;
                }
            }
        }
        return r;
    });
}
var y6 = (0, $8B0Dy.defineComponent)({
    name: "ElButton"
}), w6 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)((0, $bnFl0._)((0, $6869c._)({}, y6), {
    props: Ac,
    emits: s6,
    setup: function(e, param) {
        var t = param.expose, n = param.emit;
        var r = e, s = b6(r), o = Te("button"), _n6 = n6(r, n), i = _n6._ref, a = _n6._size, c = _n6._type, u = _n6._disabled, d = _n6._props, l = _n6.shouldAddSpace, m = _n6.handleClick;
        return t({
            ref: i,
            size: a,
            type: c,
            disabled: u,
            shouldAddSpace: l
        }), function(f, v) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $8B0Dy.resolveDynamicComponent)(f.tag), (0, $8B0Dy.mergeProps)({
                ref_key: "_ref",
                ref: i
            }, (0, $5wB2C.unref)(d), {
                "class": [
                    (0, $5wB2C.unref)(o).b(),
                    (0, $5wB2C.unref)(o).m((0, $5wB2C.unref)(c)),
                    (0, $5wB2C.unref)(o).m((0, $5wB2C.unref)(a)),
                    (0, $5wB2C.unref)(o).is("disabled", (0, $5wB2C.unref)(u)),
                    (0, $5wB2C.unref)(o).is("loading", f.loading),
                    (0, $5wB2C.unref)(o).is("plain", f.plain),
                    (0, $5wB2C.unref)(o).is("round", f.round),
                    (0, $5wB2C.unref)(o).is("circle", f.circle),
                    (0, $5wB2C.unref)(o).is("text", f.text),
                    (0, $5wB2C.unref)(o).is("link", f.link),
                    (0, $5wB2C.unref)(o).is("has-bg", f.bg)
                ],
                style: (0, $5wB2C.unref)(s),
                onClick: (0, $5wB2C.unref)(m)
            }), {
                "default": (0, $8B0Dy.withCtx)(function() {
                    return [
                        f.loading ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)((0, $8B0Dy.Fragment), {
                            key: 0
                        }, [
                            f.$slots.loading ? (0, $8B0Dy.renderSlot)(f.$slots, "loading", {
                                key: 0
                            }) : ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(kt), {
                                key: 1,
                                "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(o).is("loading"))
                            }, {
                                "default": (0, $8B0Dy.withCtx)(function() {
                                    return [
                                        ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $8B0Dy.resolveDynamicComponent)(f.loadingIcon)))
                                    ];
                                }),
                                _: 1
                            }, 8, [
                                "class"
                            ]))
                        ], 64)) : f.icon || f.$slots.icon ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(kt), {
                            key: 1
                        }, {
                            "default": (0, $8B0Dy.withCtx)(function() {
                                return [
                                    f.icon ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $8B0Dy.resolveDynamicComponent)(f.icon), {
                                        key: 0
                                    })) : (0, $8B0Dy.renderSlot)(f.$slots, "icon", {
                                        key: 1
                                    })
                                ];
                            }),
                            _: 3
                        })) : (0, $8B0Dy.createCommentVNode)("v-if", !0),
                        f.$slots["default"] ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("span", {
                            key: 2,
                            "class": (0, $3ZJCa.normalizeClass)((0, $aRIHe._)({}, (0, $5wB2C.unref)(o).em("text", "expand"), (0, $5wB2C.unref)(l)))
                        }, [
                            (0, $8B0Dy.renderSlot)(f.$slots, "default")
                        ], 2)) : (0, $8B0Dy.createCommentVNode)("v-if", !0)
                    ];
                }),
                _: 3
            }, 16, [
                "class",
                "style",
                "onClick"
            ]);
        };
    }
}));
var k6 = /* @__PURE__ */ Ce(w6, [
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/button/src/button.vue"
    ]
]);
var x6 = {
    size: Ac.size,
    type: Ac.type
}, C6 = (0, $8B0Dy.defineComponent)({
    name: "ElButtonGroup"
}), S6 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)((0, $bnFl0._)((0, $6869c._)({}, C6), {
    props: x6,
    setup: function(e) {
        var t = e;
        (0, $8B0Dy.provide)(Hh, (0, $5wB2C.reactive)({
            size: (0, $5wB2C.toRef)(t, "size"),
            type: (0, $5wB2C.toRef)(t, "type")
        }));
        var n = Te("button");
        return function(r, s) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
                "class": (0, $3ZJCa.normalizeClass)("".concat((0, $5wB2C.unref)(n).b("group")))
            }, [
                (0, $8B0Dy.renderSlot)(r.$slots, "default")
            ], 2);
        };
    }
}));
var Uh = /* @__PURE__ */ Ce(S6, [
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/button/src/button-group.vue"
    ]
]);
var ud = jt(k6, {
    ButtonGroup: Uh
});
gs(Uh);
var Tn = /* @__PURE__ */ new Map();
var dd;
gt && (document.addEventListener("mousedown", function(e) {
    return dd = e;
}), document.addEventListener("mouseup", function(e) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator = Tn.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
            var t = _step.value;
            try {
                for(var _iterator1 = t[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = _step1.value, n = _step_value.documentHandler;
                    n(e, dd);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1["return"] != null) {
                        _iterator1["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
}));
function fd(e, t) {
    var n = [];
    return Array.isArray(t.arg) ? n = t.arg : eo(t.arg) && n.push(t.arg), function(r, s) {
        var o = t.instance.popperRef, i = r.target, a = s == null ? void 0 : s.target, c = !t || !t.instance, u = !i || !a, d = e.contains(i) || e.contains(a), l = e === i, m = n.length && n.some(function(v) {
            return v == null ? void 0 : v.contains(i);
        }) || n.length && n.includes(a), f = o && (o.contains(i) || o.contains(a));
        c || u || d || l || m || f || t.value(r, s);
    };
}
var Vh = {
    beforeMount: function(e, t) {
        Tn.has(e) || Tn.set(e, []), Tn.get(e).push({
            documentHandler: fd(e, t),
            bindingFn: t.value
        });
    },
    updated: function(e, t) {
        Tn.has(e) || Tn.set(e, []);
        var n = Tn.get(e), r = n.findIndex(function(o) {
            return o.bindingFn === t.oldValue;
        }), s = {
            documentHandler: fd(e, t),
            bindingFn: t.value
        };
        r >= 0 ? n.splice(r, 1, s) : n.push(s);
    },
    unmounted: function(e) {
        Tn["delete"](e);
    }
}, Zh = Re({
    type: {
        type: String,
        values: [
            "success",
            "info",
            "warning",
            "danger",
            ""
        ],
        "default": ""
    },
    closable: Boolean,
    disableTransitions: Boolean,
    hit: Boolean,
    color: {
        type: String,
        "default": ""
    },
    size: {
        type: String,
        values: lo,
        "default": ""
    },
    effect: {
        type: String,
        values: [
            "dark",
            "light",
            "plain"
        ],
        "default": "light"
    },
    round: Boolean
}), E6 = {
    close: function(e) {
        return e instanceof MouseEvent;
    },
    click: function(e) {
        return e instanceof MouseEvent;
    }
}, A6 = (0, $8B0Dy.defineComponent)({
    name: "ElTag"
}), $6 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)((0, $bnFl0._)((0, $6869c._)({}, A6), {
    props: Zh,
    emits: E6,
    setup: function(e, param) {
        var t = param.emit;
        var n = e, r = po(), s = Te("tag"), o = (0, $5wB2C.computed)(function() {
            var c = n.type, u = n.hit, d = n.effect, l = n.closable, m = n.round;
            return [
                s.b(),
                s.is("closable", l),
                s.m(c),
                s.m(r.value),
                s.m(d),
                s.is("hit", u),
                s.is("round", m)
            ];
        }), i = function(c) {
            t("close", c);
        }, a = function(c) {
            t("click", c);
        };
        return function(c, u) {
            return c.disableTransitions ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("span", {
                key: 0,
                "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(o)),
                style: (0, $3ZJCa.normalizeStyle)({
                    backgroundColor: c.color
                }),
                onClick: a
            }, [
                (0, $8B0Dy.createElementVNode)("span", {
                    "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(s).e("content"))
                }, [
                    (0, $8B0Dy.renderSlot)(c.$slots, "default")
                ], 2),
                c.closable ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(kt), {
                    key: 0,
                    "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(s).e("close")),
                    onClick: (0, $kRi7Z.withModifiers)(i, [
                        "stop"
                    ])
                }, {
                    "default": (0, $8B0Dy.withCtx)(function() {
                        return [
                            (0, $8B0Dy.createVNode)((0, $5wB2C.unref)(Sc))
                        ];
                    }),
                    _: 1
                }, 8, [
                    "class",
                    "onClick"
                ])) : (0, $8B0Dy.createCommentVNode)("v-if", !0)
            ], 6)) : ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $kRi7Z.Transition), {
                key: 1,
                name: "".concat((0, $5wB2C.unref)(s).namespace.value, "-zoom-in-center"),
                appear: ""
            }, {
                "default": (0, $8B0Dy.withCtx)(function() {
                    return [
                        (0, $8B0Dy.createElementVNode)("span", {
                            "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(o)),
                            style: (0, $3ZJCa.normalizeStyle)({
                                backgroundColor: c.color
                            }),
                            onClick: a
                        }, [
                            (0, $8B0Dy.createElementVNode)("span", {
                                "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(s).e("content"))
                            }, [
                                (0, $8B0Dy.renderSlot)(c.$slots, "default")
                            ], 2),
                            c.closable ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(kt), {
                                key: 0,
                                "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(s).e("close")),
                                onClick: (0, $kRi7Z.withModifiers)(i, [
                                    "stop"
                                ])
                            }, {
                                "default": (0, $8B0Dy.withCtx)(function() {
                                    return [
                                        (0, $8B0Dy.createVNode)((0, $5wB2C.unref)(Sc))
                                    ];
                                }),
                                _: 1
                            }, 8, [
                                "class",
                                "onClick"
                            ])) : (0, $8B0Dy.createCommentVNode)("v-if", !0)
                        ], 6)
                    ];
                }),
                _: 3
            }, 8, [
                "name"
            ]));
        };
    }
}));
var M6 = /* @__PURE__ */ Ce($6, [
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/tag/src/tag.vue"
    ]
]);
var I6 = jt(M6), T6 = Re({
    color: {
        type: be(Object),
        required: !0
    },
    vertical: {
        type: Boolean,
        "default": !1
    }
});
var Gs = !1;
function so(e, t) {
    if (!gt) return;
    var n = function n(o) {
        var i;
        (i = t.drag) == null || i.call(t, o);
    }, r = function r1(o) {
        var i;
        document.removeEventListener("mousemove", n), document.removeEventListener("mouseup", r), document.removeEventListener("touchmove", n), document.removeEventListener("touchend", r), document.onselectstart = null, document.ondragstart = null, Gs = !1, (i = t.end) == null || i.call(t, o);
    }, s = function s(o) {
        var i;
        Gs || (o.preventDefault(), document.onselectstart = function() {
            return !1;
        }, document.ondragstart = function() {
            return !1;
        }, document.addEventListener("mousemove", n), document.addEventListener("mouseup", r), document.addEventListener("touchmove", n), document.addEventListener("touchend", r), Gs = !0, (i = t.start) == null || i.call(t, o));
    };
    e.addEventListener("mousedown", s), e.addEventListener("touchstart", s);
}
var L6 = function(e) {
    var s = function s(i) {
        i.target !== n.value && o(i);
    };
    var o = function o(i) {
        if (!r.value || !n.value) return;
        var c = t.vnode.el.getBoundingClientRect(), _el = el(i), u = _el.clientX, d = _el.clientY;
        if (e.vertical) {
            var l = d - c.top;
            l = Math.max(n.value.offsetHeight / 2, l), l = Math.min(l, c.height - n.value.offsetHeight / 2), e.color.set("alpha", Math.round((l - n.value.offsetHeight / 2) / (c.height - n.value.offsetHeight) * 100));
        } else {
            var l1 = u - c.left;
            l1 = Math.max(n.value.offsetWidth / 2, l1), l1 = Math.min(l1, c.width - n.value.offsetWidth / 2), e.color.set("alpha", Math.round((l1 - n.value.offsetWidth / 2) / (c.width - n.value.offsetWidth) * 100));
        }
    };
    var t = (0, $8B0Dy.getCurrentInstance)(), n = (0, $5wB2C.shallowRef)(), r = (0, $5wB2C.shallowRef)();
    return {
        thumb: n,
        bar: r,
        handleDrag: o,
        handleClick: s
    };
}, O6 = function(e, param) {
    var t = param.bar, n = param.thumb, r = param.handleDrag;
    var u = function u() {
        if (!n.value || e.vertical) return 0;
        var w = s.vnode.el, k = e.color.get("alpha");
        return w ? Math.round(k * (w.offsetWidth - n.value.offsetWidth / 2) / 100) : 0;
    };
    var d = function d() {
        if (!n.value) return 0;
        var w = s.vnode.el;
        if (!e.vertical) return 0;
        var k = e.color.get("alpha");
        return w ? Math.round(k * (w.offsetHeight - n.value.offsetHeight / 2) / 100) : 0;
    };
    var l = function l() {
        if (e.color && e.color.value) {
            var _e_color_toRgb = e.color.toRgb(), w = _e_color_toRgb.r, k = _e_color_toRgb.g, x = _e_color_toRgb.b;
            return "linear-gradient(to right, rgba(".concat(w, ", ").concat(k, ", ").concat(x, ", 0) 0%, rgba(").concat(w, ", ").concat(k, ", ").concat(x, ", 1) 100%)");
        }
        return "";
    };
    var m = function m() {
        i.value = u(), a.value = d(), c.value = l();
    };
    var s = (0, $8B0Dy.getCurrentInstance)(), o = Te("color-alpha-slider"), i = (0, $5wB2C.ref)(0), a = (0, $5wB2C.ref)(0), c = (0, $5wB2C.ref)();
    (0, $8B0Dy.onMounted)(function() {
        if (!t.value || !n.value) return;
        var w = {
            drag: function(k) {
                r(k);
            },
            end: function(k) {
                r(k);
            }
        };
        so(t.value, w), so(n.value, w), m();
    }), (0, $5wB2C.watch)(function() {
        return e.color.get("alpha");
    }, function() {
        return m();
    }), (0, $5wB2C.watch)(function() {
        return e.color.value;
    }, function() {
        return m();
    });
    var f = (0, $5wB2C.computed)(function() {
        return [
            o.b(),
            o.is("vertical", e.vertical)
        ];
    }), v = (0, $5wB2C.computed)(function() {
        return o.e("bar");
    }), g = (0, $5wB2C.computed)(function() {
        return o.e("thumb");
    }), b = (0, $5wB2C.computed)(function() {
        return {
            background: c.value
        };
    }), h = (0, $5wB2C.computed)(function() {
        return {
            left: yr(i.value),
            top: yr(a.value)
        };
    });
    return {
        rootKls: f,
        barKls: v,
        barStyle: b,
        thumbKls: g,
        thumbStyle: h,
        update: m
    };
}, R6 = "ElColorAlphaSlider", P6 = (0, $8B0Dy.defineComponent)({
    name: R6
}), B6 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)((0, $bnFl0._)((0, $6869c._)({}, P6), {
    props: T6,
    setup: function(e, param) {
        var _this = this;
        var t = param.expose;
        var n = e, _L6 = L6(n), r = _L6.bar, s = _L6.thumb, o = _L6.handleDrag, i = _L6.handleClick, _O6 = O6(n, {
            bar: r,
            thumb: s,
            handleDrag: o
        }), a = _O6.rootKls, c = _O6.barKls, u = _O6.barStyle, d = _O6.thumbKls, l = _O6.thumbStyle, m = _O6.update;
        return t({
            update: m,
            bar: r,
            thumb: s
        }), function(f, v) {
            var _this1 = _this;
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
                "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(a))
            }, [
                (0, $8B0Dy.createElementVNode)("div", {
                    ref_key: "bar",
                    ref: r,
                    "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(c)),
                    style: (0, $3ZJCa.normalizeStyle)((0, $5wB2C.unref)(u)),
                    onClick: v[0] || (v[0] = function() {
                        for(var _len = arguments.length, g = new Array(_len), _key = 0; _key < _len; _key++){
                            g[_key] = arguments[_key];
                        }
                        return (0, $5wB2C.unref)(i) && (0, $5wB2C.unref)(i).apply(_this1, (0, $kf9Kn._)(g));
                    })
                }, null, 6),
                (0, $8B0Dy.createElementVNode)("div", {
                    ref_key: "thumb",
                    ref: s,
                    "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(d)),
                    style: (0, $3ZJCa.normalizeStyle)((0, $5wB2C.unref)(l))
                }, null, 6)
            ], 2);
        };
    }
}));
var z6 = /* @__PURE__ */ Ce(B6, [
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/color-picker/src/components/alpha-slider.vue"
    ]
]);
var D6 = (0, $8B0Dy.defineComponent)({
    name: "ElColorHueSlider",
    props: {
        color: {
            type: Object,
            required: !0
        },
        vertical: Boolean
    },
    setup: function(e) {
        var t = Te("color-hue-slider"), n = (0, $8B0Dy.getCurrentInstance)(), r = (0, $5wB2C.ref)(), s = (0, $5wB2C.ref)(), o = (0, $5wB2C.ref)(0), i = (0, $5wB2C.ref)(0), a = (0, $5wB2C.computed)(function() {
            return e.color.get("hue");
        });
        (0, $5wB2C.watch)(function() {
            return a.value;
        }, function() {
            m();
        });
        function c(f) {
            f.target !== r.value && u(f);
        }
        function u(f) {
            if (!s.value || !r.value) return;
            var g = n.vnode.el.getBoundingClientRect(), _el = el(f), b = _el.clientX, h = _el.clientY;
            var w;
            if (e.vertical) {
                var k = h - g.top;
                k = Math.min(k, g.height - r.value.offsetHeight / 2), k = Math.max(r.value.offsetHeight / 2, k), w = Math.round((k - r.value.offsetHeight / 2) / (g.height - r.value.offsetHeight) * 360);
            } else {
                var k1 = b - g.left;
                k1 = Math.min(k1, g.width - r.value.offsetWidth / 2), k1 = Math.max(r.value.offsetWidth / 2, k1), w = Math.round((k1 - r.value.offsetWidth / 2) / (g.width - r.value.offsetWidth) * 360);
            }
            e.color.set("hue", w);
        }
        function d() {
            if (!r.value) return 0;
            var f = n.vnode.el;
            if (e.vertical) return 0;
            var v = e.color.get("hue");
            return f ? Math.round(v * (f.offsetWidth - r.value.offsetWidth / 2) / 360) : 0;
        }
        function l() {
            if (!r.value) return 0;
            var f = n.vnode.el;
            if (!e.vertical) return 0;
            var v = e.color.get("hue");
            return f ? Math.round(v * (f.offsetHeight - r.value.offsetHeight / 2) / 360) : 0;
        }
        function m() {
            o.value = d(), i.value = l();
        }
        return (0, $8B0Dy.onMounted)(function() {
            if (!s.value || !r.value) return;
            var f = {
                drag: function(v) {
                    u(v);
                },
                end: function(v) {
                    u(v);
                }
            };
            so(s.value, f), so(r.value, f), m();
        }), {
            bar: s,
            thumb: r,
            thumbLeft: o,
            thumbTop: i,
            hueValue: a,
            handleClick: c,
            update: m,
            ns: t
        };
    }
});
function N6(e, t, n, r, s, o) {
    var _e;
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
        "class": (0, $3ZJCa.normalizeClass)([
            e.ns.b(),
            e.ns.is("vertical", e.vertical)
        ])
    }, [
        (0, $8B0Dy.createElementVNode)("div", {
            ref: "bar",
            "class": (0, $3ZJCa.normalizeClass)(e.ns.e("bar")),
            onClick: t[0] || (t[0] = function() {
                for(var _len = arguments.length, i = new Array(_len), _key = 0; _key < _len; _key++){
                    i[_key] = arguments[_key];
                }
                return e.handleClick && (_e = e).handleClick.apply(_e, (0, $kf9Kn._)(i));
            })
        }, null, 2),
        (0, $8B0Dy.createElementVNode)("div", {
            ref: "thumb",
            "class": (0, $3ZJCa.normalizeClass)(e.ns.e("thumb")),
            style: (0, $3ZJCa.normalizeStyle)({
                left: e.thumbLeft + "px",
                top: e.thumbTop + "px"
            })
        }, null, 6)
    ], 2);
}
var q6 = /* @__PURE__ */ Ce(D6, [
    [
        "render",
        N6
    ],
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/color-picker/src/components/hue-slider.vue"
    ]
]);
var _obj1;
var F6 = Re({
    modelValue: String,
    id: String,
    showAlpha: Boolean,
    colorFormat: String,
    disabled: Boolean,
    size: vl,
    popperClass: {
        type: String,
        "default": ""
    },
    label: {
        type: String,
        "default": void 0
    },
    tabindex: {
        type: [
            String,
            Number
        ],
        "default": 0
    },
    predefine: {
        type: be(Array)
    },
    validateEvent: {
        type: Boolean,
        "default": !0
    }
}), H6 = (_obj1 = {}, (0, $aRIHe._)(_obj1, wt, function(e) {
    return Yt(e) || Jn(e);
}), (0, $aRIHe._)(_obj1, il, function(e) {
    return Yt(e) || Jn(e);
}), (0, $aRIHe._)(_obj1, "activeChange", function(e) {
    return Yt(e) || Jn(e);
}), (0, $aRIHe._)(_obj1, "focus", function(e) {
    return e instanceof FocusEvent;
}), (0, $aRIHe._)(_obj1, "blur", function(e) {
    return e instanceof FocusEvent;
}), _obj1), Wh = Symbol("colorPickerContextKey"), pd = function pd(e, t, n) {
    return [
        e,
        t * n / ((e = (2 - t) * n) < 1 ? e : 2 - e) || 0,
        e / 2
    ];
}, j6 = function j6(e) {
    return typeof e == "string" && e.includes(".") && Number.parseFloat(e) === 1;
}, U6 = function U6(e) {
    return typeof e == "string" && e.includes("%");
}, gr = function gr(e, t) {
    j6(e) && (e = "100%");
    var n = U6(e);
    return e = Math.min(t, Math.max(0, Number.parseFloat("".concat(e)))), n && (e = Number.parseInt("".concat(e * t), 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : e % t / Number.parseFloat(t);
}, hd = {
    10: "A",
    11: "B",
    12: "C",
    13: "D",
    14: "E",
    15: "F"
}, Bo = function(e) {
    e = Math.min(Math.round(e), 255);
    var t = Math.floor(e / 16), n = e % 16;
    return "".concat(hd[t] || t).concat(hd[n] || n);
}, gd = function gd(param) {
    var e = param.r, t = param.g, n = param.b;
    return Number.isNaN(+e) || Number.isNaN(+t) || Number.isNaN(+n) ? "" : "#".concat(Bo(e)).concat(Bo(t)).concat(Bo(n));
}, Ks = {
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15
}, Zn = function Zn(e) {
    return e.length === 2 ? (Ks[e[0].toUpperCase()] || +e[0]) * 16 + (Ks[e[1].toUpperCase()] || +e[1]) : Ks[e[1].toUpperCase()] || +e[1];
}, V6 = function V6(e, t, n) {
    t = t / 100, n = n / 100;
    var r = t;
    var s = Math.max(n, 0.01);
    n *= 2, t *= n <= 1 ? n : 2 - n, r *= s <= 1 ? s : 2 - s;
    var o = (n + t) / 2, i = n === 0 ? 2 * r / (s + r) : 2 * t / (n + t);
    return {
        h: e,
        s: i * 100,
        v: o * 100
    };
}, md = function(e, t, n) {
    e = gr(e, 255), t = gr(t, 255), n = gr(n, 255);
    var r = Math.max(e, t, n), s = Math.min(e, t, n);
    var o;
    var i = r, a = r - s, c = r === 0 ? 0 : a / r;
    if (r === s) o = 0;
    else {
        switch(r){
            case e:
                o = (t - n) / a + (t < n ? 6 : 0);
                break;
            case t:
                o = (n - e) / a + 2;
                break;
            case n:
                o = (e - t) / a + 4;
                break;
        }
        o /= 6;
    }
    return {
        h: o * 360,
        s: c * 100,
        v: i * 100
    };
}, Dr = function Dr(e, t, n) {
    e = gr(e, 360) * 6, t = gr(t, 100), n = gr(n, 100);
    var r = Math.floor(e), s = e - r, o = n * (1 - t), i = n * (1 - s * t), a = n * (1 - (1 - s) * t), c = r % 6, u = [
        n,
        i,
        o,
        o,
        a,
        n
    ][c], d = [
        a,
        n,
        n,
        i,
        o,
        o
    ][c], l = [
        o,
        o,
        a,
        n,
        n,
        i
    ][c];
    return {
        r: Math.round(u * 255),
        g: Math.round(d * 255),
        b: Math.round(l * 255)
    };
};
var Zr = /*#__PURE__*/ function() {
    "use strict";
    function Zr() {
        var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $1UdHD._)(this, Zr);
        this._hue = 0, this._saturation = 100, this._value = 100, this._alpha = 100, this.enableAlpha = !1, this.format = "hex", this.value = "";
        for(var n in t)Vo(t, n) && (this[n] = t[n]);
        t.value ? this.fromString(t.value) : this.doOnChange();
    }
    (0, $iH1wO._)(Zr, [
        {
            key: "set",
            value: function set(t, n) {
                if (arguments.length === 1 && (typeof t === "undefined" ? "undefined" : (0, $6gBIz._)(t)) == "object") {
                    for(var r in t)Vo(t, r) && this.set(r, t[r]);
                    return;
                }
                this["_".concat(t)] = n, this.doOnChange();
            }
        },
        {
            key: "get",
            value: function get(t) {
                return t === "alpha" ? Math.floor(this["_".concat(t)]) : this["_".concat(t)];
            }
        },
        {
            key: "toRgb",
            value: function toRgb() {
                return Dr(this._hue, this._saturation, this._value);
            }
        },
        {
            key: "fromString",
            value: function fromString(t) {
                var _this = this;
                if (!t) {
                    this._hue = 0, this._saturation = 100, this._value = 100, this.doOnChange();
                    return;
                }
                var n = function(r, s, o) {
                    _this._hue = Math.max(0, Math.min(360, r)), _this._saturation = Math.max(0, Math.min(100, s)), _this._value = Math.max(0, Math.min(100, o)), _this.doOnChange();
                };
                if (t.includes("hsl")) {
                    var r = t.replace(/hsla|hsl|\(|\)/gm, "").split(/\s|,/g).filter(function(s) {
                        return s !== "";
                    }).map(function(s, o) {
                        return o > 2 ? Number.parseFloat(s) : Number.parseInt(s, 10);
                    });
                    if (r.length === 4 ? this._alpha = Number.parseFloat(r[3]) * 100 : r.length === 3 && (this._alpha = 100), r.length >= 3) {
                        var _V6 = V6(r[0], r[1], r[2]), s = _V6.h, o = _V6.s, i = _V6.v;
                        n(s, o, i);
                    }
                } else if (t.includes("hsv")) {
                    var r1 = t.replace(/hsva|hsv|\(|\)/gm, "").split(/\s|,/g).filter(function(s) {
                        return s !== "";
                    }).map(function(s, o) {
                        return o > 2 ? Number.parseFloat(s) : Number.parseInt(s, 10);
                    });
                    r1.length === 4 ? this._alpha = Number.parseFloat(r1[3]) * 100 : r1.length === 3 && (this._alpha = 100), r1.length >= 3 && n(r1[0], r1[1], r1[2]);
                } else if (t.includes("rgb")) {
                    var r2 = t.replace(/rgba|rgb|\(|\)/gm, "").split(/\s|,/g).filter(function(s) {
                        return s !== "";
                    }).map(function(s, o) {
                        return o > 2 ? Number.parseFloat(s) : Number.parseInt(s, 10);
                    });
                    if (r2.length === 4 ? this._alpha = Number.parseFloat(r2[3]) * 100 : r2.length === 3 && (this._alpha = 100), r2.length >= 3) {
                        var _md = md(r2[0], r2[1], r2[2]), s1 = _md.h, o1 = _md.s, i1 = _md.v;
                        n(s1, o1, i1);
                    }
                } else if (t.includes("#")) {
                    var r3 = t.replace("#", "").trim();
                    if (!/^[0-9a-fA-F]{3}$|^[0-9a-fA-F]{6}$|^[0-9a-fA-F]{8}$/.test(r3)) return;
                    var s2, o2, i2;
                    r3.length === 3 ? (s2 = Zn(r3[0] + r3[0]), o2 = Zn(r3[1] + r3[1]), i2 = Zn(r3[2] + r3[2])) : (r3.length === 6 || r3.length === 8) && (s2 = Zn(r3.slice(0, 2)), o2 = Zn(r3.slice(2, 4)), i2 = Zn(r3.slice(4, 6))), r3.length === 8 ? this._alpha = Zn(r3.slice(6)) / 255 * 100 : (r3.length === 3 || r3.length === 6) && (this._alpha = 100);
                    var _md1 = md(s2, o2, i2), a = _md1.h, c = _md1.s, u = _md1.v;
                    n(a, c, u);
                }
            }
        },
        {
            key: "compare",
            value: function compare(t) {
                return Math.abs(t._hue - this._hue) < 2 && Math.abs(t._saturation - this._saturation) < 1 && Math.abs(t._value - this._value) < 1 && Math.abs(t._alpha - this._alpha) < 1;
            }
        },
        {
            key: "doOnChange",
            value: function doOnChange() {
                var _this = this, t = _this._hue, n = _this._saturation, r = _this._value, s = _this._alpha, o = _this.format;
                if (this.enableAlpha) switch(o){
                    case "hsl":
                        {
                            var i = pd(t, n / 100, r / 100);
                            this.value = "hsla(".concat(t, ", ").concat(Math.round(i[1] * 100), "%, ").concat(Math.round(i[2] * 100), "%, ").concat(this.get("alpha") / 100, ")");
                            break;
                        }
                    case "hsv":
                        this.value = "hsva(".concat(t, ", ").concat(Math.round(n), "%, ").concat(Math.round(r), "%, ").concat(this.get("alpha") / 100, ")");
                        break;
                    case "hex":
                        this.value = "".concat(gd(Dr(t, n, r))).concat(Bo(s * 255 / 100));
                        break;
                    default:
                        {
                            var _Dr = Dr(t, n, r), i1 = _Dr.r, a = _Dr.g, c = _Dr.b;
                            this.value = "rgba(".concat(i1, ", ").concat(a, ", ").concat(c, ", ").concat(this.get("alpha") / 100, ")");
                        }
                }
                else switch(o){
                    case "hsl":
                        {
                            var i2 = pd(t, n / 100, r / 100);
                            this.value = "hsl(".concat(t, ", ").concat(Math.round(i2[1] * 100), "%, ").concat(Math.round(i2[2] * 100), "%)");
                            break;
                        }
                    case "hsv":
                        this.value = "hsv(".concat(t, ", ").concat(Math.round(n), "%, ").concat(Math.round(r), "%)");
                        break;
                    case "rgb":
                        {
                            var _Dr1 = Dr(t, n, r), i3 = _Dr1.r, a1 = _Dr1.g, c1 = _Dr1.b;
                            this.value = "rgb(".concat(i3, ", ").concat(a1, ", ").concat(c1, ")");
                            break;
                        }
                    default:
                        this.value = gd(Dr(t, n, r));
                }
            }
        }
    ]);
    return Zr;
}();
var Z6 = (0, $8B0Dy.defineComponent)({
    props: {
        colors: {
            type: Array,
            required: !0
        },
        color: {
            type: Object,
            required: !0
        }
    },
    setup: function(e) {
        var t = Te("color-predefine"), _Le = (0, $8B0Dy.inject)(Wh), n = _Le.currentColor, r = (0, $5wB2C.ref)(o(e.colors, e.color));
        (0, $5wB2C.watch)(function() {
            return n.value;
        }, function(i) {
            var a = new Zr();
            a.fromString(i), r.value.forEach(function(c) {
                c.selected = a.compare(c);
            });
        }), (0, $8B0Dy.watchEffect)(function() {
            r.value = o(e.colors, e.color);
        });
        function s(i) {
            e.color.fromString(e.colors[i]);
        }
        function o(i, a) {
            return i.map(function(c) {
                var u = new Zr();
                return u.enableAlpha = !0, u.format = "rgba", u.fromString(c), u.selected = u.value === a.value, u;
            });
        }
        return {
            rgbaColors: r,
            handleSelect: s,
            ns: t
        };
    }
}), W6 = [
    "onClick"
];
function G6(e, t, n, r, s, o) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
        "class": (0, $3ZJCa.normalizeClass)(e.ns.b())
    }, [
        (0, $8B0Dy.createElementVNode)("div", {
            "class": (0, $3ZJCa.normalizeClass)(e.ns.e("colors"))
        }, [
            ((0, $8B0Dy.openBlock)(!0), (0, $8B0Dy.createElementBlock)((0, $8B0Dy.Fragment), null, (0, $8B0Dy.renderList)(e.rgbaColors, function(i, a) {
                return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
                    key: e.colors[a],
                    "class": (0, $3ZJCa.normalizeClass)([
                        e.ns.e("color-selector"),
                        e.ns.is("alpha", i._alpha < 100),
                        {
                            selected: i.selected
                        }
                    ]),
                    onClick: function(c) {
                        return e.handleSelect(a);
                    }
                }, [
                    (0, $8B0Dy.createElementVNode)("div", {
                        style: (0, $3ZJCa.normalizeStyle)({
                            backgroundColor: i.value
                        })
                    }, null, 4)
                ], 10, W6);
            }), 128))
        ], 2)
    ], 2);
}
var K6 = /* @__PURE__ */ Ce(Z6, [
    [
        "render",
        G6
    ],
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/color-picker/src/components/predefine.vue"
    ]
]);
var X6 = (0, $8B0Dy.defineComponent)({
    name: "ElSlPanel",
    props: {
        color: {
            type: Object,
            required: !0
        }
    },
    setup: function(e) {
        var t = Te("color-svpanel"), n = (0, $8B0Dy.getCurrentInstance)(), r = (0, $5wB2C.ref)(0), s = (0, $5wB2C.ref)(0), o = (0, $5wB2C.ref)("hsl(0, 100%, 50%)"), i = (0, $5wB2C.computed)(function() {
            var u = e.color.get("hue"), d = e.color.get("value");
            return {
                hue: u,
                value: d
            };
        });
        function a() {
            var u = e.color.get("saturation"), d = e.color.get("value"), l = n.vnode.el, m = l.clientWidth, f = l.clientHeight;
            s.value = u * m / 100, r.value = (100 - d) * f / 100, o.value = "hsl(".concat(e.color.get("hue"), ", 100%, 50%)");
        }
        function c(u) {
            var l = n.vnode.el.getBoundingClientRect(), _el = el(u), m = _el.clientX, f = _el.clientY;
            var v = m - l.left, g = f - l.top;
            v = Math.max(0, v), v = Math.min(v, l.width), g = Math.max(0, g), g = Math.min(g, l.height), s.value = v, r.value = g, e.color.set({
                saturation: v / l.width * 100,
                value: 100 - g / l.height * 100
            });
        }
        return (0, $5wB2C.watch)(function() {
            return i.value;
        }, function() {
            a();
        }), (0, $8B0Dy.onMounted)(function() {
            so(n.vnode.el, {
                drag: function(u) {
                    c(u);
                },
                end: function(u) {
                    c(u);
                }
            }), a();
        }), {
            cursorTop: r,
            cursorLeft: s,
            background: o,
            colorValue: i,
            handleDrag: c,
            update: a,
            ns: t
        };
    }
}), Y6 = /* @__PURE__ */ (0, $8B0Dy.createElementVNode)("div", null, null, -1), J6 = [
    Y6
];
function Q6(e, t, n, r, s, o) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
        "class": (0, $3ZJCa.normalizeClass)(e.ns.b()),
        style: (0, $3ZJCa.normalizeStyle)({
            backgroundColor: e.background
        })
    }, [
        (0, $8B0Dy.createElementVNode)("div", {
            "class": (0, $3ZJCa.normalizeClass)(e.ns.e("white"))
        }, null, 2),
        (0, $8B0Dy.createElementVNode)("div", {
            "class": (0, $3ZJCa.normalizeClass)(e.ns.e("black"))
        }, null, 2),
        (0, $8B0Dy.createElementVNode)("div", {
            "class": (0, $3ZJCa.normalizeClass)(e.ns.e("cursor")),
            style: (0, $3ZJCa.normalizeStyle)({
                top: e.cursorTop + "px",
                left: e.cursorLeft + "px"
            })
        }, J6, 6)
    ], 6);
}
var e5 = /* @__PURE__ */ Ce(X6, [
    [
        "render",
        Q6
    ],
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/color-picker/src/components/sv-panel.vue"
    ]
]);
var t5 = [
    "onKeydown"
], n5 = [
    "id",
    "aria-label",
    "aria-labelledby",
    "aria-description",
    "aria-disabled",
    "tabindex"
], r5 = (0, $8B0Dy.defineComponent)({
    name: "ElColorPicker"
}), o5 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)((0, $bnFl0._)((0, $6869c._)({}, r5), {
    props: F6,
    emits: H6,
    setup: function(e, param) {
        var _this = this;
        var t = param.expose, n = param.emit;
        var r = e, _tn = tn(), s = _tn.t, o = Te("color"), _ys = ys(), i = _ys.formItem, a = po(), c = bs(), _Oh = Oh(r, {
            formItemContext: i
        }), u = _Oh.inputId, d = _Oh.isLabeledByFormItem, l = (0, $5wB2C.ref)(), m = (0, $5wB2C.ref)(), f = (0, $5wB2C.ref)(), v = (0, $5wB2C.ref)(), g = (0, $5wB2C.ref)(), b = (0, $5wB2C.ref)(), _Lh = Lh(g, {
            beforeBlur: function(re) {
                var fe;
                return (fe = v.value) == null ? void 0 : fe.isFocusInsideContent(re);
            },
            afterBlur: function() {
                N(!1), T();
            }
        }), h = _Lh.isFocused, w = _Lh.handleFocus, k = _Lh.handleBlur, x = function(re) {
            if (c.value) return Ke();
            w(re);
        };
        var A = !0;
        var S = (0, $5wB2C.reactive)(new Zr({
            enableAlpha: r.showAlpha,
            format: r.colorFormat || "",
            value: r.modelValue
        })), $ = (0, $5wB2C.ref)(!1), M = (0, $5wB2C.ref)(!1), P = (0, $5wB2C.ref)(""), R = (0, $5wB2C.computed)(function() {
            return !r.modelValue && !M.value ? "transparent" : Q(S, r.showAlpha);
        }), B = (0, $5wB2C.computed)(function() {
            return !r.modelValue && !M.value ? "" : S.value;
        }), H = (0, $5wB2C.computed)(function() {
            return d.value ? void 0 : r.label || s("el.colorpicker.defaultLabel");
        }), ie = (0, $5wB2C.computed)(function() {
            return d.value ? i == null ? void 0 : i.labelId : void 0;
        }), z = (0, $5wB2C.computed)(function() {
            return [
                o.b("picker"),
                o.is("disabled", c.value),
                o.bm("picker", a.value),
                o.is("focused", h.value)
            ];
        });
        function Q(re, fe) {
            if (!(re instanceof Zr)) throw new TypeError("color should be instance of _color Class");
            var _re_toRgb = re.toRgb(), Se = _re_toRgb.r, ze = _re_toRgb.g, Ge = _re_toRgb.b;
            return fe ? "rgba(".concat(Se, ", ").concat(ze, ", ").concat(Ge, ", ").concat(re.get("alpha") / 100, ")") : "rgb(".concat(Se, ", ").concat(ze, ", ").concat(Ge, ")");
        }
        function N(re) {
            $.value = re;
        }
        var j = xc(N, 100, {
            leading: !0
        });
        function U() {
            c.value || N(!0);
        }
        function G() {
            j(!1), T();
        }
        function T() {
            (0, $8B0Dy.nextTick)(function() {
                r.modelValue ? S.fromString(r.modelValue) : (S.value = "", (0, $8B0Dy.nextTick)(function() {
                    M.value = !1;
                }));
            });
        }
        function W() {
            c.value || j(!$.value);
        }
        function V() {
            S.fromString(P.value);
        }
        function se() {
            var re = S.value;
            n(wt, re), n("change", re), r.validateEvent && (i == null || i.validate("change")["catch"](function(fe) {
                return void 0;
            })), j(!1), (0, $8B0Dy.nextTick)(function() {
                var fe = new Zr({
                    enableAlpha: r.showAlpha,
                    format: r.colorFormat || "",
                    value: r.modelValue
                });
                S.compare(fe) || T();
            });
        }
        function de() {
            j(!1), n(wt, null), n("change", null), r.modelValue !== null && r.validateEvent && (i == null || i.validate("change")["catch"](function(re) {
                return void 0;
            })), T();
        }
        function ve(re) {
            if ($.value && (G(), h.value)) {
                var fe = new FocusEvent("focus", re);
                k(fe);
            }
        }
        function we(re) {
            re.preventDefault(), re.stopPropagation(), N(!1), T();
        }
        function Be(re) {
            switch(re.code){
                case _n.enter:
                case _n.space:
                    re.preventDefault(), re.stopPropagation(), U(), b.value.focus();
                    break;
                case _n.esc:
                    we(re);
                    break;
            }
        }
        function Oe() {
            g.value.focus();
        }
        function Ke() {
            g.value.blur();
        }
        return (0, $8B0Dy.onMounted)(function() {
            r.modelValue && (P.value = B.value);
        }), (0, $5wB2C.watch)(function() {
            return r.modelValue;
        }, function(re) {
            re ? re && re !== S.value && (A = !1, S.fromString(re)) : M.value = !1;
        }), (0, $5wB2C.watch)(function() {
            return B.value;
        }, function(re) {
            P.value = re, A && n("activeChange", re), A = !0;
        }), (0, $5wB2C.watch)(function() {
            return S.value;
        }, function() {
            !r.modelValue && !M.value && (M.value = !0);
        }), (0, $5wB2C.watch)(function() {
            return $.value;
        }, function() {
            (0, $8B0Dy.nextTick)(function() {
                var re, fe, Se;
                (re = l.value) == null || re.update(), (fe = m.value) == null || fe.update(), (Se = f.value) == null || Se.update();
            });
        }), (0, $8B0Dy.provide)(Wh, {
            currentColor: B
        }), t({
            color: S,
            show: U,
            hide: G,
            focus: Oe,
            blur: Ke
        }), function(re, fe) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(oo), {
                ref_key: "popper",
                ref: v,
                visible: $.value,
                "show-arrow": !1,
                "fallback-placements": [
                    "bottom",
                    "top",
                    "right",
                    "left"
                ],
                offset: 0,
                "gpu-acceleration": !1,
                "popper-class": [
                    (0, $5wB2C.unref)(o).be("picker", "panel"),
                    (0, $5wB2C.unref)(o).b("dropdown"),
                    re.popperClass
                ],
                "stop-popper-mouse-event": !1,
                effect: "light",
                trigger: "click",
                transition: "".concat((0, $5wB2C.unref)(o).namespace.value, "-zoom-in-top"),
                persistent: "",
                onHide: fe[2] || (fe[2] = function(Se) {
                    return N(!1);
                })
            }, {
                content: (0, $8B0Dy.withCtx)(function() {
                    return [
                        (0, $8B0Dy.withDirectives)(((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
                            onKeydown: (0, $kRi7Z.withKeys)(we, [
                                "esc"
                            ])
                        }, [
                            (0, $8B0Dy.createElementVNode)("div", {
                                "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(o).be("dropdown", "main-wrapper"))
                            }, [
                                (0, $8B0Dy.createVNode)(q6, {
                                    ref_key: "hue",
                                    ref: l,
                                    "class": "hue-slider",
                                    color: (0, $5wB2C.unref)(S),
                                    vertical: ""
                                }, null, 8, [
                                    "color"
                                ]),
                                (0, $8B0Dy.createVNode)(e5, {
                                    ref_key: "sv",
                                    ref: m,
                                    color: (0, $5wB2C.unref)(S)
                                }, null, 8, [
                                    "color"
                                ])
                            ], 2),
                            re.showAlpha ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)(z6, {
                                key: 0,
                                ref_key: "alpha",
                                ref: f,
                                color: (0, $5wB2C.unref)(S)
                            }, null, 8, [
                                "color"
                            ])) : (0, $8B0Dy.createCommentVNode)("v-if", !0),
                            re.predefine ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)(K6, {
                                key: 1,
                                ref: "predefine",
                                color: (0, $5wB2C.unref)(S),
                                colors: re.predefine
                            }, null, 8, [
                                "color",
                                "colors"
                            ])) : (0, $8B0Dy.createCommentVNode)("v-if", !0),
                            (0, $8B0Dy.createElementVNode)("div", {
                                "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(o).be("dropdown", "btns"))
                            }, [
                                (0, $8B0Dy.createElementVNode)("span", {
                                    "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(o).be("dropdown", "value"))
                                }, [
                                    (0, $8B0Dy.createVNode)((0, $5wB2C.unref)(ws), {
                                        ref_key: "inputRef",
                                        ref: b,
                                        modelValue: P.value,
                                        "onUpdate:modelValue": fe[0] || (fe[0] = function(Se) {
                                            return P.value = Se;
                                        }),
                                        "validate-event": !1,
                                        size: "small",
                                        onKeyup: (0, $kRi7Z.withKeys)(V, [
                                            "enter"
                                        ]),
                                        onBlur: V
                                    }, null, 8, [
                                        "modelValue",
                                        "onKeyup"
                                    ])
                                ], 2),
                                (0, $8B0Dy.createVNode)((0, $5wB2C.unref)(ud), {
                                    "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(o).be("dropdown", "link-btn")),
                                    text: "",
                                    size: "small",
                                    onClick: de
                                }, {
                                    "default": (0, $8B0Dy.withCtx)(function() {
                                        return [
                                            (0, $8B0Dy.createTextVNode)((0, $3ZJCa.toDisplayString)((0, $5wB2C.unref)(s)("el.colorpicker.clear")), 1)
                                        ];
                                    }),
                                    _: 1
                                }, 8, [
                                    "class"
                                ]),
                                (0, $8B0Dy.createVNode)((0, $5wB2C.unref)(ud), {
                                    plain: "",
                                    size: "small",
                                    "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(o).be("dropdown", "btn")),
                                    onClick: se
                                }, {
                                    "default": (0, $8B0Dy.withCtx)(function() {
                                        return [
                                            (0, $8B0Dy.createTextVNode)((0, $3ZJCa.toDisplayString)((0, $5wB2C.unref)(s)("el.colorpicker.confirm")), 1)
                                        ];
                                    }),
                                    _: 1
                                }, 8, [
                                    "class"
                                ])
                            ], 2)
                        ], 40, t5)), [
                            [
                                (0, $5wB2C.unref)(Vh),
                                ve
                            ]
                        ])
                    ];
                }),
                "default": (0, $8B0Dy.withCtx)(function() {
                    var _this1 = _this;
                    return [
                        (0, $8B0Dy.createElementVNode)("div", {
                            id: (0, $5wB2C.unref)(u),
                            ref_key: "triggerRef",
                            ref: g,
                            "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(z)),
                            role: "button",
                            "aria-label": (0, $5wB2C.unref)(H),
                            "aria-labelledby": (0, $5wB2C.unref)(ie),
                            "aria-description": (0, $5wB2C.unref)(s)("el.colorpicker.description", {
                                color: re.modelValue || ""
                            }),
                            "aria-disabled": (0, $5wB2C.unref)(c),
                            tabindex: (0, $5wB2C.unref)(c) ? -1 : re.tabindex,
                            onKeydown: Be,
                            onFocus: x,
                            onBlur: fe[1] || (fe[1] = function() {
                                for(var _len = arguments.length, Se = new Array(_len), _key = 0; _key < _len; _key++){
                                    Se[_key] = arguments[_key];
                                }
                                return (0, $5wB2C.unref)(k) && (0, $5wB2C.unref)(k).apply(_this1, (0, $kf9Kn._)(Se));
                            })
                        }, [
                            (0, $5wB2C.unref)(c) ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
                                key: 0,
                                "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(o).be("picker", "mask"))
                            }, null, 2)) : (0, $8B0Dy.createCommentVNode)("v-if", !0),
                            (0, $8B0Dy.createElementVNode)("div", {
                                "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(o).be("picker", "trigger")),
                                onClick: W
                            }, [
                                (0, $8B0Dy.createElementVNode)("span", {
                                    "class": (0, $3ZJCa.normalizeClass)([
                                        (0, $5wB2C.unref)(o).be("picker", "color"),
                                        (0, $5wB2C.unref)(o).is("alpha", re.showAlpha)
                                    ])
                                }, [
                                    (0, $8B0Dy.createElementVNode)("span", {
                                        "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(o).be("picker", "color-inner")),
                                        style: (0, $3ZJCa.normalizeStyle)({
                                            backgroundColor: (0, $5wB2C.unref)(R)
                                        })
                                    }, [
                                        (0, $8B0Dy.withDirectives)((0, $8B0Dy.createVNode)((0, $5wB2C.unref)(kt), {
                                            "class": (0, $3ZJCa.normalizeClass)([
                                                (0, $5wB2C.unref)(o).be("picker", "icon"),
                                                (0, $5wB2C.unref)(o).is("icon-arrow-down")
                                            ])
                                        }, {
                                            "default": (0, $8B0Dy.withCtx)(function() {
                                                return [
                                                    (0, $8B0Dy.createVNode)((0, $5wB2C.unref)(dh))
                                                ];
                                            }),
                                            _: 1
                                        }, 8, [
                                            "class"
                                        ]), [
                                            [
                                                (0, $kRi7Z.vShow),
                                                re.modelValue || M.value
                                            ]
                                        ]),
                                        (0, $8B0Dy.withDirectives)((0, $8B0Dy.createVNode)((0, $5wB2C.unref)(kt), {
                                            "class": (0, $3ZJCa.normalizeClass)([
                                                (0, $5wB2C.unref)(o).be("picker", "empty"),
                                                (0, $5wB2C.unref)(o).is("icon-close")
                                            ])
                                        }, {
                                            "default": (0, $8B0Dy.withCtx)(function() {
                                                return [
                                                    (0, $8B0Dy.createVNode)((0, $5wB2C.unref)(Sc))
                                                ];
                                            }),
                                            _: 1
                                        }, 8, [
                                            "class"
                                        ]), [
                                            [
                                                (0, $kRi7Z.vShow),
                                                !re.modelValue && !M.value
                                            ]
                                        ])
                                    ], 6)
                                ], 2)
                            ], 2)
                        ], 42, n5)
                    ];
                }),
                _: 1
            }, 8, [
                "visible",
                "popper-class",
                "transition"
            ]);
        };
    }
}));
var s5 = /* @__PURE__ */ Ce(o5, [
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/color-picker/src/color-picker.vue"
    ]
]);
var i5 = jt(s5), a5 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    inheritAttrs: !1
});
function c5(e, t, n, r, s, o) {
    return (0, $8B0Dy.renderSlot)(e.$slots, "default");
}
var l5 = /* @__PURE__ */ Ce(a5, [
    [
        "render",
        c5
    ],
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/collection/src/collection.vue"
    ]
]);
var u5 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    name: "ElCollectionItem",
    inheritAttrs: !1
});
function d5(e, t, n, r, s, o) {
    return (0, $8B0Dy.renderSlot)(e.$slots, "default");
}
var f5 = /* @__PURE__ */ Ce(u5, [
    [
        "render",
        d5
    ],
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/collection/src/collection-item.vue"
    ]
]);
var p5 = "data-el-collection-item", h5 = function(e) {
    var t = "El".concat(e, "Collection"), n = "".concat(t, "Item"), r = Symbol(t), s = Symbol(n), o = (0, $bnFl0._)((0, $6869c._)({}, l5), {
        name: t,
        setup: function() {
            var a = (0, $5wB2C.ref)(null), c = /* @__PURE__ */ new Map();
            (0, $8B0Dy.provide)(r, {
                itemMap: c,
                getItems: function() {
                    var d = (0, $5wB2C.unref)(a);
                    if (!d) return [];
                    var l = Array.from(d.querySelectorAll("[".concat(p5, "]")));
                    return (0, $kf9Kn._)(c.values()).sort(function(f, v) {
                        return l.indexOf(f.ref) - l.indexOf(v.ref);
                    });
                },
                collectionRef: a
            });
        }
    }), i = (0, $bnFl0._)((0, $6869c._)({}, f5), {
        name: n,
        setup: function(a, param) {
            var c = param.attrs;
            var u = (0, $5wB2C.ref)(null), d = (0, $8B0Dy.inject)(r, void 0);
            (0, $8B0Dy.provide)(s, {
                collectionItemRef: u
            }), (0, $8B0Dy.onMounted)(function() {
                var l = (0, $5wB2C.unref)(u);
                l && d.itemMap.set(l, (0, $6869c._)({
                    ref: l
                }, c));
            }), (0, $8B0Dy.onBeforeUnmount)(function() {
                var l = (0, $5wB2C.unref)(u);
                d.itemMap["delete"](l);
            });
        }
    });
    return {
        COLLECTION_INJECTION_KEY: r,
        COLLECTION_ITEM_INJECTION_KEY: s,
        ElCollection: o,
        ElCollectionItem: i
    };
}, Xs = Re({
    trigger: ro.trigger,
    effect: (0, $bnFl0._)((0, $6869c._)({}, Tt.effect), {
        "default": "light"
    }),
    type: {
        type: be(String)
    },
    placement: {
        type: be(String),
        "default": "bottom"
    },
    popperOptions: {
        type: be(Object),
        "default": function() {
            return {};
        }
    },
    id: String,
    size: {
        type: String,
        "default": ""
    },
    splitButton: Boolean,
    hideOnClick: {
        type: Boolean,
        "default": !0
    },
    loop: {
        type: Boolean,
        "default": !0
    },
    showTimeout: {
        type: Number,
        "default": 150
    },
    hideTimeout: {
        type: Number,
        "default": 150
    },
    tabindex: {
        type: be([
            Number,
            String
        ]),
        "default": 0
    },
    maxHeight: {
        type: be([
            Number,
            String
        ]),
        "default": ""
    },
    popperClass: {
        type: String,
        "default": ""
    },
    disabled: {
        type: Boolean,
        "default": !1
    },
    role: {
        type: String,
        "default": "menu"
    },
    buttonProps: {
        type: be(Object)
    },
    teleported: Tt.teleported
});
Re({
    command: {
        type: [
            Object,
            String,
            Number
        ],
        "default": function() {
            return {};
        }
    },
    disabled: Boolean,
    divided: Boolean,
    textValue: String,
    icon: {
        type: en
    }
});
Re({
    onKeydown: {
        type: be(Function)
    }
});
h5("Dropdown");
var Gh = Symbol("elPaginationKey"), g5 = Re({
    disabled: Boolean,
    currentPage: {
        type: Number,
        "default": 1
    },
    prevText: {
        type: String
    },
    prevIcon: {
        type: en
    }
}), m5 = {
    click: function(e) {
        return e instanceof MouseEvent;
    }
}, v5 = [
    "disabled",
    "aria-label",
    "aria-disabled"
], _5 = {
    key: 0
}, b5 = (0, $8B0Dy.defineComponent)({
    name: "ElPaginationPrev"
}), y5 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)((0, $bnFl0._)((0, $6869c._)({}, b5), {
    props: g5,
    emits: m5,
    setup: function(e) {
        var t = e, _tn = tn(), n = _tn.t, r = (0, $5wB2C.computed)(function() {
            return t.disabled || t.currentPage <= 1;
        });
        return function(s, o) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("button", {
                type: "button",
                "class": "btn-prev",
                disabled: (0, $5wB2C.unref)(r),
                "aria-label": s.prevText || (0, $5wB2C.unref)(n)("el.pagination.prev"),
                "aria-disabled": (0, $5wB2C.unref)(r),
                onClick: o[0] || (o[0] = function(i) {
                    return s.$emit("click", i);
                })
            }, [
                s.prevText ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("span", _5, (0, $3ZJCa.toDisplayString)(s.prevText), 1)) : ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(kt), {
                    key: 1
                }, {
                    "default": (0, $8B0Dy.withCtx)(function() {
                        return [
                            ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $8B0Dy.resolveDynamicComponent)(s.prevIcon)))
                        ];
                    }),
                    _: 1
                }))
            ], 8, v5);
        };
    }
}));
var w5 = /* @__PURE__ */ Ce(y5, [
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/pagination/src/components/prev.vue"
    ]
]);
var k5 = Re({
    disabled: Boolean,
    currentPage: {
        type: Number,
        "default": 1
    },
    pageCount: {
        type: Number,
        "default": 50
    },
    nextText: {
        type: String
    },
    nextIcon: {
        type: en
    }
}), x5 = [
    "disabled",
    "aria-label",
    "aria-disabled"
], C5 = {
    key: 0
}, S5 = (0, $8B0Dy.defineComponent)({
    name: "ElPaginationNext"
}), E5 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)((0, $bnFl0._)((0, $6869c._)({}, S5), {
    props: k5,
    emits: [
        "click"
    ],
    setup: function(e) {
        var t = e, _tn = tn(), n = _tn.t, r = (0, $5wB2C.computed)(function() {
            return t.disabled || t.currentPage === t.pageCount || t.pageCount === 0;
        });
        return function(s, o) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("button", {
                type: "button",
                "class": "btn-next",
                disabled: (0, $5wB2C.unref)(r),
                "aria-label": s.nextText || (0, $5wB2C.unref)(n)("el.pagination.next"),
                "aria-disabled": (0, $5wB2C.unref)(r),
                onClick: o[0] || (o[0] = function(i) {
                    return s.$emit("click", i);
                })
            }, [
                s.nextText ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("span", C5, (0, $3ZJCa.toDisplayString)(s.nextText), 1)) : ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(kt), {
                    key: 1
                }, {
                    "default": (0, $8B0Dy.withCtx)(function() {
                        return [
                            ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $8B0Dy.resolveDynamicComponent)(s.nextIcon)))
                        ];
                    }),
                    _: 1
                }))
            ], 8, x5);
        };
    }
}));
var A5 = /* @__PURE__ */ Ce(E5, [
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/pagination/src/components/next.vue"
    ]
]);
var Kh = Symbol("ElSelectGroup"), xs = Symbol("ElSelect");
function $5(e, t) {
    var n = (0, $8B0Dy.inject)(xs), r = (0, $8B0Dy.inject)(Kh, {
        disabled: !1
    }), s = (0, $5wB2C.computed)(function() {
        return Jt(e.value);
    }), o = (0, $5wB2C.computed)(function() {
        return n.props.multiple ? l(n.props.modelValue, e.value) : m(e.value, n.props.modelValue);
    }), i = (0, $5wB2C.computed)(function() {
        if (n.props.multiple) {
            var g = n.props.modelValue || [];
            return !o.value && g.length >= n.props.multipleLimit && n.props.multipleLimit > 0;
        } else return !1;
    }), a = (0, $5wB2C.computed)(function() {
        return e.label || (s.value ? "" : e.value);
    }), c = (0, $5wB2C.computed)(function() {
        return e.value || e.label || "";
    }), u = (0, $5wB2C.computed)(function() {
        return e.disabled || t.groupDisabled || i.value;
    }), d = (0, $8B0Dy.getCurrentInstance)(), l = function() {
        var g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], b = arguments.length > 1 ? arguments[1] : void 0;
        if (s.value) {
            var h = n.props.valueKey;
            return g && g.some(function(w) {
                return (0, $5wB2C.toRaw)(Lt(w, h)) === Lt(b, h);
            });
        } else return g && g.includes(b);
    }, m = function(g, b) {
        if (s.value) {
            var _n_props = n.props, h = _n_props.valueKey;
            return Lt(g, h) === Lt(b, h);
        } else return g === b;
    }, f = function() {
        !e.disabled && !r.disabled && (n.hoverIndex = n.optionsArray.indexOf(d.proxy));
    };
    (0, $5wB2C.watch)(function() {
        return a.value;
    }, function() {
        !e.created && !n.props.remote && n.setSelected();
    }), (0, $5wB2C.watch)(function() {
        return e.value;
    }, function(g, b) {
        var _n_props = n.props, h = _n_props.remote, w = _n_props.valueKey;
        if (Object.is(g, b) || (n.onOptionDestroy(b, d.proxy), n.onOptionCreate(d.proxy)), !e.created && !h) {
            if (w && Jt(g) && Jt(b) && g[w] === b[w]) return;
            n.setSelected();
        }
    }), (0, $5wB2C.watch)(function() {
        return r.disabled;
    }, function() {
        t.groupDisabled = r.disabled;
    }, {
        immediate: !0
    });
    var _Uo = (0, $5wB2C.toRaw)(n), v = _Uo.queryChange;
    return (0, $5wB2C.watch)(v, function(g) {
        var _$_ = (0, $5wB2C.unref)(g), b = _$_.query, h = new RegExp(p4(b), "i");
        t.visible = h.test(a.value) || e.created, t.visible || n.filteredOptionsCount--;
    }, {
        immediate: !0
    }), {
        select: n,
        currentLabel: a,
        currentValue: c,
        itemSelected: o,
        isDisabled: u,
        hoverItem: f
    };
}
var M5 = (0, $8B0Dy.defineComponent)({
    name: "ElOption",
    componentName: "ElOption",
    props: {
        value: {
            required: !0,
            type: [
                String,
                Number,
                Boolean,
                Object
            ]
        },
        label: [
            String,
            Number
        ],
        created: Boolean,
        disabled: Boolean
    },
    setup: function(e) {
        var t = Te("select"), n = _s(), r = (0, $5wB2C.computed)(function() {
            return [
                t.be("dropdown", "item"),
                t.is("disabled", (0, $5wB2C.unref)(a)),
                {
                    selected: (0, $5wB2C.unref)(i),
                    hover: (0, $5wB2C.unref)(l)
                }
            ];
        }), s = (0, $5wB2C.reactive)({
            index: -1,
            groupDisabled: !1,
            visible: !0,
            hitState: !1,
            hover: !1
        }), _$5 = $5(e, s), o = _$5.currentLabel, i = _$5.itemSelected, a = _$5.isDisabled, c = _$5.select, u = _$5.hoverItem, _ss = (0, $5wB2C.toRefs)(s), d = _ss.visible, l = _ss.hover, m = (0, $8B0Dy.getCurrentInstance)().proxy;
        c.onOptionCreate(m), (0, $8B0Dy.onBeforeUnmount)(function() {
            var v = m.value, g = c.selected, h = (c.props.multiple ? g : [
                g
            ]).some(function(w) {
                return w.value === m.value;
            });
            (0, $8B0Dy.nextTick)(function() {
                c.cachedOptions.get(v) === m && !h && c.cachedOptions["delete"](v);
            }), c.onOptionDestroy(v, m);
        });
        function f() {
            e.disabled !== !0 && s.groupDisabled !== !0 && c.handleOptionSelect(m);
        }
        return {
            ns: t,
            id: n,
            containerKls: r,
            currentLabel: o,
            itemSelected: i,
            isDisabled: a,
            select: c,
            hoverItem: u,
            visible: d,
            hover: l,
            selectOptionClick: f,
            states: s
        };
    }
}), I5 = [
    "id",
    "aria-disabled",
    "aria-selected"
];
function T5(e, t, n, r, s, o) {
    var _e, _e1;
    return (0, $8B0Dy.withDirectives)(((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("li", {
        id: e.id,
        "class": (0, $3ZJCa.normalizeClass)(e.containerKls),
        role: "option",
        "aria-disabled": e.isDisabled || void 0,
        "aria-selected": e.itemSelected,
        onMouseenter: t[0] || (t[0] = function() {
            for(var _len = arguments.length, i = new Array(_len), _key = 0; _key < _len; _key++){
                i[_key] = arguments[_key];
            }
            return e.hoverItem && (_e = e).hoverItem.apply(_e, (0, $kf9Kn._)(i));
        }),
        onClick: t[1] || (t[1] = (0, $kRi7Z.withModifiers)(function() {
            for(var _len = arguments.length, i = new Array(_len), _key = 0; _key < _len; _key++){
                i[_key] = arguments[_key];
            }
            return e.selectOptionClick && (_e1 = e).selectOptionClick.apply(_e1, (0, $kf9Kn._)(i));
        }, [
            "stop"
        ]))
    }, [
        (0, $8B0Dy.renderSlot)(e.$slots, "default", {}, function() {
            return [
                (0, $8B0Dy.createElementVNode)("span", null, (0, $3ZJCa.toDisplayString)(e.currentLabel), 1)
            ];
        })
    ], 42, I5)), [
        [
            (0, $kRi7Z.vShow),
            e.visible
        ]
    ]);
}
var xl = /* @__PURE__ */ Ce(M5, [
    [
        "render",
        T5
    ],
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/select/src/option.vue"
    ]
]);
var L5 = (0, $8B0Dy.defineComponent)({
    name: "ElSelectDropdown",
    componentName: "ElSelectDropdown",
    setup: function() {
        var e = (0, $8B0Dy.inject)(xs), t = Te("select"), n = (0, $5wB2C.computed)(function() {
            return e.props.popperClass;
        }), r = (0, $5wB2C.computed)(function() {
            return e.props.multiple;
        }), s = (0, $5wB2C.computed)(function() {
            return e.props.fitInputWidth;
        }), o = (0, $5wB2C.ref)("");
        function i() {
            var a;
            o.value = "".concat((a = e.selectWrapper) == null ? void 0 : a.offsetWidth, "px");
        }
        return (0, $8B0Dy.onMounted)(function() {
            i(), cs(e.selectWrapper, i);
        }), {
            ns: t,
            minWidth: o,
            popperClass: n,
            isMultiple: r,
            isFitInputWidth: s
        };
    }
});
function O5(e, t, n, r, s, o) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
        "class": (0, $3ZJCa.normalizeClass)([
            e.ns.b("dropdown"),
            e.ns.is("multiple", e.isMultiple),
            e.popperClass
        ]),
        style: (0, $3ZJCa.normalizeStyle)((0, $aRIHe._)({}, e.isFitInputWidth ? "width" : "minWidth", e.minWidth))
    }, [
        e.$slots.header ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
            key: 0,
            "class": (0, $3ZJCa.normalizeClass)(e.ns.be("dropdown", "header"))
        }, [
            (0, $8B0Dy.renderSlot)(e.$slots, "header")
        ], 2)) : (0, $8B0Dy.createCommentVNode)("v-if", !0),
        (0, $8B0Dy.renderSlot)(e.$slots, "default"),
        e.$slots.footer ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
            key: 1,
            "class": (0, $3ZJCa.normalizeClass)(e.ns.be("dropdown", "footer"))
        }, [
            (0, $8B0Dy.renderSlot)(e.$slots, "footer")
        ], 2)) : (0, $8B0Dy.createCommentVNode)("v-if", !0)
    ], 6);
}
var R5 = /* @__PURE__ */ Ce(L5, [
    [
        "render",
        O5
    ],
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/select/src/select-dropdown.vue"
    ]
]);
function P5(e) {
    var t = tn().t;
    return (0, $5wB2C.reactive)({
        options: /* @__PURE__ */ new Map(),
        cachedOptions: /* @__PURE__ */ new Map(),
        disabledOptions: /* @__PURE__ */ new Map(),
        createdLabel: null,
        createdSelected: !1,
        selected: e.multiple ? [] : {},
        inputLength: 20,
        inputWidth: 0,
        optionsCount: 0,
        filteredOptionsCount: 0,
        visible: !1,
        selectedLabel: "",
        hoverIndex: -1,
        query: "",
        previousQuery: null,
        inputHovering: !1,
        cachedPlaceHolder: "",
        currentPlaceholder: t("el.select.placeholder"),
        menuVisibleOnFocus: !1,
        isOnComposition: !1,
        prefixWidth: 11,
        mouseEnter: !1,
        focused: !1
    });
}
var B5 = function(e, t, n) {
    var _tn = tn(), r = _tn.t, s = Te("select");
    mh({
        from: "suffixTransition",
        replacement: "override style scheme",
        version: "2.3.0",
        scope: "props",
        ref: "https://element-plus.org/en-US/component/select.html#select-attributes"
    }, (0, $5wB2C.computed)(function() {
        return e.suffixTransition === !1;
    }));
    var o = (0, $5wB2C.ref)(null), i = (0, $5wB2C.ref)(null), a = (0, $5wB2C.ref)(null), c = (0, $5wB2C.ref)(null), u = (0, $5wB2C.ref)(null), d = (0, $5wB2C.ref)(null), l = (0, $5wB2C.ref)(null), m = (0, $5wB2C.ref)(null), f = (0, $5wB2C.ref)(), v = (0, $5wB2C.shallowRef)({
        query: ""
    }), g = (0, $5wB2C.shallowRef)(""), b = (0, $5wB2C.ref)([]);
    var h = 0;
    var _ys = ys(), w = _ys.form, k = _ys.formItem, x = (0, $5wB2C.computed)(function() {
        return !e.filterable || e.multiple || !t.visible;
    }), A = (0, $5wB2C.computed)(function() {
        return e.disabled || (w == null ? void 0 : w.disabled);
    }), S = (0, $5wB2C.computed)(function() {
        var O = e.multiple ? Array.isArray(e.modelValue) && e.modelValue.length > 0 : e.modelValue !== void 0 && e.modelValue !== null && e.modelValue !== "";
        return e.clearable && !A.value && t.inputHovering && O;
    }), $ = (0, $5wB2C.computed)(function() {
        return e.remote && e.filterable && !e.remoteShowSuffix ? "" : e.suffixIcon;
    }), M = (0, $5wB2C.computed)(function() {
        return s.is("reverse", $.value && t.visible && e.suffixTransition);
    }), P = (0, $5wB2C.computed)(function() {
        return (w == null ? void 0 : w.statusIcon) && (k == null ? void 0 : k.validateState) && hh[k == null ? void 0 : k.validateState];
    }), R = (0, $5wB2C.computed)(function() {
        return e.remote ? 300 : 0;
    }), B = (0, $5wB2C.computed)(function() {
        return e.loading ? e.loadingText || r("el.select.loading") : e.remote && t.query === "" && t.options.size === 0 ? !1 : e.filterable && t.query && t.options.size > 0 && t.filteredOptionsCount === 0 ? e.noMatchText || r("el.select.noMatch") : t.options.size === 0 ? e.noDataText || r("el.select.noData") : null;
    }), H = (0, $5wB2C.computed)(function() {
        var O = Array.from(t.options.values()), E = [];
        return b.value.forEach(function(L) {
            var q = O.findIndex(function(ce) {
                return ce.currentLabel === L;
            });
            q > -1 && E.push(O[q]);
        }), E.length >= O.length ? E : O;
    }), ie = (0, $5wB2C.computed)(function() {
        return Array.from(t.cachedOptions.values());
    }), z = (0, $5wB2C.computed)(function() {
        var O = H.value.filter(function(E) {
            return !E.created;
        }).some(function(E) {
            return E.currentLabel === t.query;
        });
        return e.filterable && e.allowCreate && t.query !== "" && !O;
    }), Q = po(), N = (0, $5wB2C.computed)(function() {
        return [
            "small"
        ].includes(Q.value) ? "small" : "default";
    }), j = (0, $5wB2C.computed)({
        get: function() {
            return t.visible && B.value !== !1;
        },
        set: function(O) {
            t.visible = O;
        }
    });
    (0, $5wB2C.watch)([
        function() {
            return A.value;
        },
        function() {
            return Q.value;
        },
        function() {
            return w == null ? void 0 : w.size;
        }
    ], function() {
        (0, $8B0Dy.nextTick)(function() {
            U();
        });
    }), (0, $5wB2C.watch)(function() {
        return e.placeholder;
    }, function(O) {
        t.cachedPlaceHolder = t.currentPlaceholder = O, e.multiple && Array.isArray(e.modelValue) && e.modelValue.length > 0 && (t.currentPlaceholder = "");
    }), (0, $5wB2C.watch)(function() {
        return e.modelValue;
    }, function(O, E) {
        e.multiple && (U(), O && O.length > 0 || i.value && t.query !== "" ? t.currentPlaceholder = "" : t.currentPlaceholder = t.cachedPlaceHolder, e.filterable && !e.reserveKeyword && (t.query = "", G(t.query))), V(), e.filterable && !e.multiple && (t.inputLength = 20), !Cc(O, E) && e.validateEvent && (k == null || k.validate("change")["catch"](function(L) {
            return void 0;
        }));
    }, {
        flush: "post",
        deep: !0
    }), (0, $5wB2C.watch)(function() {
        return t.visible;
    }, function(O) {
        var E, L, q, ce, xe;
        O ? ((L = (E = c.value) == null ? void 0 : E.updatePopper) == null || L.call(E), e.filterable && (t.filteredOptionsCount = t.optionsCount, t.query = e.remote ? "" : t.selectedLabel, (ce = (q = a.value) == null ? void 0 : q.focus) == null || ce.call(q), e.multiple ? (xe = i.value) == null || xe.focus() : t.selectedLabel && (t.currentPlaceholder = "".concat(t.selectedLabel), t.selectedLabel = ""), G(t.query), !e.multiple && !e.remote && (v.value.query = "", (0, $5wB2C.triggerRef)(v), (0, $5wB2C.triggerRef)(g)))) : (e.filterable && (Pt(e.filterMethod) && e.filterMethod(""), Pt(e.remoteMethod) && e.remoteMethod("")), t.query = "", t.previousQuery = null, t.selectedLabel = "", t.inputLength = 20, t.menuVisibleOnFocus = !1, de(), (0, $8B0Dy.nextTick)(function() {
            i.value && i.value.value === "" && t.selected.length === 0 && (t.currentPlaceholder = t.cachedPlaceHolder);
        }), e.multiple || (t.selected && (e.filterable && e.allowCreate && t.createdSelected && t.createdLabel ? t.selectedLabel = t.createdLabel : t.selectedLabel = t.selected.currentLabel, e.filterable && (t.query = t.selectedLabel)), e.filterable && (t.currentPlaceholder = t.cachedPlaceHolder))), n.emit("visible-change", O);
    }), (0, $5wB2C.watch)(function() {
        return t.options.entries();
    }, function() {
        var O, E, L;
        if (!gt) return;
        (E = (O = c.value) == null ? void 0 : O.updatePopper) == null || E.call(O), e.multiple && U();
        var q = ((L = l.value) == null ? void 0 : L.querySelectorAll("input")) || [];
        (!e.filterable && !e.defaultFirstOption && !uh(e.modelValue) || !Array.from(q).includes(document.activeElement)) && V(), e.defaultFirstOption && (e.filterable || e.remote) && t.filteredOptionsCount && W();
    }, {
        flush: "post"
    }), (0, $5wB2C.watch)(function() {
        return t.hoverIndex;
    }, function(O) {
        Ye(O) && O > -1 ? f.value = H.value[O] || {} : f.value = {}, H.value.forEach(function(E) {
            E.hover = f.value === E;
        });
    });
    var U = function() {
        (0, $8B0Dy.nextTick)(function() {
            var O, E;
            if (!o.value) return;
            var L = o.value.$el.querySelector("input");
            h = h || (L.clientHeight > 0 ? L.clientHeight + 2 : 0);
            var q = d.value, ce = getComputedStyle(L).getPropertyValue(s.cssVarName("input-height")), xe = Number.parseFloat(ce) || F4(Q.value || (w == null ? void 0 : w.size)), Ae = Q.value || xe === h || h <= 0 ? xe : h;
            !(L.offsetParent === null) && (L.style.height = "".concat((t.selected.length === 0 ? Ae : Math.max(q ? q.clientHeight + (q.clientHeight > Ae ? 6 : 0) : 0, Ae)) - 2, "px")), t.visible && B.value !== !1 && ((E = (O = c.value) == null ? void 0 : O.updatePopper) == null || E.call(O));
        });
    }, G = function(O) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
            var _tmp;
            return (0, $e0qXa.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!(t.previousQuery === O || t.isOnComposition)) return [
                            3,
                            3
                        ];
                        if (t.previousQuery === null && (Pt(e.filterMethod) || Pt(e.remoteMethod))) {
                            t.previousQuery = O;
                            return [
                                2
                            ];
                        }
                        t.previousQuery = O, (0, $8B0Dy.nextTick)(function() {
                            var E, L;
                            t.visible && ((L = (E = c.value) == null ? void 0 : E.updatePopper) == null || L.call(E));
                        }), t.hoverIndex = -1, e.multiple && e.filterable && (0, $8B0Dy.nextTick)(function() {
                            if (!A.value) {
                                var E = i.value.value.length * 15 + 20;
                                t.inputLength = e.collapseTags ? Math.min(50, E) : E, T();
                            }
                            U();
                        }), e.remote && Pt(e.remoteMethod) ? (t.hoverIndex = -1, e.remoteMethod(O)) : Pt(e.filterMethod) ? (e.filterMethod(O), (0, $5wB2C.triggerRef)(g)) : (t.filteredOptionsCount = t.optionsCount, v.value.query = O, (0, $5wB2C.triggerRef)(v), (0, $5wB2C.triggerRef)(g));
                        _tmp = e.defaultFirstOption && (e.filterable || e.remote) && t.filteredOptionsCount;
                        if (!_tmp) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0, $8B0Dy.nextTick)()
                        ];
                    case 1:
                        _tmp = (_state.sent(), W());
                        _state.label = 2;
                    case 2:
                        _tmp;
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }, T = function() {
        t.currentPlaceholder !== "" && (t.currentPlaceholder = i.value.value ? "" : t.cachedPlaceHolder);
    }, W = function() {
        var O = H.value.filter(function(q) {
            return q.visible && !q.disabled && !q.states.groupDisabled;
        }), E = O.find(function(q) {
            return q.created;
        }), L = O[0];
        t.hoverIndex = st(H.value, E || L);
    }, V = function() {
        var O;
        if (e.multiple) t.selectedLabel = "";
        else {
            var L = se(e.modelValue);
            (O = L.props) != null && O.created ? (t.createdLabel = L.props.value, t.createdSelected = !0) : t.createdSelected = !1, t.selectedLabel = L.currentLabel, t.selected = L, e.filterable && (t.query = t.selectedLabel);
            return;
        }
        var E = [];
        Array.isArray(e.modelValue) && e.modelValue.forEach(function(L) {
            E.push(se(L));
        }), t.selected = E, (0, $8B0Dy.nextTick)(function() {
            U();
        });
    }, se = function(O) {
        var E;
        var L = zs(O).toLowerCase() === "object", q = zs(O).toLowerCase() === "null", ce = zs(O).toLowerCase() === "undefined";
        for(var oe = t.cachedOptions.size - 1; oe >= 0; oe--){
            var ee = ie.value[oe];
            if (L ? Lt(ee.value, e.valueKey) === Lt(O, e.valueKey) : ee.value === O) {
                E = {
                    value: O,
                    currentLabel: ee.currentLabel,
                    isDisabled: ee.isDisabled
                };
                break;
            }
        }
        if (E) return E;
        var xe = L ? O.label : !q && !ce ? O : "", Ae = {
            value: O,
            currentLabel: xe
        };
        return e.multiple && (Ae.hitState = !1), Ae;
    }, de = function() {
        setTimeout(function() {
            var O = e.valueKey;
            e.multiple ? t.selected.length > 0 ? t.hoverIndex = Math.min.apply(null, t.selected.map(function(E) {
                return H.value.findIndex(function(L) {
                    return Lt(L, O) === Lt(E, O);
                });
            })) : t.hoverIndex = -1 : t.hoverIndex = H.value.findIndex(function(E) {
                return dn(E) === dn(t.selected);
            });
        }, 300);
    }, ve = function() {
        var O, E;
        we(), (E = (O = c.value) == null ? void 0 : O.updatePopper) == null || E.call(O), e.multiple && U();
    }, we = function() {
        var O;
        t.inputWidth = (O = o.value) == null ? void 0 : O.$el.offsetWidth;
    }, Be = function() {
        e.filterable && t.query !== t.selectedLabel && (t.query = t.selectedLabel, G(t.query));
    }, Oe = xc(function() {
        Be();
    }, R.value), Ke = xc(function(O) {
        G(O.target.value);
    }, R.value), re = function(O) {
        Cc(e.modelValue, O) || n.emit(il, O);
    }, fe = function(O) {
        return u4(O, function(E) {
            return !t.disabledOptions.has(E);
        });
    }, Se = function(O) {
        if (O.code !== _n["delete"]) {
            if (O.target.value.length <= 0 && !At()) {
                var E = e.modelValue.slice(), L = fe(E);
                if (L < 0) return;
                E.splice(L, 1), n.emit(wt, E), re(E);
            }
            O.target.value.length === 1 && e.modelValue.length === 0 && (t.currentPlaceholder = t.cachedPlaceHolder);
        }
    }, ze = function(O, E) {
        var L = t.selected.indexOf(E);
        if (L > -1 && !A.value) {
            var q = e.modelValue.slice();
            q.splice(L, 1), n.emit(wt, q), re(q), n.emit("remove-tag", E.value);
        }
        O.stopPropagation(), ge();
    }, Ge = function(O) {
        O.stopPropagation();
        var E = e.multiple ? [] : "";
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (!Yt(E)) try {
            for(var _iterator = t.selected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var L = _step.value;
                L.isDisabled && E.push(L.value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        n.emit(wt, E), re(E), t.hoverIndex = -1, t.visible = !1, n.emit("clear"), ge();
    }, Je = function(O) {
        var E;
        if (e.multiple) {
            var L = (e.modelValue || []).slice(), q = st(L, O.value);
            q > -1 ? L.splice(q, 1) : (e.multipleLimit <= 0 || L.length < e.multipleLimit) && L.push(O.value), n.emit(wt, L), re(L), O.created && (t.query = "", G(""), t.inputLength = 20), e.filterable && ((E = i.value) == null || E.focus());
        } else n.emit(wt, O.value), re(O.value), t.visible = !1;
        rn(), !t.visible && (0, $8B0Dy.nextTick)(function() {
            Et(O);
        });
    }, st = function() {
        var O = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], E = arguments.length > 1 ? arguments[1] : void 0;
        if (!Jt(E)) return O.indexOf(E);
        var L = e.valueKey;
        var q = -1;
        return O.some(function(ce, xe) {
            return (0, $5wB2C.toRaw)(Lt(ce, L)) === Lt(E, L) ? (q = xe, !0) : !1;
        }), q;
    }, rn = function() {
        var O = i.value || o.value;
        O && (O == null || O.focus());
    }, Et = function(O) {
        var E, L, q, ce, xe;
        var Ae = Array.isArray(O) ? O[0] : O;
        var oe = null;
        if (Ae != null && Ae.value) {
            var ee = H.value.filter(function(me) {
                return me.value === Ae.value;
            });
            ee.length > 0 && (oe = ee[0].$el);
        }
        if (c.value && oe) {
            var ee1 = (ce = (q = (L = (E = c.value) == null ? void 0 : E.popperRef) == null ? void 0 : L.contentRef) == null ? void 0 : q.querySelector) == null ? void 0 : ce.call(q, ".".concat(s.be("dropdown", "wrap")));
            ee1 && m4(ee1, oe);
        }
        (xe = m.value) == null || xe.handleScroll();
    }, Ut = function(O) {
        t.optionsCount++, t.filteredOptionsCount++, t.options.set(O.value, O), t.cachedOptions.set(O.value, O), O.disabled && t.disabledOptions.set(O.value, O);
    }, ut = function(O, E) {
        t.options.get(O) === E && (t.optionsCount--, t.filteredOptionsCount--, t.options["delete"](O));
    }, Ot = function(O) {
        O.code !== _n.backspace && At(!1), t.inputLength = i.value.value.length * 15 + 20, U();
    }, At = function(O) {
        if (!Array.isArray(t.selected)) return;
        var E = fe(t.selected.map(function(q) {
            return q.value;
        })), L = t.selected[E];
        if (L) return O === !0 || O === !1 ? (L.hitState = O, O) : (L.hitState = !L.hitState, L.hitState);
    }, Vt = function(O) {
        var E = O.target.value;
        if (O.type === "compositionend") t.isOnComposition = !1, (0, $8B0Dy.nextTick)(function() {
            return G(E);
        });
        else {
            var L = E[E.length - 1] || "";
            t.isOnComposition = !gh(L);
        }
    }, nt = function() {
        (0, $8B0Dy.nextTick)(function() {
            return Et(t.selected);
        });
    }, K = function(O) {
        t.focused || ((e.automaticDropdown || e.filterable) && (e.filterable && !t.visible && (t.menuVisibleOnFocus = !0), t.visible = !0), t.focused = !0, n.emit("focus", O));
    }, ge = function() {
        var O, E;
        t.visible ? (O = i.value || o.value) == null || O.focus() : (E = o.value) == null || E.focus();
    }, De = function() {
        var O, E, L;
        t.visible = !1, (O = o.value) == null || O.blur(), (L = (E = a.value) == null ? void 0 : E.blur) == null || L.call(E);
    }, Xe = function(O) {
        var E, L, q;
        (E = c.value) != null && E.isFocusInsideContent(O) || (L = u.value) != null && L.isFocusInsideContent(O) || (q = l.value) != null && q.contains(O.relatedTarget) || (t.visible && qn(), t.focused = !1, n.emit("blur", O));
    }, Zt = function(O) {
        Ge(O);
    }, qn = function() {
        t.visible = !1;
    }, Fn = function(O) {
        t.visible && (O.preventDefault(), O.stopPropagation(), t.visible = !1);
    }, or = function(O) {
        O && !t.mouseEnter || A.value || (t.menuVisibleOnFocus ? t.menuVisibleOnFocus = !1 : (!c.value || !c.value.isFocusInsideContent()) && (t.visible = !t.visible), ge());
    }, Tr = function() {
        t.visible ? H.value[t.hoverIndex] && Je(H.value[t.hoverIndex]) : or();
    }, dn = function(O) {
        return Jt(O.value) ? Lt(O.value, e.valueKey) : O.value;
    }, sr = (0, $5wB2C.computed)(function() {
        return H.value.filter(function(O) {
            return O.visible;
        }).every(function(O) {
            return O.disabled;
        });
    }), Lr = (0, $5wB2C.computed)(function() {
        return e.multiple ? t.selected.slice(0, e.maxCollapseTags) : [];
    }), Hn = (0, $5wB2C.computed)(function() {
        return e.multiple ? t.selected.slice(e.maxCollapseTags) : [];
    }), Sn = function(O) {
        if (!t.visible) {
            t.visible = !0;
            return;
        }
        if (!(t.options.size === 0 || t.filteredOptionsCount === 0) && !t.isOnComposition && !sr.value) {
            O === "next" ? (t.hoverIndex++, t.hoverIndex === t.options.size && (t.hoverIndex = 0)) : O === "prev" && (t.hoverIndex--, t.hoverIndex < 0 && (t.hoverIndex = t.options.size - 1));
            var E = H.value[t.hoverIndex];
            (E.disabled === !0 || E.states.groupDisabled === !0 || !E.visible) && Sn(O), (0, $8B0Dy.nextTick)(function() {
                return Et(f.value);
            });
        }
    }, ir = function() {
        t.mouseEnter = !0;
    }, jn = function() {
        t.mouseEnter = !1;
    }, Or = function(O, E) {
        var L, q;
        ze(O, E), (q = (L = u.value) == null ? void 0 : L.updatePopper) == null || q.call(L);
    }, ar = (0, $5wB2C.computed)(function() {
        return {
            maxWidth: "".concat((0, $5wB2C.unref)(t.inputWidth) - 32 - (P.value ? 22 : 0), "px"),
            width: "100%"
        };
    });
    return {
        optionList: b,
        optionsArray: H,
        hoverOption: f,
        selectSize: Q,
        handleResize: ve,
        debouncedOnInputChange: Oe,
        debouncedQueryChange: Ke,
        deletePrevTag: Se,
        deleteTag: ze,
        deleteSelected: Ge,
        handleOptionSelect: Je,
        scrollToOption: Et,
        readonly: x,
        resetInputHeight: U,
        showClose: S,
        iconComponent: $,
        iconReverse: M,
        showNewOption: z,
        collapseTagSize: N,
        setSelected: V,
        managePlaceholder: T,
        selectDisabled: A,
        emptyText: B,
        toggleLastOptionHitState: At,
        resetInputState: Ot,
        handleComposition: Vt,
        onOptionCreate: Ut,
        onOptionDestroy: ut,
        handleMenuEnter: nt,
        handleFocus: K,
        focus: ge,
        blur: De,
        handleBlur: Xe,
        handleClearClick: Zt,
        handleClose: qn,
        handleKeydownEscape: Fn,
        toggleMenu: or,
        selectOption: Tr,
        getValueKey: dn,
        navigateOptions: Sn,
        handleDeleteTooltipTag: Or,
        dropMenuVisible: j,
        queryChange: v,
        groupQueryChange: g,
        showTagList: Lr,
        collapseTagList: Hn,
        selectTagsStyle: ar,
        reference: o,
        input: i,
        iOSInput: a,
        tooltipRef: c,
        tagTooltipRef: u,
        tags: d,
        selectWrapper: l,
        scrollbar: m,
        handleMouseEnter: ir,
        handleMouseLeave: jn
    };
};
var z5 = (0, $8B0Dy.defineComponent)({
    name: "ElOptions",
    emits: [
        "update-options"
    ],
    setup: function(e, param) {
        var t = param.slots, n = param.emit;
        var r = [];
        function s(o, i) {
            if (o.length !== i.length) return !1;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = o.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $9tk0W._)(_step.value, 1), a = _step_value[0];
                    if (o[a] != i[a]) return !1;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return !0;
        }
        return function() {
            var o, i;
            var a = (o = t["default"]) == null ? void 0 : o.call(t), c = [];
            function u(d) {
                Array.isArray(d) && d.forEach(function(l) {
                    var m, f, v, g;
                    var b = (m = (l == null ? void 0 : l.type) || {}) == null ? void 0 : m.name;
                    b === "ElOptionGroup" ? u(!Yt(l.children) && !Array.isArray(l.children) && Pt((f = l.children) == null ? void 0 : f["default"]) ? (v = l.children) == null ? void 0 : v["default"]() : l.children) : b === "ElOption" ? c.push((g = l.props) == null ? void 0 : g.label) : Array.isArray(l.children) && u(l.children);
                });
            }
            return a.length && u((i = a[0]) == null ? void 0 : i.children), s(c, r) || (r = c, n("update-options", c)), a;
        };
    }
});
var vd = "ElSelect", D5 = (0, $8B0Dy.defineComponent)({
    name: vd,
    componentName: vd,
    components: {
        ElInput: ws,
        ElSelectMenu: R5,
        ElOption: xl,
        ElOptions: z5,
        ElTag: I6,
        ElScrollbar: Jx,
        ElTooltip: oo,
        ElIcon: kt
    },
    directives: {
        ClickOutside: Vh
    },
    props: {
        name: String,
        id: String,
        modelValue: {
            type: [
                Array,
                String,
                Number,
                Boolean,
                Object
            ],
            "default": void 0
        },
        autocomplete: {
            type: String,
            "default": "off"
        },
        automaticDropdown: Boolean,
        size: {
            type: String,
            validator: H4
        },
        effect: {
            type: String,
            "default": "light"
        },
        disabled: Boolean,
        clearable: Boolean,
        filterable: Boolean,
        allowCreate: Boolean,
        loading: Boolean,
        popperClass: {
            type: String,
            "default": ""
        },
        popperOptions: {
            type: Object,
            "default": function() {
                return {};
            }
        },
        remote: Boolean,
        loadingText: String,
        noMatchText: String,
        noDataText: String,
        remoteMethod: Function,
        filterMethod: Function,
        multiple: Boolean,
        multipleLimit: {
            type: Number,
            "default": 0
        },
        placeholder: {
            type: String
        },
        defaultFirstOption: Boolean,
        reserveKeyword: {
            type: Boolean,
            "default": !0
        },
        valueKey: {
            type: String,
            "default": "value"
        },
        collapseTags: Boolean,
        collapseTagsTooltip: Boolean,
        maxCollapseTags: {
            type: Number,
            "default": 1
        },
        teleported: Tt.teleported,
        persistent: {
            type: Boolean,
            "default": !0
        },
        clearIcon: {
            type: en,
            "default": sl
        },
        fitInputWidth: Boolean,
        suffixIcon: {
            type: en,
            "default": dh
        },
        tagType: (0, $bnFl0._)((0, $6869c._)({}, Zh.type), {
            "default": "info"
        }),
        validateEvent: {
            type: Boolean,
            "default": !0
        },
        remoteShowSuffix: Boolean,
        suffixTransition: {
            type: Boolean,
            "default": !0
        },
        placement: {
            type: String,
            values: ms,
            "default": "bottom-start"
        },
        ariaLabel: {
            type: String,
            "default": void 0
        }
    },
    emits: [
        wt,
        il,
        "remove-tag",
        "clear",
        "visible-change",
        "focus",
        "blur"
    ],
    setup: function(e, t) {
        var n = Te("select"), r = Te("input"), _tn = tn(), s = _tn.t, o = _s(), i = P5(e), _B5 = B5(e, i, t), a = _B5.optionList, c = _B5.optionsArray, u = _B5.hoverOption, d = _B5.selectSize, l = _B5.readonly, m = _B5.handleResize, f = _B5.collapseTagSize, v = _B5.debouncedOnInputChange, g = _B5.debouncedQueryChange, b = _B5.deletePrevTag, h = _B5.deleteTag, w = _B5.deleteSelected, k = _B5.handleOptionSelect, x = _B5.scrollToOption, A = _B5.setSelected, S = _B5.resetInputHeight, $ = _B5.managePlaceholder, M = _B5.showClose, P = _B5.selectDisabled, R = _B5.iconComponent, B = _B5.iconReverse, H = _B5.showNewOption, ie = _B5.emptyText, z = _B5.toggleLastOptionHitState, Q = _B5.resetInputState, N = _B5.handleComposition, j = _B5.onOptionCreate, U = _B5.onOptionDestroy, G = _B5.handleMenuEnter, T = _B5.handleFocus, W = _B5.focus, V = _B5.blur, se = _B5.handleBlur, de = _B5.handleClearClick, ve = _B5.handleClose, we = _B5.handleKeydownEscape, Be = _B5.toggleMenu, Oe = _B5.selectOption, Ke = _B5.getValueKey, re = _B5.navigateOptions, fe = _B5.handleDeleteTooltipTag, Se = _B5.dropMenuVisible, ze = _B5.reference, Ge = _B5.input, Je = _B5.iOSInput, st = _B5.tooltipRef, rn = _B5.tagTooltipRef, Et = _B5.tags, Ut = _B5.selectWrapper, ut = _B5.scrollbar, Ot = _B5.queryChange, At = _B5.groupQueryChange, Vt = _B5.handleMouseEnter, nt = _B5.handleMouseLeave, K = _B5.showTagList, ge = _B5.collapseTagList, De = _B5.selectTagsStyle, _ss = (0, $5wB2C.toRefs)(i), Xe = _ss.inputWidth, Zt = _ss.selected, qn = _ss.inputLength, Fn = _ss.filteredOptionsCount, or = _ss.visible, Tr = _ss.selectedLabel, dn = _ss.hoverIndex, sr = _ss.query, Lr = _ss.inputHovering, Hn = _ss.currentPlaceholder, Sn = _ss.menuVisibleOnFocus, ir = _ss.isOnComposition, jn = _ss.options, Or = _ss.cachedOptions, ar = _ss.optionsCount, O = _ss.prefixWidth, E = (0, $5wB2C.computed)(function() {
            var $e = [
                n.b()
            ], $t = (0, $5wB2C.unref)(d);
            return $t && $e.push(n.m($t)), e.disabled && $e.push(n.m("disabled")), $e;
        }), L = (0, $5wB2C.computed)(function() {
            return [
                n.e("tags"),
                n.is("disabled", (0, $5wB2C.unref)(P))
            ];
        }), q = (0, $5wB2C.computed)(function() {
            return [
                n.b("tags-wrapper"),
                {
                    "has-prefix": (0, $5wB2C.unref)(O) && (0, $5wB2C.unref)(Zt).length
                }
            ];
        }), ce = (0, $5wB2C.computed)(function() {
            return [
                n.e("input"),
                n.is((0, $5wB2C.unref)(d)),
                n.is("disabled", (0, $5wB2C.unref)(P))
            ];
        }), xe = (0, $5wB2C.computed)(function() {
            return [
                n.e("input"),
                n.is((0, $5wB2C.unref)(d)),
                n.em("input", "iOS")
            ];
        }), Ae = (0, $5wB2C.computed)(function() {
            return [
                n.is("empty", !e.allowCreate && !!(0, $5wB2C.unref)(sr) && (0, $5wB2C.unref)(Fn) === 0)
            ];
        }), oe = (0, $5wB2C.computed)(function() {
            return {
                maxWidth: "".concat((0, $5wB2C.unref)(Xe) > 123 && (0, $5wB2C.unref)(Zt).length > e.maxCollapseTags ? (0, $5wB2C.unref)(Xe) - 123 : (0, $5wB2C.unref)(Xe) - 75, "px")
            };
        }), ee = (0, $5wB2C.computed)(function() {
            return {
                marginLeft: "".concat((0, $5wB2C.unref)(O), "px"),
                flexGrow: 1,
                width: "".concat((0, $5wB2C.unref)(qn) / ((0, $5wB2C.unref)(Xe) - 32), "%"),
                maxWidth: "".concat((0, $5wB2C.unref)(Xe) - 42, "px")
            };
        });
        (0, $8B0Dy.provide)(xs, (0, $5wB2C.reactive)({
            props: e,
            options: jn,
            optionsArray: c,
            cachedOptions: Or,
            optionsCount: ar,
            filteredOptionsCount: Fn,
            hoverIndex: dn,
            handleOptionSelect: k,
            onOptionCreate: j,
            onOptionDestroy: U,
            selectWrapper: Ut,
            selected: Zt,
            setSelected: A,
            queryChange: Ot,
            groupQueryChange: At
        })), (0, $8B0Dy.onMounted)(function() {
            i.cachedPlaceHolder = Hn.value = e.placeholder || function() {
                return s("el.select.placeholder");
            }, e.multiple && Array.isArray(e.modelValue) && e.modelValue.length > 0 && (Hn.value = ""), cs(Ut, m), e.remote && e.multiple && S(), (0, $8B0Dy.nextTick)(function() {
                var $e = ze.value && ze.value.$el;
                if ($e && (Xe.value = $e.getBoundingClientRect().width, t.slots.prefix)) {
                    var $t = $e.querySelector(".".concat(r.e("prefix")));
                    O.value = Math.max($t.getBoundingClientRect().width + 11, 30);
                }
            }), A();
        }), e.multiple && !Array.isArray(e.modelValue) && t.emit(wt, []), !e.multiple && Array.isArray(e.modelValue) && t.emit(wt, "");
        var me = (0, $5wB2C.computed)(function() {
            var $e, $t;
            return ($t = ($e = st.value) == null ? void 0 : $e.popperRef) == null ? void 0 : $t.contentRef;
        });
        return {
            isIOS: Vp,
            onOptionsRendered: function($e) {
                a.value = $e;
            },
            prefixWidth: O,
            selectSize: d,
            readonly: l,
            handleResize: m,
            collapseTagSize: f,
            debouncedOnInputChange: v,
            debouncedQueryChange: g,
            deletePrevTag: b,
            deleteTag: h,
            handleDeleteTooltipTag: fe,
            deleteSelected: w,
            handleOptionSelect: k,
            scrollToOption: x,
            inputWidth: Xe,
            selected: Zt,
            inputLength: qn,
            filteredOptionsCount: Fn,
            visible: or,
            selectedLabel: Tr,
            hoverIndex: dn,
            query: sr,
            inputHovering: Lr,
            currentPlaceholder: Hn,
            menuVisibleOnFocus: Sn,
            isOnComposition: ir,
            options: jn,
            resetInputHeight: S,
            managePlaceholder: $,
            showClose: M,
            selectDisabled: P,
            iconComponent: R,
            iconReverse: B,
            showNewOption: H,
            emptyText: ie,
            toggleLastOptionHitState: z,
            resetInputState: Q,
            handleComposition: N,
            handleMenuEnter: G,
            handleFocus: T,
            focus: W,
            blur: V,
            handleBlur: se,
            handleClearClick: de,
            handleClose: ve,
            handleKeydownEscape: we,
            toggleMenu: Be,
            selectOption: Oe,
            getValueKey: Ke,
            navigateOptions: re,
            dropMenuVisible: Se,
            reference: ze,
            input: Ge,
            iOSInput: Je,
            tooltipRef: st,
            popperPaneRef: me,
            tags: Et,
            selectWrapper: Ut,
            scrollbar: ut,
            wrapperKls: E,
            tagsKls: L,
            tagWrapperKls: q,
            inputKls: ce,
            iOSInputKls: xe,
            scrollbarKls: Ae,
            selectTagsStyle: De,
            nsSelect: n,
            tagTextStyle: oe,
            inputStyle: ee,
            handleMouseEnter: Vt,
            handleMouseLeave: nt,
            showTagList: K,
            collapseTagList: ge,
            tagTooltipRef: rn,
            contentId: o,
            hoverOption: u
        };
    }
}), N5 = [
    "disabled",
    "autocomplete",
    "aria-activedescendant",
    "aria-controls",
    "aria-expanded",
    "aria-label"
], q5 = [
    "disabled"
], F5 = {
    style: {
        height: "100%",
        display: "flex",
        "justify-content": "center",
        "align-items": "center"
    }
};
function H5(e, t, n, r, s, o) {
    var _e, _e1, _e2;
    var i = (0, $8B0Dy.resolveComponent)("el-tag"), a = (0, $8B0Dy.resolveComponent)("el-tooltip"), c = (0, $8B0Dy.resolveComponent)("el-icon"), u = (0, $8B0Dy.resolveComponent)("el-input"), d = (0, $8B0Dy.resolveComponent)("el-option"), l = (0, $8B0Dy.resolveComponent)("el-options"), m = (0, $8B0Dy.resolveComponent)("el-scrollbar"), f = (0, $8B0Dy.resolveComponent)("el-select-menu"), v = (0, $8B0Dy.resolveDirective)("click-outside");
    return (0, $8B0Dy.withDirectives)(((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
        ref: "selectWrapper",
        "class": (0, $3ZJCa.normalizeClass)(e.wrapperKls),
        onMouseenter: t[22] || (t[22] = function() {
            for(var _len = arguments.length, g = new Array(_len), _key = 0; _key < _len; _key++){
                g[_key] = arguments[_key];
            }
            return e.handleMouseEnter && (_e = e).handleMouseEnter.apply(_e, (0, $kf9Kn._)(g));
        }),
        onMouseleave: t[23] || (t[23] = function() {
            for(var _len = arguments.length, g = new Array(_len), _key = 0; _key < _len; _key++){
                g[_key] = arguments[_key];
            }
            return e.handleMouseLeave && (_e1 = e).handleMouseLeave.apply(_e1, (0, $kf9Kn._)(g));
        }),
        onClick: t[24] || (t[24] = (0, $kRi7Z.withModifiers)(function() {
            for(var _len = arguments.length, g = new Array(_len), _key = 0; _key < _len; _key++){
                g[_key] = arguments[_key];
            }
            return e.toggleMenu && (_e2 = e).toggleMenu.apply(_e2, (0, $kf9Kn._)(g));
        }, [
            "stop"
        ]))
    }, [
        (0, $8B0Dy.createVNode)(a, {
            ref: "tooltipRef",
            visible: e.dropMenuVisible,
            placement: e.placement,
            teleported: e.teleported,
            "popper-class": [
                e.nsSelect.e("popper"),
                e.popperClass
            ],
            "popper-options": e.popperOptions,
            "fallback-placements": [
                "bottom-start",
                "top-start",
                "right",
                "left"
            ],
            effect: e.effect,
            pure: "",
            trigger: "click",
            transition: "".concat(e.nsSelect.namespace.value, "-zoom-in-top"),
            "stop-popper-mouse-event": !1,
            "gpu-acceleration": !1,
            persistent: e.persistent,
            onShow: e.handleMenuEnter
        }, {
            "default": (0, $8B0Dy.withCtx)(function() {
                var _e, _e1, _e2, _e3, _e4, _e5, _e6, _e7, _e8, _e9, _e10, _e11;
                var g, b;
                return [
                    (0, $8B0Dy.createElementVNode)("div", {
                        "class": "select-trigger",
                        onMouseenter: t[20] || (t[20] = function(h) {
                            return e.inputHovering = !0;
                        }),
                        onMouseleave: t[21] || (t[21] = function(h) {
                            return e.inputHovering = !1;
                        })
                    }, [
                        e.multiple ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
                            key: 0,
                            ref: "tags",
                            tabindex: "-1",
                            "class": (0, $3ZJCa.normalizeClass)(e.tagsKls),
                            style: (0, $3ZJCa.normalizeStyle)(e.selectTagsStyle),
                            onClick: t[15] || (t[15] = function() {
                                for(var _len = arguments.length, h = new Array(_len), _key = 0; _key < _len; _key++){
                                    h[_key] = arguments[_key];
                                }
                                return e.focus && (_e = e).focus.apply(_e, (0, $kf9Kn._)(h));
                            })
                        }, [
                            e.collapseTags && e.selected.length ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $kRi7Z.Transition), {
                                key: 0,
                                onAfterLeave: e.resetInputHeight
                            }, {
                                "default": (0, $8B0Dy.withCtx)(function() {
                                    return [
                                        (0, $8B0Dy.createElementVNode)("span", {
                                            "class": (0, $3ZJCa.normalizeClass)(e.tagWrapperKls)
                                        }, [
                                            ((0, $8B0Dy.openBlock)(!0), (0, $8B0Dy.createElementBlock)((0, $8B0Dy.Fragment), null, (0, $8B0Dy.renderList)(e.showTagList, function(h) {
                                                return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)(i, {
                                                    key: e.getValueKey(h),
                                                    closable: !e.selectDisabled && !h.isDisabled,
                                                    size: e.collapseTagSize,
                                                    hit: h.hitState,
                                                    type: e.tagType,
                                                    "disable-transitions": "",
                                                    onClose: function(w) {
                                                        return e.deleteTag(w, h);
                                                    }
                                                }, {
                                                    "default": (0, $8B0Dy.withCtx)(function() {
                                                        return [
                                                            (0, $8B0Dy.createElementVNode)("span", {
                                                                "class": (0, $3ZJCa.normalizeClass)(e.nsSelect.e("tags-text")),
                                                                style: (0, $3ZJCa.normalizeStyle)(e.tagTextStyle)
                                                            }, (0, $3ZJCa.toDisplayString)(h.currentLabel), 7)
                                                        ];
                                                    }),
                                                    _: 2
                                                }, 1032, [
                                                    "closable",
                                                    "size",
                                                    "hit",
                                                    "type",
                                                    "onClose"
                                                ]);
                                            }), 128)),
                                            e.selected.length > e.maxCollapseTags ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)(i, {
                                                key: 0,
                                                closable: !1,
                                                size: e.collapseTagSize,
                                                type: e.tagType,
                                                "disable-transitions": ""
                                            }, {
                                                "default": (0, $8B0Dy.withCtx)(function() {
                                                    return [
                                                        e.collapseTagsTooltip ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)(a, {
                                                            key: 0,
                                                            ref: "tagTooltipRef",
                                                            disabled: e.dropMenuVisible,
                                                            "fallback-placements": [
                                                                "bottom",
                                                                "top",
                                                                "right",
                                                                "left"
                                                            ],
                                                            effect: e.effect,
                                                            placement: "bottom",
                                                            teleported: e.teleported
                                                        }, {
                                                            "default": (0, $8B0Dy.withCtx)(function() {
                                                                return [
                                                                    (0, $8B0Dy.createElementVNode)("span", {
                                                                        "class": (0, $3ZJCa.normalizeClass)(e.nsSelect.e("tags-text"))
                                                                    }, "+ " + (0, $3ZJCa.toDisplayString)(e.selected.length - e.maxCollapseTags), 3)
                                                                ];
                                                            }),
                                                            content: (0, $8B0Dy.withCtx)(function() {
                                                                return [
                                                                    (0, $8B0Dy.createElementVNode)("div", {
                                                                        "class": (0, $3ZJCa.normalizeClass)(e.nsSelect.e("collapse-tags"))
                                                                    }, [
                                                                        ((0, $8B0Dy.openBlock)(!0), (0, $8B0Dy.createElementBlock)((0, $8B0Dy.Fragment), null, (0, $8B0Dy.renderList)(e.collapseTagList, function(h) {
                                                                            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
                                                                                key: e.getValueKey(h),
                                                                                "class": (0, $3ZJCa.normalizeClass)(e.nsSelect.e("collapse-tag"))
                                                                            }, [
                                                                                (0, $8B0Dy.createVNode)(i, {
                                                                                    "class": "in-tooltip",
                                                                                    closable: !e.selectDisabled && !h.isDisabled,
                                                                                    size: e.collapseTagSize,
                                                                                    hit: h.hitState,
                                                                                    type: e.tagType,
                                                                                    "disable-transitions": "",
                                                                                    style: {
                                                                                        margin: "2px"
                                                                                    },
                                                                                    onClose: function(w) {
                                                                                        return e.handleDeleteTooltipTag(w, h);
                                                                                    }
                                                                                }, {
                                                                                    "default": (0, $8B0Dy.withCtx)(function() {
                                                                                        return [
                                                                                            (0, $8B0Dy.createElementVNode)("span", {
                                                                                                "class": (0, $3ZJCa.normalizeClass)(e.nsSelect.e("tags-text")),
                                                                                                style: (0, $3ZJCa.normalizeStyle)({
                                                                                                    maxWidth: e.inputWidth - 75 + "px"
                                                                                                })
                                                                                            }, (0, $3ZJCa.toDisplayString)(h.currentLabel), 7)
                                                                                        ];
                                                                                    }),
                                                                                    _: 2
                                                                                }, 1032, [
                                                                                    "closable",
                                                                                    "size",
                                                                                    "hit",
                                                                                    "type",
                                                                                    "onClose"
                                                                                ])
                                                                            ], 2);
                                                                        }), 128))
                                                                    ], 2)
                                                                ];
                                                            }),
                                                            _: 1
                                                        }, 8, [
                                                            "disabled",
                                                            "effect",
                                                            "teleported"
                                                        ])) : ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("span", {
                                                            key: 1,
                                                            "class": (0, $3ZJCa.normalizeClass)(e.nsSelect.e("tags-text"))
                                                        }, "+ " + (0, $3ZJCa.toDisplayString)(e.selected.length - e.maxCollapseTags), 3))
                                                    ];
                                                }),
                                                _: 1
                                            }, 8, [
                                                "size",
                                                "type"
                                            ])) : (0, $8B0Dy.createCommentVNode)("v-if", !0)
                                        ], 2)
                                    ];
                                }),
                                _: 1
                            }, 8, [
                                "onAfterLeave"
                            ])) : (0, $8B0Dy.createCommentVNode)("v-if", !0),
                            e.collapseTags ? (0, $8B0Dy.createCommentVNode)("v-if", !0) : ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $kRi7Z.Transition), {
                                key: 1,
                                onAfterLeave: e.resetInputHeight
                            }, {
                                "default": (0, $8B0Dy.withCtx)(function() {
                                    return [
                                        (0, $8B0Dy.createElementVNode)("span", {
                                            "class": (0, $3ZJCa.normalizeClass)(e.tagWrapperKls),
                                            style: (0, $3ZJCa.normalizeStyle)(e.prefixWidth && e.selected.length ? {
                                                marginLeft: "".concat(e.prefixWidth, "px")
                                            } : "")
                                        }, [
                                            ((0, $8B0Dy.openBlock)(!0), (0, $8B0Dy.createElementBlock)((0, $8B0Dy.Fragment), null, (0, $8B0Dy.renderList)(e.selected, function(h) {
                                                return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)(i, {
                                                    key: e.getValueKey(h),
                                                    closable: !e.selectDisabled && !h.isDisabled,
                                                    size: e.collapseTagSize,
                                                    hit: h.hitState,
                                                    type: e.tagType,
                                                    "disable-transitions": "",
                                                    onClose: function(w) {
                                                        return e.deleteTag(w, h);
                                                    }
                                                }, {
                                                    "default": (0, $8B0Dy.withCtx)(function() {
                                                        return [
                                                            (0, $8B0Dy.createElementVNode)("span", {
                                                                "class": (0, $3ZJCa.normalizeClass)(e.nsSelect.e("tags-text")),
                                                                style: (0, $3ZJCa.normalizeStyle)({
                                                                    maxWidth: e.inputWidth - 75 + "px"
                                                                })
                                                            }, (0, $3ZJCa.toDisplayString)(h.currentLabel), 7)
                                                        ];
                                                    }),
                                                    _: 2
                                                }, 1032, [
                                                    "closable",
                                                    "size",
                                                    "hit",
                                                    "type",
                                                    "onClose"
                                                ]);
                                            }), 128))
                                        ], 6)
                                    ];
                                }),
                                _: 1
                            }, 8, [
                                "onAfterLeave"
                            ])),
                            e.filterable && !e.selectDisabled ? (0, $8B0Dy.withDirectives)(((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("input", {
                                key: 2,
                                ref: "input",
                                "onUpdate:modelValue": t[0] || (t[0] = function(h) {
                                    return e.query = h;
                                }),
                                type: "text",
                                "class": (0, $3ZJCa.normalizeClass)(e.inputKls),
                                disabled: e.selectDisabled,
                                autocomplete: e.autocomplete,
                                style: (0, $3ZJCa.normalizeStyle)(e.inputStyle),
                                role: "combobox",
                                "aria-activedescendant": ((g = e.hoverOption) == null ? void 0 : g.id) || "",
                                "aria-controls": e.contentId,
                                "aria-expanded": e.dropMenuVisible,
                                "aria-label": e.ariaLabel,
                                "aria-autocomplete": "none",
                                "aria-haspopup": "listbox",
                                onFocus: t[1] || (t[1] = function() {
                                    for(var _len = arguments.length, h = new Array(_len), _key = 0; _key < _len; _key++){
                                        h[_key] = arguments[_key];
                                    }
                                    return e.handleFocus && (_e1 = e).handleFocus.apply(_e1, (0, $kf9Kn._)(h));
                                }),
                                onBlur: t[2] || (t[2] = function() {
                                    for(var _len = arguments.length, h = new Array(_len), _key = 0; _key < _len; _key++){
                                        h[_key] = arguments[_key];
                                    }
                                    return e.handleBlur && (_e2 = e).handleBlur.apply(_e2, (0, $kf9Kn._)(h));
                                }),
                                onKeyup: t[3] || (t[3] = function() {
                                    for(var _len = arguments.length, h = new Array(_len), _key = 0; _key < _len; _key++){
                                        h[_key] = arguments[_key];
                                    }
                                    return e.managePlaceholder && (_e3 = e).managePlaceholder.apply(_e3, (0, $kf9Kn._)(h));
                                }),
                                onKeydown: [
                                    t[4] || (t[4] = function() {
                                        for(var _len = arguments.length, h = new Array(_len), _key = 0; _key < _len; _key++){
                                            h[_key] = arguments[_key];
                                        }
                                        return e.resetInputState && (_e4 = e).resetInputState.apply(_e4, (0, $kf9Kn._)(h));
                                    }),
                                    t[5] || (t[5] = (0, $kRi7Z.withKeys)((0, $kRi7Z.withModifiers)(function(h) {
                                        return e.navigateOptions("next");
                                    }, [
                                        "prevent"
                                    ]), [
                                        "down"
                                    ])),
                                    t[6] || (t[6] = (0, $kRi7Z.withKeys)((0, $kRi7Z.withModifiers)(function(h) {
                                        return e.navigateOptions("prev");
                                    }, [
                                        "prevent"
                                    ]), [
                                        "up"
                                    ])),
                                    t[7] || (t[7] = (0, $kRi7Z.withKeys)(function() {
                                        for(var _len = arguments.length, h = new Array(_len), _key = 0; _key < _len; _key++){
                                            h[_key] = arguments[_key];
                                        }
                                        return e.handleKeydownEscape && (_e5 = e).handleKeydownEscape.apply(_e5, (0, $kf9Kn._)(h));
                                    }, [
                                        "esc"
                                    ])),
                                    t[8] || (t[8] = (0, $kRi7Z.withKeys)((0, $kRi7Z.withModifiers)(function() {
                                        for(var _len = arguments.length, h = new Array(_len), _key = 0; _key < _len; _key++){
                                            h[_key] = arguments[_key];
                                        }
                                        return e.selectOption && (_e6 = e).selectOption.apply(_e6, (0, $kf9Kn._)(h));
                                    }, [
                                        "stop",
                                        "prevent"
                                    ]), [
                                        "enter"
                                    ])),
                                    t[9] || (t[9] = (0, $kRi7Z.withKeys)(function() {
                                        for(var _len = arguments.length, h = new Array(_len), _key = 0; _key < _len; _key++){
                                            h[_key] = arguments[_key];
                                        }
                                        return e.deletePrevTag && (_e7 = e).deletePrevTag.apply(_e7, (0, $kf9Kn._)(h));
                                    }, [
                                        "delete"
                                    ])),
                                    t[10] || (t[10] = (0, $kRi7Z.withKeys)(function(h) {
                                        return e.visible = !1;
                                    }, [
                                        "tab"
                                    ]))
                                ],
                                onCompositionstart: t[11] || (t[11] = function() {
                                    for(var _len = arguments.length, h = new Array(_len), _key = 0; _key < _len; _key++){
                                        h[_key] = arguments[_key];
                                    }
                                    return e.handleComposition && (_e8 = e).handleComposition.apply(_e8, (0, $kf9Kn._)(h));
                                }),
                                onCompositionupdate: t[12] || (t[12] = function() {
                                    for(var _len = arguments.length, h = new Array(_len), _key = 0; _key < _len; _key++){
                                        h[_key] = arguments[_key];
                                    }
                                    return e.handleComposition && (_e9 = e).handleComposition.apply(_e9, (0, $kf9Kn._)(h));
                                }),
                                onCompositionend: t[13] || (t[13] = function() {
                                    for(var _len = arguments.length, h = new Array(_len), _key = 0; _key < _len; _key++){
                                        h[_key] = arguments[_key];
                                    }
                                    return e.handleComposition && (_e10 = e).handleComposition.apply(_e10, (0, $kf9Kn._)(h));
                                }),
                                onInput: t[14] || (t[14] = function() {
                                    for(var _len = arguments.length, h = new Array(_len), _key = 0; _key < _len; _key++){
                                        h[_key] = arguments[_key];
                                    }
                                    return e.debouncedQueryChange && (_e11 = e).debouncedQueryChange.apply(_e11, (0, $kf9Kn._)(h));
                                })
                            }, null, 46, N5)), [
                                [
                                    (0, $kRi7Z.vModelText),
                                    e.query
                                ]
                            ]) : (0, $8B0Dy.createCommentVNode)("v-if", !0)
                        ], 6)) : (0, $8B0Dy.createCommentVNode)("v-if", !0),
                        e.isIOS && !e.multiple && e.filterable && e.readonly ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("input", {
                            key: 1,
                            ref: "iOSInput",
                            "class": (0, $3ZJCa.normalizeClass)(e.iOSInputKls),
                            disabled: e.selectDisabled,
                            type: "text"
                        }, null, 10, q5)) : (0, $8B0Dy.createCommentVNode)("v-if", !0),
                        (0, $8B0Dy.createVNode)(u, {
                            id: e.id,
                            ref: "reference",
                            modelValue: e.selectedLabel,
                            "onUpdate:modelValue": t[16] || (t[16] = function(h) {
                                return e.selectedLabel = h;
                            }),
                            type: "text",
                            placeholder: typeof e.currentPlaceholder == "function" ? e.currentPlaceholder() : e.currentPlaceholder,
                            name: e.name,
                            autocomplete: e.autocomplete,
                            size: e.selectSize,
                            disabled: e.selectDisabled,
                            readonly: e.readonly,
                            "validate-event": !1,
                            "class": (0, $3ZJCa.normalizeClass)([
                                e.nsSelect.is("focus", e.visible)
                            ]),
                            tabindex: e.multiple && e.filterable ? -1 : void 0,
                            role: "combobox",
                            "aria-activedescendant": ((b = e.hoverOption) == null ? void 0 : b.id) || "",
                            "aria-controls": e.contentId,
                            "aria-expanded": e.dropMenuVisible,
                            label: e.ariaLabel,
                            "aria-autocomplete": "none",
                            "aria-haspopup": "listbox",
                            onFocus: e.handleFocus,
                            onBlur: e.handleBlur,
                            onInput: e.debouncedOnInputChange,
                            onPaste: e.debouncedOnInputChange,
                            onCompositionstart: e.handleComposition,
                            onCompositionupdate: e.handleComposition,
                            onCompositionend: e.handleComposition,
                            onKeydown: [
                                t[17] || (t[17] = (0, $kRi7Z.withKeys)((0, $kRi7Z.withModifiers)(function(h) {
                                    return e.navigateOptions("next");
                                }, [
                                    "stop",
                                    "prevent"
                                ]), [
                                    "down"
                                ])),
                                t[18] || (t[18] = (0, $kRi7Z.withKeys)((0, $kRi7Z.withModifiers)(function(h) {
                                    return e.navigateOptions("prev");
                                }, [
                                    "stop",
                                    "prevent"
                                ]), [
                                    "up"
                                ])),
                                (0, $kRi7Z.withKeys)((0, $kRi7Z.withModifiers)(e.selectOption, [
                                    "stop",
                                    "prevent"
                                ]), [
                                    "enter"
                                ]),
                                (0, $kRi7Z.withKeys)(e.handleKeydownEscape, [
                                    "esc"
                                ]),
                                t[19] || (t[19] = (0, $kRi7Z.withKeys)(function(h) {
                                    return e.visible = !1;
                                }, [
                                    "tab"
                                ]))
                            ]
                        }, (0, $8B0Dy.createSlots)({
                            suffix: (0, $8B0Dy.withCtx)(function() {
                                return [
                                    e.iconComponent && !e.showClose ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)(c, {
                                        key: 0,
                                        "class": (0, $3ZJCa.normalizeClass)([
                                            e.nsSelect.e("caret"),
                                            e.nsSelect.e("icon"),
                                            e.iconReverse
                                        ])
                                    }, {
                                        "default": (0, $8B0Dy.withCtx)(function() {
                                            return [
                                                ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $8B0Dy.resolveDynamicComponent)(e.iconComponent)))
                                            ];
                                        }),
                                        _: 1
                                    }, 8, [
                                        "class"
                                    ])) : (0, $8B0Dy.createCommentVNode)("v-if", !0),
                                    e.showClose && e.clearIcon ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)(c, {
                                        key: 1,
                                        "class": (0, $3ZJCa.normalizeClass)([
                                            e.nsSelect.e("caret"),
                                            e.nsSelect.e("icon")
                                        ]),
                                        onClick: e.handleClearClick
                                    }, {
                                        "default": (0, $8B0Dy.withCtx)(function() {
                                            return [
                                                ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $8B0Dy.resolveDynamicComponent)(e.clearIcon)))
                                            ];
                                        }),
                                        _: 1
                                    }, 8, [
                                        "class",
                                        "onClick"
                                    ])) : (0, $8B0Dy.createCommentVNode)("v-if", !0)
                                ];
                            }),
                            _: 2
                        }, [
                            e.$slots.prefix ? {
                                name: "prefix",
                                fn: (0, $8B0Dy.withCtx)(function() {
                                    return [
                                        (0, $8B0Dy.createElementVNode)("div", F5, [
                                            (0, $8B0Dy.renderSlot)(e.$slots, "prefix")
                                        ])
                                    ];
                                })
                            } : void 0
                        ]), 1032, [
                            "id",
                            "modelValue",
                            "placeholder",
                            "name",
                            "autocomplete",
                            "size",
                            "disabled",
                            "readonly",
                            "class",
                            "tabindex",
                            "aria-activedescendant",
                            "aria-controls",
                            "aria-expanded",
                            "label",
                            "onFocus",
                            "onBlur",
                            "onInput",
                            "onPaste",
                            "onCompositionstart",
                            "onCompositionupdate",
                            "onCompositionend",
                            "onKeydown"
                        ])
                    ], 32)
                ];
            }),
            content: (0, $8B0Dy.withCtx)(function() {
                return [
                    (0, $8B0Dy.createVNode)(f, null, (0, $8B0Dy.createSlots)({
                        "default": (0, $8B0Dy.withCtx)(function() {
                            return [
                                (0, $8B0Dy.withDirectives)((0, $8B0Dy.createVNode)(m, {
                                    id: e.contentId,
                                    ref: "scrollbar",
                                    tag: "ul",
                                    "wrap-class": e.nsSelect.be("dropdown", "wrap"),
                                    "view-class": e.nsSelect.be("dropdown", "list"),
                                    "class": (0, $3ZJCa.normalizeClass)(e.scrollbarKls),
                                    role: "listbox",
                                    "aria-label": e.ariaLabel,
                                    "aria-orientation": "vertical"
                                }, {
                                    "default": (0, $8B0Dy.withCtx)(function() {
                                        return [
                                            e.showNewOption ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)(d, {
                                                key: 0,
                                                value: e.query,
                                                created: !0
                                            }, null, 8, [
                                                "value"
                                            ])) : (0, $8B0Dy.createCommentVNode)("v-if", !0),
                                            (0, $8B0Dy.createVNode)(l, {
                                                onUpdateOptions: e.onOptionsRendered
                                            }, {
                                                "default": (0, $8B0Dy.withCtx)(function() {
                                                    return [
                                                        (0, $8B0Dy.renderSlot)(e.$slots, "default")
                                                    ];
                                                }),
                                                _: 3
                                            }, 8, [
                                                "onUpdateOptions"
                                            ])
                                        ];
                                    }),
                                    _: 3
                                }, 8, [
                                    "id",
                                    "wrap-class",
                                    "view-class",
                                    "class",
                                    "aria-label"
                                ]), [
                                    [
                                        (0, $kRi7Z.vShow),
                                        e.options.size > 0 && !e.loading
                                    ]
                                ]),
                                e.emptyText && (!e.allowCreate || e.loading || e.allowCreate && e.options.size === 0) ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)((0, $8B0Dy.Fragment), {
                                    key: 0
                                }, [
                                    e.$slots.empty ? (0, $8B0Dy.renderSlot)(e.$slots, "empty", {
                                        key: 0
                                    }) : ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("p", {
                                        key: 1,
                                        "class": (0, $3ZJCa.normalizeClass)(e.nsSelect.be("dropdown", "empty"))
                                    }, (0, $3ZJCa.toDisplayString)(e.emptyText), 3))
                                ], 64)) : (0, $8B0Dy.createCommentVNode)("v-if", !0)
                            ];
                        }),
                        _: 2
                    }, [
                        e.$slots.header ? {
                            name: "header",
                            fn: (0, $8B0Dy.withCtx)(function() {
                                return [
                                    (0, $8B0Dy.renderSlot)(e.$slots, "header")
                                ];
                            })
                        } : void 0,
                        e.$slots.footer ? {
                            name: "footer",
                            fn: (0, $8B0Dy.withCtx)(function() {
                                return [
                                    (0, $8B0Dy.renderSlot)(e.$slots, "footer")
                                ];
                            })
                        } : void 0
                    ]), 1024)
                ];
            }),
            _: 3
        }, 8, [
            "visible",
            "placement",
            "teleported",
            "popper-class",
            "popper-options",
            "effect",
            "transition",
            "persistent",
            "onShow"
        ])
    ], 34)), [
        [
            v,
            e.handleClose,
            e.popperPaneRef
        ]
    ]);
}
var j5 = /* @__PURE__ */ Ce(D5, [
    [
        "render",
        H5
    ],
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/select/src/select.vue"
    ]
]);
var U5 = (0, $8B0Dy.defineComponent)({
    name: "ElOptionGroup",
    componentName: "ElOptionGroup",
    props: {
        label: String,
        disabled: Boolean
    },
    setup: function(e) {
        var t = Te("select"), n = (0, $5wB2C.ref)(!0), r = (0, $8B0Dy.getCurrentInstance)(), s = (0, $5wB2C.ref)([]);
        (0, $8B0Dy.provide)(Kh, (0, $5wB2C.reactive)((0, $6869c._)({}, (0, $5wB2C.toRefs)(e))));
        var o = (0, $8B0Dy.inject)(xs);
        (0, $8B0Dy.onMounted)(function() {
            s.value = i(r.subTree);
        });
        var i = function(c) {
            var u = [];
            return Array.isArray(c.children) && c.children.forEach(function(d) {
                var _u;
                var l;
                d.type && d.type.name === "ElOption" && d.component && d.component.proxy ? u.push(d.component.proxy) : (l = d.children) != null && l.length && (_u = u).push.apply(_u, (0, $kf9Kn._)(i(d)));
            }), u;
        }, _Uo = (0, $5wB2C.toRaw)(o), a = _Uo.groupQueryChange;
        return (0, $5wB2C.watch)(a, function() {
            n.value = s.value.some(function(c) {
                return c.visible === !0;
            });
        }, {
            flush: "post"
        }), {
            visible: n,
            ns: t
        };
    }
});
function V5(e, t, n, r, s, o) {
    return (0, $8B0Dy.withDirectives)(((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("ul", {
        "class": (0, $3ZJCa.normalizeClass)(e.ns.be("group", "wrap"))
    }, [
        (0, $8B0Dy.createElementVNode)("li", {
            "class": (0, $3ZJCa.normalizeClass)(e.ns.be("group", "title"))
        }, (0, $3ZJCa.toDisplayString)(e.label), 3),
        (0, $8B0Dy.createElementVNode)("li", null, [
            (0, $8B0Dy.createElementVNode)("ul", {
                "class": (0, $3ZJCa.normalizeClass)(e.ns.b("group"))
            }, [
                (0, $8B0Dy.renderSlot)(e.$slots, "default")
            ], 2)
        ])
    ], 2)), [
        [
            (0, $kRi7Z.vShow),
            e.visible
        ]
    ]);
}
var Xh = /* @__PURE__ */ Ce(U5, [
    [
        "render",
        V5
    ],
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/select/src/option-group.vue"
    ]
]);
var Mc = jt(j5, {
    Option: xl,
    OptionGroup: Xh
}), Z5 = gs(xl);
gs(Xh);
var Cl = function() {
    return (0, $8B0Dy.inject)(Gh, {});
}, W5 = Re({
    pageSize: {
        type: Number,
        required: !0
    },
    pageSizes: {
        type: be(Array),
        "default": function() {
            return al([
                10,
                20,
                30,
                40,
                50,
                100
            ]);
        }
    },
    popperClass: {
        type: String
    },
    disabled: Boolean,
    teleported: Boolean,
    size: {
        type: String,
        values: lo
    }
}), G5 = (0, $8B0Dy.defineComponent)({
    name: "ElPaginationSizes"
}), K5 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)((0, $bnFl0._)((0, $6869c._)({}, G5), {
    props: W5,
    emits: [
        "page-size-change"
    ],
    setup: function(e, param) {
        var t = param.emit;
        var n = e, _tn = tn(), r = _tn.t, s = Te("pagination"), o = Cl(), i = (0, $5wB2C.ref)(n.pageSize);
        (0, $5wB2C.watch)(function() {
            return n.pageSizes;
        }, function(u, d) {
            if (!Cc(u, d) && Array.isArray(u)) {
                var l = u.includes(n.pageSize) ? n.pageSize : n.pageSizes[0];
                t("page-size-change", l);
            }
        }), (0, $5wB2C.watch)(function() {
            return n.pageSize;
        }, function(u) {
            i.value = u;
        });
        var a = (0, $5wB2C.computed)(function() {
            return n.pageSizes;
        });
        function c(u) {
            var d;
            u !== i.value && (i.value = u, (d = o.handleSizeChange) == null || d.call(o, Number(u)));
        }
        return function(u, d) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("span", {
                "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(s).e("sizes"))
            }, [
                (0, $8B0Dy.createVNode)((0, $5wB2C.unref)(Mc), {
                    "model-value": i.value,
                    disabled: u.disabled,
                    "popper-class": u.popperClass,
                    size: u.size,
                    teleported: u.teleported,
                    "validate-event": !1,
                    onChange: c
                }, {
                    "default": (0, $8B0Dy.withCtx)(function() {
                        return [
                            ((0, $8B0Dy.openBlock)(!0), (0, $8B0Dy.createElementBlock)((0, $8B0Dy.Fragment), null, (0, $8B0Dy.renderList)((0, $5wB2C.unref)(a), function(l) {
                                return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(Z5), {
                                    key: l,
                                    value: l,
                                    label: l + (0, $5wB2C.unref)(r)("el.pagination.pagesize")
                                }, null, 8, [
                                    "value",
                                    "label"
                                ]);
                            }), 128))
                        ];
                    }),
                    _: 1
                }, 8, [
                    "model-value",
                    "disabled",
                    "popper-class",
                    "size",
                    "teleported"
                ])
            ], 2);
        };
    }
}));
var X5 = /* @__PURE__ */ Ce(K5, [
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/pagination/src/components/sizes.vue"
    ]
]);
var Y5 = Re({
    size: {
        type: String,
        values: lo
    }
}), J5 = [
    "disabled"
], Q5 = (0, $8B0Dy.defineComponent)({
    name: "ElPaginationJumper"
}), e8 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)((0, $bnFl0._)((0, $6869c._)({}, Q5), {
    props: Y5,
    setup: function(e) {
        var t = tn().t, n = Te("pagination"), _Cl = Cl(), r = _Cl.pageCount, s = _Cl.disabled, o = _Cl.currentPage, i = _Cl.changeEvent, a = (0, $5wB2C.ref)(), c = (0, $5wB2C.computed)(function() {
            var l;
            return (l = a.value) != null ? l : o == null ? void 0 : o.value;
        });
        function u(l) {
            a.value = l ? +l : "";
        }
        function d(l) {
            l = Math.trunc(+l), i == null || i(l), a.value = void 0;
        }
        return function(l, m) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("span", {
                "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(n).e("jump")),
                disabled: (0, $5wB2C.unref)(s)
            }, [
                (0, $8B0Dy.createElementVNode)("span", {
                    "class": (0, $3ZJCa.normalizeClass)([
                        (0, $5wB2C.unref)(n).e("goto")
                    ])
                }, (0, $3ZJCa.toDisplayString)((0, $5wB2C.unref)(t)("el.pagination.goto")), 3),
                (0, $8B0Dy.createVNode)((0, $5wB2C.unref)(ws), {
                    size: l.size,
                    "class": (0, $3ZJCa.normalizeClass)([
                        (0, $5wB2C.unref)(n).e("editor"),
                        (0, $5wB2C.unref)(n).is("in-pagination")
                    ]),
                    min: 1,
                    max: (0, $5wB2C.unref)(r),
                    disabled: (0, $5wB2C.unref)(s),
                    "model-value": (0, $5wB2C.unref)(c),
                    "validate-event": !1,
                    label: (0, $5wB2C.unref)(t)("el.pagination.page"),
                    type: "number",
                    "onUpdate:modelValue": u,
                    onChange: d
                }, null, 8, [
                    "size",
                    "class",
                    "max",
                    "disabled",
                    "model-value",
                    "label"
                ]),
                (0, $8B0Dy.createElementVNode)("span", {
                    "class": (0, $3ZJCa.normalizeClass)([
                        (0, $5wB2C.unref)(n).e("classifier")
                    ])
                }, (0, $3ZJCa.toDisplayString)((0, $5wB2C.unref)(t)("el.pagination.pageClassifier")), 3)
            ], 10, J5);
        };
    }
}));
var t8 = /* @__PURE__ */ Ce(e8, [
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/pagination/src/components/jumper.vue"
    ]
]);
var n8 = Re({
    total: {
        type: Number,
        "default": 1e3
    }
}), r8 = [
    "disabled"
], o8 = (0, $8B0Dy.defineComponent)({
    name: "ElPaginationTotal"
}), s8 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)((0, $bnFl0._)((0, $6869c._)({}, o8), {
    props: n8,
    setup: function(e) {
        var t = tn().t, n = Te("pagination"), _Cl = Cl(), r = _Cl.disabled;
        return function(s, o) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("span", {
                "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(n).e("total")),
                disabled: (0, $5wB2C.unref)(r)
            }, (0, $3ZJCa.toDisplayString)((0, $5wB2C.unref)(t)("el.pagination.total", {
                total: s.total
            })), 11, r8);
        };
    }
}));
var i8 = /* @__PURE__ */ Ce(s8, [
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/pagination/src/components/total.vue"
    ]
]);
var a8 = Re({
    currentPage: {
        type: Number,
        "default": 1
    },
    pageCount: {
        type: Number,
        required: !0
    },
    pagerCount: {
        type: Number,
        "default": 7
    },
    disabled: Boolean
}), c8 = [
    "onKeyup"
], l8 = [
    "aria-current",
    "aria-label",
    "tabindex"
], u8 = [
    "tabindex",
    "aria-label"
], d8 = [
    "aria-current",
    "aria-label",
    "tabindex"
], f8 = [
    "tabindex",
    "aria-label"
], p8 = [
    "aria-current",
    "aria-label",
    "tabindex"
], h8 = (0, $8B0Dy.defineComponent)({
    name: "ElPaginationPager"
}), g8 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)((0, $bnFl0._)((0, $6869c._)({}, h8), {
    props: a8,
    emits: [
        "change"
    ],
    setup: function(e, param) {
        var t = param.emit;
        var n = e, r = Te("pager"), s = Te("icon"), _tn = tn(), o = _tn.t, i = (0, $5wB2C.ref)(!1), a = (0, $5wB2C.ref)(!1), c = (0, $5wB2C.ref)(!1), u = (0, $5wB2C.ref)(!1), d = (0, $5wB2C.ref)(!1), l = (0, $5wB2C.ref)(!1), m = (0, $5wB2C.computed)(function() {
            var x = n.pagerCount, A = (x - 1) / 2, S = Number(n.currentPage), $ = Number(n.pageCount);
            var M = !1, P = !1;
            $ > x && (S > x - A && (M = !0), S < $ - A && (P = !0));
            var R = [];
            if (M && !P) {
                var B = $ - (x - 2);
                for(var H = B; H < $; H++)R.push(H);
            } else if (!M && P) for(var B1 = 2; B1 < x; B1++)R.push(B1);
            else if (M && P) {
                var B2 = Math.floor(x / 2) - 1;
                for(var H1 = S - B2; H1 <= S + B2; H1++)R.push(H1);
            } else for(var B3 = 2; B3 < $; B3++)R.push(B3);
            return R;
        }), f = (0, $5wB2C.computed)(function() {
            return [
                "more",
                "btn-quickprev",
                s.b(),
                r.is("disabled", n.disabled)
            ];
        }), v = (0, $5wB2C.computed)(function() {
            return [
                "more",
                "btn-quicknext",
                s.b(),
                r.is("disabled", n.disabled)
            ];
        }), g = (0, $5wB2C.computed)(function() {
            return n.disabled ? -1 : 0;
        });
        (0, $8B0Dy.watchEffect)(function() {
            var x = (n.pagerCount - 1) / 2;
            i.value = !1, a.value = !1, n.pageCount > n.pagerCount && (n.currentPage > n.pagerCount - x && (i.value = !0), n.currentPage < n.pageCount - x && (a.value = !0));
        });
        function b() {
            var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
            n.disabled || (x ? c.value = !0 : u.value = !0);
        }
        function h() {
            var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
            x ? d.value = !0 : l.value = !0;
        }
        function w(x) {
            var A = x.target;
            if (A.tagName.toLowerCase() === "li" && Array.from(A.classList).includes("number")) {
                var S = Number(A.textContent);
                S !== n.currentPage && t("change", S);
            } else A.tagName.toLowerCase() === "li" && Array.from(A.classList).includes("more") && k(x);
        }
        function k(x) {
            var A = x.target;
            if (A.tagName.toLowerCase() === "ul" || n.disabled) return;
            var S = Number(A.textContent);
            var $ = n.pageCount, M = n.currentPage, P = n.pagerCount - 2;
            A.className.includes("more") && (A.className.includes("quickprev") ? S = M - P : A.className.includes("quicknext") && (S = M + P)), Number.isNaN(+S) || (S < 1 && (S = 1), S > $ && (S = $)), S !== M && t("change", S);
        }
        return function(x, A) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("ul", {
                "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(r).b()),
                onClick: k,
                onKeyup: (0, $kRi7Z.withKeys)(w, [
                    "enter"
                ])
            }, [
                x.pageCount > 0 ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("li", {
                    key: 0,
                    "class": (0, $3ZJCa.normalizeClass)([
                        [
                            (0, $5wB2C.unref)(r).is("active", x.currentPage === 1),
                            (0, $5wB2C.unref)(r).is("disabled", x.disabled)
                        ],
                        "number"
                    ]),
                    "aria-current": x.currentPage === 1,
                    "aria-label": (0, $5wB2C.unref)(o)("el.pagination.currentPage", {
                        pager: 1
                    }),
                    tabindex: (0, $5wB2C.unref)(g)
                }, " 1 ", 10, l8)) : (0, $8B0Dy.createCommentVNode)("v-if", !0),
                i.value ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("li", {
                    key: 1,
                    "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(f)),
                    tabindex: (0, $5wB2C.unref)(g),
                    "aria-label": (0, $5wB2C.unref)(o)("el.pagination.prevPages", {
                        pager: x.pagerCount - 2
                    }),
                    onMouseenter: A[0] || (A[0] = function(S) {
                        return b(!0);
                    }),
                    onMouseleave: A[1] || (A[1] = function(S) {
                        return c.value = !1;
                    }),
                    onFocus: A[2] || (A[2] = function(S) {
                        return h(!0);
                    }),
                    onBlur: A[3] || (A[3] = function(S) {
                        return d.value = !1;
                    })
                }, [
                    (c.value || d.value) && !x.disabled ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(A4), {
                        key: 0
                    })) : ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(Ru), {
                        key: 1
                    }))
                ], 42, u8)) : (0, $8B0Dy.createCommentVNode)("v-if", !0),
                ((0, $8B0Dy.openBlock)(!0), (0, $8B0Dy.createElementBlock)((0, $8B0Dy.Fragment), null, (0, $8B0Dy.renderList)((0, $5wB2C.unref)(m), function(S) {
                    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("li", {
                        key: S,
                        "class": (0, $3ZJCa.normalizeClass)([
                            [
                                (0, $5wB2C.unref)(r).is("active", x.currentPage === S),
                                (0, $5wB2C.unref)(r).is("disabled", x.disabled)
                            ],
                            "number"
                        ]),
                        "aria-current": x.currentPage === S,
                        "aria-label": (0, $5wB2C.unref)(o)("el.pagination.currentPage", {
                            pager: S
                        }),
                        tabindex: (0, $5wB2C.unref)(g)
                    }, (0, $3ZJCa.toDisplayString)(S), 11, d8);
                }), 128)),
                a.value ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("li", {
                    key: 2,
                    "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(v)),
                    tabindex: (0, $5wB2C.unref)(g),
                    "aria-label": (0, $5wB2C.unref)(o)("el.pagination.nextPages", {
                        pager: x.pagerCount - 2
                    }),
                    onMouseenter: A[4] || (A[4] = function(S) {
                        return b();
                    }),
                    onMouseleave: A[5] || (A[5] = function(S) {
                        return u.value = !1;
                    }),
                    onFocus: A[6] || (A[6] = function(S) {
                        return h();
                    }),
                    onBlur: A[7] || (A[7] = function(S) {
                        return l.value = !1;
                    })
                }, [
                    (u.value || l.value) && !x.disabled ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(M4), {
                        key: 0
                    })) : ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(Ru), {
                        key: 1
                    }))
                ], 42, f8)) : (0, $8B0Dy.createCommentVNode)("v-if", !0),
                x.pageCount > 1 ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("li", {
                    key: 3,
                    "class": (0, $3ZJCa.normalizeClass)([
                        [
                            (0, $5wB2C.unref)(r).is("active", x.currentPage === x.pageCount),
                            (0, $5wB2C.unref)(r).is("disabled", x.disabled)
                        ],
                        "number"
                    ]),
                    "aria-current": x.currentPage === x.pageCount,
                    "aria-label": (0, $5wB2C.unref)(o)("el.pagination.currentPage", {
                        pager: x.pageCount
                    }),
                    tabindex: (0, $5wB2C.unref)(g)
                }, (0, $3ZJCa.toDisplayString)(x.pageCount), 11, p8)) : (0, $8B0Dy.createCommentVNode)("v-if", !0)
            ], 42, c8);
        };
    }
}));
var m8 = /* @__PURE__ */ Ce(g8, [
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/pagination/src/components/pager.vue"
    ]
]);
var vt = function(e) {
    return typeof e != "number";
}, Yh = Re({
    pageSize: Number,
    defaultPageSize: Number,
    total: Number,
    pageCount: Number,
    pagerCount: {
        type: Number,
        validator: function(e) {
            return Ye(e) && Math.trunc(e) === e && e > 4 && e < 22 && e % 2 === 1;
        },
        "default": 7
    },
    currentPage: Number,
    defaultCurrentPage: Number,
    layout: {
        type: String,
        "default": [
            "prev",
            "pager",
            "next",
            "jumper",
            "->",
            "total"
        ].join(", ")
    },
    pageSizes: {
        type: be(Array),
        "default": function() {
            return al([
                10,
                20,
                30,
                40,
                50,
                100
            ]);
        }
    },
    popperClass: {
        type: String,
        "default": ""
    },
    prevText: {
        type: String,
        "default": ""
    },
    prevIcon: {
        type: en,
        "default": function() {
            return b4;
        }
    },
    nextText: {
        type: String,
        "default": ""
    },
    nextIcon: {
        type: en,
        "default": function() {
            return w4;
        }
    },
    teleported: {
        type: Boolean,
        "default": !0
    },
    small: Boolean,
    background: Boolean,
    disabled: Boolean,
    hideOnSinglePage: Boolean
}), v8 = {
    "update:current-page": function(e) {
        return Ye(e);
    },
    "update:page-size": function(e) {
        return Ye(e);
    },
    "size-change": function(e) {
        return Ye(e);
    },
    "current-change": function(e) {
        return Ye(e);
    },
    "prev-click": function(e) {
        return Ye(e);
    },
    "next-click": function(e) {
        return Ye(e);
    }
}, _d = "ElPagination";
var _8 = (0, $8B0Dy.defineComponent)({
    name: _d,
    props: Yh,
    emits: v8,
    setup: function(e, param) {
        var t = param.emit, n = param.slots;
        var _tn = tn(), r = _tn.t, s = Te("pagination"), o = (0, $8B0Dy.getCurrentInstance)().vnode.props || {}, i = "onUpdate:currentPage" in o || "onUpdate:current-page" in o || "onCurrentChange" in o, a = "onUpdate:pageSize" in o || "onUpdate:page-size" in o || "onSizeChange" in o, c = (0, $5wB2C.computed)(function() {
            if (vt(e.total) && vt(e.pageCount) || !vt(e.currentPage) && !i) return !1;
            if (e.layout.includes("sizes")) {
                if (vt(e.pageCount)) {
                    if (!vt(e.total) && !vt(e.pageSize) && !a) return !1;
                } else if (!a) return !1;
            }
            return !0;
        }), u = (0, $5wB2C.ref)(vt(e.defaultPageSize) ? 10 : e.defaultPageSize), d = (0, $5wB2C.ref)(vt(e.defaultCurrentPage) ? 1 : e.defaultCurrentPage), l = (0, $5wB2C.computed)({
            get: function() {
                return vt(e.pageSize) ? u.value : e.pageSize;
            },
            set: function(k) {
                vt(e.pageSize) && (u.value = k), a && (t("update:page-size", k), t("size-change", k));
            }
        }), m = (0, $5wB2C.computed)(function() {
            var k = 0;
            return vt(e.pageCount) ? vt(e.total) || (k = Math.max(1, Math.ceil(e.total / l.value))) : k = e.pageCount, k;
        }), f = (0, $5wB2C.computed)({
            get: function() {
                return vt(e.currentPage) ? d.value : e.currentPage;
            },
            set: function(k) {
                var x = k;
                k < 1 ? x = 1 : k > m.value && (x = m.value), vt(e.currentPage) && (d.value = x), i && (t("update:current-page", x), t("current-change", x));
            }
        });
        (0, $5wB2C.watch)(m, function(k) {
            f.value > k && (f.value = k);
        });
        function v(k) {
            f.value = k;
        }
        function g(k) {
            l.value = k;
            var x = m.value;
            f.value > x && (f.value = x);
        }
        function b() {
            e.disabled || (f.value -= 1, t("prev-click", f.value));
        }
        function h() {
            e.disabled || (f.value += 1, t("next-click", f.value));
        }
        function w(k, x) {
            k && (k.props || (k.props = {}), k.props["class"] = [
                k.props["class"],
                x
            ].join(" "));
        }
        return (0, $8B0Dy.provide)(Gh, {
            pageCount: m,
            disabled: (0, $5wB2C.computed)(function() {
                return e.disabled;
            }),
            currentPage: f,
            changeEvent: v,
            handleSizeChange: g
        }), function() {
            var k, x;
            if (!c.value) return r("el.pagination.deprecationWarning"), null;
            if (!e.layout || e.hideOnSinglePage && m.value <= 1) return null;
            var A = [], S = [], $ = (0, $8B0Dy.h)("div", {
                "class": s.e("rightwrapper")
            }, S), M = {
                prev: (0, $8B0Dy.h)(w5, {
                    disabled: e.disabled,
                    currentPage: f.value,
                    prevText: e.prevText,
                    prevIcon: e.prevIcon,
                    onClick: b
                }),
                jumper: (0, $8B0Dy.h)(t8, {
                    size: e.small ? "small" : "default"
                }),
                pager: (0, $8B0Dy.h)(m8, {
                    currentPage: f.value,
                    pageCount: m.value,
                    pagerCount: e.pagerCount,
                    onChange: v,
                    disabled: e.disabled
                }),
                next: (0, $8B0Dy.h)(A5, {
                    disabled: e.disabled,
                    currentPage: f.value,
                    pageCount: m.value,
                    nextText: e.nextText,
                    nextIcon: e.nextIcon,
                    onClick: h
                }),
                sizes: (0, $8B0Dy.h)(X5, {
                    pageSize: l.value,
                    pageSizes: e.pageSizes,
                    popperClass: e.popperClass,
                    disabled: e.disabled,
                    teleported: e.teleported,
                    size: e.small ? "small" : "default"
                }),
                slot: (x = (k = n == null ? void 0 : n["default"]) == null ? void 0 : k.call(n)) != null ? x : null,
                total: (0, $8B0Dy.h)(i8, {
                    total: vt(e.total) ? 0 : e.total
                })
            }, P = e.layout.split(",").map(function(B) {
                return B.trim();
            });
            var R = !1;
            return P.forEach(function(B) {
                if (B === "->") {
                    R = !0;
                    return;
                }
                R ? S.push(M[B]) : A.push(M[B]);
            }), w(A[0], s.is("first")), w(A[A.length - 1], s.is("last")), R && S.length > 0 && (w(S[0], s.is("first")), w(S[S.length - 1], s.is("last")), A.push($)), (0, $8B0Dy.h)("div", {
                "class": [
                    s.b(),
                    s.is("background", e.background),
                    (0, $aRIHe._)({}, s.m("small"), e.small)
                ]
            }, A);
        };
    }
});
var b8 = jt(_8), Jh = Re({
    trigger: ro.trigger,
    placement: Xs.placement,
    disabled: ro.disabled,
    visible: Tt.visible,
    transition: Tt.transition,
    popperOptions: Xs.popperOptions,
    tabindex: Xs.tabindex,
    content: Tt.content,
    popperStyle: Tt.popperStyle,
    popperClass: Tt.popperClass,
    enterable: (0, $bnFl0._)((0, $6869c._)({}, Tt.enterable), {
        "default": !0
    }),
    effect: (0, $bnFl0._)((0, $6869c._)({}, Tt.effect), {
        "default": "light"
    }),
    teleported: Tt.teleported,
    title: String,
    width: {
        type: [
            String,
            Number
        ],
        "default": 150
    },
    offset: {
        type: Number,
        "default": void 0
    },
    showAfter: {
        type: Number,
        "default": 0
    },
    hideAfter: {
        type: Number,
        "default": 200
    },
    autoClose: {
        type: Number,
        "default": 0
    },
    showArrow: {
        type: Boolean,
        "default": !0
    },
    persistent: {
        type: Boolean,
        "default": !0
    },
    "onUpdate:visible": {
        type: Function
    }
}), y8 = {
    "update:visible": function(e) {
        return ol(e);
    },
    "before-enter": function() {
        return !0;
    },
    "before-leave": function() {
        return !0;
    },
    "after-enter": function() {
        return !0;
    },
    "after-leave": function() {
        return !0;
    }
}, w8 = "onUpdate:visible", k8 = (0, $8B0Dy.defineComponent)({
    name: "ElPopover"
}), x8 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)((0, $bnFl0._)((0, $6869c._)({}, k8), {
    props: Jh,
    emits: y8,
    setup: function(e, param) {
        var t = param.expose, n = param.emit;
        var r = e, s = (0, $5wB2C.computed)(function() {
            return r[w8];
        }), o = Te("popover"), i = (0, $5wB2C.ref)(), a = (0, $5wB2C.computed)(function() {
            var b;
            return (b = (0, $5wB2C.unref)(i)) == null ? void 0 : b.popperRef;
        }), c = (0, $5wB2C.computed)(function() {
            return [
                {
                    width: yr(r.width)
                },
                r.popperStyle
            ];
        }), u = (0, $5wB2C.computed)(function() {
            return [
                o.b(),
                r.popperClass,
                (0, $aRIHe._)({}, o.m("plain"), !!r.content)
            ];
        }), d = (0, $5wB2C.computed)(function() {
            return r.transition === "".concat(o.namespace.value, "-fade-in-linear");
        }), l = function() {
            var b;
            (b = i.value) == null || b.hide();
        }, m = function() {
            n("before-enter");
        }, f = function() {
            n("before-leave");
        }, v = function() {
            n("after-enter");
        }, g = function() {
            n("update:visible", !1), n("after-leave");
        };
        return t({
            popperRef: a,
            hide: l
        }), function(b, h) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(oo), (0, $8B0Dy.mergeProps)({
                ref_key: "tooltipRef",
                ref: i
            }, b.$attrs, {
                trigger: b.trigger,
                placement: b.placement,
                disabled: b.disabled,
                visible: b.visible,
                transition: b.transition,
                "popper-options": b.popperOptions,
                tabindex: b.tabindex,
                content: b.content,
                offset: b.offset,
                "show-after": b.showAfter,
                "hide-after": b.hideAfter,
                "auto-close": b.autoClose,
                "show-arrow": b.showArrow,
                "aria-label": b.title,
                effect: b.effect,
                enterable: b.enterable,
                "popper-class": (0, $5wB2C.unref)(u),
                "popper-style": (0, $5wB2C.unref)(c),
                teleported: b.teleported,
                persistent: b.persistent,
                "gpu-acceleration": (0, $5wB2C.unref)(d),
                "onUpdate:visible": (0, $5wB2C.unref)(s),
                onBeforeShow: m,
                onBeforeHide: f,
                onShow: v,
                onHide: g
            }), {
                content: (0, $8B0Dy.withCtx)(function() {
                    return [
                        b.title ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
                            key: 0,
                            "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(o).e("title")),
                            role: "title"
                        }, (0, $3ZJCa.toDisplayString)(b.title), 3)) : (0, $8B0Dy.createCommentVNode)("v-if", !0),
                        (0, $8B0Dy.renderSlot)(b.$slots, "default", {}, function() {
                            return [
                                (0, $8B0Dy.createTextVNode)((0, $3ZJCa.toDisplayString)(b.content), 1)
                            ];
                        })
                    ];
                }),
                "default": (0, $8B0Dy.withCtx)(function() {
                    return [
                        b.$slots.reference ? (0, $8B0Dy.renderSlot)(b.$slots, "reference", {
                            key: 0
                        }) : (0, $8B0Dy.createCommentVNode)("v-if", !0)
                    ];
                }),
                _: 3
            }, 16, [
                "trigger",
                "placement",
                "disabled",
                "visible",
                "transition",
                "popper-options",
                "tabindex",
                "content",
                "offset",
                "show-after",
                "hide-after",
                "auto-close",
                "show-arrow",
                "aria-label",
                "effect",
                "enterable",
                "popper-class",
                "popper-style",
                "teleported",
                "persistent",
                "gpu-acceleration",
                "onUpdate:visible"
            ]);
        };
    }
}));
var C8 = /* @__PURE__ */ Ce(x8, [
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/popover/src/popover.vue"
    ]
]);
var bd = function(e, t) {
    var n = t.arg || t.value, r = n == null ? void 0 : n.popperRef;
    r && (r.triggerRef = e);
};
var S8 = {
    mounted: function(e, t) {
        bd(e, t);
    },
    updated: function(e, t) {
        bd(e, t);
    }
};
var E8 = "popover", A8 = N4(S8, E8), $8 = jt(C8, {
    directive: A8
}), M8 = Re({
    animated: {
        type: Boolean,
        "default": !1
    },
    count: {
        type: Number,
        "default": 1
    },
    rows: {
        type: Number,
        "default": 3
    },
    loading: {
        type: Boolean,
        "default": !0
    },
    throttle: {
        type: Number
    }
}), I8 = Re({
    variant: {
        type: String,
        values: [
            "circle",
            "rect",
            "h1",
            "h3",
            "text",
            "caption",
            "p",
            "image",
            "button"
        ],
        "default": "text"
    }
}), T8 = (0, $8B0Dy.defineComponent)({
    name: "ElSkeletonItem"
}), L8 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)((0, $bnFl0._)((0, $6869c._)({}, T8), {
    props: I8,
    setup: function(e) {
        var t = Te("skeleton");
        return function(n, r) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
                "class": (0, $3ZJCa.normalizeClass)([
                    (0, $5wB2C.unref)(t).e("item"),
                    (0, $5wB2C.unref)(t).e(n.variant)
                ])
            }, [
                n.variant === "image" ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(P4), {
                    key: 0
                })) : (0, $8B0Dy.createCommentVNode)("v-if", !0)
            ], 2);
        };
    }
}));
var Xo = /* @__PURE__ */ Ce(L8, [
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/skeleton/src/skeleton-item.vue"
    ]
]);
var O8 = (0, $8B0Dy.defineComponent)({
    name: "ElSkeleton"
}), R8 = /* @__PURE__ */ (0, $8B0Dy.defineComponent)((0, $bnFl0._)((0, $6869c._)({}, O8), {
    props: M8,
    setup: function(e, param) {
        var t = param.expose;
        var n = e, r = Te("skeleton"), s = ix((0, $5wB2C.toRef)(n, "loading"), n.throttle);
        return t({
            uiLoading: s
        }), function(o, i) {
            return (0, $5wB2C.unref)(s) ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", (0, $8B0Dy.mergeProps)({
                key: 0,
                "class": [
                    (0, $5wB2C.unref)(r).b(),
                    (0, $5wB2C.unref)(r).is("animated", o.animated)
                ]
            }, o.$attrs), [
                ((0, $8B0Dy.openBlock)(!0), (0, $8B0Dy.createElementBlock)((0, $8B0Dy.Fragment), null, (0, $8B0Dy.renderList)(o.count, function(a) {
                    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)((0, $8B0Dy.Fragment), {
                        key: a
                    }, [
                        o.loading ? (0, $8B0Dy.renderSlot)(o.$slots, "template", {
                            key: a
                        }, function() {
                            return [
                                (0, $8B0Dy.createVNode)(Xo, {
                                    "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(r).is("first")),
                                    variant: "p"
                                }, null, 8, [
                                    "class"
                                ]),
                                ((0, $8B0Dy.openBlock)(!0), (0, $8B0Dy.createElementBlock)((0, $8B0Dy.Fragment), null, (0, $8B0Dy.renderList)(o.rows, function(c) {
                                    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)(Xo, {
                                        key: c,
                                        "class": (0, $3ZJCa.normalizeClass)([
                                            (0, $5wB2C.unref)(r).e("paragraph"),
                                            (0, $5wB2C.unref)(r).is("last", c === o.rows && o.rows > 1)
                                        ]),
                                        variant: "p"
                                    }, null, 8, [
                                        "class"
                                    ]);
                                }), 128))
                            ];
                        }) : (0, $8B0Dy.createCommentVNode)("v-if", !0)
                    ], 64);
                }), 128))
            ], 16)) : (0, $8B0Dy.renderSlot)(o.$slots, "default", (0, $3ZJCa.normalizeProps)((0, $8B0Dy.mergeProps)({
                key: 1
            }, o.$attrs)));
        };
    }
}));
var P8 = /* @__PURE__ */ Ce(R8, [
    [
        "__file",
        "/home/runner/work/element-plus/element-plus/packages/components/skeleton/src/skeleton.vue"
    ]
]);
var B8 = jt(P8, {
    SkeletonItem: Xo
}), Nr = gs(Xo), z8 = "TOOLTIP_APPEND_TO";
function D8() {
    return (0, $8B0Dy.inject)(z8, (0, $5wB2C.computed)(function() {}));
}
var Qh = "data:image/svg+xml,%3csvg%20viewBox='0%200%2012%2012'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill='currentColor'%20d='M1%200.642857C1%200.287817%201.27473%200%201.61364%200H4.06818C4.40708%200%204.68182%200.287817%204.68182%200.642857V4.5C4.68182%204.85504%204.40708%205.14286%204.06818%205.14286H1.61364C1.27473%205.14286%201%204.85504%201%204.5V0.642857ZM2.22727%201.28571V3.85714H3.45455V1.28571H2.22727ZM6.31818%200.642857C6.31818%200.287817%206.59292%200%206.93182%200H8.15909C8.49799%200%208.77273%200.287817%208.77273%200.642857V3.85714H9.38636C9.72527%203.85714%2010%204.14496%2010%204.5C10%204.85504%209.72527%205.14286%209.38636%205.14286H6.93182C6.59292%205.14286%206.31818%204.85504%206.31818%204.5C6.31818%204.14496%206.59292%203.85714%206.93182%203.85714H7.54545V1.28571H6.93182C6.59292%201.28571%206.31818%200.997897%206.31818%200.642857ZM1%207.5C1%207.14496%201.27473%206.85714%201.61364%206.85714H2.84091C3.17981%206.85714%203.45455%207.14496%203.45455%207.5V10.7143H4.06818C4.40708%2010.7143%204.68182%2011.0021%204.68182%2011.3571C4.68182%2011.7122%204.40708%2012%204.06818%2012H1.61364C1.27473%2012%201%2011.7122%201%2011.3571C1%2011.0021%201.27473%2010.7143%201.61364%2010.7143H2.22727V8.14286H1.61364C1.27473%208.14286%201%207.85504%201%207.5ZM6.31818%207.5C6.31818%207.14496%206.59292%206.85714%206.93182%206.85714H9.38636C9.72527%206.85714%2010%207.14496%2010%207.5V11.3571C10%2011.7122%209.72527%2012%209.38636%2012H6.93182C6.59292%2012%206.31818%2011.7122%206.31818%2011.3571V7.5ZM7.54545%208.14286V10.7143H8.77273V8.14286H7.54545Z'%20/%3e%3c/svg%3e", N8 = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M13.2251%201.02271C13.5179%200.968554%2013.8195%201.00233%2014.0913%201.11939L14.2055%201.17506L14.3149%201.23951C14.5275%201.37763%2014.7014%201.56758%2014.8208%201.79127L14.8764%201.90553L14.9214%202.02467C15.0145%202.30522%2015.0227%202.60793%2014.9438%202.89478C14.9403%202.90772%2014.9372%202.92106%2014.9331%202.93385L13.0132%208.95338L12.9965%209.00025H19.9995C20.3769%208.99952%2020.7471%209.10523%2021.0669%209.30592C21.3874%209.50712%2021.6437%209.79562%2021.8071%2010.137C21.9704%2010.4783%2022.0341%2010.8588%2021.9897%2011.2346C21.9453%2011.6105%2021.7946%2011.9661%2021.5561%2012.26C21.5375%2012.2829%2021.5181%2012.3052%2021.4975%2012.3264L11.5971%2022.5266L11.5962%2022.5256C11.3774%2022.7595%2011.0907%2022.9194%2010.7749%2022.9778C10.4403%2023.0397%2010.0944%2022.9859%209.7944%2022.8254C9.4944%2022.665%209.25775%2022.4066%209.1235%2022.094C8.98941%2021.7815%208.96593%2021.4327%209.05612%2021.1047L9.06686%2021.0657L10.9868%2015.0462L11.0034%2015.0003H3.99948C3.62236%2015.0008%203.25253%2014.8941%202.93307%2014.6936C2.61276%2014.4925%202.35617%2014.2047%202.19284%2013.8635C2.02947%2013.5221%201.96581%2013.1408%202.01022%2012.7649C2.05468%2012.3892%202.20544%2012.0333%202.44382%2011.7395C2.46238%2011.7167%202.4819%2011.6942%202.50241%2011.6731L12.4028%201.47389C12.6215%201.23984%2012.9091%201.08117%2013.2251%201.02271Z'%20fill='currentColor'%20fill-opacity='0.9'%20style='fill:currentColor;fill-opacity:0.9;'/%3e%3c/svg%3e", q8 = "data:image/svg+xml,%3csvg%20viewBox='0%200%20512%20512'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M224.975%2049.429c17.138-17.139%2044.919-17.139%2062.057%200l175.546%20175.546a43.8%2043.8%200%200%201%209.347%2013.817l.146.349q.125.298.243.598.1.25.197.5l.147.388q.133.356.261.716l.09.257q.141.407.275.818l.044.136a39%2039%200%200%201%20.306.988%2043.9%2043.9%200%200%201%201.802%2012.473c0%2012.497-5.225%2023.774-13.608%2031.767L287.032%20462.578c-17.138%2017.138-44.919%2017.138-62.057%200s-17.139-44.92%200-62.059l100.618-100.618H80.458c-24.238%200-43.887-19.649-43.887-43.886s19.65-43.887%2043.887-43.887h245.158L224.975%20111.486c-17.139-17.138-17.139-44.919%200-62.057'%20fill='currentColor'/%3e%3c/svg%3e", F8 = "data:image/svg+xml,%3csvg%20viewBox='0%200%20512%20512'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M209.675%20387.718c20.945%2010.711%2030.794%2035.749%2022.073%2058.141-9.306%2023.886-36.221%2035.695-60.107%2026.389-29.106-11.34-56.354-28.746-79.744-52.137-20.47-20.47-36.356-43.894-47.607-68.932l-4.53-10.812-1.517-4.508c-6.284-22.673%205.511-46.874%2027.906-55.599%2022.392-8.721%2047.431%201.129%2058.141%2022.073l1.945%204.338%202.735%206.453c6.714%2014.943%2016.204%2028.982%2028.568%2041.346%2014.132%2014.132%2030.44%2024.54%2047.799%2031.304zM91.897%2091.905c23.39-23.39%2050.638-40.796%2079.744-52.137l4.508-1.517c22.673-6.284%2046.874%205.512%2055.599%2027.906%209.303%2023.885-2.526%2050.781-26.411%2060.086-17.359%206.763-33.667%2017.171-47.799%2031.303-12.364%2012.364-21.854%2026.403-28.568%2041.347l-2.735%206.453-1.945%204.337c-10.71%2020.945-35.75%2030.794-58.141%2022.073-23.886-9.306-35.695-36.221-26.39-60.107%2011.341-29.106%2028.747-56.353%2052.138-79.744M354.462%20354.47c12.364-12.364%2021.854-26.403%2028.568-41.346l2.735-6.453%201.945-4.338c10.71-20.944%2035.749-30.794%2058.141-22.073%2022.394%208.725%2034.19%2032.926%2027.906%2055.599l-1.517%204.508-4.53%2010.812c-11.251%2025.038-27.137%2048.462-47.607%2068.932-23.39%2023.391-50.638%2040.797-79.744%2052.137-23.886%209.306-50.801-2.503-60.107-26.389-9.303-23.885%202.526-50.78%2026.411-60.085l6.453-2.735c14.943-6.715%2028.982-16.205%2041.346-28.569m65.641-262.565c23.391%2023.391%2040.796%2050.638%2052.137%2079.744%209.306%2023.886-2.503%2050.801-26.389%2060.107-22.392%208.721-47.431-1.128-58.141-22.073l-1.945-4.337-2.735-6.453c-6.714-14.944-16.204-28.983-28.568-41.347-14.132-14.132-30.44-24.54-47.799-31.303-23.885-9.305-35.714-36.201-26.411-60.086%209.306-23.886%2036.221-35.694%2060.107-26.389l10.812%204.53c25.038%2011.25%2048.462%2027.137%2068.932%2047.607'%20fill='currentColor'%20/%3e%3c/svg%3e", e2 = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9%203L9%2021'%20stroke='currentColor'%20style='stroke-opacity:1;'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M15%203L15%2021'%20stroke='currentColor'%20style='stroke-opacity:1;'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", t2 = "data:image/svg+xml,%3csvg%20viewBox='0%200%2016%2016'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill='currentColor'%20d='M13.3333%2012.5525V12.4489C14.2278%2012.0756%2014.8571%2011.1925%2014.8571%2010.1632V3.61924C14.8571%202.96252%2014.5962%202.3327%2014.1318%201.86832C13.6675%201.40395%2013.0376%201.14307%2012.3809%201.14307H5.90473C5.38113%201.14296%204.87098%201.30883%204.44756%201.61684C4.02414%201.92485%203.70926%202.35915%203.54816%202.85734H3.39501C2.70016%202.85734%202.10892%203.10191%201.70206%203.5842C1.30739%204.05124%201.14282%204.67372%201.14282%205.33352V12.0002C1.14282%2012.8078%201.43463%2013.5346%201.98854%2014.0573C2.54168%2014.5777%203.30892%2014.8535%204.19044%2014.8535H7.17711L10.2826%2014.8573H10.2842C11.0278%2014.8611%2011.7645%2014.7049%2012.336%2014.3392C12.9303%2013.9582%2013.3333%2013.3525%2013.3333%2012.5525ZM3.39501%204.0002H3.42854V10.1625C3.42854%2010.8192%203.68942%2011.449%204.1538%2011.9134C4.61817%2012.3777%205.248%2012.6386%205.90473%2012.6386H12.1874C12.163%2012.9571%2012.003%2013.1948%2011.7196%2013.3761C11.3897%2013.588%2010.8891%2013.7175%2010.2887%2013.7144H10.2857L7.17558%2013.7106H4.19044C3.54816%2013.7106%203.07806%2013.5125%202.7733%2013.2253C2.47006%2012.9403%202.28568%2012.5259%202.28568%2012.0002V5.33352C2.28568%204.84971%202.40758%204.52057%202.5752%204.32096C2.73139%204.13658%202.98054%204.0002%203.39501%204.0002ZM8.01673%203.80972H11.619C11.7706%203.80972%2011.9159%203.86992%2012.0231%203.97709C12.1302%204.08425%2012.1904%204.22959%2012.1904%204.38115V7.98418C12.1904%208.13573%2012.1302%208.28107%2012.0231%208.38823C11.9159%208.4954%2011.7706%208.5556%2011.619%208.5556C11.4675%208.5556%2011.3221%208.4954%2011.215%208.38823C11.1078%208.28107%2011.0476%208.13573%2011.0476%207.98418V5.76019L7.07044%209.73731C7.0177%209.79186%206.95463%209.83536%206.8849%209.86528C6.81517%209.89519%206.74018%209.91092%206.6643%209.91154C6.58843%209.91217%206.51319%209.89767%206.44298%209.86891C6.37277%209.84014%206.30899%209.79768%206.25536%209.74401C6.20173%209.69033%206.15933%209.62651%206.13063%209.55627C6.10193%209.48603%206.08751%209.41078%206.0882%209.3349C6.0889%209.25903%206.1047%209.18406%206.13468%209.11435C6.16466%209.04465%206.20822%208.98162%206.26282%208.92893L10.24%204.95257H8.01673C7.86517%204.95257%207.71983%204.89237%207.61267%204.7852C7.5055%204.67804%207.4453%204.5327%207.4453%204.38115C7.4453%204.22959%207.5055%204.08425%207.61267%203.97709C7.71983%203.86992%207.86517%203.80972%208.01673%203.80972Z'%20/%3e%3c/svg%3e", H8 = "data:image/svg+xml,%3csvg%20viewBox='0%200%20512%20512'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M416.648%20227.85c23.324%200%2042.232%2018.908%2042.232%2042.232v84.462c0%2038.872-31.513%2070.384-70.385%2070.385H191.423v36.402c0%2012.541-15.163%2018.822-24.031%209.954l-78.63-78.631c-5.498-5.497-5.498-14.411%200-19.908l78.63-78.631c8.868-8.868%2024.031-2.587%2024.031%209.954v36.398h182.995v-70.385c0-23.324%2018.907-42.231%2042.23-42.232M304.028%2050.669c0-12.541%2015.163-18.822%2024.031-9.954l78.63%2078.631c5.498%205.497%205.498%2014.41%200%2019.908l-78.63%2078.631c-8.868%208.867-24.031%202.587-24.031-9.954v-36.38H121.033v70.385c0%2023.324-18.908%2042.231-42.231%2042.231s-42.23-18.907-42.23-42.231v-84.462c0-38.872%2031.512-70.385%2070.384-70.385h197.072z'%20fill='currentColor'/%3e%3c/svg%3e", j8 = "data:image/svg+xml,%3csvg%20viewBox='0%200%20512%20512'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M275.114%2036.8c22.13%202.247%2039.401%2020.934%2039.401%2043.657v307.204h73.142c24.237%200%2043.886%2019.648%2043.886%2043.885s-19.648%2043.886-43.886%2043.886H153.6c-24.238-.001-43.886-19.649-43.886-43.886s19.648-43.885%2043.886-43.885h73.143V124.343H153.6c-24.238%200-43.886-19.649-43.886-43.886s19.648-43.885%2043.886-43.886h117.029z'%20fill='currentColor'/%3e%3c/svg%3e", n2 = "data:image/svg+xml,%3csvg%20viewBox='0%20-1%2014%2014'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill='currentColor'%20d='M1.63636%200H8.18182C9.08556%200%209.81818%200.732625%209.81818%201.63636C9.81818%202.5401%209.08556%203.27273%208.18182%203.27273H1.63636C0.732626%203.27273%200%202.5401%200%201.63636C0%200.732625%200.732625%200%201.63636%200ZM1.63636%201.09091C1.33512%201.09091%201.09091%201.33512%201.09091%201.63636C1.09091%201.93761%201.33512%202.18182%201.63636%202.18182H8.18182C8.48306%202.18182%208.72727%201.93761%208.72727%201.63636C8.72727%201.33512%208.48306%201.09091%208.18182%201.09091H1.63636Z%20M7.09091%204.36353H11.4545C12.3583%204.36353%2013.0909%205.09615%2013.0909%205.99989C13.0909%206.90363%2012.3583%207.63625%2011.4545%207.63625H7.09091C6.18717%207.63625%205.45454%206.90363%205.45454%205.99989C5.45454%205.09615%206.18717%204.36353%207.09091%204.36353ZM7.09091%205.45443C6.78966%205.45443%206.54545%205.69864%206.54545%205.99989C6.54545%206.30114%206.78966%206.54534%207.09091%206.54534H11.4545C11.7558%206.54534%2012%206.30114%2012%205.99989C12%205.69864%2011.7558%205.45443%2011.4545%205.45443H7.09091Z%20M7.09091%208.72729H11.4545C12.3583%208.72729%2013.0909%209.45992%2013.0909%2010.3637C13.0909%2011.2674%2012.3583%2012%2011.4545%2012H7.09091C6.18717%2012%205.45454%2011.2674%205.45454%2010.3637C5.45454%209.45992%206.18717%208.72729%207.09091%208.72729ZM7.09091%209.8182C6.78966%209.8182%206.54545%2010.0624%206.54545%2010.3637C6.54545%2010.6649%206.78966%2010.9091%207.09091%2010.9091H11.4545C11.7558%2010.9091%2012%2010.6649%2012%2010.3637C12%2010.0624%2011.7558%209.8182%2011.4545%209.8182H7.09091Z'%20/%3e%3c/svg%3e", r2 = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12%202V5'%20stroke='currentColor'%20style='stroke:currentColor;stroke-opacity:1;'%20stroke-width='2'%20stroke-linecap='round'/%3e%3cpath%20d='M12%2019V22'%20stroke='currentColor'%20style='stroke:currentColor;stroke-opacity:1;'%20stroke-width='2'%20stroke-linecap='round'/%3e%3cpath%20d='M12%202V5'%20stroke='currentColor'%20style='stroke:currentColor;stroke-opacity:1;'%20stroke-width='2'%20stroke-linecap='round'/%3e%3cpath%20d='M12%2019V22'%20stroke='currentColor'%20style='stroke:currentColor;stroke-opacity:1;'%20stroke-width='2'%20stroke-linecap='round'/%3e%3cpath%20d='M22.005%2011.9951L19.005%2011.9951'%20stroke='currentColor'%20style='stroke:currentColor;stroke-opacity:1;'%20stroke-width='2'%20stroke-linecap='round'/%3e%3cpath%20d='M5.005%2011.9951L2.005%2011.9951'%20stroke='currentColor'%20style='stroke:currentColor;stroke-opacity:1;'%20stroke-width='2'%20stroke-linecap='round'/%3e%3cpath%20d='M19.0796%2019.0676L16.9583%2016.9463'%20stroke='currentColor'%20style='stroke:currentColor;stroke-opacity:1;'%20stroke-width='2'%20stroke-linecap='round'/%3e%3cpath%20d='M7.05884%207.04688L4.93752%204.92555'%20stroke='currentColor'%20style='stroke:currentColor;stroke-opacity:1;'%20stroke-width='2'%20stroke-linecap='round'/%3e%3cpath%20d='M4.9375%2019.0676L7.05882%2016.9463'%20stroke='currentColor'%20style='stroke:currentColor;stroke-opacity:1;'%20stroke-width='2'%20stroke-linecap='round'/%3e%3cpath%20d='M16.9583%207.04688L19.0796%204.92556'%20stroke='currentColor'%20style='stroke:currentColor;stroke-opacity:1;'%20stroke-width='2'%20stroke-linecap='round'/%3e%3c/svg%3e", o2 = "data:image/svg+xml,%3csvg%20viewBox='0%200%2014%2014'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill='currentColor'%20d='M%2014%207%20C%2014%2010.866%2010.866%2014%207%2014%20C%203.134%2014%200%2010.866%200%207%20C%200%203.134%203.134%200%207%200%20C%2010.866%200%2014%203.134%2014%207%20Z%20M%2011.243%206%20L%202.758%206%20L%202.758%208%20L%2011.243%208%20L%2011.243%206%20Z'%20/%3e%3c/svg%3e", s2 = "data:image/svg+xml,%3csvg%20viewBox='0%200%2014%2014'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill='currentColor'%20d='M%2014%207%20C%2014%2010.866%2010.866%2014%207%2014%20C%203.134%2014%200%2010.866%200%207%20C%200%203.134%203.134%200%207%200%20C%2010.866%200%2014%203.134%2014%207%20Z%20M%202.575%207.728%20L%205.782%2010.935%20L%2011.489%205.228%20L%2010.075%203.814%20L%205.782%208.107%20L%203.989%206.314%20L%202.575%207.728%20Z'%20/%3e%3c/svg%3e", i2 = "data:image/svg+xml,%3csvg%20viewBox='0%200%2014%2014'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill='currentColor'%20d='M%204.207%202.793%20L%207%205.586%20L%209.793%202.793%20L%2011.207%204.207%20L%208.414%207%20L%2011.207%209.793%20L%209.793%2011.207%20L%207%208.414%20L%204.207%2011.207%20L%202.793%209.793%20L%205.586%207%20L%202.793%204.207%20L%204.207%202.793%20Z%20M%207%200%20C%203.134%200%200%203.134%200%207%20C%200%2010.866%203.134%2014%207%2014%20C%2010.866%2014%2014%2010.866%2014%207%20C%2014%203.134%2010.866%200%207%200%20Z'%20/%3e%3c/svg%3e", a2 = "data:image/svg+xml,%3csvg%20viewBox='0%200%2014%2014'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill='currentColor'%20d='M%2014%207.006%20C%2014%208.867%2013.162%2010.744%2011.95%2011.956%20C%2010.738%2013.168%208.861%2014.006%207%2014.006%20C%205.139%2014.006%203.262%2013.168%202.05%2011.956%20C%200.838%2010.744%200%208.867%200%207.006%20C%200%205.145%200.838%203.268%202.05%202.056%20C%203.262%200.844%205.139%200.006%207%200.006%20C%208.861%200.006%2010.738%200.844%2011.95%202.056%20C%2013.162%203.268%2014%205.145%2014%207.006%20Z%20M%2010.536%203.47%20C%209.576%202.511%208.453%202.006%207%202.006%20C%205.547%202.006%204.424%202.511%203.464%203.47%20C%202.505%204.43%202%205.553%202%207.006%20C%202%208.459%202.505%209.582%203.464%2010.542%20C%204.424%2011.501%205.547%2012.006%207%2012.006%20C%208.453%2012.006%209.576%2011.501%2010.536%2010.542%20C%2011.495%209.582%2012%208.459%2012%207.006%20C%2012%205.553%2011.495%204.43%2010.536%203.47%20Z'%20/%3e%3c/svg%3e", c2 = "data:image/svg+xml,%3csvg%20viewBox='0%200%2014%2014'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill='currentColor'%20d='M13.8668%208.36613L11.9048%207.978C11.967%207.66329%2012%207.33649%2012%207C12%206.66351%2011.967%206.3367%2011.9048%206.022L13.8668%205.63387C13.9542%206.07571%2014%206.5325%2014%207C14%207.4675%2013.9542%207.92429%2013.8668%208.36613ZM12.821%203.11069L11.159%204.22333C10.7934%203.67721%2010.3228%203.2066%209.77667%202.84098L10.8893%201.17904C11.6527%201.6901%2012.3099%202.34733%2012.821%203.11069ZM8.36613%200.133238L7.978%202.09521C7.66329%202.03296%207.33649%202%207%202C6.66351%202%206.3367%202.03296%206.022%202.09521L5.63387%200.133238C6.07571%200.0458286%206.5325%200%207%200C7.4675%200%207.92429%200.0458285%208.36613%200.133238ZM3.11069%201.17904L4.22333%202.84098C3.67721%203.2066%203.2066%203.67721%202.84098%204.22333L1.17904%203.11069C1.6901%202.34733%202.34733%201.6901%203.11069%201.17904ZM0.133238%205.63387C0.0458285%206.07571%200%206.5325%200%207C0%207.4675%200.0458286%207.92429%200.133238%208.36613L2.09521%207.978C2.03296%207.6633%202%207.33649%202%207C2%206.66351%202.03296%206.33671%202.09521%206.022L0.133238%205.63387ZM1.17904%2010.8893L2.84098%209.77667C3.2066%2010.3228%203.67721%2010.7934%204.22333%2011.159L3.11069%2012.821C2.34733%2012.3099%201.6901%2011.6527%201.17904%2010.8893ZM5.63387%2013.8668L6.022%2011.9048C6.33671%2011.967%206.66351%2012%207%2012C7.33649%2012%207.6633%2011.967%207.978%2011.9048L8.36613%2013.8668C7.92429%2013.9542%207.4675%2014%207%2014C6.5325%2014%206.07571%2013.9542%205.63387%2013.8668ZM10.8893%2012.821L9.77667%2011.159C10.3228%2010.7934%2010.7934%2010.3228%2011.159%209.77667L12.821%2010.8893C12.3099%2011.6527%2011.6527%2012.3099%2010.8893%2012.821Z'%20/%3e%3c/svg%3e", l2 = "data:image/svg+xml,%3csvg%20viewBox='0%200%2014%2014'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill='currentColor'%20d='M7%2014C10.866%2014%2014%2010.866%2014%207C14%203.13401%2010.866%200%207%200C3.13401%200%200%203.13401%200%207C0%2010.866%203.13401%2014%207%2014ZM7%2012C4.23858%2012%202%209.76142%202%207C2%204.23858%204.23858%202%207%202C9.76142%202%2012%204.23858%2012%207C12%209.76142%209.76142%2012%207%2012ZM6%203V8H11C11%205.23858%208.76142%203%206%203Z'%20/%3e%3c/svg%3e", u2 = "data:image/svg+xml,%3csvg%20viewBox='0%200%2014%2014'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill='currentColor'%20d='M%2014%207%20C%2014%2010.866%2010.866%2014%207%2014%20C%203.134%2014%200%2010.866%200%207%20C%200%203.134%203.134%200%207%200%20C%2010.866%200%2014%203.134%2014%207%20Z%20M%206.5%209%20C%206.224%209%206%209.224%206%209.5%20L%206%2010.5%20C%206%2010.776%206.224%2011%206.5%2011%20L%207.5%2011%20C%207.776%2011%208%2010.776%208%2010.5%20L%208%209.5%20C%208%209.224%207.776%209%207.5%209%20L%206.5%209%20Z%20M%206.5%203%20C%206.224%203%206%203.224%206%203.5%20L%206%207.5%20C%206%207.776%206.224%208%206.5%208%20L%207.5%208%20C%207.776%208%208%207.776%208%207.5%20L%208%203.5%20C%208%203.224%207.776%203%207.5%203%20L%206.5%203%20Z'%20/%3e%3c/svg%3e", d2 = "data:image/svg+xml,%3csvg%20viewBox='0%200%2012%2012'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill='currentColor'%20d='M1.78814e-07%200.666667C1.78814e-07%200.298477%200.298477%200%200.666667%200H11.3333C11.7015%200%2012%200.298477%2012%200.666667C12%201.03486%2011.7015%201.33333%2011.3333%201.33333H0.666667C0.298477%201.33333%201.78814e-07%201.03486%201.78814e-07%200.666667ZM1.78814e-07%203.62963C1.78814e-07%203.26144%200.298477%202.96296%200.666667%202.96296H11.3333C11.7015%202.96296%2012%203.26144%2012%203.62963C12%203.99782%2011.7015%204.2963%2011.3333%204.2963H0.666667C0.298477%204.2963%201.78814e-07%203.99782%201.78814e-07%203.62963ZM0%206.59259C0%206.2244%200.298477%205.92593%200.666667%205.92593H11.3333C11.7015%205.92593%2012%206.2244%2012%206.59259C12%206.96078%2011.7015%207.25926%2011.3333%207.25926H0.666667C0.298477%207.25926%200%206.96078%200%206.59259ZM0%209.55556C0%209.18737%200.298477%208.88889%200.666667%208.88889H8.66667C9.03486%208.88889%209.33333%209.18737%209.33333%209.55556C9.33333%209.92375%209.03486%2010.2222%208.66667%2010.2222H0.666667C0.298477%2010.2222%200%209.92375%200%209.55556Z'%20/%3e%3c/svg%3e", f2 = "data:image/svg+xml,%3csvg%20aria-hidden='true'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20style='stroke:currentColor;stroke-opacity:%201;'%20d='M8%208V4a2%202%200%200%201%202-2h4a2%202%200%200%201%202%202v4m6%2012V10a2%202%200%200%200-2-2H4a2%202%200%200%200-2%202v10a2%202%200%200%200%202%202h16a2%202%200%200%200%202-2ZM8%2013v4m8-4v4M2%2015h20'%20stroke='currentColor'%20stroke-width='2'%20stroke-linecap='round'/%3e%3c/svg%3e", p2 = "data:image/svg+xml,%3csvg%20viewBox='0%200%20512%20512'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill='currentColor'%20d='M214.433%2056C232.908%2023.9999%20279.096%2024.0001%20297.571%2056L477.704%20368C496.18%20400%20473.085%20440%20436.135%20440H75.8685C38.918%20440%2015.8241%20400%2034.2993%20368L214.433%2056ZM256.002%20144L131.294%20360H380.709L256.002%20144Z'%20/%3e%3c/svg%3e", h2 = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='2'%20y='2'%20width='5'%20height='5'%20rx='1'%20stroke='currentColor'%20style='stroke:currentColor;stroke-opacity:1;'%20stroke-width='2'/%3e%3crect%20x='17'%20y='2'%20width='5'%20height='5'%20rx='1'%20stroke='currentColor'%20style='stroke:currentColor;stroke-opacity:1;'%20stroke-width='2'/%3e%3crect%20x='17'%20y='17'%20width='5'%20height='5'%20rx='1'%20stroke='currentColor'%20style='stroke:currentColor;stroke-opacity:1;'%20stroke-width='2'/%3e%3crect%20x='2'%20y='17'%20width='5'%20height='5'%20rx='1'%20stroke='currentColor'%20style='stroke:currentColor;stroke-opacity:1;'%20stroke-width='2'/%3e%3crect%20x='7'%20y='3'%20width='10'%20height='2'%20fill='currentColor'%20style='fill:currentColor;fill-opacity:1;'/%3e%3crect%20x='7'%20y='19'%20width='10'%20height='2'%20fill='currentColor'%20style='fill:currentColor;fill-opacity:1;'/%3e%3crect%20x='3'%20y='7'%20width='2'%20height='10'%20fill='currentColor'%20style='fill:currentColor;fill-opacity:1;'/%3e%3crect%20x='19'%20y='7'%20width='2'%20height='10'%20fill='currentColor'%20style='fill:currentColor;fill-opacity:1;'/%3e%3c/svg%3e", U8 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function V8(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", U8, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 12H9m12 6H7M21 6H3"
        }, null, -1)
    ]));
}
var g2 = {
    name: "lucide-align-right",
    render: V8
}, Z8 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function W8(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", Z8, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("rect", {
                width: "20",
                height: "5",
                x: "2",
                y: "3",
                rx: "1"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8m-10 4h4"
            })
        ], -1)
    ]));
}
var m2 = {
    name: "lucide-archive",
    render: W8
}, G8 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function K8(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", G8, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 5v14m7-7l-7 7l-7-7"
        }, null, -1)
    ]));
}
var v2 = {
    name: "lucide-arrow-down",
    render: K8
}, X8 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function Y8(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", X8, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "m12 19l-7-7l7-7m7 7H5"
        }, null, -1)
    ]));
}
var Ic = {
    name: "lucide-arrow-left",
    render: Y8
}, J8 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function Q8(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", J8, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M8 3L4 7l4 4M4 7h16m-4 14l4-4l-4-4m4 4H4"
        }, null, -1)
    ]));
}
var _2 = {
    name: "lucide-arrow-left-right",
    render: Q8
}, eS = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function tS(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", eS, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 12h14m-7-7l7 7l-7 7"
        }, null, -1)
    ]));
}
var b2 = {
    name: "lucide-arrow-right",
    render: tS
}, nS = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function rS(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", nS, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M3 5v14m18-7H7m8 6l6-6l-6-6"
        }, null, -1)
    ]));
}
var oS = {
    name: "lucide-arrow-right-from-line",
    render: rS
}, sS = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function iS(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", sS, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M17 12H3m8 6l6-6l-6-6m10-1v14"
        }, null, -1)
    ]));
}
var aS = {
    name: "lucide-arrow-right-to-line",
    render: iS
}, cS = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function lS(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", cS, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "m5 12l7-7l7 7m-7 7V5"
        }, null, -1)
    ]));
}
var y2 = {
    name: "lucide-arrow-up",
    render: lS
}, uS = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function dS(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", uS, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "12",
                r: "4"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8"
            })
        ], -1)
    ]));
}
var w2 = {
    name: "lucide-at-sign",
    render: dS
}, fS = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function pS(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", fS, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "m4.9 4.9l14.2 14.2"
            })
        ], -1)
    ]));
}
var k2 = {
    name: "lucide-ban",
    render: pS
}, hS = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function gS(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", hS, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M10.268 21a2 2 0 0 0 3.464 0m-10.47-5.674A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326"
        }, null, -1)
    ]));
}
var x2 = {
    name: "lucide-bell",
    render: gS
}, mS = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function vS(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", mS, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"
        }, null, -1)
    ]));
}
var C2 = {
    name: "lucide-book",
    render: vS
}, _S = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function bS(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", _S, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M12 8V4H8"
            }),
            (0, $8B0Dy.createElementVNode)("rect", {
                width: "16",
                height: "12",
                x: "4",
                y: "8",
                rx: "2"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M2 14h2m16 0h2m-7-1v2m-6-2v2"
            })
        ], -1)
    ]));
}
var S2 = {
    name: "lucide-bot",
    render: bS
}, yS = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function wS(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", yS, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "m3.3 7l8.7 5l8.7-5M12 22V12"
            })
        ], -1)
    ]));
}
var E2 = {
    name: "lucide-box",
    render: wS
}, kS = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function xS(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", kS, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M8 3H7a2 2 0 0 0-2 2v5a2 2 0 0 1-2 2a2 2 0 0 1 2 2v5c0 1.1.9 2 2 2h1m8 0h1a2 2 0 0 0 2-2v-5c0-1.1.9-2 2-2a2 2 0 0 1-2-2V5a2 2 0 0 0-2-2h-1"
        }, null, -1)
    ]));
}
var A2 = {
    name: "lucide-braces",
    render: xS
}, CS = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function SS(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", CS, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M12 5a3 3 0 1 0-5.997.125a4 4 0 0 0-2.526 5.77a4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M12 5a3 3 0 1 1 5.997.125a4 4 0 0 1 2.526 5.77a4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M15 13a4.5 4.5 0 0 1-3-4a4.5 4.5 0 0 1-3 4m8.599-6.5a3 3 0 0 0 .399-1.375m-11.995 0A3 3 0 0 0 6.401 6.5m-2.924 4.396a4 4 0 0 1 .585-.396m15.876 0a4 4 0 0 1 .585.396M6 18a4 4 0 0 1-1.967-.516m15.934 0A4 4 0 0 1 18 18"
            })
        ], -1)
    ]));
}
var $2 = {
    name: "lucide-brain",
    render: SS
}, ES = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function AS(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", ES, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "m8 2l1.88 1.88m4.24 0L16 2M9 7.13v-1a3.003 3.003 0 1 1 6 0v1"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6m0 0v-9"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M6.53 9C4.6 8.8 3 7.1 3 5m3 8H2m1 8c0-2.1 1.7-3.9 3.8-4M20.97 5c0 2.1-1.6 3.8-3.5 4M22 13h-4m-.8 4c2.1.1 3.8 1.9 3.8 4"
            })
        ], -1)
    ]));
}
var M2 = {
    name: "lucide-bug",
    render: AS
}, $S = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function MS(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", $S, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("rect", {
                width: "16",
                height: "20",
                x: "4",
                y: "2",
                rx: "2"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M8 6h8m0 8v4m0-8h.01M12 10h.01M8 10h.01M12 14h.01M8 14h.01M12 18h.01M8 18h.01"
            })
        ], -1)
    ]));
}
var I2 = {
    name: "lucide-calculator",
    render: MS
}, IS = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function TS(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", IS, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M8 2v4m8-4v4"
            }),
            (0, $8B0Dy.createElementVNode)("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "4",
                rx: "2"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M3 10h18"
            })
        ], -1)
    ]));
}
var T2 = {
    name: "lucide-calendar",
    render: TS
}, LS = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function OS(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", LS, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "m3 15l4-8l4 8m-7-2h6m5-2h4.5a2 2 0 0 1 0 4H15V7h4a2 2 0 0 1 0 4"
        }, null, -1)
    ]));
}
var L2 = {
    name: "lucide-case-upper",
    render: OS
}, RS = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function PS(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", RS, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M13 17V9m5 8v-3M3 3v16a2 2 0 0 0 2 2h16M8 17V5"
        }, null, -1)
    ]));
}
var O2 = {
    name: "lucide-chart-column-decreasing",
    render: PS
}, BS = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function zS(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", BS, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M20 6L9 17l-5-5"
        }, null, -1)
    ]));
}
var R2 = {
    name: "lucide-check",
    render: zS
}, DS = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function NS(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", DS, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M18 6L7 17l-5-5m20-2l-7.5 7.5L13 16"
        }, null, -1)
    ]));
}
var P2 = {
    name: "lucide-check-check",
    render: NS
}, qS = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function FS(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", qS, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "m6 9l6 6l6-6"
        }, null, -1)
    ]));
}
var zo = {
    name: "lucide-chevron-down",
    render: FS
}, HS = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function jS(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", HS, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "m15 18l-6-6l6-6"
        }, null, -1)
    ]));
}
var Do = {
    name: "lucide-chevron-left",
    render: jS
}, US = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function VS(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", US, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "m9 18l6-6l-6-6"
        }, null, -1)
    ]));
}
var No = {
    name: "lucide-chevron-right",
    render: VS
}, ZS = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function WS(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", ZS, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "m18 15l-6-6l-6 6"
        }, null, -1)
    ]));
}
var qo = {
    name: "lucide-chevron-up",
    render: WS
}, GS = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function KS(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", GS, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "m7 20l5-5l5 5M7 4l5 5l5-5"
        }, null, -1)
    ]));
}
var XS = {
    name: "lucide-chevrons-down-up",
    render: KS
}, YS = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function JS(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", YS, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "m11 17l-5-5l5-5m7 10l-5-5l5-5"
        }, null, -1)
    ]));
}
var B2 = {
    name: "lucide-chevrons-left",
    render: JS
}, QS = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function e7(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", QS, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "m7 15l5 5l5-5M7 9l5-5l5 5"
        }, null, -1)
    ]));
}
var z2 = {
    name: "lucide-chevrons-up-down",
    render: e7
}, t7 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function n7(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", t7, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("circle", {
            cx: "12",
            cy: "12",
            r: "10",
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, null, -1)
    ]));
}
var D2 = {
    name: "lucide-circle",
    render: n7
}, r7 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function o7(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", r7, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M12 8v4m0 4h.01"
            })
        ], -1)
    ]));
}
var N2 = {
    name: "lucide-circle-alert",
    render: o7
}, s7 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function i7(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", s7, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "m9 12l2 2l4-4"
            })
        ], -1)
    ]));
}
var q2 = {
    name: "lucide-circle-check",
    render: i7
}, a7 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function c7(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", a7, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "12",
                r: "1"
            })
        ], -1)
    ]));
}
var F2 = {
    name: "lucide-circle-dot",
    render: c7
}, l7 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function u7(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", l7, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3m.08 4h.01"
            })
        ], -1)
    ]));
}
var Tc = {
    name: "lucide-circle-help",
    render: u7
}, d7 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function f7(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", d7, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M8 12h8"
            })
        ], -1)
    ]));
}
var H2 = {
    name: "lucide-circle-minus",
    render: f7
}, p7 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function h7(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", p7, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M10 15V9m4 6V9"
            })
        ], -1)
    ]));
}
var j2 = {
    name: "lucide-circle-pause",
    render: h7
}, g7 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function m7(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", g7, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "m10 8l6 4l-6 4z"
            })
        ], -1)
    ]));
}
var U2 = {
    name: "lucide-circle-play",
    render: m7
}, v7 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function _7(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", v7, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M8 12h8m-4-4v8"
            })
        ], -1)
    ]));
}
var V2 = {
    name: "lucide-circle-plus",
    render: _7
}, b7 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function y7(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", b7, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M18 20a6 6 0 0 0-12 0"
            }),
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "10",
                r: "4"
            }),
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            })
        ], -1)
    ]));
}
var Z2 = {
    name: "lucide-circle-user-round",
    render: y7
}, w7 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function k7(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", w7, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "m15 9l-6 6m0-6l6 6"
            })
        ], -1)
    ]));
}
var W2 = {
    name: "lucide-circle-x",
    render: k7
}, x7 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function C7(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", x7, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("rect", {
                width: "8",
                height: "4",
                x: "8",
                y: "2",
                rx: "1",
                ry: "1"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2m4 7h4m-4 5h4m-8-5h.01M8 16h.01"
            })
        ], -1)
    ]));
}
var G2 = {
    name: "lucide-clipboard-list",
    render: C7
}, S7 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function E7(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", S7, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M12 6v6l4 2"
            }),
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            })
        ], -1)
    ]));
}
var K2 = {
    name: "lucide-clock",
    render: E7
}, A7 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function $7(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", A7, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9"
        }, null, -1)
    ]));
}
var X2 = {
    name: "lucide-cloud",
    render: $7
}, M7 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function I7(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", M7, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M12 13v8l-4-4m4 4l4-4"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M4.393 15.269A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.436 8.284"
            })
        ], -1)
    ]));
}
var Y2 = {
    name: "lucide-cloud-download",
    render: I7
}, T7 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function L7(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", T7, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "m16 18l6-6l-6-6M8 6l-6 6l6 6"
        }, null, -1)
    ]));
}
var J2 = {
    name: "lucide-code",
    render: L7
}, O7 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function R7(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", O7, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M12 20a8 8 0 1 0 0-16a8 8 0 0 0 0 16"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M12 14a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0-12v2m0 18v-2m5 .66l-1-1.73m-5-8.66L7 3.34M20.66 17l-1.73-1M3.34 7l1.73 1M14 12h8M2 12h2m16.66-5l-1.73 1M3.34 17l1.73-1M17 3.34l-1 1.73m-5 8.66l-4 6.93"
            })
        ], -1)
    ]));
}
var Lc = {
    name: "lucide-cog",
    render: R7
}, P7 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function B7(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", P7, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M12 18a6 6 0 0 0 0-12z"
            })
        ], -1)
    ]));
}
var Q2 = {
    name: "lucide-contrast",
    render: B7
}, z7 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function D7(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", z7, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("rect", {
                width: "14",
                height: "14",
                x: "8",
                y: "8",
                rx: "2",
                ry: "2"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
            })
        ], -1)
    ]));
}
var e1 = {
    name: "lucide-copy",
    render: D7
}, N7 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function q7(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", N7, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M22 12h-4M6 12H2m10-6V2m0 20v-4"
            })
        ], -1)
    ]));
}
var F7 = {
    name: "lucide-crosshair",
    render: q7
}, H7 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function j7(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", H7, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("ellipse", {
                cx: "12",
                cy: "5",
                rx: "9",
                ry: "3"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M3 5v14a9 3 0 0 0 18 0V5"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M3 12a9 3 0 0 0 18 0"
            })
        ], -1)
    ]));
}
var t1 = {
    name: "lucide-database",
    render: j7
}, U7 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function V7(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", U7, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M21.54 15H17a2 2 0 0 0-2 2v4.54M7 3.34V5a3 3 0 0 0 3 3a2 2 0 0 1 2 2c0 1.1.9 2 2 2a2 2 0 0 0 2-2c0-1.1.9-2 2-2h3.17M11 21.95V18a2 2 0 0 0-2-2a2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05"
            }),
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            })
        ], -1)
    ]));
}
var n1 = {
    name: "lucide-earth",
    render: V7
}, Z7 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function W7(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", Z7, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "12",
                r: "1"
            }),
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "19",
                cy: "12",
                r: "1"
            }),
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "5",
                cy: "12",
                r: "1"
            })
        ], -1)
    ]));
}
var r1 = {
    name: "lucide-ellipsis",
    render: W7
}, G7 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function K7(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", G7, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "12",
                r: "1"
            }),
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "5",
                r: "1"
            }),
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "19",
                r: "1"
            })
        ], -1)
    ]));
}
var o1 = {
    name: "lucide-ellipsis-vertical",
    render: K7
}, X7 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function Y7(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", X7, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 9h14M5 15h14"
        }, null, -1)
    ]));
}
var s1 = {
    name: "lucide-equal",
    render: Y7
}, J7 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function Q7(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", J7, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 3h6v6m-11 5L21 3m-3 10v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
        }, null, -1)
    ]));
}
var i1 = {
    name: "lucide-external-link",
    render: Q7
}, eE = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function tE(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", eE, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M2.062 12.348a1 1 0 0 1 0-.696a10.75 10.75 0 0 1 19.876 0a1 1 0 0 1 0 .696a10.75 10.75 0 0 1-19.876 0"
            }),
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "12",
                r: "3"
            })
        ], -1)
    ]));
}
var a1 = {
    name: "lucide-eye",
    render: tE
}, nE = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function rE(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", nE, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575a1 1 0 0 1 0 .696a10.8 10.8 0 0 1-1.444 2.49m-6.41-.679a3 3 0 0 1-4.242-4.242"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151a1 1 0 0 1 0-.696a10.75 10.75 0 0 1 4.446-5.143M2 2l20 20"
            })
        ], -1)
    ]));
}
var c1 = {
    name: "lucide-eye-off",
    render: rE
}, oE = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function sE(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", oE, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            })
        ], -1)
    ]));
}
var l1 = {
    name: "lucide-file",
    render: sE
}, iE = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function aE(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", iE, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M10 12v-1m0 7v-2m0-9V6m4-4v4a2 2 0 0 0 2 2h4"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M15.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v16a2 2 0 0 0 .274 1.01"
            }),
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "10",
                cy: "20",
                r: "2"
            })
        ], -1)
    ]));
}
var u1 = {
    name: "lucide-file-archive",
    render: aE
}, cE = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function lE(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", cE, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M10 12.5L8 15l2 2.5m4-5l2 2.5l-2 2.5M14 2v4a2 2 0 0 0 2 2h4"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z"
            })
        ], -1)
    ]));
}
var d1 = {
    name: "lucide-file-code",
    render: lE
}, uE = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function dE(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", uE, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Zm-6 8h6m-3 3V7M9 17h6"
        }, null, -1)
    ]));
}
var fE = {
    name: "lucide-file-diff",
    render: dE
}, pE = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function hE(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", pE, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4m-8 10v-6m-3 3l3 3l3-3"
            })
        ], -1)
    ]));
}
var f1 = {
    name: "lucide-file-down",
    render: hE
}, gE = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function mE(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", gE, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4M2 15h10m-3 3l3-3l-3-3"
            })
        ], -1)
    ]));
}
var p1 = {
    name: "lucide-file-input",
    render: mE
}, vE = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function _E(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", vE, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4M4 7V4a2 2 0 0 1 2-2a2 2 0 0 0-2 2"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M4.063 20.999a2 2 0 0 0 2 1L18 22a2 2 0 0 0 2-2V7l-5-5H6m-1 9l-3 3"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "m5 17l-3-3h10"
            })
        ], -1)
    ]));
}
var h1 = {
    name: "lucide-file-output",
    render: _E
}, bE = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function yE(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", bE, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4M10 9H8m8 4H8m8 4H8"
            })
        ], -1)
    ]));
}
var Oc = {
    name: "lucide-file-text",
    render: yE
}, wE = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function kE(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", wE, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M20 7h-3a2 2 0 0 1-2-2V2"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M9 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h7l4 4v10a2 2 0 0 1-2 2Z"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M3 7.6v12.8A1.6 1.6 0 0 0 4.6 22h9.8"
            })
        ], -1)
    ]));
}
var g1 = {
    name: "lucide-files",
    render: kE
}, xE = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function CE(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", xE, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4M14 13.12c0 2.38 0 6.38-1 8.88m4.29-.98c.12-.6.43-2.3.5-3.02M2 12a10 10 0 0 1 18-6M2 16h.01m19.79 0c.2-2 .131-5.354 0-6"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2m2.31 12c.21-.66.45-1.32.57-2M9 6.8a6 6 0 0 1 9 5.2v2"
            })
        ], -1)
    ]));
}
var m1 = {
    name: "lucide-fingerprint",
    render: CE
}, SE = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function EE(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", SE, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M14 2v6a2 2 0 0 0 .245.96l5.51 10.08A2 2 0 0 1 18 22H6a2 2 0 0 1-1.755-2.96l5.51-10.08A2 2 0 0 0 10 8V2M6.453 15h11.094M8.5 2h7"
        }, null, -1)
    ]));
}
var v1 = {
    name: "lucide-flask-conical",
    render: EE
}, AE = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function $E(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", AE, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"
        }, null, -1)
    ]));
}
var _1 = {
    name: "lucide-folder",
    render: $E
}, ME = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function IE(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", ME, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "m6 14l1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2"
        }, null, -1)
    ]));
}
var b1 = {
    name: "lucide-folder-open",
    render: IE
}, TE = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function LE(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", TE, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 10v6m-3-3h6m5 7a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"
        }, null, -1)
    ]));
}
var y1 = {
    name: "lucide-folder-plus",
    render: LE
}, OE = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function RE(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", OE, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z"
        }, null, -1)
    ]));
}
var w1 = {
    name: "lucide-funnel",
    render: RE
}, PE = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function BE(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", PE, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M6 3h12l4 6l-10 13L2 9Z"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M11 3L8 9l4 13l4-13l-3-6M2 9h20"
            })
        ], -1)
    ]));
}
var k1 = {
    name: "lucide-gem",
    render: BE
}, zE = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function DE(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", zE, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("rect", {
                width: "18",
                height: "4",
                x: "3",
                y: "8",
                rx: "1"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M12 8v13m7-9v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7m2.5-4a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5a2.5 2.5 0 0 1 0 5"
            })
        ], -1)
    ]));
}
var x1 = {
    name: "lucide-gift",
    render: DE
}, NE = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function qE(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", NE, t[0] || (t[0] = [
        (0, $8B0Dy.createStaticVNode)('<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M6 3v12"></path><circle cx="18" cy="6" r="3"></circle><circle cx="6" cy="18" r="3"></circle><path d="M18 9a9 9 0 0 1-9 9"></path></g>', 1)
    ]));
}
var C1 = {
    name: "lucide-git-branch",
    render: qE
}, FE = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function HE(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", FE, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20M2 12h20"
            })
        ], -1)
    ]));
}
var S1 = {
    name: "lucide-globe",
    render: HE
}, jE = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function UE(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", jE, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0zM22 10v6"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M6 12.5V16a6 3 0 0 0 12 0v-3.5"
            })
        ], -1)
    ]));
}
var E1 = {
    name: "lucide-graduation-cap",
    render: UE
}, VE = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function ZE(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", VE, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M12 3v18m-9-9h18"
            }),
            (0, $8B0Dy.createElementVNode)("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            })
        ], -1)
    ]));
}
var A1 = {
    name: "lucide-grid-2x2",
    render: ZE
}, WE = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function GE(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", WE, t[0] || (t[0] = [
        (0, $8B0Dy.createStaticVNode)('<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><circle cx="9" cy="12" r="1"></circle><circle cx="9" cy="5" r="1"></circle><circle cx="9" cy="19" r="1"></circle><circle cx="15" cy="12" r="1"></circle><circle cx="15" cy="5" r="1"></circle><circle cx="15" cy="19" r="1"></circle></g>', 1)
    ]));
}
var $1 = {
    name: "lucide-grip-vertical",
    render: GE
}, KE = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function XE(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", KE, t[0] || (t[0] = [
        (0, $8B0Dy.createStaticVNode)('<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17"></path><path d="m7 21l1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9M2 16l6 6"></path><circle cx="16" cy="9" r="2.9"></circle><circle cx="6" cy="5" r="3"></circle></g>', 1)
    ]));
}
var M1 = {
    name: "lucide-hand-coins",
    render: XE
}, YE = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function JE(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", YE, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "m11 17l2 2a1 1 0 1 0 3-3"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "m14 14l2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "m21 3l1 11h-2M3 3L2 14l6.5 6.5a1 1 0 1 0 3-3M3 4h8"
            })
        ], -1)
    ]));
}
var I1 = {
    name: "lucide-handshake",
    render: JE
}, QE = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function e9(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", QE, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M22 12H2m3.45-6.89L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11M6 16h.01M10 16h.01"
        }, null, -1)
    ]));
}
var T1 = {
    name: "lucide-hard-drive",
    render: e9
}, t9 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function n9(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", t9, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M12 2v8m4-4l-4 4l-4-4"
            }),
            (0, $8B0Dy.createElementVNode)("rect", {
                width: "20",
                height: "8",
                x: "2",
                y: "14",
                rx: "2"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M6 18h.01M10 18h.01"
            })
        ], -1)
    ]));
}
var L1 = {
    name: "lucide-hard-drive-download",
    render: n9
}, r9 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function o9(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", r9, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 9h16M4 15h16M10 3L8 21m8-18l-2 18"
        }, null, -1)
    ]));
}
var O1 = {
    name: "lucide-hash",
    render: o9
}, s9 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function i9(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", s9, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M3 12a9 9 0 1 0 9-9a9.75 9.75 0 0 0-6.74 2.74L3 8"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M3 3v5h5m4-1v5l4 2"
            })
        ], -1)
    ]));
}
var R1 = {
    name: "lucide-history",
    render: i9
}, a9 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function c9(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", a9, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 22h14M5 2h14m-2 20v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2"
        }, null, -1)
    ]));
}
var P1 = {
    name: "lucide-hourglass",
    render: c9
}, l9 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function u9(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", l9, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
            })
        ], -1)
    ]));
}
var B1 = {
    name: "lucide-house",
    render: u9
}, d9 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function f9(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", d9, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                ry: "2"
            }),
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "9",
                cy: "9",
                r: "2"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "m21 15l-3.086-3.086a2 2 0 0 0-2.828 0L6 21"
            })
        ], -1)
    ]));
}
var z1 = {
    name: "lucide-image",
    render: f9
}, p9 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function h9(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", p9, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M22 12h-6l-2 3h-4l-2-3H2"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11"
            })
        ], -1)
    ]));
}
var D1 = {
    name: "lucide-inbox",
    render: h9
}, g9 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function m9(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", g9, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M12 16v-4m0-4h.01"
            })
        ], -1)
    ]));
}
var Rc = {
    name: "lucide-info",
    render: m9
}, v9 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function _9(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", v9, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z"
            }),
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "16.5",
                cy: "7.5",
                r: ".5",
                fill: "currentColor"
            })
        ], -1)
    ]));
}
var N1 = {
    name: "lucide-key-round",
    render: _9
}, b9 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function y9(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", b9, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "m5 8l6 6m-7 0l6-6l2-3M2 5h12M7 2h1m14 20l-5-10l-5 10m2-4h6"
        }, null, -1)
    ]));
}
var q1 = {
    name: "lucide-languages",
    render: y9
}, w9 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function k9(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", w9, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17"
            })
        ], -1)
    ]));
}
var F1 = {
    name: "lucide-layers",
    render: k9
}, x9 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function C9(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", x9, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 14c.2-1 .7-1.7 1.5-2.5c1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5c.7.7 1.3 1.5 1.5 2.5m0 4h6m-5 4h4"
        }, null, -1)
    ]));
}
var H1 = {
    name: "lucide-lightbulb",
    render: C9
}, S9 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function E9(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", S9, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
            })
        ], -1)
    ]));
}
var j1 = {
    name: "lucide-link",
    render: E9
}, A9 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function $9(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", A9, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M3 12h.01M3 18h.01M3 6h.01M8 12h13M8 18h13M8 6h13"
        }, null, -1)
    ]));
}
var U1 = {
    name: "lucide-list",
    render: $9
}, M9 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function I9(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", M9, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "m3 17l2 2l4-4M3 7l2 2l4-4m4 1h8m-8 6h8m-8 6h8"
        }, null, -1)
    ]));
}
var V1 = {
    name: "lucide-list-checks",
    render: I9
}, T9 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function L9(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", T9, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("rect", {
                width: "18",
                height: "11",
                x: "3",
                y: "11",
                rx: "2",
                ry: "2"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M7 11V7a5 5 0 0 1 10 0v4"
            })
        ], -1)
    ]));
}
var Z1 = {
    name: "lucide-lock",
    render: L9
}, O9 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function R9(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", O9, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "m10 17l5-5l-5-5m5 5H3m12-9h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"
        }, null, -1)
    ]));
}
var W1 = {
    name: "lucide-log-in",
    render: R9
}, P9 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function B9(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", P9, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "m16 17l5-5l-5-5m5 5H9m0 9H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
        }, null, -1)
    ]));
}
var G1 = {
    name: "lucide-log-out",
    render: B9
}, z9 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function D9(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", z9, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"
            }),
            (0, $8B0Dy.createElementVNode)("rect", {
                width: "20",
                height: "16",
                x: "2",
                y: "4",
                rx: "2"
            })
        ], -1)
    ]));
}
var K1 = {
    name: "lucide-mail",
    render: D9
}, N9 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function q9(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", N9, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3M3 16v3a2 2 0 0 0 2 2h3m8 0h3a2 2 0 0 0 2-2v-3"
        }, null, -1)
    ]));
}
var X1 = {
    name: "lucide-maximize",
    render: q9
}, F9 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function H9(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", F9, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 3h6v6m0-6l-7 7M3 21l7-7m-1 7H3v-6"
        }, null, -1)
    ]));
}
var Y1 = {
    name: "lucide-maximize-2",
    render: H9
}, j9 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function U9(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", j9, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 12h16M4 18h16M4 6h16"
        }, null, -1)
    ]));
}
var J1 = {
    name: "lucide-menu",
    render: U9
}, V9 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function Z9(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", V9, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z"
        }, null, -1)
    ]));
}
var Q1 = {
    name: "lucide-message-circle",
    render: Z9
}, W9 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function G9(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", W9, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M14 9a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2zm4 0h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1"
        }, null, -1)
    ]));
}
var eg = {
    name: "lucide-messages-square",
    render: G9
}, K9 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function X9(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", K9, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 13v8m0-18v3M4 6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h13a2 2 0 0 0 1.152-.365l3.424-2.317a1 1 0 0 0 0-1.635l-3.424-2.318A2 2 0 0 0 17 6z"
        }, null, -1)
    ]));
}
var tg = {
    name: "lucide-milestone",
    render: X9
}, Y9 = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function J9(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", Y9, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "m14 10l7-7m-1 7h-6V4M3 21l7-7m-6 0h6v6"
        }, null, -1)
    ]));
}
var Q9 = {
    name: "lucide-minimize-2",
    render: J9
}, eA = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function tA(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", eA, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12.586 12.586L19 19M3.688 3.037a.497.497 0 0 0-.651.651l6.5 15.999a.501.501 0 0 0 .947-.062l1.569-6.083a2 2 0 0 1 1.448-1.479l6.124-1.579a.5.5 0 0 0 .063-.947z"
        }, null, -1)
    ]));
}
var ng = {
    name: "lucide-mouse-pointer",
    render: tA
}, nA = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function rA(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", nA, t[0] || (t[0] = [
        (0, $8B0Dy.createStaticVNode)('<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><rect width="6" height="6" x="16" y="16" rx="1"></rect><rect width="6" height="6" x="2" y="16" rx="1"></rect><rect width="6" height="6" x="9" y="2" rx="1"></rect><path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3m-7-4V8"></path></g>', 1)
    ]));
}
var rg = {
    name: "lucide-network",
    render: rA
}, oA = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function sA(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", oA, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M12 22v-9m3.17-10.79a1.67 1.67 0 0 1 1.63 0L21 4.57a1.93 1.93 0 0 1 0 3.36L8.82 14.79a1.66 1.66 0 0 1-1.64 0L3 12.43a1.93 1.93 0 0 1 0-3.36z"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M20 13v3.87a2.06 2.06 0 0 1-1.11 1.83l-6 3.08a1.93 1.93 0 0 1-1.78 0l-6-3.08A2.06 2.06 0 0 1 4 16.87V13"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M21 12.43a1.93 1.93 0 0 0 0-3.36L8.83 2.2a1.64 1.64 0 0 0-1.63 0L3 4.57a1.93 1.93 0 0 0 0 3.36l12.18 6.86a1.64 1.64 0 0 0 1.63 0z"
            })
        ], -1)
    ]));
}
var og = {
    name: "lucide-package-open",
    render: sA
}, iA = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function aA(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", iA, t[0] || (t[0] = [
        (0, $8B0Dy.createStaticVNode)('<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M12 22a1 1 0 0 1 0-20a10 9 0 0 1 10 9a5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z"></path><circle cx="13.5" cy="6.5" r=".5" fill="currentColor"></circle><circle cx="17.5" cy="10.5" r=".5" fill="currentColor"></circle><circle cx="6.5" cy="12.5" r=".5" fill="currentColor"></circle><circle cx="8.5" cy="7.5" r=".5" fill="currentColor"></circle></g>', 1)
    ]));
}
var sg = {
    name: "lucide-palette",
    render: aA
}, cA = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function lA(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", cA, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M15 3v18"
            })
        ], -1)
    ]));
}
var uA = {
    name: "lucide-panel-right",
    render: lA
}, dA = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function fA(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", dA, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("rect", {
                width: "4",
                height: "16",
                x: "14",
                y: "4",
                rx: "1"
            }),
            (0, $8B0Dy.createElementVNode)("rect", {
                width: "4",
                height: "16",
                x: "6",
                y: "4",
                rx: "1"
            })
        ], -1)
    ]));
}
var ig = {
    name: "lucide-pause",
    render: fA
}, pA = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function hA(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", pA, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"
        }, null, -1)
    ]));
}
var ag = {
    name: "lucide-pen",
    render: hA
}, gA = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function mA(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", gA, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497zM15 5l4 4"
        }, null, -1)
    ]));
}
var cg = {
    name: "lucide-pencil",
    render: mA
}, vA = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function _A(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", vA, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 17v5M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4a1 1 0 0 1 1 1z"
        }, null, -1)
    ]));
}
var lg = {
    name: "lucide-pin",
    render: _A
}, bA = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function yA(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", bA, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "m6 3l14 9l-14 9z"
        }, null, -1)
    ]));
}
var ug = {
    name: "lucide-play",
    render: yA
}, wA = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function kA(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", wA, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 22v-5M9 8V2m6 6V2m3 6v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z"
        }, null, -1)
    ]));
}
var dg = {
    name: "lucide-plug",
    render: kA
}, xA = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function CA(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", xA, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 12h14m-7-7v14"
        }, null, -1)
    ]));
}
var fg = {
    name: "lucide-plus",
    render: CA
}, SA = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function EA(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", SA, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M3 2v1c0 1 2 1 2 2S3 6 3 7s2 1 2 2s-2 1-2 2s2 1 2 2m13-7h.01M6 18h.01m14.82-9.17a4 4 0 0 0-5.66-5.66l-12 12a4 4 0 1 0 5.66 5.66Z"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M18 11.66V22a4 4 0 0 0 4-4V6"
            })
        ], -1)
    ]));
}
var pg = {
    name: "lucide-pocket-knife",
    render: EA
}, AA = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function $A(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", AA, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 2v10m6.4-5.4a9 9 0 1 1-12.77.04"
        }, null, -1)
    ]));
}
var hg = {
    name: "lucide-power",
    render: $A
}, MA = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function IA(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", MA, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "m15 14l5-5l-5-5"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M20 9H9.5A5.5 5.5 0 0 0 4 14.5A5.5 5.5 0 0 0 9.5 20H13"
            })
        ], -1)
    ]));
}
var gg = {
    name: "lucide-redo-2",
    render: IA
}, TA = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function LA(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", TA, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M3 12a9 9 0 0 1 9-9a9.75 9.75 0 0 1 6.74 2.74L21 8"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M21 3v5h-5m5 4a9 9 0 0 1-9 9a9.75 9.75 0 0 1-6.74-2.74L3 16"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M8 16H3v5"
            })
        ], -1)
    ]));
}
var Fo = {
    name: "lucide-refresh-cw",
    render: LA
}, OA = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function RA(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", OA, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 7V4h16v3M5 20h6m2-16L8 20m7-5l5 5m0-5l-5 5"
        }, null, -1)
    ]));
}
var mg = {
    name: "lucide-remove-formatting",
    render: RA
}, PA = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function BA(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", PA, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M4 11a9 9 0 0 1 9 9M4 4a16 16 0 0 1 16 16"
            }),
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "5",
                cy: "19",
                r: "1"
            })
        ], -1)
    ]));
}
var vg = {
    name: "lucide-rss",
    render: BA
}, zA = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function DA(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", zA, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 10a7.31 7.31 0 0 0 10 10Zm5 5l3-3m5 1a6 6 0 0 0-6-6m10 6A10 10 0 0 0 11 3"
        }, null, -1)
    ]));
}
var _g = {
    name: "lucide-satellite-dish",
    render: DA
}, NA = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function qA(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", NA, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7M7 3v4a1 1 0 0 0 1 1h7"
            })
        ], -1)
    ]));
}
var bg = {
    name: "lucide-save",
    render: qA
}, FA = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function HA(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", FA, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "m16 16l3-8l3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1M2 16l3-8l3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1m5 5h10M12 3v18M3 7h2c2 0 5-1 7-2c2 1 5 2 7 2h2"
        }, null, -1)
    ]));
}
var yg = {
    name: "lucide-scale",
    render: HA
}, jA = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function UA(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", jA, t[0] || (t[0] = [
        (0, $8B0Dy.createStaticVNode)('<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><circle cx="6" cy="6" r="3"></circle><path d="M8.12 8.12L12 12m8-8L8.12 15.88"></path><circle cx="6" cy="18" r="3"></circle><path d="M14.8 14.8L20 20"></path></g>', 1)
    ]));
}
var Pc = {
    name: "lucide-scissors",
    render: UA
}, VA = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function ZA(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", VA, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "m21 21l-4.34-4.34"
            }),
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "11",
                cy: "11",
                r: "8"
            })
        ], -1)
    ]));
}
var wg = {
    name: "lucide-search",
    render: ZA
}, WA = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function GA(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", WA, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11zm7.318-19.539l-10.94 10.939"
        }, null, -1)
    ]));
}
var kg = {
    name: "lucide-send",
    render: GA
}, KA = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function XA(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", KA, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("rect", {
                width: "20",
                height: "8",
                x: "2",
                y: "2",
                rx: "2",
                ry: "2"
            }),
            (0, $8B0Dy.createElementVNode)("rect", {
                width: "20",
                height: "8",
                x: "2",
                y: "14",
                rx: "2",
                ry: "2"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M6 6h.01M6 18h.01"
            })
        ], -1)
    ]));
}
var xg = {
    name: "lucide-server",
    render: XA
}, YA = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function JA(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", YA, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 2v13m4-9l-4-4l-4 4m-4 6v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"
        }, null, -1)
    ]));
}
var Cg = {
    name: "lucide-share",
    render: JA
}, QA = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function e$(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", QA, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 4h-7m-4 0H3m18 8h-9m-4 0H3m18 8h-5m-4 0H3M14 2v4m-6 4v4m8 4v4"
        }, null, -1)
    ]));
}
var Sg = {
    name: "lucide-sliders-horizontal",
    render: e$
}, t$ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function n$(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", t$, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M8 14s1.5 2 4 2s4-2 4-2M9 9h.01M15 9h.01"
            })
        ], -1)
    ]));
}
var Eg = {
    name: "lucide-smile",
    render: n$
}, r$ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function o$(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", r$, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("rect", {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            rx: "2"
        }, null, -1)
    ]));
}
var Ag = {
    name: "lucide-square",
    render: o$
}, s$ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function i$(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", s$, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "m9 12l2 2l4-4"
            })
        ], -1)
    ]));
}
var $g = {
    name: "lucide-square-check",
    render: i$
}, a$ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function c$(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", a$, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"
            })
        ], -1)
    ]));
}
var Mg = {
    name: "lucide-square-pen",
    render: c$
}, l$ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function u$(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", l$, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M8 12h8m-4-4v8"
            })
        ], -1)
    ]));
}
var Ig = {
    name: "lucide-square-plus",
    render: u$
}, d$ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function f$(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", d$, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8Z"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M15 3v4a2 2 0 0 0 2 2h4"
            })
        ], -1)
    ]));
}
var Tg = {
    name: "lucide-sticky-note",
    render: f$
}, p$ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function h$(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", p$, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "12",
                r: "4"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32l1.41 1.41M2 12h2m16 0h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"
            })
        ], -1)
    ]));
}
var Lg = {
    name: "lucide-sun",
    render: h$
}, g$ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function m$(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", g$, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M12 3v18"
            }),
            (0, $8B0Dy.createElementVNode)("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M3 9h18M3 15h18"
            })
        ], -1)
    ]));
}
var Og = {
    name: "lucide-table",
    render: m$
}, v$ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function _$(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", v$, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "m15 5l6.3 6.3a2.4 2.4 0 0 1 0 3.4L17 19"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M9.586 5.586A2 2 0 0 0 8.172 5H3a1 1 0 0 0-1 1v5.172a2 2 0 0 0 .586 1.414L8.29 18.29a2.426 2.426 0 0 0 3.42 0l3.58-3.58a2.426 2.426 0 0 0 0-3.42z"
            }),
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "6.5",
                cy: "9.5",
                r: ".5",
                fill: "currentColor"
            })
        ], -1)
    ]));
}
var Rg = {
    name: "lucide-tags",
    render: _$
}, b$ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function y$(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", b$, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 19h8M4 17l6-6l-6-6"
        }, null, -1)
    ]));
}
var Pg = {
    name: "lucide-terminal",
    render: y$
}, w$ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function k$(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", w$, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M17 14V2M9 18.12L10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88"
        }, null, -1)
    ]));
}
var Bg = {
    name: "lucide-thumbs-down",
    render: k$
}, x$ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function C$(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", x$, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M7 10v12m8-16.12L14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88"
        }, null, -1)
    ]));
}
var zg = {
    name: "lucide-thumbs-up",
    render: C$
}, S$ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function E$(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", S$, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M3 6h18m-2 0v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6m3 0V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2m-6 5v6m4-6v6"
        }, null, -1)
    ]));
}
var Dg = {
    name: "lucide-trash-2",
    render: E$
}, A$ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function $$(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", A$, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "m17 14l3 3.3a1 1 0 0 1-.7 1.7H4.7a1 1 0 0 1-.7-1.7L7 14h-.3a1 1 0 0 1-.7-1.7L9 9h-.2A1 1 0 0 1 8 7.3L12 3l4 4.3a1 1 0 0 1-.8 1.7H15l3 3.3a1 1 0 0 1-.7 1.7zm-5 8v-3"
        }, null, -1)
    ]));
}
var Ng = {
    name: "lucide-tree-pine",
    render: $$
}, M$ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function I$(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", M$, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "m21.73 18l-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3M12 9v4m0 4h.01"
        }, null, -1)
    ]));
}
var qg = {
    name: "lucide-triangle-alert",
    render: I$
}, T$ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function L$(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", T$, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M9 14L4 9l5-5"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11"
            })
        ], -1)
    ]));
}
var Fg = {
    name: "lucide-undo-2",
    render: L$
}, O$ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function R$(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", O$, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "m18.84 12.25l1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07a5.006 5.006 0 0 0-6.95 0l-1.72 1.71m-6.58 6.57l-1.71 1.71a5.004 5.004 0 0 0 .12 7.07a5.006 5.006 0 0 0 6.95 0l1.71-1.71M8 2v3M2 8h3m11 11v3m3-6h3"
        }, null, -1)
    ]));
}
var Hg = {
    name: "lucide-unlink",
    render: R$
}, P$ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function B$(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", P$, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"
            }),
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "7",
                r: "4"
            })
        ], -1)
    ]));
}
var jg = {
    name: "lucide-user",
    render: B$
}, z$ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function D$(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", z$, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "m16 11l2 2l4-4m-6 12v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
            }),
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "9",
                cy: "7",
                r: "4"
            })
        ], -1)
    ]));
}
var Ug = {
    name: "lucide-user-check",
    render: D$
}, N$ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function q$(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", N$, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "10",
                cy: "7",
                r: "4"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M10.3 15H7a4 4 0 0 0-4 4v2m12-5.5V14a2 2 0 0 1 4 0v1.5"
            }),
            (0, $8B0Dy.createElementVNode)("rect", {
                width: "8",
                height: "5",
                x: "13",
                y: "16",
                rx: ".899"
            })
        ], -1)
    ]));
}
var Vg = {
    name: "lucide-user-lock",
    render: q$
}, F$ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function H$(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", F$, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "12",
                cy: "8",
                r: "5"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M20 21a8 8 0 0 0-16 0"
            })
        ], -1)
    ]));
}
var Zg = {
    name: "lucide-user-round",
    render: H$
}, j$ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function U$(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", j$, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87"
            }),
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "9",
                cy: "7",
                r: "4"
            })
        ], -1)
    ]));
}
var Wg = {
    name: "lucide-users",
    render: U$
}, V$ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function Z$(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", V$, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M8 21s-4-3-4-9s4-9 4-9m8 0s4 3 4 9s-4 9-4 9M15 9l-6 6m0-6l6 6"
        }, null, -1)
    ]));
}
var Gg = {
    name: "lucide-variable",
    render: Z$
}, W$ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function G$(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", W$, t[0] || (t[0] = [
        (0, $8B0Dy.createStaticVNode)('<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><rect width="18" height="18" x="3" y="3" rx="2"></rect><circle cx="7.5" cy="7.5" r=".5" fill="currentColor"></circle><path d="m7.9 7.9l2.7 2.7"></path><circle cx="16.5" cy="7.5" r=".5" fill="currentColor"></circle><path d="m13.4 10.6l2.7-2.7"></path><circle cx="7.5" cy="16.5" r=".5" fill="currentColor"></circle><path d="m7.9 16.1l2.7-2.7"></path><circle cx="16.5" cy="16.5" r=".5" fill="currentColor"></circle><path d="m13.4 13.4l2.7 2.7"></path><circle cx="12" cy="12" r="2"></circle></g>', 1)
    ]));
}
var Kg = {
    name: "lucide-vault",
    render: G$
}, K$ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function X$(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", K$, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "m16 13l5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5"
            }),
            (0, $8B0Dy.createElementVNode)("rect", {
                width: "14",
                height: "12",
                x: "2",
                y: "6",
                rx: "2"
            })
        ], -1)
    ]));
}
var Xg = {
    name: "lucide-video",
    render: X$
}, Y$ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function J$(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", Y$, t[0] || (t[0] = [
        (0, $8B0Dy.createStaticVNode)('<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><circle cx="12" cy="4.5" r="2.5"></circle><path d="m10.2 6.3l-3.9 3.9"></path><circle cx="4.5" cy="12" r="2.5"></circle><path d="M7 12h10"></path><circle cx="19.5" cy="12" r="2.5"></circle><path d="m13.8 17.7l3.9-3.9"></path><circle cx="12" cy="19.5" r="2.5"></circle></g>', 1)
    ]));
}
var Yg = {
    name: "lucide-waypoints",
    render: J$
}, Q$ = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function eM(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", Q$, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"
        }, null, -1)
    ]));
}
var Jg = {
    name: "lucide-wrench",
    render: eM
}, tM = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function nM(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", tM, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M18 6L6 18M6 6l12 12"
        }, null, -1)
    ]));
}
var Bc = {
    name: "lucide-x",
    render: nM
}, rM = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function oM(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", rM, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"
        }, null, -1)
    ]));
}
var Qg = {
    name: "lucide-zap",
    render: oM
}, sM = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function iM(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", sM, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "11",
                cy: "11",
                r: "8"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "m21 21l-4.35-4.35M11 8v6m-3-3h6"
            })
        ], -1)
    ]));
}
var em = {
    name: "lucide-zoom-in",
    render: iM
}, aM = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function cM(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", aM, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        }, [
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: "11",
                cy: "11",
                r: "8"
            }),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "m21 21l-4.35-4.35M8 11h6"
            })
        ], -1)
    ]));
}
var tm = {
    name: "lucide-zoom-out",
    render: cM
}, yd = {
    // customIcons
    variable: Gg,
    "pop-out": t2,
    triangle: p2,
    "status-completed": s2,
    "status-waiting": l2,
    "status-error": i2,
    "status-canceled": o2,
    "status-new": a2,
    "status-unknown": c2,
    "status-warning": u2,
    "vector-square": h2,
    schema: n2,
    json: A2,
    binary: Qh,
    text: d2,
    toolbox: f2,
    spinner: r2,
    xmark: Bc,
    // fontAwesomeIcons
    "caret-up": qo,
    "caret-down": zo,
    "caret-right": No,
    "caret-left": Do,
    "folder-plus": y1,
    share: Cg,
    "user-check": Ug,
    "check-double": P2,
    "exclamation-circle": N2,
    circle: D2,
    "eye-slash": c1,
    folder: _1,
    "minus-circle": H2,
    adjust: Q2,
    refresh: Fo,
    vault: Kg,
    "angle-double-left": B2,
    "angle-down": zo,
    "angle-left": Do,
    "angle-right": No,
    "angle-up": qo,
    archive: m2,
    "arrow-left": Ic,
    "arrow-right": b2,
    "arrow-up": y2,
    "arrow-down": v2,
    at: w2,
    ban: k2,
    "balance-scale-left": yg,
    bars: J1,
    bolt: Qg,
    book: C2,
    "box-open": og,
    bug: M2,
    brain: $2,
    calculator: I2,
    calendar: T2,
    "chart-bar": O2,
    check: R2,
    "check-circle": q2,
    "check-square": $g,
    "chevron-left": Do,
    "chevron-right": No,
    "chevron-down": zo,
    "chevron-up": qo,
    code: J2,
    "code-branch": C1,
    cog: Lc,
    cogs: Lc,
    comment: Q1,
    comments: eg,
    "clipboard-list": G2,
    clock: K2,
    clone: e1,
    cloud: X2,
    "cloud-download-alt": Y2,
    compress: z2,
    copy: g1,
    cube: E2,
    cut: Pc,
    database: t1,
    "dot-circle": F2,
    "grip-lines-vertical": e2,
    "grip-vertical": $1,
    edit: Mg,
    "ellipsis-h": r1,
    "ellipsis-v": o1,
    envelope: K1,
    equals: s1,
    eye: a1,
    "exclamation-triangle": qg,
    expand: X1,
    "expand-alt": Y1,
    "external-link-alt": i1,
    "exchange-alt": _2,
    file: l1,
    "file-alt": Oc,
    "file-archive": u1,
    "file-code": d1,
    "file-download": f1,
    "file-export": h1,
    "file-import": p1,
    "file-pdf": Oc,
    filter: w1,
    fingerprint: m1,
    flask: v1,
    "folder-open": b1,
    font: L2,
    gift: x1,
    globe: S1,
    "globe-americas": n1,
    "graduation-cap": E1,
    "hand-holding-usd": M1,
    "hand-scissors": Pc,
    handshake: I1,
    "hand-point-left": Ic,
    hashtag: O1,
    hdd: T1,
    history: R1,
    home: B1,
    hourglass: P1,
    image: z1,
    inbox: D1,
    info: Rc,
    "info-circle": Rc,
    key: N1,
    language: q1,
    "layer-group": F1,
    link: j1,
    list: U1,
    lightbulb: H1,
    lock: Z1,
    "map-signs": tg,
    "mouse-pointer": ng,
    "network-wired": rg,
    palette: sg,
    pause: ig,
    "pause-circle": j2,
    pen: ag,
    "pencil-alt": cg,
    play: ug,
    "play-circle": U2,
    plug: dg,
    plus: fg,
    "plus-circle": V2,
    "plus-square": Ig,
    "project-diagram": Yg,
    question: Tc,
    "question-circle": Tc,
    redo: gg,
    "remove-format": mg,
    robot: S2,
    rss: vg,
    save: bg,
    "satellite-dish": _g,
    search: wg,
    "search-minus": tm,
    "search-plus": em,
    server: xg,
    screwdriver: pg,
    smile: Eg,
    "sign-in-alt": W1,
    "sign-out-alt": G1,
    "sliders-h": Sg,
    "sticky-note": Tg,
    stop: Ag,
    stream: g2,
    sun: Lg,
    sync: Fo,
    "sync-alt": Fo,
    table: Og,
    tags: Rg,
    tasks: V1,
    terminal: Pg,
    "th-large": A1,
    thumbtack: lg,
    "thumbs-down": Bg,
    "thumbs-up": zg,
    times: Bc,
    "times-circle": W2,
    tools: Jg,
    trash: Dg,
    undo: Fg,
    unlink: Hg,
    user: jg,
    "user-circle": Z2,
    "user-friends": Zg,
    users: Wg,
    video: Xg,
    tree: Ng,
    "user-lock": Vg,
    gem: k1,
    download: L1,
    "power-off": hg,
    "paper-plane": kg,
    bell: x2
}, wd = {
    // custom icons
    // NOTE: ensure to replace any colors with "currentColor" in SVG
    "bolt-filled": N8,
    "grip-lines-vertical": e2,
    variable: Gg,
    "pop-out": t2,
    triangle: p2,
    "status-completed": s2,
    "status-waiting": l2,
    "status-error": i2,
    "status-canceled": o2,
    "status-new": a2,
    "status-unknown": c2,
    "status-warning": u2,
    "vector-square": h2,
    "continue-on-error": q8,
    "always-output-data": F8,
    "retry-on-fail": H8,
    "execute-once": j8,
    schema: n2,
    json: A2,
    binary: Qh,
    text: d2,
    toolbox: f2,
    spinner: r2,
    // lucide
    "align-right": g2,
    archive: m2,
    "arrow-down": v2,
    "arrow-left": Ic,
    "arrow-left-right": _2,
    "arrow-right": b2,
    "arrow-right-from-line": oS,
    "arrow-right-to-line": aS,
    "arrow-up": y2,
    "at-sign": w2,
    ban: k2,
    bell: x2,
    book: C2,
    bot: S2,
    box: E2,
    brain: $2,
    bug: M2,
    calculator: I2,
    calendar: T2,
    "case-upper": L2,
    "chart-column-decreasing": O2,
    check: R2,
    "check-check": P2,
    "chevron-down": zo,
    "chevron-left": Do,
    "chevron-right": No,
    "chevron-up": qo,
    "chevrons-left": B2,
    "chevrons-down-up": XS,
    "chevrons-up-down": z2,
    circle: D2,
    "circle-alert": N2,
    "circle-check": q2,
    "circle-dot": F2,
    "circle-help": Tc,
    "circle-minus": H2,
    "circle-pause": j2,
    "circle-play": U2,
    "circle-plus": V2,
    "circle-user-round": Z2,
    "circle-x": W2,
    "clipboard-list": G2,
    clock: K2,
    cloud: X2,
    "cloud-download": Y2,
    code: J2,
    cog: Lc,
    contrast: Q2,
    copy: e1,
    crosshair: F7,
    database: t1,
    earth: n1,
    ellipsis: r1,
    "ellipsis-vertical": o1,
    equal: s1,
    "external-link": i1,
    eye: a1,
    "eye-off": c1,
    file: l1,
    "file-archive": u1,
    "file-code": d1,
    "file-diff": fE,
    "file-down": f1,
    "file-input": p1,
    "file-output": h1,
    "file-text": Oc,
    files: g1,
    fingerprint: m1,
    "flask-conical": v1,
    folder: _1,
    "folder-open": b1,
    "folder-plus": y1,
    funnel: w1,
    gem: k1,
    gift: x1,
    "git-branch": C1,
    globe: S1,
    "graduation-cap": E1,
    "grid-2x2": A1,
    "grip-vertical": $1,
    "hand-coins": M1,
    handshake: I1,
    "hard-drive": T1,
    "hard-drive-download": L1,
    hash: O1,
    history: R1,
    hourglass: P1,
    house: B1,
    image: z1,
    inbox: D1,
    info: Rc,
    "key-round": N1,
    languages: q1,
    layers: F1,
    lightbulb: H1,
    link: j1,
    list: U1,
    "list-checks": V1,
    lock: Z1,
    "log-in": W1,
    "log-out": G1,
    mail: K1,
    "minimize-2": Q9,
    maximize: X1,
    "maximize-2": Y1,
    menu: J1,
    "message-circle": Q1,
    "messages-square": eg,
    milestone: tg,
    "mouse-pointer": ng,
    network: rg,
    "package-open": og,
    palette: sg,
    "panel-right": uA,
    pause: ig,
    pen: ag,
    pencil: cg,
    pin: lg,
    play: ug,
    plug: dg,
    plus: fg,
    "pocket-knife": pg,
    power: hg,
    "redo-2": gg,
    "refresh-cw": Fo,
    "remove-formatting": mg,
    rss: vg,
    "satellite-dish": _g,
    save: bg,
    scale: yg,
    scissors: Pc,
    search: wg,
    send: kg,
    server: xg,
    share: Cg,
    "sliders-horizontal": Sg,
    smile: Eg,
    square: Ag,
    "square-check": $g,
    "square-pen": Mg,
    "square-plus": Ig,
    "sticky-note": Tg,
    sun: Lg,
    table: Og,
    tags: Rg,
    terminal: Pg,
    "thumbs-down": Bg,
    "thumbs-up": zg,
    "trash-2": Dg,
    "tree-pine": Ng,
    "triangle-alert": qg,
    "undo-2": Fg,
    unlink: Hg,
    user: jg,
    "user-check": Ug,
    "user-lock": Vg,
    "user-round": Zg,
    users: Wg,
    vault: Kg,
    video: Xg,
    waypoints: Yg,
    wrench: Jg,
    x: Bc,
    zap: Qg,
    "zoom-in": em,
    "zoom-out": tm
}, lM = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    name: "N8nIcon",
    __name: "Icon",
    props: {
        icon: {},
        size: {
            "default": void 0
        },
        spin: {
            type: Boolean,
            "default": !1
        },
        color: {
            "default": void 0
        },
        strokeWidth: {}
    },
    setup: function(e) {
        var t = e, n = (0, $kRi7Z.useCssModule)(), r = (0, $5wB2C.computed)(function() {
            var a = [];
            return t.spin && a.push("spin"), t.strokeWidth && a.push("strokeWidth"), [
                "n8n-icon"
            ].concat((0, $kf9Kn._)(a.map(function(c) {
                return n[c];
            })));
        }), s = {
            xsmall: 10,
            small: 12,
            medium: 14,
            large: 16,
            xlarge: 20
        }, o = (0, $5wB2C.computed)(function() {
            var a = "1em";
            return t.size && (a = "".concat(typeof t.size == "number" ? t.size : s[t.size], "px")), {
                height: a,
                width: a
            };
        }), i = (0, $5wB2C.computed)(function() {
            var a = {};
            return t.color && (a.color = "var(--color-".concat(t.color, ")")), t.strokeWidth && (a["--n8n-icon-stroke-width"] = "".concat(t.strokeWidth, "px")), a;
        });
        return function(a, c) {
            var __a_icon, __a_icon1;
            return ((__a_icon = (0, $5wB2C.unref)(wd)[a.icon]) !== null && __a_icon !== void 0 ? __a_icon : (0, $5wB2C.unref)(yd)[a.icon]) ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $8B0Dy.resolveDynamicComponent)((__a_icon1 = (0, $5wB2C.unref)(wd)[a.icon]) !== null && __a_icon1 !== void 0 ? __a_icon1 : (0, $5wB2C.unref)(yd)[a.icon]), {
                key: 0,
                "class": (0, $3ZJCa.normalizeClass)(r.value),
                "aria-hidden": "true",
                focusable: "false",
                role: "img",
                height: o.value.height,
                width: o.value.width,
                "data-icon": t.icon,
                style: (0, $3ZJCa.normalizeStyle)(i.value)
            }, null, 8, [
                "class",
                "height",
                "width",
                "data-icon",
                "style"
            ])) : (0, $8B0Dy.createCommentVNode)("", !0);
        };
    }
}), uM = "_strokeWidth_fqxq5_1", dM = "_spin_fqxq5_6", fM = {
    strokeWidth: uM,
    spin: dM
}, pM = {
    $style: fM
}, Sl = /* @__PURE__ */ Ht(lM, [
    [
        "__cssModules",
        pM
    ]
]), hM = {
    "class": "n8n-spinner"
}, gM = {
    key: 0,
    "class": "lds-ring"
}, mM = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    name: "N8nSpinner",
    __name: "Spinner",
    props: {
        size: {
            "default": "medium"
        },
        type: {
            "default": "dots"
        }
    },
    setup: function(e) {
        return function(t, n) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("span", hM, [
                t.type === "ring" ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", gM, n[0] || (n[0] = [
                    (0, $8B0Dy.createElementVNode)("div", null, null, -1),
                    (0, $8B0Dy.createElementVNode)("div", null, null, -1),
                    (0, $8B0Dy.createElementVNode)("div", null, null, -1),
                    (0, $8B0Dy.createElementVNode)("div", null, null, -1)
                ]))) : ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(Sl), {
                    key: 1,
                    icon: "spinner",
                    size: t.size,
                    spin: ""
                }, null, 8, [
                    "size"
                ]))
            ]);
        };
    }
}), vM = {
    key: 1
}, _M = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    name: "N8nButton",
    __name: "Button",
    props: {
        block: {
            type: Boolean,
            "default": !1
        },
        element: {
            "default": "button"
        },
        href: {},
        label: {
            "default": ""
        },
        square: {
            type: Boolean,
            "default": !1
        },
        active: {
            type: Boolean,
            "default": !1
        },
        disabled: {
            type: Boolean,
            "default": !1
        },
        float: {},
        icon: {},
        loading: {
            type: Boolean,
            "default": !1
        },
        outline: {
            type: Boolean,
            "default": !1
        },
        size: {
            "default": "medium"
        },
        iconSize: {},
        text: {
            type: Boolean,
            "default": !1
        },
        type: {
            "default": "primary"
        },
        nativeType: {}
    },
    setup: function(e) {
        var t = (0, $kRi7Z.useCssModule)(), n = (0, $8B0Dy.useAttrs)(), r = e;
        (0, $8B0Dy.watchEffect)(function() {
            r.element === "a" && !r.href && console.error("n8n-button:href is required for link buttons");
        });
        var s = (0, $5wB2C.computed)(function() {
            return r.loading ? "true" : void 0;
        }), o = (0, $5wB2C.computed)(function() {
            return r.disabled ? "true" : void 0;
        }), i = (0, $5wB2C.computed)(function() {
            return r.disabled || r.loading;
        }), a = (0, $5wB2C.computed)(function() {
            var _r_iconSize;
            return (_r_iconSize = r.iconSize) !== null && _r_iconSize !== void 0 ? _r_iconSize : r.size === "xmini" || r.size === "mini" ? "xsmall" : r.size;
        }), c = (0, $5wB2C.computed)(function() {
            return "button ".concat(t.button, " ").concat(t[r.type]).concat(r.size ? " ".concat(t[r.size]) : "").concat(r.outline ? " ".concat(t.outline) : "").concat(r.loading ? " ".concat(t.loading) : "").concat(r["float"] ? " ".concat(t["float-".concat(r["float"])]) : "").concat(r.text ? " ".concat(t.text) : "").concat(r.disabled ? " ".concat(t.disabled) : "").concat(r.block ? " ".concat(t.block) : "").concat(r.active ? " ".concat(t.active) : "").concat(r.icon || r.loading ? " ".concat(t.withIcon) : "").concat(r.square ? " ".concat(t.square) : "");
        });
        return function(u, d) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $8B0Dy.resolveDynamicComponent)(u.element), (0, $8B0Dy.mergeProps)({
                "class": c.value,
                disabled: i.value,
                "aria-disabled": o.value,
                "aria-busy": s.value,
                href: u.href,
                "aria-live": "polite"
            }, (0, $6869c._)({}, (0, $5wB2C.unref)(n), r.nativeType ? {
                type: r.nativeType
            } : {})), {
                "default": (0, $8B0Dy.withCtx)(function() {
                    return [
                        u.loading || u.icon ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("span", {
                            key: 0,
                            "class": (0, $3ZJCa.normalizeClass)((0, $5wB2C.unref)(t).icon)
                        }, [
                            u.loading ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(mM), {
                                key: 0,
                                size: a.value
                            }, null, 8, [
                                "size"
                            ])) : u.icon ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(Sl), {
                                key: 1,
                                icon: u.icon,
                                size: a.value
                            }, null, 8, [
                                "icon",
                                "size"
                            ])) : (0, $8B0Dy.createCommentVNode)("", !0)
                        ], 2)) : (0, $8B0Dy.createCommentVNode)("", !0),
                        u.label ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("span", vM, (0, $3ZJCa.toDisplayString)(u.label), 1)) : u.$slots["default"] ? (0, $8B0Dy.renderSlot)(u.$slots, "default", {
                            key: 2
                        }) : (0, $8B0Dy.createCommentVNode)("", !0)
                    ];
                }),
                _: 3
            }, 16, [
                "class",
                "disabled",
                "aria-disabled",
                "aria-busy",
                "href"
            ]);
        };
    }
}), bM = "_button_mdqve_229", yM = "_active_mdqve_263", wM = "_disabled_mdqve_281", kM = "_loading_mdqve_289", xM = "_secondary_mdqve_312", CM = "_tertiary_mdqve_334", SM = "_success_mdqve_356", EM = "_warning_mdqve_378", AM = "_danger_mdqve_400", $M = "_xmini_mdqve_425", MM = "_square_mdqve_430", IM = "_mini_mdqve_435", TM = "_small_mdqve_445", LM = "_medium_mdqve_455", OM = "_large_mdqve_465", RM = "_xlarge_mdqve_470", PM = "_outline_mdqve_483", BM = "_primary_mdqve_487", zM = "_text_mdqve_524", DM = "_transparent_mdqve_592", NM = "_withIcon_mdqve_597", qM = "_icon_mdqve_603", FM = "_block_mdqve_612", HM = {
    button: bM,
    active: yM,
    disabled: wM,
    loading: kM,
    secondary: xM,
    tertiary: CM,
    success: SM,
    warning: EM,
    danger: AM,
    xmini: $M,
    square: MM,
    mini: IM,
    small: TM,
    medium: LM,
    large: OM,
    xlarge: RM,
    outline: PM,
    primary: BM,
    text: zM,
    transparent: DM,
    withIcon: NM,
    icon: qM,
    block: FM,
    "float-left": "_float-left_mdqve_616",
    "float-right": "_float-right_mdqve_620"
}, jM = {
    $style: HM
}, UM = /* @__PURE__ */ Ht(_M, [
    [
        "__cssModules",
        jM
    ]
]);
(0, $6869c._)({}, oo.props);
var VM = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    name: "N8nText",
    __name: "Text",
    props: {
        bold: {
            type: Boolean,
            "default": !1
        },
        size: {
            "default": "medium"
        },
        color: {},
        align: {},
        compact: {
            type: Boolean,
            "default": !1
        },
        tag: {
            "default": "span"
        }
    },
    setup: function(e) {
        var t = e, n = (0, $kRi7Z.useCssModule)(), r = (0, $5wB2C.computed)(function() {
            var s = [];
            return t.align && s.push("align-".concat(t.align)), t.color && s.push(t.color), t.compact && s.push("compact"), s.push("size-".concat(t.size)), s.push(t.bold ? "bold" : "regular"), s.map(function(o) {
                return n[o];
            });
        });
        return function(s, o) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $8B0Dy.resolveDynamicComponent)(s.tag), (0, $8B0Dy.mergeProps)({
                "class": [
                    "n8n-text"
                ].concat((0, $kf9Kn._)(r.value))
            }, s.$attrs), {
                "default": (0, $8B0Dy.withCtx)(function() {
                    return [
                        (0, $8B0Dy.renderSlot)(s.$slots, "default")
                    ];
                }),
                _: 3
            }, 16, [
                "class"
            ]);
        };
    }
}), ZM = "_bold_ushv1_1", WM = "_regular_ushv1_5", GM = "_compact_ushv1_34", KM = "_primary_ushv1_38", XM = "_secondary_ushv1_42", YM = "_danger_ushv1_62", JM = "_success_ushv1_66", QM = "_warning_ushv1_70", eI = {
    bold: ZM,
    regular: WM,
    "size-xlarge": "_size-xlarge_ushv1_9",
    "size-large": "_size-large_ushv1_14",
    "size-medium": "_size-medium_ushv1_19",
    "size-small": "_size-small_ushv1_24",
    "size-xsmall": "_size-xsmall_ushv1_29",
    compact: GM,
    primary: KM,
    secondary: XM,
    "text-dark": "_text-dark_ushv1_46",
    "text-base": "_text-base_ushv1_50",
    "text-light": "_text-light_ushv1_54",
    "text-xlight": "_text-xlight_ushv1_58",
    danger: YM,
    success: JM,
    warning: QM,
    "foreground-dark": "_foreground-dark_ushv1_74",
    "foreground-xdark": "_foreground-xdark_ushv1_78",
    "align-left": "_align-left_ushv1_82",
    "align-right": "_align-right_ushv1_86",
    "align-center": "_align-center_ushv1_90"
}, tI = {
    $style: eI
}, nm = /* @__PURE__ */ Ht(VM, [
    [
        "__cssModules",
        tI
    ]
]), nI = {
    key: 0
}, rI = {
    key: 1
}, oI = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    __name: "Loading",
    props: {
        animated: {
            type: Boolean,
            "default": !0
        },
        loading: {
            type: Boolean,
            "default": !0
        },
        rows: {
            "default": 1
        },
        cols: {
            "default": 0
        },
        shrinkLast: {
            type: Boolean,
            "default": !0
        },
        variant: {
            "default": "p"
        }
    },
    setup: function(e) {
        return function(t, n) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(B8), {
                loading: t.loading,
                animated: t.animated,
                "class": (0, $3ZJCa.normalizeClass)([
                    "n8n-loading",
                    "n8n-loading-".concat(t.variant)
                ])
            }, (0, $8B0Dy.createSlots)({
                _: 2
            }, [
                t.cols ? {
                    name: "template",
                    fn: (0, $8B0Dy.withCtx)(function() {
                        return [
                            ((0, $8B0Dy.openBlock)(!0), (0, $8B0Dy.createElementBlock)((0, $8B0Dy.Fragment), null, (0, $8B0Dy.renderList)(t.cols, function(r) {
                                return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(Nr), {
                                    key: r
                                });
                            }), 128))
                        ];
                    }),
                    key: "0"
                } : {
                    name: "template",
                    fn: (0, $8B0Dy.withCtx)(function() {
                        return [
                            t.variant === "h1" ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", nI, [
                                ((0, $8B0Dy.openBlock)(!0), (0, $8B0Dy.createElementBlock)((0, $8B0Dy.Fragment), null, (0, $8B0Dy.renderList)(t.rows, function(r, s) {
                                    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
                                        key: s,
                                        "class": (0, $3ZJCa.normalizeClass)((0, $aRIHe._)({}, t.$style.h1Last, r === t.rows && t.rows > 1 && t.shrinkLast))
                                    }, [
                                        (0, $8B0Dy.createVNode)((0, $5wB2C.unref)(Nr), {
                                            variant: t.variant
                                        }, null, 8, [
                                            "variant"
                                        ])
                                    ], 2);
                                }), 128))
                            ])) : t.variant === "p" ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", rI, [
                                ((0, $8B0Dy.openBlock)(!0), (0, $8B0Dy.createElementBlock)((0, $8B0Dy.Fragment), null, (0, $8B0Dy.renderList)(t.rows, function(r, s) {
                                    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
                                        key: s,
                                        "class": (0, $3ZJCa.normalizeClass)((0, $aRIHe._)({}, t.$style.pLast, r === t.rows && t.rows > 1 && t.shrinkLast))
                                    }, [
                                        (0, $8B0Dy.createVNode)((0, $5wB2C.unref)(Nr), {
                                            variant: t.variant
                                        }, null, 8, [
                                            "variant"
                                        ])
                                    ], 2);
                                }), 128))
                            ])) : t.variant === "custom" ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
                                key: 2,
                                "class": (0, $3ZJCa.normalizeClass)(t.$style.custom)
                            }, [
                                (0, $8B0Dy.createVNode)((0, $5wB2C.unref)(Nr))
                            ], 2)) : ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(Nr), {
                                key: 3,
                                variant: t.variant
                            }, null, 8, [
                                "variant"
                            ]))
                        ];
                    }),
                    key: "1"
                }
            ]), 1032, [
                "loading",
                "animated",
                "class"
            ]);
        };
    }
}), sI = "_h1Last_1sdbr_1", iI = "_pLast_1sdbr_5", aI = "_custom_1sdbr_9", cI = {
    h1Last: sI,
    pLast: iI,
    custom: aI
}, lI = {
    $style: cI
}, uI = /* @__PURE__ */ Ht(oI, [
    [
        "__cssModules",
        lI
    ]
]), Mr = function(e) {
    var t = 0;
    for(var n = 0; n < e.length; n++){
        var r = e.charCodeAt(n);
        t = (t << 5) - t + r, t = t & t;
    }
    return Math.abs(t);
}, rm = function(e, t) {
    return Math.floor(e / Math.pow(10, t) % 10);
}, zc = function(e, t) {
    return !(rm(e, t) % 2);
}, pt = function(e, t, n) {
    var r = e % t;
    return n && rm(e, n) % 2 === 0 ? -r : r;
}, nr = function(e, t, n) {
    return t[e % n];
}, dI = function(e) {
    e.slice(0, 1) === "#" && (e = e.slice(1));
    var t = parseInt(e.substring(0, 2), 16), n = parseInt(e.substring(2, 4), 16), r = parseInt(e.substring(4, 6), 16);
    return (t * 299 + n * 587 + r * 114) / 1e3 >= 128 ? "#000000" : "#FFFFFF";
}, fI = 4, Dc = 80;
function pI(e, t) {
    var n = Mr(e), r = t && t.length;
    return Array.from({
        length: fI
    }, function(s, o) {
        return {
            color: nr(n + o, t, r),
            translateX: pt(n * (o + 1), Dc / 2 - (o + 17), 1),
            translateY: pt(n * (o + 1), Dc / 2 - (o + 17), 2),
            rotate: pt(n * (o + 1), 360),
            isSquare: zc(n, 2)
        };
    });
}
var hI = (0, $8B0Dy.defineComponent)({
    props: {
        colors: {
            type: Array,
            required: !0
        },
        name: {
            type: String,
            required: !0
        },
        square: {
            type: Boolean,
            required: !1,
            "default": !1
        },
        size: {
            type: Number,
            required: !0
        },
        title: {
            type: Boolean,
            required: !1,
            "default": !1
        }
    },
    setup: function(e) {
        return {
            properties: (0, $5wB2C.computed)(function() {
                return pI(e.name, e.colors);
            }),
            SIZE: Dc
        };
    }
}), Ir = function(e, t) {
    var n = e.__vccOpts || e;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $9tk0W._)(_step.value, 2), r = _step_value[0], s = _step_value[1];
            n[r] = s;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return n;
}, gI = [
    "viewBox",
    "width",
    "height"
], mI = {
    key: 0
}, vI = [
    "width",
    "height"
], _I = [
    "width",
    "height",
    "rx"
], bI = {
    mask: "url(#mask__bauhaus)"
}, yI = [
    "width",
    "height",
    "fill"
], wI = [
    "x",
    "y",
    "width",
    "height",
    "fill",
    "transform"
], kI = [
    "cx",
    "cy",
    "fill",
    "r",
    "transform"
], xI = [
    "y1",
    "x2",
    "y2",
    "stroke",
    "transform"
];
function CI(e, t, n, r, s, o) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", {
        viewBox: "0 0 ".concat(e.SIZE, " ").concat(e.SIZE),
        fill: "none",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        width: e.size,
        height: e.size
    }, [
        e.title ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("title", mI, (0, $3ZJCa.toDisplayString)(e.name), 1)) : (0, $8B0Dy.createCommentVNode)("", !0),
        (0, $8B0Dy.createElementVNode)("mask", {
            id: "mask__bauhaus",
            maskUnits: "userSpaceOnUse",
            x: 0,
            y: 0,
            width: e.SIZE,
            height: e.SIZE
        }, [
            (0, $8B0Dy.createElementVNode)("rect", {
                width: e.SIZE,
                height: e.SIZE,
                rx: e.square ? void 0 : e.SIZE * 2,
                fill: "#FFFFFF"
            }, null, 8, _I)
        ], 8, vI),
        (0, $8B0Dy.createElementVNode)("g", bI, [
            (0, $8B0Dy.createElementVNode)("rect", {
                width: e.SIZE,
                height: e.SIZE,
                fill: e.properties[0].color
            }, null, 8, yI),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: (e.SIZE - 60) / 2,
                y: (e.SIZE - 20) / 2,
                width: e.SIZE,
                height: e.properties[1].isSquare ? e.SIZE : e.SIZE / 8,
                fill: e.properties[1].color,
                transform: "translate(".concat(e.properties[1].translateX, " ").concat(e.properties[1].translateY, ") rotate(").concat(e.properties[1].rotate, " ").concat(e.SIZE / 2, " ").concat(e.SIZE / 2, ")")
            }, null, 8, wI),
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: e.SIZE / 2,
                cy: e.SIZE / 2,
                fill: e.properties[2].color,
                r: e.SIZE / 5,
                transform: "translate(".concat(e.properties[2].translateX, " ").concat(e.properties[2].translateY, ")")
            }, null, 8, kI),
            (0, $8B0Dy.createElementVNode)("line", {
                x1: 0,
                y1: e.SIZE / 2,
                x2: e.SIZE,
                y2: e.SIZE / 2,
                "stroke-width": 2,
                stroke: e.properties[3].color,
                transform: "translate(".concat(e.properties[3].translateX, " ").concat(e.properties[3].translateY, ") rotate(").concat(e.properties[3].rotate, " ").concat(e.SIZE / 2, " ").concat(e.SIZE / 2, ")")
            }, null, 8, xI)
        ])
    ], 8, gI);
}
var SI = /* @__PURE__ */ Ir(hI, [
    [
        "render",
        CI
    ]
]), fr = 36;
function EI(e, t) {
    var n = Mr(e), r = t && t.length, s = nr(n, t, r), o = pt(n, 10, 1), i = o < 5 ? o + fr / 9 : o, a = pt(n, 10, 2), c = a < 5 ? a + fr / 9 : a;
    return {
        wrapperColor: s,
        faceColor: dI(s),
        backgroundColor: nr(n + 13, t, r),
        wrapperTranslateX: i,
        wrapperTranslateY: c,
        wrapperRotate: pt(n, 360),
        wrapperScale: 1 + pt(n, fr / 12) / 10,
        isMouthOpen: zc(n, 2),
        isCircle: zc(n, 1),
        eyeSpread: pt(n, 5),
        mouthSpread: pt(n, 3),
        faceRotate: pt(n, 10, 3),
        faceTranslateX: i > fr / 6 ? i / 2 : pt(n, 8, 1),
        faceTranslateY: c > fr / 6 ? c / 2 : pt(n, 7, 2)
    };
}
var AI = (0, $8B0Dy.defineComponent)({
    props: {
        colors: {
            type: Array,
            required: !0
        },
        name: {
            type: String,
            required: !0
        },
        square: {
            type: Boolean,
            required: !1,
            "default": !1
        },
        size: {
            type: Number,
            required: !0
        },
        title: {
            type: Boolean,
            required: !1,
            "default": !1
        }
    },
    setup: function(e) {
        return {
            data: (0, $5wB2C.computed)(function() {
                return EI(e.name, e.colors);
            }),
            SIZE: fr
        };
    }
}), $I = [
    "viewBox",
    "width",
    "height"
], MI = {
    key: 0
}, II = [
    "width",
    "height"
], TI = [
    "width",
    "height",
    "rx"
], LI = {
    mask: "url(#mask__beam)"
}, OI = [
    "width",
    "height",
    "fill"
], RI = [
    "width",
    "height",
    "transform",
    "fill",
    "rx"
], PI = [
    "transform"
], BI = [
    "d",
    "stroke"
], zI = [
    "d",
    "fill"
], DI = [
    "x",
    "width",
    "fill"
], NI = [
    "x",
    "width",
    "fill"
];
function qI(e, t, n, r, s, o) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", {
        viewBox: "0 0 ".concat(e.SIZE, " ").concat(e.SIZE),
        fill: "none",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        width: e.size,
        height: e.size
    }, [
        e.title ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("title", MI, (0, $3ZJCa.toDisplayString)(e.name), 1)) : (0, $8B0Dy.createCommentVNode)("", !0),
        (0, $8B0Dy.createElementVNode)("mask", {
            id: "mask__beam",
            maskUnits: "userSpaceOnUse",
            x: 0,
            y: 0,
            width: e.SIZE,
            height: e.SIZE
        }, [
            (0, $8B0Dy.createElementVNode)("rect", {
                width: e.SIZE,
                height: e.SIZE,
                rx: e.square ? void 0 : e.SIZE * 2,
                fill: "#FFFFFF"
            }, null, 8, TI)
        ], 8, II),
        (0, $8B0Dy.createElementVNode)("g", LI, [
            (0, $8B0Dy.createElementVNode)("rect", {
                width: e.SIZE,
                height: e.SIZE,
                fill: e.data.backgroundColor
            }, null, 8, OI),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 0,
                y: 0,
                width: e.SIZE,
                height: e.SIZE,
                transform: "translate(".concat(e.data.wrapperTranslateX, " ").concat(e.data.wrapperTranslateY, ") rotate(").concat(e.data.wrapperRotate, " ").concat(e.SIZE / 2, " ").concat(e.SIZE / 2, ") scale(").concat(e.data.wrapperScale, ")"),
                fill: e.data.wrapperColor,
                rx: e.data.isCircle ? e.SIZE : e.SIZE / 6
            }, null, 8, RI),
            (0, $8B0Dy.createElementVNode)("g", {
                transform: "translate(".concat(e.data.faceTranslateX, " ").concat(e.data.faceTranslateY, ") rotate(").concat(e.data.faceRotate, " ").concat(e.SIZE / 2, " ").concat(e.SIZE / 2, ")")
            }, [
                e.data.isMouthOpen ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("path", {
                    key: 0,
                    d: "M15 ".concat(19 + e.data.mouthSpread, "c2 1\n        4 1 6 0"),
                    stroke: e.data.faceColor,
                    fill: "none",
                    "stroke-linecap": "round"
                }, null, 8, BI)) : ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("path", {
                    key: 1,
                    d: "M13,".concat(19 + e.data.mouthSpread, " a1,0.75 0 0,0 10,0"),
                    fill: e.data.faceColor
                }, null, 8, zI)),
                (0, $8B0Dy.createElementVNode)("rect", {
                    x: 14 - e.data.eyeSpread,
                    y: 14,
                    width: 1.5,
                    height: 2,
                    rx: 1,
                    stroke: "none",
                    fill: e.data.faceColor
                }, null, 8, DI),
                (0, $8B0Dy.createElementVNode)("rect", {
                    x: 20 + e.data.eyeSpread,
                    y: 14,
                    width: 1.5,
                    height: 2,
                    rx: 1,
                    stroke: "none",
                    fill: e.data.faceColor
                }, null, 8, NI)
            ], 8, PI)
        ])
    ], 8, $I);
}
var FI = /* @__PURE__ */ Ir(AI, [
    [
        "render",
        qI
    ]
]), HI = 3, Ho = 80;
function jI(e, t) {
    var n = Mr(e), r = t && t.length;
    return Array.from({
        length: HI
    }, function(s, o) {
        return {
            color: nr(n + o, t, r),
            translateX: pt(n * (o + 1), Ho / 10, 1),
            translateY: pt(n * (o + 1), Ho / 10, 2),
            scale: 1.2 + pt(n * (o + 1), Ho / 20) / 10,
            rotate: pt(n * (o + 1), 360, 1)
        };
    });
}
var UI = (0, $8B0Dy.defineComponent)({
    props: {
        colors: {
            type: Array,
            required: !0
        },
        name: {
            type: String,
            required: !0
        },
        square: {
            type: Boolean,
            required: !1,
            "default": !1
        },
        size: {
            type: Number,
            required: !0
        },
        title: {
            type: Boolean,
            required: !1,
            "default": !1
        }
    },
    setup: function(e) {
        return {
            properties: (0, $5wB2C.computed)(function() {
                return jI(e.name, e.colors);
            }),
            SIZE: Ho
        };
    }
}), VI = function(e) {
    return (0, $8B0Dy.pushScopeId)("data-v-3c8b58b0"), e = e(), (0, $8B0Dy.popScopeId)(), e;
}, ZI = [
    "viewBox",
    "width",
    "height"
], WI = {
    key: 0
}, GI = [
    "width",
    "height"
], KI = [
    "width",
    "height",
    "rx"
], XI = {
    mask: "url(#mask__marble)"
}, YI = [
    "width",
    "height",
    "fill"
], JI = [
    "fill",
    "transform"
], QI = [
    "fill",
    "transform"
], eT = /* @__PURE__ */ VI(function() {
    return /* @__PURE__ */ (0, $8B0Dy.createElementVNode)("defs", null, [
        /* @__PURE__ */ (0, $8B0Dy.createElementVNode)("filter", {
            id: "prefix__filter0_f",
            filterUnits: "userSpaceOnUse",
            "color-interpolation-filters": "sRGB"
        }, [
            /* @__PURE__ */ (0, $8B0Dy.createElementVNode)("feFlood", {
                "flood-opacity": 0,
                result: "BackgroundImageFix"
            }),
            /* @__PURE__ */ (0, $8B0Dy.createElementVNode)("feBlend", {
                "in": "SourceGraphic",
                in2: "BackgroundImageFix",
                result: "shape"
            }),
            /* @__PURE__ */ (0, $8B0Dy.createElementVNode)("feGaussianBlur", {
                stdDeviation: 7,
                result: "effect1_foregroundBlur"
            })
        ])
    ], -1);
});
function tT(e, t, n, r, s, o) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", {
        viewBox: "0 0 ".concat(e.SIZE, " ").concat(e.SIZE),
        fill: "none",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        width: e.size,
        height: e.size
    }, [
        e.title ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("title", WI, (0, $3ZJCa.toDisplayString)(e.name), 1)) : (0, $8B0Dy.createCommentVNode)("", !0),
        (0, $8B0Dy.createElementVNode)("mask", {
            id: "mask__marble",
            maskUnits: "userSpaceOnUse",
            x: 0,
            y: 0,
            width: e.SIZE,
            height: e.SIZE
        }, [
            (0, $8B0Dy.createElementVNode)("rect", {
                width: e.SIZE,
                height: e.SIZE,
                rx: e.square ? void 0 : e.SIZE * 2,
                fill: "#FFFFFF"
            }, null, 8, KI)
        ], 8, GI),
        (0, $8B0Dy.createElementVNode)("g", XI, [
            (0, $8B0Dy.createElementVNode)("rect", {
                width: e.SIZE,
                height: e.SIZE,
                fill: e.properties[0].color
            }, null, 8, YI),
            (0, $8B0Dy.createElementVNode)("path", {
                filter: "url(#prefix__filter0_f)",
                d: "M32.414 59.35L50.376 70.5H72.5v-71H33.728L26.5 13.381l19.057 27.08L32.414 59.35z",
                fill: e.properties[1].color,
                transform: "translate(".concat(e.properties[1].translateX, " ").concat(e.properties[1].translateY, ") rotate(").concat(e.properties[1].rotate, " ").concat(e.SIZE / 2, " ").concat(e.SIZE / 2, ") scale(").concat(e.properties[2].scale, ")")
            }, null, 8, JI),
            (0, $8B0Dy.createElementVNode)("path", {
                filter: "url(#prefix__filter0_f)",
                "class": "mix-blend-overlay",
                d: "M22.216 24L0 46.75l14.108 38.129L78 86l-3.081-59.276-22.378 4.005 12.972 20.186-23.35 27.395L22.215 24z",
                fill: e.properties[2].color,
                transform: "translate(".concat(e.properties[2].translateX, " ").concat(e.properties[2].translateY, ") rotate(").concat(e.properties[2].rotate, " ").concat(e.SIZE / 2, " ").concat(e.SIZE / 2, ") scale(").concat(e.properties[2].scale, ")")
            }, null, 8, QI)
        ]),
        eT
    ], 8, ZI);
}
var nT = /* @__PURE__ */ Ir(UI, [
    [
        "render",
        tT
    ],
    [
        "__scopeId",
        "data-v-3c8b58b0"
    ]
]), rT = 64, oT = 80;
function sT(e, t) {
    var n = Mr(e), r = t && t.length;
    return Array.from({
        length: rT
    }, function(s, o) {
        return nr(n % o, t, r);
    });
}
var iT = (0, $8B0Dy.defineComponent)({
    props: {
        colors: {
            type: Array,
            required: !0
        },
        name: {
            type: String,
            required: !0
        },
        square: {
            type: Boolean,
            required: !1,
            "default": !1
        },
        size: {
            type: Number,
            required: !0
        },
        title: {
            type: Boolean,
            required: !1,
            "default": !1
        }
    },
    setup: function(e) {
        return {
            pixelColors: (0, $5wB2C.computed)(function() {
                return sT(e.name, e.colors);
            }),
            SIZE: oT
        };
    }
}), aT = [
    "viewBox",
    "width",
    "height"
], cT = {
    key: 0
}, lT = [
    "width",
    "height"
], uT = [
    "width",
    "height",
    "rx"
], dT = {
    mask: "url(#mask__pixel)"
}, fT = [
    "fill"
], pT = [
    "fill"
], hT = [
    "fill"
], gT = [
    "fill"
], mT = [
    "fill"
], vT = [
    "fill"
], _T = [
    "fill"
], bT = [
    "fill"
], yT = [
    "fill"
], wT = [
    "fill"
], kT = [
    "fill"
], xT = [
    "fill"
], CT = [
    "fill"
], ST = [
    "fill"
], ET = [
    "fill"
], AT = [
    "fill"
], $T = [
    "fill"
], MT = [
    "fill"
], IT = [
    "fill"
], TT = [
    "fill"
], LT = [
    "fill"
], OT = [
    "fill"
], RT = [
    "fill"
], PT = [
    "fill"
], BT = [
    "fill"
], zT = [
    "fill"
], DT = [
    "fill"
], NT = [
    "fill"
], qT = [
    "fill"
], FT = [
    "fill"
], HT = [
    "fill"
], jT = [
    "fill"
], UT = [
    "fill"
], VT = [
    "fill"
], ZT = [
    "fill"
], WT = [
    "fill"
], GT = [
    "fill"
], KT = [
    "fill"
], XT = [
    "fill"
], YT = [
    "fill"
], JT = [
    "fill"
], QT = [
    "fill"
], eL = [
    "fill"
], tL = [
    "fill"
], nL = [
    "fill"
], rL = [
    "fill"
], oL = [
    "fill"
], sL = [
    "fill"
], iL = [
    "fill"
], aL = [
    "fill"
], cL = [
    "fill"
], lL = [
    "fill"
], uL = [
    "fill"
], dL = [
    "fill"
], fL = [
    "fill"
], pL = [
    "fill"
], hL = [
    "fill"
], gL = [
    "fill"
], mL = [
    "fill"
], vL = [
    "fill"
], _L = [
    "fill"
], bL = [
    "fill"
], yL = [
    "fill"
], wL = [
    "fill"
];
function kL(e, t, n, r, s, o) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", {
        viewBox: "0 0 ".concat(e.SIZE, " ").concat(e.SIZE),
        fill: "none",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        width: e.size,
        height: e.size
    }, [
        e.title ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("title", cT, (0, $3ZJCa.toDisplayString)(e.name), 1)) : (0, $8B0Dy.createCommentVNode)("", !0),
        (0, $8B0Dy.createElementVNode)("mask", {
            id: "mask__pixel",
            "mask-type": "alpha",
            maskUnits: "userSpaceOnUse",
            x: 0,
            y: 0,
            width: e.SIZE,
            height: e.SIZE
        }, [
            (0, $8B0Dy.createElementVNode)("rect", {
                width: e.SIZE,
                height: e.SIZE,
                rx: e.square ? void 0 : e.SIZE * 2,
                fill: "#FFFFFF"
            }, null, 8, uT)
        ], 8, lT),
        (0, $8B0Dy.createElementVNode)("g", dT, [
            (0, $8B0Dy.createElementVNode)("rect", {
                width: 10,
                height: 10,
                fill: e.pixelColors[0]
            }, null, 8, fT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 20,
                width: 10,
                height: 10,
                fill: e.pixelColors[1]
            }, null, 8, pT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 40,
                width: 10,
                height: 10,
                fill: e.pixelColors[2]
            }, null, 8, hT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 60,
                width: 10,
                height: 10,
                fill: e.pixelColors[3]
            }, null, 8, gT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 10,
                width: 10,
                height: 10,
                fill: e.pixelColors[4]
            }, null, 8, mT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 30,
                width: 10,
                height: 10,
                fill: e.pixelColors[5]
            }, null, 8, vT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 50,
                width: 10,
                height: 10,
                fill: e.pixelColors[6]
            }, null, 8, _T),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 70,
                width: 10,
                height: 10,
                fill: e.pixelColors[7]
            }, null, 8, bT),
            (0, $8B0Dy.createElementVNode)("rect", {
                y: 10,
                width: 10,
                height: 10,
                fill: e.pixelColors[8]
            }, null, 8, yT),
            (0, $8B0Dy.createElementVNode)("rect", {
                y: 20,
                width: 10,
                height: 10,
                fill: e.pixelColors[9]
            }, null, 8, wT),
            (0, $8B0Dy.createElementVNode)("rect", {
                y: 30,
                width: 10,
                height: 10,
                fill: e.pixelColors[10]
            }, null, 8, kT),
            (0, $8B0Dy.createElementVNode)("rect", {
                y: 40,
                width: 10,
                height: 10,
                fill: e.pixelColors[11]
            }, null, 8, xT),
            (0, $8B0Dy.createElementVNode)("rect", {
                y: 50,
                width: 10,
                height: 10,
                fill: e.pixelColors[12]
            }, null, 8, CT),
            (0, $8B0Dy.createElementVNode)("rect", {
                y: 60,
                width: 10,
                height: 10,
                fill: e.pixelColors[13]
            }, null, 8, ST),
            (0, $8B0Dy.createElementVNode)("rect", {
                y: 70,
                width: 10,
                height: 10,
                fill: e.pixelColors[14]
            }, null, 8, ET),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 20,
                y: 10,
                width: 10,
                height: 10,
                fill: e.pixelColors[15]
            }, null, 8, AT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 20,
                y: 20,
                width: 10,
                height: 10,
                fill: e.pixelColors[16]
            }, null, 8, $T),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 20,
                y: 30,
                width: 10,
                height: 10,
                fill: e.pixelColors[17]
            }, null, 8, MT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 20,
                y: 40,
                width: 10,
                height: 10,
                fill: e.pixelColors[18]
            }, null, 8, IT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 20,
                y: 50,
                width: 10,
                height: 10,
                fill: e.pixelColors[19]
            }, null, 8, TT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 20,
                y: 60,
                width: 10,
                height: 10,
                fill: e.pixelColors[20]
            }, null, 8, LT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 20,
                y: 70,
                width: 10,
                height: 10,
                fill: e.pixelColors[21]
            }, null, 8, OT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 40,
                y: 10,
                width: 10,
                height: 10,
                fill: e.pixelColors[22]
            }, null, 8, RT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 40,
                y: 20,
                width: 10,
                height: 10,
                fill: e.pixelColors[23]
            }, null, 8, PT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 40,
                y: 30,
                width: 10,
                height: 10,
                fill: e.pixelColors[24]
            }, null, 8, BT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 40,
                y: 40,
                width: 10,
                height: 10,
                fill: e.pixelColors[25]
            }, null, 8, zT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 40,
                y: 50,
                width: 10,
                height: 10,
                fill: e.pixelColors[26]
            }, null, 8, DT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 40,
                y: 60,
                width: 10,
                height: 10,
                fill: e.pixelColors[27]
            }, null, 8, NT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 40,
                y: 70,
                width: 10,
                height: 10,
                fill: e.pixelColors[28]
            }, null, 8, qT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 60,
                y: 10,
                width: 10,
                height: 10,
                fill: e.pixelColors[29]
            }, null, 8, FT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 60,
                y: 20,
                width: 10,
                height: 10,
                fill: e.pixelColors[30]
            }, null, 8, HT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 60,
                y: 30,
                width: 10,
                height: 10,
                fill: e.pixelColors[31]
            }, null, 8, jT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 60,
                y: 40,
                width: 10,
                height: 10,
                fill: e.pixelColors[32]
            }, null, 8, UT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 60,
                y: 50,
                width: 10,
                height: 10,
                fill: e.pixelColors[33]
            }, null, 8, VT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 60,
                y: 60,
                width: 10,
                height: 10,
                fill: e.pixelColors[34]
            }, null, 8, ZT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 60,
                y: 70,
                width: 10,
                height: 10,
                fill: e.pixelColors[35]
            }, null, 8, WT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 10,
                y: 10,
                width: 10,
                height: 10,
                fill: e.pixelColors[36]
            }, null, 8, GT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 10,
                y: 20,
                width: 10,
                height: 10,
                fill: e.pixelColors[37]
            }, null, 8, KT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 10,
                y: 30,
                width: 10,
                height: 10,
                fill: e.pixelColors[38]
            }, null, 8, XT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 10,
                y: 40,
                width: 10,
                height: 10,
                fill: e.pixelColors[39]
            }, null, 8, YT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 10,
                y: 50,
                width: 10,
                height: 10,
                fill: e.pixelColors[40]
            }, null, 8, JT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 10,
                y: 60,
                width: 10,
                height: 10,
                fill: e.pixelColors[41]
            }, null, 8, QT),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 10,
                y: 70,
                width: 10,
                height: 10,
                fill: e.pixelColors[42]
            }, null, 8, eL),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 30,
                y: 10,
                width: 10,
                height: 10,
                fill: e.pixelColors[43]
            }, null, 8, tL),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 30,
                y: 20,
                width: 10,
                height: 10,
                fill: e.pixelColors[44]
            }, null, 8, nL),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 30,
                y: 30,
                width: 10,
                height: 10,
                fill: e.pixelColors[45]
            }, null, 8, rL),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 30,
                y: 40,
                width: 10,
                height: 10,
                fill: e.pixelColors[46]
            }, null, 8, oL),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 30,
                y: 50,
                width: 10,
                height: 10,
                fill: e.pixelColors[47]
            }, null, 8, sL),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 30,
                y: 60,
                width: 10,
                height: 10,
                fill: e.pixelColors[48]
            }, null, 8, iL),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 30,
                y: 70,
                width: 10,
                height: 10,
                fill: e.pixelColors[49]
            }, null, 8, aL),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 50,
                y: 10,
                width: 10,
                height: 10,
                fill: e.pixelColors[50]
            }, null, 8, cL),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 50,
                y: 20,
                width: 10,
                height: 10,
                fill: e.pixelColors[51]
            }, null, 8, lL),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 50,
                y: 30,
                width: 10,
                height: 10,
                fill: e.pixelColors[52]
            }, null, 8, uL),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 50,
                y: 40,
                width: 10,
                height: 10,
                fill: e.pixelColors[53]
            }, null, 8, dL),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 50,
                y: 50,
                width: 10,
                height: 10,
                fill: e.pixelColors[54]
            }, null, 8, fL),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 50,
                y: 60,
                width: 10,
                height: 10,
                fill: e.pixelColors[55]
            }, null, 8, pL),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 50,
                y: 70,
                width: 10,
                height: 10,
                fill: e.pixelColors[56]
            }, null, 8, hL),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 70,
                y: 10,
                width: 10,
                height: 10,
                fill: e.pixelColors[57]
            }, null, 8, gL),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 70,
                y: 20,
                width: 10,
                height: 10,
                fill: e.pixelColors[58]
            }, null, 8, mL),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 70,
                y: 30,
                width: 10,
                height: 10,
                fill: e.pixelColors[59]
            }, null, 8, vL),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 70,
                y: 40,
                width: 10,
                height: 10,
                fill: e.pixelColors[60]
            }, null, 8, _L),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 70,
                y: 50,
                width: 10,
                height: 10,
                fill: e.pixelColors[61]
            }, null, 8, bL),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 70,
                y: 60,
                width: 10,
                height: 10,
                fill: e.pixelColors[62]
            }, null, 8, yL),
            (0, $8B0Dy.createElementVNode)("rect", {
                x: 70,
                y: 70,
                width: 10,
                height: 10,
                fill: e.pixelColors[63]
            }, null, 8, wL)
        ])
    ], 8, aT);
}
var xL = /* @__PURE__ */ Ir(iT, [
    [
        "render",
        kL
    ]
]), CL = 90, SL = 5;
function EL(e, t) {
    var n = Mr(e), r = t && t.length, s = Array.from({
        length: SL
    }, function(i, a) {
        return nr(n + a, t, r);
    }), o = [];
    return o[0] = s[0], o[1] = s[1], o[2] = s[1], o[3] = s[2], o[4] = s[2], o[5] = s[3], o[6] = s[3], o[7] = s[0], o[8] = s[4], o;
}
var AL = (0, $8B0Dy.defineComponent)({
    props: {
        colors: {
            type: Array,
            required: !0
        },
        name: {
            type: String,
            required: !0
        },
        square: {
            type: Boolean,
            required: !1,
            "default": !1
        },
        size: {
            type: Number,
            required: !0
        },
        title: {
            type: Boolean,
            required: !1,
            "default": !1
        }
    },
    setup: function(e) {
        return {
            ringColors: (0, $5wB2C.computed)(function() {
                return EL(e.name, e.colors);
            }),
            SIZE: CL
        };
    }
}), $L = [
    "viewBox",
    "width",
    "height"
], ML = {
    key: 0
}, IL = [
    "width",
    "height"
], TL = [
    "width",
    "height",
    "rx"
], LL = {
    mask: "url(#mask__ring)"
}, OL = [
    "fill"
], RL = [
    "fill"
], PL = [
    "fill"
], BL = [
    "fill"
], zL = [
    "fill"
], DL = [
    "fill"
], NL = [
    "fill"
], qL = [
    "fill"
], FL = [
    "fill"
];
function HL(e, t, n, r, s, o) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", {
        viewBox: "0 0 ".concat(e.SIZE, " ").concat(e.SIZE),
        fill: "none",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        width: e.size,
        height: e.size
    }, [
        e.title ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("title", ML, (0, $3ZJCa.toDisplayString)(e.name), 1)) : (0, $8B0Dy.createCommentVNode)("", !0),
        (0, $8B0Dy.createElementVNode)("mask", {
            id: "mask__ring",
            maskUnits: "userSpaceOnUse",
            x: 0,
            y: 0,
            width: e.SIZE,
            height: e.SIZE
        }, [
            (0, $8B0Dy.createElementVNode)("rect", {
                width: e.SIZE,
                height: e.SIZE,
                rx: e.square ? void 0 : e.SIZE * 2,
                fill: "#FFFFFF"
            }, null, 8, TL)
        ], 8, IL),
        (0, $8B0Dy.createElementVNode)("g", LL, [
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M0 0h90v45H0z",
                fill: e.ringColors[0]
            }, null, 8, OL),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M0 45h90v45H0z",
                fill: e.ringColors[1]
            }, null, 8, RL),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M83 45a38 38 0 00-76 0h76z",
                fill: e.ringColors[2]
            }, null, 8, PL),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M83 45a38 38 0 01-76 0h76z",
                fill: e.ringColors[3]
            }, null, 8, BL),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M77 45a32 32 0 10-64 0h64z",
                fill: e.ringColors[4]
            }, null, 8, zL),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M77 45a32 32 0 11-64 0h64z",
                fill: e.ringColors[5]
            }, null, 8, DL),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M71 45a26 26 0 00-52 0h52z",
                fill: e.ringColors[6]
            }, null, 8, NL),
            (0, $8B0Dy.createElementVNode)("path", {
                d: "M71 45a26 26 0 01-52 0h52z",
                fill: e.ringColors[7]
            }, null, 8, qL),
            (0, $8B0Dy.createElementVNode)("circle", {
                cx: 45,
                cy: 45,
                r: 23,
                fill: e.ringColors[8]
            }, null, 8, FL)
        ])
    ], 8, $L);
}
var jL = /* @__PURE__ */ Ir(AL, [
    [
        "render",
        HL
    ]
]), UL = 4, VL = 80;
function ZL(e, t) {
    var n = Mr(e), r = t && t.length;
    return Array.from({
        length: UL
    }, function(s, o) {
        return nr(n + o, t, r);
    });
}
var WL = (0, $8B0Dy.defineComponent)({
    props: {
        colors: {
            type: Array,
            required: !0
        },
        name: {
            type: String,
            required: !0
        },
        square: {
            type: Boolean,
            required: !1,
            "default": !1
        },
        size: {
            type: Number,
            required: !0
        },
        title: {
            type: Boolean,
            required: !1,
            "default": !1
        }
    },
    setup: function(e) {
        var t = (0, $5wB2C.computed)(function() {
            return ZL(e.name, e.colors);
        }), n = (0, $5wB2C.computed)(function() {
            return e.name.replace(/\s/g, "");
        });
        return {
            sunsetColors: t,
            formattedName: n,
            SIZE: VL
        };
    }
}), GL = [
    "viewBox",
    "width",
    "height"
], KL = {
    key: 0
}, XL = [
    "width",
    "height"
], YL = [
    "width",
    "height",
    "rx"
], JL = {
    mask: "url(#mask__sunset)"
}, QL = [
    "fill"
], eO = [
    "fill"
], tO = [
    "id",
    "x1",
    "x2",
    "y2"
], nO = [
    "stop-color"
], rO = [
    "stop-color"
], oO = [
    "id",
    "x1",
    "y1",
    "x2",
    "y2"
], sO = [
    "stop-color"
], iO = [
    "stop-color"
];
function aO(e, t, n, r, s, o) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", {
        viewBox: "0 0 ".concat(e.SIZE, " ").concat(e.SIZE),
        fill: "none",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        width: e.size,
        height: e.size
    }, [
        e.title ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("title", KL, (0, $3ZJCa.toDisplayString)(e.name), 1)) : (0, $8B0Dy.createCommentVNode)("", !0),
        (0, $8B0Dy.createElementVNode)("mask", {
            id: "mask__sunset",
            maskUnits: "userSpaceOnUse",
            x: 0,
            y: 0,
            width: e.SIZE,
            height: e.SIZE
        }, [
            (0, $8B0Dy.createElementVNode)("rect", {
                width: e.SIZE,
                height: e.SIZE,
                rx: e.square ? void 0 : e.SIZE * 2,
                fill: "#FFFFFF"
            }, null, 8, YL)
        ], 8, XL),
        (0, $8B0Dy.createElementVNode)("g", JL, [
            (0, $8B0Dy.createElementVNode)("path", {
                fill: "url(#gradient_paint0_linear_".concat(e.formattedName, ")"),
                d: "M0 0h80v40H0z"
            }, null, 8, QL),
            (0, $8B0Dy.createElementVNode)("path", {
                fill: "url(#gradient_paint1_linear_".concat(e.formattedName, ")"),
                d: "M0 40h80v40H0z"
            }, null, 8, eO)
        ]),
        (0, $8B0Dy.createElementVNode)("defs", null, [
            (0, $8B0Dy.createElementVNode)("linearGradient", {
                id: "gradient_paint0_linear_".concat(e.formattedName),
                x1: e.SIZE / 2,
                y1: 0,
                x2: e.SIZE / 2,
                y2: e.SIZE / 2,
                gradientUnits: "userSpaceOnUse"
            }, [
                (0, $8B0Dy.createElementVNode)("stop", {
                    "stop-color": e.sunsetColors[0]
                }, null, 8, nO),
                (0, $8B0Dy.createElementVNode)("stop", {
                    offset: 1,
                    "stop-color": e.sunsetColors[1]
                }, null, 8, rO)
            ], 8, tO),
            (0, $8B0Dy.createElementVNode)("linearGradient", {
                id: "gradient_paint1_linear_".concat(e.formattedName),
                x1: e.SIZE / 2,
                y1: e.SIZE / 2,
                x2: e.SIZE / 2,
                y2: e.SIZE,
                gradientUnits: "userSpaceOnUse"
            }, [
                (0, $8B0Dy.createElementVNode)("stop", {
                    "stop-color": e.sunsetColors[2]
                }, null, 8, sO),
                (0, $8B0Dy.createElementVNode)("stop", {
                    offset: 1,
                    "stop-color": e.sunsetColors[3]
                }, null, 8, iO)
            ], 8, oO)
        ])
    ], 8, GL);
}
var cO = /* @__PURE__ */ Ir(WL, [
    [
        "render",
        aO
    ]
]);
(0, $8B0Dy.defineComponent)({
    name: "Avatar",
    props: {
        variant: {
            type: String,
            required: !1,
            "default": "marble",
            validator: function(e) {
                return [
                    "bauhaus",
                    "beam",
                    "marble",
                    "pixel",
                    "ring",
                    "sunset"
                ].includes(e);
            }
        },
        colors: {
            type: Array,
            required: !1,
            "default": function() {
                return [
                    "#92A1C6",
                    "#146A7C",
                    "#F0AB3D",
                    "#C271B4",
                    "#C20D90"
                ];
            }
        },
        name: {
            type: String,
            required: !1,
            "default": "Clara Barton"
        },
        square: {
            type: Boolean,
            required: !1,
            "default": !1
        },
        size: {
            type: Number,
            required: !1,
            "default": 40
        },
        title: {
            type: Boolean,
            required: !1,
            "default": !1
        }
    },
    setup: function() {
        return {};
    },
    components: {
        AvatarBauhaus: SI,
        AvatarBeam: FI,
        AvatarMarble: nT,
        AvatarPixel: xL,
        AvatarRing: jL,
        AvatarSunset: cO
    }
});
var kd = /(\*|-) \[x\]/, xd = /(\*|-) \[\s\]/, lO = function(e, t) {
    var n = 0;
    var r = e.split("\n");
    for(var s = 0; s < r.length; s++){
        var o = r[s], i = kd.test(o), a = xd.test(o);
        if (i || a) {
            if (n === t) {
                var c = i ? kd : xd, u = i ? "[ ]" : "[x]";
                r[s] = o.replace(c, "$1 ".concat(u));
                break;
            }
            n++;
        }
    }
    return r.join("\n");
};
function uO(e, t) {
    return /^on[A-Z]/.test(t);
}
function om(e) {
    return "".concat(e ? "".concat(e, "-") : "").concat(Math.random().toString(36).substring(2, 11));
}
var dO = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    name: "N8nInput",
    __name: "Input",
    props: {
        modelValue: {
            "default": ""
        },
        type: {
            "default": "text"
        },
        size: {
            "default": "large"
        },
        placeholder: {
            "default": ""
        },
        disabled: {
            type: Boolean,
            "default": !1
        },
        readonly: {
            type: Boolean,
            "default": !1
        },
        clearable: {
            type: Boolean,
            "default": !1
        },
        rows: {
            "default": 2
        },
        maxlength: {
            "default": void 0
        },
        title: {
            "default": ""
        },
        name: {
            "default": function() {
                return om("input");
            }
        },
        autocomplete: {
            "default": "off"
        }
    },
    setup: function(e, param) {
        var t = param.expose;
        var n = e, r = (0, $5wB2C.computed)(function() {
            return n.size === "medium" ? "default" : n.size;
        }), s = (0, $5wB2C.computed)(function() {
            var d = [];
            return n.size === "xlarge" && d.push("xlarge"), n.type === "password" && d.push("ph-no-capture"), d;
        }), o = (0, $5wB2C.ref)(), i = (0, $5wB2C.computed)(function() {
            if (!(o != null && o.value)) return;
            var d = n.type === "textarea" ? "textarea" : "input";
            return o.value.$el.querySelector(d);
        });
        return t({
            focus: function() {
                var d;
                return (d = i.value) == null ? void 0 : d.focus();
            },
            blur: function() {
                var d;
                return (d = i.value) == null ? void 0 : d.blur();
            },
            select: function() {
                var d;
                return (d = i.value) == null ? void 0 : d.select();
            }
        }), function(d, l) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(ws), (0, $8B0Dy.mergeProps)({
                ref_key: "innerInput",
                ref: o,
                "model-value": d.modelValue,
                type: d.type,
                size: r.value,
                "class": [
                    "n8n-input"
                ].concat((0, $kf9Kn._)(s.value)),
                autocomplete: d.autocomplete,
                name: d.name,
                placeholder: d.placeholder,
                disabled: d.disabled,
                readonly: d.readonly,
                clearable: d.clearable,
                rows: d.rows,
                title: d.title,
                maxlength: d.maxlength
            }, d.$attrs), (0, $8B0Dy.createSlots)({
                _: 2
            }, [
                d.$slots.prepend ? {
                    name: "prepend",
                    fn: (0, $8B0Dy.withCtx)(function() {
                        return [
                            (0, $8B0Dy.renderSlot)(d.$slots, "prepend")
                        ];
                    }),
                    key: "0"
                } : void 0,
                d.$slots.append ? {
                    name: "append",
                    fn: (0, $8B0Dy.withCtx)(function() {
                        return [
                            (0, $8B0Dy.renderSlot)(d.$slots, "append")
                        ];
                    }),
                    key: "1"
                } : void 0,
                d.$slots.prefix ? {
                    name: "prefix",
                    fn: (0, $8B0Dy.withCtx)(function() {
                        return [
                            (0, $8B0Dy.renderSlot)(d.$slots, "prefix")
                        ];
                    }),
                    key: "2"
                } : void 0,
                d.$slots.suffix ? {
                    name: "suffix",
                    fn: (0, $8B0Dy.withCtx)(function() {
                        return [
                            (0, $8B0Dy.renderSlot)(d.$slots, "suffix")
                        ];
                    }),
                    key: "3"
                } : void 0
            ]), 1040, [
                "model-value",
                "type",
                "size",
                "class",
                "autocomplete",
                "name",
                "placeholder",
                "disabled",
                "readonly",
                "clearable",
                "rows",
                "title",
                "maxlength"
            ]);
        };
    }
}), fO = "_xlarge_ddtui_1", pO = {
    xlarge: fO
}, hO = {
    $style: pO
}, sm = /* @__PURE__ */ Ht(dO, [
    [
        "__cssModules",
        hO
    ]
]);
om("color-picker");
function gO() {
    return {
        t: function(e) {
            var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
            return kb(e, t);
        }
    };
}
(0, $6869c._)({}, Yh);
(0, $6869c._)({}, Mc.props);
/*!
  * vue-router v4.5.0
  * (c) 2024 Eduardo San Martin Morote
  * @license MIT
  */ var mO = function() {}, Yo = Array.isArray;
function Cd(e, t) {
    return (e.aliasOf || e) === (t.aliasOf || t);
}
function vO(e, t) {
    if (Object.keys(e).length !== Object.keys(t).length) return !1;
    for(var n in e)if (!_O(e[n], t[n])) return !1;
    return !0;
}
function _O(e, t) {
    return Yo(e) ? Sd(e, t) : Yo(t) ? Sd(t, e) : e === t;
}
function Sd(e, t) {
    return Yo(t) ? e.length === t.length && e.every(function(n, r) {
        return n === t[r];
    }) : e.length === 1 && e[0] === t;
}
var Ed;
(function(e) {
    e.pop = "pop", e.push = "push";
})(Ed || (Ed = {}));
var Ad;
(function(e) {
    e.back = "back", e.forward = "forward", e.unknown = "";
})(Ad || (Ad = {}));
var $d;
(function(e) {
    e[e.aborted = 4] = "aborted", e[e.cancelled = 8] = "cancelled", e[e.duplicated = 16] = "duplicated";
})($d || ($d = {}));
var im = Symbol(""), bO = Symbol("");
function Md(e) {
    var t = (0, $8B0Dy.inject)(im), n = (0, $8B0Dy.inject)(bO), r = (0, $5wB2C.computed)(function() {
        var c = (0, $5wB2C.unref)(e.to);
        return t.resolve(c);
    }), s = (0, $5wB2C.computed)(function() {
        var _r_value = r.value, c = _r_value.matched, u = c.length, d = c[u - 1], l = n.matched;
        if (!d || !l.length) return -1;
        var m = l.findIndex(Cd.bind(null, d));
        if (m > -1) return m;
        var f = Td(c[u - 2]);
        return(// we are dealing with nested routes
        u > 1 && // if the parent and matched route have the same path, this link is
        // referring to the empty child. Or we currently are on a different
        // child of the same parent
        Td(d) === f && // avoid comparing the child with its parent
        l[l.length - 1].path !== f ? l.findIndex(Cd.bind(null, c[u - 2])) : m);
    }), o = (0, $5wB2C.computed)(function() {
        return s.value > -1 && xO(n.params, r.value.params);
    }), i = (0, $5wB2C.computed)(function() {
        return s.value > -1 && s.value === n.matched.length - 1 && vO(n.params, r.value.params);
    });
    function a() {
        var c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        if (kO(c)) {
            var u = t[(0, $5wB2C.unref)(e.replace) ? "replace" : "push"]((0, $5wB2C.unref)(e.to))["catch"](mO);
            return e.viewTransition && (typeof document === "undefined" ? "undefined" : (0, $6gBIz._)(document)) < "u" && "startViewTransition" in document && document.startViewTransition(function() {
                return u;
            }), u;
        }
        return Promise.resolve();
    }
    return {
        route: r,
        href: (0, $5wB2C.computed)(function() {
            return r.value.href;
        }),
        isActive: o,
        isExactActive: i,
        navigate: a
    };
}
function yO(e) {
    return e.length === 1 ? e[0] : e;
}
var wO = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    name: "RouterLink",
    compatConfig: {
        MODE: 3
    },
    props: {
        to: {
            type: [
                String,
                Object
            ],
            required: !0
        },
        replace: Boolean,
        activeClass: String,
        // inactiveClass: String,
        exactActiveClass: String,
        custom: Boolean,
        ariaCurrentValue: {
            type: String,
            "default": "page"
        }
    },
    useLink: Md,
    setup: function(e, param) {
        var t = param.slots;
        var n = (0, $5wB2C.reactive)(Md(e)), _Le = (0, $8B0Dy.inject)(im), r = _Le.options, s = (0, $5wB2C.computed)(function() {
            var _obj;
            return _obj = {}, (0, $aRIHe._)(_obj, Ld(e.activeClass, r.linkActiveClass, "router-link-active"), n.isActive), // [getLinkClass(
            //   props.inactiveClass,
            //   options.linkInactiveClass,
            //   'router-link-inactive'
            // )]: !link.isExactActive,
            (0, $aRIHe._)(_obj, Ld(e.exactActiveClass, r.linkExactActiveClass, "router-link-exact-active"), n.isExactActive), _obj;
        });
        return function() {
            var o = t["default"] && yO(t["default"](n));
            return e.custom ? o : (0, $8B0Dy.h)("a", {
                "aria-current": n.isExactActive ? e.ariaCurrentValue : null,
                href: n.href,
                // this would override user added attrs but Vue will still add
                // the listener, so we end up triggering both
                onClick: n.navigate,
                "class": s.value
            }, o);
        };
    }
}), Id = wO;
function kO(e) {
    if (!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) && !e.defaultPrevented && !(e.button !== void 0 && e.button !== 0)) {
        if (e.currentTarget && e.currentTarget.getAttribute) {
            var t = e.currentTarget.getAttribute("target");
            if (/\b_blank\b/i.test(t)) return;
        }
        return e.preventDefault && e.preventDefault(), !0;
    }
}
function xO(e, t) {
    var _loop = function(n) {
        var r = t[n], s = e[n];
        if (typeof r == "string") {
            if (r !== s) return {
                v: !1
            };
        } else if (!Yo(s) || s.length !== r.length || r.some(function(o, i) {
            return o !== s[i];
        })) return {
            v: !1
        };
    };
    for(var n in t){
        var _ret = _loop(n);
        if ((0, $6gBIz._)(_ret) === "object") return _ret.v;
    }
    return !0;
}
function Td(e) {
    return e ? e.aliasOf ? e.aliasOf.path : e.path : "";
}
var Ld = function(e, t, n) {
    var _ref;
    return (_ref = e !== null && e !== void 0 ? e : t) !== null && _ref !== void 0 ? _ref : n;
};
var Ys = {};
var CO = "\xc1", SO = "\xe1", EO = "\u0102", AO = "\u0103", $O = "\u223E", MO = "\u223F", IO = "\u223E\u0333", TO = "\xc2", LO = "\xe2", OO = "\xb4", RO = "\u0410", PO = "\u0430", BO = "\xc6", zO = "\xe6", DO = "\u2061", NO = "\uD835\uDD04", qO = "\uD835\uDD1E", FO = "\xc0", HO = "\xe0", jO = "\u2135", UO = "\u2135", VO = "\u0391", ZO = "\u03B1", WO = "\u0100", GO = "\u0101", KO = "\u2A3F", XO = "&", YO = "&", JO = "\u2A55", QO = "\u2A53", eR = "\u2227", tR = "\u2A5C", nR = "\u2A58", rR = "\u2A5A", oR = "\u2220", sR = "\u29A4", iR = "\u2220", aR = "\u29A8", cR = "\u29A9", lR = "\u29AA", uR = "\u29AB", dR = "\u29AC", fR = "\u29AD", pR = "\u29AE", hR = "\u29AF", gR = "\u2221", mR = "\u221F", vR = "\u22BE", _R = "\u299D", bR = "\u2222", yR = "\xc5", wR = "\u237C", kR = "\u0104", xR = "\u0105", CR = "\uD835\uDD38", SR = "\uD835\uDD52", ER = "\u2A6F", AR = "\u2248", $R = "\u2A70", MR = "\u224A", IR = "\u224B", TR = "'", LR = "\u2061", OR = "\u2248", RR = "\u224A", PR = "\xc5", BR = "\xe5", zR = "\uD835\uDC9C", DR = "\uD835\uDCB6", NR = "\u2254", qR = "*", FR = "\u2248", HR = "\u224D", jR = "\xc3", UR = "\xe3", VR = "\xc4", ZR = "\xe4", WR = "\u2233", GR = "\u2A11", KR = "\u224C", XR = "\u03F6", YR = "\u2035", JR = "\u223D", QR = "\u22CD", eP = "\u2216", tP = "\u2AE7", nP = "\u22BD", rP = "\u2305", oP = "\u2306", sP = "\u2305", iP = "\u23B5", aP = "\u23B6", cP = "\u224C", lP = "\u0411", uP = "\u0431", dP = "\u201E", fP = "\u2235", pP = "\u2235", hP = "\u2235", gP = "\u29B0", mP = "\u03F6", vP = "\u212C", _P = "\u212C", bP = "\u0392", yP = "\u03B2", wP = "\u2136", kP = "\u226C", xP = "\uD835\uDD05", CP = "\uD835\uDD1F", SP = "\u22C2", EP = "\u25EF", AP = "\u22C3", $P = "\u2A00", MP = "\u2A01", IP = "\u2A02", TP = "\u2A06", LP = "\u2605", OP = "\u25BD", RP = "\u25B3", PP = "\u2A04", BP = "\u22C1", zP = "\u22C0", DP = "\u290D", NP = "\u29EB", qP = "\u25AA", FP = "\u25B4", HP = "\u25BE", jP = "\u25C2", UP = "\u25B8", VP = "\u2423", ZP = "\u2592", WP = "\u2591", GP = "\u2593", KP = "\u2588", XP = "=\u20E5", YP = "\u2261\u20E5", JP = "\u2AED", QP = "\u2310", eB = "\uD835\uDD39", tB = "\uD835\uDD53", nB = "\u22A5", rB = "\u22A5", oB = "\u22C8", sB = "\u29C9", iB = "\u2510", aB = "\u2555", cB = "\u2556", lB = "\u2557", uB = "\u250C", dB = "\u2552", fB = "\u2553", pB = "\u2554", hB = "\u2500", gB = "\u2550", mB = "\u252C", vB = "\u2564", _B = "\u2565", bB = "\u2566", yB = "\u2534", wB = "\u2567", kB = "\u2568", xB = "\u2569", CB = "\u229F", SB = "\u229E", EB = "\u22A0", AB = "\u2518", $B = "\u255B", MB = "\u255C", IB = "\u255D", TB = "\u2514", LB = "\u2558", OB = "\u2559", RB = "\u255A", PB = "\u2502", BB = "\u2551", zB = "\u253C", DB = "\u256A", NB = "\u256B", qB = "\u256C", FB = "\u2524", HB = "\u2561", jB = "\u2562", UB = "\u2563", VB = "\u251C", ZB = "\u255E", WB = "\u255F", GB = "\u2560", KB = "\u2035", XB = "\u02D8", YB = "\u02D8", JB = "\xa6", QB = "\uD835\uDCB7", ez = "\u212C", tz = "\u204F", nz = "\u223D", rz = "\u22CD", oz = "\u29C5", sz = "\\", iz = "\u27C8", az = "\u2022", cz = "\u2022", lz = "\u224E", uz = "\u2AAE", dz = "\u224F", fz = "\u224E", pz = "\u224F", hz = "\u0106", gz = "\u0107", mz = "\u2A44", vz = "\u2A49", _z = "\u2A4B", bz = "\u2229", yz = "\u22D2", wz = "\u2A47", kz = "\u2A40", xz = "\u2145", Cz = "\u2229\uFE00", Sz = "\u2041", Ez = "\u02C7", Az = "\u212D", $z = "\u2A4D", Mz = "\u010C", Iz = "\u010D", Tz = "\xc7", Lz = "\xe7", Oz = "\u0108", Rz = "\u0109", Pz = "\u2230", Bz = "\u2A4C", zz = "\u2A50", Dz = "\u010A", Nz = "\u010B", qz = "\xb8", Fz = "\xb8", Hz = "\u29B2", jz = "\xa2", Uz = "\xb7", Vz = "\xb7", Zz = "\uD835\uDD20", Wz = "\u212D", Gz = "\u0427", Kz = "\u0447", Xz = "\u2713", Yz = "\u2713", Jz = "\u03A7", Qz = "\u03C7", eD = "\u02C6", tD = "\u2257", nD = "\u21BA", rD = "\u21BB", oD = "\u229B", sD = "\u229A", iD = "\u229D", aD = "\u2299", cD = "\xae", lD = "\u24C8", uD = "\u2296", dD = "\u2295", fD = "\u2297", pD = "\u25CB", hD = "\u29C3", gD = "\u2257", mD = "\u2A10", vD = "\u2AEF", _D = "\u29C2", bD = "\u2232", yD = "\u201D", wD = "\u2019", kD = "\u2663", xD = "\u2663", CD = ":", SD = "\u2237", ED = "\u2A74", AD = "\u2254", $D = "\u2254", MD = ",", ID = "@", TD = "\u2201", LD = "\u2218", OD = "\u2201", RD = "\u2102", PD = "\u2245", BD = "\u2A6D", zD = "\u2261", DD = "\u222E", ND = "\u222F", qD = "\u222E", FD = "\uD835\uDD54", HD = "\u2102", jD = "\u2210", UD = "\u2210", VD = "\xa9", ZD = "\xa9", WD = "\u2117", GD = "\u2233", KD = "\u21B5", XD = "\u2717", YD = "\u2A2F", JD = "\uD835\uDC9E", QD = "\uD835\uDCB8", eN = "\u2ACF", tN = "\u2AD1", nN = "\u2AD0", rN = "\u2AD2", oN = "\u22EF", sN = "\u2938", iN = "\u2935", aN = "\u22DE", cN = "\u22DF", lN = "\u21B6", uN = "\u293D", dN = "\u2A48", fN = "\u2A46", pN = "\u224D", hN = "\u222A", gN = "\u22D3", mN = "\u2A4A", vN = "\u228D", _N = "\u2A45", bN = "\u222A\uFE00", yN = "\u21B7", wN = "\u293C", kN = "\u22DE", xN = "\u22DF", CN = "\u22CE", SN = "\u22CF", EN = "\xa4", AN = "\u21B6", $N = "\u21B7", MN = "\u22CE", IN = "\u22CF", TN = "\u2232", LN = "\u2231", ON = "\u232D", RN = "\u2020", PN = "\u2021", BN = "\u2138", zN = "\u2193", DN = "\u21A1", NN = "\u21D3", qN = "\u2010", FN = "\u2AE4", HN = "\u22A3", jN = "\u290F", UN = "\u02DD", VN = "\u010E", ZN = "\u010F", WN = "\u0414", GN = "\u0434", KN = "\u2021", XN = "\u21CA", YN = "\u2145", JN = "\u2146", QN = "\u2911", eq = "\u2A77", tq = "\xb0", nq = "\u2207", rq = "\u0394", oq = "\u03B4", sq = "\u29B1", iq = "\u297F", aq = "\uD835\uDD07", cq = "\uD835\uDD21", lq = "\u2965", uq = "\u21C3", dq = "\u21C2", fq = "\xb4", pq = "\u02D9", hq = "\u02DD", gq = "`", mq = "\u02DC", vq = "\u22C4", _q = "\u22C4", bq = "\u22C4", yq = "\u2666", wq = "\u2666", kq = "\xa8", xq = "\u2146", Cq = "\u03DD", Sq = "\u22F2", Eq = "\xf7", Aq = "\xf7", $q = "\u22C7", Mq = "\u22C7", Iq = "\u0402", Tq = "\u0452", Lq = "\u231E", Oq = "\u230D", Rq = "$", Pq = "\uD835\uDD3B", Bq = "\uD835\uDD55", zq = "\xa8", Dq = "\u02D9", Nq = "\u20DC", qq = "\u2250", Fq = "\u2251", Hq = "\u2250", jq = "\u2238", Uq = "\u2214", Vq = "\u22A1", Zq = "\u2306", Wq = "\u222F", Gq = "\xa8", Kq = "\u21D3", Xq = "\u21D0", Yq = "\u21D4", Jq = "\u2AE4", Qq = "\u27F8", eF = "\u27FA", tF = "\u27F9", nF = "\u21D2", rF = "\u22A8", oF = "\u21D1", sF = "\u21D5", iF = "\u2225", aF = "\u2913", cF = "\u2193", lF = "\u2193", uF = "\u21D3", dF = "\u21F5", fF = "\u0311", pF = "\u21CA", hF = "\u21C3", gF = "\u21C2", mF = "\u2950", vF = "\u295E", _F = "\u2956", bF = "\u21BD", yF = "\u295F", wF = "\u2957", kF = "\u21C1", xF = "\u21A7", CF = "\u22A4", SF = "\u2910", EF = "\u231F", AF = "\u230C", $F = "\uD835\uDC9F", MF = "\uD835\uDCB9", IF = "\u0405", TF = "\u0455", LF = "\u29F6", OF = "\u0110", RF = "\u0111", PF = "\u22F1", BF = "\u25BF", zF = "\u25BE", DF = "\u21F5", NF = "\u296F", qF = "\u29A6", FF = "\u040F", HF = "\u045F", jF = "\u27FF", UF = "\xc9", VF = "\xe9", ZF = "\u2A6E", WF = "\u011A", GF = "\u011B", KF = "\xca", XF = "\xea", YF = "\u2256", JF = "\u2255", QF = "\u042D", eH = "\u044D", tH = "\u2A77", nH = "\u0116", rH = "\u0117", oH = "\u2251", sH = "\u2147", iH = "\u2252", aH = "\uD835\uDD08", cH = "\uD835\uDD22", lH = "\u2A9A", uH = "\xc8", dH = "\xe8", fH = "\u2A96", pH = "\u2A98", hH = "\u2A99", gH = "\u2208", mH = "\u23E7", vH = "\u2113", _H = "\u2A95", bH = "\u2A97", yH = "\u0112", wH = "\u0113", kH = "\u2205", xH = "\u2205", CH = "\u25FB", SH = "\u2205", EH = "\u25AB", AH = "\u2004", $H = "\u2005", MH = "\u2003", IH = "\u014A", TH = "\u014B", LH = "\u2002", OH = "\u0118", RH = "\u0119", PH = "\uD835\uDD3C", BH = "\uD835\uDD56", zH = "\u22D5", DH = "\u29E3", NH = "\u2A71", qH = "\u03B5", FH = "\u0395", HH = "\u03B5", jH = "\u03F5", UH = "\u2256", VH = "\u2255", ZH = "\u2242", WH = "\u2A96", GH = "\u2A95", KH = "\u2A75", XH = "=", YH = "\u2242", JH = "\u225F", QH = "\u21CC", ej = "\u2261", tj = "\u2A78", nj = "\u29E5", rj = "\u2971", oj = "\u2253", sj = "\u212F", ij = "\u2130", aj = "\u2250", cj = "\u2A73", lj = "\u2242", uj = "\u0397", dj = "\u03B7", fj = "\xd0", pj = "\xf0", hj = "\xcb", gj = "\xeb", mj = "\u20AC", vj = "!", _j = "\u2203", bj = "\u2203", yj = "\u2130", wj = "\u2147", kj = "\u2147", xj = "\u2252", Cj = "\u0424", Sj = "\u0444", Ej = "\u2640", Aj = "\uFB03", $j = "\uFB00", Mj = "\uFB04", Ij = "\uD835\uDD09", Tj = "\uD835\uDD23", Lj = "\uFB01", Oj = "\u25FC", Rj = "\u25AA", Pj = "fj", Bj = "\u266D", zj = "\uFB02", Dj = "\u25B1", Nj = "\u0192", qj = "\uD835\uDD3D", Fj = "\uD835\uDD57", Hj = "\u2200", jj = "\u2200", Uj = "\u22D4", Vj = "\u2AD9", Zj = "\u2131", Wj = "\u2A0D", Gj = "\xbd", Kj = "\u2153", Xj = "\xbc", Yj = "\u2155", Jj = "\u2159", Qj = "\u215B", eU = "\u2154", tU = "\u2156", nU = "\xbe", rU = "\u2157", oU = "\u215C", sU = "\u2158", iU = "\u215A", aU = "\u215D", cU = "\u215E", lU = "\u2044", uU = "\u2322", dU = "\uD835\uDCBB", fU = "\u2131", pU = "\u01F5", hU = "\u0393", gU = "\u03B3", mU = "\u03DC", vU = "\u03DD", _U = "\u2A86", bU = "\u011E", yU = "\u011F", wU = "\u0122", kU = "\u011C", xU = "\u011D", CU = "\u0413", SU = "\u0433", EU = "\u0120", AU = "\u0121", $U = "\u2265", MU = "\u2267", IU = "\u2A8C", TU = "\u22DB", LU = "\u2265", OU = "\u2267", RU = "\u2A7E", PU = "\u2AA9", BU = "\u2A7E", zU = "\u2A80", DU = "\u2A82", NU = "\u2A84", qU = "\u22DB\uFE00", FU = "\u2A94", HU = "\uD835\uDD0A", jU = "\uD835\uDD24", UU = "\u226B", VU = "\u22D9", ZU = "\u22D9", WU = "\u2137", GU = "\u0403", KU = "\u0453", XU = "\u2AA5", YU = "\u2277", JU = "\u2A92", QU = "\u2AA4", eV = "\u2A8A", tV = "\u2A8A", nV = "\u2A88", rV = "\u2269", oV = "\u2A88", sV = "\u2269", iV = "\u22E7", aV = "\uD835\uDD3E", cV = "\uD835\uDD58", lV = "`", uV = "\u2265", dV = "\u22DB", fV = "\u2267", pV = "\u2AA2", hV = "\u2277", gV = "\u2A7E", mV = "\u2273", vV = "\uD835\uDCA2", _V = "\u210A", bV = "\u2273", yV = "\u2A8E", wV = "\u2A90", kV = "\u2AA7", xV = "\u2A7A", CV = ">", SV = ">", EV = "\u226B", AV = "\u22D7", $V = "\u2995", MV = "\u2A7C", IV = "\u2A86", TV = "\u2978", LV = "\u22D7", OV = "\u22DB", RV = "\u2A8C", PV = "\u2277", BV = "\u2273", zV = "\u2269\uFE00", DV = "\u2269\uFE00", NV = "\u02C7", qV = "\u200A", FV = "\xbd", HV = "\u210B", jV = "\u042A", UV = "\u044A", VV = "\u2948", ZV = "\u2194", WV = "\u21D4", GV = "\u21AD", KV = "^", XV = "\u210F", YV = "\u0124", JV = "\u0125", QV = "\u2665", eZ = "\u2665", tZ = "\u2026", nZ = "\u22B9", rZ = "\uD835\uDD25", oZ = "\u210C", sZ = "\u210B", iZ = "\u2925", aZ = "\u2926", cZ = "\u21FF", lZ = "\u223B", uZ = "\u21A9", dZ = "\u21AA", fZ = "\uD835\uDD59", pZ = "\u210D", hZ = "\u2015", gZ = "\u2500", mZ = "\uD835\uDCBD", vZ = "\u210B", _Z = "\u210F", bZ = "\u0126", yZ = "\u0127", wZ = "\u224E", kZ = "\u224F", xZ = "\u2043", CZ = "\u2010", SZ = "\xcd", EZ = "\xed", AZ = "\u2063", $Z = "\xce", MZ = "\xee", IZ = "\u0418", TZ = "\u0438", LZ = "\u0130", OZ = "\u0415", RZ = "\u0435", PZ = "\xa1", BZ = "\u21D4", zZ = "\uD835\uDD26", DZ = "\u2111", NZ = "\xcc", qZ = "\xec", FZ = "\u2148", HZ = "\u2A0C", jZ = "\u222D", UZ = "\u29DC", VZ = "\u2129", ZZ = "\u0132", WZ = "\u0133", GZ = "\u012A", KZ = "\u012B", XZ = "\u2111", YZ = "\u2148", JZ = "\u2110", QZ = "\u2111", eW = "\u0131", tW = "\u2111", nW = "\u22B7", rW = "\u01B5", oW = "\u21D2", sW = "\u2105", iW = "\u221E", aW = "\u29DD", cW = "\u0131", lW = "\u22BA", uW = "\u222B", dW = "\u222C", fW = "\u2124", pW = "\u222B", hW = "\u22BA", gW = "\u22C2", mW = "\u2A17", vW = "\u2A3C", _W = "\u2063", bW = "\u2062", yW = "\u0401", wW = "\u0451", kW = "\u012E", xW = "\u012F", CW = "\uD835\uDD40", SW = "\uD835\uDD5A", EW = "\u0399", AW = "\u03B9", $W = "\u2A3C", MW = "\xbf", IW = "\uD835\uDCBE", TW = "\u2110", LW = "\u2208", OW = "\u22F5", RW = "\u22F9", PW = "\u22F4", BW = "\u22F3", zW = "\u2208", DW = "\u2062", NW = "\u0128", qW = "\u0129", FW = "\u0406", HW = "\u0456", jW = "\xcf", UW = "\xef", VW = "\u0134", ZW = "\u0135", WW = "\u0419", GW = "\u0439", KW = "\uD835\uDD0D", XW = "\uD835\uDD27", YW = "\u0237", JW = "\uD835\uDD41", QW = "\uD835\uDD5B", eG = "\uD835\uDCA5", tG = "\uD835\uDCBF", nG = "\u0408", rG = "\u0458", oG = "\u0404", sG = "\u0454", iG = "\u039A", aG = "\u03BA", cG = "\u03F0", lG = "\u0136", uG = "\u0137", dG = "\u041A", fG = "\u043A", pG = "\uD835\uDD0E", hG = "\uD835\uDD28", gG = "\u0138", mG = "\u0425", vG = "\u0445", _G = "\u040C", bG = "\u045C", yG = "\uD835\uDD42", wG = "\uD835\uDD5C", kG = "\uD835\uDCA6", xG = "\uD835\uDCC0", CG = "\u21DA", SG = "\u0139", EG = "\u013A", AG = "\u29B4", $G = "\u2112", MG = "\u039B", IG = "\u03BB", TG = "\u27E8", LG = "\u27EA", OG = "\u2991", RG = "\u27E8", PG = "\u2A85", BG = "\u2112", zG = "\xab", DG = "\u21E4", NG = "\u291F", qG = "\u2190", FG = "\u219E", HG = "\u21D0", jG = "\u291D", UG = "\u21A9", VG = "\u21AB", ZG = "\u2939", WG = "\u2973", GG = "\u21A2", KG = "\u2919", XG = "\u291B", YG = "\u2AAB", JG = "\u2AAD", QG = "\u2AAD\uFE00", eK = "\u290C", tK = "\u290E", nK = "\u2772", rK = "{", oK = "[", sK = "\u298B", iK = "\u298F", aK = "\u298D", cK = "\u013D", lK = "\u013E", uK = "\u013B", dK = "\u013C", fK = "\u2308", pK = "{", hK = "\u041B", gK = "\u043B", mK = "\u2936", vK = "\u201C", _K = "\u201E", bK = "\u2967", yK = "\u294B", wK = "\u21B2", kK = "\u2264", xK = "\u2266", CK = "\u27E8", SK = "\u21E4", EK = "\u2190", AK = "\u2190", $K = "\u21D0", MK = "\u21C6", IK = "\u21A2", TK = "\u2308", LK = "\u27E6", OK = "\u2961", RK = "\u2959", PK = "\u21C3", BK = "\u230A", zK = "\u21BD", DK = "\u21BC", NK = "\u21C7", qK = "\u2194", FK = "\u2194", HK = "\u21D4", jK = "\u21C6", UK = "\u21CB", VK = "\u21AD", ZK = "\u294E", WK = "\u21A4", GK = "\u22A3", KK = "\u295A", XK = "\u22CB", YK = "\u29CF", JK = "\u22B2", QK = "\u22B4", eX = "\u2951", tX = "\u2960", nX = "\u2958", rX = "\u21BF", oX = "\u2952", sX = "\u21BC", iX = "\u2A8B", aX = "\u22DA", cX = "\u2264", lX = "\u2266", uX = "\u2A7D", dX = "\u2AA8", fX = "\u2A7D", pX = "\u2A7F", hX = "\u2A81", gX = "\u2A83", mX = "\u22DA\uFE00", vX = "\u2A93", _X = "\u2A85", bX = "\u22D6", yX = "\u22DA", wX = "\u2A8B", kX = "\u22DA", xX = "\u2266", CX = "\u2276", SX = "\u2276", EX = "\u2AA1", AX = "\u2272", $X = "\u2A7D", MX = "\u2272", IX = "\u297C", TX = "\u230A", LX = "\uD835\uDD0F", OX = "\uD835\uDD29", RX = "\u2276", PX = "\u2A91", BX = "\u2962", zX = "\u21BD", DX = "\u21BC", NX = "\u296A", qX = "\u2584", FX = "\u0409", HX = "\u0459", jX = "\u21C7", UX = "\u226A", VX = "\u22D8", ZX = "\u231E", WX = "\u21DA", GX = "\u296B", KX = "\u25FA", XX = "\u013F", YX = "\u0140", JX = "\u23B0", QX = "\u23B0", eY = "\u2A89", tY = "\u2A89", nY = "\u2A87", rY = "\u2268", oY = "\u2A87", sY = "\u2268", iY = "\u22E6", aY = "\u27EC", cY = "\u21FD", lY = "\u27E6", uY = "\u27F5", dY = "\u27F5", fY = "\u27F8", pY = "\u27F7", hY = "\u27F7", gY = "\u27FA", mY = "\u27FC", vY = "\u27F6", _Y = "\u27F6", bY = "\u27F9", yY = "\u21AB", wY = "\u21AC", kY = "\u2985", xY = "\uD835\uDD43", CY = "\uD835\uDD5D", SY = "\u2A2D", EY = "\u2A34", AY = "\u2217", $Y = "_", MY = "\u2199", IY = "\u2198", TY = "\u25CA", LY = "\u25CA", OY = "\u29EB", RY = "(", PY = "\u2993", BY = "\u21C6", zY = "\u231F", DY = "\u21CB", NY = "\u296D", qY = "\u200E", FY = "\u22BF", HY = "\u2039", jY = "\uD835\uDCC1", UY = "\u2112", VY = "\u21B0", ZY = "\u21B0", WY = "\u2272", GY = "\u2A8D", KY = "\u2A8F", XY = "[", YY = "\u2018", JY = "\u201A", QY = "\u0141", eJ = "\u0142", tJ = "\u2AA6", nJ = "\u2A79", rJ = "<", oJ = "<", sJ = "\u226A", iJ = "\u22D6", aJ = "\u22CB", cJ = "\u22C9", lJ = "\u2976", uJ = "\u2A7B", dJ = "\u25C3", fJ = "\u22B4", pJ = "\u25C2", hJ = "\u2996", gJ = "\u294A", mJ = "\u2966", vJ = "\u2268\uFE00", _J = "\u2268\uFE00", bJ = "\xaf", yJ = "\u2642", wJ = "\u2720", kJ = "\u2720", xJ = "\u21A6", CJ = "\u21A6", SJ = "\u21A7", EJ = "\u21A4", AJ = "\u21A5", $J = "\u25AE", MJ = "\u2A29", IJ = "\u041C", TJ = "\u043C", LJ = "\u2014", OJ = "\u223A", RJ = "\u2221", PJ = "\u205F", BJ = "\u2133", zJ = "\uD835\uDD10", DJ = "\uD835\uDD2A", NJ = "\u2127", qJ = "\xb5", FJ = "*", HJ = "\u2AF0", jJ = "\u2223", UJ = "\xb7", VJ = "\u229F", ZJ = "\u2212", WJ = "\u2238", GJ = "\u2A2A", KJ = "\u2213", XJ = "\u2ADB", YJ = "\u2026", JJ = "\u2213", QJ = "\u22A7", eQ = "\uD835\uDD44", tQ = "\uD835\uDD5E", nQ = "\u2213", rQ = "\uD835\uDCC2", oQ = "\u2133", sQ = "\u223E", iQ = "\u039C", aQ = "\u03BC", cQ = "\u22B8", lQ = "\u22B8", uQ = "\u2207", dQ = "\u0143", fQ = "\u0144", pQ = "\u2220\u20D2", hQ = "\u2249", gQ = "\u2A70\u0338", mQ = "\u224B\u0338", vQ = "\u0149", _Q = "\u2249", bQ = "\u266E", yQ = "\u2115", wQ = "\u266E", kQ = "\xa0", xQ = "\u224E\u0338", CQ = "\u224F\u0338", SQ = "\u2A43", EQ = "\u0147", AQ = "\u0148", $Q = "\u0145", MQ = "\u0146", IQ = "\u2247", TQ = "\u2A6D\u0338", LQ = "\u2A42", OQ = "\u041D", RQ = "\u043D", PQ = "\u2013", BQ = "\u2924", zQ = "\u2197", DQ = "\u21D7", NQ = "\u2197", qQ = "\u2260", FQ = "\u2250\u0338", HQ = "\u200B", jQ = "\u200B", UQ = "\u200B", VQ = "\u200B", ZQ = "\u2262", WQ = "\u2928", GQ = "\u2242\u0338", KQ = "\u226B", XQ = "\u226A", YQ = "\n", JQ = "\u2204", QQ = "\u2204", eee = "\uD835\uDD11", tee = "\uD835\uDD2B", nee = "\u2267\u0338", ree = "\u2271", oee = "\u2271", see = "\u2267\u0338", iee = "\u2A7E\u0338", aee = "\u2A7E\u0338", cee = "\u22D9\u0338", lee = "\u2275", uee = "\u226B\u20D2", dee = "\u226F", fee = "\u226F", pee = "\u226B\u0338", hee = "\u21AE", gee = "\u21CE", mee = "\u2AF2", vee = "\u220B", _ee = "\u22FC", bee = "\u22FA", yee = "\u220B", wee = "\u040A", kee = "\u045A", xee = "\u219A", Cee = "\u21CD", See = "\u2025", Eee = "\u2266\u0338", Aee = "\u2270", $ee = "\u219A", Mee = "\u21CD", Iee = "\u21AE", Tee = "\u21CE", Lee = "\u2270", Oee = "\u2266\u0338", Ree = "\u2A7D\u0338", Pee = "\u2A7D\u0338", Bee = "\u226E", zee = "\u22D8\u0338", Dee = "\u2274", Nee = "\u226A\u20D2", qee = "\u226E", Fee = "\u22EA", Hee = "\u22EC", jee = "\u226A\u0338", Uee = "\u2224", Vee = "\u2060", Zee = "\xa0", Wee = "\uD835\uDD5F", Gee = "\u2115", Kee = "\u2AEC", Xee = "\xac", Yee = "\u2262", Jee = "\u226D", Qee = "\u2226", ete = "\u2209", tte = "\u2260", nte = "\u2242\u0338", rte = "\u2204", ote = "\u226F", ste = "\u2271", ite = "\u2267\u0338", ate = "\u226B\u0338", cte = "\u2279", lte = "\u2A7E\u0338", ute = "\u2275", dte = "\u224E\u0338", fte = "\u224F\u0338", pte = "\u2209", hte = "\u22F5\u0338", gte = "\u22F9\u0338", mte = "\u2209", vte = "\u22F7", _te = "\u22F6", bte = "\u29CF\u0338", yte = "\u22EA", wte = "\u22EC", kte = "\u226E", xte = "\u2270", Cte = "\u2278", Ste = "\u226A\u0338", Ete = "\u2A7D\u0338", Ate = "\u2274", $te = "\u2AA2\u0338", Mte = "\u2AA1\u0338", Ite = "\u220C", Tte = "\u220C", Lte = "\u22FE", Ote = "\u22FD", Rte = "\u2280", Pte = "\u2AAF\u0338", Bte = "\u22E0", zte = "\u220C", Dte = "\u29D0\u0338", Nte = "\u22EB", qte = "\u22ED", Fte = "\u228F\u0338", Hte = "\u22E2", jte = "\u2290\u0338", Ute = "\u22E3", Vte = "\u2282\u20D2", Zte = "\u2288", Wte = "\u2281", Gte = "\u2AB0\u0338", Kte = "\u22E1", Xte = "\u227F\u0338", Yte = "\u2283\u20D2", Jte = "\u2289", Qte = "\u2241", ene = "\u2244", tne = "\u2247", nne = "\u2249", rne = "\u2224", one = "\u2226", sne = "\u2226", ine = "\u2AFD\u20E5", ane = "\u2202\u0338", cne = "\u2A14", lne = "\u2280", une = "\u22E0", dne = "\u2280", fne = "\u2AAF\u0338", pne = "\u2AAF\u0338", hne = "\u2933\u0338", gne = "\u219B", mne = "\u21CF", vne = "\u219D\u0338", _ne = "\u219B", bne = "\u21CF", yne = "\u22EB", wne = "\u22ED", kne = "\u2281", xne = "\u22E1", Cne = "\u2AB0\u0338", Sne = "\uD835\uDCA9", Ene = "\uD835\uDCC3", Ane = "\u2224", $ne = "\u2226", Mne = "\u2241", Ine = "\u2244", Tne = "\u2244", Lne = "\u2224", One = "\u2226", Rne = "\u22E2", Pne = "\u22E3", Bne = "\u2284", zne = "\u2AC5\u0338", Dne = "\u2288", Nne = "\u2282\u20D2", qne = "\u2288", Fne = "\u2AC5\u0338", Hne = "\u2281", jne = "\u2AB0\u0338", Une = "\u2285", Vne = "\u2AC6\u0338", Zne = "\u2289", Wne = "\u2283\u20D2", Gne = "\u2289", Kne = "\u2AC6\u0338", Xne = "\u2279", Yne = "\xd1", Jne = "\xf1", Qne = "\u2278", ere = "\u22EA", tre = "\u22EC", nre = "\u22EB", rre = "\u22ED", ore = "\u039D", sre = "\u03BD", ire = "#", are = "\u2116", cre = "\u2007", lre = "\u224D\u20D2", ure = "\u22AC", dre = "\u22AD", fre = "\u22AE", pre = "\u22AF", hre = "\u2265\u20D2", gre = ">\u20D2", mre = "\u2904", vre = "\u29DE", _re = "\u2902", bre = "\u2264\u20D2", yre = "<\u20D2", wre = "\u22B4\u20D2", kre = "\u2903", xre = "\u22B5\u20D2", Cre = "\u223C\u20D2", Sre = "\u2923", Ere = "\u2196", Are = "\u21D6", $re = "\u2196", Mre = "\u2927", Ire = "\xd3", Tre = "\xf3", Lre = "\u229B", Ore = "\xd4", Rre = "\xf4", Pre = "\u229A", Bre = "\u041E", zre = "\u043E", Dre = "\u229D", Nre = "\u0150", qre = "\u0151", Fre = "\u2A38", Hre = "\u2299", jre = "\u29BC", Ure = "\u0152", Vre = "\u0153", Zre = "\u29BF", Wre = "\uD835\uDD12", Gre = "\uD835\uDD2C", Kre = "\u02DB", Xre = "\xd2", Yre = "\xf2", Jre = "\u29C1", Qre = "\u29B5", eoe = "\u03A9", toe = "\u222E", noe = "\u21BA", roe = "\u29BE", ooe = "\u29BB", soe = "\u203E", ioe = "\u29C0", aoe = "\u014C", coe = "\u014D", loe = "\u03A9", uoe = "\u03C9", doe = "\u039F", foe = "\u03BF", poe = "\u29B6", hoe = "\u2296", goe = "\uD835\uDD46", moe = "\uD835\uDD60", voe = "\u29B7", _oe = "\u201C", boe = "\u2018", yoe = "\u29B9", woe = "\u2295", koe = "\u21BB", xoe = "\u2A54", Coe = "\u2228", Soe = "\u2A5D", Eoe = "\u2134", Aoe = "\u2134", $oe = "\xaa", Moe = "\xba", Ioe = "\u22B6", Toe = "\u2A56", Loe = "\u2A57", Ooe = "\u2A5B", Roe = "\u24C8", Poe = "\uD835\uDCAA", Boe = "\u2134", zoe = "\xd8", Doe = "\xf8", Noe = "\u2298", qoe = "\xd5", Foe = "\xf5", Hoe = "\u2A36", joe = "\u2A37", Uoe = "\u2297", Voe = "\xd6", Zoe = "\xf6", Woe = "\u233D", Goe = "\u203E", Koe = "\u23DE", Xoe = "\u23B4", Yoe = "\u23DC", Joe = "\xb6", Qoe = "\u2225", ese = "\u2225", tse = "\u2AF3", nse = "\u2AFD", rse = "\u2202", ose = "\u2202", sse = "\u041F", ise = "\u043F", ase = "%", cse = ".", lse = "\u2030", use = "\u22A5", dse = "\u2031", fse = "\uD835\uDD13", pse = "\uD835\uDD2D", hse = "\u03A6", gse = "\u03C6", mse = "\u03D5", vse = "\u2133", _se = "\u260E", bse = "\u03A0", yse = "\u03C0", wse = "\u22D4", kse = "\u03D6", xse = "\u210F", Cse = "\u210E", Sse = "\u210F", Ese = "\u2A23", Ase = "\u229E", $se = "\u2A22", Mse = "+", Ise = "\u2214", Tse = "\u2A25", Lse = "\u2A72", Ose = "\xb1", Rse = "\xb1", Pse = "\u2A26", Bse = "\u2A27", zse = "\xb1", Dse = "\u210C", Nse = "\u2A15", qse = "\uD835\uDD61", Fse = "\u2119", Hse = "\xa3", jse = "\u2AB7", Use = "\u2ABB", Vse = "\u227A", Zse = "\u227C", Wse = "\u2AB7", Gse = "\u227A", Kse = "\u227C", Xse = "\u227A", Yse = "\u2AAF", Jse = "\u227C", Qse = "\u227E", eie = "\u2AAF", tie = "\u2AB9", nie = "\u2AB5", rie = "\u22E8", oie = "\u2AAF", sie = "\u2AB3", iie = "\u227E", aie = "\u2032", cie = "\u2033", lie = "\u2119", uie = "\u2AB9", die = "\u2AB5", fie = "\u22E8", pie = "\u220F", hie = "\u220F", gie = "\u232E", mie = "\u2312", vie = "\u2313", _ie = "\u221D", bie = "\u221D", yie = "\u2237", wie = "\u221D", kie = "\u227E", xie = "\u22B0", Cie = "\uD835\uDCAB", Sie = "\uD835\uDCC5", Eie = "\u03A8", Aie = "\u03C8", $ie = "\u2008", Mie = "\uD835\uDD14", Iie = "\uD835\uDD2E", Tie = "\u2A0C", Lie = "\uD835\uDD62", Oie = "\u211A", Rie = "\u2057", Pie = "\uD835\uDCAC", Bie = "\uD835\uDCC6", zie = "\u210D", Die = "\u2A16", Nie = "?", qie = "\u225F", Fie = '"', Hie = '"', jie = "\u21DB", Uie = "\u223D\u0331", Vie = "\u0154", Zie = "\u0155", Wie = "\u221A", Gie = "\u29B3", Kie = "\u27E9", Xie = "\u27EB", Yie = "\u2992", Jie = "\u29A5", Qie = "\u27E9", eae = "\xbb", tae = "\u2975", nae = "\u21E5", rae = "\u2920", oae = "\u2933", sae = "\u2192", iae = "\u21A0", aae = "\u21D2", cae = "\u291E", lae = "\u21AA", uae = "\u21AC", dae = "\u2945", fae = "\u2974", pae = "\u2916", hae = "\u21A3", gae = "\u219D", mae = "\u291A", vae = "\u291C", _ae = "\u2236", bae = "\u211A", yae = "\u290D", wae = "\u290F", kae = "\u2910", xae = "\u2773", Cae = "}", Sae = "]", Eae = "\u298C", Aae = "\u298E", $ae = "\u2990", Mae = "\u0158", Iae = "\u0159", Tae = "\u0156", Lae = "\u0157", Oae = "\u2309", Rae = "}", Pae = "\u0420", Bae = "\u0440", zae = "\u2937", Dae = "\u2969", Nae = "\u201D", qae = "\u201D", Fae = "\u21B3", Hae = "\u211C", jae = "\u211B", Uae = "\u211C", Vae = "\u211D", Zae = "\u211C", Wae = "\u25AD", Gae = "\xae", Kae = "\xae", Xae = "\u220B", Yae = "\u21CB", Jae = "\u296F", Qae = "\u297D", ece = "\u230B", tce = "\uD835\uDD2F", nce = "\u211C", rce = "\u2964", oce = "\u21C1", sce = "\u21C0", ice = "\u296C", ace = "\u03A1", cce = "\u03C1", lce = "\u03F1", uce = "\u27E9", dce = "\u21E5", fce = "\u2192", pce = "\u2192", hce = "\u21D2", gce = "\u21C4", mce = "\u21A3", vce = "\u2309", _ce = "\u27E7", bce = "\u295D", yce = "\u2955", wce = "\u21C2", kce = "\u230B", xce = "\u21C1", Cce = "\u21C0", Sce = "\u21C4", Ece = "\u21CC", Ace = "\u21C9", $ce = "\u219D", Mce = "\u21A6", Ice = "\u22A2", Tce = "\u295B", Lce = "\u22CC", Oce = "\u29D0", Rce = "\u22B3", Pce = "\u22B5", Bce = "\u294F", zce = "\u295C", Dce = "\u2954", Nce = "\u21BE", qce = "\u2953", Fce = "\u21C0", Hce = "\u02DA", jce = "\u2253", Uce = "\u21C4", Vce = "\u21CC", Zce = "\u200F", Wce = "\u23B1", Gce = "\u23B1", Kce = "\u2AEE", Xce = "\u27ED", Yce = "\u21FE", Jce = "\u27E7", Qce = "\u2986", ele = "\uD835\uDD63", tle = "\u211D", nle = "\u2A2E", rle = "\u2A35", ole = "\u2970", sle = ")", ile = "\u2994", ale = "\u2A12", cle = "\u21C9", lle = "\u21DB", ule = "\u203A", dle = "\uD835\uDCC7", fle = "\u211B", ple = "\u21B1", hle = "\u21B1", gle = "]", mle = "\u2019", vle = "\u2019", _le = "\u22CC", ble = "\u22CA", yle = "\u25B9", wle = "\u22B5", kle = "\u25B8", xle = "\u29CE", Cle = "\u29F4", Sle = "\u2968", Ele = "\u211E", Ale = "\u015A", $le = "\u015B", Mle = "\u201A", Ile = "\u2AB8", Tle = "\u0160", Lle = "\u0161", Ole = "\u2ABC", Rle = "\u227B", Ple = "\u227D", Ble = "\u2AB0", zle = "\u2AB4", Dle = "\u015E", Nle = "\u015F", qle = "\u015C", Fle = "\u015D", Hle = "\u2ABA", jle = "\u2AB6", Ule = "\u22E9", Vle = "\u2A13", Zle = "\u227F", Wle = "\u0421", Gle = "\u0441", Kle = "\u22A1", Xle = "\u22C5", Yle = "\u2A66", Jle = "\u2925", Qle = "\u2198", eue = "\u21D8", tue = "\u2198", nue = "\xa7", rue = ";", oue = "\u2929", sue = "\u2216", iue = "\u2216", aue = "\u2736", cue = "\uD835\uDD16", lue = "\uD835\uDD30", uue = "\u2322", due = "\u266F", fue = "\u0429", pue = "\u0449", hue = "\u0428", gue = "\u0448", mue = "\u2193", vue = "\u2190", _ue = "\u2223", bue = "\u2225", yue = "\u2192", wue = "\u2191", kue = "\xad", xue = "\u03A3", Cue = "\u03C3", Sue = "\u03C2", Eue = "\u03C2", Aue = "\u223C", $ue = "\u2A6A", Mue = "\u2243", Iue = "\u2243", Tue = "\u2A9E", Lue = "\u2AA0", Oue = "\u2A9D", Rue = "\u2A9F", Pue = "\u2246", Bue = "\u2A24", zue = "\u2972", Due = "\u2190", Nue = "\u2218", que = "\u2216", Fue = "\u2A33", Hue = "\u29E4", jue = "\u2223", Uue = "\u2323", Vue = "\u2AAA", Zue = "\u2AAC", Wue = "\u2AAC\uFE00", Gue = "\u042C", Kue = "\u044C", Xue = "\u233F", Yue = "\u29C4", Jue = "/", Que = "\uD835\uDD4A", ede = "\uD835\uDD64", tde = "\u2660", nde = "\u2660", rde = "\u2225", ode = "\u2293", sde = "\u2293\uFE00", ide = "\u2294", ade = "\u2294\uFE00", cde = "\u221A", lde = "\u228F", ude = "\u2291", dde = "\u228F", fde = "\u2291", pde = "\u2290", hde = "\u2292", gde = "\u2290", mde = "\u2292", vde = "\u25A1", _de = "\u25A1", bde = "\u2293", yde = "\u228F", wde = "\u2291", kde = "\u2290", xde = "\u2292", Cde = "\u2294", Sde = "\u25AA", Ede = "\u25A1", Ade = "\u25AA", $de = "\u2192", Mde = "\uD835\uDCAE", Ide = "\uD835\uDCC8", Tde = "\u2216", Lde = "\u2323", Ode = "\u22C6", Rde = "\u22C6", Pde = "\u2606", Bde = "\u2605", zde = "\u03F5", Dde = "\u03D5", Nde = "\xaf", qde = "\u2282", Fde = "\u22D0", Hde = "\u2ABD", jde = "\u2AC5", Ude = "\u2286", Vde = "\u2AC3", Zde = "\u2AC1", Wde = "\u2ACB", Gde = "\u228A", Kde = "\u2ABF", Xde = "\u2979", Yde = "\u2282", Jde = "\u22D0", Qde = "\u2286", efe = "\u2AC5", tfe = "\u2286", nfe = "\u228A", rfe = "\u2ACB", ofe = "\u2AC7", sfe = "\u2AD5", ife = "\u2AD3", afe = "\u2AB8", cfe = "\u227B", lfe = "\u227D", ufe = "\u227B", dfe = "\u2AB0", ffe = "\u227D", pfe = "\u227F", hfe = "\u2AB0", gfe = "\u2ABA", mfe = "\u2AB6", vfe = "\u22E9", _fe = "\u227F", bfe = "\u220B", yfe = "\u2211", wfe = "\u2211", kfe = "\u266A", xfe = "\xb9", Cfe = "\xb2", Sfe = "\xb3", Efe = "\u2283", Afe = "\u22D1", $fe = "\u2ABE", Mfe = "\u2AD8", Ife = "\u2AC6", Tfe = "\u2287", Lfe = "\u2AC4", Ofe = "\u2283", Rfe = "\u2287", Pfe = "\u27C9", Bfe = "\u2AD7", zfe = "\u297B", Dfe = "\u2AC2", Nfe = "\u2ACC", qfe = "\u228B", Ffe = "\u2AC0", Hfe = "\u2283", jfe = "\u22D1", Ufe = "\u2287", Vfe = "\u2AC6", Zfe = "\u228B", Wfe = "\u2ACC", Gfe = "\u2AC8", Kfe = "\u2AD4", Xfe = "\u2AD6", Yfe = "\u2926", Jfe = "\u2199", Qfe = "\u21D9", e0e = "\u2199", t0e = "\u292A", n0e = "\xdf", r0e = "	", o0e = "\u2316", s0e = "\u03A4", i0e = "\u03C4", a0e = "\u23B4", c0e = "\u0164", l0e = "\u0165", u0e = "\u0162", d0e = "\u0163", f0e = "\u0422", p0e = "\u0442", h0e = "\u20DB", g0e = "\u2315", m0e = "\uD835\uDD17", v0e = "\uD835\uDD31", _0e = "\u2234", b0e = "\u2234", y0e = "\u2234", w0e = "\u0398", k0e = "\u03B8", x0e = "\u03D1", C0e = "\u03D1", S0e = "\u2248", E0e = "\u223C", A0e = "\u205F\u200A", $0e = "\u2009", M0e = "\u2009", I0e = "\u2248", T0e = "\u223C", L0e = "\xde", O0e = "\xfe", R0e = "\u02DC", P0e = "\u223C", B0e = "\u2243", z0e = "\u2245", D0e = "\u2248", N0e = "\u2A31", q0e = "\u22A0", F0e = "\xd7", H0e = "\u2A30", j0e = "\u222D", U0e = "\u2928", V0e = "\u2336", Z0e = "\u2AF1", W0e = "\u22A4", G0e = "\uD835\uDD4B", K0e = "\uD835\uDD65", X0e = "\u2ADA", Y0e = "\u2929", J0e = "\u2034", Q0e = "\u2122", epe = "\u2122", tpe = "\u25B5", npe = "\u25BF", rpe = "\u25C3", ope = "\u22B4", spe = "\u225C", ipe = "\u25B9", ape = "\u22B5", cpe = "\u25EC", lpe = "\u225C", upe = "\u2A3A", dpe = "\u20DB", fpe = "\u2A39", ppe = "\u29CD", hpe = "\u2A3B", gpe = "\u23E2", mpe = "\uD835\uDCAF", vpe = "\uD835\uDCC9", _pe = "\u0426", bpe = "\u0446", ype = "\u040B", wpe = "\u045B", kpe = "\u0166", xpe = "\u0167", Cpe = "\u226C", Spe = "\u219E", Epe = "\u21A0", Ape = "\xda", $pe = "\xfa", Mpe = "\u2191", Ipe = "\u219F", Tpe = "\u21D1", Lpe = "\u2949", Ope = "\u040E", Rpe = "\u045E", Ppe = "\u016C", Bpe = "\u016D", zpe = "\xdb", Dpe = "\xfb", Npe = "\u0423", qpe = "\u0443", Fpe = "\u21C5", Hpe = "\u0170", jpe = "\u0171", Upe = "\u296E", Vpe = "\u297E", Zpe = "\uD835\uDD18", Wpe = "\uD835\uDD32", Gpe = "\xd9", Kpe = "\xf9", Xpe = "\u2963", Ype = "\u21BF", Jpe = "\u21BE", Qpe = "\u2580", ehe = "\u231C", the = "\u231C", nhe = "\u230F", rhe = "\u25F8", ohe = "\u016A", she = "\u016B", ihe = "\xa8", ahe = "_", che = "\u23DF", lhe = "\u23B5", uhe = "\u23DD", dhe = "\u22C3", fhe = "\u228E", phe = "\u0172", hhe = "\u0173", ghe = "\uD835\uDD4C", mhe = "\uD835\uDD66", vhe = "\u2912", _he = "\u2191", bhe = "\u2191", yhe = "\u21D1", whe = "\u21C5", khe = "\u2195", xhe = "\u2195", Che = "\u21D5", She = "\u296E", Ehe = "\u21BF", Ahe = "\u21BE", $he = "\u228E", Mhe = "\u2196", Ihe = "\u2197", The = "\u03C5", Lhe = "\u03D2", Ohe = "\u03D2", Rhe = "\u03A5", Phe = "\u03C5", Bhe = "\u21A5", zhe = "\u22A5", Dhe = "\u21C8", Nhe = "\u231D", qhe = "\u231D", Fhe = "\u230E", Hhe = "\u016E", jhe = "\u016F", Uhe = "\u25F9", Vhe = "\uD835\uDCB0", Zhe = "\uD835\uDCCA", Whe = "\u22F0", Ghe = "\u0168", Khe = "\u0169", Xhe = "\u25B5", Yhe = "\u25B4", Jhe = "\u21C8", Qhe = "\xdc", e2e = "\xfc", t2e = "\u29A7", n2e = "\u299C", r2e = "\u03F5", o2e = "\u03F0", s2e = "\u2205", i2e = "\u03D5", a2e = "\u03D6", c2e = "\u221D", l2e = "\u2195", u2e = "\u21D5", d2e = "\u03F1", f2e = "\u03C2", p2e = "\u228A\uFE00", h2e = "\u2ACB\uFE00", g2e = "\u228B\uFE00", m2e = "\u2ACC\uFE00", v2e = "\u03D1", _2e = "\u22B2", b2e = "\u22B3", y2e = "\u2AE8", w2e = "\u2AEB", k2e = "\u2AE9", x2e = "\u0412", C2e = "\u0432", S2e = "\u22A2", E2e = "\u22A8", A2e = "\u22A9", $2e = "\u22AB", M2e = "\u2AE6", I2e = "\u22BB", T2e = "\u2228", L2e = "\u22C1", O2e = "\u225A", R2e = "\u22EE", P2e = "|", B2e = "\u2016", z2e = "|", D2e = "\u2016", N2e = "\u2223", q2e = "|", F2e = "\u2758", H2e = "\u2240", j2e = "\u200A", U2e = "\uD835\uDD19", V2e = "\uD835\uDD33", Z2e = "\u22B2", W2e = "\u2282\u20D2", G2e = "\u2283\u20D2", K2e = "\uD835\uDD4D", X2e = "\uD835\uDD67", Y2e = "\u221D", J2e = "\u22B3", Q2e = "\uD835\uDCB1", e1e = "\uD835\uDCCB", t1e = "\u2ACB\uFE00", n1e = "\u228A\uFE00", r1e = "\u2ACC\uFE00", o1e = "\u228B\uFE00", s1e = "\u22AA", i1e = "\u299A", a1e = "\u0174", c1e = "\u0175", l1e = "\u2A5F", u1e = "\u2227", d1e = "\u22C0", f1e = "\u2259", p1e = "\u2118", h1e = "\uD835\uDD1A", g1e = "\uD835\uDD34", m1e = "\uD835\uDD4E", v1e = "\uD835\uDD68", _1e = "\u2118", b1e = "\u2240", y1e = "\u2240", w1e = "\uD835\uDCB2", k1e = "\uD835\uDCCC", x1e = "\u22C2", C1e = "\u25EF", S1e = "\u22C3", E1e = "\u25BD", A1e = "\uD835\uDD1B", $1e = "\uD835\uDD35", M1e = "\u27F7", I1e = "\u27FA", T1e = "\u039E", L1e = "\u03BE", O1e = "\u27F5", R1e = "\u27F8", P1e = "\u27FC", B1e = "\u22FB", z1e = "\u2A00", D1e = "\uD835\uDD4F", N1e = "\uD835\uDD69", q1e = "\u2A01", F1e = "\u2A02", H1e = "\u27F6", j1e = "\u27F9", U1e = "\uD835\uDCB3", V1e = "\uD835\uDCCD", Z1e = "\u2A06", W1e = "\u2A04", G1e = "\u25B3", K1e = "\u22C1", X1e = "\u22C0", Y1e = "\xdd", J1e = "\xfd", Q1e = "\u042F", ege = "\u044F", tge = "\u0176", nge = "\u0177", rge = "\u042B", oge = "\u044B", sge = "\xa5", ige = "\uD835\uDD1C", age = "\uD835\uDD36", cge = "\u0407", lge = "\u0457", uge = "\uD835\uDD50", dge = "\uD835\uDD6A", fge = "\uD835\uDCB4", pge = "\uD835\uDCCE", hge = "\u042E", gge = "\u044E", mge = "\xff", vge = "\u0178", _ge = "\u0179", bge = "\u017A", yge = "\u017D", wge = "\u017E", kge = "\u0417", xge = "\u0437", Cge = "\u017B", Sge = "\u017C", Ege = "\u2128", Age = "\u200B", $ge = "\u0396", Mge = "\u03B6", Ige = "\uD835\uDD37", Tge = "\u2128", Lge = "\u0416", Oge = "\u0436", Rge = "\u21DD", Pge = "\uD835\uDD6B", Bge = "\u2124", zge = "\uD835\uDCB5", Dge = "\uD835\uDCCF", Nge = "\u200D", qge = "\u200C", Fge = {
    Aacute: CO,
    aacute: SO,
    Abreve: EO,
    abreve: AO,
    ac: $O,
    acd: MO,
    acE: IO,
    Acirc: TO,
    acirc: LO,
    acute: OO,
    Acy: RO,
    acy: PO,
    AElig: BO,
    aelig: zO,
    af: DO,
    Afr: NO,
    afr: qO,
    Agrave: FO,
    agrave: HO,
    alefsym: jO,
    aleph: UO,
    Alpha: VO,
    alpha: ZO,
    Amacr: WO,
    amacr: GO,
    amalg: KO,
    amp: XO,
    AMP: YO,
    andand: JO,
    And: QO,
    and: eR,
    andd: tR,
    andslope: nR,
    andv: rR,
    ang: oR,
    ange: sR,
    angle: iR,
    angmsdaa: aR,
    angmsdab: cR,
    angmsdac: lR,
    angmsdad: uR,
    angmsdae: dR,
    angmsdaf: fR,
    angmsdag: pR,
    angmsdah: hR,
    angmsd: gR,
    angrt: mR,
    angrtvb: vR,
    angrtvbd: _R,
    angsph: bR,
    angst: yR,
    angzarr: wR,
    Aogon: kR,
    aogon: xR,
    Aopf: CR,
    aopf: SR,
    apacir: ER,
    ap: AR,
    apE: $R,
    ape: MR,
    apid: IR,
    apos: TR,
    ApplyFunction: LR,
    approx: OR,
    approxeq: RR,
    Aring: PR,
    aring: BR,
    Ascr: zR,
    ascr: DR,
    Assign: NR,
    ast: qR,
    asymp: FR,
    asympeq: HR,
    Atilde: jR,
    atilde: UR,
    Auml: VR,
    auml: ZR,
    awconint: WR,
    awint: GR,
    backcong: KR,
    backepsilon: XR,
    backprime: YR,
    backsim: JR,
    backsimeq: QR,
    Backslash: eP,
    Barv: tP,
    barvee: nP,
    barwed: rP,
    Barwed: oP,
    barwedge: sP,
    bbrk: iP,
    bbrktbrk: aP,
    bcong: cP,
    Bcy: lP,
    bcy: uP,
    bdquo: dP,
    becaus: fP,
    because: pP,
    Because: hP,
    bemptyv: gP,
    bepsi: mP,
    bernou: vP,
    Bernoullis: _P,
    Beta: bP,
    beta: yP,
    beth: wP,
    between: kP,
    Bfr: xP,
    bfr: CP,
    bigcap: SP,
    bigcirc: EP,
    bigcup: AP,
    bigodot: $P,
    bigoplus: MP,
    bigotimes: IP,
    bigsqcup: TP,
    bigstar: LP,
    bigtriangledown: OP,
    bigtriangleup: RP,
    biguplus: PP,
    bigvee: BP,
    bigwedge: zP,
    bkarow: DP,
    blacklozenge: NP,
    blacksquare: qP,
    blacktriangle: FP,
    blacktriangledown: HP,
    blacktriangleleft: jP,
    blacktriangleright: UP,
    blank: VP,
    blk12: ZP,
    blk14: WP,
    blk34: GP,
    block: KP,
    bne: XP,
    bnequiv: YP,
    bNot: JP,
    bnot: QP,
    Bopf: eB,
    bopf: tB,
    bot: nB,
    bottom: rB,
    bowtie: oB,
    boxbox: sB,
    boxdl: iB,
    boxdL: aB,
    boxDl: cB,
    boxDL: lB,
    boxdr: uB,
    boxdR: dB,
    boxDr: fB,
    boxDR: pB,
    boxh: hB,
    boxH: gB,
    boxhd: mB,
    boxHd: vB,
    boxhD: _B,
    boxHD: bB,
    boxhu: yB,
    boxHu: wB,
    boxhU: kB,
    boxHU: xB,
    boxminus: CB,
    boxplus: SB,
    boxtimes: EB,
    boxul: AB,
    boxuL: $B,
    boxUl: MB,
    boxUL: IB,
    boxur: TB,
    boxuR: LB,
    boxUr: OB,
    boxUR: RB,
    boxv: PB,
    boxV: BB,
    boxvh: zB,
    boxvH: DB,
    boxVh: NB,
    boxVH: qB,
    boxvl: FB,
    boxvL: HB,
    boxVl: jB,
    boxVL: UB,
    boxvr: VB,
    boxvR: ZB,
    boxVr: WB,
    boxVR: GB,
    bprime: KB,
    breve: XB,
    Breve: YB,
    brvbar: JB,
    bscr: QB,
    Bscr: ez,
    bsemi: tz,
    bsim: nz,
    bsime: rz,
    bsolb: oz,
    bsol: sz,
    bsolhsub: iz,
    bull: az,
    bullet: cz,
    bump: lz,
    bumpE: uz,
    bumpe: dz,
    Bumpeq: fz,
    bumpeq: pz,
    Cacute: hz,
    cacute: gz,
    capand: mz,
    capbrcup: vz,
    capcap: _z,
    cap: bz,
    Cap: yz,
    capcup: wz,
    capdot: kz,
    CapitalDifferentialD: xz,
    caps: Cz,
    caret: Sz,
    caron: Ez,
    Cayleys: Az,
    ccaps: $z,
    Ccaron: Mz,
    ccaron: Iz,
    Ccedil: Tz,
    ccedil: Lz,
    Ccirc: Oz,
    ccirc: Rz,
    Cconint: Pz,
    ccups: Bz,
    ccupssm: zz,
    Cdot: Dz,
    cdot: Nz,
    cedil: qz,
    Cedilla: Fz,
    cemptyv: Hz,
    cent: jz,
    centerdot: Uz,
    CenterDot: Vz,
    cfr: Zz,
    Cfr: Wz,
    CHcy: Gz,
    chcy: Kz,
    check: Xz,
    checkmark: Yz,
    Chi: Jz,
    chi: Qz,
    circ: eD,
    circeq: tD,
    circlearrowleft: nD,
    circlearrowright: rD,
    circledast: oD,
    circledcirc: sD,
    circleddash: iD,
    CircleDot: aD,
    circledR: cD,
    circledS: lD,
    CircleMinus: uD,
    CirclePlus: dD,
    CircleTimes: fD,
    cir: pD,
    cirE: hD,
    cire: gD,
    cirfnint: mD,
    cirmid: vD,
    cirscir: _D,
    ClockwiseContourIntegral: bD,
    CloseCurlyDoubleQuote: yD,
    CloseCurlyQuote: wD,
    clubs: kD,
    clubsuit: xD,
    colon: CD,
    Colon: SD,
    Colone: ED,
    colone: AD,
    coloneq: $D,
    comma: MD,
    commat: ID,
    comp: TD,
    compfn: LD,
    complement: OD,
    complexes: RD,
    cong: PD,
    congdot: BD,
    Congruent: zD,
    conint: DD,
    Conint: ND,
    ContourIntegral: qD,
    copf: FD,
    Copf: HD,
    coprod: jD,
    Coproduct: UD,
    copy: VD,
    COPY: ZD,
    copysr: WD,
    CounterClockwiseContourIntegral: GD,
    crarr: KD,
    cross: XD,
    Cross: YD,
    Cscr: JD,
    cscr: QD,
    csub: eN,
    csube: tN,
    csup: nN,
    csupe: rN,
    ctdot: oN,
    cudarrl: sN,
    cudarrr: iN,
    cuepr: aN,
    cuesc: cN,
    cularr: lN,
    cularrp: uN,
    cupbrcap: dN,
    cupcap: fN,
    CupCap: pN,
    cup: hN,
    Cup: gN,
    cupcup: mN,
    cupdot: vN,
    cupor: _N,
    cups: bN,
    curarr: yN,
    curarrm: wN,
    curlyeqprec: kN,
    curlyeqsucc: xN,
    curlyvee: CN,
    curlywedge: SN,
    curren: EN,
    curvearrowleft: AN,
    curvearrowright: $N,
    cuvee: MN,
    cuwed: IN,
    cwconint: TN,
    cwint: LN,
    cylcty: ON,
    dagger: RN,
    Dagger: PN,
    daleth: BN,
    darr: zN,
    Darr: DN,
    dArr: NN,
    dash: qN,
    Dashv: FN,
    dashv: HN,
    dbkarow: jN,
    dblac: UN,
    Dcaron: VN,
    dcaron: ZN,
    Dcy: WN,
    dcy: GN,
    ddagger: KN,
    ddarr: XN,
    DD: YN,
    dd: JN,
    DDotrahd: QN,
    ddotseq: eq,
    deg: tq,
    Del: nq,
    Delta: rq,
    delta: oq,
    demptyv: sq,
    dfisht: iq,
    Dfr: aq,
    dfr: cq,
    dHar: lq,
    dharl: uq,
    dharr: dq,
    DiacriticalAcute: fq,
    DiacriticalDot: pq,
    DiacriticalDoubleAcute: hq,
    DiacriticalGrave: gq,
    DiacriticalTilde: mq,
    diam: vq,
    diamond: _q,
    Diamond: bq,
    diamondsuit: yq,
    diams: wq,
    die: kq,
    DifferentialD: xq,
    digamma: Cq,
    disin: Sq,
    div: Eq,
    divide: Aq,
    divideontimes: $q,
    divonx: Mq,
    DJcy: Iq,
    djcy: Tq,
    dlcorn: Lq,
    dlcrop: Oq,
    dollar: Rq,
    Dopf: Pq,
    dopf: Bq,
    Dot: zq,
    dot: Dq,
    DotDot: Nq,
    doteq: qq,
    doteqdot: Fq,
    DotEqual: Hq,
    dotminus: jq,
    dotplus: Uq,
    dotsquare: Vq,
    doublebarwedge: Zq,
    DoubleContourIntegral: Wq,
    DoubleDot: Gq,
    DoubleDownArrow: Kq,
    DoubleLeftArrow: Xq,
    DoubleLeftRightArrow: Yq,
    DoubleLeftTee: Jq,
    DoubleLongLeftArrow: Qq,
    DoubleLongLeftRightArrow: eF,
    DoubleLongRightArrow: tF,
    DoubleRightArrow: nF,
    DoubleRightTee: rF,
    DoubleUpArrow: oF,
    DoubleUpDownArrow: sF,
    DoubleVerticalBar: iF,
    DownArrowBar: aF,
    downarrow: cF,
    DownArrow: lF,
    Downarrow: uF,
    DownArrowUpArrow: dF,
    DownBreve: fF,
    downdownarrows: pF,
    downharpoonleft: hF,
    downharpoonright: gF,
    DownLeftRightVector: mF,
    DownLeftTeeVector: vF,
    DownLeftVectorBar: _F,
    DownLeftVector: bF,
    DownRightTeeVector: yF,
    DownRightVectorBar: wF,
    DownRightVector: kF,
    DownTeeArrow: xF,
    DownTee: CF,
    drbkarow: SF,
    drcorn: EF,
    drcrop: AF,
    Dscr: $F,
    dscr: MF,
    DScy: IF,
    dscy: TF,
    dsol: LF,
    Dstrok: OF,
    dstrok: RF,
    dtdot: PF,
    dtri: BF,
    dtrif: zF,
    duarr: DF,
    duhar: NF,
    dwangle: qF,
    DZcy: FF,
    dzcy: HF,
    dzigrarr: jF,
    Eacute: UF,
    eacute: VF,
    easter: ZF,
    Ecaron: WF,
    ecaron: GF,
    Ecirc: KF,
    ecirc: XF,
    ecir: YF,
    ecolon: JF,
    Ecy: QF,
    ecy: eH,
    eDDot: tH,
    Edot: nH,
    edot: rH,
    eDot: oH,
    ee: sH,
    efDot: iH,
    Efr: aH,
    efr: cH,
    eg: lH,
    Egrave: uH,
    egrave: dH,
    egs: fH,
    egsdot: pH,
    el: hH,
    Element: gH,
    elinters: mH,
    ell: vH,
    els: _H,
    elsdot: bH,
    Emacr: yH,
    emacr: wH,
    empty: kH,
    emptyset: xH,
    EmptySmallSquare: CH,
    emptyv: SH,
    EmptyVerySmallSquare: EH,
    emsp13: AH,
    emsp14: $H,
    emsp: MH,
    ENG: IH,
    eng: TH,
    ensp: LH,
    Eogon: OH,
    eogon: RH,
    Eopf: PH,
    eopf: BH,
    epar: zH,
    eparsl: DH,
    eplus: NH,
    epsi: qH,
    Epsilon: FH,
    epsilon: HH,
    epsiv: jH,
    eqcirc: UH,
    eqcolon: VH,
    eqsim: ZH,
    eqslantgtr: WH,
    eqslantless: GH,
    Equal: KH,
    equals: XH,
    EqualTilde: YH,
    equest: JH,
    Equilibrium: QH,
    equiv: ej,
    equivDD: tj,
    eqvparsl: nj,
    erarr: rj,
    erDot: oj,
    escr: sj,
    Escr: ij,
    esdot: aj,
    Esim: cj,
    esim: lj,
    Eta: uj,
    eta: dj,
    ETH: fj,
    eth: pj,
    Euml: hj,
    euml: gj,
    euro: mj,
    excl: vj,
    exist: _j,
    Exists: bj,
    expectation: yj,
    exponentiale: wj,
    ExponentialE: kj,
    fallingdotseq: xj,
    Fcy: Cj,
    fcy: Sj,
    female: Ej,
    ffilig: Aj,
    fflig: $j,
    ffllig: Mj,
    Ffr: Ij,
    ffr: Tj,
    filig: Lj,
    FilledSmallSquare: Oj,
    FilledVerySmallSquare: Rj,
    fjlig: Pj,
    flat: Bj,
    fllig: zj,
    fltns: Dj,
    fnof: Nj,
    Fopf: qj,
    fopf: Fj,
    forall: Hj,
    ForAll: jj,
    fork: Uj,
    forkv: Vj,
    Fouriertrf: Zj,
    fpartint: Wj,
    frac12: Gj,
    frac13: Kj,
    frac14: Xj,
    frac15: Yj,
    frac16: Jj,
    frac18: Qj,
    frac23: eU,
    frac25: tU,
    frac34: nU,
    frac35: rU,
    frac38: oU,
    frac45: sU,
    frac56: iU,
    frac58: aU,
    frac78: cU,
    frasl: lU,
    frown: uU,
    fscr: dU,
    Fscr: fU,
    gacute: pU,
    Gamma: hU,
    gamma: gU,
    Gammad: mU,
    gammad: vU,
    gap: _U,
    Gbreve: bU,
    gbreve: yU,
    Gcedil: wU,
    Gcirc: kU,
    gcirc: xU,
    Gcy: CU,
    gcy: SU,
    Gdot: EU,
    gdot: AU,
    ge: $U,
    gE: MU,
    gEl: IU,
    gel: TU,
    geq: LU,
    geqq: OU,
    geqslant: RU,
    gescc: PU,
    ges: BU,
    gesdot: zU,
    gesdoto: DU,
    gesdotol: NU,
    gesl: qU,
    gesles: FU,
    Gfr: HU,
    gfr: jU,
    gg: UU,
    Gg: VU,
    ggg: ZU,
    gimel: WU,
    GJcy: GU,
    gjcy: KU,
    gla: XU,
    gl: YU,
    glE: JU,
    glj: QU,
    gnap: eV,
    gnapprox: tV,
    gne: nV,
    gnE: rV,
    gneq: oV,
    gneqq: sV,
    gnsim: iV,
    Gopf: aV,
    gopf: cV,
    grave: lV,
    GreaterEqual: uV,
    GreaterEqualLess: dV,
    GreaterFullEqual: fV,
    GreaterGreater: pV,
    GreaterLess: hV,
    GreaterSlantEqual: gV,
    GreaterTilde: mV,
    Gscr: vV,
    gscr: _V,
    gsim: bV,
    gsime: yV,
    gsiml: wV,
    gtcc: kV,
    gtcir: xV,
    gt: CV,
    GT: SV,
    Gt: EV,
    gtdot: AV,
    gtlPar: $V,
    gtquest: MV,
    gtrapprox: IV,
    gtrarr: TV,
    gtrdot: LV,
    gtreqless: OV,
    gtreqqless: RV,
    gtrless: PV,
    gtrsim: BV,
    gvertneqq: zV,
    gvnE: DV,
    Hacek: NV,
    hairsp: qV,
    half: FV,
    hamilt: HV,
    HARDcy: jV,
    hardcy: UV,
    harrcir: VV,
    harr: ZV,
    hArr: WV,
    harrw: GV,
    Hat: KV,
    hbar: XV,
    Hcirc: YV,
    hcirc: JV,
    hearts: QV,
    heartsuit: eZ,
    hellip: tZ,
    hercon: nZ,
    hfr: rZ,
    Hfr: oZ,
    HilbertSpace: sZ,
    hksearow: iZ,
    hkswarow: aZ,
    hoarr: cZ,
    homtht: lZ,
    hookleftarrow: uZ,
    hookrightarrow: dZ,
    hopf: fZ,
    Hopf: pZ,
    horbar: hZ,
    HorizontalLine: gZ,
    hscr: mZ,
    Hscr: vZ,
    hslash: _Z,
    Hstrok: bZ,
    hstrok: yZ,
    HumpDownHump: wZ,
    HumpEqual: kZ,
    hybull: xZ,
    hyphen: CZ,
    Iacute: SZ,
    iacute: EZ,
    ic: AZ,
    Icirc: $Z,
    icirc: MZ,
    Icy: IZ,
    icy: TZ,
    Idot: LZ,
    IEcy: OZ,
    iecy: RZ,
    iexcl: PZ,
    iff: BZ,
    ifr: zZ,
    Ifr: DZ,
    Igrave: NZ,
    igrave: qZ,
    ii: FZ,
    iiiint: HZ,
    iiint: jZ,
    iinfin: UZ,
    iiota: VZ,
    IJlig: ZZ,
    ijlig: WZ,
    Imacr: GZ,
    imacr: KZ,
    image: XZ,
    ImaginaryI: YZ,
    imagline: JZ,
    imagpart: QZ,
    imath: eW,
    Im: tW,
    imof: nW,
    imped: rW,
    Implies: oW,
    incare: sW,
    "in": "\u2208",
    infin: iW,
    infintie: aW,
    inodot: cW,
    intcal: lW,
    int: uW,
    Int: dW,
    integers: fW,
    Integral: pW,
    intercal: hW,
    Intersection: gW,
    intlarhk: mW,
    intprod: vW,
    InvisibleComma: _W,
    InvisibleTimes: bW,
    IOcy: yW,
    iocy: wW,
    Iogon: kW,
    iogon: xW,
    Iopf: CW,
    iopf: SW,
    Iota: EW,
    iota: AW,
    iprod: $W,
    iquest: MW,
    iscr: IW,
    Iscr: TW,
    isin: LW,
    isindot: OW,
    isinE: RW,
    isins: PW,
    isinsv: BW,
    isinv: zW,
    it: DW,
    Itilde: NW,
    itilde: qW,
    Iukcy: FW,
    iukcy: HW,
    Iuml: jW,
    iuml: UW,
    Jcirc: VW,
    jcirc: ZW,
    Jcy: WW,
    jcy: GW,
    Jfr: KW,
    jfr: XW,
    jmath: YW,
    Jopf: JW,
    jopf: QW,
    Jscr: eG,
    jscr: tG,
    Jsercy: nG,
    jsercy: rG,
    Jukcy: oG,
    jukcy: sG,
    Kappa: iG,
    kappa: aG,
    kappav: cG,
    Kcedil: lG,
    kcedil: uG,
    Kcy: dG,
    kcy: fG,
    Kfr: pG,
    kfr: hG,
    kgreen: gG,
    KHcy: mG,
    khcy: vG,
    KJcy: _G,
    kjcy: bG,
    Kopf: yG,
    kopf: wG,
    Kscr: kG,
    kscr: xG,
    lAarr: CG,
    Lacute: SG,
    lacute: EG,
    laemptyv: AG,
    lagran: $G,
    Lambda: MG,
    lambda: IG,
    lang: TG,
    Lang: LG,
    langd: OG,
    langle: RG,
    lap: PG,
    Laplacetrf: BG,
    laquo: zG,
    larrb: DG,
    larrbfs: NG,
    larr: qG,
    Larr: FG,
    lArr: HG,
    larrfs: jG,
    larrhk: UG,
    larrlp: VG,
    larrpl: ZG,
    larrsim: WG,
    larrtl: GG,
    latail: KG,
    lAtail: XG,
    lat: YG,
    late: JG,
    lates: QG,
    lbarr: eK,
    lBarr: tK,
    lbbrk: nK,
    lbrace: rK,
    lbrack: oK,
    lbrke: sK,
    lbrksld: iK,
    lbrkslu: aK,
    Lcaron: cK,
    lcaron: lK,
    Lcedil: uK,
    lcedil: dK,
    lceil: fK,
    lcub: pK,
    Lcy: hK,
    lcy: gK,
    ldca: mK,
    ldquo: vK,
    ldquor: _K,
    ldrdhar: bK,
    ldrushar: yK,
    ldsh: wK,
    le: kK,
    lE: xK,
    LeftAngleBracket: CK,
    LeftArrowBar: SK,
    leftarrow: EK,
    LeftArrow: AK,
    Leftarrow: $K,
    LeftArrowRightArrow: MK,
    leftarrowtail: IK,
    LeftCeiling: TK,
    LeftDoubleBracket: LK,
    LeftDownTeeVector: OK,
    LeftDownVectorBar: RK,
    LeftDownVector: PK,
    LeftFloor: BK,
    leftharpoondown: zK,
    leftharpoonup: DK,
    leftleftarrows: NK,
    leftrightarrow: qK,
    LeftRightArrow: FK,
    Leftrightarrow: HK,
    leftrightarrows: jK,
    leftrightharpoons: UK,
    leftrightsquigarrow: VK,
    LeftRightVector: ZK,
    LeftTeeArrow: WK,
    LeftTee: GK,
    LeftTeeVector: KK,
    leftthreetimes: XK,
    LeftTriangleBar: YK,
    LeftTriangle: JK,
    LeftTriangleEqual: QK,
    LeftUpDownVector: eX,
    LeftUpTeeVector: tX,
    LeftUpVectorBar: nX,
    LeftUpVector: rX,
    LeftVectorBar: oX,
    LeftVector: sX,
    lEg: iX,
    leg: aX,
    leq: cX,
    leqq: lX,
    leqslant: uX,
    lescc: dX,
    les: fX,
    lesdot: pX,
    lesdoto: hX,
    lesdotor: gX,
    lesg: mX,
    lesges: vX,
    lessapprox: _X,
    lessdot: bX,
    lesseqgtr: yX,
    lesseqqgtr: wX,
    LessEqualGreater: kX,
    LessFullEqual: xX,
    LessGreater: CX,
    lessgtr: SX,
    LessLess: EX,
    lesssim: AX,
    LessSlantEqual: $X,
    LessTilde: MX,
    lfisht: IX,
    lfloor: TX,
    Lfr: LX,
    lfr: OX,
    lg: RX,
    lgE: PX,
    lHar: BX,
    lhard: zX,
    lharu: DX,
    lharul: NX,
    lhblk: qX,
    LJcy: FX,
    ljcy: HX,
    llarr: jX,
    ll: UX,
    Ll: VX,
    llcorner: ZX,
    Lleftarrow: WX,
    llhard: GX,
    lltri: KX,
    Lmidot: XX,
    lmidot: YX,
    lmoustache: JX,
    lmoust: QX,
    lnap: eY,
    lnapprox: tY,
    lne: nY,
    lnE: rY,
    lneq: oY,
    lneqq: sY,
    lnsim: iY,
    loang: aY,
    loarr: cY,
    lobrk: lY,
    longleftarrow: uY,
    LongLeftArrow: dY,
    Longleftarrow: fY,
    longleftrightarrow: pY,
    LongLeftRightArrow: hY,
    Longleftrightarrow: gY,
    longmapsto: mY,
    longrightarrow: vY,
    LongRightArrow: _Y,
    Longrightarrow: bY,
    looparrowleft: yY,
    looparrowright: wY,
    lopar: kY,
    Lopf: xY,
    lopf: CY,
    loplus: SY,
    lotimes: EY,
    lowast: AY,
    lowbar: $Y,
    LowerLeftArrow: MY,
    LowerRightArrow: IY,
    loz: TY,
    lozenge: LY,
    lozf: OY,
    lpar: RY,
    lparlt: PY,
    lrarr: BY,
    lrcorner: zY,
    lrhar: DY,
    lrhard: NY,
    lrm: qY,
    lrtri: FY,
    lsaquo: HY,
    lscr: jY,
    Lscr: UY,
    lsh: VY,
    Lsh: ZY,
    lsim: WY,
    lsime: GY,
    lsimg: KY,
    lsqb: XY,
    lsquo: YY,
    lsquor: JY,
    Lstrok: QY,
    lstrok: eJ,
    ltcc: tJ,
    ltcir: nJ,
    lt: rJ,
    LT: oJ,
    Lt: sJ,
    ltdot: iJ,
    lthree: aJ,
    ltimes: cJ,
    ltlarr: lJ,
    ltquest: uJ,
    ltri: dJ,
    ltrie: fJ,
    ltrif: pJ,
    ltrPar: hJ,
    lurdshar: gJ,
    luruhar: mJ,
    lvertneqq: vJ,
    lvnE: _J,
    macr: bJ,
    male: yJ,
    malt: wJ,
    maltese: kJ,
    Map: "\u2905",
    map: xJ,
    mapsto: CJ,
    mapstodown: SJ,
    mapstoleft: EJ,
    mapstoup: AJ,
    marker: $J,
    mcomma: MJ,
    Mcy: IJ,
    mcy: TJ,
    mdash: LJ,
    mDDot: OJ,
    measuredangle: RJ,
    MediumSpace: PJ,
    Mellintrf: BJ,
    Mfr: zJ,
    mfr: DJ,
    mho: NJ,
    micro: qJ,
    midast: FJ,
    midcir: HJ,
    mid: jJ,
    middot: UJ,
    minusb: VJ,
    minus: ZJ,
    minusd: WJ,
    minusdu: GJ,
    MinusPlus: KJ,
    mlcp: XJ,
    mldr: YJ,
    mnplus: JJ,
    models: QJ,
    Mopf: eQ,
    mopf: tQ,
    mp: nQ,
    mscr: rQ,
    Mscr: oQ,
    mstpos: sQ,
    Mu: iQ,
    mu: aQ,
    multimap: cQ,
    mumap: lQ,
    nabla: uQ,
    Nacute: dQ,
    nacute: fQ,
    nang: pQ,
    nap: hQ,
    napE: gQ,
    napid: mQ,
    napos: vQ,
    napprox: _Q,
    natural: bQ,
    naturals: yQ,
    natur: wQ,
    nbsp: kQ,
    nbump: xQ,
    nbumpe: CQ,
    ncap: SQ,
    Ncaron: EQ,
    ncaron: AQ,
    Ncedil: $Q,
    ncedil: MQ,
    ncong: IQ,
    ncongdot: TQ,
    ncup: LQ,
    Ncy: OQ,
    ncy: RQ,
    ndash: PQ,
    nearhk: BQ,
    nearr: zQ,
    neArr: DQ,
    nearrow: NQ,
    ne: qQ,
    nedot: FQ,
    NegativeMediumSpace: HQ,
    NegativeThickSpace: jQ,
    NegativeThinSpace: UQ,
    NegativeVeryThinSpace: VQ,
    nequiv: ZQ,
    nesear: WQ,
    nesim: GQ,
    NestedGreaterGreater: KQ,
    NestedLessLess: XQ,
    NewLine: YQ,
    nexist: JQ,
    nexists: QQ,
    Nfr: eee,
    nfr: tee,
    ngE: nee,
    nge: ree,
    ngeq: oee,
    ngeqq: see,
    ngeqslant: iee,
    nges: aee,
    nGg: cee,
    ngsim: lee,
    nGt: uee,
    ngt: dee,
    ngtr: fee,
    nGtv: pee,
    nharr: hee,
    nhArr: gee,
    nhpar: mee,
    ni: vee,
    nis: _ee,
    nisd: bee,
    niv: yee,
    NJcy: wee,
    njcy: kee,
    nlarr: xee,
    nlArr: Cee,
    nldr: See,
    nlE: Eee,
    nle: Aee,
    nleftarrow: $ee,
    nLeftarrow: Mee,
    nleftrightarrow: Iee,
    nLeftrightarrow: Tee,
    nleq: Lee,
    nleqq: Oee,
    nleqslant: Ree,
    nles: Pee,
    nless: Bee,
    nLl: zee,
    nlsim: Dee,
    nLt: Nee,
    nlt: qee,
    nltri: Fee,
    nltrie: Hee,
    nLtv: jee,
    nmid: Uee,
    NoBreak: Vee,
    NonBreakingSpace: Zee,
    nopf: Wee,
    Nopf: Gee,
    Not: Kee,
    not: Xee,
    NotCongruent: Yee,
    NotCupCap: Jee,
    NotDoubleVerticalBar: Qee,
    NotElement: ete,
    NotEqual: tte,
    NotEqualTilde: nte,
    NotExists: rte,
    NotGreater: ote,
    NotGreaterEqual: ste,
    NotGreaterFullEqual: ite,
    NotGreaterGreater: ate,
    NotGreaterLess: cte,
    NotGreaterSlantEqual: lte,
    NotGreaterTilde: ute,
    NotHumpDownHump: dte,
    NotHumpEqual: fte,
    notin: pte,
    notindot: hte,
    notinE: gte,
    notinva: mte,
    notinvb: vte,
    notinvc: _te,
    NotLeftTriangleBar: bte,
    NotLeftTriangle: yte,
    NotLeftTriangleEqual: wte,
    NotLess: kte,
    NotLessEqual: xte,
    NotLessGreater: Cte,
    NotLessLess: Ste,
    NotLessSlantEqual: Ete,
    NotLessTilde: Ate,
    NotNestedGreaterGreater: $te,
    NotNestedLessLess: Mte,
    notni: Ite,
    notniva: Tte,
    notnivb: Lte,
    notnivc: Ote,
    NotPrecedes: Rte,
    NotPrecedesEqual: Pte,
    NotPrecedesSlantEqual: Bte,
    NotReverseElement: zte,
    NotRightTriangleBar: Dte,
    NotRightTriangle: Nte,
    NotRightTriangleEqual: qte,
    NotSquareSubset: Fte,
    NotSquareSubsetEqual: Hte,
    NotSquareSuperset: jte,
    NotSquareSupersetEqual: Ute,
    NotSubset: Vte,
    NotSubsetEqual: Zte,
    NotSucceeds: Wte,
    NotSucceedsEqual: Gte,
    NotSucceedsSlantEqual: Kte,
    NotSucceedsTilde: Xte,
    NotSuperset: Yte,
    NotSupersetEqual: Jte,
    NotTilde: Qte,
    NotTildeEqual: ene,
    NotTildeFullEqual: tne,
    NotTildeTilde: nne,
    NotVerticalBar: rne,
    nparallel: one,
    npar: sne,
    nparsl: ine,
    npart: ane,
    npolint: cne,
    npr: lne,
    nprcue: une,
    nprec: dne,
    npreceq: fne,
    npre: pne,
    nrarrc: hne,
    nrarr: gne,
    nrArr: mne,
    nrarrw: vne,
    nrightarrow: _ne,
    nRightarrow: bne,
    nrtri: yne,
    nrtrie: wne,
    nsc: kne,
    nsccue: xne,
    nsce: Cne,
    Nscr: Sne,
    nscr: Ene,
    nshortmid: Ane,
    nshortparallel: $ne,
    nsim: Mne,
    nsime: Ine,
    nsimeq: Tne,
    nsmid: Lne,
    nspar: One,
    nsqsube: Rne,
    nsqsupe: Pne,
    nsub: Bne,
    nsubE: zne,
    nsube: Dne,
    nsubset: Nne,
    nsubseteq: qne,
    nsubseteqq: Fne,
    nsucc: Hne,
    nsucceq: jne,
    nsup: Une,
    nsupE: Vne,
    nsupe: Zne,
    nsupset: Wne,
    nsupseteq: Gne,
    nsupseteqq: Kne,
    ntgl: Xne,
    Ntilde: Yne,
    ntilde: Jne,
    ntlg: Qne,
    ntriangleleft: ere,
    ntrianglelefteq: tre,
    ntriangleright: nre,
    ntrianglerighteq: rre,
    Nu: ore,
    nu: sre,
    num: ire,
    numero: are,
    numsp: cre,
    nvap: lre,
    nvdash: ure,
    nvDash: dre,
    nVdash: fre,
    nVDash: pre,
    nvge: hre,
    nvgt: gre,
    nvHarr: mre,
    nvinfin: vre,
    nvlArr: _re,
    nvle: bre,
    nvlt: yre,
    nvltrie: wre,
    nvrArr: kre,
    nvrtrie: xre,
    nvsim: Cre,
    nwarhk: Sre,
    nwarr: Ere,
    nwArr: Are,
    nwarrow: $re,
    nwnear: Mre,
    Oacute: Ire,
    oacute: Tre,
    oast: Lre,
    Ocirc: Ore,
    ocirc: Rre,
    ocir: Pre,
    Ocy: Bre,
    ocy: zre,
    odash: Dre,
    Odblac: Nre,
    odblac: qre,
    odiv: Fre,
    odot: Hre,
    odsold: jre,
    OElig: Ure,
    oelig: Vre,
    ofcir: Zre,
    Ofr: Wre,
    ofr: Gre,
    ogon: Kre,
    Ograve: Xre,
    ograve: Yre,
    ogt: Jre,
    ohbar: Qre,
    ohm: eoe,
    oint: toe,
    olarr: noe,
    olcir: roe,
    olcross: ooe,
    oline: soe,
    olt: ioe,
    Omacr: aoe,
    omacr: coe,
    Omega: loe,
    omega: uoe,
    Omicron: doe,
    omicron: foe,
    omid: poe,
    ominus: hoe,
    Oopf: goe,
    oopf: moe,
    opar: voe,
    OpenCurlyDoubleQuote: _oe,
    OpenCurlyQuote: boe,
    operp: yoe,
    oplus: woe,
    orarr: koe,
    Or: xoe,
    or: Coe,
    ord: Soe,
    order: Eoe,
    orderof: Aoe,
    ordf: $oe,
    ordm: Moe,
    origof: Ioe,
    oror: Toe,
    orslope: Loe,
    orv: Ooe,
    oS: Roe,
    Oscr: Poe,
    oscr: Boe,
    Oslash: zoe,
    oslash: Doe,
    osol: Noe,
    Otilde: qoe,
    otilde: Foe,
    otimesas: Hoe,
    Otimes: joe,
    otimes: Uoe,
    Ouml: Voe,
    ouml: Zoe,
    ovbar: Woe,
    OverBar: Goe,
    OverBrace: Koe,
    OverBracket: Xoe,
    OverParenthesis: Yoe,
    para: Joe,
    parallel: Qoe,
    par: ese,
    parsim: tse,
    parsl: nse,
    part: rse,
    PartialD: ose,
    Pcy: sse,
    pcy: ise,
    percnt: ase,
    period: cse,
    permil: lse,
    perp: use,
    pertenk: dse,
    Pfr: fse,
    pfr: pse,
    Phi: hse,
    phi: gse,
    phiv: mse,
    phmmat: vse,
    phone: _se,
    Pi: bse,
    pi: yse,
    pitchfork: wse,
    piv: kse,
    planck: xse,
    planckh: Cse,
    plankv: Sse,
    plusacir: Ese,
    plusb: Ase,
    pluscir: $se,
    plus: Mse,
    plusdo: Ise,
    plusdu: Tse,
    pluse: Lse,
    PlusMinus: Ose,
    plusmn: Rse,
    plussim: Pse,
    plustwo: Bse,
    pm: zse,
    Poincareplane: Dse,
    pointint: Nse,
    popf: qse,
    Popf: Fse,
    pound: Hse,
    prap: jse,
    Pr: Use,
    pr: Vse,
    prcue: Zse,
    precapprox: Wse,
    prec: Gse,
    preccurlyeq: Kse,
    Precedes: Xse,
    PrecedesEqual: Yse,
    PrecedesSlantEqual: Jse,
    PrecedesTilde: Qse,
    preceq: eie,
    precnapprox: tie,
    precneqq: nie,
    precnsim: rie,
    pre: oie,
    prE: sie,
    precsim: iie,
    prime: aie,
    Prime: cie,
    primes: lie,
    prnap: uie,
    prnE: die,
    prnsim: fie,
    prod: pie,
    Product: hie,
    profalar: gie,
    profline: mie,
    profsurf: vie,
    prop: _ie,
    Proportional: bie,
    Proportion: yie,
    propto: wie,
    prsim: kie,
    prurel: xie,
    Pscr: Cie,
    pscr: Sie,
    Psi: Eie,
    psi: Aie,
    puncsp: $ie,
    Qfr: Mie,
    qfr: Iie,
    qint: Tie,
    qopf: Lie,
    Qopf: Oie,
    qprime: Rie,
    Qscr: Pie,
    qscr: Bie,
    quaternions: zie,
    quatint: Die,
    quest: Nie,
    questeq: qie,
    quot: Fie,
    QUOT: Hie,
    rAarr: jie,
    race: Uie,
    Racute: Vie,
    racute: Zie,
    radic: Wie,
    raemptyv: Gie,
    rang: Kie,
    Rang: Xie,
    rangd: Yie,
    range: Jie,
    rangle: Qie,
    raquo: eae,
    rarrap: tae,
    rarrb: nae,
    rarrbfs: rae,
    rarrc: oae,
    rarr: sae,
    Rarr: iae,
    rArr: aae,
    rarrfs: cae,
    rarrhk: lae,
    rarrlp: uae,
    rarrpl: dae,
    rarrsim: fae,
    Rarrtl: pae,
    rarrtl: hae,
    rarrw: gae,
    ratail: mae,
    rAtail: vae,
    ratio: _ae,
    rationals: bae,
    rbarr: yae,
    rBarr: wae,
    RBarr: kae,
    rbbrk: xae,
    rbrace: Cae,
    rbrack: Sae,
    rbrke: Eae,
    rbrksld: Aae,
    rbrkslu: $ae,
    Rcaron: Mae,
    rcaron: Iae,
    Rcedil: Tae,
    rcedil: Lae,
    rceil: Oae,
    rcub: Rae,
    Rcy: Pae,
    rcy: Bae,
    rdca: zae,
    rdldhar: Dae,
    rdquo: Nae,
    rdquor: qae,
    rdsh: Fae,
    real: Hae,
    realine: jae,
    realpart: Uae,
    reals: Vae,
    Re: Zae,
    rect: Wae,
    reg: Gae,
    REG: Kae,
    ReverseElement: Xae,
    ReverseEquilibrium: Yae,
    ReverseUpEquilibrium: Jae,
    rfisht: Qae,
    rfloor: ece,
    rfr: tce,
    Rfr: nce,
    rHar: rce,
    rhard: oce,
    rharu: sce,
    rharul: ice,
    Rho: ace,
    rho: cce,
    rhov: lce,
    RightAngleBracket: uce,
    RightArrowBar: dce,
    rightarrow: fce,
    RightArrow: pce,
    Rightarrow: hce,
    RightArrowLeftArrow: gce,
    rightarrowtail: mce,
    RightCeiling: vce,
    RightDoubleBracket: _ce,
    RightDownTeeVector: bce,
    RightDownVectorBar: yce,
    RightDownVector: wce,
    RightFloor: kce,
    rightharpoondown: xce,
    rightharpoonup: Cce,
    rightleftarrows: Sce,
    rightleftharpoons: Ece,
    rightrightarrows: Ace,
    rightsquigarrow: $ce,
    RightTeeArrow: Mce,
    RightTee: Ice,
    RightTeeVector: Tce,
    rightthreetimes: Lce,
    RightTriangleBar: Oce,
    RightTriangle: Rce,
    RightTriangleEqual: Pce,
    RightUpDownVector: Bce,
    RightUpTeeVector: zce,
    RightUpVectorBar: Dce,
    RightUpVector: Nce,
    RightVectorBar: qce,
    RightVector: Fce,
    ring: Hce,
    risingdotseq: jce,
    rlarr: Uce,
    rlhar: Vce,
    rlm: Zce,
    rmoustache: Wce,
    rmoust: Gce,
    rnmid: Kce,
    roang: Xce,
    roarr: Yce,
    robrk: Jce,
    ropar: Qce,
    ropf: ele,
    Ropf: tle,
    roplus: nle,
    rotimes: rle,
    RoundImplies: ole,
    rpar: sle,
    rpargt: ile,
    rppolint: ale,
    rrarr: cle,
    Rrightarrow: lle,
    rsaquo: ule,
    rscr: dle,
    Rscr: fle,
    rsh: ple,
    Rsh: hle,
    rsqb: gle,
    rsquo: mle,
    rsquor: vle,
    rthree: _le,
    rtimes: ble,
    rtri: yle,
    rtrie: wle,
    rtrif: kle,
    rtriltri: xle,
    RuleDelayed: Cle,
    ruluhar: Sle,
    rx: Ele,
    Sacute: Ale,
    sacute: $le,
    sbquo: Mle,
    scap: Ile,
    Scaron: Tle,
    scaron: Lle,
    Sc: Ole,
    sc: Rle,
    sccue: Ple,
    sce: Ble,
    scE: zle,
    Scedil: Dle,
    scedil: Nle,
    Scirc: qle,
    scirc: Fle,
    scnap: Hle,
    scnE: jle,
    scnsim: Ule,
    scpolint: Vle,
    scsim: Zle,
    Scy: Wle,
    scy: Gle,
    sdotb: Kle,
    sdot: Xle,
    sdote: Yle,
    searhk: Jle,
    searr: Qle,
    seArr: eue,
    searrow: tue,
    sect: nue,
    semi: rue,
    seswar: oue,
    setminus: sue,
    setmn: iue,
    sext: aue,
    Sfr: cue,
    sfr: lue,
    sfrown: uue,
    sharp: due,
    SHCHcy: fue,
    shchcy: pue,
    SHcy: hue,
    shcy: gue,
    ShortDownArrow: mue,
    ShortLeftArrow: vue,
    shortmid: _ue,
    shortparallel: bue,
    ShortRightArrow: yue,
    ShortUpArrow: wue,
    shy: kue,
    Sigma: xue,
    sigma: Cue,
    sigmaf: Sue,
    sigmav: Eue,
    sim: Aue,
    simdot: $ue,
    sime: Mue,
    simeq: Iue,
    simg: Tue,
    simgE: Lue,
    siml: Oue,
    simlE: Rue,
    simne: Pue,
    simplus: Bue,
    simrarr: zue,
    slarr: Due,
    SmallCircle: Nue,
    smallsetminus: que,
    smashp: Fue,
    smeparsl: Hue,
    smid: jue,
    smile: Uue,
    smt: Vue,
    smte: Zue,
    smtes: Wue,
    SOFTcy: Gue,
    softcy: Kue,
    solbar: Xue,
    solb: Yue,
    sol: Jue,
    Sopf: Que,
    sopf: ede,
    spades: tde,
    spadesuit: nde,
    spar: rde,
    sqcap: ode,
    sqcaps: sde,
    sqcup: ide,
    sqcups: ade,
    Sqrt: cde,
    sqsub: lde,
    sqsube: ude,
    sqsubset: dde,
    sqsubseteq: fde,
    sqsup: pde,
    sqsupe: hde,
    sqsupset: gde,
    sqsupseteq: mde,
    square: vde,
    Square: _de,
    SquareIntersection: bde,
    SquareSubset: yde,
    SquareSubsetEqual: wde,
    SquareSuperset: kde,
    SquareSupersetEqual: xde,
    SquareUnion: Cde,
    squarf: Sde,
    squ: Ede,
    squf: Ade,
    srarr: $de,
    Sscr: Mde,
    sscr: Ide,
    ssetmn: Tde,
    ssmile: Lde,
    sstarf: Ode,
    Star: Rde,
    star: Pde,
    starf: Bde,
    straightepsilon: zde,
    straightphi: Dde,
    strns: Nde,
    sub: qde,
    Sub: Fde,
    subdot: Hde,
    subE: jde,
    sube: Ude,
    subedot: Vde,
    submult: Zde,
    subnE: Wde,
    subne: Gde,
    subplus: Kde,
    subrarr: Xde,
    subset: Yde,
    Subset: Jde,
    subseteq: Qde,
    subseteqq: efe,
    SubsetEqual: tfe,
    subsetneq: nfe,
    subsetneqq: rfe,
    subsim: ofe,
    subsub: sfe,
    subsup: ife,
    succapprox: afe,
    succ: cfe,
    succcurlyeq: lfe,
    Succeeds: ufe,
    SucceedsEqual: dfe,
    SucceedsSlantEqual: ffe,
    SucceedsTilde: pfe,
    succeq: hfe,
    succnapprox: gfe,
    succneqq: mfe,
    succnsim: vfe,
    succsim: _fe,
    SuchThat: bfe,
    sum: yfe,
    Sum: wfe,
    sung: kfe,
    sup1: xfe,
    sup2: Cfe,
    sup3: Sfe,
    sup: Efe,
    Sup: Afe,
    supdot: $fe,
    supdsub: Mfe,
    supE: Ife,
    supe: Tfe,
    supedot: Lfe,
    Superset: Ofe,
    SupersetEqual: Rfe,
    suphsol: Pfe,
    suphsub: Bfe,
    suplarr: zfe,
    supmult: Dfe,
    supnE: Nfe,
    supne: qfe,
    supplus: Ffe,
    supset: Hfe,
    Supset: jfe,
    supseteq: Ufe,
    supseteqq: Vfe,
    supsetneq: Zfe,
    supsetneqq: Wfe,
    supsim: Gfe,
    supsub: Kfe,
    supsup: Xfe,
    swarhk: Yfe,
    swarr: Jfe,
    swArr: Qfe,
    swarrow: e0e,
    swnwar: t0e,
    szlig: n0e,
    Tab: r0e,
    target: o0e,
    Tau: s0e,
    tau: i0e,
    tbrk: a0e,
    Tcaron: c0e,
    tcaron: l0e,
    Tcedil: u0e,
    tcedil: d0e,
    Tcy: f0e,
    tcy: p0e,
    tdot: h0e,
    telrec: g0e,
    Tfr: m0e,
    tfr: v0e,
    there4: _0e,
    therefore: b0e,
    Therefore: y0e,
    Theta: w0e,
    theta: k0e,
    thetasym: x0e,
    thetav: C0e,
    thickapprox: S0e,
    thicksim: E0e,
    ThickSpace: A0e,
    ThinSpace: $0e,
    thinsp: M0e,
    thkap: I0e,
    thksim: T0e,
    THORN: L0e,
    thorn: O0e,
    tilde: R0e,
    Tilde: P0e,
    TildeEqual: B0e,
    TildeFullEqual: z0e,
    TildeTilde: D0e,
    timesbar: N0e,
    timesb: q0e,
    times: F0e,
    timesd: H0e,
    tint: j0e,
    toea: U0e,
    topbot: V0e,
    topcir: Z0e,
    top: W0e,
    Topf: G0e,
    topf: K0e,
    topfork: X0e,
    tosa: Y0e,
    tprime: J0e,
    trade: Q0e,
    TRADE: epe,
    triangle: tpe,
    triangledown: npe,
    triangleleft: rpe,
    trianglelefteq: ope,
    triangleq: spe,
    triangleright: ipe,
    trianglerighteq: ape,
    tridot: cpe,
    trie: lpe,
    triminus: upe,
    TripleDot: dpe,
    triplus: fpe,
    trisb: ppe,
    tritime: hpe,
    trpezium: gpe,
    Tscr: mpe,
    tscr: vpe,
    TScy: _pe,
    tscy: bpe,
    TSHcy: ype,
    tshcy: wpe,
    Tstrok: kpe,
    tstrok: xpe,
    twixt: Cpe,
    twoheadleftarrow: Spe,
    twoheadrightarrow: Epe,
    Uacute: Ape,
    uacute: $pe,
    uarr: Mpe,
    Uarr: Ipe,
    uArr: Tpe,
    Uarrocir: Lpe,
    Ubrcy: Ope,
    ubrcy: Rpe,
    Ubreve: Ppe,
    ubreve: Bpe,
    Ucirc: zpe,
    ucirc: Dpe,
    Ucy: Npe,
    ucy: qpe,
    udarr: Fpe,
    Udblac: Hpe,
    udblac: jpe,
    udhar: Upe,
    ufisht: Vpe,
    Ufr: Zpe,
    ufr: Wpe,
    Ugrave: Gpe,
    ugrave: Kpe,
    uHar: Xpe,
    uharl: Ype,
    uharr: Jpe,
    uhblk: Qpe,
    ulcorn: ehe,
    ulcorner: the,
    ulcrop: nhe,
    ultri: rhe,
    Umacr: ohe,
    umacr: she,
    uml: ihe,
    UnderBar: ahe,
    UnderBrace: che,
    UnderBracket: lhe,
    UnderParenthesis: uhe,
    Union: dhe,
    UnionPlus: fhe,
    Uogon: phe,
    uogon: hhe,
    Uopf: ghe,
    uopf: mhe,
    UpArrowBar: vhe,
    uparrow: _he,
    UpArrow: bhe,
    Uparrow: yhe,
    UpArrowDownArrow: whe,
    updownarrow: khe,
    UpDownArrow: xhe,
    Updownarrow: Che,
    UpEquilibrium: She,
    upharpoonleft: Ehe,
    upharpoonright: Ahe,
    uplus: $he,
    UpperLeftArrow: Mhe,
    UpperRightArrow: Ihe,
    upsi: The,
    Upsi: Lhe,
    upsih: Ohe,
    Upsilon: Rhe,
    upsilon: Phe,
    UpTeeArrow: Bhe,
    UpTee: zhe,
    upuparrows: Dhe,
    urcorn: Nhe,
    urcorner: qhe,
    urcrop: Fhe,
    Uring: Hhe,
    uring: jhe,
    urtri: Uhe,
    Uscr: Vhe,
    uscr: Zhe,
    utdot: Whe,
    Utilde: Ghe,
    utilde: Khe,
    utri: Xhe,
    utrif: Yhe,
    uuarr: Jhe,
    Uuml: Qhe,
    uuml: e2e,
    uwangle: t2e,
    vangrt: n2e,
    varepsilon: r2e,
    varkappa: o2e,
    varnothing: s2e,
    varphi: i2e,
    varpi: a2e,
    varpropto: c2e,
    varr: l2e,
    vArr: u2e,
    varrho: d2e,
    varsigma: f2e,
    varsubsetneq: p2e,
    varsubsetneqq: h2e,
    varsupsetneq: g2e,
    varsupsetneqq: m2e,
    vartheta: v2e,
    vartriangleleft: _2e,
    vartriangleright: b2e,
    vBar: y2e,
    Vbar: w2e,
    vBarv: k2e,
    Vcy: x2e,
    vcy: C2e,
    vdash: S2e,
    vDash: E2e,
    Vdash: A2e,
    VDash: $2e,
    Vdashl: M2e,
    veebar: I2e,
    vee: T2e,
    Vee: L2e,
    veeeq: O2e,
    vellip: R2e,
    verbar: P2e,
    Verbar: B2e,
    vert: z2e,
    Vert: D2e,
    VerticalBar: N2e,
    VerticalLine: q2e,
    VerticalSeparator: F2e,
    VerticalTilde: H2e,
    VeryThinSpace: j2e,
    Vfr: U2e,
    vfr: V2e,
    vltri: Z2e,
    vnsub: W2e,
    vnsup: G2e,
    Vopf: K2e,
    vopf: X2e,
    vprop: Y2e,
    vrtri: J2e,
    Vscr: Q2e,
    vscr: e1e,
    vsubnE: t1e,
    vsubne: n1e,
    vsupnE: r1e,
    vsupne: o1e,
    Vvdash: s1e,
    vzigzag: i1e,
    Wcirc: a1e,
    wcirc: c1e,
    wedbar: l1e,
    wedge: u1e,
    Wedge: d1e,
    wedgeq: f1e,
    weierp: p1e,
    Wfr: h1e,
    wfr: g1e,
    Wopf: m1e,
    wopf: v1e,
    wp: _1e,
    wr: b1e,
    wreath: y1e,
    Wscr: w1e,
    wscr: k1e,
    xcap: x1e,
    xcirc: C1e,
    xcup: S1e,
    xdtri: E1e,
    Xfr: A1e,
    xfr: $1e,
    xharr: M1e,
    xhArr: I1e,
    Xi: T1e,
    xi: L1e,
    xlarr: O1e,
    xlArr: R1e,
    xmap: P1e,
    xnis: B1e,
    xodot: z1e,
    Xopf: D1e,
    xopf: N1e,
    xoplus: q1e,
    xotime: F1e,
    xrarr: H1e,
    xrArr: j1e,
    Xscr: U1e,
    xscr: V1e,
    xsqcup: Z1e,
    xuplus: W1e,
    xutri: G1e,
    xvee: K1e,
    xwedge: X1e,
    Yacute: Y1e,
    yacute: J1e,
    YAcy: Q1e,
    yacy: ege,
    Ycirc: tge,
    ycirc: nge,
    Ycy: rge,
    ycy: oge,
    yen: sge,
    Yfr: ige,
    yfr: age,
    YIcy: cge,
    yicy: lge,
    Yopf: uge,
    yopf: dge,
    Yscr: fge,
    yscr: pge,
    YUcy: hge,
    yucy: gge,
    yuml: mge,
    Yuml: vge,
    Zacute: _ge,
    zacute: bge,
    Zcaron: yge,
    zcaron: wge,
    Zcy: kge,
    zcy: xge,
    Zdot: Cge,
    zdot: Sge,
    zeetrf: Ege,
    ZeroWidthSpace: Age,
    Zeta: $ge,
    zeta: Mge,
    zfr: Ige,
    Zfr: Tge,
    ZHcy: Lge,
    zhcy: Oge,
    zigrarr: Rge,
    zopf: Pge,
    Zopf: Bge,
    Zscr: zge,
    zscr: Dge,
    zwj: Nge,
    zwnj: qge
};
var Js, Od;
function am() {
    return Od || (Od = 1, Js = Fge), Js;
}
var Qs, Rd;
function El() {
    return Rd || (Rd = 1, Qs = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/), Qs;
}
var lr = {}, ei, Pd;
function Hge() {
    if (Pd) return ei;
    Pd = 1;
    var e = {};
    function t(r) {
        var s, o, i = e[r];
        if (i) return i;
        for(i = e[r] = [], s = 0; s < 128; s++)o = String.fromCharCode(s), /^[0-9a-z]$/i.test(o) ? i.push(o) : i.push("%" + ("0" + s.toString(16).toUpperCase()).slice(-2));
        for(s = 0; s < r.length; s++)i[r.charCodeAt(s)] = r[s];
        return i;
    }
    function n(r, s, o) {
        var i, a, c, u, d, l = "";
        for(typeof s != "string" && (o = s, s = n.defaultChars), (typeof o === "undefined" ? "undefined" : (0, $6gBIz._)(o)) > "u" && (o = !0), d = t(s), i = 0, a = r.length; i < a; i++){
            if (c = r.charCodeAt(i), o && c === 37 && i + 2 < a && /^[0-9a-f]{2}$/i.test(r.slice(i + 1, i + 3))) {
                l += r.slice(i, i + 3), i += 2;
                continue;
            }
            if (c < 128) {
                l += d[c];
                continue;
            }
            if (c >= 55296 && c <= 57343) {
                if (c >= 55296 && c <= 56319 && i + 1 < a && (u = r.charCodeAt(i + 1), u >= 56320 && u <= 57343)) {
                    l += encodeURIComponent(r[i] + r[i + 1]), i++;
                    continue;
                }
                l += "%EF%BF%BD";
                continue;
            }
            l += encodeURIComponent(r[i]);
        }
        return l;
    }
    return n.defaultChars = ";/?:@&=+$,-_.!~*'()#", n.componentChars = "-_.!~*'()", ei = n, ei;
}
var ti, Bd;
function jge() {
    if (Bd) return ti;
    Bd = 1;
    var e = {};
    function t(r) {
        var s, o, i = e[r];
        if (i) return i;
        for(i = e[r] = [], s = 0; s < 128; s++)o = String.fromCharCode(s), i.push(o);
        for(s = 0; s < r.length; s++)o = r.charCodeAt(s), i[o] = "%" + ("0" + o.toString(16).toUpperCase()).slice(-2);
        return i;
    }
    function n(r, s) {
        var o;
        return typeof s != "string" && (s = n.defaultChars), o = t(s), r.replace(/(%[a-f0-9]{2})+/gi, function(i) {
            var a, c, u, d, l, m, f, v = "";
            for(a = 0, c = i.length; a < c; a += 3){
                if (u = parseInt(i.slice(a + 1, a + 3), 16), u < 128) {
                    v += o[u];
                    continue;
                }
                if ((u & 224) === 192 && a + 3 < c && (d = parseInt(i.slice(a + 4, a + 6), 16), (d & 192) === 128)) {
                    f = u << 6 & 1984 | d & 63, f < 128 ? v += "\uFFFD\uFFFD" : v += String.fromCharCode(f), a += 3;
                    continue;
                }
                if ((u & 240) === 224 && a + 6 < c && (d = parseInt(i.slice(a + 4, a + 6), 16), l = parseInt(i.slice(a + 7, a + 9), 16), (d & 192) === 128 && (l & 192) === 128)) {
                    f = u << 12 & 61440 | d << 6 & 4032 | l & 63, f < 2048 || f >= 55296 && f <= 57343 ? v += "\uFFFD\uFFFD\uFFFD" : v += String.fromCharCode(f), a += 6;
                    continue;
                }
                if ((u & 248) === 240 && a + 9 < c && (d = parseInt(i.slice(a + 4, a + 6), 16), l = parseInt(i.slice(a + 7, a + 9), 16), m = parseInt(i.slice(a + 10, a + 12), 16), (d & 192) === 128 && (l & 192) === 128 && (m & 192) === 128)) {
                    f = u << 18 & 1835008 | d << 12 & 258048 | l << 6 & 4032 | m & 63, f < 65536 || f > 1114111 ? v += "\uFFFD\uFFFD\uFFFD\uFFFD" : (f -= 65536, v += String.fromCharCode(55296 + (f >> 10), 56320 + (f & 1023))), a += 9;
                    continue;
                }
                v += "\uFFFD";
            }
            return v;
        });
    }
    return n.defaultChars = ";/?:@&=+$,#", n.componentChars = "", ti = n, ti;
}
var ni, zd;
function Uge() {
    return zd || (zd = 1, ni = function ni(t) {
        var n = "";
        return n += t.protocol || "", n += t.slashes ? "//" : "", n += t.auth ? t.auth + "@" : "", t.hostname && t.hostname.indexOf(":") !== -1 ? n += "[" + t.hostname + "]" : n += t.hostname || "", n += t.port ? ":" + t.port : "", n += t.pathname || "", n += t.search || "", n += t.hash || "", n;
    }), ni;
}
var ri, Dd;
function Vge() {
    if (Dd) return ri;
    Dd = 1;
    function e() {
        this.protocol = null, this.slashes = null, this.auth = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.pathname = null;
    }
    var t = /^([a-z0-9.+-]+:)/i, n = /:[0-9]*$/, r = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, s = [
        "<",
        ">",
        '"',
        "`",
        " ",
        "\r",
        "\n",
        "	"
    ], o = [
        "{",
        "}",
        "|",
        "\\",
        "^",
        "`"
    ].concat(s), i = [
        "'"
    ].concat(o), a = [
        "%",
        "/",
        "?",
        ";",
        "#"
    ].concat(i), c = [
        "/",
        "?",
        "#"
    ], u = 255, d = /^[+a-z0-9A-Z_-]{0,63}$/, l = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, m = {
        javascript: !0,
        "javascript:": !0
    }, f = {
        http: !0,
        https: !0,
        ftp: !0,
        gopher: !0,
        file: !0,
        "http:": !0,
        "https:": !0,
        "ftp:": !0,
        "gopher:": !0,
        "file:": !0
    };
    function v(g, b) {
        if (g && g instanceof e) return g;
        var h = new e();
        return h.parse(g, b), h;
    }
    return e.prototype.parse = function(g, b) {
        var h, w, k, x, A, S = g;
        if (S = S.trim(), !b && g.split("#").length === 1) {
            var $ = r.exec(S);
            if ($) return this.pathname = $[1], $[2] && (this.search = $[2]), this;
        }
        var M = t.exec(S);
        if (M && (M = M[0], k = M.toLowerCase(), this.protocol = M, S = S.substr(M.length)), (b || M || S.match(/^\/\/[^@\/]+@[^@\/]+/)) && (A = S.substr(0, 2) === "//", A && !(M && m[M]) && (S = S.substr(2), this.slashes = !0)), !m[M] && (A || M && !f[M])) {
            var P = -1;
            for(h = 0; h < c.length; h++)x = S.indexOf(c[h]), x !== -1 && (P === -1 || x < P) && (P = x);
            var R, B;
            for(P === -1 ? B = S.lastIndexOf("@") : B = S.lastIndexOf("@", P), B !== -1 && (R = S.slice(0, B), S = S.slice(B + 1), this.auth = R), P = -1, h = 0; h < a.length; h++)x = S.indexOf(a[h]), x !== -1 && (P === -1 || x < P) && (P = x);
            P === -1 && (P = S.length), S[P - 1] === ":" && P--;
            var H = S.slice(0, P);
            S = S.slice(P), this.parseHost(H), this.hostname = this.hostname || "";
            var ie = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
            if (!ie) {
                var z = this.hostname.split(/\./);
                for(h = 0, w = z.length; h < w; h++){
                    var Q = z[h];
                    if (Q && !Q.match(d)) {
                        for(var N = "", j = 0, U = Q.length; j < U; j++)Q.charCodeAt(j) > 127 ? N += "x" : N += Q[j];
                        if (!N.match(d)) {
                            var G = z.slice(0, h), T = z.slice(h + 1), W = Q.match(l);
                            W && (G.push(W[1]), T.unshift(W[2])), T.length && (S = T.join(".") + S), this.hostname = G.join(".");
                            break;
                        }
                    }
                }
            }
            this.hostname.length > u && (this.hostname = ""), ie && (this.hostname = this.hostname.substr(1, this.hostname.length - 2));
        }
        var V = S.indexOf("#");
        V !== -1 && (this.hash = S.substr(V), S = S.slice(0, V));
        var se = S.indexOf("?");
        return se !== -1 && (this.search = S.substr(se), S = S.slice(0, se)), S && (this.pathname = S), f[k] && this.hostname && !this.pathname && (this.pathname = ""), this;
    }, e.prototype.parseHost = function(g) {
        var b = n.exec(g);
        b && (b = b[0], b !== ":" && (this.port = b.substr(1)), g = g.substr(0, g.length - b.length)), g && (this.hostname = g);
    }, ri = v, ri;
}
var Nd;
function cm() {
    return Nd || (Nd = 1, lr.encode = Hge(), lr.decode = jge(), lr.format = Uge(), lr.parse = Vge()), lr;
}
var Wn = {}, oi, qd;
function lm() {
    return qd || (qd = 1, oi = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/), oi;
}
var si, Fd;
function um() {
    return Fd || (Fd = 1, si = /[\0-\x1F\x7F-\x9F]/), si;
}
var ii, Hd;
function Zge() {
    return Hd || (Hd = 1, ii = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/), ii;
}
var ai, jd;
function dm() {
    return jd || (jd = 1, ai = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/), ai;
}
var Ud;
function Wge() {
    return Ud || (Ud = 1, Wn.Any = lm(), Wn.Cc = um(), Wn.Cf = Zge(), Wn.P = El(), Wn.Z = dm()), Wn;
}
var Vd;
function Pe() {
    return Vd || (Vd = 1, function(e) {
        function t(z) {
            return Object.prototype.toString.call(z);
        }
        function n(z) {
            return t(z) === "[object String]";
        }
        var r = Object.prototype.hasOwnProperty;
        function s(z, Q) {
            return r.call(z, Q);
        }
        function o(z) {
            var Q = Array.prototype.slice.call(arguments, 1);
            return Q.forEach(function(N) {
                if (N) {
                    if ((typeof N === "undefined" ? "undefined" : (0, $6gBIz._)(N)) != "object") throw new TypeError(N + "must be object");
                    Object.keys(N).forEach(function(j) {
                        z[j] = N[j];
                    });
                }
            }), z;
        }
        function i(z, Q, N) {
            return [].concat(z.slice(0, Q), N, z.slice(Q + 1));
        }
        function a(z) {
            return !(z >= 55296 && z <= 57343 || z >= 64976 && z <= 65007 || (z & 65535) === 65535 || (z & 65535) === 65534 || z >= 0 && z <= 8 || z === 11 || z >= 14 && z <= 31 || z >= 127 && z <= 159 || z > 1114111);
        }
        function c(z) {
            if (z > 65535) {
                z -= 65536;
                var Q = 55296 + (z >> 10), N = 56320 + (z & 1023);
                return String.fromCharCode(Q, N);
            }
            return String.fromCharCode(z);
        }
        var u = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g, d = /&([a-z#][a-z0-9]{1,31});/gi, l = new RegExp(u.source + "|" + d.source, "gi"), m = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i, f = am();
        function v(z, Q) {
            var N;
            return s(f, Q) ? f[Q] : Q.charCodeAt(0) === 35 && m.test(Q) && (N = Q[1].toLowerCase() === "x" ? parseInt(Q.slice(2), 16) : parseInt(Q.slice(1), 10), a(N)) ? c(N) : z;
        }
        function g(z) {
            return z.indexOf("\\") < 0 ? z : z.replace(u, "$1");
        }
        function b(z) {
            return z.indexOf("\\") < 0 && z.indexOf("&") < 0 ? z : z.replace(l, function(Q, N, j) {
                return N || v(Q, j);
            });
        }
        var h = /[&<>"]/, w = /[&<>"]/g, k = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;"
        };
        function x(z) {
            return k[z];
        }
        function A(z) {
            return h.test(z) ? z.replace(w, x) : z;
        }
        var S = /[.?*+^$[\]\\(){}|-]/g;
        function $(z) {
            return z.replace(S, "\\$&");
        }
        function M(z) {
            switch(z){
                case 9:
                case 32:
                    return !0;
            }
            return !1;
        }
        function P(z) {
            if (z >= 8192 && z <= 8202) return !0;
            switch(z){
                case 9:
                // \t
                case 10:
                // \n
                case 11:
                // \v
                case 12:
                // \f
                case 13:
                // \r
                case 32:
                case 160:
                case 5760:
                case 8239:
                case 8287:
                case 12288:
                    return !0;
            }
            return !1;
        }
        var R = El();
        function B(z) {
            return R.test(z);
        }
        function H(z) {
            switch(z){
                case 33:
                case 34:
                case 35:
                case 36:
                case 37:
                case 38:
                case 39:
                case 40:
                case 41:
                case 42:
                case 43:
                case 44:
                case 45:
                case 46:
                case 47:
                case 58:
                case 59:
                case 60:
                case 61:
                case 62:
                case 63:
                case 64:
                case 91:
                case 92:
                case 93:
                case 94:
                case 95:
                case 96:
                case 123:
                case 124:
                case 125:
                case 126:
                    return !0;
                default:
                    return !1;
            }
        }
        function ie(z) {
            return z = z.trim().replace(/\s+/g, " "), "\u1E9E".toLowerCase() === "\u1E7E" && (z = z.replace(/ẞ/g, "\xdf")), z.toLowerCase().toUpperCase();
        }
        e.lib = {}, e.lib.mdurl = cm(), e.lib.ucmicro = Wge(), e.assign = o, e.isString = n, e.has = s, e.unescapeMd = g, e.unescapeAll = b, e.isValidEntityCode = a, e.fromCodePoint = c, e.escapeHtml = A, e.arrayReplaceAt = i, e.isSpace = M, e.isWhiteSpace = P, e.isMdAsciiPunct = H, e.isPunctChar = B, e.escapeRE = $, e.normalizeReference = ie;
    }(Ys)), Ys;
}
var qr = {}, ci, Zd;
function Gge() {
    return Zd || (Zd = 1, ci = function ci(t, n, r) {
        var s, o, i, a, c = -1, u = t.posMax, d = t.pos;
        for(t.pos = n + 1, s = 1; t.pos < u;){
            if (i = t.src.charCodeAt(t.pos), i === 93 && (s--, s === 0)) {
                o = !0;
                break;
            }
            if (a = t.pos, t.md.inline.skipToken(t), i === 91) {
                if (a === t.pos - 1) s++;
                else if (r) return t.pos = d, -1;
            }
        }
        return o && (c = t.pos), t.pos = d, c;
    }), ci;
}
var li, Wd;
function Kge() {
    if (Wd) return li;
    Wd = 1;
    var e = Pe().unescapeAll;
    return li = function li(n, r, s) {
        var o, i, a = r, c = {
            ok: !1,
            pos: 0,
            lines: 0,
            str: ""
        };
        if (n.charCodeAt(a) === 60) {
            for(a++; a < s;){
                if (o = n.charCodeAt(a), o === 10 || o === 60) return c;
                if (o === 62) return c.pos = a + 1, c.str = e(n.slice(r + 1, a)), c.ok = !0, c;
                if (o === 92 && a + 1 < s) {
                    a += 2;
                    continue;
                }
                a++;
            }
            return c;
        }
        for(i = 0; a < s && (o = n.charCodeAt(a), !(o === 32 || o < 32 || o === 127));){
            if (o === 92 && a + 1 < s) {
                if (n.charCodeAt(a + 1) === 32) break;
                a += 2;
                continue;
            }
            if (o === 40 && (i++, i > 32)) return c;
            if (o === 41) {
                if (i === 0) break;
                i--;
            }
            a++;
        }
        return r === a || i !== 0 || (c.str = e(n.slice(r, a)), c.pos = a, c.ok = !0), c;
    }, li;
}
var ui, Gd;
function Xge() {
    if (Gd) return ui;
    Gd = 1;
    var e = Pe().unescapeAll;
    return ui = function ui(n, r, s) {
        var o, i, a = 0, c = r, u = {
            ok: !1,
            pos: 0,
            lines: 0,
            str: ""
        };
        if (c >= s || (i = n.charCodeAt(c), i !== 34 && i !== 39 && i !== 40)) return u;
        for(c++, i === 40 && (i = 41); c < s;){
            if (o = n.charCodeAt(c), o === i) return u.pos = c + 1, u.lines = a, u.str = e(n.slice(r + 1, c)), u.ok = !0, u;
            if (o === 40 && i === 41) return u;
            o === 10 ? a++ : o === 92 && c + 1 < s && (c++, n.charCodeAt(c) === 10 && a++), c++;
        }
        return u;
    }, ui;
}
var Kd;
function Yge() {
    return Kd || (Kd = 1, qr.parseLinkLabel = Gge(), qr.parseLinkDestination = Kge(), qr.parseLinkTitle = Xge()), qr;
}
var di, Xd;
function Jge() {
    if (Xd) return di;
    Xd = 1;
    var e = Pe().assign, t = Pe().unescapeAll, n = Pe().escapeHtml, r = {};
    r.code_inline = function(o, i, a, c, u) {
        var d = o[i];
        return "<code" + u.renderAttrs(d) + ">" + n(d.content) + "</code>";
    }, r.code_block = function(o, i, a, c, u) {
        var d = o[i];
        return "<pre" + u.renderAttrs(d) + "><code>" + n(o[i].content) + "</code></pre>\n";
    }, r.fence = function(o, i, a, c, u) {
        var d = o[i], l = d.info ? t(d.info).trim() : "", m = "", f = "", v, g, b, h, w;
        return l && (b = l.split(/(\s+)/g), m = b[0], f = b.slice(2).join("")), a.highlight ? v = a.highlight(d.content, m, f) || n(d.content) : v = n(d.content), v.indexOf("<pre") === 0 ? v + "\n" : l ? (g = d.attrIndex("class"), h = d.attrs ? d.attrs.slice() : [], g < 0 ? h.push([
            "class",
            a.langPrefix + m
        ]) : (h[g] = h[g].slice(), h[g][1] += " " + a.langPrefix + m), w = {
            attrs: h
        }, "<pre><code" + u.renderAttrs(w) + ">" + v + "</code></pre>\n") : "<pre><code" + u.renderAttrs(d) + ">" + v + "</code></pre>\n";
    }, r.image = function(o, i, a, c, u) {
        var d = o[i];
        return d.attrs[d.attrIndex("alt")][1] = u.renderInlineAsText(d.children, a, c), u.renderToken(o, i, a);
    }, r.hardbreak = function(o, i, a) {
        return a.xhtmlOut ? "<br />\n" : "<br>\n";
    }, r.softbreak = function(o, i, a) {
        return a.breaks ? a.xhtmlOut ? "<br />\n" : "<br>\n" : "\n";
    }, r.text = function(o, i) {
        return n(o[i].content);
    }, r.html_block = function(o, i) {
        return o[i].content;
    }, r.html_inline = function(o, i) {
        return o[i].content;
    };
    function s() {
        this.rules = e({}, r);
    }
    return s.prototype.renderAttrs = function(i) {
        var a, c, u;
        if (!i.attrs) return "";
        for(u = "", a = 0, c = i.attrs.length; a < c; a++)u += " " + n(i.attrs[a][0]) + '="' + n(i.attrs[a][1]) + '"';
        return u;
    }, s.prototype.renderToken = function(i, a, c) {
        var u, d = "", l = !1, m = i[a];
        return m.hidden ? "" : (m.block && m.nesting !== -1 && a && i[a - 1].hidden && (d += "\n"), d += (m.nesting === -1 ? "</" : "<") + m.tag, d += this.renderAttrs(m), m.nesting === 0 && c.xhtmlOut && (d += " /"), m.block && (l = !0, m.nesting === 1 && a + 1 < i.length && (u = i[a + 1], (u.type === "inline" || u.hidden || u.nesting === -1 && u.tag === m.tag) && (l = !1))), d += l ? ">\n" : ">", d);
    }, s.prototype.renderInline = function(o, i, a) {
        for(var c, u = "", d = this.rules, l = 0, m = o.length; l < m; l++)c = o[l].type, (0, $6gBIz._)(d[c]) < "u" ? u += d[c](o, l, i, a, this) : u += this.renderToken(o, l, i);
        return u;
    }, s.prototype.renderInlineAsText = function(o, i, a) {
        for(var c = "", u = 0, d = o.length; u < d; u++)o[u].type === "text" ? c += o[u].content : o[u].type === "image" ? c += this.renderInlineAsText(o[u].children, i, a) : o[u].type === "softbreak" && (c += "\n");
        return c;
    }, s.prototype.render = function(o, i, a) {
        var c, u, d, l = "", m = this.rules;
        for(c = 0, u = o.length; c < u; c++)d = o[c].type, d === "inline" ? l += this.renderInline(o[c].children, i, a) : (0, $6gBIz._)(m[d]) < "u" ? l += m[d](o, c, i, a, this) : l += this.renderToken(o, c, i, a);
        return l;
    }, di = s, di;
}
var fi, Yd;
function Al() {
    if (Yd) return fi;
    Yd = 1;
    function e() {
        this.__rules__ = [], this.__cache__ = null;
    }
    return e.prototype.__find__ = function(t) {
        for(var n = 0; n < this.__rules__.length; n++)if (this.__rules__[n].name === t) return n;
        return -1;
    }, e.prototype.__compile__ = function() {
        var t = this, n = [
            ""
        ];
        t.__rules__.forEach(function(r) {
            r.enabled && r.alt.forEach(function(s) {
                n.indexOf(s) < 0 && n.push(s);
            });
        }), t.__cache__ = {}, n.forEach(function(r) {
            t.__cache__[r] = [], t.__rules__.forEach(function(s) {
                s.enabled && (r && s.alt.indexOf(r) < 0 || t.__cache__[r].push(s.fn));
            });
        });
    }, e.prototype.at = function(t, n, r) {
        var s = this.__find__(t), o = r || {};
        if (s === -1) throw new Error("Parser rule not found: " + t);
        this.__rules__[s].fn = n, this.__rules__[s].alt = o.alt || [], this.__cache__ = null;
    }, e.prototype.before = function(t, n, r, s) {
        var o = this.__find__(t), i = s || {};
        if (o === -1) throw new Error("Parser rule not found: " + t);
        this.__rules__.splice(o, 0, {
            name: n,
            enabled: !0,
            fn: r,
            alt: i.alt || []
        }), this.__cache__ = null;
    }, e.prototype.after = function(t, n, r, s) {
        var o = this.__find__(t), i = s || {};
        if (o === -1) throw new Error("Parser rule not found: " + t);
        this.__rules__.splice(o + 1, 0, {
            name: n,
            enabled: !0,
            fn: r,
            alt: i.alt || []
        }), this.__cache__ = null;
    }, e.prototype.push = function(t, n, r) {
        var s = r || {};
        this.__rules__.push({
            name: t,
            enabled: !0,
            fn: n,
            alt: s.alt || []
        }), this.__cache__ = null;
    }, e.prototype.enable = function(t, n) {
        Array.isArray(t) || (t = [
            t
        ]);
        var r = [];
        return t.forEach(function(s) {
            var o = this.__find__(s);
            if (o < 0) {
                if (n) return;
                throw new Error("Rules manager: invalid rule name " + s);
            }
            this.__rules__[o].enabled = !0, r.push(s);
        }, this), this.__cache__ = null, r;
    }, e.prototype.enableOnly = function(t, n) {
        Array.isArray(t) || (t = [
            t
        ]), this.__rules__.forEach(function(r) {
            r.enabled = !1;
        }), this.enable(t, n);
    }, e.prototype.disable = function(t, n) {
        Array.isArray(t) || (t = [
            t
        ]);
        var r = [];
        return t.forEach(function(s) {
            var o = this.__find__(s);
            if (o < 0) {
                if (n) return;
                throw new Error("Rules manager: invalid rule name " + s);
            }
            this.__rules__[o].enabled = !1, r.push(s);
        }, this), this.__cache__ = null, r;
    }, e.prototype.getRules = function(t) {
        return this.__cache__ === null && this.__compile__(), this.__cache__[t] || [];
    }, fi = e, fi;
}
var pi, Jd;
function Qge() {
    if (Jd) return pi;
    Jd = 1;
    var e = /\r\n?|\n/g, t = /\0/g;
    return pi = function pi(r) {
        var s;
        s = r.src.replace(e, "\n"), s = s.replace(t, "\uFFFD"), r.src = s;
    }, pi;
}
var hi, Qd;
function eme() {
    return Qd || (Qd = 1, hi = function hi(t) {
        var n;
        t.inlineMode ? (n = new t.Token("inline", "", 0), n.content = t.src, n.map = [
            0,
            1
        ], n.children = [], t.tokens.push(n)) : t.md.block.parse(t.src, t.md, t.env, t.tokens);
    }), hi;
}
var gi, ef;
function tme() {
    return ef || (ef = 1, gi = function gi(t) {
        var n = t.tokens, r, s, o;
        for(s = 0, o = n.length; s < o; s++)r = n[s], r.type === "inline" && t.md.inline.parse(r.content, t.md, t.env, r.children);
    }), gi;
}
var mi, tf;
function nme() {
    if (tf) return mi;
    tf = 1;
    var e = Pe().arrayReplaceAt;
    function t(r) {
        return /^<a[>\s]/i.test(r);
    }
    function n(r) {
        return /^<\/a\s*>/i.test(r);
    }
    return mi = function mi(s) {
        var o, i, a, c, u, d, l, m, f, v, g, b, h, w, k, x, A = s.tokens, S;
        if (s.md.options.linkify) {
            for(i = 0, a = A.length; i < a; i++)if (!(A[i].type !== "inline" || !s.md.linkify.pretest(A[i].content))) for(c = A[i].children, h = 0, o = c.length - 1; o >= 0; o--){
                if (d = c[o], d.type === "link_close") {
                    for(o--; c[o].level !== d.level && c[o].type !== "link_open";)o--;
                    continue;
                }
                if (d.type === "html_inline" && (t(d.content) && h > 0 && h--, n(d.content) && h++), !(h > 0) && d.type === "text" && s.md.linkify.test(d.content)) {
                    for(f = d.content, S = s.md.linkify.match(f), l = [], b = d.level, g = 0, S.length > 0 && S[0].index === 0 && o > 0 && c[o - 1].type === "text_special" && (S = S.slice(1)), m = 0; m < S.length; m++)w = S[m].url, k = s.md.normalizeLink(w), s.md.validateLink(k) && (x = S[m].text, S[m].schema ? S[m].schema === "mailto:" && !/^mailto:/i.test(x) ? x = s.md.normalizeLinkText("mailto:" + x).replace(/^mailto:/, "") : x = s.md.normalizeLinkText(x) : x = s.md.normalizeLinkText("http://" + x).replace(/^http:\/\//, ""), v = S[m].index, v > g && (u = new s.Token("text", "", 0), u.content = f.slice(g, v), u.level = b, l.push(u)), u = new s.Token("link_open", "a", 1), u.attrs = [
                        [
                            "href",
                            k
                        ]
                    ], u.level = b++, u.markup = "linkify", u.info = "auto", l.push(u), u = new s.Token("text", "", 0), u.content = x, u.level = b, l.push(u), u = new s.Token("link_close", "a", -1), u.level = --b, u.markup = "linkify", u.info = "auto", l.push(u), g = S[m].lastIndex);
                    g < f.length && (u = new s.Token("text", "", 0), u.content = f.slice(g), u.level = b, l.push(u)), A[i].children = c = e(c, o, l);
                }
            }
        }
    }, mi;
}
var vi, nf;
function rme() {
    if (nf) return vi;
    nf = 1;
    var e = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/, t = /\((c|tm|r)\)/i, n = /\((c|tm|r)\)/ig, r = {
        c: "\xa9",
        r: "\xae",
        tm: "\u2122"
    };
    function s(a, c) {
        return r[c.toLowerCase()];
    }
    function o(a) {
        var c, u, d = 0;
        for(c = a.length - 1; c >= 0; c--)u = a[c], u.type === "text" && !d && (u.content = u.content.replace(n, s)), u.type === "link_open" && u.info === "auto" && d--, u.type === "link_close" && u.info === "auto" && d++;
    }
    function i(a) {
        var c, u, d = 0;
        for(c = a.length - 1; c >= 0; c--)u = a[c], u.type === "text" && !d && e.test(u.content) && (u.content = u.content.replace(/\+-/g, "\xb1").replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",").replace(/(^|[^-])---(?=[^-]|$)/mg, "$1\u2014").replace(/(^|\s)--(?=\s|$)/mg, "$1\u2013").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1\u2013")), u.type === "link_open" && u.info === "auto" && d--, u.type === "link_close" && u.info === "auto" && d++;
    }
    return vi = function vi(c) {
        var u;
        if (c.md.options.typographer) for(u = c.tokens.length - 1; u >= 0; u--)c.tokens[u].type === "inline" && (t.test(c.tokens[u].content) && o(c.tokens[u].children), e.test(c.tokens[u].content) && i(c.tokens[u].children));
    }, vi;
}
var _i, rf;
function ome() {
    if (rf) return _i;
    rf = 1;
    var e = Pe().isWhiteSpace, t = Pe().isPunctChar, n = Pe().isMdAsciiPunct, r = /['"]/, s = /['"]/g, o = "\u2019";
    function i(c, u, d) {
        return c.slice(0, u) + d + c.slice(u + 1);
    }
    function a(c, u) {
        var d, l, m, f, v, g, b, h, w, k, x, A, S, $, M, P, R, B, H, ie, z;
        for(H = [], d = 0; d < c.length; d++){
            for(l = c[d], b = c[d].level, R = H.length - 1; R >= 0 && !(H[R].level <= b); R--);
            if (H.length = R + 1, l.type === "text") {
                m = l.content, v = 0, g = m.length;
                e: for(; v < g && (s.lastIndex = v, f = s.exec(m), !!f);){
                    if (M = P = !0, v = f.index + 1, B = f[0] === "'", w = 32, f.index - 1 >= 0) w = m.charCodeAt(f.index - 1);
                    else for(R = d - 1; R >= 0 && !(c[R].type === "softbreak" || c[R].type === "hardbreak"); R--)if (c[R].content) {
                        w = c[R].content.charCodeAt(c[R].content.length - 1);
                        break;
                    }
                    if (k = 32, v < g) k = m.charCodeAt(v);
                    else for(R = d + 1; R < c.length && !(c[R].type === "softbreak" || c[R].type === "hardbreak"); R++)if (c[R].content) {
                        k = c[R].content.charCodeAt(0);
                        break;
                    }
                    if (x = n(w) || t(String.fromCharCode(w)), A = n(k) || t(String.fromCharCode(k)), S = e(w), $ = e(k), $ ? M = !1 : A && (S || x || (M = !1)), S ? P = !1 : x && ($ || A || (P = !1)), k === 34 && f[0] === '"' && w >= 48 && w <= 57 && (P = M = !1), M && P && (M = x, P = A), !M && !P) {
                        B && (l.content = i(l.content, f.index, o));
                        continue;
                    }
                    if (P) {
                        for(R = H.length - 1; R >= 0 && (h = H[R], !(H[R].level < b)); R--)if (h.single === B && H[R].level === b) {
                            h = H[R], B ? (ie = u.md.options.quotes[2], z = u.md.options.quotes[3]) : (ie = u.md.options.quotes[0], z = u.md.options.quotes[1]), l.content = i(l.content, f.index, z), c[h.token].content = i(c[h.token].content, h.pos, ie), v += z.length - 1, h.token === d && (v += ie.length - 1), m = l.content, g = m.length, H.length = R;
                            continue e;
                        }
                    }
                    M ? H.push({
                        token: d,
                        pos: f.index,
                        single: B,
                        level: b
                    }) : P && B && (l.content = i(l.content, f.index, o));
                }
            }
        }
    }
    return _i = function _i(u) {
        var d;
        if (u.md.options.typographer) for(d = u.tokens.length - 1; d >= 0; d--)u.tokens[d].type !== "inline" || !r.test(u.tokens[d].content) || a(u.tokens[d].children, u);
    }, _i;
}
var bi, of;
function sme() {
    return of || (of = 1, bi = function bi(t) {
        var n, r, s, o, i, a, c = t.tokens;
        for(n = 0, r = c.length; n < r; n++)if (c[n].type === "inline") {
            for(s = c[n].children, i = s.length, o = 0; o < i; o++)s[o].type === "text_special" && (s[o].type = "text");
            for(o = a = 0; o < i; o++)s[o].type === "text" && o + 1 < i && s[o + 1].type === "text" ? s[o + 1].content = s[o].content + s[o + 1].content : (o !== a && (s[a] = s[o]), a++);
            o !== a && (s.length = a);
        }
    }), bi;
}
var yi, sf;
function $l() {
    if (sf) return yi;
    sf = 1;
    function e(t, n, r) {
        this.type = t, this.tag = n, this.attrs = null, this.map = null, this.nesting = r, this.level = 0, this.children = null, this.content = "", this.markup = "", this.info = "", this.meta = null, this.block = !1, this.hidden = !1;
    }
    return e.prototype.attrIndex = function(n) {
        var r, s, o;
        if (!this.attrs) return -1;
        for(r = this.attrs, s = 0, o = r.length; s < o; s++)if (r[s][0] === n) return s;
        return -1;
    }, e.prototype.attrPush = function(n) {
        this.attrs ? this.attrs.push(n) : this.attrs = [
            n
        ];
    }, e.prototype.attrSet = function(n, r) {
        var s = this.attrIndex(n), o = [
            n,
            r
        ];
        s < 0 ? this.attrPush(o) : this.attrs[s] = o;
    }, e.prototype.attrGet = function(n) {
        var r = this.attrIndex(n), s = null;
        return r >= 0 && (s = this.attrs[r][1]), s;
    }, e.prototype.attrJoin = function(n, r) {
        var s = this.attrIndex(n);
        s < 0 ? this.attrPush([
            n,
            r
        ]) : this.attrs[s][1] = this.attrs[s][1] + " " + r;
    }, yi = e, yi;
}
var wi, af;
function ime() {
    if (af) return wi;
    af = 1;
    var e = $l();
    function t(n, r, s) {
        this.src = n, this.env = s, this.tokens = [], this.inlineMode = !1, this.md = r;
    }
    return t.prototype.Token = e, wi = t, wi;
}
var ki, cf;
function ame() {
    if (cf) return ki;
    cf = 1;
    var e = Al(), t = [
        [
            "normalize",
            Qge()
        ],
        [
            "block",
            eme()
        ],
        [
            "inline",
            tme()
        ],
        [
            "linkify",
            nme()
        ],
        [
            "replacements",
            rme()
        ],
        [
            "smartquotes",
            ome()
        ],
        // `text_join` finds `text_special` tokens (for escape sequences)
        // and joins them with the rest of the text
        [
            "text_join",
            sme()
        ]
    ];
    function n() {
        this.ruler = new e();
        for(var r = 0; r < t.length; r++)this.ruler.push(t[r][0], t[r][1]);
    }
    return n.prototype.process = function(r) {
        var s, o, i;
        for(i = this.ruler.getRules(""), s = 0, o = i.length; s < o; s++)i[s](r);
    }, n.prototype.State = ime(), ki = n, ki;
}
var xi, lf;
function cme() {
    if (lf) return xi;
    lf = 1;
    var e = Pe().isSpace;
    function t(r, s) {
        var o = r.bMarks[s] + r.tShift[s], i = r.eMarks[s];
        return r.src.slice(o, i);
    }
    function n(r) {
        var s = [], o = 0, i = r.length, a, c = !1, u = 0, d = "";
        for(a = r.charCodeAt(o); o < i;)a === 124 && (c ? (d += r.substring(u, o - 1), u = o) : (s.push(d + r.substring(u, o)), d = "", u = o + 1)), c = a === 92, o++, a = r.charCodeAt(o);
        return s.push(d + r.substring(u)), s;
    }
    return xi = function xi(s, o, i, a) {
        var c, u, d, l, m, f, v, g, b, h, w, k, x, A, S, $, M, P;
        if (o + 2 > i || (f = o + 1, s.sCount[f] < s.blkIndent) || s.sCount[f] - s.blkIndent >= 4 || (d = s.bMarks[f] + s.tShift[f], d >= s.eMarks[f]) || (M = s.src.charCodeAt(d++), M !== 124 && M !== 45 && M !== 58) || d >= s.eMarks[f] || (P = s.src.charCodeAt(d++), P !== 124 && P !== 45 && P !== 58 && !e(P)) || M === 45 && e(P)) return !1;
        for(; d < s.eMarks[f];){
            if (c = s.src.charCodeAt(d), c !== 124 && c !== 45 && c !== 58 && !e(c)) return !1;
            d++;
        }
        for(u = t(s, o + 1), v = u.split("|"), h = [], l = 0; l < v.length; l++){
            if (w = v[l].trim(), !w) {
                if (l === 0 || l === v.length - 1) continue;
                return !1;
            }
            if (!/^:?-+:?$/.test(w)) return !1;
            w.charCodeAt(w.length - 1) === 58 ? h.push(w.charCodeAt(0) === 58 ? "center" : "right") : w.charCodeAt(0) === 58 ? h.push("left") : h.push("");
        }
        if (u = t(s, o).trim(), u.indexOf("|") === -1 || s.sCount[o] - s.blkIndent >= 4 || (v = n(u), v.length && v[0] === "" && v.shift(), v.length && v[v.length - 1] === "" && v.pop(), g = v.length, g === 0 || g !== h.length)) return !1;
        if (a) return !0;
        for(A = s.parentType, s.parentType = "table", $ = s.md.block.ruler.getRules("blockquote"), b = s.push("table_open", "table", 1), b.map = k = [
            o,
            0
        ], b = s.push("thead_open", "thead", 1), b.map = [
            o,
            o + 1
        ], b = s.push("tr_open", "tr", 1), b.map = [
            o,
            o + 1
        ], l = 0; l < v.length; l++)b = s.push("th_open", "th", 1), h[l] && (b.attrs = [
            [
                "style",
                "text-align:" + h[l]
            ]
        ]), b = s.push("inline", "", 0), b.content = v[l].trim(), b.children = [], b = s.push("th_close", "th", -1);
        for(b = s.push("tr_close", "tr", -1), b = s.push("thead_close", "thead", -1), f = o + 2; f < i && !(s.sCount[f] < s.blkIndent); f++){
            for(S = !1, l = 0, m = $.length; l < m; l++)if ($[l](s, f, i, !0)) {
                S = !0;
                break;
            }
            if (S || (u = t(s, f).trim(), !u) || s.sCount[f] - s.blkIndent >= 4) break;
            for(v = n(u), v.length && v[0] === "" && v.shift(), v.length && v[v.length - 1] === "" && v.pop(), f === o + 2 && (b = s.push("tbody_open", "tbody", 1), b.map = x = [
                o + 2,
                0
            ]), b = s.push("tr_open", "tr", 1), b.map = [
                f,
                f + 1
            ], l = 0; l < g; l++)b = s.push("td_open", "td", 1), h[l] && (b.attrs = [
                [
                    "style",
                    "text-align:" + h[l]
                ]
            ]), b = s.push("inline", "", 0), b.content = v[l] ? v[l].trim() : "", b.children = [], b = s.push("td_close", "td", -1);
            b = s.push("tr_close", "tr", -1);
        }
        return x && (b = s.push("tbody_close", "tbody", -1), x[1] = f), b = s.push("table_close", "table", -1), k[1] = f, s.parentType = A, s.line = f, !0;
    }, xi;
}
var Ci, uf;
function lme() {
    return uf || (uf = 1, Ci = function Ci(t, n, r) {
        var s, o, i;
        if (t.sCount[n] - t.blkIndent < 4) return !1;
        for(o = s = n + 1; s < r;){
            if (t.isEmpty(s)) {
                s++;
                continue;
            }
            if (t.sCount[s] - t.blkIndent >= 4) {
                s++, o = s;
                continue;
            }
            break;
        }
        return t.line = o, i = t.push("code_block", "code", 0), i.content = t.getLines(n, o, 4 + t.blkIndent, !1) + "\n", i.map = [
            n,
            t.line
        ], !0;
    }), Ci;
}
var Si, df;
function ume() {
    return df || (df = 1, Si = function Si(t, n, r, s) {
        var o, i, a, c, u, d, l, m = !1, f = t.bMarks[n] + t.tShift[n], v = t.eMarks[n];
        if (t.sCount[n] - t.blkIndent >= 4 || f + 3 > v || (o = t.src.charCodeAt(f), o !== 126 && o !== 96) || (u = f, f = t.skipChars(f, o), i = f - u, i < 3) || (l = t.src.slice(u, f), a = t.src.slice(f, v), o === 96 && a.indexOf(String.fromCharCode(o)) >= 0)) return !1;
        if (s) return !0;
        for(c = n; c++, !(c >= r || (f = u = t.bMarks[c] + t.tShift[c], v = t.eMarks[c], f < v && t.sCount[c] < t.blkIndent));)if (t.src.charCodeAt(f) === o && !(t.sCount[c] - t.blkIndent >= 4) && (f = t.skipChars(f, o), !(f - u < i) && (f = t.skipSpaces(f), !(f < v)))) {
            m = !0;
            break;
        }
        return i = t.sCount[n], t.line = c + (m ? 1 : 0), d = t.push("fence", "code", 0), d.info = a, d.content = t.getLines(n + 1, c, i, !0), d.markup = l, d.map = [
            n,
            t.line
        ], !0;
    }), Si;
}
var Ei, ff;
function dme() {
    if (ff) return Ei;
    ff = 1;
    var e = Pe().isSpace;
    return Ei = function Ei(n, r, s, o) {
        var i, a, c, u, d, l, m, f, v, g, b, h, w, k, x, A, S, $, M, P, R = n.lineMax, B = n.bMarks[r] + n.tShift[r], H = n.eMarks[r];
        if (n.sCount[r] - n.blkIndent >= 4 || n.src.charCodeAt(B) !== 62) return !1;
        if (o) return !0;
        for(g = [], b = [], k = [], x = [], $ = n.md.block.ruler.getRules("blockquote"), w = n.parentType, n.parentType = "blockquote", f = r; f < s && (P = n.sCount[f] < n.blkIndent, B = n.bMarks[f] + n.tShift[f], H = n.eMarks[f], !(B >= H)); f++){
            if (n.src.charCodeAt(B++) === 62 && !P) {
                for(u = n.sCount[f] + 1, n.src.charCodeAt(B) === 32 ? (B++, u++, i = !1, A = !0) : n.src.charCodeAt(B) === 9 ? (A = !0, (n.bsCount[f] + u) % 4 === 3 ? (B++, u++, i = !1) : i = !0) : A = !1, v = u, g.push(n.bMarks[f]), n.bMarks[f] = B; B < H && (a = n.src.charCodeAt(B), e(a));){
                    a === 9 ? v += 4 - (v + n.bsCount[f] + (i ? 1 : 0)) % 4 : v++;
                    B++;
                }
                l = B >= H, b.push(n.bsCount[f]), n.bsCount[f] = n.sCount[f] + 1 + (A ? 1 : 0), k.push(n.sCount[f]), n.sCount[f] = v - u, x.push(n.tShift[f]), n.tShift[f] = B - n.bMarks[f];
                continue;
            }
            if (l) break;
            for(S = !1, c = 0, d = $.length; c < d; c++)if ($[c](n, f, s, !0)) {
                S = !0;
                break;
            }
            if (S) {
                n.lineMax = f, n.blkIndent !== 0 && (g.push(n.bMarks[f]), b.push(n.bsCount[f]), x.push(n.tShift[f]), k.push(n.sCount[f]), n.sCount[f] -= n.blkIndent);
                break;
            }
            g.push(n.bMarks[f]), b.push(n.bsCount[f]), x.push(n.tShift[f]), k.push(n.sCount[f]), n.sCount[f] = -1;
        }
        for(h = n.blkIndent, n.blkIndent = 0, M = n.push("blockquote_open", "blockquote", 1), M.markup = ">", M.map = m = [
            r,
            0
        ], n.md.block.tokenize(n, r, f), M = n.push("blockquote_close", "blockquote", -1), M.markup = ">", n.lineMax = R, n.parentType = w, m[1] = n.line, c = 0; c < x.length; c++)n.bMarks[c + r] = g[c], n.tShift[c + r] = x[c], n.sCount[c + r] = k[c], n.bsCount[c + r] = b[c];
        return n.blkIndent = h, !0;
    }, Ei;
}
var Ai, pf;
function fme() {
    if (pf) return Ai;
    pf = 1;
    var e = Pe().isSpace;
    return Ai = function Ai(n, r, s, o) {
        var i, a, c, u, d = n.bMarks[r] + n.tShift[r], l = n.eMarks[r];
        if (n.sCount[r] - n.blkIndent >= 4 || (i = n.src.charCodeAt(d++), i !== 42 && i !== 45 && i !== 95)) return !1;
        for(a = 1; d < l;){
            if (c = n.src.charCodeAt(d++), c !== i && !e(c)) return !1;
            c === i && a++;
        }
        return a < 3 ? !1 : (o || (n.line = r + 1, u = n.push("hr", "hr", 0), u.map = [
            r,
            n.line
        ], u.markup = Array(a + 1).join(String.fromCharCode(i))), !0);
    }, Ai;
}
var $i, hf;
function pme() {
    if (hf) return $i;
    hf = 1;
    var e = Pe().isSpace;
    function t(s, o) {
        var i, a, c, u;
        return a = s.bMarks[o] + s.tShift[o], c = s.eMarks[o], i = s.src.charCodeAt(a++), i !== 42 && i !== 45 && i !== 43 || a < c && (u = s.src.charCodeAt(a), !e(u)) ? -1 : a;
    }
    function n(s, o) {
        var i, a = s.bMarks[o] + s.tShift[o], c = a, u = s.eMarks[o];
        if (c + 1 >= u || (i = s.src.charCodeAt(c++), i < 48 || i > 57)) return -1;
        for(;;){
            if (c >= u) return -1;
            if (i = s.src.charCodeAt(c++), i >= 48 && i <= 57) {
                if (c - a >= 10) return -1;
                continue;
            }
            if (i === 41 || i === 46) break;
            return -1;
        }
        return c < u && (i = s.src.charCodeAt(c), !e(i)) ? -1 : c;
    }
    function r(s, o) {
        var i, a, c = s.level + 2;
        for(i = o + 2, a = s.tokens.length - 2; i < a; i++)s.tokens[i].level === c && s.tokens[i].type === "paragraph_open" && (s.tokens[i + 2].hidden = !0, s.tokens[i].hidden = !0, i += 2);
    }
    return $i = function $i(o, i, a, c) {
        var u, d, l, m, f, v, g, b, h, w, k, x, A, S, $, M, P, R, B, H, ie, z, Q, N, j, U, G, T = i, W = !1, V = !0;
        if (o.sCount[T] - o.blkIndent >= 4 || o.listIndent >= 0 && o.sCount[T] - o.listIndent >= 4 && o.sCount[T] < o.blkIndent) return !1;
        if (c && o.parentType === "paragraph" && o.sCount[T] >= o.blkIndent && (W = !0), (z = n(o, T)) >= 0) {
            if (g = !0, N = o.bMarks[T] + o.tShift[T], A = Number(o.src.slice(N, z - 1)), W && A !== 1) return !1;
        } else if ((z = t(o, T)) >= 0) g = !1;
        else return !1;
        if (W && o.skipSpaces(z) >= o.eMarks[T]) return !1;
        if (c) return !0;
        for(x = o.src.charCodeAt(z - 1), k = o.tokens.length, g ? (G = o.push("ordered_list_open", "ol", 1), A !== 1 && (G.attrs = [
            [
                "start",
                A
            ]
        ])) : G = o.push("bullet_list_open", "ul", 1), G.map = w = [
            T,
            0
        ], G.markup = String.fromCharCode(x), Q = !1, U = o.md.block.ruler.getRules("list"), P = o.parentType, o.parentType = "list"; T < a;){
            for(ie = z, S = o.eMarks[T], v = $ = o.sCount[T] + z - (o.bMarks[T] + o.tShift[T]); ie < S;){
                if (u = o.src.charCodeAt(ie), u === 9) $ += 4 - ($ + o.bsCount[T]) % 4;
                else if (u === 32) $++;
                else break;
                ie++;
            }
            if (d = ie, d >= S ? f = 1 : f = $ - v, f > 4 && (f = 1), m = v + f, G = o.push("list_item_open", "li", 1), G.markup = String.fromCharCode(x), G.map = b = [
                T,
                0
            ], g && (G.info = o.src.slice(N, z - 1)), H = o.tight, B = o.tShift[T], R = o.sCount[T], M = o.listIndent, o.listIndent = o.blkIndent, o.blkIndent = m, o.tight = !0, o.tShift[T] = d - o.bMarks[T], o.sCount[T] = $, d >= S && o.isEmpty(T + 1) ? o.line = Math.min(o.line + 2, a) : o.md.block.tokenize(o, T, a, !0), (!o.tight || Q) && (V = !1), Q = o.line - T > 1 && o.isEmpty(o.line - 1), o.blkIndent = o.listIndent, o.listIndent = M, o.tShift[T] = B, o.sCount[T] = R, o.tight = H, G = o.push("list_item_close", "li", -1), G.markup = String.fromCharCode(x), T = o.line, b[1] = T, T >= a || o.sCount[T] < o.blkIndent || o.sCount[T] - o.blkIndent >= 4) break;
            for(j = !1, l = 0, h = U.length; l < h; l++)if (U[l](o, T, a, !0)) {
                j = !0;
                break;
            }
            if (j) break;
            if (g) {
                if (z = n(o, T), z < 0) break;
                N = o.bMarks[T] + o.tShift[T];
            } else if (z = t(o, T), z < 0) break;
            if (x !== o.src.charCodeAt(z - 1)) break;
        }
        return g ? G = o.push("ordered_list_close", "ol", -1) : G = o.push("bullet_list_close", "ul", -1), G.markup = String.fromCharCode(x), w[1] = T, o.line = T, o.parentType = P, V && r(o, k), !0;
    }, $i;
}
var Mi, gf;
function hme() {
    if (gf) return Mi;
    gf = 1;
    var e = Pe().normalizeReference, t = Pe().isSpace;
    return Mi = function Mi(r, s, o, i) {
        var a, c, u, d, l, m, f, v, g, b, h, w, k, x, A, S, $ = 0, M = r.bMarks[s] + r.tShift[s], P = r.eMarks[s], R = s + 1;
        if (r.sCount[s] - r.blkIndent >= 4 || r.src.charCodeAt(M) !== 91) return !1;
        for(; ++M < P;)if (r.src.charCodeAt(M) === 93 && r.src.charCodeAt(M - 1) !== 92) {
            if (M + 1 === P || r.src.charCodeAt(M + 1) !== 58) return !1;
            break;
        }
        for(d = r.lineMax, A = r.md.block.ruler.getRules("reference"), b = r.parentType, r.parentType = "reference"; R < d && !r.isEmpty(R); R++)if (!(r.sCount[R] - r.blkIndent > 3) && !(r.sCount[R] < 0)) {
            for(x = !1, m = 0, f = A.length; m < f; m++)if (A[m](r, R, d, !0)) {
                x = !0;
                break;
            }
            if (x) break;
        }
        for(k = r.getLines(s, R, r.blkIndent, !1).trim(), P = k.length, M = 1; M < P; M++){
            if (a = k.charCodeAt(M), a === 91) return !1;
            if (a === 93) {
                g = M;
                break;
            } else a === 10 ? $++ : a === 92 && (M++, M < P && k.charCodeAt(M) === 10 && $++);
        }
        if (g < 0 || k.charCodeAt(g + 1) !== 58) return !1;
        for(M = g + 2; M < P; M++)if (a = k.charCodeAt(M), a === 10) $++;
        else if (!t(a)) break;
        if (h = r.md.helpers.parseLinkDestination(k, M, P), !h.ok || (l = r.md.normalizeLink(h.str), !r.md.validateLink(l))) return !1;
        for(M = h.pos, $ += h.lines, c = M, u = $, w = M; M < P; M++)if (a = k.charCodeAt(M), a === 10) $++;
        else if (!t(a)) break;
        for(h = r.md.helpers.parseLinkTitle(k, M, P), M < P && w !== M && h.ok ? (S = h.str, M = h.pos, $ += h.lines) : (S = "", M = c, $ = u); M < P && (a = k.charCodeAt(M), !!t(a));)M++;
        if (M < P && k.charCodeAt(M) !== 10 && S) for(S = "", M = c, $ = u; M < P && (a = k.charCodeAt(M), !!t(a));)M++;
        return M < P && k.charCodeAt(M) !== 10 || (v = e(k.slice(1, g)), !v) ? !1 : (i || ((0, $6gBIz._)(r.env.references) > "u" && (r.env.references = {}), (0, $6gBIz._)(r.env.references[v]) > "u" && (r.env.references[v] = {
            title: S,
            href: l
        }), r.parentType = b, r.line = s + $ + 1), !0);
    }, Mi;
}
var Ii, mf;
function gme() {
    return mf || (mf = 1, Ii = [
        "address",
        "article",
        "aside",
        "base",
        "basefont",
        "blockquote",
        "body",
        "caption",
        "center",
        "col",
        "colgroup",
        "dd",
        "details",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "frame",
        "frameset",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hr",
        "html",
        "iframe",
        "legend",
        "li",
        "link",
        "main",
        "menu",
        "menuitem",
        "nav",
        "noframes",
        "ol",
        "optgroup",
        "option",
        "p",
        "param",
        "section",
        "source",
        "summary",
        "table",
        "tbody",
        "td",
        "tfoot",
        "th",
        "thead",
        "title",
        "tr",
        "track",
        "ul"
    ]), Ii;
}
var $o = {}, vf;
function fm() {
    if (vf) return $o;
    vf = 1;
    var e = "[a-zA-Z_:][a-zA-Z0-9:._-]*", t = "[^\"'=<>`\\x00-\\x20]+", n = "'[^']*'", r = '"[^"]*"', s = "(?:" + t + "|" + n + "|" + r + ")", o = "(?:\\s+" + e + "(?:\\s*=\\s*" + s + ")?)", i = "<[A-Za-z][A-Za-z0-9\\-]*" + o + "*\\s*\\/?>", a = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>", c = "<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->", u = "<[?][\\s\\S]*?[?]>", d = "<![A-Z]+\\s+[^>]*>", l = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>", m = new RegExp("^(?:" + i + "|" + a + "|" + c + "|" + u + "|" + d + "|" + l + ")"), f = new RegExp("^(?:" + i + "|" + a + ")");
    return $o.HTML_TAG_RE = m, $o.HTML_OPEN_CLOSE_TAG_RE = f, $o;
}
var Ti, _f;
function mme() {
    if (_f) return Ti;
    _f = 1;
    var e = gme(), t = fm().HTML_OPEN_CLOSE_TAG_RE, n = [
        [
            /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
            /<\/(script|pre|style|textarea)>/i,
            !0
        ],
        [
            /^<!--/,
            /-->/,
            !0
        ],
        [
            /^<\?/,
            /\?>/,
            !0
        ],
        [
            /^<![A-Z]/,
            />/,
            !0
        ],
        [
            /^<!\[CDATA\[/,
            /\]\]>/,
            !0
        ],
        [
            new RegExp("^</?(" + e.join("|") + ")(?=(\\s|/?>|$))", "i"),
            /^$/,
            !0
        ],
        [
            new RegExp(t.source + "\\s*$"),
            /^$/,
            !1
        ]
    ];
    return Ti = function Ti(s, o, i, a) {
        var c, u, d, l, m = s.bMarks[o] + s.tShift[o], f = s.eMarks[o];
        if (s.sCount[o] - s.blkIndent >= 4 || !s.md.options.html || s.src.charCodeAt(m) !== 60) return !1;
        for(l = s.src.slice(m, f), c = 0; c < n.length && !n[c][0].test(l); c++);
        if (c === n.length) return !1;
        if (a) return n[c][2];
        if (u = o + 1, !n[c][1].test(l)) {
            for(; u < i && !(s.sCount[u] < s.blkIndent); u++)if (m = s.bMarks[u] + s.tShift[u], f = s.eMarks[u], l = s.src.slice(m, f), n[c][1].test(l)) {
                l.length !== 0 && u++;
                break;
            }
        }
        return s.line = u, d = s.push("html_block", "", 0), d.map = [
            o,
            u
        ], d.content = s.getLines(o, u, s.blkIndent, !0), !0;
    }, Ti;
}
var Li, bf;
function vme() {
    if (bf) return Li;
    bf = 1;
    var e = Pe().isSpace;
    return Li = function Li(n, r, s, o) {
        var i, a, c, u, d = n.bMarks[r] + n.tShift[r], l = n.eMarks[r];
        if (n.sCount[r] - n.blkIndent >= 4 || (i = n.src.charCodeAt(d), i !== 35 || d >= l)) return !1;
        for(a = 1, i = n.src.charCodeAt(++d); i === 35 && d < l && a <= 6;)a++, i = n.src.charCodeAt(++d);
        return a > 6 || d < l && !e(i) ? !1 : (o || (l = n.skipSpacesBack(l, d), c = n.skipCharsBack(l, 35, d), c > d && e(n.src.charCodeAt(c - 1)) && (l = c), n.line = r + 1, u = n.push("heading_open", "h" + String(a), 1), u.markup = "########".slice(0, a), u.map = [
            r,
            n.line
        ], u = n.push("inline", "", 0), u.content = n.src.slice(d, l).trim(), u.map = [
            r,
            n.line
        ], u.children = [], u = n.push("heading_close", "h" + String(a), -1), u.markup = "########".slice(0, a)), !0);
    }, Li;
}
var Oi, yf;
function _me() {
    return yf || (yf = 1, Oi = function Oi(t, n, r) {
        var s, o, i, a, c, u, d, l, m, f = n + 1, v, g = t.md.block.ruler.getRules("paragraph");
        if (t.sCount[n] - t.blkIndent >= 4) return !1;
        for(v = t.parentType, t.parentType = "paragraph"; f < r && !t.isEmpty(f); f++)if (!(t.sCount[f] - t.blkIndent > 3)) {
            if (t.sCount[f] >= t.blkIndent && (u = t.bMarks[f] + t.tShift[f], d = t.eMarks[f], u < d && (m = t.src.charCodeAt(u), (m === 45 || m === 61) && (u = t.skipChars(u, m), u = t.skipSpaces(u), u >= d)))) {
                l = m === 61 ? 1 : 2;
                break;
            }
            if (!(t.sCount[f] < 0)) {
                for(o = !1, i = 0, a = g.length; i < a; i++)if (g[i](t, f, r, !0)) {
                    o = !0;
                    break;
                }
                if (o) break;
            }
        }
        return l ? (s = t.getLines(n, f, t.blkIndent, !1).trim(), t.line = f + 1, c = t.push("heading_open", "h" + String(l), 1), c.markup = String.fromCharCode(m), c.map = [
            n,
            t.line
        ], c = t.push("inline", "", 0), c.content = s, c.map = [
            n,
            t.line - 1
        ], c.children = [], c = t.push("heading_close", "h" + String(l), -1), c.markup = String.fromCharCode(m), t.parentType = v, !0) : !1;
    }), Oi;
}
var Ri, wf;
function bme() {
    return wf || (wf = 1, Ri = function Ri(t, n, r) {
        var s, o, i, a, c, u, d = n + 1, l = t.md.block.ruler.getRules("paragraph");
        for(u = t.parentType, t.parentType = "paragraph"; d < r && !t.isEmpty(d); d++)if (!(t.sCount[d] - t.blkIndent > 3) && !(t.sCount[d] < 0)) {
            for(o = !1, i = 0, a = l.length; i < a; i++)if (l[i](t, d, r, !0)) {
                o = !0;
                break;
            }
            if (o) break;
        }
        return s = t.getLines(n, d, t.blkIndent, !1).trim(), t.line = d, c = t.push("paragraph_open", "p", 1), c.map = [
            n,
            t.line
        ], c = t.push("inline", "", 0), c.content = s, c.map = [
            n,
            t.line
        ], c.children = [], c = t.push("paragraph_close", "p", -1), t.parentType = u, !0;
    }), Ri;
}
var Pi, kf;
function yme() {
    if (kf) return Pi;
    kf = 1;
    var e = $l(), t = Pe().isSpace;
    function n(r, s, o, i) {
        var a, c, u, d, l, m, f, v;
        for(this.src = r, this.md = s, this.env = o, this.tokens = i, this.bMarks = [], this.eMarks = [], this.tShift = [], this.sCount = [], this.bsCount = [], this.blkIndent = 0, this.line = 0, this.lineMax = 0, this.tight = !1, this.ddIndent = -1, this.listIndent = -1, this.parentType = "root", this.level = 0, this.result = "", c = this.src, v = !1, u = d = m = f = 0, l = c.length; d < l; d++){
            if (a = c.charCodeAt(d), !v) {
                if (t(a)) {
                    m++, a === 9 ? f += 4 - f % 4 : f++;
                    continue;
                } else v = !0;
            }
            (a === 10 || d === l - 1) && (a !== 10 && d++, this.bMarks.push(u), this.eMarks.push(d), this.tShift.push(m), this.sCount.push(f), this.bsCount.push(0), v = !1, m = 0, f = 0, u = d + 1);
        }
        this.bMarks.push(c.length), this.eMarks.push(c.length), this.tShift.push(0), this.sCount.push(0), this.bsCount.push(0), this.lineMax = this.bMarks.length - 1;
    }
    return n.prototype.push = function(r, s, o) {
        var i = new e(r, s, o);
        return i.block = !0, o < 0 && this.level--, i.level = this.level, o > 0 && this.level++, this.tokens.push(i), i;
    }, n.prototype.isEmpty = function(s) {
        return this.bMarks[s] + this.tShift[s] >= this.eMarks[s];
    }, n.prototype.skipEmptyLines = function(s) {
        for(var o = this.lineMax; s < o && !(this.bMarks[s] + this.tShift[s] < this.eMarks[s]); s++);
        return s;
    }, n.prototype.skipSpaces = function(s) {
        for(var o, i = this.src.length; s < i && (o = this.src.charCodeAt(s), !!t(o)); s++);
        return s;
    }, n.prototype.skipSpacesBack = function(s, o) {
        if (s <= o) return s;
        for(; s > o;)if (!t(this.src.charCodeAt(--s))) return s + 1;
        return s;
    }, n.prototype.skipChars = function(s, o) {
        for(var i = this.src.length; s < i && this.src.charCodeAt(s) === o; s++);
        return s;
    }, n.prototype.skipCharsBack = function(s, o, i) {
        if (s <= i) return s;
        for(; s > i;)if (o !== this.src.charCodeAt(--s)) return s + 1;
        return s;
    }, n.prototype.getLines = function(s, o, i, a) {
        var c, u, d, l, m, f, v, g = s;
        if (s >= o) return "";
        for(f = new Array(o - s), c = 0; g < o; g++, c++){
            for(u = 0, v = l = this.bMarks[g], g + 1 < o || a ? m = this.eMarks[g] + 1 : m = this.eMarks[g]; l < m && u < i;){
                if (d = this.src.charCodeAt(l), t(d)) d === 9 ? u += 4 - (u + this.bsCount[g]) % 4 : u++;
                else if (l - v < this.tShift[g]) u++;
                else break;
                l++;
            }
            u > i ? f[c] = new Array(u - i + 1).join(" ") + this.src.slice(l, m) : f[c] = this.src.slice(l, m);
        }
        return f.join("");
    }, n.prototype.Token = e, Pi = n, Pi;
}
var Bi, xf;
function wme() {
    if (xf) return Bi;
    xf = 1;
    var e = Al(), t = [
        // First 2 params - rule name & source. Secondary array - list of rules,
        // which can be terminated by this one.
        [
            "table",
            cme(),
            [
                "paragraph",
                "reference"
            ]
        ],
        [
            "code",
            lme()
        ],
        [
            "fence",
            ume(),
            [
                "paragraph",
                "reference",
                "blockquote",
                "list"
            ]
        ],
        [
            "blockquote",
            dme(),
            [
                "paragraph",
                "reference",
                "blockquote",
                "list"
            ]
        ],
        [
            "hr",
            fme(),
            [
                "paragraph",
                "reference",
                "blockquote",
                "list"
            ]
        ],
        [
            "list",
            pme(),
            [
                "paragraph",
                "reference",
                "blockquote"
            ]
        ],
        [
            "reference",
            hme()
        ],
        [
            "html_block",
            mme(),
            [
                "paragraph",
                "reference",
                "blockquote"
            ]
        ],
        [
            "heading",
            vme(),
            [
                "paragraph",
                "reference",
                "blockquote"
            ]
        ],
        [
            "lheading",
            _me()
        ],
        [
            "paragraph",
            bme()
        ]
    ];
    function n() {
        this.ruler = new e();
        for(var r = 0; r < t.length; r++)this.ruler.push(t[r][0], t[r][1], {
            alt: (t[r][2] || []).slice()
        });
    }
    return n.prototype.tokenize = function(r, s, o) {
        for(var i, a, c, u = this.ruler.getRules(""), d = u.length, l = s, m = !1, f = r.md.options.maxNesting; l < o && (r.line = l = r.skipEmptyLines(l), !(l >= o || r.sCount[l] < r.blkIndent));){
            if (r.level >= f) {
                r.line = o;
                break;
            }
            for(c = r.line, a = 0; a < d; a++)if (i = u[a](r, l, o, !1), i) {
                if (c >= r.line) throw new Error("block rule didn't increment state.line");
                break;
            }
            if (!i) throw new Error("none of the block rules matched");
            r.tight = !m, r.isEmpty(r.line - 1) && (m = !0), l = r.line, l < o && r.isEmpty(l) && (m = !0, l++, r.line = l);
        }
    }, n.prototype.parse = function(r, s, o, i) {
        var a;
        r && (a = new this.State(r, s, o, i), this.tokenize(a, a.line, a.lineMax));
    }, n.prototype.State = yme(), Bi = n, Bi;
}
var zi, Cf;
function kme() {
    if (Cf) return zi;
    Cf = 1;
    function e(t) {
        switch(t){
            case 10:
            case 33:
            case 35:
            case 36:
            case 37:
            case 38:
            case 42:
            case 43:
            case 45:
            case 58:
            case 60:
            case 61:
            case 62:
            case 64:
            case 91:
            case 92:
            case 93:
            case 94:
            case 95:
            case 96:
            case 123:
            case 125:
            case 126:
                return !0;
            default:
                return !1;
        }
    }
    return zi = function zi(n, r) {
        for(var s = n.pos; s < n.posMax && !e(n.src.charCodeAt(s));)s++;
        return s === n.pos ? !1 : (r || (n.pending += n.src.slice(n.pos, s)), n.pos = s, !0);
    }, zi;
}
var Di, Sf;
function xme() {
    if (Sf) return Di;
    Sf = 1;
    var e = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
    return Di = function Di(n, r) {
        var s, o, i, a, c, u, d, l;
        return !n.md.options.linkify || n.linkLevel > 0 || (s = n.pos, o = n.posMax, s + 3 > o) || n.src.charCodeAt(s) !== 58 || n.src.charCodeAt(s + 1) !== 47 || n.src.charCodeAt(s + 2) !== 47 || (i = n.pending.match(e), !i) || (a = i[1], c = n.md.linkify.matchAtStart(n.src.slice(s - a.length)), !c) || (u = c.url, u.length <= a.length) || (u = u.replace(/\*+$/, ""), d = n.md.normalizeLink(u), !n.md.validateLink(d)) ? !1 : (r || (n.pending = n.pending.slice(0, -a.length), l = n.push("link_open", "a", 1), l.attrs = [
            [
                "href",
                d
            ]
        ], l.markup = "linkify", l.info = "auto", l = n.push("text", "", 0), l.content = n.md.normalizeLinkText(u), l = n.push("link_close", "a", -1), l.markup = "linkify", l.info = "auto"), n.pos += u.length - a.length, !0);
    }, Di;
}
var Ni, Ef;
function Cme() {
    if (Ef) return Ni;
    Ef = 1;
    var e = Pe().isSpace;
    return Ni = function Ni(n, r) {
        var s, o, i, a = n.pos;
        if (n.src.charCodeAt(a) !== 10) return !1;
        if (s = n.pending.length - 1, o = n.posMax, !r) {
            if (s >= 0 && n.pending.charCodeAt(s) === 32) {
                if (s >= 1 && n.pending.charCodeAt(s - 1) === 32) {
                    for(i = s - 1; i >= 1 && n.pending.charCodeAt(i - 1) === 32;)i--;
                    n.pending = n.pending.slice(0, i), n.push("hardbreak", "br", 0);
                } else n.pending = n.pending.slice(0, -1), n.push("softbreak", "br", 0);
            } else n.push("softbreak", "br", 0);
        }
        for(a++; a < o && e(n.src.charCodeAt(a));)a++;
        return n.pos = a, !0;
    }, Ni;
}
var qi, Af;
function Sme() {
    if (Af) return qi;
    Af = 1;
    for(var e = Pe().isSpace, t = [], n = 0; n < 256; n++)t.push(0);
    return "\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(r) {
        t[r.charCodeAt(0)] = 1;
    }), qi = function qi(s, o) {
        var i, a, c, u, d, l = s.pos, m = s.posMax;
        if (s.src.charCodeAt(l) !== 92 || (l++, l >= m)) return !1;
        if (i = s.src.charCodeAt(l), i === 10) {
            for(o || s.push("hardbreak", "br", 0), l++; l < m && (i = s.src.charCodeAt(l), !!e(i));)l++;
            return s.pos = l, !0;
        }
        return u = s.src[l], i >= 55296 && i <= 56319 && l + 1 < m && (a = s.src.charCodeAt(l + 1), a >= 56320 && a <= 57343 && (u += s.src[l + 1], l++)), c = "\\" + u, o || (d = s.push("text_special", "", 0), i < 256 && t[i] !== 0 ? d.content = u : d.content = c, d.markup = c, d.info = "escape"), s.pos = l + 1, !0;
    }, qi;
}
var Fi, $f;
function Eme() {
    return $f || ($f = 1, Fi = function Fi(t, n) {
        var r, s, o, i, a, c, u, d, l = t.pos, m = t.src.charCodeAt(l);
        if (m !== 96) return !1;
        for(r = l, l++, s = t.posMax; l < s && t.src.charCodeAt(l) === 96;)l++;
        if (o = t.src.slice(r, l), u = o.length, t.backticksScanned && (t.backticks[u] || 0) <= r) return n || (t.pending += o), t.pos += u, !0;
        for(c = l; (a = t.src.indexOf("`", c)) !== -1;){
            for(c = a + 1; c < s && t.src.charCodeAt(c) === 96;)c++;
            if (d = c - a, d === u) return n || (i = t.push("code_inline", "code", 0), i.markup = o, i.content = t.src.slice(l, a).replace(/\n/g, " ").replace(/^ (.+) $/, "$1")), t.pos = c, !0;
            t.backticks[d] = a;
        }
        return t.backticksScanned = !0, n || (t.pending += o), t.pos += u, !0;
    }), Fi;
}
var Mo = {}, Mf;
function If() {
    if (Mf) return Mo;
    Mf = 1, Mo.tokenize = function(n, r) {
        var s, o, i, a, c, u = n.pos, d = n.src.charCodeAt(u);
        if (r || d !== 126 || (o = n.scanDelims(n.pos, !0), a = o.length, c = String.fromCharCode(d), a < 2)) return !1;
        for(a % 2 && (i = n.push("text", "", 0), i.content = c, a--), s = 0; s < a; s += 2)i = n.push("text", "", 0), i.content = c + c, n.delimiters.push({
            marker: d,
            length: 0,
            // disable "rule of 3" length checks meant for emphasis
            token: n.tokens.length - 1,
            end: -1,
            open: o.can_open,
            close: o.can_close
        });
        return n.pos += o.length, !0;
    };
    function e(t, n) {
        var r, s, o, i, a, c = [], u = n.length;
        for(r = 0; r < u; r++)o = n[r], o.marker === 126 && o.end !== -1 && (i = n[o.end], a = t.tokens[o.token], a.type = "s_open", a.tag = "s", a.nesting = 1, a.markup = "~~", a.content = "", a = t.tokens[i.token], a.type = "s_close", a.tag = "s", a.nesting = -1, a.markup = "~~", a.content = "", t.tokens[i.token - 1].type === "text" && t.tokens[i.token - 1].content === "~" && c.push(i.token - 1));
        for(; c.length;){
            for(r = c.pop(), s = r + 1; s < t.tokens.length && t.tokens[s].type === "s_close";)s++;
            s--, r !== s && (a = t.tokens[s], t.tokens[s] = t.tokens[r], t.tokens[r] = a);
        }
    }
    return Mo.postProcess = function(n) {
        var r, s = n.tokens_meta, o = n.tokens_meta.length;
        for(e(n, n.delimiters), r = 0; r < o; r++)s[r] && s[r].delimiters && e(n, s[r].delimiters);
    }, Mo;
}
var Io = {}, Tf;
function Lf() {
    if (Tf) return Io;
    Tf = 1, Io.tokenize = function(n, r) {
        var s, o, i, a = n.pos, c = n.src.charCodeAt(a);
        if (r || c !== 95 && c !== 42) return !1;
        for(o = n.scanDelims(n.pos, c === 42), s = 0; s < o.length; s++)i = n.push("text", "", 0), i.content = String.fromCharCode(c), n.delimiters.push({
            // Char code of the starting marker (number).
            //
            marker: c,
            // Total length of these series of delimiters.
            //
            length: o.length,
            // A position of the token this delimiter corresponds to.
            //
            token: n.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: o.can_open,
            close: o.can_close
        });
        return n.pos += o.length, !0;
    };
    function e(t, n) {
        var r, s, o, i, a, c, u = n.length;
        for(r = u - 1; r >= 0; r--)s = n[r], !(s.marker !== 95 && s.marker !== 42) && s.end !== -1 && (o = n[s.end], c = r > 0 && n[r - 1].end === s.end + 1 && // check that first two markers match and adjacent
        n[r - 1].marker === s.marker && n[r - 1].token === s.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        n[s.end + 1].token === o.token + 1, a = String.fromCharCode(s.marker), i = t.tokens[s.token], i.type = c ? "strong_open" : "em_open", i.tag = c ? "strong" : "em", i.nesting = 1, i.markup = c ? a + a : a, i.content = "", i = t.tokens[o.token], i.type = c ? "strong_close" : "em_close", i.tag = c ? "strong" : "em", i.nesting = -1, i.markup = c ? a + a : a, i.content = "", c && (t.tokens[n[r - 1].token].content = "", t.tokens[n[s.end + 1].token].content = "", r--));
    }
    return Io.postProcess = function(n) {
        var r, s = n.tokens_meta, o = n.tokens_meta.length;
        for(e(n, n.delimiters), r = 0; r < o; r++)s[r] && s[r].delimiters && e(n, s[r].delimiters);
    }, Io;
}
var Hi, Of;
function Ame() {
    if (Of) return Hi;
    Of = 1;
    var e = Pe().normalizeReference, t = Pe().isSpace;
    return Hi = function Hi(r, s) {
        var o, i, a, c, u, d, l, m, f, v = "", g = "", b = r.pos, h = r.posMax, w = r.pos, k = !0;
        if (r.src.charCodeAt(r.pos) !== 91 || (u = r.pos + 1, c = r.md.helpers.parseLinkLabel(r, r.pos, !0), c < 0)) return !1;
        if (d = c + 1, d < h && r.src.charCodeAt(d) === 40) {
            for(k = !1, d++; d < h && (i = r.src.charCodeAt(d), !(!t(i) && i !== 10)); d++);
            if (d >= h) return !1;
            if (w = d, l = r.md.helpers.parseLinkDestination(r.src, d, r.posMax), l.ok) {
                for(v = r.md.normalizeLink(l.str), r.md.validateLink(v) ? d = l.pos : v = "", w = d; d < h && (i = r.src.charCodeAt(d), !(!t(i) && i !== 10)); d++);
                if (l = r.md.helpers.parseLinkTitle(r.src, d, r.posMax), d < h && w !== d && l.ok) for(g = l.str, d = l.pos; d < h && (i = r.src.charCodeAt(d), !(!t(i) && i !== 10)); d++);
            }
            (d >= h || r.src.charCodeAt(d) !== 41) && (k = !0), d++;
        }
        if (k) {
            if ((0, $6gBIz._)(r.env.references) > "u") return !1;
            if (d < h && r.src.charCodeAt(d) === 91 ? (w = d + 1, d = r.md.helpers.parseLinkLabel(r, d), d >= 0 ? a = r.src.slice(w, d++) : d = c + 1) : d = c + 1, a || (a = r.src.slice(u, c)), m = r.env.references[e(a)], !m) return r.pos = b, !1;
            v = m.href, g = m.title;
        }
        return s || (r.pos = u, r.posMax = c, f = r.push("link_open", "a", 1), f.attrs = o = [
            [
                "href",
                v
            ]
        ], g && o.push([
            "title",
            g
        ]), r.linkLevel++, r.md.inline.tokenize(r), r.linkLevel--, f = r.push("link_close", "a", -1)), r.pos = d, r.posMax = h, !0;
    }, Hi;
}
var ji, Rf;
function $me() {
    if (Rf) return ji;
    Rf = 1;
    var e = Pe().normalizeReference, t = Pe().isSpace;
    return ji = function ji(r, s) {
        var o, i, a, c, u, d, l, m, f, v, g, b, h, w = "", k = r.pos, x = r.posMax;
        if (r.src.charCodeAt(r.pos) !== 33 || r.src.charCodeAt(r.pos + 1) !== 91 || (d = r.pos + 2, u = r.md.helpers.parseLinkLabel(r, r.pos + 1, !1), u < 0)) return !1;
        if (l = u + 1, l < x && r.src.charCodeAt(l) === 40) {
            for(l++; l < x && (i = r.src.charCodeAt(l), !(!t(i) && i !== 10)); l++);
            if (l >= x) return !1;
            for(h = l, f = r.md.helpers.parseLinkDestination(r.src, l, r.posMax), f.ok && (w = r.md.normalizeLink(f.str), r.md.validateLink(w) ? l = f.pos : w = ""), h = l; l < x && (i = r.src.charCodeAt(l), !(!t(i) && i !== 10)); l++);
            if (f = r.md.helpers.parseLinkTitle(r.src, l, r.posMax), l < x && h !== l && f.ok) for(v = f.str, l = f.pos; l < x && (i = r.src.charCodeAt(l), !(!t(i) && i !== 10)); l++);
            else v = "";
            if (l >= x || r.src.charCodeAt(l) !== 41) return r.pos = k, !1;
            l++;
        } else {
            if ((0, $6gBIz._)(r.env.references) > "u") return !1;
            if (l < x && r.src.charCodeAt(l) === 91 ? (h = l + 1, l = r.md.helpers.parseLinkLabel(r, l), l >= 0 ? c = r.src.slice(h, l++) : l = u + 1) : l = u + 1, c || (c = r.src.slice(d, u)), m = r.env.references[e(c)], !m) return r.pos = k, !1;
            w = m.href, v = m.title;
        }
        return s || (a = r.src.slice(d, u), r.md.inline.parse(a, r.md, r.env, b = []), g = r.push("image", "img", 0), g.attrs = o = [
            [
                "src",
                w
            ],
            [
                "alt",
                ""
            ]
        ], g.children = b, g.content = a, v && o.push([
            "title",
            v
        ])), r.pos = l, r.posMax = x, !0;
    }, ji;
}
var Ui, Pf;
function Mme() {
    if (Pf) return Ui;
    Pf = 1;
    var e = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/, t = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/;
    return Ui = function Ui(r, s) {
        var o, i, a, c, u, d, l = r.pos;
        if (r.src.charCodeAt(l) !== 60) return !1;
        for(u = r.pos, d = r.posMax;;){
            if (++l >= d || (c = r.src.charCodeAt(l), c === 60)) return !1;
            if (c === 62) break;
        }
        return o = r.src.slice(u + 1, l), t.test(o) ? (i = r.md.normalizeLink(o), r.md.validateLink(i) ? (s || (a = r.push("link_open", "a", 1), a.attrs = [
            [
                "href",
                i
            ]
        ], a.markup = "autolink", a.info = "auto", a = r.push("text", "", 0), a.content = r.md.normalizeLinkText(o), a = r.push("link_close", "a", -1), a.markup = "autolink", a.info = "auto"), r.pos += o.length + 2, !0) : !1) : e.test(o) ? (i = r.md.normalizeLink("mailto:" + o), r.md.validateLink(i) ? (s || (a = r.push("link_open", "a", 1), a.attrs = [
            [
                "href",
                i
            ]
        ], a.markup = "autolink", a.info = "auto", a = r.push("text", "", 0), a.content = r.md.normalizeLinkText(o), a = r.push("link_close", "a", -1), a.markup = "autolink", a.info = "auto"), r.pos += o.length + 2, !0) : !1) : !1;
    }, Ui;
}
var Vi, Bf;
function Ime() {
    if (Bf) return Vi;
    Bf = 1;
    var e = fm().HTML_TAG_RE;
    function t(s) {
        return /^<a[>\s]/i.test(s);
    }
    function n(s) {
        return /^<\/a\s*>/i.test(s);
    }
    function r(s) {
        var o = s | 32;
        return o >= 97 && o <= 122;
    }
    return Vi = function Vi(o, i) {
        var a, c, u, d, l = o.pos;
        return !o.md.options.html || (u = o.posMax, o.src.charCodeAt(l) !== 60 || l + 2 >= u) || (a = o.src.charCodeAt(l + 1), a !== 33 && a !== 63 && a !== 47 && !r(a)) || (c = o.src.slice(l).match(e), !c) ? !1 : (i || (d = o.push("html_inline", "", 0), d.content = c[0], t(d.content) && o.linkLevel++, n(d.content) && o.linkLevel--), o.pos += c[0].length, !0);
    }, Vi;
}
var Zi, zf;
function Tme() {
    if (zf) return Zi;
    zf = 1;
    var e = am(), t = Pe().has, n = Pe().isValidEntityCode, r = Pe().fromCodePoint, s = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i, o = /^&([a-z][a-z0-9]{1,31});/i;
    return Zi = function Zi(a, c) {
        var u, d, l, m, f = a.pos, v = a.posMax;
        if (a.src.charCodeAt(f) !== 38 || f + 1 >= v) return !1;
        if (u = a.src.charCodeAt(f + 1), u === 35) {
            if (l = a.src.slice(f).match(s), l) return c || (d = l[1][0].toLowerCase() === "x" ? parseInt(l[1].slice(1), 16) : parseInt(l[1], 10), m = a.push("text_special", "", 0), m.content = n(d) ? r(d) : r(65533), m.markup = l[0], m.info = "entity"), a.pos += l[0].length, !0;
        } else if (l = a.src.slice(f).match(o), l && t(e, l[1])) return c || (m = a.push("text_special", "", 0), m.content = e[l[1]], m.markup = l[0], m.info = "entity"), a.pos += l[0].length, !0;
        return !1;
    }, Zi;
}
var Wi, Df;
function Lme() {
    if (Df) return Wi;
    Df = 1;
    function e(t) {
        var n, r, s, o, i, a, c, u, d = {}, l = t.length;
        if (l) {
            var m = 0, f = -2, v = [];
            for(n = 0; n < l; n++)if (s = t[n], v.push(0), (t[m].marker !== s.marker || f !== s.token - 1) && (m = n), f = s.token, s.length = s.length || 0, !!s.close) {
                for(d.hasOwnProperty(s.marker) || (d[s.marker] = [
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1
                ]), i = d[s.marker][(s.open ? 3 : 0) + s.length % 3], r = m - v[m] - 1, a = r; r > i; r -= v[r] + 1)if (o = t[r], o.marker === s.marker && o.open && o.end < 0 && (c = !1, (o.close || s.open) && (o.length + s.length) % 3 === 0 && (o.length % 3 !== 0 || s.length % 3 !== 0) && (c = !0), !c)) {
                    u = r > 0 && !t[r - 1].open ? v[r - 1] + 1 : 0, v[n] = n - r + u, v[r] = u, s.open = !1, o.end = n, o.close = !1, a = -1, f = -2;
                    break;
                }
                a !== -1 && (d[s.marker][(s.open ? 3 : 0) + (s.length || 0) % 3] = a);
            }
        }
    }
    return Wi = function Wi(n) {
        var r, s = n.tokens_meta, o = n.tokens_meta.length;
        for(e(n.delimiters), r = 0; r < o; r++)s[r] && s[r].delimiters && e(s[r].delimiters);
    }, Wi;
}
var Gi, Nf;
function Ome() {
    return Nf || (Nf = 1, Gi = function Gi(t) {
        var n, r, s = 0, o = t.tokens, i = t.tokens.length;
        for(n = r = 0; n < i; n++)o[n].nesting < 0 && s--, o[n].level = s, o[n].nesting > 0 && s++, o[n].type === "text" && n + 1 < i && o[n + 1].type === "text" ? o[n + 1].content = o[n].content + o[n + 1].content : (n !== r && (o[r] = o[n]), r++);
        n !== r && (o.length = r);
    }), Gi;
}
var Ki, qf;
function Rme() {
    if (qf) return Ki;
    qf = 1;
    var e = $l(), t = Pe().isWhiteSpace, n = Pe().isPunctChar, r = Pe().isMdAsciiPunct;
    function s(o, i, a, c) {
        this.src = o, this.env = a, this.md = i, this.tokens = c, this.tokens_meta = Array(c.length), this.pos = 0, this.posMax = this.src.length, this.level = 0, this.pending = "", this.pendingLevel = 0, this.cache = {}, this.delimiters = [], this._prev_delimiters = [], this.backticks = {}, this.backticksScanned = !1, this.linkLevel = 0;
    }
    return s.prototype.pushPending = function() {
        var o = new e("text", "", 0);
        return o.content = this.pending, o.level = this.pendingLevel, this.tokens.push(o), this.pending = "", o;
    }, s.prototype.push = function(o, i, a) {
        this.pending && this.pushPending();
        var c = new e(o, i, a), u = null;
        return a < 0 && (this.level--, this.delimiters = this._prev_delimiters.pop()), c.level = this.level, a > 0 && (this.level++, this._prev_delimiters.push(this.delimiters), this.delimiters = [], u = {
            delimiters: this.delimiters
        }), this.pendingLevel = this.level, this.tokens.push(c), this.tokens_meta.push(u), c;
    }, s.prototype.scanDelims = function(o, i) {
        var a = o, c, u, d, l, m, f, v, g, b, h = !0, w = !0, k = this.posMax, x = this.src.charCodeAt(o);
        for(c = o > 0 ? this.src.charCodeAt(o - 1) : 32; a < k && this.src.charCodeAt(a) === x;)a++;
        return d = a - o, u = a < k ? this.src.charCodeAt(a) : 32, v = r(c) || n(String.fromCharCode(c)), b = r(u) || n(String.fromCharCode(u)), f = t(c), g = t(u), g ? h = !1 : b && (f || v || (h = !1)), f ? w = !1 : v && (g || b || (w = !1)), i ? (l = h, m = w) : (l = h && (!w || v), m = w && (!h || b)), {
            can_open: l,
            can_close: m,
            length: d
        };
    }, s.prototype.Token = e, Ki = s, Ki;
}
var Xi, Ff;
function Pme() {
    if (Ff) return Xi;
    Ff = 1;
    var e = Al(), t = [
        [
            "text",
            kme()
        ],
        [
            "linkify",
            xme()
        ],
        [
            "newline",
            Cme()
        ],
        [
            "escape",
            Sme()
        ],
        [
            "backticks",
            Eme()
        ],
        [
            "strikethrough",
            If().tokenize
        ],
        [
            "emphasis",
            Lf().tokenize
        ],
        [
            "link",
            Ame()
        ],
        [
            "image",
            $me()
        ],
        [
            "autolink",
            Mme()
        ],
        [
            "html_inline",
            Ime()
        ],
        [
            "entity",
            Tme()
        ]
    ], n = [
        [
            "balance_pairs",
            Lme()
        ],
        [
            "strikethrough",
            If().postProcess
        ],
        [
            "emphasis",
            Lf().postProcess
        ],
        // rules for pairs separate '**' into its own text tokens, which may be left unused,
        // rule below merges unused segments back with the rest of the text
        [
            "fragments_join",
            Ome()
        ]
    ];
    function r() {
        var s;
        for(this.ruler = new e(), s = 0; s < t.length; s++)this.ruler.push(t[s][0], t[s][1]);
        for(this.ruler2 = new e(), s = 0; s < n.length; s++)this.ruler2.push(n[s][0], n[s][1]);
    }
    return r.prototype.skipToken = function(s) {
        var o, i, a = s.pos, c = this.ruler.getRules(""), u = c.length, d = s.md.options.maxNesting, l = s.cache;
        if ((0, $6gBIz._)(l[a]) < "u") {
            s.pos = l[a];
            return;
        }
        if (s.level < d) {
            for(i = 0; i < u; i++)if (s.level++, o = c[i](s, !0), s.level--, o) {
                if (a >= s.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        } else s.pos = s.posMax;
        o || s.pos++, l[a] = s.pos;
    }, r.prototype.tokenize = function(s) {
        for(var o, i, a, c = this.ruler.getRules(""), u = c.length, d = s.posMax, l = s.md.options.maxNesting; s.pos < d;){
            if (a = s.pos, s.level < l) {
                for(i = 0; i < u; i++)if (o = c[i](s, !1), o) {
                    if (a >= s.pos) throw new Error("inline rule didn't increment state.pos");
                    break;
                }
            }
            if (o) {
                if (s.pos >= d) break;
                continue;
            }
            s.pending += s.src[s.pos++];
        }
        s.pending && s.pushPending();
    }, r.prototype.parse = function(s, o, i, a) {
        var c, u, d, l = new this.State(s, o, i, a);
        for(this.tokenize(l), u = this.ruler2.getRules(""), d = u.length, c = 0; c < d; c++)u[c](l);
    }, r.prototype.State = Rme(), Xi = r, Xi;
}
var Yi, Hf;
function Bme() {
    return Hf || (Hf = 1, Yi = function Yi(e) {
        var t = {};
        e = e || {}, t.src_Any = lm().source, t.src_Cc = um().source, t.src_Z = dm().source, t.src_P = El().source, t.src_ZPCc = [
            t.src_Z,
            t.src_P,
            t.src_Cc
        ].join("|"), t.src_ZCc = [
            t.src_Z,
            t.src_Cc
        ].join("|");
        var n = "[><\uFF5C]";
        return t.src_pseudo_letter = "(?:(?!" + n + "|" + t.src_ZPCc + ")" + t.src_Any + ")", t.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)", t.src_auth = "(?:(?:(?!" + t.src_ZCc + "|[@/\\[\\]()]).)+@)?", t.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?", t.src_host_terminator = "(?=$|" + n + "|" + t.src_ZPCc + ")(?!" + (e["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + t.src_ZPCc + "))", t.src_path = "(?:[/?#](?:(?!" + t.src_ZCc + "|" + n + "|[()[\\]{}.,\"'?!\\-;]).|\\[(?:(?!" + t.src_ZCc + "|\\]).)*\\]|\\((?:(?!" + t.src_ZCc + "|[)]).)*\\)|\\{(?:(?!" + t.src_ZCc + '|[}]).)*\\}|\\"(?:(?!' + t.src_ZCc + '|["]).)+\\"|\\\'(?:(?!' + t.src_ZCc + "|[']).)+\\'|\\'(?=" + t.src_pseudo_letter + "|[-])|\\.{2,}[a-zA-Z0-9%/&]|\\.(?!" + t.src_ZCc + "|[.]|$)|" + (e["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" : "\\-+|") + ",(?!" + t.src_ZCc + "|$)|;(?!" + t.src_ZCc + "|$)|\\!+(?!" + t.src_ZCc + "|[!]|$)|\\?(?!" + t.src_ZCc + "|[?]|$))+|\\/)?", t.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*', t.src_xn = "xn--[a-z0-9\\-]{1,59}", t.src_domain_root = "(?:" + t.src_xn + "|" + t.src_pseudo_letter + "{1,63})", t.src_domain = "(?:" + t.src_xn + "|(?:" + t.src_pseudo_letter + ")|(?:" + t.src_pseudo_letter + "(?:-|" + t.src_pseudo_letter + "){0,61}" + t.src_pseudo_letter + "))", t.src_host = "(?:(?:(?:(?:" + t.src_domain + ")\\.)*" + t.src_domain + "))", t.tpl_host_fuzzy = "(?:" + t.src_ip4 + "|(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%)))", t.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%))", t.src_host_strict = t.src_host + t.src_host_terminator, t.tpl_host_fuzzy_strict = t.tpl_host_fuzzy + t.src_host_terminator, t.src_host_port_strict = t.src_host + t.src_port + t.src_host_terminator, t.tpl_host_port_fuzzy_strict = t.tpl_host_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_port_no_ip_fuzzy_strict = t.tpl_host_no_ip_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + t.src_ZPCc + "|>|$))", t.tpl_email_fuzzy = "(^|" + n + '|"|\\(|' + t.src_ZCc + ")(" + t.src_email_name + "@" + t.tpl_host_fuzzy_strict + ")", t.tpl_link_fuzzy = // but can start with > (markdown blockquote)
        "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + t.src_ZPCc + "))((?![$+<=>^`|\uFF5C])" + t.tpl_host_port_fuzzy_strict + t.src_path + ")", t.tpl_link_no_ip_fuzzy = // but can start with > (markdown blockquote)
        "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + t.src_ZPCc + "))((?![$+<=>^`|\uFF5C])" + t.tpl_host_port_no_ip_fuzzy_strict + t.src_path + ")", t;
    }), Yi;
}
var Ji, jf;
function zme() {
    if (jf) return Ji;
    jf = 1;
    function e(k) {
        var x = Array.prototype.slice.call(arguments, 1);
        return x.forEach(function(A) {
            A && Object.keys(A).forEach(function(S) {
                k[S] = A[S];
            });
        }), k;
    }
    function t(k) {
        return Object.prototype.toString.call(k);
    }
    function n(k) {
        return t(k) === "[object String]";
    }
    function r(k) {
        return t(k) === "[object Object]";
    }
    function s(k) {
        return t(k) === "[object RegExp]";
    }
    function o(k) {
        return t(k) === "[object Function]";
    }
    function i(k) {
        return k.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
    }
    var a = {
        fuzzyLink: !0,
        fuzzyEmail: !0,
        fuzzyIP: !1
    };
    function c(k) {
        return Object.keys(k || {}).reduce(function(x, A) {
            return x || a.hasOwnProperty(A);
        }, !1);
    }
    var u = {
        "http:": {
            validate: function validate(k, x, A) {
                var S = k.slice(x);
                return A.re.http || (A.re.http = new RegExp("^\\/\\/" + A.re.src_auth + A.re.src_host_port_strict + A.re.src_path, "i")), A.re.http.test(S) ? S.match(A.re.http)[0].length : 0;
            }
        },
        "https:": "http:",
        "ftp:": "http:",
        "//": {
            validate: function validate(k, x, A) {
                var S = k.slice(x);
                return A.re.no_http || (A.re.no_http = new RegExp("^" + A.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
                // with code comments
                "(?:localhost|(?:(?:" + A.re.src_domain + ")\\.)+" + A.re.src_domain_root + ")" + A.re.src_port + A.re.src_host_terminator + A.re.src_path, "i")), A.re.no_http.test(S) ? x >= 3 && k[x - 3] === ":" || x >= 3 && k[x - 3] === "/" ? 0 : S.match(A.re.no_http)[0].length : 0;
            }
        },
        "mailto:": {
            validate: function validate(k, x, A) {
                var S = k.slice(x);
                return A.re.mailto || (A.re.mailto = new RegExp("^" + A.re.src_email_name + "@" + A.re.src_host_strict, "i")), A.re.mailto.test(S) ? S.match(A.re.mailto)[0].length : 0;
            }
        }
    }, d = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]", l = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split("|");
    function m(k) {
        k.__index__ = -1, k.__text_cache__ = "";
    }
    function f(k) {
        return function(x, A) {
            var S = x.slice(A);
            return k.test(S) ? S.match(k)[0].length : 0;
        };
    }
    function v() {
        return function(k, x) {
            x.normalize(k);
        };
    }
    function g(k) {
        var x = k.re = Bme()(k.__opts__), A = k.__tlds__.slice();
        k.onCompile(), k.__tlds_replaced__ || A.push(d), A.push(x.src_xn), x.src_tlds = A.join("|");
        function S(R) {
            return R.replace("%TLDS%", x.src_tlds);
        }
        x.email_fuzzy = RegExp(S(x.tpl_email_fuzzy), "i"), x.link_fuzzy = RegExp(S(x.tpl_link_fuzzy), "i"), x.link_no_ip_fuzzy = RegExp(S(x.tpl_link_no_ip_fuzzy), "i"), x.host_fuzzy_test = RegExp(S(x.tpl_host_fuzzy_test), "i");
        var $ = [];
        k.__compiled__ = {};
        function M(R, B) {
            throw new Error('(LinkifyIt) Invalid schema "' + R + '": ' + B);
        }
        Object.keys(k.__schemas__).forEach(function(R) {
            var B = k.__schemas__[R];
            if (B !== null) {
                var H = {
                    validate: null,
                    link: null
                };
                if (k.__compiled__[R] = H, r(B)) {
                    s(B.validate) ? H.validate = f(B.validate) : o(B.validate) ? H.validate = B.validate : M(R, B), o(B.normalize) ? H.normalize = B.normalize : B.normalize ? M(R, B) : H.normalize = v();
                    return;
                }
                if (n(B)) {
                    $.push(R);
                    return;
                }
                M(R, B);
            }
        }), $.forEach(function(R) {
            k.__compiled__[k.__schemas__[R]] && (k.__compiled__[R].validate = k.__compiled__[k.__schemas__[R]].validate, k.__compiled__[R].normalize = k.__compiled__[k.__schemas__[R]].normalize);
        }), k.__compiled__[""] = {
            validate: null,
            normalize: v()
        };
        var P = Object.keys(k.__compiled__).filter(function(R) {
            return R.length > 0 && k.__compiled__[R];
        }).map(i).join("|");
        k.re.schema_test = RegExp("(^|(?!_)(?:[><\uFF5C]|" + x.src_ZPCc + "))(" + P + ")", "i"), k.re.schema_search = RegExp("(^|(?!_)(?:[><\uFF5C]|" + x.src_ZPCc + "))(" + P + ")", "ig"), k.re.schema_at_start = RegExp("^" + k.re.schema_search.source, "i"), k.re.pretest = RegExp("(" + k.re.schema_test.source + ")|(" + k.re.host_fuzzy_test.source + ")|@", "i"), m(k);
    }
    function b(k, x) {
        var A = k.__index__, S = k.__last_index__, $ = k.__text_cache__.slice(A, S);
        this.schema = k.__schema__.toLowerCase(), this.index = A + x, this.lastIndex = S + x, this.raw = $, this.text = $, this.url = $;
    }
    function h(k, x) {
        var A = new b(k, x);
        return k.__compiled__[A.schema].normalize(A, k), A;
    }
    function w(k, x) {
        if (!(this instanceof w)) return new w(k, x);
        x || c(k) && (x = k, k = {}), this.__opts__ = e({}, a, x), this.__index__ = -1, this.__last_index__ = -1, this.__schema__ = "", this.__text_cache__ = "", this.__schemas__ = e({}, u, k), this.__compiled__ = {}, this.__tlds__ = l, this.__tlds_replaced__ = !1, this.re = {}, g(this);
    }
    return w.prototype.add = function(x, A) {
        return this.__schemas__[x] = A, g(this), this;
    }, w.prototype.set = function(x) {
        return this.__opts__ = e(this.__opts__, x), this;
    }, w.prototype.test = function(x) {
        if (this.__text_cache__ = x, this.__index__ = -1, !x.length) return !1;
        var A, S, $, M, P, R, B, H, ie;
        if (this.re.schema_test.test(x)) {
            for(B = this.re.schema_search, B.lastIndex = 0; (A = B.exec(x)) !== null;)if (M = this.testSchemaAt(x, A[2], B.lastIndex), M) {
                this.__schema__ = A[2], this.__index__ = A.index + A[1].length, this.__last_index__ = A.index + A[0].length + M;
                break;
            }
        }
        return this.__opts__.fuzzyLink && this.__compiled__["http:"] && (H = x.search(this.re.host_fuzzy_test), H >= 0 && (this.__index__ < 0 || H < this.__index__) && (S = x.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null && (P = S.index + S[1].length, (this.__index__ < 0 || P < this.__index__) && (this.__schema__ = "", this.__index__ = P, this.__last_index__ = S.index + S[0].length))), this.__opts__.fuzzyEmail && this.__compiled__["mailto:"] && (ie = x.indexOf("@"), ie >= 0 && ($ = x.match(this.re.email_fuzzy)) !== null && (P = $.index + $[1].length, R = $.index + $[0].length, (this.__index__ < 0 || P < this.__index__ || P === this.__index__ && R > this.__last_index__) && (this.__schema__ = "mailto:", this.__index__ = P, this.__last_index__ = R))), this.__index__ >= 0;
    }, w.prototype.pretest = function(x) {
        return this.re.pretest.test(x);
    }, w.prototype.testSchemaAt = function(x, A, S) {
        return this.__compiled__[A.toLowerCase()] ? this.__compiled__[A.toLowerCase()].validate(x, S, this) : 0;
    }, w.prototype.match = function(x) {
        var A = 0, S = [];
        this.__index__ >= 0 && this.__text_cache__ === x && (S.push(h(this, A)), A = this.__last_index__);
        for(var $ = A ? x.slice(A) : x; this.test($);)S.push(h(this, A)), $ = $.slice(this.__last_index__), A += this.__last_index__;
        return S.length ? S : null;
    }, w.prototype.matchAtStart = function(x) {
        if (this.__text_cache__ = x, this.__index__ = -1, !x.length) return null;
        var A = this.re.schema_at_start.exec(x);
        if (!A) return null;
        var S = this.testSchemaAt(x, A[2], A[0].length);
        return S ? (this.__schema__ = A[2], this.__index__ = A.index + A[1].length, this.__last_index__ = A.index + A[0].length + S, h(this, 0)) : null;
    }, w.prototype.tlds = function(x, A) {
        return x = Array.isArray(x) ? x : [
            x
        ], A ? (this.__tlds__ = this.__tlds__.concat(x).sort().filter(function(S, $, M) {
            return S !== M[$ - 1];
        }).reverse(), g(this), this) : (this.__tlds__ = x.slice(), this.__tlds_replaced__ = !0, g(this), this);
    }, w.prototype.normalize = function(x) {
        x.schema || (x.url = "http://" + x.url), x.schema === "mailto:" && !/^mailto:/i.test(x.url) && (x.url = "mailto:" + x.url);
    }, w.prototype.onCompile = function() {}, Ji = w, Ji;
}
var Fr = {
    exports: {}
};
/*! https://mths.be/punycode v1.4.1 by @mathias */ var Dme = Fr.exports, Uf;
function Nme() {
    return Uf || (Uf = 1, function(e, t) {
        (function(n) {
            var r = t && !t.nodeType && t, s = e && !e.nodeType && e, o = (typeof pr === "undefined" ? "undefined" : (0, $6gBIz._)(pr)) == "object" && pr;
            (o.global === o || o.window === o || o.self === o) && (n = o);
            var i, a = 2147483647, c = 36, u = 1, d = 26, l = 38, m = 700, f = 72, v = 128, g = "-", b = /^xn--/, h = /[^\x20-\x7E]/, w = /[\x2E\u3002\uFF0E\uFF61]/g, k = {
                overflow: "Overflow: input needs wider integers to process",
                "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                "invalid-input": "Invalid input"
            }, x = c - u, A = Math.floor, S = String.fromCharCode, $;
            function M(T) {
                throw new RangeError(k[T]);
            }
            function P(T, W) {
                for(var V = T.length, se = []; V--;)se[V] = W(T[V]);
                return se;
            }
            function R(T, W) {
                var V = T.split("@"), se = "";
                V.length > 1 && (se = V[0] + "@", T = V[1]), T = T.replace(w, ".");
                var de = T.split("."), ve = P(de, W).join(".");
                return se + ve;
            }
            function B(T) {
                for(var W = [], V = 0, se = T.length, de, ve; V < se;)de = T.charCodeAt(V++), de >= 55296 && de <= 56319 && V < se ? (ve = T.charCodeAt(V++), (ve & 64512) == 56320 ? W.push(((de & 1023) << 10) + (ve & 1023) + 65536) : (W.push(de), V--)) : W.push(de);
                return W;
            }
            function H(T) {
                return P(T, function(W) {
                    var V = "";
                    return W > 65535 && (W -= 65536, V += S(W >>> 10 & 1023 | 55296), W = 56320 | W & 1023), V += S(W), V;
                }).join("");
            }
            function ie(T) {
                return T - 48 < 10 ? T - 22 : T - 65 < 26 ? T - 65 : T - 97 < 26 ? T - 97 : c;
            }
            function z(T, W) {
                return T + 22 + 75 * (T < 26) - ((W != 0) << 5);
            }
            function Q(T, W, V) {
                var se = 0;
                for(T = V ? A(T / m) : T >> 1, T += A(T / W); T > x * d >> 1; se += c)T = A(T / x);
                return A(se + (x + 1) * T / (T + l));
            }
            function N(T) {
                var W = [], V = T.length, se, de = 0, ve = v, we = f, Be, Oe, Ke, re, fe, Se, ze, Ge, Je;
                for(Be = T.lastIndexOf(g), Be < 0 && (Be = 0), Oe = 0; Oe < Be; ++Oe)T.charCodeAt(Oe) >= 128 && M("not-basic"), W.push(T.charCodeAt(Oe));
                for(Ke = Be > 0 ? Be + 1 : 0; Ke < V;){
                    for(re = de, fe = 1, Se = c; Ke >= V && M("invalid-input"), ze = ie(T.charCodeAt(Ke++)), (ze >= c || ze > A((a - de) / fe)) && M("overflow"), de += ze * fe, Ge = Se <= we ? u : Se >= we + d ? d : Se - we, !(ze < Ge); Se += c)Je = c - Ge, fe > A(a / Je) && M("overflow"), fe *= Je;
                    se = W.length + 1, we = Q(de - re, se, re == 0), A(de / se) > a - ve && M("overflow"), ve += A(de / se), de %= se, W.splice(de++, 0, ve);
                }
                return H(W);
            }
            function j(T) {
                var W, V, se, de, ve, we, Be, Oe, Ke, re, fe, Se = [], ze, Ge, Je, st;
                for(T = B(T), ze = T.length, W = v, V = 0, ve = f, we = 0; we < ze; ++we)fe = T[we], fe < 128 && Se.push(S(fe));
                for(se = de = Se.length, de && Se.push(g); se < ze;){
                    for(Be = a, we = 0; we < ze; ++we)fe = T[we], fe >= W && fe < Be && (Be = fe);
                    for(Ge = se + 1, Be - W > A((a - V) / Ge) && M("overflow"), V += (Be - W) * Ge, W = Be, we = 0; we < ze; ++we)if (fe = T[we], fe < W && ++V > a && M("overflow"), fe == W) {
                        for(Oe = V, Ke = c; re = Ke <= ve ? u : Ke >= ve + d ? d : Ke - ve, !(Oe < re); Ke += c)st = Oe - re, Je = c - re, Se.push(S(z(re + st % Je, 0))), Oe = A(st / Je);
                        Se.push(S(z(Oe, 0))), ve = Q(V, Ge, se == de), V = 0, ++se;
                    }
                    ++V, ++W;
                }
                return Se.join("");
            }
            function U(T) {
                return R(T, function(W) {
                    return b.test(W) ? N(W.slice(4).toLowerCase()) : W;
                });
            }
            function G(T) {
                return R(T, function(W) {
                    return h.test(W) ? "xn--" + j(W) : W;
                });
            }
            if (i = {
                /**
         * A string representing the current Punycode.js version number.
         * @memberOf punycode
         * @type String
         */ version: "1.4.1",
                /**
         * An object of methods to convert from JavaScript's internal character
         * representation (UCS-2) to Unicode code points, and back.
         * @see <https://mathiasbynens.be/notes/javascript-encoding>
         * @memberOf punycode
         * @type Object
         */ ucs2: {
                    decode: B,
                    encode: H
                },
                decode: N,
                encode: j,
                toASCII: G,
                toUnicode: U
            }, r && s) {
                if (e.exports == r) s.exports = i;
                else for($ in i)i.hasOwnProperty($) && (r[$] = i[$]);
            } else n.punycode = i;
        })(Dme);
    }(Fr, Fr.exports)), Fr.exports;
}
var Qi, Vf;
function qme() {
    return Vf || (Vf = 1, Qi = {
        options: {
            html: !1,
            // Enable HTML tags in source
            xhtmlOut: !1,
            // Use '/' to close single tags (<br />)
            breaks: !1,
            // Convert '\n' in paragraphs into <br>
            langPrefix: "language-",
            // CSS language prefix for fenced blocks
            linkify: !1,
            // autoconvert URL-like texts to links
            // Enable some language-neutral replacements + quotes beautification
            typographer: !1,
            // Double + single quotes replacement pairs, when typographer enabled,
            // and smartquotes on. Could be either a String or an Array.
            //
            // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
            // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
            quotes: "\u201C\u201D\u2018\u2019",
            /* “”‘’ */ // Highlighter function. Should return escaped HTML,
            // or '' if the source string is not changed and should be escaped externaly.
            // If result starts with <pre... internal wrapper is skipped.
            //
            // function (/*str, lang*/) { return ''; }
            //
            highlight: null,
            maxNesting: 100
        },
        components: {
            core: {},
            block: {},
            inline: {}
        }
    }), Qi;
}
var ea, Zf;
function Fme() {
    return Zf || (Zf = 1, ea = {
        options: {
            html: !1,
            // Enable HTML tags in source
            xhtmlOut: !1,
            // Use '/' to close single tags (<br />)
            breaks: !1,
            // Convert '\n' in paragraphs into <br>
            langPrefix: "language-",
            // CSS language prefix for fenced blocks
            linkify: !1,
            // autoconvert URL-like texts to links
            // Enable some language-neutral replacements + quotes beautification
            typographer: !1,
            // Double + single quotes replacement pairs, when typographer enabled,
            // and smartquotes on. Could be either a String or an Array.
            //
            // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
            // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
            quotes: "\u201C\u201D\u2018\u2019",
            /* “”‘’ */ // Highlighter function. Should return escaped HTML,
            // or '' if the source string is not changed and should be escaped externaly.
            // If result starts with <pre... internal wrapper is skipped.
            //
            // function (/*str, lang*/) { return ''; }
            //
            highlight: null,
            maxNesting: 20
        },
        components: {
            core: {
                rules: [
                    "normalize",
                    "block",
                    "inline",
                    "text_join"
                ]
            },
            block: {
                rules: [
                    "paragraph"
                ]
            },
            inline: {
                rules: [
                    "text"
                ],
                rules2: [
                    "balance_pairs",
                    "fragments_join"
                ]
            }
        }
    }), ea;
}
var ta, Wf;
function Hme() {
    return Wf || (Wf = 1, ta = {
        options: {
            html: !0,
            // Enable HTML tags in source
            xhtmlOut: !0,
            // Use '/' to close single tags (<br />)
            breaks: !1,
            // Convert '\n' in paragraphs into <br>
            langPrefix: "language-",
            // CSS language prefix for fenced blocks
            linkify: !1,
            // autoconvert URL-like texts to links
            // Enable some language-neutral replacements + quotes beautification
            typographer: !1,
            // Double + single quotes replacement pairs, when typographer enabled,
            // and smartquotes on. Could be either a String or an Array.
            //
            // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
            // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
            quotes: "\u201C\u201D\u2018\u2019",
            /* “”‘’ */ // Highlighter function. Should return escaped HTML,
            // or '' if the source string is not changed and should be escaped externaly.
            // If result starts with <pre... internal wrapper is skipped.
            //
            // function (/*str, lang*/) { return ''; }
            //
            highlight: null,
            maxNesting: 20
        },
        components: {
            core: {
                rules: [
                    "normalize",
                    "block",
                    "inline",
                    "text_join"
                ]
            },
            block: {
                rules: [
                    "blockquote",
                    "code",
                    "fence",
                    "heading",
                    "hr",
                    "html_block",
                    "lheading",
                    "list",
                    "reference",
                    "paragraph"
                ]
            },
            inline: {
                rules: [
                    "autolink",
                    "backticks",
                    "emphasis",
                    "entity",
                    "escape",
                    "html_inline",
                    "image",
                    "link",
                    "newline",
                    "text"
                ],
                rules2: [
                    "balance_pairs",
                    "emphasis",
                    "fragments_join"
                ]
            }
        }
    }), ta;
}
var na, Gf;
function jme() {
    if (Gf) return na;
    Gf = 1;
    var e = Pe(), t = Yge(), n = Jge(), r = ame(), s = wme(), o = Pme(), i = zme(), a = cm(), c = Nme(), u = {
        "default": qme(),
        zero: Fme(),
        commonmark: Hme()
    }, d = /^(vbscript|javascript|file|data):/, l = /^data:image\/(gif|png|jpeg|webp);/;
    function m(h) {
        var w = h.trim().toLowerCase();
        return d.test(w) ? !!l.test(w) : !0;
    }
    var f = [
        "http:",
        "https:",
        "mailto:"
    ];
    function v(h) {
        var w = a.parse(h, !0);
        if (w.hostname && (!w.protocol || f.indexOf(w.protocol) >= 0)) try {
            w.hostname = c.toASCII(w.hostname);
        } catch (e) {}
        return a.encode(a.format(w));
    }
    function g(h) {
        var w = a.parse(h, !0);
        if (w.hostname && (!w.protocol || f.indexOf(w.protocol) >= 0)) try {
            w.hostname = c.toUnicode(w.hostname);
        } catch (e) {}
        return a.decode(a.format(w), a.decode.defaultChars + "%");
    }
    function b(h, w) {
        if (!(this instanceof b)) return new b(h, w);
        w || e.isString(h) || (w = h || {}, h = "default"), this.inline = new o(), this.block = new s(), this.core = new r(), this.renderer = new n(), this.linkify = new i(), this.validateLink = m, this.normalizeLink = v, this.normalizeLinkText = g, this.utils = e, this.helpers = e.assign({}, t), this.options = {}, this.configure(h), w && this.set(w);
    }
    return b.prototype.set = function(h) {
        return e.assign(this.options, h), this;
    }, b.prototype.configure = function(h) {
        var w = this, k;
        if (e.isString(h) && (k = h, h = u[k], !h)) throw new Error('Wrong `markdown-it` preset "' + k + '", check name');
        if (!h) throw new Error("Wrong `markdown-it` preset, can't be empty");
        return h.options && w.set(h.options), h.components && Object.keys(h.components).forEach(function(x) {
            h.components[x].rules && w[x].ruler.enableOnly(h.components[x].rules), h.components[x].rules2 && w[x].ruler2.enableOnly(h.components[x].rules2);
        }), this;
    }, b.prototype.enable = function(h, w) {
        var k = [];
        Array.isArray(h) || (h = [
            h
        ]), [
            "core",
            "block",
            "inline"
        ].forEach(function(A) {
            k = k.concat(this[A].ruler.enable(h, !0));
        }, this), k = k.concat(this.inline.ruler2.enable(h, !0));
        var x = h.filter(function(A) {
            return k.indexOf(A) < 0;
        });
        if (x.length && !w) throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + x);
        return this;
    }, b.prototype.disable = function(h, w) {
        var k = [];
        Array.isArray(h) || (h = [
            h
        ]), [
            "core",
            "block",
            "inline"
        ].forEach(function(A) {
            k = k.concat(this[A].ruler.disable(h, !0));
        }, this), k = k.concat(this.inline.ruler2.disable(h, !0));
        var x = h.filter(function(A) {
            return k.indexOf(A) < 0;
        });
        if (x.length && !w) throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + x);
        return this;
    }, b.prototype.use = function(h) {
        var w = [
            this
        ].concat(Array.prototype.slice.call(arguments, 1));
        return h.apply(h, w), this;
    }, b.prototype.parse = function(h, w) {
        if (typeof h != "string") throw new Error("Input data should be a String");
        var k = new this.core.State(h, this, w);
        return this.core.process(k), k.tokens;
    }, b.prototype.render = function(h, w) {
        return w = w || {}, this.renderer.render(this.parse(h, w), this.options, w);
    }, b.prototype.parseInline = function(h, w) {
        var k = new this.core.State(h, this, w);
        return k.inlineMode = !0, this.core.process(k), k.tokens;
    }, b.prototype.renderInline = function(h, w) {
        return w = w || {}, this.renderer.render(this.parseInline(h, w), this.options, w);
    }, na = b, na;
}
var ra, Kf;
function Ume() {
    return Kf || (Kf = 1, ra = jme()), ra;
}
var Vme = Ume();
var pm = /* @__PURE__ */ Er(Vme), Zme = "\uD83D\uDE00", Wme = "\uD83D\uDE03", Gme = "\uD83D\uDE04", Kme = "\uD83D\uDE01", Xme = "\uD83D\uDE06", Yme = "\uD83D\uDE06", Jme = "\uD83D\uDE05", Qme = "\uD83E\uDD23", eve = "\uD83D\uDE02", tve = "\uD83D\uDE42", nve = "\uD83D\uDE43", rve = "\uD83D\uDE09", ove = "\uD83D\uDE0A", sve = "\uD83D\uDE07", ive = "\uD83E\uDD70", ave = "\uD83D\uDE0D", cve = "\uD83E\uDD29", lve = "\uD83D\uDE18", uve = "\uD83D\uDE17", dve = "\u263A\uFE0F", fve = "\uD83D\uDE1A", pve = "\uD83D\uDE19", hve = "\uD83E\uDD72", gve = "\uD83D\uDE0B", mve = "\uD83D\uDE1B", vve = "\uD83D\uDE1C", _ve = "\uD83E\uDD2A", bve = "\uD83D\uDE1D", yve = "\uD83E\uDD11", wve = "\uD83E\uDD17", kve = "\uD83E\uDD2D", xve = "\uD83E\uDD2B", Cve = "\uD83E\uDD14", Sve = "\uD83E\uDD10", Eve = "\uD83E\uDD28", Ave = "\uD83D\uDE10", $ve = "\uD83D\uDE11", Mve = "\uD83D\uDE36", Ive = "\uD83D\uDE0F", Tve = "\uD83D\uDE12", Lve = "\uD83D\uDE44", Ove = "\uD83D\uDE2C", Rve = "\uD83E\uDD25", Pve = "\uD83D\uDE0C", Bve = "\uD83D\uDE14", zve = "\uD83D\uDE2A", Dve = "\uD83E\uDD24", Nve = "\uD83D\uDE34", qve = "\uD83D\uDE37", Fve = "\uD83E\uDD12", Hve = "\uD83E\uDD15", jve = "\uD83E\uDD22", Uve = "\uD83E\uDD2E", Vve = "\uD83E\uDD27", Zve = "\uD83E\uDD75", Wve = "\uD83E\uDD76", Gve = "\uD83E\uDD74", Kve = "\uD83D\uDE35", Xve = "\uD83E\uDD2F", Yve = "\uD83E\uDD20", Jve = "\uD83E\uDD73", Qve = "\uD83E\uDD78", e_e = "\uD83D\uDE0E", t_e = "\uD83E\uDD13", n_e = "\uD83E\uDDD0", r_e = "\uD83D\uDE15", o_e = "\uD83D\uDE1F", s_e = "\uD83D\uDE41", i_e = "\u2639\uFE0F", a_e = "\uD83D\uDE2E", c_e = "\uD83D\uDE2F", l_e = "\uD83D\uDE32", u_e = "\uD83D\uDE33", d_e = "\uD83E\uDD7A", f_e = "\uD83D\uDE26", p_e = "\uD83D\uDE27", h_e = "\uD83D\uDE28", g_e = "\uD83D\uDE30", m_e = "\uD83D\uDE25", v_e = "\uD83D\uDE22", __e = "\uD83D\uDE2D", b_e = "\uD83D\uDE31", y_e = "\uD83D\uDE16", w_e = "\uD83D\uDE23", k_e = "\uD83D\uDE1E", x_e = "\uD83D\uDE13", C_e = "\uD83D\uDE29", S_e = "\uD83D\uDE2B", E_e = "\uD83E\uDD71", A_e = "\uD83D\uDE24", $_e = "\uD83D\uDE21", M_e = "\uD83D\uDE21", I_e = "\uD83D\uDE20", T_e = "\uD83E\uDD2C", L_e = "\uD83D\uDE08", O_e = "\uD83D\uDC7F", R_e = "\uD83D\uDC80", P_e = "\u2620\uFE0F", B_e = "\uD83D\uDCA9", z_e = "\uD83D\uDCA9", D_e = "\uD83D\uDCA9", N_e = "\uD83E\uDD21", q_e = "\uD83D\uDC79", F_e = "\uD83D\uDC7A", H_e = "\uD83D\uDC7B", j_e = "\uD83D\uDC7D", U_e = "\uD83D\uDC7E", V_e = "\uD83E\uDD16", Z_e = "\uD83D\uDE3A", W_e = "\uD83D\uDE38", G_e = "\uD83D\uDE39", K_e = "\uD83D\uDE3B", X_e = "\uD83D\uDE3C", Y_e = "\uD83D\uDE3D", J_e = "\uD83D\uDE40", Q_e = "\uD83D\uDE3F", ebe = "\uD83D\uDE3E", tbe = "\uD83D\uDE48", nbe = "\uD83D\uDE49", rbe = "\uD83D\uDE4A", obe = "\uD83D\uDC8B", sbe = "\uD83D\uDC8C", ibe = "\uD83D\uDC98", abe = "\uD83D\uDC9D", cbe = "\uD83D\uDC96", lbe = "\uD83D\uDC97", ube = "\uD83D\uDC93", dbe = "\uD83D\uDC9E", fbe = "\uD83D\uDC95", pbe = "\uD83D\uDC9F", hbe = "\u2763\uFE0F", gbe = "\uD83D\uDC94", mbe = "\u2764\uFE0F", vbe = "\uD83E\uDDE1", _be = "\uD83D\uDC9B", bbe = "\uD83D\uDC9A", ybe = "\uD83D\uDC99", wbe = "\uD83D\uDC9C", kbe = "\uD83E\uDD0E", xbe = "\uD83D\uDDA4", Cbe = "\uD83E\uDD0D", Sbe = "\uD83D\uDCA2", Ebe = "\uD83D\uDCA5", Abe = "\uD83D\uDCA5", $be = "\uD83D\uDCAB", Mbe = "\uD83D\uDCA6", Ibe = "\uD83D\uDCA8", Tbe = "\uD83D\uDD73\uFE0F", Lbe = "\uD83D\uDCA3", Obe = "\uD83D\uDCAC", Rbe = "\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8\uFE0F", Pbe = "\uD83D\uDDE8\uFE0F", Bbe = "\uD83D\uDDEF\uFE0F", zbe = "\uD83D\uDCAD", Dbe = "\uD83D\uDCA4", Nbe = "\uD83D\uDC4B", qbe = "\uD83E\uDD1A", Fbe = "\uD83D\uDD90\uFE0F", Hbe = "\u270B", jbe = "\u270B", Ube = "\uD83D\uDD96", Vbe = "\uD83D\uDC4C", Zbe = "\uD83E\uDD0C", Wbe = "\uD83E\uDD0F", Gbe = "\u270C\uFE0F", Kbe = "\uD83E\uDD1E", Xbe = "\uD83E\uDD1F", Ybe = "\uD83E\uDD18", Jbe = "\uD83E\uDD19", Qbe = "\uD83D\uDC48", eye = "\uD83D\uDC49", tye = "\uD83D\uDC46", nye = "\uD83D\uDD95", rye = "\uD83D\uDD95", oye = "\uD83D\uDC47", sye = "\u261D\uFE0F", iye = "\uD83D\uDC4D", aye = "\uD83D\uDC4E", cye = "\u270A", lye = "\u270A", uye = "\uD83D\uDC4A", dye = "\uD83D\uDC4A", fye = "\uD83D\uDC4A", pye = "\uD83E\uDD1B", hye = "\uD83E\uDD1C", gye = "\uD83D\uDC4F", mye = "\uD83D\uDE4C", vye = "\uD83D\uDC50", _ye = "\uD83E\uDD32", bye = "\uD83E\uDD1D", yye = "\uD83D\uDE4F", wye = "\u270D\uFE0F", kye = "\uD83D\uDC85", xye = "\uD83E\uDD33", Cye = "\uD83D\uDCAA", Sye = "\uD83E\uDDBE", Eye = "\uD83E\uDDBF", Aye = "\uD83E\uDDB5", $ye = "\uD83E\uDDB6", Mye = "\uD83D\uDC42", Iye = "\uD83E\uDDBB", Tye = "\uD83D\uDC43", Lye = "\uD83E\uDDE0", Oye = "\uD83E\uDEC0", Rye = "\uD83E\uDEC1", Pye = "\uD83E\uDDB7", Bye = "\uD83E\uDDB4", zye = "\uD83D\uDC40", Dye = "\uD83D\uDC41\uFE0F", Nye = "\uD83D\uDC45", qye = "\uD83D\uDC44", Fye = "\uD83D\uDC76", Hye = "\uD83E\uDDD2", jye = "\uD83D\uDC66", Uye = "\uD83D\uDC67", Vye = "\uD83E\uDDD1", Zye = "\uD83D\uDC71", Wye = "\uD83D\uDC68", Gye = "\uD83E\uDDD4", Kye = "\uD83D\uDC68\u200D\uD83E\uDDB0", Xye = "\uD83D\uDC68\u200D\uD83E\uDDB1", Yye = "\uD83D\uDC68\u200D\uD83E\uDDB3", Jye = "\uD83D\uDC68\u200D\uD83E\uDDB2", Qye = "\uD83D\uDC69", ewe = "\uD83D\uDC69\u200D\uD83E\uDDB0", twe = "\uD83E\uDDD1\u200D\uD83E\uDDB0", nwe = "\uD83D\uDC69\u200D\uD83E\uDDB1", rwe = "\uD83E\uDDD1\u200D\uD83E\uDDB1", owe = "\uD83D\uDC69\u200D\uD83E\uDDB3", swe = "\uD83E\uDDD1\u200D\uD83E\uDDB3", iwe = "\uD83D\uDC69\u200D\uD83E\uDDB2", awe = "\uD83E\uDDD1\u200D\uD83E\uDDB2", cwe = "\uD83D\uDC71\u200D\u2640\uFE0F", lwe = "\uD83D\uDC71\u200D\u2640\uFE0F", uwe = "\uD83D\uDC71\u200D\u2642\uFE0F", dwe = "\uD83E\uDDD3", fwe = "\uD83D\uDC74", pwe = "\uD83D\uDC75", hwe = "\uD83D\uDE4D", gwe = "\uD83D\uDE4D\u200D\u2642\uFE0F", mwe = "\uD83D\uDE4D\u200D\u2640\uFE0F", vwe = "\uD83D\uDE4E", _we = "\uD83D\uDE4E\u200D\u2642\uFE0F", bwe = "\uD83D\uDE4E\u200D\u2640\uFE0F", ywe = "\uD83D\uDE45", wwe = "\uD83D\uDE45\u200D\u2642\uFE0F", kwe = "\uD83D\uDE45\u200D\u2642\uFE0F", xwe = "\uD83D\uDE45\u200D\u2640\uFE0F", Cwe = "\uD83D\uDE45\u200D\u2640\uFE0F", Swe = "\uD83D\uDE46", Ewe = "\uD83D\uDE46\u200D\u2642\uFE0F", Awe = "\uD83D\uDE46\u200D\u2640\uFE0F", $we = "\uD83D\uDC81", Mwe = "\uD83D\uDC81", Iwe = "\uD83D\uDC81\u200D\u2642\uFE0F", Twe = "\uD83D\uDC81\u200D\u2642\uFE0F", Lwe = "\uD83D\uDC81\u200D\u2640\uFE0F", Owe = "\uD83D\uDC81\u200D\u2640\uFE0F", Rwe = "\uD83D\uDE4B", Pwe = "\uD83D\uDE4B\u200D\u2642\uFE0F", Bwe = "\uD83D\uDE4B\u200D\u2640\uFE0F", zwe = "\uD83E\uDDCF", Dwe = "\uD83E\uDDCF\u200D\u2642\uFE0F", Nwe = "\uD83E\uDDCF\u200D\u2640\uFE0F", qwe = "\uD83D\uDE47", Fwe = "\uD83D\uDE47\u200D\u2642\uFE0F", Hwe = "\uD83D\uDE47\u200D\u2640\uFE0F", jwe = "\uD83E\uDD26", Uwe = "\uD83E\uDD26\u200D\u2642\uFE0F", Vwe = "\uD83E\uDD26\u200D\u2640\uFE0F", Zwe = "\uD83E\uDD37", Wwe = "\uD83E\uDD37\u200D\u2642\uFE0F", Gwe = "\uD83E\uDD37\u200D\u2640\uFE0F", Kwe = "\uD83E\uDDD1\u200D\u2695\uFE0F", Xwe = "\uD83D\uDC68\u200D\u2695\uFE0F", Ywe = "\uD83D\uDC69\u200D\u2695\uFE0F", Jwe = "\uD83E\uDDD1\u200D\uD83C\uDF93", Qwe = "\uD83D\uDC68\u200D\uD83C\uDF93", eke = "\uD83D\uDC69\u200D\uD83C\uDF93", tke = "\uD83E\uDDD1\u200D\uD83C\uDFEB", nke = "\uD83D\uDC68\u200D\uD83C\uDFEB", rke = "\uD83D\uDC69\u200D\uD83C\uDFEB", oke = "\uD83E\uDDD1\u200D\u2696\uFE0F", ske = "\uD83D\uDC68\u200D\u2696\uFE0F", ike = "\uD83D\uDC69\u200D\u2696\uFE0F", ake = "\uD83E\uDDD1\u200D\uD83C\uDF3E", cke = "\uD83D\uDC68\u200D\uD83C\uDF3E", lke = "\uD83D\uDC69\u200D\uD83C\uDF3E", uke = "\uD83E\uDDD1\u200D\uD83C\uDF73", dke = "\uD83D\uDC68\u200D\uD83C\uDF73", fke = "\uD83D\uDC69\u200D\uD83C\uDF73", pke = "\uD83E\uDDD1\u200D\uD83D\uDD27", hke = "\uD83D\uDC68\u200D\uD83D\uDD27", gke = "\uD83D\uDC69\u200D\uD83D\uDD27", mke = "\uD83E\uDDD1\u200D\uD83C\uDFED", vke = "\uD83D\uDC68\u200D\uD83C\uDFED", _ke = "\uD83D\uDC69\u200D\uD83C\uDFED", bke = "\uD83E\uDDD1\u200D\uD83D\uDCBC", yke = "\uD83D\uDC68\u200D\uD83D\uDCBC", wke = "\uD83D\uDC69\u200D\uD83D\uDCBC", kke = "\uD83E\uDDD1\u200D\uD83D\uDD2C", xke = "\uD83D\uDC68\u200D\uD83D\uDD2C", Cke = "\uD83D\uDC69\u200D\uD83D\uDD2C", Ske = "\uD83E\uDDD1\u200D\uD83D\uDCBB", Eke = "\uD83D\uDC68\u200D\uD83D\uDCBB", Ake = "\uD83D\uDC69\u200D\uD83D\uDCBB", $ke = "\uD83E\uDDD1\u200D\uD83C\uDFA4", Mke = "\uD83D\uDC68\u200D\uD83C\uDFA4", Ike = "\uD83D\uDC69\u200D\uD83C\uDFA4", Tke = "\uD83E\uDDD1\u200D\uD83C\uDFA8", Lke = "\uD83D\uDC68\u200D\uD83C\uDFA8", Oke = "\uD83D\uDC69\u200D\uD83C\uDFA8", Rke = "\uD83E\uDDD1\u200D\u2708\uFE0F", Pke = "\uD83D\uDC68\u200D\u2708\uFE0F", Bke = "\uD83D\uDC69\u200D\u2708\uFE0F", zke = "\uD83E\uDDD1\u200D\uD83D\uDE80", Dke = "\uD83D\uDC68\u200D\uD83D\uDE80", Nke = "\uD83D\uDC69\u200D\uD83D\uDE80", qke = "\uD83E\uDDD1\u200D\uD83D\uDE92", Fke = "\uD83D\uDC68\u200D\uD83D\uDE92", Hke = "\uD83D\uDC69\u200D\uD83D\uDE92", jke = "\uD83D\uDC6E", Uke = "\uD83D\uDC6E", Vke = "\uD83D\uDC6E\u200D\u2642\uFE0F", Zke = "\uD83D\uDC6E\u200D\u2640\uFE0F", Wke = "\uD83D\uDD75\uFE0F", Gke = "\uD83D\uDD75\uFE0F\u200D\u2642\uFE0F", Kke = "\uD83D\uDD75\uFE0F\u200D\u2640\uFE0F", Xke = "\uD83D\uDC82", Yke = "\uD83D\uDC82\u200D\u2642\uFE0F", Jke = "\uD83D\uDC82\u200D\u2640\uFE0F", Qke = "\uD83E\uDD77", e4e = "\uD83D\uDC77", t4e = "\uD83D\uDC77\u200D\u2642\uFE0F", n4e = "\uD83D\uDC77\u200D\u2640\uFE0F", r4e = "\uD83E\uDD34", o4e = "\uD83D\uDC78", s4e = "\uD83D\uDC73", i4e = "\uD83D\uDC73\u200D\u2642\uFE0F", a4e = "\uD83D\uDC73\u200D\u2640\uFE0F", c4e = "\uD83D\uDC72", l4e = "\uD83E\uDDD5", u4e = "\uD83E\uDD35", d4e = "\uD83E\uDD35\u200D\u2642\uFE0F", f4e = "\uD83E\uDD35\u200D\u2640\uFE0F", p4e = "\uD83D\uDC70", h4e = "\uD83D\uDC70\u200D\u2642\uFE0F", g4e = "\uD83D\uDC70\u200D\u2640\uFE0F", m4e = "\uD83D\uDC70\u200D\u2640\uFE0F", v4e = "\uD83E\uDD30", _4e = "\uD83E\uDD31", b4e = "\uD83D\uDC69\u200D\uD83C\uDF7C", y4e = "\uD83D\uDC68\u200D\uD83C\uDF7C", w4e = "\uD83E\uDDD1\u200D\uD83C\uDF7C", k4e = "\uD83D\uDC7C", x4e = "\uD83C\uDF85", C4e = "\uD83E\uDD36", S4e = "\uD83E\uDDD1\u200D\uD83C\uDF84", E4e = "\uD83E\uDDB8", A4e = "\uD83E\uDDB8\u200D\u2642\uFE0F", $4e = "\uD83E\uDDB8\u200D\u2640\uFE0F", M4e = "\uD83E\uDDB9", I4e = "\uD83E\uDDB9\u200D\u2642\uFE0F", T4e = "\uD83E\uDDB9\u200D\u2640\uFE0F", L4e = "\uD83E\uDDD9", O4e = "\uD83E\uDDD9\u200D\u2642\uFE0F", R4e = "\uD83E\uDDD9\u200D\u2640\uFE0F", P4e = "\uD83E\uDDDA", B4e = "\uD83E\uDDDA\u200D\u2642\uFE0F", z4e = "\uD83E\uDDDA\u200D\u2640\uFE0F", D4e = "\uD83E\uDDDB", N4e = "\uD83E\uDDDB\u200D\u2642\uFE0F", q4e = "\uD83E\uDDDB\u200D\u2640\uFE0F", F4e = "\uD83E\uDDDC", H4e = "\uD83E\uDDDC\u200D\u2642\uFE0F", j4e = "\uD83E\uDDDC\u200D\u2640\uFE0F", U4e = "\uD83E\uDDDD", V4e = "\uD83E\uDDDD\u200D\u2642\uFE0F", Z4e = "\uD83E\uDDDD\u200D\u2640\uFE0F", W4e = "\uD83E\uDDDE", G4e = "\uD83E\uDDDE\u200D\u2642\uFE0F", K4e = "\uD83E\uDDDE\u200D\u2640\uFE0F", X4e = "\uD83E\uDDDF", Y4e = "\uD83E\uDDDF\u200D\u2642\uFE0F", J4e = "\uD83E\uDDDF\u200D\u2640\uFE0F", Q4e = "\uD83D\uDC86", e3e = "\uD83D\uDC86\u200D\u2642\uFE0F", t3e = "\uD83D\uDC86\u200D\u2640\uFE0F", n3e = "\uD83D\uDC87", r3e = "\uD83D\uDC87\u200D\u2642\uFE0F", o3e = "\uD83D\uDC87\u200D\u2640\uFE0F", s3e = "\uD83D\uDEB6", i3e = "\uD83D\uDEB6\u200D\u2642\uFE0F", a3e = "\uD83D\uDEB6\u200D\u2640\uFE0F", c3e = "\uD83E\uDDCD", l3e = "\uD83E\uDDCD\u200D\u2642\uFE0F", u3e = "\uD83E\uDDCD\u200D\u2640\uFE0F", d3e = "\uD83E\uDDCE", f3e = "\uD83E\uDDCE\u200D\u2642\uFE0F", p3e = "\uD83E\uDDCE\u200D\u2640\uFE0F", h3e = "\uD83E\uDDD1\u200D\uD83E\uDDAF", g3e = "\uD83D\uDC68\u200D\uD83E\uDDAF", m3e = "\uD83D\uDC69\u200D\uD83E\uDDAF", v3e = "\uD83E\uDDD1\u200D\uD83E\uDDBC", _3e = "\uD83D\uDC68\u200D\uD83E\uDDBC", b3e = "\uD83D\uDC69\u200D\uD83E\uDDBC", y3e = "\uD83E\uDDD1\u200D\uD83E\uDDBD", w3e = "\uD83D\uDC68\u200D\uD83E\uDDBD", k3e = "\uD83D\uDC69\u200D\uD83E\uDDBD", x3e = "\uD83C\uDFC3", C3e = "\uD83C\uDFC3", S3e = "\uD83C\uDFC3\u200D\u2642\uFE0F", E3e = "\uD83C\uDFC3\u200D\u2640\uFE0F", A3e = "\uD83D\uDC83", $3e = "\uD83D\uDC83", M3e = "\uD83D\uDD7A", I3e = "\uD83D\uDD74\uFE0F", T3e = "\uD83D\uDC6F", L3e = "\uD83D\uDC6F\u200D\u2642\uFE0F", O3e = "\uD83D\uDC6F\u200D\u2640\uFE0F", R3e = "\uD83E\uDDD6", P3e = "\uD83E\uDDD6\u200D\u2642\uFE0F", B3e = "\uD83E\uDDD6\u200D\u2640\uFE0F", z3e = "\uD83E\uDDD7", D3e = "\uD83E\uDDD7\u200D\u2642\uFE0F", N3e = "\uD83E\uDDD7\u200D\u2640\uFE0F", q3e = "\uD83E\uDD3A", F3e = "\uD83C\uDFC7", H3e = "\u26F7\uFE0F", j3e = "\uD83C\uDFC2", U3e = "\uD83C\uDFCC\uFE0F", V3e = "\uD83C\uDFCC\uFE0F\u200D\u2642\uFE0F", Z3e = "\uD83C\uDFCC\uFE0F\u200D\u2640\uFE0F", W3e = "\uD83C\uDFC4", G3e = "\uD83C\uDFC4\u200D\u2642\uFE0F", K3e = "\uD83C\uDFC4\u200D\u2640\uFE0F", X3e = "\uD83D\uDEA3", Y3e = "\uD83D\uDEA3\u200D\u2642\uFE0F", J3e = "\uD83D\uDEA3\u200D\u2640\uFE0F", Q3e = "\uD83C\uDFCA", exe = "\uD83C\uDFCA\u200D\u2642\uFE0F", txe = "\uD83C\uDFCA\u200D\u2640\uFE0F", nxe = "\u26F9\uFE0F", rxe = "\u26F9\uFE0F\u200D\u2642\uFE0F", oxe = "\u26F9\uFE0F\u200D\u2642\uFE0F", sxe = "\u26F9\uFE0F\u200D\u2640\uFE0F", ixe = "\u26F9\uFE0F\u200D\u2640\uFE0F", axe = "\uD83C\uDFCB\uFE0F", cxe = "\uD83C\uDFCB\uFE0F\u200D\u2642\uFE0F", lxe = "\uD83C\uDFCB\uFE0F\u200D\u2640\uFE0F", uxe = "\uD83D\uDEB4", dxe = "\uD83D\uDEB4\u200D\u2642\uFE0F", fxe = "\uD83D\uDEB4\u200D\u2640\uFE0F", pxe = "\uD83D\uDEB5", hxe = "\uD83D\uDEB5\u200D\u2642\uFE0F", gxe = "\uD83D\uDEB5\u200D\u2640\uFE0F", mxe = "\uD83E\uDD38", vxe = "\uD83E\uDD38\u200D\u2642\uFE0F", _xe = "\uD83E\uDD38\u200D\u2640\uFE0F", bxe = "\uD83E\uDD3C", yxe = "\uD83E\uDD3C\u200D\u2642\uFE0F", wxe = "\uD83E\uDD3C\u200D\u2640\uFE0F", kxe = "\uD83E\uDD3D", xxe = "\uD83E\uDD3D\u200D\u2642\uFE0F", Cxe = "\uD83E\uDD3D\u200D\u2640\uFE0F", Sxe = "\uD83E\uDD3E", Exe = "\uD83E\uDD3E\u200D\u2642\uFE0F", Axe = "\uD83E\uDD3E\u200D\u2640\uFE0F", $xe = "\uD83E\uDD39", Mxe = "\uD83E\uDD39\u200D\u2642\uFE0F", Ixe = "\uD83E\uDD39\u200D\u2640\uFE0F", Txe = "\uD83E\uDDD8", Lxe = "\uD83E\uDDD8\u200D\u2642\uFE0F", Oxe = "\uD83E\uDDD8\u200D\u2640\uFE0F", Rxe = "\uD83D\uDEC0", Pxe = "\uD83D\uDECC", Bxe = "\uD83E\uDDD1\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1", zxe = "\uD83D\uDC6D", Dxe = "\uD83D\uDC6B", Nxe = "\uD83D\uDC6C", qxe = "\uD83D\uDC8F", Fxe = "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68", Hxe = "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68", jxe = "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69", Uxe = "\uD83D\uDC91", Vxe = "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC68", Zxe = "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC68", Wxe = "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC69", Gxe = "\uD83D\uDC6A", Kxe = "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66", Xxe = "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67", Yxe = "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66", Jxe = "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66", Qxe = "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67", eCe = "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66", tCe = "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67", nCe = "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66", rCe = "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66", oCe = "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67", sCe = "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66", iCe = "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67", aCe = "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66", cCe = "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66", lCe = "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67", uCe = "\uD83D\uDC68\u200D\uD83D\uDC66", dCe = "\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66", fCe = "\uD83D\uDC68\u200D\uD83D\uDC67", pCe = "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66", hCe = "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67", gCe = "\uD83D\uDC69\u200D\uD83D\uDC66", mCe = "\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66", vCe = "\uD83D\uDC69\u200D\uD83D\uDC67", _Ce = "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66", bCe = "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67", yCe = "\uD83D\uDDE3\uFE0F", wCe = "\uD83D\uDC64", kCe = "\uD83D\uDC65", xCe = "\uD83E\uDEC2", CCe = "\uD83D\uDC63", SCe = "\uD83D\uDC35", ECe = "\uD83D\uDC12", ACe = "\uD83E\uDD8D", $Ce = "\uD83E\uDDA7", MCe = "\uD83D\uDC36", ICe = "\uD83D\uDC15", TCe = "\uD83E\uDDAE", LCe = "\uD83D\uDC15\u200D\uD83E\uDDBA", OCe = "\uD83D\uDC29", RCe = "\uD83D\uDC3A", PCe = "\uD83E\uDD8A", BCe = "\uD83E\uDD9D", zCe = "\uD83D\uDC31", DCe = "\uD83D\uDC08", NCe = "\uD83D\uDC08\u200D\u2B1B", qCe = "\uD83E\uDD81", FCe = "\uD83D\uDC2F", HCe = "\uD83D\uDC05", jCe = "\uD83D\uDC06", UCe = "\uD83D\uDC34", VCe = "\uD83D\uDC0E", ZCe = "\uD83E\uDD84", WCe = "\uD83E\uDD93", GCe = "\uD83E\uDD8C", KCe = "\uD83E\uDDAC", XCe = "\uD83D\uDC2E", YCe = "\uD83D\uDC02", JCe = "\uD83D\uDC03", QCe = "\uD83D\uDC04", e6e = "\uD83D\uDC37", t6e = "\uD83D\uDC16", n6e = "\uD83D\uDC17", r6e = "\uD83D\uDC3D", o6e = "\uD83D\uDC0F", s6e = "\uD83D\uDC11", i6e = "\uD83D\uDC10", a6e = "\uD83D\uDC2A", c6e = "\uD83D\uDC2B", l6e = "\uD83E\uDD99", u6e = "\uD83E\uDD92", d6e = "\uD83D\uDC18", f6e = "\uD83E\uDDA3", p6e = "\uD83E\uDD8F", h6e = "\uD83E\uDD9B", g6e = "\uD83D\uDC2D", m6e = "\uD83D\uDC01", v6e = "\uD83D\uDC00", _6e = "\uD83D\uDC39", b6e = "\uD83D\uDC30", y6e = "\uD83D\uDC07", w6e = "\uD83D\uDC3F\uFE0F", k6e = "\uD83E\uDDAB", x6e = "\uD83E\uDD94", C6e = "\uD83E\uDD87", S6e = "\uD83D\uDC3B", E6e = "\uD83D\uDC3B\u200D\u2744\uFE0F", A6e = "\uD83D\uDC28", $6e = "\uD83D\uDC3C", M6e = "\uD83E\uDDA5", I6e = "\uD83E\uDDA6", T6e = "\uD83E\uDDA8", L6e = "\uD83E\uDD98", O6e = "\uD83E\uDDA1", R6e = "\uD83D\uDC3E", P6e = "\uD83D\uDC3E", B6e = "\uD83E\uDD83", z6e = "\uD83D\uDC14", D6e = "\uD83D\uDC13", N6e = "\uD83D\uDC23", q6e = "\uD83D\uDC24", F6e = "\uD83D\uDC25", H6e = "\uD83D\uDC26", j6e = "\uD83D\uDC27", U6e = "\uD83D\uDD4A\uFE0F", V6e = "\uD83E\uDD85", Z6e = "\uD83E\uDD86", W6e = "\uD83E\uDDA2", G6e = "\uD83E\uDD89", K6e = "\uD83E\uDDA4", X6e = "\uD83E\uDEB6", Y6e = "\uD83E\uDDA9", J6e = "\uD83E\uDD9A", Q6e = "\uD83E\uDD9C", e5e = "\uD83D\uDC38", t5e = "\uD83D\uDC0A", n5e = "\uD83D\uDC22", r5e = "\uD83E\uDD8E", o5e = "\uD83D\uDC0D", s5e = "\uD83D\uDC32", i5e = "\uD83D\uDC09", a5e = "\uD83E\uDD95", c5e = "\uD83D\uDC33", l5e = "\uD83D\uDC0B", u5e = "\uD83D\uDC2C", d5e = "\uD83D\uDC2C", f5e = "\uD83E\uDDAD", p5e = "\uD83D\uDC1F", h5e = "\uD83D\uDC20", g5e = "\uD83D\uDC21", m5e = "\uD83E\uDD88", v5e = "\uD83D\uDC19", _5e = "\uD83D\uDC1A", b5e = "\uD83D\uDC0C", y5e = "\uD83E\uDD8B", w5e = "\uD83D\uDC1B", k5e = "\uD83D\uDC1C", x5e = "\uD83D\uDC1D", C5e = "\uD83D\uDC1D", S5e = "\uD83E\uDEB2", E5e = "\uD83D\uDC1E", A5e = "\uD83E\uDD97", $5e = "\uD83E\uDEB3", M5e = "\uD83D\uDD77\uFE0F", I5e = "\uD83D\uDD78\uFE0F", T5e = "\uD83E\uDD82", L5e = "\uD83E\uDD9F", O5e = "\uD83E\uDEB0", R5e = "\uD83E\uDEB1", P5e = "\uD83E\uDDA0", B5e = "\uD83D\uDC90", z5e = "\uD83C\uDF38", D5e = "\uD83D\uDCAE", N5e = "\uD83C\uDFF5\uFE0F", q5e = "\uD83C\uDF39", F5e = "\uD83E\uDD40", H5e = "\uD83C\uDF3A", j5e = "\uD83C\uDF3B", U5e = "\uD83C\uDF3C", V5e = "\uD83C\uDF37", Z5e = "\uD83C\uDF31", W5e = "\uD83E\uDEB4", G5e = "\uD83C\uDF32", K5e = "\uD83C\uDF33", X5e = "\uD83C\uDF34", Y5e = "\uD83C\uDF35", J5e = "\uD83C\uDF3E", Q5e = "\uD83C\uDF3F", e8e = "\u2618\uFE0F", t8e = "\uD83C\uDF40", n8e = "\uD83C\uDF41", r8e = "\uD83C\uDF42", o8e = "\uD83C\uDF43", s8e = "\uD83C\uDF47", i8e = "\uD83C\uDF48", a8e = "\uD83C\uDF49", c8e = "\uD83C\uDF4A", l8e = "\uD83C\uDF4A", u8e = "\uD83C\uDF4A", d8e = "\uD83C\uDF4B", f8e = "\uD83C\uDF4C", p8e = "\uD83C\uDF4D", h8e = "\uD83E\uDD6D", g8e = "\uD83C\uDF4E", m8e = "\uD83C\uDF4F", v8e = "\uD83C\uDF50", _8e = "\uD83C\uDF51", b8e = "\uD83C\uDF52", y8e = "\uD83C\uDF53", w8e = "\uD83E\uDED0", k8e = "\uD83E\uDD5D", x8e = "\uD83C\uDF45", C8e = "\uD83E\uDED2", S8e = "\uD83E\uDD65", E8e = "\uD83E\uDD51", A8e = "\uD83C\uDF46", $8e = "\uD83E\uDD54", M8e = "\uD83E\uDD55", I8e = "\uD83C\uDF3D", T8e = "\uD83C\uDF36\uFE0F", L8e = "\uD83E\uDED1", O8e = "\uD83E\uDD52", R8e = "\uD83E\uDD6C", P8e = "\uD83E\uDD66", B8e = "\uD83E\uDDC4", z8e = "\uD83E\uDDC5", D8e = "\uD83C\uDF44", N8e = "\uD83E\uDD5C", q8e = "\uD83C\uDF30", F8e = "\uD83C\uDF5E", H8e = "\uD83E\uDD50", j8e = "\uD83E\uDD56", U8e = "\uD83E\uDED3", V8e = "\uD83E\uDD68", Z8e = "\uD83E\uDD6F", W8e = "\uD83E\uDD5E", G8e = "\uD83E\uDDC7", K8e = "\uD83E\uDDC0", X8e = "\uD83C\uDF56", Y8e = "\uD83C\uDF57", J8e = "\uD83E\uDD69", Q8e = "\uD83E\uDD53", eSe = "\uD83C\uDF54", tSe = "\uD83C\uDF5F", nSe = "\uD83C\uDF55", rSe = "\uD83C\uDF2D", oSe = "\uD83E\uDD6A", sSe = "\uD83C\uDF2E", iSe = "\uD83C\uDF2F", aSe = "\uD83E\uDED4", cSe = "\uD83E\uDD59", lSe = "\uD83E\uDDC6", uSe = "\uD83E\uDD5A", dSe = "\uD83C\uDF73", fSe = "\uD83E\uDD58", pSe = "\uD83C\uDF72", hSe = "\uD83E\uDED5", gSe = "\uD83E\uDD63", mSe = "\uD83E\uDD57", vSe = "\uD83C\uDF7F", _Se = "\uD83E\uDDC8", bSe = "\uD83E\uDDC2", ySe = "\uD83E\uDD6B", wSe = "\uD83C\uDF71", kSe = "\uD83C\uDF58", xSe = "\uD83C\uDF59", CSe = "\uD83C\uDF5A", SSe = "\uD83C\uDF5B", ESe = "\uD83C\uDF5C", ASe = "\uD83C\uDF5D", $Se = "\uD83C\uDF60", MSe = "\uD83C\uDF62", ISe = "\uD83C\uDF63", TSe = "\uD83C\uDF64", LSe = "\uD83C\uDF65", OSe = "\uD83E\uDD6E", RSe = "\uD83C\uDF61", PSe = "\uD83E\uDD5F", BSe = "\uD83E\uDD60", zSe = "\uD83E\uDD61", DSe = "\uD83E\uDD80", NSe = "\uD83E\uDD9E", qSe = "\uD83E\uDD90", FSe = "\uD83E\uDD91", HSe = "\uD83E\uDDAA", jSe = "\uD83C\uDF66", USe = "\uD83C\uDF67", VSe = "\uD83C\uDF68", ZSe = "\uD83C\uDF69", WSe = "\uD83C\uDF6A", GSe = "\uD83C\uDF82", KSe = "\uD83C\uDF70", XSe = "\uD83E\uDDC1", YSe = "\uD83E\uDD67", JSe = "\uD83C\uDF6B", QSe = "\uD83C\uDF6C", e7e = "\uD83C\uDF6D", t7e = "\uD83C\uDF6E", n7e = "\uD83C\uDF6F", r7e = "\uD83C\uDF7C", o7e = "\uD83E\uDD5B", s7e = "\u2615", i7e = "\uD83E\uDED6", a7e = "\uD83C\uDF75", c7e = "\uD83C\uDF76", l7e = "\uD83C\uDF7E", u7e = "\uD83C\uDF77", d7e = "\uD83C\uDF78", f7e = "\uD83C\uDF79", p7e = "\uD83C\uDF7A", h7e = "\uD83C\uDF7B", g7e = "\uD83E\uDD42", m7e = "\uD83E\uDD43", v7e = "\uD83E\uDD64", _7e = "\uD83E\uDDCB", b7e = "\uD83E\uDDC3", y7e = "\uD83E\uDDC9", w7e = "\uD83E\uDDCA", k7e = "\uD83E\uDD62", x7e = "\uD83C\uDF7D\uFE0F", C7e = "\uD83C\uDF74", S7e = "\uD83E\uDD44", E7e = "\uD83D\uDD2A", A7e = "\uD83D\uDD2A", $7e = "\uD83C\uDFFA", M7e = "\uD83C\uDF0D", I7e = "\uD83C\uDF0E", T7e = "\uD83C\uDF0F", L7e = "\uD83C\uDF10", O7e = "\uD83D\uDDFA\uFE0F", R7e = "\uD83D\uDDFE", P7e = "\uD83E\uDDED", B7e = "\uD83C\uDFD4\uFE0F", z7e = "\u26F0\uFE0F", D7e = "\uD83C\uDF0B", N7e = "\uD83D\uDDFB", q7e = "\uD83C\uDFD5\uFE0F", F7e = "\uD83C\uDFD6\uFE0F", H7e = "\uD83C\uDFDC\uFE0F", j7e = "\uD83C\uDFDD\uFE0F", U7e = "\uD83C\uDFDE\uFE0F", V7e = "\uD83C\uDFDF\uFE0F", Z7e = "\uD83C\uDFDB\uFE0F", W7e = "\uD83C\uDFD7\uFE0F", G7e = "\uD83E\uDDF1", K7e = "\uD83E\uDEA8", X7e = "\uD83E\uDEB5", Y7e = "\uD83D\uDED6", J7e = "\uD83C\uDFD8\uFE0F", Q7e = "\uD83C\uDFDA\uFE0F", eEe = "\uD83C\uDFE0", tEe = "\uD83C\uDFE1", nEe = "\uD83C\uDFE2", rEe = "\uD83C\uDFE3", oEe = "\uD83C\uDFE4", sEe = "\uD83C\uDFE5", iEe = "\uD83C\uDFE6", aEe = "\uD83C\uDFE8", cEe = "\uD83C\uDFE9", lEe = "\uD83C\uDFEA", uEe = "\uD83C\uDFEB", dEe = "\uD83C\uDFEC", fEe = "\uD83C\uDFED", pEe = "\uD83C\uDFEF", hEe = "\uD83C\uDFF0", gEe = "\uD83D\uDC92", mEe = "\uD83D\uDDFC", vEe = "\uD83D\uDDFD", _Ee = "\u26EA", bEe = "\uD83D\uDD4C", yEe = "\uD83D\uDED5", wEe = "\uD83D\uDD4D", kEe = "\u26E9\uFE0F", xEe = "\uD83D\uDD4B", CEe = "\u26F2", SEe = "\u26FA", EEe = "\uD83C\uDF01", AEe = "\uD83C\uDF03", $Ee = "\uD83C\uDFD9\uFE0F", MEe = "\uD83C\uDF04", IEe = "\uD83C\uDF05", TEe = "\uD83C\uDF06", LEe = "\uD83C\uDF07", OEe = "\uD83C\uDF09", REe = "\u2668\uFE0F", PEe = "\uD83C\uDFA0", BEe = "\uD83C\uDFA1", zEe = "\uD83C\uDFA2", DEe = "\uD83D\uDC88", NEe = "\uD83C\uDFAA", qEe = "\uD83D\uDE82", FEe = "\uD83D\uDE83", HEe = "\uD83D\uDE84", jEe = "\uD83D\uDE85", UEe = "\uD83D\uDE86", VEe = "\uD83D\uDE87", ZEe = "\uD83D\uDE88", WEe = "\uD83D\uDE89", GEe = "\uD83D\uDE8A", KEe = "\uD83D\uDE9D", XEe = "\uD83D\uDE9E", YEe = "\uD83D\uDE8B", JEe = "\uD83D\uDE8C", QEe = "\uD83D\uDE8D", e9e = "\uD83D\uDE8E", t9e = "\uD83D\uDE90", n9e = "\uD83D\uDE91", r9e = "\uD83D\uDE92", o9e = "\uD83D\uDE93", s9e = "\uD83D\uDE94", i9e = "\uD83D\uDE95", a9e = "\uD83D\uDE96", c9e = "\uD83D\uDE97", l9e = "\uD83D\uDE97", u9e = "\uD83D\uDE98", d9e = "\uD83D\uDE99", f9e = "\uD83D\uDEFB", p9e = "\uD83D\uDE9A", h9e = "\uD83D\uDE9B", g9e = "\uD83D\uDE9C", m9e = "\uD83C\uDFCE\uFE0F", v9e = "\uD83C\uDFCD\uFE0F", _9e = "\uD83D\uDEF5", b9e = "\uD83E\uDDBD", y9e = "\uD83E\uDDBC", w9e = "\uD83D\uDEFA", k9e = "\uD83D\uDEB2", x9e = "\uD83D\uDEF4", C9e = "\uD83D\uDEF9", S9e = "\uD83D\uDEFC", E9e = "\uD83D\uDE8F", A9e = "\uD83D\uDEE3\uFE0F", $9e = "\uD83D\uDEE4\uFE0F", M9e = "\uD83D\uDEE2\uFE0F", I9e = "\u26FD", T9e = "\uD83D\uDEA8", L9e = "\uD83D\uDEA5", O9e = "\uD83D\uDEA6", R9e = "\uD83D\uDED1", P9e = "\uD83D\uDEA7", B9e = "\u2693", z9e = "\u26F5", D9e = "\u26F5", N9e = "\uD83D\uDEF6", q9e = "\uD83D\uDEA4", F9e = "\uD83D\uDEF3\uFE0F", H9e = "\u26F4\uFE0F", j9e = "\uD83D\uDEE5\uFE0F", U9e = "\uD83D\uDEA2", V9e = "\u2708\uFE0F", Z9e = "\uD83D\uDEE9\uFE0F", W9e = "\uD83D\uDEEB", G9e = "\uD83D\uDEEC", K9e = "\uD83E\uDE82", X9e = "\uD83D\uDCBA", Y9e = "\uD83D\uDE81", J9e = "\uD83D\uDE9F", Q9e = "\uD83D\uDEA0", eAe = "\uD83D\uDEA1", tAe = "\uD83D\uDEF0\uFE0F", nAe = "\uD83D\uDE80", rAe = "\uD83D\uDEF8", oAe = "\uD83D\uDECE\uFE0F", sAe = "\uD83E\uDDF3", iAe = "\u231B", aAe = "\u23F3", cAe = "\u231A", lAe = "\u23F0", uAe = "\u23F1\uFE0F", dAe = "\u23F2\uFE0F", fAe = "\uD83D\uDD70\uFE0F", pAe = "\uD83D\uDD5B", hAe = "\uD83D\uDD67", gAe = "\uD83D\uDD50", mAe = "\uD83D\uDD5C", vAe = "\uD83D\uDD51", _Ae = "\uD83D\uDD5D", bAe = "\uD83D\uDD52", yAe = "\uD83D\uDD5E", wAe = "\uD83D\uDD53", kAe = "\uD83D\uDD5F", xAe = "\uD83D\uDD54", CAe = "\uD83D\uDD60", SAe = "\uD83D\uDD55", EAe = "\uD83D\uDD61", AAe = "\uD83D\uDD56", $Ae = "\uD83D\uDD62", MAe = "\uD83D\uDD57", IAe = "\uD83D\uDD63", TAe = "\uD83D\uDD58", LAe = "\uD83D\uDD64", OAe = "\uD83D\uDD59", RAe = "\uD83D\uDD65", PAe = "\uD83D\uDD5A", BAe = "\uD83D\uDD66", zAe = "\uD83C\uDF11", DAe = "\uD83C\uDF12", NAe = "\uD83C\uDF13", qAe = "\uD83C\uDF14", FAe = "\uD83C\uDF14", HAe = "\uD83C\uDF15", jAe = "\uD83C\uDF16", UAe = "\uD83C\uDF17", VAe = "\uD83C\uDF18", ZAe = "\uD83C\uDF19", WAe = "\uD83C\uDF1A", GAe = "\uD83C\uDF1B", KAe = "\uD83C\uDF1C", XAe = "\uD83C\uDF21\uFE0F", YAe = "\u2600\uFE0F", JAe = "\uD83C\uDF1D", QAe = "\uD83C\uDF1E", e$e = "\uD83E\uDE90", t$e = "\u2B50", n$e = "\uD83C\uDF1F", r$e = "\uD83C\uDF20", o$e = "\uD83C\uDF0C", s$e = "\u2601\uFE0F", i$e = "\u26C5", a$e = "\u26C8\uFE0F", c$e = "\uD83C\uDF24\uFE0F", l$e = "\uD83C\uDF25\uFE0F", u$e = "\uD83C\uDF26\uFE0F", d$e = "\uD83C\uDF27\uFE0F", f$e = "\uD83C\uDF28\uFE0F", p$e = "\uD83C\uDF29\uFE0F", h$e = "\uD83C\uDF2A\uFE0F", g$e = "\uD83C\uDF2B\uFE0F", m$e = "\uD83C\uDF2C\uFE0F", v$e = "\uD83C\uDF00", _$e = "\uD83C\uDF08", b$e = "\uD83C\uDF02", y$e = "\u2602\uFE0F", w$e = "\u2614", k$e = "\u26F1\uFE0F", x$e = "\u26A1", C$e = "\u2744\uFE0F", S$e = "\u2603\uFE0F", E$e = "\u26C4", A$e = "\u2604\uFE0F", $$e = "\uD83D\uDD25", M$e = "\uD83D\uDCA7", I$e = "\uD83C\uDF0A", T$e = "\uD83C\uDF83", L$e = "\uD83C\uDF84", O$e = "\uD83C\uDF86", R$e = "\uD83C\uDF87", P$e = "\uD83E\uDDE8", B$e = "\u2728", z$e = "\uD83C\uDF88", D$e = "\uD83C\uDF89", N$e = "\uD83C\uDF8A", q$e = "\uD83C\uDF8B", F$e = "\uD83C\uDF8D", H$e = "\uD83C\uDF8E", j$e = "\uD83C\uDF8F", U$e = "\uD83C\uDF90", V$e = "\uD83C\uDF91", Z$e = "\uD83E\uDDE7", W$e = "\uD83C\uDF80", G$e = "\uD83C\uDF81", K$e = "\uD83C\uDF97\uFE0F", X$e = "\uD83C\uDF9F\uFE0F", Y$e = "\uD83C\uDFAB", J$e = "\uD83C\uDF96\uFE0F", Q$e = "\uD83C\uDFC6", eMe = "\uD83C\uDFC5", tMe = "\u26BD", nMe = "\u26BE", rMe = "\uD83E\uDD4E", oMe = "\uD83C\uDFC0", sMe = "\uD83C\uDFD0", iMe = "\uD83C\uDFC8", aMe = "\uD83C\uDFC9", cMe = "\uD83C\uDFBE", lMe = "\uD83E\uDD4F", uMe = "\uD83C\uDFB3", dMe = "\uD83C\uDFCF", fMe = "\uD83C\uDFD1", pMe = "\uD83C\uDFD2", hMe = "\uD83E\uDD4D", gMe = "\uD83C\uDFD3", mMe = "\uD83C\uDFF8", vMe = "\uD83E\uDD4A", _Me = "\uD83E\uDD4B", bMe = "\uD83E\uDD45", yMe = "\u26F3", wMe = "\u26F8\uFE0F", kMe = "\uD83C\uDFA3", xMe = "\uD83E\uDD3F", CMe = "\uD83C\uDFBD", SMe = "\uD83C\uDFBF", EMe = "\uD83D\uDEF7", AMe = "\uD83E\uDD4C", $Me = "\uD83C\uDFAF", MMe = "\uD83E\uDE80", IMe = "\uD83E\uDE81", TMe = "\uD83D\uDD2E", LMe = "\uD83E\uDE84", OMe = "\uD83E\uDDFF", RMe = "\uD83C\uDFAE", PMe = "\uD83D\uDD79\uFE0F", BMe = "\uD83C\uDFB0", zMe = "\uD83C\uDFB2", DMe = "\uD83E\uDDE9", NMe = "\uD83E\uDDF8", qMe = "\uD83E\uDE85", FMe = "\uD83E\uDE86", HMe = "\u2660\uFE0F", jMe = "\u2665\uFE0F", UMe = "\u2666\uFE0F", VMe = "\u2663\uFE0F", ZMe = "\u265F\uFE0F", WMe = "\uD83C\uDCCF", GMe = "\uD83C\uDC04", KMe = "\uD83C\uDFB4", XMe = "\uD83C\uDFAD", YMe = "\uD83D\uDDBC\uFE0F", JMe = "\uD83C\uDFA8", QMe = "\uD83E\uDDF5", eIe = "\uD83E\uDEA1", tIe = "\uD83E\uDDF6", nIe = "\uD83E\uDEA2", rIe = "\uD83D\uDC53", oIe = "\uD83D\uDD76\uFE0F", sIe = "\uD83E\uDD7D", iIe = "\uD83E\uDD7C", aIe = "\uD83E\uDDBA", cIe = "\uD83D\uDC54", lIe = "\uD83D\uDC55", uIe = "\uD83D\uDC55", dIe = "\uD83D\uDC56", fIe = "\uD83E\uDDE3", pIe = "\uD83E\uDDE4", hIe = "\uD83E\uDDE5", gIe = "\uD83E\uDDE6", mIe = "\uD83D\uDC57", vIe = "\uD83D\uDC58", _Ie = "\uD83E\uDD7B", bIe = "\uD83E\uDE71", yIe = "\uD83E\uDE72", wIe = "\uD83E\uDE73", kIe = "\uD83D\uDC59", xIe = "\uD83D\uDC5A", CIe = "\uD83D\uDC5B", SIe = "\uD83D\uDC5C", EIe = "\uD83D\uDC5D", AIe = "\uD83D\uDECD\uFE0F", $Ie = "\uD83C\uDF92", MIe = "\uD83E\uDE74", IIe = "\uD83D\uDC5E", TIe = "\uD83D\uDC5E", LIe = "\uD83D\uDC5F", OIe = "\uD83E\uDD7E", RIe = "\uD83E\uDD7F", PIe = "\uD83D\uDC60", BIe = "\uD83D\uDC61", zIe = "\uD83E\uDE70", DIe = "\uD83D\uDC62", NIe = "\uD83D\uDC51", qIe = "\uD83D\uDC52", FIe = "\uD83C\uDFA9", HIe = "\uD83C\uDF93", jIe = "\uD83E\uDDE2", UIe = "\uD83E\uDE96", VIe = "\u26D1\uFE0F", ZIe = "\uD83D\uDCFF", WIe = "\uD83D\uDC84", GIe = "\uD83D\uDC8D", KIe = "\uD83D\uDC8E", XIe = "\uD83D\uDD07", YIe = "\uD83D\uDD08", JIe = "\uD83D\uDD09", QIe = "\uD83D\uDD0A", eTe = "\uD83D\uDCE2", tTe = "\uD83D\uDCE3", nTe = "\uD83D\uDCEF", rTe = "\uD83D\uDD14", oTe = "\uD83D\uDD15", sTe = "\uD83C\uDFBC", iTe = "\uD83C\uDFB5", aTe = "\uD83C\uDFB6", cTe = "\uD83C\uDF99\uFE0F", lTe = "\uD83C\uDF9A\uFE0F", uTe = "\uD83C\uDF9B\uFE0F", dTe = "\uD83C\uDFA4", fTe = "\uD83C\uDFA7", pTe = "\uD83D\uDCFB", hTe = "\uD83C\uDFB7", gTe = "\uD83E\uDE97", mTe = "\uD83C\uDFB8", vTe = "\uD83C\uDFB9", _Te = "\uD83C\uDFBA", bTe = "\uD83C\uDFBB", yTe = "\uD83E\uDE95", wTe = "\uD83E\uDD41", kTe = "\uD83E\uDE98", xTe = "\uD83D\uDCF1", CTe = "\uD83D\uDCF2", STe = "\u260E\uFE0F", ETe = "\u260E\uFE0F", ATe = "\uD83D\uDCDE", $Te = "\uD83D\uDCDF", MTe = "\uD83D\uDCE0", ITe = "\uD83D\uDD0B", TTe = "\uD83D\uDD0C", LTe = "\uD83D\uDCBB", OTe = "\uD83D\uDDA5\uFE0F", RTe = "\uD83D\uDDA8\uFE0F", PTe = "\u2328\uFE0F", BTe = "\uD83D\uDDB1\uFE0F", zTe = "\uD83D\uDDB2\uFE0F", DTe = "\uD83D\uDCBD", NTe = "\uD83D\uDCBE", qTe = "\uD83D\uDCBF", FTe = "\uD83D\uDCC0", HTe = "\uD83E\uDDEE", jTe = "\uD83C\uDFA5", UTe = "\uD83C\uDF9E\uFE0F", VTe = "\uD83D\uDCFD\uFE0F", ZTe = "\uD83C\uDFAC", WTe = "\uD83D\uDCFA", GTe = "\uD83D\uDCF7", KTe = "\uD83D\uDCF8", XTe = "\uD83D\uDCF9", YTe = "\uD83D\uDCFC", JTe = "\uD83D\uDD0D", QTe = "\uD83D\uDD0E", eLe = "\uD83D\uDD6F\uFE0F", tLe = "\uD83D\uDCA1", nLe = "\uD83D\uDD26", rLe = "\uD83C\uDFEE", oLe = "\uD83C\uDFEE", sLe = "\uD83E\uDE94", iLe = "\uD83D\uDCD4", aLe = "\uD83D\uDCD5", cLe = "\uD83D\uDCD6", lLe = "\uD83D\uDCD6", uLe = "\uD83D\uDCD7", dLe = "\uD83D\uDCD8", fLe = "\uD83D\uDCD9", pLe = "\uD83D\uDCDA", hLe = "\uD83D\uDCD3", gLe = "\uD83D\uDCD2", mLe = "\uD83D\uDCC3", vLe = "\uD83D\uDCDC", _Le = "\uD83D\uDCC4", bLe = "\uD83D\uDCF0", yLe = "\uD83D\uDDDE\uFE0F", wLe = "\uD83D\uDCD1", kLe = "\uD83D\uDD16", xLe = "\uD83C\uDFF7\uFE0F", CLe = "\uD83D\uDCB0", SLe = "\uD83E\uDE99", ELe = "\uD83D\uDCB4", ALe = "\uD83D\uDCB5", $Le = "\uD83D\uDCB6", MLe = "\uD83D\uDCB7", ILe = "\uD83D\uDCB8", TLe = "\uD83D\uDCB3", LLe = "\uD83E\uDDFE", OLe = "\uD83D\uDCB9", RLe = "\u2709\uFE0F", PLe = "\uD83D\uDCE7", BLe = "\uD83D\uDCE8", zLe = "\uD83D\uDCE9", DLe = "\uD83D\uDCE4", NLe = "\uD83D\uDCE5", qLe = "\uD83D\uDCEB", FLe = "\uD83D\uDCEA", HLe = "\uD83D\uDCEC", jLe = "\uD83D\uDCED", ULe = "\uD83D\uDCEE", VLe = "\uD83D\uDDF3\uFE0F", ZLe = "\u270F\uFE0F", WLe = "\u2712\uFE0F", GLe = "\uD83D\uDD8B\uFE0F", KLe = "\uD83D\uDD8A\uFE0F", XLe = "\uD83D\uDD8C\uFE0F", YLe = "\uD83D\uDD8D\uFE0F", JLe = "\uD83D\uDCDD", QLe = "\uD83D\uDCDD", eOe = "\uD83D\uDCBC", tOe = "\uD83D\uDCC1", nOe = "\uD83D\uDCC2", rOe = "\uD83D\uDDC2\uFE0F", oOe = "\uD83D\uDCC5", sOe = "\uD83D\uDCC6", iOe = "\uD83D\uDDD2\uFE0F", aOe = "\uD83D\uDDD3\uFE0F", cOe = "\uD83D\uDCC7", lOe = "\uD83D\uDCC8", uOe = "\uD83D\uDCC9", dOe = "\uD83D\uDCCA", fOe = "\uD83D\uDCCB", pOe = "\uD83D\uDCCC", hOe = "\uD83D\uDCCD", gOe = "\uD83D\uDCCE", mOe = "\uD83D\uDD87\uFE0F", vOe = "\uD83D\uDCCF", _Oe = "\uD83D\uDCD0", bOe = "\u2702\uFE0F", yOe = "\uD83D\uDDC3\uFE0F", wOe = "\uD83D\uDDC4\uFE0F", kOe = "\uD83D\uDDD1\uFE0F", xOe = "\uD83D\uDD12", COe = "\uD83D\uDD13", SOe = "\uD83D\uDD0F", EOe = "\uD83D\uDD10", AOe = "\uD83D\uDD11", $Oe = "\uD83D\uDDDD\uFE0F", MOe = "\uD83D\uDD28", IOe = "\uD83E\uDE93", TOe = "\u26CF\uFE0F", LOe = "\u2692\uFE0F", OOe = "\uD83D\uDEE0\uFE0F", ROe = "\uD83D\uDDE1\uFE0F", POe = "\u2694\uFE0F", BOe = "\uD83D\uDD2B", zOe = "\uD83E\uDE83", DOe = "\uD83C\uDFF9", NOe = "\uD83D\uDEE1\uFE0F", qOe = "\uD83E\uDE9A", FOe = "\uD83D\uDD27", HOe = "\uD83E\uDE9B", jOe = "\uD83D\uDD29", UOe = "\u2699\uFE0F", VOe = "\uD83D\uDDDC\uFE0F", ZOe = "\u2696\uFE0F", WOe = "\uD83E\uDDAF", GOe = "\uD83D\uDD17", KOe = "\u26D3\uFE0F", XOe = "\uD83E\uDE9D", YOe = "\uD83E\uDDF0", JOe = "\uD83E\uDDF2", QOe = "\uD83E\uDE9C", eRe = "\u2697\uFE0F", tRe = "\uD83E\uDDEA", nRe = "\uD83E\uDDEB", rRe = "\uD83E\uDDEC", oRe = "\uD83D\uDD2C", sRe = "\uD83D\uDD2D", iRe = "\uD83D\uDCE1", aRe = "\uD83D\uDC89", cRe = "\uD83E\uDE78", lRe = "\uD83D\uDC8A", uRe = "\uD83E\uDE79", dRe = "\uD83E\uDE7A", fRe = "\uD83D\uDEAA", pRe = "\uD83D\uDED7", hRe = "\uD83E\uDE9E", gRe = "\uD83E\uDE9F", mRe = "\uD83D\uDECF\uFE0F", vRe = "\uD83D\uDECB\uFE0F", _Re = "\uD83E\uDE91", bRe = "\uD83D\uDEBD", yRe = "\uD83E\uDEA0", wRe = "\uD83D\uDEBF", kRe = "\uD83D\uDEC1", xRe = "\uD83E\uDEA4", CRe = "\uD83E\uDE92", SRe = "\uD83E\uDDF4", ERe = "\uD83E\uDDF7", ARe = "\uD83E\uDDF9", $Re = "\uD83E\uDDFA", MRe = "\uD83E\uDDFB", IRe = "\uD83E\uDEA3", TRe = "\uD83E\uDDFC", LRe = "\uD83E\uDEA5", ORe = "\uD83E\uDDFD", RRe = "\uD83E\uDDEF", PRe = "\uD83D\uDED2", BRe = "\uD83D\uDEAC", zRe = "\u26B0\uFE0F", DRe = "\uD83E\uDEA6", NRe = "\u26B1\uFE0F", qRe = "\uD83D\uDDFF", FRe = "\uD83E\uDEA7", HRe = "\uD83C\uDFE7", jRe = "\uD83D\uDEAE", URe = "\uD83D\uDEB0", VRe = "\u267F", ZRe = "\uD83D\uDEB9", WRe = "\uD83D\uDEBA", GRe = "\uD83D\uDEBB", KRe = "\uD83D\uDEBC", XRe = "\uD83D\uDEBE", YRe = "\uD83D\uDEC2", JRe = "\uD83D\uDEC3", QRe = "\uD83D\uDEC4", ePe = "\uD83D\uDEC5", tPe = "\u26A0\uFE0F", nPe = "\uD83D\uDEB8", rPe = "\u26D4", oPe = "\uD83D\uDEAB", sPe = "\uD83D\uDEB3", iPe = "\uD83D\uDEAD", aPe = "\uD83D\uDEAF", cPe = "\uD83D\uDEB7", lPe = "\uD83D\uDCF5", uPe = "\uD83D\uDD1E", dPe = "\u2622\uFE0F", fPe = "\u2623\uFE0F", pPe = "\u2B06\uFE0F", hPe = "\u2197\uFE0F", gPe = "\u27A1\uFE0F", mPe = "\u2198\uFE0F", vPe = "\u2B07\uFE0F", _Pe = "\u2199\uFE0F", bPe = "\u2B05\uFE0F", yPe = "\u2196\uFE0F", wPe = "\u2195\uFE0F", kPe = "\u2194\uFE0F", xPe = "\u21A9\uFE0F", CPe = "\u21AA\uFE0F", SPe = "\u2934\uFE0F", EPe = "\u2935\uFE0F", APe = "\uD83D\uDD03", $Pe = "\uD83D\uDD04", MPe = "\uD83D\uDD19", IPe = "\uD83D\uDD1A", TPe = "\uD83D\uDD1B", LPe = "\uD83D\uDD1C", OPe = "\uD83D\uDD1D", RPe = "\uD83D\uDED0", PPe = "\u269B\uFE0F", BPe = "\uD83D\uDD49\uFE0F", zPe = "\u2721\uFE0F", DPe = "\u2638\uFE0F", NPe = "\u262F\uFE0F", qPe = "\u271D\uFE0F", FPe = "\u2626\uFE0F", HPe = "\u262A\uFE0F", jPe = "\u262E\uFE0F", UPe = "\uD83D\uDD4E", VPe = "\uD83D\uDD2F", ZPe = "\u2648", WPe = "\u2649", GPe = "\u264A", KPe = "\u264B", XPe = "\u264C", YPe = "\u264D", JPe = "\u264E", QPe = "\u264F", eBe = "\u2650", tBe = "\u2651", nBe = "\u2652", rBe = "\u2653", oBe = "\u26CE", sBe = "\uD83D\uDD00", iBe = "\uD83D\uDD01", aBe = "\uD83D\uDD02", cBe = "\u25B6\uFE0F", lBe = "\u23E9", uBe = "\u23ED\uFE0F", dBe = "\u23EF\uFE0F", fBe = "\u25C0\uFE0F", pBe = "\u23EA", hBe = "\u23EE\uFE0F", gBe = "\uD83D\uDD3C", mBe = "\u23EB", vBe = "\uD83D\uDD3D", _Be = "\u23EC", bBe = "\u23F8\uFE0F", yBe = "\u23F9\uFE0F", wBe = "\u23FA\uFE0F", kBe = "\u23CF\uFE0F", xBe = "\uD83C\uDFA6", CBe = "\uD83D\uDD05", SBe = "\uD83D\uDD06", EBe = "\uD83D\uDCF6", ABe = "\uD83D\uDCF3", $Be = "\uD83D\uDCF4", MBe = "\u2640\uFE0F", IBe = "\u2642\uFE0F", TBe = "\u26A7\uFE0F", LBe = "\u2716\uFE0F", OBe = "\u2795", RBe = "\u2796", PBe = "\u2797", BBe = "\u267E\uFE0F", zBe = "\u203C\uFE0F", DBe = "\u2049\uFE0F", NBe = "\u2753", qBe = "\u2754", FBe = "\u2755", HBe = "\u2757", jBe = "\u2757", UBe = "\u3030\uFE0F", VBe = "\uD83D\uDCB1", ZBe = "\uD83D\uDCB2", WBe = "\u2695\uFE0F", GBe = "\u267B\uFE0F", KBe = "\u269C\uFE0F", XBe = "\uD83D\uDD31", YBe = "\uD83D\uDCDB", JBe = "\uD83D\uDD30", QBe = "\u2B55", eze = "\u2705", tze = "\u2611\uFE0F", nze = "\u2714\uFE0F", rze = "\u274C", oze = "\u274E", sze = "\u27B0", ize = "\u27BF", aze = "\u303D\uFE0F", cze = "\u2733\uFE0F", lze = "\u2734\uFE0F", uze = "\u2747\uFE0F", dze = "\xa9\uFE0F", fze = "\xae\uFE0F", pze = "\u2122\uFE0F", hze = "#\uFE0F\u20E3", gze = "*\uFE0F\u20E3", mze = "0\uFE0F\u20E3", vze = "1\uFE0F\u20E3", _ze = "2\uFE0F\u20E3", bze = "3\uFE0F\u20E3", yze = "4\uFE0F\u20E3", wze = "5\uFE0F\u20E3", kze = "6\uFE0F\u20E3", xze = "7\uFE0F\u20E3", Cze = "8\uFE0F\u20E3", Sze = "9\uFE0F\u20E3", Eze = "\uD83D\uDD1F", Aze = "\uD83D\uDD20", $ze = "\uD83D\uDD21", Mze = "\uD83D\uDD23", Ize = "\uD83D\uDD24", Tze = "\uD83C\uDD70\uFE0F", Lze = "\uD83C\uDD8E", Oze = "\uD83C\uDD71\uFE0F", Rze = "\uD83C\uDD91", Pze = "\uD83C\uDD92", Bze = "\uD83C\uDD93", zze = "\u2139\uFE0F", Dze = "\uD83C\uDD94", Nze = "\u24C2\uFE0F", qze = "\uD83C\uDD96", Fze = "\uD83C\uDD7E\uFE0F", Hze = "\uD83C\uDD97", jze = "\uD83C\uDD7F\uFE0F", Uze = "\uD83C\uDD98", Vze = "\uD83C\uDD99", Zze = "\uD83C\uDD9A", Wze = "\uD83C\uDE01", Gze = "\uD83C\uDE02\uFE0F", Kze = "\uD83C\uDE50", Xze = "\uD83C\uDE51", Yze = "\u3297\uFE0F", Jze = "\u3299\uFE0F", Qze = "\uD83C\uDE35", eDe = "\uD83D\uDD34", tDe = "\uD83D\uDFE0", nDe = "\uD83D\uDFE1", rDe = "\uD83D\uDFE2", oDe = "\uD83D\uDD35", sDe = "\uD83D\uDFE3", iDe = "\uD83D\uDFE4", aDe = "\u26AB", cDe = "\u26AA", lDe = "\uD83D\uDFE5", uDe = "\uD83D\uDFE7", dDe = "\uD83D\uDFE8", fDe = "\uD83D\uDFE9", pDe = "\uD83D\uDFE6", hDe = "\uD83D\uDFEA", gDe = "\uD83D\uDFEB", mDe = "\u2B1B", vDe = "\u2B1C", _De = "\u25FC\uFE0F", bDe = "\u25FB\uFE0F", yDe = "\u25FE", wDe = "\u25FD", kDe = "\u25AA\uFE0F", xDe = "\u25AB\uFE0F", CDe = "\uD83D\uDD36", SDe = "\uD83D\uDD37", EDe = "\uD83D\uDD38", ADe = "\uD83D\uDD39", $De = "\uD83D\uDD3A", MDe = "\uD83D\uDD3B", IDe = "\uD83D\uDCA0", TDe = "\uD83D\uDD18", LDe = "\uD83D\uDD33", ODe = "\uD83D\uDD32", RDe = "\uD83C\uDFC1", PDe = "\uD83D\uDEA9", BDe = "\uD83C\uDF8C", zDe = "\uD83C\uDFF4", DDe = "\uD83C\uDFF3\uFE0F", NDe = "\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08", qDe = "\uD83C\uDFF3\uFE0F\u200D\u26A7\uFE0F", FDe = "\uD83C\uDFF4\u200D\u2620\uFE0F", HDe = "\uD83C\uDDE6\uD83C\uDDE8", jDe = "\uD83C\uDDE6\uD83C\uDDE9", UDe = "\uD83C\uDDE6\uD83C\uDDEA", VDe = "\uD83C\uDDE6\uD83C\uDDEB", ZDe = "\uD83C\uDDE6\uD83C\uDDEC", WDe = "\uD83C\uDDE6\uD83C\uDDEE", GDe = "\uD83C\uDDE6\uD83C\uDDF1", KDe = "\uD83C\uDDE6\uD83C\uDDF2", XDe = "\uD83C\uDDE6\uD83C\uDDF4", YDe = "\uD83C\uDDE6\uD83C\uDDF6", JDe = "\uD83C\uDDE6\uD83C\uDDF7", QDe = "\uD83C\uDDE6\uD83C\uDDF8", eNe = "\uD83C\uDDE6\uD83C\uDDF9", tNe = "\uD83C\uDDE6\uD83C\uDDFA", nNe = "\uD83C\uDDE6\uD83C\uDDFC", rNe = "\uD83C\uDDE6\uD83C\uDDFD", oNe = "\uD83C\uDDE6\uD83C\uDDFF", sNe = "\uD83C\uDDE7\uD83C\uDDE6", iNe = "\uD83C\uDDE7\uD83C\uDDE7", aNe = "\uD83C\uDDE7\uD83C\uDDE9", cNe = "\uD83C\uDDE7\uD83C\uDDEA", lNe = "\uD83C\uDDE7\uD83C\uDDEB", uNe = "\uD83C\uDDE7\uD83C\uDDEC", dNe = "\uD83C\uDDE7\uD83C\uDDED", fNe = "\uD83C\uDDE7\uD83C\uDDEE", pNe = "\uD83C\uDDE7\uD83C\uDDEF", hNe = "\uD83C\uDDE7\uD83C\uDDF1", gNe = "\uD83C\uDDE7\uD83C\uDDF2", mNe = "\uD83C\uDDE7\uD83C\uDDF3", vNe = "\uD83C\uDDE7\uD83C\uDDF4", _Ne = "\uD83C\uDDE7\uD83C\uDDF6", bNe = "\uD83C\uDDE7\uD83C\uDDF7", yNe = "\uD83C\uDDE7\uD83C\uDDF8", wNe = "\uD83C\uDDE7\uD83C\uDDF9", kNe = "\uD83C\uDDE7\uD83C\uDDFB", xNe = "\uD83C\uDDE7\uD83C\uDDFC", CNe = "\uD83C\uDDE7\uD83C\uDDFE", SNe = "\uD83C\uDDE7\uD83C\uDDFF", ENe = "\uD83C\uDDE8\uD83C\uDDE6", ANe = "\uD83C\uDDE8\uD83C\uDDE8", $Ne = "\uD83C\uDDE8\uD83C\uDDE9", MNe = "\uD83C\uDDE8\uD83C\uDDEB", INe = "\uD83C\uDDE8\uD83C\uDDEC", TNe = "\uD83C\uDDE8\uD83C\uDDED", LNe = "\uD83C\uDDE8\uD83C\uDDEE", ONe = "\uD83C\uDDE8\uD83C\uDDF0", RNe = "\uD83C\uDDE8\uD83C\uDDF1", PNe = "\uD83C\uDDE8\uD83C\uDDF2", BNe = "\uD83C\uDDE8\uD83C\uDDF3", zNe = "\uD83C\uDDE8\uD83C\uDDF4", DNe = "\uD83C\uDDE8\uD83C\uDDF5", NNe = "\uD83C\uDDE8\uD83C\uDDF7", qNe = "\uD83C\uDDE8\uD83C\uDDFA", FNe = "\uD83C\uDDE8\uD83C\uDDFB", HNe = "\uD83C\uDDE8\uD83C\uDDFC", jNe = "\uD83C\uDDE8\uD83C\uDDFD", UNe = "\uD83C\uDDE8\uD83C\uDDFE", VNe = "\uD83C\uDDE8\uD83C\uDDFF", ZNe = "\uD83C\uDDE9\uD83C\uDDEA", WNe = "\uD83C\uDDE9\uD83C\uDDEC", GNe = "\uD83C\uDDE9\uD83C\uDDEF", KNe = "\uD83C\uDDE9\uD83C\uDDF0", XNe = "\uD83C\uDDE9\uD83C\uDDF2", YNe = "\uD83C\uDDE9\uD83C\uDDF4", JNe = "\uD83C\uDDE9\uD83C\uDDFF", QNe = "\uD83C\uDDEA\uD83C\uDDE6", eqe = "\uD83C\uDDEA\uD83C\uDDE8", tqe = "\uD83C\uDDEA\uD83C\uDDEA", nqe = "\uD83C\uDDEA\uD83C\uDDEC", rqe = "\uD83C\uDDEA\uD83C\uDDED", oqe = "\uD83C\uDDEA\uD83C\uDDF7", sqe = "\uD83C\uDDEA\uD83C\uDDF8", iqe = "\uD83C\uDDEA\uD83C\uDDF9", aqe = "\uD83C\uDDEA\uD83C\uDDFA", cqe = "\uD83C\uDDEA\uD83C\uDDFA", lqe = "\uD83C\uDDEB\uD83C\uDDEE", uqe = "\uD83C\uDDEB\uD83C\uDDEF", dqe = "\uD83C\uDDEB\uD83C\uDDF0", fqe = "\uD83C\uDDEB\uD83C\uDDF2", pqe = "\uD83C\uDDEB\uD83C\uDDF4", hqe = "\uD83C\uDDEB\uD83C\uDDF7", gqe = "\uD83C\uDDEC\uD83C\uDDE6", mqe = "\uD83C\uDDEC\uD83C\uDDE7", vqe = "\uD83C\uDDEC\uD83C\uDDE7", _qe = "\uD83C\uDDEC\uD83C\uDDE9", bqe = "\uD83C\uDDEC\uD83C\uDDEA", yqe = "\uD83C\uDDEC\uD83C\uDDEB", wqe = "\uD83C\uDDEC\uD83C\uDDEC", kqe = "\uD83C\uDDEC\uD83C\uDDED", xqe = "\uD83C\uDDEC\uD83C\uDDEE", Cqe = "\uD83C\uDDEC\uD83C\uDDF1", Sqe = "\uD83C\uDDEC\uD83C\uDDF2", Eqe = "\uD83C\uDDEC\uD83C\uDDF3", Aqe = "\uD83C\uDDEC\uD83C\uDDF5", $qe = "\uD83C\uDDEC\uD83C\uDDF6", Mqe = "\uD83C\uDDEC\uD83C\uDDF7", Iqe = "\uD83C\uDDEC\uD83C\uDDF8", Tqe = "\uD83C\uDDEC\uD83C\uDDF9", Lqe = "\uD83C\uDDEC\uD83C\uDDFA", Oqe = "\uD83C\uDDEC\uD83C\uDDFC", Rqe = "\uD83C\uDDEC\uD83C\uDDFE", Pqe = "\uD83C\uDDED\uD83C\uDDF0", Bqe = "\uD83C\uDDED\uD83C\uDDF2", zqe = "\uD83C\uDDED\uD83C\uDDF3", Dqe = "\uD83C\uDDED\uD83C\uDDF7", Nqe = "\uD83C\uDDED\uD83C\uDDF9", qqe = "\uD83C\uDDED\uD83C\uDDFA", Fqe = "\uD83C\uDDEE\uD83C\uDDE8", Hqe = "\uD83C\uDDEE\uD83C\uDDE9", jqe = "\uD83C\uDDEE\uD83C\uDDEA", Uqe = "\uD83C\uDDEE\uD83C\uDDF1", Vqe = "\uD83C\uDDEE\uD83C\uDDF2", Zqe = "\uD83C\uDDEE\uD83C\uDDF3", Wqe = "\uD83C\uDDEE\uD83C\uDDF4", Gqe = "\uD83C\uDDEE\uD83C\uDDF6", Kqe = "\uD83C\uDDEE\uD83C\uDDF7", Xqe = "\uD83C\uDDEE\uD83C\uDDF8", Yqe = "\uD83C\uDDEE\uD83C\uDDF9", Jqe = "\uD83C\uDDEF\uD83C\uDDEA", Qqe = "\uD83C\uDDEF\uD83C\uDDF2", eFe = "\uD83C\uDDEF\uD83C\uDDF4", tFe = "\uD83C\uDDEF\uD83C\uDDF5", nFe = "\uD83C\uDDF0\uD83C\uDDEA", rFe = "\uD83C\uDDF0\uD83C\uDDEC", oFe = "\uD83C\uDDF0\uD83C\uDDED", sFe = "\uD83C\uDDF0\uD83C\uDDEE", iFe = "\uD83C\uDDF0\uD83C\uDDF2", aFe = "\uD83C\uDDF0\uD83C\uDDF3", cFe = "\uD83C\uDDF0\uD83C\uDDF5", lFe = "\uD83C\uDDF0\uD83C\uDDF7", uFe = "\uD83C\uDDF0\uD83C\uDDFC", dFe = "\uD83C\uDDF0\uD83C\uDDFE", fFe = "\uD83C\uDDF0\uD83C\uDDFF", pFe = "\uD83C\uDDF1\uD83C\uDDE6", hFe = "\uD83C\uDDF1\uD83C\uDDE7", gFe = "\uD83C\uDDF1\uD83C\uDDE8", mFe = "\uD83C\uDDF1\uD83C\uDDEE", vFe = "\uD83C\uDDF1\uD83C\uDDF0", _Fe = "\uD83C\uDDF1\uD83C\uDDF7", bFe = "\uD83C\uDDF1\uD83C\uDDF8", yFe = "\uD83C\uDDF1\uD83C\uDDF9", wFe = "\uD83C\uDDF1\uD83C\uDDFA", kFe = "\uD83C\uDDF1\uD83C\uDDFB", xFe = "\uD83C\uDDF1\uD83C\uDDFE", CFe = "\uD83C\uDDF2\uD83C\uDDE6", SFe = "\uD83C\uDDF2\uD83C\uDDE8", EFe = "\uD83C\uDDF2\uD83C\uDDE9", AFe = "\uD83C\uDDF2\uD83C\uDDEA", $Fe = "\uD83C\uDDF2\uD83C\uDDEB", MFe = "\uD83C\uDDF2\uD83C\uDDEC", IFe = "\uD83C\uDDF2\uD83C\uDDED", TFe = "\uD83C\uDDF2\uD83C\uDDF0", LFe = "\uD83C\uDDF2\uD83C\uDDF1", OFe = "\uD83C\uDDF2\uD83C\uDDF2", RFe = "\uD83C\uDDF2\uD83C\uDDF3", PFe = "\uD83C\uDDF2\uD83C\uDDF4", BFe = "\uD83C\uDDF2\uD83C\uDDF5", zFe = "\uD83C\uDDF2\uD83C\uDDF6", DFe = "\uD83C\uDDF2\uD83C\uDDF7", NFe = "\uD83C\uDDF2\uD83C\uDDF8", qFe = "\uD83C\uDDF2\uD83C\uDDF9", FFe = "\uD83C\uDDF2\uD83C\uDDFA", HFe = "\uD83C\uDDF2\uD83C\uDDFB", jFe = "\uD83C\uDDF2\uD83C\uDDFC", UFe = "\uD83C\uDDF2\uD83C\uDDFD", VFe = "\uD83C\uDDF2\uD83C\uDDFE", ZFe = "\uD83C\uDDF2\uD83C\uDDFF", WFe = "\uD83C\uDDF3\uD83C\uDDE6", GFe = "\uD83C\uDDF3\uD83C\uDDE8", KFe = "\uD83C\uDDF3\uD83C\uDDEA", XFe = "\uD83C\uDDF3\uD83C\uDDEB", YFe = "\uD83C\uDDF3\uD83C\uDDEC", JFe = "\uD83C\uDDF3\uD83C\uDDEE", QFe = "\uD83C\uDDF3\uD83C\uDDF1", eHe = "\uD83C\uDDF3\uD83C\uDDF4", tHe = "\uD83C\uDDF3\uD83C\uDDF5", nHe = "\uD83C\uDDF3\uD83C\uDDF7", rHe = "\uD83C\uDDF3\uD83C\uDDFA", oHe = "\uD83C\uDDF3\uD83C\uDDFF", sHe = "\uD83C\uDDF4\uD83C\uDDF2", iHe = "\uD83C\uDDF5\uD83C\uDDE6", aHe = "\uD83C\uDDF5\uD83C\uDDEA", cHe = "\uD83C\uDDF5\uD83C\uDDEB", lHe = "\uD83C\uDDF5\uD83C\uDDEC", uHe = "\uD83C\uDDF5\uD83C\uDDED", dHe = "\uD83C\uDDF5\uD83C\uDDF0", fHe = "\uD83C\uDDF5\uD83C\uDDF1", pHe = "\uD83C\uDDF5\uD83C\uDDF2", hHe = "\uD83C\uDDF5\uD83C\uDDF3", gHe = "\uD83C\uDDF5\uD83C\uDDF7", mHe = "\uD83C\uDDF5\uD83C\uDDF8", vHe = "\uD83C\uDDF5\uD83C\uDDF9", _He = "\uD83C\uDDF5\uD83C\uDDFC", bHe = "\uD83C\uDDF5\uD83C\uDDFE", yHe = "\uD83C\uDDF6\uD83C\uDDE6", wHe = "\uD83C\uDDF7\uD83C\uDDEA", kHe = "\uD83C\uDDF7\uD83C\uDDF4", xHe = "\uD83C\uDDF7\uD83C\uDDF8", CHe = "\uD83C\uDDF7\uD83C\uDDFA", SHe = "\uD83C\uDDF7\uD83C\uDDFC", EHe = "\uD83C\uDDF8\uD83C\uDDE6", AHe = "\uD83C\uDDF8\uD83C\uDDE7", $He = "\uD83C\uDDF8\uD83C\uDDE8", MHe = "\uD83C\uDDF8\uD83C\uDDE9", IHe = "\uD83C\uDDF8\uD83C\uDDEA", THe = "\uD83C\uDDF8\uD83C\uDDEC", LHe = "\uD83C\uDDF8\uD83C\uDDED", OHe = "\uD83C\uDDF8\uD83C\uDDEE", RHe = "\uD83C\uDDF8\uD83C\uDDEF", PHe = "\uD83C\uDDF8\uD83C\uDDF0", BHe = "\uD83C\uDDF8\uD83C\uDDF1", zHe = "\uD83C\uDDF8\uD83C\uDDF2", DHe = "\uD83C\uDDF8\uD83C\uDDF3", NHe = "\uD83C\uDDF8\uD83C\uDDF4", qHe = "\uD83C\uDDF8\uD83C\uDDF7", FHe = "\uD83C\uDDF8\uD83C\uDDF8", HHe = "\uD83C\uDDF8\uD83C\uDDF9", jHe = "\uD83C\uDDF8\uD83C\uDDFB", UHe = "\uD83C\uDDF8\uD83C\uDDFD", VHe = "\uD83C\uDDF8\uD83C\uDDFE", ZHe = "\uD83C\uDDF8\uD83C\uDDFF", WHe = "\uD83C\uDDF9\uD83C\uDDE6", GHe = "\uD83C\uDDF9\uD83C\uDDE8", KHe = "\uD83C\uDDF9\uD83C\uDDE9", XHe = "\uD83C\uDDF9\uD83C\uDDEB", YHe = "\uD83C\uDDF9\uD83C\uDDEC", JHe = "\uD83C\uDDF9\uD83C\uDDED", QHe = "\uD83C\uDDF9\uD83C\uDDEF", eje = "\uD83C\uDDF9\uD83C\uDDF0", tje = "\uD83C\uDDF9\uD83C\uDDF1", nje = "\uD83C\uDDF9\uD83C\uDDF2", rje = "\uD83C\uDDF9\uD83C\uDDF3", oje = "\uD83C\uDDF9\uD83C\uDDF4", sje = "\uD83C\uDDF9\uD83C\uDDF7", ije = "\uD83C\uDDF9\uD83C\uDDF9", aje = "\uD83C\uDDF9\uD83C\uDDFB", cje = "\uD83C\uDDF9\uD83C\uDDFC", lje = "\uD83C\uDDF9\uD83C\uDDFF", uje = "\uD83C\uDDFA\uD83C\uDDE6", dje = "\uD83C\uDDFA\uD83C\uDDEC", fje = "\uD83C\uDDFA\uD83C\uDDF2", pje = "\uD83C\uDDFA\uD83C\uDDF3", hje = "\uD83C\uDDFA\uD83C\uDDF8", gje = "\uD83C\uDDFA\uD83C\uDDFE", mje = "\uD83C\uDDFA\uD83C\uDDFF", vje = "\uD83C\uDDFB\uD83C\uDDE6", _je = "\uD83C\uDDFB\uD83C\uDDE8", bje = "\uD83C\uDDFB\uD83C\uDDEA", yje = "\uD83C\uDDFB\uD83C\uDDEC", wje = "\uD83C\uDDFB\uD83C\uDDEE", kje = "\uD83C\uDDFB\uD83C\uDDF3", xje = "\uD83C\uDDFB\uD83C\uDDFA", Cje = "\uD83C\uDDFC\uD83C\uDDEB", Sje = "\uD83C\uDDFC\uD83C\uDDF8", Eje = "\uD83C\uDDFD\uD83C\uDDF0", Aje = "\uD83C\uDDFE\uD83C\uDDEA", $je = "\uD83C\uDDFE\uD83C\uDDF9", Mje = "\uD83C\uDDFF\uD83C\uDDE6", Ije = "\uD83C\uDDFF\uD83C\uDDF2", Tje = "\uD83C\uDDFF\uD83C\uDDFC", Lje = "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F", Oje = "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74\uDB40\uDC7F", Rje = "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73\uDB40\uDC7F", Pje = {
    100: "\uD83D\uDCAF",
    1234: "\uD83D\uDD22",
    grinning: Zme,
    smiley: Wme,
    smile: Gme,
    grin: Kme,
    laughing: Xme,
    satisfied: Yme,
    sweat_smile: Jme,
    rofl: Qme,
    joy: eve,
    slightly_smiling_face: tve,
    upside_down_face: nve,
    wink: rve,
    blush: ove,
    innocent: sve,
    smiling_face_with_three_hearts: ive,
    heart_eyes: ave,
    star_struck: cve,
    kissing_heart: lve,
    kissing: uve,
    relaxed: dve,
    kissing_closed_eyes: fve,
    kissing_smiling_eyes: pve,
    smiling_face_with_tear: hve,
    yum: gve,
    stuck_out_tongue: mve,
    stuck_out_tongue_winking_eye: vve,
    zany_face: _ve,
    stuck_out_tongue_closed_eyes: bve,
    money_mouth_face: yve,
    hugs: wve,
    hand_over_mouth: kve,
    shushing_face: xve,
    thinking: Cve,
    zipper_mouth_face: Sve,
    raised_eyebrow: Eve,
    neutral_face: Ave,
    expressionless: $ve,
    no_mouth: Mve,
    smirk: Ive,
    unamused: Tve,
    roll_eyes: Lve,
    grimacing: Ove,
    lying_face: Rve,
    relieved: Pve,
    pensive: Bve,
    sleepy: zve,
    drooling_face: Dve,
    sleeping: Nve,
    mask: qve,
    face_with_thermometer: Fve,
    face_with_head_bandage: Hve,
    nauseated_face: jve,
    vomiting_face: Uve,
    sneezing_face: Vve,
    hot_face: Zve,
    cold_face: Wve,
    woozy_face: Gve,
    dizzy_face: Kve,
    exploding_head: Xve,
    cowboy_hat_face: Yve,
    partying_face: Jve,
    disguised_face: Qve,
    sunglasses: e_e,
    nerd_face: t_e,
    monocle_face: n_e,
    confused: r_e,
    worried: o_e,
    slightly_frowning_face: s_e,
    frowning_face: i_e,
    open_mouth: a_e,
    hushed: c_e,
    astonished: l_e,
    flushed: u_e,
    pleading_face: d_e,
    frowning: f_e,
    anguished: p_e,
    fearful: h_e,
    cold_sweat: g_e,
    disappointed_relieved: m_e,
    cry: v_e,
    sob: __e,
    scream: b_e,
    confounded: y_e,
    persevere: w_e,
    disappointed: k_e,
    sweat: x_e,
    weary: C_e,
    tired_face: S_e,
    yawning_face: E_e,
    triumph: A_e,
    rage: $_e,
    pout: M_e,
    angry: I_e,
    cursing_face: T_e,
    smiling_imp: L_e,
    imp: O_e,
    skull: R_e,
    skull_and_crossbones: P_e,
    hankey: B_e,
    poop: z_e,
    shit: D_e,
    clown_face: N_e,
    japanese_ogre: q_e,
    japanese_goblin: F_e,
    ghost: H_e,
    alien: j_e,
    space_invader: U_e,
    robot: V_e,
    smiley_cat: Z_e,
    smile_cat: W_e,
    joy_cat: G_e,
    heart_eyes_cat: K_e,
    smirk_cat: X_e,
    kissing_cat: Y_e,
    scream_cat: J_e,
    crying_cat_face: Q_e,
    pouting_cat: ebe,
    see_no_evil: tbe,
    hear_no_evil: nbe,
    speak_no_evil: rbe,
    kiss: obe,
    love_letter: sbe,
    cupid: ibe,
    gift_heart: abe,
    sparkling_heart: cbe,
    heartpulse: lbe,
    heartbeat: ube,
    revolving_hearts: dbe,
    two_hearts: fbe,
    heart_decoration: pbe,
    heavy_heart_exclamation: hbe,
    broken_heart: gbe,
    heart: mbe,
    orange_heart: vbe,
    yellow_heart: _be,
    green_heart: bbe,
    blue_heart: ybe,
    purple_heart: wbe,
    brown_heart: kbe,
    black_heart: xbe,
    white_heart: Cbe,
    anger: Sbe,
    boom: Ebe,
    collision: Abe,
    dizzy: $be,
    sweat_drops: Mbe,
    dash: Ibe,
    hole: Tbe,
    bomb: Lbe,
    speech_balloon: Obe,
    eye_speech_bubble: Rbe,
    left_speech_bubble: Pbe,
    right_anger_bubble: Bbe,
    thought_balloon: zbe,
    zzz: Dbe,
    wave: Nbe,
    raised_back_of_hand: qbe,
    raised_hand_with_fingers_splayed: Fbe,
    hand: Hbe,
    raised_hand: jbe,
    vulcan_salute: Ube,
    ok_hand: Vbe,
    pinched_fingers: Zbe,
    pinching_hand: Wbe,
    v: Gbe,
    crossed_fingers: Kbe,
    love_you_gesture: Xbe,
    metal: Ybe,
    call_me_hand: Jbe,
    point_left: Qbe,
    point_right: eye,
    point_up_2: tye,
    middle_finger: nye,
    fu: rye,
    point_down: oye,
    point_up: sye,
    "+1": "\uD83D\uDC4D",
    thumbsup: iye,
    "-1": "\uD83D\uDC4E",
    thumbsdown: aye,
    fist_raised: cye,
    fist: lye,
    fist_oncoming: uye,
    facepunch: dye,
    punch: fye,
    fist_left: pye,
    fist_right: hye,
    clap: gye,
    raised_hands: mye,
    open_hands: vye,
    palms_up_together: _ye,
    handshake: bye,
    pray: yye,
    writing_hand: wye,
    nail_care: kye,
    selfie: xye,
    muscle: Cye,
    mechanical_arm: Sye,
    mechanical_leg: Eye,
    leg: Aye,
    foot: $ye,
    ear: Mye,
    ear_with_hearing_aid: Iye,
    nose: Tye,
    brain: Lye,
    anatomical_heart: Oye,
    lungs: Rye,
    tooth: Pye,
    bone: Bye,
    eyes: zye,
    eye: Dye,
    tongue: Nye,
    lips: qye,
    baby: Fye,
    child: Hye,
    boy: jye,
    girl: Uye,
    adult: Vye,
    blond_haired_person: Zye,
    man: Wye,
    bearded_person: Gye,
    red_haired_man: Kye,
    curly_haired_man: Xye,
    white_haired_man: Yye,
    bald_man: Jye,
    woman: Qye,
    red_haired_woman: ewe,
    person_red_hair: twe,
    curly_haired_woman: nwe,
    person_curly_hair: rwe,
    white_haired_woman: owe,
    person_white_hair: swe,
    bald_woman: iwe,
    person_bald: awe,
    blond_haired_woman: cwe,
    blonde_woman: lwe,
    blond_haired_man: uwe,
    older_adult: dwe,
    older_man: fwe,
    older_woman: pwe,
    frowning_person: hwe,
    frowning_man: gwe,
    frowning_woman: mwe,
    pouting_face: vwe,
    pouting_man: _we,
    pouting_woman: bwe,
    no_good: ywe,
    no_good_man: wwe,
    ng_man: kwe,
    no_good_woman: xwe,
    ng_woman: Cwe,
    ok_person: Swe,
    ok_man: Ewe,
    ok_woman: Awe,
    tipping_hand_person: $we,
    information_desk_person: Mwe,
    tipping_hand_man: Iwe,
    sassy_man: Twe,
    tipping_hand_woman: Lwe,
    sassy_woman: Owe,
    raising_hand: Rwe,
    raising_hand_man: Pwe,
    raising_hand_woman: Bwe,
    deaf_person: zwe,
    deaf_man: Dwe,
    deaf_woman: Nwe,
    bow: qwe,
    bowing_man: Fwe,
    bowing_woman: Hwe,
    facepalm: jwe,
    man_facepalming: Uwe,
    woman_facepalming: Vwe,
    shrug: Zwe,
    man_shrugging: Wwe,
    woman_shrugging: Gwe,
    health_worker: Kwe,
    man_health_worker: Xwe,
    woman_health_worker: Ywe,
    student: Jwe,
    man_student: Qwe,
    woman_student: eke,
    teacher: tke,
    man_teacher: nke,
    woman_teacher: rke,
    judge: oke,
    man_judge: ske,
    woman_judge: ike,
    farmer: ake,
    man_farmer: cke,
    woman_farmer: lke,
    cook: uke,
    man_cook: dke,
    woman_cook: fke,
    mechanic: pke,
    man_mechanic: hke,
    woman_mechanic: gke,
    factory_worker: mke,
    man_factory_worker: vke,
    woman_factory_worker: _ke,
    office_worker: bke,
    man_office_worker: yke,
    woman_office_worker: wke,
    scientist: kke,
    man_scientist: xke,
    woman_scientist: Cke,
    technologist: Ske,
    man_technologist: Eke,
    woman_technologist: Ake,
    singer: $ke,
    man_singer: Mke,
    woman_singer: Ike,
    artist: Tke,
    man_artist: Lke,
    woman_artist: Oke,
    pilot: Rke,
    man_pilot: Pke,
    woman_pilot: Bke,
    astronaut: zke,
    man_astronaut: Dke,
    woman_astronaut: Nke,
    firefighter: qke,
    man_firefighter: Fke,
    woman_firefighter: Hke,
    police_officer: jke,
    cop: Uke,
    policeman: Vke,
    policewoman: Zke,
    detective: Wke,
    male_detective: Gke,
    female_detective: Kke,
    guard: Xke,
    guardsman: Yke,
    guardswoman: Jke,
    ninja: Qke,
    construction_worker: e4e,
    construction_worker_man: t4e,
    construction_worker_woman: n4e,
    prince: r4e,
    princess: o4e,
    person_with_turban: s4e,
    man_with_turban: i4e,
    woman_with_turban: a4e,
    man_with_gua_pi_mao: c4e,
    woman_with_headscarf: l4e,
    person_in_tuxedo: u4e,
    man_in_tuxedo: d4e,
    woman_in_tuxedo: f4e,
    person_with_veil: p4e,
    man_with_veil: h4e,
    woman_with_veil: g4e,
    bride_with_veil: m4e,
    pregnant_woman: v4e,
    breast_feeding: _4e,
    woman_feeding_baby: b4e,
    man_feeding_baby: y4e,
    person_feeding_baby: w4e,
    angel: k4e,
    santa: x4e,
    mrs_claus: C4e,
    mx_claus: S4e,
    superhero: E4e,
    superhero_man: A4e,
    superhero_woman: $4e,
    supervillain: M4e,
    supervillain_man: I4e,
    supervillain_woman: T4e,
    mage: L4e,
    mage_man: O4e,
    mage_woman: R4e,
    fairy: P4e,
    fairy_man: B4e,
    fairy_woman: z4e,
    vampire: D4e,
    vampire_man: N4e,
    vampire_woman: q4e,
    merperson: F4e,
    merman: H4e,
    mermaid: j4e,
    elf: U4e,
    elf_man: V4e,
    elf_woman: Z4e,
    genie: W4e,
    genie_man: G4e,
    genie_woman: K4e,
    zombie: X4e,
    zombie_man: Y4e,
    zombie_woman: J4e,
    massage: Q4e,
    massage_man: e3e,
    massage_woman: t3e,
    haircut: n3e,
    haircut_man: r3e,
    haircut_woman: o3e,
    walking: s3e,
    walking_man: i3e,
    walking_woman: a3e,
    standing_person: c3e,
    standing_man: l3e,
    standing_woman: u3e,
    kneeling_person: d3e,
    kneeling_man: f3e,
    kneeling_woman: p3e,
    person_with_probing_cane: h3e,
    man_with_probing_cane: g3e,
    woman_with_probing_cane: m3e,
    person_in_motorized_wheelchair: v3e,
    man_in_motorized_wheelchair: _3e,
    woman_in_motorized_wheelchair: b3e,
    person_in_manual_wheelchair: y3e,
    man_in_manual_wheelchair: w3e,
    woman_in_manual_wheelchair: k3e,
    runner: x3e,
    running: C3e,
    running_man: S3e,
    running_woman: E3e,
    woman_dancing: A3e,
    dancer: $3e,
    man_dancing: M3e,
    business_suit_levitating: I3e,
    dancers: T3e,
    dancing_men: L3e,
    dancing_women: O3e,
    sauna_person: R3e,
    sauna_man: P3e,
    sauna_woman: B3e,
    climbing: z3e,
    climbing_man: D3e,
    climbing_woman: N3e,
    person_fencing: q3e,
    horse_racing: F3e,
    skier: H3e,
    snowboarder: j3e,
    golfing: U3e,
    golfing_man: V3e,
    golfing_woman: Z3e,
    surfer: W3e,
    surfing_man: G3e,
    surfing_woman: K3e,
    rowboat: X3e,
    rowing_man: Y3e,
    rowing_woman: J3e,
    swimmer: Q3e,
    swimming_man: exe,
    swimming_woman: txe,
    bouncing_ball_person: nxe,
    bouncing_ball_man: rxe,
    basketball_man: oxe,
    bouncing_ball_woman: sxe,
    basketball_woman: ixe,
    weight_lifting: axe,
    weight_lifting_man: cxe,
    weight_lifting_woman: lxe,
    bicyclist: uxe,
    biking_man: dxe,
    biking_woman: fxe,
    mountain_bicyclist: pxe,
    mountain_biking_man: hxe,
    mountain_biking_woman: gxe,
    cartwheeling: mxe,
    man_cartwheeling: vxe,
    woman_cartwheeling: _xe,
    wrestling: bxe,
    men_wrestling: yxe,
    women_wrestling: wxe,
    water_polo: kxe,
    man_playing_water_polo: xxe,
    woman_playing_water_polo: Cxe,
    handball_person: Sxe,
    man_playing_handball: Exe,
    woman_playing_handball: Axe,
    juggling_person: $xe,
    man_juggling: Mxe,
    woman_juggling: Ixe,
    lotus_position: Txe,
    lotus_position_man: Lxe,
    lotus_position_woman: Oxe,
    bath: Rxe,
    sleeping_bed: Pxe,
    people_holding_hands: Bxe,
    two_women_holding_hands: zxe,
    couple: Dxe,
    two_men_holding_hands: Nxe,
    couplekiss: qxe,
    couplekiss_man_woman: Fxe,
    couplekiss_man_man: Hxe,
    couplekiss_woman_woman: jxe,
    couple_with_heart: Uxe,
    couple_with_heart_woman_man: Vxe,
    couple_with_heart_man_man: Zxe,
    couple_with_heart_woman_woman: Wxe,
    family: Gxe,
    family_man_woman_boy: Kxe,
    family_man_woman_girl: Xxe,
    family_man_woman_girl_boy: Yxe,
    family_man_woman_boy_boy: Jxe,
    family_man_woman_girl_girl: Qxe,
    family_man_man_boy: eCe,
    family_man_man_girl: tCe,
    family_man_man_girl_boy: nCe,
    family_man_man_boy_boy: rCe,
    family_man_man_girl_girl: oCe,
    family_woman_woman_boy: sCe,
    family_woman_woman_girl: iCe,
    family_woman_woman_girl_boy: aCe,
    family_woman_woman_boy_boy: cCe,
    family_woman_woman_girl_girl: lCe,
    family_man_boy: uCe,
    family_man_boy_boy: dCe,
    family_man_girl: fCe,
    family_man_girl_boy: pCe,
    family_man_girl_girl: hCe,
    family_woman_boy: gCe,
    family_woman_boy_boy: mCe,
    family_woman_girl: vCe,
    family_woman_girl_boy: _Ce,
    family_woman_girl_girl: bCe,
    speaking_head: yCe,
    bust_in_silhouette: wCe,
    busts_in_silhouette: kCe,
    people_hugging: xCe,
    footprints: CCe,
    monkey_face: SCe,
    monkey: ECe,
    gorilla: ACe,
    orangutan: $Ce,
    dog: MCe,
    dog2: ICe,
    guide_dog: TCe,
    service_dog: LCe,
    poodle: OCe,
    wolf: RCe,
    fox_face: PCe,
    raccoon: BCe,
    cat: zCe,
    cat2: DCe,
    black_cat: NCe,
    lion: qCe,
    tiger: FCe,
    tiger2: HCe,
    leopard: jCe,
    horse: UCe,
    racehorse: VCe,
    unicorn: ZCe,
    zebra: WCe,
    deer: GCe,
    bison: KCe,
    cow: XCe,
    ox: YCe,
    water_buffalo: JCe,
    cow2: QCe,
    pig: e6e,
    pig2: t6e,
    boar: n6e,
    pig_nose: r6e,
    ram: o6e,
    sheep: s6e,
    goat: i6e,
    dromedary_camel: a6e,
    camel: c6e,
    llama: l6e,
    giraffe: u6e,
    elephant: d6e,
    mammoth: f6e,
    rhinoceros: p6e,
    hippopotamus: h6e,
    mouse: g6e,
    mouse2: m6e,
    rat: v6e,
    hamster: _6e,
    rabbit: b6e,
    rabbit2: y6e,
    chipmunk: w6e,
    beaver: k6e,
    hedgehog: x6e,
    bat: C6e,
    bear: S6e,
    polar_bear: E6e,
    koala: A6e,
    panda_face: $6e,
    sloth: M6e,
    otter: I6e,
    skunk: T6e,
    kangaroo: L6e,
    badger: O6e,
    feet: R6e,
    paw_prints: P6e,
    turkey: B6e,
    chicken: z6e,
    rooster: D6e,
    hatching_chick: N6e,
    baby_chick: q6e,
    hatched_chick: F6e,
    bird: H6e,
    penguin: j6e,
    dove: U6e,
    eagle: V6e,
    duck: Z6e,
    swan: W6e,
    owl: G6e,
    dodo: K6e,
    feather: X6e,
    flamingo: Y6e,
    peacock: J6e,
    parrot: Q6e,
    frog: e5e,
    crocodile: t5e,
    turtle: n5e,
    lizard: r5e,
    snake: o5e,
    dragon_face: s5e,
    dragon: i5e,
    sauropod: a5e,
    "t-rex": "\uD83E\uDD96",
    whale: c5e,
    whale2: l5e,
    dolphin: u5e,
    flipper: d5e,
    seal: f5e,
    fish: p5e,
    tropical_fish: h5e,
    blowfish: g5e,
    shark: m5e,
    octopus: v5e,
    shell: _5e,
    snail: b5e,
    butterfly: y5e,
    bug: w5e,
    ant: k5e,
    bee: x5e,
    honeybee: C5e,
    beetle: S5e,
    lady_beetle: E5e,
    cricket: A5e,
    cockroach: $5e,
    spider: M5e,
    spider_web: I5e,
    scorpion: T5e,
    mosquito: L5e,
    fly: O5e,
    worm: R5e,
    microbe: P5e,
    bouquet: B5e,
    cherry_blossom: z5e,
    white_flower: D5e,
    rosette: N5e,
    rose: q5e,
    wilted_flower: F5e,
    hibiscus: H5e,
    sunflower: j5e,
    blossom: U5e,
    tulip: V5e,
    seedling: Z5e,
    potted_plant: W5e,
    evergreen_tree: G5e,
    deciduous_tree: K5e,
    palm_tree: X5e,
    cactus: Y5e,
    ear_of_rice: J5e,
    herb: Q5e,
    shamrock: e8e,
    four_leaf_clover: t8e,
    maple_leaf: n8e,
    fallen_leaf: r8e,
    leaves: o8e,
    grapes: s8e,
    melon: i8e,
    watermelon: a8e,
    tangerine: c8e,
    orange: l8e,
    mandarin: u8e,
    lemon: d8e,
    banana: f8e,
    pineapple: p8e,
    mango: h8e,
    apple: g8e,
    green_apple: m8e,
    pear: v8e,
    peach: _8e,
    cherries: b8e,
    strawberry: y8e,
    blueberries: w8e,
    kiwi_fruit: k8e,
    tomato: x8e,
    olive: C8e,
    coconut: S8e,
    avocado: E8e,
    eggplant: A8e,
    potato: $8e,
    carrot: M8e,
    corn: I8e,
    hot_pepper: T8e,
    bell_pepper: L8e,
    cucumber: O8e,
    leafy_green: R8e,
    broccoli: P8e,
    garlic: B8e,
    onion: z8e,
    mushroom: D8e,
    peanuts: N8e,
    chestnut: q8e,
    bread: F8e,
    croissant: H8e,
    baguette_bread: j8e,
    flatbread: U8e,
    pretzel: V8e,
    bagel: Z8e,
    pancakes: W8e,
    waffle: G8e,
    cheese: K8e,
    meat_on_bone: X8e,
    poultry_leg: Y8e,
    cut_of_meat: J8e,
    bacon: Q8e,
    hamburger: eSe,
    fries: tSe,
    pizza: nSe,
    hotdog: rSe,
    sandwich: oSe,
    taco: sSe,
    burrito: iSe,
    tamale: aSe,
    stuffed_flatbread: cSe,
    falafel: lSe,
    egg: uSe,
    fried_egg: dSe,
    shallow_pan_of_food: fSe,
    stew: pSe,
    fondue: hSe,
    bowl_with_spoon: gSe,
    green_salad: mSe,
    popcorn: vSe,
    butter: _Se,
    salt: bSe,
    canned_food: ySe,
    bento: wSe,
    rice_cracker: kSe,
    rice_ball: xSe,
    rice: CSe,
    curry: SSe,
    ramen: ESe,
    spaghetti: ASe,
    sweet_potato: $Se,
    oden: MSe,
    sushi: ISe,
    fried_shrimp: TSe,
    fish_cake: LSe,
    moon_cake: OSe,
    dango: RSe,
    dumpling: PSe,
    fortune_cookie: BSe,
    takeout_box: zSe,
    crab: DSe,
    lobster: NSe,
    shrimp: qSe,
    squid: FSe,
    oyster: HSe,
    icecream: jSe,
    shaved_ice: USe,
    ice_cream: VSe,
    doughnut: ZSe,
    cookie: WSe,
    birthday: GSe,
    cake: KSe,
    cupcake: XSe,
    pie: YSe,
    chocolate_bar: JSe,
    candy: QSe,
    lollipop: e7e,
    custard: t7e,
    honey_pot: n7e,
    baby_bottle: r7e,
    milk_glass: o7e,
    coffee: s7e,
    teapot: i7e,
    tea: a7e,
    sake: c7e,
    champagne: l7e,
    wine_glass: u7e,
    cocktail: d7e,
    tropical_drink: f7e,
    beer: p7e,
    beers: h7e,
    clinking_glasses: g7e,
    tumbler_glass: m7e,
    cup_with_straw: v7e,
    bubble_tea: _7e,
    beverage_box: b7e,
    mate: y7e,
    ice_cube: w7e,
    chopsticks: k7e,
    plate_with_cutlery: x7e,
    fork_and_knife: C7e,
    spoon: S7e,
    hocho: E7e,
    knife: A7e,
    amphora: $7e,
    earth_africa: M7e,
    earth_americas: I7e,
    earth_asia: T7e,
    globe_with_meridians: L7e,
    world_map: O7e,
    japan: R7e,
    compass: P7e,
    mountain_snow: B7e,
    mountain: z7e,
    volcano: D7e,
    mount_fuji: N7e,
    camping: q7e,
    beach_umbrella: F7e,
    desert: H7e,
    desert_island: j7e,
    national_park: U7e,
    stadium: V7e,
    classical_building: Z7e,
    building_construction: W7e,
    bricks: G7e,
    rock: K7e,
    wood: X7e,
    hut: Y7e,
    houses: J7e,
    derelict_house: Q7e,
    house: eEe,
    house_with_garden: tEe,
    office: nEe,
    post_office: rEe,
    european_post_office: oEe,
    hospital: sEe,
    bank: iEe,
    hotel: aEe,
    love_hotel: cEe,
    convenience_store: lEe,
    school: uEe,
    department_store: dEe,
    factory: fEe,
    japanese_castle: pEe,
    european_castle: hEe,
    wedding: gEe,
    tokyo_tower: mEe,
    statue_of_liberty: vEe,
    church: _Ee,
    mosque: bEe,
    hindu_temple: yEe,
    synagogue: wEe,
    shinto_shrine: kEe,
    kaaba: xEe,
    fountain: CEe,
    tent: SEe,
    foggy: EEe,
    night_with_stars: AEe,
    cityscape: $Ee,
    sunrise_over_mountains: MEe,
    sunrise: IEe,
    city_sunset: TEe,
    city_sunrise: LEe,
    bridge_at_night: OEe,
    hotsprings: REe,
    carousel_horse: PEe,
    ferris_wheel: BEe,
    roller_coaster: zEe,
    barber: DEe,
    circus_tent: NEe,
    steam_locomotive: qEe,
    railway_car: FEe,
    bullettrain_side: HEe,
    bullettrain_front: jEe,
    train2: UEe,
    metro: VEe,
    light_rail: ZEe,
    station: WEe,
    tram: GEe,
    monorail: KEe,
    mountain_railway: XEe,
    train: YEe,
    bus: JEe,
    oncoming_bus: QEe,
    trolleybus: e9e,
    minibus: t9e,
    ambulance: n9e,
    fire_engine: r9e,
    police_car: o9e,
    oncoming_police_car: s9e,
    taxi: i9e,
    oncoming_taxi: a9e,
    car: c9e,
    red_car: l9e,
    oncoming_automobile: u9e,
    blue_car: d9e,
    pickup_truck: f9e,
    truck: p9e,
    articulated_lorry: h9e,
    tractor: g9e,
    racing_car: m9e,
    motorcycle: v9e,
    motor_scooter: _9e,
    manual_wheelchair: b9e,
    motorized_wheelchair: y9e,
    auto_rickshaw: w9e,
    bike: k9e,
    kick_scooter: x9e,
    skateboard: C9e,
    roller_skate: S9e,
    busstop: E9e,
    motorway: A9e,
    railway_track: $9e,
    oil_drum: M9e,
    fuelpump: I9e,
    rotating_light: T9e,
    traffic_light: L9e,
    vertical_traffic_light: O9e,
    stop_sign: R9e,
    construction: P9e,
    anchor: B9e,
    boat: z9e,
    sailboat: D9e,
    canoe: N9e,
    speedboat: q9e,
    passenger_ship: F9e,
    ferry: H9e,
    motor_boat: j9e,
    ship: U9e,
    airplane: V9e,
    small_airplane: Z9e,
    flight_departure: W9e,
    flight_arrival: G9e,
    parachute: K9e,
    seat: X9e,
    helicopter: Y9e,
    suspension_railway: J9e,
    mountain_cableway: Q9e,
    aerial_tramway: eAe,
    artificial_satellite: tAe,
    rocket: nAe,
    flying_saucer: rAe,
    bellhop_bell: oAe,
    luggage: sAe,
    hourglass: iAe,
    hourglass_flowing_sand: aAe,
    watch: cAe,
    alarm_clock: lAe,
    stopwatch: uAe,
    timer_clock: dAe,
    mantelpiece_clock: fAe,
    clock12: pAe,
    clock1230: hAe,
    clock1: gAe,
    clock130: mAe,
    clock2: vAe,
    clock230: _Ae,
    clock3: bAe,
    clock330: yAe,
    clock4: wAe,
    clock430: kAe,
    clock5: xAe,
    clock530: CAe,
    clock6: SAe,
    clock630: EAe,
    clock7: AAe,
    clock730: $Ae,
    clock8: MAe,
    clock830: IAe,
    clock9: TAe,
    clock930: LAe,
    clock10: OAe,
    clock1030: RAe,
    clock11: PAe,
    clock1130: BAe,
    new_moon: zAe,
    waxing_crescent_moon: DAe,
    first_quarter_moon: NAe,
    moon: qAe,
    waxing_gibbous_moon: FAe,
    full_moon: HAe,
    waning_gibbous_moon: jAe,
    last_quarter_moon: UAe,
    waning_crescent_moon: VAe,
    crescent_moon: ZAe,
    new_moon_with_face: WAe,
    first_quarter_moon_with_face: GAe,
    last_quarter_moon_with_face: KAe,
    thermometer: XAe,
    sunny: YAe,
    full_moon_with_face: JAe,
    sun_with_face: QAe,
    ringed_planet: e$e,
    star: t$e,
    star2: n$e,
    stars: r$e,
    milky_way: o$e,
    cloud: s$e,
    partly_sunny: i$e,
    cloud_with_lightning_and_rain: a$e,
    sun_behind_small_cloud: c$e,
    sun_behind_large_cloud: l$e,
    sun_behind_rain_cloud: u$e,
    cloud_with_rain: d$e,
    cloud_with_snow: f$e,
    cloud_with_lightning: p$e,
    tornado: h$e,
    fog: g$e,
    wind_face: m$e,
    cyclone: v$e,
    rainbow: _$e,
    closed_umbrella: b$e,
    open_umbrella: y$e,
    umbrella: w$e,
    parasol_on_ground: k$e,
    zap: x$e,
    snowflake: C$e,
    snowman_with_snow: S$e,
    snowman: E$e,
    comet: A$e,
    fire: $$e,
    droplet: M$e,
    ocean: I$e,
    jack_o_lantern: T$e,
    christmas_tree: L$e,
    fireworks: O$e,
    sparkler: R$e,
    firecracker: P$e,
    sparkles: B$e,
    balloon: z$e,
    tada: D$e,
    confetti_ball: N$e,
    tanabata_tree: q$e,
    bamboo: F$e,
    dolls: H$e,
    flags: j$e,
    wind_chime: U$e,
    rice_scene: V$e,
    red_envelope: Z$e,
    ribbon: W$e,
    gift: G$e,
    reminder_ribbon: K$e,
    tickets: X$e,
    ticket: Y$e,
    medal_military: J$e,
    trophy: Q$e,
    medal_sports: eMe,
    "1st_place_medal": "\uD83E\uDD47",
    "2nd_place_medal": "\uD83E\uDD48",
    "3rd_place_medal": "\uD83E\uDD49",
    soccer: tMe,
    baseball: nMe,
    softball: rMe,
    basketball: oMe,
    volleyball: sMe,
    football: iMe,
    rugby_football: aMe,
    tennis: cMe,
    flying_disc: lMe,
    bowling: uMe,
    cricket_game: dMe,
    field_hockey: fMe,
    ice_hockey: pMe,
    lacrosse: hMe,
    ping_pong: gMe,
    badminton: mMe,
    boxing_glove: vMe,
    martial_arts_uniform: _Me,
    goal_net: bMe,
    golf: yMe,
    ice_skate: wMe,
    fishing_pole_and_fish: kMe,
    diving_mask: xMe,
    running_shirt_with_sash: CMe,
    ski: SMe,
    sled: EMe,
    curling_stone: AMe,
    dart: $Me,
    yo_yo: MMe,
    kite: IMe,
    "8ball": "\uD83C\uDFB1",
    crystal_ball: TMe,
    magic_wand: LMe,
    nazar_amulet: OMe,
    video_game: RMe,
    joystick: PMe,
    slot_machine: BMe,
    game_die: zMe,
    jigsaw: DMe,
    teddy_bear: NMe,
    pinata: qMe,
    nesting_dolls: FMe,
    spades: HMe,
    hearts: jMe,
    diamonds: UMe,
    clubs: VMe,
    chess_pawn: ZMe,
    black_joker: WMe,
    mahjong: GMe,
    flower_playing_cards: KMe,
    performing_arts: XMe,
    framed_picture: YMe,
    art: JMe,
    thread: QMe,
    sewing_needle: eIe,
    yarn: tIe,
    knot: nIe,
    eyeglasses: rIe,
    dark_sunglasses: oIe,
    goggles: sIe,
    lab_coat: iIe,
    safety_vest: aIe,
    necktie: cIe,
    shirt: lIe,
    tshirt: uIe,
    jeans: dIe,
    scarf: fIe,
    gloves: pIe,
    coat: hIe,
    socks: gIe,
    dress: mIe,
    kimono: vIe,
    sari: _Ie,
    one_piece_swimsuit: bIe,
    swim_brief: yIe,
    shorts: wIe,
    bikini: kIe,
    womans_clothes: xIe,
    purse: CIe,
    handbag: SIe,
    pouch: EIe,
    shopping: AIe,
    school_satchel: $Ie,
    thong_sandal: MIe,
    mans_shoe: IIe,
    shoe: TIe,
    athletic_shoe: LIe,
    hiking_boot: OIe,
    flat_shoe: RIe,
    high_heel: PIe,
    sandal: BIe,
    ballet_shoes: zIe,
    boot: DIe,
    crown: NIe,
    womans_hat: qIe,
    tophat: FIe,
    mortar_board: HIe,
    billed_cap: jIe,
    military_helmet: UIe,
    rescue_worker_helmet: VIe,
    prayer_beads: ZIe,
    lipstick: WIe,
    ring: GIe,
    gem: KIe,
    mute: XIe,
    speaker: YIe,
    sound: JIe,
    loud_sound: QIe,
    loudspeaker: eTe,
    mega: tTe,
    postal_horn: nTe,
    bell: rTe,
    no_bell: oTe,
    musical_score: sTe,
    musical_note: iTe,
    notes: aTe,
    studio_microphone: cTe,
    level_slider: lTe,
    control_knobs: uTe,
    microphone: dTe,
    headphones: fTe,
    radio: pTe,
    saxophone: hTe,
    accordion: gTe,
    guitar: mTe,
    musical_keyboard: vTe,
    trumpet: _Te,
    violin: bTe,
    banjo: yTe,
    drum: wTe,
    long_drum: kTe,
    iphone: xTe,
    calling: CTe,
    phone: STe,
    telephone: ETe,
    telephone_receiver: ATe,
    pager: $Te,
    fax: MTe,
    battery: ITe,
    electric_plug: TTe,
    computer: LTe,
    desktop_computer: OTe,
    printer: RTe,
    keyboard: PTe,
    computer_mouse: BTe,
    trackball: zTe,
    minidisc: DTe,
    floppy_disk: NTe,
    cd: qTe,
    dvd: FTe,
    abacus: HTe,
    movie_camera: jTe,
    film_strip: UTe,
    film_projector: VTe,
    clapper: ZTe,
    tv: WTe,
    camera: GTe,
    camera_flash: KTe,
    video_camera: XTe,
    vhs: YTe,
    mag: JTe,
    mag_right: QTe,
    candle: eLe,
    bulb: tLe,
    flashlight: nLe,
    izakaya_lantern: rLe,
    lantern: oLe,
    diya_lamp: sLe,
    notebook_with_decorative_cover: iLe,
    closed_book: aLe,
    book: cLe,
    open_book: lLe,
    green_book: uLe,
    blue_book: dLe,
    orange_book: fLe,
    books: pLe,
    notebook: hLe,
    ledger: gLe,
    page_with_curl: mLe,
    scroll: vLe,
    page_facing_up: _Le,
    newspaper: bLe,
    newspaper_roll: yLe,
    bookmark_tabs: wLe,
    bookmark: kLe,
    label: xLe,
    moneybag: CLe,
    coin: SLe,
    yen: ELe,
    dollar: ALe,
    euro: $Le,
    pound: MLe,
    money_with_wings: ILe,
    credit_card: TLe,
    receipt: LLe,
    chart: OLe,
    envelope: RLe,
    email: PLe,
    "e-mail": "\uD83D\uDCE7",
    incoming_envelope: BLe,
    envelope_with_arrow: zLe,
    outbox_tray: DLe,
    inbox_tray: NLe,
    "package": "\uD83D\uDCE6",
    mailbox: qLe,
    mailbox_closed: FLe,
    mailbox_with_mail: HLe,
    mailbox_with_no_mail: jLe,
    postbox: ULe,
    ballot_box: VLe,
    pencil2: ZLe,
    black_nib: WLe,
    fountain_pen: GLe,
    pen: KLe,
    paintbrush: XLe,
    crayon: YLe,
    memo: JLe,
    pencil: QLe,
    briefcase: eOe,
    file_folder: tOe,
    open_file_folder: nOe,
    card_index_dividers: rOe,
    date: oOe,
    calendar: sOe,
    spiral_notepad: iOe,
    spiral_calendar: aOe,
    card_index: cOe,
    chart_with_upwards_trend: lOe,
    chart_with_downwards_trend: uOe,
    bar_chart: dOe,
    clipboard: fOe,
    pushpin: pOe,
    round_pushpin: hOe,
    paperclip: gOe,
    paperclips: mOe,
    straight_ruler: vOe,
    triangular_ruler: _Oe,
    scissors: bOe,
    card_file_box: yOe,
    file_cabinet: wOe,
    wastebasket: kOe,
    lock: xOe,
    unlock: COe,
    lock_with_ink_pen: SOe,
    closed_lock_with_key: EOe,
    key: AOe,
    old_key: $Oe,
    hammer: MOe,
    axe: IOe,
    pick: TOe,
    hammer_and_pick: LOe,
    hammer_and_wrench: OOe,
    dagger: ROe,
    crossed_swords: POe,
    gun: BOe,
    boomerang: zOe,
    bow_and_arrow: DOe,
    shield: NOe,
    carpentry_saw: qOe,
    wrench: FOe,
    screwdriver: HOe,
    nut_and_bolt: jOe,
    gear: UOe,
    clamp: VOe,
    balance_scale: ZOe,
    probing_cane: WOe,
    link: GOe,
    chains: KOe,
    hook: XOe,
    toolbox: YOe,
    magnet: JOe,
    ladder: QOe,
    alembic: eRe,
    test_tube: tRe,
    petri_dish: nRe,
    dna: rRe,
    microscope: oRe,
    telescope: sRe,
    satellite: iRe,
    syringe: aRe,
    drop_of_blood: cRe,
    pill: lRe,
    adhesive_bandage: uRe,
    stethoscope: dRe,
    door: fRe,
    elevator: pRe,
    mirror: hRe,
    window: gRe,
    bed: mRe,
    couch_and_lamp: vRe,
    chair: _Re,
    toilet: bRe,
    plunger: yRe,
    shower: wRe,
    bathtub: kRe,
    mouse_trap: xRe,
    razor: CRe,
    lotion_bottle: SRe,
    safety_pin: ERe,
    broom: ARe,
    basket: $Re,
    roll_of_paper: MRe,
    bucket: IRe,
    soap: TRe,
    toothbrush: LRe,
    sponge: ORe,
    fire_extinguisher: RRe,
    shopping_cart: PRe,
    smoking: BRe,
    coffin: zRe,
    headstone: DRe,
    funeral_urn: NRe,
    moyai: qRe,
    placard: FRe,
    atm: HRe,
    put_litter_in_its_place: jRe,
    potable_water: URe,
    wheelchair: VRe,
    mens: ZRe,
    womens: WRe,
    restroom: GRe,
    baby_symbol: KRe,
    wc: XRe,
    passport_control: YRe,
    customs: JRe,
    baggage_claim: QRe,
    left_luggage: ePe,
    warning: tPe,
    children_crossing: nPe,
    no_entry: rPe,
    no_entry_sign: oPe,
    no_bicycles: sPe,
    no_smoking: iPe,
    do_not_litter: aPe,
    "non-potable_water": "\uD83D\uDEB1",
    no_pedestrians: cPe,
    no_mobile_phones: lPe,
    underage: uPe,
    radioactive: dPe,
    biohazard: fPe,
    arrow_up: pPe,
    arrow_upper_right: hPe,
    arrow_right: gPe,
    arrow_lower_right: mPe,
    arrow_down: vPe,
    arrow_lower_left: _Pe,
    arrow_left: bPe,
    arrow_upper_left: yPe,
    arrow_up_down: wPe,
    left_right_arrow: kPe,
    leftwards_arrow_with_hook: xPe,
    arrow_right_hook: CPe,
    arrow_heading_up: SPe,
    arrow_heading_down: EPe,
    arrows_clockwise: APe,
    arrows_counterclockwise: $Pe,
    back: MPe,
    end: IPe,
    on: TPe,
    soon: LPe,
    top: OPe,
    place_of_worship: RPe,
    atom_symbol: PPe,
    om: BPe,
    star_of_david: zPe,
    wheel_of_dharma: DPe,
    yin_yang: NPe,
    latin_cross: qPe,
    orthodox_cross: FPe,
    star_and_crescent: HPe,
    peace_symbol: jPe,
    menorah: UPe,
    six_pointed_star: VPe,
    aries: ZPe,
    taurus: WPe,
    gemini: GPe,
    cancer: KPe,
    leo: XPe,
    virgo: YPe,
    libra: JPe,
    scorpius: QPe,
    sagittarius: eBe,
    capricorn: tBe,
    aquarius: nBe,
    pisces: rBe,
    ophiuchus: oBe,
    twisted_rightwards_arrows: sBe,
    repeat: iBe,
    repeat_one: aBe,
    arrow_forward: cBe,
    fast_forward: lBe,
    next_track_button: uBe,
    play_or_pause_button: dBe,
    arrow_backward: fBe,
    rewind: pBe,
    previous_track_button: hBe,
    arrow_up_small: gBe,
    arrow_double_up: mBe,
    arrow_down_small: vBe,
    arrow_double_down: _Be,
    pause_button: bBe,
    stop_button: yBe,
    record_button: wBe,
    eject_button: kBe,
    cinema: xBe,
    low_brightness: CBe,
    high_brightness: SBe,
    signal_strength: EBe,
    vibration_mode: ABe,
    mobile_phone_off: $Be,
    female_sign: MBe,
    male_sign: IBe,
    transgender_symbol: TBe,
    heavy_multiplication_x: LBe,
    heavy_plus_sign: OBe,
    heavy_minus_sign: RBe,
    heavy_division_sign: PBe,
    infinity: BBe,
    bangbang: zBe,
    interrobang: DBe,
    question: NBe,
    grey_question: qBe,
    grey_exclamation: FBe,
    exclamation: HBe,
    heavy_exclamation_mark: jBe,
    wavy_dash: UBe,
    currency_exchange: VBe,
    heavy_dollar_sign: ZBe,
    medical_symbol: WBe,
    recycle: GBe,
    fleur_de_lis: KBe,
    trident: XBe,
    name_badge: YBe,
    beginner: JBe,
    o: QBe,
    white_check_mark: eze,
    ballot_box_with_check: tze,
    heavy_check_mark: nze,
    x: rze,
    negative_squared_cross_mark: oze,
    curly_loop: sze,
    loop: ize,
    part_alternation_mark: aze,
    eight_spoked_asterisk: cze,
    eight_pointed_black_star: lze,
    sparkle: uze,
    copyright: dze,
    registered: fze,
    tm: pze,
    hash: hze,
    asterisk: gze,
    zero: mze,
    one: vze,
    two: _ze,
    three: bze,
    four: yze,
    five: wze,
    six: kze,
    seven: xze,
    eight: Cze,
    nine: Sze,
    keycap_ten: Eze,
    capital_abcd: Aze,
    abcd: $ze,
    symbols: Mze,
    abc: Ize,
    a: Tze,
    ab: Lze,
    b: Oze,
    cl: Rze,
    cool: Pze,
    free: Bze,
    information_source: zze,
    id: Dze,
    m: Nze,
    "new": "\uD83C\uDD95",
    ng: qze,
    o2: Fze,
    ok: Hze,
    parking: jze,
    sos: Uze,
    up: Vze,
    vs: Zze,
    koko: Wze,
    sa: Gze,
    ideograph_advantage: Kze,
    accept: Xze,
    congratulations: Yze,
    secret: Jze,
    u6e80: Qze,
    red_circle: eDe,
    orange_circle: tDe,
    yellow_circle: nDe,
    green_circle: rDe,
    large_blue_circle: oDe,
    purple_circle: sDe,
    brown_circle: iDe,
    black_circle: aDe,
    white_circle: cDe,
    red_square: lDe,
    orange_square: uDe,
    yellow_square: dDe,
    green_square: fDe,
    blue_square: pDe,
    purple_square: hDe,
    brown_square: gDe,
    black_large_square: mDe,
    white_large_square: vDe,
    black_medium_square: _De,
    white_medium_square: bDe,
    black_medium_small_square: yDe,
    white_medium_small_square: wDe,
    black_small_square: kDe,
    white_small_square: xDe,
    large_orange_diamond: CDe,
    large_blue_diamond: SDe,
    small_orange_diamond: EDe,
    small_blue_diamond: ADe,
    small_red_triangle: $De,
    small_red_triangle_down: MDe,
    diamond_shape_with_a_dot_inside: IDe,
    radio_button: TDe,
    white_square_button: LDe,
    black_square_button: ODe,
    checkered_flag: RDe,
    triangular_flag_on_post: PDe,
    crossed_flags: BDe,
    black_flag: zDe,
    white_flag: DDe,
    rainbow_flag: NDe,
    transgender_flag: qDe,
    pirate_flag: FDe,
    ascension_island: HDe,
    andorra: jDe,
    united_arab_emirates: UDe,
    afghanistan: VDe,
    antigua_barbuda: ZDe,
    anguilla: WDe,
    albania: GDe,
    armenia: KDe,
    angola: XDe,
    antarctica: YDe,
    argentina: JDe,
    american_samoa: QDe,
    austria: eNe,
    australia: tNe,
    aruba: nNe,
    aland_islands: rNe,
    azerbaijan: oNe,
    bosnia_herzegovina: sNe,
    barbados: iNe,
    bangladesh: aNe,
    belgium: cNe,
    burkina_faso: lNe,
    bulgaria: uNe,
    bahrain: dNe,
    burundi: fNe,
    benin: pNe,
    st_barthelemy: hNe,
    bermuda: gNe,
    brunei: mNe,
    bolivia: vNe,
    caribbean_netherlands: _Ne,
    brazil: bNe,
    bahamas: yNe,
    bhutan: wNe,
    bouvet_island: kNe,
    botswana: xNe,
    belarus: CNe,
    belize: SNe,
    canada: ENe,
    cocos_islands: ANe,
    congo_kinshasa: $Ne,
    central_african_republic: MNe,
    congo_brazzaville: INe,
    switzerland: TNe,
    cote_divoire: LNe,
    cook_islands: ONe,
    chile: RNe,
    cameroon: PNe,
    cn: BNe,
    colombia: zNe,
    clipperton_island: DNe,
    costa_rica: NNe,
    cuba: qNe,
    cape_verde: FNe,
    curacao: HNe,
    christmas_island: jNe,
    cyprus: UNe,
    czech_republic: VNe,
    de: ZNe,
    diego_garcia: WNe,
    djibouti: GNe,
    denmark: KNe,
    dominica: XNe,
    dominican_republic: YNe,
    algeria: JNe,
    ceuta_melilla: QNe,
    ecuador: eqe,
    estonia: tqe,
    egypt: nqe,
    western_sahara: rqe,
    eritrea: oqe,
    es: sqe,
    ethiopia: iqe,
    eu: aqe,
    european_union: cqe,
    finland: lqe,
    fiji: uqe,
    falkland_islands: dqe,
    micronesia: fqe,
    faroe_islands: pqe,
    fr: hqe,
    gabon: gqe,
    gb: mqe,
    uk: vqe,
    grenada: _qe,
    georgia: bqe,
    french_guiana: yqe,
    guernsey: wqe,
    ghana: kqe,
    gibraltar: xqe,
    greenland: Cqe,
    gambia: Sqe,
    guinea: Eqe,
    guadeloupe: Aqe,
    equatorial_guinea: $qe,
    greece: Mqe,
    south_georgia_south_sandwich_islands: Iqe,
    guatemala: Tqe,
    guam: Lqe,
    guinea_bissau: Oqe,
    guyana: Rqe,
    hong_kong: Pqe,
    heard_mcdonald_islands: Bqe,
    honduras: zqe,
    croatia: Dqe,
    haiti: Nqe,
    hungary: qqe,
    canary_islands: Fqe,
    indonesia: Hqe,
    ireland: jqe,
    israel: Uqe,
    isle_of_man: Vqe,
    india: Zqe,
    british_indian_ocean_territory: Wqe,
    iraq: Gqe,
    iran: Kqe,
    iceland: Xqe,
    it: Yqe,
    jersey: Jqe,
    jamaica: Qqe,
    jordan: eFe,
    jp: tFe,
    kenya: nFe,
    kyrgyzstan: rFe,
    cambodia: oFe,
    kiribati: sFe,
    comoros: iFe,
    st_kitts_nevis: aFe,
    north_korea: cFe,
    kr: lFe,
    kuwait: uFe,
    cayman_islands: dFe,
    kazakhstan: fFe,
    laos: pFe,
    lebanon: hFe,
    st_lucia: gFe,
    liechtenstein: mFe,
    sri_lanka: vFe,
    liberia: _Fe,
    lesotho: bFe,
    lithuania: yFe,
    luxembourg: wFe,
    latvia: kFe,
    libya: xFe,
    morocco: CFe,
    monaco: SFe,
    moldova: EFe,
    montenegro: AFe,
    st_martin: $Fe,
    madagascar: MFe,
    marshall_islands: IFe,
    macedonia: TFe,
    mali: LFe,
    myanmar: OFe,
    mongolia: RFe,
    macau: PFe,
    northern_mariana_islands: BFe,
    martinique: zFe,
    mauritania: DFe,
    montserrat: NFe,
    malta: qFe,
    mauritius: FFe,
    maldives: HFe,
    malawi: jFe,
    mexico: UFe,
    malaysia: VFe,
    mozambique: ZFe,
    namibia: WFe,
    new_caledonia: GFe,
    niger: KFe,
    norfolk_island: XFe,
    nigeria: YFe,
    nicaragua: JFe,
    netherlands: QFe,
    norway: eHe,
    nepal: tHe,
    nauru: nHe,
    niue: rHe,
    new_zealand: oHe,
    oman: sHe,
    panama: iHe,
    peru: aHe,
    french_polynesia: cHe,
    papua_new_guinea: lHe,
    philippines: uHe,
    pakistan: dHe,
    poland: fHe,
    st_pierre_miquelon: pHe,
    pitcairn_islands: hHe,
    puerto_rico: gHe,
    palestinian_territories: mHe,
    portugal: vHe,
    palau: _He,
    paraguay: bHe,
    qatar: yHe,
    reunion: wHe,
    romania: kHe,
    serbia: xHe,
    ru: CHe,
    rwanda: SHe,
    saudi_arabia: EHe,
    solomon_islands: AHe,
    seychelles: $He,
    sudan: MHe,
    sweden: IHe,
    singapore: THe,
    st_helena: LHe,
    slovenia: OHe,
    svalbard_jan_mayen: RHe,
    slovakia: PHe,
    sierra_leone: BHe,
    san_marino: zHe,
    senegal: DHe,
    somalia: NHe,
    suriname: qHe,
    south_sudan: FHe,
    sao_tome_principe: HHe,
    el_salvador: jHe,
    sint_maarten: UHe,
    syria: VHe,
    swaziland: ZHe,
    tristan_da_cunha: WHe,
    turks_caicos_islands: GHe,
    chad: KHe,
    french_southern_territories: XHe,
    togo: YHe,
    thailand: JHe,
    tajikistan: QHe,
    tokelau: eje,
    timor_leste: tje,
    turkmenistan: nje,
    tunisia: rje,
    tonga: oje,
    tr: sje,
    trinidad_tobago: ije,
    tuvalu: aje,
    taiwan: cje,
    tanzania: lje,
    ukraine: uje,
    uganda: dje,
    us_outlying_islands: fje,
    united_nations: pje,
    us: hje,
    uruguay: gje,
    uzbekistan: mje,
    vatican_city: vje,
    st_vincent_grenadines: _je,
    venezuela: bje,
    british_virgin_islands: yje,
    us_virgin_islands: wje,
    vietnam: kje,
    vanuatu: xje,
    wallis_futuna: Cje,
    samoa: Sje,
    kosovo: Eje,
    yemen: Aje,
    mayotte: $je,
    south_africa: Mje,
    zambia: Ije,
    zimbabwe: Tje,
    england: Lje,
    scotland: Oje,
    wales: Rje
};
var oa, Xf;
function Bje() {
    return Xf || (Xf = 1, oa = {
        angry: [
            ">:(",
            ">:-("
        ],
        blush: [
            ':")',
            ':-")'
        ],
        broken_heart: [
            "</3",
            "<\\3"
        ],
        // :\ and :-\ not used because of conflict with markdown escaping
        confused: [
            ":/",
            ":-/"
        ],
        // twemoji shows question
        cry: [
            ":'(",
            ":'-(",
            ":,(",
            ":,-("
        ],
        frowning: [
            ":(",
            ":-("
        ],
        heart: [
            "<3"
        ],
        imp: [
            "]:(",
            "]:-("
        ],
        innocent: [
            "o:)",
            "O:)",
            "o:-)",
            "O:-)",
            "0:)",
            "0:-)"
        ],
        joy: [
            ":')",
            ":'-)",
            ":,)",
            ":,-)",
            ":'D",
            ":'-D",
            ":,D",
            ":,-D"
        ],
        kissing: [
            ":*",
            ":-*"
        ],
        laughing: [
            "x-)",
            "X-)"
        ],
        neutral_face: [
            ":|",
            ":-|"
        ],
        open_mouth: [
            ":o",
            ":-o",
            ":O",
            ":-O"
        ],
        rage: [
            ":@",
            ":-@"
        ],
        smile: [
            ":D",
            ":-D"
        ],
        smiley: [
            ":)",
            ":-)"
        ],
        smiling_imp: [
            "]:)",
            "]:-)"
        ],
        sob: [
            ":,'(",
            ":,'-(",
            ";(",
            ";-("
        ],
        stuck_out_tongue: [
            ":P",
            ":-P"
        ],
        sunglasses: [
            "8-)",
            "B-)"
        ],
        sweat: [
            ",:(",
            ",:-("
        ],
        sweat_smile: [
            ",:)",
            ",:-)"
        ],
        unamused: [
            ":s",
            ":-S",
            ":z",
            ":-Z",
            ":$",
            ":-$"
        ],
        wink: [
            ";)",
            ";-)"
        ]
    }), oa;
}
var sa, Yf;
function zje() {
    return Yf || (Yf = 1, sa = function sa(t, n) {
        return t[n].content;
    }), sa;
}
var ia, Jf;
function Dje() {
    return Jf || (Jf = 1, ia = function ia(t, n, r, s, o) {
        var i = t.utils.arrayReplaceAt, a = t.utils.lib.ucmicro, c = new RegExp([
            a.Z.source,
            a.P.source,
            a.Cc.source
        ].join("|"));
        function u(d, l, m) {
            var f, v = 0, g = [];
            return d.replace(o, function(b, h, w) {
                var k;
                if (r.hasOwnProperty(b)) {
                    if (k = r[b], h > 0 && !c.test(w[h - 1]) || h + b.length < w.length && !c.test(w[h + b.length])) return;
                } else k = b.slice(1, -1);
                h > v && (f = new m("text", "", 0), f.content = d.slice(v, h), g.push(f)), f = new m("emoji", "", 0), f.markup = k, f.content = n[k], g.push(f), v = h + b.length;
            }), v < d.length && (f = new m("text", "", 0), f.content = d.slice(v), g.push(f)), g;
        }
        return function(l) {
            var m, f, v, g, b, h = l.tokens, w = 0;
            for(f = 0, v = h.length; f < v; f++)if (h[f].type === "inline") for(g = h[f].children, m = g.length - 1; m >= 0; m--)b = g[m], (b.type === "link_open" || b.type === "link_close") && b.info === "auto" && (w -= b.nesting), b.type === "text" && w === 0 && s.test(b.content) && (h[f].children = g = i(g, m, u(b.content, b.level, l.Token)));
        };
    }), ia;
}
var aa, Qf;
function Nje() {
    if (Qf) return aa;
    Qf = 1;
    function e(t) {
        return t.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
    }
    return aa = function aa(n) {
        var r = n.defs, s;
        n.enabled.length && (r = Object.keys(r).reduce(function(u, d) {
            return n.enabled.indexOf(d) >= 0 && (u[d] = r[d]), u;
        }, {})), s = Object.keys(n.shortcuts).reduce(function(u, d) {
            return r[d] ? Array.isArray(n.shortcuts[d]) ? (n.shortcuts[d].forEach(function(l) {
                u[l] = d;
            }), u) : (u[n.shortcuts[d]] = d, u) : u;
        }, {});
        var o = Object.keys(r), i;
        o.length === 0 ? i = "^$" : i = o.map(function(u) {
            return ":" + u + ":";
        }).concat(Object.keys(s)).sort().reverse().map(function(u) {
            return e(u);
        }).join("|");
        var a = RegExp(i), c = RegExp(i, "g");
        return {
            defs: r,
            shortcuts: s,
            scanRE: a,
            replaceRE: c
        };
    }, aa;
}
var ca, e0;
function qje() {
    if (e0) return ca;
    e0 = 1;
    var e = zje(), t = Dje(), n = Nje();
    return ca = function ca(s, o) {
        var i = {
            defs: {},
            shortcuts: {},
            enabled: []
        }, a = n(s.utils.assign({}, i, o || {}));
        s.renderer.rules.emoji = e, s.core.ruler.after("linkify", "emoji", t(s, a.defs, a.shortcuts, a.scanRE, a.replaceRE));
    }, ca;
}
var la, t0;
function Fje() {
    if (t0) return la;
    t0 = 1;
    var e = Pje, t = Bje(), n = qje();
    return la = function la(s, o) {
        var i = {
            defs: e,
            shortcuts: t,
            enabled: []
        }, a = s.utils.assign({}, i, o || {});
        n(s, a);
    }, la;
}
var Hje = Fje();
var jje = /* @__PURE__ */ Er(Hje);
var ua, n0;
function Uje() {
    if (n0) return ua;
    n0 = 1;
    function e(r, s) {
        var o, i, a = r.attrs[r.attrIndex("href")][1];
        for(o = 0; o < s.length; ++o){
            if (i = s[o], typeof i.matcher == "function") {
                if (i.matcher(a, i)) return i;
                continue;
            }
            return i;
        }
    }
    function t(r, s, o) {
        Object.keys(o).forEach(function(i) {
            var a, c = o[i];
            i === "className" && (i = "class"), a = s[r].attrIndex(i), a < 0 ? s[r].attrPush([
                i,
                c
            ]) : s[r].attrs[a][1] = c;
        });
    }
    function n(r, s) {
        s ? s = Array.isArray(s) ? s : [
            s
        ] : s = [], Object.freeze(s);
        var o = r.renderer.rules.link_open || this.defaultRender;
        r.renderer.rules.link_open = function(i, a, c, u, d) {
            var l = e(i[a], s), m = l && l.attrs;
            return m && t(a, i, m), o(i, a, c, u, d);
        };
    }
    return n.defaultRender = function(r, s, o, i, a) {
        return a.renderToken(r, s, o);
    }, ua = n, ua;
}
var Vje = Uje();
var hm = /* @__PURE__ */ Er(Vje);
var da, r0;
function Zje() {
    if (r0) return da;
    r0 = 1;
    var e = !0, t = !1, n = !1;
    da = function da(g, b) {
        b && (e = !b.enabled, t = !!b.label, n = !!b.labelAfter), g.core.ruler.after("inline", "github-task-lists", function(h) {
            for(var w = h.tokens, k = 2; k < w.length; k++)o(w, k) && (i(w[k], h.Token), r(w[k - 2], "class", "task-list-item" + (e ? "" : " enabled")), r(w[s(w, k - 2)], "class", "contains-task-list"));
        });
    };
    function r(g, b, h) {
        var w = g.attrIndex(b), k = [
            b,
            h
        ];
        w < 0 ? g.attrPush(k) : g.attrs[w] = k;
    }
    function s(g, b) {
        for(var h = g[b].level - 1, w = b - 1; w >= 0; w--)if (g[w].level === h) return w;
        return -1;
    }
    function o(g, b) {
        return l(g[b]) && m(g[b - 1]) && f(g[b - 2]) && v(g[b]);
    }
    function i(g, b) {
        if (g.children.unshift(a(g, b)), g.children[1].content = g.children[1].content.slice(3), g.content = g.content.slice(3), t) {
            if (n) {
                g.children.pop();
                var h = "task-item-" + Math.ceil(Math.random() * (1e4 * 1e3) - 1e3);
                g.children[0].content = g.children[0].content.slice(0, -1) + ' id="' + h + '">', g.children.push(d(g.content, h, b));
            } else g.children.unshift(c(b)), g.children.push(u(b));
        }
    }
    function a(g, b) {
        var h = new b("html_inline", "", 0), w = e ? ' disabled="" ' : "";
        return g.content.indexOf("[ ] ") === 0 ? h.content = '<input class="task-list-item-checkbox"' + w + 'type="checkbox">' : (g.content.indexOf("[x] ") === 0 || g.content.indexOf("[X] ") === 0) && (h.content = '<input class="task-list-item-checkbox" checked=""' + w + 'type="checkbox">'), h;
    }
    function c(g) {
        var b = new g("html_inline", "", 0);
        return b.content = "<label>", b;
    }
    function u(g) {
        var b = new g("html_inline", "", 0);
        return b.content = "</label>", b;
    }
    function d(g, b, h) {
        var w = new h("html_inline", "", 0);
        return w.content = '<label class="task-list-item-label" for="' + b + '">' + g + "</label>", w.attrs = [
            {
                "for": b
            }
        ], w;
    }
    function l(g) {
        return g.type === "inline";
    }
    function m(g) {
        return g.type === "paragraph_open";
    }
    function f(g) {
        return g.type === "list_item_open";
    }
    function v(g) {
        return g.content.indexOf("[ ] ") === 0 || g.content.indexOf("[x] ") === 0 || g.content.indexOf("[X] ") === 0;
    }
    return da;
}
var Wje = Zje();
var Gje = /* @__PURE__ */ Er(Wje);
var To = {
    exports: {}
}, Ze = {}, Lo = {
    exports: {}
}, Gn = {}, o0;
function gm() {
    if (o0) return Gn;
    o0 = 1;
    function e() {
        var o = {};
        return o["align-content"] = !1, o["align-items"] = !1, o["align-self"] = !1, o["alignment-adjust"] = !1, o["alignment-baseline"] = !1, o.all = !1, o["anchor-point"] = !1, o.animation = !1, o["animation-delay"] = !1, o["animation-direction"] = !1, o["animation-duration"] = !1, o["animation-fill-mode"] = !1, o["animation-iteration-count"] = !1, o["animation-name"] = !1, o["animation-play-state"] = !1, o["animation-timing-function"] = !1, o.azimuth = !1, o["backface-visibility"] = !1, o.background = !0, o["background-attachment"] = !0, o["background-clip"] = !0, o["background-color"] = !0, o["background-image"] = !0, o["background-origin"] = !0, o["background-position"] = !0, o["background-repeat"] = !0, o["background-size"] = !0, o["baseline-shift"] = !1, o.binding = !1, o.bleed = !1, o["bookmark-label"] = !1, o["bookmark-level"] = !1, o["bookmark-state"] = !1, o.border = !0, o["border-bottom"] = !0, o["border-bottom-color"] = !0, o["border-bottom-left-radius"] = !0, o["border-bottom-right-radius"] = !0, o["border-bottom-style"] = !0, o["border-bottom-width"] = !0, o["border-collapse"] = !0, o["border-color"] = !0, o["border-image"] = !0, o["border-image-outset"] = !0, o["border-image-repeat"] = !0, o["border-image-slice"] = !0, o["border-image-source"] = !0, o["border-image-width"] = !0, o["border-left"] = !0, o["border-left-color"] = !0, o["border-left-style"] = !0, o["border-left-width"] = !0, o["border-radius"] = !0, o["border-right"] = !0, o["border-right-color"] = !0, o["border-right-style"] = !0, o["border-right-width"] = !0, o["border-spacing"] = !0, o["border-style"] = !0, o["border-top"] = !0, o["border-top-color"] = !0, o["border-top-left-radius"] = !0, o["border-top-right-radius"] = !0, o["border-top-style"] = !0, o["border-top-width"] = !0, o["border-width"] = !0, o.bottom = !1, o["box-decoration-break"] = !0, o["box-shadow"] = !0, o["box-sizing"] = !0, o["box-snap"] = !0, o["box-suppress"] = !0, o["break-after"] = !0, o["break-before"] = !0, o["break-inside"] = !0, o["caption-side"] = !1, o.chains = !1, o.clear = !0, o.clip = !1, o["clip-path"] = !1, o["clip-rule"] = !1, o.color = !0, o["color-interpolation-filters"] = !0, o["column-count"] = !1, o["column-fill"] = !1, o["column-gap"] = !1, o["column-rule"] = !1, o["column-rule-color"] = !1, o["column-rule-style"] = !1, o["column-rule-width"] = !1, o["column-span"] = !1, o["column-width"] = !1, o.columns = !1, o.contain = !1, o.content = !1, o["counter-increment"] = !1, o["counter-reset"] = !1, o["counter-set"] = !1, o.crop = !1, o.cue = !1, o["cue-after"] = !1, o["cue-before"] = !1, o.cursor = !1, o.direction = !1, o.display = !0, o["display-inside"] = !0, o["display-list"] = !0, o["display-outside"] = !0, o["dominant-baseline"] = !1, o.elevation = !1, o["empty-cells"] = !1, o.filter = !1, o.flex = !1, o["flex-basis"] = !1, o["flex-direction"] = !1, o["flex-flow"] = !1, o["flex-grow"] = !1, o["flex-shrink"] = !1, o["flex-wrap"] = !1, o["float"] = !1, o["float-offset"] = !1, o["flood-color"] = !1, o["flood-opacity"] = !1, o["flow-from"] = !1, o["flow-into"] = !1, o.font = !0, o["font-family"] = !0, o["font-feature-settings"] = !0, o["font-kerning"] = !0, o["font-language-override"] = !0, o["font-size"] = !0, o["font-size-adjust"] = !0, o["font-stretch"] = !0, o["font-style"] = !0, o["font-synthesis"] = !0, o["font-variant"] = !0, o["font-variant-alternates"] = !0, o["font-variant-caps"] = !0, o["font-variant-east-asian"] = !0, o["font-variant-ligatures"] = !0, o["font-variant-numeric"] = !0, o["font-variant-position"] = !0, o["font-weight"] = !0, o.grid = !1, o["grid-area"] = !1, o["grid-auto-columns"] = !1, o["grid-auto-flow"] = !1, o["grid-auto-rows"] = !1, o["grid-column"] = !1, o["grid-column-end"] = !1, o["grid-column-start"] = !1, o["grid-row"] = !1, o["grid-row-end"] = !1, o["grid-row-start"] = !1, o["grid-template"] = !1, o["grid-template-areas"] = !1, o["grid-template-columns"] = !1, o["grid-template-rows"] = !1, o["hanging-punctuation"] = !1, o.height = !0, o.hyphens = !1, o.icon = !1, o["image-orientation"] = !1, o["image-resolution"] = !1, o["ime-mode"] = !1, o["initial-letters"] = !1, o["inline-box-align"] = !1, o["justify-content"] = !1, o["justify-items"] = !1, o["justify-self"] = !1, o.left = !1, o["letter-spacing"] = !0, o["lighting-color"] = !0, o["line-box-contain"] = !1, o["line-break"] = !1, o["line-grid"] = !1, o["line-height"] = !1, o["line-snap"] = !1, o["line-stacking"] = !1, o["line-stacking-ruby"] = !1, o["line-stacking-shift"] = !1, o["line-stacking-strategy"] = !1, o["list-style"] = !0, o["list-style-image"] = !0, o["list-style-position"] = !0, o["list-style-type"] = !0, o.margin = !0, o["margin-bottom"] = !0, o["margin-left"] = !0, o["margin-right"] = !0, o["margin-top"] = !0, o["marker-offset"] = !1, o["marker-side"] = !1, o.marks = !1, o.mask = !1, o["mask-box"] = !1, o["mask-box-outset"] = !1, o["mask-box-repeat"] = !1, o["mask-box-slice"] = !1, o["mask-box-source"] = !1, o["mask-box-width"] = !1, o["mask-clip"] = !1, o["mask-image"] = !1, o["mask-origin"] = !1, o["mask-position"] = !1, o["mask-repeat"] = !1, o["mask-size"] = !1, o["mask-source-type"] = !1, o["mask-type"] = !1, o["max-height"] = !0, o["max-lines"] = !1, o["max-width"] = !0, o["min-height"] = !0, o["min-width"] = !0, o["move-to"] = !1, o["nav-down"] = !1, o["nav-index"] = !1, o["nav-left"] = !1, o["nav-right"] = !1, o["nav-up"] = !1, o["object-fit"] = !1, o["object-position"] = !1, o.opacity = !1, o.order = !1, o.orphans = !1, o.outline = !1, o["outline-color"] = !1, o["outline-offset"] = !1, o["outline-style"] = !1, o["outline-width"] = !1, o.overflow = !1, o["overflow-wrap"] = !1, o["overflow-x"] = !1, o["overflow-y"] = !1, o.padding = !0, o["padding-bottom"] = !0, o["padding-left"] = !0, o["padding-right"] = !0, o["padding-top"] = !0, o.page = !1, o["page-break-after"] = !1, o["page-break-before"] = !1, o["page-break-inside"] = !1, o["page-policy"] = !1, o.pause = !1, o["pause-after"] = !1, o["pause-before"] = !1, o.perspective = !1, o["perspective-origin"] = !1, o.pitch = !1, o["pitch-range"] = !1, o["play-during"] = !1, o.position = !1, o["presentation-level"] = !1, o.quotes = !1, o["region-fragment"] = !1, o.resize = !1, o.rest = !1, o["rest-after"] = !1, o["rest-before"] = !1, o.richness = !1, o.right = !1, o.rotation = !1, o["rotation-point"] = !1, o["ruby-align"] = !1, o["ruby-merge"] = !1, o["ruby-position"] = !1, o["shape-image-threshold"] = !1, o["shape-outside"] = !1, o["shape-margin"] = !1, o.size = !1, o.speak = !1, o["speak-as"] = !1, o["speak-header"] = !1, o["speak-numeral"] = !1, o["speak-punctuation"] = !1, o["speech-rate"] = !1, o.stress = !1, o["string-set"] = !1, o["tab-size"] = !1, o["table-layout"] = !1, o["text-align"] = !0, o["text-align-last"] = !0, o["text-combine-upright"] = !0, o["text-decoration"] = !0, o["text-decoration-color"] = !0, o["text-decoration-line"] = !0, o["text-decoration-skip"] = !0, o["text-decoration-style"] = !0, o["text-emphasis"] = !0, o["text-emphasis-color"] = !0, o["text-emphasis-position"] = !0, o["text-emphasis-style"] = !0, o["text-height"] = !0, o["text-indent"] = !0, o["text-justify"] = !0, o["text-orientation"] = !0, o["text-overflow"] = !0, o["text-shadow"] = !0, o["text-space-collapse"] = !0, o["text-transform"] = !0, o["text-underline-position"] = !0, o["text-wrap"] = !0, o.top = !1, o.transform = !1, o["transform-origin"] = !1, o["transform-style"] = !1, o.transition = !1, o["transition-delay"] = !1, o["transition-duration"] = !1, o["transition-property"] = !1, o["transition-timing-function"] = !1, o["unicode-bidi"] = !1, o["vertical-align"] = !1, o.visibility = !1, o["voice-balance"] = !1, o["voice-duration"] = !1, o["voice-family"] = !1, o["voice-pitch"] = !1, o["voice-range"] = !1, o["voice-rate"] = !1, o["voice-stress"] = !1, o["voice-volume"] = !1, o.volume = !1, o["white-space"] = !1, o.widows = !1, o.width = !0, o["will-change"] = !1, o["word-break"] = !0, o["word-spacing"] = !0, o["word-wrap"] = !0, o["wrap-flow"] = !1, o["wrap-through"] = !1, o["writing-mode"] = !1, o["z-index"] = !1, o;
    }
    function t(o, i, a) {}
    function n(o, i, a) {}
    var r = /javascript\s*\:/img;
    function s(o, i) {
        return r.test(i) ? "" : i;
    }
    return Gn.whiteList = e(), Gn.getDefaultWhiteList = e, Gn.onAttr = t, Gn.onIgnoreAttr = n, Gn.safeAttrValue = s, Gn;
}
var fa, s0;
function mm() {
    return s0 || (s0 = 1, fa = {
        indexOf: function indexOf(e, t) {
            var n, r;
            if (Array.prototype.indexOf) return e.indexOf(t);
            for(n = 0, r = e.length; n < r; n++)if (e[n] === t) return n;
            return -1;
        },
        forEach: function forEach(e, t, n) {
            var r, s;
            if (Array.prototype.forEach) return e.forEach(t, n);
            for(r = 0, s = e.length; r < s; r++)t.call(n, e[r], r, e);
        },
        trim: function trim(e) {
            return String.prototype.trim ? e.trim() : e.replace(/(^\s*)|(\s*$)/g, "");
        },
        trimRight: function trimRight(e) {
            return String.prototype.trimRight ? e.trimRight() : e.replace(/(\s*$)/g, "");
        }
    }), fa;
}
var pa, i0;
function Kje() {
    if (i0) return pa;
    i0 = 1;
    var e = mm();
    function t(n, r) {
        n = e.trimRight(n), n[n.length - 1] !== ";" && (n += ";");
        var s = n.length, o = !1, i = 0, a = 0, c = "";
        function u() {
            if (!o) {
                var m = e.trim(n.slice(i, a)), f = m.indexOf(":");
                if (f !== -1) {
                    var v = e.trim(m.slice(0, f)), g = e.trim(m.slice(f + 1));
                    if (v) {
                        var b = r(i, c.length, v, g, m);
                        b && (c += b + "; ");
                    }
                }
            }
            i = a + 1;
        }
        for(; a < s; a++){
            var d = n[a];
            if (d === "/" && n[a + 1] === "*") {
                var l = n.indexOf("*/", a + 2);
                if (l === -1) break;
                a = l + 1, i = a + 1, o = !1;
            } else d === "(" ? o = !0 : d === ")" ? o = !1 : d === ";" ? o || u() : d === "\n" && u();
        }
        return e.trim(c);
    }
    return pa = t, pa;
}
var ha, a0;
function Xje() {
    if (a0) return ha;
    a0 = 1;
    var e = gm(), t = Kje();
    mm();
    function n(o) {
        return o == null;
    }
    function r(o) {
        var i = {};
        for(var a in o)i[a] = o[a];
        return i;
    }
    function s(o) {
        o = r(o || {}), o.whiteList = o.whiteList || e.whiteList, o.onAttr = o.onAttr || e.onAttr, o.onIgnoreAttr = o.onIgnoreAttr || e.onIgnoreAttr, o.safeAttrValue = o.safeAttrValue || e.safeAttrValue, this.options = o;
    }
    return s.prototype.process = function(o) {
        if (o = o || "", o = o.toString(), !o) return "";
        var i = this, a = i.options, c = a.whiteList, u = a.onAttr, d = a.onIgnoreAttr, l = a.safeAttrValue, m = t(o, function(f, v, g, b, h) {
            var w = c[g], k = !1;
            if (w === !0 ? k = w : typeof w == "function" ? k = w(b) : w instanceof RegExp && (k = w.test(b)), k !== !0 && (k = !1), b = l(g, b), !!b) {
                var x = {
                    position: v,
                    sourcePosition: f,
                    source: h,
                    isWhite: k
                };
                if (k) {
                    var A = u(g, b, x);
                    return n(A) ? g + ":" + b : A;
                } else {
                    var A = d(g, b, x);
                    if (!n(A)) return A;
                }
            }
        });
        return m;
    }, ha = s, ha;
}
var c0;
function Nc() {
    return c0 || (c0 = 1, function(e, t) {
        var n = gm(), r = Xje();
        function s(i, a) {
            var c = new r(a);
            return c.process(i);
        }
        t = e.exports = s, t.FilterCSS = r;
        for(var o in n)t[o] = n[o];
        (typeof window === "undefined" ? "undefined" : (0, $6gBIz._)(window)) < "u" && (window.filterCSS = e.exports);
    }(Lo, Lo.exports)), Lo.exports;
}
var ga, l0;
function Ml() {
    return l0 || (l0 = 1, ga = {
        indexOf: function indexOf(e, t) {
            var n, r;
            if (Array.prototype.indexOf) return e.indexOf(t);
            for(n = 0, r = e.length; n < r; n++)if (e[n] === t) return n;
            return -1;
        },
        forEach: function forEach(e, t, n) {
            var r, s;
            if (Array.prototype.forEach) return e.forEach(t, n);
            for(r = 0, s = e.length; r < s; r++)t.call(n, e[r], r, e);
        },
        trim: function trim(e) {
            return String.prototype.trim ? e.trim() : e.replace(/(^\s*)|(\s*$)/g, "");
        },
        spaceIndex: function spaceIndex(e) {
            var t = /\s|\n|\t/, n = t.exec(e);
            return n ? n.index : -1;
        }
    }), ga;
}
var u0;
function vm() {
    if (u0) return Ze;
    u0 = 1;
    var e = Nc().FilterCSS, t = Nc().getDefaultWhiteList, n = Ml();
    function r() {
        return {
            a: [
                "target",
                "href",
                "title"
            ],
            abbr: [
                "title"
            ],
            address: [],
            area: [
                "shape",
                "coords",
                "href",
                "alt"
            ],
            article: [],
            aside: [],
            audio: [
                "autoplay",
                "controls",
                "crossorigin",
                "loop",
                "muted",
                "preload",
                "src"
            ],
            b: [],
            bdi: [
                "dir"
            ],
            bdo: [
                "dir"
            ],
            big: [],
            blockquote: [
                "cite"
            ],
            br: [],
            caption: [],
            center: [],
            cite: [],
            code: [],
            col: [
                "align",
                "valign",
                "span",
                "width"
            ],
            colgroup: [
                "align",
                "valign",
                "span",
                "width"
            ],
            dd: [],
            del: [
                "datetime"
            ],
            details: [
                "open"
            ],
            div: [],
            dl: [],
            dt: [],
            em: [],
            figcaption: [],
            figure: [],
            font: [
                "color",
                "size",
                "face"
            ],
            footer: [],
            h1: [],
            h2: [],
            h3: [],
            h4: [],
            h5: [],
            h6: [],
            header: [],
            hr: [],
            i: [],
            img: [
                "src",
                "alt",
                "title",
                "width",
                "height",
                "loading"
            ],
            ins: [
                "datetime"
            ],
            kbd: [],
            li: [],
            mark: [],
            nav: [],
            ol: [],
            p: [],
            pre: [],
            s: [],
            section: [],
            small: [],
            span: [],
            sub: [],
            summary: [],
            sup: [],
            strong: [],
            strike: [],
            table: [
                "width",
                "border",
                "align",
                "valign"
            ],
            tbody: [
                "align",
                "valign"
            ],
            td: [
                "width",
                "rowspan",
                "colspan",
                "align",
                "valign"
            ],
            tfoot: [
                "align",
                "valign"
            ],
            th: [
                "width",
                "rowspan",
                "colspan",
                "align",
                "valign"
            ],
            thead: [
                "align",
                "valign"
            ],
            tr: [
                "rowspan",
                "align",
                "valign"
            ],
            tt: [],
            u: [],
            ul: [],
            video: [
                "autoplay",
                "controls",
                "crossorigin",
                "loop",
                "muted",
                "playsinline",
                "poster",
                "preload",
                "src",
                "height",
                "width"
            ]
        };
    }
    var s = new e();
    function o(N, j, U) {}
    function i(N, j, U) {}
    function a(N, j, U) {}
    function c(N, j, U) {}
    function u(N) {
        return N.replace(l, "&lt;").replace(m, "&gt;");
    }
    function d(N, j, U, G) {
        if (U = R(U), j === "href" || j === "src") {
            if (U = n.trim(U), U === "#") return "#";
            if (!(U.substr(0, 7) === "http://" || U.substr(0, 8) === "https://" || U.substr(0, 7) === "mailto:" || U.substr(0, 4) === "tel:" || U.substr(0, 11) === "data:image/" || U.substr(0, 6) === "ftp://" || U.substr(0, 2) === "./" || U.substr(0, 3) === "../" || U[0] === "#" || U[0] === "/")) return "";
        } else if (j === "background") {
            if (w.lastIndex = 0, w.test(U)) return "";
        } else if (j === "style") {
            if (k.lastIndex = 0, k.test(U) || (x.lastIndex = 0, x.test(U) && (w.lastIndex = 0, w.test(U)))) return "";
            G !== !1 && (G = G || s, U = G.process(U));
        }
        return U = B(U), U;
    }
    var l = /</g, m = />/g, f = /"/g, v = /&quot;/g, g = /&#([a-zA-Z0-9]*);?/gim, b = /&colon;?/gim, h = /&newline;?/gim, w = /((j\s*a\s*v\s*a|v\s*b|l\s*i\s*v\s*e)\s*s\s*c\s*r\s*i\s*p\s*t\s*|m\s*o\s*c\s*h\s*a):/gi, k = /e\s*x\s*p\s*r\s*e\s*s\s*s\s*i\s*o\s*n\s*\(.*/gi, x = /u\s*r\s*l\s*\(.*/gi;
    function A(N) {
        return N.replace(f, "&quot;");
    }
    function S(N) {
        return N.replace(v, '"');
    }
    function $(N) {
        return N.replace(g, function(U, G) {
            return G[0] === "x" || G[0] === "X" ? String.fromCharCode(parseInt(G.substr(1), 16)) : String.fromCharCode(parseInt(G, 10));
        });
    }
    function M(N) {
        return N.replace(b, ":").replace(h, " ");
    }
    function P(N) {
        for(var j = "", U = 0, G = N.length; U < G; U++)j += N.charCodeAt(U) < 32 ? " " : N.charAt(U);
        return n.trim(j);
    }
    function R(N) {
        return N = S(N), N = $(N), N = M(N), N = P(N), N;
    }
    function B(N) {
        return N = A(N), N = u(N), N;
    }
    function H() {
        return "";
    }
    function ie(N, j) {
        typeof j != "function" && (j = function j() {});
        var U = !Array.isArray(N);
        function G(V) {
            return U ? !0 : n.indexOf(N, V) !== -1;
        }
        var T = [], W = !1;
        return {
            onIgnoreTag: function onIgnoreTag(V, se, de) {
                if (G(V)) {
                    if (de.isClosing) {
                        var ve = "[/removed]", we = de.position + ve.length;
                        return T.push([
                            W !== !1 ? W : de.position,
                            we
                        ]), W = !1, ve;
                    } else return W || (W = de.position), "[removed]";
                } else return j(V, se, de);
            },
            remove: function remove(V) {
                var se = "", de = 0;
                return n.forEach(T, function(ve) {
                    se += V.slice(de, ve[0]), de = ve[1];
                }), se += V.slice(de), se;
            }
        };
    }
    function z(N) {
        for(var j = "", U = 0; U < N.length;){
            var G = N.indexOf("<!--", U);
            if (G === -1) {
                j += N.slice(U);
                break;
            }
            j += N.slice(U, G);
            var T = N.indexOf("-->", G);
            if (T === -1) break;
            U = T + 3;
        }
        return j;
    }
    function Q(N) {
        var j = N.split("");
        return j = j.filter(function(U) {
            var G = U.charCodeAt(0);
            return G === 127 ? !1 : G <= 31 ? G === 10 || G === 13 : !0;
        }), j.join("");
    }
    return Ze.whiteList = r(), Ze.getDefaultWhiteList = r, Ze.onTag = o, Ze.onIgnoreTag = i, Ze.onTagAttr = a, Ze.onIgnoreTagAttr = c, Ze.safeAttrValue = d, Ze.escapeHtml = u, Ze.escapeQuote = A, Ze.unescapeQuote = S, Ze.escapeHtmlEntities = $, Ze.escapeDangerHtml5Entities = M, Ze.clearNonPrintableCharacter = P, Ze.friendlyAttrValue = R, Ze.escapeAttrValue = B, Ze.onIgnoreTagStripAll = H, Ze.StripTagBody = ie, Ze.stripCommentTag = z, Ze.stripBlankChar = Q, Ze.attributeWrapSign = '"', Ze.cssFilter = s, Ze.getDefaultCSSWhiteList = t, Ze;
}
var Oo = {}, d0;
function _m() {
    if (d0) return Oo;
    d0 = 1;
    var e = Ml();
    function t(l) {
        var m = e.spaceIndex(l), f;
        return m === -1 ? f = l.slice(1, -1) : f = l.slice(1, m + 1), f = e.trim(f).toLowerCase(), f.slice(0, 1) === "/" && (f = f.slice(1)), f.slice(-1) === "/" && (f = f.slice(0, -1)), f;
    }
    function n(l) {
        return l.slice(0, 2) === "</";
    }
    function r(l, m, f) {
        var v = "", g = 0, b = !1, h = !1, w = 0, k = l.length, x = "", A = "";
        e: for(w = 0; w < k; w++){
            var S = l.charAt(w);
            if (b === !1) {
                if (S === "<") {
                    b = w;
                    continue;
                }
            } else if (h === !1) {
                if (S === "<") {
                    v += f(l.slice(g, w)), b = w, g = w;
                    continue;
                }
                if (S === ">" || w === k - 1) {
                    v += f(l.slice(g, b)), A = l.slice(b, w + 1), x = t(A), v += m(b, v.length, x, A, n(A)), g = w + 1, b = !1;
                    continue;
                }
                if (S === '"' || S === "'") for(var $ = 1, M = l.charAt(w - $); M.trim() === "" || M === "=";){
                    if (M === "=") {
                        h = S;
                        continue e;
                    }
                    M = l.charAt(w - ++$);
                }
            } else if (S === h) {
                h = !1;
                continue;
            }
        }
        return g < k && (v += f(l.substr(g))), v;
    }
    var s = /[^a-zA-Z0-9\\_:.-]/gim;
    function o(l, m) {
        var f = 0, v = 0, g = [], b = !1, h = l.length;
        function w($, M) {
            if ($ = e.trim($), $ = $.replace(s, "").toLowerCase(), !($.length < 1)) {
                var P = m($, M || "");
                P && g.push(P);
            }
        }
        for(var k = 0; k < h; k++){
            var x = l.charAt(k), A, S;
            if (b === !1 && x === "=") {
                b = l.slice(f, k), f = k + 1, v = l.charAt(f) === '"' || l.charAt(f) === "'" ? f : a(l, k + 1);
                continue;
            }
            if (b !== !1 && k === v) {
                if (S = l.indexOf(x, k + 1), S === -1) break;
                A = e.trim(l.slice(v + 1, S)), w(b, A), b = !1, k = S, f = k + 1;
                continue;
            }
            if (/\s|\n|\t/.test(x)) {
                if (l = l.replace(/\s|\n|\t/g, " "), b === !1) {
                    if (S = i(l, k), S === -1) {
                        A = e.trim(l.slice(f, k)), w(A), b = !1, f = k + 1;
                        continue;
                    } else {
                        k = S - 1;
                        continue;
                    }
                } else if (S = c(l, k - 1), S === -1) {
                    A = e.trim(l.slice(f, k)), A = d(A), w(b, A), b = !1, f = k + 1;
                    continue;
                } else continue;
            }
        }
        return f < l.length && (b === !1 ? w(l.slice(f)) : w(b, d(e.trim(l.slice(f))))), e.trim(g.join(" "));
    }
    function i(l, m) {
        for(; m < l.length; m++){
            var f = l[m];
            if (f !== " ") return f === "=" ? m : -1;
        }
    }
    function a(l, m) {
        for(; m < l.length; m++){
            var f = l[m];
            if (f !== " ") return f === "'" || f === '"' ? m : -1;
        }
    }
    function c(l, m) {
        for(; m > 0; m--){
            var f = l[m];
            if (f !== " ") return f === "=" ? m : -1;
        }
    }
    function u(l) {
        return l[0] === '"' && l[l.length - 1] === '"' || l[0] === "'" && l[l.length - 1] === "'";
    }
    function d(l) {
        return u(l) ? l.substr(1, l.length - 2) : l;
    }
    return Oo.parseTag = r, Oo.parseAttr = o, Oo;
}
var ma, f0;
function Yje() {
    if (f0) return ma;
    f0 = 1;
    var e = Nc().FilterCSS, t = vm(), n = _m(), r = n.parseTag, s = n.parseAttr, o = Ml();
    function i(l) {
        return l == null;
    }
    function a(l) {
        var m = o.spaceIndex(l);
        if (m === -1) return {
            html: "",
            closing: l[l.length - 2] === "/"
        };
        l = o.trim(l.slice(m + 1, -1));
        var f = l[l.length - 1] === "/";
        return f && (l = o.trim(l.slice(0, -1))), {
            html: l,
            closing: f
        };
    }
    function c(l) {
        var m = {};
        for(var f in l)m[f] = l[f];
        return m;
    }
    function u(l) {
        var m = {};
        for(var f in l)Array.isArray(l[f]) ? m[f.toLowerCase()] = l[f].map(function(v) {
            return v.toLowerCase();
        }) : m[f.toLowerCase()] = l[f];
        return m;
    }
    function d(l) {
        l = c(l || {}), l.stripIgnoreTag && (l.onIgnoreTag && console.error('Notes: cannot use these two options "stripIgnoreTag" and "onIgnoreTag" at the same time'), l.onIgnoreTag = t.onIgnoreTagStripAll), l.whiteList || l.allowList ? l.whiteList = u(l.whiteList || l.allowList) : l.whiteList = t.whiteList, this.attributeWrapSign = l.singleQuotedAttributeValue === !0 ? "'" : t.attributeWrapSign, l.onTag = l.onTag || t.onTag, l.onTagAttr = l.onTagAttr || t.onTagAttr, l.onIgnoreTag = l.onIgnoreTag || t.onIgnoreTag, l.onIgnoreTagAttr = l.onIgnoreTagAttr || t.onIgnoreTagAttr, l.safeAttrValue = l.safeAttrValue || t.safeAttrValue, l.escapeHtml = l.escapeHtml || t.escapeHtml, this.options = l, l.css === !1 ? this.cssFilter = !1 : (l.css = l.css || {}, this.cssFilter = new e(l.css));
    }
    return d.prototype.process = function(l) {
        if (l = l || "", l = l.toString(), !l) return "";
        var m = this, f = m.options, v = f.whiteList, g = f.onTag, b = f.onIgnoreTag, h = f.onTagAttr, w = f.onIgnoreTagAttr, k = f.safeAttrValue, x = f.escapeHtml, A = m.attributeWrapSign, S = m.cssFilter;
        f.stripBlankChar && (l = t.stripBlankChar(l)), f.allowCommentTag || (l = t.stripCommentTag(l));
        var $ = !1;
        f.stripIgnoreTagBody && ($ = t.StripTagBody(f.stripIgnoreTagBody, b), b = $.onIgnoreTag);
        var M = r(l, function(P, R, B, H, ie) {
            var z = {
                sourcePosition: P,
                position: R,
                isClosing: ie,
                isWhite: Object.prototype.hasOwnProperty.call(v, B)
            }, Q = g(B, H, z);
            if (!i(Q)) return Q;
            if (z.isWhite) {
                if (z.isClosing) return "</" + B + ">";
                var N = a(H), j = v[B], U = s(N.html, function(G, T) {
                    var W = o.indexOf(j, G) !== -1, V = h(B, G, T, W);
                    return i(V) ? W ? (T = k(B, G, T, S), T ? G + "=" + A + T + A : G) : (V = w(B, G, T, W), i(V) ? void 0 : V) : V;
                });
                return H = "<" + B, U && (H += " " + U), N.closing && (H += " /"), H += ">", H;
            } else return Q = b(B, H, z), i(Q) ? x(H) : Q;
        }, x);
        return $ && (M = $.remove(M)), M;
    }, ma = d, ma;
}
var p0;
function Jje() {
    return p0 || (p0 = 1, function(e, t) {
        var n = vm(), r = _m(), s = Yje();
        function o(a, c) {
            var u = new s(c);
            return u.process(a);
        }
        t = e.exports = o, t.filterXSS = o, t.FilterXSS = s, function() {
            for(var a in n)t[a] = n[a];
            for(var c in r)t[c] = r[c];
        }(), (typeof window === "undefined" ? "undefined" : (0, $6gBIz._)(window)) < "u" && (window.filterXSS = e.exports);
        function i() {
            return (typeof self === "undefined" ? "undefined" : (0, $6gBIz._)(self)) < "u" && (typeof DedicatedWorkerGlobalScope === "undefined" ? "undefined" : (0, $6gBIz._)(DedicatedWorkerGlobalScope)) < "u" && self instanceof DedicatedWorkerGlobalScope;
        }
        i() && (self.filterXSS = e.exports);
    }(To, To.exports)), To.exports;
}
var jo = Jje();
var Qje = /* @__PURE__ */ Er(jo), eUe = /@\[youtube]\(([\w-]{11}(?:\?.*)?)\)/im, tUe = /^https:\/\/(?:www\.)?(youtube\.com|youtube-nocookie\.com)\/embed\/[\w-]{11}(?:\?.*)?$/i, nUe = function(e, t) {
    var n = (0, $6869c._)({
        width: "100%",
        title: "YouTube video player",
        nocookie: !0
    }, t), r = function(o, i) {
        var a = o.pos, c = o.src;
        if (c.charCodeAt(a) !== 64) return !1;
        var u = eUe.exec(c.slice(a));
        if (!u) return !1;
        if (!i) {
            var d = o.push("youtube_embed", "", 0);
            d.meta = {
                videoId: u[1]
            };
        }
        return o.pos += u[0].length, !0;
    }, s = n.nocookie ? "https://www.youtube-nocookie.com/embed/" : "https://www.youtube.com/embed/";
    e.inline.ruler.before("link", "youtube_embed", r), e.renderer.rules.youtube_embed = function(o, i) {
        var _o_i_meta = o[i].meta, a = _o_i_meta.videoId;
        return "<iframe ".concat([
            'width="'.concat(n.width, '"')
        ].concat((0, $kf9Kn._)(n.height ? [
            'height="'.concat(n.height, '"')
        ] : []), [
            'src="'.concat(s).concat(a, '"'),
            'title="'.concat(e.utils.escapeHtml(n.title), '"'),
            'frameborder="0"',
            'allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"',
            'referrerpolicy="strict-origin-when-cross-origin"',
            "allowfullscreen"
        ]).join(" "), "></iframe>");
    };
}, rUe = {
    "class": "n8n-markdown"
}, oUe = [
    "innerHTML"
], sUe = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    __name: "Markdown",
    props: {
        content: {
            "default": ""
        },
        withMultiBreaks: {
            type: Boolean,
            "default": !1
        },
        images: {
            "default": function() {
                return [];
            }
        },
        loading: {
            type: Boolean,
            "default": !1
        },
        loadingBlocks: {
            "default": 2
        },
        loadingRows: {
            "default": 3
        },
        theme: {
            "default": "markdown"
        },
        options: {
            "default": function() {
                return {
                    markdown: {
                        html: !1,
                        linkify: !0,
                        typographer: !0,
                        breaks: !0
                    },
                    linkAttributes: {
                        attrs: {
                            target: "_blank",
                            rel: "noopener"
                        }
                    },
                    tasklists: {
                        enabled: !0,
                        label: !0,
                        labelAfter: !0
                    },
                    youtube: {}
                };
            }
        }
    },
    emits: [
        "markdown-click",
        "update-content"
    ],
    setup: function(e, param) {
        var t = param.emit;
        var n = e, r = (0, $5wB2C.ref)(void 0), s = n.options, o = new pm(s.markdown).use(hm, s.linkAttributes).use(jje).use(Gje, s.tasklists).use(nUe, s.youtube), i = (0, $bnFl0._)((0, $6869c._)({}, jo.whiteList), {
            label: [
                "class",
                "for"
            ],
            iframe: [
                "width",
                "height",
                "src",
                "title",
                "frameborder",
                "allow",
                "referrerpolicy",
                "allowfullscreen"
            ]
        }), a = (0, $5wB2C.computed)(function() {
            if (!n.content) return "";
            var f = {};
            n.images && n.images.forEach(function(w) {
                w && (f[w.id] = w.url);
            });
            var v = new RegExp("fileId:([0-9]+)");
            var g = n.content;
            n.withMultiBreaks && (g = g.replaceAll("\n\n", "\n&nbsp;\n"));
            var b = o.render(g);
            return Qje(b, {
                onTagAttr: function(w, k, x) {
                    if (w === "img" && k === "src") {
                        if (x.match(v)) {
                            var $ = x.split("fileId:")[1], M = jo.friendlyAttrValue(f[$]);
                            return M ? "src=".concat(M) : "";
                        }
                        var S = x.split("#")[0].match(/\.(jpeg|jpg|gif|png|webp)$/) !== null && x.startsWith("/static/");
                        if (!x.startsWith("https://") && !S) return "";
                    }
                    if (w === "iframe") return k === "src" ? tUe.test(x) ? "src=".concat(jo.friendlyAttrValue(x)) : "" : void 0;
                },
                onTag: function(w, k) {
                    if (w === "img" && k.includes('alt="workflow-screenshot"')) return "";
                },
                onIgnoreTag: function(w, k) {
                    if (w === "input" && k.includes('type="checkbox"')) return k;
                },
                whiteList: i
            });
        }), c = t, u = function(f) {
            var v = null;
            if (f.target instanceof HTMLAnchorElement && (v = f.target), f.target instanceof HTMLElement && f.target.matches("a *")) {
                var g = f.target.closest("a");
                g && (v = g);
            }
            v && c("markdown-click", v, f);
        }, d = function(f) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
                var v, g, b;
                return (0, $e0qXa.__generator)(this, function(_state) {
                    if (f.target instanceof HTMLInputElement && f.target.type === "checkbox") {
                        g = (v = r.value) == null ? void 0 : v.querySelectorAll('input[type="checkbox"]');
                        if (g) {
                            b = Array.from(g).indexOf(f.target);
                            b !== -1 && m(b);
                        }
                    }
                    return [
                        2
                    ];
                });
            })();
        }, l = function(f) {
            f.target instanceof HTMLInputElement && f.stopPropagation();
        }, m = function(f) {
            var v = n.content;
            if (!v) return;
            var g = lO(v, f);
            c("update-content", g);
        };
        return function(f, v) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", rUe, [
                f.loading ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
                    key: 1,
                    "class": (0, $3ZJCa.normalizeClass)(f.$style.markdown)
                }, [
                    ((0, $8B0Dy.openBlock)(!0), (0, $8B0Dy.createElementBlock)((0, $8B0Dy.Fragment), null, (0, $8B0Dy.renderList)(f.loadingBlocks, function(g, b) {
                        return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
                            key: b
                        }, [
                            (0, $8B0Dy.createVNode)((0, $5wB2C.unref)(uI), {
                                loading: f.loading,
                                rows: f.loadingRows,
                                animated: "",
                                variant: "p"
                            }, null, 8, [
                                "loading",
                                "rows"
                            ]),
                            (0, $8B0Dy.createElementVNode)("div", {
                                "class": (0, $3ZJCa.normalizeClass)(f.$style.spacer)
                            }, null, 2)
                        ]);
                    }), 128))
                ], 2)) : ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
                    key: 0,
                    ref_key: "editor",
                    ref: r,
                    "class": (0, $3ZJCa.normalizeClass)(f.$style[f.theme]),
                    onClick: u,
                    onMousedown: l,
                    onChange: d,
                    innerHTML: a.value
                }, null, 42, oUe))
            ]);
        };
    }
}), iUe = "_markdown_17ukb_1", aUe = "_label_17ukb_43", cUe = "_sticky_17ukb_64", lUe = "_spacer_17ukb_160", uUe = {
    markdown: iUe,
    label: aUe,
    sticky: cUe,
    spacer: lUe
}, dUe = {
    $style: uUe
}, fUe = /* @__PURE__ */ Ht(sUe, [
    [
        "__cssModules",
        dUe
    ]
]), h0 = {
    right: "ew-resize",
    top: "ns-resize",
    bottom: "ns-resize",
    left: "ew-resize",
    topLeft: "nw-resize",
    topRight: "ne-resize",
    bottomLeft: "sw-resize",
    bottomRight: "se-resize"
};
(0, $6869c._)({}, Id.props);
/*!
 * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */ function Wr(e) {
    return typeof Symbol == "function" && (0, $6gBIz._)(Symbol.iterator) == "symbol" ? Wr = function Wr(t) {
        return typeof t === "undefined" ? "undefined" : (0, $6gBIz._)(t);
    } : Wr = function Wr(t) {
        return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $6gBIz._)(t);
    }, Wr(e);
}
function pUe(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function hUe(e, t) {
    for(var n = 0; n < t.length; n++){
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
}
function gUe(e, t, n) {
    return t && hUe(e.prototype, t), e;
}
function mUe(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
function Ie(e) {
    for(var t = 1; t < arguments.length; t++){
        var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
        typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(s) {
            return Object.getOwnPropertyDescriptor(n, s).enumerable;
        }))), r.forEach(function(s) {
            mUe(e, s, n[s]);
        });
    }
    return e;
}
function bm(e, t) {
    return bUe(e) || wUe(e, t) || xUe();
}
function vUe(e) {
    return _Ue(e) || yUe(e) || kUe();
}
function _Ue(e) {
    if (Array.isArray(e)) {
        for(var t = 0, n = new Array(e.length); t < e.length; t++)n[t] = e[t];
        return n;
    }
}
function bUe(e) {
    if (Array.isArray(e)) return e;
}
function yUe(e) {
    if (Symbol.iterator in Object(e) || Object.prototype.toString.call(e) === "[object Arguments]") return Array.from(e);
}
function wUe(e, t) {
    var n = [], r = !0, s = !1, o = void 0;
    try {
        for(var i = e[Symbol.iterator](), a; !(r = (a = i.next()).done) && (n.push(a.value), !(t && n.length === t)); r = !0);
    } catch (c) {
        s = !0, o = c;
    } finally{
        try {
            !r && i["return"] != null && i["return"]();
        } finally{
            if (s) throw o;
        }
    }
    return n;
}
function kUe() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function xUe() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
var g0 = function g0() {}, Il = {}, ym = {}, CUe = null, wm = {
    mark: g0,
    measure: g0
};
try {
    (typeof window === "undefined" ? "undefined" : (0, $6gBIz._)(window)) < "u" && (Il = window), (typeof document === "undefined" ? "undefined" : (0, $6gBIz._)(document)) < "u" && (ym = document), (typeof MutationObserver === "undefined" ? "undefined" : (0, $6gBIz._)(MutationObserver)) < "u" && (CUe = MutationObserver), (typeof performance === "undefined" ? "undefined" : (0, $6gBIz._)(performance)) < "u" && (wm = performance);
} catch (e) {}
var SUe = Il.navigator || {}, m0 = SUe.userAgent, v0 = m0 === void 0 ? "" : m0, Cs = Il, bt = ym, Ro = wm;
Cs.document;
var Tl = !!bt.documentElement && !!bt.head && typeof bt.addEventListener == "function" && typeof bt.createElement == "function", EUe = ~v0.indexOf("MSIE") || ~v0.indexOf("Trident/"), wn = "___FONT_AWESOME___", qc = 16, km = "fa", xm = "svg-inline--fa", Cm = "data-fa-i2svg";
(function() {
    try {
        return !0;
    } catch (e) {
        return !1;
    }
})();
var va = {
    GROUP: "group",
    PRIMARY: "primary",
    SECONDARY: "secondary"
}, Sm = Cs.FontAwesomeConfig || {};
function AUe(e) {
    var t = bt.querySelector("script[" + e + "]");
    if (t) return t.getAttribute(e);
}
function $Ue(e) {
    return e === "" ? !0 : e === "false" ? !1 : e === "true" ? !0 : e;
}
if (bt && typeof bt.querySelector == "function") {
    var MUe = [
        [
            "data-family-prefix",
            "familyPrefix"
        ],
        [
            "data-replacement-class",
            "replacementClass"
        ],
        [
            "data-auto-replace-svg",
            "autoReplaceSvg"
        ],
        [
            "data-auto-add-css",
            "autoAddCss"
        ],
        [
            "data-auto-a11y",
            "autoA11y"
        ],
        [
            "data-search-pseudo-elements",
            "searchPseudoElements"
        ],
        [
            "data-observe-mutations",
            "observeMutations"
        ],
        [
            "data-mutate-approach",
            "mutateApproach"
        ],
        [
            "data-keep-original-source",
            "keepOriginalSource"
        ],
        [
            "data-measure-performance",
            "measurePerformance"
        ],
        [
            "data-show-missing-icons",
            "showMissingIcons"
        ]
    ];
    MUe.forEach(function(e) {
        var t = bm(e, 2), n = t[0], r = t[1], s = $Ue(AUe(n));
        s != null && (Sm[r] = s);
    });
}
var IUe = {
    familyPrefix: km,
    replacementClass: xm,
    autoReplaceSvg: !0,
    autoAddCss: !0,
    autoA11y: !0,
    searchPseudoElements: !1,
    observeMutations: !0,
    mutateApproach: "async",
    keepOriginalSource: !0,
    measurePerformance: !1,
    showMissingIcons: !0
}, Fc = Ie({}, IUe, Sm);
Fc.autoReplaceSvg || (Fc.observeMutations = !1);
var mt = Ie({}, Fc);
Cs.FontAwesomeConfig = mt;
var kn = Cs || {};
kn[wn] || (kn[wn] = {});
kn[wn].styles || (kn[wn].styles = {});
kn[wn].hooks || (kn[wn].hooks = {});
kn[wn].shims || (kn[wn].shims = []);
var an = kn[wn], TUe = [], LUe = function e() {
    bt.removeEventListener("DOMContentLoaded", e), Hc = 1, TUe.map(function(t) {
        return t();
    });
}, Hc = !1;
Tl && (Hc = (bt.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(bt.readyState), Hc || bt.addEventListener("DOMContentLoaded", LUe));
var Ll = "pending", Em = "settled", Jo = "fulfilled", Qo = "rejected", OUe = function OUe() {}, Am = (typeof $parcel$global === "undefined" ? "undefined" : (0, $6gBIz._)($parcel$global)) < "u" && (0, $6gBIz._)($parcel$global.process) < "u" && typeof $parcel$global.process.emit == "function", RUe = (typeof setImmediate === "undefined" ? "undefined" : (0, $6gBIz._)(setImmediate)) > "u" ? setTimeout : setImmediate, Hr = [], jc;
function PUe() {
    for(var e = 0; e < Hr.length; e++)Hr[e][0](Hr[e][1]);
    Hr = [], jc = !1;
}
function es(e, t) {
    Hr.push([
        e,
        t
    ]), jc || (jc = !0, RUe(PUe, 0));
}
function BUe(e, t) {
    function n(s) {
        Ol(t, s);
    }
    function r(s) {
        io(t, s);
    }
    try {
        e(n, r);
    } catch (s) {
        r(s);
    }
}
function $m(e) {
    var t = e.owner, n = t._state, r = t._data, s = e[n], o = e.then;
    if (typeof s == "function") {
        n = Jo;
        try {
            r = s(r);
        } catch (i) {
            io(o, i);
        }
    }
    Mm(o, r) || (n === Jo && Ol(o, r), n === Qo && io(o, r));
}
function Mm(e, t) {
    var n;
    try {
        if (e === t) throw new TypeError("A promises callback cannot return that same promise.");
        if (t && (typeof t == "function" || Wr(t) === "object")) {
            var r = t.then;
            if (typeof r == "function") return r.call(t, function(s) {
                n || (n = !0, t === s ? Im(e, s) : Ol(e, s));
            }, function(s) {
                n || (n = !0, io(e, s));
            }), !0;
        }
    } catch (s) {
        return n || io(e, s), !0;
    }
    return !1;
}
function Ol(e, t) {
    (e === t || !Mm(e, t)) && Im(e, t);
}
function Im(e, t) {
    e._state === Ll && (e._state = Em, e._data = t, es(zUe, e));
}
function io(e, t) {
    e._state === Ll && (e._state = Em, e._data = t, es(DUe, e));
}
function Tm(e) {
    e._then = e._then.forEach($m);
}
function zUe(e) {
    e._state = Jo, Tm(e);
}
function DUe(e) {
    e._state = Qo, Tm(e), !e._handled && Am && $parcel$global.process.emit("unhandledRejection", e._data, e);
}
function NUe(e) {
    $parcel$global.process.emit("rejectionHandled", e);
}
function Dt(e) {
    if (typeof e != "function") throw new TypeError("Promise resolver " + e + " is not a function");
    if (!(this instanceof Dt)) throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
    this._then = [], BUe(e, this);
}
Dt.prototype = {
    constructor: Dt,
    _state: Ll,
    _then: null,
    _data: void 0,
    _handled: !1,
    then: function then(t, n) {
        var r = {
            owner: this,
            then: new this.constructor(OUe),
            fulfilled: t,
            rejected: n
        };
        return (n || t) && !this._handled && (this._handled = !0, this._state === Qo && Am && es(NUe, this)), this._state === Jo || this._state === Qo ? es($m, r) : this._then.push(r), r.then;
    },
    "catch": function _catch(t) {
        return this.then(null, t);
    }
};
Dt.all = function(e) {
    if (!Array.isArray(e)) throw new TypeError("You must pass an array to Promise.all().");
    return new Dt(function(t, n) {
        var r = [], s = 0;
        function o(c) {
            return s++, function(u) {
                r[c] = u, --s || t(r);
            };
        }
        for(var i = 0, a; i < e.length; i++)a = e[i], a && typeof a.then == "function" ? a.then(o(i), n) : r[i] = a;
        s || t(r);
    });
};
Dt.race = function(e) {
    if (!Array.isArray(e)) throw new TypeError("You must pass an array to Promise.race().");
    return new Dt(function(t, n) {
        for(var r = 0, s; r < e.length; r++)s = e[r], s && typeof s.then == "function" ? s.then(t, n) : t(s);
    });
};
Dt.resolve = function(e) {
    return e && Wr(e) === "object" && e.constructor === Dt ? e : new Dt(function(t) {
        t(e);
    });
};
Dt.reject = function(e) {
    return new Dt(function(t, n) {
        n(e);
    });
};
var ur = qc, Pn = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: !1,
    flipY: !1
};
function qUe(e) {
    if (!(!e || !Tl)) {
        var t = bt.createElement("style");
        t.setAttribute("type", "text/css"), t.innerHTML = e;
        for(var n = bt.head.childNodes, r = null, s = n.length - 1; s > -1; s--){
            var o = n[s], i = (o.tagName || "").toUpperCase();
            [
                "STYLE",
                "LINK"
            ].indexOf(i) > -1 && (r = o);
        }
        return bt.head.insertBefore(t, r), e;
    }
}
var FUe = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function ts() {
    for(var e = 12, t = ""; e-- > 0;)t += FUe[Math.random() * 62 | 0];
    return t;
}
function Lm(e) {
    return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function HUe(e) {
    return Object.keys(e || {}).reduce(function(t, n) {
        return t + "".concat(n, '="').concat(Lm(e[n]), '" ');
    }, "").trim();
}
function Rl(e) {
    return Object.keys(e || {}).reduce(function(t, n) {
        return t + "".concat(n, ": ").concat(e[n], ";");
    }, "");
}
function Pl(e) {
    return e.size !== Pn.size || e.x !== Pn.x || e.y !== Pn.y || e.rotate !== Pn.rotate || e.flipX || e.flipY;
}
function Om(e) {
    var t = e.transform, n = e.containerWidth, r = e.iconWidth, s = {
        transform: "translate(".concat(n / 2, " 256)")
    }, o = "translate(".concat(t.x * 32, ", ").concat(t.y * 32, ") "), i = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "), a = "rotate(".concat(t.rotate, " 0 0)"), c = {
        transform: "".concat(o, " ").concat(i, " ").concat(a)
    }, u = {
        transform: "translate(".concat(r / 2 * -1, " -256)")
    };
    return {
        outer: s,
        inner: c,
        path: u
    };
}
function jUe(e) {
    var t = e.transform, n = e.width, r = n === void 0 ? qc : n, s = e.height, o = s === void 0 ? qc : s, i = "";
    return EUe ? i += "translate(".concat(t.x / ur - r / 2, "em, ").concat(t.y / ur - o / 2, "em) ") : i += "translate(calc(-50% + ".concat(t.x / ur, "em), calc(-50% + ").concat(t.y / ur, "em)) "), i += "scale(".concat(t.size / ur * (t.flipX ? -1 : 1), ", ").concat(t.size / ur * (t.flipY ? -1 : 1), ") "), i += "rotate(".concat(t.rotate, "deg) "), i;
}
var _a = {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
};
function _0(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    return e.attributes && (e.attributes.fill || t) && (e.attributes.fill = "black"), e;
}
function UUe(e) {
    return e.tag === "g" ? e.children : [
        e
    ];
}
function VUe(e) {
    var t = e.children, n = e.attributes, r = e.main, s = e.mask, o = e.maskId, i = e.transform, a = r.width, c = r.icon, u = s.width, d = s.icon, l = Om({
        transform: i,
        containerWidth: u,
        iconWidth: a
    }), m = {
        tag: "rect",
        attributes: Ie({}, _a, {
            fill: "white"
        })
    }, f = c.children ? {
        children: c.children.map(_0)
    } : {}, v = {
        tag: "g",
        attributes: Ie({}, l.inner),
        children: [
            _0(Ie({
                tag: c.tag,
                attributes: Ie({}, c.attributes, l.path)
            }, f))
        ]
    }, g = {
        tag: "g",
        attributes: Ie({}, l.outer),
        children: [
            v
        ]
    }, b = "mask-".concat(o || ts()), h = "clip-".concat(o || ts()), w = {
        tag: "mask",
        attributes: Ie({}, _a, {
            id: b,
            maskUnits: "userSpaceOnUse",
            maskContentUnits: "userSpaceOnUse"
        }),
        children: [
            m,
            g
        ]
    }, k = {
        tag: "defs",
        children: [
            {
                tag: "clipPath",
                attributes: {
                    id: h
                },
                children: UUe(d)
            },
            w
        ]
    };
    return t.push(k, {
        tag: "rect",
        attributes: Ie({
            fill: "currentColor",
            "clip-path": "url(#".concat(h, ")"),
            mask: "url(#".concat(b, ")")
        }, _a)
    }), {
        children: t,
        attributes: n
    };
}
function ZUe(e) {
    var t = e.children, n = e.attributes, r = e.main, s = e.transform, o = e.styles, i = Rl(o);
    if (i.length > 0 && (n.style = i), Pl(s)) {
        var a = Om({
            transform: s,
            containerWidth: r.width,
            iconWidth: r.width
        });
        t.push({
            tag: "g",
            attributes: Ie({}, a.outer),
            children: [
                {
                    tag: "g",
                    attributes: Ie({}, a.inner),
                    children: [
                        {
                            tag: r.icon.tag,
                            children: r.icon.children,
                            attributes: Ie({}, r.icon.attributes, a.path)
                        }
                    ]
                }
            ]
        });
    } else t.push(r.icon);
    return {
        children: t,
        attributes: n
    };
}
function WUe(e) {
    var t = e.children, n = e.main, r = e.mask, s = e.attributes, o = e.styles, i = e.transform;
    if (Pl(i) && n.found && !r.found) {
        var a = n.width, c = n.height, u = {
            x: a / c / 2,
            y: 0.5
        };
        s.style = Rl(Ie({}, o, {
            "transform-origin": "".concat(u.x + i.x / 16, "em ").concat(u.y + i.y / 16, "em")
        }));
    }
    return [
        {
            tag: "svg",
            attributes: s,
            children: t
        }
    ];
}
function GUe(e) {
    var t = e.prefix, n = e.iconName, r = e.children, s = e.attributes, o = e.symbol, i = o === !0 ? "".concat(t, "-").concat(mt.familyPrefix, "-").concat(n) : o;
    return [
        {
            tag: "svg",
            attributes: {
                style: "display: none;"
            },
            children: [
                {
                    tag: "symbol",
                    attributes: Ie({}, s, {
                        id: i
                    }),
                    children: r
                }
            ]
        }
    ];
}
function KUe(e) {
    var t = e.icons, n = t.main, r = t.mask, s = e.prefix, o = e.iconName, i = e.transform, a = e.symbol, c = e.title, u = e.maskId, d = e.titleId, l = e.extra, m = e.watchable, f = m === void 0 ? !1 : m, v = r.found ? r : n, g = v.width, b = v.height, h = s === "fak", w = h ? "" : "fa-w-".concat(Math.ceil(g / b * 16)), k = [
        mt.replacementClass,
        o ? "".concat(mt.familyPrefix, "-").concat(o) : "",
        w
    ].filter(function(R) {
        return l.classes.indexOf(R) === -1;
    }).filter(function(R) {
        return R !== "" || !!R;
    }).concat(l.classes).join(" "), x = {
        children: [],
        attributes: Ie({}, l.attributes, {
            "data-prefix": s,
            "data-icon": o,
            "class": k,
            role: l.attributes.role || "img",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 ".concat(g, " ").concat(b)
        })
    }, A = h && !~l.classes.indexOf("fa-fw") ? {
        width: "".concat(g / b * 1, "em")
    } : {};
    f && (x.attributes[Cm] = ""), c && x.children.push({
        tag: "title",
        attributes: {
            id: x.attributes["aria-labelledby"] || "title-".concat(d || ts())
        },
        children: [
            c
        ]
    });
    var S = Ie({}, x, {
        prefix: s,
        iconName: o,
        main: n,
        mask: r,
        maskId: u,
        transform: i,
        symbol: a,
        styles: Ie({}, A, l.styles)
    }), $ = r.found && n.found ? VUe(S) : ZUe(S), M = $.children, P = $.attributes;
    return S.children = M, S.attributes = P, a ? GUe(S) : WUe(S);
}
function XUe(e) {
    var t = e.content, n = e.width, r = e.height, s = e.transform, o = e.title, i = e.extra, a = e.watchable, c = a === void 0 ? !1 : a, u = Ie({}, i.attributes, o ? {
        title: o
    } : {}, {
        "class": i.classes.join(" ")
    });
    c && (u[Cm] = "");
    var d = Ie({}, i.styles);
    Pl(s) && (d.transform = jUe({
        transform: s,
        width: n,
        height: r
    }), d["-webkit-transform"] = d.transform);
    var l = Rl(d);
    l.length > 0 && (u.style = l);
    var m = [];
    return m.push({
        tag: "span",
        attributes: u,
        children: [
            t
        ]
    }), o && m.push({
        tag: "span",
        attributes: {
            "class": "sr-only"
        },
        children: [
            o
        ]
    }), m;
}
mt.measurePerformance && Ro && Ro.mark && Ro.measure;
var ba = function ba(t, n, r, s) {
    var o = Object.keys(t), i = o.length, a = n, c, u, d;
    for(r === void 0 ? (c = 1, d = t[o[0]]) : (c = 0, d = r); c < i; c++)u = o[c], d = a(d, t[u], u, t);
    return d;
};
function Rm(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = n.skipHooks, s = r === void 0 ? !1 : r, o = Object.keys(t).reduce(function(i, a) {
        var c = t[a], u = !!c.icon;
        return u ? i[c.iconName] = c.icon : i[a] = c, i;
    }, {});
    typeof an.hooks.addPack == "function" && !s ? an.hooks.addPack(e, o) : an.styles[e] = Ie({}, an.styles[e] || {}, o), e === "fas" && Rm("fa", t);
}
var b0 = an.styles, YUe = an.shims, Pm = function Pm() {
    var t = function t(s) {
        return ba(b0, function(o, i, a) {
            return o[a] = ba(i, s, {}), o;
        }, {});
    };
    t(function(r, s, o) {
        return s[3] && (r[s[3]] = o), r;
    }), t(function(r, s, o) {
        var i = s[2];
        return r[o] = o, i.forEach(function(a) {
            r[a] = o;
        }), r;
    });
    var n = "far" in b0;
    ba(YUe, function(r, s) {
        var o = s[0], i = s[1], a = s[2];
        return i === "far" && !n && (i = "fas"), r[o] = {
            prefix: i,
            iconName: a
        }, r;
    }, {});
};
Pm();
an.styles;
function y0(e, t, n) {
    if (e && e[t] && e[t][n]) return {
        prefix: t,
        iconName: n,
        icon: e[t][n]
    };
}
function Bm(e) {
    var t = e.tag, n = e.attributes, r = n === void 0 ? {} : n, s = e.children, o = s === void 0 ? [] : s;
    return typeof e == "string" ? Lm(e) : "<".concat(t, " ").concat(HUe(r), ">").concat(o.map(Bm).join(""), "</").concat(t, ">");
}
var JUe = function JUe(t) {
    var n = {
        size: 16,
        x: 0,
        y: 0,
        flipX: !1,
        flipY: !1,
        rotate: 0
    };
    return t ? t.toLowerCase().split(" ").reduce(function(r, s) {
        var o = s.toLowerCase().split("-"), i = o[0], a = o.slice(1).join("-");
        if (i && a === "h") return r.flipX = !0, r;
        if (i && a === "v") return r.flipY = !0, r;
        if (a = parseFloat(a), isNaN(a)) return r;
        switch(i){
            case "grow":
                r.size = r.size + a;
                break;
            case "shrink":
                r.size = r.size - a;
                break;
            case "left":
                r.x = r.x - a;
                break;
            case "right":
                r.x = r.x + a;
                break;
            case "up":
                r.y = r.y - a;
                break;
            case "down":
                r.y = r.y + a;
                break;
            case "rotate":
                r.rotate = r.rotate + a;
                break;
        }
        return r;
    }, n) : n;
};
function Uc(e) {
    this.name = "MissingIcon", this.message = e || "Icon unavailable", this.stack = new Error().stack;
}
Uc.prototype = Object.create(Error.prototype);
Uc.prototype.constructor = Uc;
var Ss = {
    fill: "currentColor"
}, zm = {
    attributeType: "XML",
    repeatCount: "indefinite",
    dur: "2s"
};
Ie({}, Ss, {
    d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
});
var Bl = Ie({}, zm, {
    attributeName: "opacity"
});
Ie({}, Ss, {
    cx: "256",
    cy: "364",
    r: "28"
}), Ie({}, zm, {
    attributeName: "r",
    values: "28;14;28;28;14;28;"
}), Ie({}, Bl, {
    values: "1;0;1;1;0;1;"
});
Ie({}, Ss, {
    opacity: "1",
    d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
}), Ie({}, Bl, {
    values: "1;0;0;0;0;1;"
});
Ie({}, Ss, {
    opacity: "0",
    d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
}), Ie({}, Bl, {
    values: "0;0;1;1;0;0;"
});
an.styles;
function w0(e) {
    var t = e[0], n = e[1], r = e.slice(4), s = bm(r, 1), o = s[0], i = null;
    return Array.isArray(o) ? i = {
        tag: "g",
        attributes: {
            "class": "".concat(mt.familyPrefix, "-").concat(va.GROUP)
        },
        children: [
            {
                tag: "path",
                attributes: {
                    "class": "".concat(mt.familyPrefix, "-").concat(va.SECONDARY),
                    fill: "currentColor",
                    d: o[0]
                }
            },
            {
                tag: "path",
                attributes: {
                    "class": "".concat(mt.familyPrefix, "-").concat(va.PRIMARY),
                    fill: "currentColor",
                    d: o[1]
                }
            }
        ]
    } : i = {
        tag: "path",
        attributes: {
            fill: "currentColor",
            d: o
        }
    }, {
        found: !0,
        width: t,
        height: n,
        icon: i
    };
}
an.styles;
var QUe = 'svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.225em;\n}\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: 0.25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse {\n  color: #fff;\n}';
function eVe() {
    var e = km, t = xm, n = mt.familyPrefix, r = mt.replacementClass, s = QUe;
    if (n !== e || r !== t) {
        var o = new RegExp("\\.".concat(e, "\\-"), "g"), i = new RegExp("\\--".concat(e, "\\-"), "g"), a = new RegExp("\\.".concat(t), "g");
        s = s.replace(o, ".".concat(n, "-")).replace(i, "--".concat(n, "-")).replace(a, ".".concat(r));
    }
    return s;
}
var tVe = /* @__PURE__ */ function() {
    function e() {
        pUe(this, e), this.definitions = {};
    }
    return gUe(e, [
        {
            key: "add",
            value: function value() {
                for(var n = this, r = arguments.length, s = new Array(r), o = 0; o < r; o++)s[o] = arguments[o];
                var i = s.reduce(this._pullDefinitions, {});
                Object.keys(i).forEach(function(a) {
                    n.definitions[a] = Ie({}, n.definitions[a] || {}, i[a]), Rm(a, i[a]), Pm();
                });
            }
        },
        {
            key: "reset",
            value: function value() {
                this.definitions = {};
            }
        },
        {
            key: "_pullDefinitions",
            value: function value(n, r) {
                var s = r.prefix && r.iconName && r.icon ? {
                    0: r
                } : r;
                return Object.keys(s).map(function(o) {
                    var i = s[o], a = i.prefix, c = i.iconName, u = i.icon;
                    n[a] || (n[a] = {}), n[a][c] = u;
                }), n;
            }
        }
    ]), e;
}();
function Dm() {
    mt.autoAddCss && !x0 && (qUe(eVe()), x0 = !0);
}
function Nm(e, t) {
    return Object.defineProperty(e, "abstract", {
        get: t
    }), Object.defineProperty(e, "html", {
        get: function get() {
            return e["abstract"].map(function(r) {
                return Bm(r);
            });
        }
    }), Object.defineProperty(e, "node", {
        get: function get() {
            if (Tl) {
                var r = bt.createElement("div");
                return r.innerHTML = e.html, r.children;
            }
        }
    }), e;
}
function k0(e) {
    var t = e.prefix, n = t === void 0 ? "fa" : t, r = e.iconName;
    if (r) return y0(rVe.definitions, n, r) || y0(an.styles, n, r);
}
function nVe(e) {
    return function(t) {
        var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = (t || {}).icon ? t : k0(t || {}), s = n.mask;
        return s && (s = (s || {}).icon ? s : k0(s || {})), e(r, Ie({}, n, {
            mask: s
        }));
    };
}
var rVe = new tVe(), x0 = !1, ns = {
    transform: function transform(t) {
        return JUe(t);
    }
}, oVe = nVe(function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.transform, r = n === void 0 ? Pn : n, s = t.symbol, o = s === void 0 ? !1 : s, i = t.mask, a = i === void 0 ? null : i, c = t.maskId, u = c === void 0 ? null : c, d = t.title, l = d === void 0 ? null : d, m = t.titleId, f = m === void 0 ? null : m, v = t.classes, g = v === void 0 ? [] : v, b = t.attributes, h = b === void 0 ? {} : b, w = t.styles, k = w === void 0 ? {} : w;
    if (e) {
        var x = e.prefix, A = e.iconName, S = e.icon;
        return Nm(Ie({
            type: "icon"
        }, e), function() {
            return Dm(), mt.autoA11y && (l ? h["aria-labelledby"] = "".concat(mt.replacementClass, "-title-").concat(f || ts()) : (h["aria-hidden"] = "true", h.focusable = "false")), KUe({
                icons: {
                    main: w0(S),
                    mask: a ? w0(a.icon) : {
                        found: !1,
                        width: null,
                        height: null,
                        icon: {}
                    }
                },
                prefix: x,
                iconName: A,
                transform: Ie({}, Pn, r),
                symbol: o,
                title: l,
                maskId: u,
                titleId: f,
                extra: {
                    attributes: h,
                    styles: k,
                    classes: g
                }
            });
        });
    }
}), sVe = function sVe(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.transform, s = r === void 0 ? Pn : r, o = n.title, i = o === void 0 ? null : o, a = n.classes, c = a === void 0 ? [] : a, u = n.attributes, d = u === void 0 ? {} : u, l = n.styles, m = l === void 0 ? {} : l;
    return Nm({
        type: "text",
        content: t
    }, function() {
        return Dm(), XUe({
            content: t,
            transform: Ie({}, Pn, s),
            title: i,
            extra: {
                attributes: d,
                styles: m,
                classes: [
                    "".concat(mt.familyPrefix, "-layers-text")
                ].concat(vUe(c))
            }
        });
    });
};
function C0(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function(s) {
            return Object.getOwnPropertyDescriptor(e, s).enumerable;
        })), n.push.apply(n, r);
    }
    return n;
}
function Xt(e) {
    for(var t = 1; t < arguments.length; t++){
        var n = arguments[t] != null ? arguments[t] : {};
        t % 2 ? C0(Object(n), !0).forEach(function(r) {
            yt(e, r, n[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : C0(Object(n)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
        });
    }
    return e;
}
function rs(e) {
    "@babel/helpers - typeof";
    return rs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function rs(t) {
        return typeof t;
    } : function(t) {
        return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, rs(e);
}
function yt(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
function iVe(e, t) {
    if (e == null) return {};
    var n = {}, r = Object.keys(e), s, o;
    for(o = 0; o < r.length; o++)s = r[o], !(t.indexOf(s) >= 0) && (n[s] = e[s]);
    return n;
}
function aVe(e, t) {
    if (e == null) return {};
    var n = iVe(e, t), r, s;
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for(s = 0; s < o.length; s++)r = o[s], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function Vc(e) {
    return cVe(e) || lVe(e) || uVe(e) || dVe();
}
function cVe(e) {
    if (Array.isArray(e)) return Zc(e);
}
function lVe(e) {
    if ((typeof Symbol === "undefined" ? "undefined" : (0, $6gBIz._)(Symbol)) < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function uVe(e, t) {
    if (e) {
        if (typeof e == "string") return Zc(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Zc(e, t);
    }
}
function Zc(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
    return r;
}
function dVe() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var fVe = (typeof globalThis === "undefined" ? "undefined" : (0, $6gBIz._)(globalThis)) < "u" ? globalThis : (typeof window === "undefined" ? "undefined" : (0, $6gBIz._)(window)) < "u" ? window : (typeof $parcel$global === "undefined" ? "undefined" : (0, $6gBIz._)($parcel$global)) < "u" ? $parcel$global : (typeof self === "undefined" ? "undefined" : (0, $6gBIz._)(self)) < "u" ? self : {}, qm = {
    exports: {}
};
(function(e) {
    (function(t) {
        var n = function n1(h, w, k) {
            if (!u(w) || l(w) || m(w) || f(w) || c(w)) return w;
            var x, A = 0, S = 0;
            if (d(w)) for(x = [], S = w.length; A < S; A++)x.push(n(h, w[A], k));
            else {
                x = {};
                for(var $ in w)Object.prototype.hasOwnProperty.call(w, $) && (x[h($, k)] = n(h, w[$], k));
            }
            return x;
        }, r = function r(h, w) {
            w = w || {};
            var k = w.separator || "_", x = w.split || /(?=[A-Z])/;
            return h.split(x).join(k);
        }, s = function s(h) {
            return v(h) ? h : (h = h.replace(/[\-_\s]+(.)?/g, function(w, k) {
                return k ? k.toUpperCase() : "";
            }), h.substr(0, 1).toLowerCase() + h.substr(1));
        }, o = function o(h) {
            var w = s(h);
            return w.substr(0, 1).toUpperCase() + w.substr(1);
        }, i = function i(h, w) {
            return r(h, w).toLowerCase();
        }, a = Object.prototype.toString, c = function c(h) {
            return typeof h == "function";
        }, u = function u(h) {
            return h === Object(h);
        }, d = function d(h) {
            return a.call(h) == "[object Array]";
        }, l = function l(h) {
            return a.call(h) == "[object Date]";
        }, m = function m(h) {
            return a.call(h) == "[object RegExp]";
        }, f = function f(h) {
            return a.call(h) == "[object Boolean]";
        }, v = function v(h) {
            return h = h - 0, h === h;
        }, g = function g(h, w) {
            var k = w && "process" in w ? w.process : w;
            return typeof k != "function" ? h : function(x, A) {
                return k(x, h, A);
            };
        }, b = {
            camelize: s,
            decamelize: i,
            pascalize: o,
            depascalize: i,
            camelizeKeys: function camelizeKeys(h, w) {
                return n(g(s, w), h);
            },
            decamelizeKeys: function decamelizeKeys(h, w) {
                return n(g(i, w), h, w);
            },
            pascalizeKeys: function pascalizeKeys(h, w) {
                return n(g(o, w), h);
            },
            depascalizeKeys: function depascalizeKeys() {
                return this.decamelizeKeys.apply(this, arguments);
            }
        };
        e.exports ? e.exports = b : t.humps = b;
    })(fVe);
})(qm);
var pVe = qm.exports, hVe = [
    "class",
    "style"
];
function gVe(e) {
    return e.split(";").map(function(t) {
        return t.trim();
    }).filter(function(t) {
        return t;
    }).reduce(function(t, n) {
        var r = n.indexOf(":"), s = pVe.camelize(n.slice(0, r)), o = n.slice(r + 1).trim();
        return t[s] = o, t;
    }, {});
}
function mVe(e) {
    return e.split(/\s+/).reduce(function(t, n) {
        return t[n] = !0, t;
    }, {});
}
function zl(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (typeof e == "string") return e;
    var r = (e.children || []).map(function(c) {
        return zl(c);
    }), s = Object.keys(e.attributes || {}).reduce(function(c, u) {
        var d = e.attributes[u];
        switch(u){
            case "class":
                c["class"] = mVe(d);
                break;
            case "style":
                c.style = gVe(d);
                break;
            default:
                c.attrs[u] = d;
        }
        return c;
    }, {
        attrs: {},
        "class": {},
        style: {}
    });
    n["class"];
    var o = n.style, i = o === void 0 ? {} : o, a = aVe(n, hVe);
    return (0, $8B0Dy.h)(e.tag, Xt(Xt(Xt({}, t), {}, {
        "class": s["class"],
        style: Xt(Xt({}, s.style), i)
    }, s.attrs), a), r);
}
var Fm = !1;
try {
    Fm = !0;
} catch (e) {}
function vVe() {
    if (!Fm && console && typeof console.error == "function") {
        var e;
        (e = console).error.apply(e, arguments);
    }
}
function Gr(e, t) {
    return Array.isArray(t) && t.length > 0 || !Array.isArray(t) && t ? yt({}, e, t) : {};
}
function _Ve(e) {
    var t, n = (t = {
        "fa-spin": e.spin,
        "fa-pulse": e.pulse,
        "fa-fw": e.fixedWidth,
        "fa-border": e.border,
        "fa-li": e.listItem,
        "fa-inverse": e.inverse,
        "fa-flip": e.flip === !0,
        "fa-flip-horizontal": e.flip === "horizontal" || e.flip === "both",
        "fa-flip-vertical": e.flip === "vertical" || e.flip === "both"
    }, yt(t, "fa-".concat(e.size), e.size !== null), yt(t, "fa-rotate-".concat(e.rotation), e.rotation !== null), yt(t, "fa-pull-".concat(e.pull), e.pull !== null), yt(t, "fa-swap-opacity", e.swapOpacity), yt(t, "fa-bounce", e.bounce), yt(t, "fa-shake", e.shake), yt(t, "fa-beat", e.beat), yt(t, "fa-fade", e.fade), yt(t, "fa-beat-fade", e.beatFade), yt(t, "fa-flash", e.flash), yt(t, "fa-spin-pulse", e.spinPulse), yt(t, "fa-spin-reverse", e.spinReverse), t);
    return Object.keys(n).map(function(r) {
        return n[r] ? r : null;
    }).filter(function(r) {
        return r;
    });
}
function S0(e) {
    if (e && rs(e) === "object" && e.prefix && e.iconName && e.icon) return e;
    if (ns.icon) return ns.icon(e);
    if (e === null) return null;
    if (rs(e) === "object" && e.prefix && e.iconName) return e;
    if (Array.isArray(e) && e.length === 2) return {
        prefix: e[0],
        iconName: e[1]
    };
    if (typeof e == "string") return {
        prefix: "fas",
        iconName: e
    };
}
(0, $8B0Dy.defineComponent)({
    name: "FontAwesomeIcon",
    props: {
        border: {
            type: Boolean,
            "default": !1
        },
        fixedWidth: {
            type: Boolean,
            "default": !1
        },
        flip: {
            type: [
                Boolean,
                String
            ],
            "default": !1,
            validator: function validator(t) {
                return [
                    !0,
                    !1,
                    "horizontal",
                    "vertical",
                    "both"
                ].indexOf(t) > -1;
            }
        },
        icon: {
            type: [
                Object,
                Array,
                String
            ],
            required: !0
        },
        mask: {
            type: [
                Object,
                Array,
                String
            ],
            "default": null
        },
        listItem: {
            type: Boolean,
            "default": !1
        },
        pull: {
            type: String,
            "default": null,
            validator: function validator(t) {
                return [
                    "right",
                    "left"
                ].indexOf(t) > -1;
            }
        },
        pulse: {
            type: Boolean,
            "default": !1
        },
        rotation: {
            type: [
                String,
                Number
            ],
            "default": null,
            validator: function validator(t) {
                return [
                    90,
                    180,
                    270
                ].indexOf(Number.parseInt(t, 10)) > -1;
            }
        },
        swapOpacity: {
            type: Boolean,
            "default": !1
        },
        size: {
            type: String,
            "default": null,
            validator: function validator(t) {
                return [
                    "2xs",
                    "xs",
                    "sm",
                    "lg",
                    "xl",
                    "2xl",
                    "1x",
                    "2x",
                    "3x",
                    "4x",
                    "5x",
                    "6x",
                    "7x",
                    "8x",
                    "9x",
                    "10x"
                ].indexOf(t) > -1;
            }
        },
        spin: {
            type: Boolean,
            "default": !1
        },
        transform: {
            type: [
                String,
                Object
            ],
            "default": null
        },
        symbol: {
            type: [
                Boolean,
                String
            ],
            "default": !1
        },
        title: {
            type: String,
            "default": null
        },
        inverse: {
            type: Boolean,
            "default": !1
        },
        bounce: {
            type: Boolean,
            "default": !1
        },
        shake: {
            type: Boolean,
            "default": !1
        },
        beat: {
            type: Boolean,
            "default": !1
        },
        fade: {
            type: Boolean,
            "default": !1
        },
        beatFade: {
            type: Boolean,
            "default": !1
        },
        flash: {
            type: Boolean,
            "default": !1
        },
        spinPulse: {
            type: Boolean,
            "default": !1
        },
        spinReverse: {
            type: Boolean,
            "default": !1
        }
    },
    setup: function setup(t, n) {
        var r = n.attrs, s = (0, $5wB2C.computed)(function() {
            return S0(t.icon);
        }), o = (0, $5wB2C.computed)(function() {
            return Gr("classes", _Ve(t));
        }), i = (0, $5wB2C.computed)(function() {
            return Gr("transform", typeof t.transform == "string" ? ns.transform(t.transform) : t.transform);
        }), a = (0, $5wB2C.computed)(function() {
            return Gr("mask", S0(t.mask));
        }), c = (0, $5wB2C.computed)(function() {
            return oVe(s.value, Xt(Xt(Xt(Xt({}, o.value), i.value), a.value), {}, {
                symbol: t.symbol,
                title: t.title
            }));
        });
        (0, $5wB2C.watch)(c, function(d) {
            if (!d) return vVe("Could not find one or more icon(s)", s.value, a.value);
        }, {
            immediate: !0
        });
        var u = (0, $5wB2C.computed)(function() {
            return c.value ? zl(c.value["abstract"][0], {}, r) : null;
        });
        return function() {
            return u.value;
        };
    }
});
(0, $8B0Dy.defineComponent)({
    name: "FontAwesomeLayers",
    props: {
        fixedWidth: {
            type: Boolean,
            "default": !1
        }
    },
    setup: function setup(t, n) {
        var r = n.slots, s = mt.familyPrefix, o = (0, $5wB2C.computed)(function() {
            return [
                "".concat(s, "-layers")
            ].concat(Vc(t.fixedWidth ? [
                "".concat(s, "-fw")
            ] : []));
        });
        return function() {
            return (0, $8B0Dy.h)("div", {
                "class": o.value
            }, r["default"] ? r["default"]() : []);
        };
    }
});
(0, $8B0Dy.defineComponent)({
    name: "FontAwesomeLayersText",
    props: {
        value: {
            type: [
                String,
                Number
            ],
            "default": ""
        },
        transform: {
            type: [
                String,
                Object
            ],
            "default": null
        },
        counter: {
            type: Boolean,
            "default": !1
        },
        position: {
            type: String,
            "default": null,
            validator: function validator(t) {
                return [
                    "bottom-left",
                    "bottom-right",
                    "top-left",
                    "top-right"
                ].indexOf(t) > -1;
            }
        }
    },
    setup: function setup(t, n) {
        var r = n.attrs, s = mt.familyPrefix, o = (0, $5wB2C.computed)(function() {
            return Gr("classes", [].concat(Vc(t.counter ? [
                "".concat(s, "-layers-counter")
            ] : []), Vc(t.position ? [
                "".concat(s, "-layers-").concat(t.position)
            ] : [])));
        }), i = (0, $5wB2C.computed)(function() {
            return Gr("transform", typeof t.transform == "string" ? ns.transform(t.transform) : t.transform);
        }), a = (0, $5wB2C.computed)(function() {
            var u = sVe(t.value.toString(), Xt(Xt({}, i.value), o.value)), d = u["abstract"];
            return t.counter && (d[0].attributes["class"] = d[0].attributes["class"].replace("fa-layers-text", "")), d[0];
        }), c = (0, $5wB2C.computed)(function() {
            return zl(a.value, {}, r);
        });
        return function() {
            return c.value;
        };
    }
});
(0, $6869c._)({}, Jh);
var bVe = [
    "data-dir"
], yVe = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    __name: "ResizeWrapper",
    props: {
        isResizingEnabled: {
            type: Boolean,
            "default": !0
        },
        height: {
            "default": 0
        },
        width: {
            "default": 0
        },
        minHeight: {
            "default": 0
        },
        maxHeight: {
            "default": Number.POSITIVE_INFINITY
        },
        minWidth: {
            "default": 0
        },
        maxWidth: {
            "default": Number.POSITIVE_INFINITY
        },
        scale: {
            "default": 1
        },
        gridSize: {
            "default": 20
        },
        supportedDirections: {
            "default": function() {
                return [];
            }
        },
        outset: {
            type: Boolean,
            "default": !1
        },
        window: {
            "default": void 0
        }
    },
    emits: [
        "resizestart",
        "resize",
        "resizeend"
    ],
    setup: function(e, param) {
        var t = param.emit;
        function n(f, v) {
            var g = f / v, b = v * g, h = f * v > 0 ? v * (g + 1) : v * (g - 1);
            return Math.abs(f - b) < Math.abs(f - h) ? b : h;
        }
        function r(f, v, g, b) {
            if (v <= 0) return f;
            var h = n(v, g);
            return h <= f ? f : h >= b ? b : h;
        }
        var s = e, o = (0, $kRi7Z.useCssModule)(), i = t, a = (0, $5wB2C.computed)(function() {
            var f = Object.keys(h0);
            return s.isResizingEnabled ? s.supportedDirections.length === 0 ? f : s.supportedDirections : [];
        }), c = {
            dir: (0, $5wB2C.ref)(""),
            dHeight: (0, $5wB2C.ref)(0),
            dWidth: (0, $5wB2C.ref)(0),
            vHeight: (0, $5wB2C.ref)(0),
            vWidth: (0, $5wB2C.ref)(0),
            x: (0, $5wB2C.ref)(0),
            y: (0, $5wB2C.ref)(0)
        }, u = (0, $5wB2C.computed)(function() {
            var _obj;
            return _obj = {}, (0, $aRIHe._)(_obj, o.resize, !0), (0, $aRIHe._)(_obj, o.outset, s.outset), _obj;
        }), d = function(f) {
            f.preventDefault(), f.stopPropagation();
            var v = 0, g = 0, b = !1, h = !1;
            c.dir.value.includes("right") && (v = f.pageX - c.x.value), c.dir.value.includes("left") && (v = c.x.value - f.pageX, h = !0), c.dir.value.includes("top") && (g = c.y.value - f.pageY, b = !0), c.dir.value.includes("bottom") && (g = f.pageY - c.y.value);
            var w = (v - c.dWidth.value) / s.scale, k = (g - c.dHeight.value) / s.scale;
            c.vHeight.value = c.vHeight.value + k, c.vWidth.value = c.vWidth.value + w;
            var x = r(s.minHeight, c.vHeight.value, s.gridSize, s.maxHeight), A = r(s.minWidth, c.vWidth.value, s.gridSize, s.maxWidth), S = h && A !== s.width ? -1 * (A - s.width) : 0, $ = b && x !== s.height ? -1 * (x - s.height) : 0, M = f.x, P = f.y, R = c.dir.value;
            i("resize", {
                height: x,
                width: A,
                dX: S,
                dY: $,
                x: M,
                y: P,
                direction: R
            }), c.dHeight.value = g, c.dWidth.value = v;
        }, l = function(f) {
            var _s_window, _s_window1;
            f.preventDefault(), f.stopPropagation(), i("resizeend"), ((_s_window = s.window) !== null && _s_window !== void 0 ? _s_window : window).removeEventListener("mousemove", d), ((_s_window1 = s.window) !== null && _s_window1 !== void 0 ? _s_window1 : window).removeEventListener("mouseup", l), document.body.style.cursor = "unset", c.dir.value = "";
        }, m = function(f) {
            f.preventDefault(), f.stopPropagation();
            var v = f.target;
            var _s_window, _s_window1;
            v && (c.dir.value = v.dataset.dir.toLocaleLowerCase()), document.body.style.cursor = h0[c.dir.value], c.x.value = f.pageX, c.y.value = f.pageY, c.dWidth.value = 0, c.dHeight.value = 0, c.vHeight.value = s.height, c.vWidth.value = s.width, ((_s_window = s.window) !== null && _s_window !== void 0 ? _s_window : window).addEventListener("mousemove", d), ((_s_window1 = s.window) !== null && _s_window1 !== void 0 ? _s_window1 : window).addEventListener("mouseup", l), i("resizestart");
        };
        return function(f, v) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
                "class": (0, $3ZJCa.normalizeClass)(u.value)
            }, [
                ((0, $8B0Dy.openBlock)(!0), (0, $8B0Dy.createElementBlock)((0, $8B0Dy.Fragment), null, (0, $8B0Dy.renderList)(a.value, function(g) {
                    var _obj;
                    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
                        key: g,
                        "data-dir": g,
                        "class": (0, $3ZJCa.normalizeClass)((_obj = {}, (0, $aRIHe._)(_obj, (0, $5wB2C.unref)(o).resizer, !0), (0, $aRIHe._)(_obj, (0, $5wB2C.unref)(o)[g], !0), _obj)),
                        "data-test-id": "resize-handle",
                        onMousedown: m
                    }, null, 42, bVe);
                }), 128)),
                (0, $8B0Dy.renderSlot)(f.$slots, "default")
            ], 2);
        };
    }
}), wVe = "_resize_r3sn9_1", kVe = "_resizer_r3sn9_11", xVe = "_right_r3sn9_16", CVe = "_top_r3sn9_24", SVe = "_bottom_r3sn9_32", EVe = "_left_r3sn9_40", AVe = "_topLeft_r3sn9_48", $Ve = "_topRight_r3sn9_56", MVe = "_bottomLeft_r3sn9_64", IVe = "_bottomRight_r3sn9_72", TVe = "_outset_r3sn9_80", LVe = {
    resize: wVe,
    resizer: kVe,
    right: xVe,
    top: CVe,
    bottom: SVe,
    left: EVe,
    topLeft: AVe,
    topRight: $Ve,
    bottomLeft: MVe,
    bottomRight: IVe,
    outset: TVe
}, OVe = {
    $style: LVe
}, RVe = /* @__PURE__ */ Ht(yVe, [
    [
        "__cssModules",
        OVe
    ]
]), Hm = {
    height: 180,
    width: 240,
    minHeight: 80,
    minWidth: 150,
    id: "0",
    editMode: !1,
    readOnly: !1,
    backgroundColor: 1
}, PVe = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    __name: "Sticky",
    props: /* @__PURE__ */ (0, $8B0Dy.mergeDefaults)({
        modelValue: {},
        height: {},
        width: {},
        minHeight: {},
        minWidth: {},
        id: {},
        defaultText: {},
        editMode: {
            type: Boolean
        },
        readOnly: {
            type: Boolean
        },
        backgroundColor: {}
    }, Hm),
    emits: [
        "edit",
        "update:modelValue",
        "markdown-click"
    ],
    setup: function(e, param) {
        var t = param.emit;
        var n = e, r = t, _gO = gO(), s = _gO.t, o = (0, $5wB2C.ref)(!1), i = (0, $5wB2C.ref)(void 0), a = (0, $5wB2C.computed)(function() {
            return n.height < n.minHeight ? n.minHeight : n.height;
        }), c = (0, $5wB2C.computed)(function() {
            return n.width < n.minWidth ? n.minWidth : n.width;
        }), u = (0, $5wB2C.computed)(function() {
            return n.id ? "".concat(n.id, "-input") : void 0;
        }), d = (0, $5wB2C.computed)(function() {
            return {
                height: "".concat(a.value, "px"),
                width: "".concat(c.value, "px")
            };
        }), l = (0, $5wB2C.computed)(function() {
            return a.value > 100 && c.value > 155;
        });
        (0, $5wB2C.watch)(function() {
            return n.editMode;
        }, function(h, w) {
            setTimeout(function() {
                h && !w && i.value && (n.defaultText === n.modelValue && i.value.select(), i.value.focus());
            }, 100);
        });
        var m = function() {
            n.readOnly || r("edit", !0);
        }, f = function() {
            o.value || r("edit", !1);
        }, v = function(h) {
            r("update:modelValue", h);
        }, g = function(h, w) {
            r("markdown-click", h, w);
        }, b = function(h) {
            !h.ctrlKey && !h.metaKey && h.stopPropagation();
        };
        return function(h, w) {
            var k = (0, $8B0Dy.resolveDirective)("n8n-html");
            var _obj;
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
                "class": (0, $3ZJCa.normalizeClass)((_obj = {
                    "n8n-sticky": !0
                }, (0, $aRIHe._)(_obj, h.$style.sticky, !0), (0, $aRIHe._)(_obj, h.$style.clickable, !o.value), (0, $aRIHe._)(_obj, h.$style["color-".concat(h.backgroundColor)], !0), _obj)),
                style: (0, $3ZJCa.normalizeStyle)(d.value),
                onKeydown: w[4] || (w[4] = (0, $kRi7Z.withModifiers)(function() {}, [
                    "prevent"
                ]))
            }, [
                (0, $8B0Dy.withDirectives)((0, $8B0Dy.createElementVNode)("div", {
                    "class": (0, $3ZJCa.normalizeClass)(h.$style.wrapper),
                    onDblclick: (0, $kRi7Z.withModifiers)(m, [
                        "stop"
                    ])
                }, [
                    (0, $8B0Dy.createVNode)((0, $5wB2C.unref)(fUe), {
                        theme: "sticky",
                        content: h.modelValue,
                        "with-multi-breaks": !0,
                        onMarkdownClick: g,
                        onUpdateContent: v
                    }, null, 8, [
                        "content"
                    ])
                ], 34), [
                    [
                        (0, $kRi7Z.vShow),
                        !h.editMode
                    ]
                ]),
                (0, $8B0Dy.withDirectives)((0, $8B0Dy.createElementVNode)("div", {
                    "class": (0, $3ZJCa.normalizeClass)({
                        "full-height": !l.value,
                        "sticky-textarea": !0
                    }),
                    onClick: w[0] || (w[0] = (0, $kRi7Z.withModifiers)(function() {}, [
                        "stop"
                    ])),
                    onMousedown: w[1] || (w[1] = (0, $kRi7Z.withModifiers)(function() {}, [
                        "stop"
                    ])),
                    onMouseup: w[2] || (w[2] = (0, $kRi7Z.withModifiers)(function() {}, [
                        "stop"
                    ])),
                    onKeydown: [
                        (0, $kRi7Z.withKeys)(f, [
                            "esc"
                        ]),
                        w[3] || (w[3] = (0, $kRi7Z.withModifiers)(function() {}, [
                            "stop"
                        ]))
                    ]
                }, [
                    (0, $8B0Dy.createVNode)((0, $5wB2C.unref)(sm), {
                        ref_key: "input",
                        ref: i,
                        "model-value": h.modelValue,
                        name: u.value,
                        type: "textarea",
                        rows: 5,
                        onBlur: f,
                        "onUpdate:modelValue": v,
                        onWheel: b
                    }, null, 8, [
                        "model-value",
                        "name"
                    ])
                ], 34), [
                    [
                        (0, $kRi7Z.vShow),
                        h.editMode
                    ]
                ]),
                h.editMode && l.value ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
                    key: 0,
                    "class": (0, $3ZJCa.normalizeClass)(h.$style.footer)
                }, [
                    (0, $8B0Dy.createVNode)((0, $5wB2C.unref)(nm), {
                        size: "xsmall",
                        align: "right"
                    }, {
                        "default": (0, $8B0Dy.withCtx)(function() {
                            return [
                                (0, $8B0Dy.withDirectives)((0, $8B0Dy.createElementVNode)("span", null, null, 512), [
                                    [
                                        k,
                                        (0, $5wB2C.unref)(s)("sticky.markdownHint")
                                    ]
                                ])
                            ];
                        }),
                        _: 1
                    })
                ], 2)) : (0, $8B0Dy.createCommentVNode)("", !0)
            ], 38);
        };
    }
}), BVe = "_sticky_1iqd8_1", zVe = "_wrapper_1iqd8_7", DVe = "_clickable_1iqd8_12", NVe = "_footer_1iqd8_33", qVe = {
    sticky: BVe,
    wrapper: zVe,
    clickable: DVe,
    footer: NVe,
    "color-2": "_color-2_1iqd8_39",
    "color-3": "_color-3_1iqd8_44",
    "color-4": "_color-4_1iqd8_49",
    "color-5": "_color-5_1iqd8_54",
    "color-6": "_color-6_1iqd8_59",
    "color-7": "_color-7_1iqd8_64"
}, FVe = {
    $style: qVe
}, HVe = /* @__PURE__ */ Ht(PVe, [
    [
        "__cssModules",
        FVe
    ]
]);
(0, $6869c._)({}, Hm);
var ya, E0;
function Dl() {
    if (E0) return ya;
    E0 = 1;
    var e = Array.isArray;
    return ya = e, ya;
}
var wa, A0;
function jVe() {
    if (A0) return wa;
    A0 = 1;
    var e = (typeof pr === "undefined" ? "undefined" : (0, $6gBIz._)(pr)) == "object" && pr && pr.Object === Object && pr;
    return wa = e, wa;
}
var ka, $0;
function Nl() {
    if ($0) return ka;
    $0 = 1;
    var e = jVe(), t = (typeof self === "undefined" ? "undefined" : (0, $6gBIz._)(self)) == "object" && self && self.Object === Object && self, n = e || t || Function("return this")();
    return ka = n, ka;
}
var xa, M0;
function ql() {
    if (M0) return xa;
    M0 = 1;
    var e = Nl(), t = e.Symbol;
    return xa = t, xa;
}
var Ca, I0;
function UVe() {
    if (I0) return Ca;
    I0 = 1;
    var e = ql(), t = Object.prototype, n = t.hasOwnProperty, r = t.toString, s = e ? e.toStringTag : void 0;
    function o(i) {
        var a = n.call(i, s), c = i[s];
        try {
            i[s] = void 0;
            var u = !0;
        } catch (e) {}
        var d = r.call(i);
        return u && (a ? i[s] = c : delete i[s]), d;
    }
    return Ca = o, Ca;
}
var Sa, T0;
function VVe() {
    if (T0) return Sa;
    T0 = 1;
    var e = Object.prototype, t = e.toString;
    function n(r) {
        return t.call(r);
    }
    return Sa = n, Sa;
}
var Ea, L0;
function jm() {
    if (L0) return Ea;
    L0 = 1;
    var e = ql(), t = UVe(), n = VVe(), r = "[object Null]", s = "[object Undefined]", o = e ? e.toStringTag : void 0;
    function i(a) {
        return a == null ? a === void 0 ? s : r : o && o in Object(a) ? t(a) : n(a);
    }
    return Ea = i, Ea;
}
var Aa, O0;
function ZVe() {
    if (O0) return Aa;
    O0 = 1;
    function e(t) {
        return t != null && (typeof t === "undefined" ? "undefined" : (0, $6gBIz._)(t)) == "object";
    }
    return Aa = e, Aa;
}
var $a, R0;
function Fl() {
    if (R0) return $a;
    R0 = 1;
    var e = jm(), t = ZVe(), n = "[object Symbol]";
    function r(s) {
        return (typeof s === "undefined" ? "undefined" : (0, $6gBIz._)(s)) == "symbol" || t(s) && e(s) == n;
    }
    return $a = r, $a;
}
var Ma, P0;
function WVe() {
    if (P0) return Ma;
    P0 = 1;
    var e = Dl(), t = Fl(), n = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, r = /^\w*$/;
    function s(o, i) {
        if (e(o)) return !1;
        var a = typeof o === "undefined" ? "undefined" : (0, $6gBIz._)(o);
        return a == "number" || a == "symbol" || a == "boolean" || o == null || t(o) ? !0 : r.test(o) || !n.test(o) || i != null && o in Object(i);
    }
    return Ma = s, Ma;
}
var Ia, B0;
function Um() {
    if (B0) return Ia;
    B0 = 1;
    function e(t) {
        var n = typeof t === "undefined" ? "undefined" : (0, $6gBIz._)(t);
        return t != null && (n == "object" || n == "function");
    }
    return Ia = e, Ia;
}
var Ta, z0;
function GVe() {
    if (z0) return Ta;
    z0 = 1;
    var e = jm(), t = Um(), n = "[object AsyncFunction]", r = "[object Function]", s = "[object GeneratorFunction]", o = "[object Proxy]";
    function i(a) {
        if (!t(a)) return !1;
        var c = e(a);
        return c == r || c == s || c == n || c == o;
    }
    return Ta = i, Ta;
}
var La, D0;
function KVe() {
    if (D0) return La;
    D0 = 1;
    var e = Nl(), t = e["__core-js_shared__"];
    return La = t, La;
}
var Oa, N0;
function XVe() {
    if (N0) return Oa;
    N0 = 1;
    var e = KVe(), t = function() {
        var r = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
        return r ? "Symbol(src)_1." + r : "";
    }();
    function n(r) {
        return !!t && t in r;
    }
    return Oa = n, Oa;
}
var Ra, q0;
function YVe() {
    if (q0) return Ra;
    q0 = 1;
    var e = Function.prototype, t = e.toString;
    function n(r) {
        if (r != null) {
            try {
                return t.call(r);
            } catch (e) {}
            try {
                return r + "";
            } catch (e) {}
        }
        return "";
    }
    return Ra = n, Ra;
}
var Pa, F0;
function JVe() {
    if (F0) return Pa;
    F0 = 1;
    var e = GVe(), t = XVe(), n = Um(), r = YVe(), s = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, i = Function.prototype, a = Object.prototype, c = i.toString, u = a.hasOwnProperty, d = RegExp("^" + c.call(u).replace(s, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    function l(m) {
        if (!n(m) || t(m)) return !1;
        var f = e(m) ? d : o;
        return f.test(r(m));
    }
    return Pa = l, Pa;
}
var Ba, H0;
function QVe() {
    if (H0) return Ba;
    H0 = 1;
    function e(t, n) {
        return t == null ? void 0 : t[n];
    }
    return Ba = e, Ba;
}
var za, j0;
function Vm() {
    if (j0) return za;
    j0 = 1;
    var e = JVe(), t = QVe();
    function n(r, s) {
        var o = t(r, s);
        return e(o) ? o : void 0;
    }
    return za = n, za;
}
var Da, U0;
function Es() {
    if (U0) return Da;
    U0 = 1;
    var e = Vm(), t = e(Object, "create");
    return Da = t, Da;
}
var Na, V0;
function eZe() {
    if (V0) return Na;
    V0 = 1;
    var e = Es();
    function t() {
        this.__data__ = e ? e(null) : {}, this.size = 0;
    }
    return Na = t, Na;
}
var qa, Z0;
function tZe() {
    if (Z0) return qa;
    Z0 = 1;
    function e(t) {
        var n = this.has(t) && delete this.__data__[t];
        return this.size -= n ? 1 : 0, n;
    }
    return qa = e, qa;
}
var Fa, W0;
function nZe() {
    if (W0) return Fa;
    W0 = 1;
    var e = Es(), t = "__lodash_hash_undefined__", n = Object.prototype, r = n.hasOwnProperty;
    function s(o) {
        var i = this.__data__;
        if (e) {
            var a = i[o];
            return a === t ? void 0 : a;
        }
        return r.call(i, o) ? i[o] : void 0;
    }
    return Fa = s, Fa;
}
var Ha, G0;
function rZe() {
    if (G0) return Ha;
    G0 = 1;
    var e = Es(), t = Object.prototype, n = t.hasOwnProperty;
    function r(s) {
        var o = this.__data__;
        return e ? o[s] !== void 0 : n.call(o, s);
    }
    return Ha = r, Ha;
}
var ja, K0;
function oZe() {
    if (K0) return ja;
    K0 = 1;
    var e = Es(), t = "__lodash_hash_undefined__";
    function n(r, s) {
        var o = this.__data__;
        return this.size += this.has(r) ? 0 : 1, o[r] = e && s === void 0 ? t : s, this;
    }
    return ja = n, ja;
}
var Ua, X0;
function sZe() {
    if (X0) return Ua;
    X0 = 1;
    var e = eZe(), t = tZe(), n = nZe(), r = rZe(), s = oZe();
    function o(i) {
        var a = -1, c = i == null ? 0 : i.length;
        for(this.clear(); ++a < c;){
            var u = i[a];
            this.set(u[0], u[1]);
        }
    }
    return o.prototype.clear = e, o.prototype["delete"] = t, o.prototype.get = n, o.prototype.has = r, o.prototype.set = s, Ua = o, Ua;
}
var Va, Y0;
function iZe() {
    if (Y0) return Va;
    Y0 = 1;
    function e() {
        this.__data__ = [], this.size = 0;
    }
    return Va = e, Va;
}
var Za, J0;
function aZe() {
    if (J0) return Za;
    J0 = 1;
    function e(t, n) {
        return t === n || t !== t && n !== n;
    }
    return Za = e, Za;
}
var Wa, Q0;
function As() {
    if (Q0) return Wa;
    Q0 = 1;
    var e = aZe();
    function t(n, r) {
        for(var s = n.length; s--;)if (e(n[s][0], r)) return s;
        return -1;
    }
    return Wa = t, Wa;
}
var Ga, ep;
function cZe() {
    if (ep) return Ga;
    ep = 1;
    var e = As(), t = Array.prototype, n = t.splice;
    function r(s) {
        var o = this.__data__, i = e(o, s);
        if (i < 0) return !1;
        var a = o.length - 1;
        return i == a ? o.pop() : n.call(o, i, 1), --this.size, !0;
    }
    return Ga = r, Ga;
}
var Ka, tp;
function lZe() {
    if (tp) return Ka;
    tp = 1;
    var e = As();
    function t(n) {
        var r = this.__data__, s = e(r, n);
        return s < 0 ? void 0 : r[s][1];
    }
    return Ka = t, Ka;
}
var Xa, np;
function uZe() {
    if (np) return Xa;
    np = 1;
    var e = As();
    function t(n) {
        return e(this.__data__, n) > -1;
    }
    return Xa = t, Xa;
}
var Ya, rp;
function dZe() {
    if (rp) return Ya;
    rp = 1;
    var e = As();
    function t(n, r) {
        var s = this.__data__, o = e(s, n);
        return o < 0 ? (++this.size, s.push([
            n,
            r
        ])) : s[o][1] = r, this;
    }
    return Ya = t, Ya;
}
var Ja, op;
function fZe() {
    if (op) return Ja;
    op = 1;
    var e = iZe(), t = cZe(), n = lZe(), r = uZe(), s = dZe();
    function o(i) {
        var a = -1, c = i == null ? 0 : i.length;
        for(this.clear(); ++a < c;){
            var u = i[a];
            this.set(u[0], u[1]);
        }
    }
    return o.prototype.clear = e, o.prototype["delete"] = t, o.prototype.get = n, o.prototype.has = r, o.prototype.set = s, Ja = o, Ja;
}
var Qa, sp;
function pZe() {
    if (sp) return Qa;
    sp = 1;
    var e = Vm(), t = Nl(), n = e(t, "Map");
    return Qa = n, Qa;
}
var ec, ip;
function hZe() {
    if (ip) return ec;
    ip = 1;
    var e = sZe(), t = fZe(), n = pZe();
    function r() {
        this.size = 0, this.__data__ = {
            hash: new e(),
            map: new (n || t)(),
            string: new e()
        };
    }
    return ec = r, ec;
}
var tc, ap;
function gZe() {
    if (ap) return tc;
    ap = 1;
    function e(t) {
        var n = typeof t === "undefined" ? "undefined" : (0, $6gBIz._)(t);
        return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? t !== "__proto__" : t === null;
    }
    return tc = e, tc;
}
var nc, cp;
function $s() {
    if (cp) return nc;
    cp = 1;
    var e = gZe();
    function t(n, r) {
        var s = n.__data__;
        return e(r) ? s[typeof r == "string" ? "string" : "hash"] : s.map;
    }
    return nc = t, nc;
}
var rc, lp;
function mZe() {
    if (lp) return rc;
    lp = 1;
    var e = $s();
    function t(n) {
        var r = e(this, n)["delete"](n);
        return this.size -= r ? 1 : 0, r;
    }
    return rc = t, rc;
}
var oc, up;
function vZe() {
    if (up) return oc;
    up = 1;
    var e = $s();
    function t(n) {
        return e(this, n).get(n);
    }
    return oc = t, oc;
}
var sc, dp;
function _Ze() {
    if (dp) return sc;
    dp = 1;
    var e = $s();
    function t(n) {
        return e(this, n).has(n);
    }
    return sc = t, sc;
}
var ic, fp;
function bZe() {
    if (fp) return ic;
    fp = 1;
    var e = $s();
    function t(n, r) {
        var s = e(this, n), o = s.size;
        return s.set(n, r), this.size += s.size == o ? 0 : 1, this;
    }
    return ic = t, ic;
}
var ac, pp;
function yZe() {
    if (pp) return ac;
    pp = 1;
    var e = hZe(), t = mZe(), n = vZe(), r = _Ze(), s = bZe();
    function o(i) {
        var a = -1, c = i == null ? 0 : i.length;
        for(this.clear(); ++a < c;){
            var u = i[a];
            this.set(u[0], u[1]);
        }
    }
    return o.prototype.clear = e, o.prototype["delete"] = t, o.prototype.get = n, o.prototype.has = r, o.prototype.set = s, ac = o, ac;
}
var cc, hp;
function wZe() {
    if (hp) return cc;
    hp = 1;
    var e = yZe(), t = "Expected a function";
    function n(r, s) {
        if (typeof r != "function" || s != null && typeof s != "function") throw new TypeError(t);
        var o = function o1() {
            var i = arguments, a = s ? s.apply(this, i) : i[0], c = o.cache;
            if (c.has(a)) return c.get(a);
            var u = r.apply(this, i);
            return o.cache = c.set(a, u) || c, u;
        };
        return o.cache = new (n.Cache || e)(), o;
    }
    return n.Cache = e, cc = n, cc;
}
var lc, gp;
function kZe() {
    if (gp) return lc;
    gp = 1;
    var e = wZe(), t = 500;
    function n(r) {
        var s = e(r, function(i) {
            return o.size === t && o.clear(), i;
        }), o = s.cache;
        return s;
    }
    return lc = n, lc;
}
var uc, mp;
function xZe() {
    if (mp) return uc;
    mp = 1;
    var e = kZe(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, n = /\\(\\)?/g, r = e(function(s) {
        var o = [];
        return s.charCodeAt(0) === 46 && o.push(""), s.replace(t, function(i, a, c, u) {
            o.push(c ? u.replace(n, "$1") : a || i);
        }), o;
    });
    return uc = r, uc;
}
var dc, vp;
function CZe() {
    if (vp) return dc;
    vp = 1;
    function e(t, n) {
        for(var r = -1, s = t == null ? 0 : t.length, o = Array(s); ++r < s;)o[r] = n(t[r], r, t);
        return o;
    }
    return dc = e, dc;
}
var fc, _p;
function SZe() {
    if (_p) return fc;
    _p = 1;
    var e = ql(), t = CZe(), n = Dl(), r = Fl(), s = e ? e.prototype : void 0, o = s ? s.toString : void 0;
    function i(a) {
        if (typeof a == "string") return a;
        if (n(a)) return t(a, i) + "";
        if (r(a)) return o ? o.call(a) : "";
        var c = a + "";
        return c == "0" && 1 / a == -1 / 0 ? "-0" : c;
    }
    return fc = i, fc;
}
var pc, bp;
function EZe() {
    if (bp) return pc;
    bp = 1;
    var e = SZe();
    function t(n) {
        return n == null ? "" : e(n);
    }
    return pc = t, pc;
}
var hc, yp;
function AZe() {
    if (yp) return hc;
    yp = 1;
    var e = Dl(), t = WVe(), n = xZe(), r = EZe();
    function s(o, i) {
        return e(o) ? o : t(o, i) ? [
            o
        ] : n(r(o));
    }
    return hc = s, hc;
}
var gc, wp;
function $Ze() {
    if (wp) return gc;
    wp = 1;
    var e = Fl();
    function t(n) {
        if (typeof n == "string" || e(n)) return n;
        var r = n + "";
        return r == "0" && 1 / n == -1 / 0 ? "-0" : r;
    }
    return gc = t, gc;
}
var mc, kp;
function MZe() {
    if (kp) return mc;
    kp = 1;
    var e = AZe(), t = $Ze();
    function n(r, s) {
        s = e(s, r);
        for(var o = 0, i = s.length; r != null && o < i;)r = r[t(s[o++])];
        return o && o == i ? r : void 0;
    }
    return mc = n, mc;
}
var vc, xp;
function IZe() {
    if (xp) return vc;
    xp = 1;
    var e = MZe();
    function t(n, r, s) {
        var o = n == null ? void 0 : e(n, r);
        return o === void 0 ? s : o;
    }
    return vc = t, vc;
}
IZe();
function TZe(e) {
    var t = e.regex, n = {}, r = {
        begin: /\$\{/,
        end: /\}/,
        contains: [
            "self",
            {
                begin: /:-/,
                contains: [
                    n
                ]
            }
        ]
    };
    Object.assign(n, {
        className: "variable",
        variants: [
            {
                begin: t.concat(/\$[\w\d#@][\w\d_]*/, // negative look-ahead tries to avoid matching patterns that are not
                // Perl at all like $ident$, @ident@, etc.
                "(?![\\w\\d])(?![$])")
            },
            r
        ]
    });
    var s = {
        className: "subst",
        begin: /\$\(/,
        end: /\)/,
        contains: [
            e.BACKSLASH_ESCAPE
        ]
    }, o = {
        begin: /<<-?\s*(?=\w+)/,
        starts: {
            contains: [
                e.END_SAME_AS_BEGIN({
                    begin: /(\w+)/,
                    end: /(\w+)/,
                    className: "string"
                })
            ]
        }
    }, i = {
        className: "string",
        begin: /"/,
        end: /"/,
        contains: [
            e.BACKSLASH_ESCAPE,
            n,
            s
        ]
    };
    s.contains.push(i);
    var a = {
        match: /\\"/
    }, c = {
        className: "string",
        begin: /'/,
        end: /'/
    }, u = {
        match: /\\'/
    }, d = {
        begin: /\$?\(\(/,
        end: /\)\)/,
        contains: [
            {
                begin: /\d+#[0-9a-f]+/,
                className: "number"
            },
            e.NUMBER_MODE,
            n
        ]
    }, l = [
        "fish",
        "bash",
        "zsh",
        "sh",
        "csh",
        "ksh",
        "tcsh",
        "dash",
        "scsh"
    ], m = e.SHEBANG({
        binary: "(".concat(l.join("|"), ")"),
        relevance: 10
    }), f = {
        className: "function",
        begin: /\w[\w\d_]*\s*\(\s*\)\s*\{/,
        returnBegin: !0,
        contains: [
            e.inherit(e.TITLE_MODE, {
                begin: /\w[\w\d_]*/
            })
        ],
        relevance: 0
    }, v = [
        "if",
        "then",
        "else",
        "elif",
        "fi",
        "for",
        "while",
        "until",
        "in",
        "do",
        "done",
        "case",
        "esac",
        "function",
        "select"
    ], g = [
        "true",
        "false"
    ], b = {
        match: /(\/[a-z._-]+)+/
    }, h = [
        "break",
        "cd",
        "continue",
        "eval",
        "exec",
        "exit",
        "export",
        "getopts",
        "hash",
        "pwd",
        "readonly",
        "return",
        "shift",
        "test",
        "times",
        "trap",
        "umask",
        "unset"
    ], w = [
        "alias",
        "bind",
        "builtin",
        "caller",
        "command",
        "declare",
        "echo",
        "enable",
        "help",
        "let",
        "local",
        "logout",
        "mapfile",
        "printf",
        "read",
        "readarray",
        "source",
        "type",
        "typeset",
        "ulimit",
        "unalias"
    ], k = [
        "autoload",
        "bg",
        "bindkey",
        "bye",
        "cap",
        "chdir",
        "clone",
        "comparguments",
        "compcall",
        "compctl",
        "compdescribe",
        "compfiles",
        "compgroups",
        "compquote",
        "comptags",
        "comptry",
        "compvalues",
        "dirs",
        "disable",
        "disown",
        "echotc",
        "echoti",
        "emulate",
        "fc",
        "fg",
        "float",
        "functions",
        "getcap",
        "getln",
        "history",
        "integer",
        "jobs",
        "kill",
        "limit",
        "log",
        "noglob",
        "popd",
        "print",
        "pushd",
        "pushln",
        "rehash",
        "sched",
        "setcap",
        "setopt",
        "stat",
        "suspend",
        "ttyctl",
        "unfunction",
        "unhash",
        "unlimit",
        "unsetopt",
        "vared",
        "wait",
        "whence",
        "where",
        "which",
        "zcompile",
        "zformat",
        "zftp",
        "zle",
        "zmodload",
        "zparseopts",
        "zprof",
        "zpty",
        "zregexparse",
        "zsocket",
        "zstyle",
        "ztcp"
    ], x = [
        "chcon",
        "chgrp",
        "chown",
        "chmod",
        "cp",
        "dd",
        "df",
        "dir",
        "dircolors",
        "ln",
        "ls",
        "mkdir",
        "mkfifo",
        "mknod",
        "mktemp",
        "mv",
        "realpath",
        "rm",
        "rmdir",
        "shred",
        "sync",
        "touch",
        "truncate",
        "vdir",
        "b2sum",
        "base32",
        "base64",
        "cat",
        "cksum",
        "comm",
        "csplit",
        "cut",
        "expand",
        "fmt",
        "fold",
        "head",
        "join",
        "md5sum",
        "nl",
        "numfmt",
        "od",
        "paste",
        "ptx",
        "pr",
        "sha1sum",
        "sha224sum",
        "sha256sum",
        "sha384sum",
        "sha512sum",
        "shuf",
        "sort",
        "split",
        "sum",
        "tac",
        "tail",
        "tr",
        "tsort",
        "unexpand",
        "uniq",
        "wc",
        "arch",
        "basename",
        "chroot",
        "date",
        "dirname",
        "du",
        "echo",
        "env",
        "expr",
        "factor",
        // "false", // keyword literal already
        "groups",
        "hostid",
        "id",
        "link",
        "logname",
        "nice",
        "nohup",
        "nproc",
        "pathchk",
        "pinky",
        "printenv",
        "printf",
        "pwd",
        "readlink",
        "runcon",
        "seq",
        "sleep",
        "stat",
        "stdbuf",
        "stty",
        "tee",
        "test",
        "timeout",
        // "true", // keyword literal already
        "tty",
        "uname",
        "unlink",
        "uptime",
        "users",
        "who",
        "whoami",
        "yes"
    ];
    return {
        name: "Bash",
        aliases: [
            "sh"
        ],
        keywords: {
            $pattern: /\b[a-z][a-z0-9._-]+\b/,
            keyword: v,
            literal: g,
            built_in: (0, $kf9Kn._)(h).concat((0, $kf9Kn._)(w), [
                // Shell modifiers
                "set",
                "shopt"
            ], (0, $kf9Kn._)(k), (0, $kf9Kn._)(x))
        },
        contains: [
            m,
            // to catch known shells and boost relevancy
            e.SHEBANG(),
            // to catch unknown shells but still highlight the shebang
            f,
            d,
            e.HASH_COMMENT_MODE,
            o,
            b,
            i,
            a,
            c,
            u,
            n
        ]
    };
}
function LZe(e) {
    var t = e.regex, n = new RegExp("[\\p{XID_Start}_]\\p{XID_Continue}*", "u"), r = [
        "and",
        "as",
        "assert",
        "async",
        "await",
        "break",
        "case",
        "class",
        "continue",
        "def",
        "del",
        "elif",
        "else",
        "except",
        "finally",
        "for",
        "from",
        "global",
        "if",
        "import",
        "in",
        "is",
        "lambda",
        "match",
        "nonlocal|10",
        "not",
        "or",
        "pass",
        "raise",
        "return",
        "try",
        "while",
        "with",
        "yield"
    ], a = {
        $pattern: /[A-Za-z]\w+|__\w+__/,
        keyword: r,
        built_in: [
            "__import__",
            "abs",
            "all",
            "any",
            "ascii",
            "bin",
            "bool",
            "breakpoint",
            "bytearray",
            "bytes",
            "callable",
            "chr",
            "classmethod",
            "compile",
            "complex",
            "delattr",
            "dict",
            "dir",
            "divmod",
            "enumerate",
            "eval",
            "exec",
            "filter",
            "float",
            "format",
            "frozenset",
            "getattr",
            "globals",
            "hasattr",
            "hash",
            "help",
            "hex",
            "id",
            "input",
            "int",
            "isinstance",
            "issubclass",
            "iter",
            "len",
            "list",
            "locals",
            "map",
            "max",
            "memoryview",
            "min",
            "next",
            "object",
            "oct",
            "open",
            "ord",
            "pow",
            "print",
            "property",
            "range",
            "repr",
            "reversed",
            "round",
            "set",
            "setattr",
            "slice",
            "sorted",
            "staticmethod",
            "str",
            "sum",
            "super",
            "tuple",
            "type",
            "vars",
            "zip"
        ],
        literal: [
            "__debug__",
            "Ellipsis",
            "False",
            "None",
            "NotImplemented",
            "True"
        ],
        type: [
            "Any",
            "Callable",
            "Coroutine",
            "Dict",
            "List",
            "Literal",
            "Generic",
            "Optional",
            "Sequence",
            "Set",
            "Tuple",
            "Type",
            "Union"
        ]
    }, c = {
        className: "meta",
        begin: /^(>>>|\.\.\.) /
    }, u = {
        className: "subst",
        begin: /\{/,
        end: /\}/,
        keywords: a,
        illegal: /#/
    }, d = {
        begin: /\{\{/,
        relevance: 0
    }, l = {
        className: "string",
        contains: [
            e.BACKSLASH_ESCAPE
        ],
        variants: [
            {
                begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?'''/,
                end: /'''/,
                contains: [
                    e.BACKSLASH_ESCAPE,
                    c
                ],
                relevance: 10
            },
            {
                begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?"""/,
                end: /"""/,
                contains: [
                    e.BACKSLASH_ESCAPE,
                    c
                ],
                relevance: 10
            },
            {
                begin: /([fF][rR]|[rR][fF]|[fF])'''/,
                end: /'''/,
                contains: [
                    e.BACKSLASH_ESCAPE,
                    c,
                    d,
                    u
                ]
            },
            {
                begin: /([fF][rR]|[rR][fF]|[fF])"""/,
                end: /"""/,
                contains: [
                    e.BACKSLASH_ESCAPE,
                    c,
                    d,
                    u
                ]
            },
            {
                begin: /([uU]|[rR])'/,
                end: /'/,
                relevance: 10
            },
            {
                begin: /([uU]|[rR])"/,
                end: /"/,
                relevance: 10
            },
            {
                begin: /([bB]|[bB][rR]|[rR][bB])'/,
                end: /'/
            },
            {
                begin: /([bB]|[bB][rR]|[rR][bB])"/,
                end: /"/
            },
            {
                begin: /([fF][rR]|[rR][fF]|[fF])'/,
                end: /'/,
                contains: [
                    e.BACKSLASH_ESCAPE,
                    d,
                    u
                ]
            },
            {
                begin: /([fF][rR]|[rR][fF]|[fF])"/,
                end: /"/,
                contains: [
                    e.BACKSLASH_ESCAPE,
                    d,
                    u
                ]
            },
            e.APOS_STRING_MODE,
            e.QUOTE_STRING_MODE
        ]
    }, m = "[0-9](_?[0-9])*", f = "(\\b(".concat(m, "))?\\.(").concat(m, ")|\\b(").concat(m, ")\\."), v = "\\b|".concat(r.join("|")), g = {
        className: "number",
        relevance: 0,
        variants: [
            // exponentfloat, pointfloat
            // https://docs.python.org/3.9/reference/lexical_analysis.html#floating-point-literals
            // optionally imaginary
            // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
            // Note: no leading \b because floats can start with a decimal point
            // and we don't want to mishandle e.g. `fn(.5)`,
            // no trailing \b for pointfloat because it can end with a decimal point
            // and we don't want to mishandle e.g. `0..hex()`; this should be safe
            // because both MUST contain a decimal point and so cannot be confused with
            // the interior part of an identifier
            {
                begin: "(\\b(".concat(m, ")|(").concat(f, "))[eE][+-]?(").concat(m, ")[jJ]?(?=").concat(v, ")")
            },
            {
                begin: "(".concat(f, ")[jJ]?")
            },
            // decinteger, bininteger, octinteger, hexinteger
            // https://docs.python.org/3.9/reference/lexical_analysis.html#integer-literals
            // optionally "long" in Python 2
            // https://docs.python.org/2.7/reference/lexical_analysis.html#integer-and-long-integer-literals
            // decinteger is optionally imaginary
            // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
            {
                begin: "\\b([1-9](_?[0-9])*|0+(_?0)*)[lLjJ]?(?=".concat(v, ")")
            },
            {
                begin: "\\b0[bB](_?[01])+[lL]?(?=".concat(v, ")")
            },
            {
                begin: "\\b0[oO](_?[0-7])+[lL]?(?=".concat(v, ")")
            },
            {
                begin: "\\b0[xX](_?[0-9a-fA-F])+[lL]?(?=".concat(v, ")")
            },
            // imagnumber (digitpart-based)
            // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
            {
                begin: "\\b(".concat(m, ")[jJ](?=").concat(v, ")")
            }
        ]
    }, b = {
        className: "comment",
        begin: t.lookahead(/# type:/),
        end: /$/,
        keywords: a,
        contains: [
            {
                // prevent keywords from coloring `type`
                begin: /# type:/
            },
            // comment within a datatype comment includes no keywords
            {
                begin: /#/,
                end: /\b\B/,
                endsWithParent: !0
            }
        ]
    }, h = {
        className: "params",
        variants: [
            // Exclude params in functions without params
            {
                className: "",
                begin: /\(\s*\)/,
                skip: !0
            },
            {
                begin: /\(/,
                end: /\)/,
                excludeBegin: !0,
                excludeEnd: !0,
                keywords: a,
                contains: [
                    "self",
                    c,
                    g,
                    l,
                    e.HASH_COMMENT_MODE
                ]
            }
        ]
    };
    return u.contains = [
        l,
        g,
        c
    ], {
        name: "Python",
        aliases: [
            "py",
            "gyp",
            "ipython"
        ],
        unicodeRegex: !0,
        keywords: a,
        illegal: /(<\/|\?)|=>/,
        contains: [
            c,
            g,
            {
                // very common convention
                begin: /\bself\b/
            },
            {
                // eat "if" prior to string so that it won't accidentally be
                // labeled as an f-string
                beginKeywords: "if",
                relevance: 0
            },
            l,
            b,
            e.HASH_COMMENT_MODE,
            {
                match: [
                    /\bdef/,
                    /\s+/,
                    n
                ],
                scope: {
                    1: "keyword",
                    3: "title.function"
                },
                contains: [
                    h
                ]
            },
            {
                variants: [
                    {
                        match: [
                            /\bclass/,
                            /\s+/,
                            n,
                            /\s*/,
                            /\(\s*/,
                            n,
                            /\s*\)/
                        ]
                    },
                    {
                        match: [
                            /\bclass/,
                            /\s+/,
                            n
                        ]
                    }
                ],
                scope: {
                    1: "keyword",
                    3: "title.class",
                    6: "title.class.inherited"
                }
            },
            {
                className: "meta",
                begin: /^[\t ]*@/,
                end: /(?=#)|$/,
                contains: [
                    g,
                    h,
                    l
                ]
            }
        ]
    };
}
var os = "[A-Za-z$_][0-9A-Za-z$_]*", Zm = [
    "as",
    // for exports
    "in",
    "of",
    "if",
    "for",
    "while",
    "finally",
    "var",
    "new",
    "function",
    "do",
    "return",
    "void",
    "else",
    "break",
    "catch",
    "instanceof",
    "with",
    "throw",
    "case",
    "default",
    "try",
    "switch",
    "continue",
    "typeof",
    "delete",
    "let",
    "yield",
    "const",
    "class",
    // JS handles these with a special rule
    // "get",
    // "set",
    "debugger",
    "async",
    "await",
    "static",
    "import",
    "from",
    "export",
    "extends"
], Wm = [
    "true",
    "false",
    "null",
    "undefined",
    "NaN",
    "Infinity"
], Gm = [
    // Fundamental objects
    "Object",
    "Function",
    "Boolean",
    "Symbol",
    // numbers and dates
    "Math",
    "Date",
    "Number",
    "BigInt",
    // text
    "String",
    "RegExp",
    // Indexed collections
    "Array",
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Int16Array",
    "Int32Array",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array",
    // Keyed collections
    "Set",
    "Map",
    "WeakSet",
    "WeakMap",
    // Structured data
    "ArrayBuffer",
    "SharedArrayBuffer",
    "Atomics",
    "DataView",
    "JSON",
    // Control abstraction objects
    "Promise",
    "Generator",
    "GeneratorFunction",
    "AsyncFunction",
    // Reflection
    "Reflect",
    "Proxy",
    // Internationalization
    "Intl",
    // WebAssembly
    "WebAssembly"
], Km = [
    "Error",
    "EvalError",
    "InternalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
], Xm = [
    "setInterval",
    "setTimeout",
    "clearInterval",
    "clearTimeout",
    "require",
    "exports",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "unescape"
], Ym = [
    "arguments",
    "this",
    "super",
    "console",
    "window",
    "document",
    "localStorage",
    "sessionStorage",
    "module",
    "global"
], Jm = [].concat(Xm, Gm, Km);
function OZe(e) {
    var t = e.regex, n = function(U, param) {
        var G = param.after;
        var T = "</" + U[0].slice(1);
        return U.input.indexOf(T, G) !== -1;
    }, r = os, s = {
        begin: "<>",
        end: "</>"
    }, o = /<[A-Za-z0-9\\._:-]+\s*\/>/, i = {
        begin: /<[A-Za-z0-9\\._:-]+/,
        end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
        /**
     * @param {RegExpMatchArray} match
     * @param {CallbackResponse} response
     */ isTrulyOpeningTag: function(U, G) {
            var T = U[0].length + U.index, W = U.input[T];
            if (// HTML should not include another raw `<` inside a tag
            // nested type?
            // `<Array<Array<number>>`, etc.
            W === "<" || // the , gives away that this is not HTML
            // `<T, A extends keyof T, V>`
            W === ",") {
                G.ignoreMatch();
                return;
            }
            W === ">" && (n(U, {
                after: T
            }) || G.ignoreMatch());
            var V;
            var se = U.input.substring(T);
            if (V = se.match(/^\s*=/)) {
                G.ignoreMatch();
                return;
            }
            if ((V = se.match(/^\s+extends\s+/)) && V.index === 0) {
                G.ignoreMatch();
                return;
            }
        }
    }, a = {
        $pattern: os,
        keyword: Zm,
        literal: Wm,
        built_in: Jm,
        "variable.language": Ym
    }, c = "[0-9](_?[0-9])*", u = "\\.(".concat(c, ")"), d = "0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*", l = {
        className: "number",
        variants: [
            // DecimalLiteral
            {
                begin: "(\\b(".concat(d, ")((").concat(u, ")|\\.)?|(").concat(u, "))[eE][+-]?(").concat(c, ")\\b")
            },
            {
                begin: "\\b(".concat(d, ")\\b((").concat(u, ")\\b|\\.)?|(").concat(u, ")\\b")
            },
            // DecimalBigIntegerLiteral
            {
                begin: "\\b(0|[1-9](_?[0-9])*)n\\b"
            },
            // NonDecimalIntegerLiteral
            {
                begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b"
            },
            {
                begin: "\\b0[bB][0-1](_?[0-1])*n?\\b"
            },
            {
                begin: "\\b0[oO][0-7](_?[0-7])*n?\\b"
            },
            // LegacyOctalIntegerLiteral (does not include underscore separators)
            // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
            {
                begin: "\\b0[0-7]+n?\\b"
            }
        ],
        relevance: 0
    }, m = {
        className: "subst",
        begin: "\\$\\{",
        end: "\\}",
        keywords: a,
        contains: []
    }, f = {
        begin: "html`",
        end: "",
        starts: {
            end: "`",
            returnEnd: !1,
            contains: [
                e.BACKSLASH_ESCAPE,
                m
            ],
            subLanguage: "xml"
        }
    }, v = {
        begin: "css`",
        end: "",
        starts: {
            end: "`",
            returnEnd: !1,
            contains: [
                e.BACKSLASH_ESCAPE,
                m
            ],
            subLanguage: "css"
        }
    }, g = {
        begin: "gql`",
        end: "",
        starts: {
            end: "`",
            returnEnd: !1,
            contains: [
                e.BACKSLASH_ESCAPE,
                m
            ],
            subLanguage: "graphql"
        }
    }, b = {
        className: "string",
        begin: "`",
        end: "`",
        contains: [
            e.BACKSLASH_ESCAPE,
            m
        ]
    }, w = {
        className: "comment",
        variants: [
            e.COMMENT(/\/\*\*(?!\/)/, "\\*/", {
                relevance: 0,
                contains: [
                    {
                        begin: "(?=@[A-Za-z]+)",
                        relevance: 0,
                        contains: [
                            {
                                className: "doctag",
                                begin: "@[A-Za-z]+"
                            },
                            {
                                className: "type",
                                begin: "\\{",
                                end: "\\}",
                                excludeEnd: !0,
                                excludeBegin: !0,
                                relevance: 0
                            },
                            {
                                className: "variable",
                                begin: r + "(?=\\s*(-)|$)",
                                endsParent: !0,
                                relevance: 0
                            },
                            // eat spaces (not newlines) so we can find
                            // types or variables
                            {
                                begin: /(?=[^\n])\s/,
                                relevance: 0
                            }
                        ]
                    }
                ]
            }),
            e.C_BLOCK_COMMENT_MODE,
            e.C_LINE_COMMENT_MODE
        ]
    }, k = [
        e.APOS_STRING_MODE,
        e.QUOTE_STRING_MODE,
        f,
        v,
        g,
        b,
        // Skip numbers when they are part of a variable name
        {
            match: /\$\d+/
        },
        l
    ];
    m.contains = k.concat({
        // we need to pair up {} inside our subst to prevent
        // it from ending too early by matching another }
        begin: /\{/,
        end: /\}/,
        keywords: a,
        contains: [
            "self"
        ].concat(k)
    });
    var x = [].concat(w, m.contains), A = x.concat([
        // eat recursive parens in sub expressions
        {
            begin: /\(/,
            end: /\)/,
            keywords: a,
            contains: [
                "self"
            ].concat(x)
        }
    ]), S = {
        className: "params",
        begin: /\(/,
        end: /\)/,
        excludeBegin: !0,
        excludeEnd: !0,
        keywords: a,
        contains: A
    }, $ = {
        variants: [
            // class Car extends vehicle
            {
                match: [
                    /class/,
                    /\s+/,
                    r,
                    /\s+/,
                    /extends/,
                    /\s+/,
                    t.concat(r, "(", t.concat(/\./, r), ")*")
                ],
                scope: {
                    1: "keyword",
                    3: "title.class",
                    5: "keyword",
                    7: "title.class.inherited"
                }
            },
            // class Car
            {
                match: [
                    /class/,
                    /\s+/,
                    r
                ],
                scope: {
                    1: "keyword",
                    3: "title.class"
                }
            }
        ]
    }, M = {
        relevance: 0,
        match: t.either(// Hard coded exceptions
        /\bJSON/, // Float32Array, OutT
        /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/, // CSSFactory, CSSFactoryT
        /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/, // FPs, FPsT
        /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/),
        className: "title.class",
        keywords: {
            _: // se we still get relevance credit for JS library classes
            (0, $kf9Kn._)(Gm).concat((0, $kf9Kn._)(Km))
        }
    }, P = {
        label: "use_strict",
        className: "meta",
        relevance: 10,
        begin: /^\s*['"]use (strict|asm)['"]/
    }, R = {
        variants: [
            {
                match: [
                    /function/,
                    /\s+/,
                    r,
                    /(?=\s*\()/
                ]
            },
            // anonymous function
            {
                match: [
                    /function/,
                    /\s*(?=\()/
                ]
            }
        ],
        className: {
            1: "keyword",
            3: "title.function"
        },
        label: "func.def",
        contains: [
            S
        ],
        illegal: /%/
    }, B = {
        relevance: 0,
        match: /\b[A-Z][A-Z_0-9]+\b/,
        className: "variable.constant"
    };
    function H(U) {
        return t.concat("(?!", U.join("|"), ")");
    }
    var ie = {
        match: t.concat(/\b/, H((0, $kf9Kn._)(Xm).concat([
            "super",
            "import"
        ])), r, t.lookahead(/\(/)),
        className: "title.function",
        relevance: 0
    }, z = {
        begin: t.concat(/\./, t.lookahead(t.concat(r, /(?![0-9A-Za-z$_(])/))),
        end: r,
        excludeBegin: !0,
        keywords: "prototype",
        className: "property",
        relevance: 0
    }, Q = {
        match: [
            /get|set/,
            /\s+/,
            r,
            /(?=\()/
        ],
        className: {
            1: "keyword",
            3: "title.function"
        },
        contains: [
            {
                // eat to avoid empty params
                begin: /\(\)/
            },
            S
        ]
    }, N = "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + e.UNDERSCORE_IDENT_RE + ")\\s*=>", j = {
        match: [
            /const|var|let/,
            /\s+/,
            r,
            /\s*/,
            /=\s*/,
            /(async\s*)?/,
            // async is optional
            t.lookahead(N)
        ],
        keywords: "async",
        className: {
            1: "keyword",
            3: "title.function"
        },
        contains: [
            S
        ]
    };
    return {
        name: "JavaScript",
        aliases: [
            "js",
            "jsx",
            "mjs",
            "cjs"
        ],
        keywords: a,
        // this will be extended by TypeScript
        exports: {
            PARAMS_CONTAINS: A,
            CLASS_REFERENCE: M
        },
        illegal: /#(?![$_A-z])/,
        contains: [
            e.SHEBANG({
                label: "shebang",
                binary: "node",
                relevance: 5
            }),
            P,
            e.APOS_STRING_MODE,
            e.QUOTE_STRING_MODE,
            f,
            v,
            g,
            b,
            w,
            // Skip numbers when they are part of a variable name
            {
                match: /\$\d+/
            },
            l,
            M,
            {
                className: "attr",
                begin: r + t.lookahead(":"),
                relevance: 0
            },
            j,
            {
                // "value" container
                begin: "(" + e.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
                keywords: "return throw case",
                relevance: 0,
                contains: [
                    w,
                    e.REGEXP_MODE,
                    {
                        className: "function",
                        // we have to count the parens to make sure we actually have the
                        // correct bounding ( ) before the =>.  There could be any number of
                        // sub-expressions inside also surrounded by parens.
                        begin: N,
                        returnBegin: !0,
                        end: "\\s*=>",
                        contains: [
                            {
                                className: "params",
                                variants: [
                                    {
                                        begin: e.UNDERSCORE_IDENT_RE,
                                        relevance: 0
                                    },
                                    {
                                        className: null,
                                        begin: /\(\s*\)/,
                                        skip: !0
                                    },
                                    {
                                        begin: /\(/,
                                        end: /\)/,
                                        excludeBegin: !0,
                                        excludeEnd: !0,
                                        keywords: a,
                                        contains: A
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        // could be a comma delimited list of params to a function call
                        begin: /,/,
                        relevance: 0
                    },
                    {
                        match: /\s+/,
                        relevance: 0
                    },
                    {
                        // JSX
                        variants: [
                            {
                                begin: s.begin,
                                end: s.end
                            },
                            {
                                match: o
                            },
                            {
                                begin: i.begin,
                                // we carefully check the opening tag to see if it truly
                                // is a tag and not a false positive
                                "on:begin": i.isTrulyOpeningTag,
                                end: i.end
                            }
                        ],
                        subLanguage: "xml",
                        contains: [
                            {
                                begin: i.begin,
                                end: i.end,
                                skip: !0,
                                contains: [
                                    "self"
                                ]
                            }
                        ]
                    }
                ]
            },
            R,
            {
                // prevent this from getting swallowed up by function
                // since they appear "function like"
                beginKeywords: "while if switch catch for"
            },
            {
                // we have to count the parens to make sure we actually have the correct
                // bounding ( ).  There could be any number of sub-expressions inside
                // also surrounded by parens.
                begin: "\\b(?!function)" + e.UNDERSCORE_IDENT_RE + "\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{",
                // end parens
                returnBegin: !0,
                label: "func.def",
                contains: [
                    S,
                    e.inherit(e.TITLE_MODE, {
                        begin: r,
                        className: "title.function"
                    })
                ]
            },
            // catch ... so it won't trigger the property rule below
            {
                match: /\.\.\./,
                relevance: 0
            },
            z,
            // hack: prevents detection of keywords in some circumstances
            // .keyword()
            // $keyword = x
            {
                match: "\\$" + r,
                relevance: 0
            },
            {
                match: [
                    /\bconstructor(?=\s*\()/
                ],
                className: {
                    1: "title.function"
                },
                contains: [
                    S
                ]
            },
            ie,
            B,
            $,
            Q,
            {
                match: /\$[(.]/
            }
        ]
    };
}
function RZe(e) {
    var t = OZe(e), n = os, r = [
        "any",
        "void",
        "number",
        "boolean",
        "string",
        "object",
        "never",
        "symbol",
        "bigint",
        "unknown"
    ], s = {
        beginKeywords: "namespace",
        end: /\{/,
        excludeEnd: !0,
        contains: [
            t.exports.CLASS_REFERENCE
        ]
    }, o = {
        beginKeywords: "interface",
        end: /\{/,
        excludeEnd: !0,
        keywords: {
            keyword: "interface extends",
            built_in: r
        },
        contains: [
            t.exports.CLASS_REFERENCE
        ]
    }, i = {
        className: "meta",
        relevance: 10,
        begin: /^\s*['"]use strict['"]/
    }, a = [
        "type",
        "namespace",
        "interface",
        "public",
        "private",
        "protected",
        "implements",
        "declare",
        "abstract",
        "readonly",
        "enum",
        "override"
    ], c = {
        $pattern: os,
        keyword: Zm.concat(a),
        literal: Wm,
        built_in: Jm.concat(r),
        "variable.language": Ym
    }, u = {
        className: "meta",
        begin: "@" + n
    }, d = function(m, f, v) {
        var g = m.contains.findIndex(function(b) {
            return b.label === f;
        });
        if (g === -1) throw new Error("can not find mode to replace");
        m.contains.splice(g, 1, v);
    };
    Object.assign(t.keywords, c), t.exports.PARAMS_CONTAINS.push(u), t.contains = t.contains.concat([
        u,
        s,
        o
    ]), d(t, "shebang", e.SHEBANG()), d(t, "use_strict", i);
    var l = t.contains.find(function(m) {
        return m.label === "func.def";
    });
    return l.relevance = 0, Object.assign(t, {
        name: "TypeScript",
        aliases: [
            "ts",
            "tsx",
            "mts",
            "cts"
        ]
    }), t;
}
var PZe = (0, $8B0Dy.defineComponent)({
    name: "VueMarkdown",
    props: {
        source: {
            type: String,
            required: !0
        },
        options: {
            type: Object,
            required: !1
        },
        plugins: {
            type: Array,
            required: !1
        }
    },
    setup: function(e) {
        var _e_options;
        var t = (0, $5wB2C.ref)(new pm((_e_options = e.options) !== null && _e_options !== void 0 ? _e_options : {}));
        var _e_plugins;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = ((_e_plugins = e.plugins) !== null && _e_plugins !== void 0 ? _e_plugins : [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var r = _step.value;
                t.value.use(r);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var n = (0, $5wB2C.computed)(function() {
            return t.value.render(e.source);
        });
        return function() {
            return (0, $8B0Dy.h)("div", {
                innerHTML: n.value
            });
        };
    }
}), BZe = {
    key: 0,
    "class": "chat-message-actions"
}, zZe = {
    key: 2,
    "class": "chat-message-files"
}, Wc = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    __name: "Message",
    props: {
        message: {}
    },
    setup: function(e, param) {
        var t = param.expose;
        var n = e;
        hn.registerLanguage("javascript", Fp), hn.registerLanguage("typescript", RZe), hn.registerLanguage("python", LZe), hn.registerLanguage("xml", Hp), hn.registerLanguage("bash", TZe);
        var _ref;
        var _ss = (0, $5wB2C.toRefs)(n), r = _ss.message, _co = co(), s = _co.options, o = (0, $5wB2C.ref)(null), i = (0, $5wB2C.ref)({}), a = (0, $5wB2C.computed)(function() {
            return r.value.text || "&lt;Empty response&gt;";
        }), c = (0, $5wB2C.computed)(function() {
            return {
                "chat-message-from-user": r.value.sender === "user",
                "chat-message-from-bot": r.value.sender === "bot",
                "chat-message-transparent": r.value.transparent === !0
            };
        }), u = function(v) {
            v.use(hm, {
                attrs: {
                    target: "_blank",
                    rel: "noopener"
                }
            });
        }, d = function() {
            var v;
            (v = o.value) != null && v.scrollIntoView && o.value.scrollIntoView({
                block: "start"
            });
        }, l = {
            highlight: function(v, g) {
                if (g && hn.getLanguage(g)) try {
                    return hn.highlight(v, {
                        language: g
                    }).value;
                } catch (e) {}
                return "";
            }
        }, m = (0, $6869c._)({}, (_ref = s == null ? void 0 : s.messageComponents) !== null && _ref !== void 0 ? _ref : {});
        t({
            scrollToView: d
        });
        var f = function(v) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
                return (0, $e0qXa.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                new Promise(function(g, b) {
                                    var h = new FileReader();
                                    h.onload = function() {
                                        return g(h.result);
                                    }, h.onerror = b, h.readAsDataURL(v);
                                })
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            })();
        };
        return (0, $8B0Dy.onMounted)(function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, v, _$g, g, err;
                return (0, $e0qXa.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            if (!r.value.files) return [
                                3,
                                10
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                8,
                                9,
                                10
                            ]);
                            _iterator = r.value.files[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                7
                            ];
                            v = _step.value;
                            _state.label = 3;
                        case 3:
                            _state.trys.push([
                                3,
                                5,
                                ,
                                6
                            ]);
                            return [
                                4,
                                f(v)
                            ];
                        case 4:
                            _$g = _state.sent();
                            i.value[v.name] = _$g;
                            return [
                                3,
                                6
                            ];
                        case 5:
                            g = _state.sent();
                            console.error("Error reading file:", g);
                            return [
                                3,
                                6
                            ];
                        case 6:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 7:
                            return [
                                3,
                                10
                            ];
                        case 8:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                10
                            ];
                        case 9:
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 10:
                            return [
                                2
                            ];
                    }
                });
            })();
        }), function(v, g) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
                ref_key: "messageContainer",
                ref: o,
                "class": (0, $3ZJCa.normalizeClass)([
                    "chat-message",
                    c.value
                ])
            }, [
                v.$slots.beforeMessage ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", BZe, [
                    (0, $8B0Dy.renderSlot)(v.$slots, "beforeMessage", (0, $3ZJCa.normalizeProps)((0, $8B0Dy.guardReactiveProps)({
                        message: (0, $5wB2C.unref)(r)
                    })))
                ])) : (0, $8B0Dy.createCommentVNode)("", !0),
                (0, $8B0Dy.renderSlot)(v.$slots, "default", {}, function() {
                    var __files, __files1;
                    return [
                        (0, $5wB2C.unref)(r).type === "component" && m[(0, $5wB2C.unref)(r).key] ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $8B0Dy.resolveDynamicComponent)(m[(0, $5wB2C.unref)(r).key]), (0, $3ZJCa.normalizeProps)((0, $8B0Dy.mergeProps)({
                            key: 0
                        }, (0, $5wB2C.unref)(r)["arguments"])), null, 16)) : ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(PZe), {
                            key: 1,
                            "class": "chat-message-markdown",
                            source: a.value,
                            options: l,
                            plugins: [
                                u
                            ]
                        }, null, 8, [
                            "source",
                            "plugins"
                        ])),
                        ((__files = (0, $5wB2C.unref)(r).files) !== null && __files !== void 0 ? __files : []).length > 0 ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", zZe, [
                            ((0, $8B0Dy.openBlock)(!0), (0, $8B0Dy.createElementBlock)((0, $8B0Dy.Fragment), null, (0, $8B0Dy.renderList)((__files1 = (0, $5wB2C.unref)(r).files) !== null && __files1 !== void 0 ? __files1 : [], function(b) {
                                return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", {
                                    key: b.name,
                                    "class": "chat-message-file"
                                }, [
                                    (0, $8B0Dy.createVNode)(jp, {
                                        file: b,
                                        "is-removable": !1,
                                        "is-previewable": !0
                                    }, null, 8, [
                                        "file"
                                    ])
                                ]);
                            }), 128))
                        ])) : (0, $8B0Dy.createCommentVNode)("", !0)
                    ];
                })
            ], 2);
        };
    }
}), DZe = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function NZe(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", DZe, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "currentColor",
            d: "M12 3c5.5 0 10 3.58 10 8s-4.5 8-10 8c-1.24 0-2.43-.18-3.53-.5C5.55 21 2 21 2 21c2.33-2.33 2.7-3.9 2.75-4.5C3.05 15.07 2 13.13 2 11c0-4.42 4.5-8 10-8"
        }, null, -1)
    ]));
}
var qZe = {
    name: "mdi-chat",
    render: NZe
}, FZe = {
    viewBox: "0 0 24 24",
    width: "1.2em",
    height: "1.2em"
};
function HZe(e, t) {
    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("svg", FZe, t[0] || (t[0] = [
        (0, $8B0Dy.createElementVNode)("path", {
            fill: "currentColor",
            d: "M7.41 8.58L12 13.17l4.59-4.59L18 10l-6 6l-6-6z"
        }, null, -1)
    ]));
}
var jZe = {
    name: "mdi-chevron-down",
    render: HZe
}, UZe = {
    "class": "chat-window-wrapper"
}, VZe = {
    "class": "chat-window"
}, ZZe = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    __name: "ChatWindow",
    setup: function(e) {
        var t = (0, $5wB2C.ref)(!1);
        function n() {
            t.value = !t.value, t.value && (0, $8B0Dy.nextTick)(function() {
                _t.emit("scrollToBottom");
            });
        }
        return function(r, s) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", UZe, [
                (0, $8B0Dy.createVNode)((0, $kRi7Z.Transition), {
                    name: "chat-window-transition"
                }, {
                    "default": (0, $8B0Dy.withCtx)(function() {
                        return [
                            (0, $8B0Dy.withDirectives)((0, $8B0Dy.createElementVNode)("div", VZe, [
                                (0, $8B0Dy.createVNode)(Qm)
                            ], 512), [
                                [
                                    (0, $kRi7Z.vShow),
                                    t.value
                                ]
                            ])
                        ];
                    }),
                    _: 1
                }),
                (0, $8B0Dy.createElementVNode)("div", {
                    "class": "chat-window-toggle",
                    onClick: n
                }, [
                    (0, $8B0Dy.createVNode)((0, $kRi7Z.Transition), {
                        name: "chat-window-toggle-transition",
                        mode: "out-in"
                    }, {
                        "default": (0, $8B0Dy.withCtx)(function() {
                            return [
                                t.value ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(jZe), {
                                    key: 1,
                                    height: "32",
                                    width: "32"
                                })) : ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(qZe), {
                                    key: 0,
                                    height: "32",
                                    width: "32"
                                }))
                            ];
                        }),
                        _: 1
                    })
                ])
            ]);
        };
    }
}), WZe = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    __name: "MessageTyping",
    props: {
        animation: {
            "default": "bouncing"
        }
    },
    setup: function(e) {
        var t = e, n = {
            id: "typing",
            text: "",
            sender: "bot"
        }, r = (0, $5wB2C.ref)(), s = (0, $5wB2C.computed)(function() {
            return (0, $aRIHe._)({
                // eslint-disable-next-line @typescript-eslint/naming-convention
                "chat-message-typing": !0
            }, "chat-message-typing-animation-".concat(t.animation), !0);
        });
        return (0, $8B0Dy.onMounted)(function() {
            var o;
            (o = r.value) == null || o.scrollToView();
        }), function(o, i) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)((0, $5wB2C.unref)(Wc), {
                ref_key: "messageContainer",
                ref: r,
                "class": (0, $3ZJCa.normalizeClass)(s.value),
                message: n,
                "data-test-id": "chat-message-typing"
            }, {
                "default": (0, $8B0Dy.withCtx)(function() {
                    return i[0] || (i[0] = [
                        (0, $8B0Dy.createElementVNode)("div", {
                            "class": "chat-message-typing-body"
                        }, [
                            (0, $8B0Dy.createElementVNode)("span", {
                                "class": "chat-message-typing-circle"
                            }),
                            (0, $8B0Dy.createElementVNode)("span", {
                                "class": "chat-message-typing-circle"
                            }),
                            (0, $8B0Dy.createElementVNode)("span", {
                                "class": "chat-message-typing-circle"
                            })
                        ], -1)
                    ]);
                }),
                _: 1
            }, 8, [
                "class"
            ]);
        };
    }
}), GZe = {
    key: 0,
    "class": "empty-container"
}, KZe = {
    "class": "empty",
    "data-test-id": "chat-messages-empty"
}, XZe = {
    key: 1,
    "class": "chat-messages-list"
}, YZe = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    __name: "MessagesList",
    props: {
        messages: {},
        emptyText: {}
    },
    setup: function(e) {
        var t = Yc(), n = (0, $5wB2C.ref)([]), r = t.initialMessages, s = t.waitingForResponse;
        return (0, $5wB2C.watch)(function() {
            return n.value.length;
        }, function() {
            var o = n.value[n.value.length - 1];
            o && o.scrollToView();
        }), function(o, i) {
            return o.emptyText && (0, $5wB2C.unref)(r).length === 0 && o.messages.length === 0 ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", GZe, [
                (0, $8B0Dy.createElementVNode)("div", KZe, [
                    (0, $8B0Dy.createVNode)((0, $5wB2C.unref)(Sl), {
                        icon: "message-circle",
                        size: "large",
                        "class": "emptyIcon"
                    }),
                    (0, $8B0Dy.createVNode)((0, $5wB2C.unref)(nm), {
                        tag: "p",
                        size: "medium",
                        color: "text-base"
                    }, {
                        "default": (0, $8B0Dy.withCtx)(function() {
                            return [
                                (0, $8B0Dy.createTextVNode)((0, $3ZJCa.toDisplayString)(o.emptyText), 1)
                            ];
                        }),
                        _: 1
                    })
                ])
            ])) : ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("div", XZe, [
                ((0, $8B0Dy.openBlock)(!0), (0, $8B0Dy.createElementBlock)((0, $8B0Dy.Fragment), null, (0, $8B0Dy.renderList)((0, $5wB2C.unref)(r), function(a) {
                    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)(Wc, {
                        key: a.id,
                        message: a
                    }, null, 8, [
                        "message"
                    ]);
                }), 128)),
                ((0, $8B0Dy.openBlock)(!0), (0, $8B0Dy.createElementBlock)((0, $8B0Dy.Fragment), null, (0, $8B0Dy.renderList)(o.messages, function(a) {
                    return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)(Wc, {
                        key: a.id,
                        ref_for: !0,
                        ref_key: "messageComponents",
                        ref: n,
                        message: a
                    }, {
                        beforeMessage: (0, $8B0Dy.withCtx)(function(param) {
                            var c = param.message;
                            return [
                                (0, $8B0Dy.renderSlot)(o.$slots, "beforeMessage", (0, $8B0Dy.mergeProps)({
                                    ref_for: !0
                                }, {
                                    message: c
                                }))
                            ];
                        }),
                        _: 2
                    }, 1032, [
                        "message"
                    ]);
                }), 128)),
                (0, $5wB2C.unref)(s) ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)(WZe, {
                    key: 0
                })) : (0, $8B0Dy.createCommentVNode)("", !0)
            ]));
        };
    }
}), JZe = {
    "class": "chat-heading"
}, QZe = [
    "title"
], eWe = {
    key: 0
}, Qm = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    __name: "Chat",
    setup: function(e) {
        var t = as().t, n = Yc(), r = n.messages, s = n.currentSessionId, _co = co(), o = _co.options, i = (0, $5wB2C.computed)(function() {
            return o.mode === "window" && o.showWindowCloseButton;
        });
        function a() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
                return (0, $e0qXa.__generator)(this, function(_state) {
                    n.startNewSession && (n.startNewSession(), (0, $8B0Dy.nextTick)(function() {
                        _t.emit("scrollToBottom");
                    }));
                    return [
                        2
                    ];
                });
            })();
        }
        function c() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
                var _tmp;
                return (0, $e0qXa.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _tmp = n.loadPreviousSession;
                            if (!_tmp) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                n.loadPreviousSession()
                            ];
                        case 1:
                            _tmp = (_state.sent(), (0, $8B0Dy.nextTick)(function() {
                                _t.emit("scrollToBottom");
                            }));
                            _state.label = 2;
                        case 2:
                            _tmp;
                            return [
                                2
                            ];
                    }
                });
            })();
        }
        function u() {
            _t.emit("close");
        }
        return (0, $8B0Dy.onMounted)(function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $5VAZB._)(function() {
                var _tmp;
                return (0, $e0qXa.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                c()
                            ];
                        case 1:
                            _state.sent();
                            _tmp = !o.showWelcomeScreen && !s.value;
                            if (!_tmp) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                a()
                            ];
                        case 2:
                            _tmp = _state.sent();
                            _state.label = 3;
                        case 3:
                            _tmp;
                            return [
                                2
                            ];
                    }
                });
            })();
        }), function(d, l) {
            return (0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)(vb, {
                "class": "chat-wrapper"
            }, {
                header: (0, $8B0Dy.withCtx)(function() {
                    return [
                        (0, $8B0Dy.createElementVNode)("div", JZe, [
                            (0, $8B0Dy.createElementVNode)("h1", null, (0, $3ZJCa.toDisplayString)((0, $5wB2C.unref)(t)("title")), 1),
                            i.value ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("button", {
                                key: 0,
                                "class": "chat-close-button",
                                title: (0, $5wB2C.unref)(t)("closeButtonTooltip"),
                                onClick: u
                            }, [
                                (0, $8B0Dy.createVNode)((0, $5wB2C.unref)(p_), {
                                    height: "18",
                                    width: "18"
                                })
                            ], 8, QZe)) : (0, $8B0Dy.createCommentVNode)("", !0)
                        ]),
                        (0, $5wB2C.unref)(t)("subtitle") ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createElementBlock)("p", eWe, (0, $3ZJCa.toDisplayString)((0, $5wB2C.unref)(t)("subtitle")), 1)) : (0, $8B0Dy.createCommentVNode)("", !0)
                    ];
                }),
                footer: (0, $8B0Dy.withCtx)(function() {
                    return [
                        (0, $5wB2C.unref)(s) ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)(pb, {
                            key: 0
                        })) : ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)(E_, {
                            key: 1
                        }))
                    ];
                }),
                "default": (0, $8B0Dy.withCtx)(function() {
                    return [
                        !(0, $5wB2C.unref)(s) && (0, $5wB2C.unref)(o).showWelcomeScreen ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)(b_, {
                            key: 0,
                            "onClick:button": a
                        })) : ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)(YZe, {
                            key: 1,
                            messages: (0, $5wB2C.unref)(r)
                        }, null, 8, [
                            "messages"
                        ]))
                    ];
                }),
                _: 1
            });
        };
    }
}), tWe = /* @__PURE__ */ (0, $8B0Dy.defineComponent)({
    __name: "App",
    props: {},
    setup: function(e) {
        var _co = co(), t = _co.options, n = (0, $5wB2C.computed)(function() {
            return t.mode === "fullscreen";
        });
        return (0, $8B0Dy.onMounted)(function() {
            hn.registerLanguage("xml", Hp), hn.registerLanguage("javascript", Fp);
        }), function(r, s) {
            return n.value ? ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)(Qm, {
                key: 0,
                "class": "n8n-chat"
            })) : ((0, $8B0Dy.openBlock)(), (0, $8B0Dy.createBlock)(ZZe, {
                key: 1,
                "class": "n8n-chat"
            }));
        };
    }
});
function oWe(e) {
    var s, o;
    var _t_target;
    var t = (0, $bnFl0._)((0, $6869c._)({}, Pr, e), {
        webhookConfig: (0, $6869c._)({}, Pr.webhookConfig, e == null ? void 0 : e.webhookConfig),
        i18n: (0, $bnFl0._)((0, $6869c._)({}, Pr.i18n, e == null ? void 0 : e.i18n), {
            en: (0, $6869c._)({}, (s = Pr.i18n) == null ? void 0 : s.en, (o = e == null ? void 0 : e.i18n) == null ? void 0 : o.en)
        }),
        theme: (0, $6869c._)({}, Pr.theme, e == null ? void 0 : e.theme)
    }), n = (_t_target = t.target) !== null && _t_target !== void 0 ? _t_target : Tv;
    typeof n == "string" && Zv(n);
    var r = (0, $kRi7Z.createApp)(tWe);
    return r.use(o_, t), r.mount(n), r;
}

});
parcelRegister("5VAZB", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $450ef88efc590f7d$export$71511d61b312f219; });
function $450ef88efc590f7d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $450ef88efc590f7d$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $450ef88efc590f7d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $450ef88efc590f7d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("1mRNr", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0ff1935d21ae6733$export$71511d61b312f219; });

var $g3nWa = parcelRequire("g3nWa");

var $9fOWX = parcelRequire("9fOWX");

var $8kooB = parcelRequire("8kooB");
function $0ff1935d21ae6733$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $g3nWa._)(derived);
    return (0, $8kooB._)(_this, (0, $9fOWX._)() ? Reflect.construct(derived, args || [], (0, $g3nWa._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("g3nWa", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $baff7e953f6921a4$export$71511d61b312f219; });
function $baff7e953f6921a4$export$71511d61b312f219(o) {
    $baff7e953f6921a4$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $baff7e953f6921a4$export$71511d61b312f219(o);
}

});

parcelRegister("9fOWX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6bcd09612395ce00$export$71511d61b312f219; });
function $6bcd09612395ce00$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($6bcd09612395ce00$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("8kooB", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $61031d7ad42fef1a$export$71511d61b312f219; });

var $eksDr = parcelRequire("eksDr");

var $6gBIz = parcelRequire("6gBIz");
function $61031d7ad42fef1a$export$71511d61b312f219(self, call) {
    if (call && ((0, $6gBIz._)(call) === "object" || typeof call === "function")) return call;
    return (0, $eksDr._)(self);
}

});
parcelRegister("eksDr", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a6e9254da7786e6f$export$71511d61b312f219; });
function $a6e9254da7786e6f$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("1UdHD", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1635a67c9a8c784c$export$71511d61b312f219; });
function $1635a67c9a8c784c$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("iH1wO", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d9bd6d9be03bb318$export$71511d61b312f219; });
function $d9bd6d9be03bb318$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d9bd6d9be03bb318$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $d9bd6d9be03bb318$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d9bd6d9be03bb318$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("aRIHe", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7e91866236ec34ef$export$71511d61b312f219; });
function $7e91866236ec34ef$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("h4SHl", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c6ed3d50b3c0a9b3$export$71511d61b312f219; });

var $9Zaof = parcelRequire("9Zaof");
function $c6ed3d50b3c0a9b3$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $9Zaof._)(subClass, superClass);
}

});
parcelRegister("9Zaof", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7451ded1398097e5$export$71511d61b312f219; });
function $7451ded1398097e5$export$71511d61b312f219(o, p) {
    $7451ded1398097e5$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7451ded1398097e5$export$71511d61b312f219(o, p);
}

});


parcelRegister("6869c", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4768422a7d62ac7e$export$71511d61b312f219; });

var $aRIHe = parcelRequire("aRIHe");
function $4768422a7d62ac7e$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $aRIHe._)(target, key, source[key]);
        });
    }
    return target;
}

});

parcelRegister("bnFl0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8491e88195480bf0$export$71511d61b312f219; });
function $8491e88195480bf0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8491e88195480bf0$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $8491e88195480bf0$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("9tk0W", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6e5658ded36fdfdf$export$71511d61b312f219; });

var $br0w7 = parcelRequire("br0w7");

var $bzwpS = parcelRequire("bzwpS");

var $5Kp9W = parcelRequire("5Kp9W");

var $kEXzK = parcelRequire("kEXzK");
function $6e5658ded36fdfdf$export$71511d61b312f219(arr, i) {
    return (0, $br0w7._)(arr) || (0, $bzwpS._)(arr, i) || (0, $kEXzK._)(arr, i) || (0, $5Kp9W._)();
}

});
parcelRegister("br0w7", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $85329e03f5be7480$export$71511d61b312f219; });
function $85329e03f5be7480$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("bzwpS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $86cc1bc9743f6955$export$71511d61b312f219; });
function $86cc1bc9743f6955$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("5Kp9W", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $42f4c3b981515918$export$71511d61b312f219; });
function $42f4c3b981515918$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("kEXzK", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f0a5c1904674bc16$export$71511d61b312f219; });

var $aMSNy = parcelRequire("aMSNy");
function $f0a5c1904674bc16$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $aMSNy._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $aMSNy._)(o, minLen);
}

});
parcelRegister("aMSNy", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7da8e4db0fa7fb28$export$71511d61b312f219; });
function $7da8e4db0fa7fb28$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("kf9Kn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ebccc4e7bc73869e$export$71511d61b312f219; });

var $57JNW = parcelRequire("57JNW");

var $leUNC = parcelRequire("leUNC");

var $6qwmg = parcelRequire("6qwmg");

var $kEXzK = parcelRequire("kEXzK");
function $ebccc4e7bc73869e$export$71511d61b312f219(arr) {
    return (0, $57JNW._)(arr) || (0, $leUNC._)(arr) || (0, $kEXzK._)(arr) || (0, $6qwmg._)();
}

});
parcelRegister("57JNW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3bb12306f7554d45$export$71511d61b312f219; });

var $aMSNy = parcelRequire("aMSNy");
function $3bb12306f7554d45$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $aMSNy._)(arr);
}

});

parcelRegister("leUNC", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f766f6ed54a156ff$export$71511d61b312f219; });
function $f766f6ed54a156ff$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("6qwmg", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4ade456debc7b6c2$export$71511d61b312f219; });
function $4ade456debc7b6c2$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("gOgNZ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c3ce5a02443e0406$export$71511d61b312f219; });

var $1Z1DD = parcelRequire("1Z1DD");

var $g3nWa = parcelRequire("g3nWa");

var $cmF2q = parcelRequire("cmF2q");

var $9Zaof = parcelRequire("9Zaof");
function $c3ce5a02443e0406$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $c3ce5a02443e0406$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $cmF2q._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $1Z1DD._)(Class, arguments, (0, $g3nWa._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $9Zaof._)(Wrapper, Class);
    };
    return $c3ce5a02443e0406$export$71511d61b312f219(Class);
}

});
parcelRegister("1Z1DD", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $171cc249a2eb2aa3$export$71511d61b312f219; });

var $9fOWX = parcelRequire("9fOWX");

var $9Zaof = parcelRequire("9Zaof");
function $171cc249a2eb2aa3$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $9fOWX._)()) $171cc249a2eb2aa3$export$71511d61b312f219 = Reflect.construct;
    else $171cc249a2eb2aa3$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $9Zaof._)(instance, Class.prototype);
        return instance;
    };
    return $171cc249a2eb2aa3$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("cmF2q", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $90075f6a20ebcb63$export$71511d61b312f219; });
function $90075f6a20ebcb63$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("e0qXa", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $a325f921ee3b821f$export$67ebef60e6f28a6; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $6gBIz = parcelRequire("6gBIz");
var $a325f921ee3b821f$var$extendStatics = function extendStatics1(d, b) {
    $a325f921ee3b821f$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a325f921ee3b821f$var$extendStatics(d, b);
};
function $a325f921ee3b821f$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $a325f921ee3b821f$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a325f921ee3b821f$export$18ce0697a983be9b = function __assign1() {
    $a325f921ee3b821f$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a325f921ee3b821f$export$18ce0697a983be9b.apply(this, arguments);
};
function $a325f921ee3b821f$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a325f921ee3b821f$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $6gBIz._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a325f921ee3b821f$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a325f921ee3b821f$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $6gBIz._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $a325f921ee3b821f$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $a325f921ee3b821f$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $6gBIz._)(x)) === "symbol" ? x : "".concat(x);
}
function $a325f921ee3b821f$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $6gBIz._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $a325f921ee3b821f$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $6gBIz._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a325f921ee3b821f$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a325f921ee3b821f$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $a325f921ee3b821f$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $a325f921ee3b821f$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $a325f921ee3b821f$export$45d3717a4c69092e(o, m, p);
}
function $a325f921ee3b821f$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a325f921ee3b821f$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a325f921ee3b821f$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a325f921ee3b821f$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a325f921ee3b821f$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a325f921ee3b821f$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $a325f921ee3b821f$export$10c90e4f7922046c(v) {
    return this instanceof $a325f921ee3b821f$export$10c90e4f7922046c ? (this.v = v, this) : new $a325f921ee3b821f$export$10c90e4f7922046c(v);
}
function $a325f921ee3b821f$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a325f921ee3b821f$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a325f921ee3b821f$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a325f921ee3b821f$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $a325f921ee3b821f$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a325f921ee3b821f$export$19a8beecd37a4c45 === "function" ? $a325f921ee3b821f$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a325f921ee3b821f$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $a325f921ee3b821f$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $a325f921ee3b821f$var$ownKeys = function ownKeys1(o) {
    $a325f921ee3b821f$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $a325f921ee3b821f$var$ownKeys(o);
};
function $a325f921ee3b821f$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $a325f921ee3b821f$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $a325f921ee3b821f$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $a325f921ee3b821f$var$__setModuleDefault(result, mod);
    return result;
}
function $a325f921ee3b821f$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
}
function $a325f921ee3b821f$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $a325f921ee3b821f$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $a325f921ee3b821f$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $6gBIz._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $a325f921ee3b821f$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $6gBIz._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $a325f921ee3b821f$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $a325f921ee3b821f$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $a325f921ee3b821f$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $a325f921ee3b821f$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $a325f921ee3b821f$export$2e2bcd8739ae039 = {
    __extends: $a325f921ee3b821f$export$a8ba968b8961cb8a,
    __assign: $a325f921ee3b821f$export$18ce0697a983be9b,
    __rest: $a325f921ee3b821f$export$3c9a16f847548506,
    __decorate: $a325f921ee3b821f$export$29e00dfd3077644b,
    __param: $a325f921ee3b821f$export$d5ad3fd78186038f,
    __esDecorate: $a325f921ee3b821f$export$3a84e1ae4e97e9b0,
    __runInitializers: $a325f921ee3b821f$export$d831c04e792af3d,
    __propKey: $a325f921ee3b821f$export$6a2a36740a146cb8,
    __setFunctionName: $a325f921ee3b821f$export$d1a06452d3489bc7,
    __metadata: $a325f921ee3b821f$export$f1db080c865becb9,
    __awaiter: $a325f921ee3b821f$export$1050f835b63b671e,
    __generator: $a325f921ee3b821f$export$67ebef60e6f28a6,
    __createBinding: $a325f921ee3b821f$export$45d3717a4c69092e,
    __exportStar: $a325f921ee3b821f$export$f33643c0debef087,
    __values: $a325f921ee3b821f$export$19a8beecd37a4c45,
    __read: $a325f921ee3b821f$export$8d051b38c9118094,
    __spread: $a325f921ee3b821f$export$afc72e2116322959,
    __spreadArrays: $a325f921ee3b821f$export$6388937ca91ccae8,
    __spreadArray: $a325f921ee3b821f$export$1216008129fb82ed,
    __await: $a325f921ee3b821f$export$10c90e4f7922046c,
    __asyncGenerator: $a325f921ee3b821f$export$e427f37a30a4de9b,
    __asyncDelegator: $a325f921ee3b821f$export$bbd80228419bb833,
    __asyncValues: $a325f921ee3b821f$export$e3b29a3d6162315f,
    __makeTemplateObject: $a325f921ee3b821f$export$4fb47efe1390b86f,
    __importStar: $a325f921ee3b821f$export$c21735bcef00d192,
    __importDefault: $a325f921ee3b821f$export$da59b14a69baef04,
    __classPrivateFieldGet: $a325f921ee3b821f$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $a325f921ee3b821f$export$d40a35129aaff81f,
    __classPrivateFieldIn: $a325f921ee3b821f$export$81fdc39f203e4e04,
    __addDisposableResource: $a325f921ee3b821f$export$88ac25d8e944e405,
    __disposeResources: $a325f921ee3b821f$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $a325f921ee3b821f$export$889dfb5d17574b0b
};

});

parcelRegister("kTPvz", function(module, exports) {
$parcel$export(module.exports, "cloneVNode", function () { return (parcelRequire("8B0Dy")).cloneVNode; });
$parcel$export(module.exports, "Comment", function () { return (parcelRequire("8B0Dy")).Comment; });
$parcel$export(module.exports, "computed", function () { return (parcelRequire("8B0Dy")).computed; });
$parcel$export(module.exports, "createBlock", function () { return (parcelRequire("8B0Dy")).createBlock; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("8B0Dy")).createCommentVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("8B0Dy")).createElementBlock; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("8B0Dy")).createElementVNode; });
$parcel$export(module.exports, "createSlots", function () { return (parcelRequire("8B0Dy")).createSlots; });
$parcel$export(module.exports, "createStaticVNode", function () { return (parcelRequire("8B0Dy")).createStaticVNode; });
$parcel$export(module.exports, "createTextVNode", function () { return (parcelRequire("8B0Dy")).createTextVNode; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("8B0Dy")).createVNode; });
$parcel$export(module.exports, "defineComponent", function () { return (parcelRequire("8B0Dy")).defineComponent; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("8B0Dy")).Fragment; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("8B0Dy")).getCurrentInstance; });
$parcel$export(module.exports, "guardReactiveProps", function () { return (parcelRequire("8B0Dy")).guardReactiveProps; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("8B0Dy")).h; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("8B0Dy")).initCustomFormatter; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("8B0Dy")).inject; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("5wB2C")).isRef; });
$parcel$export(module.exports, "mergeDefaults", function () { return (parcelRequire("8B0Dy")).mergeDefaults; });
$parcel$export(module.exports, "mergeProps", function () { return (parcelRequire("8B0Dy")).mergeProps; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("8B0Dy")).nextTick; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("3ZJCa")).normalizeClass; });
$parcel$export(module.exports, "normalizeStyle", function () { return (parcelRequire("3ZJCa")).normalizeStyle; });
$parcel$export(module.exports, "onBeforeMount", function () { return (parcelRequire("8B0Dy")).onBeforeMount; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return (parcelRequire("8B0Dy")).onBeforeUnmount; });
$parcel$export(module.exports, "onDeactivated", function () { return (parcelRequire("8B0Dy")).onDeactivated; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("8B0Dy")).onMounted; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("8B0Dy")).onUnmounted; });
$parcel$export(module.exports, "onUpdated", function () { return (parcelRequire("8B0Dy")).onUpdated; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("8B0Dy")).openBlock; });
$parcel$export(module.exports, "popScopeId", function () { return (parcelRequire("8B0Dy")).popScopeId; });
$parcel$export(module.exports, "provide", function () { return (parcelRequire("8B0Dy")).provide; });
$parcel$export(module.exports, "pushScopeId", function () { return (parcelRequire("8B0Dy")).pushScopeId; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("5wB2C")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("5wB2C")).ref; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("8B0Dy")).renderList; });
$parcel$export(module.exports, "renderSlot", function () { return (parcelRequire("8B0Dy")).renderSlot; });
$parcel$export(module.exports, "resolveComponent", function () { return (parcelRequire("8B0Dy")).resolveComponent; });
$parcel$export(module.exports, "resolveDirective", function () { return (parcelRequire("8B0Dy")).resolveDirective; });
$parcel$export(module.exports, "resolveDynamicComponent", function () { return (parcelRequire("8B0Dy")).resolveDynamicComponent; });
$parcel$export(module.exports, "shallowRef", function () { return (parcelRequire("5wB2C")).shallowRef; });
$parcel$export(module.exports, "Teleport", function () { return (parcelRequire("8B0Dy")).Teleport; });
$parcel$export(module.exports, "Text", function () { return (parcelRequire("8B0Dy")).Text; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("5wB2C")).toRaw; });
$parcel$export(module.exports, "useAttrs", function () { return (parcelRequire("8B0Dy")).useAttrs; });
$parcel$export(module.exports, "useSlots", function () { return (parcelRequire("8B0Dy")).useSlots; });
$parcel$export(module.exports, "warn", function () { return (parcelRequire("8B0Dy")).warn; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("8B0Dy")).watch; });
$parcel$export(module.exports, "watchEffect", function () { return (parcelRequire("8B0Dy")).watchEffect; });
$parcel$export(module.exports, "withCtx", function () { return (parcelRequire("8B0Dy")).withCtx; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("8B0Dy")).withDirectives; });
$parcel$export(module.exports, "createApp", function () { return (parcelRequire("kRi7Z")).createApp; });
$parcel$export(module.exports, "Transition", function () { return (parcelRequire("kRi7Z")).Transition; });
$parcel$export(module.exports, "useCssModule", function () { return (parcelRequire("kRi7Z")).useCssModule; });
$parcel$export(module.exports, "vModelText", function () { return (parcelRequire("kRi7Z")).vModelText; });
$parcel$export(module.exports, "vShow", function () { return (parcelRequire("kRi7Z")).vShow; });
$parcel$export(module.exports, "withKeys", function () { return (parcelRequire("kRi7Z")).withKeys; });
$parcel$export(module.exports, "withModifiers", function () { return (parcelRequire("kRi7Z")).withModifiers; });
$parcel$export(module.exports, "normalizeProps", function () { return (parcelRequire("3ZJCa")).normalizeProps; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("3ZJCa")).toDisplayString; });
/**
* vue v3.5.22
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $8B0Dy = parcelRequire("8B0Dy");parcelRequire("kRi7Z");
var $5wB2C = parcelRequire("5wB2C");parcelRequire("3ZJCa");
function $f370e62d42e548fe$var$initDev() {
    (0, $8B0Dy.initCustomFormatter)();
}
var $f370e62d42e548fe$export$ef7acd7185315e22 = function() {};
$parcel$exportWildcard(module.exports, $5wB2C);

});
parcelRegister("8B0Dy", function(module, exports) {

$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return $642245f23a3b0f5d$export$dae85862a8d94378; });
$parcel$export(module.exports, "nextTick", function () { return $642245f23a3b0f5d$export$bdd553fddd433dcb; });
$parcel$export(module.exports, "queuePostFlushCb", function () { return $642245f23a3b0f5d$export$59536a0199721cab; });
$parcel$export(module.exports, "Fragment", function () { return $642245f23a3b0f5d$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Text", function () { return $642245f23a3b0f5d$export$5f1af8db9871e1d6; });
$parcel$export(module.exports, "Comment", function () { return $642245f23a3b0f5d$export$4d299b491347818a; });
$parcel$export(module.exports, "Static", function () { return $642245f23a3b0f5d$export$c1b9a1d3af45b7b6; });
$parcel$export(module.exports, "pushScopeId", function () { return $642245f23a3b0f5d$export$ac020265ca2cc4cd; });
$parcel$export(module.exports, "popScopeId", function () { return $642245f23a3b0f5d$export$f2dc6805dc11834e; });
$parcel$export(module.exports, "withCtx", function () { return $642245f23a3b0f5d$export$694b237e827a3d23; });
$parcel$export(module.exports, "withDirectives", function () { return $642245f23a3b0f5d$export$49729353e7c1e6c5; });
$parcel$export(module.exports, "Teleport", function () { return $642245f23a3b0f5d$export$76d55a0304a371f4; });
$parcel$export(module.exports, "useTransitionState", function () { return $642245f23a3b0f5d$export$d2a0a1bc267c90f6; });
$parcel$export(module.exports, "onMounted", function () { return $642245f23a3b0f5d$export$6d1641039221b5cb; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return $642245f23a3b0f5d$export$40c420df62d2614; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return $642245f23a3b0f5d$export$b876c99684f8cf3b; });
$parcel$export(module.exports, "getCurrentInstance", function () { return $642245f23a3b0f5d$export$f13e630aa3915748; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return $642245f23a3b0f5d$export$a67f9b1229c7c97a; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return $642245f23a3b0f5d$export$76ac1779589cd824; });
$parcel$export(module.exports, "setTransitionHooks", function () { return $642245f23a3b0f5d$export$7770a22486565649; });
$parcel$export(module.exports, "BaseTransition", function () { return $642245f23a3b0f5d$export$abd95b5f5e8a8837; });
$parcel$export(module.exports, "cloneVNode", function () { return $642245f23a3b0f5d$export$ee4f9e12c0a92a1a; });
$parcel$export(module.exports, "defineComponent", function () { return $642245f23a3b0f5d$export$afa64b67e5a01c3b; });
$parcel$export(module.exports, "createVNode", function () { return $642245f23a3b0f5d$export$bf5c4cf060303d58; });
$parcel$export(module.exports, "createTextVNode", function () { return $642245f23a3b0f5d$export$22f9b5ffd89dac9; });
$parcel$export(module.exports, "watch", function () { return $642245f23a3b0f5d$export$3db5d71bdb2d5499; });
$parcel$export(module.exports, "onUpdated", function () { return $642245f23a3b0f5d$export$5876c47052fb88b1; });
$parcel$export(module.exports, "onDeactivated", function () { return $642245f23a3b0f5d$export$bf1440eeaf5fa709; });
$parcel$export(module.exports, "onUnmounted", function () { return $642245f23a3b0f5d$export$13348a43ccacfe58; });
$parcel$export(module.exports, "onBeforeMount", function () { return $642245f23a3b0f5d$export$23b7aeb0d671f804; });
$parcel$export(module.exports, "onBeforeUpdate", function () { return $642245f23a3b0f5d$export$ab91988a13872e4c; });
$parcel$export(module.exports, "resolveComponent", function () { return $642245f23a3b0f5d$export$681d65eec9d1d1e8; });
$parcel$export(module.exports, "resolveDynamicComponent", function () { return $642245f23a3b0f5d$export$b44c564a05ca975; });
$parcel$export(module.exports, "resolveDirective", function () { return $642245f23a3b0f5d$export$a1989e995cd481be; });
$parcel$export(module.exports, "renderList", function () { return $642245f23a3b0f5d$export$4bf387f59bfc6d67; });
$parcel$export(module.exports, "createSlots", function () { return $642245f23a3b0f5d$export$85738f8fcd0a5430; });
$parcel$export(module.exports, "renderSlot", function () { return $642245f23a3b0f5d$export$4abee4c34694ada1; });
$parcel$export(module.exports, "openBlock", function () { return $642245f23a3b0f5d$export$e7eaa45e502fe5cc; });
$parcel$export(module.exports, "createBlock", function () { return $642245f23a3b0f5d$export$9f2dfe8048dfb22b; });
$parcel$export(module.exports, "useSlots", function () { return $642245f23a3b0f5d$export$9203a8e84125433c; });
$parcel$export(module.exports, "useAttrs", function () { return $642245f23a3b0f5d$export$75e29435042cd2ea; });
$parcel$export(module.exports, "mergeDefaults", function () { return $642245f23a3b0f5d$export$ec60f47d4a8a2e7f; });
$parcel$export(module.exports, "computed", function () { return $642245f23a3b0f5d$export$2983e091f1a1e8e2; });
$parcel$export(module.exports, "provide", function () { return $642245f23a3b0f5d$export$abe1e183e22e10ad; });
$parcel$export(module.exports, "inject", function () { return $642245f23a3b0f5d$export$a976684a0efeb93f; });
$parcel$export(module.exports, "createRenderer", function () { return $642245f23a3b0f5d$export$53ae2f996c64e9a; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return $642245f23a3b0f5d$export$200524cf0d997ff0; });
$parcel$export(module.exports, "watchEffect", function () { return $642245f23a3b0f5d$export$ede35fc0e5500309; });
$parcel$export(module.exports, "createElementBlock", function () { return $642245f23a3b0f5d$export$167055419fc69ec1; });
$parcel$export(module.exports, "createElementVNode", function () { return $642245f23a3b0f5d$export$42098e0eaa15c48e; });
$parcel$export(module.exports, "guardReactiveProps", function () { return $642245f23a3b0f5d$export$1f1be0e0e384d7d2; });
$parcel$export(module.exports, "mergeProps", function () { return $642245f23a3b0f5d$export$9d1611c77c2fe928; });
$parcel$export(module.exports, "createStaticVNode", function () { return $642245f23a3b0f5d$export$33a9f6dd2840e6bb; });
$parcel$export(module.exports, "createCommentVNode", function () { return $642245f23a3b0f5d$export$49553837c7236d3c; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return $642245f23a3b0f5d$export$c93a9c496c5211fa; });
$parcel$export(module.exports, "h", function () { return $642245f23a3b0f5d$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "initCustomFormatter", function () { return $642245f23a3b0f5d$export$aed4979be6a60047; });
$parcel$export(module.exports, "warn", function () { return $642245f23a3b0f5d$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("5wB2C")).isRef; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("5wB2C")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("5wB2C")).ref; });
$parcel$export(module.exports, "shallowRef", function () { return (parcelRequire("5wB2C")).shallowRef; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("5wB2C")).toRaw; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("3ZJCa")).camelize; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("3ZJCa")).normalizeClass; });
$parcel$export(module.exports, "normalizeStyle", function () { return (parcelRequire("3ZJCa")).normalizeStyle; });
/**
* @vue/runtime-core v3.5.22
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $aRIHe = parcelRequire("aRIHe");

var $9tk0W = parcelRequire("9tk0W");

var $kf9Kn = parcelRequire("kf9Kn");

var $6gBIz = parcelRequire("6gBIz");

var $5wB2C = parcelRequire("5wB2C");

var $3ZJCa = parcelRequire("3ZJCa");
var $642245f23a3b0f5d$var$stack = [];
function $642245f23a3b0f5d$var$pushWarningContext(vnode) {
    $642245f23a3b0f5d$var$stack.push(vnode);
}
function $642245f23a3b0f5d$var$popWarningContext() {
    $642245f23a3b0f5d$var$stack.pop();
}
var $642245f23a3b0f5d$var$isWarning = false;
function $642245f23a3b0f5d$var$warn$1(msg) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    if ($642245f23a3b0f5d$var$isWarning) return;
    $642245f23a3b0f5d$var$isWarning = true;
    (0, $5wB2C.pauseTracking)();
    var instance = $642245f23a3b0f5d$var$stack.length ? $642245f23a3b0f5d$var$stack[$642245f23a3b0f5d$var$stack.length - 1].component : null;
    var appWarnHandler = instance && instance.appContext.config.warnHandler;
    var trace = $642245f23a3b0f5d$var$getComponentTrace();
    if (appWarnHandler) $642245f23a3b0f5d$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map(function(a) {
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(function(param) {
            var vnode = param.vnode;
            return "at <".concat($642245f23a3b0f5d$var$formatComponentName(instance, vnode.type), ">");
        }).join("\n"),
        trace
    ]);
    else {
        var _warnArgs, _console;
        var warnArgs = [
            "[Vue warn]: ".concat(msg)
        ].concat((0, $kf9Kn._)(args));
        if (trace.length && // avoid spamming console during tests
        true) (_warnArgs = warnArgs).push.apply(_warnArgs, [
            "\n"
        ].concat((0, $kf9Kn._)($642245f23a3b0f5d$var$formatTrace(trace))));
        (_console = console).warn.apply(_console, (0, $kf9Kn._)(warnArgs));
    }
    (0, $5wB2C.resetTracking)();
    $642245f23a3b0f5d$var$isWarning = false;
}
function $642245f23a3b0f5d$var$getComponentTrace() {
    var currentVNode = $642245f23a3b0f5d$var$stack[$642245f23a3b0f5d$var$stack.length - 1];
    if (!currentVNode) return [];
    var normalizedStack = [];
    while(currentVNode){
        var last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        var parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $642245f23a3b0f5d$var$formatTrace(trace) {
    var logs = [];
    trace.forEach(function(entry, i) {
        var _logs;
        (_logs = logs).push.apply(_logs, (0, $kf9Kn._)(i === 0 ? [] : [
            "\n"
        ]).concat((0, $kf9Kn._)($642245f23a3b0f5d$var$formatTraceEntry(entry))));
    });
    return logs;
}
function $642245f23a3b0f5d$var$formatTraceEntry(param) {
    var vnode = param.vnode, recurseCount = param.recurseCount;
    var postfix = recurseCount > 0 ? "... (".concat(recurseCount, " recursive calls)") : "";
    var isRoot = vnode.component ? vnode.component.parent == null : false;
    var open = " at <".concat($642245f23a3b0f5d$var$formatComponentName(vnode.component, vnode.type, isRoot));
    var close = ">" + postfix;
    return vnode.props ? [
        open
    ].concat((0, $kf9Kn._)($642245f23a3b0f5d$var$formatProps(vnode.props)), [
        close
    ]) : [
        open + close
    ];
}
function $642245f23a3b0f5d$var$formatProps(props) {
    var res = [];
    var keys = Object.keys(props);
    keys.slice(0, 3).forEach(function(key) {
        var _res;
        (_res = res).push.apply(_res, (0, $kf9Kn._)($642245f23a3b0f5d$var$formatProp(key, props[key])));
    });
    if (keys.length > 3) res.push(" ...");
    return res;
}
function $642245f23a3b0f5d$var$formatProp(key, value, raw) {
    if ((0, $3ZJCa.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            "".concat(key, "=").concat(value)
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        "".concat(key, "=").concat(value)
    ];
    else if ((0, $5wB2C.isRef)(value)) {
        value = $642245f23a3b0f5d$var$formatProp(key, (0, $5wB2C.toRaw)(value.value), true);
        return raw ? value : [
            "".concat(key, "=Ref<"),
            value,
            ">"
        ];
    } else if ((0, $3ZJCa.isFunction)(value)) return [
        "".concat(key, "=fn").concat(value.name ? "<".concat(value.name, ">") : "")
    ];
    else {
        value = (0, $5wB2C.toRaw)(value);
        return raw ? value : [
            "".concat(key, "="),
            value
        ];
    }
}
function $642245f23a3b0f5d$export$dfbcecb440255e4a(val, type) {
    return;
}
var $642245f23a3b0f5d$export$10e8e1cf990558d7 = {
    SETUP_FUNCTION: 0,
    "0": "SETUP_FUNCTION",
    RENDER_FUNCTION: 1,
    "1": "RENDER_FUNCTION",
    NATIVE_EVENT_HANDLER: 5,
    "5": "NATIVE_EVENT_HANDLER",
    COMPONENT_EVENT_HANDLER: 6,
    "6": "COMPONENT_EVENT_HANDLER",
    VNODE_HOOK: 7,
    "7": "VNODE_HOOK",
    DIRECTIVE_HOOK: 8,
    "8": "DIRECTIVE_HOOK",
    TRANSITION_HOOK: 9,
    "9": "TRANSITION_HOOK",
    APP_ERROR_HANDLER: 10,
    "10": "APP_ERROR_HANDLER",
    APP_WARN_HANDLER: 11,
    "11": "APP_WARN_HANDLER",
    FUNCTION_REF: 12,
    "12": "FUNCTION_REF",
    ASYNC_COMPONENT_LOADER: 13,
    "13": "ASYNC_COMPONENT_LOADER",
    SCHEDULER: 14,
    "14": "SCHEDULER",
    COMPONENT_UPDATE: 15,
    "15": "COMPONENT_UPDATE",
    APP_UNMOUNT_CLEANUP: 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
var $642245f23a3b0f5d$var$_obj;
var $642245f23a3b0f5d$var$ErrorTypeStrings$1 = ($642245f23a3b0f5d$var$_obj = {}, (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, "sp", "serverPrefetch hook"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, "bc", "beforeCreate hook"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, "c", "created hook"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, "bm", "beforeMount hook"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, "m", "mounted hook"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, "bu", "beforeUpdate hook"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, "u", "updated"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, "bum", "beforeUnmount hook"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, "um", "unmounted hook"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, "a", "activated hook"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, "da", "deactivated hook"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, "ec", "errorCaptured hook"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, "rtc", "renderTracked hook"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, "rtg", "renderTriggered hook"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, 0, "setup function"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, 1, "render function"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, 2, "watcher getter"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, 3, "watcher callback"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, 4, "watcher cleanup function"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, 5, "native event handler"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, 6, "component event handler"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, 7, "vnode hook"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, 8, "directive hook"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, 9, "transition hook"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, 10, "app errorHandler"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, 11, "app warnHandler"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, 12, "ref function"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, 13, "async component loader"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, 14, "scheduler flush"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, 15, "component update"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj, 16, "app unmount cleanup function"), $642245f23a3b0f5d$var$_obj);
function $642245f23a3b0f5d$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn.apply(void 0, (0, $kf9Kn._)(args)) : fn();
    } catch (err) {
        $642245f23a3b0f5d$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $642245f23a3b0f5d$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $3ZJCa.isFunction)(fn)) {
        var res = $642245f23a3b0f5d$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $3ZJCa.isPromise)(res)) res["catch"](function(err) {
            $642245f23a3b0f5d$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $3ZJCa.isArray)(fn)) {
        var values = [];
        for(var i = 0; i < fn.length; i++)values.push($642245f23a3b0f5d$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $642245f23a3b0f5d$export$d3da1ecaf1206c58(err, instance, type) {
    var throwInDev = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    var contextVNode = instance ? instance.vnode : null;
    var _ref = instance && instance.appContext.config || (0, $3ZJCa.EMPTY_OBJ), errorHandler = _ref.errorHandler, throwUnhandledErrorInProduction = _ref.throwUnhandledErrorInProduction;
    if (instance) {
        var cur = instance.parent;
        var exposedInstance = instance.proxy;
        var errorInfo = "https://vuejs.org/error-reference/#runtime-".concat(type);
        while(cur){
            var errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(var i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            (0, $5wB2C.pauseTracking)();
            $642245f23a3b0f5d$export$b22fcaf88446e9bf(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $5wB2C.resetTracking)();
            return;
        }
    }
    $642245f23a3b0f5d$var$logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function $642245f23a3b0f5d$var$logError(err, type, contextVNode) {
    var throwInDev = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, throwInProd = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    if (throwInProd) throw err;
    else console.error(err);
}
var $642245f23a3b0f5d$var$queue = [];
var $642245f23a3b0f5d$var$flushIndex = -1;
var $642245f23a3b0f5d$var$pendingPostFlushCbs = [];
var $642245f23a3b0f5d$var$activePostFlushCbs = null;
var $642245f23a3b0f5d$var$postFlushIndex = 0;
var $642245f23a3b0f5d$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
var $642245f23a3b0f5d$var$currentFlushPromise = null;
var $642245f23a3b0f5d$var$RECURSION_LIMIT = 100;
function $642245f23a3b0f5d$export$bdd553fddd433dcb(fn) {
    var p = $642245f23a3b0f5d$var$currentFlushPromise || $642245f23a3b0f5d$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $642245f23a3b0f5d$var$findInsertionIndex(id) {
    var start = $642245f23a3b0f5d$var$flushIndex + 1;
    var end = $642245f23a3b0f5d$var$queue.length;
    while(start < end){
        var middle = start + end >>> 1;
        var middleJob = $642245f23a3b0f5d$var$queue[middle];
        var middleJobId = $642245f23a3b0f5d$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $642245f23a3b0f5d$var$queueJob(job) {
    if (!(job.flags & 1)) {
        var jobId = $642245f23a3b0f5d$var$getId(job);
        var lastJob = $642245f23a3b0f5d$var$queue[$642245f23a3b0f5d$var$queue.length - 1];
        if (!lastJob || // fast path when the job id is larger than the tail
        !(job.flags & 2) && jobId >= $642245f23a3b0f5d$var$getId(lastJob)) $642245f23a3b0f5d$var$queue.push(job);
        else $642245f23a3b0f5d$var$queue.splice($642245f23a3b0f5d$var$findInsertionIndex(jobId), 0, job);
        job.flags |= 1;
        $642245f23a3b0f5d$var$queueFlush();
    }
}
function $642245f23a3b0f5d$var$queueFlush() {
    if (!$642245f23a3b0f5d$var$currentFlushPromise) $642245f23a3b0f5d$var$currentFlushPromise = $642245f23a3b0f5d$var$resolvedPromise.then($642245f23a3b0f5d$var$flushJobs);
}
function $642245f23a3b0f5d$export$59536a0199721cab(cb) {
    var _pendingPostFlushCbs;
    if (!(0, $3ZJCa.isArray)(cb)) {
        if ($642245f23a3b0f5d$var$activePostFlushCbs && cb.id === -1) $642245f23a3b0f5d$var$activePostFlushCbs.splice($642245f23a3b0f5d$var$postFlushIndex + 1, 0, cb);
        else if (!(cb.flags & 1)) {
            $642245f23a3b0f5d$var$pendingPostFlushCbs.push(cb);
            cb.flags |= 1;
        }
    } else (_pendingPostFlushCbs = $642245f23a3b0f5d$var$pendingPostFlushCbs).push.apply(_pendingPostFlushCbs, (0, $kf9Kn._)(cb));
    $642245f23a3b0f5d$var$queueFlush();
}
function $642245f23a3b0f5d$var$flushPreFlushCbs(instance, seen) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $642245f23a3b0f5d$var$flushIndex + 1;
    for(; i < $642245f23a3b0f5d$var$queue.length; i++){
        var cb = $642245f23a3b0f5d$var$queue[i];
        if (cb && cb.flags & 2) {
            if (instance && cb.id !== instance.uid) continue;
            $642245f23a3b0f5d$var$queue.splice(i, 1);
            i--;
            if (cb.flags & 4) cb.flags &= -2;
            cb();
            if (!(cb.flags & 4)) cb.flags &= -2;
        }
    }
}
function $642245f23a3b0f5d$var$flushPostFlushCbs(seen) {
    if ($642245f23a3b0f5d$var$pendingPostFlushCbs.length) {
        var deduped = (0, $kf9Kn._)(new Set($642245f23a3b0f5d$var$pendingPostFlushCbs)).sort(function(a, b) {
            return $642245f23a3b0f5d$var$getId(a) - $642245f23a3b0f5d$var$getId(b);
        });
        $642245f23a3b0f5d$var$pendingPostFlushCbs.length = 0;
        if ($642245f23a3b0f5d$var$activePostFlushCbs) {
            var _activePostFlushCbs;
            (_activePostFlushCbs = $642245f23a3b0f5d$var$activePostFlushCbs).push.apply(_activePostFlushCbs, (0, $kf9Kn._)(deduped));
            return;
        }
        $642245f23a3b0f5d$var$activePostFlushCbs = deduped;
        for($642245f23a3b0f5d$var$postFlushIndex = 0; $642245f23a3b0f5d$var$postFlushIndex < $642245f23a3b0f5d$var$activePostFlushCbs.length; $642245f23a3b0f5d$var$postFlushIndex++){
            var cb = $642245f23a3b0f5d$var$activePostFlushCbs[$642245f23a3b0f5d$var$postFlushIndex];
            if (cb.flags & 4) cb.flags &= -2;
            if (!(cb.flags & 8)) cb();
            cb.flags &= -2;
        }
        $642245f23a3b0f5d$var$activePostFlushCbs = null;
        $642245f23a3b0f5d$var$postFlushIndex = 0;
    }
}
var $642245f23a3b0f5d$var$getId = function(job) {
    return job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
};
function $642245f23a3b0f5d$var$flushJobs(seen) {
    var check = (0, $3ZJCa.NOOP);
    try {
        for($642245f23a3b0f5d$var$flushIndex = 0; $642245f23a3b0f5d$var$flushIndex < $642245f23a3b0f5d$var$queue.length; $642245f23a3b0f5d$var$flushIndex++){
            var job = $642245f23a3b0f5d$var$queue[$642245f23a3b0f5d$var$flushIndex];
            if (job && !(job.flags & 8)) {
                if (job.flags & 4) job.flags &= -2;
                $642245f23a3b0f5d$export$b22fcaf88446e9bf(job, job.i, job.i ? 15 : 14);
                if (!(job.flags & 4)) job.flags &= -2;
            }
        }
    } finally{
        for(; $642245f23a3b0f5d$var$flushIndex < $642245f23a3b0f5d$var$queue.length; $642245f23a3b0f5d$var$flushIndex++){
            var job1 = $642245f23a3b0f5d$var$queue[$642245f23a3b0f5d$var$flushIndex];
            if (job1) job1.flags &= -2;
        }
        $642245f23a3b0f5d$var$flushIndex = -1;
        $642245f23a3b0f5d$var$queue.length = 0;
        $642245f23a3b0f5d$var$flushPostFlushCbs(seen);
        $642245f23a3b0f5d$var$currentFlushPromise = null;
        if ($642245f23a3b0f5d$var$queue.length || $642245f23a3b0f5d$var$pendingPostFlushCbs.length) $642245f23a3b0f5d$var$flushJobs(seen);
    }
}
function $642245f23a3b0f5d$var$checkRecursiveUpdates(seen, fn) {
    var count = seen.get(fn) || 0;
    if (count > $642245f23a3b0f5d$var$RECURSION_LIMIT) {
        var instance = fn.i;
        var componentName = instance && $642245f23a3b0f5d$var$getComponentName(instance.type);
        $642245f23a3b0f5d$export$d3da1ecaf1206c58("Maximum recursive updates exceeded".concat(componentName ? " in component <".concat(componentName, ">") : "", ". This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function."), null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
var $642245f23a3b0f5d$var$isHmrUpdating = false;
var $642245f23a3b0f5d$var$hmrDirtyComponents = /* @__PURE__ */ new Map();
var $642245f23a3b0f5d$var$map = /* @__PURE__ */ new Map();
function $642245f23a3b0f5d$var$registerHMR(instance) {
    var id = instance.type.__hmrId;
    var record = $642245f23a3b0f5d$var$map.get(id);
    if (!record) {
        $642245f23a3b0f5d$var$createRecord(id, instance.type);
        record = $642245f23a3b0f5d$var$map.get(id);
    }
    record.instances.add(instance);
}
function $642245f23a3b0f5d$var$unregisterHMR(instance) {
    $642245f23a3b0f5d$var$map.get(instance.type.__hmrId).instances["delete"](instance);
}
function $642245f23a3b0f5d$var$createRecord(id, initialDef) {
    if ($642245f23a3b0f5d$var$map.has(id)) return false;
    $642245f23a3b0f5d$var$map.set(id, {
        initialDef: $642245f23a3b0f5d$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $642245f23a3b0f5d$var$normalizeClassComponent(component) {
    return $642245f23a3b0f5d$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $642245f23a3b0f5d$var$rerender(id, newRender) {
    var record = $642245f23a3b0f5d$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    (0, $kf9Kn._)(record.instances).forEach(function(instance) {
        if (newRender) {
            instance.render = newRender;
            $642245f23a3b0f5d$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $642245f23a3b0f5d$var$isHmrUpdating = true;
        if (!(instance.job.flags & 8)) instance.update();
        $642245f23a3b0f5d$var$isHmrUpdating = false;
    });
}
function $642245f23a3b0f5d$var$reload(id, newComp) {
    var _loop = function(i) {
        var instance = instances[i];
        var oldComp = $642245f23a3b0f5d$var$normalizeClassComponent(instance.type);
        var dirtyInstances = $642245f23a3b0f5d$var$hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) $642245f23a3b0f5d$var$updateComponentDef(oldComp, newComp);
            $642245f23a3b0f5d$var$hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache["delete"](instance.type);
        instance.appContext.emitsCache["delete"](instance.type);
        instance.appContext.optionsCache["delete"](instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances["delete"](instance);
        } else if (instance.parent) $642245f23a3b0f5d$var$queueJob(function() {
            if (!(instance.job.flags & 8)) {
                $642245f23a3b0f5d$var$isHmrUpdating = true;
                instance.parent.update();
                $642245f23a3b0f5d$var$isHmrUpdating = false;
                dirtyInstances["delete"](instance);
            }
        });
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
    };
    var record = $642245f23a3b0f5d$var$map.get(id);
    if (!record) return;
    newComp = $642245f23a3b0f5d$var$normalizeClassComponent(newComp);
    $642245f23a3b0f5d$var$updateComponentDef(record.initialDef, newComp);
    var instances = (0, $kf9Kn._)(record.instances);
    for(var i = 0; i < instances.length; i++)_loop(i);
    $642245f23a3b0f5d$export$59536a0199721cab(function() {
        $642245f23a3b0f5d$var$hmrDirtyComponents.clear();
    });
}
function $642245f23a3b0f5d$var$updateComponentDef(oldComp, newComp) {
    (0, $3ZJCa.extend)(oldComp, newComp);
    for(var key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $642245f23a3b0f5d$var$tryWrap(fn) {
    return function(id, arg) {
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn("[HMR] Something went wrong during Vue component hot-reload. Full reload required.");
        }
    };
}
var $642245f23a3b0f5d$var$devtools$1;
var $642245f23a3b0f5d$var$buffer = [];
var $642245f23a3b0f5d$var$devtoolsNotInstalled = false;
function $642245f23a3b0f5d$var$emit$1(event) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _devtools$1;
    if ($642245f23a3b0f5d$var$devtools$1) (_devtools$1 = $642245f23a3b0f5d$var$devtools$1).emit.apply(_devtools$1, [
        event
    ].concat((0, $kf9Kn._)(args)));
    else if (!$642245f23a3b0f5d$var$devtoolsNotInstalled) $642245f23a3b0f5d$var$buffer.push({
        event: event,
        args: args
    });
}
function $642245f23a3b0f5d$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $642245f23a3b0f5d$var$devtools$1 = hook;
    if ($642245f23a3b0f5d$var$devtools$1) {
        var _devtools$1;
        $642245f23a3b0f5d$var$devtools$1.enabled = true;
        $642245f23a3b0f5d$var$buffer.forEach(function(param) {
            var event = param.event, args = param.args;
            return (_devtools$1 = $642245f23a3b0f5d$var$devtools$1).emit.apply(_devtools$1, [
                event
            ].concat((0, $kf9Kn._)(args)));
        });
        $642245f23a3b0f5d$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        var replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push(function(newHook) {
            $642245f23a3b0f5d$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(function() {
            if (!$642245f23a3b0f5d$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $642245f23a3b0f5d$var$devtoolsNotInstalled = true;
                $642245f23a3b0f5d$var$buffer = [];
            }
        }, 3e3);
    } else {
        $642245f23a3b0f5d$var$devtoolsNotInstalled = true;
        $642245f23a3b0f5d$var$buffer = [];
    }
}
function $642245f23a3b0f5d$var$devtoolsInitApp(app, version) {
    $642245f23a3b0f5d$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $642245f23a3b0f5d$export$ffb0004e005737fa,
        Text: $642245f23a3b0f5d$export$5f1af8db9871e1d6,
        Comment: $642245f23a3b0f5d$export$4d299b491347818a,
        Static: $642245f23a3b0f5d$export$c1b9a1d3af45b7b6
    });
}
function $642245f23a3b0f5d$var$devtoolsUnmountApp(app) {
    $642245f23a3b0f5d$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
var $642245f23a3b0f5d$var$devtoolsComponentAdded = /* @__PURE__ */ $642245f23a3b0f5d$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
var $642245f23a3b0f5d$var$devtoolsComponentUpdated = /* @__PURE__ */ $642245f23a3b0f5d$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
var $642245f23a3b0f5d$var$_devtoolsComponentRemoved = /* @__PURE__ */ $642245f23a3b0f5d$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
var $642245f23a3b0f5d$var$devtoolsComponentRemoved = function(component) {
    if ($642245f23a3b0f5d$var$devtools$1 && typeof $642245f23a3b0f5d$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$642245f23a3b0f5d$var$devtools$1.cleanupBuffer(component)) $642245f23a3b0f5d$var$_devtoolsComponentRemoved(component);
};
// @__NO_SIDE_EFFECTS__
function $642245f23a3b0f5d$var$createDevtoolsComponentHook(hook) {
    return function(component) {
        $642245f23a3b0f5d$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
var $642245f23a3b0f5d$var$devtoolsPerfStart = /* @__PURE__ */ $642245f23a3b0f5d$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
var $642245f23a3b0f5d$var$devtoolsPerfEnd = /* @__PURE__ */ $642245f23a3b0f5d$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $642245f23a3b0f5d$var$createDevtoolsPerformanceHook(hook) {
    return function(component, type, time) {
        $642245f23a3b0f5d$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $642245f23a3b0f5d$var$devtoolsComponentEmit(component, event, params) {
    $642245f23a3b0f5d$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
var $642245f23a3b0f5d$var$currentRenderingInstance = null;
var $642245f23a3b0f5d$var$currentScopeId = null;
function $642245f23a3b0f5d$var$setCurrentRenderingInstance(instance) {
    var prev = $642245f23a3b0f5d$var$currentRenderingInstance;
    $642245f23a3b0f5d$var$currentRenderingInstance = instance;
    $642245f23a3b0f5d$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $642245f23a3b0f5d$export$ac020265ca2cc4cd(id) {
    $642245f23a3b0f5d$var$currentScopeId = id;
}
function $642245f23a3b0f5d$export$f2dc6805dc11834e() {
    $642245f23a3b0f5d$var$currentScopeId = null;
}
var $642245f23a3b0f5d$export$15ba313e13f3dd04 = function(_id) {
    return $642245f23a3b0f5d$export$694b237e827a3d23;
};
function $642245f23a3b0f5d$export$694b237e827a3d23(fn) {
    var ctx = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $642245f23a3b0f5d$var$currentRenderingInstance, isNonScopedSlot = arguments.length > 2 ? arguments[2] : void 0;
    if (!ctx) return fn;
    if (fn._n) return fn;
    var renderFnWithContext = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (renderFnWithContext._d) $642245f23a3b0f5d$export$c20bee82f26f1e27(-1);
        var prevInstance = $642245f23a3b0f5d$var$setCurrentRenderingInstance(ctx);
        var res;
        try {
            res = fn.apply(void 0, (0, $kf9Kn._)(args));
        } finally{
            $642245f23a3b0f5d$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $642245f23a3b0f5d$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $642245f23a3b0f5d$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function $642245f23a3b0f5d$var$validateDirectiveName(name) {
    if ((0, $3ZJCa.isBuiltInDirective)(name)) $642245f23a3b0f5d$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $642245f23a3b0f5d$export$49729353e7c1e6c5(vnode, directives) {
    if ($642245f23a3b0f5d$var$currentRenderingInstance === null) return vnode;
    var instance = $642245f23a3b0f5d$var$getComponentPublicInstance($642245f23a3b0f5d$var$currentRenderingInstance);
    var bindings = vnode.dirs || (vnode.dirs = []);
    for(var i = 0; i < directives.length; i++){
        var _directives_i = (0, $9tk0W._)(directives[i], 4), dir = _directives_i[0], value = _directives_i[1], arg = _directives_i[2], tmp = _directives_i[3], modifiers = tmp === void 0 ? (0, $3ZJCa.EMPTY_OBJ) : tmp;
        if (dir) {
            if ((0, $3ZJCa.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, $5wB2C.traverse)(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $642245f23a3b0f5d$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    var bindings = vnode.dirs;
    var oldBindings = prevVNode && prevVNode.dirs;
    for(var i = 0; i < bindings.length; i++){
        var binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        var hook = binding.dir[name];
        if (hook) {
            (0, $5wB2C.pauseTracking)();
            $642245f23a3b0f5d$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $5wB2C.resetTracking)();
        }
    }
}
var $642245f23a3b0f5d$var$TeleportEndKey = Symbol("_vte");
var $642245f23a3b0f5d$var$isTeleport = function(type) {
    return type.__isTeleport;
};
var $642245f23a3b0f5d$var$isTeleportDisabled = function(props) {
    return props && (props.disabled || props.disabled === "");
};
var $642245f23a3b0f5d$var$isTeleportDeferred = function(props) {
    return props && (props.defer || props.defer === "");
};
var $642245f23a3b0f5d$var$isTargetSVG = function(target) {
    return typeof SVGElement !== "undefined" && target instanceof SVGElement;
};
var $642245f23a3b0f5d$var$isTargetMathML = function(target) {
    return typeof MathMLElement === "function" && target instanceof MathMLElement;
};
var $642245f23a3b0f5d$var$resolveTarget = function(props, select) {
    var targetSelector = props && props.to;
    if ((0, $3ZJCa.isString)(targetSelector)) {
        if (!select) return null;
        else {
            var target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
var $642245f23a3b0f5d$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process: function(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        var mountChildren = internals.mc, patchChildren = internals.pc, patchBlockChildren = internals.pbc, _internals_o = internals.o, insert = _internals_o.insert, querySelector = _internals_o.querySelector, createText = _internals_o.createText, createComment = _internals_o.createComment;
        var disabled = $642245f23a3b0f5d$var$isTeleportDisabled(n2.props);
        var shapeFlag = n2.shapeFlag, children = n2.children, dynamicChildren = n2.dynamicChildren;
        if (n1 == null) {
            var placeholder = n2.el = createText("");
            var mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            var mount = function(container2, anchor2) {
                if (shapeFlag & 16) mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            };
            var mountToTarget = function() {
                var target = n2.target = $642245f23a3b0f5d$var$resolveTarget(n2.props, querySelector);
                var targetAnchor = $642245f23a3b0f5d$var$prepareAnchor(target, n2, createText, insert);
                if (target) {
                    if (namespace !== "svg" && $642245f23a3b0f5d$var$isTargetSVG(target)) namespace = "svg";
                    else if (namespace !== "mathml" && $642245f23a3b0f5d$var$isTargetMathML(target)) namespace = "mathml";
                    if (parentComponent && parentComponent.isCE) (parentComponent.ce._teleportTargets || (parentComponent.ce._teleportTargets = /* @__PURE__ */ new Set())).add(target);
                    if (!disabled) {
                        mount(target, targetAnchor);
                        $642245f23a3b0f5d$var$updateCssVars(n2, false);
                    }
                }
            };
            if (disabled) {
                mount(container, mainAnchor);
                $642245f23a3b0f5d$var$updateCssVars(n2, true);
            }
            if ($642245f23a3b0f5d$var$isTeleportDeferred(n2.props)) {
                n2.el.__isMounted = false;
                $642245f23a3b0f5d$var$queuePostRenderEffect(function() {
                    mountToTarget();
                    delete n2.el.__isMounted;
                }, parentSuspense);
            } else mountToTarget();
        } else {
            if ($642245f23a3b0f5d$var$isTeleportDeferred(n2.props) && n1.el.__isMounted === false) {
                $642245f23a3b0f5d$var$queuePostRenderEffect(function() {
                    $642245f23a3b0f5d$var$TeleportImpl.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                }, parentSuspense);
                return;
            }
            n2.el = n1.el;
            n2.targetStart = n1.targetStart;
            var mainAnchor1 = n2.anchor = n1.anchor;
            var target = n2.target = n1.target;
            var targetAnchor = n2.targetAnchor = n1.targetAnchor;
            var wasDisabled = $642245f23a3b0f5d$var$isTeleportDisabled(n1.props);
            var currentContainer = wasDisabled ? container : target;
            var currentAnchor = wasDisabled ? mainAnchor1 : targetAnchor;
            if (namespace === "svg" || $642245f23a3b0f5d$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $642245f23a3b0f5d$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $642245f23a3b0f5d$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $642245f23a3b0f5d$var$moveTeleport(n2, container, mainAnchor1, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    var nextTarget = n2.target = $642245f23a3b0f5d$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $642245f23a3b0f5d$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $642245f23a3b0f5d$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
            $642245f23a3b0f5d$var$updateCssVars(n2, disabled);
        }
    },
    remove: function(vnode, parentComponent, parentSuspense, param, doRemove) {
        var unmount = param.um, _param_o = param.o, hostRemove = _param_o.remove;
        var shapeFlag = vnode.shapeFlag, children = vnode.children, anchor = vnode.anchor, targetStart = vnode.targetStart, targetAnchor = vnode.targetAnchor, target = vnode.target, props = vnode.props;
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            var shouldRemove = doRemove || !$642245f23a3b0f5d$var$isTeleportDisabled(props);
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: $642245f23a3b0f5d$var$moveTeleport,
    hydrate: $642245f23a3b0f5d$var$hydrateTeleport
};
function $642245f23a3b0f5d$var$moveTeleport(vnode, container, parentAnchor, param) {
    var insert = param.o.insert, move = param.m, moveType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 2;
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    var el = vnode.el, anchor = vnode.anchor, shapeFlag = vnode.shapeFlag, children = vnode.children, props = vnode.props;
    var isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $642245f23a3b0f5d$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(var i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $642245f23a3b0f5d$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, param, hydrateChildren) {
    var _param_o = param.o, nextSibling = _param_o.nextSibling, parentNode = _param_o.parentNode, querySelector = _param_o.querySelector, insert = _param_o.insert, createText = _param_o.createText;
    function hydrateDisabledTeleport(node2, vnode2, targetStart, targetAnchor) {
        vnode2.anchor = hydrateChildren(nextSibling(node2), vnode2, parentNode(node2), parentComponent, parentSuspense, slotScopeIds, optimized);
        vnode2.targetStart = targetStart;
        vnode2.targetAnchor = targetAnchor;
    }
    var target = vnode.target = $642245f23a3b0f5d$var$resolveTarget(vnode.props, querySelector);
    var disabled = $642245f23a3b0f5d$var$isTeleportDisabled(vnode.props);
    if (target) {
        var targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) hydrateDisabledTeleport(node, vnode, targetNode, targetNode && nextSibling(targetNode));
            else {
                vnode.anchor = nextSibling(node);
                var targetAnchor = targetNode;
                while(targetAnchor){
                    if (targetAnchor && targetAnchor.nodeType === 8) {
                        if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                        else if (targetAnchor.data === "teleport anchor") {
                            vnode.targetAnchor = targetAnchor;
                            target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                            break;
                        }
                    }
                    targetAnchor = nextSibling(targetAnchor);
                }
                if (!vnode.targetAnchor) $642245f23a3b0f5d$var$prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $642245f23a3b0f5d$var$updateCssVars(vnode, disabled);
    } else if (disabled) {
        if (vnode.shapeFlag & 16) hydrateDisabledTeleport(node, vnode, node, nextSibling(node));
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
var $642245f23a3b0f5d$export$76d55a0304a371f4 = $642245f23a3b0f5d$var$TeleportImpl;
function $642245f23a3b0f5d$var$updateCssVars(vnode, isDisabled) {
    var ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        var node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function $642245f23a3b0f5d$var$prepareAnchor(target, vnode, createText, insert) {
    var targetStart = vnode.targetStart = createText("");
    var targetAnchor = vnode.targetAnchor = createText("");
    targetStart[$642245f23a3b0f5d$var$TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target);
        insert(targetAnchor, target);
    }
    return targetAnchor;
}
var $642245f23a3b0f5d$var$leaveCbKey = Symbol("_leaveCb");
var $642245f23a3b0f5d$var$enterCbKey = Symbol("_enterCb");
function $642245f23a3b0f5d$export$d2a0a1bc267c90f6() {
    var state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $642245f23a3b0f5d$export$6d1641039221b5cb(function() {
        state.isMounted = true;
    });
    $642245f23a3b0f5d$export$40c420df62d2614(function() {
        state.isUnmounting = true;
    });
    return state;
}
var $642245f23a3b0f5d$var$TransitionHookValidator = [
    Function,
    Array
];
var $642245f23a3b0f5d$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $642245f23a3b0f5d$var$TransitionHookValidator,
    onEnter: $642245f23a3b0f5d$var$TransitionHookValidator,
    onAfterEnter: $642245f23a3b0f5d$var$TransitionHookValidator,
    onEnterCancelled: $642245f23a3b0f5d$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $642245f23a3b0f5d$var$TransitionHookValidator,
    onLeave: $642245f23a3b0f5d$var$TransitionHookValidator,
    onAfterLeave: $642245f23a3b0f5d$var$TransitionHookValidator,
    onLeaveCancelled: $642245f23a3b0f5d$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $642245f23a3b0f5d$var$TransitionHookValidator,
    onAppear: $642245f23a3b0f5d$var$TransitionHookValidator,
    onAfterAppear: $642245f23a3b0f5d$var$TransitionHookValidator,
    onAppearCancelled: $642245f23a3b0f5d$var$TransitionHookValidator
};
var $642245f23a3b0f5d$var$recursiveGetSubtree = function(instance) {
    var subTree = instance.subTree;
    return subTree.component ? $642245f23a3b0f5d$var$recursiveGetSubtree(subTree.component) : subTree;
};
var $642245f23a3b0f5d$var$BaseTransitionImpl = {
    name: "BaseTransition",
    props: $642245f23a3b0f5d$export$b876c99684f8cf3b,
    setup: function(props, param) {
        var slots = param.slots;
        var instance = $642245f23a3b0f5d$export$f13e630aa3915748();
        var state = $642245f23a3b0f5d$export$d2a0a1bc267c90f6();
        return function() {
            var children = slots["default"] && $642245f23a3b0f5d$export$a67f9b1229c7c97a(slots["default"](), true);
            if (!children || !children.length) return;
            var child = $642245f23a3b0f5d$var$findNonCommentChild(children);
            var rawProps = (0, $5wB2C.toRaw)(props);
            var mode = rawProps.mode;
            if (state.isLeaving) return $642245f23a3b0f5d$var$emptyPlaceholder(child);
            var innerChild = $642245f23a3b0f5d$var$getInnerChild$1(child);
            if (!innerChild) return $642245f23a3b0f5d$var$emptyPlaceholder(child);
            var enterHooks = $642245f23a3b0f5d$export$76ac1779589cd824(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            function(hooks) {
                return enterHooks = hooks;
            });
            if (innerChild.type !== $642245f23a3b0f5d$export$4d299b491347818a) $642245f23a3b0f5d$export$7770a22486565649(innerChild, enterHooks);
            var oldInnerChild = instance.subTree && $642245f23a3b0f5d$var$getInnerChild$1(instance.subTree);
            if (oldInnerChild && oldInnerChild.type !== $642245f23a3b0f5d$export$4d299b491347818a && !$642245f23a3b0f5d$var$isSameVNodeType(oldInnerChild, innerChild) && $642245f23a3b0f5d$var$recursiveGetSubtree(instance).type !== $642245f23a3b0f5d$export$4d299b491347818a) {
                var leavingHooks = $642245f23a3b0f5d$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $642245f23a3b0f5d$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $642245f23a3b0f5d$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = function() {
                        state.isLeaving = false;
                        if (!(instance.job.flags & 8)) instance.update();
                        delete leavingHooks.afterLeave;
                        oldInnerChild = void 0;
                    };
                    return $642245f23a3b0f5d$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $642245f23a3b0f5d$export$4d299b491347818a) leavingHooks.delayLeave = function(el, earlyRemove, delayedLeave) {
                    var leavingVNodesCache = $642245f23a3b0f5d$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$642245f23a3b0f5d$var$leaveCbKey] = function() {
                        earlyRemove();
                        el[$642245f23a3b0f5d$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                    enterHooks.delayedLeave = function() {
                        delayedLeave();
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                };
                else oldInnerChild = void 0;
            } else if (oldInnerChild) oldInnerChild = void 0;
            return child;
        };
    }
};
function $642245f23a3b0f5d$var$findNonCommentChild(children) {
    var child = children[0];
    if (children.length > 1) {
        var hasFound = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var c = _step.value;
                if (c.type !== $642245f23a3b0f5d$export$4d299b491347818a) {
                    child = c;
                    hasFound = true;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return child;
}
var $642245f23a3b0f5d$export$abd95b5f5e8a8837 = $642245f23a3b0f5d$var$BaseTransitionImpl;
function $642245f23a3b0f5d$var$getLeavingNodesForType(state, vnode) {
    var leavingVNodes = state.leavingVNodes;
    var leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $642245f23a3b0f5d$export$76ac1779589cd824(vnode, props, state, instance, postClone) {
    var appear = props.appear, mode = props.mode, _props_persisted = props.persisted, persisted = _props_persisted === void 0 ? false : _props_persisted, onBeforeEnter = props.onBeforeEnter, onEnter = props.onEnter, onAfterEnter = props.onAfterEnter, onEnterCancelled = props.onEnterCancelled, onBeforeLeave = props.onBeforeLeave, onLeave = props.onLeave, onAfterLeave = props.onAfterLeave, onLeaveCancelled = props.onLeaveCancelled, onBeforeAppear = props.onBeforeAppear, onAppear = props.onAppear, onAfterAppear = props.onAfterAppear, onAppearCancelled = props.onAppearCancelled;
    var key = String(vnode.key);
    var leavingVNodesCache = $642245f23a3b0f5d$var$getLeavingNodesForType(state, vnode);
    var callHook = function(hook, args) {
        hook && $642245f23a3b0f5d$export$dae85862a8d94378(hook, instance, 9, args);
    };
    var callAsyncHook = function(hook, args) {
        var done = args[1];
        callHook(hook, args);
        if ((0, $3ZJCa.isArray)(hook)) {
            if (hook.every(function(hook2) {
                return hook2.length <= 1;
            })) done();
        } else if (hook.length <= 1) done();
    };
    var hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter: function(el) {
            var hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$642245f23a3b0f5d$var$leaveCbKey]) el[$642245f23a3b0f5d$var$leaveCbKey](true);
            var leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $642245f23a3b0f5d$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$642245f23a3b0f5d$var$leaveCbKey]) leavingVNode.el[$642245f23a3b0f5d$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter: function(el) {
            var hook = onEnter;
            var afterHook = onAfterEnter;
            var cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            var called = false;
            var done = el[$642245f23a3b0f5d$var$enterCbKey] = function(cancelled) {
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$642245f23a3b0f5d$var$enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave: function(el, remove) {
            var key2 = String(vnode.key);
            if (el[$642245f23a3b0f5d$var$enterCbKey]) el[$642245f23a3b0f5d$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            var called = false;
            var done = el[$642245f23a3b0f5d$var$leaveCbKey] = function(cancelled) {
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$642245f23a3b0f5d$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone: function(vnode2) {
            var hooks2 = $642245f23a3b0f5d$export$76ac1779589cd824(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function $642245f23a3b0f5d$var$emptyPlaceholder(vnode) {
    if ($642245f23a3b0f5d$var$isKeepAlive(vnode)) {
        vnode = $642245f23a3b0f5d$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $642245f23a3b0f5d$var$getInnerChild$1(vnode) {
    if (!$642245f23a3b0f5d$var$isKeepAlive(vnode)) {
        if ($642245f23a3b0f5d$var$isTeleport(vnode.type) && vnode.children) return $642245f23a3b0f5d$var$findNonCommentChild(vnode.children);
        return vnode;
    }
    if (vnode.component) return vnode.component.subTree;
    var shapeFlag = vnode.shapeFlag, children = vnode.children;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $3ZJCa.isFunction)(children["default"])) return children["default"]();
    }
}
function $642245f23a3b0f5d$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        $642245f23a3b0f5d$export$7770a22486565649(vnode.component.subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $642245f23a3b0f5d$export$a67f9b1229c7c97a(children) {
    var keepComment = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, parentKey = arguments.length > 2 ? arguments[2] : void 0;
    var ret = [];
    var keyedFragmentCount = 0;
    for(var i = 0; i < children.length; i++){
        var child = children[i];
        var key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $642245f23a3b0f5d$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($642245f23a3b0f5d$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $642245f23a3b0f5d$export$4d299b491347818a) ret.push(key != null ? $642245f23a3b0f5d$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(var i1 = 0; i1 < ret.length; i1++)ret[i1].patchFlag = -2;
    return ret;
}
// @__NO_SIDE_EFFECTS__
function $642245f23a3b0f5d$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $3ZJCa.isFunction)(options) ? // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ function() {
        return (0, $3ZJCa.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        });
    }() : options;
}
function $642245f23a3b0f5d$export$f680877a34711e37() {
    var i = $642245f23a3b0f5d$export$f13e630aa3915748();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    return "";
}
function $642245f23a3b0f5d$var$markAsyncBoundary(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
var $642245f23a3b0f5d$var$knownTemplateRefs = /* @__PURE__ */ new WeakSet();
function $642245f23a3b0f5d$export$83a5dbc1f35517ca(key) {
    var i = $642245f23a3b0f5d$export$f13e630aa3915748();
    var r = (0, $5wB2C.shallowRef)(null);
    if (i) {
        var refs = i.refs === (0, $3ZJCa.EMPTY_OBJ) ? i.refs = {} : i.refs;
        var desc;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: function() {
                return r.value;
            },
            set: function(val) {
                return r.value = val;
            }
        });
    }
    var ret = r;
    return ret;
}
var $642245f23a3b0f5d$var$pendingSetRefMap = /* @__PURE__ */ new WeakMap();
function $642245f23a3b0f5d$var$setRef(rawRef, oldRawRef, parentSuspense, vnode) {
    var isUnmount = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    if ((0, $3ZJCa.isArray)(rawRef)) {
        rawRef.forEach(function(r, i) {
            return $642245f23a3b0f5d$var$setRef(r, oldRawRef && ((0, $3ZJCa.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount);
        });
        return;
    }
    if ($642245f23a3b0f5d$var$isAsyncWrapper(vnode) && !isUnmount) {
        if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) $642245f23a3b0f5d$var$setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
        return;
    }
    var refValue = vnode.shapeFlag & 4 ? $642245f23a3b0f5d$var$getComponentPublicInstance(vnode.component) : vnode.el;
    var value = isUnmount ? null : refValue;
    var owner = rawRef.i, ref = rawRef.r;
    var oldRef = oldRawRef && oldRawRef.r;
    var refs = owner.refs === (0, $3ZJCa.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    var setupState = owner.setupState;
    var rawSetupState = (0, $5wB2C.toRaw)(setupState);
    var canSetSetupRef = setupState === (0, $3ZJCa.EMPTY_OBJ) ? (0, $3ZJCa.NO) : function(key) {
        return (0, $3ZJCa.hasOwn)(rawSetupState, key);
    };
    var canSetRef = function(ref2) {
        return true;
    };
    if (oldRef != null && oldRef !== ref) {
        $642245f23a3b0f5d$var$invalidatePendingSetRef(oldRawRef);
        if ((0, $3ZJCa.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, $5wB2C.isRef)(oldRef)) {
            if (canSetRef(oldRef)) oldRef.value = null;
            var oldRawRefAtom = oldRawRef;
            if (oldRawRefAtom.k) refs[oldRawRefAtom.k] = null;
        }
    }
    if ((0, $3ZJCa.isFunction)(ref)) $642245f23a3b0f5d$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        var _isString = (0, $3ZJCa.isString)(ref);
        var _isRef = (0, $5wB2C.isRef)(ref);
        if (_isString || _isRef) {
            var doSet = function() {
                if (rawRef.f) {
                    var existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : canSetRef(ref) || !rawRef.k ? ref.value : refs[rawRef.k];
                    if (isUnmount) (0, $3ZJCa.isArray)(existing) && (0, $3ZJCa.remove)(existing, refValue);
                    else {
                        if (!(0, $3ZJCa.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                            } else {
                                var newVal = [
                                    refValue
                                ];
                                if (canSetRef(ref)) ref.value = newVal;
                                if (rawRef.k) refs[rawRef.k] = newVal;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    if (canSetRef(ref)) ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                var job = function() {
                    doSet();
                    $642245f23a3b0f5d$var$pendingSetRefMap["delete"](rawRef);
                };
                job.id = -1;
                $642245f23a3b0f5d$var$pendingSetRefMap.set(rawRef, job);
                $642245f23a3b0f5d$var$queuePostRenderEffect(job, parentSuspense);
            } else {
                $642245f23a3b0f5d$var$invalidatePendingSetRef(rawRef);
                doSet();
            }
        }
    }
}
function $642245f23a3b0f5d$var$invalidatePendingSetRef(rawRef) {
    var pendingSetRef = $642245f23a3b0f5d$var$pendingSetRefMap.get(rawRef);
    if (pendingSetRef) {
        pendingSetRef.flags |= 8;
        $642245f23a3b0f5d$var$pendingSetRefMap["delete"](rawRef);
    }
}
var $642245f23a3b0f5d$var$hasLoggedMismatchError = false;
var $642245f23a3b0f5d$var$logMismatchError = function() {
    if ($642245f23a3b0f5d$var$hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    $642245f23a3b0f5d$var$hasLoggedMismatchError = true;
};
var $642245f23a3b0f5d$var$isSVGContainer = function(container) {
    return container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
};
var $642245f23a3b0f5d$var$isMathMLContainer = function(container) {
    return container.namespaceURI.includes("MathML");
};
var $642245f23a3b0f5d$var$getContainerType = function(container) {
    if (container.nodeType !== 1) return void 0;
    if ($642245f23a3b0f5d$var$isSVGContainer(container)) return "svg";
    if ($642245f23a3b0f5d$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
var $642245f23a3b0f5d$var$isComment = function(node) {
    return node.nodeType === 8;
};
function $642245f23a3b0f5d$var$createHydrationFunctions(rendererInternals) {
    var mountComponent = rendererInternals.mt, patch = rendererInternals.p, _rendererInternals_o = rendererInternals.o, patchProp = _rendererInternals_o.patchProp, createText = _rendererInternals_o.createText, nextSibling = _rendererInternals_o.nextSibling, parentNode = _rendererInternals_o.parentNode, remove = _rendererInternals_o.remove, insert = _rendererInternals_o.insert, createComment = _rendererInternals_o.createComment;
    var hydrate = function(vnode, container) {
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $642245f23a3b0f5d$var$warn$1("Attempting to hydrate existing markup but container is empty. Performing full mount instead.");
            patch(null, vnode, container);
            $642245f23a3b0f5d$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        $642245f23a3b0f5d$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    var hydrateNode = function(node, vnode, parentComponent, parentSuspense, slotScopeIds) {
        var optimized = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
        optimized = optimized || !!vnode.dynamicChildren;
        var isFragmentStart = $642245f23a3b0f5d$var$isComment(node) && node.data === "[";
        var onMismatch = function() {
            return handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        };
        var type = vnode.type, ref = vnode.ref, shapeFlag = vnode.shapeFlag, patchFlag = vnode.patchFlag;
        var domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $3ZJCa.def)(node, "__vnode", vnode, true);
            (0, $3ZJCa.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        var nextNode = null;
        switch(type){
            case $642245f23a3b0f5d$export$5f1af8db9871e1d6:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $642245f23a3b0f5d$var$warn$1("Hydration text mismatch in", node.parentNode, "\n  - rendered on server: ".concat(JSON.stringify(node.data), "\n  - expected on client: ").concat(JSON.stringify(vnode.children)));
                        $642245f23a3b0f5d$var$logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $642245f23a3b0f5d$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $642245f23a3b0f5d$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    var needToAdoptContent = !vnode.children.length;
                    for(var i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $642245f23a3b0f5d$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    var container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($642245f23a3b0f5d$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $642245f23a3b0f5d$var$getContainerType(container), optimized);
                    if ($642245f23a3b0f5d$var$isAsyncWrapper(vnode) && !vnode.type.__asyncResolved) {
                        var subTree;
                        if (isFragmentStart) {
                            subTree = $642245f23a3b0f5d$export$bf5c4cf060303d58($642245f23a3b0f5d$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $642245f23a3b0f5d$export$22f9b5ffd89dac9("") : $642245f23a3b0f5d$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $642245f23a3b0f5d$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $642245f23a3b0f5d$var$warn$1("Invalid HostVNode type:", type, "(".concat(typeof type === "undefined" ? "undefined" : (0, $6gBIz._)(type), ")"));
        }
        if (ref != null) $642245f23a3b0f5d$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    var hydrateElement = function(el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized) {
        optimized = optimized || !!vnode.dynamicChildren;
        var type = vnode.type, props = vnode.props, patchFlag = vnode.patchFlag, shapeFlag = vnode.shapeFlag, dirs = vnode.dirs, transition = vnode.transition;
        var forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) $642245f23a3b0f5d$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            var needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $642245f23a3b0f5d$var$needTransition(null, // no need check parentSuspense in hydration
                transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                var content = el.content.firstChild;
                if (needCallTransitionHooks) {
                    var cls = content.getAttribute("class");
                    if (cls) content.$cls = cls;
                    transition.beforeEnter(content);
                }
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                var next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                var hasWarned = false;
                while(next){
                    if (!$642245f23a3b0f5d$var$isMismatchAllowed(el, 1 /* CHILDREN */ )) {
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                            $642245f23a3b0f5d$var$warn$1("Hydration children mismatch on", el, "\nServer rendered element contains more child nodes than client vdom.");
                            hasWarned = true;
                        }
                        $642245f23a3b0f5d$var$logMismatchError();
                    }
                    var cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                var clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                if (el.textContent !== clientText) {
                    if (!$642245f23a3b0f5d$var$isMismatchAllowed(el, 0 /* TEXT */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $642245f23a3b0f5d$var$warn$1("Hydration text content mismatch on", el, "\n  - rendered on server: ".concat(el.textContent, "\n  - expected on client: ").concat(vnode.children));
                        $642245f23a3b0f5d$var$logMismatchError();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & 48) {
                    var isCustomElement = el.tagName.includes("-");
                    for(var key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                        // as it could have mutated the DOM in any possible way
                        !(dirs && dirs.some(function(d) {
                            return d.dir.created;
                        })) && $642245f23a3b0f5d$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $642245f23a3b0f5d$var$logMismatchError();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $3ZJCa.isOn)(key) && !(0, $3ZJCa.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                        key[0] === "." || isCustomElement) patchProp(el, key, null, props[key], void 0, parentComponent);
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, $5wB2C.isReactive)(props.style)) for(var key1 in props.style)props.style[key1];
            }
            var vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $642245f23a3b0f5d$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $642245f23a3b0f5d$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $642245f23a3b0f5d$var$queueEffectWithSuspense(function() {
                vnodeHooks && $642245f23a3b0f5d$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $642245f23a3b0f5d$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    var hydrateChildren = function(node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized) {
        optimized = optimized || !!parentVNode.dynamicChildren;
        var children = parentVNode.children;
        var l = children.length;
        var hasWarned = false;
        for(var i = 0; i < l; i++){
            var vnode = optimized ? children[i] : children[i] = $642245f23a3b0f5d$var$normalizeVNode(children[i]);
            var isText = vnode.type === $642245f23a3b0f5d$export$5f1af8db9871e1d6;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && $642245f23a3b0f5d$var$normalizeVNode(children[i + 1]).type === $642245f23a3b0f5d$export$5f1af8db9871e1d6) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!$642245f23a3b0f5d$var$isMismatchAllowed(container, 1 /* CHILDREN */ )) {
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                        $642245f23a3b0f5d$var$warn$1("Hydration children mismatch on", container, "\nServer rendered element contains fewer child nodes than client vdom.");
                        hasWarned = true;
                    }
                    $642245f23a3b0f5d$var$logMismatchError();
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $642245f23a3b0f5d$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    var hydrateFragment = function(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized) {
        var fragmentSlotScopeIds = vnode.slotScopeIds;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        var container = parentNode(node);
        var next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $642245f23a3b0f5d$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $642245f23a3b0f5d$var$logMismatchError();
            insert(vnode.anchor = createComment("]"), container, next);
            return next;
        }
    };
    var handleMismatch = function(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment) {
        if (!$642245f23a3b0f5d$var$isMismatchAllowed(node.parentElement, 1 /* CHILDREN */ )) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $642245f23a3b0f5d$var$warn$1("Hydration node mismatch:\n- rendered on server:", node, node.nodeType === 3 ? "(text)" : $642245f23a3b0f5d$var$isComment(node) && node.data === "[" ? "(start of fragment)" : "", "\n- expected on client:", vnode.type);
            $642245f23a3b0f5d$var$logMismatchError();
        }
        vnode.el = null;
        if (isFragment) {
            var end = locateClosingAnchor(node);
            while(true){
                var next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        var next = nextSibling(node);
        var container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $642245f23a3b0f5d$var$getContainerType(container), slotScopeIds);
        if (parentComponent) {
            parentComponent.vnode.el = vnode.el;
            $642245f23a3b0f5d$var$updateHOCHostEl(parentComponent, vnode.el);
        }
        return next;
    };
    var locateClosingAnchor = function(node) {
        var open = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "[", close = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "]";
        var match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $642245f23a3b0f5d$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    var replaceNode = function(newNode, oldNode, parentComponent) {
        var parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        var parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    var isTemplateNode = function(node) {
        return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function $642245f23a3b0f5d$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    var mismatchType;
    var mismatchKey;
    var actual;
    var expected;
    if (key === "class") {
        if (el.$cls) {
            actual = el.$cls;
            delete el.$cls;
        } else actual = el.getAttribute("class");
        expected = (0, $3ZJCa.normalizeClass)(clientValue);
        if (!$642245f23a3b0f5d$var$isSetEqual($642245f23a3b0f5d$var$toClassSet(actual || ""), $642245f23a3b0f5d$var$toClassSet(expected))) {
            mismatchType = 2 /* CLASS */ ;
            mismatchKey = "class";
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $3ZJCa.isString)(clientValue) ? clientValue : (0, $3ZJCa.stringifyStyle)((0, $3ZJCa.normalizeStyle)(clientValue));
        var actualMap = $642245f23a3b0f5d$var$toStyleMap(actual);
        var expectedMap = $642245f23a3b0f5d$var$toStyleMap(expected);
        if (vnode.dirs) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = vnode.dirs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = _step.value, dir = _step_value.dir, value = _step_value.value;
                    if (dir.name === "show" && !value) expectedMap.set("display", "none");
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        if (instance) $642245f23a3b0f5d$var$resolveCssVars(instance, vnode, expectedMap);
        if (!$642245f23a3b0f5d$var$isMapEqual(actualMap, expectedMap)) {
            mismatchType = 3 /* STYLE */ ;
            mismatchKey = "style";
        }
    } else if (el instanceof SVGElement && (0, $3ZJCa.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $3ZJCa.isBooleanAttr)(key) || (0, $3ZJCa.isKnownHtmlAttr)(key))) {
        if ((0, $3ZJCa.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $3ZJCa.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $3ZJCa.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = 4 /* ATTRIBUTE */ ;
            mismatchKey = key;
        }
    }
    if (mismatchType != null && !$642245f23a3b0f5d$var$isMismatchAllowed(el, mismatchType)) {
        var format = function(v1) {
            return v1 === false ? "(not rendered)" : "".concat(mismatchKey, '="').concat(v1, '"');
        };
        var preSegment = "Hydration ".concat($642245f23a3b0f5d$var$MismatchTypeString[mismatchType], " mismatch on");
        var postSegment = "\n  - rendered on server: ".concat(format(actual), "\n  - expected on client: ").concat(format(expected), "\n  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.\n  You should fix the source of the mismatch.");
        $642245f23a3b0f5d$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $642245f23a3b0f5d$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $642245f23a3b0f5d$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var s = _step.value;
            if (!b.has(s)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $642245f23a3b0f5d$var$toStyleMap(str) {
    var styleMap = /* @__PURE__ */ new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = str.split(";")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var _item_split = (0, $9tk0W._)(item.split(":"), 2), key = _item_split[0], value = _item_split[1];
            key = key.trim();
            value = value && value.trim();
            if (key && value) styleMap.set(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return styleMap;
}
function $642245f23a3b0f5d$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $9tk0W._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            if (value !== b.get(key)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $642245f23a3b0f5d$var$resolveCssVars(instance, vnode, expectedMap) {
    var root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === $642245f23a3b0f5d$export$ffb0004e005737fa && root.children.includes(vnode))) {
        var cssVars = instance.getCssVars();
        for(var key in cssVars){
            var value = (0, $3ZJCa.normalizeCssVarValue)(cssVars[key]);
            expectedMap.set("--".concat((0, $3ZJCa.getEscapedCssVarName)(key, false)), value);
        }
    }
    if (vnode === root && instance.parent) $642245f23a3b0f5d$var$resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
var $642245f23a3b0f5d$var$allowMismatchAttr = "data-allow-mismatch";
var $642245f23a3b0f5d$var$_obj1;
var $642245f23a3b0f5d$var$MismatchTypeString = ($642245f23a3b0f5d$var$_obj1 = {}, (0, $aRIHe._)($642245f23a3b0f5d$var$_obj1, 0 /* TEXT */ , "text"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj1, 1 /* CHILDREN */ , "children"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj1, 2 /* CLASS */ , "class"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj1, 3 /* STYLE */ , "style"), (0, $aRIHe._)($642245f23a3b0f5d$var$_obj1, 4 /* ATTRIBUTE */ , "attribute"), $642245f23a3b0f5d$var$_obj1);
function $642245f23a3b0f5d$var$isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 /* TEXT */  || allowedType === 1 /* CHILDREN */ ) while(el && !el.hasAttribute($642245f23a3b0f5d$var$allowMismatchAttr))el = el.parentElement;
    var allowedAttr = el && el.getAttribute($642245f23a3b0f5d$var$allowMismatchAttr);
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        var list = allowedAttr.split(",");
        if (allowedType === 0 /* TEXT */  && list.includes("children")) return true;
        return list.includes($642245f23a3b0f5d$var$MismatchTypeString[allowedType]);
    }
}
var $642245f23a3b0f5d$var$requestIdleCallback = (0, $3ZJCa.getGlobalThis)().requestIdleCallback || function(cb) {
    return setTimeout(cb, 1);
};
var $642245f23a3b0f5d$var$cancelIdleCallback = (0, $3ZJCa.getGlobalThis)().cancelIdleCallback || function(id) {
    return clearTimeout(id);
};
var $642245f23a3b0f5d$export$8bfca283fd254627 = function() {
    var timeout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1e4;
    return function(hydrate) {
        var id = $642245f23a3b0f5d$var$requestIdleCallback(hydrate, {
            timeout: timeout
        });
        return function() {
            return $642245f23a3b0f5d$var$cancelIdleCallback(id);
        };
    };
};
function $642245f23a3b0f5d$var$elementIsVisibleInViewport(el) {
    var _el_getBoundingClientRect = el.getBoundingClientRect(), top = _el_getBoundingClientRect.top, left = _el_getBoundingClientRect.left, bottom = _el_getBoundingClientRect.bottom, right = _el_getBoundingClientRect.right;
    var innerHeight = window.innerHeight, innerWidth = window.innerWidth;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
var $642245f23a3b0f5d$export$2b04cd335e660930 = function(opts) {
    return function(hydrate, forEach) {
        var ob = new IntersectionObserver(function(entries) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var e = _step.value;
                    if (!e.isIntersecting) continue;
                    ob.disconnect();
                    hydrate();
                    break;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }, opts);
        forEach(function(el) {
            if (!(el instanceof Element)) return;
            if ($642245f23a3b0f5d$var$elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            ob.observe(el);
        });
        return function() {
            return ob.disconnect();
        };
    };
};
var $642245f23a3b0f5d$export$804dbb6002787b74 = function(query) {
    return function(hydrate) {
        if (query) {
            var mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return function() {
                    return mql.removeEventListener("change", hydrate);
                };
            }
        }
    };
};
var $642245f23a3b0f5d$export$288f5a9b4248e114 = function() {
    var interactions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return function(hydrate, forEach) {
        if ((0, $3ZJCa.isString)(interactions)) interactions = [
            interactions
        ];
        var hasHydrated = false;
        var doHydrate = function(e) {
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        var teardown = function() {
            forEach(function(el) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = interactions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        el.removeEventListener(i, doHydrate);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        };
        forEach(function(el) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = interactions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var i = _step.value;
                    el.addEventListener(i, doHydrate, {
                        once: true
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        return teardown;
    };
};
function $642245f23a3b0f5d$var$forEachElement(node, cb) {
    if ($642245f23a3b0f5d$var$isComment(node) && node.data === "[") {
        var depth = 1;
        var next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                var result = cb(next);
                if (result === false) break;
            } else if ($642245f23a3b0f5d$var$isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
var $642245f23a3b0f5d$var$isAsyncWrapper = function(i) {
    return !!i.type.__asyncLoader;
};
// @__NO_SIDE_EFFECTS__
function $642245f23a3b0f5d$export$d75d499b4c16cf21(source) {
    if ((0, $3ZJCa.isFunction)(source)) source = {
        loader: source
    };
    var loader = source.loader, loadingComponent = source.loadingComponent, errorComponent = source.errorComponent, _source_delay = source.delay, delay = _source_delay === void 0 ? 200 : _source_delay, hydrateStrategy = source.hydrate, timeout = source.timeout, _source_suspensible = source.// undefined = never times out
    suspensible, suspensible = _source_suspensible === void 0 ? true : _source_suspensible, userOnError = source.onError;
    var pendingRequest = null;
    var resolvedComp;
    var retries = 0;
    var retry = function() {
        retries++;
        pendingRequest = null;
        return load();
    };
    var load = function() {
        var thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader()["catch"](function(err) {
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise(function(resolve, reject) {
                var userRetry = function() {
                    return resolve(retry());
                };
                var userFail = function() {
                    return reject(err);
                };
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then(function(comp) {
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp["default"];
            resolvedComp = comp;
            return comp;
        }));
    };
    return $642245f23a3b0f5d$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate: function(el, instance, hydrate) {
            var patched = false;
            (instance.bu || (instance.bu = [])).push(function() {
                return patched = true;
            });
            var performHydrate = function() {
                if (patched) return;
                hydrate();
            };
            var doHydrate = hydrateStrategy ? function() {
                var teardown = hydrateStrategy(performHydrate, function(cb) {
                    return $642245f23a3b0f5d$var$forEachElement(el, cb);
                });
                if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
            } : performHydrate;
            if (resolvedComp) doHydrate();
            else load().then(function() {
                return !instance.isUnmounted && doHydrate();
            });
        },
        get __asyncResolved () {
            return resolvedComp;
        },
        setup: function() {
            var instance = $642245f23a3b0f5d$var$currentInstance;
            $642245f23a3b0f5d$var$markAsyncBoundary(instance);
            if (resolvedComp) return function() {
                return $642245f23a3b0f5d$var$createInnerComp(resolvedComp, instance);
            };
            var onError = function(err) {
                pendingRequest = null;
                $642245f23a3b0f5d$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $642245f23a3b0f5d$var$isInSSRComponentSetup) return load().then(function(comp) {
                return function() {
                    return $642245f23a3b0f5d$var$createInnerComp(comp, instance);
                };
            })["catch"](function(err) {
                onError(err);
                return function() {
                    return errorComponent ? $642245f23a3b0f5d$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
                };
            });
            var loaded = (0, $5wB2C.ref)(false);
            var error = (0, $5wB2C.ref)();
            var delayed = (0, $5wB2C.ref)(!!delay);
            if (delay) setTimeout(function() {
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(function() {
                if (!loaded.value && !error.value) {
                    var err = new Error("Async component timed out after ".concat(timeout, "ms."));
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(function() {
                loaded.value = true;
                if (instance.parent && $642245f23a3b0f5d$var$isKeepAlive(instance.parent.vnode)) instance.parent.update();
            })["catch"](function(err) {
                onError(err);
                error.value = err;
            });
            return function() {
                if (loaded.value && resolvedComp) return $642245f23a3b0f5d$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $642245f23a3b0f5d$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $642245f23a3b0f5d$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $642245f23a3b0f5d$var$createInnerComp(comp, parent) {
    var _parent_vnode = parent.vnode, ref2 = _parent_vnode.ref, props = _parent_vnode.props, children = _parent_vnode.children, ce = _parent_vnode.ce;
    var vnode = $642245f23a3b0f5d$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
var $642245f23a3b0f5d$var$isKeepAlive = function(vnode) {
    return vnode.type.__isKeepAlive;
};
var $642245f23a3b0f5d$var$KeepAliveImpl = {
    name: "KeepAlive",
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup: function(props, param) {
        var slots = param.slots;
        var instance = $642245f23a3b0f5d$export$f13e630aa3915748();
        var sharedContext = instance.ctx;
        if (!sharedContext.renderer) return function() {
            var children = slots["default"] && slots["default"]();
            return children && children.length === 1 ? children[0] : children;
        };
        var cache = /* @__PURE__ */ new Map();
        var keys = /* @__PURE__ */ new Set();
        var current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        var parentSuspense = instance.suspense;
        var _sharedContext_renderer = sharedContext.renderer, patch = _sharedContext_renderer.p, move = _sharedContext_renderer.m, _unmount = _sharedContext_renderer.um, createElement = _sharedContext_renderer.o.createElement;
        var storageContainer = createElement("div");
        sharedContext.activate = function(vnode, container, anchor, namespace, optimized) {
            var instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $642245f23a3b0f5d$var$queuePostRenderEffect(function() {
                instance2.isDeactivated = false;
                if (instance2.a) (0, $3ZJCa.invokeArrayFns)(instance2.a);
                var vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $642245f23a3b0f5d$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $642245f23a3b0f5d$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = function(vnode) {
            var instance2 = vnode.component;
            $642245f23a3b0f5d$var$invalidateMount(instance2.m);
            $642245f23a3b0f5d$var$invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            $642245f23a3b0f5d$var$queuePostRenderEffect(function() {
                if (instance2.da) (0, $3ZJCa.invokeArrayFns)(instance2.da);
                var vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $642245f23a3b0f5d$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $642245f23a3b0f5d$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $642245f23a3b0f5d$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach(function(vnode, key) {
                var name = $642245f23a3b0f5d$var$getComponentName(vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            var cached = cache.get(key);
            if (cached && (!current || !$642245f23a3b0f5d$var$isSameVNodeType(cached, current))) unmount(cached);
            else if (current) $642245f23a3b0f5d$var$resetShapeFlag(current);
            cache["delete"](key);
            keys["delete"](key);
        }
        $642245f23a3b0f5d$export$3db5d71bdb2d5499(function() {
            return [
                props.include,
                props.exclude
            ];
        }, function(param) {
            var _param = (0, $9tk0W._)(param, 2), include = _param[0], exclude = _param[1];
            include && pruneCache(function(name) {
                return $642245f23a3b0f5d$var$matches(include, name);
            });
            exclude && pruneCache(function(name) {
                return !$642245f23a3b0f5d$var$matches(exclude, name);
            });
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        var pendingCacheKey = null;
        var cacheSubtree = function() {
            if (pendingCacheKey != null) {
                if ($642245f23a3b0f5d$var$isSuspense(instance.subTree.type)) $642245f23a3b0f5d$var$queuePostRenderEffect(function() {
                    cache.set(pendingCacheKey, $642245f23a3b0f5d$var$getInnerChild(instance.subTree));
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, $642245f23a3b0f5d$var$getInnerChild(instance.subTree));
            }
        };
        $642245f23a3b0f5d$export$6d1641039221b5cb(cacheSubtree);
        $642245f23a3b0f5d$export$5876c47052fb88b1(cacheSubtree);
        $642245f23a3b0f5d$export$40c420df62d2614(function() {
            cache.forEach(function(cached) {
                var subTree = instance.subTree, suspense = instance.suspense;
                var vnode = $642245f23a3b0f5d$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $642245f23a3b0f5d$var$resetShapeFlag(vnode);
                    var da = vnode.component.da;
                    da && $642245f23a3b0f5d$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return function() {
            pendingCacheKey = null;
            if (!slots["default"]) return current = null;
            var children = slots["default"]();
            var rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$642245f23a3b0f5d$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            var vnode = $642245f23a3b0f5d$var$getInnerChild(rawVNode);
            if (vnode.type === $642245f23a3b0f5d$export$4d299b491347818a) {
                current = null;
                return vnode;
            }
            var comp = vnode.type;
            var name = $642245f23a3b0f5d$var$getComponentName($642245f23a3b0f5d$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            var include = props.include, exclude = props.exclude, max = props.max;
            if (include && (!name || !$642245f23a3b0f5d$var$matches(include, name)) || exclude && name && $642245f23a3b0f5d$var$matches(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            var key = vnode.key == null ? comp : vnode.key;
            var cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $642245f23a3b0f5d$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $642245f23a3b0f5d$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys["delete"](key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $642245f23a3b0f5d$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
var $642245f23a3b0f5d$export$70eb8a58709972df = $642245f23a3b0f5d$var$KeepAliveImpl;
function $642245f23a3b0f5d$var$matches(pattern, name) {
    if ((0, $3ZJCa.isArray)(pattern)) return pattern.some(function(p) {
        return $642245f23a3b0f5d$var$matches(p, name);
    });
    else if ((0, $3ZJCa.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $3ZJCa.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    return false;
}
function $642245f23a3b0f5d$export$ba52d824b95a2154(hook, target) {
    $642245f23a3b0f5d$var$registerKeepAliveHook(hook, "a", target);
}
function $642245f23a3b0f5d$export$bf1440eeaf5fa709(hook, target) {
    $642245f23a3b0f5d$var$registerKeepAliveHook(hook, "da", target);
}
function $642245f23a3b0f5d$var$registerKeepAliveHook(hook, type) {
    var target = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $642245f23a3b0f5d$var$currentInstance;
    var wrappedHook = hook.__wdc || (hook.__wdc = function() {
        var current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $642245f23a3b0f5d$var$injectHook(type, wrappedHook, target);
    if (target) {
        var current = target.parent;
        while(current && current.parent){
            if ($642245f23a3b0f5d$var$isKeepAlive(current.parent.vnode)) $642245f23a3b0f5d$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $642245f23a3b0f5d$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    var injected = $642245f23a3b0f5d$var$injectHook(type, hook, keepAliveRoot, true);
    $642245f23a3b0f5d$export$13348a43ccacfe58(function() {
        (0, $3ZJCa.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $642245f23a3b0f5d$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $642245f23a3b0f5d$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $642245f23a3b0f5d$var$injectHook(type, hook) {
    var target = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $642245f23a3b0f5d$var$currentInstance, prepend = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if (target) {
        var hooks = target[type] || (target[type] = []);
        var wrappedHook = hook.__weh || (hook.__weh = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $5wB2C.pauseTracking)();
            var reset = $642245f23a3b0f5d$var$setCurrentInstance(target);
            var res = $642245f23a3b0f5d$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $5wB2C.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
var $642245f23a3b0f5d$var$createHook = function(lifecycle) {
    return function(hook) {
        var target = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $642245f23a3b0f5d$var$currentInstance;
        if (!$642245f23a3b0f5d$var$isInSSRComponentSetup || lifecycle === "sp") $642245f23a3b0f5d$var$injectHook(lifecycle, function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return hook.apply(void 0, (0, $kf9Kn._)(args));
        }, target);
    };
};
var $642245f23a3b0f5d$export$23b7aeb0d671f804 = $642245f23a3b0f5d$var$createHook("bm");
var $642245f23a3b0f5d$export$6d1641039221b5cb = $642245f23a3b0f5d$var$createHook("m");
var $642245f23a3b0f5d$export$ab91988a13872e4c = $642245f23a3b0f5d$var$createHook("bu");
var $642245f23a3b0f5d$export$5876c47052fb88b1 = $642245f23a3b0f5d$var$createHook("u");
var $642245f23a3b0f5d$export$40c420df62d2614 = $642245f23a3b0f5d$var$createHook("bum");
var $642245f23a3b0f5d$export$13348a43ccacfe58 = $642245f23a3b0f5d$var$createHook("um");
var $642245f23a3b0f5d$export$ebf0c601f267bceb = $642245f23a3b0f5d$var$createHook("sp");
var $642245f23a3b0f5d$export$898295a813d662eb = $642245f23a3b0f5d$var$createHook("rtg");
var $642245f23a3b0f5d$export$2b41f4235363e921 = $642245f23a3b0f5d$var$createHook("rtc");
function $642245f23a3b0f5d$export$6a3a15856e50ad19(hook) {
    var target = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $642245f23a3b0f5d$var$currentInstance;
    $642245f23a3b0f5d$var$injectHook("ec", hook, target);
}
var $642245f23a3b0f5d$var$COMPONENTS = "components";
var $642245f23a3b0f5d$var$DIRECTIVES = "directives";
function $642245f23a3b0f5d$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $642245f23a3b0f5d$var$resolveAsset($642245f23a3b0f5d$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
var $642245f23a3b0f5d$var$NULL_DYNAMIC_COMPONENT = Symbol["for"]("v-ndc");
function $642245f23a3b0f5d$export$b44c564a05ca975(component) {
    if ((0, $3ZJCa.isString)(component)) return $642245f23a3b0f5d$var$resolveAsset($642245f23a3b0f5d$var$COMPONENTS, component, false) || component;
    else return component || $642245f23a3b0f5d$var$NULL_DYNAMIC_COMPONENT;
}
function $642245f23a3b0f5d$export$a1989e995cd481be(name) {
    return $642245f23a3b0f5d$var$resolveAsset($642245f23a3b0f5d$var$DIRECTIVES, name);
}
function $642245f23a3b0f5d$var$resolveAsset(type, name) {
    var warnMissing = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, maybeSelfReference = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var instance = $642245f23a3b0f5d$var$currentRenderingInstance || $642245f23a3b0f5d$var$currentInstance;
    if (instance) {
        var Component = instance.type;
        if (type === $642245f23a3b0f5d$var$COMPONENTS) {
            var selfName = $642245f23a3b0f5d$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $3ZJCa.camelize)(name) || selfName === (0, $3ZJCa.capitalize)((0, $3ZJCa.camelize)(name)))) return Component;
        }
        var res = // local registration
        // check instance[type] first which is resolved for options API
        $642245f23a3b0f5d$var$resolve(instance[type] || Component[type], name) || // global registration
        $642245f23a3b0f5d$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $642245f23a3b0f5d$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $3ZJCa.camelize)(name)] || registry[(0, $3ZJCa.capitalize)((0, $3ZJCa.camelize)(name))]);
}
function $642245f23a3b0f5d$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    var ret;
    var cached = cache && cache[index];
    var sourceIsArray = (0, $3ZJCa.isArray)(source);
    if (sourceIsArray || (0, $3ZJCa.isString)(source)) {
        var sourceIsReactiveArray = sourceIsArray && (0, $5wB2C.isReactive)(source);
        var needsWrap = false;
        var isReadonlySource = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, $5wB2C.isShallow)(source);
            isReadonlySource = (0, $5wB2C.isReadonly)(source);
            source = (0, $5wB2C.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(var i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? isReadonlySource ? (0, $5wB2C.toReadonly)((0, $5wB2C.toReactive)(source[i])) : (0, $5wB2C.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(var i1 = 0; i1 < source; i1++)ret[i1] = renderItem(i1 + 1, i1, void 0, cached && cached[i1]);
    } else if ((0, $3ZJCa.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, function(item, i) {
            return renderItem(item, i, void 0, cached && cached[i]);
        });
        else {
            var keys = Object.keys(source);
            ret = new Array(keys.length);
            for(var i2 = 0, l1 = keys.length; i2 < l1; i2++){
                var key = keys[i2];
                ret[i2] = renderItem(source[key], key, i2, cached && cached[i2]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $642245f23a3b0f5d$export$85738f8fcd0a5430(slots, dynamicSlots) {
    var _loop = function(i) {
        var slot = dynamicSlots[i];
        if ((0, $3ZJCa.isArray)(slot)) for(var j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _slot;
            var res = (_slot = slot).fn.apply(_slot, (0, $kf9Kn._)(args));
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    };
    for(var i = 0; i < dynamicSlots.length; i++)_loop(i);
    return slots;
}
function $642245f23a3b0f5d$export$4abee4c34694ada1(slots, name) {
    var props = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, fallback = arguments.length > 3 ? arguments[3] : void 0, noSlotted = arguments.length > 4 ? arguments[4] : void 0;
    if ($642245f23a3b0f5d$var$currentRenderingInstance.ce || $642245f23a3b0f5d$var$currentRenderingInstance.parent && $642245f23a3b0f5d$var$isAsyncWrapper($642245f23a3b0f5d$var$currentRenderingInstance.parent) && $642245f23a3b0f5d$var$currentRenderingInstance.parent.ce) {
        var hasProps = Object.keys(props).length > 0;
        if (name !== "default") props.name = name;
        return $642245f23a3b0f5d$export$e7eaa45e502fe5cc(), $642245f23a3b0f5d$export$9f2dfe8048dfb22b($642245f23a3b0f5d$export$ffb0004e005737fa, null, [
            $642245f23a3b0f5d$export$bf5c4cf060303d58("slot", props, fallback && fallback())
        ], hasProps ? -2 : 64);
    }
    var slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $642245f23a3b0f5d$export$e7eaa45e502fe5cc();
    var validSlotContent = slot && $642245f23a3b0f5d$var$ensureValidVNode(slot(props));
    var slotKey = props.key || // slot content array of a dynamic conditional slot may have a branch
    // key attached in the `createSlots` helper, respect that
    validSlotContent && validSlotContent.key;
    var rendered = $642245f23a3b0f5d$export$9f2dfe8048dfb22b($642245f23a3b0f5d$export$ffb0004e005737fa, {
        key: (slotKey && !(0, $3ZJCa.isSymbol)(slotKey) ? slotKey : "_".concat(name)) + // #7256 force differentiate fallback content from actual content
        (!validSlotContent && fallback ? "_fb" : "")
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $642245f23a3b0f5d$var$ensureValidVNode(vnodes) {
    return vnodes.some(function(child) {
        if (!$642245f23a3b0f5d$export$3868d13f8734ae81(child)) return true;
        if (child.type === $642245f23a3b0f5d$export$4d299b491347818a) return false;
        if (child.type === $642245f23a3b0f5d$export$ffb0004e005737fa && !$642245f23a3b0f5d$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $642245f23a3b0f5d$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    var ret = {};
    for(var key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? "on:".concat(key) : (0, $3ZJCa.toHandlerKey)(key)] = obj[key];
    return ret;
}
var $642245f23a3b0f5d$var$getPublicInstance = function(i) {
    if (!i) return null;
    if ($642245f23a3b0f5d$var$isStatefulComponent(i)) return $642245f23a3b0f5d$var$getComponentPublicInstance(i);
    return $642245f23a3b0f5d$var$getPublicInstance(i.parent);
};
var $642245f23a3b0f5d$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $3ZJCa.extend)(/* @__PURE__ */ Object.create(null), {
    $: function(i) {
        return i;
    },
    $el: function(i) {
        return i.vnode.el;
    },
    $data: function(i) {
        return i.data;
    },
    $props: function(i) {
        return 0, i.props;
    },
    $attrs: function(i) {
        return 0, i.attrs;
    },
    $slots: function(i) {
        return 0, i.slots;
    },
    $refs: function(i) {
        return 0, i.refs;
    },
    $parent: function(i) {
        return $642245f23a3b0f5d$var$getPublicInstance(i.parent);
    },
    $root: function(i) {
        return $642245f23a3b0f5d$var$getPublicInstance(i.root);
    },
    $host: function(i) {
        return i.ce;
    },
    $emit: function(i) {
        return i.emit;
    },
    $options: function(i) {
        return __VUE_OPTIONS_API__ ? $642245f23a3b0f5d$var$resolveMergedOptions(i) : i.type;
    },
    $forceUpdate: function(i) {
        return i.f || (i.f = function() {
            $642245f23a3b0f5d$var$queueJob(i.update);
        });
    },
    $nextTick: function(i) {
        return i.n || (i.n = $642245f23a3b0f5d$export$bdd553fddd433dcb.bind(i.proxy));
    },
    $watch: function(i) {
        return __VUE_OPTIONS_API__ ? $642245f23a3b0f5d$var$instanceWatch.bind(i) : (0, $3ZJCa.NOOP);
    }
});
var $642245f23a3b0f5d$var$isReservedPrefix = function(key) {
    return key === "_" || key === "$";
};
var $642245f23a3b0f5d$var$hasSetupBinding = function(state, key) {
    return state !== (0, $3ZJCa.EMPTY_OBJ) && !state.__isScriptSetup && (0, $3ZJCa.hasOwn)(state, key);
};
var $642245f23a3b0f5d$var$PublicInstanceProxyHandlers = {
    get: function(param, key) {
        var instance = param._;
        if (key === "__v_skip") return true;
        var ctx = instance.ctx, setupState = instance.setupState, data = instance.data, props = instance.props, accessCache = instance.accessCache, type = instance.type, appContext = instance.appContext;
        var normalizedProps;
        if (key[0] !== "$") {
            var n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($642245f23a3b0f5d$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $3ZJCa.EMPTY_OBJ) && (0, $3ZJCa.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $3ZJCa.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $3ZJCa.EMPTY_OBJ) && (0, $3ZJCa.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $642245f23a3b0f5d$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        var publicGetter = $642245f23a3b0f5d$var$publicPropertiesMap[key];
        var cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $5wB2C.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $3ZJCa.EMPTY_OBJ) && (0, $3ZJCa.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $3ZJCa.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set: function(param, key, value) {
        var instance = param._;
        var data = instance.data, setupState = instance.setupState, ctx = instance.ctx;
        if ($642245f23a3b0f5d$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (data !== (0, $3ZJCa.EMPTY_OBJ) && (0, $3ZJCa.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $3ZJCa.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has: function(param, key) {
        var _param__ = param._, data = _param__.data, setupState = _param__.setupState, accessCache = _param__.accessCache, ctx = _param__.ctx, appContext = _param__.appContext, propsOptions = _param__.propsOptions, type = _param__.type;
        var normalizedProps, cssModules;
        return !!(accessCache[key] || data !== (0, $3ZJCa.EMPTY_OBJ) && key[0] !== "$" && (0, $3ZJCa.hasOwn)(data, key) || $642245f23a3b0f5d$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $3ZJCa.hasOwn)(normalizedProps, key) || (0, $3ZJCa.hasOwn)(ctx, key) || (0, $3ZJCa.hasOwn)($642245f23a3b0f5d$var$publicPropertiesMap, key) || (0, $3ZJCa.hasOwn)(appContext.config.globalProperties, key) || (cssModules = type.__cssModules) && cssModules[key]);
    },
    defineProperty: function(target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $3ZJCa.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $642245f23a3b0f5d$var$target;
var $642245f23a3b0f5d$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $3ZJCa.extend)({}, $642245f23a3b0f5d$var$PublicInstanceProxyHandlers, {
    get: function(target, key) {
        if (key === Symbol.unscopables) return;
        return $642245f23a3b0f5d$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has: function(_, key) {
        var has = key[0] !== "_" && !(0, $3ZJCa.isGloballyAllowed)(key);
        return has;
    }
});
function $642245f23a3b0f5d$var$createDevRenderContext(instance) {
    var target = {};
    Object.defineProperty(target, "_", {
        configurable: true,
        enumerable: false,
        get: function() {
            return instance;
        }
    });
    Object.keys($642245f23a3b0f5d$var$publicPropertiesMap).forEach(function(key) {
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: function() {
                return $642245f23a3b0f5d$var$publicPropertiesMap[key](instance);
            },
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $3ZJCa.NOOP)
        });
    });
    return target;
}
function $642245f23a3b0f5d$var$exposePropsOnRenderContext(instance) {
    var ctx = instance.ctx, _instance_propsOptions = (0, $9tk0W._)(instance.propsOptions, 1), propsOptions = _instance_propsOptions[0];
    if (propsOptions) Object.keys(propsOptions).forEach(function(key) {
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: function() {
                return instance.props[key];
            },
            set: (0, $3ZJCa.NOOP)
        });
    });
}
function $642245f23a3b0f5d$var$exposeSetupStateOnRenderContext(instance) {
    var ctx = instance.ctx, setupState = instance.setupState;
    Object.keys((0, $5wB2C.toRaw)(setupState)).forEach(function(key) {
        if (!setupState.__isScriptSetup) {
            if ($642245f23a3b0f5d$var$isReservedPrefix(key[0])) {
                $642245f23a3b0f5d$var$warn$1("setup() return property ".concat(JSON.stringify(key), ' should not start with "$" or "_" which are reserved prefixes for Vue internals.'));
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: function() {
                    return setupState[key];
                },
                set: (0, $3ZJCa.NOOP)
            });
        }
    });
}
var $642245f23a3b0f5d$var$warnRuntimeUsage = function(method) {
    return $642245f23a3b0f5d$var$warn$1("".concat(method, "() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect."));
};
function $642245f23a3b0f5d$export$80b33eababae110e() {
    return null;
}
function $642245f23a3b0f5d$export$51ecece22fc17ddc() {
    return null;
}
function $642245f23a3b0f5d$export$da25b65ca24b518a(exposed) {}
function $642245f23a3b0f5d$export$77e79129327f3d0d(options) {}
function $642245f23a3b0f5d$export$1b3acd4bb805b712() {
    return null;
}
function $642245f23a3b0f5d$export$acd55aa037e791bb() {}
function $642245f23a3b0f5d$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $642245f23a3b0f5d$export$9203a8e84125433c() {
    return $642245f23a3b0f5d$var$getContext("useSlots").slots;
}
function $642245f23a3b0f5d$export$75e29435042cd2ea() {
    return $642245f23a3b0f5d$var$getContext("useAttrs").attrs;
}
function $642245f23a3b0f5d$var$getContext(calledFunctionName) {
    var i = $642245f23a3b0f5d$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $642245f23a3b0f5d$var$createSetupContext(i));
}
function $642245f23a3b0f5d$var$normalizePropsOrEmits(props) {
    return (0, $3ZJCa.isArray)(props) ? props.reduce(function(normalized, p) {
        return normalized[p] = null, normalized;
    }, {}) : props;
}
function $642245f23a3b0f5d$export$ec60f47d4a8a2e7f(raw, defaults) {
    var props = $642245f23a3b0f5d$var$normalizePropsOrEmits(raw);
    for(var key in defaults){
        if (key.startsWith("__skip")) continue;
        var opt = props[key];
        if (opt) {
            if ((0, $3ZJCa.isArray)(opt) || (0, $3ZJCa.isFunction)(opt)) opt = props[key] = {
                type: opt,
                "default": defaults[key]
            };
            else opt["default"] = defaults[key];
        } else if (opt === null) opt = props[key] = {
            "default": defaults[key]
        };
        if (opt && defaults["__skip_".concat(key)]) opt.skipFactory = true;
    }
    return props;
}
function $642245f23a3b0f5d$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $3ZJCa.isArray)(a) && (0, $3ZJCa.isArray)(b)) return a.concat(b);
    return (0, $3ZJCa.extend)({}, $642245f23a3b0f5d$var$normalizePropsOrEmits(a), $642245f23a3b0f5d$var$normalizePropsOrEmits(b));
}
function $642245f23a3b0f5d$export$7c343e855c563faa(props, excludedKeys) {
    var _loop = function(key) {
        if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
            enumerable: true,
            get: function() {
                return props[key];
            }
        });
    };
    var ret = {};
    for(var key in props)_loop(key);
    return ret;
}
function $642245f23a3b0f5d$export$d6d6f7369f1fb104(getAwaitable) {
    var ctx = $642245f23a3b0f5d$export$f13e630aa3915748();
    var awaitable = getAwaitable();
    $642245f23a3b0f5d$var$unsetCurrentInstance();
    if ((0, $3ZJCa.isPromise)(awaitable)) awaitable = awaitable["catch"](function(e) {
        $642245f23a3b0f5d$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        function() {
            return $642245f23a3b0f5d$var$setCurrentInstance(ctx);
        }
    ];
}
function $642245f23a3b0f5d$var$createDuplicateChecker() {
    var cache = /* @__PURE__ */ Object.create(null);
    return function(type, key) {
        if (cache[key]) $642245f23a3b0f5d$var$warn$1("".concat(type, ' property "').concat(key, '" is already defined in ').concat(cache[key], "."));
        else cache[key] = type;
    };
}
var $642245f23a3b0f5d$var$shouldCacheAccess = true;
function $642245f23a3b0f5d$var$applyOptions(instance) {
    var _loop = function(key1) {
        var opt = computedOptions[key1];
        var get = (0, $3ZJCa.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $3ZJCa.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $3ZJCa.NOOP);
        var set = !(0, $3ZJCa.isFunction)(opt) && (0, $3ZJCa.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $3ZJCa.NOOP);
        var c = $642245f23a3b0f5d$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key1, {
            enumerable: true,
            configurable: true,
            get: function() {
                return c.value;
            },
            set: function(v1) {
                return c.value = v1;
            }
        });
    };
    var options = $642245f23a3b0f5d$var$resolveMergedOptions(instance);
    var publicThis = instance.proxy;
    var ctx = instance.ctx;
    $642245f23a3b0f5d$var$shouldCacheAccess = false;
    if (options.beforeCreate) $642245f23a3b0f5d$var$callHook(options.beforeCreate, instance, "bc");
    var // state
    dataOptions = options.data, computedOptions = options.computed, methods = options.methods, watchOptions = options.watch, provideOptions = options.provide, injectOptions = options.inject, // lifecycle
    created = options.created, beforeMount = options.beforeMount, mounted = options.mounted, beforeUpdate = options.beforeUpdate, updated = options.updated, activated = options.activated, deactivated = options.deactivated, beforeDestroy = options.beforeDestroy, beforeUnmount = options.beforeUnmount, destroyed = options.destroyed, unmounted = options.unmounted, render = options.render, renderTracked = options.renderTracked, renderTriggered = options.renderTriggered, errorCaptured = options.errorCaptured, serverPrefetch = options.serverPrefetch, // public API
    expose = options.expose, inheritAttrs = options.inheritAttrs, // assets
    components = options.components, directives = options.directives, filters = options.filters;
    var checkDuplicateProperties = null;
    if (injectOptions) $642245f23a3b0f5d$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(var key in methods){
        var methodHandler = methods[key];
        if ((0, $3ZJCa.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        var data = dataOptions.call(publicThis, publicThis);
        if (!(0, $3ZJCa.isObject)(data)) ;
        else instance.data = (0, $5wB2C.reactive)(data);
    }
    $642245f23a3b0f5d$var$shouldCacheAccess = true;
    if (computedOptions) for(var key1 in computedOptions)_loop(key1);
    if (watchOptions) for(var key2 in watchOptions)$642245f23a3b0f5d$var$createWatcher(watchOptions[key2], ctx, publicThis, key2);
    if (provideOptions) {
        var provides = (0, $3ZJCa.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach(function(key) {
            $642245f23a3b0f5d$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $642245f23a3b0f5d$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $3ZJCa.isArray)(hook)) hook.forEach(function(_hook) {
            return register(_hook.bind(publicThis));
        });
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($642245f23a3b0f5d$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($642245f23a3b0f5d$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($642245f23a3b0f5d$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($642245f23a3b0f5d$export$5876c47052fb88b1, updated);
    registerLifecycleHook($642245f23a3b0f5d$export$ba52d824b95a2154, activated);
    registerLifecycleHook($642245f23a3b0f5d$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($642245f23a3b0f5d$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($642245f23a3b0f5d$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($642245f23a3b0f5d$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($642245f23a3b0f5d$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($642245f23a3b0f5d$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($642245f23a3b0f5d$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $3ZJCa.isArray)(expose)) {
        if (expose.length) {
            var exposed = instance.exposed || (instance.exposed = {});
            expose.forEach(function(key) {
                Object.defineProperty(exposed, key, {
                    get: function() {
                        return publicThis[key];
                    },
                    set: function(val) {
                        return publicThis[key] = val;
                    },
                    enumerable: true
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $3ZJCa.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) $642245f23a3b0f5d$var$markAsyncBoundary(instance);
}
function $642245f23a3b0f5d$var$resolveInjections(injectOptions, ctx) {
    var _loop = function(key) {
        var opt = injectOptions[key];
        var injected = void 0;
        if ((0, $3ZJCa.isObject)(opt)) {
            if ("default" in opt) injected = $642245f23a3b0f5d$export$a976684a0efeb93f(opt.from || key, opt["default"], true);
            else injected = $642245f23a3b0f5d$export$a976684a0efeb93f(opt.from || key);
        } else injected = $642245f23a3b0f5d$export$a976684a0efeb93f(opt);
        if ((0, $5wB2C.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: function() {
                return injected.value;
            },
            set: function(v1) {
                return injected.value = v1;
            }
        });
        else ctx[key] = injected;
    };
    var checkDuplicateProperties = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $3ZJCa.NOOP);
    if ((0, $3ZJCa.isArray)(injectOptions)) injectOptions = $642245f23a3b0f5d$var$normalizeInject(injectOptions);
    for(var key in injectOptions)_loop(key);
}
function $642245f23a3b0f5d$var$callHook(hook, instance, type) {
    $642245f23a3b0f5d$export$dae85862a8d94378((0, $3ZJCa.isArray)(hook) ? hook.map(function(h) {
        return h.bind(instance.proxy);
    }) : hook.bind(instance.proxy), instance, type);
}
function $642245f23a3b0f5d$var$createWatcher(raw, ctx, publicThis, key) {
    var getter = key.includes(".") ? $642245f23a3b0f5d$var$createPathGetter(publicThis, key) : function() {
        return publicThis[key];
    };
    if ((0, $3ZJCa.isString)(raw)) {
        var handler = ctx[raw];
        if ((0, $3ZJCa.isFunction)(handler)) $642245f23a3b0f5d$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $3ZJCa.isFunction)(raw)) $642245f23a3b0f5d$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $3ZJCa.isObject)(raw)) {
        if ((0, $3ZJCa.isArray)(raw)) raw.forEach(function(r) {
            return $642245f23a3b0f5d$var$createWatcher(r, ctx, publicThis, key);
        });
        else {
            var handler1 = (0, $3ZJCa.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $3ZJCa.isFunction)(handler1)) $642245f23a3b0f5d$export$3db5d71bdb2d5499(getter, handler1, raw);
        }
    } else ;
}
function $642245f23a3b0f5d$var$resolveMergedOptions(instance) {
    var base = instance.type;
    var mixins = base.mixins, extendsOptions = base["extends"];
    var _instance_appContext = instance.appContext, globalMixins = _instance_appContext.mixins, cache = _instance_appContext.optionsCache, optionMergeStrategies = _instance_appContext.config.optionMergeStrategies;
    var cached = cache.get(base);
    var resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach(function(m) {
            return $642245f23a3b0f5d$var$mergeOptions(resolved, m, optionMergeStrategies, true);
        });
        $642245f23a3b0f5d$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $3ZJCa.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $642245f23a3b0f5d$var$mergeOptions(to, from, strats) {
    var asMixin = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var mixins = from.mixins, extendsOptions = from["extends"];
    if (extendsOptions) $642245f23a3b0f5d$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach(function(m) {
        return $642245f23a3b0f5d$var$mergeOptions(to, m, strats, true);
    });
    for(var key in from){
        if (asMixin && key === "expose") ;
        else {
            var strat = $642245f23a3b0f5d$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
var $642245f23a3b0f5d$var$internalOptionMergeStrats = {
    data: $642245f23a3b0f5d$var$mergeDataFn,
    props: $642245f23a3b0f5d$var$mergeEmitsOrPropsOptions,
    emits: $642245f23a3b0f5d$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $642245f23a3b0f5d$var$mergeObjectOptions,
    computed: $642245f23a3b0f5d$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $642245f23a3b0f5d$var$mergeAsArray,
    created: $642245f23a3b0f5d$var$mergeAsArray,
    beforeMount: $642245f23a3b0f5d$var$mergeAsArray,
    mounted: $642245f23a3b0f5d$var$mergeAsArray,
    beforeUpdate: $642245f23a3b0f5d$var$mergeAsArray,
    updated: $642245f23a3b0f5d$var$mergeAsArray,
    beforeDestroy: $642245f23a3b0f5d$var$mergeAsArray,
    beforeUnmount: $642245f23a3b0f5d$var$mergeAsArray,
    destroyed: $642245f23a3b0f5d$var$mergeAsArray,
    unmounted: $642245f23a3b0f5d$var$mergeAsArray,
    activated: $642245f23a3b0f5d$var$mergeAsArray,
    deactivated: $642245f23a3b0f5d$var$mergeAsArray,
    errorCaptured: $642245f23a3b0f5d$var$mergeAsArray,
    serverPrefetch: $642245f23a3b0f5d$var$mergeAsArray,
    // assets
    components: $642245f23a3b0f5d$var$mergeObjectOptions,
    directives: $642245f23a3b0f5d$var$mergeObjectOptions,
    // watch
    watch: $642245f23a3b0f5d$var$mergeWatchOptions,
    // provide / inject
    provide: $642245f23a3b0f5d$var$mergeDataFn,
    inject: $642245f23a3b0f5d$var$mergeInject
};
function $642245f23a3b0f5d$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $3ZJCa.extend)((0, $3ZJCa.isFunction)(to) ? to.call(this, this) : to, (0, $3ZJCa.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $642245f23a3b0f5d$var$mergeInject(to, from) {
    return $642245f23a3b0f5d$var$mergeObjectOptions($642245f23a3b0f5d$var$normalizeInject(to), $642245f23a3b0f5d$var$normalizeInject(from));
}
function $642245f23a3b0f5d$var$normalizeInject(raw) {
    if ((0, $3ZJCa.isArray)(raw)) {
        var res = {};
        for(var i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $642245f23a3b0f5d$var$mergeAsArray(to, from) {
    return to ? (0, $kf9Kn._)(new Set([].concat(to, from))) : from;
}
function $642245f23a3b0f5d$var$mergeObjectOptions(to, from) {
    return to ? (0, $3ZJCa.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $642245f23a3b0f5d$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $3ZJCa.isArray)(to) && (0, $3ZJCa.isArray)(from)) return (0, $kf9Kn._)(/* @__PURE__ */ new Set((0, $kf9Kn._)(to).concat((0, $kf9Kn._)(from))));
        return (0, $3ZJCa.extend)(/* @__PURE__ */ Object.create(null), $642245f23a3b0f5d$var$normalizePropsOrEmits(to), $642245f23a3b0f5d$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $642245f23a3b0f5d$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    var merged = (0, $3ZJCa.extend)(/* @__PURE__ */ Object.create(null), to);
    for(var key in from)merged[key] = $642245f23a3b0f5d$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $642245f23a3b0f5d$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $3ZJCa.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
var $642245f23a3b0f5d$var$uid$1 = 0;
function $642245f23a3b0f5d$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent) {
        var rootProps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        if (!(0, $3ZJCa.isFunction)(rootComponent)) rootComponent = (0, $3ZJCa.extend)({}, rootComponent);
        if (rootProps != null && !(0, $3ZJCa.isObject)(rootProps)) rootProps = null;
        var context = $642245f23a3b0f5d$var$createAppContext();
        var installedPlugins = /* @__PURE__ */ new WeakSet();
        var pluginCleanupFns = [];
        var isMounted = false;
        var app = context.app = {
            _uid: $642245f23a3b0f5d$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $642245f23a3b0f5d$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use: function(plugin) {
                for(var _len = arguments.length, options = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    options[_key - 1] = arguments[_key];
                }
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $3ZJCa.isFunction)(plugin.install)) {
                    var _plugin;
                    installedPlugins.add(plugin);
                    (_plugin = plugin).install.apply(_plugin, [
                        app
                    ].concat((0, $kf9Kn._)(options)));
                } else if ((0, $3ZJCa.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin.apply(void 0, [
                        app
                    ].concat((0, $kf9Kn._)(options)));
                }
                return app;
            },
            mixin: function(mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component: function(name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive: function(name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount: function(rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    var vnode = app._ceVNode || $642245f23a3b0f5d$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $642245f23a3b0f5d$var$devtoolsInitApp(app, $642245f23a3b0f5d$export$83d89fbfd8236492);
                    }
                    return $642245f23a3b0f5d$var$getComponentPublicInstance(vnode.component);
                }
            },
            onUnmount: function(cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount: function() {
                if (isMounted) {
                    $642245f23a3b0f5d$export$dae85862a8d94378(pluginCleanupFns, app._instance, 16);
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $642245f23a3b0f5d$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide: function(key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext: function(fn) {
                var lastApp = $642245f23a3b0f5d$var$currentApp;
                $642245f23a3b0f5d$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $642245f23a3b0f5d$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
var $642245f23a3b0f5d$var$currentApp = null;
function $642245f23a3b0f5d$export$abe1e183e22e10ad(key, value) {
    if (!$642245f23a3b0f5d$var$currentInstance) ;
    else {
        var provides = $642245f23a3b0f5d$var$currentInstance.provides;
        var parentProvides = $642245f23a3b0f5d$var$currentInstance.parent && $642245f23a3b0f5d$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $642245f23a3b0f5d$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $642245f23a3b0f5d$export$a976684a0efeb93f(key, defaultValue) {
    var treatDefaultAsFactory = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var instance = $642245f23a3b0f5d$export$f13e630aa3915748();
    if (instance || $642245f23a3b0f5d$var$currentApp) {
        var provides = $642245f23a3b0f5d$var$currentApp ? $642245f23a3b0f5d$var$currentApp._context.provides : instance ? instance.parent == null || instance.ce ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $3ZJCa.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $642245f23a3b0f5d$export$caf6761f24fc571a() {
    return !!($642245f23a3b0f5d$export$f13e630aa3915748() || $642245f23a3b0f5d$var$currentApp);
}
var $642245f23a3b0f5d$var$internalObjectProto = {};
var $642245f23a3b0f5d$var$createInternalObject = function() {
    return Object.create($642245f23a3b0f5d$var$internalObjectProto);
};
var $642245f23a3b0f5d$var$isInternalObject = function(obj) {
    return Object.getPrototypeOf(obj) === $642245f23a3b0f5d$var$internalObjectProto;
};
function $642245f23a3b0f5d$var$initProps(instance, rawProps, isStateful) {
    var isSSR = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var props = {};
    var attrs = $642245f23a3b0f5d$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $642245f23a3b0f5d$var$setFullProps(instance, rawProps, props, attrs);
    for(var key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $5wB2C.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $642245f23a3b0f5d$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $642245f23a3b0f5d$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    var props = instance.props, attrs = instance.attrs, patchFlag = instance.vnode.patchFlag;
    var rawCurrentProps = (0, $5wB2C.toRaw)(props);
    var _instance_propsOptions = (0, $9tk0W._)(instance.propsOptions, 1), options = _instance_propsOptions[0];
    var hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            var propsToUpdate = instance.vnode.dynamicProps;
            for(var i = 0; i < propsToUpdate.length; i++){
                var key = propsToUpdate[i];
                if ($642245f23a3b0f5d$var$isEmitListener(instance.emitsOptions, key)) continue;
                var value = rawProps[key];
                if (options) {
                    if ((0, $3ZJCa.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        var camelizedKey = (0, $3ZJCa.camelize)(key);
                        props[camelizedKey] = $642245f23a3b0f5d$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($642245f23a3b0f5d$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        var kebabKey;
        for(var key1 in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $3ZJCa.hasOwn)(rawProps, key1) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $3ZJCa.hyphenate)(key1)) === key1 || !(0, $3ZJCa.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key1] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key1] = $642245f23a3b0f5d$var$resolvePropValue(options, rawCurrentProps, key1, void 0, instance, true);
            } else delete props[key1];
        }
        if (attrs !== rawCurrentProps) {
            for(var key2 in attrs)if (!rawProps || !(0, $3ZJCa.hasOwn)(rawProps, key2) && true) {
                delete attrs[key2];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $5wB2C.trigger)(instance.attrs, "set", "");
}
function $642245f23a3b0f5d$var$setFullProps(instance, rawProps, props, attrs) {
    var _instance_propsOptions = (0, $9tk0W._)(instance.propsOptions, 2), options = _instance_propsOptions[0], needCastKeys = _instance_propsOptions[1];
    var hasAttrsChanged = false;
    var rawCastValues;
    if (rawProps) for(var key in rawProps){
        if ((0, $3ZJCa.isReservedProp)(key)) continue;
        var value = rawProps[key];
        var camelKey = void 0;
        if (options && (0, $3ZJCa.hasOwn)(options, camelKey = (0, $3ZJCa.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$642245f23a3b0f5d$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        var rawCurrentProps = (0, $5wB2C.toRaw)(props);
        var castValues = rawCastValues || (0, $3ZJCa.EMPTY_OBJ);
        for(var i = 0; i < needCastKeys.length; i++){
            var key1 = needCastKeys[i];
            props[key1] = $642245f23a3b0f5d$var$resolvePropValue(options, rawCurrentProps, key1, castValues[key1], instance, !(0, $3ZJCa.hasOwn)(castValues, key1));
        }
    }
    return hasAttrsChanged;
}
function $642245f23a3b0f5d$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    var opt = options[key];
    if (opt != null) {
        var hasDefault = (0, $3ZJCa.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            var defaultValue = opt["default"];
            if (opt.type !== Function && !opt.skipFactory && (0, $3ZJCa.isFunction)(defaultValue)) {
                var propsDefaults = instance.propsDefaults;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    var reset = $642245f23a3b0f5d$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $3ZJCa.hyphenate)(key))) value = true;
        }
    }
    return value;
}
var $642245f23a3b0f5d$var$mixinPropsCache = /* @__PURE__ */ new WeakMap();
function $642245f23a3b0f5d$var$normalizePropsOptions(comp, appContext) {
    var asMixin = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var cache = __VUE_OPTIONS_API__ && asMixin ? $642245f23a3b0f5d$var$mixinPropsCache : appContext.propsCache;
    var cached = cache.get(comp);
    if (cached) return cached;
    var raw = comp.props;
    var normalized = {};
    var needCastKeys = [];
    var hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $3ZJCa.isFunction)(comp)) {
        var extendProps = function(raw2) {
            var _needCastKeys;
            hasExtends = true;
            var _normalizePropsOptions = (0, $9tk0W._)($642245f23a3b0f5d$var$normalizePropsOptions(raw2, appContext, true), 2), props = _normalizePropsOptions[0], keys = _normalizePropsOptions[1];
            (0, $3ZJCa.extend)(normalized, props);
            if (keys) (_needCastKeys = needCastKeys).push.apply(_needCastKeys, (0, $kf9Kn._)(keys));
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp["extends"]) extendProps(comp["extends"]);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $3ZJCa.isObject)(comp)) cache.set(comp, (0, $3ZJCa.EMPTY_ARR));
        return 0, $3ZJCa.EMPTY_ARR;
    }
    if ((0, $3ZJCa.isArray)(raw)) for(var i = 0; i < raw.length; i++){
        var normalizedKey = (0, $3ZJCa.camelize)(raw[i]);
        if ($642245f23a3b0f5d$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $3ZJCa.EMPTY_OBJ);
    }
    else if (raw) for(var key in raw){
        var normalizedKey1 = (0, $3ZJCa.camelize)(key);
        if ($642245f23a3b0f5d$var$validatePropName(normalizedKey1)) {
            var opt = raw[key];
            var prop = normalized[normalizedKey1] = (0, $3ZJCa.isArray)(opt) || (0, $3ZJCa.isFunction)(opt) ? {
                type: opt
            } : (0, $3ZJCa.extend)({}, opt);
            var propType = prop.type;
            var shouldCast = false;
            var shouldCastTrue = true;
            if ((0, $3ZJCa.isArray)(propType)) for(var index = 0; index < propType.length; ++index){
                var type = propType[index];
                var typeName = (0, $3ZJCa.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, $3ZJCa.isFunction)(propType) && propType.name === "Boolean";
            prop[0 /* shouldCast */ ] = shouldCast;
            prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
            if (shouldCast || (0, $3ZJCa.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey1);
        }
    }
    var res = [
        normalized,
        needCastKeys
    ];
    if ((0, $3ZJCa.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $642245f23a3b0f5d$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $3ZJCa.isReservedProp)(key)) return true;
    return false;
}
function $642245f23a3b0f5d$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if ((typeof ctor === "undefined" ? "undefined" : (0, $6gBIz._)(ctor)) === "object") {
        var name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $642245f23a3b0f5d$var$validateProps(rawProps, props, instance) {
    var resolvedValues = (0, $5wB2C.toRaw)(props);
    var options = instance.propsOptions[0];
    var camelizePropsKey = Object.keys(rawProps).map(function(key) {
        return (0, $3ZJCa.camelize)(key);
    });
    for(var key in options){
        var opt = options[key];
        if (opt == null) continue;
        $642245f23a3b0f5d$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !camelizePropsKey.includes(key));
    }
}
function $642245f23a3b0f5d$var$validateProp(name, value, prop, props, isAbsent) {
    var type = prop.type, required = prop.required, validator = prop.validator, skipCheck = prop.skipCheck;
    if (required && isAbsent) {
        $642245f23a3b0f5d$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        var isValid = false;
        var types = (0, $3ZJCa.isArray)(type) ? type : [
            type
        ];
        var expectedTypes = [];
        for(var i = 0; i < types.length && !isValid; i++){
            var _assertType = $642245f23a3b0f5d$var$assertType(value, types[i]), valid = _assertType.valid, expectedType = _assertType.expectedType;
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $642245f23a3b0f5d$var$warn$1($642245f23a3b0f5d$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $642245f23a3b0f5d$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
var $642245f23a3b0f5d$var$isSimpleType = /* @__PURE__ */ (0, $3ZJCa.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $642245f23a3b0f5d$var$assertType(value, type) {
    var valid;
    var expectedType = $642245f23a3b0f5d$var$getType(type);
    if (expectedType === "null") valid = value === null;
    else if ($642245f23a3b0f5d$var$isSimpleType(expectedType)) {
        var t = typeof value === "undefined" ? "undefined" : (0, $6gBIz._)(value);
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $3ZJCa.isObject)(value);
    else if (expectedType === "Array") valid = (0, $3ZJCa.isArray)(value);
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $642245f23a3b0f5d$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return 'Prop type [] for prop "'.concat(name, "\" won't match anything. Did you mean to use type Array instead?");
    var message = 'Invalid prop: type check failed for prop "'.concat(name, '". Expected ').concat(expectedTypes.map((0, $3ZJCa.capitalize)).join(" | "));
    var expectedType = expectedTypes[0];
    var receivedType = (0, $3ZJCa.toRawType)(value);
    var expectedValue = $642245f23a3b0f5d$var$styleValue(value, expectedType);
    var receivedValue = $642245f23a3b0f5d$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $642245f23a3b0f5d$var$isExplicable(expectedType) && !$642245f23a3b0f5d$var$isBoolean(expectedType, receivedType)) message += " with value ".concat(expectedValue);
    message += ", got ".concat(receivedType, " ");
    if ($642245f23a3b0f5d$var$isExplicable(receivedType)) message += "with value ".concat(receivedValue, ".");
    return message;
}
function $642245f23a3b0f5d$var$styleValue(value, type) {
    if (type === "String") return '"'.concat(value, '"');
    else if (type === "Number") return "".concat(Number(value));
    else return "".concat(value);
}
function $642245f23a3b0f5d$var$isExplicable(type) {
    var explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some(function(elem) {
        return type.toLowerCase() === elem;
    });
}
function $642245f23a3b0f5d$var$isBoolean() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return args.some(function(elem) {
        return elem.toLowerCase() === "boolean";
    });
}
var $642245f23a3b0f5d$var$isInternalKey = function(key) {
    return key === "_" || key === "_ctx" || key === "$stable";
};
var $642245f23a3b0f5d$var$normalizeSlotValue = function(value) {
    return (0, $3ZJCa.isArray)(value) ? value.map($642245f23a3b0f5d$var$normalizeVNode) : [
        $642245f23a3b0f5d$var$normalizeVNode(value)
    ];
};
var $642245f23a3b0f5d$var$normalizeSlot = function(key, rawSlot, ctx) {
    if (rawSlot._n) return rawSlot;
    var normalized = $642245f23a3b0f5d$export$694b237e827a3d23(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $642245f23a3b0f5d$var$normalizeSlotValue(rawSlot.apply(void 0, (0, $kf9Kn._)(args)));
    }, ctx);
    normalized._c = false;
    return normalized;
};
var $642245f23a3b0f5d$var$normalizeObjectSlots = function(rawSlots, slots, instance) {
    var _loop = function(key) {
        if ($642245f23a3b0f5d$var$isInternalKey(key)) return "continue";
        var value = rawSlots[key];
        if ((0, $3ZJCa.isFunction)(value)) slots[key] = $642245f23a3b0f5d$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            var normalized = $642245f23a3b0f5d$var$normalizeSlotValue(value);
            slots[key] = function() {
                return normalized;
            };
        }
    };
    var ctx = rawSlots._ctx;
    for(var key in rawSlots)_loop(key);
};
var $642245f23a3b0f5d$var$normalizeVNodeSlots = function(instance, children) {
    var normalized = $642245f23a3b0f5d$var$normalizeSlotValue(children);
    instance.slots["default"] = function() {
        return normalized;
    };
};
var $642245f23a3b0f5d$var$assignSlots = function(slots, children, optimized) {
    for(var key in children)if (optimized || !$642245f23a3b0f5d$var$isInternalKey(key)) slots[key] = children[key];
};
var $642245f23a3b0f5d$var$initSlots = function(instance, children, optimized) {
    var slots = instance.slots = $642245f23a3b0f5d$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        var type = children._;
        if (type) {
            $642245f23a3b0f5d$var$assignSlots(slots, children, optimized);
            if (optimized) (0, $3ZJCa.def)(slots, "_", type, true);
        } else $642245f23a3b0f5d$var$normalizeObjectSlots(children, slots);
    } else if (children) $642245f23a3b0f5d$var$normalizeVNodeSlots(instance, children);
};
var $642245f23a3b0f5d$var$updateSlots = function(instance, children, optimized) {
    var vnode = instance.vnode, slots = instance.slots;
    var needDeletionCheck = true;
    var deletionComparisonTarget = (0, $3ZJCa.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        var type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else $642245f23a3b0f5d$var$assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            $642245f23a3b0f5d$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $642245f23a3b0f5d$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            "default": 1
        };
    }
    if (needDeletionCheck) {
        for(var key in slots)if (!$642245f23a3b0f5d$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
var $642245f23a3b0f5d$var$supported;
var $642245f23a3b0f5d$var$perf;
function $642245f23a3b0f5d$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $642245f23a3b0f5d$var$isSupported()) $642245f23a3b0f5d$var$perf.mark("vue-".concat(type, "-").concat(instance.uid));
    if (__VUE_PROD_DEVTOOLS__) $642245f23a3b0f5d$var$devtoolsPerfStart(instance, type, $642245f23a3b0f5d$var$isSupported() ? $642245f23a3b0f5d$var$perf.now() : Date.now());
}
function $642245f23a3b0f5d$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $642245f23a3b0f5d$var$isSupported()) {
        var startTag = "vue-".concat(type, "-").concat(instance.uid);
        var endTag = startTag + ":end";
        var measureName = "<".concat($642245f23a3b0f5d$var$formatComponentName(instance, instance.type), "> ").concat(type);
        $642245f23a3b0f5d$var$perf.mark(endTag);
        $642245f23a3b0f5d$var$perf.measure(measureName, startTag, endTag);
        $642245f23a3b0f5d$var$perf.clearMeasures(measureName);
        $642245f23a3b0f5d$var$perf.clearMarks(startTag);
        $642245f23a3b0f5d$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $642245f23a3b0f5d$var$devtoolsPerfEnd(instance, type, $642245f23a3b0f5d$var$isSupported() ? $642245f23a3b0f5d$var$perf.now() : Date.now());
}
function $642245f23a3b0f5d$var$isSupported() {
    if ($642245f23a3b0f5d$var$supported !== void 0) return $642245f23a3b0f5d$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $642245f23a3b0f5d$var$supported = true;
        $642245f23a3b0f5d$var$perf = window.performance;
    } else $642245f23a3b0f5d$var$supported = false;
    return $642245f23a3b0f5d$var$supported;
}
function $642245f23a3b0f5d$var$initFeatureFlags() {
    var needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $3ZJCa.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $3ZJCa.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $3ZJCa.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
var $642245f23a3b0f5d$var$queuePostRenderEffect = $642245f23a3b0f5d$var$queueEffectWithSuspense;
function $642245f23a3b0f5d$export$53ae2f996c64e9a(options) {
    return $642245f23a3b0f5d$var$baseCreateRenderer(options);
}
function $642245f23a3b0f5d$export$200524cf0d997ff0(options) {
    return $642245f23a3b0f5d$var$baseCreateRenderer(options, $642245f23a3b0f5d$var$createHydrationFunctions);
}
function $642245f23a3b0f5d$var$baseCreateRenderer(options, createHydrationFns) {
    $642245f23a3b0f5d$var$initFeatureFlags();
    var target = (0, $3ZJCa.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $642245f23a3b0f5d$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    var hostInsert = options.insert, hostRemove = options.remove, hostPatchProp = options.patchProp, hostCreateElement = options.createElement, hostCreateText = options.createText, hostCreateComment = options.createComment, hostSetText = options.setText, hostSetElementText = options.setElementText, hostParentNode = options.parentNode, hostNextSibling = options.nextSibling, tmp = options.setScopeId, hostSetScopeId = tmp === void 0 ? (0, $3ZJCa.NOOP) : tmp, hostInsertStaticContent = options.insertStaticContent;
    var patch = function(n1, n2, container) {
        var anchor = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, parentComponent = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, parentSuspense = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, namespace = arguments.length > 6 ? arguments[6] : void 0, slotScopeIds = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null, optimized = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : !!n2.dynamicChildren;
        if (n1 === n2) return;
        if (n1 && !$642245f23a3b0f5d$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        var type = n2.type, ref = n2.ref, shapeFlag = n2.shapeFlag;
        switch(type){
            case $642245f23a3b0f5d$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $642245f23a3b0f5d$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $642245f23a3b0f5d$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $642245f23a3b0f5d$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $642245f23a3b0f5d$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
        else if (ref == null && n1 && n1.ref != null) $642245f23a3b0f5d$var$setRef(n1.ref, null, parentSuspense, n1, true);
    };
    var processText = function(n1, n2, container, anchor) {
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            var el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    var processCommentNode = function(n1, n2, container, anchor) {
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    var mountStaticNode = function(n2, container, anchor, namespace) {
        var ref;
        ref = (0, $9tk0W._)(hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor), 2), n2.el = ref[0], n2.anchor = ref[1], ref;
    };
    var patchStaticNode = function(n1, n2, container, namespace) {
        if (n2.children !== n1.children) {
            var anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            var ref;
            ref = (0, $9tk0W._)(hostInsertStaticContent(n2.children, container, anchor, namespace), 2), n2.el = ref[0], n2.anchor = ref[1], ref;
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    var moveStaticNode = function(param, container, nextSibling) {
        var el = param.el, anchor = param.anchor;
        var next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    var removeStaticNode = function(param) {
        var el = param.el, anchor = param.anchor;
        var next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    var processElement = function(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    var mountElement = function(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        var el;
        var vnodeHook;
        var props = vnode.props, shapeFlag = vnode.shapeFlag, transition = vnode.transition, dirs = vnode.dirs;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $642245f23a3b0f5d$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $642245f23a3b0f5d$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(var key in props)if (key !== "value" && !(0, $3ZJCa.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $642245f23a3b0f5d$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $3ZJCa.def)(el, "__vnode", vnode, true);
            (0, $3ZJCa.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) $642245f23a3b0f5d$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        var needCallTransitionHooks = $642245f23a3b0f5d$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $642245f23a3b0f5d$var$queuePostRenderEffect(function() {
            vnodeHook && $642245f23a3b0f5d$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $642245f23a3b0f5d$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    var setScopeId = function(el, vnode, scopeId, slotScopeIds, parentComponent) {
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(var i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            var subTree = parentComponent.subTree;
            if (vnode === subTree || $642245f23a3b0f5d$var$isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
                var parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    var mountChildren = function(children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        var start = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : 0;
        for(var i = start; i < children.length; i++){
            var child = children[i] = optimized ? $642245f23a3b0f5d$var$cloneIfMounted(children[i]) : $642245f23a3b0f5d$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    var patchElement = function(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        var el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        var patchFlag = n2.patchFlag, dynamicChildren = n2.dynamicChildren, dirs = n2.dirs;
        patchFlag |= n1.patchFlag & 16;
        var oldProps = n1.props || (0, $3ZJCa.EMPTY_OBJ);
        var newProps = n2.props || (0, $3ZJCa.EMPTY_OBJ);
        var vnodeHook;
        parentComponent && $642245f23a3b0f5d$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $642245f23a3b0f5d$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $642245f23a3b0f5d$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $642245f23a3b0f5d$var$toggleRecurse(parentComponent, true);
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $642245f23a3b0f5d$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $642245f23a3b0f5d$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps["class"] !== newProps["class"]) hostPatchProp(el, "class", null, newProps["class"], namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    var propsToUpdate = n2.dynamicProps;
                    for(var i = 0; i < propsToUpdate.length; i++){
                        var key = propsToUpdate[i];
                        var prev = oldProps[key];
                        var next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $642245f23a3b0f5d$var$queuePostRenderEffect(function() {
            vnodeHook && $642245f23a3b0f5d$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $642245f23a3b0f5d$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    var patchBlockChildren = function(oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds) {
        for(var i = 0; i < newChildren.length; i++){
            var oldVNode = oldChildren[i];
            var newVNode = newChildren[i];
            var container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $642245f23a3b0f5d$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$642245f23a3b0f5d$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 198) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    var patchProps = function(el, oldProps, newProps, parentComponent, namespace) {
        if (oldProps !== newProps) {
            if (oldProps !== (0, $3ZJCa.EMPTY_OBJ)) {
                for(var key in oldProps)if (!(0, $3ZJCa.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(var key1 in newProps){
                if ((0, $3ZJCa.isReservedProp)(key1)) continue;
                var next = newProps[key1];
                var prev = oldProps[key1];
                if (next !== prev && key1 !== "value") hostPatchProp(el, key1, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    var processFragment = function(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        var fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        var fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        var patchFlag = n2.patchFlag, dynamicChildren = n2.dynamicChildren, fragmentSlotScopeIds = n2.slotScopeIds;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $642245f23a3b0f5d$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    var processComponent = function(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    var mountComponent = function(initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized) {
        var instance = initialVNode.component = $642245f23a3b0f5d$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($642245f23a3b0f5d$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $642245f23a3b0f5d$var$setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
            if (!initialVNode.el) {
                var placeholder = instance.subTree = $642245f23a3b0f5d$export$bf5c4cf060303d58($642245f23a3b0f5d$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
                initialVNode.placeholder = placeholder.el;
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    var updateComponent = function(n1, n2, optimized) {
        var instance = n2.component = n1.component;
        if ($642245f23a3b0f5d$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    var setupRenderEffect = function(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized) {
        var componentUpdateFn = function() {
            if (!instance.isMounted) {
                var vnodeHook;
                var el = initialVNode.el, props = initialVNode.props;
                var bm = instance.bm, m = instance.m, parent = instance.parent, root = instance.root, type = instance.type;
                var isAsyncWrapperVNode = $642245f23a3b0f5d$var$isAsyncWrapper(initialVNode);
                $642245f23a3b0f5d$var$toggleRecurse(instance, false);
                if (bm) (0, $3ZJCa.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $642245f23a3b0f5d$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $642245f23a3b0f5d$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    var hydrateSubTree = function() {
                        instance.subTree = $642245f23a3b0f5d$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce && // @ts-expect-error _def is private
                    root.ce._def.shadowRoot !== false) root.ce._injectChildStyle(type);
                    var subTree = instance.subTree = $642245f23a3b0f5d$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $642245f23a3b0f5d$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    var scopedInitialVNode = initialVNode;
                    $642245f23a3b0f5d$var$queuePostRenderEffect(function() {
                        return $642245f23a3b0f5d$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode);
                    }, parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $642245f23a3b0f5d$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $642245f23a3b0f5d$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $642245f23a3b0f5d$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                var next = instance.next, bu = instance.bu, u = instance.u, parent1 = instance.parent, vnode = instance.vnode;
                {
                    var nonHydratedAsyncRoot = $642245f23a3b0f5d$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(function() {
                            if (!instance.isUnmounted) componentUpdateFn();
                        });
                        return;
                    }
                }
                var originNext = next;
                var vnodeHook1;
                $642245f23a3b0f5d$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $3ZJCa.invokeArrayFns)(bu);
                if (vnodeHook1 = next.props && next.props.onVnodeBeforeUpdate) $642245f23a3b0f5d$var$invokeVNodeHook(vnodeHook1, parent1, next, vnode);
                $642245f23a3b0f5d$var$toggleRecurse(instance, true);
                var nextTree = $642245f23a3b0f5d$var$renderComponentRoot(instance);
                var prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $642245f23a3b0f5d$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $642245f23a3b0f5d$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook1 = next.props && next.props.onVnodeUpdated) $642245f23a3b0f5d$var$queuePostRenderEffect(function() {
                    return $642245f23a3b0f5d$var$invokeVNodeHook(vnodeHook1, parent1, next, vnode);
                }, parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $642245f23a3b0f5d$var$devtoolsComponentUpdated(instance);
            }
        };
        instance.scope.on();
        var effect = instance.effect = new (0, $5wB2C.ReactiveEffect)(componentUpdateFn);
        instance.scope.off();
        var update = instance.update = effect.run.bind(effect);
        var job = instance.job = effect.runIfDirty.bind(effect);
        job.i = instance;
        job.id = instance.uid;
        effect.scheduler = function() {
            return $642245f23a3b0f5d$var$queueJob(job);
        };
        $642245f23a3b0f5d$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    var updateComponentPreRender = function(instance, nextVNode, optimized) {
        nextVNode.component = instance;
        var prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $642245f23a3b0f5d$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $642245f23a3b0f5d$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $5wB2C.pauseTracking)();
        $642245f23a3b0f5d$var$flushPreFlushCbs(instance);
        (0, $5wB2C.resetTracking)();
    };
    var patchChildren = function(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds) {
        var optimized = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : false;
        var c1 = n1 && n1.children;
        var prevShapeFlag = n1 ? n1.shapeFlag : 0;
        var c2 = n2.children;
        var patchFlag = n2.patchFlag, shapeFlag = n2.shapeFlag;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    var patchUnkeyedChildren = function(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        c1 = c1 || (0, $3ZJCa.EMPTY_ARR);
        c2 = c2 || (0, $3ZJCa.EMPTY_ARR);
        var oldLength = c1.length;
        var newLength = c2.length;
        var commonLength = Math.min(oldLength, newLength);
        var i;
        for(i = 0; i < commonLength; i++){
            var nextChild = c2[i] = optimized ? $642245f23a3b0f5d$var$cloneIfMounted(c2[i]) : $642245f23a3b0f5d$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    var patchKeyedChildren = function(c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        var i = 0;
        var l2 = c2.length;
        var e1 = c1.length - 1;
        var e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            var n1 = c1[i];
            var n2 = c2[i] = optimized ? $642245f23a3b0f5d$var$cloneIfMounted(c2[i]) : $642245f23a3b0f5d$var$normalizeVNode(c2[i]);
            if ($642245f23a3b0f5d$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            var n11 = c1[e1];
            var n21 = c2[e2] = optimized ? $642245f23a3b0f5d$var$cloneIfMounted(c2[e2]) : $642245f23a3b0f5d$var$normalizeVNode(c2[e2]);
            if ($642245f23a3b0f5d$var$isSameVNodeType(n11, n21)) patch(n11, n21, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                var nextPos = e2 + 1;
                var anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $642245f23a3b0f5d$var$cloneIfMounted(c2[i]) : $642245f23a3b0f5d$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            var s1 = i;
            var s2 = i;
            var keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                var nextChild = c2[i] = optimized ? $642245f23a3b0f5d$var$cloneIfMounted(c2[i]) : $642245f23a3b0f5d$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            var j;
            var patched = 0;
            var toBePatched = e2 - s2 + 1;
            var moved = false;
            var maxNewIndexSoFar = 0;
            var newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                var prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                var newIndex = void 0;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $642245f23a3b0f5d$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            var increasingNewIndexSequence = moved ? $642245f23a3b0f5d$var$getSequence(newIndexToOldIndexMap) : (0, $3ZJCa.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                var nextIndex = s2 + i;
                var nextChild1 = c2[nextIndex];
                var anchorVNode = c2[nextIndex + 1];
                var anchor1 = nextIndex + 1 < l2 ? // #13559, fallback to el placeholder for unresolved async component
                anchorVNode.el || anchorVNode.placeholder : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild1, container, anchor1, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild1, container, anchor1, 2);
                    else j--;
                }
            }
        }
    };
    var move = function(vnode, container, anchor, moveType) {
        var parentSuspense = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
        var el = vnode.el, type = vnode.type, transition = vnode.transition, children = vnode.children, shapeFlag = vnode.shapeFlag;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $642245f23a3b0f5d$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(var i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $642245f23a3b0f5d$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        var needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $642245f23a3b0f5d$var$queuePostRenderEffect(function() {
                    return transition.enter(el);
                }, parentSuspense);
            } else {
                var leave = transition.leave, delayLeave = transition.delayLeave, afterLeave = transition.afterLeave;
                var remove2 = function() {
                    if (vnode.ctx.isUnmounted) hostRemove(el);
                    else hostInsert(el, container, anchor);
                };
                var performLeave = function() {
                    if (el._isLeaving) el[$642245f23a3b0f5d$var$leaveCbKey](true);
                    leave(el, function() {
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    var unmount = function(vnode, parentComponent, parentSuspense) {
        var doRemove = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, optimized = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
        var type = vnode.type, props = vnode.props, ref = vnode.ref, children = vnode.children, dynamicChildren = vnode.dynamicChildren, shapeFlag = vnode.shapeFlag, patchFlag = vnode.patchFlag, dirs = vnode.dirs, cacheIndex = vnode.cacheIndex;
        if (patchFlag === -2) optimized = false;
        if (ref != null) {
            (0, $5wB2C.pauseTracking)();
            $642245f23a3b0f5d$var$setRef(ref, null, parentSuspense, vnode, true);
            (0, $5wB2C.resetTracking)();
        }
        if (cacheIndex != null) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        var shouldInvokeDirs = shapeFlag & 1 && dirs;
        var shouldInvokeVnodeHook = !$642245f23a3b0f5d$var$isAsyncWrapper(vnode);
        var vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $642245f23a3b0f5d$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $642245f23a3b0f5d$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $642245f23a3b0f5d$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $642245f23a3b0f5d$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $642245f23a3b0f5d$var$queuePostRenderEffect(function() {
            vnodeHook && $642245f23a3b0f5d$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $642245f23a3b0f5d$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    var remove = function(vnode) {
        var type = vnode.type, el = vnode.el, anchor = vnode.anchor, transition = vnode.transition;
        if (type === $642245f23a3b0f5d$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $642245f23a3b0f5d$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        var performRemove = function() {
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            var leave = transition.leave, delayLeave = transition.delayLeave;
            var performLeave = function() {
                return leave(el, performRemove);
            };
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    var removeFragment = function(cur, end) {
        var next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    var unmountComponent = function(instance, parentSuspense, doRemove) {
        var bum = instance.bum, scope = instance.scope, job = instance.job, subTree = instance.subTree, um = instance.um, m = instance.m, a = instance.a;
        $642245f23a3b0f5d$var$invalidateMount(m);
        $642245f23a3b0f5d$var$invalidateMount(a);
        if (bum) (0, $3ZJCa.invokeArrayFns)(bum);
        scope.stop();
        if (job) {
            job.flags |= 8;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $642245f23a3b0f5d$var$queuePostRenderEffect(um, parentSuspense);
        $642245f23a3b0f5d$var$queuePostRenderEffect(function() {
            instance.isUnmounted = true;
        }, parentSuspense);
        if (__VUE_PROD_DEVTOOLS__) $642245f23a3b0f5d$var$devtoolsComponentRemoved(instance);
    };
    var unmountChildren = function(children, parentComponent, parentSuspense) {
        var doRemove = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, optimized = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, start = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
        for(var i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    var getNextHostNode = function(vnode) {
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        var el = hostNextSibling(vnode.anchor || vnode.el);
        var teleportEnd = el && el[$642245f23a3b0f5d$var$TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    var isFlushing = false;
    var render = function(vnode, container, namespace) {
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        container._vnode = vnode;
        if (!isFlushing) {
            isFlushing = true;
            $642245f23a3b0f5d$var$flushPreFlushCbs();
            $642245f23a3b0f5d$var$flushPostFlushCbs();
            isFlushing = false;
        }
    };
    var internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    var hydrate;
    var hydrateNode;
    var ref;
    if (createHydrationFns) ref = (0, $9tk0W._)(createHydrationFns(internals), 2), hydrate = ref[0], hydrateNode = ref[1], ref;
    return {
        render: render,
        hydrate: hydrate,
        createApp: $642245f23a3b0f5d$var$createAppAPI(render, hydrate)
    };
}
function $642245f23a3b0f5d$var$resolveChildrenNamespace(param, currentNamespace) {
    var type = param.type, props = param.props;
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $642245f23a3b0f5d$var$toggleRecurse(param, allowed) {
    var effect = param.effect, job = param.job;
    if (allowed) {
        effect.flags |= 32;
        job.flags |= 4;
    } else {
        effect.flags &= -33;
        job.flags &= -5;
    }
}
function $642245f23a3b0f5d$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $642245f23a3b0f5d$var$traverseStaticChildren(n1, n2) {
    var shallow = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var ch1 = n1.children;
    var ch2 = n2.children;
    if ((0, $3ZJCa.isArray)(ch1) && (0, $3ZJCa.isArray)(ch2)) for(var i = 0; i < ch1.length; i++){
        var c1 = ch1[i];
        var c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $642245f23a3b0f5d$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) $642245f23a3b0f5d$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $642245f23a3b0f5d$export$5f1af8db9871e1d6 && // avoid cached text nodes retaining detached dom nodes
        c2.patchFlag !== -1) c2.el = c1.el;
        if (c2.type === $642245f23a3b0f5d$export$4d299b491347818a && !c2.el) c2.el = c1.el;
    }
}
function $642245f23a3b0f5d$var$getSequence(arr) {
    var p = arr.slice();
    var result = [
        0
    ];
    var i, j, u, v1, c;
    var len = arr.length;
    for(i = 0; i < len; i++){
        var arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $642245f23a3b0f5d$var$locateNonHydratedAsyncRoot(instance) {
    var subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $642245f23a3b0f5d$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
function $642245f23a3b0f5d$var$invalidateMount(hooks) {
    if (hooks) for(var i = 0; i < hooks.length; i++)hooks[i].flags |= 8;
}
var $642245f23a3b0f5d$export$f2549a27e18acf2d = Symbol["for"]("v-scx");
var $642245f23a3b0f5d$export$6b1c54dc4befcda = function() {
    {
        var ctx = $642245f23a3b0f5d$export$a976684a0efeb93f($642245f23a3b0f5d$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $642245f23a3b0f5d$export$ede35fc0e5500309(effect, options) {
    return $642245f23a3b0f5d$var$doWatch(effect, null, options);
}
function $642245f23a3b0f5d$export$b7f27ea67102d543(effect, options) {
    return $642245f23a3b0f5d$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $642245f23a3b0f5d$export$2035654f31b0e555(effect, options) {
    return $642245f23a3b0f5d$var$doWatch(effect, null, {
        flush: "sync"
    });
}
function $642245f23a3b0f5d$export$3db5d71bdb2d5499(source, cb, options) {
    return $642245f23a3b0f5d$var$doWatch(source, cb, options);
}
function $642245f23a3b0f5d$var$doWatch(source, cb) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $3ZJCa.EMPTY_OBJ);
    var immediate = options.immediate, deep = options.deep, flush = options.flush, once = options.once;
    var baseWatchOptions = (0, $3ZJCa.extend)({}, options);
    var runsImmediately = cb && immediate || !cb && flush !== "post";
    var ssrCleanup;
    if ($642245f23a3b0f5d$var$isInSSRComponentSetup) {
        if (flush === "sync") {
            var ctx = $642245f23a3b0f5d$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            var watchStopHandle = function() {};
            watchStopHandle.stop = (0, $3ZJCa.NOOP);
            watchStopHandle.resume = (0, $3ZJCa.NOOP);
            watchStopHandle.pause = (0, $3ZJCa.NOOP);
            return watchStopHandle;
        }
    }
    var instance = $642245f23a3b0f5d$var$currentInstance;
    baseWatchOptions.call = function(fn, type, args) {
        return $642245f23a3b0f5d$export$dae85862a8d94378(fn, instance, type, args);
    };
    var isPre = false;
    if (flush === "post") baseWatchOptions.scheduler = function(job) {
        $642245f23a3b0f5d$var$queuePostRenderEffect(job, instance && instance.suspense);
    };
    else if (flush !== "sync") {
        isPre = true;
        baseWatchOptions.scheduler = function(job, isFirstRun) {
            if (isFirstRun) job();
            else $642245f23a3b0f5d$var$queueJob(job);
        };
    }
    baseWatchOptions.augmentJob = function(job) {
        if (cb) job.flags |= 4;
        if (isPre) {
            job.flags |= 2;
            if (instance) {
                job.id = instance.uid;
                job.i = instance;
            }
        }
    };
    var watchHandle = (0, $5wB2C.watch)(source, cb, baseWatchOptions);
    if ($642245f23a3b0f5d$var$isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(watchHandle);
        else if (runsImmediately) watchHandle();
    }
    return watchHandle;
}
function $642245f23a3b0f5d$var$instanceWatch(source, value, options) {
    var publicThis = this.proxy;
    var getter = (0, $3ZJCa.isString)(source) ? source.includes(".") ? $642245f23a3b0f5d$var$createPathGetter(publicThis, source) : function() {
        return publicThis[source];
    } : source.bind(publicThis, publicThis);
    var cb;
    if ((0, $3ZJCa.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    var reset = $642245f23a3b0f5d$var$setCurrentInstance(this);
    var res = $642245f23a3b0f5d$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $642245f23a3b0f5d$var$createPathGetter(ctx, path) {
    var segments = path.split(".");
    return function() {
        var cur = ctx;
        for(var i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $642245f23a3b0f5d$export$fb78bd113157f1a1(props, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $3ZJCa.EMPTY_OBJ);
    var i = $642245f23a3b0f5d$export$f13e630aa3915748();
    var camelizedName = (0, $3ZJCa.camelize)(name);
    var hyphenatedName = (0, $3ZJCa.hyphenate)(name);
    var modifiers = $642245f23a3b0f5d$var$getModelModifiers(props, camelizedName);
    var res = (0, $5wB2C.customRef)(function(track, trigger) {
        var localValue;
        var prevSetValue = (0, $3ZJCa.EMPTY_OBJ);
        var prevEmittedValue;
        $642245f23a3b0f5d$export$2035654f31b0e555(function() {
            var propValue = props[camelizedName];
            if ((0, $3ZJCa.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get: function() {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set: function(value) {
                var emittedValue = options.set ? options.set(value) : value;
                if (!(0, $3ZJCa.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, $3ZJCa.EMPTY_OBJ) && (0, $3ZJCa.hasChanged)(value, prevSetValue))) return;
                var rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && ("onUpdate:".concat(name) in rawProps || "onUpdate:".concat(camelizedName) in rawProps || "onUpdate:".concat(hyphenatedName) in rawProps))) {
                    localValue = value;
                    trigger();
                }
                i.emit("update:".concat(name), emittedValue);
                if ((0, $3ZJCa.hasChanged)(value, emittedValue) && (0, $3ZJCa.hasChanged)(value, prevSetValue) && !(0, $3ZJCa.hasChanged)(emittedValue, prevEmittedValue)) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = function() {
        var i2 = 0;
        return {
            next: function() {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, $3ZJCa.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
var $642245f23a3b0f5d$var$getModelModifiers = function(props, modelName) {
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props["".concat(modelName, "Modifiers")] || props["".concat((0, $3ZJCa.camelize)(modelName), "Modifiers")] || props["".concat((0, $3ZJCa.hyphenate)(modelName), "Modifiers")];
};
function $642245f23a3b0f5d$var$emit(instance, event) {
    for(var _len = arguments.length, rawArgs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        rawArgs[_key - 2] = arguments[_key];
    }
    if (instance.isUnmounted) return;
    var props = instance.vnode.props || (0, $3ZJCa.EMPTY_OBJ);
    var args = rawArgs;
    var isModelListener = event.startsWith("update:");
    var modifiers = isModelListener && $642245f23a3b0f5d$var$getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map(function(a) {
            return (0, $3ZJCa.isString)(a) ? a.trim() : a;
        });
        if (modifiers.number) args = rawArgs.map((0, $3ZJCa.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $642245f23a3b0f5d$var$devtoolsComponentEmit(instance, event, args);
    var handlerName;
    var handler = props[handlerName = (0, $3ZJCa.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $3ZJCa.toHandlerKey)((0, $3ZJCa.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $3ZJCa.toHandlerKey)((0, $3ZJCa.hyphenate)(event))];
    if (handler) $642245f23a3b0f5d$export$dae85862a8d94378(handler, instance, 6, args);
    var onceHandler = props[handlerName + "Once"];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $642245f23a3b0f5d$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
var $642245f23a3b0f5d$var$mixinEmitsCache = /* @__PURE__ */ new WeakMap();
function $642245f23a3b0f5d$var$normalizeEmitsOptions(comp, appContext) {
    var asMixin = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var cache = __VUE_OPTIONS_API__ && asMixin ? $642245f23a3b0f5d$var$mixinEmitsCache : appContext.emitsCache;
    var cached = cache.get(comp);
    if (cached !== void 0) return cached;
    var raw = comp.emits;
    var normalized = {};
    var hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $3ZJCa.isFunction)(comp)) {
        var extendEmits = function(raw2) {
            var normalizedFromExtend = $642245f23a3b0f5d$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $3ZJCa.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp["extends"]) extendEmits(comp["extends"]);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $3ZJCa.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $3ZJCa.isArray)(raw)) raw.forEach(function(key) {
        return normalized[key] = null;
    });
    else (0, $3ZJCa.extend)(normalized, raw);
    if ((0, $3ZJCa.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $642245f23a3b0f5d$var$isEmitListener(options, key) {
    if (!options || !(0, $3ZJCa.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $3ZJCa.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $3ZJCa.hasOwn)(options, (0, $3ZJCa.hyphenate)(key)) || (0, $3ZJCa.hasOwn)(options, key);
}
var $642245f23a3b0f5d$var$accessedAttrs = false;
function $642245f23a3b0f5d$var$markAttrsAccessed() {
    $642245f23a3b0f5d$var$accessedAttrs = true;
}
function $642245f23a3b0f5d$var$renderComponentRoot(instance) {
    var Component = instance.type, vnode = instance.vnode, proxy = instance.proxy, withProxy = instance.withProxy, _instance_propsOptions = (0, $9tk0W._)(instance.propsOptions, 1), propsOptions = _instance_propsOptions[0], slots = instance.slots, attrs = instance.attrs, emit = instance.emit, render = instance.render, renderCache = instance.renderCache, props = instance.props, data = instance.data, setupState = instance.setupState, ctx = instance.ctx, inheritAttrs = instance.inheritAttrs;
    var prev = $642245f23a3b0f5d$var$setCurrentRenderingInstance(instance);
    var result;
    var fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            var proxyToUse = withProxy || proxy;
            var thisProxy = proxyToUse;
            result = $642245f23a3b0f5d$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            var render2 = Component;
            result = $642245f23a3b0f5d$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $642245f23a3b0f5d$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $642245f23a3b0f5d$var$blockStack.length = 0;
        $642245f23a3b0f5d$export$d3da1ecaf1206c58(err, instance, 1);
        result = $642245f23a3b0f5d$export$bf5c4cf060303d58($642245f23a3b0f5d$export$4d299b491347818a);
    }
    var root = result;
    var setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        var keys = Object.keys(fallthroughAttrs);
        var shapeFlag = root.shapeFlag;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $3ZJCa.isModelListener))) fallthroughAttrs = $642245f23a3b0f5d$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $642245f23a3b0f5d$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $642245f23a3b0f5d$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) $642245f23a3b0f5d$export$7770a22486565649(root, vnode.transition);
    result = root;
    $642245f23a3b0f5d$var$setCurrentRenderingInstance(prev);
    return result;
}
var $642245f23a3b0f5d$var$getChildRoot = function(vnode) {
    var rawChildren = vnode.children;
    var dynamicChildren = vnode.dynamicChildren;
    var childRoot = $642245f23a3b0f5d$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    var index = rawChildren.indexOf(childRoot);
    var dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    var setRoot = function(updatedRoot) {
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = (0, $kf9Kn._)(dynamicChildren).concat([
                updatedRoot
            ]);
        }
    };
    return [
        $642245f23a3b0f5d$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $642245f23a3b0f5d$var$filterSingleRoot(children) {
    var recurse = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var singleRoot;
    for(var i = 0; i < children.length; i++){
        var child = children[i];
        if ($642245f23a3b0f5d$export$3868d13f8734ae81(child)) {
            if (child.type !== $642245f23a3b0f5d$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
var $642245f23a3b0f5d$var$getFunctionalFallthrough = function(attrs) {
    var res;
    for(var key in attrs)if (key === "class" || key === "style" || (0, $3ZJCa.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
var $642245f23a3b0f5d$var$filterModelListeners = function(attrs, props) {
    var res = {};
    for(var key in attrs)if (!(0, $3ZJCa.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
var $642245f23a3b0f5d$var$isElementRoot = function(vnode) {
    return vnode.shapeFlag & 7 || vnode.type === $642245f23a3b0f5d$export$4d299b491347818a;
};
function $642245f23a3b0f5d$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    var prevProps = prevVNode.props, prevChildren = prevVNode.children, component = prevVNode.component;
    var nextProps = nextVNode.props, nextChildren = nextVNode.children, patchFlag = nextVNode.patchFlag;
    var emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $642245f23a3b0f5d$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            var dynamicProps = nextVNode.dynamicProps;
            for(var i = 0; i < dynamicProps.length; i++){
                var key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$642245f23a3b0f5d$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $642245f23a3b0f5d$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $642245f23a3b0f5d$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    var nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(var i = 0; i < nextKeys.length; i++){
        var key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$642245f23a3b0f5d$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $642245f23a3b0f5d$var$updateHOCHostEl(param, el) {
    var vnode = param.vnode, parent = param.parent;
    while(parent){
        var root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) root.el = vnode.el;
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
}
var $642245f23a3b0f5d$var$isSuspense = function(type) {
    return type.__isSuspense;
};
var $642245f23a3b0f5d$var$suspenseId = 0;
var $642245f23a3b0f5d$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process: function(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $642245f23a3b0f5d$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $642245f23a3b0f5d$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $642245f23a3b0f5d$var$hydrateSuspense,
    normalize: $642245f23a3b0f5d$var$normalizeSuspenseChildren
};
var $642245f23a3b0f5d$export$74bf444e3cd11ea5 = $642245f23a3b0f5d$var$SuspenseImpl;
function $642245f23a3b0f5d$var$triggerEvent(vnode, name) {
    var eventListener = vnode.props && vnode.props[name];
    if ((0, $3ZJCa.isFunction)(eventListener)) eventListener();
}
function $642245f23a3b0f5d$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    var patch = rendererInternals.p, createElement = rendererInternals.o.createElement;
    var hiddenContainer = createElement("div");
    var suspense = vnode.suspense = $642245f23a3b0f5d$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $642245f23a3b0f5d$var$triggerEvent(vnode, "onPending");
        $642245f23a3b0f5d$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $642245f23a3b0f5d$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $642245f23a3b0f5d$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, param) {
    var patch = param.p, unmount = param.um, createElement = param.o.createElement;
    var suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    var newBranch = n2.ssContent;
    var newFallback = n2.ssFallback;
    var activeBranch = suspense.activeBranch, pendingBranch = suspense.pendingBranch, isInFallback = suspense.isInFallback, isHydrating = suspense.isHydrating;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($642245f23a3b0f5d$var$isSameVNodeType(pendingBranch, newBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $642245f23a3b0f5d$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $642245f23a3b0f5d$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $642245f23a3b0f5d$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $642245f23a3b0f5d$var$isSameVNodeType(activeBranch, newBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $642245f23a3b0f5d$var$isSameVNodeType(activeBranch, newBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $642245f23a3b0f5d$var$setActiveBranch(suspense, newBranch);
    } else {
        $642245f23a3b0f5d$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $642245f23a3b0f5d$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            var timeout = suspense.timeout, pendingId = suspense.pendingId;
            if (timeout > 0) setTimeout(function() {
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
var $642245f23a3b0f5d$var$hasWarned = false;
function $642245f23a3b0f5d$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals) {
    var isHydrating = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : false;
    var patch = rendererInternals.p, move = rendererInternals.m, unmount = rendererInternals.um, next = rendererInternals.n, _rendererInternals_o = rendererInternals.o, parentNode = _rendererInternals_o.parentNode, remove = _rendererInternals_o.remove;
    var parentSuspenseId;
    var isSuspensible = $642245f23a3b0f5d$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    var timeout = vnode.props ? (0, $3ZJCa.toNumber)(vnode.props.timeout) : void 0;
    var initialAnchor = anchor;
    var suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $642245f23a3b0f5d$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve: function() {
            var resume = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, sync = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            var vnode2 = suspense.vnode, activeBranch = suspense.activeBranch, pendingBranch = suspense.pendingBranch, pendingId = suspense.pendingId, effects = suspense.effects, parentComponent2 = suspense.parentComponent, container2 = suspense.container;
            var delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = function() {
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        $642245f23a3b0f5d$export$59536a0199721cab(effects);
                    }
                };
                if (activeBranch) {
                    if (parentNode(activeBranch.el) === container2) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            $642245f23a3b0f5d$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            var parent = suspense.parent;
            var hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    var _parent_effects;
                    (_parent_effects = parent.effects).push.apply(_parent_effects, (0, $kf9Kn._)(effects));
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $642245f23a3b0f5d$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $642245f23a3b0f5d$var$triggerEvent(vnode2, "onResolve");
        },
        fallback: function(fallbackVNode) {
            if (!suspense.pendingBranch) return;
            var vnode2 = suspense.vnode, activeBranch = suspense.activeBranch, parentComponent2 = suspense.parentComponent, container2 = suspense.container, namespace2 = suspense.namespace;
            $642245f23a3b0f5d$var$triggerEvent(vnode2, "onFallback");
            var anchor2 = next(activeBranch);
            var mountFallback = function() {
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $642245f23a3b0f5d$var$setActiveBranch(suspense, fallbackVNode);
            };
            var delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move: function(container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next: function() {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep: function(instance, setupRenderEffect, optimized2) {
            var isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            var hydratedEl = instance.vnode.el;
            instance.asyncDep["catch"](function(err) {
                $642245f23a3b0f5d$export$d3da1ecaf1206c58(err, instance, 0);
            }).then(function(asyncSetupResult) {
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                var vnode2 = instance.vnode;
                $642245f23a3b0f5d$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                var placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized2);
                if (placeholder) remove(placeholder);
                $642245f23a3b0f5d$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount: function(parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $642245f23a3b0f5d$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    var suspense = vnode.suspense = $642245f23a3b0f5d$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    var result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $642245f23a3b0f5d$var$normalizeSuspenseChildren(vnode) {
    var shapeFlag = vnode.shapeFlag, children = vnode.children;
    var isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $642245f23a3b0f5d$var$normalizeSuspenseSlot(isSlotChildren ? children["default"] : children);
    vnode.ssFallback = isSlotChildren ? $642245f23a3b0f5d$var$normalizeSuspenseSlot(children.fallback) : $642245f23a3b0f5d$export$bf5c4cf060303d58($642245f23a3b0f5d$export$4d299b491347818a);
}
function $642245f23a3b0f5d$var$normalizeSuspenseSlot(s) {
    var block;
    if ((0, $3ZJCa.isFunction)(s)) {
        var trackBlock = $642245f23a3b0f5d$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $642245f23a3b0f5d$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $642245f23a3b0f5d$var$currentBlock;
            $642245f23a3b0f5d$var$closeBlock();
        }
    }
    if ((0, $3ZJCa.isArray)(s)) {
        var singleChild = $642245f23a3b0f5d$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $642245f23a3b0f5d$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter(function(c) {
        return c !== s;
    });
    return s;
}
function $642245f23a3b0f5d$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        var _suspense_effects;
        if ((0, $3ZJCa.isArray)(fn)) (_suspense_effects = suspense.effects).push.apply(_suspense_effects, (0, $kf9Kn._)(fn));
        else suspense.effects.push(fn);
    } else $642245f23a3b0f5d$export$59536a0199721cab(fn);
}
function $642245f23a3b0f5d$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    var vnode = suspense.vnode, parentComponent = suspense.parentComponent;
    var el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $642245f23a3b0f5d$var$updateHOCHostEl(parentComponent, el);
    }
}
function $642245f23a3b0f5d$var$isVNodeSuspensible(vnode) {
    var suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
var $642245f23a3b0f5d$export$ffb0004e005737fa = Symbol["for"]("v-fgt");
var $642245f23a3b0f5d$export$5f1af8db9871e1d6 = Symbol["for"]("v-txt");
var $642245f23a3b0f5d$export$4d299b491347818a = Symbol["for"]("v-cmt");
var $642245f23a3b0f5d$export$c1b9a1d3af45b7b6 = Symbol["for"]("v-stc");
var $642245f23a3b0f5d$var$blockStack = [];
var $642245f23a3b0f5d$var$currentBlock = null;
function $642245f23a3b0f5d$export$e7eaa45e502fe5cc() {
    var disableTracking = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    $642245f23a3b0f5d$var$blockStack.push($642245f23a3b0f5d$var$currentBlock = disableTracking ? null : []);
}
function $642245f23a3b0f5d$var$closeBlock() {
    $642245f23a3b0f5d$var$blockStack.pop();
    $642245f23a3b0f5d$var$currentBlock = $642245f23a3b0f5d$var$blockStack[$642245f23a3b0f5d$var$blockStack.length - 1] || null;
}
var $642245f23a3b0f5d$var$isBlockTreeEnabled = 1;
function $642245f23a3b0f5d$export$c20bee82f26f1e27(value) {
    var inVOnce = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    $642245f23a3b0f5d$var$isBlockTreeEnabled += value;
    if (value < 0 && $642245f23a3b0f5d$var$currentBlock && inVOnce) $642245f23a3b0f5d$var$currentBlock.hasOnce = true;
}
function $642245f23a3b0f5d$var$setupBlock(vnode) {
    vnode.dynamicChildren = $642245f23a3b0f5d$var$isBlockTreeEnabled > 0 ? $642245f23a3b0f5d$var$currentBlock || (0, $3ZJCa.EMPTY_ARR) : null;
    $642245f23a3b0f5d$var$closeBlock();
    if ($642245f23a3b0f5d$var$isBlockTreeEnabled > 0 && $642245f23a3b0f5d$var$currentBlock) $642245f23a3b0f5d$var$currentBlock.push(vnode);
    return vnode;
}
function $642245f23a3b0f5d$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $642245f23a3b0f5d$var$setupBlock($642245f23a3b0f5d$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $642245f23a3b0f5d$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $642245f23a3b0f5d$var$setupBlock($642245f23a3b0f5d$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $642245f23a3b0f5d$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $642245f23a3b0f5d$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
var $642245f23a3b0f5d$var$vnodeArgsTransformer;
function $642245f23a3b0f5d$export$83beccd3afeeb809(transformer) {
    $642245f23a3b0f5d$var$vnodeArgsTransformer = transformer;
}
var $642245f23a3b0f5d$var$createVNodeWithArgsTransform = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return $642245f23a3b0f5d$var$_createVNode.apply(void 0, (0, $kf9Kn._)($642245f23a3b0f5d$var$vnodeArgsTransformer ? $642245f23a3b0f5d$var$vnodeArgsTransformer(args, $642245f23a3b0f5d$var$currentRenderingInstance) : args));
};
var $642245f23a3b0f5d$var$normalizeKey = function(param) {
    var key = param.key;
    return key != null ? key : null;
};
var $642245f23a3b0f5d$var$normalizeRef = function(param) {
    var ref = param.ref, ref_key = param.ref_key, ref_for = param.ref_for;
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $3ZJCa.isString)(ref) || (0, $5wB2C.isRef)(ref) || (0, $3ZJCa.isFunction)(ref) ? {
        i: $642245f23a3b0f5d$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $642245f23a3b0f5d$export$42098e0eaa15c48e(type) {
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, children = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, patchFlag = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, dynamicProps = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, shapeFlag = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : type === $642245f23a3b0f5d$export$ffb0004e005737fa ? 0 : 1, isBlockNode = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false, needFullChildrenNormalization = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : false;
    var vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $642245f23a3b0f5d$var$normalizeKey(props),
        ref: props && $642245f23a3b0f5d$var$normalizeRef(props),
        scopeId: $642245f23a3b0f5d$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $642245f23a3b0f5d$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $642245f23a3b0f5d$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $3ZJCa.isString)(children) ? 8 : 16;
    if ($642245f23a3b0f5d$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $642245f23a3b0f5d$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $642245f23a3b0f5d$var$currentBlock.push(vnode);
    return vnode;
}
var $642245f23a3b0f5d$export$bf5c4cf060303d58 = $642245f23a3b0f5d$var$_createVNode;
function $642245f23a3b0f5d$var$_createVNode(type) {
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, children = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, patchFlag = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, dynamicProps = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, isBlockNode = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    if (!type || type === $642245f23a3b0f5d$var$NULL_DYNAMIC_COMPONENT) type = $642245f23a3b0f5d$export$4d299b491347818a;
    if ($642245f23a3b0f5d$export$3868d13f8734ae81(type)) {
        var cloned = $642245f23a3b0f5d$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $642245f23a3b0f5d$var$normalizeChildren(cloned, children);
        if ($642245f23a3b0f5d$var$isBlockTreeEnabled > 0 && !isBlockNode && $642245f23a3b0f5d$var$currentBlock) {
            if (cloned.shapeFlag & 6) $642245f23a3b0f5d$var$currentBlock[$642245f23a3b0f5d$var$currentBlock.indexOf(type)] = cloned;
            else $642245f23a3b0f5d$var$currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if ($642245f23a3b0f5d$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $642245f23a3b0f5d$export$1f1be0e0e384d7d2(props);
        var klass = props["class"], style = props.style;
        if (klass && !(0, $3ZJCa.isString)(klass)) props["class"] = (0, $3ZJCa.normalizeClass)(klass);
        if ((0, $3ZJCa.isObject)(style)) {
            if ((0, $5wB2C.isProxy)(style) && !(0, $3ZJCa.isArray)(style)) style = (0, $3ZJCa.extend)({}, style);
            props.style = (0, $3ZJCa.normalizeStyle)(style);
        }
    }
    var shapeFlag = (0, $3ZJCa.isString)(type) ? 1 : $642245f23a3b0f5d$var$isSuspense(type) ? 128 : $642245f23a3b0f5d$var$isTeleport(type) ? 64 : (0, $3ZJCa.isObject)(type) ? 4 : (0, $3ZJCa.isFunction)(type) ? 2 : 0;
    return $642245f23a3b0f5d$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $642245f23a3b0f5d$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $5wB2C.isProxy)(props) || $642245f23a3b0f5d$var$isInternalObject(props) ? (0, $3ZJCa.extend)({}, props) : props;
}
function $642245f23a3b0f5d$export$ee4f9e12c0a92a1a(vnode, extraProps) {
    var mergeRef = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, cloneTransition = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var props = vnode.props, ref = vnode.ref, patchFlag = vnode.patchFlag, children = vnode.children, transition = vnode.transition;
    var mergedProps = extraProps ? $642245f23a3b0f5d$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    var cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $642245f23a3b0f5d$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $3ZJCa.isArray)(ref) ? ref.concat($642245f23a3b0f5d$var$normalizeRef(extraProps)) : [
            ref,
            $642245f23a3b0f5d$var$normalizeRef(extraProps)
        ] : $642245f23a3b0f5d$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $642245f23a3b0f5d$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $642245f23a3b0f5d$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $642245f23a3b0f5d$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        placeholder: vnode.placeholder,
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) $642245f23a3b0f5d$export$7770a22486565649(cloned, transition.clone(cloned));
    return cloned;
}
function $642245f23a3b0f5d$var$deepCloneVNode(vnode) {
    var cloned = $642245f23a3b0f5d$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $3ZJCa.isArray)(vnode.children)) cloned.children = vnode.children.map($642245f23a3b0f5d$var$deepCloneVNode);
    return cloned;
}
function $642245f23a3b0f5d$export$22f9b5ffd89dac9() {
    var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : " ", flag = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $642245f23a3b0f5d$export$bf5c4cf060303d58($642245f23a3b0f5d$export$5f1af8db9871e1d6, null, text, flag);
}
function $642245f23a3b0f5d$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    var vnode = $642245f23a3b0f5d$export$bf5c4cf060303d58($642245f23a3b0f5d$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $642245f23a3b0f5d$export$49553837c7236d3c() {
    var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", asBlock = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return asBlock ? ($642245f23a3b0f5d$export$e7eaa45e502fe5cc(), $642245f23a3b0f5d$export$9f2dfe8048dfb22b($642245f23a3b0f5d$export$4d299b491347818a, null, text)) : $642245f23a3b0f5d$export$bf5c4cf060303d58($642245f23a3b0f5d$export$4d299b491347818a, null, text);
}
function $642245f23a3b0f5d$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $642245f23a3b0f5d$export$bf5c4cf060303d58($642245f23a3b0f5d$export$4d299b491347818a);
    else if ((0, $3ZJCa.isArray)(child)) return $642245f23a3b0f5d$export$bf5c4cf060303d58($642245f23a3b0f5d$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if ($642245f23a3b0f5d$export$3868d13f8734ae81(child)) return $642245f23a3b0f5d$var$cloneIfMounted(child);
    else return $642245f23a3b0f5d$export$bf5c4cf060303d58($642245f23a3b0f5d$export$5f1af8db9871e1d6, null, String(child));
}
function $642245f23a3b0f5d$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $642245f23a3b0f5d$export$ee4f9e12c0a92a1a(child);
}
function $642245f23a3b0f5d$var$normalizeChildren(vnode, children) {
    var type = 0;
    var shapeFlag = vnode.shapeFlag;
    if (children == null) children = null;
    else if ((0, $3ZJCa.isArray)(children)) type = 16;
    else if ((typeof children === "undefined" ? "undefined" : (0, $6gBIz._)(children)) === "object") {
        if (shapeFlag & 65) {
            var slot = children["default"];
            if (slot) {
                slot._c && (slot._d = false);
                $642245f23a3b0f5d$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            var slotFlag = children._;
            if (!slotFlag && !$642245f23a3b0f5d$var$isInternalObject(children)) children._ctx = $642245f23a3b0f5d$var$currentRenderingInstance;
            else if (slotFlag === 3 && $642245f23a3b0f5d$var$currentRenderingInstance) {
                if ($642245f23a3b0f5d$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $3ZJCa.isFunction)(children)) {
        children = {
            "default": children,
            _ctx: $642245f23a3b0f5d$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $642245f23a3b0f5d$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $642245f23a3b0f5d$export$9d1611c77c2fe928() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var ret = {};
    for(var i = 0; i < args.length; i++){
        var toMerge = args[i];
        for(var key in toMerge){
            if (key === "class") {
                if (ret["class"] !== toMerge["class"]) ret["class"] = (0, $3ZJCa.normalizeClass)([
                    ret["class"],
                    toMerge["class"]
                ]);
            } else if (key === "style") ret.style = (0, $3ZJCa.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $3ZJCa.isOn)(key)) {
                var existing = ret[key];
                var incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $3ZJCa.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $642245f23a3b0f5d$var$invokeVNodeHook(hook, instance, vnode) {
    var prevVNode = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    $642245f23a3b0f5d$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
var $642245f23a3b0f5d$var$emptyAppContext = $642245f23a3b0f5d$var$createAppContext();
var $642245f23a3b0f5d$var$uid = 0;
function $642245f23a3b0f5d$var$createComponentInstance(vnode, parent, suspense) {
    var type = vnode.type;
    var appContext = (parent ? parent.appContext : vnode.appContext) || $642245f23a3b0f5d$var$emptyAppContext;
    var instance = {
        uid: $642245f23a3b0f5d$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        job: null,
        scope: new (0, $5wB2C.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $642245f23a3b0f5d$var$normalizePropsOptions(type, appContext),
        emitsOptions: $642245f23a3b0f5d$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $3ZJCa.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $3ZJCa.EMPTY_OBJ),
        data: (0, $3ZJCa.EMPTY_OBJ),
        props: (0, $3ZJCa.EMPTY_OBJ),
        attrs: (0, $3ZJCa.EMPTY_OBJ),
        slots: (0, $3ZJCa.EMPTY_OBJ),
        refs: (0, $3ZJCa.EMPTY_OBJ),
        setupState: (0, $3ZJCa.EMPTY_OBJ),
        setupContext: null,
        // suspense related
        suspense: suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $642245f23a3b0f5d$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
var $642245f23a3b0f5d$var$currentInstance = null;
var $642245f23a3b0f5d$export$f13e630aa3915748 = function() {
    return $642245f23a3b0f5d$var$currentInstance || $642245f23a3b0f5d$var$currentRenderingInstance;
};
var $642245f23a3b0f5d$var$internalSetCurrentInstance;
var $642245f23a3b0f5d$var$setInSSRSetupState;
{
    var $642245f23a3b0f5d$var$g = (0, $3ZJCa.getGlobalThis)();
    var $642245f23a3b0f5d$var$registerGlobalSetter = function(key, setter) {
        var setters;
        if (!(setters = $642245f23a3b0f5d$var$g[key])) setters = $642245f23a3b0f5d$var$g[key] = [];
        setters.push(setter);
        return function(v1) {
            if (setters.length > 1) setters.forEach(function(set) {
                return set(v1);
            });
            else setters[0](v1);
        };
    };
    $642245f23a3b0f5d$var$internalSetCurrentInstance = $642245f23a3b0f5d$var$registerGlobalSetter("__VUE_INSTANCE_SETTERS__", function(v1) {
        return $642245f23a3b0f5d$var$currentInstance = v1;
    });
    $642245f23a3b0f5d$var$setInSSRSetupState = $642245f23a3b0f5d$var$registerGlobalSetter("__VUE_SSR_SETTERS__", function(v1) {
        return $642245f23a3b0f5d$var$isInSSRComponentSetup = v1;
    });
}var $642245f23a3b0f5d$var$setCurrentInstance = function(instance) {
    var prev = $642245f23a3b0f5d$var$currentInstance;
    $642245f23a3b0f5d$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return function() {
        instance.scope.off();
        $642245f23a3b0f5d$var$internalSetCurrentInstance(prev);
    };
};
var $642245f23a3b0f5d$var$unsetCurrentInstance = function() {
    $642245f23a3b0f5d$var$currentInstance && $642245f23a3b0f5d$var$currentInstance.scope.off();
    $642245f23a3b0f5d$var$internalSetCurrentInstance(null);
};
var $642245f23a3b0f5d$var$isBuiltInTag = /* @__PURE__ */ (0, $3ZJCa.makeMap)("slot,component");
function $642245f23a3b0f5d$var$validateComponentName(name, param) {
    var isNativeTag = param.isNativeTag;
    if ($642245f23a3b0f5d$var$isBuiltInTag(name) || isNativeTag(name)) $642245f23a3b0f5d$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $642245f23a3b0f5d$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
var $642245f23a3b0f5d$var$isInSSRComponentSetup = false;
function $642245f23a3b0f5d$var$setupComponent(instance) {
    var isSSR = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, optimized = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    isSSR && $642245f23a3b0f5d$var$setInSSRSetupState(isSSR);
    var _instance_vnode = instance.vnode, props = _instance_vnode.props, children = _instance_vnode.children;
    var isStateful = $642245f23a3b0f5d$var$isStatefulComponent(instance);
    $642245f23a3b0f5d$var$initProps(instance, props, isStateful, isSSR);
    $642245f23a3b0f5d$var$initSlots(instance, children, optimized || isSSR);
    var setupResult = isStateful ? $642245f23a3b0f5d$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $642245f23a3b0f5d$var$setInSSRSetupState(false);
    return setupResult;
}
function $642245f23a3b0f5d$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    var Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $642245f23a3b0f5d$var$PublicInstanceProxyHandlers);
    var setup = Component.setup;
    if (setup) {
        (0, $5wB2C.pauseTracking)();
        var setupContext = instance.setupContext = setup.length > 1 ? $642245f23a3b0f5d$var$createSetupContext(instance) : null;
        var reset = $642245f23a3b0f5d$var$setCurrentInstance(instance);
        var setupResult = $642245f23a3b0f5d$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        var isAsyncSetup = (0, $3ZJCa.isPromise)(setupResult);
        (0, $5wB2C.resetTracking)();
        reset();
        if ((isAsyncSetup || instance.sp) && !$642245f23a3b0f5d$var$isAsyncWrapper(instance)) $642245f23a3b0f5d$var$markAsyncBoundary(instance);
        if (isAsyncSetup) {
            setupResult.then($642245f23a3b0f5d$var$unsetCurrentInstance, $642245f23a3b0f5d$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then(function(resolvedResult) {
                $642245f23a3b0f5d$var$handleSetupResult(instance, resolvedResult, isSSR);
            })["catch"](function(e) {
                $642245f23a3b0f5d$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $642245f23a3b0f5d$var$handleSetupResult(instance, setupResult, isSSR);
    } else $642245f23a3b0f5d$var$finishComponentSetup(instance, isSSR);
}
function $642245f23a3b0f5d$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $3ZJCa.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $3ZJCa.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $5wB2C.proxyRefs)(setupResult);
    }
    $642245f23a3b0f5d$var$finishComponentSetup(instance, isSSR);
}
var $642245f23a3b0f5d$var$compile;
var $642245f23a3b0f5d$var$installWithProxy;
function $642245f23a3b0f5d$export$667bb5a67822b941(_compile) {
    $642245f23a3b0f5d$var$compile = _compile;
    $642245f23a3b0f5d$var$installWithProxy = function(i) {
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $642245f23a3b0f5d$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
var $642245f23a3b0f5d$export$c93a9c496c5211fa = function() {
    return !$642245f23a3b0f5d$var$compile;
};
function $642245f23a3b0f5d$var$finishComponentSetup(instance, isSSR, skipOptions) {
    var Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $642245f23a3b0f5d$var$compile && !Component.render) {
            var template = Component.template || __VUE_OPTIONS_API__ && $642245f23a3b0f5d$var$resolveMergedOptions(instance).template;
            if (template) {
                var _instance_appContext_config = instance.appContext.config, isCustomElement = _instance_appContext_config.isCustomElement, compilerOptions = _instance_appContext_config.compilerOptions;
                var delimiters = Component.delimiters, componentCompilerOptions = Component.compilerOptions;
                var finalCompilerOptions = (0, $3ZJCa.extend)((0, $3ZJCa.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $642245f23a3b0f5d$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $3ZJCa.NOOP);
        if ($642245f23a3b0f5d$var$installWithProxy) $642245f23a3b0f5d$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        var reset = $642245f23a3b0f5d$var$setCurrentInstance(instance);
        (0, $5wB2C.pauseTracking)();
        try {
            $642245f23a3b0f5d$var$applyOptions(instance);
        } finally{
            (0, $5wB2C.resetTracking)();
            reset();
        }
    }
}
var $642245f23a3b0f5d$var$attrsProxyHandlers = {
    get: function(target, key) {
        (0, $5wB2C.track)(target, "get", "");
        return target[key];
    }
};
function $642245f23a3b0f5d$var$getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get: function(target, key) {
            (0, $5wB2C.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function $642245f23a3b0f5d$var$createSetupContext(instance) {
    var expose = function(exposed) {
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $642245f23a3b0f5d$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $642245f23a3b0f5d$var$getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $5wB2C.proxyRefs)((0, $5wB2C.markRaw)(instance.exposed)), {
        get: function(target, key) {
            if (key in target) return target[key];
            else if (key in $642245f23a3b0f5d$var$publicPropertiesMap) return $642245f23a3b0f5d$var$publicPropertiesMap[key](instance);
        },
        has: function(target, key) {
            return key in target || key in $642245f23a3b0f5d$var$publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
var $642245f23a3b0f5d$var$classifyRE = /(?:^|[-_])\w/g;
var $642245f23a3b0f5d$var$classify = function(str) {
    return str.replace($642245f23a3b0f5d$var$classifyRE, function(c) {
        return c.toUpperCase();
    }).replace(/[-_]/g, "");
};
function $642245f23a3b0f5d$var$getComponentName(Component) {
    var includeInferred = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    return (0, $3ZJCa.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $642245f23a3b0f5d$var$formatComponentName(instance, Component) {
    var isRoot = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var name = $642245f23a3b0f5d$var$getComponentName(Component);
    if (!name && Component.__file) {
        var match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        var inferFromRegistry = function(registry) {
            for(var key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $642245f23a3b0f5d$var$classify(name) : isRoot ? "App" : "Anonymous";
}
function $642245f23a3b0f5d$var$isClassComponent(value) {
    return (0, $3ZJCa.isFunction)(value) && "__vccOpts" in value;
}
var $642245f23a3b0f5d$export$2983e091f1a1e8e2 = function(getterOrOptions, debugOptions) {
    var c = (0, $5wB2C.computed)(getterOrOptions, debugOptions, $642245f23a3b0f5d$var$isInSSRComponentSetup);
    return c;
};
function $642245f23a3b0f5d$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    try {
        $642245f23a3b0f5d$export$c20bee82f26f1e27(-1);
        var l = arguments.length;
        if (l === 2) {
            if ((0, $3ZJCa.isObject)(propsOrChildren) && !(0, $3ZJCa.isArray)(propsOrChildren)) {
                if ($642245f23a3b0f5d$export$3868d13f8734ae81(propsOrChildren)) return $642245f23a3b0f5d$export$bf5c4cf060303d58(type, null, [
                    propsOrChildren
                ]);
                return $642245f23a3b0f5d$export$bf5c4cf060303d58(type, propsOrChildren);
            } else return $642245f23a3b0f5d$export$bf5c4cf060303d58(type, null, propsOrChildren);
        } else {
            if (l > 3) children = Array.prototype.slice.call(arguments, 2);
            else if (l === 3 && $642245f23a3b0f5d$export$3868d13f8734ae81(children)) children = [
                children
            ];
            return $642245f23a3b0f5d$export$bf5c4cf060303d58(type, propsOrChildren, children);
        }
    } finally{
        $642245f23a3b0f5d$export$c20bee82f26f1e27(1);
    }
}
function $642245f23a3b0f5d$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        var blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $5wB2C.toRaw)(instance.props)));
        if (instance.setupState !== (0, $3ZJCa.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $3ZJCa.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $5wB2C.toRaw)(instance.data)));
        var computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        var injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $3ZJCa.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                }
            ].concat((0, $kf9Kn._)(Object.keys(target).map(function(key) {
                return [
                    "div",
                    {},
                    [
                        "span",
                        keywordStyle,
                        key + ": "
                    ],
                    formatValue(target[key], false)
                ];
            })))
        ];
    }
    function formatValue(v1) {
        var asRaw = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $3ZJCa.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $5wB2C.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        var Comp = instance.type;
        if ((0, $3ZJCa.isFunction)(Comp)) return;
        var extracted = {};
        for(var key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        var opts = Comp[type];
        if ((0, $3ZJCa.isArray)(opts) && opts.includes(key) || (0, $3ZJCa.isObject)(opts) && key in opts) return true;
        if (Comp["extends"] && isKeyOfType(Comp["extends"], key, type)) return true;
        if (Comp.mixins && Comp.mixins.some(function(m) {
            return isKeyOfType(m, key, type);
        })) return true;
    }
    function genRefFlag(v1) {
        if ((0, $5wB2C.isShallow)(v1)) return "ShallowRef";
        if (v1.effect) return "ComputedRef";
        return "Ref";
    }
}
function $642245f23a3b0f5d$export$2a6d714a4d738ae(memo, render, cache, index) {
    var cached = cache[index];
    if (cached && $642245f23a3b0f5d$export$bf525184d622787c(cached, memo)) return cached;
    var ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function $642245f23a3b0f5d$export$bf525184d622787c(cached, memo) {
    var prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(var i = 0; i < prev.length; i++){
        if ((0, $3ZJCa.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($642245f23a3b0f5d$var$isBlockTreeEnabled > 0 && $642245f23a3b0f5d$var$currentBlock) $642245f23a3b0f5d$var$currentBlock.push(cached);
    return true;
}
var $642245f23a3b0f5d$export$83d89fbfd8236492 = "3.5.22";
var $642245f23a3b0f5d$export$c106dd0671a0fc2d = (0, $3ZJCa.NOOP);
var $642245f23a3b0f5d$export$795e0ad4a0e2ed30 = $642245f23a3b0f5d$var$ErrorTypeStrings$1;
var $642245f23a3b0f5d$export$6922d3b3a607469e = $642245f23a3b0f5d$var$devtools$1;
var $642245f23a3b0f5d$export$b0c258b32c26c785 = $642245f23a3b0f5d$var$setDevtoolsHook$1;
var $642245f23a3b0f5d$var$_ssrUtils = {
    createComponentInstance: $642245f23a3b0f5d$var$createComponentInstance,
    setupComponent: $642245f23a3b0f5d$var$setupComponent,
    renderComponentRoot: $642245f23a3b0f5d$var$renderComponentRoot,
    setCurrentRenderingInstance: $642245f23a3b0f5d$var$setCurrentRenderingInstance,
    isVNode: $642245f23a3b0f5d$export$3868d13f8734ae81,
    normalizeVNode: $642245f23a3b0f5d$var$normalizeVNode,
    getComponentPublicInstance: $642245f23a3b0f5d$var$getComponentPublicInstance,
    ensureValidVNode: $642245f23a3b0f5d$var$ensureValidVNode,
    pushWarningContext: $642245f23a3b0f5d$var$pushWarningContext,
    popWarningContext: $642245f23a3b0f5d$var$popWarningContext
};
var $642245f23a3b0f5d$export$a9679033567b336d = $642245f23a3b0f5d$var$_ssrUtils;
var $642245f23a3b0f5d$export$83cf26e06ea620e1 = null;
var $642245f23a3b0f5d$export$dc678eddf276286e = null;
var $642245f23a3b0f5d$export$22072a82865312f6 = null;

});
parcelRegister("5wB2C", function(module, exports) {

$parcel$export(module.exports, "EffectScope", function () { return EffectScope; });
$parcel$export(module.exports, "getCurrentScope", function () { return getCurrentScope; });
$parcel$export(module.exports, "onScopeDispose", function () { return onScopeDispose; });
$parcel$export(module.exports, "ReactiveEffect", function () { return ReactiveEffect; });
$parcel$export(module.exports, "pauseTracking", function () { return pauseTracking; });
$parcel$export(module.exports, "resetTracking", function () { return resetTracking; });
$parcel$export(module.exports, "track", function () { return track; });
$parcel$export(module.exports, "trigger", function () { return trigger; });
$parcel$export(module.exports, "toRaw", function () { return toRaw; });
$parcel$export(module.exports, "isShallow", function () { return isShallow; });
$parcel$export(module.exports, "toReactive", function () { return toReactive; });
$parcel$export(module.exports, "shallowReadArray", function () { return shallowReadArray; });
$parcel$export(module.exports, "isProxy", function () { return isProxy; });
$parcel$export(module.exports, "isRef", function () { return isRef; });
$parcel$export(module.exports, "readonly", function () { return readonly; });
$parcel$export(module.exports, "reactive", function () { return reactive; });
$parcel$export(module.exports, "isReadonly", function () { return isReadonly; });
$parcel$export(module.exports, "toReadonly", function () { return toReadonly; });
$parcel$export(module.exports, "shallowReactive", function () { return shallowReactive; });
$parcel$export(module.exports, "isReactive", function () { return isReactive; });
$parcel$export(module.exports, "markRaw", function () { return markRaw; });
$parcel$export(module.exports, "ref", function () { return ref; });
$parcel$export(module.exports, "shallowRef", function () { return shallowRef; });
$parcel$export(module.exports, "triggerRef", function () { return triggerRef; });
$parcel$export(module.exports, "unref", function () { return unref; });
$parcel$export(module.exports, "proxyRefs", function () { return proxyRefs; });
$parcel$export(module.exports, "customRef", function () { return customRef; });
$parcel$export(module.exports, "toRefs", function () { return toRefs; });
$parcel$export(module.exports, "toRef", function () { return toRef; });
$parcel$export(module.exports, "computed", function () { return computed; });
$parcel$export(module.exports, "watch", function () { return watch; });
$parcel$export(module.exports, "traverse", function () { return traverse; });
/**
* @vue/reactivity v3.5.22
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $1mRNr = parcelRequire("1mRNr");

var $1UdHD = parcelRequire("1UdHD");

var $iH1wO = parcelRequire("iH1wO");

var $aRIHe = parcelRequire("aRIHe");

var $h4SHl = parcelRequire("h4SHl");

var $kf9Kn = parcelRequire("kf9Kn");

var $3ZJCa = parcelRequire("3ZJCa");
function warn(msg) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _console;
    (_console = console).warn.apply(_console, [
        "[Vue warn] ".concat(msg)
    ].concat((0, $kf9Kn._)(args)));
}
var activeEffectScope;
var EffectScope = /*#__PURE__*/ function() {
    "use strict";
    function EffectScope() {
        var detached = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        (0, $1UdHD._)(this, EffectScope);
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal track `on` calls, allow `on` call multiple times
     */ this._on = 0;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this._isPaused = false;
        this.parent = activeEffectScope;
        if (!detached && activeEffectScope) this.index = (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(this) - 1;
    }
    (0, $iH1wO._)(EffectScope, [
        {
            key: "active",
            get: function get() {
                return this._active;
            }
        },
        {
            key: "pause",
            value: function pause() {
                if (this._active) {
                    this._isPaused = true;
                    var i, l;
                    if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].pause();
                    for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].pause();
                }
            }
        },
        {
            /**
   * Resumes the effect scope, including all child scopes and effects.
   */ key: "resume",
            value: function resume() {
                if (this._active) {
                    if (this._isPaused) {
                        this._isPaused = false;
                        var i, l;
                        if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].resume();
                        for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].resume();
                    }
                }
            }
        },
        {
            key: "run",
            value: function run(fn) {
                if (this._active) {
                    var currentEffectScope = activeEffectScope;
                    try {
                        activeEffectScope = this;
                        return fn();
                    } finally{
                        activeEffectScope = currentEffectScope;
                    }
                }
            }
        },
        {
            /**
   * This should only be called on non-detached scopes
   * @internal
   */ key: "on",
            value: function on() {
                if (++this._on === 1) {
                    this.prevScope = activeEffectScope;
                    activeEffectScope = this;
                }
            }
        },
        {
            /**
   * This should only be called on non-detached scopes
   * @internal
   */ key: "off",
            value: function off() {
                if (this._on > 0 && --this._on === 0) {
                    activeEffectScope = this.prevScope;
                    this.prevScope = void 0;
                }
            }
        },
        {
            key: "stop",
            value: function stop(fromParent) {
                if (this._active) {
                    this._active = false;
                    var i, l;
                    for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
                    this.effects.length = 0;
                    for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
                    this.cleanups.length = 0;
                    if (this.scopes) {
                        for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
                        this.scopes.length = 0;
                    }
                    if (!this.detached && this.parent && !fromParent) {
                        var last = this.parent.scopes.pop();
                        if (last && last !== this) {
                            this.parent.scopes[this.index] = last;
                            last.index = this.index;
                        }
                    }
                    this.parent = void 0;
                }
            }
        }
    ]);
    return EffectScope;
}();
function effectScope(detached) {
    return new EffectScope(detached);
}
function getCurrentScope() {
    return activeEffectScope;
}
function onScopeDispose(fn) {
    var failSilently = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (activeEffectScope) activeEffectScope.cleanups.push(fn);
}
var activeSub;
var EffectFlags = {
    ACTIVE: 1,
    "1": "ACTIVE",
    RUNNING: 2,
    "2": "RUNNING",
    TRACKING: 4,
    "4": "TRACKING",
    NOTIFIED: 8,
    "8": "NOTIFIED",
    DIRTY: 16,
    "16": "DIRTY",
    ALLOW_RECURSE: 32,
    "32": "ALLOW_RECURSE",
    PAUSED: 64,
    "64": "PAUSED",
    EVALUATED: 128,
    "128": "EVALUATED"
};
var pausedQueueEffects = /* @__PURE__ */ new WeakSet();
var ReactiveEffect = /*#__PURE__*/ function() {
    "use strict";
    function ReactiveEffect(fn) {
        (0, $1UdHD._)(this, ReactiveEffect);
        this.fn = fn;
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 5;
        /**
     * @internal
     */ this.next = void 0;
        /**
     * @internal
     */ this.cleanup = void 0;
        this.scheduler = void 0;
        if (activeEffectScope && activeEffectScope.active) activeEffectScope.effects.push(this);
    }
    (0, $iH1wO._)(ReactiveEffect, [
        {
            key: "pause",
            value: function pause() {
                this.flags |= 64;
            }
        },
        {
            key: "resume",
            value: function resume() {
                if (this.flags & 64) {
                    this.flags &= -65;
                    if (pausedQueueEffects.has(this)) {
                        pausedQueueEffects["delete"](this);
                        this.trigger();
                    }
                }
            }
        },
        {
            /**
   * @internal
   */ key: "notify",
            value: function notify() {
                if (this.flags & 2 && !(this.flags & 32)) return;
                if (!(this.flags & 8)) batch(this);
            }
        },
        {
            key: "run",
            value: function run() {
                if (!(this.flags & 1)) return this.fn();
                this.flags |= 2;
                cleanupEffect(this);
                prepareDeps(this);
                var prevEffect = activeSub;
                var prevShouldTrack = shouldTrack;
                activeSub = this;
                shouldTrack = true;
                try {
                    return this.fn();
                } finally{
                    cleanupDeps(this);
                    activeSub = prevEffect;
                    shouldTrack = prevShouldTrack;
                    this.flags &= -3;
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.flags & 1) {
                    for(var link = this.deps; link; link = link.nextDep)removeSub(link);
                    this.deps = this.depsTail = void 0;
                    cleanupEffect(this);
                    this.onStop && this.onStop();
                    this.flags &= -2;
                }
            }
        },
        {
            key: "trigger",
            value: function trigger() {
                if (this.flags & 64) pausedQueueEffects.add(this);
                else if (this.scheduler) this.scheduler();
                else this.runIfDirty();
            }
        },
        {
            /**
   * @internal
   */ key: "runIfDirty",
            value: function runIfDirty() {
                if (isDirty(this)) this.run();
            }
        },
        {
            key: "dirty",
            get: function get() {
                return isDirty(this);
            }
        }
    ]);
    return ReactiveEffect;
}();
var batchDepth = 0;
var batchedSub;
var batchedComputed;
function batch(sub) {
    var isComputed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    sub.flags |= 8;
    if (isComputed) {
        sub.next = batchedComputed;
        batchedComputed = sub;
        return;
    }
    sub.next = batchedSub;
    batchedSub = sub;
}
function startBatch() {
    batchDepth++;
}
function endBatch() {
    if (--batchDepth > 0) return;
    if (batchedComputed) {
        var e = batchedComputed;
        batchedComputed = void 0;
        while(e){
            var next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    var error;
    while(batchedSub){
        var e1 = batchedSub;
        batchedSub = void 0;
        while(e1){
            var next1 = e1.next;
            e1.next = void 0;
            e1.flags &= -9;
            if (e1.flags & 1) try {
                e1.trigger();
            } catch (err) {
                if (!error) error = err;
            }
            e1 = next1;
        }
    }
    if (error) throw error;
}
function prepareDeps(sub) {
    for(var link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function cleanupDeps(sub) {
    var head;
    var tail = sub.depsTail;
    var link = tail;
    while(link){
        var prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            removeSub(link);
            removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function isDirty(sub) {
    for(var link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && (refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === globalVersion) return;
    computed.globalVersion = globalVersion;
    if (!computed.isSSR && computed.flags & 128 && (!computed.deps && !computed._dirty || !isDirty(computed))) return;
    computed.flags |= 2;
    var dep = computed.dep;
    var prevSub = activeSub;
    var prevShouldTrack = shouldTrack;
    activeSub = computed;
    shouldTrack = true;
    try {
        prepareDeps(computed);
        var value = computed.fn(computed._value);
        if (dep.version === 0 || (0, $3ZJCa.hasChanged)(value, computed._value)) {
            computed.flags |= 128;
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        activeSub = prevSub;
        shouldTrack = prevShouldTrack;
        cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function removeSub(link) {
    var soft = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var dep = link.dep, prevSub = link.prevSub, nextSub = link.nextSub;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(var l = dep.computed.deps; l; l = l.nextDep)removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map["delete"](dep.key);
}
function removeDep(link) {
    var prevDep = link.prevDep, nextDep = link.nextDep;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function effect(fn, options) {
    if (fn.effect instanceof ReactiveEffect) fn = fn.effect.fn;
    var e = new ReactiveEffect(fn);
    if (options) (0, $3ZJCa.extend)(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    var runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function stop(runner) {
    runner.effect.stop();
}
var shouldTrack = true;
var trackStack = [];
function pauseTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = false;
}
function enableTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = true;
}
function resetTracking() {
    var last = trackStack.pop();
    shouldTrack = last === void 0 ? true : last;
}
function onEffectCleanup(fn) {
    var failSilently = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (activeSub instanceof ReactiveEffect) activeSub.cleanup = fn;
}
function cleanupEffect(e) {
    var cleanup = e.cleanup;
    e.cleanup = void 0;
    if (cleanup) {
        var prevSub = activeSub;
        activeSub = void 0;
        try {
            cleanup();
        } finally{
            activeSub = prevSub;
        }
    }
}
var globalVersion = 0;
var Link = function Link(sub, dep) {
    "use strict";
    (0, $1UdHD._)(this, Link);
    this.sub = sub;
    this.dep = dep;
    this.version = dep.version;
    this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
};
var Dep = /*#__PURE__*/ function() {
    "use strict";
    function Dep(computed) {
        (0, $1UdHD._)(this, Dep);
        this.computed = computed;
        this.version = 0;
        /**
     * Link between this dep and the current active effect
     */ this.activeLink = void 0;
        /**
     * Doubly linked list representing the subscribing effects (tail)
     */ this.subs = void 0;
        /**
     * For object property deps cleanup
     */ this.map = void 0;
        this.key = void 0;
        /**
     * Subscriber counter
     */ this.sc = 0;
        /**
     * @internal
     */ this.__v_skip = true;
    }
    (0, $iH1wO._)(Dep, [
        {
            key: "track",
            value: function track(debugInfo) {
                if (!activeSub || !shouldTrack || activeSub === this.computed) return;
                var link = this.activeLink;
                if (link === void 0 || link.sub !== activeSub) {
                    link = this.activeLink = new Link(activeSub, this);
                    if (!activeSub.deps) activeSub.deps = activeSub.depsTail = link;
                    else {
                        link.prevDep = activeSub.depsTail;
                        activeSub.depsTail.nextDep = link;
                        activeSub.depsTail = link;
                    }
                    addSub(link);
                } else if (link.version === -1) {
                    link.version = this.version;
                    if (link.nextDep) {
                        var next = link.nextDep;
                        next.prevDep = link.prevDep;
                        if (link.prevDep) link.prevDep.nextDep = next;
                        link.prevDep = activeSub.depsTail;
                        link.nextDep = void 0;
                        activeSub.depsTail.nextDep = link;
                        activeSub.depsTail = link;
                        if (activeSub.deps === link) activeSub.deps = next;
                    }
                }
                return link;
            }
        },
        {
            key: "trigger",
            value: function trigger(debugInfo) {
                this.version++;
                globalVersion++;
                this.notify(debugInfo);
            }
        },
        {
            key: "notify",
            value: function notify(debugInfo) {
                startBatch();
                try {
                    for(var link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
                } finally{
                    endBatch();
                }
            }
        }
    ]);
    return Dep;
}();
function addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        var computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(var l = computed.deps; l; l = l.nextDep)addSub(l);
        }
        var currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        link.dep.subs = link;
    }
}
var targetMap = /* @__PURE__ */ new WeakMap();
var ITERATE_KEY = Symbol("");
var MAP_KEY_ITERATE_KEY = Symbol("");
var ARRAY_ITERATE_KEY = Symbol("");
function track(target, type, key) {
    if (shouldTrack && activeSub) {
        var depsMap = targetMap.get(target);
        if (!depsMap) targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        var dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track();
    }
}
function trigger(target, type, key, newValue, oldValue, oldTarget) {
    var depsMap = targetMap.get(target);
    if (!depsMap) {
        globalVersion++;
        return;
    }
    var run = function(dep) {
        if (dep) dep.trigger();
    };
    startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        var targetIsArray = (0, $3ZJCa.isArray)(target);
        var isArrayIndex = targetIsArray && (0, $3ZJCa.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            var newLength = Number(newValue);
            depsMap.forEach(function(dep, key2) {
                if (key2 === "length" || key2 === ARRAY_ITERATE_KEY || !(0, $3ZJCa.isSymbol)(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get(ARRAY_ITERATE_KEY));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get(ITERATE_KEY));
                        if ((0, $3ZJCa.isMap)(target)) run(depsMap.get(MAP_KEY_ITERATE_KEY));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get(ITERATE_KEY));
                        if ((0, $3ZJCa.isMap)(target)) run(depsMap.get(MAP_KEY_ITERATE_KEY));
                    }
                    break;
                case "set":
                    if ((0, $3ZJCa.isMap)(target)) run(depsMap.get(ITERATE_KEY));
                    break;
            }
        }
    }
    endBatch();
}
function getDepFromReactive(object, key) {
    var depMap = targetMap.get(object);
    return depMap && depMap.get(key);
}
function reactiveReadArray(array) {
    var raw = toRaw(array);
    if (raw === array) return raw;
    track(raw, "iterate", ARRAY_ITERATE_KEY);
    return isShallow(array) ? raw : raw.map(toReactive);
}
function shallowReadArray(arr) {
    track(arr = toRaw(arr), "iterate", ARRAY_ITERATE_KEY);
    return arr;
}
var _obj;
var arrayInstrumentations = (_obj = {
    __proto__: null
}, (0, $aRIHe._)(_obj, Symbol.iterator, function() {
    return iterator(this, Symbol.iterator, toReactive);
}), (0, $aRIHe._)(_obj, "concat", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _reactiveReadArray;
    return (_reactiveReadArray = reactiveReadArray(this)).concat.apply(_reactiveReadArray, (0, $kf9Kn._)(args.map(function(x) {
        return (0, $3ZJCa.isArray)(x) ? reactiveReadArray(x) : x;
    })));
}), (0, $aRIHe._)(_obj, "entries", function() {
    return iterator(this, "entries", function(value) {
        value[1] = toReactive(value[1]);
        return value;
    });
}), (0, $aRIHe._)(_obj, "every", function(fn, thisArg) {
    return apply(this, "every", fn, thisArg, void 0, arguments);
}), (0, $aRIHe._)(_obj, "filter", function(fn, thisArg) {
    return apply(this, "filter", fn, thisArg, function(v) {
        return v.map(toReactive);
    }, arguments);
}), (0, $aRIHe._)(_obj, "find", function(fn, thisArg) {
    return apply(this, "find", fn, thisArg, toReactive, arguments);
}), (0, $aRIHe._)(_obj, "findIndex", function(fn, thisArg) {
    return apply(this, "findIndex", fn, thisArg, void 0, arguments);
}), (0, $aRIHe._)(_obj, "findLast", function(fn, thisArg) {
    return apply(this, "findLast", fn, thisArg, toReactive, arguments);
}), (0, $aRIHe._)(_obj, "findLastIndex", function(fn, thisArg) {
    return apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
}), // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
(0, $aRIHe._)(_obj, "forEach", function(fn, thisArg) {
    return apply(this, "forEach", fn, thisArg, void 0, arguments);
}), (0, $aRIHe._)(_obj, "includes", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return searchProxy(this, "includes", args);
}), (0, $aRIHe._)(_obj, "indexOf", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return searchProxy(this, "indexOf", args);
}), (0, $aRIHe._)(_obj, "join", function(separator) {
    return reactiveReadArray(this).join(separator);
}), // keys() iterator only reads `length`, no optimization required
(0, $aRIHe._)(_obj, "lastIndexOf", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return searchProxy(this, "lastIndexOf", args);
}), (0, $aRIHe._)(_obj, "map", function(fn, thisArg) {
    return apply(this, "map", fn, thisArg, void 0, arguments);
}), (0, $aRIHe._)(_obj, "pop", function() {
    return noTracking(this, "pop");
}), (0, $aRIHe._)(_obj, "push", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return noTracking(this, "push", args);
}), (0, $aRIHe._)(_obj, "reduce", function(fn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return reduce(this, "reduce", fn, args);
}), (0, $aRIHe._)(_obj, "reduceRight", function(fn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return reduce(this, "reduceRight", fn, args);
}), (0, $aRIHe._)(_obj, "shift", function() {
    return noTracking(this, "shift");
}), // slice could use ARRAY_ITERATE but also seems to beg for range tracking
(0, $aRIHe._)(_obj, "some", function(fn, thisArg) {
    return apply(this, "some", fn, thisArg, void 0, arguments);
}), (0, $aRIHe._)(_obj, "splice", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return noTracking(this, "splice", args);
}), (0, $aRIHe._)(_obj, "toReversed", function() {
    return reactiveReadArray(this).toReversed();
}), (0, $aRIHe._)(_obj, "toSorted", function(comparer) {
    return reactiveReadArray(this).toSorted(comparer);
}), (0, $aRIHe._)(_obj, "toSpliced", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _reactiveReadArray;
    return (_reactiveReadArray = reactiveReadArray(this)).toSpliced.apply(_reactiveReadArray, (0, $kf9Kn._)(args));
}), (0, $aRIHe._)(_obj, "unshift", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return noTracking(this, "unshift", args);
}), (0, $aRIHe._)(_obj, "values", function() {
    return iterator(this, "values", toReactive);
}), _obj);
function iterator(self, method, wrapValue) {
    var arr = shallowReadArray(self);
    var iter = arr[method]();
    if (arr !== self && !isShallow(self)) {
        iter._next = iter.next;
        iter.next = function() {
            var result = iter._next();
            if (!result.done) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
var arrayProto = Array.prototype;
function apply(self, method, fn, thisArg, wrappedRetFn, args) {
    var arr = shallowReadArray(self);
    var needsWrap = arr !== self && !isShallow(self);
    var methodFn = arr[method];
    if (methodFn !== arrayProto[method]) {
        var result2 = methodFn.apply(self, args);
        return needsWrap ? toReactive(result2) : result2;
    }
    var wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function wrappedFn(item, index) {
            return fn.call(this, toReactive(item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function wrappedFn(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    var result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function reduce(self, method, fn, args) {
    var _arr;
    var arr = shallowReadArray(self);
    var wrappedFn = fn;
    if (arr !== self) {
        if (!isShallow(self)) wrappedFn = function wrappedFn(acc, item, index) {
            return fn.call(this, acc, toReactive(item), index, self);
        };
        else if (fn.length > 3) wrappedFn = function wrappedFn(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    return (_arr = arr)[method].apply(_arr, [
        wrappedFn
    ].concat((0, $kf9Kn._)(args)));
}
function searchProxy(self, method, args) {
    var _arr;
    var arr = toRaw(self);
    track(arr, "iterate", ARRAY_ITERATE_KEY);
    var res = (_arr = arr)[method].apply(_arr, (0, $kf9Kn._)(args));
    if ((res === -1 || res === false) && isProxy(args[0])) {
        var _arr1;
        args[0] = toRaw(args[0]);
        return (_arr1 = arr)[method].apply(_arr1, (0, $kf9Kn._)(args));
    }
    return res;
}
function noTracking(self, method) {
    var args = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    pauseTracking();
    startBatch();
    var res = toRaw(self)[method].apply(self, args);
    endBatch();
    resetTracking();
    return res;
}
var isNonTrackableKeys = /* @__PURE__ */ (0, $3ZJCa.makeMap)("__proto__,__v_isRef,__isVue");
var builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter(function(key) {
    return key !== "arguments" && key !== "caller";
}).map(function(key) {
    return Symbol[key];
}).filter((0, $3ZJCa.isSymbol)));
function hasOwnProperty(key) {
    if (!(0, $3ZJCa.isSymbol)(key)) key = String(key);
    var obj = toRaw(this);
    track(obj, "has", key);
    return obj.hasOwnProperty(key);
}
var BaseReactiveHandler = /*#__PURE__*/ function() {
    "use strict";
    function BaseReactiveHandler() {
        var _isReadonly = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, _isShallow = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        (0, $1UdHD._)(this, BaseReactiveHandler);
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    (0, $iH1wO._)(BaseReactiveHandler, [
        {
            key: "get",
            value: function get(target, key, receiver) {
                if (key === "__v_skip") return target["__v_skip"];
                var isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
                if (key === "__v_isReactive") return !isReadonly2;
                else if (key === "__v_isReadonly") return isReadonly2;
                else if (key === "__v_isShallow") return isShallow2;
                else if (key === "__v_raw") {
                    if (receiver === (isReadonly2 ? isShallow2 ? shallowReadonlyMap : readonlyMap : isShallow2 ? shallowReactiveMap : reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
                    // this means the receiver is a user proxy of the reactive proxy
                    Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
                    return;
                }
                var targetIsArray = (0, $3ZJCa.isArray)(target);
                if (!isReadonly2) {
                    var fn;
                    if (targetIsArray && (fn = arrayInstrumentations[key])) return fn;
                    if (key === "hasOwnProperty") return hasOwnProperty;
                }
                var res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
                // as receiver so that we don't have to call `toRaw` on the ref in all
                // its class methods
                isRef(target) ? target : receiver);
                if ((0, $3ZJCa.isSymbol)(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)) return res;
                if (!isReadonly2) track(target, "get", key);
                if (isShallow2) return res;
                if (isRef(res)) {
                    var value = targetIsArray && (0, $3ZJCa.isIntegerKey)(key) ? res : res.value;
                    return isReadonly2 && (0, $3ZJCa.isObject)(value) ? readonly(value) : value;
                }
                if ((0, $3ZJCa.isObject)(res)) return isReadonly2 ? readonly(res) : reactive(res);
                return res;
            }
        }
    ]);
    return BaseReactiveHandler;
}();
var MutableReactiveHandler = /*#__PURE__*/ function(BaseReactiveHandler) {
    "use strict";
    (0, $h4SHl._)(MutableReactiveHandler, BaseReactiveHandler);
    function MutableReactiveHandler() {
        var isShallow2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        (0, $1UdHD._)(this, MutableReactiveHandler);
        return (0, $1mRNr._)(this, MutableReactiveHandler, [
            false,
            isShallow2
        ]);
    }
    (0, $iH1wO._)(MutableReactiveHandler, [
        {
            key: "set",
            value: function set(target, key, value, receiver) {
                var oldValue = target[key];
                if (!this._isShallow) {
                    var isOldValueReadonly = isReadonly(oldValue);
                    if (!isShallow(value) && !isReadonly(value)) {
                        oldValue = toRaw(oldValue);
                        value = toRaw(value);
                    }
                    if (!(0, $3ZJCa.isArray)(target) && isRef(oldValue) && !isRef(value)) {
                        if (isOldValueReadonly) return true;
                        else {
                            oldValue.value = value;
                            return true;
                        }
                    }
                }
                var hadKey = (0, $3ZJCa.isArray)(target) && (0, $3ZJCa.isIntegerKey)(key) ? Number(key) < target.length : (0, $3ZJCa.hasOwn)(target, key);
                var result = Reflect.set(target, key, value, isRef(target) ? target : receiver);
                if (target === toRaw(receiver)) {
                    if (!hadKey) trigger(target, "add", key, value);
                    else if ((0, $3ZJCa.hasChanged)(value, oldValue)) trigger(target, "set", key, value, oldValue);
                }
                return result;
            }
        },
        {
            key: "deleteProperty",
            value: function deleteProperty(target, key) {
                var hadKey = (0, $3ZJCa.hasOwn)(target, key);
                var oldValue = target[key];
                var result = Reflect.deleteProperty(target, key);
                if (result && hadKey) trigger(target, "delete", key, void 0, oldValue);
                return result;
            }
        },
        {
            key: "has",
            value: function has(target, key) {
                var result = Reflect.has(target, key);
                if (!(0, $3ZJCa.isSymbol)(key) || !builtInSymbols.has(key)) track(target, "has", key);
                return result;
            }
        },
        {
            key: "ownKeys",
            value: function ownKeys(target) {
                track(target, "iterate", (0, $3ZJCa.isArray)(target) ? "length" : ITERATE_KEY);
                return Reflect.ownKeys(target);
            }
        }
    ]);
    return MutableReactiveHandler;
}(BaseReactiveHandler);
var ReadonlyReactiveHandler = /*#__PURE__*/ function(BaseReactiveHandler) {
    "use strict";
    (0, $h4SHl._)(ReadonlyReactiveHandler, BaseReactiveHandler);
    function ReadonlyReactiveHandler() {
        var isShallow2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        (0, $1UdHD._)(this, ReadonlyReactiveHandler);
        return (0, $1mRNr._)(this, ReadonlyReactiveHandler, [
            true,
            isShallow2
        ]);
    }
    (0, $iH1wO._)(ReadonlyReactiveHandler, [
        {
            key: "set",
            value: function set(target, key) {
                return true;
            }
        },
        {
            key: "deleteProperty",
            value: function deleteProperty(target, key) {
                return true;
            }
        }
    ]);
    return ReadonlyReactiveHandler;
}(BaseReactiveHandler);
var mutableHandlers = /* @__PURE__ */ new MutableReactiveHandler();
var readonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler();
var shallowReactiveHandlers = /* @__PURE__ */ new MutableReactiveHandler(true);
var shallowReadonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler(true);
var toShallow = function(value) {
    return value;
};
var getProto = function(v) {
    return Reflect.getPrototypeOf(v);
};
function createIterableMethod(method, isReadonly2, isShallow2) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _target;
        var target = this["__v_raw"];
        var rawTarget = toRaw(target);
        var targetIsMap = (0, $3ZJCa.isMap)(rawTarget);
        var isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        var isKeyOnly = method === "keys" && targetIsMap;
        var innerIterator = (_target = target)[method].apply(_target, (0, $kf9Kn._)(args));
        var wrap = isShallow2 ? toShallow : isReadonly2 ? toReadonly : toReactive;
        !isReadonly2 && track(rawTarget, "iterate", isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY);
        return(// iterable protocol
        (0, $aRIHe._)({
            // iterator protocol
            next: function() {
                var _innerIterator_next = innerIterator.next(), value = _innerIterator_next.value, done = _innerIterator_next.done;
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            }
        }, Symbol.iterator, function() {
            return this;
        }));
    };
}
function createReadonlyMethod(type) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function createInstrumentations(readonly, shallow) {
    var instrumentations = {
        get: function(key) {
            var target = this["__v_raw"];
            var rawTarget = toRaw(target);
            var rawKey = toRaw(key);
            if (!readonly) {
                if ((0, $3ZJCa.hasChanged)(key, rawKey)) track(rawTarget, "get", key);
                track(rawTarget, "get", rawKey);
            }
            var has = getProto(rawTarget).has;
            var wrap = shallow ? toShallow : readonly ? toReadonly : toReactive;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            var target = this["__v_raw"];
            !readonly && track(toRaw(target), "iterate", ITERATE_KEY);
            return target.size;
        },
        has: function(key) {
            var target = this["__v_raw"];
            var rawTarget = toRaw(target);
            var rawKey = toRaw(key);
            if (!readonly) {
                if ((0, $3ZJCa.hasChanged)(key, rawKey)) track(rawTarget, "has", key);
                track(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach: function(callback, thisArg) {
            var observed = this;
            var target = observed["__v_raw"];
            var rawTarget = toRaw(target);
            var wrap = shallow ? toShallow : readonly ? toReadonly : toReactive;
            !readonly && track(rawTarget, "iterate", ITERATE_KEY);
            return target.forEach(function(value, key) {
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, $3ZJCa.extend)(instrumentations, readonly ? {
        add: createReadonlyMethod("add"),
        set: createReadonlyMethod("set"),
        "delete": createReadonlyMethod("delete"),
        clear: createReadonlyMethod("clear")
    } : {
        add: function(value) {
            if (!shallow && !isShallow(value) && !isReadonly(value)) value = toRaw(value);
            var target = toRaw(this);
            var proto = getProto(target);
            var hadKey = proto.has.call(target, value);
            if (!hadKey) {
                target.add(value);
                trigger(target, "add", value, value);
            }
            return this;
        },
        set: function(key, value) {
            if (!shallow && !isShallow(value) && !isReadonly(value)) value = toRaw(value);
            var target = toRaw(this);
            var _getProto = getProto(target), has = _getProto.has, get = _getProto.get;
            var hadKey = has.call(target, key);
            if (!hadKey) {
                key = toRaw(key);
                hadKey = has.call(target, key);
            }
            var oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) trigger(target, "add", key, value);
            else if ((0, $3ZJCa.hasChanged)(value, oldValue)) trigger(target, "set", key, value, oldValue);
            return this;
        },
        "delete": function(key) {
            var target = toRaw(this);
            var _getProto = getProto(target), has = _getProto.has, get = _getProto.get;
            var hadKey = has.call(target, key);
            if (!hadKey) {
                key = toRaw(key);
                hadKey = has.call(target, key);
            }
            var oldValue = get ? get.call(target, key) : void 0;
            var result = target["delete"](key);
            if (hadKey) trigger(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear: function() {
            var target = toRaw(this);
            var hadItems = target.size !== 0;
            var oldTarget = void 0;
            var result = target.clear();
            if (hadItems) trigger(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    var iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach(function(method) {
        instrumentations[method] = createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function createInstrumentationGetter(isReadonly2, shallow) {
    var instrumentations = createInstrumentations(isReadonly2, shallow);
    return function(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $3ZJCa.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var mutableCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(false, false)
};
var shallowCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(false, true)
};
var readonlyCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(true, false)
};
var shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(true, true)
};
function checkIdentityKeys(target, has, key) {
    var rawKey = toRaw(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        var type = (0, $3ZJCa.toRawType)(target);
        warn("Reactive ".concat(type, " contains both the raw and reactive versions of the same object").concat(type === "Map" ? " as keys" : "", ", which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible."));
    }
}
var reactiveMap = /* @__PURE__ */ new WeakMap();
var shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var readonlyMap = /* @__PURE__ */ new WeakMap();
var shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : targetTypeMap((0, $3ZJCa.toRawType)(value));
}
function reactive(target) {
    if (isReadonly(target)) return target;
    return createReactiveObject(target, false, mutableHandlers, mutableCollectionHandlers, reactiveMap);
}
function shallowReactive(target) {
    return createReactiveObject(target, false, shallowReactiveHandlers, shallowCollectionHandlers, shallowReactiveMap);
}
function readonly(target) {
    return createReactiveObject(target, true, readonlyHandlers, readonlyCollectionHandlers, readonlyMap);
}
function shallowReadonly(target) {
    return createReactiveObject(target, true, shallowReadonlyHandlers, shallowReadonlyCollectionHandlers, shallowReadonlyMap);
}
function createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $3ZJCa.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    var targetType = getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    var existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    var proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function isReactive(value) {
    if (isReadonly(value)) return isReactive(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function isReadonly(value) {
    return !!(value && value["__v_isReadonly"]);
}
function isShallow(value) {
    return !!(value && value["__v_isShallow"]);
}
function isProxy(value) {
    return value ? !!value["__v_raw"] : false;
}
function toRaw(observed) {
    var raw = observed && observed["__v_raw"];
    return raw ? toRaw(raw) : observed;
}
function markRaw(value) {
    if (!(0, $3ZJCa.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, $3ZJCa.def)(value, "__v_skip", true);
    return value;
}
var toReactive = function(value) {
    return (0, $3ZJCa.isObject)(value) ? reactive(value) : value;
};
var toReadonly = function(value) {
    return (0, $3ZJCa.isObject)(value) ? readonly(value) : value;
};
function isRef(r) {
    return r ? r["__v_isRef"] === true : false;
}
function ref(value) {
    return createRef(value, false);
}
function shallowRef(value) {
    return createRef(value, true);
}
function createRef(rawValue, shallow) {
    if (isRef(rawValue)) return rawValue;
    return new RefImpl(rawValue, shallow);
}
var RefImpl = /*#__PURE__*/ function() {
    "use strict";
    function RefImpl(value, isShallow2) {
        (0, $1UdHD._)(this, RefImpl);
        this.dep = new Dep();
        this["__v_isRef"] = true;
        this["__v_isShallow"] = false;
        this._rawValue = isShallow2 ? value : toRaw(value);
        this._value = isShallow2 ? value : toReactive(value);
        this["__v_isShallow"] = isShallow2;
    }
    (0, $iH1wO._)(RefImpl, [
        {
            key: "value",
            get: function get() {
                this.dep.track();
                return this._value;
            },
            set: function set(newValue) {
                var oldValue = this._rawValue;
                var useDirectValue = this["__v_isShallow"] || isShallow(newValue) || isReadonly(newValue);
                newValue = useDirectValue ? newValue : toRaw(newValue);
                if ((0, $3ZJCa.hasChanged)(newValue, oldValue)) {
                    this._rawValue = newValue;
                    this._value = useDirectValue ? newValue : toReactive(newValue);
                    this.dep.trigger();
                }
            }
        }
    ]);
    return RefImpl;
}();
function triggerRef(ref2) {
    if (ref2.dep) ref2.dep.trigger();
}
function unref(ref2) {
    return isRef(ref2) ? ref2.value : ref2;
}
function toValue(source) {
    return (0, $3ZJCa.isFunction)(source) ? source() : unref(source);
}
var shallowUnwrapHandlers = {
    get: function(target, key, receiver) {
        return key === "__v_raw" ? target : unref(Reflect.get(target, key, receiver));
    },
    set: function(target, key, value, receiver) {
        var oldValue = target[key];
        if (isRef(oldValue) && !isRef(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function proxyRefs(objectWithRefs) {
    return isReactive(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, shallowUnwrapHandlers);
}
var CustomRefImpl = /*#__PURE__*/ function() {
    "use strict";
    function CustomRefImpl(factory) {
        (0, $1UdHD._)(this, CustomRefImpl);
        this["__v_isRef"] = true;
        this._value = void 0;
        var dep = this.dep = new Dep();
        var _factory = factory(dep.track.bind(dep), dep.trigger.bind(dep)), get = _factory.get, set = _factory.set;
        this._get = get;
        this._set = set;
    }
    (0, $iH1wO._)(CustomRefImpl, [
        {
            key: "value",
            get: function get() {
                return this._value = this._get();
            },
            set: function set(newVal) {
                this._set(newVal);
            }
        }
    ]);
    return CustomRefImpl;
}();
function customRef(factory) {
    return new CustomRefImpl(factory);
}
function toRefs(object) {
    var ret = (0, $3ZJCa.isArray)(object) ? new Array(object.length) : {};
    for(var key in object)ret[key] = propertyToRef(object, key);
    return ret;
}
var ObjectRefImpl = /*#__PURE__*/ function() {
    "use strict";
    function ObjectRefImpl(_object, _key, _defaultValue) {
        (0, $1UdHD._)(this, ObjectRefImpl);
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
    }
    (0, $iH1wO._)(ObjectRefImpl, [
        {
            key: "value",
            get: function get() {
                var val = this._object[this._key];
                return this._value = val === void 0 ? this._defaultValue : val;
            },
            set: function set(newVal) {
                this._object[this._key] = newVal;
            }
        },
        {
            key: "dep",
            get: function get() {
                return getDepFromReactive(toRaw(this._object), this._key);
            }
        }
    ]);
    return ObjectRefImpl;
}();
var GetterRefImpl = /*#__PURE__*/ function() {
    "use strict";
    function GetterRefImpl(_getter) {
        (0, $1UdHD._)(this, GetterRefImpl);
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    (0, $iH1wO._)(GetterRefImpl, [
        {
            key: "value",
            get: function get() {
                return this._value = this._getter();
            }
        }
    ]);
    return GetterRefImpl;
}();
function toRef(source, key, defaultValue) {
    if (isRef(source)) return source;
    else if ((0, $3ZJCa.isFunction)(source)) return new GetterRefImpl(source);
    else if ((0, $3ZJCa.isObject)(source) && arguments.length > 1) return propertyToRef(source, key, defaultValue);
    else return ref(source);
}
function propertyToRef(source, key, defaultValue) {
    var val = source[key];
    return isRef(val) ? val : new ObjectRefImpl(source, key, defaultValue);
}
var ComputedRefImpl = /*#__PURE__*/ function() {
    "use strict";
    function ComputedRefImpl(fn, setter, isSSR) {
        (0, $1UdHD._)(this, ComputedRefImpl);
        this.fn = fn;
        this.setter = setter;
        /**
     * @internal
     */ this._value = void 0;
        /**
     * @internal
     */ this.dep = new Dep(this);
        /**
     * @internal
     */ this.__v_isRef = true;
        // TODO isolatedDeclarations "__v_isReadonly"
        // A computed is also a subscriber that tracks other deps
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 16;
        /**
     * @internal
     */ this.globalVersion = globalVersion - 1;
        /**
     * @internal
     */ this.next = void 0;
        // for backwards compat
        this.effect = this;
        this["__v_isReadonly"] = !setter;
        this.isSSR = isSSR;
    }
    (0, $iH1wO._)(ComputedRefImpl, [
        {
            /**
   * @internal
   */ key: "notify",
            value: function notify() {
                this.flags |= 16;
                if (!(this.flags & 8) && // avoid infinite self recursion
                activeSub !== this) {
                    batch(this, true);
                    return true;
                }
            }
        },
        {
            key: "value",
            get: function get() {
                var link = this.dep.track();
                refreshComputed(this);
                if (link) link.version = this.dep.version;
                return this._value;
            },
            set: function set(newValue) {
                if (this.setter) this.setter(newValue);
            }
        }
    ]);
    return ComputedRefImpl;
}();
function computed(getterOrOptions, debugOptions) {
    var isSSR = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var getter;
    var setter;
    if ((0, $3ZJCa.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    var cRef = new ComputedRefImpl(getter, setter, isSSR);
    return cRef;
}
var TrackOpTypes = {
    GET: "get",
    HAS: "has",
    ITERATE: "iterate"
};
var TriggerOpTypes = {
    SET: "set",
    ADD: "add",
    DELETE: "delete",
    CLEAR: "clear"
};
var ReactiveFlags = {
    SKIP: "__v_skip",
    IS_REACTIVE: "__v_isReactive",
    IS_READONLY: "__v_isReadonly",
    IS_SHALLOW: "__v_isShallow",
    RAW: "__v_raw",
    IS_REF: "__v_isRef"
};
var WatchErrorCodes = {
    WATCH_GETTER: 2,
    "2": "WATCH_GETTER",
    WATCH_CALLBACK: 3,
    "3": "WATCH_CALLBACK",
    WATCH_CLEANUP: 4,
    "4": "WATCH_CLEANUP"
};
var INITIAL_WATCHER_VALUE = {};
var cleanupMap = /* @__PURE__ */ new WeakMap();
var activeWatcher = void 0;
function getCurrentWatcher() {
    return activeWatcher;
}
function onWatcherCleanup(cleanupFn) {
    var failSilently = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, owner = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : activeWatcher;
    if (owner) {
        var cleanups = cleanupMap.get(owner);
        if (!cleanups) cleanupMap.set(owner, cleanups = []);
        cleanups.push(cleanupFn);
    }
}
function watch(source, cb) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $3ZJCa.EMPTY_OBJ);
    var immediate = options.immediate, deep = options.deep, once = options.once, scheduler = options.scheduler, augmentJob = options.augmentJob, call = options.call;
    var warnInvalidSource = function(s) {
        (options.onWarn || warn)("Invalid watch source: ", s, "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.");
    };
    var reactiveGetter = function(source2) {
        if (deep) return source2;
        if (isShallow(source2) || deep === false || deep === 0) return traverse(source2, 1);
        return traverse(source2);
    };
    var effect;
    var getter;
    var cleanup;
    var boundCleanup;
    var forceTrigger = false;
    var isMultiSource = false;
    if (isRef(source)) {
        getter = function() {
            return source.value;
        };
        forceTrigger = isShallow(source);
    } else if (isReactive(source)) {
        getter = function() {
            return reactiveGetter(source);
        };
        forceTrigger = true;
    } else if ((0, $3ZJCa.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some(function(s) {
            return isReactive(s) || isShallow(s);
        });
        getter = function() {
            return source.map(function(s) {
                if (isRef(s)) return s.value;
                else if (isReactive(s)) return reactiveGetter(s);
                else if ((0, $3ZJCa.isFunction)(s)) return call ? call(s, 2) : s();
            });
        };
    } else if ((0, $3ZJCa.isFunction)(source)) {
        if (cb) getter = call ? function() {
            return call(source, 2);
        } : source;
        else getter = function() {
            if (cleanup) {
                pauseTracking();
                try {
                    cleanup();
                } finally{
                    resetTracking();
                }
            }
            var currentEffect = activeWatcher;
            activeWatcher = effect;
            try {
                return call ? call(source, 3, [
                    boundCleanup
                ]) : source(boundCleanup);
            } finally{
                activeWatcher = currentEffect;
            }
        };
    } else getter = (0, $3ZJCa.NOOP);
    if (cb && deep) {
        var baseGetter = getter;
        var depth = deep === true ? Infinity : deep;
        getter = function() {
            return traverse(baseGetter(), depth);
        };
    }
    var scope = getCurrentScope();
    var watchHandle = function() {
        effect.stop();
        if (scope && scope.active) (0, $3ZJCa.remove)(scope.effects, effect);
    };
    if (once && cb) {
        var _cb = cb;
        cb = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            _cb.apply(void 0, (0, $kf9Kn._)(args));
            watchHandle();
        };
    }
    var oldValue = isMultiSource ? new Array(source.length).fill(INITIAL_WATCHER_VALUE) : INITIAL_WATCHER_VALUE;
    var job = function(immediateFirstRun) {
        if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
        if (cb) {
            var newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some(function(v, i) {
                return (0, $3ZJCa.hasChanged)(v, oldValue[i]);
            }) : (0, $3ZJCa.hasChanged)(newValue, oldValue))) {
                if (cleanup) cleanup();
                var currentWatcher = activeWatcher;
                activeWatcher = effect;
                try {
                    var args = [
                        newValue,
                        // pass undefined as the old value when it's changed for the first time
                        oldValue === INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === INITIAL_WATCHER_VALUE ? [] : oldValue,
                        boundCleanup
                    ];
                    oldValue = newValue;
                    call ? call(cb, 3, args) : // @ts-expect-error
                    cb.apply(void 0, (0, $kf9Kn._)(args));
                } finally{
                    activeWatcher = currentWatcher;
                }
            }
        } else effect.run();
    };
    if (augmentJob) augmentJob(job);
    effect = new ReactiveEffect(getter);
    effect.scheduler = scheduler ? function() {
        return scheduler(job, false);
    } : job;
    boundCleanup = function(fn) {
        return onWatcherCleanup(fn, false, effect);
    };
    cleanup = effect.onStop = function() {
        var cleanups = cleanupMap.get(effect);
        if (cleanups) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (call) call(cleanups, 4);
            else try {
                for(var _iterator = cleanups[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var cleanup2 = _step.value;
                    cleanup2();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            cleanupMap["delete"](effect);
        }
    };
    if (cb) {
        if (immediate) job(true);
        else oldValue = effect.run();
    } else if (scheduler) scheduler(job.bind(null, true), true);
    else effect.run();
    watchHandle.pause = effect.pause.bind(effect);
    watchHandle.resume = effect.resume.bind(effect);
    watchHandle.stop = watchHandle;
    return watchHandle;
}
function traverse(value) {
    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Infinity, seen = arguments.length > 2 ? arguments[2] : void 0;
    if (depth <= 0 || !(0, $3ZJCa.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Map();
    if ((seen.get(value) || 0) >= depth) return value;
    seen.set(value, depth);
    depth--;
    if (isRef(value)) traverse(value.value, depth, seen);
    else if ((0, $3ZJCa.isArray)(value)) for(var i = 0; i < value.length; i++)traverse(value[i], depth, seen);
    else if ((0, $3ZJCa.isSet)(value) || (0, $3ZJCa.isMap)(value)) value.forEach(function(v) {
        traverse(v, depth, seen);
    });
    else if ((0, $3ZJCa.isPlainObject)(value)) {
        for(var key in value)traverse(value[key], depth, seen);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.getOwnPropertySymbols(value)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key1 = _step.value;
                if (Object.prototype.propertyIsEnumerable.call(value, key1)) traverse(value[key1], depth, seen);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return value;
}

});
parcelRegister("3ZJCa", function(module, exports) {

$parcel$export(module.exports, "makeMap", function () { return $2e8a73b3e94346d3$export$b41394a5437791c8; });
$parcel$export(module.exports, "EMPTY_OBJ", function () { return $2e8a73b3e94346d3$export$cf583d23ab39677c; });
$parcel$export(module.exports, "EMPTY_ARR", function () { return $2e8a73b3e94346d3$export$6bd8558f433f1cc1; });
$parcel$export(module.exports, "NOOP", function () { return $2e8a73b3e94346d3$export$5702a91a6f42969f; });
$parcel$export(module.exports, "NO", function () { return $2e8a73b3e94346d3$export$c01351c0af048e39; });
$parcel$export(module.exports, "isOn", function () { return $2e8a73b3e94346d3$export$1a2d97de39ecbb75; });
$parcel$export(module.exports, "isModelListener", function () { return $2e8a73b3e94346d3$export$793aa5469768d691; });
$parcel$export(module.exports, "extend", function () { return $2e8a73b3e94346d3$export$8b58be045bf06082; });
$parcel$export(module.exports, "remove", function () { return $2e8a73b3e94346d3$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "hasOwn", function () { return $2e8a73b3e94346d3$export$b5a638e9b3fff9f3; });
$parcel$export(module.exports, "isArray", function () { return $2e8a73b3e94346d3$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isMap", function () { return $2e8a73b3e94346d3$export$5c90113a285f2241; });
$parcel$export(module.exports, "isSet", function () { return $2e8a73b3e94346d3$export$6750766a7c7ec627; });
$parcel$export(module.exports, "isRegExp", function () { return $2e8a73b3e94346d3$export$49841c62b9eff15; });
$parcel$export(module.exports, "isFunction", function () { return $2e8a73b3e94346d3$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "isString", function () { return $2e8a73b3e94346d3$export$844ec244b1367d54; });
$parcel$export(module.exports, "isSymbol", function () { return $2e8a73b3e94346d3$export$a244864fd9645c7f; });
$parcel$export(module.exports, "isObject", function () { return $2e8a73b3e94346d3$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isPromise", function () { return $2e8a73b3e94346d3$export$4369c812aac99591; });
$parcel$export(module.exports, "toRawType", function () { return $2e8a73b3e94346d3$export$5ad0a3c360b8fbb5; });
$parcel$export(module.exports, "isPlainObject", function () { return $2e8a73b3e94346d3$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isIntegerKey", function () { return $2e8a73b3e94346d3$export$e2a2b93446ec9fe; });
$parcel$export(module.exports, "isReservedProp", function () { return $2e8a73b3e94346d3$export$bf7d3c0236f0aa85; });
$parcel$export(module.exports, "isBuiltInDirective", function () { return $2e8a73b3e94346d3$export$a9c1fdb3030c2a6b; });
$parcel$export(module.exports, "camelize", function () { return $2e8a73b3e94346d3$export$161d051f5dd25de7; });
$parcel$export(module.exports, "hyphenate", function () { return $2e8a73b3e94346d3$export$6e6a0a3676c4b8bb; });
$parcel$export(module.exports, "capitalize", function () { return $2e8a73b3e94346d3$export$9a00dee1beb8f576; });
$parcel$export(module.exports, "toHandlerKey", function () { return $2e8a73b3e94346d3$export$8c022799eeaaefcd; });
$parcel$export(module.exports, "hasChanged", function () { return $2e8a73b3e94346d3$export$f619eb8b89076d23; });
$parcel$export(module.exports, "invokeArrayFns", function () { return $2e8a73b3e94346d3$export$39951422d618a9d3; });
$parcel$export(module.exports, "def", function () { return $2e8a73b3e94346d3$export$8afb76124cf08683; });
$parcel$export(module.exports, "looseToNumber", function () { return $2e8a73b3e94346d3$export$d3be7195bcc2f31b; });
$parcel$export(module.exports, "toNumber", function () { return $2e8a73b3e94346d3$export$a0a81dc3380ce7d3; });
$parcel$export(module.exports, "getGlobalThis", function () { return $2e8a73b3e94346d3$export$ff5f2eeb11fc7e14; });
$parcel$export(module.exports, "isGloballyAllowed", function () { return $2e8a73b3e94346d3$export$f73b8c13b7f97ebf; });
$parcel$export(module.exports, "normalizeStyle", function () { return $2e8a73b3e94346d3$export$8756898546458274; });
$parcel$export(module.exports, "stringifyStyle", function () { return $2e8a73b3e94346d3$export$9466a5a0ee6f1479; });
$parcel$export(module.exports, "normalizeClass", function () { return $2e8a73b3e94346d3$export$4f7022d2d68e2c5a; });
$parcel$export(module.exports, "normalizeProps", function () { return $2e8a73b3e94346d3$export$601abcd8103db5e4; });
$parcel$export(module.exports, "isHTMLTag", function () { return $2e8a73b3e94346d3$export$1ccf854a0984f890; });
$parcel$export(module.exports, "isSVGTag", function () { return $2e8a73b3e94346d3$export$6328ce7565ea1049; });
$parcel$export(module.exports, "isMathMLTag", function () { return $2e8a73b3e94346d3$export$4a46ca4c5be17b20; });
$parcel$export(module.exports, "isSpecialBooleanAttr", function () { return $2e8a73b3e94346d3$export$d186f5eb2e810715; });
$parcel$export(module.exports, "isBooleanAttr", function () { return $2e8a73b3e94346d3$export$f763ba3b84e9cd8c; });
$parcel$export(module.exports, "includeBooleanAttr", function () { return $2e8a73b3e94346d3$export$e3f3cdb1390d56ce; });
$parcel$export(module.exports, "isKnownHtmlAttr", function () { return $2e8a73b3e94346d3$export$f7e7a1cc7da8d5e9; });
$parcel$export(module.exports, "isKnownSvgAttr", function () { return $2e8a73b3e94346d3$export$80da416f43933831; });
$parcel$export(module.exports, "isRenderableAttrValue", function () { return $2e8a73b3e94346d3$export$921dd2acf0d386a3; });
$parcel$export(module.exports, "getEscapedCssVarName", function () { return $2e8a73b3e94346d3$export$ad9a320bfb7ba440; });
$parcel$export(module.exports, "looseEqual", function () { return $2e8a73b3e94346d3$export$ae8015769846262c; });
$parcel$export(module.exports, "looseIndexOf", function () { return $2e8a73b3e94346d3$export$42912a80cedb8bd4; });
$parcel$export(module.exports, "toDisplayString", function () { return $2e8a73b3e94346d3$export$b5b1545233b45293; });
$parcel$export(module.exports, "normalizeCssVarValue", function () { return $2e8a73b3e94346d3$export$97fe3d6453ee2f5e; });
/**
* @vue/shared v3.5.22
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ // @__NO_SIDE_EFFECTS__

var $aRIHe = parcelRequire("aRIHe");

var $9tk0W = parcelRequire("9tk0W");

var $kf9Kn = parcelRequire("kf9Kn");

var $6gBIz = parcelRequire("6gBIz");
function $2e8a73b3e94346d3$export$b41394a5437791c8(str) {
    var map = /* @__PURE__ */ Object.create(null);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = str.split(",")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            map[key] = 1;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return function(val) {
        return val in map;
    };
}
var $2e8a73b3e94346d3$export$cf583d23ab39677c = {};
var $2e8a73b3e94346d3$export$6bd8558f433f1cc1 = [];
var $2e8a73b3e94346d3$export$5702a91a6f42969f = function() {};
var $2e8a73b3e94346d3$export$c01351c0af048e39 = function() {
    return false;
};
var $2e8a73b3e94346d3$export$1a2d97de39ecbb75 = function(key) {
    return key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
};
var $2e8a73b3e94346d3$export$793aa5469768d691 = function(key) {
    return key.startsWith("onUpdate:");
};
var $2e8a73b3e94346d3$export$8b58be045bf06082 = Object.assign;
var $2e8a73b3e94346d3$export$cd7f480d6b8286c3 = function(arr, el) {
    var i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
var $2e8a73b3e94346d3$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $2e8a73b3e94346d3$export$b5a638e9b3fff9f3 = function(val, key) {
    return $2e8a73b3e94346d3$var$hasOwnProperty.call(val, key);
};
var $2e8a73b3e94346d3$export$43bee75e5e14138e = Array.isArray;
var $2e8a73b3e94346d3$export$5c90113a285f2241 = function(val) {
    return $2e8a73b3e94346d3$export$1dccc787cc36538b(val) === "[object Map]";
};
var $2e8a73b3e94346d3$export$6750766a7c7ec627 = function(val) {
    return $2e8a73b3e94346d3$export$1dccc787cc36538b(val) === "[object Set]";
};
var $2e8a73b3e94346d3$export$871608497c498473 = function(val) {
    return $2e8a73b3e94346d3$export$1dccc787cc36538b(val) === "[object Date]";
};
var $2e8a73b3e94346d3$export$49841c62b9eff15 = function(val) {
    return $2e8a73b3e94346d3$export$1dccc787cc36538b(val) === "[object RegExp]";
};
var $2e8a73b3e94346d3$export$f6e2535fb5126e54 = function(val) {
    return typeof val === "function";
};
var $2e8a73b3e94346d3$export$844ec244b1367d54 = function(val) {
    return typeof val === "string";
};
var $2e8a73b3e94346d3$export$a244864fd9645c7f = function(val) {
    return (typeof val === "undefined" ? "undefined" : (0, $6gBIz._)(val)) === "symbol";
};
var $2e8a73b3e94346d3$export$a6cdc56e425d0d0a = function(val) {
    return val !== null && (typeof val === "undefined" ? "undefined" : (0, $6gBIz._)(val)) === "object";
};
var $2e8a73b3e94346d3$export$4369c812aac99591 = function(val) {
    return ($2e8a73b3e94346d3$export$a6cdc56e425d0d0a(val) || $2e8a73b3e94346d3$export$f6e2535fb5126e54(val)) && $2e8a73b3e94346d3$export$f6e2535fb5126e54(val.then) && $2e8a73b3e94346d3$export$f6e2535fb5126e54(val["catch"]);
};
var $2e8a73b3e94346d3$export$830c053460e5ddf6 = Object.prototype.toString;
var $2e8a73b3e94346d3$export$1dccc787cc36538b = function(value) {
    return $2e8a73b3e94346d3$export$830c053460e5ddf6.call(value);
};
var $2e8a73b3e94346d3$export$5ad0a3c360b8fbb5 = function(value) {
    return $2e8a73b3e94346d3$export$1dccc787cc36538b(value).slice(8, -1);
};
var $2e8a73b3e94346d3$export$53b83ca8eaab0383 = function(val) {
    return $2e8a73b3e94346d3$export$1dccc787cc36538b(val) === "[object Object]";
};
var $2e8a73b3e94346d3$export$e2a2b93446ec9fe = function(key) {
    return $2e8a73b3e94346d3$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
};
var $2e8a73b3e94346d3$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $2e8a73b3e94346d3$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
var $2e8a73b3e94346d3$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $2e8a73b3e94346d3$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
var $2e8a73b3e94346d3$var$cacheStringFunction = function(fn) {
    var cache = /* @__PURE__ */ Object.create(null);
    return function(str) {
        var hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $2e8a73b3e94346d3$var$camelizeRE = /-\w/g;
var $2e8a73b3e94346d3$export$161d051f5dd25de7 = $2e8a73b3e94346d3$var$cacheStringFunction(function(str) {
    return str.replace($2e8a73b3e94346d3$var$camelizeRE, function(c) {
        return c.slice(1).toUpperCase();
    });
});
var $2e8a73b3e94346d3$var$hyphenateRE = /\B([A-Z])/g;
var $2e8a73b3e94346d3$export$6e6a0a3676c4b8bb = $2e8a73b3e94346d3$var$cacheStringFunction(function(str) {
    return str.replace($2e8a73b3e94346d3$var$hyphenateRE, "-$1").toLowerCase();
});
var $2e8a73b3e94346d3$export$9a00dee1beb8f576 = $2e8a73b3e94346d3$var$cacheStringFunction(function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
});
var $2e8a73b3e94346d3$export$8c022799eeaaefcd = $2e8a73b3e94346d3$var$cacheStringFunction(function(str) {
    var s = str ? "on".concat($2e8a73b3e94346d3$export$9a00dee1beb8f576(str)) : "";
    return s;
});
var $2e8a73b3e94346d3$export$f619eb8b89076d23 = function(value, oldValue) {
    return !Object.is(value, oldValue);
};
var $2e8a73b3e94346d3$export$39951422d618a9d3 = function(fns) {
    for(var _len = arguments.length, arg = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        arg[_key - 1] = arguments[_key];
    }
    var _fns;
    for(var i = 0; i < fns.length; i++)(_fns = fns)[i].apply(_fns, (0, $kf9Kn._)(arg));
};
var $2e8a73b3e94346d3$export$8afb76124cf08683 = function(obj, key, value) {
    var writable = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
var $2e8a73b3e94346d3$export$d3be7195bcc2f31b = function(val) {
    var n = parseFloat(val);
    return isNaN(n) ? val : n;
};
var $2e8a73b3e94346d3$export$a0a81dc3380ce7d3 = function(val) {
    var n = $2e8a73b3e94346d3$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
var $2e8a73b3e94346d3$var$_globalThis;
var $2e8a73b3e94346d3$export$ff5f2eeb11fc7e14 = function() {
    return $2e8a73b3e94346d3$var$_globalThis || ($2e8a73b3e94346d3$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
var $2e8a73b3e94346d3$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $2e8a73b3e94346d3$export$53d5e12f9a1d3cde(name) {
    return $2e8a73b3e94346d3$var$identRE.test(name) ? "__props.".concat(name) : "__props[".concat(JSON.stringify(name), "]");
}
function $2e8a73b3e94346d3$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, function(_, val) {
        return typeof val === "function" ? val.toString() : val;
    });
}
var $2e8a73b3e94346d3$export$4bcc674e2ac54ab0 = {
    TEXT: 1,
    "1": "TEXT",
    CLASS: 2,
    "2": "CLASS",
    STYLE: 4,
    "4": "STYLE",
    PROPS: 8,
    "8": "PROPS",
    FULL_PROPS: 16,
    "16": "FULL_PROPS",
    NEED_HYDRATION: 32,
    "32": "NEED_HYDRATION",
    STABLE_FRAGMENT: 64,
    "64": "STABLE_FRAGMENT",
    KEYED_FRAGMENT: 128,
    "128": "KEYED_FRAGMENT",
    UNKEYED_FRAGMENT: 256,
    "256": "UNKEYED_FRAGMENT",
    NEED_PATCH: 512,
    "512": "NEED_PATCH",
    DYNAMIC_SLOTS: 1024,
    "1024": "DYNAMIC_SLOTS",
    DEV_ROOT_FRAGMENT: 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    CACHED: -1,
    "-1": "CACHED",
    BAIL: -2,
    "-2": "BAIL"
};
var $2e8a73b3e94346d3$var$_obj;
var $2e8a73b3e94346d3$export$def7dc2c2e95a08a = ($2e8a73b3e94346d3$var$_obj = {}, (0, $aRIHe._)($2e8a73b3e94346d3$var$_obj, 1, "TEXT"), (0, $aRIHe._)($2e8a73b3e94346d3$var$_obj, 2, "CLASS"), (0, $aRIHe._)($2e8a73b3e94346d3$var$_obj, 4, "STYLE"), (0, $aRIHe._)($2e8a73b3e94346d3$var$_obj, 8, "PROPS"), (0, $aRIHe._)($2e8a73b3e94346d3$var$_obj, 16, "FULL_PROPS"), (0, $aRIHe._)($2e8a73b3e94346d3$var$_obj, 32, "NEED_HYDRATION"), (0, $aRIHe._)($2e8a73b3e94346d3$var$_obj, 64, "STABLE_FRAGMENT"), (0, $aRIHe._)($2e8a73b3e94346d3$var$_obj, 128, "KEYED_FRAGMENT"), (0, $aRIHe._)($2e8a73b3e94346d3$var$_obj, 256, "UNKEYED_FRAGMENT"), (0, $aRIHe._)($2e8a73b3e94346d3$var$_obj, 512, "NEED_PATCH"), (0, $aRIHe._)($2e8a73b3e94346d3$var$_obj, 1024, "DYNAMIC_SLOTS"), (0, $aRIHe._)($2e8a73b3e94346d3$var$_obj, 2048, "DEV_ROOT_FRAGMENT"), (0, $aRIHe._)($2e8a73b3e94346d3$var$_obj, -1, "CACHED"), (0, $aRIHe._)($2e8a73b3e94346d3$var$_obj, -2, "BAIL"), $2e8a73b3e94346d3$var$_obj);
var $2e8a73b3e94346d3$export$ff27c1ebf2311072 = {
    ELEMENT: 1,
    "1": "ELEMENT",
    FUNCTIONAL_COMPONENT: 2,
    "2": "FUNCTIONAL_COMPONENT",
    STATEFUL_COMPONENT: 4,
    "4": "STATEFUL_COMPONENT",
    TEXT_CHILDREN: 8,
    "8": "TEXT_CHILDREN",
    ARRAY_CHILDREN: 16,
    "16": "ARRAY_CHILDREN",
    SLOTS_CHILDREN: 32,
    "32": "SLOTS_CHILDREN",
    TELEPORT: 64,
    "64": "TELEPORT",
    SUSPENSE: 128,
    "128": "SUSPENSE",
    COMPONENT_SHOULD_KEEP_ALIVE: 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    COMPONENT_KEPT_ALIVE: 512,
    "512": "COMPONENT_KEPT_ALIVE",
    COMPONENT: 6,
    "6": "COMPONENT"
};
var $2e8a73b3e94346d3$export$b1e6fe37bcdef5be = {
    STABLE: 1,
    "1": "STABLE",
    DYNAMIC: 2,
    "2": "DYNAMIC",
    FORWARDED: 3,
    "3": "FORWARDED"
};
var $2e8a73b3e94346d3$var$_obj1;
var $2e8a73b3e94346d3$export$624972196ed3745f = ($2e8a73b3e94346d3$var$_obj1 = {}, (0, $aRIHe._)($2e8a73b3e94346d3$var$_obj1, 1, "STABLE"), (0, $aRIHe._)($2e8a73b3e94346d3$var$_obj1, 2, "DYNAMIC"), (0, $aRIHe._)($2e8a73b3e94346d3$var$_obj1, 3, "FORWARDED"), $2e8a73b3e94346d3$var$_obj1);
var $2e8a73b3e94346d3$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
var $2e8a73b3e94346d3$export$f73b8c13b7f97ebf = /* @__PURE__ */ $2e8a73b3e94346d3$export$b41394a5437791c8($2e8a73b3e94346d3$var$GLOBALS_ALLOWED);
var $2e8a73b3e94346d3$export$d6571a1911e4f27e = $2e8a73b3e94346d3$export$f73b8c13b7f97ebf;
var $2e8a73b3e94346d3$var$range = 2;
function $2e8a73b3e94346d3$export$f9c0d8b6684a279b(source) {
    var start = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : source.length;
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    var lines = source.split(/(\r?\n)/);
    var newlineSequences = lines.filter(function(_, idx) {
        return idx % 2 === 1;
    });
    lines = lines.filter(function(_, idx) {
        return idx % 2 === 0;
    });
    var count = 0;
    var res = [];
    for(var i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(var j = i - $2e8a73b3e94346d3$var$range; j <= i + $2e8a73b3e94346d3$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                var line = j + 1;
                res.push("".concat(line).concat(" ".repeat(Math.max(3 - String(line).length, 0)), "|  ").concat(lines[j]));
                var lineLength = lines[j].length;
                var newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    var pad = start - (count - (lineLength + newLineSeqLength));
                    var length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push("   |  " + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        var length1 = Math.max(Math.min(end - count, lineLength), 1);
                        res.push("   |  " + "^".repeat(length1));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $2e8a73b3e94346d3$export$8756898546458274(value) {
    if ($2e8a73b3e94346d3$export$43bee75e5e14138e(value)) {
        var res = {};
        for(var i = 0; i < value.length; i++){
            var item = value[i];
            var normalized = $2e8a73b3e94346d3$export$844ec244b1367d54(item) ? $2e8a73b3e94346d3$export$76a205ce979d066a(item) : $2e8a73b3e94346d3$export$8756898546458274(item);
            if (normalized) for(var key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($2e8a73b3e94346d3$export$844ec244b1367d54(value) || $2e8a73b3e94346d3$export$a6cdc56e425d0d0a(value)) return value;
}
var $2e8a73b3e94346d3$var$listDelimiterRE = /;(?![^(]*\))/g;
var $2e8a73b3e94346d3$var$propertyDelimiterRE = /:([^]+)/;
var $2e8a73b3e94346d3$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $2e8a73b3e94346d3$export$76a205ce979d066a(cssText) {
    var ret = {};
    cssText.replace($2e8a73b3e94346d3$var$styleCommentRE, "").split($2e8a73b3e94346d3$var$listDelimiterRE).forEach(function(item) {
        if (item) {
            var tmp = item.split($2e8a73b3e94346d3$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $2e8a73b3e94346d3$export$9466a5a0ee6f1479(styles) {
    if (!styles) return "";
    if ($2e8a73b3e94346d3$export$844ec244b1367d54(styles)) return styles;
    var ret = "";
    for(var key in styles){
        var value = styles[key];
        if ($2e8a73b3e94346d3$export$844ec244b1367d54(value) || typeof value === "number") {
            var normalizedKey = key.startsWith("--") ? key : $2e8a73b3e94346d3$export$6e6a0a3676c4b8bb(key);
            ret += "".concat(normalizedKey, ":").concat(value, ";");
        }
    }
    return ret;
}
function $2e8a73b3e94346d3$export$4f7022d2d68e2c5a(value) {
    var res = "";
    if ($2e8a73b3e94346d3$export$844ec244b1367d54(value)) res = value;
    else if ($2e8a73b3e94346d3$export$43bee75e5e14138e(value)) for(var i = 0; i < value.length; i++){
        var normalized = $2e8a73b3e94346d3$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($2e8a73b3e94346d3$export$a6cdc56e425d0d0a(value)) {
        for(var name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $2e8a73b3e94346d3$export$601abcd8103db5e4(props) {
    if (!props) return null;
    var klass = props["class"], style = props.style;
    if (klass && !$2e8a73b3e94346d3$export$844ec244b1367d54(klass)) props["class"] = $2e8a73b3e94346d3$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $2e8a73b3e94346d3$export$8756898546458274(style);
    return props;
}
var $2e8a73b3e94346d3$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
var $2e8a73b3e94346d3$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
var $2e8a73b3e94346d3$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
var $2e8a73b3e94346d3$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
var $2e8a73b3e94346d3$export$1ccf854a0984f890 = /* @__PURE__ */ $2e8a73b3e94346d3$export$b41394a5437791c8($2e8a73b3e94346d3$var$HTML_TAGS);
var $2e8a73b3e94346d3$export$6328ce7565ea1049 = /* @__PURE__ */ $2e8a73b3e94346d3$export$b41394a5437791c8($2e8a73b3e94346d3$var$SVG_TAGS);
var $2e8a73b3e94346d3$export$4a46ca4c5be17b20 = /* @__PURE__ */ $2e8a73b3e94346d3$export$b41394a5437791c8($2e8a73b3e94346d3$var$MATH_TAGS);
var $2e8a73b3e94346d3$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $2e8a73b3e94346d3$export$b41394a5437791c8($2e8a73b3e94346d3$var$VOID_TAGS);
var $2e8a73b3e94346d3$var$specialBooleanAttrs = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly";
var $2e8a73b3e94346d3$export$d186f5eb2e810715 = /* @__PURE__ */ $2e8a73b3e94346d3$export$b41394a5437791c8($2e8a73b3e94346d3$var$specialBooleanAttrs);
var $2e8a73b3e94346d3$export$f763ba3b84e9cd8c = /* @__PURE__ */ $2e8a73b3e94346d3$export$b41394a5437791c8($2e8a73b3e94346d3$var$specialBooleanAttrs + ",async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected");
function $2e8a73b3e94346d3$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
var $2e8a73b3e94346d3$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
var $2e8a73b3e94346d3$var$attrValidationCache = {};
function $2e8a73b3e94346d3$export$d55ef77660f30d12(name) {
    if ($2e8a73b3e94346d3$var$attrValidationCache.hasOwnProperty(name)) return $2e8a73b3e94346d3$var$attrValidationCache[name];
    var isUnsafe = $2e8a73b3e94346d3$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error("unsafe attribute name: ".concat(name));
    return $2e8a73b3e94346d3$var$attrValidationCache[name] = !isUnsafe;
}
var $2e8a73b3e94346d3$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
var $2e8a73b3e94346d3$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $2e8a73b3e94346d3$export$b41394a5437791c8("accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap");
var $2e8a73b3e94346d3$export$80da416f43933831 = /* @__PURE__ */ $2e8a73b3e94346d3$export$b41394a5437791c8("xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan");
var $2e8a73b3e94346d3$export$fc0748a8e0014066 = /* @__PURE__ */ $2e8a73b3e94346d3$export$b41394a5437791c8("accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns");
function $2e8a73b3e94346d3$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    var type = typeof value === "undefined" ? "undefined" : (0, $6gBIz._)(value);
    return type === "string" || type === "number" || type === "boolean";
}
var $2e8a73b3e94346d3$var$escapeRE = /["'&<>]/;
function $2e8a73b3e94346d3$export$4cf11838cdc2a8a8(string) {
    var str = "" + string;
    var match = $2e8a73b3e94346d3$var$escapeRE.exec(str);
    if (!match) return str;
    var html = "";
    var escaped;
    var index;
    var lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
var $2e8a73b3e94346d3$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $2e8a73b3e94346d3$export$7b105034a53bde5f(src) {
    return src.replace($2e8a73b3e94346d3$var$commentStripRE, "");
}
var $2e8a73b3e94346d3$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $2e8a73b3e94346d3$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($2e8a73b3e94346d3$export$9320a7246b331080, function(s) {
        return doubleEscape ? s === '"' ? '\\\\\\"' : "\\\\".concat(s) : "\\".concat(s);
    });
}
function $2e8a73b3e94346d3$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    var equal = true;
    for(var i = 0; equal && i < a.length; i++)equal = $2e8a73b3e94346d3$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $2e8a73b3e94346d3$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    var aValidType = $2e8a73b3e94346d3$export$871608497c498473(a);
    var bValidType = $2e8a73b3e94346d3$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $2e8a73b3e94346d3$export$a244864fd9645c7f(a);
    bValidType = $2e8a73b3e94346d3$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $2e8a73b3e94346d3$export$43bee75e5e14138e(a);
    bValidType = $2e8a73b3e94346d3$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $2e8a73b3e94346d3$var$looseCompareArrays(a, b) : false;
    aValidType = $2e8a73b3e94346d3$export$a6cdc56e425d0d0a(a);
    bValidType = $2e8a73b3e94346d3$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        var aKeysCount = Object.keys(a).length;
        var bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(var key in a){
            var aHasKey = a.hasOwnProperty(key);
            var bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$2e8a73b3e94346d3$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $2e8a73b3e94346d3$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex(function(item) {
        return $2e8a73b3e94346d3$export$ae8015769846262c(item, val);
    });
}
var $2e8a73b3e94346d3$var$isRef = function(val) {
    return !!(val && val["__v_isRef"] === true);
};
var $2e8a73b3e94346d3$export$b5b1545233b45293 = function(val) {
    return $2e8a73b3e94346d3$export$844ec244b1367d54(val) ? val : val == null ? "" : $2e8a73b3e94346d3$export$43bee75e5e14138e(val) || $2e8a73b3e94346d3$export$a6cdc56e425d0d0a(val) && (val.toString === $2e8a73b3e94346d3$export$830c053460e5ddf6 || !$2e8a73b3e94346d3$export$f6e2535fb5126e54(val.toString)) ? $2e8a73b3e94346d3$var$isRef(val) ? $2e8a73b3e94346d3$export$b5b1545233b45293(val.value) : JSON.stringify(val, $2e8a73b3e94346d3$var$replacer, 2) : String(val);
};
var $2e8a73b3e94346d3$var$replacer = function(_key, val) {
    if ($2e8a73b3e94346d3$var$isRef(val)) return $2e8a73b3e94346d3$var$replacer(_key, val.value);
    else if ($2e8a73b3e94346d3$export$5c90113a285f2241(val)) return (0, $aRIHe._)({}, "Map(".concat(val.size, ")"), (0, $kf9Kn._)(val.entries()).reduce(function(entries, param, i) {
        var _param = (0, $9tk0W._)(param, 2), key = _param[0], val2 = _param[1];
        entries[$2e8a73b3e94346d3$var$stringifySymbol(key, i) + " =>"] = val2;
        return entries;
    }, {}));
    else if ($2e8a73b3e94346d3$export$6750766a7c7ec627(val)) return (0, $aRIHe._)({}, "Set(".concat(val.size, ")"), (0, $kf9Kn._)(val.values()).map(function(v) {
        return $2e8a73b3e94346d3$var$stringifySymbol(v);
    }));
    else if ($2e8a73b3e94346d3$export$a244864fd9645c7f(val)) return $2e8a73b3e94346d3$var$stringifySymbol(val);
    else if ($2e8a73b3e94346d3$export$a6cdc56e425d0d0a(val) && !$2e8a73b3e94346d3$export$43bee75e5e14138e(val) && !$2e8a73b3e94346d3$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
var $2e8a73b3e94346d3$var$stringifySymbol = function(v) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $2e8a73b3e94346d3$export$a244864fd9645c7f(v) ? "Symbol(".concat((_a = v.description) != null ? _a : i, ")") : v);
};
function $2e8a73b3e94346d3$export$97fe3d6453ee2f5e(value) {
    if (value == null) return "initial";
    if (typeof value === "string") return value === "" ? " " : value;
    typeof value !== "number" || Number.isFinite(value);
    return String(value);
}

});



parcelRegister("kRi7Z", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", function () { return (parcelRequire("8B0Dy")).BaseTransition; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return (parcelRequire("8B0Dy")).BaseTransitionPropsValidators; });
$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return (parcelRequire("8B0Dy")).callWithAsyncErrorHandling; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("3ZJCa")).camelize; });
$parcel$export(module.exports, "cloneVNode", function () { return (parcelRequire("8B0Dy")).cloneVNode; });
$parcel$export(module.exports, "Comment", function () { return (parcelRequire("8B0Dy")).Comment; });
$parcel$export(module.exports, "computed", function () { return (parcelRequire("8B0Dy")).computed; });
$parcel$export(module.exports, "createBlock", function () { return (parcelRequire("8B0Dy")).createBlock; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("8B0Dy")).createCommentVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("8B0Dy")).createElementBlock; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("8B0Dy")).createElementVNode; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return (parcelRequire("8B0Dy")).createHydrationRenderer; });
$parcel$export(module.exports, "createRenderer", function () { return (parcelRequire("8B0Dy")).createRenderer; });
$parcel$export(module.exports, "createSlots", function () { return (parcelRequire("8B0Dy")).createSlots; });
$parcel$export(module.exports, "createStaticVNode", function () { return (parcelRequire("8B0Dy")).createStaticVNode; });
$parcel$export(module.exports, "createTextVNode", function () { return (parcelRequire("8B0Dy")).createTextVNode; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("8B0Dy")).createVNode; });
$parcel$export(module.exports, "defineComponent", function () { return (parcelRequire("8B0Dy")).defineComponent; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("8B0Dy")).Fragment; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("8B0Dy")).getCurrentInstance; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return (parcelRequire("8B0Dy")).getTransitionRawChildren; });
$parcel$export(module.exports, "guardReactiveProps", function () { return (parcelRequire("8B0Dy")).guardReactiveProps; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("8B0Dy")).h; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("8B0Dy")).initCustomFormatter; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("8B0Dy")).inject; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("5wB2C")).isRef; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return (parcelRequire("8B0Dy")).isRuntimeOnly; });
$parcel$export(module.exports, "mergeDefaults", function () { return (parcelRequire("8B0Dy")).mergeDefaults; });
$parcel$export(module.exports, "mergeProps", function () { return (parcelRequire("8B0Dy")).mergeProps; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("8B0Dy")).nextTick; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("3ZJCa")).normalizeClass; });
$parcel$export(module.exports, "normalizeStyle", function () { return (parcelRequire("3ZJCa")).normalizeStyle; });
$parcel$export(module.exports, "onBeforeMount", function () { return (parcelRequire("8B0Dy")).onBeforeMount; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return (parcelRequire("8B0Dy")).onBeforeUnmount; });
$parcel$export(module.exports, "onBeforeUpdate", function () { return (parcelRequire("8B0Dy")).onBeforeUpdate; });
$parcel$export(module.exports, "onDeactivated", function () { return (parcelRequire("8B0Dy")).onDeactivated; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("8B0Dy")).onMounted; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("8B0Dy")).onUnmounted; });
$parcel$export(module.exports, "onUpdated", function () { return (parcelRequire("8B0Dy")).onUpdated; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("8B0Dy")).openBlock; });
$parcel$export(module.exports, "popScopeId", function () { return (parcelRequire("8B0Dy")).popScopeId; });
$parcel$export(module.exports, "provide", function () { return (parcelRequire("8B0Dy")).provide; });
$parcel$export(module.exports, "pushScopeId", function () { return (parcelRequire("8B0Dy")).pushScopeId; });
$parcel$export(module.exports, "queuePostFlushCb", function () { return (parcelRequire("8B0Dy")).queuePostFlushCb; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("5wB2C")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("5wB2C")).ref; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("8B0Dy")).renderList; });
$parcel$export(module.exports, "renderSlot", function () { return (parcelRequire("8B0Dy")).renderSlot; });
$parcel$export(module.exports, "resolveComponent", function () { return (parcelRequire("8B0Dy")).resolveComponent; });
$parcel$export(module.exports, "resolveDirective", function () { return (parcelRequire("8B0Dy")).resolveDirective; });
$parcel$export(module.exports, "resolveDynamicComponent", function () { return (parcelRequire("8B0Dy")).resolveDynamicComponent; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return (parcelRequire("8B0Dy")).resolveTransitionHooks; });
$parcel$export(module.exports, "setTransitionHooks", function () { return (parcelRequire("8B0Dy")).setTransitionHooks; });
$parcel$export(module.exports, "shallowRef", function () { return (parcelRequire("5wB2C")).shallowRef; });
$parcel$export(module.exports, "Static", function () { return (parcelRequire("8B0Dy")).Static; });
$parcel$export(module.exports, "Teleport", function () { return (parcelRequire("8B0Dy")).Teleport; });
$parcel$export(module.exports, "Text", function () { return (parcelRequire("8B0Dy")).Text; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("5wB2C")).toRaw; });
$parcel$export(module.exports, "useAttrs", function () { return (parcelRequire("8B0Dy")).useAttrs; });
$parcel$export(module.exports, "useSlots", function () { return (parcelRequire("8B0Dy")).useSlots; });
$parcel$export(module.exports, "useTransitionState", function () { return (parcelRequire("8B0Dy")).useTransitionState; });
$parcel$export(module.exports, "warn", function () { return (parcelRequire("8B0Dy")).warn; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("8B0Dy")).watch; });
$parcel$export(module.exports, "watchEffect", function () { return (parcelRequire("8B0Dy")).watchEffect; });
$parcel$export(module.exports, "withCtx", function () { return (parcelRequire("8B0Dy")).withCtx; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("8B0Dy")).withDirectives; });
$parcel$export(module.exports, "normalizeProps", function () { return (parcelRequire("3ZJCa")).normalizeProps; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("3ZJCa")).toDisplayString; });

$parcel$export(module.exports, "Transition", function () { return $f2f6d1b61d3ac3fc$export$be58926105124dd4; });
$parcel$export(module.exports, "vShow", function () { return $f2f6d1b61d3ac3fc$export$5cb4fcdc6937d7e1; });
$parcel$export(module.exports, "createApp", function () { return $f2f6d1b61d3ac3fc$export$4e373c34abfa8c68; });
$parcel$export(module.exports, "useCssModule", function () { return $f2f6d1b61d3ac3fc$export$9300d5b90d56e3d1; });
$parcel$export(module.exports, "vModelText", function () { return $f2f6d1b61d3ac3fc$export$f1f88689f5728478; });
$parcel$export(module.exports, "withModifiers", function () { return $f2f6d1b61d3ac3fc$export$26bd3b8e29e6f273; });
$parcel$export(module.exports, "withKeys", function () { return $f2f6d1b61d3ac3fc$export$f691a8759658f782; });
/**
* @vue/runtime-dom v3.5.22
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $1mRNr = parcelRequire("1mRNr");

var $1UdHD = parcelRequire("1UdHD");

var $iH1wO = parcelRequire("iH1wO");

var $h4SHl = parcelRequire("h4SHl");

var $9tk0W = parcelRequire("9tk0W");

var $kf9Kn = parcelRequire("kf9Kn");

var $6gBIz = parcelRequire("6gBIz");

var $8B0Dy = parcelRequire("8B0Dy");
var $3ZJCa = parcelRequire("3ZJCa");
var $5wB2C = parcelRequire("5wB2C");
var $5wB2C = parcelRequire("5wB2C");parcelRequire("3ZJCa");

var $3ZJCa = parcelRequire("3ZJCa");
var $f2f6d1b61d3ac3fc$var$policy = void 0;
var $f2f6d1b61d3ac3fc$var$tt = typeof window !== "undefined" && window.trustedTypes;
if ($f2f6d1b61d3ac3fc$var$tt) try {
    $f2f6d1b61d3ac3fc$var$policy = /* @__PURE__ */ $f2f6d1b61d3ac3fc$var$tt.createPolicy("vue", {
        createHTML: function(val) {
            return val;
        }
    });
} catch (e) {}
var $f2f6d1b61d3ac3fc$var$unsafeToTrustedHTML = $f2f6d1b61d3ac3fc$var$policy ? function(val) {
    return $f2f6d1b61d3ac3fc$var$policy.createHTML(val);
} : function(val) {
    return val;
};
var $f2f6d1b61d3ac3fc$var$svgNS = "http://www.w3.org/2000/svg";
var $f2f6d1b61d3ac3fc$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
var $f2f6d1b61d3ac3fc$var$doc = typeof document !== "undefined" ? document : null;
var $f2f6d1b61d3ac3fc$var$templateContainer = $f2f6d1b61d3ac3fc$var$doc && /* @__PURE__ */ $f2f6d1b61d3ac3fc$var$doc.createElement("template");
var $f2f6d1b61d3ac3fc$var$nodeOps = {
    insert: function(child, parent, anchor) {
        parent.insertBefore(child, anchor || null);
    },
    remove: function(child) {
        var parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: function(tag, namespace, is, props) {
        var el = namespace === "svg" ? $f2f6d1b61d3ac3fc$var$doc.createElementNS($f2f6d1b61d3ac3fc$var$svgNS, tag) : namespace === "mathml" ? $f2f6d1b61d3ac3fc$var$doc.createElementNS($f2f6d1b61d3ac3fc$var$mathmlNS, tag) : is ? $f2f6d1b61d3ac3fc$var$doc.createElement(tag, {
            is: is
        }) : $f2f6d1b61d3ac3fc$var$doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: function(text) {
        return $f2f6d1b61d3ac3fc$var$doc.createTextNode(text);
    },
    createComment: function(text) {
        return $f2f6d1b61d3ac3fc$var$doc.createComment(text);
    },
    setText: function(node, text) {
        node.nodeValue = text;
    },
    setElementText: function(el, text) {
        el.textContent = text;
    },
    parentNode: function(node) {
        return node.parentNode;
    },
    nextSibling: function(node) {
        return node.nextSibling;
    },
    querySelector: function(selector) {
        return $f2f6d1b61d3ac3fc$var$doc.querySelector(selector);
    },
    setScopeId: function(el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent: function(content, parent, anchor, namespace, start, end) {
        var before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $f2f6d1b61d3ac3fc$var$templateContainer.innerHTML = $f2f6d1b61d3ac3fc$var$unsafeToTrustedHTML(namespace === "svg" ? "<svg>".concat(content, "</svg>") : namespace === "mathml" ? "<math>".concat(content, "</math>") : content);
            var template = $f2f6d1b61d3ac3fc$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                var wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
var $f2f6d1b61d3ac3fc$var$TRANSITION = "transition";
var $f2f6d1b61d3ac3fc$var$ANIMATION = "animation";
var $f2f6d1b61d3ac3fc$var$vtcKey = Symbol("_vtc");
var $f2f6d1b61d3ac3fc$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        "default": true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
var $f2f6d1b61d3ac3fc$var$TransitionPropsValidators = /* @__PURE__ */ (0, $3ZJCa.extend)({}, (0, $8B0Dy.BaseTransitionPropsValidators), $f2f6d1b61d3ac3fc$var$DOMTransitionPropsValidators);
var $f2f6d1b61d3ac3fc$var$decorate$1 = function(t) {
    t.displayName = "Transition";
    t.props = $f2f6d1b61d3ac3fc$var$TransitionPropsValidators;
    return t;
};
var $f2f6d1b61d3ac3fc$export$be58926105124dd4 = /* @__PURE__ */ $f2f6d1b61d3ac3fc$var$decorate$1(function(props, param) {
    var slots = param.slots;
    return (0, $8B0Dy.h)((0, $8B0Dy.BaseTransition), $f2f6d1b61d3ac3fc$var$resolveTransitionProps(props), slots);
});
var $f2f6d1b61d3ac3fc$var$callHook = function(hook) {
    var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    if ((0, $3ZJCa.isArray)(hook)) hook.forEach(function(h2) {
        return h2.apply(void 0, (0, $kf9Kn._)(args));
    });
    else if (hook) hook.apply(void 0, (0, $kf9Kn._)(args));
};
var $f2f6d1b61d3ac3fc$var$hasExplicitCallback = function(hook) {
    return hook ? (0, $3ZJCa.isArray)(hook) ? hook.some(function(h2) {
        return h2.length > 1;
    }) : hook.length > 1 : false;
};
function $f2f6d1b61d3ac3fc$var$resolveTransitionProps(rawProps) {
    var baseProps = {};
    for(var key in rawProps)if (!(key in $f2f6d1b61d3ac3fc$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    var _rawProps_name = rawProps.name, name = _rawProps_name === void 0 ? "v" : _rawProps_name, type = rawProps.type, duration = rawProps.duration, _rawProps_enterFromClass = rawProps.enterFromClass, enterFromClass = _rawProps_enterFromClass === void 0 ? "".concat(name, "-enter-from") : _rawProps_enterFromClass, _rawProps_enterActiveClass = rawProps.enterActiveClass, enterActiveClass = _rawProps_enterActiveClass === void 0 ? "".concat(name, "-enter-active") : _rawProps_enterActiveClass, _rawProps_enterToClass = rawProps.enterToClass, enterToClass = _rawProps_enterToClass === void 0 ? "".concat(name, "-enter-to") : _rawProps_enterToClass, _rawProps_appearFromClass = rawProps.appearFromClass, appearFromClass = _rawProps_appearFromClass === void 0 ? enterFromClass : _rawProps_appearFromClass, _rawProps_appearActiveClass = rawProps.appearActiveClass, appearActiveClass = _rawProps_appearActiveClass === void 0 ? enterActiveClass : _rawProps_appearActiveClass, _rawProps_appearToClass = rawProps.appearToClass, appearToClass = _rawProps_appearToClass === void 0 ? enterToClass : _rawProps_appearToClass, _rawProps_leaveFromClass = rawProps.leaveFromClass, leaveFromClass = _rawProps_leaveFromClass === void 0 ? "".concat(name, "-leave-from") : _rawProps_leaveFromClass, _rawProps_leaveActiveClass = rawProps.leaveActiveClass, leaveActiveClass = _rawProps_leaveActiveClass === void 0 ? "".concat(name, "-leave-active") : _rawProps_leaveActiveClass, _rawProps_leaveToClass = rawProps.leaveToClass, leaveToClass = _rawProps_leaveToClass === void 0 ? "".concat(name, "-leave-to") : _rawProps_leaveToClass;
    var durations = $f2f6d1b61d3ac3fc$var$normalizeDuration(duration);
    var enterDuration = durations && durations[0];
    var leaveDuration = durations && durations[1];
    var onBeforeEnter = baseProps.onBeforeEnter, onEnter = baseProps.onEnter, onEnterCancelled = baseProps.onEnterCancelled, onLeave = baseProps.onLeave, onLeaveCancelled = baseProps.onLeaveCancelled, _baseProps_onBeforeAppear = baseProps.onBeforeAppear, onBeforeAppear = _baseProps_onBeforeAppear === void 0 ? onBeforeEnter : _baseProps_onBeforeAppear, _baseProps_onAppear = baseProps.onAppear, onAppear = _baseProps_onAppear === void 0 ? onEnter : _baseProps_onAppear, _baseProps_onAppearCancelled = baseProps.onAppearCancelled, onAppearCancelled = _baseProps_onAppearCancelled === void 0 ? onEnterCancelled : _baseProps_onAppearCancelled;
    var finishEnter = function(el, isAppear, done, isCancelled) {
        el._enterCancelled = isCancelled;
        $f2f6d1b61d3ac3fc$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $f2f6d1b61d3ac3fc$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    var finishLeave = function(el, done) {
        el._isLeaving = false;
        $f2f6d1b61d3ac3fc$var$removeTransitionClass(el, leaveFromClass);
        $f2f6d1b61d3ac3fc$var$removeTransitionClass(el, leaveToClass);
        $f2f6d1b61d3ac3fc$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    var makeEnterHook = function(isAppear) {
        return function(el, done) {
            var hook = isAppear ? onAppear : onEnter;
            var resolve = function() {
                return finishEnter(el, isAppear, done);
            };
            $f2f6d1b61d3ac3fc$var$callHook(hook, [
                el,
                resolve
            ]);
            $f2f6d1b61d3ac3fc$var$nextFrame(function() {
                $f2f6d1b61d3ac3fc$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $f2f6d1b61d3ac3fc$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$f2f6d1b61d3ac3fc$var$hasExplicitCallback(hook)) $f2f6d1b61d3ac3fc$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $3ZJCa.extend)(baseProps, {
        onBeforeEnter: function(el) {
            $f2f6d1b61d3ac3fc$var$callHook(onBeforeEnter, [
                el
            ]);
            $f2f6d1b61d3ac3fc$var$addTransitionClass(el, enterFromClass);
            $f2f6d1b61d3ac3fc$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear: function(el) {
            $f2f6d1b61d3ac3fc$var$callHook(onBeforeAppear, [
                el
            ]);
            $f2f6d1b61d3ac3fc$var$addTransitionClass(el, appearFromClass);
            $f2f6d1b61d3ac3fc$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave: function(el, done) {
            el._isLeaving = true;
            var resolve = function() {
                return finishLeave(el, done);
            };
            $f2f6d1b61d3ac3fc$var$addTransitionClass(el, leaveFromClass);
            if (!el._enterCancelled) {
                $f2f6d1b61d3ac3fc$var$forceReflow(el);
                $f2f6d1b61d3ac3fc$var$addTransitionClass(el, leaveActiveClass);
            } else {
                $f2f6d1b61d3ac3fc$var$addTransitionClass(el, leaveActiveClass);
                $f2f6d1b61d3ac3fc$var$forceReflow(el);
            }
            $f2f6d1b61d3ac3fc$var$nextFrame(function() {
                if (!el._isLeaving) return;
                $f2f6d1b61d3ac3fc$var$removeTransitionClass(el, leaveFromClass);
                $f2f6d1b61d3ac3fc$var$addTransitionClass(el, leaveToClass);
                if (!$f2f6d1b61d3ac3fc$var$hasExplicitCallback(onLeave)) $f2f6d1b61d3ac3fc$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $f2f6d1b61d3ac3fc$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled: function(el) {
            finishEnter(el, false, void 0, true);
            $f2f6d1b61d3ac3fc$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled: function(el) {
            finishEnter(el, true, void 0, true);
            $f2f6d1b61d3ac3fc$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled: function(el) {
            finishLeave(el);
            $f2f6d1b61d3ac3fc$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $f2f6d1b61d3ac3fc$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $3ZJCa.isObject)(duration)) return [
        $f2f6d1b61d3ac3fc$var$NumberOf(duration.enter),
        $f2f6d1b61d3ac3fc$var$NumberOf(duration.leave)
    ];
    else {
        var n = $f2f6d1b61d3ac3fc$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $f2f6d1b61d3ac3fc$var$NumberOf(val) {
    var res = (0, $3ZJCa.toNumber)(val);
    return res;
}
function $f2f6d1b61d3ac3fc$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach(function(c) {
        return c && el.classList.add(c);
    });
    (el[$f2f6d1b61d3ac3fc$var$vtcKey] || (el[$f2f6d1b61d3ac3fc$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $f2f6d1b61d3ac3fc$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach(function(c) {
        return c && el.classList.remove(c);
    });
    var _vtc = el[$f2f6d1b61d3ac3fc$var$vtcKey];
    if (_vtc) {
        _vtc["delete"](cls);
        if (!_vtc.size) el[$f2f6d1b61d3ac3fc$var$vtcKey] = void 0;
    }
}
function $f2f6d1b61d3ac3fc$var$nextFrame(cb) {
    requestAnimationFrame(function() {
        requestAnimationFrame(cb);
    });
}
var $f2f6d1b61d3ac3fc$var$endId = 0;
function $f2f6d1b61d3ac3fc$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    var id = el._endId = ++$f2f6d1b61d3ac3fc$var$endId;
    var resolveIfNotStale = function() {
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    var _getTransitionInfo = $f2f6d1b61d3ac3fc$var$getTransitionInfo(el, expectedType), type = _getTransitionInfo.type, timeout = _getTransitionInfo.timeout, propCount = _getTransitionInfo.propCount;
    if (!type) return resolve();
    var endEvent = type + "end";
    var ended = 0;
    var end = function() {
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    var onEnd = function(e) {
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(function() {
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $f2f6d1b61d3ac3fc$var$getTransitionInfo(el, expectedType) {
    var styles = window.getComputedStyle(el);
    var getStyleProperties = function(key) {
        return (styles[key] || "").split(", ");
    };
    var transitionDelays = getStyleProperties("".concat($f2f6d1b61d3ac3fc$var$TRANSITION, "Delay"));
    var transitionDurations = getStyleProperties("".concat($f2f6d1b61d3ac3fc$var$TRANSITION, "Duration"));
    var transitionTimeout = $f2f6d1b61d3ac3fc$var$getTimeout(transitionDelays, transitionDurations);
    var animationDelays = getStyleProperties("".concat($f2f6d1b61d3ac3fc$var$ANIMATION, "Delay"));
    var animationDurations = getStyleProperties("".concat($f2f6d1b61d3ac3fc$var$ANIMATION, "Duration"));
    var animationTimeout = $f2f6d1b61d3ac3fc$var$getTimeout(animationDelays, animationDurations);
    var type = null;
    var timeout = 0;
    var propCount = 0;
    if (expectedType === $f2f6d1b61d3ac3fc$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $f2f6d1b61d3ac3fc$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $f2f6d1b61d3ac3fc$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $f2f6d1b61d3ac3fc$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $f2f6d1b61d3ac3fc$var$TRANSITION : $f2f6d1b61d3ac3fc$var$ANIMATION : null;
        propCount = type ? type === $f2f6d1b61d3ac3fc$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    var hasTransform = type === $f2f6d1b61d3ac3fc$var$TRANSITION && /\b(?:transform|all)(?:,|$)/.test(getStyleProperties("".concat($f2f6d1b61d3ac3fc$var$TRANSITION, "Property")).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $f2f6d1b61d3ac3fc$var$getTimeout(delays, durations) {
    var _Math;
    while(delays.length < durations.length)delays = delays.concat(delays);
    return (_Math = Math).max.apply(_Math, (0, $kf9Kn._)(durations.map(function(d, i) {
        return $f2f6d1b61d3ac3fc$var$toMs(d) + $f2f6d1b61d3ac3fc$var$toMs(delays[i]);
    })));
}
function $f2f6d1b61d3ac3fc$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $f2f6d1b61d3ac3fc$var$forceReflow(el) {
    var targetDocument = el ? el.ownerDocument : document;
    return targetDocument.body.offsetHeight;
}
function $f2f6d1b61d3ac3fc$var$patchClass(el, value, isSVG) {
    var transitionClasses = el[$f2f6d1b61d3ac3fc$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value
    ].concat((0, $kf9Kn._)(transitionClasses)) : (0, $kf9Kn._)(transitionClasses)).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
var $f2f6d1b61d3ac3fc$var$vShowOriginalDisplay = Symbol("_vod");
var $f2f6d1b61d3ac3fc$var$vShowHidden = Symbol("_vsh");
var $f2f6d1b61d3ac3fc$export$5cb4fcdc6937d7e1 = {
    // used for prop mismatch check during hydration
    name: "show",
    beforeMount: function(el, param, param1) {
        var value = param.value, transition = param1.transition;
        el[$f2f6d1b61d3ac3fc$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $f2f6d1b61d3ac3fc$var$setDisplay(el, value);
    },
    mounted: function(el, param, param1) {
        var value = param.value, transition = param1.transition;
        if (transition && value) transition.enter(el);
    },
    updated: function(el, param, param1) {
        var value = param.value, oldValue = param.oldValue, transition = param1.transition;
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $f2f6d1b61d3ac3fc$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, function() {
                $f2f6d1b61d3ac3fc$var$setDisplay(el, false);
            });
        } else $f2f6d1b61d3ac3fc$var$setDisplay(el, value);
    },
    beforeUnmount: function(el, param) {
        var value = param.value;
        $f2f6d1b61d3ac3fc$var$setDisplay(el, value);
    }
};
function $f2f6d1b61d3ac3fc$var$setDisplay(el, value) {
    el.style.display = value ? el[$f2f6d1b61d3ac3fc$var$vShowOriginalDisplay] : "none";
    el[$f2f6d1b61d3ac3fc$var$vShowHidden] = !value;
}
function $f2f6d1b61d3ac3fc$var$initVShowForSSR() {
    $f2f6d1b61d3ac3fc$export$5cb4fcdc6937d7e1.getSSRProps = function(param) {
        var value = param.value;
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
var $f2f6d1b61d3ac3fc$var$CSS_VAR_TEXT = Symbol("");
function $f2f6d1b61d3ac3fc$export$ef28b76f07940108(getter) {
    var instance = (0, $8B0Dy.getCurrentInstance)();
    if (!instance) return;
    var updateTeleports = instance.ut = function() {
        var vars = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getter(instance.proxy);
        Array.from(document.querySelectorAll('[data-v-owner="'.concat(instance.uid, '"]'))).forEach(function(node) {
            return $f2f6d1b61d3ac3fc$var$setVarsOnNode(node, vars);
        });
    };
    var setVars = function() {
        var vars = getter(instance.proxy);
        if (instance.ce) $f2f6d1b61d3ac3fc$var$setVarsOnNode(instance.ce, vars);
        else $f2f6d1b61d3ac3fc$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $8B0Dy.onBeforeUpdate)(function() {
        (0, $8B0Dy.queuePostFlushCb)(setVars);
    });
    (0, $8B0Dy.onMounted)(function() {
        (0, $8B0Dy.watch)(setVars, (0, $3ZJCa.NOOP), {
            flush: "post"
        });
        var ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $8B0Dy.onUnmounted)(function() {
            return ob.disconnect();
        });
    });
}
function $f2f6d1b61d3ac3fc$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        var suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(function() {
            $f2f6d1b61d3ac3fc$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $f2f6d1b61d3ac3fc$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $8B0Dy.Fragment)) vnode.children.forEach(function(c) {
        return $f2f6d1b61d3ac3fc$var$setVarsOnVNode(c, vars);
    });
    else if (vnode.type === (0, $8B0Dy.Static)) {
        var el = vnode.el, anchor = vnode.anchor;
        while(el){
            $f2f6d1b61d3ac3fc$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $f2f6d1b61d3ac3fc$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        var style = el.style;
        var cssText = "";
        for(var key in vars){
            var value = (0, $3ZJCa.normalizeCssVarValue)(vars[key]);
            style.setProperty("--".concat(key), value);
            cssText += "--".concat(key, ": ").concat(value, ";");
        }
        style[$f2f6d1b61d3ac3fc$var$CSS_VAR_TEXT] = cssText;
    }
}
var $f2f6d1b61d3ac3fc$var$displayRE = /(?:^|;)\s*display\s*:/;
function $f2f6d1b61d3ac3fc$var$patchStyle(el, prev, next) {
    var style = el.style;
    var isCssString = (0, $3ZJCa.isString)(next);
    var hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (!(0, $3ZJCa.isString)(prev)) {
                for(var key in prev)if (next[key] == null) $f2f6d1b61d3ac3fc$var$setStyle(style, key, "");
            } else try {
                for(var _iterator = prev.split(";")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var prevStyle = _step.value;
                    var key1 = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                    if (next[key1] == null) $f2f6d1b61d3ac3fc$var$setStyle(style, key1, "");
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        for(var key2 in next){
            if (key2 === "display") hasControlledDisplay = true;
            $f2f6d1b61d3ac3fc$var$setStyle(style, key2, next[key2]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                var cssVarText = style[$f2f6d1b61d3ac3fc$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $f2f6d1b61d3ac3fc$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($f2f6d1b61d3ac3fc$var$vShowOriginalDisplay in el) {
        el[$f2f6d1b61d3ac3fc$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$f2f6d1b61d3ac3fc$var$vShowHidden]) style.display = "none";
    }
}
var $f2f6d1b61d3ac3fc$var$semicolonRE = /[^\\];\s*$/;
var $f2f6d1b61d3ac3fc$var$importantRE = /\s*!important$/;
function $f2f6d1b61d3ac3fc$var$setStyle(style, name, val) {
    if ((0, $3ZJCa.isArray)(val)) val.forEach(function(v) {
        return $f2f6d1b61d3ac3fc$var$setStyle(style, name, v);
    });
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            var prefixed = $f2f6d1b61d3ac3fc$var$autoPrefix(style, name);
            if ($f2f6d1b61d3ac3fc$var$importantRE.test(val)) style.setProperty((0, $3ZJCa.hyphenate)(prefixed), val.replace($f2f6d1b61d3ac3fc$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
var $f2f6d1b61d3ac3fc$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
var $f2f6d1b61d3ac3fc$var$prefixCache = {};
function $f2f6d1b61d3ac3fc$var$autoPrefix(style, rawName) {
    var cached = $f2f6d1b61d3ac3fc$var$prefixCache[rawName];
    if (cached) return cached;
    var name = (0, $3ZJCa.camelize)(rawName);
    if (name !== "filter" && name in style) return $f2f6d1b61d3ac3fc$var$prefixCache[rawName] = name;
    name = (0, $3ZJCa.capitalize)(name);
    for(var i = 0; i < $f2f6d1b61d3ac3fc$var$prefixes.length; i++){
        var prefixed = $f2f6d1b61d3ac3fc$var$prefixes[i] + name;
        if (prefixed in style) return $f2f6d1b61d3ac3fc$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
var $f2f6d1b61d3ac3fc$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $f2f6d1b61d3ac3fc$var$patchAttr(el, key, value, isSVG, instance) {
    var isBoolean = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : (0, $3ZJCa.isSpecialBooleanAttr)(key);
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($f2f6d1b61d3ac3fc$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($f2f6d1b61d3ac3fc$var$xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, $3ZJCa.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, $3ZJCa.isSymbol)(value) ? String(value) : value);
}
function $f2f6d1b61d3ac3fc$var$patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? $f2f6d1b61d3ac3fc$var$unsafeToTrustedHTML(value) : value;
        return;
    }
    var tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        var oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        var newValue = value == null ? // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    var needRemove = false;
    if (value === "" || value == null) {
        var type = (0, $6gBIz._)(el[key]);
        if (type === "boolean") value = (0, $3ZJCa.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
function $f2f6d1b61d3ac3fc$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $f2f6d1b61d3ac3fc$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
var $f2f6d1b61d3ac3fc$var$veiKey = Symbol("_vei");
function $f2f6d1b61d3ac3fc$var$patchEvent(el, rawName, prevValue, nextValue) {
    var instance = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    var invokers = el[$f2f6d1b61d3ac3fc$var$veiKey] || (el[$f2f6d1b61d3ac3fc$var$veiKey] = {});
    var existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        var _parseName = (0, $9tk0W._)($f2f6d1b61d3ac3fc$var$parseName(rawName), 2), name = _parseName[0], options = _parseName[1];
        if (nextValue) {
            var invoker = invokers[rawName] = $f2f6d1b61d3ac3fc$var$createInvoker(nextValue, instance);
            $f2f6d1b61d3ac3fc$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $f2f6d1b61d3ac3fc$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
var $f2f6d1b61d3ac3fc$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $f2f6d1b61d3ac3fc$var$parseName(name) {
    var options;
    if ($f2f6d1b61d3ac3fc$var$optionsModifierRE.test(name)) {
        options = {};
        var m;
        while(m = name.match($f2f6d1b61d3ac3fc$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    var event = name[2] === ":" ? name.slice(3) : (0, $3ZJCa.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
var $f2f6d1b61d3ac3fc$var$cachedNow = 0;
var $f2f6d1b61d3ac3fc$var$p = /* @__PURE__ */ Promise.resolve();
var $f2f6d1b61d3ac3fc$var$getNow = function() {
    return $f2f6d1b61d3ac3fc$var$cachedNow || ($f2f6d1b61d3ac3fc$var$p.then(function() {
        return $f2f6d1b61d3ac3fc$var$cachedNow = 0;
    }), $f2f6d1b61d3ac3fc$var$cachedNow = Date.now());
};
function $f2f6d1b61d3ac3fc$var$createInvoker(initialValue, instance) {
    var invoker = function(e) {
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $8B0Dy.callWithAsyncErrorHandling)($f2f6d1b61d3ac3fc$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $f2f6d1b61d3ac3fc$var$getNow();
    return invoker;
}
function $f2f6d1b61d3ac3fc$var$sanitizeEventValue(value, propName) {
    if ((0, $3ZJCa.isFunction)(value) || (0, $3ZJCa.isArray)(value)) return value;
    (0, $8B0Dy.warn)("Wrong type passed as event handler to ".concat(propName, " - did you forget @ or : in front of your prop?\nExpected function or array of functions, received type ").concat(typeof value === "undefined" ? "undefined" : (0, $6gBIz._)(value), "."));
    return 0, $3ZJCa.NOOP;
}
function $f2f6d1b61d3ac3fc$var$patchStopImmediatePropagation(e, value) {
    if ((0, $3ZJCa.isArray)(value)) {
        var originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = function() {
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map(function(fn) {
            return function(e2) {
                return !e2._stopped && fn && fn(e2);
            };
        });
    } else return value;
}
var $f2f6d1b61d3ac3fc$var$isNativeOn = function(key) {
    return key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
};
var $f2f6d1b61d3ac3fc$var$patchProp = function(el, key, prevValue, nextValue, namespace, parentComponent) {
    var isSVG = namespace === "svg";
    if (key === "class") $f2f6d1b61d3ac3fc$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $f2f6d1b61d3ac3fc$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $3ZJCa.isOn)(key)) {
        if (!(0, $3ZJCa.isModelListener)(key)) $f2f6d1b61d3ac3fc$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $f2f6d1b61d3ac3fc$var$shouldSetAsProp(el, key, nextValue, isSVG)) {
        $f2f6d1b61d3ac3fc$var$patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) $f2f6d1b61d3ac3fc$var$patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (// #11081 force set props for possible async custom element
    el._isVueCE && (/[A-Z]/.test(key) || !(0, $3ZJCa.isString)(nextValue))) $f2f6d1b61d3ac3fc$var$patchDOMProp(el, (0, $3ZJCa.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $f2f6d1b61d3ac3fc$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $f2f6d1b61d3ac3fc$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $f2f6d1b61d3ac3fc$var$isNativeOn(key) && (0, $3ZJCa.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate" || key === "autocorrect") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        var tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($f2f6d1b61d3ac3fc$var$isNativeOn(key) && (0, $3ZJCa.isString)(value)) return false;
    return key in el;
}
var $f2f6d1b61d3ac3fc$var$REMOVAL = {};
// @__NO_SIDE_EFFECTS__
function $f2f6d1b61d3ac3fc$export$a00e2346eabbdbef(options, extraOptions, _createApp) {
    var Comp = (0, $8B0Dy.defineComponent)(options, extraOptions);
    if ((0, $3ZJCa.isPlainObject)(Comp)) Comp = (0, $3ZJCa.extend)({}, Comp, extraOptions);
    var VueCustomElement = /*#__PURE__*/ function(VueElement) {
        "use strict";
        (0, $h4SHl._)(VueCustomElement, VueElement);
        function VueCustomElement(initialProps) {
            (0, $1UdHD._)(this, VueCustomElement);
            return (0, $1mRNr._)(this, VueCustomElement, [
                Comp,
                initialProps,
                _createApp
            ]);
        }
        return VueCustomElement;
    }($f2f6d1b61d3ac3fc$export$b337c1a55163dbe3);
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
var $f2f6d1b61d3ac3fc$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ function(options, extraOptions) {
    return /* @__PURE__ */ $f2f6d1b61d3ac3fc$export$a00e2346eabbdbef(options, extraOptions, $f2f6d1b61d3ac3fc$export$35800275c0037383);
};
var $f2f6d1b61d3ac3fc$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : function _class() {
    "use strict";
    (0, $1UdHD._)(this, _class);
};
var $f2f6d1b61d3ac3fc$export$b337c1a55163dbe3 = /*#__PURE__*/ function(BaseClass) {
    "use strict";
    (0, $h4SHl._)(VueElement, BaseClass);
    function VueElement(_def) {
        var _props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _createApp = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $f2f6d1b61d3ac3fc$export$4e373c34abfa8c68;
        (0, $1UdHD._)(this, VueElement);
        var _this;
        _this = (0, $1mRNr._)(this, VueElement);
        _this._def = _def;
        _this._props = _props;
        _this._createApp = _createApp;
        _this._isVueCE = true;
        /**
     * @internal
     */ _this._instance = null;
        /**
     * @internal
     */ _this._app = null;
        /**
     * @internal
     */ _this._nonce = _this._def.nonce;
        _this._connected = false;
        _this._resolved = false;
        _this._numberProps = null;
        _this._styleChildren = /* @__PURE__ */ new WeakSet();
        _this._ob = null;
        if (_this.shadowRoot && _createApp !== $f2f6d1b61d3ac3fc$export$4e373c34abfa8c68) _this._root = _this.shadowRoot;
        else if (_def.shadowRoot !== false) {
            _this.attachShadow((0, $3ZJCa.extend)({}, _def.shadowRootOptions, {
                mode: "open"
            }));
            _this._root = _this.shadowRoot;
        } else _this._root = _this;
        return _this;
    }
    (0, $iH1wO._)(VueElement, [
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                var _this = this;
                if (!this.isConnected) return;
                if (!this.shadowRoot && !this._resolved) this._parseSlots();
                this._connected = true;
                var parent = this;
                while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof VueElement) {
                    this._parent = parent;
                    break;
                }
                if (!this._instance) {
                    if (this._resolved) this._mount(this._def);
                    else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(function() {
                        _this._pendingResolve = void 0;
                        _this._resolveDef();
                    });
                    else this._resolveDef();
                }
            }
        },
        {
            key: "_setParent",
            value: function _setParent() {
                var parent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._parent;
                if (parent) {
                    this._instance.parent = parent._instance;
                    this._inheritParentContext(parent);
                }
            }
        },
        {
            key: "_inheritParentContext",
            value: function _inheritParentContext() {
                var parent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._parent;
                if (parent && this._app) Object.setPrototypeOf(this._app._context.provides, parent._instance.provides);
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                var _this = this;
                this._connected = false;
                (0, $8B0Dy.nextTick)(function() {
                    if (!_this._connected) {
                        if (_this._ob) {
                            _this._ob.disconnect();
                            _this._ob = null;
                        }
                        _this._app && _this._app.unmount();
                        if (_this._instance) _this._instance.ce = void 0;
                        _this._app = _this._instance = null;
                        if (_this._teleportTargets) {
                            _this._teleportTargets.clear();
                            _this._teleportTargets = void 0;
                        }
                    }
                });
            }
        },
        {
            key: "_processMutations",
            value: function _processMutations(mutations) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var m = _step.value;
                        this._setAttr(m.attributeName);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
   * resolve inner component definition (handle possible async component)
   */ key: "_resolveDef",
            value: function _resolveDef() {
                var _this = this;
                var _this1 = this;
                if (this._pendingResolve) return;
                for(var i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
                this._ob = new MutationObserver(this._processMutations.bind(this));
                this._ob.observe(this, {
                    attributes: true
                });
                var resolve = function(def) {
                    var isAsync = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                    _this1._resolved = true;
                    _this1._pendingResolve = void 0;
                    var props = def.props, styles = def.styles;
                    var numberProps;
                    if (props && !(0, $3ZJCa.isArray)(props)) for(var key in props){
                        var opt = props[key];
                        if (opt === Number || opt && opt.type === Number) {
                            if (key in _this1._props) _this1._props[key] = (0, $3ZJCa.toNumber)(_this1._props[key]);
                            (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $3ZJCa.camelize)(key)] = true;
                        }
                    }
                    _this1._numberProps = numberProps;
                    _this1._resolveProps(def);
                    if (_this1.shadowRoot) _this1._applyStyles(styles);
                    _this1._mount(def);
                };
                var asyncDef = this._def.__asyncLoader;
                if (asyncDef) this._pendingResolve = asyncDef().then(function(def) {
                    def.configureApp = _this._def.configureApp;
                    resolve(_this._def = def, true);
                });
                else resolve(this._def);
            }
        },
        {
            key: "_mount",
            value: function _mount(def) {
                var _this, _loop = function(key) {
                    if (!(0, $3ZJCa.hasOwn)(_this, key)) Object.defineProperty(_this, key, {
                        // unwrap ref to be consistent with public instance behavior
                        get: function() {
                            return (0, $5wB2C.unref)(exposed[key]);
                        }
                    });
                };
                if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
                this._app = this._createApp(def);
                this._inheritParentContext();
                if (def.configureApp) def.configureApp(this._app);
                this._app._ceVNode = this._createVNode();
                this._app.mount(this._root);
                var exposed = this._instance && this._instance.exposed;
                if (!exposed) return;
                for(var key in exposed)_this = this, _loop(key);
            }
        },
        {
            key: "_resolveProps",
            value: function _resolveProps(def) {
                var props = def.props;
                var declaredPropKeys = (0, $3ZJCa.isArray)(props) ? props : Object.keys(props || {});
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    var _this, _loop = function() {
                        var key = _step1.value;
                        Object.defineProperty(_this, key, {
                            get: function() {
                                return this._getProp(key);
                            },
                            set: function(val) {
                                this._setProp(key, val, true, true);
                            }
                        });
                    };
                    for(var _iterator1 = declaredPropKeys.map((0, $3ZJCa.camelize))[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_this = this, _loop();
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            key: "_setAttr",
            value: function _setAttr(key) {
                if (key.startsWith("data-v-")) return;
                var has = this.hasAttribute(key);
                var value = has ? this.getAttribute(key) : $f2f6d1b61d3ac3fc$var$REMOVAL;
                var camelKey = (0, $3ZJCa.camelize)(key);
                if (has && this._numberProps && this._numberProps[camelKey]) value = (0, $3ZJCa.toNumber)(value);
                this._setProp(camelKey, value, false, true);
            }
        },
        {
            /**
   * @internal
   */ key: "_getProp",
            value: function _getProp(key) {
                return this._props[key];
            }
        },
        {
            /**
   * @internal
   */ key: "_setProp",
            value: function _setProp(key, val) {
                var shouldReflect = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, shouldUpdate = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
                if (val !== this._props[key]) {
                    if (val === $f2f6d1b61d3ac3fc$var$REMOVAL) delete this._props[key];
                    else {
                        this._props[key] = val;
                        if (key === "key" && this._app) this._app._ceVNode.key = val;
                    }
                    if (shouldUpdate && this._instance) this._update();
                    if (shouldReflect) {
                        var ob = this._ob;
                        if (ob) {
                            this._processMutations(ob.takeRecords());
                            ob.disconnect();
                        }
                        if (val === true) this.setAttribute((0, $3ZJCa.hyphenate)(key), "");
                        else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $3ZJCa.hyphenate)(key), val + "");
                        else if (!val) this.removeAttribute((0, $3ZJCa.hyphenate)(key));
                        ob && ob.observe(this, {
                            attributes: true
                        });
                    }
                }
            }
        },
        {
            key: "_update",
            value: function _update() {
                var vnode = this._createVNode();
                if (this._app) vnode.appContext = this._app._context;
                $f2f6d1b61d3ac3fc$export$b3890eb0ae9dca99(vnode, this._root);
            }
        },
        {
            key: "_createVNode",
            value: function _createVNode() {
                var _this = this;
                var baseProps = {};
                if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
                var vnode = (0, $8B0Dy.createVNode)(this._def, (0, $3ZJCa.extend)(baseProps, this._props));
                if (!this._instance) vnode.ce = function(instance) {
                    _this._instance = instance;
                    instance.ce = _this;
                    instance.isCE = true;
                    var newStyles, s;
                    var dispatch = function(event, args) {
                        _this.dispatchEvent(new CustomEvent(event, (0, $3ZJCa.isPlainObject)(args[0]) ? (0, $3ZJCa.extend)({
                            detail: args
                        }, args[0]) : {
                            detail: args
                        }));
                    };
                    instance.emit = function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                            args[_key - 1] = arguments[_key];
                        }
                        dispatch(event, args);
                        if ((0, $3ZJCa.hyphenate)(event) !== event) dispatch((0, $3ZJCa.hyphenate)(event), args);
                    };
                    _this._setParent();
                };
                return vnode;
            }
        },
        {
            key: "_applyStyles",
            value: function _applyStyles(styles, owner) {
                if (!styles) return;
                if (owner) {
                    if (owner === this._def || this._styleChildren.has(owner)) return;
                    this._styleChildren.add(owner);
                }
                var nonce = this._nonce;
                for(var i = styles.length - 1; i >= 0; i--){
                    var s = document.createElement("style");
                    if (nonce) s.setAttribute("nonce", nonce);
                    s.textContent = styles[i];
                    this.shadowRoot.prepend(s);
                }
            }
        },
        {
            /**
   * Only called when shadowRoot is false
   */ key: "_parseSlots",
            value: function _parseSlots() {
                var slots = this._slots = {};
                var n;
                while(n = this.firstChild){
                    var slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
                    (slots[slotName] || (slots[slotName] = [])).push(n);
                    this.removeChild(n);
                }
            }
        },
        {
            /**
   * Only called when shadowRoot is false
   */ key: "_renderSlots",
            value: function _renderSlots() {
                var outlets = this._getSlots();
                var scopeId = this._instance.type.__scopeId;
                for(var i = 0; i < outlets.length; i++){
                    var o = outlets[i];
                    var slotName = o.getAttribute("name") || "default";
                    var content = this._slots[slotName];
                    var parent = o.parentNode;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (content) try {
                        for(var _iterator = content[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var n = _step.value;
                            if (scopeId && n.nodeType === 1) {
                                var id = scopeId + "-s";
                                var walker = document.createTreeWalker(n, 1);
                                n.setAttribute(id, "");
                                var child = void 0;
                                while(child = walker.nextNode())child.setAttribute(id, "");
                            }
                            parent.insertBefore(n, o);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    else while(o.firstChild)parent.insertBefore(o.firstChild, o);
                    parent.removeChild(o);
                }
            }
        },
        {
            /**
   * @internal
   */ key: "_getSlots",
            value: function _getSlots() {
                var _roots;
                var roots = [
                    this
                ];
                if (this._teleportTargets) (_roots = roots).push.apply(_roots, (0, $kf9Kn._)(this._teleportTargets));
                return roots.reduce(function(res, i) {
                    var _res;
                    (_res = res).push.apply(_res, (0, $kf9Kn._)(Array.from(i.querySelectorAll("slot"))));
                    return res;
                }, []);
            }
        },
        {
            /**
   * @internal
   */ key: "_injectChildStyle",
            value: function _injectChildStyle(comp) {
                this._applyStyles(comp.styles, comp);
            }
        },
        {
            /**
   * @internal
   */ key: "_removeChildStyle",
            value: function _removeChildStyle(comp) {
                var s;
            }
        }
    ]);
    return VueElement;
}($f2f6d1b61d3ac3fc$var$BaseClass);
function $f2f6d1b61d3ac3fc$export$da5acfe93a94e37d(caller) {
    var instance = (0, $8B0Dy.getCurrentInstance)();
    var el = instance && instance.ce;
    if (el) return el;
    else if (false) {
        if (!instance) (0, $8B0Dy.warn)("".concat(caller || "useHost", " called without an active component instance."));
        else (0, $8B0Dy.warn)("".concat(caller || "useHost", " can only be used in components defined via defineCustomElement."));
    }
    return null;
}
function $f2f6d1b61d3ac3fc$export$64d45095031fa749() {
    var el = $f2f6d1b61d3ac3fc$export$da5acfe93a94e37d();
    return el && el.shadowRoot;
}
function $f2f6d1b61d3ac3fc$export$9300d5b90d56e3d1() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "$style";
    {
        var instance = (0, $8B0Dy.getCurrentInstance)();
        if (!instance) return 0, $3ZJCa.EMPTY_OBJ;
        var modules = instance.type.__cssModules;
        if (!modules) return 0, $3ZJCa.EMPTY_OBJ;
        var mod = modules[name];
        if (!mod) return 0, $3ZJCa.EMPTY_OBJ;
        return mod;
    }
}
var $f2f6d1b61d3ac3fc$var$positionMap = /* @__PURE__ */ new WeakMap();
var $f2f6d1b61d3ac3fc$var$newPositionMap = /* @__PURE__ */ new WeakMap();
var $f2f6d1b61d3ac3fc$var$moveCbKey = Symbol("_moveCb");
var $f2f6d1b61d3ac3fc$var$enterCbKey = Symbol("_enterCb");
var $f2f6d1b61d3ac3fc$var$decorate = function(t) {
    delete t.props.mode;
    return t;
};
var $f2f6d1b61d3ac3fc$var$TransitionGroupImpl = /* @__PURE__ */ $f2f6d1b61d3ac3fc$var$decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $3ZJCa.extend)({}, $f2f6d1b61d3ac3fc$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup: function(props, param) {
        var slots = param.slots;
        var instance = (0, $8B0Dy.getCurrentInstance)();
        var state = (0, $8B0Dy.useTransitionState)();
        var prevChildren;
        var children;
        (0, $8B0Dy.onUpdated)(function() {
            if (!prevChildren.length) return;
            var moveClass = props.moveClass || "".concat(props.name || "v", "-move");
            if (!$f2f6d1b61d3ac3fc$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) {
                prevChildren = [];
                return;
            }
            prevChildren.forEach($f2f6d1b61d3ac3fc$var$callPendingCbs);
            prevChildren.forEach($f2f6d1b61d3ac3fc$var$recordPosition);
            var movedChildren = prevChildren.filter($f2f6d1b61d3ac3fc$var$applyTranslation);
            $f2f6d1b61d3ac3fc$var$forceReflow(instance.vnode.el);
            movedChildren.forEach(function(c) {
                var el = c.el;
                var style = el.style;
                $f2f6d1b61d3ac3fc$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                var cb = el[$f2f6d1b61d3ac3fc$var$moveCbKey] = function(e) {
                    if (e && e.target !== el) return;
                    if (!e || e.propertyName.endsWith("transform")) {
                        el.removeEventListener("transitionend", cb);
                        el[$f2f6d1b61d3ac3fc$var$moveCbKey] = null;
                        $f2f6d1b61d3ac3fc$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
            prevChildren = [];
        });
        return function() {
            var rawProps = (0, $5wB2C.toRaw)(props);
            var cssTransitionProps = $f2f6d1b61d3ac3fc$var$resolveTransitionProps(rawProps);
            var tag = rawProps.tag || (0, $8B0Dy.Fragment);
            prevChildren = [];
            if (children) for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, $8B0Dy.setTransitionHooks)(child, (0, $8B0Dy.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $f2f6d1b61d3ac3fc$var$positionMap.set(child, child.el.getBoundingClientRect());
                }
            }
            children = slots["default"] ? (0, $8B0Dy.getTransitionRawChildren)(slots["default"]()) : [];
            for(var i1 = 0; i1 < children.length; i1++){
                var child1 = children[i1];
                if (child1.key != null) (0, $8B0Dy.setTransitionHooks)(child1, (0, $8B0Dy.resolveTransitionHooks)(child1, cssTransitionProps, state, instance));
            }
            return (0, $8B0Dy.createVNode)(tag, null, children);
        };
    }
});
var $f2f6d1b61d3ac3fc$export$19ffa8f511f7bc2e = $f2f6d1b61d3ac3fc$var$TransitionGroupImpl;
function $f2f6d1b61d3ac3fc$var$callPendingCbs(c) {
    var el = c.el;
    if (el[$f2f6d1b61d3ac3fc$var$moveCbKey]) el[$f2f6d1b61d3ac3fc$var$moveCbKey]();
    if (el[$f2f6d1b61d3ac3fc$var$enterCbKey]) el[$f2f6d1b61d3ac3fc$var$enterCbKey]();
}
function $f2f6d1b61d3ac3fc$var$recordPosition(c) {
    $f2f6d1b61d3ac3fc$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $f2f6d1b61d3ac3fc$var$applyTranslation(c) {
    var oldPos = $f2f6d1b61d3ac3fc$var$positionMap.get(c);
    var newPos = $f2f6d1b61d3ac3fc$var$newPositionMap.get(c);
    var dx = oldPos.left - newPos.left;
    var dy = oldPos.top - newPos.top;
    if (dx || dy) {
        var s = c.el.style;
        s.transform = s.webkitTransform = "translate(".concat(dx, "px,").concat(dy, "px)");
        s.transitionDuration = "0s";
        return c;
    }
}
function $f2f6d1b61d3ac3fc$var$hasCSSTransform(el, root, moveClass) {
    var clone = el.cloneNode();
    var _vtc = el[$f2f6d1b61d3ac3fc$var$vtcKey];
    if (_vtc) _vtc.forEach(function(cls) {
        cls.split(/\s+/).forEach(function(c) {
            return c && clone.classList.remove(c);
        });
    });
    moveClass.split(/\s+/).forEach(function(c) {
        return c && clone.classList.add(c);
    });
    clone.style.display = "none";
    var container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    var hasTransform = $f2f6d1b61d3ac3fc$var$getTransitionInfo(clone).hasTransform;
    container.removeChild(clone);
    return hasTransform;
}
var $f2f6d1b61d3ac3fc$var$getModelAssigner = function(vnode) {
    var fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $3ZJCa.isArray)(fn) ? function(value) {
        return (0, $3ZJCa.invokeArrayFns)(fn, value);
    } : fn;
};
function $f2f6d1b61d3ac3fc$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $f2f6d1b61d3ac3fc$var$onCompositionEnd(e) {
    var target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
var $f2f6d1b61d3ac3fc$var$assignKey = Symbol("_assign");
var $f2f6d1b61d3ac3fc$export$f1f88689f5728478 = {
    created: function(el, param, vnode) {
        var _param_modifiers = param.modifiers, lazy = _param_modifiers.lazy, trim = _param_modifiers.trim, number = _param_modifiers.number;
        el[$f2f6d1b61d3ac3fc$var$assignKey] = $f2f6d1b61d3ac3fc$var$getModelAssigner(vnode);
        var castToNumber = number || vnode.props && vnode.props.type === "number";
        $f2f6d1b61d3ac3fc$var$addEventListener(el, lazy ? "change" : "input", function(e) {
            if (e.target.composing) return;
            var domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $3ZJCa.looseToNumber)(domValue);
            el[$f2f6d1b61d3ac3fc$var$assignKey](domValue);
        });
        if (trim) $f2f6d1b61d3ac3fc$var$addEventListener(el, "change", function() {
            el.value = el.value.trim();
        });
        if (!lazy) {
            $f2f6d1b61d3ac3fc$var$addEventListener(el, "compositionstart", $f2f6d1b61d3ac3fc$var$onCompositionStart);
            $f2f6d1b61d3ac3fc$var$addEventListener(el, "compositionend", $f2f6d1b61d3ac3fc$var$onCompositionEnd);
            $f2f6d1b61d3ac3fc$var$addEventListener(el, "change", $f2f6d1b61d3ac3fc$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted: function(el, param) {
        var value = param.value;
        el.value = value == null ? "" : value;
    },
    beforeUpdate: function(el, param, vnode) {
        var value = param.value, oldValue = param.oldValue, _param_modifiers = param.modifiers, lazy = _param_modifiers.lazy, trim = _param_modifiers.trim, number = _param_modifiers.number;
        el[$f2f6d1b61d3ac3fc$var$assignKey] = $f2f6d1b61d3ac3fc$var$getModelAssigner(vnode);
        if (el.composing) return;
        var elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $3ZJCa.looseToNumber)(el.value) : el.value;
        var newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
var $f2f6d1b61d3ac3fc$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created: function(el, _, vnode) {
        el[$f2f6d1b61d3ac3fc$var$assignKey] = $f2f6d1b61d3ac3fc$var$getModelAssigner(vnode);
        $f2f6d1b61d3ac3fc$var$addEventListener(el, "change", function() {
            var modelValue = el._modelValue;
            var elementValue = $f2f6d1b61d3ac3fc$var$getValue(el);
            var checked = el.checked;
            var assign = el[$f2f6d1b61d3ac3fc$var$assignKey];
            if ((0, $3ZJCa.isArray)(modelValue)) {
                var index = (0, $3ZJCa.looseIndexOf)(modelValue, elementValue);
                var found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    var filtered = (0, $kf9Kn._)(modelValue);
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $3ZJCa.isSet)(modelValue)) {
                var cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned["delete"](elementValue);
                assign(cloned);
            } else assign($f2f6d1b61d3ac3fc$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $f2f6d1b61d3ac3fc$var$setChecked,
    beforeUpdate: function(el, binding, vnode) {
        el[$f2f6d1b61d3ac3fc$var$assignKey] = $f2f6d1b61d3ac3fc$var$getModelAssigner(vnode);
        $f2f6d1b61d3ac3fc$var$setChecked(el, binding, vnode);
    }
};
function $f2f6d1b61d3ac3fc$var$setChecked(el, param, vnode) {
    var value = param.value, oldValue = param.oldValue;
    el._modelValue = value;
    var checked;
    if ((0, $3ZJCa.isArray)(value)) checked = (0, $3ZJCa.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $3ZJCa.isSet)(value)) checked = value.has(vnode.props.value);
    else {
        if (value === oldValue) return;
        checked = (0, $3ZJCa.looseEqual)(value, $f2f6d1b61d3ac3fc$var$getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
}
var $f2f6d1b61d3ac3fc$export$b4356c59b38b7aa9 = {
    created: function(el, param, vnode) {
        var value = param.value;
        el.checked = (0, $3ZJCa.looseEqual)(value, vnode.props.value);
        el[$f2f6d1b61d3ac3fc$var$assignKey] = $f2f6d1b61d3ac3fc$var$getModelAssigner(vnode);
        $f2f6d1b61d3ac3fc$var$addEventListener(el, "change", function() {
            el[$f2f6d1b61d3ac3fc$var$assignKey]($f2f6d1b61d3ac3fc$var$getValue(el));
        });
    },
    beforeUpdate: function(el, param, vnode) {
        var value = param.value, oldValue = param.oldValue;
        el[$f2f6d1b61d3ac3fc$var$assignKey] = $f2f6d1b61d3ac3fc$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $3ZJCa.looseEqual)(value, vnode.props.value);
    }
};
var $f2f6d1b61d3ac3fc$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created: function(el, param, vnode) {
        var value = param.value, number = param.modifiers.number;
        var isSetModel = (0, $3ZJCa.isSet)(value);
        $f2f6d1b61d3ac3fc$var$addEventListener(el, "change", function() {
            var selectedVal = Array.prototype.filter.call(el.options, function(o) {
                return o.selected;
            }).map(function(o) {
                return number ? (0, $3ZJCa.looseToNumber)($f2f6d1b61d3ac3fc$var$getValue(o)) : $f2f6d1b61d3ac3fc$var$getValue(o);
            });
            el[$f2f6d1b61d3ac3fc$var$assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $8B0Dy.nextTick)(function() {
                el._assigning = false;
            });
        });
        el[$f2f6d1b61d3ac3fc$var$assignKey] = $f2f6d1b61d3ac3fc$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted: function(el, param) {
        var value = param.value;
        $f2f6d1b61d3ac3fc$var$setSelected(el, value);
    },
    beforeUpdate: function(el, _binding, vnode) {
        el[$f2f6d1b61d3ac3fc$var$assignKey] = $f2f6d1b61d3ac3fc$var$getModelAssigner(vnode);
    },
    updated: function(el, param) {
        var value = param.value;
        if (!el._assigning) $f2f6d1b61d3ac3fc$var$setSelected(el, value);
    }
};
function $f2f6d1b61d3ac3fc$var$setSelected(el, value) {
    var _loop = function(i, l) {
        var option = el.options[i];
        var optionValue = $f2f6d1b61d3ac3fc$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                var optionType = typeof optionValue === "undefined" ? "undefined" : (0, $6gBIz._)(optionValue);
                if (optionType === "string" || optionType === "number") option.selected = value.some(function(v) {
                    return String(v) === String(optionValue);
                });
                else option.selected = (0, $3ZJCa.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $3ZJCa.looseEqual)($f2f6d1b61d3ac3fc$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return {
                v: void void 0
            };
        }
    };
    var isMultiple = el.multiple;
    var isArrayValue = (0, $3ZJCa.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $3ZJCa.isSet)(value)) return;
    for(var i = 0, l = el.options.length; i < l; i++){
        var _ret = _loop(i, l);
        if ((0, $6gBIz._)(_ret) === "object") return _ret.v;
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $f2f6d1b61d3ac3fc$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $f2f6d1b61d3ac3fc$var$getCheckboxValue(el, checked) {
    var key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
var $f2f6d1b61d3ac3fc$export$5ad5c0e01ff62c5 = {
    created: function(el, binding, vnode) {
        $f2f6d1b61d3ac3fc$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted: function(el, binding, vnode) {
        $f2f6d1b61d3ac3fc$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate: function(el, binding, vnode, prevVNode) {
        $f2f6d1b61d3ac3fc$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated: function(el, binding, vnode, prevVNode) {
        $f2f6d1b61d3ac3fc$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $f2f6d1b61d3ac3fc$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $f2f6d1b61d3ac3fc$export$87d227567b51ca39;
        case "TEXTAREA":
            return $f2f6d1b61d3ac3fc$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $f2f6d1b61d3ac3fc$export$8847c2e532b35714;
                case "radio":
                    return $f2f6d1b61d3ac3fc$export$b4356c59b38b7aa9;
                default:
                    return $f2f6d1b61d3ac3fc$export$f1f88689f5728478;
            }
    }
}
function $f2f6d1b61d3ac3fc$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    var modelToUse = $f2f6d1b61d3ac3fc$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    var fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $f2f6d1b61d3ac3fc$var$initVModelForSSR() {
    $f2f6d1b61d3ac3fc$export$f1f88689f5728478.getSSRProps = function(param) {
        var value = param.value;
        return {
            value: value
        };
    };
    $f2f6d1b61d3ac3fc$export$b4356c59b38b7aa9.getSSRProps = function(param, vnode) {
        var value = param.value;
        if (vnode.props && (0, $3ZJCa.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $f2f6d1b61d3ac3fc$export$8847c2e532b35714.getSSRProps = function(param, vnode) {
        var value = param.value;
        if ((0, $3ZJCa.isArray)(value)) {
            if (vnode.props && (0, $3ZJCa.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $3ZJCa.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $f2f6d1b61d3ac3fc$export$5ad5c0e01ff62c5.getSSRProps = function(binding, vnode) {
        if (typeof vnode.type !== "string") return;
        var modelToUse = $f2f6d1b61d3ac3fc$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
var $f2f6d1b61d3ac3fc$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
var $f2f6d1b61d3ac3fc$var$modifierGuards = {
    stop: function(e) {
        return e.stopPropagation();
    },
    prevent: function(e) {
        return e.preventDefault();
    },
    self: function(e) {
        return e.target !== e.currentTarget;
    },
    ctrl: function(e) {
        return !e.ctrlKey;
    },
    shift: function(e) {
        return !e.shiftKey;
    },
    alt: function(e) {
        return !e.altKey;
    },
    meta: function(e) {
        return !e.metaKey;
    },
    left: function(e) {
        return "button" in e && e.button !== 0;
    },
    middle: function(e) {
        return "button" in e && e.button !== 1;
    },
    right: function(e) {
        return "button" in e && e.button !== 2;
    },
    exact: function(e, modifiers) {
        return $f2f6d1b61d3ac3fc$var$systemModifiers.some(function(m) {
            return e["".concat(m, "Key")] && !modifiers.includes(m);
        });
    }
};
var $f2f6d1b61d3ac3fc$export$26bd3b8e29e6f273 = function(fn, modifiers) {
    var cache = fn._withMods || (fn._withMods = {});
    var cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = function(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        for(var i = 0; i < modifiers.length; i++){
            var guard = $f2f6d1b61d3ac3fc$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn.apply(void 0, [
            event
        ].concat((0, $kf9Kn._)(args)));
    });
};
var $f2f6d1b61d3ac3fc$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    "delete": "backspace"
};
var $f2f6d1b61d3ac3fc$export$f691a8759658f782 = function(fn, modifiers) {
    var cache = fn._withKeys || (fn._withKeys = {});
    var cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = function(event) {
        if (!("key" in event)) return;
        var eventKey = (0, $3ZJCa.hyphenate)(event.key);
        if (modifiers.some(function(k) {
            return k === eventKey || $f2f6d1b61d3ac3fc$var$keyNames[k] === eventKey;
        })) return fn(event);
    });
};
var $f2f6d1b61d3ac3fc$var$rendererOptions = /* @__PURE__ */ (0, $3ZJCa.extend)({
    patchProp: $f2f6d1b61d3ac3fc$var$patchProp
}, $f2f6d1b61d3ac3fc$var$nodeOps);
var $f2f6d1b61d3ac3fc$var$renderer;
var $f2f6d1b61d3ac3fc$var$enabledHydration = false;
function $f2f6d1b61d3ac3fc$var$ensureRenderer() {
    return $f2f6d1b61d3ac3fc$var$renderer || ($f2f6d1b61d3ac3fc$var$renderer = (0, $8B0Dy.createRenderer)($f2f6d1b61d3ac3fc$var$rendererOptions));
}
function $f2f6d1b61d3ac3fc$var$ensureHydrationRenderer() {
    $f2f6d1b61d3ac3fc$var$renderer = $f2f6d1b61d3ac3fc$var$enabledHydration ? $f2f6d1b61d3ac3fc$var$renderer : (0, $8B0Dy.createHydrationRenderer)($f2f6d1b61d3ac3fc$var$rendererOptions);
    $f2f6d1b61d3ac3fc$var$enabledHydration = true;
    return $f2f6d1b61d3ac3fc$var$renderer;
}
var $f2f6d1b61d3ac3fc$export$b3890eb0ae9dca99 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _ensureRenderer;
    (_ensureRenderer = $f2f6d1b61d3ac3fc$var$ensureRenderer()).render.apply(_ensureRenderer, (0, $kf9Kn._)(args));
};
var $f2f6d1b61d3ac3fc$export$fa8d919ba61d84db = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _ensureHydrationRenderer;
    (_ensureHydrationRenderer = $f2f6d1b61d3ac3fc$var$ensureHydrationRenderer()).hydrate.apply(_ensureHydrationRenderer, (0, $kf9Kn._)(args));
};
var $f2f6d1b61d3ac3fc$export$4e373c34abfa8c68 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _ensureRenderer;
    var app = (_ensureRenderer = $f2f6d1b61d3ac3fc$var$ensureRenderer()).createApp.apply(_ensureRenderer, (0, $kf9Kn._)(args));
    var mount = app.mount;
    app.mount = function(containerOrSelector) {
        var container = $f2f6d1b61d3ac3fc$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        var component = app._component;
        if (!(0, $3ZJCa.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        var proxy = mount(container, false, $f2f6d1b61d3ac3fc$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
var $f2f6d1b61d3ac3fc$export$35800275c0037383 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _ensureHydrationRenderer;
    var app = (_ensureHydrationRenderer = $f2f6d1b61d3ac3fc$var$ensureHydrationRenderer()).createApp.apply(_ensureHydrationRenderer, (0, $kf9Kn._)(args));
    var mount = app.mount;
    app.mount = function(containerOrSelector) {
        var container = $f2f6d1b61d3ac3fc$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $f2f6d1b61d3ac3fc$var$resolveRootNamespace(container));
    };
    return app;
};
function $f2f6d1b61d3ac3fc$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $f2f6d1b61d3ac3fc$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: function(tag) {
            return (0, $3ZJCa.isHTMLTag)(tag) || (0, $3ZJCa.isSVGTag)(tag) || (0, $3ZJCa.isMathMLTag)(tag);
        },
        writable: false
    });
}
function $f2f6d1b61d3ac3fc$var$injectCompilerOptionsCheck(app) {
    if ((0, $8B0Dy.isRuntimeOnly)()) {
        var isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get: function() {
                return isCustomElement;
            },
            set: function() {
                (0, $8B0Dy.warn)("The `isCustomElement` config option is deprecated. Use `compilerOptions.isCustomElement` instead.");
            }
        });
        var compilerOptions = app.config.compilerOptions;
        var msg = 'The `compilerOptions` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, `compilerOptions` must be passed to `@vue/compiler-dom` in the build setup instead.\n- For vue-loader: pass it via vue-loader\'s `compilerOptions` loader option.\n- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc';
        Object.defineProperty(app.config, "compilerOptions", {
            get: function() {
                (0, $8B0Dy.warn)(msg);
                return compilerOptions;
            },
            set: function() {
                (0, $8B0Dy.warn)(msg);
            }
        });
    }
}
function $f2f6d1b61d3ac3fc$var$normalizeContainer(container) {
    if ((0, $3ZJCa.isString)(container)) {
        var res = document.querySelector(container);
        return res;
    }
    return container;
}
var $f2f6d1b61d3ac3fc$var$ssrDirectiveInitialized = false;
var $f2f6d1b61d3ac3fc$export$800b28255aa678d9 = function() {
    if (!$f2f6d1b61d3ac3fc$var$ssrDirectiveInitialized) {
        $f2f6d1b61d3ac3fc$var$ssrDirectiveInitialized = true;
        $f2f6d1b61d3ac3fc$var$initVModelForSSR();
        $f2f6d1b61d3ac3fc$var$initVShowForSSR();
    }
};
$parcel$exportWildcard(module.exports, $5wB2C);

});




var $7gZDx = parcelRequire("7gZDx");
var $e7c2e0dc37015513$exports = {};
/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.1
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */ /* global window, document, define, jQuery, setInterval, clearInterval */ 
var $6gBIz = parcelRequire("6gBIz");

(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) define([
        'jquery'
    ], factory);
    else $e7c2e0dc37015513$exports = factory((parcelRequire("7gZDx")));
})(function($) {
    'use strict';
    var Slick = window.Slick || {};
    Slick = function() {
        var instanceUid = 0;
        function Slick(element, settings) {
            var _ = this, dataSettings;
            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function customPaging(slider, i) {
                    return $('<button type="button" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                focusOnChange: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };
            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: false,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                swiping: false,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };
            $.extend(_, _.initials);
            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;
            dataSettings = $(element).data('slick') || {};
            _.options = $.extend({}, _.defaults, settings, dataSettings);
            _.currentSlide = _.options.initialSlide;
            _.originalSettings = _.options;
            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }
            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);
            _.instanceUid = instanceUid++;
            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;
            _.registerBreakpoints();
            _.init(true);
        }
        return Slick;
    }();
    Slick.prototype.activateADA = function() {
        var _ = this;
        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            tabindex: '0'
        });
    };
    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {
        var _ = this;
        if (typeof index === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || index >= _.slideCount) return false;
        _.unload();
        if (typeof index === 'number') {
            if (index === 0 && _.$slides.length === 0) $(markup).appendTo(_.$slideTrack);
            else if (addBefore) $(markup).insertBefore(_.$slides.eq(index));
            else $(markup).insertAfter(_.$slides.eq(index));
        } else if (addBefore === true) $(markup).prependTo(_.$slideTrack);
        else $(markup).appendTo(_.$slideTrack);
        _.$slides = _.$slideTrack.children(this.options.slide);
        _.$slideTrack.children(this.options.slide).detach();
        _.$slideTrack.append(_.$slides);
        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index);
        });
        _.$slidesCache = _.$slides;
        _.reinit();
    };
    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };
    Slick.prototype.animateSlide = function(targetLeft, callback) {
        var animProps = {}, _ = this;
        _.animateHeight();
        if (_.options.rtl === true && _.options.vertical === false) targetLeft = -targetLeft;
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) _.$slideTrack.animate({
                left: targetLeft
            }, _.options.speed, _.options.easing, callback);
            else _.$slideTrack.animate({
                top: targetLeft
            }, _.options.speed, _.options.easing, callback);
        } else if (_.cssTransitions === false) {
            if (_.options.rtl === true) _.currentLeft = -_.currentLeft;
            $({
                animStart: _.currentLeft
            }).animate({
                animStart: targetLeft
            }, {
                duration: _.options.speed,
                easing: _.options.easing,
                step: function step(now) {
                    now = Math.ceil(now);
                    if (_.options.vertical === false) {
                        animProps[_.animType] = 'translate(' + now + 'px, 0px)';
                        _.$slideTrack.css(animProps);
                    } else {
                        animProps[_.animType] = 'translate(0px,' + now + 'px)';
                        _.$slideTrack.css(animProps);
                    }
                },
                complete: function complete() {
                    if (callback) callback.call();
                }
            });
        } else {
            _.applyTransition();
            targetLeft = Math.ceil(targetLeft);
            if (_.options.vertical === false) animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
            else animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
            _.$slideTrack.css(animProps);
            if (callback) setTimeout(function() {
                _.disableTransition();
                callback.call();
            }, _.options.speed);
        }
    };
    Slick.prototype.getNavTarget = function() {
        var _ = this, asNavFor = _.options.asNavFor;
        if (asNavFor && asNavFor !== null) asNavFor = $(asNavFor).not(_.$slider);
        return asNavFor;
    };
    Slick.prototype.asNavFor = function(index) {
        var _ = this, asNavFor = _.getNavTarget();
        if (asNavFor !== null && (typeof asNavFor === "undefined" ? "undefined" : (0, $6gBIz._)(asNavFor)) === 'object') asNavFor.each(function() {
            var target = $(this).slick('getSlick');
            if (!target.unslicked) target.slideHandler(index, true);
        });
    };
    Slick.prototype.applyTransition = function(slide) {
        var _ = this, transition = {};
        if (_.options.fade === false) transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        else transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        if (_.options.fade === false) _.$slideTrack.css(transition);
        else _.$slides.eq(slide).css(transition);
    };
    Slick.prototype.autoPlay = function() {
        var _ = this;
        _.autoPlayClear();
        if (_.slideCount > _.options.slidesToShow) _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
    };
    Slick.prototype.autoPlayClear = function() {
        var _ = this;
        if (_.autoPlayTimer) clearInterval(_.autoPlayTimer);
    };
    Slick.prototype.autoPlayIterator = function() {
        var _ = this, slideTo = _.currentSlide + _.options.slidesToScroll;
        if (!_.paused && !_.interrupted && !_.focussed) {
            if (_.options.infinite === false) {
                if (_.direction === 1 && _.currentSlide + 1 === _.slideCount - 1) _.direction = 0;
                else if (_.direction === 0) {
                    slideTo = _.currentSlide - _.options.slidesToScroll;
                    if (_.currentSlide - 1 === 0) _.direction = 1;
                }
            }
            _.slideHandler(slideTo);
        }
    };
    Slick.prototype.buildArrows = function() {
        var _ = this;
        if (_.options.arrows === true) {
            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');
            if (_.slideCount > _.options.slidesToShow) {
                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                if (_.htmlExpr.test(_.options.prevArrow)) _.$prevArrow.prependTo(_.options.appendArrows);
                if (_.htmlExpr.test(_.options.nextArrow)) _.$nextArrow.appendTo(_.options.appendArrows);
                if (_.options.infinite !== true) _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
            } else _.$prevArrow.add(_.$nextArrow).addClass('slick-hidden').attr({
                'aria-disabled': 'true',
                tabindex: '-1'
            });
        }
    };
    Slick.prototype.buildDots = function() {
        var _ = this, i, dot;
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            _.$slider.addClass('slick-dotted');
            dot = $('<ul />').addClass(_.options.dotsClass);
            for(i = 0; i <= _.getDotCount(); i += 1)dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            _.$dots = dot.appendTo(_.options.appendDots);
            _.$dots.find('li').first().addClass('slick-active');
        }
    };
    Slick.prototype.buildOut = function() {
        var _ = this;
        _.$slides = _.$slider.children(_.options.slide + ':not(.slick-cloned)').addClass('slick-slide');
        _.slideCount = _.$slides.length;
        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index).data('originalStyling', $(element).attr('style') || '');
        });
        _.$slider.addClass('slick-slider');
        _.$slideTrack = _.slideCount === 0 ? $('<div class="slick-track"/>').appendTo(_.$slider) : _.$slides.wrapAll('<div class="slick-track"/>').parent();
        _.$list = _.$slideTrack.wrap('<div class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);
        if (_.options.centerMode === true || _.options.swipeToSlide === true) _.options.slidesToScroll = 1;
        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');
        _.setupInfinite();
        _.buildArrows();
        _.buildDots();
        _.updateDots();
        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
        if (_.options.draggable === true) _.$list.addClass('draggable');
    };
    Slick.prototype.buildRows = function() {
        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides, slidesPerSection;
        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();
        if (_.options.rows > 0) {
            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(originalSlides.length / slidesPerSection);
            for(a = 0; a < numOfSlides; a++){
                var slide = document.createElement('div');
                for(b = 0; b < _.options.rows; b++){
                    var row = document.createElement('div');
                    for(c = 0; c < _.options.slidesPerRow; c++){
                        var target = a * slidesPerSection + (b * _.options.slidesPerRow + c);
                        if (originalSlides.get(target)) row.appendChild(originalSlides.get(target));
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }
            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children().css({
                width: 100 / _.options.slidesPerRow + '%',
                display: 'inline-block'
            });
        }
    };
    Slick.prototype.checkResponsive = function(initial, forceUpdate) {
        var _ = this, breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();
        if (_.respondTo === 'window') respondToWidth = windowWidth;
        else if (_.respondTo === 'slider') respondToWidth = sliderWidth;
        else if (_.respondTo === 'min') respondToWidth = Math.min(windowWidth, sliderWidth);
        if (_.options.responsive && _.options.responsive.length && _.options.responsive !== null) {
            targetBreakpoint = null;
            for(breakpoint in _.breakpoints)if (_.breakpoints.hasOwnProperty(breakpoint)) {
                if (_.originalSettings.mobileFirst === false) {
                    if (respondToWidth < _.breakpoints[breakpoint]) targetBreakpoint = _.breakpoints[breakpoint];
                } else if (respondToWidth > _.breakpoints[breakpoint]) targetBreakpoint = _.breakpoints[breakpoint];
            }
            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint = targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') _.unslick(targetBreakpoint);
                        else {
                            _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                            if (initial === true) _.currentSlide = _.options.initialSlide;
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') _.unslick(targetBreakpoint);
                    else {
                        _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                        if (initial === true) _.currentSlide = _.options.initialSlide;
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else if (_.activeBreakpoint !== null) {
                _.activeBreakpoint = null;
                _.options = _.originalSettings;
                if (initial === true) _.currentSlide = _.options.initialSlide;
                _.refresh(initial);
                triggerBreakpoint = targetBreakpoint;
            }
            // only trigger breakpoints during an actual break. not on initialize.
            if (!initial && triggerBreakpoint !== false) _.$slider.trigger('breakpoint', [
                _,
                triggerBreakpoint
            ]);
        }
    };
    Slick.prototype.changeSlide = function(event, dontAnimate) {
        var _ = this, $target = $(event.currentTarget), indexOffset, slideOffset, unevenOffset;
        // If target is a link, prevent default action.
        if ($target.is('a')) event.preventDefault();
        // If target is not the <li> element (ie: a child), find the <li>.
        if (!$target.is('li')) $target = $target.closest('li');
        unevenOffset = _.slideCount % _.options.slidesToScroll !== 0;
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;
        switch(event.data.message){
            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                break;
            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                break;
            case 'index':
                var index = event.data.index === 0 ? 0 : event.data.index || $target.index() * _.options.slidesToScroll;
                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;
            default:
                return;
        }
    };
    Slick.prototype.checkNavigable = function(index) {
        var _ = this, navigables, prevNavigable;
        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) index = navigables[navigables.length - 1];
        else for(var n in navigables){
            if (index < navigables[n]) {
                index = prevNavigable;
                break;
            }
            prevNavigable = navigables[n];
        }
        return index;
    };
    Slick.prototype.cleanUpEvents = function() {
        var _ = this;
        if (_.options.dots && _.$dots !== null) {
            $('li', _.$dots).off('click.slick', _.changeSlide).off('mouseenter.slick', $.proxy(_.interrupt, _, true)).off('mouseleave.slick', $.proxy(_.interrupt, _, false));
            if (_.options.accessibility === true) _.$dots.off('keydown.slick', _.keyHandler);
        }
        _.$slider.off('focus.slick blur.slick');
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
            if (_.options.accessibility === true) {
                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
            }
        }
        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);
        _.$list.off('click.slick', _.clickHandler);
        $(document).off(_.visibilityChange, _.visibility);
        _.cleanUpSlideEvents();
        if (_.options.accessibility === true) _.$list.off('keydown.slick', _.keyHandler);
        if (_.options.focusOnSelect === true) $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);
        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);
        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);
        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
    };
    Slick.prototype.cleanUpSlideEvents = function() {
        var _ = this;
        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
    };
    Slick.prototype.cleanUpRows = function() {
        var _ = this, originalSlides;
        if (_.options.rows > 0) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }
    };
    Slick.prototype.clickHandler = function(event) {
        var _ = this;
        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }
    };
    Slick.prototype.destroy = function(refresh) {
        var _ = this;
        _.autoPlayClear();
        _.touchObject = {};
        _.cleanUpEvents();
        $('.slick-cloned', _.$slider).detach();
        if (_.$dots) _.$dots.remove();
        if (_.$prevArrow && _.$prevArrow.length) {
            _.$prevArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
            if (_.htmlExpr.test(_.options.prevArrow)) _.$prevArrow.remove();
        }
        if (_.$nextArrow && _.$nextArrow.length) {
            _.$nextArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
            if (_.htmlExpr.test(_.options.nextArrow)) _.$nextArrow.remove();
        }
        if (_.$slides) {
            _.$slides.removeClass('slick-slide slick-active slick-center slick-visible slick-current').removeAttr('aria-hidden').removeAttr('data-slick-index').each(function() {
                $(this).attr('style', $(this).data('originalStyling'));
            });
            _.$slideTrack.children(this.options.slide).detach();
            _.$slideTrack.detach();
            _.$list.detach();
            _.$slider.append(_.$slides);
        }
        _.cleanUpRows();
        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');
        _.unslicked = true;
        if (!refresh) _.$slider.trigger('destroy', [
            _
        ]);
    };
    Slick.prototype.disableTransition = function(slide) {
        var _ = this, transition = {};
        transition[_.transitionType] = '';
        if (_.options.fade === false) _.$slideTrack.css(transition);
        else _.$slides.eq(slide).css(transition);
    };
    Slick.prototype.fadeSlide = function(slideIndex, callback) {
        var _ = this;
        if (_.cssTransitions === false) {
            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });
            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);
        } else {
            _.applyTransition(slideIndex);
            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });
            if (callback) setTimeout(function() {
                _.disableTransition(slideIndex);
                callback.call();
            }, _.options.speed);
        }
    };
    Slick.prototype.fadeSlideOut = function(slideIndex) {
        var _ = this;
        if (_.cssTransitions === false) _.$slides.eq(slideIndex).animate({
            opacity: 0,
            zIndex: _.options.zIndex - 2
        }, _.options.speed, _.options.easing);
        else {
            _.applyTransition(slideIndex);
            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });
        }
    };
    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {
        var _ = this;
        if (filter !== null) {
            _.$slidesCache = _.$slides;
            _.unload();
            _.$slideTrack.children(this.options.slide).detach();
            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);
            _.reinit();
        }
    };
    Slick.prototype.focusHandler = function() {
        var _ = this;
        _.$slider.off('focus.slick blur.slick').on('focus.slick blur.slick', '*', function(event) {
            event.stopImmediatePropagation();
            var $sf = $(this);
            setTimeout(function() {
                if (_.options.pauseOnFocus) {
                    _.focussed = $sf.is(':focus');
                    _.autoPlay();
                }
            }, 0);
        });
    };
    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {
        var _ = this;
        return _.currentSlide;
    };
    Slick.prototype.getDotCount = function() {
        var _ = this;
        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;
        if (_.options.infinite === true) {
            if (_.slideCount <= _.options.slidesToShow) ++pagerQty;
            else while(breakPoint < _.slideCount){
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        } else if (_.options.centerMode === true) pagerQty = _.slideCount;
        else if (!_.options.asNavFor) pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        else while(breakPoint < _.slideCount){
            ++pagerQty;
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }
        return pagerQty - 1;
    };
    Slick.prototype.getLeft = function(slideIndex) {
        var _ = this, targetLeft, verticalHeight, verticalOffset = 0, targetSlide, coef;
        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);
        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = _.slideWidth * _.options.slidesToShow * -1;
                coef = -1;
                if (_.options.vertical === true && _.options.centerMode === true) {
                    if (_.options.slidesToShow === 2) coef = -1.5;
                    else if (_.options.slidesToShow === 1) coef = -2;
                }
                verticalOffset = verticalHeight * _.options.slidesToShow * coef;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth * -1;
                        verticalOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight * -1;
                    } else {
                        _.slideOffset = _.slideCount % _.options.slidesToScroll * _.slideWidth * -1;
                        verticalOffset = _.slideCount % _.options.slidesToScroll * verticalHeight * -1;
                    }
                }
            }
        } else if (slideIndex + _.options.slidesToShow > _.slideCount) {
            _.slideOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * _.slideWidth;
            verticalOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * verticalHeight;
        }
        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }
        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) _.slideOffset = _.slideWidth * Math.floor(_.options.slidesToShow) / 2 - _.slideWidth * _.slideCount / 2;
        else if (_.options.centerMode === true && _.options.infinite === true) _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }
        if (_.options.vertical === false) targetLeft = slideIndex * _.slideWidth * -1 + _.slideOffset;
        else targetLeft = slideIndex * verticalHeight * -1 + verticalOffset;
        if (_.options.variableWidth === true) {
            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            else targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            if (_.options.rtl === true) {
                if (targetSlide[0]) targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                else targetLeft = 0;
            } else targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                else targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                if (_.options.rtl === true) {
                    if (targetSlide[0]) targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    else targetLeft = 0;
                } else targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }
        return targetLeft;
    };
    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {
        var _ = this;
        return _.options[option];
    };
    Slick.prototype.getNavigableIndexes = function() {
        var _ = this, breakPoint = 0, counter = 0, indexes = [], max;
        if (_.options.infinite === false) max = _.slideCount;
        else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }
        while(breakPoint < max){
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }
        return indexes;
    };
    Slick.prototype.getSlick = function() {
        return this;
    };
    Slick.prototype.getSlideCount = function() {
        var _ = this, slidesTraversed, swipedSlide, centerOffset;
        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;
        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
                if (slide.offsetLeft - centerOffset + $(slide).outerWidth() / 2 > _.swipeLeft * -1) {
                    swipedSlide = slide;
                    return false;
                }
            });
            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;
            return slidesTraversed;
        } else return _.options.slidesToScroll;
    };
    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {
        var _ = this;
        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);
    };
    Slick.prototype.init = function(creation) {
        var _ = this;
        if (!$(_.$slider).hasClass('slick-initialized')) {
            $(_.$slider).addClass('slick-initialized');
            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();
        }
        if (creation) _.$slider.trigger('init', [
            _
        ]);
        if (_.options.accessibility === true) _.initADA();
        if (_.options.autoplay) {
            _.paused = false;
            _.autoPlay();
        }
    };
    Slick.prototype.initADA = function() {
        var _ = this, numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow), tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
            return val >= 0 && val < _.slideCount;
        });
        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            tabindex: '-1'
        }).find('a, input, button, select').attr({
            tabindex: '-1'
        });
        if (_.$dots !== null) {
            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
                var slideControlIndex = tabControlIndexes.indexOf(i);
                $(this).attr({
                    role: 'tabpanel',
                    id: 'slick-slide' + _.instanceUid + i,
                    tabindex: -1
                });
                if (slideControlIndex !== -1) {
                    var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex;
                    if ($('#' + ariaButtonControl).length) $(this).attr({
                        'aria-describedby': ariaButtonControl
                    });
                }
            });
            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
                var mappedSlideIndex = tabControlIndexes[i];
                $(this).attr({
                    role: 'presentation'
                });
                $(this).find('button').first().attr({
                    role: 'tab',
                    id: 'slick-slide-control' + _.instanceUid + i,
                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
                    'aria-label': i + 1 + ' of ' + numDotGroups,
                    'aria-selected': null,
                    tabindex: '-1'
                });
            }).eq(_.currentSlide).find('button').attr({
                'aria-selected': 'true',
                tabindex: '0'
            }).end();
        }
        for(var i = _.currentSlide, max = i + _.options.slidesToShow; i < max; i++)if (_.options.focusOnChange) _.$slides.eq(i).attr({
            tabindex: '0'
        });
        else _.$slides.eq(i).removeAttr('tabindex');
        _.activateADA();
    };
    Slick.prototype.initArrowEvents = function() {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.off('click.slick').on('click.slick', {
                message: 'previous'
            }, _.changeSlide);
            _.$nextArrow.off('click.slick').on('click.slick', {
                message: 'next'
            }, _.changeSlide);
            if (_.options.accessibility === true) {
                _.$prevArrow.on('keydown.slick', _.keyHandler);
                _.$nextArrow.on('keydown.slick', _.keyHandler);
            }
        }
    };
    Slick.prototype.initDotEvents = function() {
        var _ = this;
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);
            if (_.options.accessibility === true) _.$dots.on('keydown.slick', _.keyHandler);
        }
        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) $('li', _.$dots).on('mouseenter.slick', $.proxy(_.interrupt, _, true)).on('mouseleave.slick', $.proxy(_.interrupt, _, false));
    };
    Slick.prototype.initSlideEvents = function() {
        var _ = this;
        if (_.options.pauseOnHover) {
            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
        }
    };
    Slick.prototype.initializeEvents = function() {
        var _ = this;
        _.initArrowEvents();
        _.initDotEvents();
        _.initSlideEvents();
        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('click.slick', _.clickHandler);
        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));
        if (_.options.accessibility === true) _.$list.on('keydown.slick', _.keyHandler);
        if (_.options.focusOnSelect === true) $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));
        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));
        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);
        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(_.setPosition);
    };
    Slick.prototype.initUI = function() {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.show();
            _.$nextArrow.show();
        }
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) _.$dots.show();
    };
    Slick.prototype.keyHandler = function(event) {
        var _ = this;
        //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if (!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) _.changeSlide({
                data: {
                    message: _.options.rtl === true ? 'next' : 'previous'
                }
            });
            else if (event.keyCode === 39 && _.options.accessibility === true) _.changeSlide({
                data: {
                    message: _.options.rtl === true ? 'previous' : 'next'
                }
            });
        }
    };
    Slick.prototype.lazyLoad = function() {
        var _ = this, loadRange, cloneRange, rangeStart, rangeEnd;
        function loadImages(imagesScope) {
            $('img[data-lazy]', imagesScope).each(function() {
                var image = $(this), imageSource = $(this).attr('data-lazy'), imageSrcSet = $(this).attr('data-srcset'), imageSizes = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'), imageToLoad = document.createElement('img');
                imageToLoad.onload = function() {
                    image.animate({
                        opacity: 0
                    }, 100, function() {
                        if (imageSrcSet) {
                            image.attr('srcset', imageSrcSet);
                            if (imageSizes) image.attr('sizes', imageSizes);
                        }
                        image.attr('src', imageSource).animate({
                            opacity: 1
                        }, 200, function() {
                            image.removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
                        });
                        _.$slider.trigger('lazyLoaded', [
                            _,
                            image,
                            imageSource
                        ]);
                    });
                };
                imageToLoad.onerror = function() {
                    image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
                    _.$slider.trigger('lazyLoadError', [
                        _,
                        image,
                        imageSource
                    ]);
                };
                imageToLoad.src = imageSource;
            });
        }
        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }
        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
        if (_.options.lazyLoad === 'anticipated') {
            var prevSlide = rangeStart - 1, nextSlide = rangeEnd, $slides = _.$slider.find('.slick-slide');
            for(var i = 0; i < _.options.slidesToScroll; i++){
                if (prevSlide < 0) prevSlide = _.slideCount - 1;
                loadRange = loadRange.add($slides.eq(prevSlide));
                loadRange = loadRange.add($slides.eq(nextSlide));
                prevSlide--;
                nextSlide++;
            }
        }
        loadImages(loadRange);
        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }
    };
    Slick.prototype.loadSlider = function() {
        var _ = this;
        _.setPosition();
        _.$slideTrack.css({
            opacity: 1
        });
        _.$slider.removeClass('slick-loading');
        _.initUI();
        if (_.options.lazyLoad === 'progressive') _.progressiveLazyLoad();
    };
    Slick.prototype.next = Slick.prototype.slickNext = function() {
        var _ = this;
        _.changeSlide({
            data: {
                message: 'next'
            }
        });
    };
    Slick.prototype.orientationChange = function() {
        var _ = this;
        _.checkResponsive();
        _.setPosition();
    };
    Slick.prototype.pause = Slick.prototype.slickPause = function() {
        var _ = this;
        _.autoPlayClear();
        _.paused = true;
    };
    Slick.prototype.play = Slick.prototype.slickPlay = function() {
        var _ = this;
        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;
    };
    Slick.prototype.postSlide = function(index) {
        var _ = this;
        if (!_.unslicked) {
            _.$slider.trigger('afterChange', [
                _,
                index
            ]);
            _.animating = false;
            if (_.slideCount > _.options.slidesToShow) _.setPosition();
            _.swipeLeft = null;
            if (_.options.autoplay) _.autoPlay();
            if (_.options.accessibility === true) {
                _.initADA();
                if (_.options.focusOnChange) {
                    var $currentSlide = $(_.$slides.get(_.currentSlide));
                    $currentSlide.attr('tabindex', 0).focus();
                }
            }
        }
    };
    Slick.prototype.prev = Slick.prototype.slickPrev = function() {
        var _ = this;
        _.changeSlide({
            data: {
                message: 'previous'
            }
        });
    };
    Slick.prototype.preventDefault = function(event) {
        event.preventDefault();
    };
    Slick.prototype.progressiveLazyLoad = function(tryCount) {
        tryCount = tryCount || 1;
        var _ = this, $imgsToLoad = $('img[data-lazy]', _.$slider), image, imageSource, imageSrcSet, imageSizes, imageToLoad;
        if ($imgsToLoad.length) {
            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageSrcSet = image.attr('data-srcset');
            imageSizes = image.attr('data-sizes') || _.$slider.attr('data-sizes');
            imageToLoad = document.createElement('img');
            imageToLoad.onload = function() {
                if (imageSrcSet) {
                    image.attr('srcset', imageSrcSet);
                    if (imageSizes) image.attr('sizes', imageSizes);
                }
                image.attr('src', imageSource).removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
                if (_.options.adaptiveHeight === true) _.setPosition();
                _.$slider.trigger('lazyLoaded', [
                    _,
                    image,
                    imageSource
                ]);
                _.progressiveLazyLoad();
            };
            imageToLoad.onerror = function() {
                if (tryCount < 3) /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */ setTimeout(function() {
                    _.progressiveLazyLoad(tryCount + 1);
                }, 500);
                else {
                    image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
                    _.$slider.trigger('lazyLoadError', [
                        _,
                        image,
                        imageSource
                    ]);
                    _.progressiveLazyLoad();
                }
            };
            imageToLoad.src = imageSource;
        } else _.$slider.trigger('allImagesLoaded', [
            _
        ]);
    };
    Slick.prototype.refresh = function(initializing) {
        var _ = this, currentSlide, lastVisibleIndex;
        lastVisibleIndex = _.slideCount - _.options.slidesToShow;
        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if (!_.options.infinite && _.currentSlide > lastVisibleIndex) _.currentSlide = lastVisibleIndex;
        // if less slides than to show, go to start.
        if (_.slideCount <= _.options.slidesToShow) _.currentSlide = 0;
        currentSlide = _.currentSlide;
        _.destroy(true);
        $.extend(_, _.initials, {
            currentSlide: currentSlide
        });
        _.init();
        if (!initializing) _.changeSlide({
            data: {
                message: 'index',
                index: currentSlide
            }
        }, false);
    };
    Slick.prototype.registerBreakpoints = function() {
        var _ = this, breakpoint, currentBreakpoint, l, responsiveSettings = _.options.responsive || null;
        if ($.type(responsiveSettings) === 'array' && responsiveSettings.length) {
            _.respondTo = _.options.respondTo || 'window';
            for(breakpoint in responsiveSettings){
                l = _.breakpoints.length - 1;
                if (responsiveSettings.hasOwnProperty(breakpoint)) {
                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;
                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while(l >= 0){
                        if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) _.breakpoints.splice(l, 1);
                        l--;
                    }
                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
                }
            }
            _.breakpoints.sort(function(a, b) {
                return _.options.mobileFirst ? a - b : b - a;
            });
        }
    };
    Slick.prototype.reinit = function() {
        var _ = this;
        _.$slides = _.$slideTrack.children(_.options.slide).addClass('slick-slide');
        _.slideCount = _.$slides.length;
        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        if (_.slideCount <= _.options.slidesToShow) _.currentSlide = 0;
        _.registerBreakpoints();
        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();
        _.checkResponsive(false, true);
        if (_.options.focusOnSelect === true) $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
        _.setPosition();
        _.focusHandler();
        _.paused = !_.options.autoplay;
        _.autoPlay();
        _.$slider.trigger('reInit', [
            _
        ]);
    };
    Slick.prototype.resize = function() {
        var _ = this;
        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if (!_.unslicked) _.setPosition();
            }, 50);
        }
    };
    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {
        var _ = this;
        if (typeof index === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else index = removeBefore === true ? --index : index;
        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) return false;
        _.unload();
        if (removeAll === true) _.$slideTrack.children().remove();
        else _.$slideTrack.children(this.options.slide).eq(index).remove();
        _.$slides = _.$slideTrack.children(this.options.slide);
        _.$slideTrack.children(this.options.slide).detach();
        _.$slideTrack.append(_.$slides);
        _.$slidesCache = _.$slides;
        _.reinit();
    };
    Slick.prototype.setCSS = function(position) {
        var _ = this, positionProps = {}, x, y;
        if (_.options.rtl === true) position = -position;
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';
        positionProps[_.positionProp] = position;
        if (_.transformsEnabled === false) _.$slideTrack.css(positionProps);
        else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }
    };
    Slick.prototype.setDimensions = function() {
        var _ = this;
        if (_.options.vertical === false) {
            if (_.options.centerMode === true) _.$list.css({
                padding: '0px ' + _.options.centerPadding
            });
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) _.$list.css({
                padding: _.options.centerPadding + ' 0px'
            });
        }
        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();
        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil(_.slideWidth * _.$slideTrack.children('.slick-slide').length));
        } else if (_.options.variableWidth === true) _.$slideTrack.width(5000 * _.slideCount);
        else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil(_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length));
        }
        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
    };
    Slick.prototype.setFade = function() {
        var _ = this, targetLeft;
        _.$slides.each(function(index, element) {
            targetLeft = _.slideWidth * index * -1;
            if (_.options.rtl === true) $(element).css({
                position: 'relative',
                right: targetLeft,
                top: 0,
                zIndex: _.options.zIndex - 2,
                opacity: 0
            });
            else $(element).css({
                position: 'relative',
                left: targetLeft,
                top: 0,
                zIndex: _.options.zIndex - 2,
                opacity: 0
            });
        });
        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });
    };
    Slick.prototype.setHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }
    };
    Slick.prototype.setOption = Slick.prototype.slickSetOption = function() {
        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */ var _ = this, l, item, option, value, refresh = false, type;
        if ($.type(arguments[0]) === 'object') {
            option = arguments[0];
            refresh = arguments[1];
            type = 'multiple';
        } else if ($.type(arguments[0]) === 'string') {
            option = arguments[0];
            value = arguments[1];
            refresh = arguments[2];
            if (arguments[0] === 'responsive' && $.type(arguments[1]) === 'array') type = 'responsive';
            else if (typeof arguments[1] !== 'undefined') type = 'single';
        }
        if (type === 'single') _.options[option] = value;
        else if (type === 'multiple') $.each(option, function(opt, val) {
            _.options[opt] = val;
        });
        else if (type === 'responsive') {
            for(item in value)if ($.type(_.options.responsive) !== 'array') _.options.responsive = [
                value[item]
            ];
            else {
                l = _.options.responsive.length - 1;
                // loop through the responsive object and splice out duplicates.
                while(l >= 0){
                    if (_.options.responsive[l].breakpoint === value[item].breakpoint) _.options.responsive.splice(l, 1);
                    l--;
                }
                _.options.responsive.push(value[item]);
            }
        }
        if (refresh) {
            _.unload();
            _.reinit();
        }
    };
    Slick.prototype.setPosition = function() {
        var _ = this;
        _.setDimensions();
        _.setHeight();
        if (_.options.fade === false) _.setCSS(_.getLeft(_.currentSlide));
        else _.setFade();
        _.$slider.trigger('setPosition', [
            _
        ]);
    };
    Slick.prototype.setProps = function() {
        var _ = this, bodyStyle = document.body.style;
        _.positionProp = _.options.vertical === true ? 'top' : 'left';
        if (_.positionProp === 'top') _.$slider.addClass('slick-vertical');
        else _.$slider.removeClass('slick-vertical');
        if (bodyStyle.WebkitTransition !== undefined || bodyStyle.MozTransition !== undefined || bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) _.cssTransitions = true;
        }
        if (_.options.fade) {
            if (typeof _.options.zIndex === 'number') {
                if (_.options.zIndex < 3) _.options.zIndex = 3;
            } else _.options.zIndex = _.defaults.zIndex;
        }
        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && _.animType !== null && _.animType !== false;
    };
    Slick.prototype.setSlideClasses = function(index) {
        var _ = this, centerOffset, allSlides, indexOffset, remainder;
        allSlides = _.$slider.find('.slick-slide').removeClass('slick-active slick-center slick-current').attr('aria-hidden', 'true');
        _.$slides.eq(index).addClass('slick-current');
        if (_.options.centerMode === true) {
            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;
            centerOffset = Math.floor(_.options.slidesToShow / 2);
            if (_.options.infinite === true) {
                if (index >= centerOffset && index <= _.slideCount - 1 - centerOffset) _.$slides.slice(index - centerOffset + evenCoef, index + centerOffset + 1).addClass('slick-active').attr('aria-hidden', 'false');
                else {
                    indexOffset = _.options.slidesToShow + index;
                    allSlides.slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2).addClass('slick-active').attr('aria-hidden', 'false');
                }
                if (index === 0) allSlides.eq(allSlides.length - 1 - _.options.slidesToShow).addClass('slick-center');
                else if (index === _.slideCount - 1) allSlides.eq(_.options.slidesToShow).addClass('slick-center');
            }
            _.$slides.eq(index).addClass('slick-center');
        } else {
            if (index >= 0 && index <= _.slideCount - _.options.slidesToShow) _.$slides.slice(index, index + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
            else if (allSlides.length <= _.options.slidesToShow) allSlides.addClass('slick-active').attr('aria-hidden', 'false');
            else {
                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;
                if (_.options.slidesToShow == _.options.slidesToScroll && _.slideCount - index < _.options.slidesToShow) allSlides.slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder).addClass('slick-active').attr('aria-hidden', 'false');
                else allSlides.slice(indexOffset, indexOffset + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
            }
        }
        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') _.lazyLoad();
    };
    Slick.prototype.setupInfinite = function() {
        var _ = this, i, slideIndex, infiniteCount;
        if (_.options.fade === true) _.options.centerMode = false;
        if (_.options.infinite === true && _.options.fade === false) {
            slideIndex = null;
            if (_.slideCount > _.options.slidesToShow) {
                if (_.options.centerMode === true) infiniteCount = _.options.slidesToShow + 1;
                else infiniteCount = _.options.slidesToShow;
                for(i = _.slideCount; i > _.slideCount - infiniteCount; i -= 1){
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex - _.slideCount).prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for(i = 0; i < infiniteCount + _.slideCount; i += 1){
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex + _.slideCount).appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                    $(this).attr('id', '');
                });
            }
        }
    };
    Slick.prototype.interrupt = function(toggle) {
        var _ = this;
        if (!toggle) _.autoPlay();
        _.interrupted = toggle;
    };
    Slick.prototype.selectHandler = function(event) {
        var _ = this;
        var targetElement = $(event.target).is('.slick-slide') ? $(event.target) : $(event.target).parents('.slick-slide');
        var index = parseInt(targetElement.attr('data-slick-index'));
        if (!index) index = 0;
        if (_.slideCount <= _.options.slidesToShow) {
            _.slideHandler(index, false, true);
            return;
        }
        _.slideHandler(index);
    };
    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {
        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null, _ = this, navTarget;
        sync = sync || false;
        if (_.animating === true && _.options.waitForAnimate === true) return;
        if (_.options.fade === true && _.currentSlide === index) return;
        if (sync === false) _.asNavFor(index);
        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);
        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;
        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) _.animateSlide(slideLeft, function() {
                    _.postSlide(targetSlide);
                });
                else _.postSlide(targetSlide);
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > _.slideCount - _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) _.animateSlide(slideLeft, function() {
                    _.postSlide(targetSlide);
                });
                else _.postSlide(targetSlide);
            }
            return;
        }
        if (_.options.autoplay) clearInterval(_.autoPlayTimer);
        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) animSlide = _.slideCount - _.slideCount % _.options.slidesToScroll;
            else animSlide = _.slideCount + targetSlide;
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) animSlide = 0;
            else animSlide = targetSlide - _.slideCount;
        } else animSlide = targetSlide;
        _.animating = true;
        _.$slider.trigger('beforeChange', [
            _,
            _.currentSlide,
            animSlide
        ]);
        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;
        _.setSlideClasses(_.currentSlide);
        if (_.options.asNavFor) {
            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');
            if (navTarget.slideCount <= navTarget.options.slidesToShow) navTarget.setSlideClasses(_.currentSlide);
        }
        _.updateDots();
        _.updateArrows();
        if (_.options.fade === true) {
            if (dontAnimate !== true) {
                _.fadeSlideOut(oldSlide);
                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });
            } else _.postSlide(animSlide);
            _.animateHeight();
            return;
        }
        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) _.animateSlide(targetLeft, function() {
            _.postSlide(animSlide);
        });
        else _.postSlide(animSlide);
    };
    Slick.prototype.startLoad = function() {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.hide();
            _.$nextArrow.hide();
        }
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) _.$dots.hide();
        _.$slider.addClass('slick-loading');
    };
    Slick.prototype.swipeDirection = function() {
        var xDist, yDist, r, swipeAngle, _ = this;
        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);
        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) swipeAngle = 360 - Math.abs(swipeAngle);
        if (swipeAngle <= 45 && swipeAngle >= 0) return _.options.rtl === false ? 'left' : 'right';
        if (swipeAngle <= 360 && swipeAngle >= 315) return _.options.rtl === false ? 'left' : 'right';
        if (swipeAngle >= 135 && swipeAngle <= 225) return _.options.rtl === false ? 'right' : 'left';
        if (_.options.verticalSwiping === true) {
            if (swipeAngle >= 35 && swipeAngle <= 135) return 'down';
            else return 'up';
        }
        return 'vertical';
    };
    Slick.prototype.swipeEnd = function(event) {
        var _ = this, slideCount, direction;
        _.dragging = false;
        _.swiping = false;
        if (_.scrolling) {
            _.scrolling = false;
            return false;
        }
        _.interrupted = false;
        _.shouldClick = _.touchObject.swipeLength > 10 ? false : true;
        if (_.touchObject.curX === undefined) return false;
        if (_.touchObject.edgeHit === true) _.$slider.trigger('edge', [
            _,
            _.swipeDirection()
        ]);
        if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {
            direction = _.swipeDirection();
            switch(direction){
                case 'left':
                case 'down':
                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide + _.getSlideCount()) : _.currentSlide + _.getSlideCount();
                    _.currentDirection = 0;
                    break;
                case 'right':
                case 'up':
                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide - _.getSlideCount()) : _.currentSlide - _.getSlideCount();
                    _.currentDirection = 1;
                    break;
                default:
            }
            if (direction != 'vertical') {
                _.slideHandler(slideCount);
                _.touchObject = {};
                _.$slider.trigger('swipe', [
                    _,
                    direction
                ]);
            }
        } else if (_.touchObject.startX !== _.touchObject.curX) {
            _.slideHandler(_.currentSlide);
            _.touchObject = {};
        }
    };
    Slick.prototype.swipeHandler = function(event) {
        var _ = this;
        if (_.options.swipe === false || 'ontouchend' in document && _.options.swipe === false) return;
        else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) return;
        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ? event.originalEvent.touches.length : 1;
        _.touchObject.minSwipe = _.listWidth / _.options.touchThreshold;
        if (_.options.verticalSwiping === true) _.touchObject.minSwipe = _.listHeight / _.options.touchThreshold;
        switch(event.data.action){
            case 'start':
                _.swipeStart(event);
                break;
            case 'move':
                _.swipeMove(event);
                break;
            case 'end':
                _.swipeEnd(event);
                break;
        }
    };
    Slick.prototype.swipeMove = function(event) {
        var _ = this, edgeWasHit = false, curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;
        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;
        if (!_.dragging || _.scrolling || touches && touches.length !== 1) return false;
        curLeft = _.getLeft(_.currentSlide);
        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;
        _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));
        verticalSwipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
            _.scrolling = true;
            return false;
        }
        if (_.options.verticalSwiping === true) _.touchObject.swipeLength = verticalSwipeLength;
        swipeDirection = _.swipeDirection();
        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            _.swiping = true;
            event.preventDefault();
        }
        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        swipeLength = _.touchObject.swipeLength;
        _.touchObject.edgeHit = false;
        if (_.options.infinite === false) {
            if (_.currentSlide === 0 && swipeDirection === 'right' || _.currentSlide >= _.getDotCount() && swipeDirection === 'left') {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }
        if (_.options.vertical === false) _.swipeLeft = curLeft + swipeLength * positionOffset;
        else _.swipeLeft = curLeft + swipeLength * (_.$list.height() / _.listWidth) * positionOffset;
        if (_.options.verticalSwiping === true) _.swipeLeft = curLeft + swipeLength * positionOffset;
        if (_.options.fade === true || _.options.touchMove === false) return false;
        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }
        _.setCSS(_.swipeLeft);
    };
    Slick.prototype.swipeStart = function(event) {
        var _ = this, touches;
        _.interrupted = true;
        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }
        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) touches = event.originalEvent.touches[0];
        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;
        _.dragging = true;
    };
    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {
        var _ = this;
        if (_.$slidesCache !== null) {
            _.unload();
            _.$slideTrack.children(this.options.slide).detach();
            _.$slidesCache.appendTo(_.$slideTrack);
            _.reinit();
        }
    };
    Slick.prototype.unload = function() {
        var _ = this;
        $('.slick-cloned', _.$slider).remove();
        if (_.$dots) _.$dots.remove();
        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) _.$prevArrow.remove();
        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) _.$nextArrow.remove();
        _.$slides.removeClass('slick-slide slick-active slick-visible slick-current').attr('aria-hidden', 'true').css('width', '');
    };
    Slick.prototype.unslick = function(fromBreakpoint) {
        var _ = this;
        _.$slider.trigger('unslick', [
            _,
            fromBreakpoint
        ]);
        _.destroy();
    };
    Slick.prototype.updateArrows = function() {
        var _ = this, centerOffset;
        centerOffset = Math.floor(_.options.slidesToShow / 2);
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow && !_.options.infinite) {
            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            if (_.currentSlide === 0) {
                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {
                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {
                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            }
        }
    };
    Slick.prototype.updateDots = function() {
        var _ = this;
        if (_.$dots !== null) {
            _.$dots.find('li').removeClass('slick-active').end();
            _.$dots.find('li').eq(Math.floor(_.currentSlide / _.options.slidesToScroll)).addClass('slick-active');
        }
    };
    Slick.prototype.visibility = function() {
        var _ = this;
        if (_.options.autoplay) {
            if (document[_.hidden]) _.interrupted = true;
            else _.interrupted = false;
        }
    };
    $.fn.slick = function() {
        var _ = this, opt = arguments[0], args = Array.prototype.slice.call(arguments, 1), l = _.length, i, ret;
        for(i = 0; i < l; i++){
            if ((typeof opt === "undefined" ? "undefined" : (0, $6gBIz._)(opt)) == 'object' || typeof opt == 'undefined') _[i].slick = new Slick(_[i], opt);
            else ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };
});


var $7160571f9911b107$exports = {};
'use strict';

$7160571f9911b107$exports = (parcelRequire("5SVJi"));



var $2Aaz3 = parcelRequire("2Aaz3");
var $2Aaz3 = parcelRequire("2Aaz3");
/*!
 * CSSPlugin 3.13.0
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $6gBIz = parcelRequire("6gBIz");

var $2Aaz3 = parcelRequire("2Aaz3");
var $2c25c90c3df8b6ce$var$_win, $2c25c90c3df8b6ce$var$_doc, $2c25c90c3df8b6ce$var$_docElement, $2c25c90c3df8b6ce$var$_pluginInitted, $2c25c90c3df8b6ce$var$_tempDiv, $2c25c90c3df8b6ce$var$_tempDivStyler, $2c25c90c3df8b6ce$var$_recentSetterPlugin, $2c25c90c3df8b6ce$var$_reverting, $2c25c90c3df8b6ce$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $2c25c90c3df8b6ce$var$_transformProps = {}, $2c25c90c3df8b6ce$var$_RAD2DEG = 180 / Math.PI, $2c25c90c3df8b6ce$var$_DEG2RAD = Math.PI / 180, $2c25c90c3df8b6ce$var$_atan2 = Math.atan2, $2c25c90c3df8b6ce$var$_bigNum = 1e8, $2c25c90c3df8b6ce$var$_capsExp = /([A-Z])/g, $2c25c90c3df8b6ce$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $2c25c90c3df8b6ce$var$_complexExp = /[\s,\(]\S/, $2c25c90c3df8b6ce$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $2c25c90c3df8b6ce$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $2c25c90c3df8b6ce$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $2c25c90c3df8b6ce$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$2c25c90c3df8b6ce$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $2c25c90c3df8b6ce$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $2c25c90c3df8b6ce$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $2c25c90c3df8b6ce$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $2c25c90c3df8b6ce$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $2c25c90c3df8b6ce$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $2c25c90c3df8b6ce$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $2c25c90c3df8b6ce$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $2c25c90c3df8b6ce$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $2c25c90c3df8b6ce$var$_transformProp = "transform", $2c25c90c3df8b6ce$var$_transformOriginProp = $2c25c90c3df8b6ce$var$_transformProp + "Origin", $2c25c90c3df8b6ce$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style, cache = target._gsap;
    if (property in $2c25c90c3df8b6ce$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $2c25c90c3df8b6ce$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $2c25c90c3df8b6ce$var$_get(target, a);
            }) : this.tfm[property] = cache.x ? cache[property] : $2c25c90c3df8b6ce$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
            property === $2c25c90c3df8b6ce$var$_transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
        } else return $2c25c90c3df8b6ce$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($2c25c90c3df8b6ce$var$_transformProp) >= 0) return;
        if (cache.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($2c25c90c3df8b6ce$var$_transformOriginProp, isNotCSS, "");
        }
        property = $2c25c90c3df8b6ce$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $2c25c90c3df8b6ce$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $2c25c90c3df8b6ce$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3){
        // stored like this: property, isNotCSS, value
        if (!props[i + 1]) props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($2c25c90c3df8b6ce$var$_capsExp, "-$1").toLowerCase());
        else if (props[i + 1] === 2) // non-CSS value (function-based)
        target[props[i]](props[i + 2]);
        else // non-CSS value (not function-based)
        target[props[i]] = props[i + 2];
    }
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $2c25c90c3df8b6ce$var$_reverting();
        if ((!i || !i.isStart) && !style[$2c25c90c3df8b6ce$var$_transformProp]) {
            $2c25c90c3df8b6ce$var$_removeIndependentTransforms(style);
            if (cache.zOrigin && style[$2c25c90c3df8b6ce$var$_transformOriginProp]) {
                style[$2c25c90c3df8b6ce$var$_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.
                cache.zOrigin = 0;
                cache.renderTransform();
            }
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $2c25c90c3df8b6ce$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $2c25c90c3df8b6ce$var$_revertStyle,
        save: $2c25c90c3df8b6ce$var$_saveStyle
    };
    target._gsap || (0, $2Aaz3.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && target.style && target.nodeType && properties.split(",").forEach(function(p) {
        return saver.save(p);
    }); // make sure it's a DOM node too.
    return saver;
}, $2c25c90c3df8b6ce$var$_supports3D, $2c25c90c3df8b6ce$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $2c25c90c3df8b6ce$var$_doc.createElementNS ? $2c25c90c3df8b6ce$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $2c25c90c3df8b6ce$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e && e.style ? e : $2c25c90c3df8b6ce$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $2c25c90c3df8b6ce$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($2c25c90c3df8b6ce$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $2c25c90c3df8b6ce$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $2c25c90c3df8b6ce$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $2c25c90c3df8b6ce$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $2c25c90c3df8b6ce$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($2c25c90c3df8b6ce$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $2c25c90c3df8b6ce$var$_prefixes[i] : "") + property;
}, $2c25c90c3df8b6ce$var$_initCore = function _initCore() {
    if ($2c25c90c3df8b6ce$var$_windowExists() && window.document) {
        $2c25c90c3df8b6ce$var$_win = window;
        $2c25c90c3df8b6ce$var$_doc = $2c25c90c3df8b6ce$var$_win.document;
        $2c25c90c3df8b6ce$var$_docElement = $2c25c90c3df8b6ce$var$_doc.documentElement;
        $2c25c90c3df8b6ce$var$_tempDiv = $2c25c90c3df8b6ce$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $2c25c90c3df8b6ce$var$_tempDivStyler = $2c25c90c3df8b6ce$export$a232bb0480ae674a("div");
        $2c25c90c3df8b6ce$var$_transformProp = $2c25c90c3df8b6ce$export$8cbef5dd49a09c8b($2c25c90c3df8b6ce$var$_transformProp);
        $2c25c90c3df8b6ce$var$_transformOriginProp = $2c25c90c3df8b6ce$var$_transformProp + "Origin";
        $2c25c90c3df8b6ce$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $2c25c90c3df8b6ce$var$_supports3D = !!$2c25c90c3df8b6ce$export$8cbef5dd49a09c8b("perspective");
        $2c25c90c3df8b6ce$var$_reverting = (0, $2Aaz3.gsap).core.reverting;
        $2c25c90c3df8b6ce$var$_pluginInitted = 1;
    }
}, $2c25c90c3df8b6ce$var$_getReparentedCloneBBox = function _getReparentedCloneBBox(target) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var owner = target.ownerSVGElement, svg = $2c25c90c3df8b6ce$export$a232bb0480ae674a("svg", owner && owner.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), clone = target.cloneNode(true), bbox;
    clone.style.display = "block";
    svg.appendChild(clone);
    $2c25c90c3df8b6ce$var$_docElement.appendChild(svg);
    try {
        bbox = clone.getBBox();
    } catch (e) {}
    svg.removeChild(clone);
    $2c25c90c3df8b6ce$var$_docElement.removeChild(svg);
    return bbox;
}, $2c25c90c3df8b6ce$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $2c25c90c3df8b6ce$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds, cloned;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $2c25c90c3df8b6ce$var$_getReparentedCloneBBox(target);
        cloned = 1;
    }
    bounds && (bounds.width || bounds.height) || cloned || (bounds = $2c25c90c3df8b6ce$var$_getReparentedCloneBBox(target)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$2c25c90c3df8b6ce$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$2c25c90c3df8b6ce$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $2c25c90c3df8b6ce$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $2c25c90c3df8b6ce$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$2c25c90c3df8b6ce$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style, first2Chars;
        if (property in $2c25c90c3df8b6ce$var$_transformProps && property !== $2c25c90c3df8b6ce$var$_transformOriginProp) property = $2c25c90c3df8b6ce$var$_transformProp;
        if (style.removeProperty) {
            first2Chars = property.substr(0, 2);
            if (first2Chars === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(first2Chars === "--" ? property : property.replace($2c25c90c3df8b6ce$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $2c25c90c3df8b6ce$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $2Aaz3.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $2c25c90c3df8b6ce$var$_renderNonTweeningValueOnlyAtEnd : $2c25c90c3df8b6ce$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $2c25c90c3df8b6ce$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $2c25c90c3df8b6ce$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$2c25c90c3df8b6ce$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $2c25c90c3df8b6ce$var$_tempDiv.style, horizontal = $2c25c90c3df8b6ce$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $2c25c90c3df8b6ce$var$_nonConvertibleUnits[unit] || $2c25c90c3df8b6ce$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $2c25c90c3df8b6ce$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($2c25c90c3df8b6ce$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $2Aaz3._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = unit !== "rem" && ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $2c25c90c3df8b6ce$var$_doc || !parent.appendChild) parent = $2c25c90c3df8b6ce$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $2Aaz3._ticker).time && !cache.uncache) return (0, $2Aaz3._round)(curValue / cache.width * amount);
    else {
        if (toPercent && (property === "height" || property === "width")) {
            // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
            var v = target.style[property];
            target.style[property] = amount + unit;
            px = target[measureProperty];
            v ? target.style[property] = v : $2c25c90c3df8b6ce$var$_removeProperty(target, property);
        } else {
            (toPercent || curUnit === "%") && !$2c25c90c3df8b6ce$var$_nonStandardLayouts[$2c25c90c3df8b6ce$var$_getComputedProperty(parent, "display")] && (style.position = $2c25c90c3df8b6ce$var$_getComputedProperty(target, "position"));
            parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
            parent.appendChild($2c25c90c3df8b6ce$var$_tempDiv);
            px = $2c25c90c3df8b6ce$var$_tempDiv[measureProperty];
            parent.removeChild($2c25c90c3df8b6ce$var$_tempDiv);
            style.position = "absolute";
        }
        if (horizontal && toPercent) {
            cache = (0, $2Aaz3._getCache)(parent);
            cache.time = (0, $2Aaz3._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $2Aaz3._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $2c25c90c3df8b6ce$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $2c25c90c3df8b6ce$var$_pluginInitted || $2c25c90c3df8b6ce$var$_initCore();
    if (property in $2c25c90c3df8b6ce$var$_propertyAliases && property !== "transform") {
        property = $2c25c90c3df8b6ce$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($2c25c90c3df8b6ce$var$_transformProps[property] && property !== "transform") {
        value = $2c25c90c3df8b6ce$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $2c25c90c3df8b6ce$var$_firstTwoOnly($2c25c90c3df8b6ce$var$_getComputedProperty(target, $2c25c90c3df8b6ce$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $2c25c90c3df8b6ce$var$_specialProps[property] && $2c25c90c3df8b6ce$var$_specialProps[property](target, property, unit) || $2c25c90c3df8b6ce$var$_getComputedProperty(target, property) || (0, $2Aaz3._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $2c25c90c3df8b6ce$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $2c25c90c3df8b6ce$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $2c25c90c3df8b6ce$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $2c25c90c3df8b6ce$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $2c25c90c3df8b6ce$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $2Aaz3.PropTween)(this._pt, target.style, prop, 0, 1, (0, $2Aaz3._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end.substring(0, 6) === "var(--") end = $2c25c90c3df8b6ce$var$_getComputedProperty(target, end.substring(4, end.indexOf(")")));
    if (end === "auto") {
        startValue = target.style[prop];
        target.style[prop] = end;
        end = $2c25c90c3df8b6ce$var$_getComputedProperty(target, prop) || end;
        startValue ? target.style[prop] = startValue : $2c25c90c3df8b6ce$var$_removeProperty(target, prop);
    }
    a = [
        start,
        end
    ];
    (0, $2Aaz3._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $2Aaz3._numWithUnitExp)) || [];
    endValues = end.match((0, $2Aaz3._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, $2Aaz3._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $2Aaz3._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $2Aaz3._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $2Aaz3._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $2c25c90c3df8b6ce$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $2c25c90c3df8b6ce$var$_renderNonTweeningValueOnlyAtEnd : $2c25c90c3df8b6ce$var$_renderNonTweeningValue;
    (0, $2Aaz3._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $2c25c90c3df8b6ce$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $2c25c90c3df8b6ce$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $2c25c90c3df8b6ce$var$_keywordToPercent[x] || x;
    split[1] = $2c25c90c3df8b6ce$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $2c25c90c3df8b6ce$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($2c25c90c3df8b6ce$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $2c25c90c3df8b6ce$var$_transformOriginProp : $2c25c90c3df8b6ce$var$_transformProp;
                }
                $2c25c90c3df8b6ce$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $2c25c90c3df8b6ce$var$_removeProperty(target, $2c25c90c3df8b6ce$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                style.scale = style.rotate = style.translate = "none";
                $2c25c90c3df8b6ce$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $2c25c90c3df8b6ce$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$2c25c90c3df8b6ce$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $2Aaz3.PropTween)(plugin._pt, target, property, 0, 0, $2c25c90c3df8b6ce$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $2c25c90c3df8b6ce$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $2c25c90c3df8b6ce$var$_rotationalProperties = {}, $2c25c90c3df8b6ce$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $2c25c90c3df8b6ce$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $2c25c90c3df8b6ce$var$_getComputedProperty(target, $2c25c90c3df8b6ce$var$_transformProp);
    return $2c25c90c3df8b6ce$var$_isNullTransform(matrixString) ? $2c25c90c3df8b6ce$var$_identity2DMatrix : matrixString.substr(7).match((0, $2Aaz3._numExp)).map((0, $2Aaz3._round));
}, $2c25c90c3df8b6ce$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $2Aaz3._getCache)(target), style = target.style, matrix = $2c25c90c3df8b6ce$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $2c25c90c3df8b6ce$var$_identity2DMatrix : matrix;
    } else if (matrix === $2c25c90c3df8b6ce$var$_identity2DMatrix && !target.offsetParent && target !== $2c25c90c3df8b6ce$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent && !target.getBoundingClientRect().width) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375. Note: position: fixed elements report a null offsetParent but they could also be invisible because they're in an ancestor with display: none, so we check getBoundingClientRect(). We only want to alter the DOM if we absolutely have to because it can cause iframe content to reload, like a Vimeo video.
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $2c25c90c3df8b6ce$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $2c25c90c3df8b6ce$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $2c25c90c3df8b6ce$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $2c25c90c3df8b6ce$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $2c25c90c3df8b6ce$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $2c25c90c3df8b6ce$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $2c25c90c3df8b6ce$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
    } else if (matrix !== $2c25c90c3df8b6ce$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$2c25c90c3df8b6ce$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $2c25c90c3df8b6ce$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $2c25c90c3df8b6ce$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $2c25c90c3df8b6ce$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $2c25c90c3df8b6ce$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $2c25c90c3df8b6ce$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $2Aaz3.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $2c25c90c3df8b6ce$var$_getComputedProperty(target, $2c25c90c3df8b6ce$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $2c25c90c3df8b6ce$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$2c25c90c3df8b6ce$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$2c25c90c3df8b6ce$var$_transformProp] !== "none" ? cs[$2c25c90c3df8b6ce$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $2c25c90c3df8b6ce$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $2c25c90c3df8b6ce$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $2c25c90c3df8b6ce$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $2c25c90c3df8b6ce$var$_atan2(b, a) * $2c25c90c3df8b6ce$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $2c25c90c3df8b6ce$var$_atan2(c, d) * $2c25c90c3df8b6ce$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $2c25c90c3df8b6ce$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $2c25c90c3df8b6ce$var$_atan2(a32, a33);
            rotationX = angle * $2c25c90c3df8b6ce$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $2c25c90c3df8b6ce$var$_atan2(-c, a33);
            rotationY = angle * $2c25c90c3df8b6ce$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $2c25c90c3df8b6ce$var$_atan2(b, a);
            rotation = angle * $2c25c90c3df8b6ce$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $2Aaz3._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $2Aaz3._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $2c25c90c3df8b6ce$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $2c25c90c3df8b6ce$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$2c25c90c3df8b6ce$var$_isNullTransform($2c25c90c3df8b6ce$var$_getComputedProperty(target, $2c25c90c3df8b6ce$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $2Aaz3._round)(scaleX);
    cache.scaleY = (0, $2Aaz3._round)(scaleY);
    cache.rotation = (0, $2Aaz3._round)(rotation) + deg;
    cache.rotationX = (0, $2Aaz3._round)(rotationX) + deg;
    cache.rotationY = (0, $2Aaz3._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) style[$2c25c90c3df8b6ce$var$_transformOriginProp] = $2c25c90c3df8b6ce$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $2Aaz3._config).force3D;
    cache.renderTransform = cache.svg ? $2c25c90c3df8b6ce$var$_renderSVGTransforms : $2c25c90c3df8b6ce$var$_supports3D ? $2c25c90c3df8b6ce$var$_renderCSSTransforms : $2c25c90c3df8b6ce$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $2c25c90c3df8b6ce$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$2c25c90c3df8b6ce$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $2Aaz3.getUnit)(start);
    return (0, $2Aaz3._round)(parseFloat(start) + parseFloat($2c25c90c3df8b6ce$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $2c25c90c3df8b6ce$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $2c25c90c3df8b6ce$var$_renderCSSTransforms(ratio, cache);
}, $2c25c90c3df8b6ce$var$_zeroDeg = "0deg", $2c25c90c3df8b6ce$var$_zeroPx = "0px", $2c25c90c3df8b6ce$var$_endParenthesis = ") ", $2c25c90c3df8b6ce$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $2c25c90c3df8b6ce$var$_zeroDeg || rotationY !== $2c25c90c3df8b6ce$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $2c25c90c3df8b6ce$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $2c25c90c3df8b6ce$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $2c25c90c3df8b6ce$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $2c25c90c3df8b6ce$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $2c25c90c3df8b6ce$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $2c25c90c3df8b6ce$var$_zeroPx) transforms += "perspective(" + transformPerspective + $2c25c90c3df8b6ce$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $2c25c90c3df8b6ce$var$_zeroPx || y !== $2c25c90c3df8b6ce$var$_zeroPx || z !== $2c25c90c3df8b6ce$var$_zeroPx) transforms += z !== $2c25c90c3df8b6ce$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $2c25c90c3df8b6ce$var$_endParenthesis;
    if (rotation !== $2c25c90c3df8b6ce$var$_zeroDeg) transforms += "rotate(" + rotation + $2c25c90c3df8b6ce$var$_endParenthesis;
    if (rotationY !== $2c25c90c3df8b6ce$var$_zeroDeg) transforms += "rotateY(" + rotationY + $2c25c90c3df8b6ce$var$_endParenthesis;
    if (rotationX !== $2c25c90c3df8b6ce$var$_zeroDeg) transforms += "rotateX(" + rotationX + $2c25c90c3df8b6ce$var$_endParenthesis;
    if (skewX !== $2c25c90c3df8b6ce$var$_zeroDeg || skewY !== $2c25c90c3df8b6ce$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $2c25c90c3df8b6ce$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $2c25c90c3df8b6ce$var$_endParenthesis;
    target.style[$2c25c90c3df8b6ce$var$_transformProp] = transforms || "translate(0, 0)";
}, $2c25c90c3df8b6ce$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $2c25c90c3df8b6ce$var$_DEG2RAD;
        skewX *= $2c25c90c3df8b6ce$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $2c25c90c3df8b6ce$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $2Aaz3._round)(a11);
        a21 = (0, $2Aaz3._round)(a21);
        a12 = (0, $2Aaz3._round)(a12);
        a22 = (0, $2Aaz3._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $2c25c90c3df8b6ce$var$_convertToUnit(target, "x", x, "px");
        ty = $2c25c90c3df8b6ce$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $2Aaz3._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $2Aaz3._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $2Aaz3._round)(tx + xPercent / 100 * temp.width);
        ty = (0, $2Aaz3._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$2c25c90c3df8b6ce$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $2c25c90c3df8b6ce$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $2Aaz3._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $2c25c90c3df8b6ce$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $2c25c90c3df8b6ce$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $2c25c90c3df8b6ce$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $2Aaz3.PropTween)(plugin._pt, target, property, startNum, change, $2c25c90c3df8b6ce$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $2c25c90c3df8b6ce$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $2c25c90c3df8b6ce$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $2c25c90c3df8b6ce$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$2c25c90c3df8b6ce$var$_transformProp] = transforms;
        endCache = $2c25c90c3df8b6ce$var$_parseTransform(target, 1);
        $2c25c90c3df8b6ce$var$_removeProperty(target, $2c25c90c3df8b6ce$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$2c25c90c3df8b6ce$var$_transformProp];
        style[$2c25c90c3df8b6ce$var$_transformProp] = transforms;
        endCache = $2c25c90c3df8b6ce$var$_parseTransform(target, 1);
        style[$2c25c90c3df8b6ce$var$_transformProp] = startValue;
    }
    for(p in $2c25c90c3df8b6ce$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $2Aaz3.getUnit)(startValue);
            endUnit = (0, $2Aaz3.getUnit)(endValue);
            startNum = startUnit !== endUnit ? $2c25c90c3df8b6ce$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $2Aaz3.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, $2c25c90c3df8b6ce$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $2c25c90c3df8b6ce$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $2Aaz3._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $2c25c90c3df8b6ce$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $2c25c90c3df8b6ce$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $2c25c90c3df8b6ce$export$855822f522f18eef = {
    name: "css",
    register: $2c25c90c3df8b6ce$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps;
        $2c25c90c3df8b6ce$var$_pluginInitted || $2c25c90c3df8b6ce$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $2c25c90c3df8b6ce$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $2Aaz3._plugins)[p] && (0, $2Aaz3._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue === "undefined" ? "undefined" : (0, $6gBIz._)(endValue);
            specialProp = $2c25c90c3df8b6ce$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue === "undefined" ? "undefined" : (0, $6gBIz._)(endValue);
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $2Aaz3._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $2Aaz3._colorExp).lastIndex = 0;
                if (!(0, $2Aaz3._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $2Aaz3.getUnit)(startValue);
                    endUnit = (0, $2Aaz3.getUnit)(endValue);
                }
                endUnit ? startUnit !== endUnit && (startValue = $2c25c90c3df8b6ce$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $2Aaz3._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $2Aaz3._replaceRandom)(startValue));
                    (0, $2Aaz3.getUnit)(startValue + "") || startValue === "auto" || (startValue += (0, $2Aaz3._config).units[p] || (0, $2Aaz3.getUnit)($2c25c90c3df8b6ce$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $2c25c90c3df8b6ce$var$_get(target, p)); // can't work with relative values
                } else startValue = $2c25c90c3df8b6ce$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $2c25c90c3df8b6ce$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $2c25c90c3df8b6ce$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $2c25c90c3df8b6ce$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $2c25c90c3df8b6ce$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $2c25c90c3df8b6ce$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    if (type === "string" && endValue.substring(0, 6) === "var(--") {
                        endValue = $2c25c90c3df8b6ce$var$_getComputedProperty(target, endValue.substring(4, endValue.indexOf(")")));
                        endNum = parseFloat(endValue);
                    }
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $2c25c90c3df8b6ce$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $2Aaz3.PropTween)(this._pt, style, $2c25c90c3df8b6ce$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $2Aaz3.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $2Aaz3._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $2c25c90c3df8b6ce$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($2c25c90c3df8b6ce$var$_transformOriginProp, 0, style[$2c25c90c3df8b6ce$var$_transformOriginProp]);
                        endValue = $2c25c90c3df8b6ce$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $2c25c90c3df8b6ce$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $2c25c90c3df8b6ce$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $2c25c90c3df8b6ce$var$_addNonTweeningPT(this, style, p, $2c25c90c3df8b6ce$var$_firstTwoOnly(startValue), $2c25c90c3df8b6ce$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $2c25c90c3df8b6ce$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $2c25c90c3df8b6ce$var$_rotationalProperties) {
                        $2c25c90c3df8b6ce$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $2Aaz3._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $2c25c90c3df8b6ce$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $2c25c90c3df8b6ce$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $2c25c90c3df8b6ce$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$2c25c90c3df8b6ce$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $2Aaz3.getUnit)(endValue) || (p in (0, $2Aaz3._config).units ? (0, $2Aaz3._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $2c25c90c3df8b6ce$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $2Aaz3.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $2Aaz3._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $2c25c90c3df8b6ce$var$_renderRoundedCSSProp : $2c25c90c3df8b6ce$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $2c25c90c3df8b6ce$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $2Aaz3._missingPlugin)(p, endValue);
                        continue;
                    }
                } else $2c25c90c3df8b6ce$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : typeof target[p] === "function" ? inlineProps.push(p, 2, target[p]()) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $2Aaz3._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$2c25c90c3df8b6ce$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $2c25c90c3df8b6ce$var$_get,
    aliases: $2c25c90c3df8b6ce$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $2c25c90c3df8b6ce$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $2c25c90c3df8b6ce$var$_transformProps && property !== $2c25c90c3df8b6ce$var$_transformOriginProp && (target._gsap.x || $2c25c90c3df8b6ce$var$_get(target, "x")) ? plugin && $2c25c90c3df8b6ce$var$_recentSetterPlugin === plugin ? property === "scale" ? $2c25c90c3df8b6ce$var$_setterScale : $2c25c90c3df8b6ce$var$_setterTransform : ($2c25c90c3df8b6ce$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $2c25c90c3df8b6ce$var$_setterScaleWithRender : $2c25c90c3df8b6ce$var$_setterTransformWithRender) : target.style && !(0, $2Aaz3._isUndefined)(target.style[property]) ? $2c25c90c3df8b6ce$var$_setterCSSStyle : ~property.indexOf("-") ? $2c25c90c3df8b6ce$var$_setterCSSProp : (0, $2Aaz3._getSetter)(target, property);
    },
    core: {
        _removeProperty: $2c25c90c3df8b6ce$var$_removeProperty,
        _getMatrix: $2c25c90c3df8b6ce$var$_getMatrix
    }
};
(0, $2Aaz3.gsap).utils.checkPrefix = $2c25c90c3df8b6ce$export$8cbef5dd49a09c8b;
(0, $2Aaz3.gsap).core.getStyleSaver = $2c25c90c3df8b6ce$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $2Aaz3._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        $2c25c90c3df8b6ce$var$_transformProps[name] = 1;
    });
    (0, $2Aaz3._forEachName)(rotation, function(name) {
        (0, $2Aaz3._config).units[name] = "deg";
        $2c25c90c3df8b6ce$var$_rotationalProperties[name] = 1;
    });
    $2c25c90c3df8b6ce$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $2Aaz3._forEachName)(aliases, function(name) {
        var split = name.split(":");
        $2c25c90c3df8b6ce$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $2Aaz3._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $2Aaz3._config).units[name] = "px";
});
(0, $2Aaz3.gsap).registerPlugin($2c25c90c3df8b6ce$export$855822f522f18eef);


var $ef4a4081ea69cd07$export$99ee26438460406a = (0, $2Aaz3.gsap).registerPlugin((0, $2c25c90c3df8b6ce$export$855822f522f18eef)) || (0, $2Aaz3.gsap), // to protect from tree shaking
$ef4a4081ea69cd07$export$7b23975ad686bf91 = $ef4a4081ea69cd07$export$99ee26438460406a.core.Tween;


var $1badb982a685f949$exports = {};

var $6gBIz = parcelRequire("6gBIz");
/*!
 * ScrollMagic v2.0.8 (2020-08-14)
 * The javascript library for magical scroll interactions.
 * (c) 2020 Jan Paepke (@janpaepke)
 * Project Website: http://scrollmagic.io
 * 
 * @version 2.0.8
 * @license Dual licensed under MIT license and GPL.
 * @author Jan Paepke - e-mail@janpaepke.de
 *
 * @file ScrollMagic main library.
 */ /**
 * @namespace ScrollMagic
 */ (function(root, factory) {
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(factory);
    else // CommonJS
    $1badb982a685f949$exports = factory();
})(undefined, function() {
    "use strict";
    var ScrollMagic = function ScrollMagic() {
        _util.log(2, '(COMPATIBILITY NOTICE) -> As of ScrollMagic 2.0.0 you need to use \'new ScrollMagic.Controller()\' to create a new controller instance. Use \'new ScrollMagic.Scene()\' to instance a scene.');
    };
    ScrollMagic.version = "2.0.8";
    // TODO: temporary workaround for chrome's scroll jitter bug
    if (typeof window !== 'undefined') window.addEventListener("mousewheel", void 0);
    // global const
    var PIN_SPACER_ATTRIBUTE = "data-scrollmagic-pin-spacer";
    /**
	 * The main class that is needed once per scroll container.
	 *
	 * @class
	 *
	 * @example
	 * // basic initialization
	 * var controller = new ScrollMagic.Controller();
	 *
	 * // passing options
	 * var controller = new ScrollMagic.Controller({container: "#myContainer", loglevel: 3});
	 *
	 * @param {object} [options] - An object containing one or more options for the controller.
	 * @param {(string|object)} [options.container=window] - A selector, DOM object that references the main container for scrolling.
	 * @param {boolean} [options.vertical=true] - Sets the scroll mode to vertical (`true`) or horizontal (`false`) scrolling.
	 * @param {object} [options.globalSceneOptions={}] - These options will be passed to every Scene that is added to the controller using the addScene method. For more information on Scene options see {@link ScrollMagic.Scene}.
	 * @param {number} [options.loglevel=2] Loglevel for debugging. Note that logging is disabled in the minified version of ScrollMagic.
											 ** `0` => silent
											 ** `1` => errors
											 ** `2` => errors, warnings
											 ** `3` => errors, warnings, debuginfo
	 * @param {boolean} [options.refreshInterval=100] - Some changes don't call events by default, like changing the container size or moving a scene trigger element.  
	 																										 This interval polls these parameters to fire the necessary events.  
	 																										 If you don't use custom containers, trigger elements or have static layouts, where the positions of the trigger elements don't change, you can set this to 0 disable interval checking and improve performance.
	 *
	 */ ScrollMagic.Controller = function(options) {
        /*
		 * ----------------------------------------------------------------
		 * settings
		 * ----------------------------------------------------------------
		 */ var NAMESPACE = 'ScrollMagic.Controller', SCROLL_DIRECTION_FORWARD = 'FORWARD', SCROLL_DIRECTION_REVERSE = 'REVERSE', SCROLL_DIRECTION_PAUSED = 'PAUSED', DEFAULT_OPTIONS = CONTROLLER_OPTIONS.defaults;
        /*
		 * ----------------------------------------------------------------
		 * private vars
		 * ----------------------------------------------------------------
		 */ var Controller = this, _options = _util.extend({}, DEFAULT_OPTIONS, options), _sceneObjects = [], _updateScenesOnNextCycle = false, _scrollPos = 0, _scrollDirection = SCROLL_DIRECTION_PAUSED, _isDocument = true, _viewPortSize = 0, _enabled = true, _updateTimeout, _refreshTimeout;
        /*
		 * ----------------------------------------------------------------
		 * private functions
		 * ----------------------------------------------------------------
		 */ /**
		 * Internal constructor function of the ScrollMagic Controller
		 * @private
		 */ var construct = function construct() {
            for(var key in _options)if (!DEFAULT_OPTIONS.hasOwnProperty(key)) {
                log(2, "WARNING: Unknown option \"" + key + "\"");
                delete _options[key];
            }
            _options.container = _util.get.elements(_options.container)[0];
            // check ScrollContainer
            if (!_options.container) {
                log(1, "ERROR creating object " + NAMESPACE + ": No valid scroll container supplied");
                throw NAMESPACE + " init failed."; // cancel
            }
            _isDocument = _options.container === window || _options.container === document.body || !document.body.contains(_options.container);
            // normalize to window
            if (_isDocument) _options.container = window;
            // update container size immediately
            _viewPortSize = getViewportSize();
            // set event handlers
            _options.container.addEventListener("resize", onChange);
            _options.container.addEventListener("scroll", onChange);
            var ri = parseInt(_options.refreshInterval, 10);
            _options.refreshInterval = _util.type.Number(ri) ? ri : DEFAULT_OPTIONS.refreshInterval;
            scheduleRefresh();
            log(3, "added new " + NAMESPACE + " controller (v" + ScrollMagic.version + ")");
        };
        /**
		 * Schedule the next execution of the refresh function
		 * @private
		 */ var scheduleRefresh = function scheduleRefresh() {
            if (_options.refreshInterval > 0) _refreshTimeout = window.setTimeout(refresh, _options.refreshInterval);
        };
        /**
		 * Default function to get scroll pos - overwriteable using `Controller.scrollPos(newFunction)`
		 * @private
		 */ var getScrollPos = function getScrollPos() {
            return _options.vertical ? _util.get.scrollTop(_options.container) : _util.get.scrollLeft(_options.container);
        };
        /**
		 * Returns the current viewport Size (width vor horizontal, height for vertical)
		 * @private
		 */ var getViewportSize = function getViewportSize() {
            return _options.vertical ? _util.get.height(_options.container) : _util.get.width(_options.container);
        };
        /**
		 * Default function to set scroll pos - overwriteable using `Controller.scrollTo(newFunction)`
		 * Make available publicly for pinned mousewheel workaround.
		 * @private
		 */ var setScrollPos = this._setScrollPos = function setScrollPos(pos) {
            if (_options.vertical) {
                if (_isDocument) window.scrollTo(_util.get.scrollLeft(), pos);
                else _options.container.scrollTop = pos;
            } else if (_isDocument) window.scrollTo(pos, _util.get.scrollTop());
            else _options.container.scrollLeft = pos;
        };
        /**
		 * Handle updates in cycles instead of on scroll (performance)
		 * @private
		 */ var updateScenes = function updateScenes() {
            if (_enabled && _updateScenesOnNextCycle) {
                // determine scenes to update
                var scenesToUpdate = _util.type.Array(_updateScenesOnNextCycle) ? _updateScenesOnNextCycle : _sceneObjects.slice(0);
                // reset scenes
                _updateScenesOnNextCycle = false;
                var oldScrollPos = _scrollPos;
                // update scroll pos now instead of onChange, as it might have changed since scheduling (i.e. in-browser smooth scroll)
                _scrollPos = Controller.scrollPos();
                var deltaScroll = _scrollPos - oldScrollPos;
                if (deltaScroll !== 0) _scrollDirection = deltaScroll > 0 ? SCROLL_DIRECTION_FORWARD : SCROLL_DIRECTION_REVERSE;
                // reverse order of scenes if scrolling reverse
                if (_scrollDirection === SCROLL_DIRECTION_REVERSE) scenesToUpdate.reverse();
                // update scenes
                scenesToUpdate.forEach(function(scene, index) {
                    log(3, "updating Scene " + (index + 1) + "/" + scenesToUpdate.length + " (" + _sceneObjects.length + " total)");
                    scene.update(true);
                });
                if (scenesToUpdate.length === 0 && _options.loglevel >= 3) log(3, "updating 0 Scenes (nothing added to controller)");
            }
        };
        /**
		 * Initializes rAF callback
		 * @private
		 */ var debounceUpdate = function debounceUpdate() {
            _updateTimeout = _util.rAF(updateScenes);
        };
        /**
		 * Handles Container changes
		 * @private
		 */ var onChange = function onChange(e) {
            log(3, "event fired causing an update:", e.type);
            if (e.type == "resize") {
                // resize
                _viewPortSize = getViewportSize();
                _scrollDirection = SCROLL_DIRECTION_PAUSED;
            }
            // schedule update
            if (_updateScenesOnNextCycle !== true) {
                _updateScenesOnNextCycle = true;
                debounceUpdate();
            }
        };
        var refresh = function refresh() {
            if (!_isDocument) // simulate resize event. Only works for viewport relevant param (performance)
            {
                if (_viewPortSize != getViewportSize()) {
                    var resizeEvent;
                    try {
                        resizeEvent = new Event('resize', {
                            bubbles: false,
                            cancelable: false
                        });
                    } catch (e) {
                        resizeEvent = document.createEvent("Event");
                        resizeEvent.initEvent("resize", false, false);
                    }
                    _options.container.dispatchEvent(resizeEvent);
                }
            }
            _sceneObjects.forEach(function(scene, index) {
                scene.refresh();
            });
            scheduleRefresh();
        };
        /**
		 * Send a debug message to the console.
		 * provided publicly with _log for plugins
		 * @private
		 *
		 * @param {number} loglevel - The loglevel required to initiate output for the message.
		 * @param {...mixed} output - One or more variables that should be passed to the console.
		 */ var log = this._log = function log(loglevel, output) {
            if (_options.loglevel >= loglevel) {
                Array.prototype.splice.call(arguments, 1, 0, "(" + NAMESPACE + ") ->");
                _util.log.apply(window, arguments);
            }
        };
        // for scenes we have getters for each option, but for the controller we don't, so we need to make it available externally for plugins
        this._options = _options;
        /**
		 * Sort scenes in ascending order of their start offset.
		 * @private
		 *
		 * @param {array} ScenesArray - an array of ScrollMagic Scenes that should be sorted
		 * @return {array} The sorted array of Scenes.
		 */ var sortScenes = function sortScenes(ScenesArray) {
            if (ScenesArray.length <= 1) return ScenesArray;
            else {
                var scenes = ScenesArray.slice(0);
                scenes.sort(function(a, b) {
                    return a.scrollOffset() > b.scrollOffset() ? 1 : -1;
                });
                return scenes;
            }
        };
        /**
		 * ----------------------------------------------------------------
		 * public functions
		 * ----------------------------------------------------------------
		 */ /**
		 * Add one ore more scene(s) to the controller.  
		 * This is the equivalent to `Scene.addTo(controller)`.
		 * @public
		 * @example
		 * // with a previously defined scene
		 * controller.addScene(scene);
		 *
		 * // with a newly created scene.
		 * controller.addScene(new ScrollMagic.Scene({duration : 0}));
		 *
		 * // adding multiple scenes
		 * controller.addScene([scene, scene2, new ScrollMagic.Scene({duration : 0})]);
		 *
		 * @param {(ScrollMagic.Scene|array)} newScene - ScrollMagic Scene or Array of Scenes to be added to the controller.
		 * @return {Controller} Parent object for chaining.
		 */ this.addScene = function(newScene) {
            if (_util.type.Array(newScene)) newScene.forEach(function(scene, index) {
                Controller.addScene(scene);
            });
            else if (newScene instanceof ScrollMagic.Scene) {
                if (newScene.controller() !== Controller) newScene.addTo(Controller);
                else if (_sceneObjects.indexOf(newScene) < 0) {
                    // new scene
                    _sceneObjects.push(newScene); // add to array
                    _sceneObjects = sortScenes(_sceneObjects); // sort
                    newScene.on("shift.controller_sort", function() {
                        _sceneObjects = sortScenes(_sceneObjects);
                    });
                    // insert Global defaults.
                    for(var key in _options.globalSceneOptions)if (newScene[key]) newScene[key].call(newScene, _options.globalSceneOptions[key]);
                    log(3, "adding Scene (now " + _sceneObjects.length + " total)");
                }
            } else log(1, "ERROR: invalid argument supplied for '.addScene()'");
            return Controller;
        };
        /**
		 * Remove one ore more scene(s) from the controller.  
		 * This is the equivalent to `Scene.remove()`.
		 * @public
		 * @example
		 * // remove a scene from the controller
		 * controller.removeScene(scene);
		 *
		 * // remove multiple scenes from the controller
		 * controller.removeScene([scene, scene2, scene3]);
		 *
		 * @param {(ScrollMagic.Scene|array)} Scene - ScrollMagic Scene or Array of Scenes to be removed from the controller.
		 * @returns {Controller} Parent object for chaining.
		 */ this.removeScene = function(Scene) {
            if (_util.type.Array(Scene)) Scene.forEach(function(scene, index) {
                Controller.removeScene(scene);
            });
            else {
                var index = _sceneObjects.indexOf(Scene);
                if (index > -1) {
                    Scene.off("shift.controller_sort");
                    _sceneObjects.splice(index, 1);
                    log(3, "removing Scene (now " + _sceneObjects.length + " left)");
                    Scene.remove();
                }
            }
            return Controller;
        };
        /**
	 * Update one ore more scene(s) according to the scroll position of the container.  
	 * This is the equivalent to `Scene.update()`.  
	 * The update method calculates the scene's start and end position (based on the trigger element, trigger hook, duration and offset) and checks it against the current scroll position of the container.  
	 * It then updates the current scene state accordingly (or does nothing, if the state is already correct) – Pins will be set to their correct position and tweens will be updated to their correct progress.  
	 * _**Note:** This method gets called constantly whenever Controller detects a change. The only application for you is if you change something outside of the realm of ScrollMagic, like moving the trigger or changing tween parameters._
	 * @public
	 * @example
	 * // update a specific scene on next cycle
 	 * controller.updateScene(scene);
 	 *
	 * // update a specific scene immediately
	 * controller.updateScene(scene, true);
 	 *
	 * // update multiple scenes scene on next cycle
	 * controller.updateScene([scene1, scene2, scene3]);
	 *
	 * @param {ScrollMagic.Scene} Scene - ScrollMagic Scene or Array of Scenes that is/are supposed to be updated.
	 * @param {boolean} [immediately=false] - If `true` the update will be instant, if `false` it will wait until next update cycle.  
	 										  This is useful when changing multiple properties of the scene - this way it will only be updated once all new properties are set (updateScenes).
	 * @return {Controller} Parent object for chaining.
	 */ this.updateScene = function(Scene, immediately) {
            if (_util.type.Array(Scene)) Scene.forEach(function(scene, index) {
                Controller.updateScene(scene, immediately);
            });
            else {
                if (immediately) Scene.update(true);
                else if (_updateScenesOnNextCycle !== true && Scene instanceof ScrollMagic.Scene) {
                    // prep array for next update cycle
                    _updateScenesOnNextCycle = _updateScenesOnNextCycle || [];
                    if (_updateScenesOnNextCycle.indexOf(Scene) == -1) _updateScenesOnNextCycle.push(Scene);
                    _updateScenesOnNextCycle = sortScenes(_updateScenesOnNextCycle); // sort
                    debounceUpdate();
                }
            }
            return Controller;
        };
        /**
		 * Updates the controller params and calls updateScene on every scene, that is attached to the controller.  
		 * See `Controller.updateScene()` for more information about what this means.  
		 * In most cases you will not need this function, as it is called constantly, whenever ScrollMagic detects a state change event, like resize or scroll.  
		 * The only application for this method is when ScrollMagic fails to detect these events.  
		 * One application is with some external scroll libraries (like iScroll) that move an internal container to a negative offset instead of actually scrolling. In this case the update on the controller needs to be called whenever the child container's position changes.
		 * For this case there will also be the need to provide a custom function to calculate the correct scroll position. See `Controller.scrollPos()` for details.
		 * @public
		 * @example
		 * // update the controller on next cycle (saves performance due to elimination of redundant updates)
		 * controller.update();
		 *
		 * // update the controller immediately
		 * controller.update(true);
		 *
		 * @param {boolean} [immediately=false] - If `true` the update will be instant, if `false` it will wait until next update cycle (better performance)
		 * @return {Controller} Parent object for chaining.
		 */ this.update = function(immediately) {
            onChange({
                type: "resize"
            }); // will update size and set _updateScenesOnNextCycle to true
            if (immediately) updateScenes();
            return Controller;
        };
        /**
		 * Scroll to a numeric scroll offset, a DOM element, the start of a scene or provide an alternate method for scrolling.  
		 * For vertical controllers it will change the top scroll offset and for horizontal applications it will change the left offset.
		 * @public
		 *
		 * @since 1.1.0
		 * @example
		 * // scroll to an offset of 100
		 * controller.scrollTo(100);
		 *
		 * // scroll to a DOM element
		 * controller.scrollTo("#anchor");
		 *
		 * // scroll to the beginning of a scene
		 * var scene = new ScrollMagic.Scene({offset: 200});
		 * controller.scrollTo(scene);
		 *
		 * // define a new scroll position modification function (jQuery animate instead of jump)
		 * controller.scrollTo(function (newScrollPos) {
		 *	$("html, body").animate({scrollTop: newScrollPos});
		 * });
		 * controller.scrollTo(100); // call as usual, but the new function will be used instead
		 *
		 * // define a new scroll function with an additional parameter
		 * controller.scrollTo(function (newScrollPos, message) {
		 *  console.log(message);
		 *	$(this).animate({scrollTop: newScrollPos});
		 * });
		 * // call as usual, but supply an extra parameter to the defined custom function
		 * controller.scrollTo(100, "my message");
		 *
		 * // define a new scroll function with an additional parameter containing multiple variables
		 * controller.scrollTo(function (newScrollPos, options) {
		 *  someGlobalVar = options.a + options.b;
		 *	$(this).animate({scrollTop: newScrollPos});
		 * });
		 * // call as usual, but supply an extra parameter containing multiple options
		 * controller.scrollTo(100, {a: 1, b: 2});
		 *
		 * // define a new scroll function with a callback supplied as an additional parameter
		 * controller.scrollTo(function (newScrollPos, callback) {
		 *	$(this).animate({scrollTop: newScrollPos}, 400, "swing", callback);
		 * });
		 * // call as usual, but supply an extra parameter, which is used as a callback in the previously defined custom scroll function
		 * controller.scrollTo(100, function() {
		 *	console.log("scroll has finished.");
		 * });
		 *
		 * @param {mixed} scrollTarget - The supplied argument can be one of these types:
		 * 1. `number` -> The container will scroll to this new scroll offset.
		 * 2. `string` or `object` -> Can be a selector or a DOM object.  
		 *  The container will scroll to the position of this element.
		 * 3. `ScrollMagic Scene` -> The container will scroll to the start of this scene.
		 * 4. `function` -> This function will be used for future scroll position modifications.  
		 *  This provides a way for you to change the behaviour of scrolling and adding new behaviour like animation. The function receives the new scroll position as a parameter and a reference to the container element using `this`.  
		 *  It may also optionally receive an optional additional parameter (see below)  
		 *  _**NOTE:**  
		 *  All other options will still work as expected, using the new function to scroll._
		 * @param {mixed} [additionalParameter] - If a custom scroll function was defined (see above 4.), you may want to supply additional parameters to it, when calling it. You can do this using this parameter – see examples for details. Please note, that this parameter will have no effect, if you use the default scrolling function.
		 * @returns {Controller} Parent object for chaining.
		 */ this.scrollTo = function(scrollTarget, additionalParameter) {
            if (_util.type.Number(scrollTarget)) setScrollPos.call(_options.container, scrollTarget, additionalParameter);
            else if (scrollTarget instanceof ScrollMagic.Scene) {
                if (scrollTarget.controller() === Controller) Controller.scrollTo(scrollTarget.scrollOffset(), additionalParameter);
                else log(2, "scrollTo(): The supplied scene does not belong to this controller. Scroll cancelled.", scrollTarget);
            } else if (_util.type.Function(scrollTarget)) setScrollPos = scrollTarget;
            else {
                var elem = _util.get.elements(scrollTarget)[0];
                if (elem) {
                    // if parent is pin spacer, use spacer position instead so correct start position is returned for pinned elements.
                    while(elem.parentNode.hasAttribute(PIN_SPACER_ATTRIBUTE))elem = elem.parentNode;
                    var param = _options.vertical ? "top" : "left", containerOffset = _util.get.offset(_options.container), elementOffset = _util.get.offset(elem);
                    if (!_isDocument) containerOffset[param] -= Controller.scrollPos();
                    Controller.scrollTo(elementOffset[param] - containerOffset[param], additionalParameter);
                } else log(2, "scrollTo(): The supplied argument is invalid. Scroll cancelled.", scrollTarget);
            }
            return Controller;
        };
        /**
		 * **Get** the current scrollPosition or **Set** a new method to calculate it.  
		 * -> **GET**:
		 * When used as a getter this function will return the current scroll position.  
		 * To get a cached value use Controller.info("scrollPos"), which will be updated in the update cycle.  
		 * For vertical controllers it will return the top scroll offset and for horizontal applications it will return the left offset.
		 *
		 * -> **SET**:
		 * When used as a setter this method prodes a way to permanently overwrite the controller's scroll position calculation.  
		 * A typical usecase is when the scroll position is not reflected by the containers scrollTop or scrollLeft values, but for example by the inner offset of a child container.  
		 * Moving a child container inside a parent is a commonly used method for several scrolling frameworks, including iScroll.  
		 * By providing an alternate calculation function you can make sure ScrollMagic receives the correct scroll position.  
		 * Please also bear in mind that your function should return y values for vertical scrolls an x for horizontals.
		 *
		 * To change the current scroll position please use `Controller.scrollTo()`.
		 * @public
		 *
		 * @example
		 * // get the current scroll Position
		 * var scrollPos = controller.scrollPos();
		 *
		 * // set a new scroll position calculation method
		 * controller.scrollPos(function () {
		 *	return this.info("vertical") ? -mychildcontainer.y : -mychildcontainer.x
		 * });
		 *
		 * @param {function} [scrollPosMethod] - The function to be used for the scroll position calculation of the container.
		 * @returns {(number|Controller)} Current scroll position or parent object for chaining.
		 */ this.scrollPos = function(scrollPosMethod) {
            if (!arguments.length) return getScrollPos.call(Controller);
            else if (_util.type.Function(scrollPosMethod)) getScrollPos = scrollPosMethod;
            else log(2, "Provided value for method 'scrollPos' is not a function. To change the current scroll position use 'scrollTo()'.");
            return Controller;
        };
        /**
		 * **Get** all infos or one in particular about the controller.
		 * @public
		 * @example
		 * // returns the current scroll position (number)
		 * var scrollPos = controller.info("scrollPos");
		 *
		 * // returns all infos as an object
		 * var infos = controller.info();
		 *
		 * @param {string} [about] - If passed only this info will be returned instead of an object containing all.  
		 							 Valid options are:
		 							 ** `"size"` => the current viewport size of the container
		 							 ** `"vertical"` => true if vertical scrolling, otherwise false
		 							 ** `"scrollPos"` => the current scroll position
		 							 ** `"scrollDirection"` => the last known direction of the scroll
		 							 ** `"container"` => the container element
		 							 ** `"isDocument"` => true if container element is the document.
		 * @returns {(mixed|object)} The requested info(s).
		 */ this.info = function(about) {
            var values = {
                size: _viewPortSize,
                vertical: _options.vertical,
                scrollPos: _scrollPos,
                scrollDirection: _scrollDirection,
                container: _options.container,
                isDocument: _isDocument
            };
            if (!arguments.length) return values;
            else if (values[about] !== undefined) return values[about];
            else {
                log(1, "ERROR: option \"" + about + "\" is not available");
                return;
            }
        };
        /**
		 * **Get** or **Set** the current loglevel option value.
		 * @public
		 *
		 * @example
		 * // get the current value
		 * var loglevel = controller.loglevel();
		 *
		 * // set a new value
		 * controller.loglevel(3);
		 *
		 * @param {number} [newLoglevel] - The new loglevel setting of the Controller. `[0-3]`
		 * @returns {(number|Controller)} Current loglevel or parent object for chaining.
		 */ this.loglevel = function(newLoglevel) {
            if (!arguments.length) return _options.loglevel;
            else if (_options.loglevel != newLoglevel) _options.loglevel = newLoglevel;
            return Controller;
        };
        /**
		 * **Get** or **Set** the current enabled state of the controller.  
		 * This can be used to disable all Scenes connected to the controller without destroying or removing them.
		 * @public
		 *
		 * @example
		 * // get the current value
		 * var enabled = controller.enabled();
		 *
		 * // disable the controller
		 * controller.enabled(false);
		 *
		 * @param {boolean} [newState] - The new enabled state of the controller `true` or `false`.
		 * @returns {(boolean|Controller)} Current enabled state or parent object for chaining.
		 */ this.enabled = function(newState) {
            if (!arguments.length) return _enabled;
            else if (_enabled != newState) {
                _enabled = !!newState;
                Controller.updateScene(_sceneObjects, true);
            }
            return Controller;
        };
        /**
		 * Destroy the Controller, all Scenes and everything.
		 * @public
		 *
		 * @example
		 * // without resetting the scenes
		 * controller = controller.destroy();
		 *
		 * // with scene reset
		 * controller = controller.destroy(true);
		 *
		 * @param {boolean} [resetScenes=false] - If `true` the pins and tweens (if existent) of all scenes will be reset.
		 * @returns {null} Null to unset handler variables.
		 */ this.destroy = function(resetScenes) {
            window.clearTimeout(_refreshTimeout);
            var i = _sceneObjects.length;
            while(i--)_sceneObjects[i].destroy(resetScenes);
            _options.container.removeEventListener("resize", onChange);
            _options.container.removeEventListener("scroll", onChange);
            _util.cAF(_updateTimeout);
            log(3, "destroyed " + NAMESPACE + " (reset: " + (resetScenes ? "true" : "false") + ")");
            return null;
        };
        // INIT
        construct();
        return Controller;
    };
    // store pagewide controller options
    var CONTROLLER_OPTIONS = {
        defaults: {
            container: window,
            vertical: true,
            globalSceneOptions: {},
            loglevel: 2,
            refreshInterval: 100
        }
    };
    /*
	 * method used to add an option to ScrollMagic Scenes.
	 */ ScrollMagic.Controller.addOption = function(name, defaultValue) {
        CONTROLLER_OPTIONS.defaults[name] = defaultValue;
    };
    // instance extension function for plugins
    ScrollMagic.Controller.extend = function(extension) {
        var oldClass = this;
        ScrollMagic.Controller = function() {
            oldClass.apply(this, arguments);
            this.$super = _util.extend({}, this); // copy parent state
            return extension.apply(this, arguments) || this;
        };
        _util.extend(ScrollMagic.Controller, oldClass); // copy properties
        ScrollMagic.Controller.prototype = oldClass.prototype; // copy prototype
        ScrollMagic.Controller.prototype.constructor = ScrollMagic.Controller; // restore constructor
    };
    /**
	 * A Scene defines where the controller should react and how.
	 *
	 * @class
	 *
	 * @example
	 * // create a standard scene and add it to a controller
	 * new ScrollMagic.Scene()
	 *		.addTo(controller);
	 *
	 * // create a scene with custom options and assign a handler to it.
	 * var scene = new ScrollMagic.Scene({
	 * 		duration: 100,
	 *		offset: 200,
	 *		triggerHook: "onEnter",
	 *		reverse: false
	 * });
	 *
	 * @param {object} [options] - Options for the Scene. The options can be updated at any time.  
	 							   Instead of setting the options for each scene individually you can also set them globally in the controller as the controllers `globalSceneOptions` option. The object accepts the same properties as the ones below.  
	 							   When a scene is added to the controller the options defined using the Scene constructor will be overwritten by those set in `globalSceneOptions`.
	 * @param {(number|string|function)} [options.duration=0] - The duration of the scene. 
	 					Please see `Scene.duration()` for details.
	 * @param {number} [options.offset=0] - Offset Value for the Trigger Position. If no triggerElement is defined this will be the scroll distance from the start of the page, after which the scene will start.
	 * @param {(string|object)} [options.triggerElement=null] - Selector or DOM object that defines the start of the scene. If undefined the scene will start right at the start of the page (unless an offset is set).
	 * @param {(number|string)} [options.triggerHook="onCenter"] - Can be a number between 0 and 1 defining the position of the trigger Hook in relation to the viewport.  
	 															  Can also be defined using a string:
	 															  ** `"onEnter"` => `1`
	 															  ** `"onCenter"` => `0.5`
	 															  ** `"onLeave"` => `0`
	 * @param {boolean} [options.reverse=true] - Should the scene reverse, when scrolling up?
	 * @param {number} [options.loglevel=2] - Loglevel for debugging. Note that logging is disabled in the minified version of ScrollMagic.
	 										  ** `0` => silent
	 										  ** `1` => errors
	 										  ** `2` => errors, warnings
	 										  ** `3` => errors, warnings, debuginfo
	 * 
	 */ ScrollMagic.Scene = function(options) {
        /*
		 * ----------------------------------------------------------------
		 * settings
		 * ----------------------------------------------------------------
		 */ var NAMESPACE = 'ScrollMagic.Scene', SCENE_STATE_BEFORE = 'BEFORE', SCENE_STATE_DURING = 'DURING', SCENE_STATE_AFTER = 'AFTER', DEFAULT_OPTIONS = SCENE_OPTIONS.defaults;
        /*
		 * ----------------------------------------------------------------
		 * private vars
		 * ----------------------------------------------------------------
		 */ var Scene = this, _options = _util.extend({}, DEFAULT_OPTIONS, options), _state = SCENE_STATE_BEFORE, _progress = 0, _scrollOffset = {
            start: 0,
            end: 0
        }, _triggerPos = 0, _enabled = true, _durationUpdateMethod, _controller;
        /**
		 * Internal constructor function of the ScrollMagic Scene
		 * @private
		 */ var construct = function construct() {
            for(var key in _options)if (!DEFAULT_OPTIONS.hasOwnProperty(key)) {
                log(2, "WARNING: Unknown option \"" + key + "\"");
                delete _options[key];
            }
            // add getters/setters for all possible options
            for(var optionName in DEFAULT_OPTIONS)addSceneOption(optionName);
            // validate all options
            validateOption();
        };
        /*
		 * ----------------------------------------------------------------
		 * Event Management
		 * ----------------------------------------------------------------
		 */ var _listeners = {};
        /**
		 * Scene start event.  
		 * Fires whenever the scroll position its the starting point of the scene.  
		 * It will also fire when scrolling back up going over the start position of the scene. If you want something to happen only when scrolling down/right, use the scrollDirection parameter passed to the callback.
		 *
		 * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
		 *
		 * @event ScrollMagic.Scene#start
		 *
		 * @example
		 * scene.on("start", function (event) {
		 * 	console.log("Hit start point of scene.");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.progress - Reflects the current progress of the scene
		 * @property {string} event.state - The current state of the scene `"BEFORE"` or `"DURING"`
		 * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
		 */ /**
		 * Scene end event.  
		 * Fires whenever the scroll position its the ending point of the scene.  
		 * It will also fire when scrolling back up from after the scene and going over its end position. If you want something to happen only when scrolling down/right, use the scrollDirection parameter passed to the callback.
		 *
		 * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
		 *
		 * @event ScrollMagic.Scene#end
		 *
		 * @example
		 * scene.on("end", function (event) {
		 * 	console.log("Hit end point of scene.");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.progress - Reflects the current progress of the scene
		 * @property {string} event.state - The current state of the scene `"DURING"` or `"AFTER"`
		 * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
		 */ /**
		 * Scene enter event.  
		 * Fires whenever the scene enters the "DURING" state.  
		 * Keep in mind that it doesn't matter if the scene plays forward or backward: This event always fires when the scene enters its active scroll timeframe, regardless of the scroll-direction.
		 *
		 * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
		 *
		 * @event ScrollMagic.Scene#enter
		 *
		 * @example
		 * scene.on("enter", function (event) {
		 * 	console.log("Scene entered.");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.progress - Reflects the current progress of the scene
		 * @property {string} event.state - The current state of the scene - always `"DURING"`
		 * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
		 */ /**
		 * Scene leave event.  
		 * Fires whenever the scene's state goes from "DURING" to either "BEFORE" or "AFTER".  
		 * Keep in mind that it doesn't matter if the scene plays forward or backward: This event always fires when the scene leaves its active scroll timeframe, regardless of the scroll-direction.
		 *
		 * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
		 *
		 * @event ScrollMagic.Scene#leave
		 *
		 * @example
		 * scene.on("leave", function (event) {
		 * 	console.log("Scene left.");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.progress - Reflects the current progress of the scene
		 * @property {string} event.state - The current state of the scene `"BEFORE"` or `"AFTER"`
		 * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
		 */ /**
		 * Scene update event.  
		 * Fires whenever the scene is updated (but not necessarily changes the progress).
		 *
		 * @event ScrollMagic.Scene#update
		 *
		 * @example
		 * scene.on("update", function (event) {
		 * 	console.log("Scene updated.");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.startPos - The starting position of the scene (in relation to the conainer)
		 * @property {number} event.endPos - The ending position of the scene (in relation to the conainer)
		 * @property {number} event.scrollPos - The current scroll position of the container
		 */ /**
		 * Scene progress event.  
		 * Fires whenever the progress of the scene changes.
		 *
		 * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
		 *
		 * @event ScrollMagic.Scene#progress
		 *
		 * @example
		 * scene.on("progress", function (event) {
		 * 	console.log("Scene progress changed to " + event.progress);
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.progress - Reflects the current progress of the scene
		 * @property {string} event.state - The current state of the scene `"BEFORE"`, `"DURING"` or `"AFTER"`
		 * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
		 */ /**
		 * Scene change event.  
		 * Fires whenvever a property of the scene is changed.
		 *
		 * @event ScrollMagic.Scene#change
		 *
		 * @example
		 * scene.on("change", function (event) {
		 * 	console.log("Scene Property \"" + event.what + "\" changed to " + event.newval);
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {string} event.what - Indicates what value has been changed
		 * @property {mixed} event.newval - The new value of the changed property
		 */ /**
		 * Scene shift event.  
		 * Fires whenvever the start or end **scroll offset** of the scene change.
		 * This happens explicitely, when one of these values change: `offset`, `duration` or `triggerHook`.
		 * It will fire implicitly when the `triggerElement` changes, if the new element has a different position (most cases).
		 * It will also fire implicitly when the size of the container changes and the triggerHook is anything other than `onLeave`.
		 *
		 * @event ScrollMagic.Scene#shift
		 * @since 1.1.0
		 *
		 * @example
		 * scene.on("shift", function (event) {
		 * 	console.log("Scene moved, because the " + event.reason + " has changed.)");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {string} event.reason - Indicates why the scene has shifted
		 */ /**
		 * Scene destroy event.  
		 * Fires whenvever the scene is destroyed.
		 * This can be used to tidy up custom behaviour used in events.
		 *
		 * @event ScrollMagic.Scene#destroy
		 * @since 1.1.0
		 *
		 * @example
		 * scene.on("enter", function (event) {
		 *        // add custom action
		 *        $("#my-elem").left("200");
		 *      })
		 *      .on("destroy", function (event) {
		 *        // reset my element to start position
		 *        if (event.reset) {
		 *          $("#my-elem").left("0");
		 *        }
		 *      });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {boolean} event.reset - Indicates if the destroy method was called with reset `true` or `false`.
		 */ /**
		 * Scene add event.  
		 * Fires when the scene is added to a controller.
		 * This is mostly used by plugins to know that change might be due.
		 *
		 * @event ScrollMagic.Scene#add
		 * @since 2.0.0
		 *
		 * @example
		 * scene.on("add", function (event) {
		 * 	console.log('Scene was added to a new controller.');
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {boolean} event.controller - The controller object the scene was added to.
		 */ /**
		 * Scene remove event.  
		 * Fires when the scene is removed from a controller.
		 * This is mostly used by plugins to know that change might be due.
		 *
		 * @event ScrollMagic.Scene#remove
		 * @since 2.0.0
		 *
		 * @example
		 * scene.on("remove", function (event) {
		 * 	console.log('Scene was removed from its controller.');
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 */ /**
		 * Add one ore more event listener.  
		 * The callback function will be fired at the respective event, and an object containing relevant data will be passed to the callback.
		 * @method ScrollMagic.Scene#on
		 *
		 * @example
		 * function callback (event) {
		 * 		console.log("Event fired! (" + event.type + ")");
		 * }
		 * // add listeners
		 * scene.on("change update progress start end enter leave", callback);
		 *
		 * @param {string} names - The name or names of the event the callback should be attached to.
		 * @param {function} callback - A function that should be executed, when the event is dispatched. An event object will be passed to the callback.
		 * @returns {Scene} Parent object for chaining.
		 */ this.on = function(names, callback) {
            if (_util.type.Function(callback)) {
                names = names.trim().split(' ');
                names.forEach(function(fullname) {
                    var nameparts = fullname.split('.'), eventname = nameparts[0], namespace = nameparts[1];
                    if (eventname != "*") {
                        if (!_listeners[eventname]) _listeners[eventname] = [];
                        _listeners[eventname].push({
                            namespace: namespace || '',
                            callback: callback
                        });
                    }
                });
            } else log(1, "ERROR when calling '.on()': Supplied callback for '" + names + "' is not a valid function!");
            return Scene;
        };
        /**
		 * Remove one or more event listener.
		 * @method ScrollMagic.Scene#off
		 *
		 * @example
		 * function callback (event) {
		 * 		console.log("Event fired! (" + event.type + ")");
		 * }
		 * // add listeners
		 * scene.on("change update", callback);
		 * // remove listeners
		 * scene.off("change update", callback);
		 *
		 * @param {string} names - The name or names of the event that should be removed.
		 * @param {function} [callback] - A specific callback function that should be removed. If none is passed all callbacks to the event listener will be removed.
		 * @returns {Scene} Parent object for chaining.
		 */ this.off = function(names, callback) {
            if (!names) {
                log(1, "ERROR: Invalid event name supplied.");
                return Scene;
            }
            names = names.trim().split(' ');
            names.forEach(function(fullname, key) {
                var nameparts = fullname.split('.'), eventname = nameparts[0], namespace = nameparts[1] || '', removeList = eventname === '*' ? Object.keys(_listeners) : [
                    eventname
                ];
                removeList.forEach(function(remove) {
                    var list = _listeners[remove] || [], i = list.length;
                    while(i--){
                        var listener = list[i];
                        if (listener && (namespace === listener.namespace || namespace === '*') && (!callback || callback == listener.callback)) list.splice(i, 1);
                    }
                    if (!list.length) delete _listeners[remove];
                });
            });
            return Scene;
        };
        /**
		 * Trigger an event.
		 * @method ScrollMagic.Scene#trigger
		 *
		 * @example
		 * this.trigger("change");
		 *
		 * @param {string} name - The name of the event that should be triggered.
		 * @param {object} [vars] - An object containing info that should be passed to the callback.
		 * @returns {Scene} Parent object for chaining.
		 */ this.trigger = function(name, vars) {
            if (name) {
                var nameparts = name.trim().split('.'), eventname = nameparts[0], namespace = nameparts[1], listeners = _listeners[eventname];
                log(3, 'event fired:', eventname, vars ? "->" : '', vars || '');
                if (listeners) listeners.forEach(function(listener, key) {
                    if (!namespace || namespace === listener.namespace) listener.callback.call(Scene, new ScrollMagic.Event(eventname, listener.namespace, Scene, vars));
                });
            } else log(1, "ERROR: Invalid event name supplied.");
            return Scene;
        };
        // set event listeners
        Scene.on("change.internal", function(e) {
            if (e.what !== "loglevel" && e.what !== "tweenChanges") {
                if (e.what === "triggerElement") updateTriggerElementPosition();
                else if (e.what === "reverse") Scene.update();
            }
        }).on("shift.internal", function(e) {
            updateScrollOffset();
            Scene.update(); // update scene to reflect new position
        });
        /**
		 * Send a debug message to the console.
		 * @private
		 * but provided publicly with _log for plugins
		 *
		 * @param {number} loglevel - The loglevel required to initiate output for the message.
		 * @param {...mixed} output - One or more variables that should be passed to the console.
		 */ var log = this._log = function log(loglevel, output) {
            if (_options.loglevel >= loglevel) {
                Array.prototype.splice.call(arguments, 1, 0, "(" + NAMESPACE + ") ->");
                _util.log.apply(window, arguments);
            }
        };
        /**
		 * Add the scene to a controller.  
		 * This is the equivalent to `Controller.addScene(scene)`.
		 * @method ScrollMagic.Scene#addTo
		 *
		 * @example
		 * // add a scene to a ScrollMagic Controller
		 * scene.addTo(controller);
		 *
		 * @param {ScrollMagic.Controller} controller - The controller to which the scene should be added.
		 * @returns {Scene} Parent object for chaining.
		 */ this.addTo = function(controller) {
            if (!(controller instanceof ScrollMagic.Controller)) log(1, "ERROR: supplied argument of 'addTo()' is not a valid ScrollMagic Controller");
            else if (_controller != controller) {
                // new controller
                if (_controller) _controller.removeScene(Scene);
                _controller = controller;
                validateOption();
                updateDuration(true);
                updateTriggerElementPosition(true);
                updateScrollOffset();
                _controller.info("container").addEventListener('resize', onContainerResize);
                controller.addScene(Scene);
                Scene.trigger("add", {
                    controller: _controller
                });
                log(3, "added " + NAMESPACE + " to controller");
                Scene.update();
            }
            return Scene;
        };
        /**
		 * **Get** or **Set** the current enabled state of the scene.  
		 * This can be used to disable this scene without removing or destroying it.
		 * @method ScrollMagic.Scene#enabled
		 *
		 * @example
		 * // get the current value
		 * var enabled = scene.enabled();
		 *
		 * // disable the scene
		 * scene.enabled(false);
		 *
		 * @param {boolean} [newState] - The new enabled state of the scene `true` or `false`.
		 * @returns {(boolean|Scene)} Current enabled state or parent object for chaining.
		 */ this.enabled = function(newState) {
            if (!arguments.length) return _enabled;
            else if (_enabled != newState) {
                _enabled = !!newState;
                Scene.update(true);
            }
            return Scene;
        };
        /**
		 * Remove the scene from the controller.  
		 * This is the equivalent to `Controller.removeScene(scene)`.
		 * The scene will not be updated anymore until you readd it to a controller.
		 * To remove the pin or the tween you need to call removeTween() or removePin() respectively.
		 * @method ScrollMagic.Scene#remove
		 * @example
		 * // remove the scene from its controller
		 * scene.remove();
		 *
		 * @returns {Scene} Parent object for chaining.
		 */ this.remove = function() {
            if (_controller) {
                _controller.info("container").removeEventListener('resize', onContainerResize);
                var tmpParent = _controller;
                _controller = undefined;
                tmpParent.removeScene(Scene);
                Scene.trigger("remove");
                log(3, "removed " + NAMESPACE + " from controller");
            }
            return Scene;
        };
        /**
		 * Destroy the scene and everything.
		 * @method ScrollMagic.Scene#destroy
		 * @example
		 * // destroy the scene without resetting the pin and tween to their initial positions
		 * scene = scene.destroy();
		 *
		 * // destroy the scene and reset the pin and tween
		 * scene = scene.destroy(true);
		 *
		 * @param {boolean} [reset=false] - If `true` the pin and tween (if existent) will be reset.
		 * @returns {null} Null to unset handler variables.
		 */ this.destroy = function(reset) {
            Scene.trigger("destroy", {
                reset: reset
            });
            Scene.remove();
            Scene.off("*.*");
            log(3, "destroyed " + NAMESPACE + " (reset: " + (reset ? "true" : "false") + ")");
            return null;
        };
        /**
		 * Updates the Scene to reflect the current state.  
		 * This is the equivalent to `Controller.updateScene(scene, immediately)`.  
		 * The update method calculates the scene's start and end position (based on the trigger element, trigger hook, duration and offset) and checks it against the current scroll position of the container.  
		 * It then updates the current scene state accordingly (or does nothing, if the state is already correct) – Pins will be set to their correct position and tweens will be updated to their correct progress.
		 * This means an update doesn't necessarily result in a progress change. The `progress` event will be fired if the progress has indeed changed between this update and the last.  
		 * _**NOTE:** This method gets called constantly whenever ScrollMagic detects a change. The only application for you is if you change something outside of the realm of ScrollMagic, like moving the trigger or changing tween parameters._
		 * @method ScrollMagic.Scene#update
		 * @example
		 * // update the scene on next tick
		 * scene.update();
		 *
		 * // update the scene immediately
		 * scene.update(true);
		 *
		 * @fires Scene.update
		 *
		 * @param {boolean} [immediately=false] - If `true` the update will be instant, if `false` it will wait until next update cycle (better performance).
		 * @returns {Scene} Parent object for chaining.
		 */ this.update = function(immediately) {
            if (_controller) {
                if (immediately) {
                    if (_controller.enabled() && _enabled) {
                        var scrollPos = _controller.info("scrollPos"), newProgress;
                        if (_options.duration > 0) newProgress = (scrollPos - _scrollOffset.start) / (_scrollOffset.end - _scrollOffset.start);
                        else newProgress = scrollPos >= _scrollOffset.start ? 1 : 0;
                        Scene.trigger("update", {
                            startPos: _scrollOffset.start,
                            endPos: _scrollOffset.end,
                            scrollPos: scrollPos
                        });
                        Scene.progress(newProgress);
                    } else if (_pin && _state === SCENE_STATE_DURING) updatePinState(true); // unpin in position
                } else _controller.updateScene(Scene, false);
            }
            return Scene;
        };
        /**
		 * Updates dynamic scene variables like the trigger element position or the duration.
		 * This method is automatically called in regular intervals from the controller. See {@link ScrollMagic.Controller} option `refreshInterval`.
		 * 
		 * You can call it to minimize lag, for example when you intentionally change the position of the triggerElement.
		 * If you don't it will simply be updated in the next refresh interval of the container, which is usually sufficient.
		 *
		 * @method ScrollMagic.Scene#refresh
		 * @since 1.1.0
		 * @example
		 * scene = new ScrollMagic.Scene({triggerElement: "#trigger"});
		 * 
		 * // change the position of the trigger
		 * $("#trigger").css("top", 500);
		 * // immediately let the scene know of this change
		 * scene.refresh();
		 *
		 * @fires {@link Scene.shift}, if the trigger element position or the duration changed
		 * @fires {@link Scene.change}, if the duration changed
		 *
		 * @returns {Scene} Parent object for chaining.
		 */ this.refresh = function() {
            updateDuration();
            updateTriggerElementPosition();
            // update trigger element position
            return Scene;
        };
        /**
		 * **Get** or **Set** the scene's progress.  
		 * Usually it shouldn't be necessary to use this as a setter, as it is set automatically by scene.update().  
		 * The order in which the events are fired depends on the duration of the scene:
		 *  1. Scenes with `duration == 0`:  
		 *  Scenes that have no duration by definition have no ending. Thus the `end` event will never be fired.  
		 *  When the trigger position of the scene is passed the events are always fired in this order:  
		 *  `enter`, `start`, `progress` when scrolling forward  
		 *  and  
		 *  `progress`, `start`, `leave` when scrolling in reverse
		 *  2. Scenes with `duration > 0`:  
		 *  Scenes with a set duration have a defined start and end point.  
		 *  When scrolling past the start position of the scene it will fire these events in this order:  
		 *  `enter`, `start`, `progress`  
		 *  When continuing to scroll and passing the end point it will fire these events:  
		 *  `progress`, `end`, `leave`  
		 *  When reversing through the end point these events are fired:  
		 *  `enter`, `end`, `progress`  
		 *  And when continuing to scroll past the start position in reverse it will fire:  
		 *  `progress`, `start`, `leave`  
		 *  In between start and end the `progress` event will be called constantly, whenever the progress changes.
		 * 
		 * In short:  
		 * `enter` events will always trigger **before** the progress update and `leave` envents will trigger **after** the progress update.  
		 * `start` and `end` will always trigger at their respective position.
		 * 
		 * Please review the event descriptions for details on the events and the event object that is passed to the callback.
		 * 
		 * @method ScrollMagic.Scene#progress
		 * @example
		 * // get the current scene progress
		 * var progress = scene.progress();
		 *
		 * // set new scene progress
		 * scene.progress(0.3);
		 *
		 * @fires {@link Scene.enter}, when used as setter
		 * @fires {@link Scene.start}, when used as setter
		 * @fires {@link Scene.progress}, when used as setter
		 * @fires {@link Scene.end}, when used as setter
		 * @fires {@link Scene.leave}, when used as setter
		 *
		 * @param {number} [progress] - The new progress value of the scene `[0-1]`.
		 * @returns {number} `get` -  Current scene progress.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ this.progress = function(progress) {
            if (!arguments.length) return _progress;
            else {
                var doUpdate = false, oldState = _state, scrollDirection = _controller ? _controller.info("scrollDirection") : 'PAUSED', reverseOrForward = _options.reverse || progress >= _progress;
                if (_options.duration === 0) {
                    // zero duration scenes
                    doUpdate = _progress != progress;
                    _progress = progress < 1 && reverseOrForward ? 0 : 1;
                    _state = _progress === 0 ? SCENE_STATE_BEFORE : SCENE_STATE_DURING;
                } else {
                    // scenes with start and end
                    if (progress < 0 && _state !== SCENE_STATE_BEFORE && reverseOrForward) {
                        // go back to initial state
                        _progress = 0;
                        _state = SCENE_STATE_BEFORE;
                        doUpdate = true;
                    } else if (progress >= 0 && progress < 1 && reverseOrForward) {
                        _progress = progress;
                        _state = SCENE_STATE_DURING;
                        doUpdate = true;
                    } else if (progress >= 1 && _state !== SCENE_STATE_AFTER) {
                        _progress = 1;
                        _state = SCENE_STATE_AFTER;
                        doUpdate = true;
                    } else if (_state === SCENE_STATE_DURING && !reverseOrForward) updatePinState(); // in case we scrolled backwards mid-scene and reverse is disabled => update the pin position, so it doesn't move back as well.
                }
                if (doUpdate) {
                    // fire events
                    var eventVars = {
                        progress: _progress,
                        state: _state,
                        scrollDirection: scrollDirection
                    }, stateChanged = _state != oldState;
                    var trigger = function trigger(eventName) {
                        Scene.trigger(eventName, eventVars);
                    };
                    if (stateChanged) {
                        if (oldState !== SCENE_STATE_DURING) {
                            trigger("enter");
                            trigger(oldState === SCENE_STATE_BEFORE ? "start" : "end");
                        }
                    }
                    trigger("progress");
                    if (stateChanged) {
                        if (_state !== SCENE_STATE_DURING) {
                            trigger(_state === SCENE_STATE_BEFORE ? "start" : "end");
                            trigger("leave");
                        }
                    }
                }
                return Scene;
            }
        };
        /**
		 * Update the start and end scrollOffset of the container.
		 * The positions reflect what the controller's scroll position will be at the start and end respectively.
		 * Is called, when:
		 *   - Scene event "change" is called with: offset, triggerHook, duration 
		 *   - scroll container event "resize" is called
		 *   - the position of the triggerElement changes
		 *   - the controller changes -> addTo()
		 * @private
		 */ var updateScrollOffset = function updateScrollOffset() {
            _scrollOffset = {
                start: _triggerPos + _options.offset
            };
            if (_controller && _options.triggerElement) // take away triggerHook portion to get relative to top
            _scrollOffset.start -= _controller.info("size") * _options.triggerHook;
            _scrollOffset.end = _scrollOffset.start + _options.duration;
        };
        /**
		 * Updates the duration if set to a dynamic function.
		 * This method is called when the scene is added to a controller and in regular intervals from the controller through scene.refresh().
		 * 
		 * @fires {@link Scene.change}, if the duration changed
		 * @fires {@link Scene.shift}, if the duration changed
		 *
		 * @param {boolean} [suppressEvents=false] - If true the shift event will be suppressed.
		 * @private
		 */ var updateDuration = function updateDuration(suppressEvents) {
            // update duration
            if (_durationUpdateMethod) {
                var varname = "duration";
                if (changeOption(varname, _durationUpdateMethod.call(Scene)) && !suppressEvents) {
                    Scene.trigger("change", {
                        what: varname,
                        newval: _options[varname]
                    });
                    Scene.trigger("shift", {
                        reason: varname
                    });
                }
            }
        };
        /**
		 * Updates the position of the triggerElement, if present.
		 * This method is called ...
		 *  - ... when the triggerElement is changed
		 *  - ... when the scene is added to a (new) controller
		 *  - ... in regular intervals from the controller through scene.refresh().
		 * 
		 * @fires {@link Scene.shift}, if the position changed
		 *
		 * @param {boolean} [suppressEvents=false] - If true the shift event will be suppressed.
		 * @private
		 */ var updateTriggerElementPosition = function updateTriggerElementPosition(suppressEvents) {
            var elementPos = 0, telem = _options.triggerElement;
            if (_controller && (telem || _triggerPos > 0)) {
                if (telem) {
                    if (telem.parentNode) {
                        var controllerInfo = _controller.info(), containerOffset = _util.get.offset(controllerInfo.container), param = controllerInfo.vertical ? "top" : "left"; // which param is of interest ?
                        // if parent is spacer, use spacer position instead so correct start position is returned for pinned elements.
                        while(telem.parentNode.hasAttribute(PIN_SPACER_ATTRIBUTE))telem = telem.parentNode;
                        var elementOffset = _util.get.offset(telem);
                        if (!controllerInfo.isDocument) containerOffset[param] -= _controller.scrollPos();
                        elementPos = elementOffset[param] - containerOffset[param];
                    } else {
                        log(2, "WARNING: triggerElement was removed from DOM and will be reset to", undefined);
                        Scene.triggerElement(undefined); // unset, so a change event is triggered
                    }
                }
                var changed = elementPos != _triggerPos;
                _triggerPos = elementPos;
                if (changed && !suppressEvents) Scene.trigger("shift", {
                    reason: "triggerElementPosition"
                });
            }
        };
        /**
		 * Trigger a shift event, when the container is resized and the triggerHook is > 1.
		 * @private
		 */ var onContainerResize = function onContainerResize(e) {
            if (_options.triggerHook > 0) Scene.trigger("shift", {
                reason: "containerResize"
            });
        };
        var _validate = _util.extend(SCENE_OPTIONS.validate, {
            // validation for duration handled internally for reference to private var _durationMethod
            duration: function duration(val) {
                if (_util.type.String(val) && val.match(/^(\.|\d)*\d+%$/)) {
                    // percentage value
                    var perc = parseFloat(val) / 100;
                    val = function val() {
                        return _controller ? _controller.info("size") * perc : 0;
                    };
                }
                if (_util.type.Function(val)) {
                    // function
                    _durationUpdateMethod = val;
                    try {
                        val = parseFloat(_durationUpdateMethod.call(Scene));
                    } catch (e) {
                        val = -1; // will cause error below
                    }
                }
                // val has to be float
                val = parseFloat(val);
                if (!_util.type.Number(val) || val < 0) {
                    if (_durationUpdateMethod) {
                        _durationUpdateMethod = undefined;
                        throw [
                            "Invalid return value of supplied function for option \"duration\":",
                            val
                        ];
                    } else throw [
                        "Invalid value for option \"duration\":",
                        val
                    ];
                }
                return val;
            }
        });
        /**
		 * Checks the validity of a specific or all options and reset to default if neccessary.
		 * @private
		 */ var validateOption = function validateOption(check) {
            check = arguments.length ? [
                check
            ] : Object.keys(_validate);
            check.forEach(function(optionName, key) {
                var value;
                if (_validate[optionName]) try {
                    value = _validate[optionName](_options[optionName]);
                } catch (e) {
                    value = DEFAULT_OPTIONS[optionName];
                    var logMSG = _util.type.String(e) ? [
                        e
                    ] : e;
                    if (_util.type.Array(logMSG)) {
                        logMSG[0] = "ERROR: " + logMSG[0];
                        logMSG.unshift(1); // loglevel 1 for error msg
                        log.apply(this, logMSG);
                    } else log(1, "ERROR: Problem executing validation callback for option '" + optionName + "':", e.message);
                } finally{
                    _options[optionName] = value;
                }
            });
        };
        /**
		 * Helper used by the setter/getters for scene options
		 * @private
		 */ var changeOption = function changeOption(varname, newval) {
            var changed = false, oldval = _options[varname];
            if (_options[varname] != newval) {
                _options[varname] = newval;
                validateOption(varname); // resets to default if necessary
                changed = oldval != _options[varname];
            }
            return changed;
        };
        // generate getters/setters for all options
        var addSceneOption = function addSceneOption(optionName) {
            if (!Scene[optionName]) Scene[optionName] = function(newVal) {
                if (!arguments.length) return _options[optionName];
                else {
                    if (optionName === "duration") _durationUpdateMethod = undefined;
                    if (changeOption(optionName, newVal)) {
                        Scene.trigger("change", {
                            what: optionName,
                            newval: _options[optionName]
                        });
                        if (SCENE_OPTIONS.shifts.indexOf(optionName) > -1) Scene.trigger("shift", {
                            reason: optionName
                        });
                    }
                }
                return Scene;
            };
        };
        /**
		 * **Get** or **Set** the duration option value.
		 *
		 * As a **setter** it accepts three types of parameters:
		 * 1. `number`: Sets the duration of the scene to exactly this amount of pixels.  
		 *   This means the scene will last for exactly this amount of pixels scrolled. Sub-Pixels are also valid.
		 *   A value of `0` means that the scene is 'open end' and no end will be triggered. Pins will never unpin and animations will play independently of scroll progress.
		 * 2. `string`: Always updates the duration relative to parent scroll container.  
		 *   For example `"100%"` will keep the duration always exactly at the inner height of the scroll container.
		 *   When scrolling vertically the width is used for reference respectively.
		 * 3. `function`: The supplied function will be called to return the scene duration.
		 *   This is useful in setups where the duration depends on other elements who might change size. By supplying a function you can return a value instead of updating potentially multiple scene durations.  
		 *   The scene can be referenced inside the callback using `this`.
		 *   _**WARNING:** This is an easy way to kill performance, as the callback will be executed every time `Scene.refresh()` is called, which happens a lot. The interval is defined by the controller (see ScrollMagic.Controller option `refreshInterval`).  
		 *   It's recomended to avoid calculations within the function and use cached variables as return values.  
		 *   This counts double if you use the same function for multiple scenes._
		 *
		 * @method ScrollMagic.Scene#duration
		 * @example
		 * // get the current duration value
		 * var duration = scene.duration();
		 *
		 * // set a new duration
		 * scene.duration(300);
		 *
		 * // set duration responsively to container size
		 * scene.duration("100%");
		 *
		 * // use a function to randomize the duration for some reason.
		 * var durationValueCache;
		 * function durationCallback () {
		 *   return durationValueCache;
		 * }
		 * function updateDuration () {
		 *   durationValueCache = Math.random() * 100;
		 * }
		 * updateDuration(); // set to initial value
		 * scene.duration(durationCallback); // set duration callback
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @fires {@link Scene.shift}, when used as setter
		 * @param {(number|string|function)} [newDuration] - The new duration setting for the scene.
		 * @returns {number} `get` -  Current scene duration.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ /**
		 * **Get** or **Set** the offset option value.
		 * @method ScrollMagic.Scene#offset
		 * @example
		 * // get the current offset
		 * var offset = scene.offset();
		 *
		 * // set a new offset
		 * scene.offset(100);
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @fires {@link Scene.shift}, when used as setter
		 * @param {number} [newOffset] - The new offset of the scene.
		 * @returns {number} `get` -  Current scene offset.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ /**
		 * **Get** or **Set** the triggerElement option value.
		 * Does **not** fire `Scene.shift`, because changing the trigger Element doesn't necessarily mean the start position changes. This will be determined in `Scene.refresh()`, which is automatically triggered.
		 * @method ScrollMagic.Scene#triggerElement
		 * @example
		 * // get the current triggerElement
		 * var triggerElement = scene.triggerElement();
		 *
		 * // set a new triggerElement using a selector
		 * scene.triggerElement("#trigger");
		 * // set a new triggerElement using a DOM object
		 * scene.triggerElement(document.getElementById("trigger"));
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @param {(string|object)} [newTriggerElement] - The new trigger element for the scene.
		 * @returns {(string|object)} `get` -  Current triggerElement.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ /**
		 * **Get** or **Set** the triggerHook option value.
		 * @method ScrollMagic.Scene#triggerHook
		 * @example
		 * // get the current triggerHook value
		 * var triggerHook = scene.triggerHook();
		 *
		 * // set a new triggerHook using a string
		 * scene.triggerHook("onLeave");
		 * // set a new triggerHook using a number
		 * scene.triggerHook(0.7);
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @fires {@link Scene.shift}, when used as setter
		 * @param {(number|string)} [newTriggerHook] - The new triggerHook of the scene. See {@link Scene} parameter description for value options.
		 * @returns {number} `get` -  Current triggerHook (ALWAYS numerical).
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ /**
		 * **Get** or **Set** the reverse option value.
		 * @method ScrollMagic.Scene#reverse
		 * @example
		 * // get the current reverse option
		 * var reverse = scene.reverse();
		 *
		 * // set new reverse option
		 * scene.reverse(false);
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @param {boolean} [newReverse] - The new reverse setting of the scene.
		 * @returns {boolean} `get` -  Current reverse option value.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ /**
		 * **Get** or **Set** the loglevel option value.
		 * @method ScrollMagic.Scene#loglevel
		 * @example
		 * // get the current loglevel
		 * var loglevel = scene.loglevel();
		 *
		 * // set new loglevel
		 * scene.loglevel(3);
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @param {number} [newLoglevel] - The new loglevel setting of the scene. `[0-3]`
		 * @returns {number} `get` -  Current loglevel.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ /**
		 * **Get** the associated controller.
		 * @method ScrollMagic.Scene#controller
		 * @example
		 * // get the controller of a scene
		 * var controller = scene.controller();
		 *
		 * @returns {ScrollMagic.Controller} Parent controller or `undefined`
		 */ this.controller = function() {
            return _controller;
        };
        /**
		 * **Get** the current state.
		 * @method ScrollMagic.Scene#state
		 * @example
		 * // get the current state
		 * var state = scene.state();
		 *
		 * @returns {string} `"BEFORE"`, `"DURING"` or `"AFTER"`
		 */ this.state = function() {
            return _state;
        };
        /**
		 * **Get** the current scroll offset for the start of the scene.  
		 * Mind, that the scrollOffset is related to the size of the container, if `triggerHook` is bigger than `0` (or `"onLeave"`).  
		 * This means, that resizing the container or changing the `triggerHook` will influence the scene's start offset.
		 * @method ScrollMagic.Scene#scrollOffset
		 * @example
		 * // get the current scroll offset for the start and end of the scene.
		 * var start = scene.scrollOffset();
		 * var end = scene.scrollOffset() + scene.duration();
		 * console.log("the scene starts at", start, "and ends at", end);
		 *
		 * @returns {number} The scroll offset (of the container) at which the scene will trigger. Y value for vertical and X value for horizontal scrolls.
		 */ this.scrollOffset = function() {
            return _scrollOffset.start;
        };
        /**
		 * **Get** the trigger position of the scene (including the value of the `offset` option).  
		 * @method ScrollMagic.Scene#triggerPosition
		 * @example
		 * // get the scene's trigger position
		 * var triggerPosition = scene.triggerPosition();
		 *
		 * @returns {number} Start position of the scene. Top position value for vertical and left position value for horizontal scrolls.
		 */ this.triggerPosition = function() {
            var pos = _options.offset; // the offset is the basis
            if (_controller) {
                // get the trigger position
                if (_options.triggerElement) // Element as trigger
                pos += _triggerPos;
                else // return the height of the triggerHook to start at the beginning
                pos += _controller.info("size") * Scene.triggerHook();
            }
            return pos;
        };
        var _pin, _pinOptions;
        Scene.on("shift.internal", function(e) {
            var durationChanged = e.reason === "duration";
            if (_state === SCENE_STATE_AFTER && durationChanged || _state === SCENE_STATE_DURING && _options.duration === 0) // if [duration changed after a scene (inside scene progress updates pin position)] or [duration is 0, we are in pin phase and some other value changed].
            updatePinState();
            if (durationChanged) updatePinDimensions();
        }).on("progress.internal", function(e) {
            updatePinState();
        }).on("add.internal", function(e) {
            updatePinDimensions();
        }).on("destroy.internal", function(e) {
            Scene.removePin(e.reset);
        });
        /**
		 * Update the pin state.
		 * @private
		 */ var updatePinState = function updatePinState(forceUnpin) {
            if (_pin && _controller) {
                var containerInfo = _controller.info(), pinTarget = _pinOptions.spacer.firstChild; // may be pin element or another spacer, if cascading pins
                if (!forceUnpin && _state === SCENE_STATE_DURING) {
                    // pinned state
                    if (_util.css(pinTarget, "position") != "fixed") {
                        // change state before updating pin spacer (position changes due to fixed collapsing might occur.)
                        _util.css(pinTarget, {
                            position: "fixed"
                        });
                        // update pin spacer
                        updatePinDimensions();
                    }
                    var fixedPos = _util.get.offset(_pinOptions.spacer, true), scrollDistance = _options.reverse || _options.duration === 0 ? containerInfo.scrollPos - _scrollOffset.start // quicker
                     : Math.round(_progress * _options.duration * 10) / 10; // if no reverse and during pin the position needs to be recalculated using the progress
                    // add scrollDistance
                    fixedPos[containerInfo.vertical ? "top" : "left"] += scrollDistance;
                    // set new values
                    _util.css(_pinOptions.spacer.firstChild, {
                        top: fixedPos.top,
                        left: fixedPos.left
                    });
                } else {
                    // unpinned state
                    var newCSS = {
                        position: _pinOptions.inFlow ? "relative" : "absolute",
                        top: 0,
                        left: 0
                    }, change = _util.css(pinTarget, "position") != newCSS.position;
                    if (!_pinOptions.pushFollowers) newCSS[containerInfo.vertical ? "top" : "left"] = _options.duration * _progress;
                    else if (_options.duration > 0) {
                        if (_state === SCENE_STATE_AFTER && parseFloat(_util.css(_pinOptions.spacer, "padding-top")) === 0) change = true; // if in after state but havent updated spacer yet (jumped past pin)
                        else if (_state === SCENE_STATE_BEFORE && parseFloat(_util.css(_pinOptions.spacer, "padding-bottom")) === 0) change = true; // jumped past fixed state upward direction
                    }
                    // set new values
                    _util.css(pinTarget, newCSS);
                    if (change) // update pin spacer if state changed
                    updatePinDimensions();
                }
            }
        };
        /**
		 * Update the pin spacer and/or element size.
		 * The size of the spacer needs to be updated whenever the duration of the scene changes, if it is to push down following elements.
		 * @private
		 */ var updatePinDimensions = function updatePinDimensions() {
            if (_pin && _controller && _pinOptions.inFlow) {
                var after = _state === SCENE_STATE_AFTER, before = _state === SCENE_STATE_BEFORE, during = _state === SCENE_STATE_DURING, vertical = _controller.info("vertical"), pinTarget = _pinOptions.spacer.firstChild, marginCollapse = _util.isMarginCollapseType(_util.css(_pinOptions.spacer, "display")), css = {};
                // set new size
                // if relsize: spacer -> pin | else: pin -> spacer
                if (_pinOptions.relSize.width || _pinOptions.relSize.autoFullWidth) {
                    if (during) _util.css(_pin, {
                        width: _util.get.width(_pinOptions.spacer)
                    });
                    else _util.css(_pin, {
                        width: "100%"
                    });
                } else {
                    // minwidth is needed for cascaded pins.
                    css["min-width"] = _util.get.width(vertical ? _pin : pinTarget, true, true);
                    css.width = during ? css["min-width"] : "auto";
                }
                if (_pinOptions.relSize.height) {
                    if (during) // the only padding the spacer should ever include is the duration (if pushFollowers = true), so we need to substract that.
                    _util.css(_pin, {
                        height: _util.get.height(_pinOptions.spacer) - (_pinOptions.pushFollowers ? _options.duration : 0)
                    });
                    else _util.css(_pin, {
                        height: "100%"
                    });
                } else {
                    // margin is only included if it's a cascaded pin to resolve an IE9 bug
                    css["min-height"] = _util.get.height(vertical ? pinTarget : _pin, true, !marginCollapse); // needed for cascading pins
                    css.height = during ? css["min-height"] : "auto";
                }
                // add space for duration if pushFollowers is true
                if (_pinOptions.pushFollowers) {
                    css["padding" + (vertical ? "Top" : "Left")] = _options.duration * _progress;
                    css["padding" + (vertical ? "Bottom" : "Right")] = _options.duration * (1 - _progress);
                }
                _util.css(_pinOptions.spacer, css);
            }
        };
        /**
		 * Updates the Pin state (in certain scenarios)
		 * If the controller container is not the document and we are mid-pin-phase scrolling or resizing the main document can result to wrong pin positions.
		 * So this function is called on resize and scroll of the document.
		 * @private
		 */ var updatePinInContainer = function updatePinInContainer() {
            if (_controller && _pin && _state === SCENE_STATE_DURING && !_controller.info("isDocument")) updatePinState();
        };
        /**
		 * Updates the Pin spacer size state (in certain scenarios)
		 * If container is resized during pin and relatively sized the size of the pin might need to be updated...
		 * So this function is called on resize of the container.
		 * @private
		 */ var updateRelativePinSpacer = function updateRelativePinSpacer() {
            if (_controller && _pin && // well, duh
            _state === SCENE_STATE_DURING && // element in pinned state?
            ((_pinOptions.relSize.width || _pinOptions.relSize.autoFullWidth) && _util.get.width(window) != _util.get.width(_pinOptions.spacer.parentNode) || _pinOptions.relSize.height && _util.get.height(window) != _util.get.height(_pinOptions.spacer.parentNode))) updatePinDimensions();
        };
        /**
		 * Is called, when the mousewhel is used while over a pinned element inside a div container.
		 * If the scene is in fixed state scroll events would be counted towards the body. This forwards the event to the scroll container.
		 * @private
		 */ var onMousewheelOverPin = function onMousewheelOverPin(e) {
            if (_controller && _pin && _state === SCENE_STATE_DURING && !_controller.info("isDocument")) {
                e.preventDefault();
                _controller._setScrollPos(_controller.info("scrollPos") - ((e.wheelDelta || e[_controller.info("vertical") ? "wheelDeltaY" : "wheelDeltaX"]) / 3 || -e.detail * 30));
            }
        };
        /**
		 * Pin an element for the duration of the scene.
		 * If the scene duration is 0 the element will only be unpinned, if the user scrolls back past the start position.  
		 * Make sure only one pin is applied to an element at the same time.
		 * An element can be pinned multiple times, but only successively.
		 * _**NOTE:** The option `pushFollowers` has no effect, when the scene duration is 0._
		 * @method ScrollMagic.Scene#setPin
		 * @example
		 * // pin element and push all following elements down by the amount of the pin duration.
		 * scene.setPin("#pin");
		 *
		 * // pin element and keeping all following elements in their place. The pinned element will move past them.
		 * scene.setPin("#pin", {pushFollowers: false});
		 *
		 * @param {(string|object)} element - A Selector targeting an element or a DOM object that is supposed to be pinned.
		 * @param {object} [settings] - settings for the pin
		 * @param {boolean} [settings.pushFollowers=true] - If `true` following elements will be "pushed" down for the duration of the pin, if `false` the pinned element will just scroll past them.  
		 												   Ignored, when duration is `0`.
		 * @param {string} [settings.spacerClass="scrollmagic-pin-spacer"] - Classname of the pin spacer element, which is used to replace the element.
		 *
		 * @returns {Scene} Parent object for chaining.
		 */ this.setPin = function(element, settings) {
            var defaultSettings = {
                pushFollowers: true,
                spacerClass: "scrollmagic-pin-spacer"
            };
            var pushFollowersActivelySet = settings && settings.hasOwnProperty('pushFollowers');
            settings = _util.extend({}, defaultSettings, settings);
            // validate Element
            element = _util.get.elements(element)[0];
            if (!element) {
                log(1, "ERROR calling method 'setPin()': Invalid pin element supplied.");
                return Scene; // cancel
            } else if (_util.css(element, "position") === "fixed") {
                log(1, "ERROR calling method 'setPin()': Pin does not work with elements that are positioned 'fixed'.");
                return Scene; // cancel
            }
            if (_pin) {
                if (_pin === element) // same pin we already have -> do nothing
                return Scene; // cancel
                else // kill old pin
                Scene.removePin();
            }
            _pin = element;
            var parentDisplay = _pin.parentNode.style.display, boundsParams = [
                "top",
                "left",
                "bottom",
                "right",
                "margin",
                "marginLeft",
                "marginRight",
                "marginTop",
                "marginBottom"
            ];
            _pin.parentNode.style.display = 'none'; // hack start to force css to return stylesheet values instead of calculated px values.
            var inFlow = _util.css(_pin, "position") != "absolute", pinCSS = _util.css(_pin, boundsParams.concat([
                "display"
            ])), sizeCSS = _util.css(_pin, [
                "width",
                "height"
            ]);
            _pin.parentNode.style.display = parentDisplay; // hack end.
            if (!inFlow && settings.pushFollowers) {
                log(2, "WARNING: If the pinned element is positioned absolutely pushFollowers will be disabled.");
                settings.pushFollowers = false;
            }
            window.setTimeout(function() {
                if (_pin && _options.duration === 0 && pushFollowersActivelySet && settings.pushFollowers) log(2, "WARNING: pushFollowers =", true, "has no effect, when scene duration is 0.");
            }, 0);
            // create spacer and insert
            var spacer = _pin.parentNode.insertBefore(document.createElement('div'), _pin), spacerCSS = _util.extend(pinCSS, {
                position: inFlow ? "relative" : "absolute",
                boxSizing: "content-box",
                mozBoxSizing: "content-box",
                webkitBoxSizing: "content-box"
            });
            if (!inFlow) _util.extend(spacerCSS, _util.css(_pin, [
                "width",
                "height"
            ]));
            _util.css(spacer, spacerCSS);
            spacer.setAttribute(PIN_SPACER_ATTRIBUTE, "");
            _util.addClass(spacer, settings.spacerClass);
            // set the pin Options
            _pinOptions = {
                spacer: spacer,
                relSize: {
                    width: sizeCSS.width.slice(-1) === "%",
                    height: sizeCSS.height.slice(-1) === "%",
                    autoFullWidth: sizeCSS.width === "auto" && inFlow && _util.isMarginCollapseType(pinCSS.display)
                },
                pushFollowers: settings.pushFollowers,
                inFlow: inFlow
            };
            if (!_pin.___origStyle) {
                _pin.___origStyle = {};
                var pinInlineCSS = _pin.style, copyStyles = boundsParams.concat([
                    "width",
                    "height",
                    "position",
                    "boxSizing",
                    "mozBoxSizing",
                    "webkitBoxSizing"
                ]);
                copyStyles.forEach(function(val) {
                    _pin.___origStyle[val] = pinInlineCSS[val] || "";
                });
            }
            // if relative size, transfer it to spacer and make pin calculate it...
            if (_pinOptions.relSize.width) _util.css(spacer, {
                width: sizeCSS.width
            });
            if (_pinOptions.relSize.height) _util.css(spacer, {
                height: sizeCSS.height
            });
            // now place the pin element inside the spacer	
            spacer.appendChild(_pin);
            // and set new css
            _util.css(_pin, {
                position: inFlow ? "relative" : "absolute",
                margin: "auto",
                top: "auto",
                left: "auto",
                bottom: "auto",
                right: "auto"
            });
            if (_pinOptions.relSize.width || _pinOptions.relSize.autoFullWidth) _util.css(_pin, {
                boxSizing: "border-box",
                mozBoxSizing: "border-box",
                webkitBoxSizing: "border-box"
            });
            // add listener to document to update pin position in case controller is not the document.
            window.addEventListener('scroll', updatePinInContainer);
            window.addEventListener('resize', updatePinInContainer);
            window.addEventListener('resize', updateRelativePinSpacer);
            // add mousewheel listener to catch scrolls over fixed elements
            _pin.addEventListener("mousewheel", onMousewheelOverPin);
            _pin.addEventListener("DOMMouseScroll", onMousewheelOverPin);
            log(3, "added pin");
            // finally update the pin to init
            updatePinState();
            return Scene;
        };
        /**
		 * Remove the pin from the scene.
		 * @method ScrollMagic.Scene#removePin
		 * @example
		 * // remove the pin from the scene without resetting it (the spacer is not removed)
		 * scene.removePin();
		 *
		 * // remove the pin from the scene and reset the pin element to its initial position (spacer is removed)
		 * scene.removePin(true);
		 *
		 * @param {boolean} [reset=false] - If `false` the spacer will not be removed and the element's position will not be reset.
		 * @returns {Scene} Parent object for chaining.
		 */ this.removePin = function(reset) {
            if (_pin) {
                if (_state === SCENE_STATE_DURING) updatePinState(true); // force unpin at position
                if (reset || !_controller) {
                    var pinTarget = _pinOptions.spacer.firstChild; // usually the pin element, but may be another spacer (cascaded pins)...
                    if (pinTarget.hasAttribute(PIN_SPACER_ATTRIBUTE)) {
                        var style = _pinOptions.spacer.style, values = [
                            "margin",
                            "marginLeft",
                            "marginRight",
                            "marginTop",
                            "marginBottom"
                        ], margins = {};
                        values.forEach(function(val) {
                            margins[val] = style[val] || "";
                        });
                        _util.css(pinTarget, margins);
                    }
                    _pinOptions.spacer.parentNode.insertBefore(pinTarget, _pinOptions.spacer);
                    _pinOptions.spacer.parentNode.removeChild(_pinOptions.spacer);
                    if (!_pin.parentNode.hasAttribute(PIN_SPACER_ATTRIBUTE)) {
                        // TODO: only correctly set for first pin (when cascading) - how to fix?
                        _util.css(_pin, _pin.___origStyle);
                        delete _pin.___origStyle;
                    }
                }
                window.removeEventListener('scroll', updatePinInContainer);
                window.removeEventListener('resize', updatePinInContainer);
                window.removeEventListener('resize', updateRelativePinSpacer);
                _pin.removeEventListener("mousewheel", onMousewheelOverPin);
                _pin.removeEventListener("DOMMouseScroll", onMousewheelOverPin);
                _pin = undefined;
                log(3, "removed pin (reset: " + (reset ? "true" : "false") + ")");
            }
            return Scene;
        };
        var _cssClasses, _cssClassElems = [];
        Scene.on("destroy.internal", function(e) {
            Scene.removeClassToggle(e.reset);
        });
        /**
		 * Define a css class modification while the scene is active.  
		 * When the scene triggers the classes will be added to the supplied element and removed, when the scene is over.
		 * If the scene duration is 0 the classes will only be removed if the user scrolls back past the start position.
		 * @method ScrollMagic.Scene#setClassToggle
		 * @example
		 * // add the class 'myclass' to the element with the id 'my-elem' for the duration of the scene
		 * scene.setClassToggle("#my-elem", "myclass");
		 *
		 * // add multiple classes to multiple elements defined by the selector '.classChange'
		 * scene.setClassToggle(".classChange", "class1 class2 class3");
		 *
		 * @param {(string|object)} element - A Selector targeting one or more elements or a DOM object that is supposed to be modified.
		 * @param {string} classes - One or more Classnames (separated by space) that should be added to the element during the scene.
		 *
		 * @returns {Scene} Parent object for chaining.
		 */ this.setClassToggle = function(element, classes) {
            var elems = _util.get.elements(element);
            if (elems.length === 0 || !_util.type.String(classes)) {
                log(1, "ERROR calling method 'setClassToggle()': Invalid " + (elems.length === 0 ? "element" : "classes") + " supplied.");
                return Scene;
            }
            if (_cssClassElems.length > 0) // remove old ones
            Scene.removeClassToggle();
            _cssClasses = classes;
            _cssClassElems = elems;
            Scene.on("enter.internal_class leave.internal_class", function(e) {
                var toggle = e.type === "enter" ? _util.addClass : _util.removeClass;
                _cssClassElems.forEach(function(elem, key) {
                    toggle(elem, _cssClasses);
                });
            });
            return Scene;
        };
        /**
		 * Remove the class binding from the scene.
		 * @method ScrollMagic.Scene#removeClassToggle
		 * @example
		 * // remove class binding from the scene without reset
		 * scene.removeClassToggle();
		 *
		 * // remove class binding and remove the changes it caused
		 * scene.removeClassToggle(true);
		 *
		 * @param {boolean} [reset=false] - If `false` and the classes are currently active, they will remain on the element. If `true` they will be removed.
		 * @returns {Scene} Parent object for chaining.
		 */ this.removeClassToggle = function(reset) {
            if (reset) _cssClassElems.forEach(function(elem, key) {
                _util.removeClass(elem, _cssClasses);
            });
            Scene.off("start.internal_class end.internal_class");
            _cssClasses = undefined;
            _cssClassElems = [];
            return Scene;
        };
        // INIT
        construct();
        return Scene;
    };
    // store pagewide scene options
    var SCENE_OPTIONS = {
        defaults: {
            duration: 0,
            offset: 0,
            triggerElement: undefined,
            triggerHook: 0.5,
            reverse: true,
            loglevel: 2
        },
        validate: {
            offset: function offset(val) {
                val = parseFloat(val);
                if (!_util.type.Number(val)) throw [
                    "Invalid value for option \"offset\":",
                    val
                ];
                return val;
            },
            triggerElement: function triggerElement(val) {
                val = val || undefined;
                if (val) {
                    var elem = _util.get.elements(val)[0];
                    if (elem && elem.parentNode) val = elem;
                    else throw [
                        "Element defined in option \"triggerElement\" was not found:",
                        val
                    ];
                }
                return val;
            },
            triggerHook: function triggerHook(val) {
                var translate = {
                    onCenter: 0.5,
                    onEnter: 1,
                    onLeave: 0
                };
                if (_util.type.Number(val)) val = Math.max(0, Math.min(parseFloat(val), 1)); //  make sure its betweeen 0 and 1
                else if (val in translate) val = translate[val];
                else throw [
                    "Invalid value for option \"triggerHook\": ",
                    val
                ];
                return val;
            },
            reverse: function reverse(val) {
                return !!val; // force boolean
            },
            loglevel: function loglevel(val) {
                val = parseInt(val);
                if (!_util.type.Number(val) || val < 0 || val > 3) throw [
                    "Invalid value for option \"loglevel\":",
                    val
                ];
                return val;
            }
        },
        shifts: [
            "duration",
            "offset",
            "triggerHook"
        ]
    };
    /*
	 * method used to add an option to ScrollMagic Scenes.
	 * TODO: DOC (private for dev)
	 */ ScrollMagic.Scene.addOption = function(name, defaultValue, validationCallback, shifts) {
        if (!(name in SCENE_OPTIONS.defaults)) {
            SCENE_OPTIONS.defaults[name] = defaultValue;
            SCENE_OPTIONS.validate[name] = validationCallback;
            if (shifts) SCENE_OPTIONS.shifts.push(name);
        } else ScrollMagic._util.log(1, "[static] ScrollMagic.Scene -> Cannot add Scene option '" + name + "', because it already exists.");
    };
    // instance extension function for plugins
    // TODO: DOC (private for dev)
    ScrollMagic.Scene.extend = function(extension) {
        var oldClass = this;
        ScrollMagic.Scene = function() {
            oldClass.apply(this, arguments);
            this.$super = _util.extend({}, this); // copy parent state
            return extension.apply(this, arguments) || this;
        };
        _util.extend(ScrollMagic.Scene, oldClass); // copy properties
        ScrollMagic.Scene.prototype = oldClass.prototype; // copy prototype
        ScrollMagic.Scene.prototype.constructor = ScrollMagic.Scene; // restore constructor
    };
    /**
	 * TODO: DOCS (private for dev)
	 * @class
	 * @private
	 */ ScrollMagic.Event = function(type, namespace, target, vars) {
        vars = vars || {};
        for(var key in vars)this[key] = vars[key];
        this.type = type;
        this.target = this.currentTarget = target;
        this.namespace = namespace || '';
        this.timeStamp = this.timestamp = Date.now();
        return this;
    };
    /*
	 * TODO: DOCS (private for dev)
	 */ var _util = ScrollMagic._util = function(window1) {
        var U = {}, i;
        /**
		 * ------------------------------
		 * internal helpers
		 * ------------------------------
		 */ // parse float and fall back to 0.
        var floatval = function floatval(number) {
            return parseFloat(number) || 0;
        };
        // get current style IE safe (otherwise IE would return calculated values for 'auto')
        var _getComputedStyle = function _getComputedStyle(elem) {
            return elem.currentStyle ? elem.currentStyle : window1.getComputedStyle(elem);
        };
        // get element dimension (width or height)
        var _dimension = function _dimension(which, elem, outer, includeMargin) {
            elem = elem === document ? window1 : elem;
            if (elem === window1) includeMargin = false;
            else if (!_type.DomElement(elem)) return 0;
            which = which.charAt(0).toUpperCase() + which.substr(1).toLowerCase();
            var dimension = (outer ? elem['offset' + which] || elem['outer' + which] : elem['client' + which] || elem['inner' + which]) || 0;
            if (outer && includeMargin) {
                var style = _getComputedStyle(elem);
                dimension += which === 'Height' ? floatval(style.marginTop) + floatval(style.marginBottom) : floatval(style.marginLeft) + floatval(style.marginRight);
            }
            return dimension;
        };
        // converts 'margin-top' into 'marginTop'
        var _camelCase = function _camelCase(str) {
            return str.replace(/^[^a-z]+([a-z])/g, '$1').replace(/-([a-z])/g, function(g) {
                return g[1].toUpperCase();
            });
        };
        /**
		 * ------------------------------
		 * external helpers
		 * ------------------------------
		 */ // extend obj – same as jQuery.extend({}, objA, objB)
        U.extend = function(obj) {
            obj = obj || {};
            for(i = 1; i < arguments.length; i++){
                if (!arguments[i]) continue;
                for(var key in arguments[i])if (arguments[i].hasOwnProperty(key)) obj[key] = arguments[i][key];
            }
            return obj;
        };
        // check if a css display type results in margin-collapse or not
        U.isMarginCollapseType = function(str) {
            return [
                "block",
                "flex",
                "list-item",
                "table",
                "-webkit-box"
            ].indexOf(str) > -1;
        };
        // implementation of requestAnimationFrame
        // based on https://gist.github.com/paulirish/1579671
        var lastTime = 0, vendors = [
            'ms',
            'moz',
            'webkit',
            'o'
        ];
        var _requestAnimationFrame = window1.requestAnimationFrame;
        var _cancelAnimationFrame = window1.cancelAnimationFrame;
        // try vendor prefixes if the above doesn't work
        for(i = 0; !_requestAnimationFrame && i < vendors.length; ++i){
            _requestAnimationFrame = window1[vendors[i] + 'RequestAnimationFrame'];
            _cancelAnimationFrame = window1[vendors[i] + 'CancelAnimationFrame'] || window1[vendors[i] + 'CancelRequestAnimationFrame'];
        }
        // fallbacks
        if (!_requestAnimationFrame) _requestAnimationFrame = function _requestAnimationFrame(callback) {
            var currTime = new Date().getTime(), timeToCall = Math.max(0, 16 - (currTime - lastTime)), id = window1.setTimeout(function() {
                callback(currTime + timeToCall);
            }, timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
        if (!_cancelAnimationFrame) _cancelAnimationFrame = function _cancelAnimationFrame(id) {
            window1.clearTimeout(id);
        };
        U.rAF = _requestAnimationFrame.bind(window1);
        U.cAF = _cancelAnimationFrame.bind(window1);
        var loglevels = [
            "error",
            "warn",
            "log"
        ], console = window1.console || {};
        console.log = console.log || function() {}; // no console log, well - do nothing then...
        // make sure methods for all levels exist.
        for(i = 0; i < loglevels.length; i++){
            var method = loglevels[i];
            if (!console[method]) console[method] = console.log; // prefer .log over nothing
        }
        U.log = function(loglevel) {
            if (loglevel > loglevels.length || loglevel <= 0) loglevel = loglevels.length;
            var now = new Date(), time = ("0" + now.getHours()).slice(-2) + ":" + ("0" + now.getMinutes()).slice(-2) + ":" + ("0" + now.getSeconds()).slice(-2) + ":" + ("00" + now.getMilliseconds()).slice(-3), method = loglevels[loglevel - 1], args = Array.prototype.splice.call(arguments, 1), func = Function.prototype.bind.call(console[method], console);
            args.unshift(time);
            func.apply(console, args);
        };
        /**
		 * ------------------------------
		 * type testing
		 * ------------------------------
		 */ var _type = U.type = function _type(v) {
            return Object.prototype.toString.call(v).replace(/^\[object (.+)\]$/, "$1").toLowerCase();
        };
        _type.String = function(v) {
            return _type(v) === 'string';
        };
        _type.Function = function(v) {
            return _type(v) === 'function';
        };
        _type.Array = function(v) {
            return Array.isArray(v);
        };
        _type.Number = function(v) {
            return !_type.Array(v) && v - parseFloat(v) + 1 >= 0;
        };
        _type.DomElement = function(o) {
            return (typeof HTMLElement === "undefined" ? "undefined" : (0, $6gBIz._)(HTMLElement)) === "object" || typeof HTMLElement === "function" ? o instanceof HTMLElement || o instanceof SVGElement : o && (typeof o === "undefined" ? "undefined" : (0, $6gBIz._)(o)) === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string";
        };
        /**
		 * ------------------------------
		 * DOM Element info
		 * ------------------------------
		 */ // always returns a list of matching DOM elements, from a selector, a DOM element or an list of elements or even an array of selectors
        var _get = U.get = {};
        _get.elements = function(selector) {
            var arr = [];
            if (_type.String(selector)) try {
                selector = document.querySelectorAll(selector);
            } catch (e) {
                return arr;
            }
            if (_type(selector) === 'nodelist' || _type.Array(selector) || selector instanceof NodeList) for(var i = 0, ref = arr.length = selector.length; i < ref; i++){
                var elem = selector[i];
                arr[i] = _type.DomElement(elem) ? elem : _get.elements(elem); // if not an element, try to resolve recursively
            }
            else if (_type.DomElement(selector) || selector === document || selector === window1) arr = [
                selector
            ]; // only the element
            return arr;
        };
        // get scroll top value
        _get.scrollTop = function(elem) {
            return elem && typeof elem.scrollTop === 'number' ? elem.scrollTop : window1.pageYOffset || 0;
        };
        // get scroll left value
        _get.scrollLeft = function(elem) {
            return elem && typeof elem.scrollLeft === 'number' ? elem.scrollLeft : window1.pageXOffset || 0;
        };
        // get element height
        _get.width = function(elem, outer, includeMargin) {
            return _dimension('width', elem, outer, includeMargin);
        };
        // get element width
        _get.height = function(elem, outer, includeMargin) {
            return _dimension('height', elem, outer, includeMargin);
        };
        // get element position (optionally relative to viewport)
        _get.offset = function(elem, relativeToViewport) {
            var offset = {
                top: 0,
                left: 0
            };
            if (elem && elem.getBoundingClientRect) {
                var rect = elem.getBoundingClientRect();
                offset.top = rect.top;
                offset.left = rect.left;
                if (!relativeToViewport) {
                    offset.top += _get.scrollTop();
                    offset.left += _get.scrollLeft();
                }
            }
            return offset;
        };
        /**
		 * ------------------------------
		 * DOM Element manipulation
		 * ------------------------------
		 */ U.addClass = function(elem, classname) {
            if (classname) {
                if (elem.classList) elem.classList.add(classname);
                else elem.className += ' ' + classname;
            }
        };
        U.removeClass = function(elem, classname) {
            if (classname) {
                if (elem.classList) elem.classList.remove(classname);
                else elem.className = elem.className.replace(new RegExp('(^|\\b)' + classname.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
            }
        };
        // if options is string -> returns css value
        // if options is array -> returns object with css value pairs
        // if options is object -> set new css values
        U.css = function(elem, options) {
            if (_type.String(options)) return _getComputedStyle(elem)[_camelCase(options)];
            else if (_type.Array(options)) {
                var obj = {}, style = _getComputedStyle(elem);
                options.forEach(function(option, key) {
                    obj[option] = style[_camelCase(option)];
                });
                return obj;
            } else for(var option in options){
                var val = options[option];
                if (val == parseFloat(val)) val += 'px';
                elem.style[_camelCase(option)] = val;
            }
        };
        return U;
    }(window || {});
    ScrollMagic.Scene.prototype.addIndicators = function() {
        ScrollMagic._util.log(1, '(ScrollMagic.Scene) -> ERROR calling addIndicators() due to missing Plugin \'debug.addIndicators\'. Please make sure to include plugins/debug.addIndicators.js');
        return this;
    };
    ScrollMagic.Scene.prototype.removeIndicators = function() {
        ScrollMagic._util.log(1, '(ScrollMagic.Scene) -> ERROR calling removeIndicators() due to missing Plugin \'debug.addIndicators\'. Please make sure to include plugins/debug.addIndicators.js');
        return this;
    };
    ScrollMagic.Scene.prototype.setTween = function() {
        ScrollMagic._util.log(1, '(ScrollMagic.Scene) -> ERROR calling setTween() due to missing Plugin \'animation.gsap\'. Please make sure to include plugins/animation.gsap.js');
        return this;
    };
    ScrollMagic.Scene.prototype.removeTween = function() {
        ScrollMagic._util.log(1, '(ScrollMagic.Scene) -> ERROR calling removeTween() due to missing Plugin \'animation.gsap\'. Please make sure to include plugins/animation.gsap.js');
        return this;
    };
    ScrollMagic.Scene.prototype.setVelocity = function() {
        ScrollMagic._util.log(1, '(ScrollMagic.Scene) -> ERROR calling setVelocity() due to missing Plugin \'animation.velocity\'. Please make sure to include plugins/animation.velocity.js');
        return this;
    };
    ScrollMagic.Scene.prototype.removeVelocity = function() {
        ScrollMagic._util.log(1, '(ScrollMagic.Scene) -> ERROR calling removeVelocity() due to missing Plugin \'animation.velocity\'. Please make sure to include plugins/animation.velocity.js');
        return this;
    };
    return ScrollMagic;
});


var $28853a1c97d272c7$exports = {};
/*!
 * @file ScrollMagic GSAP Animation Plugin.
 *
 * requires: GSAP ~1.14
 * Powered by the Greensock Animation Platform (GSAP): http://www.greensock.com/js
 * Greensock License info at http://www.greensock.com/licensing/
 */ /**
 * This plugin is meant to be used in conjunction with the Greensock Animation Plattform.
 * It offers an easy API to trigger Tweens or synchronize them to the scrollbar movement.
 *
 * Both the `lite` and the `max` versions of the GSAP library are supported.
 * The most basic requirement is `TweenLite`.
 *
 * To have access to this extension, please include `plugins/animation.gsap.js`.
 * @requires {@link http://greensock.com/gsap|GSAP ~1.14.x}
 * @mixin animation.GSAP
 */ var $28853a1c97d272c7$var$ScrollMagicPluginGsap = function ScrollMagicPluginGsap(ScrollMagic, TweenMax, Timeline) {
    var Tween = TweenMax;
    var NAMESPACE = "animation.gsap";
    // (BUILD) - REMOVE IN MINIFY - START
    var console = window.console || {}, err = Function.prototype.bind.call(console.error || console.log || function() {}, console);
    if (!ScrollMagic) err("(" + NAMESPACE + ") -> ERROR: The ScrollMagic main module could not be found. Please make sure it's loaded before this plugin or use an asynchronous loader like requirejs.");
    if (!Tween) err("(" + NAMESPACE + ") -> ERROR: TweenLite or TweenMax could not be found. Please make sure GSAP is loaded before ScrollMagic or use an asynchronous loader like requirejs.");
    // (BUILD) - REMOVE IN MINIFY - END
    /*
     * ----------------------------------------------------------------
     * Extensions for Scene
     * ----------------------------------------------------------------
     */ /**
     * Every instance of ScrollMagic.Scene now accepts an additional option.  
     * See {@link ScrollMagic.Scene} for a complete list of the standard options.
     * @memberof! animation.GSAP#
     * @method new ScrollMagic.Scene(options)
     * @example
     * var scene = new ScrollMagic.Scene({tweenChanges: true});
     *
     * @param {object} [options] - Options for the Scene. The options can be updated at any time.
     * @param {boolean} [options.tweenChanges=false] - Tweens Animation to the progress target instead of setting it.  
                                                      Does not affect animations where duration is `0`.
     */ /**
     * **Get** or **Set** the tweenChanges option value.
     * This only affects scenes with a duration. If `tweenChanges` is `true`, the progress update when scrolling will not be immediate, but instead the animation will smoothly animate to the target state.
     * For a better understanding, try enabling and disabling this option in the [Scene Manipulation Example](../examples/basic/scene_manipulation.html).
     * @memberof! animation.GSAP#
     * @method Scene.tweenChanges
     *
     * @example
     * // get the current tweenChanges option
     * var tweenChanges = scene.tweenChanges();
     *
     * // set new tweenChanges option
     * scene.tweenChanges(true);
     *
     * @fires {@link Scene.change}, when used as setter
     * @param {boolean} [newTweenChanges] - The new tweenChanges setting of the scene.
     * @returns {boolean} `get` -  Current tweenChanges option value.
     * @returns {Scene} `set` -  Parent object for chaining.
     */ // add option (TODO: DOC (private for dev))
    ScrollMagic.Scene.addOption("tweenChanges", false, function(val) {
        // validation callback
        return !!val;
    });
    // extend scene
    ScrollMagic.Scene.extend(function() {
        var Scene = this, _tween;
        // (BUILD) - REMOVE IN MINIFY - START
        var log = function log() {
            if (Scene._log) {
                // not available, when main source minified
                Array.prototype.splice.call(arguments, 1, 0, "(" + NAMESPACE + ")", "->");
                Scene._log.apply(this, arguments);
            }
        };
        // (BUILD) - REMOVE IN MINIFY - END
        // set listeners
        Scene.on("progress.plugin_gsap", function() {
            updateTweenProgress();
        });
        Scene.on("destroy.plugin_gsap", function(e) {
            Scene.removeTween(e.reset);
        });
        /**
         * Update the tween progress to current position.
         * @private
         */ var updateTweenProgress = function updateTweenProgress() {
            if (_tween) {
                var progress = Scene.progress(), state = Scene.state();
                if (_tween.repeat && _tween.repeat() === -1) {
                    // infinite loop, so not in relation to progress
                    if (state === "DURING" && _tween.paused()) _tween.play();
                    else if (state !== "DURING" && !_tween.paused()) _tween.pause();
                } else if (progress != _tween.progress()) {
                    // do we even need to update the progress?
                    // no infinite loop - so should we just play or go to a specific point in time?
                    if (Scene.duration() === 0) {
                        // play the animation
                        if (progress > 0) // play from 0 to 1
                        _tween.play();
                        else // play from 1 to 0
                        _tween.reverse();
                    } else // go to a specific point in time
                    if (Scene.tweenChanges() && _tween.tweenTo) // go smooth
                    _tween.tweenTo(progress * _tween.duration());
                    else // just hard set it
                    _tween.progress(progress).pause();
                }
            }
        };
        /**
         * Add a tween to the scene.
         * If you want to add multiple tweens, add them into a GSAP Timeline object and supply it instead (see example below).
         *
         * If the scene has a duration, the tween's duration will be projected to the scroll distance of the scene, meaning its progress will be synced to scrollbar movement.
         * For a scene with a duration of `0`, the tween will be triggered when scrolling forward past the scene's trigger position and reversed, when scrolling back.
         * To gain better understanding, check out the [Simple Tweening example](../examples/basic/simple_tweening.html).
         *
         * Instead of supplying a tween this method can also be used as a shorthand for `TweenMax.to()` (see example below).
         * @memberof! animation.GSAP#
         *
         * @example
         * // add a single tween directly
         * scene.setTween(TweenMax.to("obj"), 1, {x: 100});
         *
         * // add a single tween via variable
         * var tween = TweenMax.to("obj"), 1, {x: 100};
         * scene.setTween(tween);
         *
         * // add multiple tweens, wrapped in a timeline.
         * var timeline = new TimelineMax();
         * var tween1 = TweenMax.from("obj1", 1, {x: 100});
         * var tween2 = TweenMax.to("obj2", 1, {y: 100});
         * timeline
         *      .add(tween1)
         *      .add(tween2);
         * scene.addTween(timeline);
         *
         * // short hand to add a TweenMax.to() tween
         * scene.setTween("obj3", 0.5, {y: 100});
         *
         * // short hand to add a TweenMax.to() tween for 1 second
         * // this is useful, when the scene has a duration and the tween duration isn't important anyway
         * scene.setTween("obj3", {y: 100});
         *
         * @param {(object|string)} TweenObject - A TweenMax, TweenLite, TimelineMax or TimelineLite object that should be animated in the scene. Can also be a Dom Element or Selector, when using direct tween definition (see examples).
         * @param {(number|object)} duration - A duration for the tween, or tween parameters. If an object containing parameters are supplied, a default duration of 1 will be used.
         * @param {object} params - The parameters for the tween
         * @returns {Scene} Parent object for chaining.
         */ Scene.setTween = function(TweenObject, duration, params) {
            var newTween;
            if (arguments.length > 1) {
                if (arguments.length < 3) {
                    params = duration;
                    duration = 1;
                }
                TweenObject = Tween.to(TweenObject, duration, params);
            }
            try {
                // wrap Tween into a Timeline Object if available to include delay and repeats in the duration and standardize methods.
                if (Timeline) newTween = new Timeline({
                    smoothChildTiming: true
                }).add(TweenObject);
                else newTween = TweenObject;
                newTween.pause();
            } catch (e) {
                log(1, "ERROR calling method 'setTween()': Supplied argument is not a valid TweenObject");
                return Scene;
            }
            if (_tween) // kill old tween?
            Scene.removeTween();
            _tween = newTween;
            // some properties need to be transferred it to the wrapper, otherwise they would get lost.
            if (TweenObject.repeat && TweenObject.repeat() === -1) {
                // TweenMax or TimelineMax Object?
                _tween.repeat(-1);
                _tween.yoyo(TweenObject.yoyo());
            }
            // (BUILD) - REMOVE IN MINIFY - START
            // Some tween validations and debugging helpers
            if (Scene.tweenChanges() && !_tween.tweenTo) log(2, "WARNING: tweenChanges will only work if the TimelineMax object is available for ScrollMagic.");
            // check if there are position tweens defined for the trigger and warn about it :)
            if (_tween && Scene.controller() && Scene.triggerElement() && Scene.loglevel() >= 2) {
                // controller is needed to know scroll direction.
                var triggerTweens = Tween.getTweensOf(Scene.triggerElement()), vertical = Scene.controller().info("vertical");
                triggerTweens.forEach(function(value, index) {
                    var tweenvars = value.vars.css || value.vars, condition = vertical ? tweenvars.top !== undefined || tweenvars.bottom !== undefined : tweenvars.left !== undefined || tweenvars.right !== undefined;
                    if (condition) {
                        log(2, "WARNING: Tweening the position of the trigger element affects the scene timing and should be avoided!");
                        return false;
                    }
                });
            }
            // warn about tween overwrites, when an element is tweened multiple times
            if (parseFloat(Tween.version) >= 1.14) {
                // onOverwrite only present since GSAP v1.14.0
                var list = _tween.getChildren ? _tween.getChildren(true, true, false) : [
                    _tween
                ], newCallback = function newCallback() {
                    log(2, "WARNING: tween was overwritten by another. To learn how to avoid this issue see here: https://github.com/janpaepke/ScrollMagic/wiki/WARNING:-tween-was-overwritten-by-another");
                };
                for(var i = 0, thisTween, oldCallback; i < list.length; i++){
                    /*jshint loopfunc: true */ thisTween = list[i];
                    if (oldCallback !== newCallback) {
                        // if tweens is added more than once
                        oldCallback = thisTween.vars.onOverwrite;
                        thisTween.vars.onOverwrite = function() {
                            if (oldCallback) oldCallback.apply(this, arguments);
                            newCallback.apply(this, arguments);
                        };
                    }
                }
            }
            // (BUILD) - REMOVE IN MINIFY - END
            log(3, "added tween");
            updateTweenProgress();
            return Scene;
        };
        /**
         * Remove the tween from the scene.
         * This will terminate the control of the Scene over the tween.
         *
         * Using the reset option you can decide if the tween should remain in the current state or be rewound to set the target elements back to the state they were in before the tween was added to the scene.
         * @memberof! animation.GSAP#
         *
         * @example
         * // remove the tween from the scene without resetting it
         * scene.removeTween();
         *
         * // remove the tween from the scene and reset it to initial position
         * scene.removeTween(true);
         *
         * @param {boolean} [reset=false] - If `true` the tween will be reset to its initial values.
         * @returns {Scene} Parent object for chaining.
         */ Scene.removeTween = function(reset) {
            if (_tween) {
                if (reset) _tween.progress(0).pause();
                _tween.kill();
                _tween = undefined;
                log(3, "removed tween (reset: " + (reset ? "true" : "false") + ")");
            }
            return Scene;
        };
    });
};
$28853a1c97d272c7$exports = {
    ScrollMagicPluginGsap: $28853a1c97d272c7$var$ScrollMagicPluginGsap
};


(0, $28853a1c97d272c7$exports.ScrollMagicPluginGsap)((0, (/*@__PURE__*/$parcel$interopDefault($1badb982a685f949$exports))), (0, $ef4a4081ea69cd07$export$7b23975ad686bf91), (0, $2Aaz3.TimelineMax));
function $195ce12f58f56e1b$export$2cd8252107eb640b() {
    $195ce12f58f56e1b$var$startParallax();
}
var $195ce12f58f56e1b$var$controller = new (0, (/*@__PURE__*/$parcel$interopDefault($1badb982a685f949$exports))).Controller({
    globalSceneOptions: {
        offset: -1
    }
});
function $195ce12f58f56e1b$var$startParallax() {
    var navTrigger = document.querySelector('[data-fixnav]');
    if (document.querySelector('.nav--main') && navTrigger) new (0, (/*@__PURE__*/$parcel$interopDefault($1badb982a685f949$exports))).Scene({
        triggerElement: navTrigger,
        triggerHook: 0
    }).setClassToggle(".nav--main", "nav--fixed").addTo($195ce12f58f56e1b$var$controller);
    if (document.querySelector('.sitebadge') && navTrigger) new (0, (/*@__PURE__*/$parcel$interopDefault($1badb982a685f949$exports))).Scene({
        triggerElement: navTrigger,
        triggerHook: 0
    }).setClassToggle(".sitebadge", "sitebadge--show").addTo($195ce12f58f56e1b$var$controller).on("progress", function(event) {
        document.querySelector(".sitebadge").classList.add("sitebadge--loaded");
    });
    document.querySelectorAll('.parallax').forEach(function(element) {
        var data = element.dataset;
        var translateYIn = data.translateyIn || 0;
        var translateYOut = data.translateyOut || 0;
        var translateXIn = data.translatexIn || 0;
        var translateXOut = data.translatexOut || 0;
        var opacityIn = data.opacityIn || 1;
        var opacityOut = data.opacityOut || 1;
        var elHeight = element.clientHeight;
        var windowHeight = window.innerHeight;
        var proportion = Math.min(100 * elHeight / windowHeight, 50);
        if (elHeight < windowHeight / 3) proportion = 35;
        if (translateYOut !== 0) $195ce12f58f56e1b$var$addScene(element, 0, proportion, {
            translateY: 1
        }, {
            translateY: translateYOut
        });
        if (translateXOut !== 0) $195ce12f58f56e1b$var$addScene(element, 0, proportion, {
            translateX: 1
        }, {
            translateX: translateXOut
        });
        if (opacityOut !== 1) $195ce12f58f56e1b$var$addScene(element, 0, proportion, {
            opacity: 1
        }, {
            opacity: opacityOut
        });
        if (translateYIn !== 0) $195ce12f58f56e1b$var$addScene(element, 1, proportion, {
            translateY: translateYIn
        }, {
            translateY: 1
        });
        if (translateXIn !== 0) $195ce12f58f56e1b$var$addScene(element, 1, proportion, {
            translateX: translateXIn
        }, {
            translateX: 1
        });
        if (opacityIn !== 1) $195ce12f58f56e1b$var$addScene(element, 1, proportion, {
            opacity: opacityIn
        }, {
            opacity: 1
        });
    });
}
function $195ce12f58f56e1b$var$addScene(element, hook, duration, from, to) {
    to.ease = 'none';
    new (0, (/*@__PURE__*/$parcel$interopDefault($1badb982a685f949$exports))).Scene({
        triggerElement: element,
        triggerHook: hook,
        duration: duration + "%"
    }).setTween((0, $ef4a4081ea69cd07$export$7b23975ad686bf91).fromTo(element.children, .5, from, to)).addTo($195ce12f58f56e1b$var$controller);
}



var $7gZDx = parcelRequire("7gZDx");
function $9f1fc78e5ada3b6b$var$hasBurger() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))('.nav-burger').is(':visible');
}
(0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))(document).on('click', '.nav-secondary-item a', function(e) {
    var subnav = (0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))('.nav-secondary');
    if (subnav.length && $9f1fc78e5ada3b6b$var$hasBurger()) {
        subnav.toggleClass('nav-secondary--opened');
        if (subnav.hasClass('nav-secondary--opened')) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
    }
});
(0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))(document).on('click', function(e) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))(e.target).closest('.nav-secondary').length) (0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))('.nav-secondary').removeClass('nav-secondary--opened');
});
(0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))(document).on('click', '.nav-burger', function(e) {
    e.preventDefault();
    (0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))(this).parents('.nav').toggleClass('nav--opened');
});
(0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))(document).on('click', 'main, .nav-wrapper a[href]', function(e) {
    var subnav = (0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))(this).siblings('.nav-subitems');
    if (!subnav.length) (0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))('.nav').removeClass('nav--opened');
});
(0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))(document).on('click', '.nav-item a', function(e) {
    var subnav = (0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))(this).siblings('.nav-subitems');
    if (subnav.length && $9f1fc78e5ada3b6b$var$hasBurger()) {
        e.preventDefault();
        if (subnav.is(':visible')) {
            (0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))(this).removeClass('active');
            subnav.slideUp();
        } else {
            (0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))(this).addClass('active');
            subnav.slideDown();
        }
    }
});



var $7gZDx = parcelRequire("7gZDx");
function $a6c539edffc31aad$var$applyFilters() {
    var categoryId = (0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))('.tag[data-category-id].active').data('category-id');
    var tutorialOnly = (0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))('input[data-tutorial]').is(':checked');
    (0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))('[data-category-ids]').each(function() {
        var $element = (0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))(this);
        var matchesCategory = !categoryId || $element.data('category-ids').toString().split(', ').includes(categoryId);
        var matchesTutorial = !tutorialOnly || $element.data('has-tutorial') === 1;
        $element.toggle(matchesCategory && matchesTutorial);
    });
}
(0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))(document).on('click', '[data-category-id]', function() {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))(this).hasClass('active')) (0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))(this).removeClass('active');
    else {
        (0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))(this).siblings('.tag[data-category-id]').removeClass('active');
        (0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))(this).addClass('active');
    }
    $a6c539edffc31aad$var$applyFilters();
});
(0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))(document).on('change', 'input[data-tutorial]', $a6c539edffc31aad$var$applyFilters);
(0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))($a6c539edffc31aad$var$applyFilters);



var $9tk0W = parcelRequire("9tk0W");

var $kf9Kn = parcelRequire("kf9Kn");
document.addEventListener('DOMContentLoaded', function() {
    var currentUrl = new URL(window.location.href);
    var utmParams = (0, $kf9Kn._)(currentUrl.searchParams.entries()).filter(function(param) {
        var _param = (0, $9tk0W._)(param, 1), key = _param[0];
        return key.toLowerCase().startsWith('utm_');
    });
    var parentUrlValue = currentUrl.origin + currentUrl.pathname + currentUrl.hash;
    var isUrl = function(url) {
        if (!url) return false;
        var trimmed = String(url).trim();
        if (trimmed === '' || trimmed.startsWith('#')) return false;
        if (/^(mailto:|tel:|javascript:|sms:|data:)/i.test(trimmed)) return false;
        try {
            var linkUrl = new URL(trimmed, window.location.origin);
            return linkUrl.protocol === 'http:' || linkUrl.protocol === 'https:';
        } catch (e) {
            return false;
        }
    };
    var addUtmParams = function(url, includeParent) {
        var linkUrl = new URL(url, window.location.origin);
        utmParams.forEach(function(param) {
            var _param = (0, $9tk0W._)(param, 2), key = _param[0], value = _param[1];
            linkUrl.searchParams.set(key, value);
        });
        if (includeParent && !linkUrl.searchParams.has('parent_url')) linkUrl.searchParams.set('parent_url', parentUrlValue);
        return linkUrl.toString();
    };
    document.querySelectorAll('a[href]').forEach(function(link) {
        var href = link.getAttribute('href');
        if (isUrl(href)) link.setAttribute('href', addUtmParams(href, false));
    });
    document.querySelectorAll('iframe[src]').forEach(function(link) {
        var src = link.getAttribute('src');
        if (isUrl(src)) link.setAttribute('src', addUtmParams(src, true));
    });
});



var $6gBIz = parcelRequire("6gBIz");
/*!
 * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */ (function() {
    'use strict';
    function _typeof(obj) {
        if (typeof Symbol === "function" && (0, $6gBIz._)(Symbol.iterator) === "symbol") _typeof = function _typeof(obj) {
            return typeof obj === "undefined" ? "undefined" : (0, $6gBIz._)(obj);
        };
        else _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $6gBIz._)(obj);
        };
        return _typeof(obj);
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _objectSpread(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            var ownKeys = Object.keys(source);
            if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
            ownKeys.forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
        }
        return target;
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) {
            for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
            return arr2;
        }
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _iterableToArray(iter) {
        if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
    }
    function _iterableToArrayLimit(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"] != null) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
    var noop = function noop() {};
    var _WINDOW = {};
    var _DOCUMENT = {};
    var _MUTATION_OBSERVER = null;
    var _PERFORMANCE = {
        mark: noop,
        measure: noop
    };
    try {
        if (typeof window !== 'undefined') _WINDOW = window;
        if (typeof document !== 'undefined') _DOCUMENT = document;
        if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER = MutationObserver;
        if (typeof performance !== 'undefined') _PERFORMANCE = performance;
    } catch (e) {}
    var _ref = _WINDOW.navigator || {}, _ref$userAgent = _ref.userAgent, userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;
    var WINDOW = _WINDOW;
    var DOCUMENT = _DOCUMENT;
    var MUTATION_OBSERVER = _MUTATION_OBSERVER;
    var PERFORMANCE = _PERFORMANCE;
    var IS_BROWSER = !!WINDOW.document;
    var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
    var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');
    var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
    var UNITS_IN_GRID = 16;
    var DEFAULT_FAMILY_PREFIX = 'fa';
    var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
    var DATA_FA_I2SVG = 'data-fa-i2svg';
    var DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
    var DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
    var DATA_PREFIX = 'data-prefix';
    var DATA_ICON = 'data-icon';
    var HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
    var MUTATION_APPROACH_ASYNC = 'async';
    var TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
        'HTML',
        'HEAD',
        'STYLE',
        'SCRIPT'
    ];
    var PRODUCTION = function() {
        try {
            return true;
        } catch (e) {
            return false;
        }
    }();
    var PREFIX_TO_STYLE = {
        fas: 'solid',
        far: 'regular',
        fal: 'light',
        fad: 'duotone',
        fab: 'brands',
        fak: 'kit',
        fa: 'solid'
    };
    var STYLE_TO_PREFIX = {
        solid: 'fas',
        regular: 'far',
        light: 'fal',
        duotone: 'fad',
        brands: 'fab',
        kit: 'fak'
    };
    var LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
    var FONT_FAMILY_PATTERN = /Font Awesome ([5 ]*)(Solid|Regular|Light|Duotone|Brands|Free|Pro|Kit).*/i; // TODO: do we need to handle font-weight for kit SVG pseudo-elements?
    var FONT_WEIGHT_TO_PREFIX = {
        '900': 'fas',
        '400': 'far',
        normal: 'far',
        '300': 'fal'
    };
    var oneToTen = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10
    ];
    var oneToTwenty = oneToTen.concat([
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20
    ]);
    var ATTRIBUTES_WATCHED_FOR_MUTATION = [
        'class',
        'data-prefix',
        'data-icon',
        'data-fa-transform',
        'data-fa-mask'
    ];
    var DUOTONE_CLASSES = {
        GROUP: 'group',
        SWAP_OPACITY: 'swap-opacity',
        PRIMARY: 'primary',
        SECONDARY: 'secondary'
    };
    var RESERVED_CLASSES = [
        'xs',
        'sm',
        'lg',
        'fw',
        'ul',
        'li',
        'border',
        'pull-left',
        'pull-right',
        'spin',
        'pulse',
        'rotate-90',
        'rotate-180',
        'rotate-270',
        'flip-horizontal',
        'flip-vertical',
        'flip-both',
        'stack',
        'stack-1x',
        'stack-2x',
        'inverse',
        'layers',
        'layers-text',
        'layers-counter',
        DUOTONE_CLASSES.GROUP,
        DUOTONE_CLASSES.SWAP_OPACITY,
        DUOTONE_CLASSES.PRIMARY,
        DUOTONE_CLASSES.SECONDARY
    ].concat(oneToTen.map(function(n) {
        return "".concat(n, "x");
    })).concat(oneToTwenty.map(function(n) {
        return "w-".concat(n);
    }));
    var initial = WINDOW.FontAwesomeConfig || {};
    function getAttrConfig(attr) {
        var element = DOCUMENT.querySelector('script[' + attr + ']');
        if (element) return element.getAttribute(attr);
    }
    function coerce(val) {
        // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
        // We'll assume that this is an indication that it should be toggled to true
        // For example <script data-search-pseudo-elements src="..."></script>
        if (val === '') return true;
        if (val === 'false') return false;
        if (val === 'true') return true;
        return val;
    }
    if (DOCUMENT && typeof DOCUMENT.querySelector === 'function') {
        var attrs = [
            [
                'data-family-prefix',
                'familyPrefix'
            ],
            [
                'data-replacement-class',
                'replacementClass'
            ],
            [
                'data-auto-replace-svg',
                'autoReplaceSvg'
            ],
            [
                'data-auto-add-css',
                'autoAddCss'
            ],
            [
                'data-auto-a11y',
                'autoA11y'
            ],
            [
                'data-search-pseudo-elements',
                'searchPseudoElements'
            ],
            [
                'data-observe-mutations',
                'observeMutations'
            ],
            [
                'data-mutate-approach',
                'mutateApproach'
            ],
            [
                'data-keep-original-source',
                'keepOriginalSource'
            ],
            [
                'data-measure-performance',
                'measurePerformance'
            ],
            [
                'data-show-missing-icons',
                'showMissingIcons'
            ]
        ];
        attrs.forEach(function(_ref) {
            var _ref2 = _slicedToArray(_ref, 2), attr = _ref2[0], key = _ref2[1];
            var val = coerce(getAttrConfig(attr));
            if (val !== undefined && val !== null) initial[key] = val;
        });
    }
    var _default = {
        familyPrefix: DEFAULT_FAMILY_PREFIX,
        replacementClass: DEFAULT_REPLACEMENT_CLASS,
        autoReplaceSvg: true,
        autoAddCss: true,
        autoA11y: true,
        searchPseudoElements: false,
        observeMutations: true,
        mutateApproach: 'async',
        keepOriginalSource: true,
        measurePerformance: false,
        showMissingIcons: true
    };
    var _config = _objectSpread({}, _default, initial);
    if (!_config.autoReplaceSvg) _config.observeMutations = false;
    var config = _objectSpread({}, _config);
    WINDOW.FontAwesomeConfig = config;
    var w = WINDOW || {};
    if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
    if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
    if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
    if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
    var namespace = w[NAMESPACE_IDENTIFIER];
    var functions = [];
    var listener = function listener() {
        DOCUMENT.removeEventListener('DOMContentLoaded', listener);
        loaded = 1;
        functions.map(function(fn) {
            return fn();
        });
    };
    var loaded = false;
    if (IS_DOM) {
        loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
        if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
    }
    function domready(fn) {
        if (!IS_DOM) return;
        loaded ? setTimeout(fn, 0) : functions.push(fn);
    }
    var PENDING = 'pending';
    var SETTLED = 'settled';
    var FULFILLED = 'fulfilled';
    var REJECTED = 'rejected';
    var NOOP = function NOOP() {};
    var isNode = typeof $parcel$global !== 'undefined' && typeof $parcel$global.process !== 'undefined' && typeof $parcel$global.process.emit === 'function';
    var asyncSetTimer = typeof setImmediate === 'undefined' ? setTimeout : setImmediate;
    var asyncQueue = [];
    var asyncTimer;
    function asyncFlush() {
        // run promise callbacks
        for(var i = 0; i < asyncQueue.length; i++)asyncQueue[i][0](asyncQueue[i][1]);
         // reset async asyncQueue
        asyncQueue = [];
        asyncTimer = false;
    }
    function asyncCall(callback, arg) {
        asyncQueue.push([
            callback,
            arg
        ]);
        if (!asyncTimer) {
            asyncTimer = true;
            asyncSetTimer(asyncFlush, 0);
        }
    }
    function invokeResolver(resolver, promise) {
        function resolvePromise(value) {
            resolve(promise, value);
        }
        function rejectPromise(reason) {
            reject(promise, reason);
        }
        try {
            resolver(resolvePromise, rejectPromise);
        } catch (e) {
            rejectPromise(e);
        }
    }
    function invokeCallback(subscriber) {
        var owner = subscriber.owner;
        var settled = owner._state;
        var value = owner._data;
        var callback = subscriber[settled];
        var promise = subscriber.then;
        if (typeof callback === 'function') {
            settled = FULFILLED;
            try {
                value = callback(value);
            } catch (e) {
                reject(promise, e);
            }
        }
        if (!handleThenable(promise, value)) {
            if (settled === FULFILLED) resolve(promise, value);
            if (settled === REJECTED) reject(promise, value);
        }
    }
    function handleThenable(promise, value) {
        var resolved;
        try {
            if (promise === value) throw new TypeError('A promises callback cannot return that same promise.');
            if (value && (typeof value === 'function' || _typeof(value) === 'object')) {
                // then should be retrieved only once
                var then = value.then;
                if (typeof then === 'function') {
                    then.call(value, function(val) {
                        if (!resolved) {
                            resolved = true;
                            if (value === val) fulfill(promise, val);
                            else resolve(promise, val);
                        }
                    }, function(reason) {
                        if (!resolved) {
                            resolved = true;
                            reject(promise, reason);
                        }
                    });
                    return true;
                }
            }
        } catch (e) {
            if (!resolved) reject(promise, e);
            return true;
        }
        return false;
    }
    function resolve(promise, value) {
        if (promise === value || !handleThenable(promise, value)) fulfill(promise, value);
    }
    function fulfill(promise, value) {
        if (promise._state === PENDING) {
            promise._state = SETTLED;
            promise._data = value;
            asyncCall(publishFulfillment, promise);
        }
    }
    function reject(promise, reason) {
        if (promise._state === PENDING) {
            promise._state = SETTLED;
            promise._data = reason;
            asyncCall(publishRejection, promise);
        }
    }
    function publish(promise) {
        promise._then = promise._then.forEach(invokeCallback);
    }
    function publishFulfillment(promise) {
        promise._state = FULFILLED;
        publish(promise);
    }
    function publishRejection(promise) {
        promise._state = REJECTED;
        publish(promise);
        if (!promise._handled && isNode) $parcel$global.process.emit('unhandledRejection', promise._data, promise);
    }
    function notifyRejectionHandled(promise) {
        $parcel$global.process.emit('rejectionHandled', promise);
    }
    /**
   * @class
   */ function P(resolver) {
        if (typeof resolver !== 'function') throw new TypeError('Promise resolver ' + resolver + ' is not a function');
        if (this instanceof P === false) throw new TypeError('Failed to construct \'Promise\': Please use the \'new\' operator, this object constructor cannot be called as a function.');
        this._then = [];
        invokeResolver(resolver, this);
    }
    P.prototype = {
        constructor: P,
        _state: PENDING,
        _then: null,
        _data: undefined,
        _handled: false,
        then: function then(onFulfillment, onRejection) {
            var subscriber = {
                owner: this,
                then: new this.constructor(NOOP),
                fulfilled: onFulfillment,
                rejected: onRejection
            };
            if ((onRejection || onFulfillment) && !this._handled) {
                this._handled = true;
                if (this._state === REJECTED && isNode) asyncCall(notifyRejectionHandled, this);
            }
            if (this._state === FULFILLED || this._state === REJECTED) // already resolved, call callback async
            asyncCall(invokeCallback, subscriber);
            else // subscribe
            this._then.push(subscriber);
            return subscriber.then;
        },
        "catch": function _catch(onRejection) {
            return this.then(null, onRejection);
        }
    };
    P.all = function(promises) {
        if (!Array.isArray(promises)) throw new TypeError('You must pass an array to Promise.all().');
        return new P(function(resolve, reject) {
            var results = [];
            var remaining = 0;
            function resolver(index) {
                remaining++;
                return function(value) {
                    results[index] = value;
                    if (!--remaining) resolve(results);
                };
            }
            for(var i = 0, promise; i < promises.length; i++){
                promise = promises[i];
                if (promise && typeof promise.then === 'function') promise.then(resolver(i), reject);
                else results[i] = promise;
            }
            if (!remaining) resolve(results);
        });
    };
    P.race = function(promises) {
        if (!Array.isArray(promises)) throw new TypeError('You must pass an array to Promise.race().');
        return new P(function(resolve, reject) {
            for(var i = 0, promise; i < promises.length; i++){
                promise = promises[i];
                if (promise && typeof promise.then === 'function') promise.then(resolve, reject);
                else resolve(promise);
            }
        });
    };
    P.resolve = function(value) {
        if (value && _typeof(value) === 'object' && value.constructor === P) return value;
        return new P(function(resolve) {
            resolve(value);
        });
    };
    P.reject = function(reason) {
        return new P(function(resolve, reject) {
            reject(reason);
        });
    };
    var picked = typeof Promise === 'function' ? Promise : P;
    var d = UNITS_IN_GRID;
    var meaninglessTransform = {
        size: 16,
        x: 0,
        y: 0,
        rotate: 0,
        flipX: false,
        flipY: false
    };
    function isReserved(name) {
        return ~RESERVED_CLASSES.indexOf(name);
    }
    function bunker(fn) {
        try {
            fn();
        } catch (e) {
            if (!PRODUCTION) throw e;
        }
    }
    function insertCss(css) {
        if (!css || !IS_DOM) return;
        var style = DOCUMENT.createElement('style');
        style.setAttribute('type', 'text/css');
        style.innerHTML = css;
        var headChildren = DOCUMENT.head.childNodes;
        var beforeChild = null;
        for(var i = headChildren.length - 1; i > -1; i--){
            var child = headChildren[i];
            var tagName = (child.tagName || '').toUpperCase();
            if ([
                'STYLE',
                'LINK'
            ].indexOf(tagName) > -1) beforeChild = child;
        }
        DOCUMENT.head.insertBefore(style, beforeChild);
        return css;
    }
    var idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    function nextUniqueId() {
        var size = 12;
        var id = '';
        while(size-- > 0)id += idPool[Math.random() * 62 | 0];
        return id;
    }
    function toArray(obj) {
        var array = [];
        for(var i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
        return array;
    }
    function classArray(node) {
        if (node.classList) return toArray(node.classList);
        else return (node.getAttribute('class') || '').split(' ').filter(function(i) {
            return i;
        });
    }
    function getIconName(familyPrefix, cls) {
        var parts = cls.split('-');
        var prefix = parts[0];
        var iconName = parts.slice(1).join('-');
        if (prefix === familyPrefix && iconName !== '' && !isReserved(iconName)) return iconName;
        else return null;
    }
    function htmlEscape(str) {
        return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    function joinAttributes(attributes) {
        return Object.keys(attributes || {}).reduce(function(acc, attributeName) {
            return acc + "".concat(attributeName, "=\"").concat(htmlEscape(attributes[attributeName]), "\" ");
        }, '').trim();
    }
    function joinStyles(styles) {
        return Object.keys(styles || {}).reduce(function(acc, styleName) {
            return acc + "".concat(styleName, ": ").concat(styles[styleName], ";");
        }, '');
    }
    function transformIsMeaningful(transform) {
        return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
    }
    function transformForSvg(_ref) {
        var transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
        var outer = {
            transform: "translate(".concat(containerWidth / 2, " 256)")
        };
        var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
        var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
        var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
        var inner = {
            transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
        };
        var path = {
            transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
        };
        return {
            outer: outer,
            inner: inner,
            path: path
        };
    }
    function transformForCss(_ref2) {
        var transform = _ref2.transform, _ref2$width = _ref2.width, width = _ref2$width === void 0 ? UNITS_IN_GRID : _ref2$width, _ref2$height = _ref2.height, height = _ref2$height === void 0 ? UNITS_IN_GRID : _ref2$height, _ref2$startCentered = _ref2.startCentered, startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
        var val = '';
        if (startCentered && IS_IE) val += "translate(".concat(transform.x / d - width / 2, "em, ").concat(transform.y / d - height / 2, "em) ");
        else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / d, "em), calc(-50% + ").concat(transform.y / d, "em)) ");
        else val += "translate(".concat(transform.x / d, "em, ").concat(transform.y / d, "em) ");
        val += "scale(".concat(transform.size / d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / d * (transform.flipY ? -1 : 1), ") ");
        val += "rotate(".concat(transform.rotate, "deg) ");
        return val;
    }
    var ALL_SPACE = {
        x: 0,
        y: 0,
        width: '100%',
        height: '100%'
    };
    function fillBlack(_abstract) {
        var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        if (_abstract.attributes && (_abstract.attributes.fill || force)) _abstract.attributes.fill = 'black';
        return _abstract;
    }
    function deGroup(_abstract) {
        if (_abstract.tag === 'g') return _abstract.children;
        else return [
            _abstract
        ];
    }
    function makeIconMasking(_ref) {
        var children = _ref.children, attributes = _ref.attributes, main = _ref.main, mask = _ref.mask, explicitMaskId = _ref.maskId, transform = _ref.transform;
        var mainWidth = main.width, mainPath = main.icon;
        var maskWidth = mask.width, maskPath = mask.icon;
        var trans = transformForSvg({
            transform: transform,
            containerWidth: maskWidth,
            iconWidth: mainWidth
        });
        var maskRect = {
            tag: 'rect',
            attributes: _objectSpread({}, ALL_SPACE, {
                fill: 'white'
            })
        };
        var maskInnerGroupChildrenMixin = mainPath.children ? {
            children: mainPath.children.map(fillBlack)
        } : {};
        var maskInnerGroup = {
            tag: 'g',
            attributes: _objectSpread({}, trans.inner),
            children: [
                fillBlack(_objectSpread({
                    tag: mainPath.tag,
                    attributes: _objectSpread({}, mainPath.attributes, trans.path)
                }, maskInnerGroupChildrenMixin))
            ]
        };
        var maskOuterGroup = {
            tag: 'g',
            attributes: _objectSpread({}, trans.outer),
            children: [
                maskInnerGroup
            ]
        };
        var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
        var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
        var maskTag = {
            tag: 'mask',
            attributes: _objectSpread({}, ALL_SPACE, {
                id: maskId,
                maskUnits: 'userSpaceOnUse',
                maskContentUnits: 'userSpaceOnUse'
            }),
            children: [
                maskRect,
                maskOuterGroup
            ]
        };
        var defs = {
            tag: 'defs',
            children: [
                {
                    tag: 'clipPath',
                    attributes: {
                        id: clipId
                    },
                    children: deGroup(maskPath)
                },
                maskTag
            ]
        };
        children.push(defs, {
            tag: 'rect',
            attributes: _objectSpread({
                fill: 'currentColor',
                'clip-path': "url(#".concat(clipId, ")"),
                mask: "url(#".concat(maskId, ")")
            }, ALL_SPACE)
        });
        return {
            children: children,
            attributes: attributes
        };
    }
    function makeIconStandard(_ref) {
        var children = _ref.children, attributes = _ref.attributes, main = _ref.main, transform = _ref.transform, styles = _ref.styles;
        var styleString = joinStyles(styles);
        if (styleString.length > 0) attributes['style'] = styleString;
        if (transformIsMeaningful(transform)) {
            var trans = transformForSvg({
                transform: transform,
                containerWidth: main.width,
                iconWidth: main.width
            });
            children.push({
                tag: 'g',
                attributes: _objectSpread({}, trans.outer),
                children: [
                    {
                        tag: 'g',
                        attributes: _objectSpread({}, trans.inner),
                        children: [
                            {
                                tag: main.icon.tag,
                                children: main.icon.children,
                                attributes: _objectSpread({}, main.icon.attributes, trans.path)
                            }
                        ]
                    }
                ]
            });
        } else children.push(main.icon);
        return {
            children: children,
            attributes: attributes
        };
    }
    function asIcon(_ref) {
        var children = _ref.children, main = _ref.main, mask = _ref.mask, attributes = _ref.attributes, styles = _ref.styles, transform = _ref.transform;
        if (transformIsMeaningful(transform) && main.found && !mask.found) {
            var width = main.width, height = main.height;
            var offset = {
                x: width / height / 2,
                y: 0.5
            };
            attributes['style'] = joinStyles(_objectSpread({}, styles, {
                'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
            }));
        }
        return [
            {
                tag: 'svg',
                attributes: attributes,
                children: children
            }
        ];
    }
    function asSymbol(_ref) {
        var prefix = _ref.prefix, iconName = _ref.iconName, children = _ref.children, attributes = _ref.attributes, symbol = _ref.symbol;
        var id = symbol === true ? "".concat(prefix, "-").concat(config.familyPrefix, "-").concat(iconName) : symbol;
        return [
            {
                tag: 'svg',
                attributes: {
                    style: 'display: none;'
                },
                children: [
                    {
                        tag: 'symbol',
                        attributes: _objectSpread({}, attributes, {
                            id: id
                        }),
                        children: children
                    }
                ]
            }
        ];
    }
    function makeInlineSvgAbstract(params) {
        var _params$icons = params.icons, main = _params$icons.main, mask = _params$icons.mask, prefix = params.prefix, iconName = params.iconName, transform = params.transform, symbol = params.symbol, title = params.title, maskId = params.maskId, titleId = params.titleId, extra = params.extra, _params$watchable = params.watchable, watchable = _params$watchable === void 0 ? false : _params$watchable;
        var _ref = mask.found ? mask : main, width = _ref.width, height = _ref.height;
        var isUploadedIcon = prefix === 'fak';
        var widthClass = isUploadedIcon ? '' : "fa-w-".concat(Math.ceil(width / height * 16));
        var attrClass = [
            config.replacementClass,
            iconName ? "".concat(config.familyPrefix, "-").concat(iconName) : '',
            widthClass
        ].filter(function(c) {
            return extra.classes.indexOf(c) === -1;
        }).filter(function(c) {
            return c !== '' || !!c;
        }).concat(extra.classes).join(' ');
        var content = {
            children: [],
            attributes: _objectSpread({}, extra.attributes, {
                'data-prefix': prefix,
                'data-icon': iconName,
                'class': attrClass,
                role: extra.attributes.role || 'img',
                xmlns: 'http://www.w3.org/2000/svg',
                viewBox: "0 0 ".concat(width, " ").concat(height)
            })
        };
        var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
            width: "".concat(width / height * 1, "em")
        } : {};
        if (watchable) content.attributes[DATA_FA_I2SVG] = '';
        if (title) content.children.push({
            tag: 'title',
            attributes: {
                id: content.attributes['aria-labelledby'] || "title-".concat(titleId || nextUniqueId())
            },
            children: [
                title
            ]
        });
        var args = _objectSpread({}, content, {
            prefix: prefix,
            iconName: iconName,
            main: main,
            mask: mask,
            maskId: maskId,
            transform: transform,
            symbol: symbol,
            styles: _objectSpread({}, uploadedIconWidthStyle, extra.styles)
        });
        var _ref2 = mask.found && main.found ? makeIconMasking(args) : makeIconStandard(args), children = _ref2.children, attributes = _ref2.attributes;
        args.children = children;
        args.attributes = attributes;
        if (symbol) return asSymbol(args);
        else return asIcon(args);
    }
    function makeLayersTextAbstract(params) {
        var content = params.content, width = params.width, height = params.height, transform = params.transform, title = params.title, extra = params.extra, _params$watchable2 = params.watchable, watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
        var attributes = _objectSpread({}, extra.attributes, title ? {
            title: title
        } : {}, {
            'class': extra.classes.join(' ')
        });
        if (watchable) attributes[DATA_FA_I2SVG] = '';
        var styles = _objectSpread({}, extra.styles);
        if (transformIsMeaningful(transform)) {
            styles['transform'] = transformForCss({
                transform: transform,
                startCentered: true,
                width: width,
                height: height
            });
            styles['-webkit-transform'] = styles['transform'];
        }
        var styleString = joinStyles(styles);
        if (styleString.length > 0) attributes['style'] = styleString;
        var val = [];
        val.push({
            tag: 'span',
            attributes: attributes,
            children: [
                content
            ]
        });
        if (title) val.push({
            tag: 'span',
            attributes: {
                "class": 'sr-only'
            },
            children: [
                title
            ]
        });
        return val;
    }
    function makeLayersCounterAbstract(params) {
        var content = params.content, title = params.title, extra = params.extra;
        var attributes = _objectSpread({}, extra.attributes, title ? {
            title: title
        } : {}, {
            'class': extra.classes.join(' ')
        });
        var styleString = joinStyles(extra.styles);
        if (styleString.length > 0) attributes['style'] = styleString;
        var val = [];
        val.push({
            tag: 'span',
            attributes: attributes,
            children: [
                content
            ]
        });
        if (title) val.push({
            tag: 'span',
            attributes: {
                "class": 'sr-only'
            },
            children: [
                title
            ]
        });
        return val;
    }
    var noop$1 = function noop() {};
    var p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
        mark: noop$1,
        measure: noop$1
    };
    var preamble = "FA \"5.15.4\"";
    var begin = function begin(name) {
        p.mark("".concat(preamble, " ").concat(name, " begins"));
        return function() {
            return end(name);
        };
    };
    var end = function end(name) {
        p.mark("".concat(preamble, " ").concat(name, " ends"));
        p.measure("".concat(preamble, " ").concat(name), "".concat(preamble, " ").concat(name, " begins"), "".concat(preamble, " ").concat(name, " ends"));
    };
    var perf = {
        begin: begin,
        end: end
    };
    /**
   * Internal helper to bind a function known to have 4 arguments
   * to a given context.
   */ var bindInternal4 = function bindInternal4(func, thisContext) {
        return function(a, b, c, d) {
            return func.call(thisContext, a, b, c, d);
        };
    };
    /**
   * # Reduce
   *
   * A fast object `.reduce()` implementation.
   *
   * @param  {Object}   subject      The object to reduce over.
   * @param  {Function} fn           The reducer function.
   * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
   * @param  {Object}   thisContext  The context for the reducer.
   * @return {mixed}                 The final result.
   */ var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
        var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn, i, key, result;
        if (initialValue === undefined) {
            i = 1;
            result = subject[keys[0]];
        } else {
            i = 0;
            result = initialValue;
        }
        for(; i < length; i++){
            key = keys[i];
            result = iterator(result, subject[key], key, subject);
        }
        return result;
    };
    function toHex(unicode) {
        var result = '';
        for(var i = 0; i < unicode.length; i++){
            var hex = unicode.charCodeAt(i).toString(16);
            result += ('000' + hex).slice(-4);
        }
        return result;
    }
    function defineIcons(prefix, icons) {
        var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
        var normalized = Object.keys(icons).reduce(function(acc, iconName) {
            var icon = icons[iconName];
            var expanded = !!icon.icon;
            if (expanded) acc[icon.iconName] = icon.icon;
            else acc[iconName] = icon;
            return acc;
        }, {});
        if (typeof namespace.hooks.addPack === 'function' && !skipHooks) namespace.hooks.addPack(prefix, normalized);
        else namespace.styles[prefix] = _objectSpread({}, namespace.styles[prefix] || {}, normalized);
        /**
     * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
     * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
     * for `fas` so we'll easy the upgrade process for our users by automatically defining
     * this as well.
     */ if (prefix === 'fas') defineIcons('fa', icons);
    }
    var styles = namespace.styles, shims = namespace.shims;
    var _byUnicode = {};
    var _byLigature = {};
    var _byOldName = {};
    var build = function build() {
        var lookup = function lookup(reducer) {
            return reduce(styles, function(o, style, prefix) {
                o[prefix] = reduce(style, reducer, {});
                return o;
            }, {});
        };
        _byUnicode = lookup(function(acc, icon, iconName) {
            if (icon[3]) acc[icon[3]] = iconName;
            return acc;
        });
        _byLigature = lookup(function(acc, icon, iconName) {
            var ligatures = icon[2];
            acc[iconName] = iconName;
            ligatures.forEach(function(ligature) {
                acc[ligature] = iconName;
            });
            return acc;
        });
        var hasRegular = 'far' in styles;
        _byOldName = reduce(shims, function(acc, shim) {
            var oldName = shim[0];
            var prefix = shim[1];
            var iconName = shim[2];
            if (prefix === 'far' && !hasRegular) prefix = 'fas';
            acc[oldName] = {
                prefix: prefix,
                iconName: iconName
            };
            return acc;
        }, {});
    };
    build();
    function byUnicode(prefix, unicode) {
        return (_byUnicode[prefix] || {})[unicode];
    }
    function byLigature(prefix, ligature) {
        return (_byLigature[prefix] || {})[ligature];
    }
    function byOldName(name) {
        return _byOldName[name] || {
            prefix: null,
            iconName: null
        };
    }
    var styles$1 = namespace.styles;
    var emptyCanonicalIcon = function emptyCanonicalIcon() {
        return {
            prefix: null,
            iconName: null,
            rest: []
        };
    };
    function getCanonicalIcon(values) {
        return values.reduce(function(acc, cls) {
            var iconName = getIconName(config.familyPrefix, cls);
            if (styles$1[cls]) acc.prefix = cls;
            else if (config.autoFetchSvg && Object.keys(PREFIX_TO_STYLE).indexOf(cls) > -1) acc.prefix = cls;
            else if (iconName) {
                var shim = acc.prefix === 'fa' ? byOldName(iconName) : {};
                acc.iconName = shim.iconName || iconName;
                acc.prefix = shim.prefix || acc.prefix;
            } else if (cls !== config.replacementClass && cls.indexOf('fa-w-') !== 0) acc.rest.push(cls);
            return acc;
        }, emptyCanonicalIcon());
    }
    function iconFromMapping(mapping, prefix, iconName) {
        if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
            prefix: prefix,
            iconName: iconName,
            icon: mapping[prefix][iconName]
        };
    }
    function toHtml(abstractNodes) {
        var tag = abstractNodes.tag, _abstractNodes$attrib = abstractNodes.attributes, attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib, _abstractNodes$childr = abstractNodes.children, children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
        if (typeof abstractNodes === 'string') return htmlEscape(abstractNodes);
        else return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(''), "</").concat(tag, ">");
    }
    var noop$2 = function noop() {};
    function isWatched(node) {
        var i2svg = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;
        return typeof i2svg === 'string';
    }
    function getMutator() {
        if (config.autoReplaceSvg === true) return mutators.replace;
        var mutator = mutators[config.autoReplaceSvg];
        return mutator || mutators.replace;
    }
    var mutators = {
        replace: function replace(mutation) {
            var node = mutation[0];
            var _abstract = mutation[1];
            var newOuterHTML = _abstract.map(function(a) {
                return toHtml(a);
            }).join('\n');
            if (node.parentNode && node.outerHTML) node.outerHTML = newOuterHTML + (config.keepOriginalSource && node.tagName.toLowerCase() !== 'svg' ? "<!-- ".concat(node.outerHTML, " Font Awesome fontawesome.com -->") : '');
            else if (node.parentNode) {
                var newNode = document.createElement('span');
                node.parentNode.replaceChild(newNode, node);
                newNode.outerHTML = newOuterHTML;
            }
        },
        nest: function nest(mutation) {
            var node = mutation[0];
            var _abstract = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
            // Short-circuit to the standard replacement
            if (~classArray(node).indexOf(config.replacementClass)) return mutators.replace(mutation);
            var forSvg = new RegExp("".concat(config.familyPrefix, "-.*"));
            delete _abstract[0].attributes.style;
            delete _abstract[0].attributes.id;
            var splitClasses = _abstract[0].attributes["class"].split(' ').reduce(function(acc, cls) {
                if (cls === config.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
                else acc.toNode.push(cls);
                return acc;
            }, {
                toNode: [],
                toSvg: []
            });
            _abstract[0].attributes["class"] = splitClasses.toSvg.join(' ');
            var newInnerHTML = _abstract.map(function(a) {
                return toHtml(a);
            }).join('\n');
            node.setAttribute('class', splitClasses.toNode.join(' '));
            node.setAttribute(DATA_FA_I2SVG, '');
            node.innerHTML = newInnerHTML;
        }
    };
    function performOperationSync(op) {
        op();
    }
    function perform(mutations, callback) {
        var callbackFunction = typeof callback === 'function' ? callback : noop$2;
        if (mutations.length === 0) callbackFunction();
        else {
            var frame = performOperationSync;
            if (config.mutateApproach === MUTATION_APPROACH_ASYNC) frame = WINDOW.requestAnimationFrame || performOperationSync;
            frame(function() {
                var mutator = getMutator();
                var mark = perf.begin('mutate');
                mutations.map(mutator);
                mark();
                callbackFunction();
            });
        }
    }
    var disabled = false;
    function disableObservation() {
        disabled = true;
    }
    function enableObservation() {
        disabled = false;
    }
    var mo = null;
    function observe(options) {
        if (!MUTATION_OBSERVER) return;
        if (!config.observeMutations) return;
        var treeCallback = options.treeCallback, nodeCallback = options.nodeCallback, pseudoElementsCallback = options.pseudoElementsCallback, _options$observeMutat = options.observeMutationsRoot, observeMutationsRoot = _options$observeMutat === void 0 ? DOCUMENT : _options$observeMutat;
        mo = new MUTATION_OBSERVER(function(objects) {
            if (disabled) return;
            toArray(objects).forEach(function(mutationRecord) {
                if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
                    if (config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                    treeCallback(mutationRecord.target);
                }
                if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target.parentNode);
                if (mutationRecord.type === 'attributes' && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                    if (mutationRecord.attributeName === 'class') {
                        var _getCanonicalIcon = getCanonicalIcon(classArray(mutationRecord.target)), prefix = _getCanonicalIcon.prefix, iconName = _getCanonicalIcon.iconName;
                        if (prefix) mutationRecord.target.setAttribute('data-prefix', prefix);
                        if (iconName) mutationRecord.target.setAttribute('data-icon', iconName);
                    } else nodeCallback(mutationRecord.target);
                }
            });
        });
        if (!IS_DOM) return;
        mo.observe(observeMutationsRoot, {
            childList: true,
            attributes: true,
            characterData: true,
            subtree: true
        });
    }
    function disconnect() {
        if (!mo) return;
        mo.disconnect();
    }
    function styleParser(node) {
        var style = node.getAttribute('style');
        var val = [];
        if (style) val = style.split(';').reduce(function(acc, style) {
            var styles = style.split(':');
            var prop = styles[0];
            var value = styles.slice(1);
            if (prop && value.length > 0) acc[prop] = value.join(':').trim();
            return acc;
        }, {});
        return val;
    }
    function classParser(node) {
        var existingPrefix = node.getAttribute('data-prefix');
        var existingIconName = node.getAttribute('data-icon');
        var innerText = node.innerText !== undefined ? node.innerText.trim() : '';
        var val = getCanonicalIcon(classArray(node));
        if (existingPrefix && existingIconName) {
            val.prefix = existingPrefix;
            val.iconName = existingIconName;
        }
        if (val.prefix && innerText.length > 1) val.iconName = byLigature(val.prefix, node.innerText);
        else if (val.prefix && innerText.length === 1) val.iconName = byUnicode(val.prefix, toHex(node.innerText));
        return val;
    }
    var parseTransformString = function parseTransformString(transformString) {
        var transform = {
            size: 16,
            x: 0,
            y: 0,
            flipX: false,
            flipY: false,
            rotate: 0
        };
        if (!transformString) return transform;
        else return transformString.toLowerCase().split(' ').reduce(function(acc, n) {
            var parts = n.toLowerCase().split('-');
            var first = parts[0];
            var rest = parts.slice(1).join('-');
            if (first && rest === 'h') {
                acc.flipX = true;
                return acc;
            }
            if (first && rest === 'v') {
                acc.flipY = true;
                return acc;
            }
            rest = parseFloat(rest);
            if (isNaN(rest)) return acc;
            switch(first){
                case 'grow':
                    acc.size = acc.size + rest;
                    break;
                case 'shrink':
                    acc.size = acc.size - rest;
                    break;
                case 'left':
                    acc.x = acc.x - rest;
                    break;
                case 'right':
                    acc.x = acc.x + rest;
                    break;
                case 'up':
                    acc.y = acc.y - rest;
                    break;
                case 'down':
                    acc.y = acc.y + rest;
                    break;
                case 'rotate':
                    acc.rotate = acc.rotate + rest;
                    break;
            }
            return acc;
        }, transform);
    };
    function transformParser(node) {
        return parseTransformString(node.getAttribute('data-fa-transform'));
    }
    function symbolParser(node) {
        var symbol = node.getAttribute('data-fa-symbol');
        return symbol === null ? false : symbol === '' ? true : symbol;
    }
    function attributesParser(node) {
        var extraAttributes = toArray(node.attributes).reduce(function(acc, attr) {
            if (acc.name !== 'class' && acc.name !== 'style') acc[attr.name] = attr.value;
            return acc;
        }, {});
        var title = node.getAttribute('title');
        var titleId = node.getAttribute('data-fa-title-id');
        if (config.autoA11y) {
            if (title) extraAttributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
            else {
                extraAttributes['aria-hidden'] = 'true';
                extraAttributes['focusable'] = 'false';
            }
        }
        return extraAttributes;
    }
    function maskParser(node) {
        var mask = node.getAttribute('data-fa-mask');
        if (!mask) return emptyCanonicalIcon();
        else return getCanonicalIcon(mask.split(' ').map(function(i) {
            return i.trim();
        }));
    }
    function blankMeta() {
        return {
            iconName: null,
            title: null,
            titleId: null,
            prefix: null,
            transform: meaninglessTransform,
            symbol: false,
            mask: null,
            maskId: null,
            extra: {
                classes: [],
                styles: {},
                attributes: {}
            }
        };
    }
    function parseMeta(node) {
        var _classParser = classParser(node), iconName = _classParser.iconName, prefix = _classParser.prefix, extraClasses = _classParser.rest;
        var extraStyles = styleParser(node);
        var transform = transformParser(node);
        var symbol = symbolParser(node);
        var extraAttributes = attributesParser(node);
        var mask = maskParser(node);
        return {
            iconName: iconName,
            title: node.getAttribute('title'),
            titleId: node.getAttribute('data-fa-title-id'),
            prefix: prefix,
            transform: transform,
            symbol: symbol,
            mask: mask,
            maskId: node.getAttribute('data-fa-mask-id'),
            extra: {
                classes: extraClasses,
                styles: extraStyles,
                attributes: extraAttributes
            }
        };
    }
    function MissingIcon(error) {
        this.name = 'MissingIcon';
        this.message = error || 'Icon unavailable';
        this.stack = new Error().stack;
    }
    MissingIcon.prototype = Object.create(Error.prototype);
    MissingIcon.prototype.constructor = MissingIcon;
    var FILL = {
        fill: 'currentColor'
    };
    var ANIMATION_BASE = {
        attributeType: 'XML',
        repeatCount: 'indefinite',
        dur: '2s'
    };
    var RING = {
        tag: 'path',
        attributes: _objectSpread({}, FILL, {
            d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
        })
    };
    var OPACITY_ANIMATE = _objectSpread({}, ANIMATION_BASE, {
        attributeName: 'opacity'
    });
    var DOT = {
        tag: 'circle',
        attributes: _objectSpread({}, FILL, {
            cx: '256',
            cy: '364',
            r: '28'
        }),
        children: [
            {
                tag: 'animate',
                attributes: _objectSpread({}, ANIMATION_BASE, {
                    attributeName: 'r',
                    values: '28;14;28;28;14;28;'
                })
            },
            {
                tag: 'animate',
                attributes: _objectSpread({}, OPACITY_ANIMATE, {
                    values: '1;0;1;1;0;1;'
                })
            }
        ]
    };
    var QUESTION = {
        tag: 'path',
        attributes: _objectSpread({}, FILL, {
            opacity: '1',
            d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
        }),
        children: [
            {
                tag: 'animate',
                attributes: _objectSpread({}, OPACITY_ANIMATE, {
                    values: '1;0;0;0;0;1;'
                })
            }
        ]
    };
    var EXCLAMATION = {
        tag: 'path',
        attributes: _objectSpread({}, FILL, {
            opacity: '0',
            d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
        }),
        children: [
            {
                tag: 'animate',
                attributes: _objectSpread({}, OPACITY_ANIMATE, {
                    values: '0;0;1;1;0;0;'
                })
            }
        ]
    };
    var missing = {
        tag: 'g',
        children: [
            RING,
            DOT,
            QUESTION,
            EXCLAMATION
        ]
    };
    var styles$2 = namespace.styles;
    function asFoundIcon(icon) {
        var width = icon[0];
        var height = icon[1];
        var _icon$slice = icon.slice(4), _icon$slice2 = _slicedToArray(_icon$slice, 1), vectorData = _icon$slice2[0];
        var element = null;
        if (Array.isArray(vectorData)) element = {
            tag: 'g',
            attributes: {
                "class": "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
            },
            children: [
                {
                    tag: 'path',
                    attributes: {
                        "class": "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
                        fill: 'currentColor',
                        d: vectorData[0]
                    }
                },
                {
                    tag: 'path',
                    attributes: {
                        "class": "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
                        fill: 'currentColor',
                        d: vectorData[1]
                    }
                }
            ]
        };
        else element = {
            tag: 'path',
            attributes: {
                fill: 'currentColor',
                d: vectorData
            }
        };
        return {
            found: true,
            width: width,
            height: height,
            icon: element
        };
    }
    function findIcon(iconName, prefix) {
        return new picked(function(resolve, reject) {
            var val = {
                found: false,
                width: 512,
                height: 512,
                icon: missing
            };
            if (iconName && prefix && styles$2[prefix] && styles$2[prefix][iconName]) {
                var icon = styles$2[prefix][iconName];
                return resolve(asFoundIcon(icon));
            }
            if (iconName && prefix && !config.showMissingIcons) reject(new MissingIcon("Icon is missing for prefix ".concat(prefix, " with icon name ").concat(iconName)));
            else resolve(val);
        });
    }
    var styles$3 = namespace.styles;
    function generateSvgReplacementMutation(node, nodeMeta) {
        var iconName = nodeMeta.iconName, title = nodeMeta.title, titleId = nodeMeta.titleId, prefix = nodeMeta.prefix, transform = nodeMeta.transform, symbol = nodeMeta.symbol, mask = nodeMeta.mask, maskId = nodeMeta.maskId, extra = nodeMeta.extra;
        return new picked(function(resolve, reject) {
            picked.all([
                findIcon(iconName, prefix),
                findIcon(mask.iconName, mask.prefix)
            ]).then(function(_ref) {
                var _ref2 = _slicedToArray(_ref, 2), main = _ref2[0], mask = _ref2[1];
                resolve([
                    node,
                    makeInlineSvgAbstract({
                        icons: {
                            main: main,
                            mask: mask
                        },
                        prefix: prefix,
                        iconName: iconName,
                        transform: transform,
                        symbol: symbol,
                        mask: mask,
                        maskId: maskId,
                        title: title,
                        titleId: titleId,
                        extra: extra,
                        watchable: true
                    })
                ]);
            });
        });
    }
    function generateLayersText(node, nodeMeta) {
        var title = nodeMeta.title, transform = nodeMeta.transform, extra = nodeMeta.extra;
        var width = null;
        var height = null;
        if (IS_IE) {
            var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
            var boundingClientRect = node.getBoundingClientRect();
            width = boundingClientRect.width / computedFontSize;
            height = boundingClientRect.height / computedFontSize;
        }
        if (config.autoA11y && !title) extra.attributes['aria-hidden'] = 'true';
        return picked.resolve([
            node,
            makeLayersTextAbstract({
                content: node.innerHTML,
                width: width,
                height: height,
                transform: transform,
                title: title,
                extra: extra,
                watchable: true
            })
        ]);
    }
    function generateMutation(node) {
        var nodeMeta = parseMeta(node);
        if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) return generateLayersText(node, nodeMeta);
        else return generateSvgReplacementMutation(node, nodeMeta);
    }
    function onTree(root) {
        var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        if (!IS_DOM) return;
        var htmlClassList = DOCUMENT.documentElement.classList;
        var hclAdd = function hclAdd(suffix) {
            return htmlClassList.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
        };
        var hclRemove = function hclRemove(suffix) {
            return htmlClassList.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
        };
        var prefixes = config.autoFetchSvg ? Object.keys(PREFIX_TO_STYLE) : Object.keys(styles$3);
        var prefixesDomQuery = [
            ".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")
        ].concat(prefixes.map(function(p) {
            return ".".concat(p, ":not([").concat(DATA_FA_I2SVG, "])");
        })).join(', ');
        if (prefixesDomQuery.length === 0) return;
        var candidates = [];
        try {
            candidates = toArray(root.querySelectorAll(prefixesDomQuery));
        } catch (e) {}
        if (candidates.length > 0) {
            hclAdd('pending');
            hclRemove('complete');
        } else return;
        var mark = perf.begin('onTree');
        var mutations = candidates.reduce(function(acc, node) {
            try {
                var mutation = generateMutation(node);
                if (mutation) acc.push(mutation);
            } catch (e) {
                if (!PRODUCTION) {
                    if (e instanceof MissingIcon) console.error(e);
                }
            }
            return acc;
        }, []);
        return new picked(function(resolve, reject) {
            picked.all(mutations).then(function(resolvedMutations) {
                perform(resolvedMutations, function() {
                    hclAdd('active');
                    hclAdd('complete');
                    hclRemove('pending');
                    if (typeof callback === 'function') callback();
                    mark();
                    resolve();
                });
            })["catch"](function() {
                mark();
                reject();
            });
        });
    }
    function onNode(node) {
        var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        generateMutation(node).then(function(mutation) {
            if (mutation) perform([
                mutation
            ], callback);
        });
    }
    function replaceForPosition(node, position) {
        var pendingAttribute = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
        return new picked(function(resolve, reject) {
            if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
            return resolve();
            var children = toArray(node.children);
            var alreadyProcessedPseudoElement = children.filter(function(c) {
                return c.getAttribute(DATA_FA_PSEUDO_ELEMENT) === position;
            })[0];
            var styles = WINDOW.getComputedStyle(node, position);
            var fontFamily = styles.getPropertyValue('font-family').match(FONT_FAMILY_PATTERN);
            var fontWeight = styles.getPropertyValue('font-weight');
            var content = styles.getPropertyValue('content');
            if (alreadyProcessedPseudoElement && !fontFamily) {
                // If we've already processed it but the current computed style does not result in a font-family,
                // that probably means that a class name that was previously present to make the icon has been
                // removed. So we now should delete the icon.
                node.removeChild(alreadyProcessedPseudoElement);
                return resolve();
            } else if (fontFamily && content !== 'none' && content !== '') {
                var _content = styles.getPropertyValue('content');
                var prefix = ~[
                    'Solid',
                    'Regular',
                    'Light',
                    'Duotone',
                    'Brands',
                    'Kit'
                ].indexOf(fontFamily[2]) ? STYLE_TO_PREFIX[fontFamily[2].toLowerCase()] : FONT_WEIGHT_TO_PREFIX[fontWeight];
                var hexValue = toHex(_content.length === 3 ? _content.substr(1, 1) : _content);
                var iconName = byUnicode(prefix, hexValue);
                var iconIdentifier = iconName; // Only convert the pseudo element in this :before/:after position into an icon if we haven't
                // already done so with the same prefix and iconName
                if (iconName && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute(DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute(DATA_ICON) !== iconIdentifier)) {
                    node.setAttribute(pendingAttribute, iconIdentifier);
                    if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                    node.removeChild(alreadyProcessedPseudoElement);
                    var meta = blankMeta();
                    var extra = meta.extra;
                    extra.attributes[DATA_FA_PSEUDO_ELEMENT] = position;
                    findIcon(iconName, prefix).then(function(main) {
                        var _abstract = makeInlineSvgAbstract(_objectSpread({}, meta, {
                            icons: {
                                main: main,
                                mask: emptyCanonicalIcon()
                            },
                            prefix: prefix,
                            iconName: iconIdentifier,
                            extra: extra,
                            watchable: true
                        }));
                        var element = DOCUMENT.createElement('svg');
                        if (position === ':before') node.insertBefore(element, node.firstChild);
                        else node.appendChild(element);
                        element.outerHTML = _abstract.map(function(a) {
                            return toHtml(a);
                        }).join('\n');
                        node.removeAttribute(pendingAttribute);
                        resolve();
                    })["catch"](reject);
                } else resolve();
            } else resolve();
        });
    }
    function replace(node) {
        return picked.all([
            replaceForPosition(node, ':before'),
            replaceForPosition(node, ':after')
        ]);
    }
    function processable(node) {
        return node.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
    }
    function searchPseudoElements(root) {
        if (!IS_DOM) return;
        return new picked(function(resolve, reject) {
            var operations = toArray(root.querySelectorAll('*')).filter(processable).map(replace);
            var end = perf.begin('searchPseudoElements');
            disableObservation();
            picked.all(operations).then(function() {
                end();
                enableObservation();
                resolve();
            })["catch"](function() {
                end();
                enableObservation();
                reject();
            });
        });
    }
    var baseStyles = "svg:not(:root).svg-inline--fa{overflow:visible}.svg-inline--fa{display:inline-block;font-size:inherit;height:1em;overflow:visible;vertical-align:-.125em}.svg-inline--fa.fa-lg{vertical-align:-.225em}.svg-inline--fa.fa-w-1{width:.0625em}.svg-inline--fa.fa-w-2{width:.125em}.svg-inline--fa.fa-w-3{width:.1875em}.svg-inline--fa.fa-w-4{width:.25em}.svg-inline--fa.fa-w-5{width:.3125em}.svg-inline--fa.fa-w-6{width:.375em}.svg-inline--fa.fa-w-7{width:.4375em}.svg-inline--fa.fa-w-8{width:.5em}.svg-inline--fa.fa-w-9{width:.5625em}.svg-inline--fa.fa-w-10{width:.625em}.svg-inline--fa.fa-w-11{width:.6875em}.svg-inline--fa.fa-w-12{width:.75em}.svg-inline--fa.fa-w-13{width:.8125em}.svg-inline--fa.fa-w-14{width:.875em}.svg-inline--fa.fa-w-15{width:.9375em}.svg-inline--fa.fa-w-16{width:1em}.svg-inline--fa.fa-w-17{width:1.0625em}.svg-inline--fa.fa-w-18{width:1.125em}.svg-inline--fa.fa-w-19{width:1.1875em}.svg-inline--fa.fa-w-20{width:1.25em}.svg-inline--fa.fa-pull-left{margin-right:.3em;width:auto}.svg-inline--fa.fa-pull-right{margin-left:.3em;width:auto}.svg-inline--fa.fa-border{height:1.5em}.svg-inline--fa.fa-li{width:2em}.svg-inline--fa.fa-fw{width:1.25em}.fa-layers svg.svg-inline--fa{bottom:0;left:0;margin:auto;position:absolute;right:0;top:0}.fa-layers{display:inline-block;height:1em;position:relative;text-align:center;vertical-align:-.125em;width:1em}.fa-layers svg.svg-inline--fa{-webkit-transform-origin:center center;transform-origin:center center}.fa-layers-counter,.fa-layers-text{display:inline-block;position:absolute;text-align:center}.fa-layers-text{left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);-webkit-transform-origin:center center;transform-origin:center center}.fa-layers-counter{background-color:#ff253a;border-radius:1em;-webkit-box-sizing:border-box;box-sizing:border-box;color:#fff;height:1.5em;line-height:1;max-width:5em;min-width:1.5em;overflow:hidden;padding:.25em;right:0;text-overflow:ellipsis;top:0;-webkit-transform:scale(.25);transform:scale(.25);-webkit-transform-origin:top right;transform-origin:top right}.fa-layers-bottom-right{bottom:0;right:0;top:auto;-webkit-transform:scale(.25);transform:scale(.25);-webkit-transform-origin:bottom right;transform-origin:bottom right}.fa-layers-bottom-left{bottom:0;left:0;right:auto;top:auto;-webkit-transform:scale(.25);transform:scale(.25);-webkit-transform-origin:bottom left;transform-origin:bottom left}.fa-layers-top-right{right:0;top:0;-webkit-transform:scale(.25);transform:scale(.25);-webkit-transform-origin:top right;transform-origin:top right}.fa-layers-top-left{left:0;right:auto;top:0;-webkit-transform:scale(.25);transform:scale(.25);-webkit-transform-origin:top left;transform-origin:top left}.fa-lg{font-size:1.3333333333em;line-height:.75em;vertical-align:-.0667em}.fa-xs{font-size:.75em}.fa-sm{font-size:.875em}.fa-1x{font-size:1em}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-6x{font-size:6em}.fa-7x{font-size:7em}.fa-8x{font-size:8em}.fa-9x{font-size:9em}.fa-10x{font-size:10em}.fa-fw{text-align:center;width:1.25em}.fa-ul{list-style-type:none;margin-left:2.5em;padding-left:0}.fa-ul>li{position:relative}.fa-li{left:-2em;position:absolute;text-align:center;width:2em;line-height:inherit}.fa-border{border:solid .08em #eee;border-radius:.1em;padding:.2em .25em .15em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left,.fab.fa-pull-left,.fal.fa-pull-left,.far.fa-pull-left,.fas.fa-pull-left{margin-right:.3em}.fa.fa-pull-right,.fab.fa-pull-right,.fal.fa-pull-right,.far.fa-pull-right,.fas.fa-pull-right{margin-left:.3em}.fa-spin{-webkit-animation:fa-spin 2s infinite linear;animation:fa-spin 2s infinite linear}.fa-pulse{-webkit-animation:fa-spin 1s infinite steps(8);animation:fa-spin 1s infinite steps(8)}@-webkit-keyframes fa-spin{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes fa-spin{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.fa-rotate-90{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.fa-rotate-180{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.fa-rotate-270{-webkit-transform:rotate(270deg);transform:rotate(270deg)}.fa-flip-horizontal{-webkit-transform:scale(-1,1);transform:scale(-1,1)}.fa-flip-vertical{-webkit-transform:scale(1,-1);transform:scale(1,-1)}.fa-flip-both,.fa-flip-horizontal.fa-flip-vertical{-webkit-transform:scale(-1,-1);transform:scale(-1,-1)}:root .fa-flip-both,:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-180,:root .fa-rotate-270,:root .fa-rotate-90{-webkit-filter:none;filter:none}.fa-stack{display:inline-block;height:2em;position:relative;width:2.5em}.fa-stack-1x,.fa-stack-2x{bottom:0;left:0;margin:auto;position:absolute;right:0;top:0}.svg-inline--fa.fa-stack-1x{height:1em;width:1.25em}.svg-inline--fa.fa-stack-2x{height:2em;width:2.5em}.fa-inverse{color:#fff}.sr-only{border:0;clip:rect(0,0,0,0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.sr-only-focusable:active,.sr-only-focusable:focus{clip:auto;height:auto;margin:0;overflow:visible;position:static;width:auto}.svg-inline--fa .fa-primary{fill:var(--fa-primary-color,currentColor);opacity:1;opacity:var(--fa-primary-opacity,1)}.svg-inline--fa .fa-secondary{fill:var(--fa-secondary-color,currentColor);opacity:.4;opacity:var(--fa-secondary-opacity,.4)}.svg-inline--fa.fa-swap-opacity .fa-primary{opacity:.4;opacity:var(--fa-secondary-opacity,.4)}.svg-inline--fa.fa-swap-opacity .fa-secondary{opacity:1;opacity:var(--fa-primary-opacity,1)}.svg-inline--fa mask .fa-primary,.svg-inline--fa mask .fa-secondary{fill:#000}.fad.fa-inverse{color:#fff}";
    function css() {
        var dfp = DEFAULT_FAMILY_PREFIX;
        var drc = DEFAULT_REPLACEMENT_CLASS;
        var fp = config.familyPrefix;
        var rc = config.replacementClass;
        var s = baseStyles;
        if (fp !== dfp || rc !== drc) {
            var dPatt = new RegExp("\\.".concat(dfp, "\\-"), 'g');
            var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), 'g');
            var rPatt = new RegExp("\\.".concat(drc), 'g');
            s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
        }
        return s;
    }
    var Library = /*#__PURE__*/ function() {
        function Library() {
            _classCallCheck(this, Library);
            this.definitions = {};
        }
        _createClass(Library, [
            {
                key: "add",
                value: function add() {
                    var _this = this;
                    for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
                    var additions = definitions.reduce(this._pullDefinitions, {});
                    Object.keys(additions).forEach(function(key) {
                        _this.definitions[key] = _objectSpread({}, _this.definitions[key] || {}, additions[key]);
                        defineIcons(key, additions[key]);
                        build();
                    });
                }
            },
            {
                key: "reset",
                value: function reset() {
                    this.definitions = {};
                }
            },
            {
                key: "_pullDefinitions",
                value: function _pullDefinitions(additions, definition) {
                    var normalized = definition.prefix && definition.iconName && definition.icon ? {
                        0: definition
                    } : definition;
                    Object.keys(normalized).map(function(key) {
                        var _normalized$key = normalized[key], prefix = _normalized$key.prefix, iconName = _normalized$key.iconName, icon = _normalized$key.icon;
                        if (!additions[prefix]) additions[prefix] = {};
                        additions[prefix][iconName] = icon;
                    });
                    return additions;
                }
            }
        ]);
        return Library;
    }();
    function ensureCss() {
        if (config.autoAddCss && !_cssInserted) {
            insertCss(css());
            _cssInserted = true;
        }
    }
    function apiObject(val, abstractCreator) {
        Object.defineProperty(val, 'abstract', {
            get: abstractCreator
        });
        Object.defineProperty(val, 'html', {
            get: function get() {
                return val["abstract"].map(function(a) {
                    return toHtml(a);
                });
            }
        });
        Object.defineProperty(val, 'node', {
            get: function get() {
                if (!IS_DOM) return;
                var container = DOCUMENT.createElement('div');
                container.innerHTML = val.html;
                return container.children;
            }
        });
        return val;
    }
    function findIconDefinition(iconLookup) {
        var _iconLookup$prefix = iconLookup.prefix, prefix = _iconLookup$prefix === void 0 ? 'fa' : _iconLookup$prefix, iconName = iconLookup.iconName;
        if (!iconName) return;
        return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
    }
    function resolveIcons(next) {
        return function(maybeIconDefinition) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
            var mask = params.mask;
            if (mask) mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
            return next(iconDefinition, _objectSpread({}, params, {
                mask: mask
            }));
        };
    }
    var library = new Library();
    var noAuto = function noAuto() {
        config.autoReplaceSvg = false;
        config.observeMutations = false;
        disconnect();
    };
    var _cssInserted = false;
    var dom = {
        i2svg: function i2svg() {
            var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (IS_DOM) {
                ensureCss();
                var _params$node = params.node, node = _params$node === void 0 ? DOCUMENT : _params$node, _params$callback = params.callback, callback = _params$callback === void 0 ? function callback() {} : _params$callback;
                if (config.searchPseudoElements) searchPseudoElements(node);
                return onTree(node, callback);
            } else return picked.reject('Operation requires a DOM of some kind.');
        },
        css: css,
        insertCss: function insertCss$$1() {
            if (!_cssInserted) {
                insertCss(css());
                _cssInserted = true;
            }
        },
        watch: function watch() {
            var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var autoReplaceSvgRoot = params.autoReplaceSvgRoot, observeMutationsRoot = params.observeMutationsRoot;
            if (config.autoReplaceSvg === false) config.autoReplaceSvg = true;
            config.observeMutations = true;
            domready(function() {
                autoReplace({
                    autoReplaceSvgRoot: autoReplaceSvgRoot
                });
                observe({
                    treeCallback: onTree,
                    nodeCallback: onNode,
                    pseudoElementsCallback: searchPseudoElements,
                    observeMutationsRoot: observeMutationsRoot
                });
            });
        }
    };
    var parse = {
        transform: function transform(transformString) {
            return parseTransformString(transformString);
        }
    };
    var icon = resolveIcons(function(iconDefinition) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$transform = params.transform, transform = _params$transform === void 0 ? meaninglessTransform : _params$transform, _params$symbol = params.symbol, symbol = _params$symbol === void 0 ? false : _params$symbol, _params$mask = params.mask, mask = _params$mask === void 0 ? null : _params$mask, _params$maskId = params.maskId, maskId = _params$maskId === void 0 ? null : _params$maskId, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$titleId = params.titleId, titleId = _params$titleId === void 0 ? null : _params$titleId, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
        if (!iconDefinition) return;
        var prefix = iconDefinition.prefix, iconName = iconDefinition.iconName, icon = iconDefinition.icon;
        return apiObject(_objectSpread({
            type: 'icon'
        }, iconDefinition), function() {
            ensureCss();
            if (config.autoA11y) {
                if (title) attributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
                else {
                    attributes['aria-hidden'] = 'true';
                    attributes['focusable'] = 'false';
                }
            }
            return makeInlineSvgAbstract({
                icons: {
                    main: asFoundIcon(icon),
                    mask: mask ? asFoundIcon(mask.icon) : {
                        found: false,
                        width: null,
                        height: null,
                        icon: {}
                    }
                },
                prefix: prefix,
                iconName: iconName,
                transform: _objectSpread({}, meaninglessTransform, transform),
                symbol: symbol,
                title: title,
                maskId: maskId,
                titleId: titleId,
                extra: {
                    attributes: attributes,
                    styles: styles,
                    classes: classes
                }
            });
        });
    });
    var text = function text(content) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$transform2 = params.transform, transform = _params$transform2 === void 0 ? meaninglessTransform : _params$transform2, _params$title2 = params.title, title = _params$title2 === void 0 ? null : _params$title2, _params$classes2 = params.classes, classes = _params$classes2 === void 0 ? [] : _params$classes2, _params$attributes2 = params.attributes, attributes = _params$attributes2 === void 0 ? {} : _params$attributes2, _params$styles2 = params.styles, styles = _params$styles2 === void 0 ? {} : _params$styles2;
        return apiObject({
            type: 'text',
            content: content
        }, function() {
            ensureCss();
            return makeLayersTextAbstract({
                content: content,
                transform: _objectSpread({}, meaninglessTransform, transform),
                title: title,
                extra: {
                    attributes: attributes,
                    styles: styles,
                    classes: [
                        "".concat(config.familyPrefix, "-layers-text")
                    ].concat(_toConsumableArray(classes))
                }
            });
        });
    };
    var counter = function counter(content) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$title3 = params.title, title = _params$title3 === void 0 ? null : _params$title3, _params$classes3 = params.classes, classes = _params$classes3 === void 0 ? [] : _params$classes3, _params$attributes3 = params.attributes, attributes = _params$attributes3 === void 0 ? {} : _params$attributes3, _params$styles3 = params.styles, styles = _params$styles3 === void 0 ? {} : _params$styles3;
        return apiObject({
            type: 'counter',
            content: content
        }, function() {
            ensureCss();
            return makeLayersCounterAbstract({
                content: content.toString(),
                title: title,
                extra: {
                    attributes: attributes,
                    styles: styles,
                    classes: [
                        "".concat(config.familyPrefix, "-layers-counter")
                    ].concat(_toConsumableArray(classes))
                }
            });
        });
    };
    var layer = function layer(assembler) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$classes4 = params.classes, classes = _params$classes4 === void 0 ? [] : _params$classes4;
        return apiObject({
            type: 'layer'
        }, function() {
            ensureCss();
            var children = [];
            assembler(function(args) {
                Array.isArray(args) ? args.map(function(a) {
                    children = children.concat(a["abstract"]);
                }) : children = children.concat(args["abstract"]);
            });
            return [
                {
                    tag: 'span',
                    attributes: {
                        "class": [
                            "".concat(config.familyPrefix, "-layers")
                        ].concat(_toConsumableArray(classes)).join(' ')
                    },
                    children: children
                }
            ];
        });
    };
    var api = {
        noAuto: noAuto,
        config: config,
        dom: dom,
        library: library,
        parse: parse,
        findIconDefinition: findIconDefinition,
        icon: icon,
        text: text,
        counter: counter,
        layer: layer,
        toHtml: toHtml
    };
    var autoReplace = function autoReplace() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _params$autoReplaceSv = params.autoReplaceSvgRoot, autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? DOCUMENT : _params$autoReplaceSv;
        if ((Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg) api.dom.i2svg({
            node: autoReplaceSvgRoot
        });
    };
    function bootstrap() {
        if (IS_BROWSER) {
            if (!WINDOW.FontAwesome) WINDOW.FontAwesome = api;
            domready(function() {
                autoReplace();
                observe({
                    treeCallback: onTree,
                    nodeCallback: onNode,
                    pseudoElementsCallback: searchPseudoElements
                });
            });
        }
        namespace.hooks = _objectSpread({}, namespace.hooks, {
            addPack: function addPack(prefix, icons) {
                namespace.styles[prefix] = _objectSpread({}, namespace.styles[prefix] || {}, icons);
                build();
                autoReplace();
            },
            addShims: function addShims(shims) {
                var _namespace$shims;
                (_namespace$shims = namespace.shims).push.apply(_namespace$shims, _toConsumableArray(shims));
                build();
                autoReplace();
            }
        });
    }
    bunker(bootstrap);
})();


/*!
 * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */ (function() {
    'use strict';
    var _WINDOW = {};
    var _DOCUMENT = {};
    try {
        if (typeof window !== 'undefined') _WINDOW = window;
        if (typeof document !== 'undefined') _DOCUMENT = document;
    } catch (e) {}
    var _ref = _WINDOW.navigator || {}, _ref$userAgent = _ref.userAgent, userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;
    var WINDOW = _WINDOW;
    var DOCUMENT = _DOCUMENT;
    var IS_BROWSER = !!WINDOW.document;
    var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
    var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');
    var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
    var PRODUCTION = function() {
        try {
            return true;
        } catch (e) {
            return false;
        }
    }();
    function bunker(fn) {
        try {
            fn();
        } catch (e) {
            if (!PRODUCTION) throw e;
        }
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _objectSpread(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            var ownKeys = Object.keys(source);
            if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
            ownKeys.forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
        }
        return target;
    }
    var w = WINDOW || {};
    if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
    if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
    if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
    if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
    var namespace = w[NAMESPACE_IDENTIFIER];
    function defineIcons(prefix, icons) {
        var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
        var normalized = Object.keys(icons).reduce(function(acc, iconName) {
            var icon = icons[iconName];
            var expanded = !!icon.icon;
            if (expanded) acc[icon.iconName] = icon.icon;
            else acc[iconName] = icon;
            return acc;
        }, {});
        if (typeof namespace.hooks.addPack === 'function' && !skipHooks) namespace.hooks.addPack(prefix, normalized);
        else namespace.styles[prefix] = _objectSpread({}, namespace.styles[prefix] || {}, normalized);
        /**
     * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
     * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
     * for `fas` so we'll easy the upgrade process for our users by automatically defining
     * this as well.
     */ if (prefix === 'fas') defineIcons('fa', icons);
    }
    var icons = {
        ad: [
            512,
            512,
            [],
            "f641",
            "M157.52 272h36.96L176 218.78 157.52 272zM352 256c-13.23 0-24 10.77-24 24s10.77 24 24 24 24-10.77 24-24-10.77-24-24-24zM464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM250.58 352h-16.94c-6.81 0-12.88-4.32-15.12-10.75L211.15 320h-70.29l-7.38 21.25A16 16 0 0 1 118.36 352h-16.94c-11.01 0-18.73-10.85-15.12-21.25L140 176.12A23.995 23.995 0 0 1 162.67 160h26.66A23.99 23.99 0 0 1 212 176.13l53.69 154.62c3.61 10.4-4.11 21.25-15.11 21.25zM424 336c0 8.84-7.16 16-16 16h-16c-4.85 0-9.04-2.27-11.98-5.68-8.62 3.66-18.09 5.68-28.02 5.68-39.7 0-72-32.3-72-72s32.3-72 72-72c8.46 0 16.46 1.73 24 4.42V176c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v160z"
        ],
        "address-book": [
            448,
            512,
            [],
            "f2b9",
            "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-228-32c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H118.4C106 384 96 375.4 96 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
        ],
        "address-card": [
            576,
            512,
            [],
            "f2bb",
            "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-352 96c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H86.4C74 384 64 375.4 64 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2zM512 312c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
        ],
        adjust: [
            512,
            512,
            [],
            "f042",
            "M8 256c0 136.966 111.033 248 248 248s248-111.034 248-248S392.966 8 256 8 8 119.033 8 256zm248 184V72c101.705 0 184 82.311 184 184 0 101.705-82.311 184-184 184z"
        ],
        "air-freshener": [
            512,
            512,
            [],
            "f5d0",
            "M224 160H96C43 160 0 203 0 256V480C0 497.625 14.375 512 32 512H288C305.625 512 320 497.625 320 480V256C320 203 277 160 224 160ZM160 416C115.875 416 80 380.125 80 336S115.875 256 160 256S240 291.875 240 336S204.125 416 160 416ZM224 32C224 14.375 209.625 0 192 0H128C110.375 0 96 14.375 96 32V128H224V32ZM381.781 51.578C383 50.969 384 49.359 384 48C384 46.625 383 45.031 381.781 44.422L352 32L339.562 2.219C338.969 1 337.375 0 336 0S333.031 1 332.406 2.219L320 32L290.219 44.422C289 45.031 288 46.625 288 48C288 49.359 289 50.969 290.219 51.578L320 64L332.406 93.781C333.031 95 334.625 96 336 96S338.969 95 339.562 93.781L352 64L381.781 51.578ZM448 64L460.406 93.781C461.031 95 462.625 96 464 96S466.969 95 467.562 93.781L480 64L509.781 51.578C511 50.969 512 49.359 512 48C512 46.625 511 45.031 509.781 44.422L480 32L467.562 2.219C466.969 1 465.375 0 464 0S461.031 1 460.406 2.219L448 32L418.219 44.422C417 45.031 416 46.625 416 48C416 49.359 417 50.969 418.219 51.578L448 64ZM480 224L467.562 194.219C466.969 193 465.375 192 464 192S461.031 193 460.406 194.219L448 224L418.219 236.422C417 237.031 416 238.625 416 240C416 241.359 417 242.969 418.219 243.578L448 256L460.406 285.781C461.031 287 462.625 288 464 288S466.969 287 467.562 285.781L480 256L509.781 243.578C511 242.969 512 241.359 512 240C512 238.625 511 237.031 509.781 236.422L480 224ZM445.781 147.578C447 146.969 448 145.359 448 144C448 142.625 447 141.031 445.781 140.422L416 128L403.562 98.219C402.969 97 401.375 96 400 96S397.031 97 396.406 98.219L384 128L354.219 140.422C353 141.031 352 142.625 352 144C352 145.359 353 146.969 354.219 147.578L384 160L396.406 189.781C397.031 191 398.625 192 400 192S402.969 191 403.562 189.781L416 160L445.781 147.578Z"
        ],
        "align-center": [
            448,
            512,
            [],
            "f037",
            "M432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM108.1 96h231.81A12.09 12.09 0 0 0 352 83.9V44.09A12.09 12.09 0 0 0 339.91 32H108.1A12.09 12.09 0 0 0 96 44.09V83.9A12.1 12.1 0 0 0 108.1 96zm231.81 256A12.09 12.09 0 0 0 352 339.9v-39.81A12.09 12.09 0 0 0 339.91 288H108.1A12.09 12.09 0 0 0 96 300.09v39.81a12.1 12.1 0 0 0 12.1 12.1z"
        ],
        "align-justify": [
            448,
            512,
            [],
            "f039",
            "M432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
        ],
        "align-left": [
            448,
            512,
            [],
            "f036",
            "M12.83 352h262.34A12.82 12.82 0 0 0 288 339.17v-38.34A12.82 12.82 0 0 0 275.17 288H12.83A12.82 12.82 0 0 0 0 300.83v38.34A12.82 12.82 0 0 0 12.83 352zm0-256h262.34A12.82 12.82 0 0 0 288 83.17V44.83A12.82 12.82 0 0 0 275.17 32H12.83A12.82 12.82 0 0 0 0 44.83v38.34A12.82 12.82 0 0 0 12.83 96zM432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
        ],
        "align-right": [
            448,
            512,
            [],
            "f038",
            "M16 224h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm416 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-384H172.83A12.82 12.82 0 0 0 160 44.83v38.34A12.82 12.82 0 0 0 172.83 96h262.34A12.82 12.82 0 0 0 448 83.17V44.83A12.82 12.82 0 0 0 435.17 32zm0 256H172.83A12.82 12.82 0 0 0 160 300.83v38.34A12.82 12.82 0 0 0 172.83 352h262.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288z"
        ],
        allergies: [
            448,
            512,
            [],
            "f461",
            "M416 112c-17.6 0-32 14.4-32 32v72c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32s-32 14.4-32 32v152c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V32c0-17.6-14.4-32-32-32s-32 14.4-32 32v184c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32S96 46.4 96 64v241l-23.6-32.5c-13-17.9-38-21.8-55.9-8.8s-21.8 38-8.8 55.9l125.6 172.7c9 12.4 23.5 19.8 38.8 19.8h197.6c22.3 0 41.6-15.3 46.7-37l26.5-112.7c3.2-13.7 4.9-28.3 5.1-42.3V144c0-17.6-14.4-32-32-32zM176 416c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 32c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32-128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
        ],
        ambulance: [
            640,
            512,
            [],
            "f0f9",
            "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm144-248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm176 248c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
        ],
        "american-sign-language-interpreting": [
            640,
            512,
            [],
            "f2a3",
            "M290.547 189.039c-20.295-10.149-44.147-11.199-64.739-3.89 42.606 0 71.208 20.475 85.578 50.576 8.576 17.899-5.148 38.071-23.617 38.071 18.429 0 32.211 20.136 23.617 38.071-14.725 30.846-46.123 50.854-80.298 50.854-.557 0-94.471-8.615-94.471-8.615l-66.406 33.347c-9.384 4.693-19.815.379-23.895-7.781L1.86 290.747c-4.167-8.615-1.111-18.897 6.946-23.621l58.072-33.069L108 159.861c6.39-57.245 34.731-109.767 79.743-146.726 11.391-9.448 28.341-7.781 37.51 3.613 9.446 11.394 7.78 28.067-3.612 37.516-12.503 10.559-23.618 22.509-32.509 35.57 21.672-14.729 46.679-24.732 74.186-28.067 14.725-1.945 28.063 8.336 29.73 23.065 1.945 14.728-8.336 28.067-23.062 29.734-16.116 1.945-31.12 7.503-44.178 15.284 26.114-5.713 58.712-3.138 88.079 11.115 13.336 6.669 18.893 22.509 12.224 35.848-6.389 13.06-22.504 18.617-35.564 12.226zm-27.229 69.472c-6.112-12.505-18.338-20.286-32.231-20.286a35.46 35.46 0 0 0-35.565 35.57c0 21.428 17.808 35.57 35.565 35.57 13.893 0 26.119-7.781 32.231-20.286 4.446-9.449 13.614-15.006 23.339-15.284-9.725-.277-18.893-5.835-23.339-15.284zm374.821-37.237c4.168 8.615 1.111 18.897-6.946 23.621l-58.071 33.069L532 352.16c-6.39 57.245-34.731 109.767-79.743 146.726-10.932 9.112-27.799 8.144-37.51-3.613-9.446-11.394-7.78-28.067 3.613-37.516 12.503-10.559 23.617-22.509 32.508-35.57-21.672 14.729-46.679 24.732-74.186 28.067-10.021 2.506-27.552-5.643-29.73-23.065-1.945-14.728 8.336-28.067 23.062-29.734 16.116-1.946 31.12-7.503 44.178-15.284-26.114 5.713-58.712 3.138-88.079-11.115-13.336-6.669-18.893-22.509-12.224-35.848 6.389-13.061 22.505-18.619 35.565-12.227 20.295 10.149 44.147 11.199 64.739 3.89-42.606 0-71.208-20.475-85.578-50.576-8.576-17.899 5.148-38.071 23.617-38.071-18.429 0-32.211-20.136-23.617-38.071 14.033-29.396 44.039-50.887 81.966-50.854l92.803 8.615 66.406-33.347c9.408-4.704 19.828-.354 23.894 7.781l44.455 88.926zm-229.227-18.618c-13.893 0-26.119 7.781-32.231 20.286-4.446 9.449-13.614 15.006-23.339 15.284 9.725.278 18.893 5.836 23.339 15.284 6.112 12.505 18.338 20.286 32.231 20.286a35.46 35.46 0 0 0 35.565-35.57c0-21.429-17.808-35.57-35.565-35.57z"
        ],
        anchor: [
            576,
            512,
            [],
            "f13d",
            "M12.971 352h32.394C67.172 454.735 181.944 512 288 512c106.229 0 220.853-57.38 242.635-160h32.394c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0l-67.029 67.029c-7.56 7.56-2.206 20.485 8.485 20.485h35.146c-20.29 54.317-84.963 86.588-144.117 94.015V256h52c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-52v-5.47c37.281-13.178 63.995-48.725 64-90.518C384.005 43.772 341.605.738 289.37.01 235.723-.739 192 42.525 192 96c0 41.798 26.716 77.35 64 90.53V192h-52c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v190.015c-58.936-7.399-123.82-39.679-144.117-94.015h35.146c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0L4.485 331.515C-3.074 339.074 2.28 352 12.971 352zM288 64c17.645 0 32 14.355 32 32s-14.355 32-32 32-32-14.355-32-32 14.355-32 32-32z"
        ],
        "angle-double-down": [
            320,
            512,
            [],
            "f103",
            "M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"
        ],
        "angle-double-left": [
            448,
            512,
            [],
            "f100",
            "M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z"
        ],
        "angle-double-right": [
            448,
            512,
            [],
            "f101",
            "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z"
        ],
        "angle-double-up": [
            320,
            512,
            [],
            "f102",
            "M177 255.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 351.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 425.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1zm-34-192L7 199.7c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l96.4-96.4 96.4 96.4c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9l-136-136c-9.2-9.4-24.4-9.4-33.8 0z"
        ],
        "angle-down": [
            320,
            512,
            [],
            "f107",
            "M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"
        ],
        "angle-left": [
            256,
            512,
            [],
            "f104",
            "M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"
        ],
        "angle-right": [
            256,
            512,
            [],
            "f105",
            "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"
        ],
        "angle-up": [
            320,
            512,
            [],
            "f106",
            "M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"
        ],
        angry: [
            496,
            512,
            [],
            "f556",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 240c0-9.3 4.1-17.5 10.5-23.4l-31-9.3c-8.5-2.5-13.3-11.5-10.7-19.9 2.5-8.5 11.4-13.2 19.9-10.7l80 24c8.5 2.5 13.3 11.5 10.7 19.9-2.1 6.9-8.4 11.4-15.3 11.4-.5 0-1.1-.2-1.7-.2.7 2.7 1.7 5.3 1.7 8.2 0 17.7-14.3 32-32 32S136 257.7 136 240zm168 154.2c-27.8-33.4-84.2-33.4-112.1 0-13.5 16.3-38.2-4.2-24.6-20.5 20-24 49.4-37.8 80.6-37.8s60.6 13.8 80.6 37.8c13.8 16.5-11.1 36.6-24.5 20.5zm76.6-186.9l-31 9.3c6.3 5.8 10.5 14.1 10.5 23.4 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-2.9.9-5.6 1.7-8.2-.6.1-1.1.2-1.7.2-6.9 0-13.2-4.5-15.3-11.4-2.5-8.5 2.3-17.4 10.7-19.9l80-24c8.4-2.5 17.4 2.3 19.9 10.7 2.5 8.5-2.3 17.4-10.8 19.9z"
        ],
        ankh: [
            320,
            512,
            [],
            "f644",
            "M296 256h-44.62C272.46 222.01 288 181.65 288 144 288 55.63 230.69 0 160 0S32 55.63 32 144c0 37.65 15.54 78.01 36.62 112H24c-13.25 0-24 10.74-24 24v32c0 13.25 10.75 24 24 24h96v152c0 13.25 10.75 24 24 24h32c13.25 0 24-10.75 24-24V336h96c13.25 0 24-10.75 24-24v-32c0-13.26-10.75-24-24-24zM160 80c29.61 0 48 24.52 48 64 0 34.66-27.14 78.14-48 100.87-20.86-22.72-48-66.21-48-100.87 0-39.48 18.39-64 48-64z"
        ],
        "apple-alt": [
            448,
            512,
            [],
            "f5d1",
            "M350.85 129c25.97 4.67 47.27 18.67 63.92 42 14.65 20.67 24.64 46.67 29.96 78 4.67 28.67 4.32 57.33-1 86-7.99 47.33-23.97 87-47.94 119-28.64 38.67-64.59 58-107.87 58-10.66 0-22.3-3.33-34.96-10-8.66-5.33-18.31-8-28.97-8s-20.3 2.67-28.97 8c-12.66 6.67-24.3 10-34.96 10-43.28 0-79.23-19.33-107.87-58-23.97-32-39.95-71.67-47.94-119-5.32-28.67-5.67-57.33-1-86 5.32-31.33 15.31-57.33 29.96-78 16.65-23.33 37.95-37.33 63.92-42 15.98-2.67 37.95-.33 65.92 7 23.97 6.67 44.28 14.67 60.93 24 16.65-9.33 36.96-17.33 60.93-24 27.98-7.33 49.96-9.67 65.94-7zm-54.94-41c-9.32 8.67-21.65 15-36.96 19-10.66 3.33-22.3 5-34.96 5l-14.98-1c-1.33-9.33-1.33-20 0-32 2.67-24 10.32-42.33 22.97-55 9.32-8.67 21.65-15 36.96-19 10.66-3.33 22.3-5 34.96-5l14.98 1 1 15c0 12.67-1.67 24.33-4.99 35-3.99 15.33-10.31 27.67-18.98 37z"
        ],
        archive: [
            512,
            512,
            [],
            "f187",
            "M32 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V160H32v288zm160-212c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-8zM480 32H32C14.3 32 0 46.3 0 64v48c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16V64c0-17.7-14.3-32-32-32z"
        ],
        archway: [
            576,
            512,
            [],
            "f557",
            "M560 448h-16V96H32v352H16.02c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16H176c8.84 0 16-7.16 16-16V320c0-53.02 42.98-96 96-96s96 42.98 96 96l.02 160v16c0 8.84 7.16 16 16 16H560c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm0-448H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h544c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"
        ],
        "arrow-alt-circle-down": [
            512,
            512,
            [],
            "f358",
            "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM212 140v116h-70.9c-10.7 0-16.1 13-8.5 20.5l114.9 114.3c4.7 4.7 12.2 4.7 16.9 0l114.9-114.3c7.6-7.6 2.2-20.5-8.5-20.5H300V140c0-6.6-5.4-12-12-12h-64c-6.6 0-12 5.4-12 12z"
        ],
        "arrow-alt-circle-left": [
            512,
            512,
            [],
            "f359",
            "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm116-292H256v-70.9c0-10.7-13-16.1-20.5-8.5L121.2 247.5c-4.7 4.7-4.7 12.2 0 16.9l114.3 114.9c7.6 7.6 20.5 2.2 20.5-8.5V300h116c6.6 0 12-5.4 12-12v-64c0-6.6-5.4-12-12-12z"
        ],
        "arrow-alt-circle-right": [
            512,
            512,
            [],
            "f35a",
            "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H140c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z"
        ],
        "arrow-alt-circle-up": [
            512,
            512,
            [],
            "f35b",
            "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm292 116V256h70.9c10.7 0 16.1-13 8.5-20.5L264.5 121.2c-4.7-4.7-12.2-4.7-16.9 0l-115 114.3c-7.6 7.6-2.2 20.5 8.5 20.5H212v116c0 6.6 5.4 12 12 12h64c6.6 0 12-5.4 12-12z"
        ],
        "arrow-circle-down": [
            512,
            512,
            [],
            "f0ab",
            "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-143.6-28.9L288 302.6V120c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v182.6l-72.4-75.5c-9.3-9.7-24.8-9.9-34.3-.4l-10.9 11c-9.4 9.4-9.4 24.6 0 33.9L239 404.3c9.4 9.4 24.6 9.4 33.9 0l132.7-132.7c9.4-9.4 9.4-24.6 0-33.9l-10.9-11c-9.5-9.5-25-9.3-34.3.4z"
        ],
        "arrow-circle-left": [
            512,
            512,
            [],
            "f0a8",
            "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm28.9-143.6L209.4 288H392c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H209.4l75.5-72.4c9.7-9.3 9.9-24.8.4-34.3l-11-10.9c-9.4-9.4-24.6-9.4-33.9 0L107.7 239c-9.4 9.4-9.4 24.6 0 33.9l132.7 132.7c9.4 9.4 24.6 9.4 33.9 0l11-10.9c9.5-9.5 9.3-25-.4-34.3z"
        ],
        "arrow-circle-right": [
            512,
            512,
            [],
            "f0a9",
            "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"
        ],
        "arrow-circle-up": [
            512,
            512,
            [],
            "f0aa",
            "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm143.6 28.9l72.4-75.5V392c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V209.4l72.4 75.5c9.3 9.7 24.8 9.9 34.3.4l10.9-11c9.4-9.4 9.4-24.6 0-33.9L273 107.7c-9.4-9.4-24.6-9.4-33.9 0L106.3 240.4c-9.4 9.4-9.4 24.6 0 33.9l10.9 11c9.6 9.5 25.1 9.3 34.4-.4z"
        ],
        "arrow-down": [
            448,
            512,
            [],
            "f063",
            "M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"
        ],
        "arrow-left": [
            448,
            512,
            [],
            "f060",
            "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
        ],
        "arrow-right": [
            448,
            512,
            [],
            "f061",
            "M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
        ],
        "arrow-up": [
            448,
            512,
            [],
            "f062",
            "M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
        ],
        "arrows-alt": [
            512,
            512,
            [],
            "f0b2",
            "M352.201 425.775l-79.196 79.196c-9.373 9.373-24.568 9.373-33.941 0l-79.196-79.196c-15.119-15.119-4.411-40.971 16.971-40.97h51.162L228 284H127.196v51.162c0 21.382-25.851 32.09-40.971 16.971L7.029 272.937c-9.373-9.373-9.373-24.569 0-33.941L86.225 159.8c15.119-15.119 40.971-4.411 40.971 16.971V228H228V127.196h-51.23c-21.382 0-32.09-25.851-16.971-40.971l79.196-79.196c9.373-9.373 24.568-9.373 33.941 0l79.196 79.196c15.119 15.119 4.411 40.971-16.971 40.971h-51.162V228h100.804v-51.162c0-21.382 25.851-32.09 40.97-16.971l79.196 79.196c9.373 9.373 9.373 24.569 0 33.941L425.773 352.2c-15.119 15.119-40.971 4.411-40.97-16.971V284H284v100.804h51.23c21.382 0 32.09 25.851 16.971 40.971z"
        ],
        "arrows-alt-h": [
            512,
            512,
            [],
            "f337",
            "M377.941 169.941V216H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.568 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296h243.882v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.568 0-33.941l-86.059-86.059c-15.119-15.12-40.971-4.412-40.971 16.97z"
        ],
        "arrows-alt-v": [
            256,
            512,
            [],
            "f338",
            "M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z"
        ],
        "assistive-listening-systems": [
            512,
            512,
            [],
            "f2a2",
            "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm-80 236c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zM32 448c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm480-187.993c0-1.518-.012-3.025-.045-4.531C510.076 140.525 436.157 38.47 327.994 1.511c-14.633-4.998-30.549 2.809-35.55 17.442-5 14.633 2.81 30.549 17.442 35.55 85.906 29.354 144.61 110.513 146.077 201.953l.003.188c.026 1.118.033 2.236.033 3.363 0 15.464 12.536 28 28 28s28.001-12.536 28.001-28zM152.971 439.029l-80-80L39.03 392.97l80 80 33.941-33.941z"
        ],
        asterisk: [
            512,
            512,
            [],
            "f069",
            "M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"
        ],
        at: [
            512,
            512,
            [],
            "f1fa",
            "M256 8C118.941 8 8 118.919 8 256c0 137.059 110.919 248 248 248 48.154 0 95.342-14.14 135.408-40.223 12.005-7.815 14.625-24.288 5.552-35.372l-10.177-12.433c-7.671-9.371-21.179-11.667-31.373-5.129C325.92 429.757 291.314 440 256 440c-101.458 0-184-82.542-184-184S154.542 72 256 72c100.139 0 184 57.619 184 160 0 38.786-21.093 79.742-58.17 83.693-17.349-.454-16.91-12.857-13.476-30.024l23.433-121.11C394.653 149.75 383.308 136 368.225 136h-44.981a13.518 13.518 0 0 0-13.432 11.993l-.01.092c-14.697-17.901-40.448-21.775-59.971-21.775-74.58 0-137.831 62.234-137.831 151.46 0 65.303 36.785 105.87 96 105.87 26.984 0 57.369-15.637 74.991-38.333 9.522 34.104 40.613 34.103 70.71 34.103C462.609 379.41 504 307.798 504 232 504 95.653 394.023 8 256 8zm-21.68 304.43c-22.249 0-36.07-15.623-36.07-40.771 0-44.993 30.779-72.729 58.63-72.729 22.292 0 35.601 15.241 35.601 40.77 0 45.061-33.875 72.73-58.161 72.73z"
        ],
        atlas: [
            448,
            512,
            [],
            "f558",
            "M318.38 208h-39.09c-1.49 27.03-6.54 51.35-14.21 70.41 27.71-13.24 48.02-39.19 53.3-70.41zm0-32c-5.29-31.22-25.59-57.17-53.3-70.41 7.68 19.06 12.72 43.38 14.21 70.41h39.09zM224 97.31c-7.69 7.45-20.77 34.42-23.43 78.69h46.87c-2.67-44.26-15.75-71.24-23.44-78.69zm-41.08 8.28c-27.71 13.24-48.02 39.19-53.3 70.41h39.09c1.49-27.03 6.53-51.35 14.21-70.41zm0 172.82c-7.68-19.06-12.72-43.38-14.21-70.41h-39.09c5.28 31.22 25.59 57.17 53.3 70.41zM247.43 208h-46.87c2.66 44.26 15.74 71.24 23.43 78.69 7.7-7.45 20.78-34.43 23.44-78.69zM448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM224 64c70.69 0 128 57.31 128 128s-57.31 128-128 128S96 262.69 96 192 153.31 64 224 64zm160 384H96c-19.2 0-32-12.8-32-32s16-32 32-32h288v64z"
        ],
        atom: [
            448,
            512,
            [],
            "f5d2",
            "M223.99908,224a32,32,0,1,0,32.00782,32A32.06431,32.06431,0,0,0,223.99908,224Zm214.172-96c-10.877-19.5-40.50979-50.75-116.27544-41.875C300.39168,34.875,267.63386,0,223.99908,0s-76.39066,34.875-97.89653,86.125C50.3369,77.375,20.706,108.5,9.82907,128-6.54984,157.375-5.17484,201.125,34.958,256-5.17484,310.875-6.54984,354.625,9.82907,384c29.13087,52.375,101.64652,43.625,116.27348,41.875C147.60842,477.125,180.36429,512,223.99908,512s76.3926-34.875,97.89652-86.125c14.62891,1.75,87.14456,10.5,116.27544-41.875C454.55,354.625,453.175,310.875,413.04017,256,453.175,201.125,454.55,157.375,438.171,128ZM63.33886,352c-4-7.25-.125-24.75,15.00391-48.25,6.87695,6.5,14.12891,12.875,21.88087,19.125,1.625,13.75,4,27.125,6.75,40.125C82.34472,363.875,67.09081,358.625,63.33886,352Zm36.88478-162.875c-7.752,6.25-15.00392,12.625-21.88087,19.125-15.12891-23.5-19.00392-41-15.00391-48.25,3.377-6.125,16.37891-11.5,37.88478-11.5,1.75,0,3.875.375,5.75.375C104.09864,162.25,101.84864,175.625,100.22364,189.125ZM223.99908,64c9.50195,0,22.25586,13.5,33.88282,37.25-11.252,3.75-22.50391,8-33.88282,12.875-11.377-4.875-22.62892-9.125-33.88283-12.875C201.74516,77.5,214.49712,64,223.99908,64Zm0,384c-9.502,0-22.25392-13.5-33.88283-37.25,11.25391-3.75,22.50587-8,33.88283-12.875C235.378,402.75,246.62994,407,257.8819,410.75,246.25494,434.5,233.501,448,223.99908,448Zm0-112a80,80,0,1,1,80-80A80.00023,80.00023,0,0,1,223.99908,336ZM384.6593,352c-3.625,6.625-19.00392,11.875-43.63479,11,2.752-13,5.127-26.375,6.752-40.125,7.75195-6.25,15.00391-12.625,21.87891-19.125C384.7843,327.25,388.6593,344.75,384.6593,352ZM369.65538,208.25c-6.875-6.5-14.127-12.875-21.87891-19.125-1.625-13.5-3.875-26.875-6.752-40.25,1.875,0,4.002-.375,5.752-.375,21.50391,0,34.50782,5.375,37.88283,11.5C388.6593,167.25,384.7843,184.75,369.65538,208.25Z"
        ],
        "audio-description": [
            512,
            512,
            [],
            "f29e",
            "M162.925 238.709l8.822 30.655h-25.606l9.041-30.652c1.277-4.421 2.651-9.994 3.872-15.245 1.22 5.251 2.594 10.823 3.871 15.242zm166.474-32.099h-14.523v98.781h14.523c29.776 0 46.175-17.678 46.175-49.776 0-32.239-17.49-49.005-46.175-49.005zM512 112v288c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48zM245.459 336.139l-57.097-168A12.001 12.001 0 0 0 177 160h-35.894a12.001 12.001 0 0 0-11.362 8.139l-57.097 168C70.003 343.922 75.789 352 84.009 352h29.133a12 12 0 0 0 11.535-8.693l8.574-29.906h51.367l8.793 29.977A12 12 0 0 0 204.926 352h29.172c8.22 0 14.006-8.078 11.361-15.861zm184.701-80.525c0-58.977-37.919-95.614-98.96-95.614h-57.366c-6.627 0-12 5.373-12 12v168c0 6.627 5.373 12 12 12H331.2c61.041 0 98.96-36.933 98.96-96.386z"
        ],
        award: [
            384,
            512,
            [],
            "f559",
            "M97.12 362.63c-8.69-8.69-4.16-6.24-25.12-11.85-9.51-2.55-17.87-7.45-25.43-13.32L1.2 448.7c-4.39 10.77 3.81 22.47 15.43 22.03l52.69-2.01L105.56 507c8 8.44 22.04 5.81 26.43-4.96l52.05-127.62c-10.84 6.04-22.87 9.58-35.31 9.58-19.5 0-37.82-7.59-51.61-21.37zM382.8 448.7l-45.37-111.24c-7.56 5.88-15.92 10.77-25.43 13.32-21.07 5.64-16.45 3.18-25.12 11.85-13.79 13.78-32.12 21.37-51.62 21.37-12.44 0-24.47-3.55-35.31-9.58L252 502.04c4.39 10.77 18.44 13.4 26.43 4.96l36.25-38.28 52.69 2.01c11.62.44 19.82-11.27 15.43-22.03zM263 340c15.28-15.55 17.03-14.21 38.79-20.14 13.89-3.79 24.75-14.84 28.47-28.98 7.48-28.4 5.54-24.97 25.95-45.75 10.17-10.35 14.14-25.44 10.42-39.58-7.47-28.38-7.48-24.42 0-52.83 3.72-14.14-.25-29.23-10.42-39.58-20.41-20.78-18.47-17.36-25.95-45.75-3.72-14.14-14.58-25.19-28.47-28.98-27.88-7.61-24.52-5.62-44.95-26.41-10.17-10.35-25-14.4-38.89-10.61-27.87 7.6-23.98 7.61-51.9 0-13.89-3.79-28.72.25-38.89 10.61-20.41 20.78-17.05 18.8-44.94 26.41-13.89 3.79-24.75 14.84-28.47 28.98-7.47 28.39-5.54 24.97-25.95 45.75-10.17 10.35-14.15 25.44-10.42 39.58 7.47 28.36 7.48 24.4 0 52.82-3.72 14.14.25 29.23 10.42 39.59 20.41 20.78 18.47 17.35 25.95 45.75 3.72 14.14 14.58 25.19 28.47 28.98C104.6 325.96 106.27 325 121 340c13.23 13.47 33.84 15.88 49.74 5.82a39.676 39.676 0 0 1 42.53 0c15.89 10.06 36.5 7.65 49.73-5.82zM97.66 175.96c0-53.03 42.24-96.02 94.34-96.02s94.34 42.99 94.34 96.02-42.24 96.02-94.34 96.02-94.34-42.99-94.34-96.02z"
        ],
        baby: [
            384,
            512,
            [],
            "f77c",
            "M192 160c44.2 0 80-35.8 80-80S236.2 0 192 0s-80 35.8-80 80 35.8 80 80 80zm-53.4 248.8l25.6-32-61.5-51.2L56.8 383c-11.4 14.2-11.7 34.4-.8 49l48 64c7.9 10.5 19.9 16 32 16 8.3 0 16.8-2.6 24-8 17.7-13.2 21.2-38.3 8-56l-29.4-39.2zm142.7-83.2l-61.5 51.2 25.6 32L216 448c-13.2 17.7-9.7 42.8 8 56 7.2 5.4 15.6 8 24 8 12.2 0 24.2-5.5 32-16l48-64c10.9-14.6 10.6-34.8-.8-49l-45.9-57.4zM376.7 145c-12.7-18.1-37.6-22.4-55.7-9.8l-40.6 28.5c-52.7 37-124.2 37-176.8 0L63 135.3C44.9 122.6 20 127 7.3 145-5.4 163.1-1 188 17 200.7l40.6 28.5c17 11.9 35.4 20.9 54.4 27.9V288h160v-30.8c19-7 37.4-16 54.4-27.9l40.6-28.5c18.1-12.8 22.4-37.7 9.7-55.8z"
        ],
        "baby-carriage": [
            512,
            512,
            [],
            "f77d",
            "M144.8 17c-11.3-17.8-37.2-22.8-54-9.4C35.3 51.9 0 118 0 192h256L144.8 17zM496 96h-48c-35.3 0-64 28.7-64 64v64H0c0 50.6 23 96.4 60.3 130.7C25.7 363.6 0 394.7 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-8.9-1.8-17.2-4.4-25.2 21.6 5.9 44.6 9.2 68.4 9.2s46.9-3.3 68.4-9.2c-2.7 8-4.4 16.3-4.4 25.2 0 44.2 35.8 80 80 80s80-35.8 80-80c0-37.3-25.7-68.4-60.3-77.3C425 320.4 448 274.6 448 224v-64h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM80 464c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm320-32c0 17.6-14.4 32-32 32s-32-14.4-32-32 14.4-32 32-32 32 14.4 32 32z"
        ],
        backspace: [
            640,
            512,
            [],
            "f55a",
            "M576 64H205.26A63.97 63.97 0 0 0 160 82.75L9.37 233.37c-12.5 12.5-12.5 32.76 0 45.25L160 429.25c12 12 28.28 18.75 45.25 18.75H576c35.35 0 64-28.65 64-64V128c0-35.35-28.65-64-64-64zm-84.69 254.06c6.25 6.25 6.25 16.38 0 22.63l-22.62 22.62c-6.25 6.25-16.38 6.25-22.63 0L384 301.25l-62.06 62.06c-6.25 6.25-16.38 6.25-22.63 0l-22.62-22.62c-6.25-6.25-6.25-16.38 0-22.63L338.75 256l-62.06-62.06c-6.25-6.25-6.25-16.38 0-22.63l22.62-22.62c6.25-6.25 16.38-6.25 22.63 0L384 210.75l62.06-62.06c6.25-6.25 16.38-6.25 22.63 0l22.62 22.62c6.25 6.25 6.25 16.38 0 22.63L429.25 256l62.06 62.06z"
        ],
        backward: [
            512,
            512,
            [],
            "f04a",
            "M11.5 280.6l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2zm256 0l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2z"
        ],
        bacon: [
            576,
            512,
            [],
            "f7e5",
            "M218.92 336.39c34.89-34.89 44.2-59.7 54.05-86 10.61-28.29 21.59-57.54 61.37-97.34s69.05-50.77 97.35-61.38c23.88-9 46.64-17.68 76.79-45.37L470.81 8.91a31 31 0 0 0-40.18-2.83c-13.64 10.1-25.15 14.39-41 20.3C247 79.52 209.26 191.29 200.65 214.1c-29.75 78.83-89.55 94.68-98.72 98.09-24.86 9.26-54.73 20.38-91.07 50.36C-3 374-3.63 395 9.07 407.61l35.76 35.51C80 410.52 107 400.15 133 390.39c26.27-9.84 51.06-19.12 85.92-54zm348-232l-35.75-35.51c-35.19 32.63-62.18 43-88.25 52.79-26.26 9.85-51.06 19.16-85.95 54s-44.19 59.69-54 86C292.33 290 281.34 319.22 241.55 359s-69 50.73-97.3 61.32c-23.86 9-46.61 17.66-76.72 45.33l37.68 37.43a31 31 0 0 0 40.18 2.82c13.6-10.06 25.09-14.34 40.94-20.24 142.2-53 180-164.1 188.94-187.69C405 219.18 464.8 203.3 474 199.86c24.87-9.27 54.74-20.4 91.11-50.41 13.89-11.4 14.52-32.45 1.82-45.05z"
        ],
        bacteria: [
            640,
            512,
            [],
            "e059",
            "M272.35,226.4A17.71,17.71,0,0,0,281.46,203l-4-9.08a121.29,121.29,0,0,1,12.36-3.08A83.34,83.34,0,0,0,323.57,177l10,9a17.76,17.76,0,1,0,23.92-26.27l-9.72-8.76a83.12,83.12,0,0,0,11.65-48.18l11.85-3.51a17.73,17.73,0,1,0-10.15-34l-11.34,3.36a84,84,0,0,0-36.38-35.57l2.84-10.85a17.8,17.8,0,0,0-34.47-8.93l-2.82,10.78a83.25,83.25,0,0,0-16.74,1.1C250.83,27,240,30.22,229.1,33.39l-3.38-9.46a17.8,17.8,0,0,0-33.56,11.89l3.49,9.8a286.74,286.74,0,0,0-43.94,23.57l-6.32-8.43a17.9,17.9,0,0,0-24.94-3.6A17.69,17.69,0,0,0,116.84,82l6.45,8.61a286.59,286.59,0,0,0-34.95,35.33l-8.82-6.42a17.84,17.84,0,0,0-24.89,3.86,17.66,17.66,0,0,0,3.88,24.77l8.88,6.47a286.6,286.6,0,0,0-23,43.91l-10.48-3.59a17.73,17.73,0,1,0-11.59,33.52L32.67,232c-2.79,10-5.79,19.84-7.52,30.22a83.16,83.16,0,0,0-.82,19l-11.58,3.43a17.73,17.73,0,1,0,10.13,34l11.27-3.33a83.51,83.51,0,0,0,36.39,35.43l-2.88,11.06a17.81,17.81,0,0,0,34.48,8.92l2.87-11c1,0,2.07.26,3.1.26a83.39,83.39,0,0,0,45.65-13.88l8.59,8.8a17.77,17.77,0,0,0,25.56-24.7l-9.14-9.37a83.41,83.41,0,0,0,12.08-31.05,119.08,119.08,0,0,1,3.87-15.53l9,4.22a17.74,17.74,0,1,0,15.15-32.09l-8.8-4.11c.67-1,1.2-2.08,1.9-3.05a119.89,119.89,0,0,1,7.87-9.41,121.73,121.73,0,0,1,11.65-11.4,119.49,119.49,0,0,1,9.94-7.82c1.12-.77,2.32-1.42,3.47-2.15l3.92,8.85a17.86,17.86,0,0,0,16.32,10.58A18.14,18.14,0,0,0,272.35,226.4ZM128,256a32,32,0,1,1,32-32A32,32,0,0,1,128,256Zm80-96a16,16,0,1,1,16-16A16,16,0,0,1,208,160Zm431.26,45.3a17.79,17.79,0,0,0-17.06-12.69,17.55,17.55,0,0,0-5.08.74l-11.27,3.33a83.61,83.61,0,0,0-36.39-35.43l2.88-11.06a17.81,17.81,0,0,0-34.48-8.91l-2.87,11c-1,0-2.07-.26-3.1-.26a83.32,83.32,0,0,0-45.65,13.89l-8.59-8.81a17.77,17.77,0,0,0-25.56,24.7l9.14,9.37a83.28,83.28,0,0,0-12.08,31.06,119.34,119.34,0,0,1-3.87,15.52l-9-4.22a17.74,17.74,0,1,0-15.15,32.09l8.8,4.11c-.67,1-1.2,2.08-1.89,3.05a117.71,117.71,0,0,1-7.94,9.47,119,119,0,0,1-11.57,11.33,121.59,121.59,0,0,1-10,7.83c-1.12.77-2.32,1.42-3.47,2.15l-3.92-8.85a17.86,17.86,0,0,0-16.32-10.58,18.14,18.14,0,0,0-7.18,1.5A17.71,17.71,0,0,0,358.54,309l4,9.08a118.71,118.71,0,0,1-12.36,3.08,83.34,83.34,0,0,0-33.77,13.9l-10-9a17.77,17.77,0,1,0-23.92,26.28l9.72,8.75a83.12,83.12,0,0,0-11.65,48.18l-11.86,3.51a17.73,17.73,0,1,0,10.16,34l11.34-3.36A84,84,0,0,0,326.61,479l-2.84,10.85a17.8,17.8,0,0,0,34.47,8.93L361.06,488a83.3,83.3,0,0,0,16.74-1.1c11.37-1.89,22.24-5.07,33.1-8.24l3.38,9.46a17.8,17.8,0,0,0,33.56-11.89l-3.49-9.79a287.66,287.66,0,0,0,43.94-23.58l6.32,8.43a17.88,17.88,0,0,0,24.93,3.6A17.67,17.67,0,0,0,523.16,430l-6.45-8.61a287.37,287.37,0,0,0,34.95-35.34l8.82,6.42a17.76,17.76,0,1,0,21-28.63l-8.88-6.46a287.17,287.17,0,0,0,23-43.92l10.48,3.59a17.73,17.73,0,1,0,11.59-33.52L607.33,280c2.79-10,5.79-19.84,7.52-30.21a83.27,83.27,0,0,0,.82-19.05l11.58-3.43A17.7,17.7,0,0,0,639.26,205.3ZM416,416a32,32,0,1,1,32-32A32,32,0,0,1,416,416Z"
        ],
        bacterium: [
            512,
            512,
            [],
            "e05a",
            "M511,102.93A23.76,23.76,0,0,0,481.47,87l-15.12,4.48a111.85,111.85,0,0,0-48.5-47.42l3.79-14.47a23.74,23.74,0,0,0-46-11.91l-3.76,14.37a111.94,111.94,0,0,0-22.33,1.47,386.74,386.74,0,0,0-44.33,10.41l-4.3-12a23.74,23.74,0,0,0-44.75,15.85l4.3,12.05a383.4,383.4,0,0,0-58.69,31.83l-8-10.63a23.85,23.85,0,0,0-33.24-4.8,23.57,23.57,0,0,0-4.83,33.09l8,10.63a386.14,386.14,0,0,0-46.7,47.44l-11-8a23.68,23.68,0,1,0-28,38.17l11.09,8.06a383.45,383.45,0,0,0-30.92,58.75l-12.93-4.43a23.65,23.65,0,1,0-15.47,44.69l13,4.48a385.81,385.81,0,0,0-9.3,40.53A111.58,111.58,0,0,0,32.44,375L17,379.56a23.64,23.64,0,0,0,13.51,45.31l15-4.44a111.49,111.49,0,0,0,48.53,47.24l-3.85,14.75a23.66,23.66,0,0,0,17,28.83,24.7,24.7,0,0,0,6,.75,23.73,23.73,0,0,0,23-17.7L140,479.67c1.37.05,2.77.35,4.13.35A111.22,111.22,0,0,0,205,461.5l11.45,11.74a23.7,23.7,0,0,0,34.08-32.93l-12.19-12.5a111,111,0,0,0,16.11-41.4,158.69,158.69,0,0,1,5.16-20.71l12,5.64a23.66,23.66,0,1,0,20.19-42.79l-11.72-5.49c.89-1.32,1.59-2.77,2.52-4.06a157.86,157.86,0,0,1,10.46-12.49,159.5,159.5,0,0,1,15.59-15.28,162.18,162.18,0,0,1,13.23-10.4c1.5-1,3.1-1.89,4.63-2.87l5.23,11.8a23.74,23.74,0,0,0,43.48-19.08l-5.36-12.11a158.87,158.87,0,0,1,16.49-4.1,111,111,0,0,0,45-18.54l13.33,12a23.69,23.69,0,1,0,31.88-35l-12.94-11.67A110.83,110.83,0,0,0,479.21,137L495,132.32A23.61,23.61,0,0,0,511,102.93ZM160,368a48,48,0,1,1,48-48A48,48,0,0,1,160,368Zm80-136a24,24,0,1,1,24-24A24,24,0,0,1,240,232Z"
        ],
        bahai: [
            512,
            512,
            [],
            "f666",
            "M496.25 202.52l-110-15.44 41.82-104.34c6.67-16.64-11.6-32.18-26.59-22.63L307.44 120 273.35 12.82C270.64 4.27 263.32 0 256 0c-7.32 0-14.64 4.27-17.35 12.82l-34.09 107.19-94.04-59.89c-14.99-9.55-33.25 5.99-26.59 22.63l41.82 104.34-110 15.43c-17.54 2.46-21.68 26.27-6.03 34.67l98.16 52.66-74.48 83.54c-10.92 12.25-1.72 30.93 13.29 30.93 1.31 0 2.67-.14 4.07-.45l108.57-23.65-4.11 112.55c-.43 11.65 8.87 19.22 18.41 19.22 5.15 0 10.39-2.21 14.2-7.18l68.18-88.9 68.18 88.9c3.81 4.97 9.04 7.18 14.2 7.18 9.54 0 18.84-7.57 18.41-19.22l-4.11-112.55 108.57 23.65c17.36 3.76 29.21-17.2 17.35-30.49l-74.48-83.54 98.16-52.66c15.64-8.39 11.5-32.2-6.04-34.66zM338.51 311.68l-51.89-11.3 1.97 53.79L256 311.68l-32.59 42.49 1.96-53.79-51.89 11.3 35.6-39.93-46.92-25.17 52.57-7.38-19.99-49.87 44.95 28.62L256 166.72l16.29 51.23 44.95-28.62-19.99 49.87 52.57 7.38-46.92 25.17 35.61 39.93z"
        ],
        "balance-scale": [
            640,
            512,
            [],
            "f24e",
            "M256 336h-.02c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0C-2.06 328.75.02 320.33.02 336H0c0 44.18 57.31 80 128 80s128-35.82 128-80zM128 176l72 144H56l72-144zm511.98 160c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 320l72-144 72 144H440zm88 128H352V153.25c23.51-10.29 41.16-31.48 46.39-57.25H528c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H383.64C369.04 12.68 346.09 0 320 0s-49.04 12.68-63.64 32H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h129.61c5.23 25.76 22.87 46.96 46.39 57.25V448H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
        ],
        "balance-scale-left": [
            640,
            512,
            [],
            "f515",
            "M528 448H352V153.25c20.42-8.94 36.1-26.22 43.38-47.47l132-44.26c8.38-2.81 12.89-11.88 10.08-20.26l-10.17-30.34C524.48 2.54 515.41-1.97 507.03.84L389.11 40.37C375.3 16.36 349.69 0 320 0c-44.18 0-80 35.82-80 80 0 3.43.59 6.71 1.01 10.03l-128.39 43.05c-8.38 2.81-12.89 11.88-10.08 20.26l10.17 30.34c2.81 8.38 11.88 12.89 20.26 10.08l142.05-47.63c4.07 2.77 8.43 5.12 12.99 7.12V496c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16v-32c-.01-8.84-7.17-16-16.01-16zm111.98-144c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 288l72-144 72 144H440zm-269.07-37.51c-17.65-35.29-68.19-35.36-85.87 0C-2.06 424.75.02 416.33.02 432H0c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-16.18 1.34-8.73-85.05-181.51zM56 416l72-144 72 144H56z"
        ],
        "balance-scale-right": [
            640,
            512,
            [],
            "f516",
            "M96 464v32c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16V153.25c4.56-2 8.92-4.35 12.99-7.12l142.05 47.63c8.38 2.81 17.45-1.71 20.26-10.08l10.17-30.34c2.81-8.38-1.71-17.45-10.08-20.26l-128.4-43.05c.42-3.32 1.01-6.6 1.01-10.03 0-44.18-35.82-80-80-80-29.69 0-55.3 16.36-69.11 40.37L132.96.83c-8.38-2.81-17.45 1.71-20.26 10.08l-10.17 30.34c-2.81 8.38 1.71 17.45 10.08 20.26l132 44.26c7.28 21.25 22.96 38.54 43.38 47.47V448H112c-8.84 0-16 7.16-16 16zM0 304c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0C-1.32 295.27.02 287.82.02 304H0zm56-16l72-144 72 144H56zm328.02 144H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0-86.38 172.78-85.04 165.33-85.04 181.51zM440 416l72-144 72 144H440z"
        ],
        ban: [
            512,
            512,
            [],
            "f05e",
            "M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z"
        ],
        "band-aid": [
            640,
            512,
            [],
            "f462",
            "M0 160v192c0 35.3 28.7 64 64 64h96V96H64c-35.3 0-64 28.7-64 64zm576-64h-96v320h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64zM192 416h256V96H192v320zm176-232c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24z"
        ],
        barcode: [
            512,
            512,
            [],
            "f02a",
            "M0 448V64h18v384H0zm26.857-.273V64H36v383.727h-9.143zm27.143 0V64h8.857v383.727H54zm44.857 0V64h8.857v383.727h-8.857zm36 0V64h17.714v383.727h-17.714zm44.857 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm35.715 0V64h18v383.727h-18zm44.857 0V64h18v383.727h-18zm35.999 0V64h18.001v383.727h-18.001zm36.001 0V64h18.001v383.727h-18.001zm26.857 0V64h18v383.727h-18zm45.143 0V64h26.857v383.727h-26.857zm35.714 0V64h9.143v383.727H476zm18 .273V64h18v384h-18z"
        ],
        bars: [
            448,
            512,
            [],
            "f0c9",
            "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
        ],
        "baseball-ball": [
            496,
            512,
            [],
            "f433",
            "M368.5 363.9l28.8-13.9c11.1 22.9 26 43.2 44.1 60.9 34-42.5 54.5-96.3 54.5-154.9 0-58.5-20.4-112.2-54.2-154.6-17.8 17.3-32.6 37.1-43.6 59.5l-28.7-14.1c12.8-26 30-49 50.8-69C375.6 34.7 315 8 248 8 181.1 8 120.5 34.6 75.9 77.7c20.7 19.9 37.9 42.9 50.7 68.8l-28.7 14.1c-11-22.3-25.7-42.1-43.5-59.4C20.4 143.7 0 197.4 0 256c0 58.6 20.4 112.3 54.4 154.7 18.2-17.7 33.2-38 44.3-61l28.8 13.9c-12.9 26.7-30.3 50.3-51.5 70.7 44.5 43.1 105.1 69.7 172 69.7 66.8 0 127.3-26.5 171.9-69.5-21.1-20.4-38.5-43.9-51.4-70.6zm-228.3-32l-30.5-9.8c14.9-46.4 12.7-93.8-.6-134l30.4-10c15 45.6 18 99.9.7 153.8zm216.3-153.4l30.4 10c-13.2 40.1-15.5 87.5-.6 134l-30.5 9.8c-17.3-54-14.3-108.3.7-153.8z"
        ],
        "basketball-ball": [
            496,
            512,
            [],
            "f434",
            "M212.3 10.3c-43.8 6.3-86.2 24.1-122.2 53.8l77.4 77.4c27.8-35.8 43.3-81.2 44.8-131.2zM248 222L405.9 64.1c-42.4-35-93.6-53.5-145.5-56.1-1.2 63.9-21.5 122.3-58.7 167.7L248 222zM56.1 98.1c-29.7 36-47.5 78.4-53.8 122.2 50-1.5 95.5-17 131.2-44.8L56.1 98.1zm272.2 204.2c45.3-37.1 103.7-57.4 167.7-58.7-2.6-51.9-21.1-103.1-56.1-145.5L282 256l46.3 46.3zM248 290L90.1 447.9c42.4 34.9 93.6 53.5 145.5 56.1 1.3-64 21.6-122.4 58.7-167.7L248 290zm191.9 123.9c29.7-36 47.5-78.4 53.8-122.2-50.1 1.6-95.5 17.1-131.2 44.8l77.4 77.4zM167.7 209.7C122.3 246.9 63.9 267.3 0 268.4c2.6 51.9 21.1 103.1 56.1 145.5L214 256l-46.3-46.3zm116 292c43.8-6.3 86.2-24.1 122.2-53.8l-77.4-77.4c-27.7 35.7-43.2 81.2-44.8 131.2z"
        ],
        bath: [
            512,
            512,
            [],
            "f2cd",
            "M32,384a95.4,95.4,0,0,0,32,71.09V496a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V480H384v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V455.09A95.4,95.4,0,0,0,480,384V336H32ZM496,256H80V69.25a21.26,21.26,0,0,1,36.28-15l19.27,19.26c-13.13,29.88-7.61,59.11,8.62,79.73l-.17.17A16,16,0,0,0,144,176l11.31,11.31a16,16,0,0,0,22.63,0L283.31,81.94a16,16,0,0,0,0-22.63L272,48a16,16,0,0,0-22.62,0l-.17.17c-20.62-16.23-49.83-21.75-79.73-8.62L150.22,20.28A69.25,69.25,0,0,0,32,69.25V256H16A16,16,0,0,0,0,272v16a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V272A16,16,0,0,0,496,256Z"
        ],
        "battery-empty": [
            640,
            512,
            [],
            "f244",
            "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48z"
        ],
        "battery-full": [
            640,
            512,
            [],
            "f240",
            "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-48 96H96v128h416V192z"
        ],
        "battery-half": [
            640,
            512,
            [],
            "f242",
            "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-240 96H96v128h224V192z"
        ],
        "battery-quarter": [
            640,
            512,
            [],
            "f243",
            "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-336 96H96v128h128V192z"
        ],
        "battery-three-quarters": [
            640,
            512,
            [],
            "f241",
            "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-144 96H96v128h320V192z"
        ],
        bed: [
            640,
            512,
            [],
            "f236",
            "M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z"
        ],
        beer: [
            448,
            512,
            [],
            "f0fc",
            "M368 96h-48V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24v-42.11l80.606-35.977C429.396 365.063 448 336.388 448 304.86V176c0-44.112-35.888-80-80-80zm16 208.86a16.018 16.018 0 0 1-9.479 14.611L320 343.805V160h48c8.822 0 16 7.178 16 16v128.86zM208 384c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16zm-96 0c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16z"
        ],
        bell: [
            448,
            512,
            [],
            "f0f3",
            "M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"
        ],
        "bell-slash": [
            640,
            512,
            [],
            "f1f6",
            "M633.82 458.1l-90.62-70.05c.19-1.38.8-2.66.8-4.06.05-7.55-2.61-15.27-8.61-21.71-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-40.33 8.38-74.66 31.07-97.59 62.57L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.35 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.42-6.97 4.17-17.02-2.81-22.45zM157.23 251.54c-8.61 67.96-36.41 93.33-52.62 110.75-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h241.92L157.23 251.54zM320 512c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"
        ],
        "bezier-curve": [
            640,
            512,
            [],
            "f55b",
            "M368 32h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM208 88h-84.75C113.75 64.56 90.84 48 64 48 28.66 48 0 76.65 0 112s28.66 64 64 64c26.84 0 49.75-16.56 59.25-40h79.73c-55.37 32.52-95.86 87.32-109.54 152h49.4c11.3-41.61 36.77-77.21 71.04-101.56-3.7-8.08-5.88-16.99-5.88-26.44V88zm-48 232H64c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zM576 48c-26.84 0-49.75 16.56-59.25 40H432v72c0 9.45-2.19 18.36-5.88 26.44 34.27 24.35 59.74 59.95 71.04 101.56h49.4c-13.68-64.68-54.17-119.48-109.54-152h79.73c9.5 23.44 32.41 40 59.25 40 35.34 0 64-28.65 64-64s-28.66-64-64-64zm0 272h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
        ],
        bible: [
            448,
            512,
            [],
            "f647",
            "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM144 144c0-8.84 7.16-16 16-16h48V80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v48h48c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-48v112c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V192h-48c-8.84 0-16-7.16-16-16v-32zm236.8 304H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"
        ],
        bicycle: [
            640,
            512,
            [],
            "f206",
            "M512.509 192.001c-16.373-.064-32.03 2.955-46.436 8.495l-77.68-125.153A24 24 0 0 0 368.001 64h-64c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h50.649l14.896 24H256.002v-16c0-8.837-7.163-16-16-16h-87.459c-13.441 0-24.777 10.999-24.536 24.437.232 13.044 10.876 23.563 23.995 23.563h48.726l-29.417 47.52c-13.433-4.83-27.904-7.483-42.992-7.52C58.094 191.83.412 249.012.002 319.236-.413 390.279 57.055 448 128.002 448c59.642 0 109.758-40.793 123.967-96h52.033a24 24 0 0 0 20.406-11.367L410.37 201.77l14.938 24.067c-25.455 23.448-41.385 57.081-41.307 94.437.145 68.833 57.899 127.051 126.729 127.719 70.606.685 128.181-55.803 129.255-125.996 1.086-70.941-56.526-129.72-127.476-129.996zM186.75 265.772c9.727 10.529 16.673 23.661 19.642 38.228h-43.306l23.664-38.228zM128.002 400c-44.112 0-80-35.888-80-80s35.888-80 80-80c5.869 0 11.586.653 17.099 1.859l-45.505 73.509C89.715 331.327 101.213 352 120.002 352h81.3c-12.37 28.225-40.562 48-73.3 48zm162.63-96h-35.624c-3.96-31.756-19.556-59.894-42.383-80.026L237.371 184h127.547l-74.286 120zm217.057 95.886c-41.036-2.165-74.049-35.692-75.627-76.755-.812-21.121 6.633-40.518 19.335-55.263l44.433 71.586c4.66 7.508 14.524 9.816 22.032 5.156l13.594-8.437c7.508-4.66 9.817-14.524 5.156-22.032l-44.468-71.643a79.901 79.901 0 0 1 19.858-2.497c44.112 0 80 35.888 80 80-.001 45.54-38.252 82.316-84.313 79.885z"
        ],
        biking: [
            640,
            512,
            [],
            "f84a",
            "M400 96a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm-4 121a31.9 31.9 0 0 0 20 7h64a32 32 0 0 0 0-64h-52.78L356 103a31.94 31.94 0 0 0-40.81.68l-112 96a32 32 0 0 0 3.08 50.92L288 305.12V416a32 32 0 0 0 64 0V288a32 32 0 0 0-14.25-26.62l-41.36-27.57 58.25-49.92zm116 39a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64zM128 256a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64z"
        ],
        binoculars: [
            512,
            512,
            [],
            "f1e5",
            "M416 48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v48h96V48zM63.91 159.99C61.4 253.84 3.46 274.22 0 404v44c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V288h32V128H95.84c-17.63 0-31.45 14.37-31.93 31.99zm384.18 0c-.48-17.62-14.3-31.99-31.93-31.99H320v160h32v160c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-44c-3.46-129.78-61.4-150.16-63.91-244.01zM176 32h-64c-8.84 0-16 7.16-16 16v48h96V48c0-8.84-7.16-16-16-16zm48 256h64V128h-64v160z"
        ],
        biohazard: [
            576,
            512,
            [],
            "f780",
            "M287.9 112c18.6 0 36.2 3.8 52.8 9.6 13.3-10.3 23.6-24.3 29.5-40.7-25.2-10.9-53-17-82.2-17-29.1 0-56.9 6-82.1 16.9 5.9 16.4 16.2 30.4 29.5 40.7 16.5-5.7 34-9.5 52.5-9.5zM163.6 438.7c12-11.8 20.4-26.4 24.5-42.4-32.9-26.4-54.8-65.3-58.9-109.6-8.5-2.8-17.2-4.6-26.4-4.6-7.6 0-15.2 1-22.5 3.1 4.1 62.8 35.8 118 83.3 153.5zm224.2-42.6c4.1 16 12.5 30.7 24.5 42.5 47.4-35.5 79.1-90.7 83-153.5-7.2-2-14.7-3-22.2-3-9.2 0-18 1.9-26.6 4.7-4.1 44.2-26 82.9-58.7 109.3zm113.5-205c-17.6-10.4-36.3-16.6-55.3-19.9 6-17.7 10-36.4 10-56.2 0-41-14.5-80.8-41-112.2-2.5-3-6.6-3.7-10-1.8-3.3 1.9-4.8 6-3.6 9.7 4.5 13.8 6.6 26.3 6.6 38.5 0 67.8-53.8 122.9-120 122.9S168 117 168 49.2c0-12.1 2.2-24.7 6.6-38.5 1.2-3.7-.3-7.8-3.6-9.7-3.4-1.9-7.5-1.2-10 1.8C134.6 34.2 120 74 120 115c0 19.8 3.9 38.5 10 56.2-18.9 3.3-37.7 9.5-55.3 19.9-34.6 20.5-61 53.3-74.3 92.4-1.3 3.7.2 7.7 3.5 9.8 3.3 2 7.5 1.3 10-1.6 9.4-10.8 19-19.1 29.2-25.1 57.3-33.9 130.8-13.7 163.9 45 33.1 58.7 13.4 134-43.9 167.9-10.2 6.1-22 10.4-35.8 13.4-3.7.8-6.4 4.2-6.4 8.1.1 4 2.7 7.3 6.5 8 39.7 7.8 80.6.8 115.2-19.7 18-10.6 32.9-24.5 45.3-40.1 12.4 15.6 27.3 29.5 45.3 40.1 34.6 20.5 75.5 27.5 115.2 19.7 3.8-.7 6.4-4 6.5-8 0-3.9-2.6-7.3-6.4-8.1-13.9-2.9-25.6-7.3-35.8-13.4-57.3-33.9-77-109.2-43.9-167.9s106.6-78.9 163.9-45c10.2 6.1 19.8 14.3 29.2 25.1 2.5 2.9 6.7 3.6 10 1.6s4.8-6.1 3.5-9.8c-13.1-39.1-39.5-72-74.1-92.4zm-213.4 129c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
        ],
        "birthday-cake": [
            448,
            512,
            [],
            "f1fd",
            "M448 384c-28.02 0-31.26-32-74.5-32-43.43 0-46.825 32-74.75 32-27.695 0-31.454-32-74.75-32-42.842 0-47.218 32-74.5 32-28.148 0-31.202-32-74.75-32-43.547 0-46.653 32-74.75 32v-80c0-26.5 21.5-48 48-48h16V112h64v144h64V112h64v144h64V112h64v144h16c26.5 0 48 21.5 48 48v80zm0 128H0v-96c43.356 0 46.767-32 74.75-32 27.951 0 31.253 32 74.75 32 42.843 0 47.217-32 74.5-32 28.148 0 31.201 32 74.75 32 43.357 0 46.767-32 74.75-32 27.488 0 31.252 32 74.5 32v96zM96 96c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40z"
        ],
        blender: [
            512,
            512,
            [],
            "f517",
            "M416 384H160c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-128 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm40-416h166.54L512 0H48C21.49 0 0 21.49 0 48v160c0 26.51 21.49 48 48 48h103.27l8.73 96h256l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H328c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM64 192V64h69.82l11.64 128H64z"
        ],
        "blender-phone": [
            576,
            512,
            [],
            "f6b6",
            "M392 64h166.54L576 0H192v352h288l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H392c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM158.8 335.01l-25.78-63.26c-2.78-6.81-9.8-10.99-17.24-10.26l-45.03 4.42c-17.28-46.94-17.65-99.78 0-147.72l45.03 4.42c7.43.73 14.46-3.46 17.24-10.26l25.78-63.26c3.02-7.39.2-15.85-6.68-20.07l-39.28-24.1C98.51-3.87 80.09-.5 68.95 11.97c-92.57 103.6-92 259.55 2.1 362.49 9.87 10.8 29.12 12.48 41.65 4.8l39.41-24.18c6.89-4.22 9.7-12.67 6.69-20.07zM480 384H192c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-144 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        blind: [
            384,
            512,
            [],
            "f29d",
            "M380.15 510.837a8 8 0 0 1-10.989-2.687l-125.33-206.427a31.923 31.923 0 0 0 12.958-9.485l126.048 207.608a8 8 0 0 1-2.687 10.991zM142.803 314.338l-32.54 89.485 36.12 88.285c6.693 16.36 25.377 24.192 41.733 17.501 16.357-6.692 24.193-25.376 17.501-41.734l-62.814-153.537zM96 88c24.301 0 44-19.699 44-44S120.301 0 96 0 52 19.699 52 44s19.699 44 44 44zm154.837 169.128l-120-152c-4.733-5.995-11.75-9.108-18.837-9.112V96H80v.026c-7.146.003-14.217 3.161-18.944 9.24L0 183.766v95.694c0 13.455 11.011 24.791 24.464 24.536C37.505 303.748 48 293.1 48 280v-79.766l16-20.571v140.698L9.927 469.055c-6.04 16.609 2.528 34.969 19.138 41.009 16.602 6.039 34.968-2.524 41.009-19.138L136 309.638V202.441l-31.406-39.816a4 4 0 1 1 6.269-4.971l102.3 129.217c9.145 11.584 24.368 11.339 33.708 3.965 10.41-8.216 12.159-23.334 3.966-33.708z"
        ],
        blog: [
            512,
            512,
            [],
            "f781",
            "M172.2 226.8c-14.6-2.9-28.2 8.9-28.2 23.8V301c0 10.2 7.1 18.4 16.7 22 18.2 6.8 31.3 24.4 31.3 45 0 26.5-21.5 48-48 48s-48-21.5-48-48V120c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24v248c0 89.5 82.1 160.2 175 140.7 54.4-11.4 98.3-55.4 109.7-109.7 17.4-82.9-37-157.2-112.5-172.2zM209 0c-9.2-.5-17 6.8-17 16v31.6c0 8.5 6.6 15.5 15 15.9 129.4 7 233.4 112 240.9 241.5.5 8.4 7.5 15 15.9 15h32.1c9.2 0 16.5-7.8 16-17C503.4 139.8 372.2 8.6 209 0zm.3 96c-9.3-.7-17.3 6.7-17.3 16.1v32.1c0 8.4 6.5 15.3 14.8 15.9 76.8 6.3 138 68.2 144.9 145.2.8 8.3 7.6 14.7 15.9 14.7h32.2c9.3 0 16.8-8 16.1-17.3-8.4-110.1-96.5-198.2-206.6-206.7z"
        ],
        bold: [
            384,
            512,
            [],
            "f032",
            "M333.49 238a122 122 0 0 0 27-65.21C367.87 96.49 308 32 233.42 32H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h31.87v288H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h209.32c70.8 0 134.14-51.75 141-122.4 4.74-48.45-16.39-92.06-50.83-119.6zM145.66 112h87.76a48 48 0 0 1 0 96h-87.76zm87.76 288h-87.76V288h87.76a56 56 0 0 1 0 112z"
        ],
        bolt: [
            320,
            512,
            [],
            "f0e7",
            "M296 160H180.6l42.6-129.8C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8l-32 240C-1.7 275.2 9.5 288 24 288h118.7L96.6 482.5c-3.6 15.2 8 29.5 23.3 29.5 8.4 0 16.4-4.4 20.8-12l176-304c9.3-15.9-2.2-36-20.7-36z"
        ],
        bomb: [
            512,
            512,
            [],
            "f1e2",
            "M440.5 88.5l-52 52L415 167c9.4 9.4 9.4 24.6 0 33.9l-17.4 17.4c11.8 26.1 18.4 55.1 18.4 85.6 0 114.9-93.1 208-208 208S0 418.9 0 304 93.1 96 208 96c30.5 0 59.5 6.6 85.6 18.4L311 97c9.4-9.4 24.6-9.4 33.9 0l26.5 26.5 52-52 17.1 17zM500 60h-24c-6.6 0-12 5.4-12 12s5.4 12 12 12h24c6.6 0 12-5.4 12-12s-5.4-12-12-12zM440 0c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12s12-5.4 12-12V12c0-6.6-5.4-12-12-12zm33.9 55l17-17c4.7-4.7 4.7-12.3 0-17-4.7-4.7-12.3-4.7-17 0l-17 17c-4.7 4.7-4.7 12.3 0 17 4.8 4.7 12.4 4.7 17 0zm-67.8 0c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17zm67.8 34c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17zM112 272c0-35.3 28.7-64 64-64 8.8 0 16-7.2 16-16s-7.2-16-16-16c-52.9 0-96 43.1-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16z"
        ],
        bone: [
            640,
            512,
            [],
            "f5d7",
            "M598.88 244.56c25.2-12.6 41.12-38.36 41.12-66.53v-7.64C640 129.3 606.7 96 565.61 96c-32.02 0-60.44 20.49-70.57 50.86-7.68 23.03-11.6 45.14-38.11 45.14H183.06c-27.38 0-31.58-25.54-38.11-45.14C134.83 116.49 106.4 96 74.39 96 33.3 96 0 129.3 0 170.39v7.64c0 28.17 15.92 53.93 41.12 66.53 9.43 4.71 9.43 18.17 0 22.88C15.92 280.04 0 305.8 0 333.97v7.64C0 382.7 33.3 416 74.38 416c32.02 0 60.44-20.49 70.57-50.86 7.68-23.03 11.6-45.14 38.11-45.14h273.87c27.38 0 31.58 25.54 38.11 45.14C505.17 395.51 533.6 416 565.61 416c41.08 0 74.38-33.3 74.38-74.39v-7.64c0-28.18-15.92-53.93-41.12-66.53-9.42-4.71-9.42-18.17.01-22.88z"
        ],
        bong: [
            448,
            512,
            [],
            "f55c",
            "M302.5 512c23.18 0 44.43-12.58 56-32.66C374.69 451.26 384 418.75 384 384c0-36.12-10.08-69.81-27.44-98.62L400 241.94l9.38 9.38c6.25 6.25 16.38 6.25 22.63 0l11.3-11.32c6.25-6.25 6.25-16.38 0-22.63l-52.69-52.69c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l9.38 9.38-39.41 39.41c-11.56-11.37-24.53-21.33-38.65-29.51V63.74l15.97-.02c8.82-.01 15.97-7.16 15.98-15.98l.04-31.72C320 7.17 312.82-.01 303.97 0L80.03.26c-8.82.01-15.97 7.16-15.98 15.98l-.04 31.73c-.01 8.85 7.17 16.02 16.02 16.01L96 63.96v153.93C38.67 251.1 0 312.97 0 384c0 34.75 9.31 67.27 25.5 95.34C37.08 499.42 58.33 512 81.5 512h221zM120.06 259.43L144 245.56V63.91l96-.11v181.76l23.94 13.87c24.81 14.37 44.12 35.73 56.56 60.57h-257c12.45-24.84 31.75-46.2 56.56-60.57z"
        ],
        book: [
            448,
            512,
            [],
            "f02d",
            "M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z"
        ],
        "book-dead": [
            448,
            512,
            [],
            "f6b7",
            "M272 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm176 222.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM240 56c44.2 0 80 28.7 80 64 0 20.9-12.7 39.2-32 50.9V184c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-13.1c-19.3-11.7-32-30-32-50.9 0-35.3 35.8-64 80-64zM124.8 223.3l6.3-14.7c1.7-4.1 6.4-5.9 10.5-4.2l98.3 42.1 98.4-42.1c4.1-1.7 8.8.1 10.5 4.2l6.3 14.7c1.7 4.1-.1 8.8-4.2 10.5L280.6 264l70.3 30.1c4.1 1.7 5.9 6.4 4.2 10.5l-6.3 14.7c-1.7 4.1-6.4 5.9-10.5 4.2L240 281.4l-98.3 42.2c-4.1 1.7-8.8-.1-10.5-4.2l-6.3-14.7c-1.7-4.1.1-8.8 4.2-10.5l70.4-30.1-70.5-30.3c-4.1-1.7-5.9-6.4-4.2-10.5zm256 224.7H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8zM208 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z"
        ],
        "book-medical": [
            448,
            512,
            [],
            "f7e6",
            "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16q0-9.6-9.6-19.2c-3.2-16-3.2-60.8 0-73.6q9.6-4.8 9.6-19.2zM144 168a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8v48a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8zm236.8 280H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8z"
        ],
        "book-open": [
            576,
            512,
            [],
            "f518",
            "M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z"
        ],
        "book-reader": [
            512,
            512,
            [],
            "f5da",
            "M352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96 42.98 96 96 96 96-42.98 96-96zM233.59 241.1c-59.33-36.32-155.43-46.3-203.79-49.05C13.55 191.13 0 203.51 0 219.14v222.8c0 14.33 11.59 26.28 26.49 27.05 43.66 2.29 131.99 10.68 193.04 41.43 9.37 4.72 20.48-1.71 20.48-11.87V252.56c-.01-4.67-2.32-8.95-6.42-11.46zm248.61-49.05c-48.35 2.74-144.46 12.73-203.78 49.05-4.1 2.51-6.41 6.96-6.41 11.63v245.79c0 10.19 11.14 16.63 20.54 11.9 61.04-30.72 149.32-39.11 192.97-41.4 14.9-.78 26.49-12.73 26.49-27.06V219.14c-.01-15.63-13.56-28.01-29.81-27.09z"
        ],
        bookmark: [
            384,
            512,
            [],
            "f02e",
            "M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"
        ],
        "border-all": [
            448,
            512,
            [],
            "f84c",
            "M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-32 64v128H256V96zm-192 0v128H64V96zM64 416V288h128v128zm192 0V288h128v128z"
        ],
        "border-none": [
            448,
            512,
            [],
            "f850",
            "M240 224h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-288 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM240 320h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-384h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM48 224H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
        ],
        "border-style": [
            448,
            512,
            [],
            "f853",
            "M240 416h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm192 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H32A32 32 0 0 0 0 64v400a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V96h368a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
        ],
        "bowling-ball": [
            496,
            512,
            [],
            "f436",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM120 192c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64-96c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm48 144c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
        ],
        box: [
            512,
            512,
            [],
            "f466",
            "M509.5 184.6L458.9 32.8C452.4 13.2 434.1 0 413.4 0H272v192h238.7c-.4-2.5-.4-5-1.2-7.4zM240 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-.8 2.4-.8 4.9-1.2 7.4H240V0zM0 224v240c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V224H0z"
        ],
        "box-open": [
            640,
            512,
            [],
            "f49e",
            "M425.7 256c-16.9 0-32.8-9-41.4-23.4L320 126l-64.2 106.6c-8.7 14.5-24.6 23.5-41.5 23.5-4.5 0-9-.6-13.3-1.9L64 215v178c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V215l-137 39.1c-4.3 1.3-8.8 1.9-13.3 1.9zm212.6-112.2L586.8 41c-3.1-6.2-9.8-9.8-16.7-8.9L320 64l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1zM53.2 41L1.7 143.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 64 69.8 32.1c-6.9-.8-13.5 2.7-16.6 8.9z"
        ],
        "box-tissue": [
            512,
            512,
            [],
            "e05b",
            "M383.88,287.82l64-192H338.47a70.2,70.2,0,0,1-66.59-48,70.21,70.21,0,0,0-66.6-48H63.88l64,288Zm-384,192a32,32,0,0,0,32,32h448a32,32,0,0,0,32-32v-64H-.12Zm480-256H438.94l-21.33,64h14.27a16,16,0,0,1,0,32h-352a16,16,0,1,1,0-32H95.09l-14.22-64h-49a32,32,0,0,0-32,32v128h512v-128A32,32,0,0,0,479.88,223.82Z"
        ],
        boxes: [
            576,
            512,
            [],
            "f468",
            "M560 288h-80v96l-32-21.3-32 21.3v-96h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16zm-384-64h224c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16h-80v96l-32-21.3L256 96V0h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16zm64 64h-80v96l-32-21.3L96 384v-96H16c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16z"
        ],
        braille: [
            640,
            512,
            [],
            "f2a1",
            "M128 256c0 35.346-28.654 64-64 64S0 291.346 0 256s28.654-64 64-64 64 28.654 64 64zM64 384c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352C28.654 32 0 60.654 0 96s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm224 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-320c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
        ],
        brain: [
            576,
            512,
            [],
            "f5dc",
            "M208 0c-29.9 0-54.7 20.5-61.8 48.2-.8 0-1.4-.2-2.2-.2-35.3 0-64 28.7-64 64 0 4.8.6 9.5 1.7 14C52.5 138 32 166.6 32 200c0 12.6 3.2 24.3 8.3 34.9C16.3 248.7 0 274.3 0 304c0 33.3 20.4 61.9 49.4 73.9-.9 4.6-1.4 9.3-1.4 14.1 0 39.8 32.2 72 72 72 4.1 0 8.1-.5 12-1.2 9.6 28.5 36.2 49.2 68 49.2 39.8 0 72-32.2 72-72V64c0-35.3-28.7-64-64-64zm368 304c0-29.7-16.3-55.3-40.3-69.1 5.2-10.6 8.3-22.3 8.3-34.9 0-33.4-20.5-62-49.7-74 1-4.5 1.7-9.2 1.7-14 0-35.3-28.7-64-64-64-.8 0-1.5.2-2.2.2C422.7 20.5 397.9 0 368 0c-35.3 0-64 28.6-64 64v376c0 39.8 32.2 72 72 72 31.8 0 58.4-20.7 68-49.2 3.9.7 7.9 1.2 12 1.2 39.8 0 72-32.2 72-72 0-4.8-.5-9.5-1.4-14.1 29-12 49.4-40.6 49.4-73.9z"
        ],
        "bread-slice": [
            576,
            512,
            [],
            "f7ec",
            "M288 0C108 0 0 93.4 0 169.14 0 199.44 24.24 224 64 224v256c0 17.67 16.12 32 36 32h376c19.88 0 36-14.33 36-32V224c39.76 0 64-24.56 64-54.86C576 93.4 468 0 288 0z"
        ],
        briefcase: [
            512,
            512,
            [],
            "f0b1",
            "M320 336c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h416c25.6 0 48-22.4 48-48V288H320v48zm144-208h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128v32z"
        ],
        "briefcase-medical": [
            512,
            512,
            [],
            "f469",
            "M464 128h-80V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48zM192 96h128v32H192V96zm160 248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48z"
        ],
        "broadcast-tower": [
            640,
            512,
            [],
            "f519",
            "M150.94 192h33.73c11.01 0 18.61-10.83 14.86-21.18-4.93-13.58-7.55-27.98-7.55-42.82s2.62-29.24 7.55-42.82C203.29 74.83 195.68 64 184.67 64h-33.73c-7.01 0-13.46 4.49-15.41 11.23C130.64 92.21 128 109.88 128 128c0 18.12 2.64 35.79 7.54 52.76 1.94 6.74 8.39 11.24 15.4 11.24zM89.92 23.34C95.56 12.72 87.97 0 75.96 0H40.63c-6.27 0-12.14 3.59-14.74 9.31C9.4 45.54 0 85.65 0 128c0 24.75 3.12 68.33 26.69 118.86 2.62 5.63 8.42 9.14 14.61 9.14h34.84c12.02 0 19.61-12.74 13.95-23.37-49.78-93.32-16.71-178.15-.17-209.29zM614.06 9.29C611.46 3.58 605.6 0 599.33 0h-35.42c-11.98 0-19.66 12.66-14.02 23.25 18.27 34.29 48.42 119.42.28 209.23-5.72 10.68 1.8 23.52 13.91 23.52h35.23c6.27 0 12.13-3.58 14.73-9.29C630.57 210.48 640 170.36 640 128s-9.42-82.48-25.94-118.71zM489.06 64h-33.73c-11.01 0-18.61 10.83-14.86 21.18 4.93 13.58 7.55 27.98 7.55 42.82s-2.62 29.24-7.55 42.82c-3.76 10.35 3.85 21.18 14.86 21.18h33.73c7.02 0 13.46-4.49 15.41-11.24 4.9-16.97 7.53-34.64 7.53-52.76 0-18.12-2.64-35.79-7.54-52.76-1.94-6.75-8.39-11.24-15.4-11.24zm-116.3 100.12c7.05-10.29 11.2-22.71 11.2-36.12 0-35.35-28.63-64-63.96-64-35.32 0-63.96 28.65-63.96 64 0 13.41 4.15 25.83 11.2 36.12l-130.5 313.41c-3.4 8.15.46 17.52 8.61 20.92l29.51 12.31c8.15 3.4 17.52-.46 20.91-8.61L244.96 384h150.07l49.2 118.15c3.4 8.16 12.76 12.01 20.91 8.61l29.51-12.31c8.15-3.4 12-12.77 8.61-20.92l-130.5-313.41zM271.62 320L320 203.81 368.38 320h-96.76z"
        ],
        broom: [
            640,
            512,
            [],
            "f51a",
            "M256.47 216.77l86.73 109.18s-16.6 102.36-76.57 150.12C206.66 523.85 0 510.19 0 510.19s3.8-23.14 11-55.43l94.62-112.17c3.97-4.7-.87-11.62-6.65-9.5l-60.4 22.09c14.44-41.66 32.72-80.04 54.6-97.47 59.97-47.76 163.3-40.94 163.3-40.94zM636.53 31.03l-19.86-25c-5.49-6.9-15.52-8.05-22.41-2.56l-232.48 177.8-34.14-42.97c-5.09-6.41-15.14-5.21-18.59 2.21l-25.33 54.55 86.73 109.18 58.8-12.45c8-1.69 11.42-11.2 6.34-17.6l-34.09-42.92 232.48-177.8c6.89-5.48 8.04-15.53 2.55-22.44z"
        ],
        brush: [
            384,
            512,
            [],
            "f55d",
            "M352 0H32C14.33 0 0 14.33 0 32v224h384V32c0-17.67-14.33-32-32-32zM0 320c0 35.35 28.66 64 64 64h64v64c0 35.35 28.66 64 64 64s64-28.65 64-64v-64h64c35.34 0 64-28.65 64-64v-32H0v32zm192 104c13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24s-24-10.75-24-24c0-13.26 10.75-24 24-24z"
        ],
        bug: [
            512,
            512,
            [],
            "f188",
            "M511.988 288.9c-.478 17.43-15.217 31.1-32.653 31.1H424v16c0 21.864-4.882 42.584-13.6 61.145l60.228 60.228c12.496 12.497 12.496 32.758 0 45.255-12.498 12.497-32.759 12.496-45.256 0l-54.736-54.736C345.886 467.965 314.351 480 280 480V236c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v244c-34.351 0-65.886-12.035-90.636-32.108l-54.736 54.736c-12.498 12.497-32.759 12.496-45.256 0-12.496-12.497-12.496-32.758 0-45.255l60.228-60.228C92.882 378.584 88 357.864 88 336v-16H32.666C15.23 320 .491 306.33.013 288.9-.484 270.816 14.028 256 32 256h56v-58.745l-46.628-46.628c-12.496-12.497-12.496-32.758 0-45.255 12.498-12.497 32.758-12.497 45.256 0L141.255 160h229.489l54.627-54.627c12.498-12.497 32.758-12.497 45.256 0 12.496 12.497 12.496 32.758 0 45.255L424 197.255V256h56c17.972 0 32.484 14.816 31.988 32.9zM257 0c-61.856 0-112 50.144-112 112h224C369 50.144 318.856 0 257 0z"
        ],
        building: [
            448,
            512,
            [],
            "f1ad",
            "M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z"
        ],
        bullhorn: [
            576,
            512,
            [],
            "f0a1",
            "M576 240c0-23.63-12.95-44.04-32-55.12V32.01C544 23.26 537.02 0 512 0c-7.12 0-14.19 2.38-19.98 7.02l-85.03 68.03C364.28 109.19 310.66 128 256 128H64c-35.35 0-64 28.65-64 64v96c0 35.35 28.65 64 64 64h33.7c-1.39 10.48-2.18 21.14-2.18 32 0 39.77 9.26 77.35 25.56 110.94 5.19 10.69 16.52 17.06 28.4 17.06h74.28c26.05 0 41.69-29.84 25.9-50.56-16.4-21.52-26.15-48.36-26.15-77.44 0-11.11 1.62-21.79 4.41-32H256c54.66 0 108.28 18.81 150.98 52.95l85.03 68.03a32.023 32.023 0 0 0 19.98 7.02c24.92 0 32-22.78 32-32V295.13C563.05 284.04 576 263.63 576 240zm-96 141.42l-33.05-26.44C392.95 311.78 325.12 288 256 288v-96c69.12 0 136.95-23.78 190.95-66.98L480 98.58v282.84z"
        ],
        bullseye: [
            496,
            512,
            [],
            "f140",
            "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 432c-101.69 0-184-82.29-184-184 0-101.69 82.29-184 184-184 101.69 0 184 82.29 184 184 0 101.69-82.29 184-184 184zm0-312c-70.69 0-128 57.31-128 128s57.31 128 128 128 128-57.31 128-128-57.31-128-128-128zm0 192c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"
        ],
        burn: [
            384,
            512,
            [],
            "f46a",
            "M192 0C79.7 101.3 0 220.9 0 300.5 0 425 79 512 192 512s192-87 192-211.5c0-79.9-80.2-199.6-192-300.5zm0 448c-56.5 0-96-39-96-94.8 0-13.5 4.6-61.5 96-161.2 91.4 99.7 96 147.7 96 161.2 0 55.8-39.5 94.8-96 94.8z"
        ],
        bus: [
            512,
            512,
            [],
            "f207",
            "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM112 400c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm16-112c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h256c17.67 0 32 14.33 32 32v128c0 17.67-14.33 32-32 32H128zm272 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        "bus-alt": [
            512,
            512,
            [],
            "f55e",
            "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM160 72c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H168c-4.42 0-8-3.58-8-8V72zm-48 328c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128-112H128c-17.67 0-32-14.33-32-32v-96c0-17.67 14.33-32 32-32h112v160zm32 0V128h112c17.67 0 32 14.33 32 32v96c0 17.67-14.33 32-32 32H272zm128 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        "business-time": [
            640,
            512,
            [],
            "f64a",
            "M496 224c-79.59 0-144 64.41-144 144s64.41 144 144 144 144-64.41 144-144-64.41-144-144-144zm64 150.29c0 5.34-4.37 9.71-9.71 9.71h-60.57c-5.34 0-9.71-4.37-9.71-9.71v-76.57c0-5.34 4.37-9.71 9.71-9.71h12.57c5.34 0 9.71 4.37 9.71 9.71V352h38.29c5.34 0 9.71 4.37 9.71 9.71v12.58zM496 192c5.4 0 10.72.33 16 .81V144c0-25.6-22.4-48-48-48h-80V48c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h395.12c28.6-20.09 63.35-32 100.88-32zM320 96H192V64h128v32zm6.82 224H208c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h291.43C327.1 423.96 320 396.82 320 368c0-16.66 2.48-32.72 6.82-48z"
        ],
        calculator: [
            448,
            512,
            [],
            "f1ec",
            "M400 0H48C22.4 0 0 22.4 0 48v416c0 25.6 22.4 48 48 48h352c25.6 0 48-22.4 48-48V48c0-25.6-22.4-48-48-48zM128 435.2c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8V268.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v166.4zm0-256c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8V76.8C64 70.4 70.4 64 76.8 64h294.4c6.4 0 12.8 6.4 12.8 12.8v102.4z"
        ],
        calendar: [
            448,
            512,
            [],
            "f133",
            "M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z"
        ],
        "calendar-alt": [
            448,
            512,
            [],
            "f073",
            "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
        ],
        "calendar-check": [
            448,
            512,
            [],
            "f274",
            "M436 160H12c-6.627 0-12-5.373-12-12v-36c0-26.51 21.49-48 48-48h48V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h128V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h48c26.51 0 48 21.49 48 48v36c0 6.627-5.373 12-12 12zM12 192h424c6.627 0 12 5.373 12 12v260c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V204c0-6.627 5.373-12 12-12zm333.296 95.947l-28.169-28.398c-4.667-4.705-12.265-4.736-16.97-.068L194.12 364.665l-45.98-46.352c-4.667-4.705-12.266-4.736-16.971-.068l-28.397 28.17c-4.705 4.667-4.736 12.265-.068 16.97l82.601 83.269c4.667 4.705 12.265 4.736 16.97.068l142.953-141.805c4.705-4.667 4.736-12.265.068-16.97z"
        ],
        "calendar-day": [
            448,
            512,
            [],
            "f783",
            "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-96zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
        ],
        "calendar-minus": [
            448,
            512,
            [],
            "f272",
            "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm304 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H132c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h184z"
        ],
        "calendar-plus": [
            448,
            512,
            [],
            "f271",
            "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm316 140c0-6.6-5.4-12-12-12h-60v-60c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v60h-60c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h60v60c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-60h60c6.6 0 12-5.4 12-12v-40z"
        ],
        "calendar-times": [
            448,
            512,
            [],
            "f273",
            "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm257.3 160l48.1-48.1c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0L224 306.7l-48.1-48.1c-4.7-4.7-12.3-4.7-17 0l-28.3 28.3c-4.7 4.7-4.7 12.3 0 17l48.1 48.1-48.1 48.1c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l48.1-48.1 48.1 48.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L269.3 352z"
        ],
        "calendar-week": [
            448,
            512,
            [],
            "f784",
            "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-64zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
        ],
        camera: [
            512,
            512,
            [],
            "f030",
            "M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z"
        ],
        "camera-retro": [
            512,
            512,
            [],
            "f083",
            "M48 32C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm0 32h106c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H38c-3.3 0-6-2.7-6-6V80c0-8.8 7.2-16 16-16zm426 96H38c-3.3 0-6-2.7-6-6v-36c0-3.3 2.7-6 6-6h138l30.2-45.3c1.1-1.7 3-2.7 5-2.7H464c8.8 0 16 7.2 16 16v74c0 3.3-2.7 6-6 6zM256 424c-66.2 0-120-53.8-120-120s53.8-120 120-120 120 53.8 120 120-53.8 120-120 120zm0-208c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm-48 104c-8.8 0-16-7.2-16-16 0-35.3 28.7-64 64-64 8.8 0 16 7.2 16 16s-7.2 16-16 16c-17.6 0-32 14.4-32 32 0 8.8-7.2 16-16 16z"
        ],
        campground: [
            640,
            512,
            [],
            "f6bb",
            "M624 448h-24.68L359.54 117.75l53.41-73.55c5.19-7.15 3.61-17.16-3.54-22.35l-25.9-18.79c-7.15-5.19-17.15-3.61-22.35 3.55L320 63.3 278.83 6.6c-5.19-7.15-15.2-8.74-22.35-3.55l-25.88 18.8c-7.15 5.19-8.74 15.2-3.54 22.35l53.41 73.55L40.68 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM320 288l116.36 160H203.64L320 288z"
        ],
        "candy-cane": [
            512,
            512,
            [],
            "f786",
            "M497.5 92C469.6 33.1 411.8 0 352.4 0c-27.9 0-56.2 7.3-81.8 22.6L243.1 39c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5l27.5-16.4c5.1-3.1 10.8-4.5 16.4-4.5 10.9 0 21.5 5.6 27.5 15.6 9.1 15.1 4.1 34.8-11 43.9L15.6 397.6c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5L428.6 301c71.7-42.9 104.6-133.5 68.9-209zm-177.7 13l-2.5 1.5L296.8 45c9.7-4.7 19.8-8.1 30.3-10.2l20.6 61.8c-9.8.8-19.4 3.3-27.9 8.4zM145.9 431.8l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm107.5-63.9l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zM364.3 302l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm20.4-197.3l46-46c8.4 6.5 16 14.1 22.6 22.6L407.6 127c-5.7-9.3-13.7-16.9-22.9-22.3zm82.1 107.8l-59.5-19.8c3.2-5.3 5.8-10.9 7.4-17.1 1.1-4.5 1.7-9.1 1.8-13.6l60.4 20.1c-2.1 10.4-5.5 20.6-10.1 30.4z"
        ],
        cannabis: [
            512,
            512,
            [],
            "f55f",
            "M503.47 360.25c-1.56-.82-32.39-16.89-76.78-25.81 64.25-75.12 84.05-161.67 84.93-165.64 1.18-5.33-.44-10.9-4.3-14.77-3.03-3.04-7.12-4.7-11.32-4.7-1.14 0-2.29.12-3.44.38-3.88.85-86.54 19.59-160.58 79.76.01-1.46.01-2.93.01-4.4 0-118.79-59.98-213.72-62.53-217.7A15.973 15.973 0 0 0 256 0c-5.45 0-10.53 2.78-13.47 7.37-2.55 3.98-62.53 98.91-62.53 217.7 0 1.47.01 2.94.01 4.4-74.03-60.16-156.69-78.9-160.58-79.76-1.14-.25-2.29-.38-3.44-.38-4.2 0-8.29 1.66-11.32 4.7A15.986 15.986 0 0 0 .38 168.8c.88 3.97 20.68 90.52 84.93 165.64-44.39 8.92-75.21 24.99-76.78 25.81a16.003 16.003 0 0 0-.02 28.29c2.45 1.29 60.76 31.72 133.49 31.72 6.14 0 11.96-.1 17.5-.31-11.37 22.23-16.52 38.31-16.81 39.22-1.8 5.68-.29 11.89 3.91 16.11a16.019 16.019 0 0 0 16.1 3.99c1.83-.57 37.72-11.99 77.3-39.29V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-64.01c39.58 27.3 75.47 38.71 77.3 39.29a16.019 16.019 0 0 0 16.1-3.99c4.2-4.22 5.71-10.43 3.91-16.11-.29-.91-5.45-16.99-16.81-39.22 5.54.21 11.37.31 17.5.31 72.72 0 131.04-30.43 133.49-31.72 5.24-2.78 8.52-8.22 8.51-14.15-.01-5.94-3.29-11.39-8.53-14.15z"
        ],
        capsules: [
            576,
            512,
            [],
            "f46b",
            "M555.3 300.1L424.2 112.8C401.9 81 366.4 64 330.4 64c-22.6 0-45.5 6.7-65.5 20.7-19.7 13.8-33.7 32.8-41.5 53.8C220.5 79.2 172 32 112 32 50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V218.9c3.3 8.6 7.3 17.1 12.8 25L368 431.2c22.2 31.8 57.7 48.8 93.8 48.8 22.7 0 45.5-6.7 65.5-20.7 51.7-36.2 64.2-107.5 28-159.2zM160 256H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm194.8 44.9l-65.6-93.7c-7.7-11-10.7-24.4-8.3-37.6 2.3-13.2 9.7-24.8 20.7-32.5 8.5-6 18.5-9.1 28.8-9.1 16.5 0 31.9 8 41.3 21.5l65.6 93.7-82.5 57.7z"
        ],
        car: [
            512,
            512,
            [],
            "f1b9",
            "M499.99 176h-59.87l-16.64-41.6C406.38 91.63 365.57 64 319.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4L71.87 176H12.01C4.2 176-1.53 183.34.37 190.91l6 24C7.7 220.25 12.5 224 18.01 224h20.07C24.65 235.73 16 252.78 16 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-19.22-8.65-36.27-22.07-48H494c5.51 0 10.31-3.75 11.64-9.09l6-24c1.89-7.57-3.84-14.91-11.65-14.91zm-352.06-17.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L384 208H128l19.93-49.83zM96 319.8c-19.2 0-32-12.76-32-31.9S76.8 256 96 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S396.8 256 416 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
        ],
        "car-alt": [
            480,
            512,
            [],
            "f5de",
            "M438.66 212.33l-11.24-28.1-19.93-49.83C390.38 91.63 349.57 64 303.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4l-19.93 49.83-11.24 28.1C17.22 221.5 0 244.66 0 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-27.34-17.22-50.5-41.34-59.67zm-306.73-54.16c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L368 208H112l19.93-49.83zM80 319.8c-19.2 0-32-12.76-32-31.9S60.8 256 80 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S380.8 256 400 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
        ],
        "car-battery": [
            512,
            512,
            [],
            "f5df",
            "M480 128h-32V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v48H192V80c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v48H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zM192 264c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm256 0c0 4.42-3.58 8-8 8h-40v40c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-40h-40c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h40v-40c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v40h40c4.42 0 8 3.58 8 8v16z"
        ],
        "car-crash": [
            640,
            512,
            [],
            "f5e1",
            "M143.25 220.81l-12.42 46.37c-3.01 11.25-3.63 22.89-2.41 34.39l-35.2 28.98c-6.57 5.41-16.31-.43-14.62-8.77l15.44-76.68c1.06-5.26-2.66-10.28-8-10.79l-77.86-7.55c-8.47-.82-11.23-11.83-4.14-16.54l65.15-43.3c4.46-2.97 5.38-9.15 1.98-13.29L21.46 93.22c-5.41-6.57.43-16.3 8.78-14.62l76.68 15.44c5.26 1.06 10.28-2.66 10.8-8l7.55-77.86c.82-8.48 11.83-11.23 16.55-4.14l43.3 65.14c2.97 4.46 9.15 5.38 13.29 1.98l60.4-49.71c6.57-5.41 16.3.43 14.62 8.77L262.1 86.38c-2.71 3.05-5.43 6.09-7.91 9.4l-32.15 42.97-10.71 14.32c-32.73 8.76-59.18 34.53-68.08 67.74zm494.57 132.51l-12.42 46.36c-3.13 11.68-9.38 21.61-17.55 29.36a66.876 66.876 0 0 1-8.76 7l-13.99 52.23c-1.14 4.27-3.1 8.1-5.65 11.38-7.67 9.84-20.74 14.68-33.54 11.25L515 502.62c-17.07-4.57-27.2-22.12-22.63-39.19l8.28-30.91-247.28-66.26-8.28 30.91c-4.57 17.07-22.12 27.2-39.19 22.63l-30.91-8.28c-12.8-3.43-21.7-14.16-23.42-26.51-.57-4.12-.35-8.42.79-12.68l13.99-52.23a66.62 66.62 0 0 1-4.09-10.45c-3.2-10.79-3.65-22.52-.52-34.2l12.42-46.37c5.31-19.8 19.36-34.83 36.89-42.21a64.336 64.336 0 0 1 18.49-4.72l18.13-24.23 32.15-42.97c3.45-4.61 7.19-8.9 11.2-12.84 8-7.89 17.03-14.44 26.74-19.51 4.86-2.54 9.89-4.71 15.05-6.49 10.33-3.58 21.19-5.63 32.24-6.04 11.05-.41 22.31.82 33.43 3.8l122.68 32.87c11.12 2.98 21.48 7.54 30.85 13.43a111.11 111.11 0 0 1 34.69 34.5c8.82 13.88 14.64 29.84 16.68 46.99l6.36 53.29 3.59 30.05a64.49 64.49 0 0 1 22.74 29.93c4.39 11.88 5.29 25.19 1.75 38.39zM255.58 234.34c-18.55-4.97-34.21 4.04-39.17 22.53-4.96 18.49 4.11 34.12 22.65 39.09 18.55 4.97 45.54 15.51 50.49-2.98 4.96-18.49-15.43-53.67-33.97-58.64zm290.61 28.17l-6.36-53.29c-.58-4.87-1.89-9.53-3.82-13.86-5.8-12.99-17.2-23.01-31.42-26.82l-122.68-32.87a48.008 48.008 0 0 0-50.86 17.61l-32.15 42.97 172 46.08 75.29 20.18zm18.49 54.65c-18.55-4.97-53.8 15.31-58.75 33.79-4.95 18.49 23.69 22.86 42.24 27.83 18.55 4.97 34.21-4.04 39.17-22.53 4.95-18.48-4.11-34.12-22.66-39.09z"
        ],
        "car-side": [
            640,
            512,
            [],
            "f5e4",
            "M544 192h-16L419.22 56.02A64.025 64.025 0 0 0 369.24 32H155.33c-26.17 0-49.7 15.93-59.42 40.23L48 194.26C20.44 201.4 0 226.21 0 256v112c0 8.84 7.16 16 16 16h48c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h48c8.84 0 16-7.16 16-16v-80c0-53.02-42.98-96-96-96zM160 432c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm72-240H116.93l38.4-96H232v96zm48 0V96h89.24l76.8 96H280zm200 240c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
        ],
        caravan: [
            640,
            512,
            [],
            "f8ff",
            "M416,208a16,16,0,1,0,16,16A16,16,0,0,0,416,208ZM624,320H576V160A160,160,0,0,0,416,0H64A64,64,0,0,0,0,64V320a64,64,0,0,0,64,64H96a96,96,0,0,0,192,0H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM192,432a48,48,0,1,1,48-48A48.05,48.05,0,0,1,192,432Zm64-240a32,32,0,0,1-32,32H96a32,32,0,0,1-32-32V128A32,32,0,0,1,96,96H224a32,32,0,0,1,32,32ZM448,320H320V128a32,32,0,0,1,32-32h64a32,32,0,0,1,32,32Z"
        ],
        "caret-down": [
            320,
            512,
            [],
            "f0d7",
            "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
        ],
        "caret-left": [
            192,
            512,
            [],
            "f0d9",
            "M192 127.338v257.324c0 17.818-21.543 26.741-34.142 14.142L29.196 270.142c-7.81-7.81-7.81-20.474 0-28.284l128.662-128.662c12.599-12.6 34.142-3.676 34.142 14.142z"
        ],
        "caret-right": [
            192,
            512,
            [],
            "f0da",
            "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"
        ],
        "caret-square-down": [
            448,
            512,
            [],
            "f150",
            "M448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM92.5 220.5l123 123c4.7 4.7 12.3 4.7 17 0l123-123c7.6-7.6 2.2-20.5-8.5-20.5H101c-10.7 0-16.1 12.9-8.5 20.5z"
        ],
        "caret-square-left": [
            448,
            512,
            [],
            "f191",
            "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM259.515 124.485l-123.03 123.03c-4.686 4.686-4.686 12.284 0 16.971l123.029 123.029c7.56 7.56 20.485 2.206 20.485-8.485V132.971c.001-10.691-12.925-16.045-20.484-8.486z"
        ],
        "caret-square-right": [
            448,
            512,
            [],
            "f152",
            "M48 32h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48zm140.485 355.515l123.029-123.029c4.686-4.686 4.686-12.284 0-16.971l-123.029-123.03c-7.56-7.56-20.485-2.206-20.485 8.485v246.059c0 10.691 12.926 16.045 20.485 8.486z"
        ],
        "caret-square-up": [
            448,
            512,
            [],
            "f151",
            "M0 432V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48zm355.515-140.485l-123.03-123.03c-4.686-4.686-12.284-4.686-16.971 0L92.485 291.515c-7.56 7.56-2.206 20.485 8.485 20.485h246.059c10.691 0 16.045-12.926 8.486-20.485z"
        ],
        "caret-up": [
            320,
            512,
            [],
            "f0d8",
            "M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z"
        ],
        carrot: [
            512,
            512,
            [],
            "f787",
            "M298.2 156.6c-52.7-25.7-114.5-10.5-150.2 32.8l55.2 55.2c6.3 6.3 6.3 16.4 0 22.6-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7L130.4 217 2.3 479.7c-2.9 6-3.1 13.3 0 19.7 5.4 11.1 18.9 15.7 30 10.3l133.6-65.2-49.2-49.2c-6.3-6.2-6.3-16.4 0-22.6 6.3-6.2 16.4-6.2 22.6 0l57 57 102-49.8c24-11.7 44.5-31.3 57.1-57.1 30.1-61.7 4.5-136.1-57.2-166.2zm92.1-34.9C409.8 81 399.7 32.9 360 0c-50.3 41.7-52.5 107.5-7.9 151.9l8 8c44.4 44.6 110.3 42.4 151.9-7.9-32.9-39.7-81-49.8-121.7-30.3z"
        ],
        "cart-arrow-down": [
            576,
            512,
            [],
            "f218",
            "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM403.029 192H360v-60c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v60h-43.029c-10.691 0-16.045 12.926-8.485 20.485l67.029 67.029c4.686 4.686 12.284 4.686 16.971 0l67.029-67.029c7.559-7.559 2.205-20.485-8.486-20.485z"
        ],
        "cart-plus": [
            576,
            512,
            [],
            "f217",
            "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM408 168h-48v-40c0-8.837-7.163-16-16-16h-16c-8.837 0-16 7.163-16 16v40h-48c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h48v40c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-40h48c8.837 0 16-7.163 16-16v-16c0-8.837-7.163-16-16-16z"
        ],
        "cash-register": [
            512,
            512,
            [],
            "f788",
            "M511.1 378.8l-26.7-160c-2.6-15.4-15.9-26.7-31.6-26.7H208v-64h96c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96v64H59.1c-15.6 0-29 11.3-31.6 26.7L.8 378.7c-.6 3.5-.9 7-.9 10.5V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-90.7c.1-3.5-.2-7-.8-10.5zM280 248c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm-32 64h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm-32-80c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16zM80 80V48h192v32H80zm40 200h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16zm16 64v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16zm216 112c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16zm24-112c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16zm48-80c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16z"
        ],
        cat: [
            512,
            512,
            [],
            "f6be",
            "M290.59 192c-20.18 0-106.82 1.98-162.59 85.95V192c0-52.94-43.06-96-96-96-17.67 0-32 14.33-32 32s14.33 32 32 32c17.64 0 32 14.36 32 32v256c0 35.3 28.7 64 64 64h176c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-32l128-96v144c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V289.86c-10.29 2.67-20.89 4.54-32 4.54-61.81 0-113.52-44.05-125.41-102.4zM448 96h-64l-64-64v134.4c0 53.02 42.98 96 96 96s96-42.98 96-96V32l-64 64zm-72 80c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm80 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
        ],
        certificate: [
            512,
            512,
            [],
            "f0a3",
            "M458.622 255.92l45.985-45.005c13.708-12.977 7.316-36.039-10.664-40.339l-62.65-15.99 17.661-62.015c4.991-17.838-11.829-34.663-29.661-29.671l-61.994 17.667-15.984-62.671C337.085.197 313.765-6.276 300.99 7.228L256 53.57 211.011 7.229c-12.63-13.351-36.047-7.234-40.325 10.668l-15.984 62.671-61.995-17.667C74.87 57.907 58.056 74.738 63.046 92.572l17.661 62.015-62.65 15.99C.069 174.878-6.31 197.944 7.392 210.915l45.985 45.005-45.985 45.004c-13.708 12.977-7.316 36.039 10.664 40.339l62.65 15.99-17.661 62.015c-4.991 17.838 11.829 34.663 29.661 29.671l61.994-17.667 15.984 62.671c4.439 18.575 27.696 24.018 40.325 10.668L256 458.61l44.989 46.001c12.5 13.488 35.987 7.486 40.325-10.668l15.984-62.671 61.994 17.667c17.836 4.994 34.651-11.837 29.661-29.671l-17.661-62.015 62.65-15.99c17.987-4.302 24.366-27.367 10.664-40.339l-45.984-45.004z"
        ],
        chair: [
            448,
            512,
            [],
            "f6c0",
            "M112 128c0-29.5 16.2-55 40-68.9V256h48V48h48v208h48V59.1c23.8 13.9 40 39.4 40 68.9v128h48V128C384 57.3 326.7 0 256 0h-64C121.3 0 64 57.3 64 128v128h48zm334.3 213.9l-10.7-32c-4.4-13.1-16.6-21.9-30.4-21.9H42.7c-13.8 0-26 8.8-30.4 21.9l-10.7 32C-5.2 362.6 10.2 384 32 384v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384h256v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384c21.8 0 37.2-21.4 30.3-42.1z"
        ],
        chalkboard: [
            640,
            512,
            [],
            "f51b",
            "M96 64h448v352h64V40c0-22.06-17.94-40-40-40H72C49.94 0 32 17.94 32 40v376h64V64zm528 384H480v-64H288v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
        ],
        "chalkboard-teacher": [
            640,
            512,
            [],
            "f51c",
            "M208 352c-2.39 0-4.78.35-7.06 1.09C187.98 357.3 174.35 360 160 360c-14.35 0-27.98-2.7-40.95-6.91-2.28-.74-4.66-1.09-7.05-1.09C49.94 352-.33 402.48 0 464.62.14 490.88 21.73 512 48 512h224c26.27 0 47.86-21.12 48-47.38.33-62.14-49.94-112.62-112-112.62zm-48-32c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zM592 0H208c-26.47 0-48 22.25-48 49.59V96c23.42 0 45.1 6.78 64 17.8V64h352v288h-64v-64H384v64h-76.24c19.1 16.69 33.12 38.73 39.69 64H592c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0z"
        ],
        "charging-station": [
            576,
            512,
            [],
            "f5e7",
            "M336 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h320c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm208-320V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-32V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-16c-8.84 0-16 7.16-16 16v32c0 35.76 23.62 65.69 56 75.93v118.49c0 13.95-9.5 26.92-23.26 29.19C431.22 402.5 416 388.99 416 372v-28c0-48.6-39.4-88-88-88h-8V64c0-35.35-28.65-64-64-64H96C60.65 0 32 28.65 32 64v352h288V304h8c22.09 0 40 17.91 40 40v24.61c0 39.67 28.92 75.16 68.41 79.01C481.71 452.05 520 416.41 520 372V251.93c32.38-10.24 56-40.17 56-75.93v-32c0-8.84-7.16-16-16-16h-16zm-283.91 47.76l-93.7 139c-2.2 3.33-6.21 5.24-10.39 5.24-7.67 0-13.47-6.28-11.67-12.92L167.35 224H108c-7.25 0-12.85-5.59-11.89-11.89l16-107C112.9 99.9 117.98 96 124 96h68c7.88 0 13.62 6.54 11.6 13.21L192 160h57.7c9.24 0 15.01 8.78 10.39 15.76z"
        ],
        "chart-area": [
            512,
            512,
            [],
            "f1fe",
            "M500 384c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v308h436zM372.7 159.5L288 216l-85.3-113.7c-5.1-6.8-15.5-6.3-19.9 1L96 248v104h384l-89.9-187.8c-3.2-6.5-11.4-8.7-17.4-4.7z"
        ],
        "chart-bar": [
            512,
            512,
            [],
            "f080",
            "M332.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8V172.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-288 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zM496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
        ],
        "chart-line": [
            512,
            512,
            [],
            "f201",
            "M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM464 96H345.94c-21.38 0-32.09 25.85-16.97 40.97l32.4 32.4L288 242.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 0l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L192 237.25l73.37 73.37c12.5 12.5 32.76 12.5 45.25 0l96-96 32.4 32.4c15.12 15.12 40.97 4.41 40.97-16.97V112c.01-8.84-7.15-16-15.99-16z"
        ],
        "chart-pie": [
            544,
            512,
            [],
            "f200",
            "M527.79 288H290.5l158.03 158.03c6.04 6.04 15.98 6.53 22.19.68 38.7-36.46 65.32-85.61 73.13-140.86 1.34-9.46-6.51-17.85-16.06-17.85zm-15.83-64.8C503.72 103.74 408.26 8.28 288.8.04 279.68-.59 272 7.1 272 16.24V240h223.77c9.14 0 16.82-7.68 16.19-16.8zM224 288V50.71c0-9.55-8.39-17.4-17.84-16.06C86.99 51.49-4.1 155.6.14 280.37 4.5 408.51 114.83 513.59 243.03 511.98c50.4-.63 96.97-16.87 135.26-44.03 7.9-5.6 8.42-17.23 1.57-24.08L224 288z"
        ],
        check: [
            512,
            512,
            [],
            "f00c",
            "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
        ],
        "check-circle": [
            512,
            512,
            [],
            "f058",
            "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
        ],
        "check-double": [
            512,
            512,
            [],
            "f560",
            "M505 174.8l-39.6-39.6c-9.4-9.4-24.6-9.4-33.9 0L192 374.7 80.6 263.2c-9.4-9.4-24.6-9.4-33.9 0L7 302.9c-9.4 9.4-9.4 24.6 0 34L175 505c9.4 9.4 24.6 9.4 33.9 0l296-296.2c9.4-9.5 9.4-24.7.1-34zm-324.3 106c6.2 6.3 16.4 6.3 22.6 0l208-208.2c6.2-6.3 6.2-16.4 0-22.6L366.1 4.7c-6.2-6.3-16.4-6.3-22.6 0L192 156.2l-55.4-55.5c-6.2-6.3-16.4-6.3-22.6 0L68.7 146c-6.2 6.3-6.2 16.4 0 22.6l112 112.2z"
        ],
        "check-square": [
            448,
            512,
            [],
            "f14a",
            "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"
        ],
        cheese: [
            512,
            512,
            [],
            "f7ef",
            "M0 288v160a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V288zM299.83 32a32 32 0 0 0-21.13 7L0 256h512c0-119.89-94-217.8-212.17-224z"
        ],
        chess: [
            512,
            512,
            [],
            "f439",
            "M74 208H64a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h15.94A535.78 535.78 0 0 1 64 384h128a535.78 535.78 0 0 1-15.94-128H192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-10l33.89-90.38a16 16 0 0 0-15-21.62H144V64h24a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8h-24V8a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24H88a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v32H55.09a16 16 0 0 0-15 21.62zm173.16 251.58L224 448v-16a16 16 0 0 0-16-16H48a16 16 0 0 0-16 16v16L8.85 459.58A16 16 0 0 0 0 473.89V496a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31zm92.77-157.78l-3.29 82.2h126.72l-3.29-82.21 24.6-20.79A32 32 0 0 0 496 256.54V198a6 6 0 0 0-6-6h-26.38a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H373.1a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H310a6 6 0 0 0-6 6v58.6a32 32 0 0 0 11.36 24.4zM384 304a16 16 0 0 1 32 0v32h-32zm119.16 155.58L480 448v-16a16 16 0 0 0-16-16H336a16 16 0 0 0-16 16v16l-23.15 11.58a16 16 0 0 0-8.85 14.31V496a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31z"
        ],
        "chess-bishop": [
            320,
            512,
            [],
            "f43a",
            "M8 287.88c0 51.64 22.14 73.83 56 84.6V416h192v-43.52c33.86-10.77 56-33 56-84.6 0-30.61-10.73-67.1-26.69-102.56L185 285.65a8 8 0 0 1-11.31 0l-11.31-11.31a8 8 0 0 1 0-11.31L270.27 155.1c-20.8-37.91-46.47-72.1-70.87-92.59C213.4 59.09 224 47.05 224 32a32 32 0 0 0-32-32h-64a32 32 0 0 0-32 32c0 15 10.6 27.09 24.6 30.51C67.81 106.8 8 214.5 8 287.88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
        ],
        "chess-board": [
            512,
            512,
            [],
            "f43c",
            "M255.9.2h-64v64h64zM0 64.17v64h64v-64zM128 .2H64v64h64zm64 255.9v64h64v-64zM0 192.12v64h64v-64zM383.85.2h-64v64h64zm128 0h-64v64h64zM128 256.1H64v64h64zM511.8 448v-64h-64v64zm0-128v-64h-64v64zM383.85 512h64v-64h-64zm128-319.88v-64h-64v64zM128 512h64v-64h-64zM0 512h64v-64H0zm255.9 0h64v-64h-64zM0 320.07v64h64v-64zm319.88-191.92v-64h-64v64zm-64 128h64v-64h-64zm-64 128v64h64v-64zm128-64h64v-64h-64zm0-127.95h64v-64h-64zm0 191.93v64h64v-64zM64 384.05v64h64v-64zm128-255.9v-64h-64v64zm191.92 255.9h64v-64h-64zm-128-191.93v-64h-64v64zm128-127.95v64h64v-64zm-128 255.9v64h64v-64zm-64-127.95H128v64h64zm191.92 64h64v-64h-64zM128 128.15H64v64h64zm0 191.92v64h64v-64z"
        ],
        "chess-king": [
            448,
            512,
            [],
            "f43f",
            "M400 448H48a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm16-288H256v-48h40a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8h-40V8a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v40h-40a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h40v48H32a32 32 0 0 0-30.52 41.54L74.56 416h298.88l73.08-214.46A32 32 0 0 0 416 160z"
        ],
        "chess-knight": [
            384,
            512,
            [],
            "f441",
            "M19 272.47l40.63 18.06a32 32 0 0 0 24.88.47l12.78-5.12a32 32 0 0 0 18.76-20.5l9.22-30.65a24 24 0 0 1 12.55-15.65L159.94 208v50.33a48 48 0 0 1-26.53 42.94l-57.22 28.65A80 80 0 0 0 32 401.48V416h319.86V224c0-106-85.92-192-191.92-192H12A12 12 0 0 0 0 44a16.9 16.9 0 0 0 1.79 7.58L16 80l-9 9a24 24 0 0 0-7 17v137.21a32 32 0 0 0 19 29.26zM52 128a20 20 0 1 1-20 20 20 20 0 0 1 20-20zm316 320H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
        ],
        "chess-pawn": [
            320,
            512,
            [],
            "f443",
            "M105.1 224H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h16v5.49c0 44-4.14 86.6-24 122.51h176c-19.89-35.91-24-78.51-24-122.51V288h16a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-25.1c29.39-18.38 49.1-50.78 49.1-88a104 104 0 0 0-208 0c0 37.22 19.71 69.62 49.1 88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
        ],
        "chess-queen": [
            512,
            512,
            [],
            "f445",
            "M256 112a56 56 0 1 0-56-56 56 56 0 0 0 56 56zm176 336H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm72.87-263.84l-28.51-15.92c-7.44-5-16.91-2.46-22.29 4.68a47.59 47.59 0 0 1-47.23 18.23C383.7 186.86 368 164.93 368 141.4a13.4 13.4 0 0 0-13.4-13.4h-38.77c-6 0-11.61 4-12.86 9.91a48 48 0 0 1-93.94 0c-1.25-5.92-6.82-9.91-12.86-9.91H157.4a13.4 13.4 0 0 0-13.4 13.4c0 25.69-19 48.75-44.67 50.49a47.5 47.5 0 0 1-41.54-19.15c-5.28-7.09-14.73-9.45-22.09-4.54l-28.57 16a16 16 0 0 0-5.44 20.47L104.24 416h303.52l102.55-211.37a16 16 0 0 0-5.44-20.47z"
        ],
        "chess-rook": [
            384,
            512,
            [],
            "f447",
            "M368 32h-56a16 16 0 0 0-16 16v48h-48V48a16 16 0 0 0-16-16h-80a16 16 0 0 0-16 16v48H88.1V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v176l64 32c0 48.33-1.54 95-13.21 160h282.42C321.54 351 320 303.72 320 256l64-32V48a16 16 0 0 0-16-16zM224 320h-64v-64a32 32 0 0 1 64 0zm144 128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
        ],
        "chevron-circle-down": [
            512,
            512,
            [],
            "f13a",
            "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM273 369.9l135.5-135.5c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L256 285.1 154.4 183.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L239 369.9c9.4 9.4 24.6 9.4 34 0z"
        ],
        "chevron-circle-left": [
            512,
            512,
            [],
            "f137",
            "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L226.9 256l101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L142.1 239c-9.4 9.4-9.4 24.6 0 34z"
        ],
        "chevron-circle-right": [
            512,
            512,
            [],
            "f138",
            "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z"
        ],
        "chevron-circle-up": [
            512,
            512,
            [],
            "f139",
            "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm231-113.9L103.5 277.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L256 226.9l101.6 101.6c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L273 142.1c-9.4-9.4-24.6-9.4-34 0z"
        ],
        "chevron-down": [
            448,
            512,
            [],
            "f078",
            "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
        ],
        "chevron-left": [
            320,
            512,
            [],
            "f053",
            "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
        ],
        "chevron-right": [
            320,
            512,
            [],
            "f054",
            "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
        ],
        "chevron-up": [
            448,
            512,
            [],
            "f077",
            "M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
        ],
        child: [
            384,
            512,
            [],
            "f1ae",
            "M120 72c0-39.765 32.235-72 72-72s72 32.235 72 72c0 39.764-32.235 72-72 72s-72-32.236-72-72zm254.627 1.373c-12.496-12.497-32.758-12.497-45.254 0L242.745 160H141.254L54.627 73.373c-12.496-12.497-32.758-12.497-45.254 0-12.497 12.497-12.497 32.758 0 45.255L104 213.254V480c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V368h16v112c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V213.254l94.627-94.627c12.497-12.497 12.497-32.757 0-45.254z"
        ],
        church: [
            640,
            512,
            [],
            "f51d",
            "M464.46 246.68L352 179.2V128h48c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-48V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v48h-48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v51.2l-112.46 67.48A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.65-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.54A32.024 32.024 0 0 0 0 395.96zm620.61-29.42L512 320v192h112c8.84 0 16-7.16 16-16V395.96c0-12.8-7.63-24.37-19.39-29.42z"
        ],
        circle: [
            512,
            512,
            [],
            "f111",
            "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
        ],
        "circle-notch": [
            512,
            512,
            [],
            "f1ce",
            "M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"
        ],
        city: [
            640,
            512,
            [],
            "f64f",
            "M616 192H480V24c0-13.26-10.74-24-24-24H312c-13.26 0-24 10.74-24 24v72h-64V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v80h-64V16c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v80H24c-13.26 0-24 10.74-24 24v360c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V216c0-13.26-10.75-24-24-24zM128 404c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm128 192c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12V76c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 288c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40z"
        ],
        "clinic-medical": [
            576,
            512,
            [],
            "f7f2",
            "M288 115L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2zm96 261a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8zm186.69-139.72l-255.94-226a39.85 39.85 0 0 0-53.45 0l-256 226a16 16 0 0 0-1.21 22.6L25.5 282.7a16 16 0 0 0 22.6 1.21L277.42 81.63a16 16 0 0 1 21.17 0L527.91 283.9a16 16 0 0 0 22.6-1.21l21.4-23.82a16 16 0 0 0-1.22-22.59z"
        ],
        clipboard: [
            384,
            512,
            [],
            "f328",
            "M384 112v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h80c0-35.29 28.71-64 64-64s64 28.71 64 64h80c26.51 0 48 21.49 48 48zM192 40c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24m96 114v-20a6 6 0 0 0-6-6H102a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h180a6 6 0 0 0 6-6z"
        ],
        "clipboard-check": [
            384,
            512,
            [],
            "f46c",
            "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm121.2 231.8l-143 141.8c-4.7 4.7-12.3 4.6-17-.1l-82.6-83.3c-4.7-4.7-4.6-12.3.1-17L99.1 285c4.7-4.7 12.3-4.6 17 .1l46 46.4 106-105.2c4.7-4.7 12.3-4.6 17 .1l28.2 28.4c4.7 4.8 4.6 12.3-.1 17z"
        ],
        "clipboard-list": [
            384,
            512,
            [],
            "f46d",
            "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
        ],
        clock: [
            512,
            512,
            [],
            "f017",
            "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z"
        ],
        clone: [
            512,
            512,
            [],
            "f24d",
            "M464 0c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48H176c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h288M176 416c-44.112 0-80-35.888-80-80V128H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-48H176z"
        ],
        "closed-captioning": [
            512,
            512,
            [],
            "f20a",
            "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM218.1 287.7c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2.1 48 51.1 70.5 92.3 32.6zm190.4 0c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.5 56.9-172.7 32.1-172.7-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 222.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6z"
        ],
        cloud: [
            640,
            512,
            [],
            "f0c2",
            "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4z"
        ],
        "cloud-download-alt": [
            640,
            512,
            [],
            "f381",
            "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zm-132.9 88.7L299.3 420.7c-6.2 6.2-16.4 6.2-22.6 0L171.3 315.3c-10.1-10.1-2.9-27.3 11.3-27.3H248V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v112h65.4c14.2 0 21.4 17.2 11.3 27.3z"
        ],
        "cloud-meatball": [
            512,
            512,
            [],
            "f73b",
            "M48 352c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm416 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm-119 11.1c4.6-14.5 1.6-30.8-9.8-42.3-11.5-11.5-27.8-14.4-42.3-9.9-7-13.5-20.7-23-36.9-23s-29.9 9.5-36.9 23c-14.5-4.6-30.8-1.6-42.3 9.9-11.5 11.5-14.4 27.8-9.9 42.3-13.5 7-23 20.7-23 36.9s9.5 29.9 23 36.9c-4.6 14.5-1.6 30.8 9.9 42.3 8.2 8.2 18.9 12.3 29.7 12.3 4.3 0 8.5-1.1 12.6-2.5 7 13.5 20.7 23 36.9 23s29.9-9.5 36.9-23c4.1 1.3 8.3 2.5 12.6 2.5 10.8 0 21.5-4.1 29.7-12.3 11.5-11.5 14.4-27.8 9.8-42.3 13.5-7 23-20.7 23-36.9s-9.5-29.9-23-36.9zM512 224c0-53-43-96-96-96-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h43.4c3.6-8 8.4-15.4 14.8-21.8 13.5-13.5 31.5-21.1 50.8-21.3 13.5-13.2 31.7-20.9 51-20.9s37.5 7.7 51 20.9c19.3.2 37.3 7.8 50.8 21.3 6.4 6.4 11.3 13.8 14.8 21.8H416c53 0 96-43 96-96z"
        ],
        "cloud-moon": [
            576,
            512,
            [],
            "f6c3",
            "M342.8 352.7c5.7-9.6 9.2-20.7 9.2-32.7 0-35.3-28.7-64-64-64-17.2 0-32.8 6.9-44.3 17.9-16.3-29.6-47.5-49.9-83.7-49.9-53 0-96 43-96 96 0 2 .5 3.8.6 5.7C27.1 338.8 0 374.1 0 416c0 53 43 96 96 96h240c44.2 0 80-35.8 80-80 0-41.9-32.3-75.8-73.2-79.3zm222.5-54.3c-93.1 17.7-178.5-53.7-178.5-147.7 0-54.2 29-104 76.1-130.8 7.3-4.1 5.4-15.1-2.8-16.7C448.4 1.1 436.7 0 425 0 319.1 0 233.1 85.9 233.1 192c0 8.5.7 16.8 1.8 25 5.9 4.3 11.6 8.9 16.7 14.2 11.4-4.7 23.7-7.2 36.4-7.2 52.9 0 96 43.1 96 96 0 3.6-.2 7.2-.6 10.7 23.6 10.8 42.4 29.5 53.5 52.6 54.4-3.4 103.7-29.3 137.1-70.4 5.3-6.5-.5-16.1-8.7-14.5z"
        ],
        "cloud-moon-rain": [
            576,
            512,
            [],
            "f73c",
            "M350.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C27.6 232.9 0 265.2 0 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm217.4-1.7c-70.4 13.3-135-40.3-135-110.8 0-40.6 21.9-78 57.5-98.1 5.5-3.1 4.1-11.4-2.1-12.5C479.6.8 470.7 0 461.8 0c-77.9 0-141.1 61.2-144.4 137.9 26.7 11.9 48.2 33.8 58.9 61.7 37.1 14.3 64 47.4 70.2 86.8 5.1.5 10 1.5 15.2 1.5 44.7 0 85.6-20.2 112.6-53.3 4.2-4.8-.2-12-6.4-10.8zM364.5 418.1c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"
        ],
        "cloud-rain": [
            512,
            512,
            [],
            "f73d",
            "M416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96zM88 374.2c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0z"
        ],
        "cloud-showers-heavy": [
            512,
            512,
            [],
            "f740",
            "M183.9 370.1c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-192 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm384 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zM416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.2 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96z"
        ],
        "cloud-sun": [
            640,
            512,
            [],
            "f6c4",
            "M575.2 325.7c.2-1.9.8-3.7.8-5.6 0-35.3-28.7-64-64-64-12.6 0-24.2 3.8-34.1 10-17.6-38.8-56.5-66-101.9-66-61.8 0-112 50.1-112 112 0 3 .7 5.8.9 8.7-49.6 3.7-88.9 44.7-88.9 95.3 0 53 43 96 96 96h272c53 0 96-43 96-96 0-42.1-27.2-77.4-64.8-90.4zm-430.4-22.6c-43.7-43.7-43.7-114.7 0-158.3 43.7-43.7 114.7-43.7 158.4 0 9.7 9.7 16.9 20.9 22.3 32.7 9.8-3.7 20.1-6 30.7-7.5L386 81.1c4-11.9-7.3-23.1-19.2-19.2L279 91.2 237.5 8.4C232-2.8 216-2.8 210.4 8.4L169 91.2 81.1 61.9C69.3 58 58 69.3 61.9 81.1l29.3 87.8-82.8 41.5c-11.2 5.6-11.2 21.5 0 27.1l82.8 41.4-29.3 87.8c-4 11.9 7.3 23.1 19.2 19.2l76.1-25.3c6.1-12.4 14-23.7 23.6-33.5-13.1-5.4-25.4-13.4-36-24zm-4.8-79.2c0 40.8 29.3 74.8 67.9 82.3 8-4.7 16.3-8.8 25.2-11.7 5.4-44.3 31-82.5 67.4-105C287.3 160.4 258 140 224 140c-46.3 0-84 37.6-84 83.9z"
        ],
        "cloud-sun-rain": [
            576,
            512,
            [],
            "f743",
            "M510.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C187.6 233 160 265.2 160 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm-386.4 34.4c-37.4-37.4-37.4-98.3 0-135.8 34.6-34.6 89.1-36.8 126.7-7.4 20-12.9 43.6-20.7 69.2-20.7.7 0 1.3.2 2 .2l8.9-26.7c3.4-10.2-6.3-19.8-16.5-16.4l-75.3 25.1-35.5-71c-4.8-9.6-18.5-9.6-23.3 0l-35.5 71-75.3-25.1c-10.2-3.4-19.8 6.3-16.4 16.5l25.1 75.3-71 35.5c-9.6 4.8-9.6 18.5 0 23.3l71 35.5-25.1 75.3c-3.4 10.2 6.3 19.8 16.5 16.5l59.2-19.7c-.2-2.4-.7-4.7-.7-7.2 0-12.5 2.3-24.5 6.2-35.9-3.6-2.7-7.1-5.2-10.2-8.3zm69.8-58c4.3-24.5 15.8-46.4 31.9-64-9.8-6.2-21.4-9.9-33.8-9.9-35.3 0-64 28.7-64 64 0 18.7 8.2 35.4 21.1 47.1 11.3-15.9 26.6-28.9 44.8-37.2zm330.6 216.2c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"
        ],
        "cloud-upload-alt": [
            640,
            512,
            [],
            "f382",
            "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zM393.4 288H328v112c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V288h-65.4c-14.3 0-21.4-17.2-11.3-27.3l105.4-105.4c6.2-6.2 16.4-6.2 22.6 0l105.4 105.4c10.1 10.1 2.9 27.3-11.3 27.3z"
        ],
        cocktail: [
            576,
            512,
            [],
            "f561",
            "M296 464h-56V338.78l168.74-168.73c15.52-15.52 4.53-42.05-17.42-42.05H24.68c-21.95 0-32.94 26.53-17.42 42.05L176 338.78V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM432 0c-62.61 0-115.35 40.2-135.18 96h52.54c16.65-28.55 47.27-48 82.64-48 52.93 0 96 43.06 96 96s-43.07 96-96 96c-14.04 0-27.29-3.2-39.32-8.64l-35.26 35.26C379.23 279.92 404.59 288 432 288c79.53 0 144-64.47 144-144S511.53 0 432 0z"
        ],
        code: [
            640,
            512,
            [],
            "f121",
            "M278.9 511.5l-61-17.7c-6.4-1.8-10-8.5-8.2-14.9L346.2 8.7c1.8-6.4 8.5-10 14.9-8.2l61 17.7c6.4 1.8 10 8.5 8.2 14.9L293.8 503.3c-1.9 6.4-8.5 10.1-14.9 8.2zm-114-112.2l43.5-46.4c4.6-4.9 4.3-12.7-.8-17.2L117 256l90.6-79.7c5.1-4.5 5.5-12.3.8-17.2l-43.5-46.4c-4.5-4.8-12.1-5.1-17-.5L3.8 247.2c-5.1 4.7-5.1 12.8 0 17.5l144.1 135.1c4.9 4.6 12.5 4.4 17-.5zm327.2.6l144.1-135.1c5.1-4.7 5.1-12.8 0-17.5L492.1 112.1c-4.8-4.5-12.4-4.3-17 .5L431.6 159c-4.6 4.9-4.3 12.7.8 17.2L523 256l-90.6 79.7c-5.1 4.5-5.5 12.3-.8 17.2l43.5 46.4c4.5 4.9 12.1 5.1 17 .6z"
        ],
        "code-branch": [
            384,
            512,
            [],
            "f126",
            "M384 144c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 36.4 24.3 67.1 57.5 76.8-.6 16.1-4.2 28.5-11 36.9-15.4 19.2-49.3 22.4-85.2 25.7-28.2 2.6-57.4 5.4-81.3 16.9v-144c32.5-10.2 56-40.5 56-76.3 0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3v199.3C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-34-21.2-63.1-51.2-74.6 3.1-5.2 7.8-9.8 14.9-13.4 16.2-8.2 40.4-10.4 66.1-12.8 42.2-3.9 90-8.4 118.2-43.4 14-17.4 21.1-39.8 21.6-67.9 31.6-10.8 54.4-40.7 54.4-75.9zM80 64c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm0 384c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm224-320c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16z"
        ],
        coffee: [
            640,
            512,
            [],
            "f0f4",
            "M192 384h192c53 0 96-43 96-96h32c70.6 0 128-57.4 128-128S582.6 32 512 32H120c-13.3 0-24 10.7-24 24v232c0 53 43 96 96 96zM512 96c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32V96h32zm47.7 384H48.3c-47.6 0-61-64-36-64h583.3c25 0 11.8 64-35.9 64z"
        ],
        cog: [
            512,
            512,
            [],
            "f013",
            "M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
        ],
        cogs: [
            640,
            512,
            [],
            "f085",
            "M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"
        ],
        coins: [
            512,
            512,
            [],
            "f51e",
            "M0 405.3V448c0 35.3 86 64 192 64s192-28.7 192-64v-42.7C342.7 434.4 267.2 448 192 448S41.3 434.4 0 405.3zM320 128c106 0 192-28.7 192-64S426 0 320 0 128 28.7 128 64s86 64 192 64zM0 300.4V352c0 35.3 86 64 192 64s192-28.7 192-64v-51.6c-41.3 34-116.9 51.6-192 51.6S41.3 334.4 0 300.4zm416 11c57.3-11.1 96-31.7 96-55.4v-42.7c-23.2 16.4-57.3 27.6-96 34.5v63.6zM192 160C86 160 0 195.8 0 240s86 80 192 80 192-35.8 192-80-86-80-192-80zm219.3 56.3c60-10.8 100.7-32 100.7-56.3v-42.7c-35.5 25.1-96.5 38.6-160.7 41.8 29.5 14.3 51.2 33.5 60 57.2z"
        ],
        columns: [
            512,
            512,
            [],
            "f0db",
            "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64V160h160v256zm224 0H288V160h160v256z"
        ],
        comment: [
            512,
            512,
            [],
            "f075",
            "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32z"
        ],
        "comment-alt": [
            512,
            512,
            [],
            "f27a",
            "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64z"
        ],
        "comment-dollar": [
            512,
            512,
            [],
            "f651",
            "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95.01 57.02 130.74C44.46 421.05 2.7 465.97 2.2 466.5A7.995 7.995 0 0 0 8 480c66.26 0 115.99-31.75 140.6-51.38C181.29 440.93 217.59 448 256 448c141.38 0 256-93.12 256-208S397.38 32 256 32zm24 302.44V352c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-17.73c-11.42-1.35-22.28-5.19-31.78-11.46-6.22-4.11-6.82-13.11-1.55-18.38l17.52-17.52c3.74-3.74 9.31-4.24 14.11-2.03 3.18 1.46 6.66 2.22 10.26 2.22h32.78c4.66 0 8.44-3.78 8.44-8.42 0-3.75-2.52-7.08-6.12-8.11l-50.07-14.3c-22.25-6.35-40.01-24.71-42.91-47.67-4.05-32.07 19.03-59.43 49.32-63.05V128c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v17.73c11.42 1.35 22.28 5.19 31.78 11.46 6.22 4.11 6.82 13.11 1.55 18.38l-17.52 17.52c-3.74 3.74-9.31 4.24-14.11 2.03a24.516 24.516 0 0 0-10.26-2.22h-32.78c-4.66 0-8.44 3.78-8.44 8.42 0 3.75 2.52 7.08 6.12 8.11l50.07 14.3c22.25 6.36 40.01 24.71 42.91 47.67 4.05 32.06-19.03 59.42-49.32 63.04z"
        ],
        "comment-dots": [
            512,
            512,
            [],
            "f4ad",
            "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128 272c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
        ],
        "comment-medical": [
            512,
            512,
            [],
            "f7f5",
            "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95 57 130.74C44.46 421.05 2.7 466 2.2 466.5A8 8 0 0 0 8 480c66.26 0 116-31.75 140.6-51.38A304.66 304.66 0 0 0 256 448c141.39 0 256-93.12 256-208S397.39 32 256 32zm96 232a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8z"
        ],
        "comment-slash": [
            640,
            512,
            [],
            "f4b3",
            "M64 240c0 49.6 21.4 95 57 130.7-12.6 50.3-54.3 95.2-54.8 95.8-2.2 2.3-2.8 5.7-1.5 8.7 1.3 2.9 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 27.4 0 53.7-3.6 78.4-10L72.9 186.4c-5.6 17.1-8.9 35-8.9 53.6zm569.8 218.1l-114.4-88.4C554.6 334.1 576 289.2 576 240c0-114.9-114.6-208-256-208-65.1 0-124.2 20.1-169.4 52.7L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"
        ],
        comments: [
            576,
            512,
            [],
            "f086",
            "M416 192c0-88.4-93.1-160-208-160S0 103.6 0 192c0 34.3 14.1 65.9 38 92-13.4 30.2-35.5 54.2-35.8 54.5-2.2 2.3-2.8 5.7-1.5 8.7S4.8 352 8 352c36.6 0 66.9-12.3 88.7-25 32.2 15.7 70.3 25 111.3 25 114.9 0 208-71.6 208-160zm122 220c23.9-26 38-57.7 38-92 0-66.9-53.5-124.2-129.3-148.1.9 6.6 1.3 13.3 1.3 20.1 0 105.9-107.7 192-240 192-10.8 0-21.3-.8-31.7-1.9C207.8 439.6 281.8 480 368 480c41 0 79.1-9.2 111.3-25 21.8 12.7 52.1 25 88.7 25 3.2 0 6.1-1.9 7.3-4.8 1.3-2.9.7-6.3-1.5-8.7-.3-.3-22.4-24.2-35.8-54.5z"
        ],
        "comments-dollar": [
            576,
            512,
            [],
            "f653",
            "M416 192c0-88.37-93.12-160-208-160S0 103.63 0 192c0 34.27 14.13 65.95 37.97 91.98C24.61 314.22 2.52 338.16 2.2 338.5A7.995 7.995 0 0 0 8 352c36.58 0 66.93-12.25 88.73-24.98C128.93 342.76 167.02 352 208 352c114.88 0 208-71.63 208-160zm-224 96v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V96c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07V288c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm346.01 123.99C561.87 385.96 576 354.27 576 320c0-66.94-53.49-124.2-129.33-148.07.86 6.6 1.33 13.29 1.33 20.07 0 105.87-107.66 192-240 192-10.78 0-21.32-.77-31.73-1.88C207.8 439.63 281.77 480 368 480c40.98 0 79.07-9.24 111.27-24.98C501.07 467.75 531.42 480 568 480c3.2 0 6.09-1.91 7.34-4.84 1.27-2.94.66-6.34-1.55-8.67-.31-.33-22.42-24.24-35.78-54.5z"
        ],
        "compact-disc": [
            496,
            512,
            [],
            "f51f",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 256H56c0-105.9 86.1-192 192-192v32c-88.2 0-160 71.8-160 160zm160 96c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
        ],
        compass: [
            496,
            512,
            [],
            "f14e",
            "M225.38 233.37c-12.5 12.5-12.5 32.76 0 45.25 12.49 12.5 32.76 12.5 45.25 0 12.5-12.5 12.5-32.76 0-45.25-12.5-12.49-32.76-12.49-45.25 0zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm126.14 148.05L308.17 300.4a31.938 31.938 0 0 1-15.77 15.77l-144.34 65.97c-16.65 7.61-33.81-9.55-26.2-26.2l65.98-144.35a31.938 31.938 0 0 1 15.77-15.77l144.34-65.97c16.65-7.6 33.8 9.55 26.19 26.2z"
        ],
        compress: [
            448,
            512,
            [],
            "f066",
            "M436 192H312c-13.3 0-24-10.7-24-24V44c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-276-24V44c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v84H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24zm0 300V344c0-13.3-10.7-24-24-24H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-84h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H312c-13.3 0-24 10.7-24 24v124c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"
        ],
        "compress-alt": [
            448,
            512,
            [],
            "f422",
            "M4.686 427.314L104 328l-32.922-31.029C55.958 281.851 66.666 256 88.048 256h112C213.303 256 224 266.745 224 280v112c0 21.382-25.803 32.09-40.922 16.971L152 376l-99.314 99.314c-6.248 6.248-16.379 6.248-22.627 0L4.686 449.941c-6.248-6.248-6.248-16.379 0-22.627zM443.314 84.686L344 184l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C234.697 256 224 245.255 224 232V120c0-21.382 25.803-32.09 40.922-16.971L296 136l99.314-99.314c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.248 6.248 6.248 16.379 0 22.627z"
        ],
        "compress-arrows-alt": [
            512,
            512,
            [],
            "f78c",
            "M200 288H88c-21.4 0-32.1 25.8-17 41l32.9 31-99.2 99.3c-6.2 6.2-6.2 16.4 0 22.6l25.4 25.4c6.2 6.2 16.4 6.2 22.6 0L152 408l31.1 33c15.1 15.1 40.9 4.4 40.9-17V312c0-13.3-10.7-24-24-24zm112-64h112c21.4 0 32.1-25.9 17-41l-33-31 99.3-99.3c6.2-6.2 6.2-16.4 0-22.6L481.9 4.7c-6.2-6.2-16.4-6.2-22.6 0L360 104l-31.1-33C313.8 55.9 288 66.6 288 88v112c0 13.3 10.7 24 24 24zm96 136l33-31.1c15.1-15.1 4.4-40.9-17-40.9H312c-13.3 0-24 10.7-24 24v112c0 21.4 25.9 32.1 41 17l31-32.9 99.3 99.3c6.2 6.2 16.4 6.2 22.6 0l25.4-25.4c6.2-6.2 6.2-16.4 0-22.6L408 360zM183 71.1L152 104 52.7 4.7c-6.2-6.2-16.4-6.2-22.6 0L4.7 30.1c-6.2 6.2-6.2 16.4 0 22.6L104 152l-33 31.1C55.9 198.2 66.6 224 88 224h112c13.3 0 24-10.7 24-24V88c0-21.3-25.9-32-41-16.9z"
        ],
        "concierge-bell": [
            512,
            512,
            [],
            "f562",
            "M288 130.54V112h16c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16v18.54C115.49 146.11 32 239.18 32 352h448c0-112.82-83.49-205.89-192-221.46zM496 384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
        ],
        cookie: [
            512,
            512,
            [],
            "f563",
            "M510.37 254.79l-12.08-76.26a132.493 132.493 0 0 0-37.16-72.95l-54.76-54.75c-19.73-19.72-45.18-32.7-72.71-37.05l-76.7-12.15c-27.51-4.36-55.69.11-80.52 12.76L107.32 49.6a132.25 132.25 0 0 0-57.79 57.8l-35.1 68.88a132.602 132.602 0 0 0-12.82 80.94l12.08 76.27a132.493 132.493 0 0 0 37.16 72.95l54.76 54.75a132.087 132.087 0 0 0 72.71 37.05l76.7 12.14c27.51 4.36 55.69-.11 80.52-12.75l69.12-35.21a132.302 132.302 0 0 0 57.79-57.8l35.1-68.87c12.71-24.96 17.2-53.3 12.82-80.96zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        "cookie-bite": [
            512,
            512,
            [],
            "f564",
            "M510.52 255.82c-69.97-.85-126.47-57.69-126.47-127.86-70.17 0-127-56.49-127.86-126.45-27.26-4.14-55.13.3-79.72 12.82l-69.13 35.22a132.221 132.221 0 0 0-57.79 57.81l-35.1 68.88a132.645 132.645 0 0 0-12.82 80.95l12.08 76.27a132.521 132.521 0 0 0 37.16 72.96l54.77 54.76a132.036 132.036 0 0 0 72.71 37.06l76.71 12.15c27.51 4.36 55.7-.11 80.53-12.76l69.13-35.21a132.273 132.273 0 0 0 57.79-57.81l35.1-68.88c12.56-24.64 17.01-52.58 12.91-79.91zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        copy: [
            448,
            512,
            [],
            "f0c5",
            "M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z"
        ],
        copyright: [
            512,
            512,
            [],
            "f1f9",
            "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm117.134 346.753c-1.592 1.867-39.776 45.731-109.851 45.731-84.692 0-144.484-63.26-144.484-145.567 0-81.303 62.004-143.401 143.762-143.401 66.957 0 101.965 37.315 103.422 38.904a12 12 0 0 1 1.238 14.623l-22.38 34.655c-4.049 6.267-12.774 7.351-18.234 2.295-.233-.214-26.529-23.88-61.88-23.88-46.116 0-73.916 33.575-73.916 76.082 0 39.602 25.514 79.692 74.277 79.692 38.697 0 65.28-28.338 65.544-28.625 5.132-5.565 14.059-5.033 18.508 1.053l24.547 33.572a12.001 12.001 0 0 1-.553 14.866z"
        ],
        couch: [
            640,
            512,
            [],
            "f4b8",
            "M160 224v64h320v-64c0-35.3 28.7-64 64-64h32c0-53-43-96-96-96H160c-53 0-96 43-96 96h32c35.3 0 64 28.7 64 64zm416-32h-32c-17.7 0-32 14.3-32 32v96H128v-96c0-17.7-14.3-32-32-32H64c-35.3 0-64 28.7-64 64 0 23.6 13 44 32 55.1V432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-16h384v16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V311.1c19-11.1 32-31.5 32-55.1 0-35.3-28.7-64-64-64z"
        ],
        "credit-card": [
            576,
            512,
            [],
            "f09d",
            "M0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V256H0v176zm192-68c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-40zm-128 0c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM576 80v48H0V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48z"
        ],
        crop: [
            512,
            512,
            [],
            "f125",
            "M488 352h-40V109.25l59.31-59.31c6.25-6.25 6.25-16.38 0-22.63L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0L402.75 64H192v96h114.75L160 306.75V24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v264c0 13.25 10.75 24 24 24h232v-96H205.25L352 205.25V488c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
        ],
        "crop-alt": [
            512,
            512,
            [],
            "f565",
            "M488 352h-40V96c0-17.67-14.33-32-32-32H192v96h160v328c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24zM160 24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v256c0 17.67 14.33 32 32 32h224v-96H160V24z"
        ],
        cross: [
            384,
            512,
            [],
            "f654",
            "M352 128h-96V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h96v224c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V256h96c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
        ],
        crosshairs: [
            512,
            512,
            [],
            "f05b",
            "M500 224h-30.364C455.724 130.325 381.675 56.276 288 42.364V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v30.364C130.325 56.276 56.276 130.325 42.364 224H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h30.364C56.276 381.675 130.325 455.724 224 469.636V500c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-30.364C381.675 455.724 455.724 381.675 469.636 288H500c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zM288 404.634V364c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40.634C165.826 392.232 119.783 346.243 107.366 288H148c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40.634C119.768 165.826 165.757 119.783 224 107.366V148c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40.634C346.174 119.768 392.217 165.757 404.634 224H364c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40.634C392.232 346.174 346.243 392.217 288 404.634zM288 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"
        ],
        crow: [
            640,
            512,
            [],
            "f520",
            "M544 32h-16.36C513.04 12.68 490.09 0 464 0c-44.18 0-80 35.82-80 80v20.98L12.09 393.57A30.216 30.216 0 0 0 0 417.74c0 22.46 23.64 37.07 43.73 27.03L165.27 384h96.49l44.41 120.1c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38L312.94 384H352c1.91 0 3.76-.23 5.66-.29l44.51 120.38c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38l-41.24-111.53C485.74 352.8 544 279.26 544 192v-80l96-16c0-35.35-42.98-64-96-64zm-80 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
        ],
        crown: [
            640,
            512,
            [],
            "f521",
            "M528 448H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm64-320c-26.5 0-48 21.5-48 48 0 7.1 1.6 13.7 4.4 19.8L476 239.2c-15.4 9.2-35.3 4-44.2-11.6L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-8.9 15.6-28.9 20.8-44.2 11.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8 0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5.4 5.1.8 7.7.8 26.5 0 48-21.5 48-48s-21.5-48-48-48z"
        ],
        crutch: [
            512,
            512,
            [],
            "f7f7",
            "M507.31 185.71l-181-181a16 16 0 0 0-22.62 0L281 27.31a16 16 0 0 0 0 22.63l181 181a16 16 0 0 0 22.63 0l22.62-22.63a16 16 0 0 0 .06-22.6zm-179.54 66.41l-67.89-67.89 55.1-55.1-45.25-45.25-109.67 109.67a96.08 96.08 0 0 0-25.67 46.29L106.65 360.1l-102 102a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0l102-102 120.25-27.75a95.88 95.88 0 0 0 46.29-25.65l109.68-109.68L382.87 197zm-54.57 54.57a32 32 0 0 1-15.45 8.54l-79.3 18.32 18.3-79.3a32.22 32.22 0 0 1 8.56-15.45l9.31-9.31 67.89 67.89z"
        ],
        cube: [
            512,
            512,
            [],
            "f1b2",
            "M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 68.4l192 72v1.1l-192 78-192-78v-1.1l192-72zm32 356V275.5l160-65v133.9l-160 80z"
        ],
        cubes: [
            512,
            512,
            [],
            "f1b3",
            "M488.6 250.2L392 214V105.5c0-15-9.3-28.4-23.4-33.7l-100-37.5c-8.1-3.1-17.1-3.1-25.3 0l-100 37.5c-14.1 5.3-23.4 18.7-23.4 33.7V214l-96.6 36.2C9.3 255.5 0 268.9 0 283.9V394c0 13.6 7.7 26.1 19.9 32.2l100 50c10.1 5.1 22.1 5.1 32.2 0l103.9-52 103.9 52c10.1 5.1 22.1 5.1 32.2 0l100-50c12.2-6.1 19.9-18.6 19.9-32.2V283.9c0-15-9.3-28.4-23.4-33.7zM358 214.8l-85 31.9v-68.2l85-37v73.3zM154 104.1l102-38.2 102 38.2v.6l-102 41.4-102-41.4v-.6zm84 291.1l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6zm240 112l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6z"
        ],
        cut: [
            448,
            512,
            [],
            "f0c4",
            "M278.06 256L444.48 89.57c4.69-4.69 4.69-12.29 0-16.97-32.8-32.8-85.99-32.8-118.79 0L210.18 188.12l-24.86-24.86c4.31-10.92 6.68-22.81 6.68-35.26 0-53.02-42.98-96-96-96S0 74.98 0 128s42.98 96 96 96c4.54 0 8.99-.32 13.36-.93L142.29 256l-32.93 32.93c-4.37-.61-8.83-.93-13.36-.93-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-12.45-2.37-24.34-6.68-35.26l24.86-24.86L325.69 439.4c32.8 32.8 85.99 32.8 118.79 0 4.69-4.68 4.69-12.28 0-16.97L278.06 256zM96 160c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm0 256c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"
        ],
        database: [
            448,
            512,
            [],
            "f1c0",
            "M448 73.143v45.714C448 159.143 347.667 192 224 192S0 159.143 0 118.857V73.143C0 32.857 100.333 0 224 0s224 32.857 224 73.143zM448 176v102.857C448 319.143 347.667 352 224 352S0 319.143 0 278.857V176c48.125 33.143 136.208 48.572 224 48.572S399.874 209.143 448 176zm0 160v102.857C448 479.143 347.667 512 224 512S0 479.143 0 438.857V336c48.125 33.143 136.208 48.572 224 48.572S399.874 369.143 448 336z"
        ],
        deaf: [
            512,
            512,
            [],
            "f2a4",
            "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm268.485-52.201L480.2 3.515c-4.687-4.686-12.284-4.686-16.971 0L376.2 90.544c-4.686 4.686-4.686 12.284 0 16.971l28.285 28.285c4.686 4.686 12.284 4.686 16.97 0l87.03-87.029c4.687-4.688 4.687-12.286 0-16.972zM168.97 314.745c-4.686-4.686-12.284-4.686-16.97 0L3.515 463.23c-4.686 4.686-4.686 12.284 0 16.971L31.8 508.485c4.687 4.686 12.284 4.686 16.971 0L197.256 360c4.686-4.686 4.686-12.284 0-16.971l-28.286-28.284z"
        ],
        democrat: [
            640,
            512,
            [],
            "f747",
            "M637.3 256.9l-19.6-29.4c-28.2-42.3-75.3-67.5-126.1-67.5H256l-81.2-81.2c20.1-20.1 22.6-51.1 7.5-73.9-3.4-5.2-10.8-5.9-15.2-1.5l-41.8 41.8L82.4 2.4c-3.6-3.6-9.6-3-12.4 1.2-12.3 18.6-10.3 44 6.1 60.4 3.3 3.3 7.3 5.3 11.3 7.5-2.2 1.7-4.7 3.1-6.4 5.4L6.4 176.2c-7.3 9.7-8.4 22.7-3 33.5l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h31c8.5 0 16.6-3.4 22.6-9.4L138 212l54 108h352v-77.8c16.2 12.2 18.3 17.6 40.1 50.3 4.9 7.4 14.8 9.3 22.2 4.4l26.6-17.7c7.3-5 9.3-14.9 4.4-22.3zm-341.1-13.6l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L256 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L368 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L480 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zM192 496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80h160v80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V352H192v144z"
        ],
        desktop: [
            576,
            512,
            [],
            "f108",
            "M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h448v288z"
        ],
        dharmachakra: [
            512,
            512,
            [],
            "f655",
            "M495 225.06l-17.22 1.08c-5.27-39.49-20.79-75.64-43.86-105.84l12.95-11.43c6.92-6.11 7.25-16.79.73-23.31L426.44 64.4c-6.53-6.53-17.21-6.19-23.31.73L391.7 78.07c-30.2-23.06-66.35-38.58-105.83-43.86L286.94 17c.58-9.21-6.74-17-15.97-17h-29.94c-9.23 0-16.54 7.79-15.97 17l1.08 17.22c-39.49 5.27-75.64 20.79-105.83 43.86l-11.43-12.95c-6.11-6.92-16.79-7.25-23.31-.73L64.4 85.56c-6.53 6.53-6.19 17.21.73 23.31l12.95 11.43c-23.06 30.2-38.58 66.35-43.86 105.84L17 225.06c-9.21-.58-17 6.74-17 15.97v29.94c0 9.23 7.79 16.54 17 15.97l17.22-1.08c5.27 39.49 20.79 75.64 43.86 105.83l-12.95 11.43c-6.92 6.11-7.25 16.79-.73 23.31l21.17 21.17c6.53 6.53 17.21 6.19 23.31-.73l11.43-12.95c30.2 23.06 66.35 38.58 105.84 43.86L225.06 495c-.58 9.21 6.74 17 15.97 17h29.94c9.23 0 16.54-7.79 15.97-17l-1.08-17.22c39.49-5.27 75.64-20.79 105.84-43.86l11.43 12.95c6.11 6.92 16.79 7.25 23.31.73l21.17-21.17c6.53-6.53 6.19-17.21-.73-23.31l-12.95-11.43c23.06-30.2 38.58-66.35 43.86-105.83l17.22 1.08c9.21.58 17-6.74 17-15.97v-29.94c-.01-9.23-7.8-16.54-17.01-15.97zM281.84 98.61c24.81 4.07 47.63 13.66 67.23 27.78l-42.62 48.29c-8.73-5.44-18.32-9.54-28.62-11.95l4.01-64.12zm-51.68 0l4.01 64.12c-10.29 2.41-19.89 6.52-28.62 11.95l-42.62-48.29c19.6-14.12 42.42-23.71 67.23-27.78zm-103.77 64.33l48.3 42.61c-5.44 8.73-9.54 18.33-11.96 28.62l-64.12-4.01c4.07-24.81 13.66-47.62 27.78-67.22zm-27.78 118.9l64.12-4.01c2.41 10.29 6.52 19.89 11.95 28.62l-48.29 42.62c-14.12-19.6-23.71-42.42-27.78-67.23zm131.55 131.55c-24.81-4.07-47.63-13.66-67.23-27.78l42.61-48.3c8.73 5.44 18.33 9.54 28.62 11.96l-4 64.12zM256 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm25.84 125.39l-4.01-64.12c10.29-2.41 19.89-6.52 28.62-11.96l42.61 48.3c-19.6 14.12-42.41 23.71-67.22 27.78zm103.77-64.33l-48.29-42.62c5.44-8.73 9.54-18.32 11.95-28.62l64.12 4.01c-4.07 24.82-13.66 47.64-27.78 67.23zm-36.34-114.89c-2.41-10.29-6.52-19.89-11.96-28.62l48.3-42.61c14.12 19.6 23.71 42.42 27.78 67.23l-64.12 4z"
        ],
        diagnoses: [
            640,
            512,
            [],
            "f470",
            "M496 256c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm-176-80c48.5 0 88-39.5 88-88S368.5 0 320 0s-88 39.5-88 88 39.5 88 88 88zM59.8 364c10.2 15.3 29.3 17.8 42.9 9.8 16.2-9.6 56.2-31.7 105.3-48.6V416h224v-90.7c49.1 16.8 89.1 39 105.3 48.6 13.6 8 32.7 5.3 42.9-9.8l17.8-26.7c8.8-13.2 7.6-34.6-10-45.1-11.9-7.1-29.7-17-51.1-27.4-28.1 46.1-99.4 17.8-87.7-35.1C409.3 217.2 365.1 208 320 208c-57 0-112.9 14.5-160 32.2-.2 40.2-47.6 63.3-79.2 36-11.2 6-21.3 11.6-28.7 16-17.6 10.5-18.8 31.8-10 45.1L59.8 364zM368 344c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-160 8c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm512 192H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
        ],
        dice: [
            640,
            512,
            [],
            "f522",
            "M592 192H473.26c12.69 29.59 7.12 65.2-17 89.32L320 417.58V464c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48V240c0-26.51-21.49-48-48-48zM480 376c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm-46.37-186.7L258.7 14.37c-19.16-19.16-50.23-19.16-69.39 0L14.37 189.3c-19.16 19.16-19.16 50.23 0 69.39L189.3 433.63c19.16 19.16 50.23 19.16 69.39 0L433.63 258.7c19.16-19.17 19.16-50.24 0-69.4zM96 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
        ],
        "dice-d20": [
            480,
            512,
            [],
            "f6cf",
            "M106.75 215.06L1.2 370.95c-3.08 5 .1 11.5 5.93 12.14l208.26 22.07-108.64-190.1zM7.41 315.43L82.7 193.08 6.06 147.1c-2.67-1.6-6.06.32-6.06 3.43v162.81c0 4.03 5.29 5.53 7.41 2.09zM18.25 423.6l194.4 87.66c5.3 2.45 11.35-1.43 11.35-7.26v-65.67l-203.55-22.3c-4.45-.5-6.23 5.59-2.2 7.57zm81.22-257.78L179.4 22.88c4.34-7.06-3.59-15.25-10.78-11.14L17.81 110.35c-2.47 1.62-2.39 5.26.13 6.78l81.53 48.69zM240 176h109.21L253.63 7.62C250.5 2.54 245.25 0 240 0s-10.5 2.54-13.63 7.62L130.79 176H240zm233.94-28.9l-76.64 45.99 75.29 122.35c2.11 3.44 7.41 1.94 7.41-2.1V150.53c0-3.11-3.39-5.03-6.06-3.43zm-93.41 18.72l81.53-48.7c2.53-1.52 2.6-5.16.13-6.78l-150.81-98.6c-7.19-4.11-15.12 4.08-10.78 11.14l79.93 142.94zm79.02 250.21L256 438.32v65.67c0 5.84 6.05 9.71 11.35 7.26l194.4-87.66c4.03-1.97 2.25-8.06-2.2-7.56zm-86.3-200.97l-108.63 190.1 208.26-22.07c5.83-.65 9.01-7.14 5.93-12.14L373.25 215.06zM240 208H139.57L240 383.75 340.43 208H240z"
        ],
        "dice-d6": [
            448,
            512,
            [],
            "f6d1",
            "M422.19 109.95L256.21 9.07c-19.91-12.1-44.52-12.1-64.43 0L25.81 109.95c-5.32 3.23-5.29 11.27.06 14.46L224 242.55l198.14-118.14c5.35-3.19 5.38-11.22.05-14.46zm13.84 44.63L240 271.46v223.82c0 12.88 13.39 20.91 24.05 14.43l152.16-92.48c19.68-11.96 31.79-33.94 31.79-57.7v-197.7c0-6.41-6.64-10.43-11.97-7.25zM0 161.83v197.7c0 23.77 12.11 45.74 31.79 57.7l152.16 92.47c10.67 6.48 24.05-1.54 24.05-14.43V271.46L11.97 154.58C6.64 151.4 0 155.42 0 161.83z"
        ],
        "dice-five": [
            448,
            512,
            [],
            "f523",
            "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        "dice-four": [
            448,
            512,
            [],
            "f524",
            "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        "dice-one": [
            448,
            512,
            [],
            "f525",
            "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM224 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        "dice-six": [
            448,
            512,
            [],
            "f526",
            "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        "dice-three": [
            448,
            512,
            [],
            "f527",
            "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        "dice-two": [
            448,
            512,
            [],
            "f528",
            "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        "digital-tachograph": [
            640,
            512,
            [],
            "f566",
            "M608 96H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128c0-17.67-14.33-32-32-32zM304 352c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8zM72 288v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H80c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm40-64c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-48c0-8.84 7.16-16 16-16h208c8.84 0 16 7.16 16 16v48zm272 128c0 4.42-3.58 8-8 8H344c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8z"
        ],
        directions: [
            512,
            512,
            [],
            "f5eb",
            "M502.61 233.32L278.68 9.39c-12.52-12.52-32.83-12.52-45.36 0L9.39 233.32c-12.52 12.53-12.52 32.83 0 45.36l223.93 223.93c12.52 12.53 32.83 12.53 45.36 0l223.93-223.93c12.52-12.53 12.52-32.83 0-45.36zm-100.98 12.56l-84.21 77.73c-5.12 4.73-13.43 1.1-13.43-5.88V264h-96v64c0 4.42-3.58 8-8 8h-32c-4.42 0-8-3.58-8-8v-80c0-17.67 14.33-32 32-32h112v-53.73c0-6.97 8.3-10.61 13.43-5.88l84.21 77.73c3.43 3.17 3.43 8.59 0 11.76z"
        ],
        disease: [
            512,
            512,
            [],
            "f7fa",
            "M472.29 195.9l-67.06-23c-19.28-6.6-33.54-20.92-38.14-38.31l-16-60.45c-11.58-43.77-76.57-57.13-110-22.62L195 99.24c-13.26 13.71-33.54 20.93-54.2 19.31l-71.9-5.62c-52-4.07-86.93 44.89-59 82.84l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24l-28.43 57C4 396.67 47.46 440.29 98.11 429.23l70-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101 7.57 104.45-37.22l4.7-61.86c1.35-17.8 12.8-33.87 30.63-43l62-31.74c44.84-22.96 39.55-80.17-8.99-96.79zM160 256a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm128 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm16-128a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"
        ],
        divide: [
            448,
            512,
            [],
            "f529",
            "M224 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm0-192c35.35 0 64-28.65 64-64s-28.65-64-64-64-64 28.65-64 64 28.65 64 64 64zm192 48H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
        ],
        dizzy: [
            496,
            512,
            [],
            "f567",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-96 206.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L174.6 192l28.7 28.7c15.2 15.2-7.9 37.4-22.6 22.6L152 214.6zM248 416c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm147.3-195.3c15.2 15.2-7.9 37.4-22.6 22.6L344 214.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L366.6 192l28.7 28.7z"
        ],
        dna: [
            448,
            512,
            [],
            "f471",
            "M.1 494.1c-1.1 9.5 6.3 17.8 15.9 17.8l32.3.1c8.1 0 14.9-5.9 16-13.9.7-4.9 1.8-11.1 3.4-18.1H380c1.6 6.9 2.9 13.2 3.5 18.1 1.1 8 7.9 14 16 13.9l32.3-.1c9.6 0 17.1-8.3 15.9-17.8-4.6-37.9-25.6-129-118.9-207.7-17.6 12.4-37.1 24.2-58.5 35.4 6.2 4.6 11.4 9.4 17 14.2H159.7c21.3-18.1 47-35.6 78.7-51.4C410.5 199.1 442.1 65.8 447.9 17.9 449 8.4 441.6.1 432 .1L399.6 0c-8.1 0-14.9 5.9-16 13.9-.7 4.9-1.8 11.1-3.4 18.1H67.8c-1.6-7-2.7-13.1-3.4-18.1-1.1-8-7.9-14-16-13.9L16.1.1C6.5.1-1 8.4.1 17.9 5.3 60.8 31.4 171.8 160 256 31.5 340.2 5.3 451.2.1 494.1zM224 219.6c-25.1-13.7-46.4-28.4-64.3-43.6h128.5c-17.8 15.2-39.1 30-64.2 43.6zM355.1 96c-5.8 10.4-12.8 21.1-21 32H114c-8.3-10.9-15.3-21.6-21-32h262.1zM92.9 416c5.8-10.4 12.8-21.1 21-32h219.4c8.3 10.9 15.4 21.6 21.2 32H92.9z"
        ],
        dog: [
            576,
            512,
            [],
            "f6d3",
            "M298.06,224,448,277.55V496a16,16,0,0,1-16,16H368a16,16,0,0,1-16-16V384H192V496a16,16,0,0,1-16,16H112a16,16,0,0,1-16-16V282.09C58.84,268.84,32,233.66,32,192a32,32,0,0,1,64,0,32.06,32.06,0,0,0,32,32ZM544,112v32a64,64,0,0,1-64,64H448v35.58L320,197.87V48c0-14.25,17.22-21.39,27.31-11.31L374.59,64h53.63c10.91,0,23.75,7.92,28.62,17.69L464,96h64A16,16,0,0,1,544,112Zm-112,0a16,16,0,1,0-16,16A16,16,0,0,0,432,112Z"
        ],
        "dollar-sign": [
            288,
            512,
            [],
            "f155",
            "M209.2 233.4l-108-31.6C88.7 198.2 80 186.5 80 173.5c0-16.3 13.2-29.5 29.5-29.5h66.3c12.2 0 24.2 3.7 34.2 10.5 6.1 4.1 14.3 3.1 19.5-2l34.8-34c7.1-6.9 6.1-18.4-1.8-24.5C238 74.8 207.4 64.1 176 64V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-2.5C45.8 64-5.4 118.7.5 183.6c4.2 46.1 39.4 83.6 83.8 96.6l102.5 30c12.5 3.7 21.2 15.3 21.2 28.3 0 16.3-13.2 29.5-29.5 29.5h-66.3C100 368 88 364.3 78 357.5c-6.1-4.1-14.3-3.1-19.5 2l-34.8 34c-7.1 6.9-6.1 18.4 1.8 24.5 24.5 19.2 55.1 29.9 86.5 30v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48.2c46.6-.9 90.3-28.6 105.7-72.7 21.5-61.6-14.6-124.8-72.5-141.7z"
        ],
        dolly: [
            576,
            512,
            [],
            "f472",
            "M294.2 277.7c18 5 34.7 13.4 49.5 24.7l161.5-53.8c8.4-2.8 12.9-11.9 10.1-20.2L454.9 47.2c-2.8-8.4-11.9-12.9-20.2-10.1l-61.1 20.4 33.1 99.4L346 177l-33.1-99.4-61.6 20.5c-8.4 2.8-12.9 11.9-10.1 20.2l53 159.4zm281 48.7L565 296c-2.8-8.4-11.9-12.9-20.2-10.1l-213.5 71.2c-17.2-22-43.6-36.4-73.5-37L158.4 21.9C154 8.8 141.8 0 128 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h88.9l92.2 276.7c-26.1 20.4-41.7 53.6-36 90.5 6.1 39.4 37.9 72.3 77.3 79.2 60.2 10.7 112.3-34.8 113.4-92.6l213.3-71.2c8.3-2.8 12.9-11.8 10.1-20.2zM256 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
        ],
        "dolly-flatbed": [
            640,
            512,
            [],
            "f474",
            "M208 320h384c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H448v128l-48-32-48 32V32H208c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm416 64H128V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h82.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H624c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
        ],
        donate: [
            512,
            512,
            [],
            "f4b9",
            "M256 416c114.9 0 208-93.1 208-208S370.9 0 256 0 48 93.1 48 208s93.1 208 208 208zM233.8 97.4V80.6c0-9.2 7.4-16.6 16.6-16.6h11.1c9.2 0 16.6 7.4 16.6 16.6v17c15.5.8 30.5 6.1 43 15.4 5.6 4.1 6.2 12.3 1.2 17.1L306 145.6c-3.8 3.7-9.5 3.8-14 1-5.4-3.4-11.4-5.1-17.8-5.1h-38.9c-9 0-16.3 8.2-16.3 18.3 0 8.2 5 15.5 12.1 17.6l62.3 18.7c25.7 7.7 43.7 32.4 43.7 60.1 0 34-26.4 61.5-59.1 62.4v16.8c0 9.2-7.4 16.6-16.6 16.6h-11.1c-9.2 0-16.6-7.4-16.6-16.6v-17c-15.5-.8-30.5-6.1-43-15.4-5.6-4.1-6.2-12.3-1.2-17.1l16.3-15.5c3.8-3.7 9.5-3.8 14-1 5.4 3.4 11.4 5.1 17.8 5.1h38.9c9 0 16.3-8.2 16.3-18.3 0-8.2-5-15.5-12.1-17.6l-62.3-18.7c-25.7-7.7-43.7-32.4-43.7-60.1.1-34 26.4-61.5 59.1-62.4zM480 352h-32.5c-19.6 26-44.6 47.7-73 64h63.8c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8h63.8c-28.4-16.3-53.3-38-73-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32z"
        ],
        "door-closed": [
            640,
            512,
            [],
            "f52a",
            "M624 448H512V50.8C512 22.78 490.47 0 464 0H175.99c-26.47 0-48 22.78-48 50.8V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM415.99 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32c.01 17.67-14.32 32-32 32z"
        ],
        "door-open": [
            640,
            512,
            [],
            "f52b",
            "M624 448h-80V113.45C544 86.19 522.47 64 496 64H384v64h96v384h144c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM312.24 1.01l-192 49.74C105.99 54.44 96 67.7 96 82.92V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h336V33.18c0-21.58-19.56-37.41-39.76-32.17zM264 288c-13.25 0-24-14.33-24-32s10.75-32 24-32 24 14.33 24 32-10.75 32-24 32z"
        ],
        "dot-circle": [
            512,
            512,
            [],
            "f192",
            "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"
        ],
        dove: [
            512,
            512,
            [],
            "f4ba",
            "M288 167.2v-28.1c-28.2-36.3-47.1-79.3-54.1-125.2-2.1-13.5-19-18.8-27.8-8.3-21.1 24.9-37.7 54.1-48.9 86.5 34.2 38.3 80 64.6 130.8 75.1zM400 64c-44.2 0-80 35.9-80 80.1v59.4C215.6 197.3 127 133 87 41.8c-5.5-12.5-23.2-13.2-29-.9C41.4 76 32 115.2 32 156.6c0 70.8 34.1 136.9 85.1 185.9 13.2 12.7 26.1 23.2 38.9 32.8l-143.9 36C1.4 414-3.4 426.4 2.6 435.7 20 462.6 63 508.2 155.8 512c8 .3 16-2.6 22.1-7.9l65.2-56.1H320c88.4 0 160-71.5 160-159.9V128l32-64H400zm0 96.1c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
        ],
        download: [
            512,
            512,
            [],
            "f019",
            "M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
        ],
        "drafting-compass": [
            512,
            512,
            [],
            "f568",
            "M457.01 344.42c-25.05 20.33-52.63 37.18-82.54 49.05l54.38 94.19 53.95 23.04c9.81 4.19 20.89-2.21 22.17-12.8l7.02-58.25-54.98-95.23zm42.49-94.56c4.86-7.67 1.89-17.99-6.05-22.39l-28.07-15.57c-7.48-4.15-16.61-1.46-21.26 5.72C403.01 281.15 332.25 320 256 320c-23.93 0-47.23-4.25-69.41-11.53l67.36-116.68c.7.02 1.34.21 2.04.21s1.35-.19 2.04-.21l51.09 88.5c31.23-8.96 59.56-25.75 82.61-48.92l-51.79-89.71C347.39 128.03 352 112.63 352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96c0 16.63 4.61 32.03 12.05 45.66l-68.3 118.31c-12.55-11.61-23.96-24.59-33.68-39-4.79-7.1-13.97-9.62-21.38-5.33l-27.75 16.07c-7.85 4.54-10.63 14.9-5.64 22.47 15.57 23.64 34.69 44.21 55.98 62.02L0 439.66l7.02 58.25c1.28 10.59 12.36 16.99 22.17 12.8l53.95-23.04 70.8-122.63C186.13 377.28 220.62 384 256 384c99.05 0 190.88-51.01 243.5-134.14zM256 64c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32z"
        ],
        dragon: [
            640,
            512,
            [],
            "f6d5",
            "M18.32 255.78L192 223.96l-91.28 68.69c-10.08 10.08-2.94 27.31 11.31 27.31h222.7c-9.44-26.4-14.73-54.47-14.73-83.38v-42.27l-119.73-87.6c-23.82-15.88-55.29-14.01-77.06 4.59L5.81 227.64c-12.38 10.33-3.45 30.42 12.51 28.14zm556.87 34.1l-100.66-50.31A47.992 47.992 0 0 1 448 196.65v-36.69h64l28.09 22.63c6 6 14.14 9.37 22.63 9.37h30.97a32 32 0 0 0 28.62-17.69l14.31-28.62a32.005 32.005 0 0 0-3.02-33.51l-74.53-99.38C553.02 4.7 543.54 0 533.47 0H296.02c-7.13 0-10.7 8.57-5.66 13.61L352 63.96 292.42 88.8c-5.9 2.95-5.9 11.36 0 14.31L352 127.96v108.62c0 72.08 36.03 139.39 96 179.38-195.59 6.81-344.56 41.01-434.1 60.91C5.78 478.67 0 485.88 0 494.2 0 504 7.95 512 17.76 512h499.08c63.29.01 119.61-47.56 122.99-110.76 2.52-47.28-22.73-90.4-64.64-111.36zM489.18 66.25l45.65 11.41c-2.75 10.91-12.47 18.89-24.13 18.26-12.96-.71-25.85-12.53-21.52-29.67z"
        ],
        "draw-polygon": [
            448,
            512,
            [],
            "f5ee",
            "M384 352c-.35 0-.67.1-1.02.1l-39.2-65.32c5.07-9.17 8.22-19.56 8.22-30.78s-3.14-21.61-8.22-30.78l39.2-65.32c.35.01.67.1 1.02.1 35.35 0 64-28.65 64-64s-28.65-64-64-64c-23.63 0-44.04 12.95-55.12 32H119.12C108.04 44.95 87.63 32 64 32 28.65 32 0 60.65 0 96c0 23.63 12.95 44.04 32 55.12v209.75C12.95 371.96 0 392.37 0 416c0 35.35 28.65 64 64 64 23.63 0 44.04-12.95 55.12-32h209.75c11.09 19.05 31.49 32 55.12 32 35.35 0 64-28.65 64-64 .01-35.35-28.64-64-63.99-64zm-288 8.88V151.12A63.825 63.825 0 0 0 119.12 128h208.36l-38.46 64.1c-.35-.01-.67-.1-1.02-.1-35.35 0-64 28.65-64 64s28.65 64 64 64c.35 0 .67-.1 1.02-.1l38.46 64.1H119.12A63.748 63.748 0 0 0 96 360.88zM272 256c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zM400 96c0 8.82-7.18 16-16 16s-16-7.18-16-16 7.18-16 16-16 16 7.18 16 16zM64 80c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM48 416c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zm336 16c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16z"
        ],
        drum: [
            512,
            512,
            [],
            "f569",
            "M431.34 122.05l73.53-47.42a16 16 0 0 0 4.44-22.19l-8.87-13.31a16 16 0 0 0-22.19-4.44l-110.06 71C318.43 96.91 271.22 96 256 96 219.55 96 0 100.55 0 208.15v160.23c0 30.27 27.5 57.68 72 77.86v-101.9a24 24 0 1 1 48 0v118.93c33.05 9.11 71.07 15.06 112 16.73V376.39a24 24 0 1 1 48 0V480c40.93-1.67 78.95-7.62 112-16.73V344.34a24 24 0 1 1 48 0v101.9c44.5-20.18 72-47.59 72-77.86V208.15c0-43.32-35.76-69.76-80.66-86.1zM256 272.24c-114.88 0-208-28.69-208-64.09s93.12-64.08 208-64.08c17.15 0 33.73.71 49.68 1.91l-72.81 47a16 16 0 0 0-4.43 22.19l8.87 13.31a16 16 0 0 0 22.19 4.44l118.64-76.52C430.09 168 464 186.84 464 208.15c0 35.4-93.13 64.09-208 64.09z"
        ],
        "drum-steelpan": [
            576,
            512,
            [],
            "f56a",
            "M288 32C128.94 32 0 89.31 0 160v192c0 70.69 128.94 128 288 128s288-57.31 288-128V160c0-70.69-128.94-128-288-128zm-82.99 158.36c-4.45 16.61-14.54 30.57-28.31 40.48C100.23 217.46 48 190.78 48 160c0-30.16 50.11-56.39 124.04-70.03l25.6 44.34c9.86 17.09 12.48 36.99 7.37 56.05zM288 240c-21.08 0-41.41-1-60.89-2.7 8.06-26.13 32.15-45.3 60.89-45.3s52.83 19.17 60.89 45.3C329.41 239 309.08 240 288 240zm64-144c0 35.29-28.71 64-64 64s-64-28.71-64-64V82.96c20.4-1.88 41.8-2.96 64-2.96s43.6 1.08 64 2.96V96zm46.93 134.9c-13.81-9.91-23.94-23.9-28.4-40.54-5.11-19.06-2.49-38.96 7.38-56.04l25.65-44.42C477.72 103.5 528 129.79 528 160c0 30.83-52.4 57.54-129.07 70.9z"
        ],
        "drumstick-bite": [
            512,
            512,
            [],
            "f6d7",
            "M462.8 49.57a169.44 169.44 0 0 0-239.5 0C187.82 85 160.13 128 160.13 192v85.83l-40.62 40.59c-9.7 9.69-24 11.07-36.78 6a60.33 60.33 0 0 0-65 98.72C33 438.39 54.24 442.7 73.85 438.21c-4.5 19.6-.18 40.83 15.1 56.1a60.35 60.35 0 0 0 98.8-65c-5.09-12.73-3.72-27 6-36.75L234.36 352h85.89a187.87 187.87 0 0 0 61.89-10c-39.64-43.89-39.83-110.23 1.05-151.07 34.38-34.36 86.76-39.46 128.74-16.8 1.3-44.96-14.81-90.28-49.13-124.56z"
        ],
        dumbbell: [
            640,
            512,
            [],
            "f44b",
            "M104 96H56c-13.3 0-24 10.7-24 24v104H8c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h24v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm528 128h-24V120c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h24c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM456 32h-48c-13.3 0-24 10.7-24 24v168H256V56c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h128v168c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24z"
        ],
        dumpster: [
            576,
            512,
            [],
            "f793",
            "M560 160c10.4 0 18-9.8 15.5-19.9l-24-96C549.7 37 543.3 32 536 32h-98.9l25.6 128H560zM272 32H171.5l-25.6 128H272V32zm132.5 0H304v128h126.1L404.5 32zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm544 64h-20l4-32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h320v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16l20-160h28c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
        ],
        "dumpster-fire": [
            640,
            512,
            [],
            "f794",
            "M418.7 104.1l.2-.2-14.4-72H304v128h60.8c16.2-19.3 34.2-38.2 53.9-55.8zM272 32H171.5l-25.6 128H272V32zm189.3 72.1c18.2 16.3 35.5 33.7 51.1 51.5 5.7-5.6 11.4-11.1 17.3-16.3l21.3-19 21.3 19c1.1.9 2.1 2.1 3.1 3.1-.1-.8.2-1.5 0-2.3l-24-96C549.7 37 543.3 32 536 32h-98.9l12.3 61.5 11.9 10.6zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm324.6 32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208.8c-30.2-33.7-48.8-77.9-48.8-126.4 0-35.9 19.9-82.9 52.6-129.6zm210.5-28.8c-14.9 13.3-28.3 27.2-40.2 41.2-19.5-25.8-43.6-52-71-76.4-70.2 62.7-120 144.3-120 193.6 0 87.5 71.6 158.4 160 158.4s160-70.9 160-158.4c.1-36.6-37-112.2-88.8-158.4zm-18.6 229.4c-14.7 10.7-32.9 17-52.5 17-49 0-88.9-33.5-88.9-88 0-27.1 16.5-51 49.4-91.9 4.7 5.6 67.1 88.1 67.1 88.1l39.8-47c2.8 4.8 5.4 9.5 7.7 14 18.6 36.7 10.8 83.6-22.6 107.8z"
        ],
        dungeon: [
            512,
            512,
            [],
            "f6d9",
            "M128.73 195.32l-82.81-51.76c-8.04-5.02-18.99-2.17-22.93 6.45A254.19 254.19 0 0 0 .54 239.28C-.05 248.37 7.59 256 16.69 256h97.13c7.96 0 14.08-6.25 15.01-14.16 1.09-9.33 3.24-18.33 6.24-26.94 2.56-7.34.25-15.46-6.34-19.58zM319.03 8C298.86 2.82 277.77 0 256 0s-42.86 2.82-63.03 8c-9.17 2.35-13.91 12.6-10.39 21.39l37.47 104.03A16.003 16.003 0 0 0 235.1 144h41.8c6.75 0 12.77-4.23 15.05-10.58l37.47-104.03c3.52-8.79-1.22-19.03-10.39-21.39zM112 288H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm77.31-283.67l-36.32-90.8c-3.53-8.83-14.13-12.99-22.42-8.31a257.308 257.308 0 0 0-71.61 59.89c-6.06 7.32-3.85 18.48 4.22 23.52l82.93 51.83c6.51 4.07 14.66 2.62 20.11-2.79 5.18-5.15 10.79-9.85 16.79-14.05 6.28-4.41 9.15-12.17 6.3-19.29zM398.18 256h97.13c9.1 0 16.74-7.63 16.15-16.72a254.135 254.135 0 0 0-22.45-89.27c-3.94-8.62-14.89-11.47-22.93-6.45l-82.81 51.76c-6.59 4.12-8.9 12.24-6.34 19.58 3.01 8.61 5.15 17.62 6.24 26.94.93 7.91 7.05 14.16 15.01 14.16zm54.85-162.89a257.308 257.308 0 0 0-71.61-59.89c-8.28-4.68-18.88-.52-22.42 8.31l-36.32 90.8c-2.85 7.12.02 14.88 6.3 19.28 6 4.2 11.61 8.9 16.79 14.05 5.44 5.41 13.6 6.86 20.11 2.79l82.93-51.83c8.07-5.03 10.29-16.19 4.22-23.51zM496 288h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zM240 177.62V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V177.62c-5.23-.89-10.52-1.62-16-1.62s-10.77.73-16 1.62zm-64 41.51V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V189.36c-12.78 7.45-23.84 17.47-32 29.77zm128-29.77V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V219.13c-8.16-12.3-19.22-22.32-32-29.77z"
        ],
        edit: [
            576,
            512,
            [],
            "f044",
            "M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"
        ],
        egg: [
            384,
            512,
            [],
            "f7fb",
            "M192 0C86 0 0 214 0 320s86 192 192 192 192-86 192-192S298 0 192 0z"
        ],
        eject: [
            448,
            512,
            [],
            "f052",
            "M448 384v64c0 17.673-14.327 32-32 32H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h384c17.673 0 32 14.327 32 32zM48.053 320h351.886c41.651 0 63.581-49.674 35.383-80.435L259.383 47.558c-19.014-20.743-51.751-20.744-70.767 0L12.67 239.565C-15.475 270.268 6.324 320 48.053 320z"
        ],
        "ellipsis-h": [
            512,
            512,
            [],
            "f141",
            "M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"
        ],
        "ellipsis-v": [
            192,
            512,
            [],
            "f142",
            "M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z"
        ],
        envelope: [
            512,
            512,
            [],
            "f0e0",
            "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
        ],
        "envelope-open": [
            512,
            512,
            [],
            "f2b6",
            "M512 464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V200.724a48 48 0 0 1 18.387-37.776c24.913-19.529 45.501-35.365 164.2-121.511C199.412 29.17 232.797-.347 256 .003c23.198-.354 56.596 29.172 73.413 41.433 118.687 86.137 139.303 101.995 164.2 121.512A48 48 0 0 1 512 200.724V464zm-65.666-196.605c-2.563-3.728-7.7-4.595-11.339-1.907-22.845 16.873-55.462 40.705-105.582 77.079-16.825 12.266-50.21 41.781-73.413 41.43-23.211.344-56.559-29.143-73.413-41.43-50.114-36.37-82.734-60.204-105.582-77.079-3.639-2.688-8.776-1.821-11.339 1.907l-9.072 13.196a7.998 7.998 0 0 0 1.839 10.967c22.887 16.899 55.454 40.69 105.303 76.868 20.274 14.781 56.524 47.813 92.264 47.573 35.724.242 71.961-32.771 92.263-47.573 49.85-36.179 82.418-59.97 105.303-76.868a7.998 7.998 0 0 0 1.839-10.967l-9.071-13.196z"
        ],
        "envelope-open-text": [
            512,
            512,
            [],
            "f658",
            "M176 216h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16zm-16 80c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16zm96 121.13c-16.42 0-32.84-5.06-46.86-15.19L0 250.86V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V250.86L302.86 401.94c-14.02 10.12-30.44 15.19-46.86 15.19zm237.61-254.18c-8.85-6.94-17.24-13.47-29.61-22.81V96c0-26.51-21.49-48-48-48h-77.55c-3.04-2.2-5.87-4.26-9.04-6.56C312.6 29.17 279.2-.35 256 0c-23.2-.35-56.59 29.17-73.41 41.44-3.17 2.3-6 4.36-9.04 6.56H96c-26.51 0-48 21.49-48 48v44.14c-12.37 9.33-20.76 15.87-29.61 22.81A47.995 47.995 0 0 0 0 200.72v10.65l96 69.35V96h320v184.72l96-69.35v-10.65c0-14.74-6.78-28.67-18.39-37.77z"
        ],
        "envelope-square": [
            448,
            512,
            [],
            "f199",
            "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM178.117 262.104C87.429 196.287 88.353 196.121 64 177.167V152c0-13.255 10.745-24 24-24h272c13.255 0 24 10.745 24 24v25.167c-24.371 18.969-23.434 19.124-114.117 84.938-10.5 7.655-31.392 26.12-45.883 25.894-14.503.218-35.367-18.227-45.883-25.895zM384 217.775V360c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V217.775c13.958 10.794 33.329 25.236 95.303 70.214 14.162 10.341 37.975 32.145 64.694 32.01 26.887.134 51.037-22.041 64.72-32.025 61.958-44.965 81.325-59.406 95.283-70.199z"
        ],
        equals: [
            448,
            512,
            [],
            "f52c",
            "M416 304H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32zm0-192H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
        ],
        eraser: [
            512,
            512,
            [],
            "f12d",
            "M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 0 0 144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80 124.686-124.686z"
        ],
        ethernet: [
            512,
            512,
            [],
            "f796",
            "M496 192h-48v-48c0-8.8-7.2-16-16-16h-48V80c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v48H80c-8.8 0-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h80V320h32v128h64V320h32v128h64V320h32v128h64V320h32v128h80c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16z"
        ],
        "euro-sign": [
            320,
            512,
            [],
            "f153",
            "M310.706 413.765c-1.314-6.63-7.835-10.872-14.424-9.369-10.692 2.439-27.422 5.413-45.426 5.413-56.763 0-101.929-34.79-121.461-85.449h113.689a12 12 0 0 0 11.708-9.369l6.373-28.36c1.686-7.502-4.019-14.631-11.708-14.631H115.22c-1.21-14.328-1.414-28.287.137-42.245H261.95a12 12 0 0 0 11.723-9.434l6.512-29.755c1.638-7.484-4.061-14.566-11.723-14.566H130.184c20.633-44.991 62.69-75.03 117.619-75.03 14.486 0 28.564 2.25 37.851 4.145 6.216 1.268 12.347-2.498 14.002-8.623l11.991-44.368c1.822-6.741-2.465-13.616-9.326-14.917C290.217 34.912 270.71 32 249.635 32 152.451 32 74.03 92.252 45.075 176H12c-6.627 0-12 5.373-12 12v29.755c0 6.627 5.373 12 12 12h21.569c-1.009 13.607-1.181 29.287-.181 42.245H12c-6.627 0-12 5.373-12 12v28.36c0 6.627 5.373 12 12 12h30.114C67.139 414.692 145.264 480 249.635 480c26.301 0 48.562-4.544 61.101-7.788 6.167-1.595 10.027-7.708 8.788-13.957l-8.818-44.49z"
        ],
        "exchange-alt": [
            512,
            512,
            [],
            "f362",
            "M0 168v-16c0-13.255 10.745-24 24-24h360V80c0-21.367 25.899-32.042 40.971-16.971l80 80c9.372 9.373 9.372 24.569 0 33.941l-80 80C409.956 271.982 384 261.456 384 240v-48H24c-13.255 0-24-10.745-24-24zm488 152H128v-48c0-21.314-25.862-32.08-40.971-16.971l-80 80c-9.372 9.373-9.372 24.569 0 33.941l80 80C102.057 463.997 128 453.437 128 432v-48h360c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24z"
        ],
        exclamation: [
            192,
            512,
            [],
            "f12a",
            "M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z"
        ],
        "exclamation-circle": [
            512,
            512,
            [],
            "f06a",
            "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
        ],
        "exclamation-triangle": [
            576,
            512,
            [],
            "f071",
            "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
        ],
        expand: [
            448,
            512,
            [],
            "f065",
            "M0 180V56c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H64v84c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zM288 44v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V56c0-13.3-10.7-24-24-24H300c-6.6 0-12 5.4-12 12zm148 276h-40c-6.6 0-12 5.4-12 12v84h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24V332c0-6.6-5.4-12-12-12zM160 468v-40c0-6.6-5.4-12-12-12H64v-84c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v124c0 13.3 10.7 24 24 24h124c6.6 0 12-5.4 12-12z"
        ],
        "expand-alt": [
            448,
            512,
            [],
            "f424",
            "M212.686 315.314L120 408l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C10.697 480 0 469.255 0 456V344c0-21.382 25.803-32.09 40.922-16.971L72 360l92.686-92.686c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.249 6.248 6.249 16.378 0 22.627zm22.628-118.628L328 104l-32.922-31.029C279.958 57.851 290.666 32 312.048 32h112C437.303 32 448 42.745 448 56v112c0 21.382-25.803 32.09-40.922 16.971L376 152l-92.686 92.686c-6.248 6.248-16.379 6.248-22.627 0l-25.373-25.373c-6.249-6.248-6.249-16.378 0-22.627z"
        ],
        "expand-arrows-alt": [
            448,
            512,
            [],
            "f31e",
            "M448 344v112a23.94 23.94 0 0 1-24 24H312c-21.39 0-32.09-25.9-17-41l36.2-36.2L224 295.6 116.77 402.9 153 439c15.09 15.1 4.39 41-17 41H24a23.94 23.94 0 0 1-24-24V344c0-21.4 25.89-32.1 41-17l36.19 36.2L184.46 256 77.18 148.7 41 185c-15.1 15.1-41 4.4-41-17V56a23.94 23.94 0 0 1 24-24h112c21.39 0 32.09 25.9 17 41l-36.2 36.2L224 216.4l107.23-107.3L295 73c-15.09-15.1-4.39-41 17-41h112a23.94 23.94 0 0 1 24 24v112c0 21.4-25.89 32.1-41 17l-36.19-36.2L263.54 256l107.28 107.3L407 327.1c15.1-15.2 41-4.5 41 16.9z"
        ],
        "external-link-alt": [
            512,
            512,
            [],
            "f35d",
            "M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"
        ],
        "external-link-square-alt": [
            448,
            512,
            [],
            "f360",
            "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-88 16H248.029c-21.313 0-32.08 25.861-16.971 40.971l31.984 31.987L67.515 364.485c-4.686 4.686-4.686 12.284 0 16.971l31.029 31.029c4.687 4.686 12.285 4.686 16.971 0l195.526-195.526 31.988 31.991C358.058 263.977 384 253.425 384 231.979V120c0-13.255-10.745-24-24-24z"
        ],
        eye: [
            576,
            512,
            [],
            "f06e",
            "M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
        ],
        "eye-dropper": [
            512,
            512,
            [],
            "f1fb",
            "M50.75 333.25c-12 12-18.75 28.28-18.75 45.26V424L0 480l32 32 56-32h45.49c16.97 0 33.25-6.74 45.25-18.74l126.64-126.62-128-128L50.75 333.25zM483.88 28.12c-37.47-37.5-98.28-37.5-135.75 0l-77.09 77.09-13.1-13.1c-9.44-9.44-24.65-9.31-33.94 0l-40.97 40.97c-9.37 9.37-9.37 24.57 0 33.94l161.94 161.94c9.44 9.44 24.65 9.31 33.94 0L419.88 288c9.37-9.37 9.37-24.57 0-33.94l-13.1-13.1 77.09-77.09c37.51-37.48 37.51-98.26.01-135.75z"
        ],
        "eye-slash": [
            640,
            512,
            [],
            "f070",
            "M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
        ],
        fan: [
            512,
            512,
            [],
            "f863",
            "M352.57 128c-28.09 0-54.09 4.52-77.06 12.86l12.41-123.11C289 7.31 279.81-1.18 269.33.13 189.63 10.13 128 77.64 128 159.43c0 28.09 4.52 54.09 12.86 77.06L17.75 224.08C7.31 223-1.18 232.19.13 242.67c10 79.7 77.51 141.33 159.3 141.33 28.09 0 54.09-4.52 77.06-12.86l-12.41 123.11c-1.05 10.43 8.11 18.93 18.59 17.62 79.7-10 141.33-77.51 141.33-159.3 0-28.09-4.52-54.09-12.86-77.06l123.11 12.41c10.44 1.05 18.93-8.11 17.62-18.59-10-79.7-77.51-141.33-159.3-141.33zM256 288a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
        ],
        "fast-backward": [
            512,
            512,
            [],
            "f049",
            "M0 436V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v151.9L235.5 71.4C256.1 54.3 288 68.6 288 96v131.9L459.5 71.4C480.1 54.3 512 68.6 512 96v320c0 27.4-31.9 41.7-52.5 24.6L288 285.3V416c0 27.4-31.9 41.7-52.5 24.6L64 285.3V436c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12z"
        ],
        "fast-forward": [
            512,
            512,
            [],
            "f050",
            "M512 76v360c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V284.1L276.5 440.6c-20.6 17.2-52.5 2.8-52.5-24.6V284.1L52.5 440.6C31.9 457.8 0 443.4 0 416V96c0-27.4 31.9-41.7 52.5-24.6L224 226.8V96c0-27.4 31.9-41.7 52.5-24.6L448 226.8V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12z"
        ],
        faucet: [
            512,
            512,
            [],
            "e005",
            "M352,256H313.39c-15.71-13.44-35.46-23.07-57.39-28V180.44l-32-3.38-32,3.38V228c-21.93,5-41.68,14.6-57.39,28H16A16,16,0,0,0,0,272v96a16,16,0,0,0,16,16h92.79C129.38,421.73,173,448,224,448s94.62-26.27,115.21-64H352a32,32,0,0,1,32,32,32,32,0,0,0,32,32h64a32,32,0,0,0,32-32A160,160,0,0,0,352,256ZM81.59,159.91l142.41-15,142.41,15c9.42,1,17.59-6.81,17.59-16.8V112.89c0-10-8.17-17.8-17.59-16.81L256,107.74V80a16,16,0,0,0-16-16H208a16,16,0,0,0-16,16v27.74L81.59,96.08C72.17,95.09,64,102.9,64,112.89v30.22C64,153.1,72.17,160.91,81.59,159.91Z"
        ],
        fax: [
            512,
            512,
            [],
            "f1ac",
            "M480 160V77.25a32 32 0 0 0-9.38-22.63L425.37 9.37A32 32 0 0 0 402.75 0H160a32 32 0 0 0-32 32v448a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM288 432a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm128 128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-112H192V64h160v48a16 16 0 0 0 16 16h48zM64 128H32a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32z"
        ],
        feather: [
            512,
            512,
            [],
            "f52d",
            "M467.14 44.84c-62.55-62.48-161.67-64.78-252.28 25.73-78.61 78.52-60.98 60.92-85.75 85.66-60.46 60.39-70.39 150.83-63.64 211.17l178.44-178.25c6.26-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.6 9.37 33.98 0l66.1-66.03C159.42 454.65 279 457.11 353.95 384h-98.19l147.57-49.14c49.99-49.93 36.38-36.18 46.31-46.86h-97.78l131.54-43.8c45.44-74.46 34.31-148.84-16.26-199.36z"
        ],
        "feather-alt": [
            512,
            512,
            [],
            "f56b",
            "M512 0C460.22 3.56 96.44 38.2 71.01 287.61c-3.09 26.66-4.84 53.44-5.99 80.24l178.87-178.69c6.25-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.59 9.37 33.98 0l57.13-57.07c42.09-.14 84.15-2.53 125.96-7.36 53.48-5.44 97.02-26.47 132.58-56.54H255.74l146.79-48.88c11.25-14.89 21.37-30.71 30.45-47.12h-81.14l106.54-53.21C500.29 132.86 510.19 26.26 512 0z"
        ],
        female: [
            256,
            512,
            [],
            "f182",
            "M128 0c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64S92.654 0 128 0m119.283 354.179l-48-192A24 24 0 0 0 176 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H80a24 24 0 0 0-23.283 18.179l-48 192C4.935 369.305 16.383 384 32 384h56v104c0 13.255 10.745 24 24 24h32c13.255 0 24-10.745 24-24V384h56c15.591 0 27.071-14.671 23.283-29.821z"
        ],
        "fighter-jet": [
            640,
            512,
            [],
            "f0fb",
            "M544 224l-128-16-48-16h-24L227.158 44h39.509C278.333 44 288 41.375 288 38s-9.667-6-21.333-6H152v12h16v164h-48l-66.667-80H18.667L8 138.667V208h8v16h48v2.666l-64 8v42.667l64 8V288H16v16H8v69.333L18.667 384h34.667L120 304h48v164h-16v12h114.667c11.667 0 21.333-2.625 21.333-6s-9.667-6-21.333-6h-39.509L344 320h24l48-16 128-16c96-21.333 96-26.583 96-32 0-5.417 0-10.667-96-32z"
        ],
        file: [
            384,
            512,
            [],
            "f15b",
            "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
        ],
        "file-alt": [
            384,
            512,
            [],
            "f15c",
            "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
        ],
        "file-archive": [
            384,
            512,
            [],
            "f1c6",
            "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zM128.4 336c-17.9 0-32.4 12.1-32.4 27 0 15 14.6 27 32.5 27s32.4-12.1 32.4-27-14.6-27-32.5-27zM224 136V0h-63.6v32h-32V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM95.9 32h32v32h-32zm32.3 384c-33.2 0-58-30.4-51.4-62.9L96.4 256v-32h32v-32h-32v-32h32v-32h-32V96h32V64h32v32h-32v32h32v32h-32v32h32v32h-32v32h22.1c5.7 0 10.7 4.1 11.8 9.7l17.3 87.7c6.4 32.4-18.4 62.6-51.4 62.6z"
        ],
        "file-audio": [
            384,
            512,
            [],
            "f1c7",
            "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-64 268c0 10.7-12.9 16-20.5 8.5L104 376H76c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h28l35.5-36.5c7.6-7.6 20.5-2.2 20.5 8.5v136zm33.2-47.6c9.1-9.3 9.1-24.1 0-33.4-22.1-22.8 12.2-56.2 34.4-33.5 27.2 27.9 27.2 72.4 0 100.4-21.8 22.3-56.9-10.4-34.4-33.5zm86-117.1c54.4 55.9 54.4 144.8 0 200.8-21.8 22.4-57-10.3-34.4-33.5 36.2-37.2 36.3-96.5 0-133.8-22.1-22.8 12.3-56.3 34.4-33.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
        ],
        "file-code": [
            384,
            512,
            [],
            "f1c9",
            "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zM123.206 400.505a5.4 5.4 0 0 1-7.633.246l-64.866-60.812a5.4 5.4 0 0 1 0-7.879l64.866-60.812a5.4 5.4 0 0 1 7.633.246l19.579 20.885a5.4 5.4 0 0 1-.372 7.747L101.65 336l40.763 35.874a5.4 5.4 0 0 1 .372 7.747l-19.579 20.884zm51.295 50.479l-27.453-7.97a5.402 5.402 0 0 1-3.681-6.692l61.44-211.626a5.402 5.402 0 0 1 6.692-3.681l27.452 7.97a5.4 5.4 0 0 1 3.68 6.692l-61.44 211.626a5.397 5.397 0 0 1-6.69 3.681zm160.792-111.045l-64.866 60.812a5.4 5.4 0 0 1-7.633-.246l-19.58-20.885a5.4 5.4 0 0 1 .372-7.747L284.35 336l-40.763-35.874a5.4 5.4 0 0 1-.372-7.747l19.58-20.885a5.4 5.4 0 0 1 7.633-.246l64.866 60.812a5.4 5.4 0 0 1-.001 7.879z"
        ],
        "file-contract": [
            384,
            512,
            [],
            "f56c",
            "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm192.81 248H304c8.84 0 16 7.16 16 16s-7.16 16-16 16h-47.19c-16.45 0-31.27-9.14-38.64-23.86-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34a15.986 15.986 0 0 1-14.31 8.84c-.38 0-.75-.02-1.14-.05-6.45-.45-12-4.75-14.03-10.89L144 354.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.77-16.19 54.05-9.7 66 14.16 2.02 4.06 5.96 6.5 10.16 6.5zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
        ],
        "file-csv": [
            384,
            512,
            [],
            "f6dd",
            "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-96 144c0 4.42-3.58 8-8 8h-8c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h8c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-8c-26.51 0-48-21.49-48-48v-32c0-26.51 21.49-48 48-48h8c4.42 0 8 3.58 8 8v16zm44.27 104H160c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h12.27c5.95 0 10.41-3.5 10.41-6.62 0-1.3-.75-2.66-2.12-3.84l-21.89-18.77c-8.47-7.22-13.33-17.48-13.33-28.14 0-21.3 19.02-38.62 42.41-38.62H200c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-12.27c-5.95 0-10.41 3.5-10.41 6.62 0 1.3.75 2.66 2.12 3.84l21.89 18.77c8.47 7.22 13.33 17.48 13.33 28.14.01 21.29-19 38.62-42.39 38.62zM256 264v20.8c0 20.27 5.7 40.17 16 56.88 10.3-16.7 16-36.61 16-56.88V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v20.8c0 35.48-12.88 68.89-36.28 94.09-3.02 3.25-7.27 5.11-11.72 5.11s-8.7-1.86-11.72-5.11c-23.4-25.2-36.28-58.61-36.28-94.09V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8zm121-159L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
        ],
        "file-download": [
            384,
            512,
            [],
            "f56d",
            "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
        ],
        "file-excel": [
            384,
            512,
            [],
            "f1c3",
            "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm60.1 106.5L224 336l60.1 93.5c5.1 8-.6 18.5-10.1 18.5h-34.9c-4.4 0-8.5-2.4-10.6-6.3C208.9 405.5 192 373 192 373c-6.4 14.8-10 20-36.6 68.8-2.1 3.9-6.1 6.3-10.5 6.3H110c-9.5 0-15.2-10.5-10.1-18.5l60.3-93.5-60.3-93.5c-5.2-8 .6-18.5 10.1-18.5h34.8c4.4 0 8.5 2.4 10.6 6.3 26.1 48.8 20 33.6 36.6 68.5 0 0 6.1-11.7 36.6-68.5 2.1-3.9 6.2-6.3 10.6-6.3H274c9.5-.1 15.2 10.4 10.1 18.4zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
        ],
        "file-export": [
            576,
            512,
            [],
            "f56e",
            "M384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128zM571 308l-95.7-96.4c-10.1-10.1-27.4-3-27.4 11.3V288h-64v64h64v65.2c0 14.3 17.3 21.4 27.4 11.3L571 332c6.6-6.6 6.6-17.4 0-24zm-379 28v-32c0-8.8 7.2-16 16-16h176V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V352H208c-8.8 0-16-7.2-16-16z"
        ],
        "file-image": [
            384,
            512,
            [],
            "f1c5",
            "M384 121.941V128H256V0h6.059a24 24 0 0 1 16.97 7.029l97.941 97.941a24.002 24.002 0 0 1 7.03 16.971zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zm-135.455 16c26.51 0 48 21.49 48 48s-21.49 48-48 48-48-21.49-48-48 21.491-48 48-48zm208 240h-256l.485-48.485L104.545 328c4.686-4.686 11.799-4.201 16.485.485L160.545 368 264.06 264.485c4.686-4.686 12.284-4.686 16.971 0L320.545 304v112z"
        ],
        "file-import": [
            512,
            512,
            [],
            "f56f",
            "M16 288c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h112v-64zm489-183L407.1 7c-4.5-4.5-10.6-7-17-7H384v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H152c-13.3 0-24 10.7-24 24v264h128v-65.2c0-14.3 17.3-21.4 27.4-11.3L379 308c6.6 6.7 6.6 17.4 0 24l-95.7 96.4c-10.1 10.1-27.4 3-27.4-11.3V352H128v136c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H376c-13.2 0-24-10.8-24-24z"
        ],
        "file-invoice": [
            384,
            512,
            [],
            "f570",
            "M288 256H96v64h192v-64zm89-151L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm256 304c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-200v96c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-96c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16z"
        ],
        "file-invoice-dollar": [
            384,
            512,
            [],
            "f571",
            "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 80v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8zm144 263.88V440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-24.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V232c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v24.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07z"
        ],
        "file-medical": [
            384,
            512,
            [],
            "f477",
            "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 160v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8z"
        ],
        "file-medical-alt": [
            448,
            512,
            [],
            "f478",
            "M288 136V0H88C74.7 0 64 10.7 64 24v232H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h140.9c3 0 5.8 1.7 7.2 4.4l19.9 39.8 56.8-113.7c2.9-5.9 11.4-5.9 14.3 0l34.7 69.5H352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-89.9L240 275.8l-56.8 113.7c-2.9 5.9-11.4 5.9-14.3 0L134.1 320H64v168c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H312c-13.2 0-24-10.8-24-24zm153-31L343.1 7c-4.5-4.5-10.6-7-17-7H320v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
        ],
        "file-pdf": [
            384,
            512,
            [],
            "f1c1",
            "M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z"
        ],
        "file-powerpoint": [
            384,
            512,
            [],
            "f1c4",
            "M193.7 271.2c8.8 0 15.5 2.7 20.3 8.1 9.6 10.9 9.8 32.7-.2 44.1-4.9 5.6-11.9 8.5-21.1 8.5h-26.9v-60.7h27.9zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm53 165.2c0 90.3-88.8 77.6-111.1 77.6V436c0 6.6-5.4 12-12 12h-30.8c-6.6 0-12-5.4-12-12V236.2c0-6.6 5.4-12 12-12h81c44.5 0 72.9 32.8 72.9 77z"
        ],
        "file-prescription": [
            384,
            512,
            [],
            "f572",
            "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm68.53 179.48l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63l-29.9 29.9L304 409.38c6.25 6.25 6.25 16.38 0 22.63l-11.31 11.31c-6.25 6.25-16.38 6.25-22.63 0L240 413.25l-30.06 30.06c-6.25 6.25-16.38 6.25-22.63 0L176 432c-6.25-6.25-6.25-16.38 0-22.63l30.06-30.06L146.74 320H128v48c0 8.84-7.16 16-16 16H96c-8.84 0-16-7.16-16-16V208c0-8.84 7.16-16 16-16h80c35.35 0 64 28.65 64 64 0 24.22-13.62 45.05-33.46 55.92L240 345.38l29.9-29.9c6.25-6.25 16.38-6.25 22.63 0zM176 272h-48v-32h48c8.82 0 16 7.18 16 16s-7.18 16-16 16zm208-150.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
        ],
        "file-signature": [
            576,
            512,
            [],
            "f573",
            "M218.17 424.14c-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34c-6.37 12.78-25.03 11.37-29.48-2.09L144 386.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.75-16.19 54.06-9.7 66 14.16 1.89 3.78 5.49 5.95 9.36 6.26v-82.12l128-127.09V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24v-40l-128-.11c-16.12-.31-30.58-9.28-37.83-23.75zM384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1zm-96 225.06V416h68.99l161.68-162.78-67.88-67.88L288 346.96zm280.54-179.63l-31.87-31.87c-9.94-9.94-26.07-9.94-36.01 0l-27.25 27.25 67.88 67.88 27.25-27.25c9.95-9.94 9.95-26.07 0-36.01z"
        ],
        "file-upload": [
            384,
            512,
            [],
            "f574",
            "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm65.18 216.01H224v80c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-80H94.82c-14.28 0-21.41-17.29-11.27-27.36l96.42-95.7c6.65-6.61 17.39-6.61 24.04 0l96.42 95.7c10.15 10.07 3.03 27.36-11.25 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
        ],
        "file-video": [
            384,
            512,
            [],
            "f1c8",
            "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM224 136V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248c-13.2 0-24-10.8-24-24zm96 144.016v111.963c0 21.445-25.943 31.998-40.971 16.971L224 353.941V392c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V280c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v38.059l55.029-55.013c15.011-15.01 40.971-4.491 40.971 16.97z"
        ],
        "file-word": [
            384,
            512,
            [],
            "f1c2",
            "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm57.1 120H305c7.7 0 13.4 7.1 11.7 14.7l-38 168c-1.2 5.5-6.1 9.3-11.7 9.3h-38c-5.5 0-10.3-3.8-11.6-9.1-25.8-103.5-20.8-81.2-25.6-110.5h-.5c-1.1 14.3-2.4 17.4-25.6 110.5-1.3 5.3-6.1 9.1-11.6 9.1H117c-5.6 0-10.5-3.9-11.7-9.4l-37.8-168c-1.7-7.5 4-14.6 11.7-14.6h24.5c5.7 0 10.7 4 11.8 9.7 15.6 78 20.1 109.5 21 122.2 1.6-10.2 7.3-32.7 29.4-122.7 1.3-5.4 6.1-9.1 11.7-9.1h29.1c5.6 0 10.4 3.8 11.7 9.2 24 100.4 28.8 124 29.6 129.4-.2-11.2-2.6-17.8 21.6-129.2 1-5.6 5.9-9.5 11.5-9.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
        ],
        fill: [
            512,
            512,
            [],
            "f575",
            "M502.63 217.06L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.77c-6.24-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.63l86.19 86.18-94.76 94.76c-37.49 37.49-37.49 98.26 0 135.75l117.19 117.19c18.75 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.88-28.12l221.57-221.57c12.49-12.5 12.49-32.76 0-45.26zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.61 58.6c12.49 12.49 32.75 12.49 45.24 0 12.49-12.49 12.49-32.75 0-45.24l-58.61-58.6 58.95-58.95 162.45 162.44-48.35 48.34z"
        ],
        "fill-drip": [
            576,
            512,
            [],
            "f576",
            "M512 320s-64 92.65-64 128c0 35.35 28.66 64 64 64s64-28.65 64-64-64-128-64-128zm-9.37-102.94L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.76c-6.25-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.62l86.19 86.18-94.76 94.76c-37.49 37.48-37.49 98.26 0 135.75l117.19 117.19c18.74 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.87-28.12l221.57-221.57c12.5-12.5 12.5-32.75.01-45.25zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.6 58.6c12.49 12.49 32.75 12.49 45.24 0s12.49-32.75 0-45.24l-58.6-58.6 58.95-58.95 162.44 162.44-48.34 48.34z"
        ],
        film: [
            512,
            512,
            [],
            "f008",
            "M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm272 208c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm0-168c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm112 152c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
        ],
        filter: [
            512,
            512,
            [],
            "f0b0",
            "M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"
        ],
        fingerprint: [
            512,
            512,
            [],
            "f577",
            "M256.12 245.96c-13.25 0-24 10.74-24 24 1.14 72.25-8.14 141.9-27.7 211.55-2.73 9.72 2.15 30.49 23.12 30.49 10.48 0 20.11-6.92 23.09-17.52 13.53-47.91 31.04-125.41 29.48-224.52.01-13.25-10.73-24-23.99-24zm-.86-81.73C194 164.16 151.25 211.3 152.1 265.32c.75 47.94-3.75 95.91-13.37 142.55-2.69 12.98 5.67 25.69 18.64 28.36 13.05 2.67 25.67-5.66 28.36-18.64 10.34-50.09 15.17-101.58 14.37-153.02-.41-25.95 19.92-52.49 54.45-52.34 31.31.47 57.15 25.34 57.62 55.47.77 48.05-2.81 96.33-10.61 143.55-2.17 13.06 6.69 25.42 19.76 27.58 19.97 3.33 26.81-15.1 27.58-19.77 8.28-50.03 12.06-101.21 11.27-152.11-.88-55.8-47.94-101.88-104.91-102.72zm-110.69-19.78c-10.3-8.34-25.37-6.8-33.76 3.48-25.62 31.5-39.39 71.28-38.75 112 .59 37.58-2.47 75.27-9.11 112.05-2.34 13.05 6.31 25.53 19.36 27.89 20.11 3.5 27.07-14.81 27.89-19.36 7.19-39.84 10.5-80.66 9.86-121.33-.47-29.88 9.2-57.88 28-80.97 8.35-10.28 6.79-25.39-3.49-33.76zm109.47-62.33c-15.41-.41-30.87 1.44-45.78 4.97-12.89 3.06-20.87 15.98-17.83 28.89 3.06 12.89 16 20.83 28.89 17.83 11.05-2.61 22.47-3.77 34-3.69 75.43 1.13 137.73 61.5 138.88 134.58.59 37.88-1.28 76.11-5.58 113.63-1.5 13.17 7.95 25.08 21.11 26.58 16.72 1.95 25.51-11.88 26.58-21.11a929.06 929.06 0 0 0 5.89-119.85c-1.56-98.75-85.07-180.33-186.16-181.83zm252.07 121.45c-2.86-12.92-15.51-21.2-28.61-18.27-12.94 2.86-21.12 15.66-18.26 28.61 4.71 21.41 4.91 37.41 4.7 61.6-.11 13.27 10.55 24.09 23.8 24.2h.2c13.17 0 23.89-10.61 24-23.8.18-22.18.4-44.11-5.83-72.34zm-40.12-90.72C417.29 43.46 337.6 1.29 252.81.02 183.02-.82 118.47 24.91 70.46 72.94 24.09 119.37-.9 181.04.14 246.65l-.12 21.47c-.39 13.25 10.03 24.31 23.28 24.69.23.02.48.02.72.02 12.92 0 23.59-10.3 23.97-23.3l.16-23.64c-.83-52.5 19.16-101.86 56.28-139 38.76-38.8 91.34-59.67 147.68-58.86 69.45 1.03 134.73 35.56 174.62 92.39 7.61 10.86 22.56 13.45 33.42 5.86 10.84-7.62 13.46-22.59 5.84-33.43z"
        ],
        fire: [
            384,
            512,
            [],
            "f06d",
            "M216 23.86c0-23.8-30.65-32.77-44.15-13.04C48 191.85 224 200 224 288c0 35.63-29.11 64.46-64.85 63.99-35.17-.45-63.15-29.77-63.15-64.94v-85.51c0-21.7-26.47-32.23-41.43-16.5C27.8 213.16 0 261.33 0 320c0 105.87 86.13 192 192 192s192-86.13 192-192c0-170.29-168-193-168-296.14z"
        ],
        "fire-alt": [
            448,
            512,
            [],
            "f7e4",
            "M323.56 51.2c-20.8 19.3-39.58 39.59-56.22 59.97C240.08 73.62 206.28 35.53 168 0 69.74 91.17 0 209.96 0 281.6 0 408.85 100.29 512 224 512s224-103.15 224-230.4c0-53.27-51.98-163.14-124.44-230.4zm-19.47 340.65C282.43 407.01 255.72 416 226.86 416 154.71 416 96 368.26 96 290.75c0-38.61 24.31-72.63 72.79-130.75 6.93 7.98 98.83 125.34 98.83 125.34l58.63-66.88c4.14 6.85 7.91 13.55 11.27 19.97 27.35 52.19 15.81 118.97-33.43 153.42z"
        ],
        "fire-extinguisher": [
            448,
            512,
            [],
            "f134",
            "M434.027 26.329l-168 28C254.693 56.218 256 67.8 256 72h-58.332C208.353 36.108 181.446 0 144 0c-39.435 0-66.368 39.676-52.228 76.203-52.039 13.051-75.381 54.213-90.049 90.884-4.923 12.307 1.063 26.274 13.37 31.197 12.317 4.926 26.279-1.075 31.196-13.37C75.058 112.99 106.964 120 168 120v27.076c-41.543 10.862-72 49.235-72 94.129V488c0 13.255 10.745 24 24 24h144c13.255 0 24-10.745 24-24V240c0-44.731-30.596-82.312-72-92.97V120h40c0 2.974-1.703 15.716 10.027 17.671l168 28C441.342 166.89 448 161.25 448 153.834V38.166c0-7.416-6.658-13.056-13.973-11.837zM144 72c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16z"
        ],
        "first-aid": [
            576,
            512,
            [],
            "f479",
            "M0 80v352c0 26.5 21.5 48 48 48h48V32H48C21.5 32 0 53.5 0 80zm128 400h320V32H128v448zm64-248c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48zM528 32h-48v448h48c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
        ],
        fish: [
            576,
            512,
            [],
            "f578",
            "M327.1 96c-89.97 0-168.54 54.77-212.27 101.63L27.5 131.58c-12.13-9.18-30.24.6-27.14 14.66L24.54 256 .35 365.77c-3.1 14.06 15.01 23.83 27.14 14.66l87.33-66.05C158.55 361.23 237.13 416 327.1 416 464.56 416 576 288 576 256S464.56 96 327.1 96zm87.43 184c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24 13.26 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"
        ],
        "fist-raised": [
            384,
            512,
            [],
            "f6de",
            "M255.98 160V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v146.93c5.02-1.78 10.34-2.93 15.97-2.93h48.03zm128 95.99c-.01-35.34-28.66-63.99-63.99-63.99H207.85c-8.78 0-15.9 7.07-15.9 15.85v.56c0 26.27 21.3 47.59 47.57 47.59h35.26c9.68 0 13.2 3.58 13.2 8v16.2c0 4.29-3.59 7.78-7.88 8-44.52 2.28-64.16 24.71-96.05 72.55l-6.31 9.47a7.994 7.994 0 0 1-11.09 2.22l-13.31-8.88a7.994 7.994 0 0 1-2.22-11.09l6.31-9.47c15.73-23.6 30.2-43.26 47.31-58.08-17.27-5.51-31.4-18.12-38.87-34.45-6.59 3.41-13.96 5.52-21.87 5.52h-32c-12.34 0-23.49-4.81-32-12.48C71.48 251.19 60.33 256 48 256H16c-5.64 0-10.97-1.15-16-2.95v77.93c0 33.95 13.48 66.5 37.49 90.51L63.99 448v64h255.98v-63.96l35.91-35.92A96.035 96.035 0 0 0 384 344.21l-.02-88.22zm-32.01-90.09V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v112h32c11.28 0 21.94 2.31 32 5.9zM16 224h32c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v128c0 8.84 7.16 16 16 16zm95.99 0h32c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v160c0 8.84 7.16 16 16 16z"
        ],
        flag: [
            512,
            512,
            [],
            "f024",
            "M349.565 98.783C295.978 98.783 251.721 64 184.348 64c-24.955 0-47.309 4.384-68.045 12.013a55.947 55.947 0 0 0 3.586-23.562C118.117 24.015 94.806 1.206 66.338.048 34.345-1.254 8 24.296 8 56c0 19.026 9.497 35.825 24 45.945V488c0 13.255 10.745 24 24 24h16c13.255 0 24-10.745 24-24v-94.4c28.311-12.064 63.582-22.122 114.435-22.122 53.588 0 97.844 34.783 165.217 34.783 48.169 0 86.667-16.294 122.505-40.858C506.84 359.452 512 349.571 512 339.045v-243.1c0-23.393-24.269-38.87-45.485-29.016-34.338 15.948-76.454 31.854-116.95 31.854z"
        ],
        "flag-checkered": [
            512,
            512,
            [],
            "f11e",
            "M243.2 189.9V258c26.1 5.9 49.3 15.6 73.6 22.3v-68.2c-26-5.8-49.4-15.5-73.6-22.2zm223.3-123c-34.3 15.9-76.5 31.9-117 31.9C296 98.8 251.7 64 184.3 64c-25 0-47.3 4.4-68 12 2.8-7.3 4.1-15.2 3.6-23.6C118.1 24 94.8 1.2 66.3 0 34.3-1.3 8 24.3 8 56c0 19 9.5 35.8 24 45.9V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-94.4c28.3-12.1 63.6-22.1 114.4-22.1 53.6 0 97.8 34.8 165.2 34.8 48.2 0 86.7-16.3 122.5-40.9 8.7-6 13.8-15.8 13.8-26.4V95.9c.1-23.3-24.2-38.8-45.4-29zM169.6 325.5c-25.8 2.7-50 8.2-73.6 16.6v-70.5c26.2-9.3 47.5-15 73.6-17.4zM464 191c-23.6 9.8-46.3 19.5-73.6 23.9V286c24.8-3.4 51.4-11.8 73.6-26v70.5c-25.1 16.1-48.5 24.7-73.6 27.1V286c-27 3.7-47.9 1.5-73.6-5.6v67.4c-23.9-7.4-47.3-16.7-73.6-21.3V258c-19.7-4.4-40.8-6.8-73.6-3.8v-70c-22.4 3.1-44.6 10.2-73.6 20.9v-70.5c33.2-12.2 50.1-19.8 73.6-22v71.6c27-3.7 48.4-1.3 73.6 5.7v-67.4c23.7 7.4 47.2 16.7 73.6 21.3v68.4c23.7 5.3 47.6 6.9 73.6 2.7V143c27-4.8 52.3-13.6 73.6-22.5z"
        ],
        "flag-usa": [
            512,
            512,
            [],
            "f74d",
            "M32 0C14.3 0 0 14.3 0 32v464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32C64 14.3 49.7 0 32 0zm267.9 303.6c-57.2-15.1-111.7-28.8-203.9 11.1V384c185.7-92.2 221.7 53.3 397.5-23.1 11.4-5 18.5-16.5 18.5-28.8v-36c-43.6 17.3-80.2 24.1-112.1 24.1-37.4-.1-68.9-8.4-100-16.6zm0-96c-57.2-15.1-111.7-28.8-203.9 11.1v61.5c94.8-37.6 154.6-22.7 212.1-7.6 57.2 15.1 111.7 28.8 203.9-11.1V200c-43.6 17.3-80.2 24.1-112.1 24.1-37.4 0-68.9-8.3-100-16.5zm9.5-125.9c51.8 15.6 97.4 29 202.6-20.1V30.8c0-25.1-26.8-38.1-49.4-26.6C291.3 91.5 305.4-62.2 96 32.4v151.9c94.8-37.5 154.6-22.7 212.1-7.6 57.2 15 111.7 28.7 203.9-11.1V96.7c-53.6 23.5-93.3 31.4-126.1 31.4s-59-7.8-85.7-15.9c-4-1.2-8.1-2.4-12.1-3.5V75.5c7.2 2 14.3 4.1 21.3 6.2zM160 128.1c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16-7.2 16-16 16zm0-55.8c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm64 47.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm0-55.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16z"
        ],
        flask: [
            448,
            512,
            [],
            "f0c3",
            "M437.2 403.5L320 215V64h8c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h8v151L10.8 403.5C-18.5 450.6 15.3 512 70.9 512h306.2c55.7 0 89.4-61.5 60.1-108.5zM137.9 320l48.2-77.6c3.7-5.2 5.8-11.6 5.8-18.4V64h64v160c0 6.9 2.2 13.2 5.8 18.4l48.2 77.6h-172z"
        ],
        flushed: [
            496,
            512,
            [],
            "f579",
            "M344 200c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-192 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM80 224c0-39.8 32.2-72 72-72s72 32.2 72 72-32.2 72-72 72-72-32.2-72-72zm232 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-104c-39.8 0-72-32.2-72-72s32.2-72 72-72 72 32.2 72 72-32.2 72-72 72z"
        ],
        folder: [
            512,
            512,
            [],
            "f07b",
            "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48z"
        ],
        "folder-minus": [
            512,
            512,
            [],
            "f65d",
            "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm-96 168c0 8.84-7.16 16-16 16H160c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16h192c8.84 0 16 7.16 16 16v16z"
        ],
        "folder-open": [
            576,
            512,
            [],
            "f07c",
            "M572.694 292.093L500.27 416.248A63.997 63.997 0 0 1 444.989 448H45.025c-18.523 0-30.064-20.093-20.731-36.093l72.424-124.155A64 64 0 0 1 152 256h399.964c18.523 0 30.064 20.093 20.73 36.093zM152 224h328v-48c0-26.51-21.49-48-48-48H272l-64-64H48C21.49 64 0 85.49 0 112v278.046l69.077-118.418C86.214 242.25 117.989 224 152 224z"
        ],
        "folder-plus": [
            512,
            512,
            [],
            "f65e",
            "M464,128H272L208,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128ZM359.5,296a16,16,0,0,1-16,16h-64v64a16,16,0,0,1-16,16h-16a16,16,0,0,1-16-16V312h-64a16,16,0,0,1-16-16V280a16,16,0,0,1,16-16h64V200a16,16,0,0,1,16-16h16a16,16,0,0,1,16,16v64h64a16,16,0,0,1,16,16Z"
        ],
        font: [
            448,
            512,
            [],
            "f031",
            "M432 416h-23.41L277.88 53.69A32 32 0 0 0 247.58 32h-47.16a32 32 0 0 0-30.3 21.69L39.41 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-19.58l23.3-64h152.56l23.3 64H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM176.85 272L224 142.51 271.15 272z"
        ],
        "font-awesome-logo-full": [
            3992,
            512,
            [
                "Font Awesome"
            ],
            "f4e6",
            "M454.6 0H57.4C25.9 0 0 25.9 0 57.4v397.3C0 486.1 25.9 512 57.4 512h397.3c31.4 0 57.4-25.9 57.4-57.4V57.4C512 25.9 486.1 0 454.6 0zm-58.9 324.9c0 4.8-4.1 6.9-8.9 8.9-19.2 8.1-39.7 15.7-61.5 15.7-40.5 0-68.7-44.8-163.2 2.5v51.8c0 30.3-45.7 30.2-45.7 0v-250c-9-7-15-17.9-15-30.3 0-21 17.1-38.2 38.2-38.2 21 0 38.2 17.1 38.2 38.2 0 12.2-5.8 23.2-14.9 30.2v21c37.1-12 65.5-34.4 146.1-3.4 26.6 11.4 68.7-15.7 76.5-15.7 5.5 0 10.3 4.1 10.3 8.9v160.4zm432.9-174.2h-137v70.1H825c39.8 0 40.4 62.2 0 62.2H691.6v105.6c0 45.5-70.7 46.4-70.7 0V128.3c0-22 18-39.8 39.8-39.8h167.8c39.6 0 40.5 62.2.1 62.2zm191.1 23.4c-169.3 0-169.1 252.4 0 252.4 169.9 0 169.9-252.4 0-252.4zm0 196.1c-81.6 0-82.1-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm372.4 53.4c-17.5 0-31.4-13.9-31.4-31.4v-117c0-62.4-72.6-52.5-99.1-16.4v133.4c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c43.3-51.6 162.4-60.4 162.4 39.3v141.5c.3 30.4-31.5 31.4-31.7 31.4zm179.7 2.9c-44.3 0-68.3-22.9-68.3-65.8V235.2H1488c-35.6 0-36.7-55.3 0-55.3h15.5v-37.3c0-41.3 63.8-42.1 63.8 0v37.5h24.9c35.4 0 35.7 55.3 0 55.3h-24.9v108.5c0 29.6 26.1 26.3 27.4 26.3 31.4 0 52.6 56.3-22.9 56.3zM1992 123c-19.5-50.2-95.5-50-114.5 0-107.3 275.7-99.5 252.7-99.5 262.8 0 42.8 58.3 51.2 72.1 14.4l13.5-35.9H2006l13 35.9c14.2 37.7 72.1 27.2 72.1-14.4 0-10.1 5.3 6.8-99.1-262.8zm-108.9 179.1l51.7-142.9 51.8 142.9h-103.5zm591.3-85.6l-53.7 176.3c-12.4 41.2-72 41-84 0l-42.3-135.9-42.3 135.9c-12.4 40.9-72 41.2-84.5 0l-54.2-176.3c-12.5-39.4 49.8-56.1 60.2-16.9L2213 342l45.3-139.5c10.9-32.7 59.6-34.7 71.2 0l45.3 139.5 39.3-142.4c10.3-38.3 72.6-23.8 60.3 16.9zm275.4 75.1c0-42.4-33.9-117.5-119.5-117.5-73.2 0-124.4 56.3-124.4 126 0 77.2 55.3 126.4 128.5 126.4 31.7 0 93-11.5 93-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-109 8.4-115.9-43.8h148.3c16.3 0 29.3-13.4 29.3-28.9zM2571 277.7c9.5-73.4 113.9-68.6 118.6 0H2571zm316.7 148.8c-31.4 0-81.6-10.5-96.6-31.9-12.4-17 2.5-39.8 21.8-39.8 16.3 0 36.8 22.9 77.7 22.9 27.4 0 40.4-11 40.4-25.8 0-39.8-142.9-7.4-142.9-102 0-40.4 35.3-75.7 98.6-75.7 31.4 0 74.1 9.9 87.6 29.4 10.8 14.8-1.4 36.2-20.9 36.2-15.1 0-26.7-17.3-66.2-17.3-22.9 0-37.8 10.5-37.8 23.8 0 35.9 142.4 6 142.4 103.1-.1 43.7-37.4 77.1-104.1 77.1zm266.8-252.4c-169.3 0-169.1 252.4 0 252.4 170.1 0 169.6-252.4 0-252.4zm0 196.1c-81.8 0-82-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm476.9 22V268.7c0-53.8-61.4-45.8-85.7-10.5v134c0 41.3-63.8 42.1-63.8 0V268.7c0-52.1-59.5-47.4-85.7-10.1v133.6c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c9.9-14.4 41.8-37.3 78.6-37.3 35.3 0 57.7 16.4 66.7 43.8 13.9-21.8 45.8-43.8 82.6-43.8 44.3 0 70.7 23.4 70.7 72.7v145.3c.5 17.3-13.5 31.4-31.9 31.4 3.5.1-31.3 1.1-31.3-31.3zM3992 291.6c0-42.4-32.4-117.5-117.9-117.5-73.2 0-127.5 56.3-127.5 126 0 77.2 58.3 126.4 131.6 126.4 31.7 0 91.5-11.5 91.5-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-110.5 8.4-117.5-43.8h149.8c16.3 0 29.1-13.4 29.3-28.9zm-180.5-13.9c9.7-74.4 115.9-68.3 120.1 0h-120.1z"
        ],
        "football-ball": [
            496,
            512,
            [],
            "f44e",
            "M481.5 60.3c-4.8-18.2-19.1-32.5-37.3-37.4C420.3 16.5 383 8.9 339.4 8L496 164.8c-.8-43.5-8.2-80.6-14.5-104.5zm-467 391.4c4.8 18.2 19.1 32.5 37.3 37.4 23.9 6.4 61.2 14 104.8 14.9L0 347.2c.8 43.5 8.2 80.6 14.5 104.5zM4.2 283.4L220.4 500c132.5-19.4 248.8-118.7 271.5-271.4L275.6 12C143.1 31.4 26.8 130.7 4.2 283.4zm317.3-123.6c3.1-3.1 8.2-3.1 11.3 0l11.3 11.3c3.1 3.1 3.1 8.2 0 11.3l-28.3 28.3 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-22.6 22.7 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L248 278.6l-22.6 22.6 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-28.3 28.3c-3.1 3.1-8.2 3.1-11.3 0l-11.3-11.3c-3.1-3.1-3.1-8.2 0-11.3l28.3-28.3-28.3-28.2c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 28.3-28.5z"
        ],
        forward: [
            512,
            512,
            [],
            "f04e",
            "M500.5 231.4l-192-160C287.9 54.3 256 68.6 256 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2zm-256 0l-192-160C31.9 54.3 0 68.6 0 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2z"
        ],
        frog: [
            576,
            512,
            [],
            "f52e",
            "M446.53 97.43C439.67 60.23 407.19 32 368 32c-39.23 0-71.72 28.29-78.54 65.54C126.75 112.96-.5 250.12 0 416.98.11 451.9 29.08 480 64 480h304c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-79.49l35.8-48.33c24.14-36.23 10.35-88.28-33.71-106.6-23.89-9.93-51.55-4.65-72.24 10.88l-32.76 24.59c-7.06 5.31-17.09 3.91-22.41-3.19-5.3-7.08-3.88-17.11 3.19-22.41l34.78-26.09c36.84-27.66 88.28-27.62 125.13 0 10.87 8.15 45.87 39.06 40.8 93.21L469.62 480H560c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-53.63l-98.52-104.68 154.44-86.65A58.16 58.16 0 0 0 576 189.94c0-21.4-11.72-40.95-30.48-51.23-40.56-22.22-98.99-41.28-98.99-41.28zM368 136c-13.26 0-24-10.75-24-24 0-13.26 10.74-24 24-24 13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"
        ],
        frown: [
            496,
            512,
            [],
            "f119",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm170.2 218.2C315.8 367.4 282.9 352 248 352s-67.8 15.4-90.2 42.2c-13.5 16.3-38.1-4.2-24.6-20.5C161.7 339.6 203.6 320 248 320s86.3 19.6 114.7 53.8c13.6 16.2-11 36.7-24.5 20.4z"
        ],
        "frown-open": [
            496,
            512,
            [],
            "f57a",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm187.3 183.3c-31.2-9.6-59.4-15.3-75.3-15.3s-44.1 5.7-75.3 15.3c-11.5 3.5-22.5-6.3-20.5-18.1 7-40 60.1-61.2 95.8-61.2s88.8 21.3 95.8 61.2c2 11.9-9.1 21.6-20.5 18.1zM328 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
        ],
        "funnel-dollar": [
            640,
            512,
            [],
            "f662",
            "M433.46 165.94l101.2-111.87C554.61 34.12 540.48 0 512.26 0H31.74C3.52 0-10.61 34.12 9.34 54.07L192 256v155.92c0 12.59 5.93 24.44 16 32l79.99 60c20.86 15.64 48.47 6.97 59.22-13.57C310.8 455.38 288 406.35 288 352c0-89.79 62.05-165.17 145.46-186.06zM480 192c-88.37 0-160 71.63-160 160s71.63 160 160 160 160-71.63 160-160-71.63-160-160-160zm16 239.88V448c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V256c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.04 44.44-42.67 45.07z"
        ],
        futbol: [
            512,
            512,
            [],
            "f1e3",
            "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-48 0l-.003-.282-26.064 22.741-62.679-58.5 16.454-84.355 34.303 3.072c-24.889-34.216-60.004-60.089-100.709-73.141l13.651 31.939L256 139l-74.953-41.525 13.651-31.939c-40.631 13.028-75.78 38.87-100.709 73.141l34.565-3.073 16.192 84.355-62.678 58.5-26.064-22.741-.003.282c0 43.015 13.497 83.952 38.472 117.991l7.704-33.897 85.138 10.447 36.301 77.826-29.902 17.786c40.202 13.122 84.29 13.148 124.572 0l-29.902-17.786 36.301-77.826 85.138-10.447 7.704 33.897C442.503 339.952 456 299.015 456 256zm-248.102 69.571l-29.894-91.312L256 177.732l77.996 56.527-29.622 91.312h-96.476z"
        ],
        gamepad: [
            640,
            512,
            [],
            "f11b",
            "M480.07 96H160a160 160 0 1 0 114.24 272h91.52A160 160 0 1 0 480.07 96zM248 268a12 12 0 0 1-12 12h-52v52a12 12 0 0 1-12 12h-24a12 12 0 0 1-12-12v-52H84a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h52v-52a12 12 0 0 1 12-12h24a12 12 0 0 1 12 12v52h52a12 12 0 0 1 12 12zm216 76a40 40 0 1 1 40-40 40 40 0 0 1-40 40zm64-96a40 40 0 1 1 40-40 40 40 0 0 1-40 40z"
        ],
        "gas-pump": [
            512,
            512,
            [],
            "f52f",
            "M336 448H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm157.2-340.7l-81-81c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-6.2 6.2-6.2 16.4 0 22.6L416 97.9V160c0 28.1 20.9 51.3 48 55.2V376c0 13.2-10.8 24-24 24s-24-10.8-24-24v-32c0-48.6-39.4-88-88-88h-8V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v352h288V304h8c22.1 0 40 17.9 40 40v27.8c0 37.7 27 72 64.5 75.9 43 4.3 79.5-29.5 79.5-71.7V152.6c0-17-6.8-33.3-18.8-45.3zM256 192H96V64h160v128z"
        ],
        gavel: [
            512,
            512,
            [],
            "f0e3",
            "M504.971 199.362l-22.627-22.627c-9.373-9.373-24.569-9.373-33.941 0l-5.657 5.657L329.608 69.255l5.657-5.657c9.373-9.373 9.373-24.569 0-33.941L312.638 7.029c-9.373-9.373-24.569-9.373-33.941 0L154.246 131.48c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l5.657-5.657 39.598 39.598-81.04 81.04-5.657-5.657c-12.497-12.497-32.758-12.497-45.255 0L9.373 412.118c-12.497 12.497-12.497 32.758 0 45.255l45.255 45.255c12.497 12.497 32.758 12.497 45.255 0l114.745-114.745c12.497-12.497 12.497-32.758 0-45.255l-5.657-5.657 81.04-81.04 39.598 39.598-5.657 5.657c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l124.451-124.451c9.372-9.372 9.372-24.568 0-33.941z"
        ],
        gem: [
            576,
            512,
            [],
            "f3a5",
            "M485.5 0L576 160H474.9L405.7 0h79.8zm-128 0l69.2 160H149.3L218.5 0h139zm-267 0h79.8l-69.2 160H0L90.5 0zM0 192h100.7l123 251.7c1.5 3.1-2.7 5.9-5 3.3L0 192zm148.2 0h279.6l-137 318.2c-1 2.4-4.5 2.4-5.5 0L148.2 192zm204.1 251.7l123-251.7H576L357.3 446.9c-2.3 2.7-6.5-.1-5-3.2z"
        ],
        genderless: [
            288,
            512,
            [],
            "f22d",
            "M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"
        ],
        ghost: [
            384,
            512,
            [],
            "f6e2",
            "M186.1.09C81.01 3.24 0 94.92 0 200.05v263.92c0 14.26 17.23 21.39 27.31 11.31l24.92-18.53c6.66-4.95 16-3.99 21.51 2.21l42.95 48.35c6.25 6.25 16.38 6.25 22.63 0l40.72-45.85c6.37-7.17 17.56-7.17 23.92 0l40.72 45.85c6.25 6.25 16.38 6.25 22.63 0l42.95-48.35c5.51-6.2 14.85-7.17 21.51-2.21l24.92 18.53c10.08 10.08 27.31 2.94 27.31-11.31V192C384 84 294.83-3.17 186.1.09zM128 224c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128 0c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        gift: [
            512,
            512,
            [],
            "f06b",
            "M32 448c0 17.7 14.3 32 32 32h160V320H32v128zm256 32h160c17.7 0 32-14.3 32-32V320H288v160zm192-320h-42.1c6.2-12.1 10.1-25.5 10.1-40 0-48.5-39.5-88-88-88-41.6 0-68.5 21.3-103 68.3-34.5-47-61.4-68.3-103-68.3-48.5 0-88 39.5-88 88 0 14.5 3.8 27.9 10.1 40H32c-17.7 0-32 14.3-32 32v80c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-80c0-17.7-14.3-32-32-32zm-326.1 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c19.9 0 34.6 3.3 86.1 80h-86.1zm206.1 0h-86.1c51.4-76.5 65.7-80 86.1-80 22.1 0 40 17.9 40 40s-17.9 40-40 40z"
        ],
        gifts: [
            640,
            512,
            [],
            "f79c",
            "M240.6 194.1c1.9-30.8 17.3-61.2 44-79.8C279.4 103.5 268.7 96 256 96h-29.4l30.7-22c7.2-5.1 8.9-15.1 3.7-22.3l-9.3-13c-5.1-7.2-15.1-8.9-22.3-3.7l-32 22.9 11.5-30.6c3.1-8.3-1.1-17.5-9.4-20.6l-15-5.6c-8.3-3.1-17.5 1.1-20.6 9.4l-19.9 53-19.9-53.1C121 2.1 111.8-2.1 103.5 1l-15 5.6C80.2 9.7 76 19 79.2 27.2l11.5 30.6L58.6 35c-7.2-5.1-17.2-3.5-22.3 3.7l-9.3 13c-5.1 7.2-3.5 17.2 3.7 22.3l30.7 22H32c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h168.9c-5.5-9.5-8.9-20.3-8.9-32V256c0-29.9 20.8-55 48.6-61.9zM224 480c0 17.7 14.3 32 32 32h160V384H224v96zm224 32h160c17.7 0 32-14.3 32-32v-96H448v128zm160-288h-20.4c2.6-7.6 4.4-15.5 4.4-23.8 0-35.5-27-72.2-72.1-72.2-48.1 0-75.9 47.7-87.9 75.3-12.1-27.6-39.9-75.3-87.9-75.3-45.1 0-72.1 36.7-72.1 72.2 0 8.3 1.7 16.2 4.4 23.8H256c-17.7 0-32 14.3-32 32v96h192V224h15.3l.7-.2.7.2H448v128h192v-96c0-17.7-14.3-32-32-32zm-272 0c-2.7-1.4-5.1-3-7.2-4.8-7.3-6.4-8.8-13.8-8.8-19 0-9.7 6.4-24.2 24.1-24.2 18.7 0 35.6 27.4 44.5 48H336zm199.2-4.8c-2.1 1.8-4.5 3.4-7.2 4.8h-52.6c8.8-20.3 25.8-48 44.5-48 17.7 0 24.1 14.5 24.1 24.2 0 5.2-1.5 12.6-8.8 19z"
        ],
        "glass-cheers": [
            640,
            512,
            [],
            "f79f",
            "M639.4 433.6c-8.4-20.4-31.8-30.1-52.2-21.6l-22.1 9.2-38.7-101.9c47.9-35 64.8-100.3 34.5-152.8L474.3 16c-8-13.9-25.1-19.7-40-13.6L320 49.8 205.7 2.4c-14.9-6.2-32-.3-40 13.6L79.1 166.5C48.9 219 65.7 284.3 113.6 319.2L74.9 421.1l-22.1-9.2c-20.4-8.5-43.7 1.2-52.2 21.6-1.7 4.1.2 8.8 4.3 10.5l162.3 67.4c4.1 1.7 8.7-.2 10.4-4.3 8.4-20.4-1.2-43.8-21.6-52.3l-22.1-9.2L173.3 342c4.4.5 8.8 1.3 13.1 1.3 51.7 0 99.4-33.1 113.4-85.3l20.2-75.4 20.2 75.4c14 52.2 61.7 85.3 113.4 85.3 4.3 0 8.7-.8 13.1-1.3L506 445.6l-22.1 9.2c-20.4 8.5-30.1 31.9-21.6 52.3 1.7 4.1 6.4 6 10.4 4.3L635.1 444c4-1.7 6-6.3 4.3-10.4zM275.9 162.1l-112.1-46.5 36.5-63.4 94.5 39.2-18.9 70.7zm88.2 0l-18.9-70.7 94.5-39.2 36.5 63.4-112.1 46.5z"
        ],
        "glass-martini": [
            512,
            512,
            [],
            "f000",
            "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6z"
        ],
        "glass-martini-alt": [
            512,
            512,
            [],
            "f57b",
            "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6zM443.77 48l-48 48H116.24l-48-48h375.53z"
        ],
        "glass-whiskey": [
            512,
            512,
            [],
            "f7a0",
            "M480 32H32C12.5 32-2.4 49.2.3 68.5l56 356.5c4.5 31.5 31.5 54.9 63.4 54.9h273c31.8 0 58.9-23.4 63.4-54.9l55.6-356.5C514.4 49.2 499.5 32 480 32zm-37.4 64l-30 192h-313L69.4 96h373.2z"
        ],
        glasses: [
            576,
            512,
            [],
            "f530",
            "M574.1 280.37L528.75 98.66c-5.91-23.7-21.59-44.05-43-55.81-21.44-11.73-46.97-14.11-70.19-6.33l-15.25 5.08c-8.39 2.79-12.92 11.86-10.12 20.24l5.06 15.18c2.79 8.38 11.85 12.91 20.23 10.12l13.18-4.39c10.87-3.62 23-3.57 33.16 1.73 10.29 5.37 17.57 14.56 20.37 25.82l38.46 153.82c-22.19-6.81-49.79-12.46-81.2-12.46-34.77 0-73.98 7.02-114.85 26.74h-73.18c-40.87-19.74-80.08-26.75-114.86-26.75-31.42 0-59.02 5.65-81.21 12.46l38.46-153.83c2.79-11.25 10.09-20.45 20.38-25.81 10.16-5.3 22.28-5.35 33.15-1.73l13.17 4.39c8.38 2.79 17.44-1.74 20.23-10.12l5.06-15.18c2.8-8.38-1.73-17.45-10.12-20.24l-15.25-5.08c-23.22-7.78-48.75-5.41-70.19 6.33-21.41 11.77-37.09 32.11-43 55.8L1.9 280.37A64.218 64.218 0 0 0 0 295.86v70.25C0 429.01 51.58 480 115.2 480h37.12c60.28 0 110.37-45.94 114.88-105.37l2.93-38.63h35.75l2.93 38.63C313.31 434.06 363.4 480 423.68 480h37.12c63.62 0 115.2-50.99 115.2-113.88v-70.25c0-5.23-.64-10.43-1.9-15.5zm-370.72 89.42c-1.97 25.91-24.4 46.21-51.06 46.21H115.2C86.97 416 64 393.62 64 366.11v-37.54c18.12-6.49 43.42-12.92 72.58-12.92 23.86 0 47.26 4.33 69.93 12.92l-3.13 41.22zM512 366.12c0 27.51-22.97 49.88-51.2 49.88h-37.12c-26.67 0-49.1-20.3-51.06-46.21l-3.13-41.22c22.67-8.59 46.08-12.92 69.95-12.92 29.12 0 54.43 6.44 72.55 12.93v37.54z"
        ],
        globe: [
            496,
            512,
            [],
            "f0ac",
            "M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"
        ],
        "globe-africa": [
            496,
            512,
            [],
            "f57c",
            "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm160 215.5v6.93c0 5.87-3.32 11.24-8.57 13.86l-15.39 7.7a15.485 15.485 0 0 1-15.53-.97l-18.21-12.14a15.52 15.52 0 0 0-13.5-1.81l-2.65.88c-9.7 3.23-13.66 14.79-7.99 23.3l13.24 19.86c2.87 4.31 7.71 6.9 12.89 6.9h8.21c8.56 0 15.5 6.94 15.5 15.5v11.34c0 3.35-1.09 6.62-3.1 9.3l-18.74 24.98c-1.42 1.9-2.39 4.1-2.83 6.43l-4.3 22.83c-.62 3.29-2.29 6.29-4.76 8.56a159.608 159.608 0 0 0-25 29.16l-13.03 19.55a27.756 27.756 0 0 1-23.09 12.36c-10.51 0-20.12-5.94-24.82-15.34a78.902 78.902 0 0 1-8.33-35.29V367.5c0-8.56-6.94-15.5-15.5-15.5h-25.88c-14.49 0-28.38-5.76-38.63-16a54.659 54.659 0 0 1-16-38.63v-14.06c0-17.19 8.1-33.38 21.85-43.7l27.58-20.69a54.663 54.663 0 0 1 32.78-10.93h.89c8.48 0 16.85 1.97 24.43 5.77l14.72 7.36c3.68 1.84 7.93 2.14 11.83.84l47.31-15.77c6.33-2.11 10.6-8.03 10.6-14.7 0-8.56-6.94-15.5-15.5-15.5h-10.09c-4.11 0-8.05-1.63-10.96-4.54l-6.92-6.92a15.493 15.493 0 0 0-10.96-4.54H199.5c-8.56 0-15.5-6.94-15.5-15.5v-4.4c0-7.11 4.84-13.31 11.74-15.04l14.45-3.61c3.74-.94 7-3.23 9.14-6.44l8.08-12.11c2.87-4.31 7.71-6.9 12.89-6.9h24.21c8.56 0 15.5-6.94 15.5-15.5v-21.7C359.23 71.63 422.86 131.02 441.93 208H423.5c-8.56 0-15.5 6.94-15.5 15.5z"
        ],
        "globe-americas": [
            496,
            512,
            [],
            "f57d",
            "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm82.29 357.6c-3.9 3.88-7.99 7.95-11.31 11.28-2.99 3-5.1 6.7-6.17 10.71-1.51 5.66-2.73 11.38-4.77 16.87l-17.39 46.85c-13.76 3-28 4.69-42.65 4.69v-27.38c1.69-12.62-7.64-36.26-22.63-51.25-6-6-9.37-14.14-9.37-22.63v-32.01c0-11.64-6.27-22.34-16.46-27.97-14.37-7.95-34.81-19.06-48.81-26.11-11.48-5.78-22.1-13.14-31.65-21.75l-.8-.72a114.792 114.792 0 0 1-18.06-20.74c-9.38-13.77-24.66-36.42-34.59-51.14 20.47-45.5 57.36-82.04 103.2-101.89l24.01 12.01C203.48 89.74 216 82.01 216 70.11v-11.3c7.99-1.29 16.12-2.11 24.39-2.42l28.3 28.3c6.25 6.25 6.25 16.38 0 22.63L264 112l-10.34 10.34c-3.12 3.12-3.12 8.19 0 11.31l4.69 4.69c3.12 3.12 3.12 8.19 0 11.31l-8 8a8.008 8.008 0 0 1-5.66 2.34h-8.99c-2.08 0-4.08.81-5.58 2.27l-9.92 9.65a8.008 8.008 0 0 0-1.58 9.31l15.59 31.19c2.66 5.32-1.21 11.58-7.15 11.58h-5.64c-1.93 0-3.79-.7-5.24-1.96l-9.28-8.06a16.017 16.017 0 0 0-15.55-3.1l-31.17 10.39a11.95 11.95 0 0 0-8.17 11.34c0 4.53 2.56 8.66 6.61 10.69l11.08 5.54c9.41 4.71 19.79 7.16 30.31 7.16s22.59 27.29 32 32h66.75c8.49 0 16.62 3.37 22.63 9.37l13.69 13.69a30.503 30.503 0 0 1 8.93 21.57 46.536 46.536 0 0 1-13.72 32.98zM417 274.25c-5.79-1.45-10.84-5-14.15-9.97l-17.98-26.97a23.97 23.97 0 0 1 0-26.62l19.59-29.38c2.32-3.47 5.5-6.29 9.24-8.15l12.98-6.49C440.2 193.59 448 223.87 448 256c0 8.67-.74 17.16-1.82 25.54L417 274.25z"
        ],
        "globe-asia": [
            496,
            512,
            [],
            "f57e",
            "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm-11.34 240.23c-2.89 4.82-8.1 7.77-13.72 7.77h-.31c-4.24 0-8.31 1.69-11.31 4.69l-5.66 5.66c-3.12 3.12-3.12 8.19 0 11.31l5.66 5.66c3 3 4.69 7.07 4.69 11.31V304c0 8.84-7.16 16-16 16h-6.11c-6.06 0-11.6-3.42-14.31-8.85l-22.62-45.23c-2.44-4.88-8.95-5.94-12.81-2.08l-19.47 19.46c-3 3-7.07 4.69-11.31 4.69H50.81C49.12 277.55 48 266.92 48 256c0-110.28 89.72-200 200-200 21.51 0 42.2 3.51 61.63 9.82l-50.16 38.53c-5.11 3.41-4.63 11.06.86 13.81l10.83 5.41c5.42 2.71 8.84 8.25 8.84 14.31V216c0 4.42-3.58 8-8 8h-3.06c-3.03 0-5.8-1.71-7.15-4.42-1.56-3.12-5.96-3.29-7.76-.3l-17.37 28.95zM408 358.43c0 4.24-1.69 8.31-4.69 11.31l-9.57 9.57c-3 3-7.07 4.69-11.31 4.69h-15.16c-4.24 0-8.31-1.69-11.31-4.69l-13.01-13.01a26.767 26.767 0 0 0-25.42-7.04l-21.27 5.32c-1.27.32-2.57.48-3.88.48h-10.34c-4.24 0-8.31-1.69-11.31-4.69l-11.91-11.91a8.008 8.008 0 0 1-2.34-5.66v-10.2c0-3.27 1.99-6.21 5.03-7.43l39.34-15.74c1.98-.79 3.86-1.82 5.59-3.05l23.71-16.89a7.978 7.978 0 0 1 4.64-1.48h12.09c3.23 0 6.15 1.94 7.39 4.93l5.35 12.85a4 4 0 0 0 3.69 2.46h3.8c1.78 0 3.35-1.18 3.84-2.88l4.2-14.47c.5-1.71 2.06-2.88 3.84-2.88h6.06c2.21 0 4 1.79 4 4v12.93c0 2.12.84 4.16 2.34 5.66l11.91 11.91c3 3 4.69 7.07 4.69 11.31v24.6z"
        ],
        "globe-europe": [
            496,
            512,
            [],
            "f7a2",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm200 248c0 22.5-3.9 44.2-10.8 64.4h-20.3c-4.3 0-8.4-1.7-11.4-4.8l-32-32.6c-4.5-4.6-4.5-12.1.1-16.7l12.5-12.5v-8.7c0-3-1.2-5.9-3.3-8l-9.4-9.4c-2.1-2.1-5-3.3-8-3.3h-16c-6.2 0-11.3-5.1-11.3-11.3 0-3 1.2-5.9 3.3-8l9.4-9.4c2.1-2.1 5-3.3 8-3.3h32c6.2 0 11.3-5.1 11.3-11.3v-9.4c0-6.2-5.1-11.3-11.3-11.3h-36.7c-8.8 0-16 7.2-16 16v4.5c0 6.9-4.4 13-10.9 15.2l-31.6 10.5c-3.3 1.1-5.5 4.1-5.5 7.6v2.2c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8s-3.6-8-8-8H247c-3 0-5.8 1.7-7.2 4.4l-9.4 18.7c-2.7 5.4-8.2 8.8-14.3 8.8H194c-8.8 0-16-7.2-16-16V199c0-4.2 1.7-8.3 4.7-11.3l20.1-20.1c4.6-4.6 7.2-10.9 7.2-17.5 0-3.4 2.2-6.5 5.5-7.6l40-13.3c1.7-.6 3.2-1.5 4.4-2.7l26.8-26.8c2.1-2.1 3.3-5 3.3-8 0-6.2-5.1-11.3-11.3-11.3H258l-16 16v8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-20c0-2.5 1.2-4.9 3.2-6.4l28.9-21.7c1.9-.1 3.8-.3 5.7-.3C358.3 56 448 145.7 448 256zM130.1 149.1c0-3 1.2-5.9 3.3-8l25.4-25.4c2.1-2.1 5-3.3 8-3.3 6.2 0 11.3 5.1 11.3 11.3v16c0 3-1.2 5.9-3.3 8l-9.4 9.4c-2.1 2.1-5 3.3-8 3.3h-16c-6.2 0-11.3-5.1-11.3-11.3zm128 306.4v-7.1c0-8.8-7.2-16-16-16h-20.2c-10.8 0-26.7-5.3-35.4-11.8l-22.2-16.7c-11.5-8.6-18.2-22.1-18.2-36.4v-23.9c0-16 8.4-30.8 22.1-39l42.9-25.7c7.1-4.2 15.2-6.5 23.4-6.5h31.2c10.9 0 21.4 3.9 29.6 10.9l43.2 37.1h18.3c8.5 0 16.6 3.4 22.6 9.4l17.3 17.3c3.4 3.4 8.1 5.3 12.9 5.3H423c-32.4 58.9-93.8 99.5-164.9 103.1z"
        ],
        "golf-ball": [
            416,
            512,
            [],
            "f450",
            "M96 416h224c0 17.7-14.3 32-32 32h-16c-17.7 0-32 14.3-32 32v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-20c0-17.7-14.3-32-32-32h-16c-17.7 0-32-14.3-32-32zm320-208c0 74.2-39 139.2-97.5 176h-221C39 347.2 0 282.2 0 208 0 93.1 93.1 0 208 0s208 93.1 208 208zm-180.1 43.9c18.3 0 33.1-14.8 33.1-33.1 0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1zm49.1 46.9c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1zm64-64c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1z"
        ],
        gopuram: [
            512,
            512,
            [],
            "f664",
            "M496 352h-16V240c0-8.8-7.2-16-16-16h-16v-80c0-8.8-7.2-16-16-16h-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16S96 7.2 96 16v112H80c-8.8 0-16 7.2-16 16v80H48c-8.8 0-16 7.2-16 16v112H16c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h80V352h32V224h32v-96h32v96h-32v128h-32v160h80v-80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v80h80V352h-32V224h-32v-96h32v96h32v128h32v160h80c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM232 176c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v48h-48zm56 176h-64v-64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"
        ],
        "graduation-cap": [
            640,
            512,
            [],
            "f19d",
            "M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 38.36 0 45.59l48.63 14.94c-10.67 13.19-17.23 29.28-17.88 46.9C38.78 266.15 32 276.11 32 288c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.94 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.65C90.32 307.85 96 298.78 96 288c0-11.57-6.47-21.25-15.66-26.87.76-15.02 8.44-28.3 20.69-36.72L296.6 284.5c9.06 2.78 26.44 6.25 46.79 0l278.95-85.7c23.55-7.24 23.55-38.36 0-45.6zM352.79 315.09c-28.53 8.76-52.84 3.92-65.59 0l-145.02-44.55L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.18-113.47-145.03 44.56z"
        ],
        "greater-than": [
            384,
            512,
            [],
            "f531",
            "M365.52 209.85L59.22 67.01c-16.06-7.49-35.15-.54-42.64 15.52L3.01 111.61c-7.49 16.06-.54 35.15 15.52 42.64L236.96 256.1 18.49 357.99C2.47 365.46-4.46 384.5 3.01 400.52l13.52 29C24 445.54 43.04 452.47 59.06 445l306.47-142.91a32.003 32.003 0 0 0 18.48-29v-34.23c-.01-12.45-7.21-23.76-18.49-29.01z"
        ],
        "greater-than-equal": [
            448,
            512,
            [],
            "f532",
            "M55.22 107.69l175.56 68.09-175.44 68.05c-18.39 6.03-27.88 24.39-21.2 41l12.09 30.08c6.68 16.61 26.99 25.19 45.38 19.15L393.02 214.2c13.77-4.52 22.98-16.61 22.98-30.17v-15.96c0-13.56-9.21-25.65-22.98-30.17L91.3 17.92c-18.29-6-38.51 2.53-45.15 19.06L34.12 66.9c-6.64 16.53 2.81 34.79 21.1 40.79zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
        ],
        grimace: [
            496,
            512,
            [],
            "f57f",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM144 400h-8c-17.7 0-32-14.3-32-32v-8h40v40zm0-56h-40v-8c0-17.7 14.3-32 32-32h8v40zm-8-136c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm72 192h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm-8-104c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64 128c0 17.7-14.3 32-32 32h-8v-40h40v8zm0-24h-40v-40h8c17.7 0 32 14.3 32 32v8z"
        ],
        grin: [
            496,
            512,
            [],
            "f580",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm80 256c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
        ],
        "grin-alt": [
            496,
            512,
            [],
            "f581",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm63.7 128.7c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zm-160 0c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
        ],
        "grin-beam": [
            496,
            512,
            [],
            "f582",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 144c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
        ],
        "grin-beam-sweat": [
            504,
            512,
            [],
            "f583",
            "M456 128c26.5 0 48-21 48-47 0-20-28.5-60.4-41.6-77.8-3.2-4.3-9.6-4.3-12.8 0C436.5 20.6 408 61 408 81c0 26 21.5 47 48 47zm0 32c-44.1 0-80-35.4-80-79 0-4.4.3-14.2 8.1-32.2C345 23.1 298.3 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-35.1-7.4-68.4-20.5-98.6-6.3 1.5-12.7 2.6-19.5 2.6zm-128-8c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
        ],
        "grin-hearts": [
            496,
            512,
            [],
            "f584",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM90.4 183.6c6.7-17.6 26.7-26.7 44.9-21.9l7.1 1.9 2-7.1c5-18.1 22.8-30.9 41.5-27.9 21.4 3.4 34.4 24.2 28.8 44.5L195.3 243c-1.2 4.5-5.9 7.2-10.5 6l-70.2-18.2c-20.4-5.4-31.9-27-24.2-47.2zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm133.4-201.3l-70.2 18.2c-4.5 1.2-9.2-1.5-10.5-6L281.3 173c-5.6-20.3 7.4-41.1 28.8-44.5 18.6-3 36.4 9.8 41.5 27.9l2 7.1 7.1-1.9c18.2-4.7 38.2 4.3 44.9 21.9 7.7 20.3-3.8 41.9-24.2 47.2z"
        ],
        "grin-squint": [
            496,
            512,
            [],
            "f585",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
        ],
        "grin-squint-tears": [
            512,
            512,
            [],
            "f586",
            "M409.6 111.9c22.6-3.2 73.5-12 88.3-26.8 19.2-19.2 18.9-50.6-.7-70.2S446-5 426.9 14.2c-14.8 14.8-23.5 65.7-26.8 88.3-.8 5.5 3.9 10.2 9.5 9.4zM102.4 400.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm311.7-256.5c-33 3.9-48.6-25.1-45.7-45.7 3.4-24 7.4-42.1 11.5-56.5C285.1-13.4 161.8-.5 80.6 80.6-.5 161.7-13.4 285 41.4 379.9c14.4-4.1 32.4-8 56.5-11.5 33.2-3.9 48.6 25.2 45.7 45.7-3.4 24-7.4 42.1-11.5 56.5 94.8 54.8 218.1 41.9 299.3-39.2s94-204.4 39.2-299.3c-14.4 4.1-32.5 8-56.5 11.5zM255.7 106c3.3-13.2 22.4-11.5 23.6 1.8l4.8 52.3 52.3 4.8c13.4 1.2 14.9 20.3 1.8 23.6l-90.5 22.6c-8.9 2.2-16.7-5.9-14.5-14.5l22.5-90.6zm-90.9 230.3L160 284l-52.3-4.8c-13.4-1.2-14.9-20.3-1.8-23.6l90.5-22.6c8.8-2.2 16.7 5.8 14.5 14.5L188.3 338c-3.1 13.2-22.2 11.7-23.5-1.7zm215.7 44.2c-29.3 29.3-75.7 50.4-116.7 50.4-18.9 0-36.6-4.5-51-14.7-9.8-6.9-8.7-21.8 2-27.2 28.3-14.6 63.9-42.4 97.8-76.3s61.7-69.6 76.3-97.8c5.4-10.5 20.2-11.9 27.3-2 32.3 45.3 7.1 124.7-35.7 167.6z"
        ],
        "grin-stars": [
            496,
            512,
            [],
            "f587",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM94.6 168.9l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.2 1 8.9 8.6 4.3 13.2l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L152 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.6-4.7-1.9-12.3 4.3-13.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm157.7-249.9l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L344 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.5-4.6-1.9-12.2 4.3-13.2l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.3.9 9 8.5 4.4 13.1z"
        ],
        "grin-tears": [
            640,
            512,
            [],
            "f588",
            "M102.4 256.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm523.4 26.8c-14.8-14.8-65.7-23.5-88.3-26.8-5.5-.8-10.3 3.9-9.5 9.5 3.2 22.6 12 73.5 26.8 88.3 19.2 19.2 50.6 18.9 70.2-.7s20-51.2.8-70.3zm-129.4-12.8c-3.8-26.6 19.1-49.5 45.7-45.7 8.9 1.3 16.8 2.7 24.3 4.1C552.7 104.5 447.7 8 320 8S87.3 104.5 73.6 228.5c7.5-1.4 15.4-2.8 24.3-4.1 33.2-3.9 48.6 25.3 45.7 45.7-11.8 82.3-29.9 100.4-35.8 106.4-.9.9-2 1.6-3 2.5 42.7 74.6 123 125 215.2 125s172.5-50.4 215.2-125.1c-1-.9-2.1-1.5-3-2.5-5.9-5.9-24-24-35.8-106.3zM400 152c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.7 9.2-21.6 20.7-17.9C227.1 330.5 272 336 320 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
        ],
        "grin-tongue": [
            496,
            512,
            [],
            "f589",
            "M248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-34.9 134.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"
        ],
        "grin-tongue-squint": [
            496,
            512,
            [],
            "f58a",
            "M293.1 374.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-33.8 210.3l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.7 4.7 7.7 15.9 0 20.6zm163 30c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.8-4.7-7.8-15.9 0-20.6l80-48c11.7-6.9 23.9 7.7 15.4 18L343.6 208l33.6 40.3z"
        ],
        "grin-tongue-wink": [
            496,
            512,
            [],
            "f58b",
            "M344 184c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-56 225l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L112 233c-8.5 7.4-21.6.3-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c1.6 11.1-11.6 18.2-20 10.8zm152 39c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm-50.9 102.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"
        ],
        "grin-wink": [
            496,
            512,
            [],
            "f58c",
            "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm168 25l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.6 11-11.5 18.2-20 10.8zm-243.1 87.8C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6 20.7 17.9-9.2 55-83.2 93.3-143.8 93.3s-134.5-38.3-143.8-93.3c-2-11.9 9.3-21.6 20.7-17.9z"
        ],
        "grip-horizontal": [
            448,
            512,
            [],
            "f58d",
            "M96 288H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM96 96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
        ],
        "grip-lines": [
            512,
            512,
            [],
            "f7a4",
            "M496 288H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-128H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
        ],
        "grip-lines-vertical": [
            256,
            512,
            [],
            "f7a5",
            "M96 496V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm128 0V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16z"
        ],
        "grip-vertical": [
            320,
            512,
            [],
            "f58e",
            "M96 32H32C14.33 32 0 46.33 0 64v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM288 32h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
        ],
        guitar: [
            512,
            512,
            [],
            "f7a6",
            "M502.63 39L473 9.37a32 32 0 0 0-45.26 0L381.46 55.7a35.14 35.14 0 0 0-8.53 13.79L360.77 106l-76.26 76.26c-12.16-8.76-25.5-15.74-40.1-19.14-33.45-7.78-67-.88-89.88 22a82.45 82.45 0 0 0-20.24 33.47c-6 18.56-23.21 32.69-42.15 34.46-23.7 2.27-45.73 11.45-62.61 28.44C-16.11 327-7.9 409 47.58 464.45S185 528 230.56 482.52c17-16.88 26.16-38.9 28.45-62.71 1.76-18.85 15.89-36.13 34.43-42.14a82.6 82.6 0 0 0 33.48-20.25c22.87-22.88 29.74-56.36 22-89.75-3.39-14.64-10.37-28-19.16-40.2L406 151.23l36.48-12.16a35.14 35.14 0 0 0 13.79-8.53l46.33-46.32a32 32 0 0 0 .03-45.22zM208 352a48 48 0 1 1 48-48 48 48 0 0 1-48 48z"
        ],
        "h-square": [
            448,
            512,
            [],
            "f0fd",
            "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-112 48h-32c-8.837 0-16 7.163-16 16v80H160v-80c0-8.837-7.163-16-16-16h-32c-8.837 0-16 7.163-16 16v224c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16v-80h128v80c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16V144c0-8.837-7.163-16-16-16z"
        ],
        hamburger: [
            512,
            512,
            [],
            "f805",
            "M464 256H48a48 48 0 0 0 0 96h416a48 48 0 0 0 0-96zm16 128H32a16 16 0 0 0-16 16v16a64 64 0 0 0 64 64h352a64 64 0 0 0 64-64v-16a16 16 0 0 0-16-16zM58.64 224h394.72c34.57 0 54.62-43.9 34.82-75.88C448 83.2 359.55 32.1 256 32c-103.54.1-192 51.2-232.18 116.11C4 180.09 24.07 224 58.64 224zM384 112a16 16 0 1 1-16 16 16 16 0 0 1 16-16zM256 80a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm-128 32a16 16 0 1 1-16 16 16 16 0 0 1 16-16z"
        ],
        hammer: [
            576,
            512,
            [],
            "f6e3",
            "M571.31 193.94l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31-28.9-28.9c5.63-21.31.36-44.9-16.35-61.61l-45.25-45.25c-62.48-62.48-163.79-62.48-226.28 0l90.51 45.25v18.75c0 16.97 6.74 33.25 18.75 45.25l49.14 49.14c16.71 16.71 40.3 21.98 61.61 16.35l28.9 28.9-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l90.51-90.51c6.23-6.24 6.23-16.37-.02-22.62zm-286.72-15.2c-3.7-3.7-6.84-7.79-9.85-11.95L19.64 404.96c-25.57 23.88-26.26 64.19-1.53 88.93s65.05 24.05 88.93-1.53l238.13-255.07c-3.96-2.91-7.9-5.87-11.44-9.41l-49.14-49.14z"
        ],
        hamsa: [
            512,
            512,
            [],
            "f665",
            "M509.34 307.25C504.28 295.56 492.75 288 480 288h-64V80c0-22-18-40-40-40s-40 18-40 40v134c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V40c0-22-18-40-40-40s-40 18-40 40v174c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V80c0-22-18-40-40-40S96 58 96 80v208H32c-12.75 0-24.28 7.56-29.34 19.25a31.966 31.966 0 0 0 5.94 34.58l102.69 110.03C146.97 490.08 199.69 512 256 512s109.03-21.92 144.72-60.14L503.4 341.83a31.966 31.966 0 0 0 5.94-34.58zM256 416c-53.02 0-96-64-96-64s42.98-64 96-64 96 64 96 64-42.98 64-96 64zm0-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
        ],
        "hand-holding": [
            576,
            512,
            [],
            "f4bd",
            "M565.3 328.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
        ],
        "hand-holding-heart": [
            576,
            512,
            [],
            "f4be",
            "M275.3 250.5c7 7.4 18.4 7.4 25.5 0l108.9-114.2c31.6-33.2 29.8-88.2-5.6-118.8-30.8-26.7-76.7-21.9-104.9 7.7L288 36.9l-11.1-11.6C248.7-4.4 202.8-9.2 172 17.5c-35.3 30.6-37.2 85.6-5.6 118.8l108.9 114.2zm290 77.6c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
        ],
        "hand-holding-medical": [
            576,
            512,
            [],
            "e05c",
            "M159.88,175.82h64v64a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16v-64h64a16,16,0,0,0,16-16v-64a16,16,0,0,0-16-16h-64v-64a16,16,0,0,0-16-16h-64a16,16,0,0,0-16,16v64h-64a16,16,0,0,0-16,16v64A16,16,0,0,0,159.88,175.82ZM568.07,336.13a39.91,39.91,0,0,0-55.93-8.47L392.47,415.84H271.86a16,16,0,0,1,0-32H350.1c16,0,30.75-10.87,33.37-26.61a32.06,32.06,0,0,0-31.62-37.38h-160a117.7,117.7,0,0,0-74.12,26.25l-46.5,37.74H15.87a16.11,16.11,0,0,0-16,16v96a16.11,16.11,0,0,0,16,16h347a104.8,104.8,0,0,0,61.7-20.27L559.6,392A40,40,0,0,0,568.07,336.13Z"
        ],
        "hand-holding-usd": [
            576,
            512,
            [],
            "f4c0",
            "M271.06,144.3l54.27,14.3a8.59,8.59,0,0,1,6.63,8.1c0,4.6-4.09,8.4-9.12,8.4h-35.6a30,30,0,0,1-11.19-2.2c-5.24-2.2-11.28-1.7-15.3,2l-19,17.5a11.68,11.68,0,0,0-2.25,2.66,11.42,11.42,0,0,0,3.88,15.74,83.77,83.77,0,0,0,34.51,11.5V240c0,8.8,7.83,16,17.37,16h17.37c9.55,0,17.38-7.2,17.38-16V222.4c32.93-3.6,57.84-31,53.5-63-3.15-23-22.46-41.3-46.56-47.7L282.68,97.4a8.59,8.59,0,0,1-6.63-8.1c0-4.6,4.09-8.4,9.12-8.4h35.6A30,30,0,0,1,332,83.1c5.23,2.2,11.28,1.7,15.3-2l19-17.5A11.31,11.31,0,0,0,368.47,61a11.43,11.43,0,0,0-3.84-15.78,83.82,83.82,0,0,0-34.52-11.5V16c0-8.8-7.82-16-17.37-16H295.37C285.82,0,278,7.2,278,16V33.6c-32.89,3.6-57.85,31-53.51,63C227.63,119.6,247,137.9,271.06,144.3ZM565.27,328.1c-11.8-10.7-30.2-10-42.6,0L430.27,402a63.64,63.64,0,0,1-40,14H272a16,16,0,0,1,0-32h78.29c15.9,0,30.71-10.9,33.25-26.6a31.2,31.2,0,0,0,.46-5.46A32,32,0,0,0,352,320H192a117.66,117.66,0,0,0-74.1,26.29L71.4,384H16A16,16,0,0,0,0,400v96a16,16,0,0,0,16,16H372.77a64,64,0,0,0,40-14L564,377a32,32,0,0,0,1.28-48.9Z"
        ],
        "hand-holding-water": [
            576,
            512,
            [],
            "f4c1",
            "M288 256c53 0 96-42.1 96-94 0-40-57.1-120.7-83.2-155.6-6.4-8.5-19.2-8.5-25.6 0C249.1 41.3 192 122 192 162c0 51.9 43 94 96 94zm277.3 72.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
        ],
        "hand-lizard": [
            576,
            512,
            [],
            "f258",
            "M384 480h192V363.778a95.998 95.998 0 0 0-14.833-51.263L398.127 54.368A48 48 0 0 0 357.544 32H24C10.745 32 0 42.745 0 56v16c0 30.928 25.072 56 56 56h229.981c12.844 0 21.556 13.067 16.615 24.923l-21.41 51.385A32 32 0 0 1 251.648 224H128c-35.346 0-64 28.654-64 64v8c0 13.255 10.745 24 24 24h147.406a47.995 47.995 0 0 1 25.692 7.455l111.748 70.811A24.001 24.001 0 0 1 384 418.539V480z"
        ],
        "hand-middle-finger": [
            512,
            512,
            [],
            "f806",
            "M479.93 317.12a37.33 37.33 0 0 0-28.28-36.19L416 272v-49.59c0-11.44-9.69-21.29-23.15-23.54l-38.4-6.4C336.63 189.5 320 200.86 320 216v32a8 8 0 0 1-16 0V50c0-26.28-20.25-49.2-46.52-50A48 48 0 0 0 208 48v200a8 8 0 0 1-16 0v-32c0-15.15-16.63-26.51-34.45-23.54l-30.68 5.12c-18 3-30.87 16.12-30.87 31.38V376a8 8 0 0 1-16 0v-76l-27.36 15A37.34 37.34 0 0 0 32 348.4v73.47a37.31 37.31 0 0 0 10.93 26.39l30.93 30.93A112 112 0 0 0 153.05 512h215A112 112 0 0 0 480 400z"
        ],
        "hand-paper": [
            448,
            512,
            [],
            "f256",
            "M408.781 128.007C386.356 127.578 368 146.36 368 168.79V256h-8V79.79c0-22.43-18.356-41.212-40.781-40.783C297.488 39.423 280 57.169 280 79v177h-8V40.79C272 18.36 253.644-.422 231.219.007 209.488.423 192 18.169 192 40v216h-8V80.79c0-22.43-18.356-41.212-40.781-40.783C121.488 40.423 104 58.169 104 80v235.992l-31.648-43.519c-12.993-17.866-38.009-21.817-55.877-8.823-17.865 12.994-21.815 38.01-8.822 55.877l125.601 172.705A48 48 0 0 0 172.073 512h197.59c22.274 0 41.622-15.324 46.724-37.006l26.508-112.66a192.011 192.011 0 0 0 5.104-43.975V168c.001-21.831-17.487-39.577-39.218-39.993z"
        ],
        "hand-peace": [
            448,
            512,
            [],
            "f25b",
            "M408 216c-22.092 0-40 17.909-40 40h-8v-32c0-22.091-17.908-40-40-40s-40 17.909-40 40v32h-8V48c0-26.51-21.49-48-48-48s-48 21.49-48 48v208h-13.572L92.688 78.449C82.994 53.774 55.134 41.63 30.461 51.324 5.787 61.017-6.356 88.877 3.337 113.551l74.765 190.342-31.09 24.872c-15.381 12.306-19.515 33.978-9.741 51.081l64 112A39.998 39.998 0 0 0 136 512h240c18.562 0 34.686-12.77 38.937-30.838l32-136A39.97 39.97 0 0 0 448 336v-80c0-22.091-17.908-40-40-40z"
        ],
        "hand-point-down": [
            384,
            512,
            [],
            "f0a7",
            "M91.826 467.2V317.966c-8.248 5.841-16.558 10.57-24.918 14.153C35.098 345.752-.014 322.222 0 288c.008-18.616 10.897-32.203 29.092-40 28.286-12.122 64.329-78.648 77.323-107.534 7.956-17.857 25.479-28.453 43.845-28.464l.001-.002h171.526c11.812 0 21.897 8.596 23.703 20.269 7.25 46.837 38.483 61.76 38.315 123.731-.007 2.724.195 13.254.195 16 0 50.654-22.122 81.574-71.263 72.6-9.297 18.597-39.486 30.738-62.315 16.45-21.177 24.645-53.896 22.639-70.944 6.299V467.2c0 24.15-20.201 44.8-43.826 44.8-23.283 0-43.826-21.35-43.826-44.8zM112 72V24c0-13.255 10.745-24 24-24h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24zm212-24c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"
        ],
        "hand-point-left": [
            512,
            512,
            [],
            "f0a5",
            "M44.8 155.826h149.234c-5.841-8.248-10.57-16.558-14.153-24.918C166.248 99.098 189.778 63.986 224 64c18.616.008 32.203 10.897 40 29.092 12.122 28.286 78.648 64.329 107.534 77.323 17.857 7.956 28.453 25.479 28.464 43.845l.002.001v171.526c0 11.812-8.596 21.897-20.269 23.703-46.837 7.25-61.76 38.483-123.731 38.315-2.724-.007-13.254.195-16 .195-50.654 0-81.574-22.122-72.6-71.263-18.597-9.297-30.738-39.486-16.45-62.315-24.645-21.177-22.639-53.896-6.299-70.944H44.8c-24.15 0-44.8-20.201-44.8-43.826 0-23.283 21.35-43.826 44.8-43.826zM440 176h48c13.255 0 24 10.745 24 24v192c0 13.255-10.745 24-24 24h-48c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24zm24 212c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20z"
        ],
        "hand-point-right": [
            512,
            512,
            [],
            "f0a4",
            "M512 199.652c0 23.625-20.65 43.826-44.8 43.826h-99.851c16.34 17.048 18.346 49.766-6.299 70.944 14.288 22.829 2.147 53.017-16.45 62.315C353.574 425.878 322.654 448 272 448c-2.746 0-13.276-.203-16-.195-61.971.168-76.894-31.065-123.731-38.315C120.596 407.683 112 397.599 112 385.786V214.261l.002-.001c.011-18.366 10.607-35.889 28.464-43.845 28.886-12.994 95.413-49.038 107.534-77.323 7.797-18.194 21.384-29.084 40-29.092 34.222-.014 57.752 35.098 44.119 66.908-3.583 8.359-8.312 16.67-14.153 24.918H467.2c23.45 0 44.8 20.543 44.8 43.826zM96 200v192c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24h48c13.255 0 24 10.745 24 24zM68 368c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"
        ],
        "hand-point-up": [
            384,
            512,
            [],
            "f0a6",
            "M135.652 0c23.625 0 43.826 20.65 43.826 44.8v99.851c17.048-16.34 49.766-18.346 70.944 6.299 22.829-14.288 53.017-2.147 62.315 16.45C361.878 158.426 384 189.346 384 240c0 2.746-.203 13.276-.195 16 .168 61.971-31.065 76.894-38.315 123.731C343.683 391.404 333.599 400 321.786 400H150.261l-.001-.002c-18.366-.011-35.889-10.607-43.845-28.464C93.421 342.648 57.377 276.122 29.092 264 10.897 256.203.008 242.616 0 224c-.014-34.222 35.098-57.752 66.908-44.119 8.359 3.583 16.67 8.312 24.918 14.153V44.8c0-23.45 20.543-44.8 43.826-44.8zM136 416h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24v-48c0-13.255 10.745-24 24-24zm168 28c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20z"
        ],
        "hand-pointer": [
            448,
            512,
            [],
            "f25a",
            "M448 240v96c0 3.084-.356 6.159-1.063 9.162l-32 136C410.686 499.23 394.562 512 376 512H168a40.004 40.004 0 0 1-32.35-16.473l-127.997-176c-12.993-17.866-9.043-42.883 8.822-55.876 17.867-12.994 42.884-9.043 55.877 8.823L104 315.992V40c0-22.091 17.908-40 40-40s40 17.909 40 40v200h8v-40c0-22.091 17.908-40 40-40s40 17.909 40 40v40h8v-24c0-22.091 17.908-40 40-40s40 17.909 40 40v24h8c0-22.091 17.908-40 40-40s40 17.909 40 40zm-256 80h-8v96h8v-96zm88 0h-8v96h8v-96zm88 0h-8v96h8v-96z"
        ],
        "hand-rock": [
            512,
            512,
            [],
            "f255",
            "M464.8 80c-26.9-.4-48.8 21.2-48.8 48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v32h-8V80.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v136l-8-7.1v-48.1c0-26.3-20.9-48.3-47.2-48.8C21.9 127.6 0 149.2 0 176v66.4c0 27.4 11.7 53.5 32.2 71.8l111.7 99.3c10.2 9.1 16.1 22.2 16.1 35.9v6.7c0 13.3 10.7 24 24 24h240c13.3 0 24-10.7 24-24v-2.9c0-12.8 2.6-25.5 7.5-37.3l49-116.3c5-11.8 7.5-24.5 7.5-37.3V128.8c0-26.3-20.9-48.4-47.2-48.8z"
        ],
        "hand-scissors": [
            512,
            512,
            [],
            "f257",
            "M216 440c0-22.092 17.909-40 40-40v-8h-32c-22.091 0-40-17.908-40-40s17.909-40 40-40h32v-8H48c-26.51 0-48-21.49-48-48s21.49-48 48-48h208v-13.572l-177.551-69.74c-24.674-9.694-36.818-37.555-27.125-62.228 9.693-24.674 37.554-36.817 62.228-27.124l190.342 74.765 24.872-31.09c12.306-15.381 33.978-19.515 51.081-9.741l112 64A40.002 40.002 0 0 1 512 168v240c0 18.562-12.77 34.686-30.838 38.937l-136 32A39.982 39.982 0 0 1 336 480h-80c-22.091 0-40-17.908-40-40z"
        ],
        "hand-sparkles": [
            640,
            512,
            [],
            "e05d",
            "M106.66,170.64l.09,0,49.55-20.65a7.32,7.32,0,0,0,3.68-6h0a7.29,7.29,0,0,0-3.68-6l-49.57-20.67-.07,0L86,67.68a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L3.7,138A7.29,7.29,0,0,0,0,144H0a7.32,7.32,0,0,0,3.68,6L53.27,170.6l.07,0L74,220.26a6.65,6.65,0,0,0,11.92,0l20.69-49.62ZM471.38,467.41l-1-.42-1-.5a38.67,38.67,0,0,1,0-69.14l1-.49,1-.43,37.49-15.63,15.63-37.48.41-1,.47-.95c3.85-7.74,10.58-13.63,18.35-17.34,0-1.33.25-2.69.27-4V144a32,32,0,0,0-64,0v72a8,8,0,0,1-8,8H456a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H360a8,8,0,0,1-8-8V32a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H264a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0v241l-23.59-32.49a40,40,0,0,0-64.71,47.09L229.3,492.21A48.07,48.07,0,0,0,268.09,512H465.7c19.24,0,35.65-11.73,43.24-28.79l-.07-.17ZM349.79,339.52,320,351.93l-12.42,29.78a4,4,0,0,1-7.15,0L288,351.93l-29.79-12.41a4,4,0,0,1,0-7.16L288,319.94l12.42-29.78a4,4,0,0,1,7.15,0L320,319.94l29.79,12.42a4,4,0,0,1,0,7.16ZM640,431.91a7.28,7.28,0,0,0-3.68-6l-49.57-20.67-.07,0L566,355.63a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L483.7,426a7.28,7.28,0,0,0-3.68,6h0a7.29,7.29,0,0,0,3.68,5.95l49.57,20.67.07,0L554,508.21a6.65,6.65,0,0,0,11.92,0l20.69-49.62h0l.09,0,49.55-20.66a7.29,7.29,0,0,0,3.68-5.95h0Z"
        ],
        "hand-spock": [
            512,
            512,
            [],
            "f259",
            "M510.9005,145.27027,442.604,432.09391A103.99507,103.99507,0,0,1,341.43745,512H214.074a135.96968,135.96968,0,0,1-93.18489-36.95291L12.59072,373.12723a39.992,39.992,0,0,1,54.8122-58.24988l60.59342,57.02528v0a283.24849,283.24849,0,0,0-11.6703-80.46734L73.63726,147.36011a40.00575,40.00575,0,1,1,76.71833-22.7187l37.15458,125.39477a8.33113,8.33113,0,0,0,16.05656-4.4414L153.26183,49.95406A39.99638,39.99638,0,1,1,230.73015,30.0166l56.09491,218.15825a10.42047,10.42047,0,0,0,20.30018-.501L344.80766,63.96966a40.052,40.052,0,0,1,51.30245-30.0893c19.86073,6.2998,30.86262,27.67378,26.67564,48.08487l-33.83869,164.966a7.55172,7.55172,0,0,0,14.74406,3.2666l29.3973-123.45874a39.99414,39.99414,0,1,1,77.81208,18.53121Z"
        ],
        hands: [
            640,
            512,
            [],
            "f4c2",
            "M204.8 230.4c-10.6-14.1-30.7-17-44.8-6.4-14.1 10.6-17 30.7-6.4 44.8l38.1 50.8c4.8 6.4 4.1 15.3-1.5 20.9l-12.8 12.8c-6.7 6.7-17.6 6.2-23.6-1.1L64 244.4V96c0-17.7-14.3-32-32-32S0 78.3 0 96v218.4c0 10.9 3.7 21.5 10.5 30l104.1 134.3c5 6.5 8.4 13.9 10.4 21.7 1.8 6.9 8.1 11.6 15.3 11.6H272c8.8 0 16-7.2 16-16V384c0-27.7-9-54.6-25.6-76.8l-57.6-76.8zM608 64c-17.7 0-32 14.3-32 32v148.4l-89.8 107.8c-6 7.2-17 7.7-23.6 1.1l-12.8-12.8c-5.6-5.6-6.3-14.5-1.5-20.9l38.1-50.8c10.6-14.1 7.7-34.2-6.4-44.8-14.1-10.6-34.2-7.7-44.8 6.4l-57.6 76.8C361 329.4 352 356.3 352 384v112c0 8.8 7.2 16 16 16h131.7c7.1 0 13.5-4.7 15.3-11.6 2-7.8 5.4-15.2 10.4-21.7l104.1-134.3c6.8-8.5 10.5-19.1 10.5-30V96c0-17.7-14.3-32-32-32z"
        ],
        "hands-helping": [
            640,
            512,
            [],
            "f4c4",
            "M488 192H336v56c0 39.7-32.3 72-72 72s-72-32.3-72-72V126.4l-64.9 39C107.8 176.9 96 197.8 96 220.2v47.3l-80 46.2C.7 322.5-4.6 342.1 4.3 357.4l80 138.6c8.8 15.3 28.4 20.5 43.7 11.7L231.4 448H368c35.3 0 64-28.7 64-64h16c17.7 0 32-14.3 32-32v-64h8c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm147.7-37.4L555.7 16C546.9.7 527.3-4.5 512 4.3L408.6 64H306.4c-12 0-23.7 3.4-33.9 9.7L239 94.6c-9.4 5.8-15 16.1-15 27.1V248c0 22.1 17.9 40 40 40s40-17.9 40-40v-88h184c30.9 0 56 25.1 56 56v28.5l80-46.2c15.3-8.9 20.5-28.4 11.7-43.7z"
        ],
        "hands-wash": [
            576,
            512,
            [],
            "e05e",
            "M496,224a48,48,0,1,0-48-48A48,48,0,0,0,496,224ZM311.47,178.45A56.77,56.77,0,0,1,328,176a56,56,0,0,1,19,3.49l15.35-48.61A24,24,0,0,0,342,99.74c-11.53-1.35-22.21,6.44-25.71,17.51l-20.9,66.17ZM93.65,386.33c.8-.19,1.54-.54,2.35-.71V359.93a156,156,0,0,1,107.06-148l73.7-22.76L310.92,81.05a24,24,0,0,0-20.33-31.11c-11.53-1.34-22.22,6.45-25.72,17.52L231.42,173.88a8,8,0,0,1-15.26-4.83L259.53,31.26A24,24,0,0,0,239.2.15C227.67-1.19,217,6.6,213.49,17.66L165.56,169.37a8,8,0,1,1-15.26-4.82l38.56-122a24,24,0,0,0-20.33-31.11C157,10,146.32,17.83,142.82,28.9l-60,189.85L80.76,168.7A24,24,0,0,0,56.9,144.55c-13.23-.05-24.72,10.54-24.9,23.86V281.14A123.69,123.69,0,0,0,93.65,386.33ZM519.1,336H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,279.84,498.71,272,487.1,272H288l47.09-17.06a24,24,0,0,0-14.18-45.88L213.19,242.31A123.88,123.88,0,0,0,128,360v25.65a79.78,79.78,0,0,1,58,108.63A118.9,118.9,0,0,0,248,512H456a24,24,0,0,0,23.54-28.76C477.35,471.84,466.71,464,455.1,464H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,407.84,498.71,400,487.1,400H360a8,8,0,0,1,0-16H520a24,24,0,0,0,23.54-28.76C541.35,343.84,530.71,336,519.1,336ZM416,64a32,32,0,1,0-32-32A32,32,0,0,0,416,64ZM112,416a48,48,0,1,0,48,48A48,48,0,0,0,112,416Z"
        ],
        handshake: [
            640,
            512,
            [],
            "f2b5",
            "M434.7 64h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-.1.1-.2.3-.3.4-16.6 15.6-16.3 40.5-2.1 56 12.7 13.9 39.4 17.6 56.1 2.7.1-.1.3-.1.4-.2l79.9-73.2c6.5-5.9 16.7-5.5 22.6 1 6 6.5 5.5 16.6-1 22.6l-26.1 23.9L504 313.8c2.9 2.4 5.5 5 7.9 7.7V128l-54.6-54.6c-5.9-6-14.1-9.4-22.6-9.4zM544 128.2v223.9c0 17.7 14.3 32 32 32h64V128.2h-96zm48 223.9c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM0 384h64c17.7 0 32-14.3 32-32V128.2H0V384zm48-63.9c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.9 7.2-16 16-16zm435.9 18.6L334.6 217.5l-30 27.5c-29.7 27.1-75.2 24.5-101.7-4.4-26.9-29.4-24.8-74.9 4.4-101.7L289.1 64h-83.8c-8.5 0-16.6 3.4-22.6 9.4L128 128v223.9h18.3l90.5 81.9c27.4 22.3 67.7 18.1 90-9.3l.2-.2 17.9 15.5c15.9 13 39.4 10.5 52.3-5.4l31.4-38.6 5.4 4.4c13.7 11.1 33.9 9.1 45-4.7l9.5-11.7c11.2-13.8 9.1-33.9-4.6-45.1z"
        ],
        "handshake-alt-slash": [
            640,
            512,
            [],
            "e05f",
            "M358.59,195.6,504.2,313.8a63.4,63.4,0,0,1,22.21,37.91H624a16.05,16.05,0,0,0,16-16V143.91A16,16,0,0,0,624,128H512L457.41,73.41A32,32,0,0,0,434.8,64H348.91a32,32,0,0,0-21.61,8.41l-88.12,80.68-25.69-19.85L289.09,64H205.3a32,32,0,0,0-22.6,9.41l-20.34,20.3L45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.54,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45L303.4,202.72l32.69-29.92,27-24.7a16,16,0,0,1,21.61,23.61ZM16,128A16.05,16.05,0,0,0,0,144V335.91a16,16,0,0,0,16,16H146.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L23.56,128Z"
        ],
        "handshake-slash": [
            640,
            512,
            [],
            "e060",
            "M0,128.21V384H64a32,32,0,0,0,32-32V184L23.83,128.21ZM48,320.1a16,16,0,1,1-16,16A16,16,0,0,1,48,320.1Zm80,31.81h18.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L128,208.72Zm416-223.7V352.1a32,32,0,0,0,32,32h64V128.21ZM592,352.1a16,16,0,1,1,16-16A16,16,0,0,1,592,352.1ZM303.33,202.67l59.58-54.57a16,16,0,0,1,21.59,23.61L358.41,195.6,504,313.8a73.08,73.08,0,0,1,7.91,7.7V128L457.3,73.41A31.76,31.76,0,0,0,434.7,64H348.8a31.93,31.93,0,0,0-21.6,8.41l-88.07,80.64-25.64-19.81L289.09,64H205.3a32,32,0,0,0-22.6,9.41L162.36,93.72,45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.65-25.27a16,16,0,0,0-2.82-22.45Z"
        ],
        hanukiah: [
            640,
            512,
            [],
            "f6e6",
            "M232 160c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm-64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm224 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm88 8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v120h32V168zm-440-8c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm520 0h-32c-8.84 0-16 7.16-16 16v112c0 17.67-14.33 32-32 32H352V128c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v192H96c-17.67 0-32-14.33-32-32V176c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v112c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V176c0-8.84-7.16-16-16-16zm-16-32c13.25 0 24-11.94 24-26.67S608 48 608 48s-24 38.61-24 53.33S594.75 128 608 128zm-576 0c13.25 0 24-11.94 24-26.67S32 48 32 48 8 86.61 8 101.33 18.75 128 32 128zm288-48c13.25 0 24-11.94 24-26.67S320 0 320 0s-24 38.61-24 53.33S306.75 80 320 80zm-208 48c13.25 0 24-11.94 24-26.67S112 48 112 48s-24 38.61-24 53.33S98.75 128 112 128zm64 0c13.25 0 24-11.94 24-26.67S176 48 176 48s-24 38.61-24 53.33S162.75 128 176 128zm64 0c13.25 0 24-11.94 24-26.67S240 48 240 48s-24 38.61-24 53.33S226.75 128 240 128zm160 0c13.25 0 24-11.94 24-26.67S400 48 400 48s-24 38.61-24 53.33S386.75 128 400 128zm64 0c13.25 0 24-11.94 24-26.67S464 48 464 48s-24 38.61-24 53.33S450.75 128 464 128zm64 0c13.25 0 24-11.94 24-26.67S528 48 528 48s-24 38.61-24 53.33S514.75 128 528 128z"
        ],
        "hard-hat": [
            512,
            512,
            [],
            "f807",
            "M480 288c0-80.25-49.28-148.92-119.19-177.62L320 192V80a16 16 0 0 0-16-16h-96a16 16 0 0 0-16 16v112l-40.81-81.62C81.28 139.08 32 207.75 32 288v64h448zm16 96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
        ],
        hashtag: [
            448,
            512,
            [],
            "f292",
            "M440.667 182.109l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l14.623-81.891C377.123 38.754 371.468 32 363.997 32h-40.632a12 12 0 0 0-11.813 9.891L296.175 128H197.54l14.623-81.891C213.477 38.754 207.822 32 200.35 32h-40.632a12 12 0 0 0-11.813 9.891L132.528 128H53.432a12 12 0 0 0-11.813 9.891l-7.143 40C33.163 185.246 38.818 192 46.289 192h74.81L98.242 320H19.146a12 12 0 0 0-11.813 9.891l-7.143 40C-1.123 377.246 4.532 384 12.003 384h74.81L72.19 465.891C70.877 473.246 76.532 480 84.003 480h40.632a12 12 0 0 0 11.813-9.891L151.826 384h98.634l-14.623 81.891C234.523 473.246 240.178 480 247.65 480h40.632a12 12 0 0 0 11.813-9.891L315.472 384h79.096a12 12 0 0 0 11.813-9.891l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l22.857-128h79.096a12 12 0 0 0 11.813-9.891zM261.889 320h-98.634l22.857-128h98.634l-22.857 128z"
        ],
        "hat-cowboy": [
            640,
            512,
            [],
            "f8c0",
            "M490 296.9C480.51 239.51 450.51 64 392.3 64c-14 0-26.49 5.93-37 14a58.21 58.21 0 0 1-70.58 0c-10.51-8-23-14-37-14-58.2 0-88.2 175.47-97.71 232.88C188.81 309.47 243.73 320 320 320s131.23-10.51 170-23.1zm142.9-37.18a16 16 0 0 0-19.75 1.5c-1 .9-101.27 90.78-293.16 90.78-190.82 0-292.22-89.94-293.24-90.84A16 16 0 0 0 1 278.53C1.73 280.55 78.32 480 320 480s318.27-199.45 319-201.47a16 16 0 0 0-6.09-18.81z"
        ],
        "hat-cowboy-side": [
            640,
            512,
            [],
            "f8c1",
            "M260.8 291.06c-28.63-22.94-62-35.06-96.4-35.06C87 256 21.47 318.72 1.43 412.06c-3.55 16.6-.43 33.83 8.57 47.3C18.75 472.47 31.83 480 45.88 480H592c-103.21 0-155-37.07-233.19-104.46zm234.65-18.29L468.4 116.2A64 64 0 0 0 392 64.41L200.85 105a64 64 0 0 0-50.35 55.79L143.61 226c6.9-.83 13.7-2 20.79-2 41.79 0 82 14.55 117.29 42.82l98 84.48C450.76 412.54 494.9 448 592 448a48 48 0 0 0 48-48c0-25.39-29.6-119.33-144.55-127.23z"
        ],
        "hat-wizard": [
            512,
            512,
            [],
            "f6e8",
            "M496 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-304-64l-64-32 64-32 32-64 32 64 64 32-64 32-16 32h208l-86.41-201.63a63.955 63.955 0 0 1-1.89-45.45L416 0 228.42 107.19a127.989 127.989 0 0 0-53.46 59.15L64 416h144l-16-32zm64-224l16-32 16 32 32 16-32 16-16 32-16-32-32-16 32-16z"
        ],
        hdd: [
            576,
            512,
            [],
            "f0a0",
            "M576 304v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48zm-48-80a79.557 79.557 0 0 1 30.777 6.165L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L17.223 230.165A79.557 79.557 0 0 1 48 224h480zm-48 96c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm-96 0c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
        ],
        "head-side-cough": [
            640,
            512,
            [],
            "e061",
            "M616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304ZM552,416a24,24,0,1,0,24,24A24,24,0,0,0,552,416Zm-64-56a24,24,0,1,0,24,24A24,24,0,0,0,488,360ZM616,464a24,24,0,1,0,24,24A24,24,0,0,0,616,464Zm0-104a24,24,0,1,0,24,24A24,24,0,0,0,616,360Zm-64-40a24,24,0,1,0,24,24A24,24,0,0,0,552,320Zm-74.78-45c-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192C86,0,0,86,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320a32,32,0,0,1,0-64h96V320h32A32,32,0,0,0,477.22,275ZM288,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,288,224Z"
        ],
        "head-side-cough-slash": [
            640,
            512,
            [],
            "e062",
            "M454.11,319.21c19.56-3.81,31.62-25,23.11-44.21-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192A190.64,190.64,0,0,0,84.18,33.3L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM313.39,210.45,263.61,172c5.88-7.14,14.43-12,24.36-12a32.06,32.06,0,0,1,32,32C320,199,317.24,205.17,313.39,210.45ZM616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304Zm-64,64a24,24,0,1,0-24-24A24,24,0,0,0,552,368ZM288,384a32,32,0,0,1,32-32h19.54L20.73,105.59A190.86,190.86,0,0,0,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320A32,32,0,0,1,288,384Zm328-24a24,24,0,1,0,24,24A24,24,0,0,0,616,360Z"
        ],
        "head-side-mask": [
            512,
            512,
            [],
            "e063",
            "M.15,184.42C-2.17,244.21,23,298.06,64,334.88V512H224V316.51L3.67,156.25A182.28,182.28,0,0,0,.15,184.42ZM509.22,275c-21-47.12-48.5-151.75-73.12-186.75A208.11,208.11,0,0,0,266.11,0H200C117,0,42.48,50.57,13.25,123.65L239.21,288H511.76A31.35,31.35,0,0,0,509.22,275ZM320,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,320,224Zm16,144H496l16-48H256V512H401.88a64,64,0,0,0,60.71-43.76L464,464H336a16,16,0,0,1,0-32H474.67l10.67-32H336a16,16,0,0,1,0-32Z"
        ],
        "head-side-virus": [
            512,
            512,
            [],
            "e064",
            "M272,240a16,16,0,1,0,16,16A16,16,0,0,0,272,240Zm-64-64a16,16,0,1,0,16,16A16,16,0,0,0,208,176Zm301.2,99c-20.93-47.12-48.43-151.73-73.07-186.75A207.9,207.9,0,0,0,266.09,0H192C86,0,0,86,0,192A191.23,191.23,0,0,0,64,334.81V512H320V448h64a64,64,0,0,0,64-64V320H480A32,32,0,0,0,509.2,275ZM368,240H355.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C290.47,297.09,256,311.37,256,339.88V352a16,16,0,0,1-32,0V339.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H112a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V96a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C313.09,173.53,327.37,208,355.88,208H368a16,16,0,0,1,0,32Z"
        ],
        heading: [
            512,
            512,
            [],
            "f1dc",
            "M448 96v320h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H320a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V288H160v128h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V96H32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32v128h192V96h-32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16z"
        ],
        headphones: [
            512,
            512,
            [],
            "f025",
            "M256 32C114.52 32 0 146.496 0 288v48a32 32 0 0 0 17.689 28.622l14.383 7.191C34.083 431.903 83.421 480 144 480h24c13.255 0 24-10.745 24-24V280c0-13.255-10.745-24-24-24h-24c-31.342 0-59.671 12.879-80 33.627V288c0-105.869 86.131-192 192-192s192 86.131 192 192v1.627C427.671 268.879 399.342 256 368 256h-24c-13.255 0-24 10.745-24 24v176c0 13.255 10.745 24 24 24h24c60.579 0 109.917-48.098 111.928-108.187l14.382-7.191A32 32 0 0 0 512 336v-48c0-141.479-114.496-256-256-256z"
        ],
        "headphones-alt": [
            512,
            512,
            [],
            "f58f",
            "M160 288h-16c-35.35 0-64 28.7-64 64.12v63.76c0 35.41 28.65 64.12 64 64.12h16c17.67 0 32-14.36 32-32.06V320.06c0-17.71-14.33-32.06-32-32.06zm208 0h-16c-17.67 0-32 14.35-32 32.06v127.88c0 17.7 14.33 32.06 32 32.06h16c35.35 0 64-28.71 64-64.12v-63.76c0-35.41-28.65-64.12-64-64.12zM256 32C112.91 32 4.57 151.13 0 288v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288c0-114.67 93.33-207.8 208-207.82 114.67.02 208 93.15 208 207.82v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288C507.43 151.13 399.09 32 256 32z"
        ],
        headset: [
            512,
            512,
            [],
            "f590",
            "M192 208c0-17.67-14.33-32-32-32h-16c-35.35 0-64 28.65-64 64v48c0 35.35 28.65 64 64 64h16c17.67 0 32-14.33 32-32V208zm176 144c35.35 0 64-28.65 64-64v-48c0-35.35-28.65-64-64-64h-16c-17.67 0-32 14.33-32 32v112c0 17.67 14.33 32 32 32h16zM256 0C113.18 0 4.58 118.83 0 256v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-114.69 93.31-208 208-208s208 93.31 208 208h-.12c.08 2.43.12 165.72.12 165.72 0 23.35-18.93 42.28-42.28 42.28H320c0-26.51-21.49-48-48-48h-32c-26.51 0-48 21.49-48 48s21.49 48 48 48h181.72c49.86 0 90.28-40.42 90.28-90.28V256C507.42 118.83 398.82 0 256 0z"
        ],
        heart: [
            512,
            512,
            [],
            "f004",
            "M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"
        ],
        "heart-broken": [
            512,
            512,
            [],
            "f7a9",
            "M473.7 73.8l-2.4-2.5c-46-47-118-51.7-169.6-14.8L336 159.9l-96 64 48 128-144-144 96-64-28.6-86.5C159.7 19.6 87 24 40.7 71.4l-2.4 2.4C-10.4 123.6-12.5 202.9 31 256l212.1 218.6c7.1 7.3 18.6 7.3 25.7 0L481 255.9c43.5-53 41.4-132.3-7.3-182.1z"
        ],
        heartbeat: [
            512,
            512,
            [],
            "f21e",
            "M320.2 243.8l-49.7 99.4c-6 12.1-23.4 11.7-28.9-.6l-56.9-126.3-30 71.7H60.6l182.5 186.5c7.1 7.3 18.6 7.3 25.7 0L451.4 288H342.3l-22.1-44.2zM473.7 73.9l-2.4-2.5c-51.5-52.6-135.8-52.6-187.4 0L256 100l-27.9-28.5c-51.5-52.7-135.9-52.7-187.4 0l-2.4 2.4C-10.4 123.7-12.5 203 31 256h102.4l35.9-86.2c5.4-12.9 23.6-13.2 29.4-.4l58.2 129.3 49-97.9c5.9-11.8 22.7-11.8 28.6 0l27.6 55.2H481c43.5-53 41.4-132.3-7.3-182.1z"
        ],
        helicopter: [
            640,
            512,
            [],
            "f533",
            "M304 384h272c17.67 0 32-14.33 32-32 0-123.71-100.29-224-224-224V64h176c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H144c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h176v64H112L68.8 70.4C65.78 66.37 61.03 64 56 64H16.01C5.6 64-2.04 73.78.49 83.88L32 192l160 64 86.4 115.2A31.992 31.992 0 0 0 304 384zm112-188.49C478.55 208.3 528.03 257.44 540.79 320H416V195.51zm219.37 263.3l-22.15-22.2c-6.25-6.26-16.24-6.1-22.64.01-7.09 6.77-13.84 11.25-24.64 11.25H240c-8.84 0-16 7.18-16 16.03v32.06c0 8.85 7.16 16.03 16 16.03h325.94c14.88 0 35.3-.47 68.45-29.52 7.02-6.14 7.57-17.05.98-23.66z"
        ],
        highlighter: [
            544,
            512,
            [],
            "f591",
            "M0 479.98L99.92 512l35.45-35.45-67.04-67.04L0 479.98zm124.61-240.01a36.592 36.592 0 0 0-10.79 38.1l13.05 42.83-50.93 50.94 96.23 96.23 50.86-50.86 42.74 13.08c13.73 4.2 28.65-.01 38.15-10.78l35.55-41.64-173.34-173.34-41.52 35.44zm403.31-160.7l-63.2-63.2c-20.49-20.49-53.38-21.52-75.12-2.35L190.55 183.68l169.77 169.78L530.27 154.4c19.18-21.74 18.15-54.63-2.35-75.13z"
        ],
        hiking: [
            384,
            512,
            [],
            "f6ec",
            "M80.95 472.23c-4.28 17.16 6.14 34.53 23.28 38.81 2.61.66 5.22.95 7.8.95 14.33 0 27.37-9.7 31.02-24.23l25.24-100.97-52.78-52.78-34.56 138.22zm14.89-196.12L137 117c2.19-8.42-3.14-16.95-11.92-19.06-43.88-10.52-88.35 15.07-99.32 57.17L.49 253.24c-2.19 8.42 3.14 16.95 11.92 19.06l63.56 15.25c8.79 2.1 17.68-3.02 19.87-11.44zM368 160h-16c-8.84 0-16 7.16-16 16v16h-34.75l-46.78-46.78C243.38 134.11 228.61 128 212.91 128c-27.02 0-50.47 18.3-57.03 44.52l-26.92 107.72a32.012 32.012 0 0 0 8.42 30.39L224 397.25V480c0 17.67 14.33 32 32 32s32-14.33 32-32v-82.75c0-17.09-6.66-33.16-18.75-45.25l-46.82-46.82c.15-.5.49-.89.62-1.41l19.89-79.57 22.43 22.43c6 6 14.14 9.38 22.62 9.38h48v240c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V176c.01-8.84-7.15-16-15.99-16zM240 96c26.51 0 48-21.49 48-48S266.51 0 240 0s-48 21.49-48 48 21.49 48 48 48z"
        ],
        hippo: [
            640,
            512,
            [],
            "f6ed",
            "M581.12 96.2c-27.67-.15-52.5 17.58-76.6 26.62C489.98 88.27 455.83 64 416 64c-11.28 0-21.95 2.3-32 5.88V56c0-13.26-10.75-24-24-24h-16c-13.25 0-24 10.74-24 24v48.98C286.01 79.58 241.24 64 192 64 85.96 64 0 135.64 0 224v240c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16v-70.79C128.35 407.57 166.72 416 208 416s79.65-8.43 112-22.79V464c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V288h128v32c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-32c17.67 0 32-14.33 32-32v-92.02c0-34.09-24.79-67.59-58.88-67.78zM448 176c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
        ],
        history: [
            512,
            512,
            [],
            "f1da",
            "M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z"
        ],
        "hockey-puck": [
            512,
            512,
            [],
            "f453",
            "M0 160c0-53 114.6-96 256-96s256 43 256 96-114.6 96-256 96S0 213 0 160zm0 82.2V352c0 53 114.6 96 256 96s256-43 256-96V242.2c-113.4 82.3-398.5 82.4-512 0z"
        ],
        "holly-berry": [
            448,
            512,
            [],
            "f7aa",
            "M144 192c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm112-48c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zm-32-48c26.5 0 48-21.5 48-48S250.5 0 224 0s-48 21.5-48 48 21.5 48 48 48zm-16.2 139.1c.1-12.4-13.1-20.1-23.8-13.7-34.3 20.3-71.4 32.7-108.7 36.2-9.7.9-15.6 11.3-11.6 20.2 6.2 13.9 11.1 28.6 14.7 43.8 3.6 15.2-5.3 30.6-20.2 35.1-14.9 4.5-30.1 7.6-45.3 9.1-9.7 1-15.7 11.3-11.7 20.2 15 32.8 22.9 69.5 23 107.7.1 14.4 15.2 23.1 27.6 16 33.2-19 68.9-30.5 104.8-33.9 9.7-.9 15.6-11.3 11.6-20.2-6.2-13.9-11.1-28.6-14.7-43.8-3.6-15.2 5.3-30.6 20.2-35.1 14.9-4.5 30.1-7.6 45.3-9.1 9.7-1 15.7-11.3 11.7-20.2-15.5-34.2-23.3-72.5-22.9-112.3zM435 365.6c-15.2-1.6-30.3-4.7-45.3-9.1-14.9-4.5-23.8-19.9-20.2-35.1 3.6-15.2 8.5-29.8 14.7-43.8 4-8.9-1.9-19.3-11.6-20.2-37.3-3.5-74.4-15.9-108.7-36.2-10.7-6.3-23.9 1.4-23.8 13.7 0 1.6-.2 3.2-.2 4.9.2 33.3 7 65.7 19.9 94 5.7 12.4 5.2 26.6-.6 38.9 4.9 1.2 9.9 2.2 14.8 3.7 14.9 4.5 23.8 19.9 20.2 35.1-3.6 15.2-8.5 29.8-14.7 43.8-4 8.9 1.9 19.3 11.6 20.2 35.9 3.4 71.6 14.9 104.8 33.9 12.5 7.1 27.6-1.6 27.6-16 .2-38.2 8-75 23-107.7 4.3-8.7-1.8-19.1-11.5-20.1z"
        ],
        home: [
            576,
            512,
            [],
            "f015",
            "M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"
        ],
        horse: [
            576,
            512,
            [],
            "f6f0",
            "M575.92 76.6c-.01-8.13-3.02-15.87-8.58-21.8-3.78-4.03-8.58-9.12-13.69-14.5 11.06-6.84 19.5-17.49 22.18-30.66C576.85 4.68 572.96 0 567.9 0H447.92c-70.69 0-128 57.31-128 128H160c-28.84 0-54.4 12.98-72 33.11V160c-48.53 0-88 39.47-88 88v56c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56c0-13.22 6.87-24.39 16.78-31.68-.21 2.58-.78 5.05-.78 7.68 0 27.64 11.84 52.36 30.54 69.88l-25.72 68.6a63.945 63.945 0 0 0-2.16 37.99l24.85 99.41A15.982 15.982 0 0 0 107.02 512h65.96c10.41 0 18.05-9.78 15.52-19.88l-26.31-105.26 23.84-63.59L320 345.6V496c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V318.22c19.74-20.19 32-47.75 32-78.22 0-.22-.07-.42-.08-.64V136.89l16 7.11 18.9 37.7c7.45 14.87 25.05 21.55 40.49 15.37l32.55-13.02a31.997 31.997 0 0 0 20.12-29.74l-.06-77.71zm-64 19.4c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
        ],
        "horse-head": [
            512,
            512,
            [],
            "f7ab",
            "M509.8 332.5l-69.9-164.3c-14.9-41.2-50.4-71-93-79.2 18-10.6 46.3-35.9 34.2-82.3-1.3-5-7.1-7.9-12-6.1L166.9 76.3C35.9 123.4 0 238.9 0 398.8V480c0 17.7 14.3 32 32 32h236.2c23.8 0 39.3-25 28.6-46.3L256 384v-.7c-45.6-3.5-84.6-30.7-104.3-69.6-1.6-3.1-.9-6.9 1.6-9.3l12.1-12.1c3.9-3.9 10.6-2.7 12.9 2.4 14.8 33.7 48.2 57.4 87.4 57.4 17.2 0 33-5.1 46.8-13.2l46 63.9c6 8.4 15.7 13.3 26 13.3h50.3c8.5 0 16.6-3.4 22.6-9.4l45.3-39.8c8.9-9.1 11.7-22.6 7.1-34.4zM328 224c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"
        ],
        hospital: [
            448,
            512,
            [],
            "f0f8",
            "M448 492v20H0v-20c0-6.627 5.373-12 12-12h20V120c0-13.255 10.745-24 24-24h88V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v72h88c13.255 0 24 10.745 24 24v360h20c6.627 0 12 5.373 12 12zM308 192h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-168 64h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm104 128h-40c-6.627 0-12 5.373-12 12v84h64v-84c0-6.627-5.373-12-12-12zm64-96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-116 12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40zM182 96h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6z"
        ],
        "hospital-alt": [
            576,
            512,
            [],
            "f47d",
            "M544 96H416V32c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32v368c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16V128c0-17.7-14.3-32-32-32zM160 436c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm160 128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm16-170c0 3.3-2.7 6-6 6h-26v26c0 3.3-2.7 6-6 6h-20c-3.3 0-6-2.7-6-6v-26h-26c-3.3 0-6-2.7-6-6v-20c0-3.3 2.7-6 6-6h26V86c0-3.3 2.7-6 6-6h20c3.3 0 6 2.7 6 6v26h26c3.3 0 6 2.7 6 6v20zm144 298c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
        ],
        "hospital-symbol": [
            512,
            512,
            [],
            "f47e",
            "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm112 376c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-88h-96v88c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v88h96v-88c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v240z"
        ],
        "hospital-user": [
            640,
            512,
            [],
            "f80d",
            "M480 320a96 96 0 1 0-96-96 96 96 0 0 0 96 96zm48 32a22.88 22.88 0 0 0-7.06 1.09 124.76 124.76 0 0 1-81.89 0A22.82 22.82 0 0 0 432 352a112 112 0 0 0-112 112.62c.14 26.26 21.73 47.38 48 47.38h224c26.27 0 47.86-21.12 48-47.38A112 112 0 0 0 528 352zm-198.09 10.45A145.19 145.19 0 0 1 352 344.62V128a32 32 0 0 0-32-32h-32V32a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v64H32a32 32 0 0 0-32 32v368a16 16 0 0 0 16 16h288.31A78.62 78.62 0 0 1 288 464.79a143.06 143.06 0 0 1 41.91-102.34zM144 404a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm48-122a6 6 0 0 1-6 6h-20a6 6 0 0 1-6-6v-26h-26a6 6 0 0 1-6-6v-20a6 6 0 0 1 6-6h26V70a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v26h26a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6h-26zm80 250a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12z"
        ],
        "hot-tub": [
            512,
            512,
            [],
            "f593",
            "M414.21 177.65c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C378.96 6.14 372.22 0 364.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zm-108 0c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C270.96 6.14 264.22 0 256.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zM480 256H256l-110.93-83.2a63.99 63.99 0 0 0-38.4-12.8H64c-35.35 0-64 28.65-64 64v224c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V288c0-17.67-14.33-32-32-32zM128 440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zM64 128c35.35 0 64-28.65 64-64S99.35 0 64 0 0 28.65 0 64s28.65 64 64 64z"
        ],
        hotdog: [
            512,
            512,
            [],
            "f80f",
            "M488.56 23.44a80 80 0 0 0-113.12 0l-352 352a80 80 0 1 0 113.12 113.12l352-352a80 80 0 0 0 0-113.12zm-49.93 95.19c-19.6 19.59-37.52 22.67-51.93 25.14C373.76 146 364.4 147.6 352 160s-14 21.76-16.23 34.71c-2.48 14.4-5.55 32.33-25.15 51.92s-37.52 22.67-51.92 25.15C245.75 274 236.4 275.6 224 288s-14 21.75-16.23 34.7c-2.47 14.4-5.54 32.33-25.14 51.92s-37.53 22.68-51.93 25.15C117.76 402 108.4 403.6 96 416a16 16 0 0 1-22.63-22.63c19.6-19.59 37.52-22.67 51.92-25.14 13-2.22 22.3-3.82 34.71-16.23s14-21.75 16.22-34.7c2.48-14.4 5.55-32.33 25.15-51.92s37.52-22.67 51.92-25.14c13-2.22 22.3-3.83 34.7-16.23s14-21.76 16.24-34.71c2.47-14.4 5.54-32.33 25.14-51.92s37.52-22.68 51.92-25.15C394.24 110 403.59 108.41 416 96a16 16 0 0 1 22.63 22.63zM31.44 322.18L322.18 31.44l-11.54-11.55c-25-25-63.85-26.66-86.79-3.72L16.17 223.85c-22.94 22.94-21.27 61.79 3.72 86.78zm449.12-132.36L189.82 480.56l11.54 11.55c25 25 63.85 26.66 86.79 3.72l207.68-207.68c22.94-22.94 21.27-61.79-3.72-86.79z"
        ],
        hotel: [
            576,
            512,
            [],
            "f594",
            "M560 64c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h15.98v384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h240v-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v80h240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-16V64h16zm-304 44.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm0 96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm-128-96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zM179.2 256h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8zM192 384c0-53.02 42.98-96 96-96s96 42.98 96 96H192zm256-140.8c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-96c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"
        ],
        hourglass: [
            384,
            512,
            [],
            "f254",
            "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64z"
        ],
        "hourglass-end": [
            384,
            512,
            [],
            "f253",
            "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64zM192 208c-57.787 0-104-66.518-104-144h208c0 77.945-46.51 144-104 144z"
        ],
        "hourglass-half": [
            384,
            512,
            [],
            "f252",
            "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-75.078 384H99.08c17.059-46.797 52.096-80 92.92-80 40.821 0 75.862 33.196 92.922 80zm.019-256H99.078C91.988 108.548 88 86.748 88 64h208c0 22.805-3.987 44.587-11.059 64z"
        ],
        "hourglass-start": [
            384,
            512,
            [],
            "f251",
            "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-64 448H88c0-77.458 46.204-144 104-144 57.786 0 104 66.517 104 144z"
        ],
        "house-damage": [
            576,
            512,
            [],
            "f6f1",
            "M288 114.96L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496c0 8.84 7.16 16 16 16h149.23L192 439.19l104.11-64-60.16-119.22L384 392.75l-104.11 64L319.81 512H496c8.84 0 16-7.16 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2L288 114.96zm282.69 121.32L512 184.45V48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v51.69L314.75 10.31C307.12 3.45 297.56.01 288 0s-19.1 3.41-26.7 10.27L5.31 236.28c-6.57 5.91-7.12 16.02-1.21 22.6l21.4 23.82c5.9 6.57 16.02 7.12 22.6 1.21L277.42 81.63c6.05-5.33 15.12-5.33 21.17 0L527.91 283.9c6.57 5.9 16.69 5.36 22.6-1.21l21.4-23.82c5.9-6.57 5.36-16.69-1.22-22.59z"
        ],
        "house-user": [
            576,
            512,
            [],
            "e065",
            "M570.69,236.27,512,184.44V48a16,16,0,0,0-16-16H432a16,16,0,0,0-16,16V99.67L314.78,10.3C308.5,4.61,296.53,0,288,0s-20.46,4.61-26.74,10.3l-256,226A18.27,18.27,0,0,0,0,248.2a18.64,18.64,0,0,0,4.09,10.71L25.5,282.7a21.14,21.14,0,0,0,12,5.3,21.67,21.67,0,0,0,10.69-4.11l15.9-14V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V269.88l15.91,14A21.94,21.94,0,0,0,538.63,288a20.89,20.89,0,0,0,11.87-5.31l21.41-23.81A21.64,21.64,0,0,0,576,248.19,21,21,0,0,0,570.69,236.27ZM288,176a64,64,0,1,1-64,64A64,64,0,0,1,288,176ZM400,448H176a16,16,0,0,1-16-16,96,96,0,0,1,96-96h64a96,96,0,0,1,96,96A16,16,0,0,1,400,448Z"
        ],
        hryvnia: [
            384,
            512,
            [],
            "f6f2",
            "M368 240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-41.86c13.41-28.63 13.74-63.33-4.13-94.05C303.34 49.84 267.1 32 229.96 32h-78.82c-24.32 0-47.86 8.53-66.54 24.09L72.83 65.9c-10.18 8.49-11.56 23.62-3.07 33.8l20.49 24.59c8.49 10.19 23.62 11.56 33.81 3.07l11.73-9.78c4.32-3.6 9.77-5.57 15.39-5.57h83.62c11.69 0 21.2 9.52 21.2 21.2 0 5.91-2.48 11.58-6.81 15.58L219.7 176H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h134.37l-34.67 32H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h41.86c-13.41 28.63-13.74 63.33 4.13 94.05C80.66 462.15 116.9 480 154.04 480h78.82c24.32 0 47.86-8.53 66.54-24.09l11.77-9.81c10.18-8.49 11.56-23.62 3.07-33.8l-20.49-24.59c-8.49-10.19-23.62-11.56-33.81-3.07l-11.75 9.8a23.992 23.992 0 0 1-15.36 5.56H149.2c-11.69 0-21.2-9.52-21.2-21.2 0-5.91 2.48-11.58 6.81-15.58L164.3 336H368c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H233.63l34.67-32H368z"
        ],
        "i-cursor": [
            256,
            512,
            [],
            "f246",
            "M256 52.048V12.065C256 5.496 250.726.148 244.158.066 211.621-.344 166.469.011 128 37.959 90.266.736 46.979-.114 11.913.114 5.318.157 0 5.519 0 12.114v39.645c0 6.687 5.458 12.078 12.145 11.998C38.111 63.447 96 67.243 96 112.182V224H60c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h36v112c0 44.932-56.075 48.031-83.95 47.959C5.404 447.942 0 453.306 0 459.952v39.983c0 6.569 5.274 11.917 11.842 11.999 32.537.409 77.689.054 116.158-37.894 37.734 37.223 81.021 38.073 116.087 37.845 6.595-.043 11.913-5.405 11.913-12V460.24c0-6.687-5.458-12.078-12.145-11.998C217.889 448.553 160 444.939 160 400V288h36c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-36V112.182c0-44.932 56.075-48.213 83.95-48.142 6.646.018 12.05-5.346 12.05-11.992z"
        ],
        "ice-cream": [
            448,
            512,
            [],
            "f810",
            "M368 160h-.94a144 144 0 1 0-286.12 0H80a48 48 0 0 0 0 96h288a48 48 0 0 0 0-96zM195.38 493.69a31.52 31.52 0 0 0 57.24 0L352 288H96z"
        ],
        icicles: [
            512,
            512,
            [],
            "f7ad",
            "M511.4 37.9C515.1 18.2 500 0 480 0H32C10.6 0-4.8 20.7 1.4 41.2l87.1 273.4c2.5 7.2 12.7 7.2 15.1 0L140 190.5l44.2 187.3c1.9 8.3 13.7 8.3 15.6 0l46.5-196.9 34.1 133.4c2.3 7.6 13 7.6 15.3 0l45.8-172.5 66.7 363.8c1.7 8.6 14 8.6 15.7 0l87.5-467.7z"
        ],
        icons: [
            512,
            512,
            [],
            "f86d",
            "M116.65 219.35a15.68 15.68 0 0 0 22.65 0l96.75-99.83c28.15-29 26.5-77.1-4.91-103.88C203.75-7.7 163-3.5 137.86 22.44L128 32.58l-9.85-10.14C93.05-3.5 52.25-7.7 24.86 15.64c-31.41 26.78-33 74.85-5 103.88zm143.92 100.49h-48l-7.08-14.24a27.39 27.39 0 0 0-25.66-17.78h-71.71a27.39 27.39 0 0 0-25.66 17.78l-7 14.24h-48A27.45 27.45 0 0 0 0 347.3v137.25A27.44 27.44 0 0 0 27.43 512h233.14A27.45 27.45 0 0 0 288 484.55V347.3a27.45 27.45 0 0 0-27.43-27.46zM144 468a52 52 0 1 1 52-52 52 52 0 0 1-52 52zm355.4-115.9h-60.58l22.36-50.75c2.1-6.65-3.93-13.21-12.18-13.21h-75.59c-6.3 0-11.66 3.9-12.5 9.1l-16.8 106.93c-1 6.3 4.88 11.89 12.5 11.89h62.31l-24.2 83c-1.89 6.65 4.2 12.9 12.23 12.9a13.26 13.26 0 0 0 10.92-5.25l92.4-138.91c4.88-6.91-1.16-15.7-10.87-15.7zM478.08.33L329.51 23.17C314.87 25.42 304 38.92 304 54.83V161.6a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V99.66l112-17.22v47.18a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V32c0-19.48-16-34.42-33.92-31.67z"
        ],
        "id-badge": [
            384,
            512,
            [],
            "f2c1",
            "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM144 32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm48 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 416 80 407.4 80 396.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
        ],
        "id-card": [
            576,
            512,
            [],
            "f2c2",
            "M528 32H48C21.5 32 0 53.5 0 80v16h576V80c0-26.5-21.5-48-48-48zM0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V128H0v304zm352-232c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zM176 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM67.1 396.2C75.5 370.5 99.6 352 128 352h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.9-5.2 19.8-15.6 19.8H82.7c-10.4 0-18.8-10-15.6-19.8z"
        ],
        "id-card-alt": [
            576,
            512,
            [],
            "f47f",
            "M528 64H384v96H192V64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM288 224c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm93.3 224H194.7c-10.4 0-18.8-10-15.6-19.8 8.3-25.6 32.4-44.2 60.9-44.2h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.8-5.2 19.8-15.6 19.8zM352 32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v96h128V32z"
        ],
        igloo: [
            576,
            512,
            [],
            "f7ae",
            "M320 33.9c-10.5-1.2-21.2-1.9-32-1.9-99.8 0-187.8 50.8-239.4 128H320V33.9zM96 192H30.3C11.1 230.6 0 274 0 320h96V192zM352 39.4V160h175.4C487.2 99.9 424.8 55.9 352 39.4zM480 320h96c0-46-11.1-89.4-30.3-128H480v128zm-64 64v96h128c17.7 0 32-14.3 32-32v-96H411.5c2.6 10.3 4.5 20.9 4.5 32zm32-192H128v128h49.8c22.2-38.1 63-64 110.2-64s88 25.9 110.2 64H448V192zM0 448c0 17.7 14.3 32 32 32h128v-96c0-11.1 1.9-21.7 4.5-32H0v96zm288-160c-53 0-96 43-96 96v96h192v-96c0-53-43-96-96-96z"
        ],
        image: [
            512,
            512,
            [],
            "f03e",
            "M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"
        ],
        images: [
            576,
            512,
            [],
            "f302",
            "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v208c0 44.112 35.888 80 80 80h336zm96-80V80c0-26.51-21.49-48-48-48H144c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h384c26.51 0 48-21.49 48-48zM256 128c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-96 144l55.515-55.515c4.686-4.686 12.284-4.686 16.971 0L272 256l135.515-135.515c4.686-4.686 12.284-4.686 16.971 0L512 208v112H160v-48z"
        ],
        inbox: [
            576,
            512,
            [],
            "f01c",
            "M567.938 243.908L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L8.062 243.908A47.994 47.994 0 0 0 0 270.533V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V270.533a47.994 47.994 0 0 0-8.062-26.625zM162.252 128h251.497l85.333 128H376l-32 64H232l-32-64H76.918l85.334-128z"
        ],
        indent: [
            448,
            512,
            [],
            "f03c",
            "M27.31 363.3l96-96a16 16 0 0 0 0-22.62l-96-96C17.27 138.66 0 145.78 0 160v192c0 14.31 17.33 21.3 27.31 11.3zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
        ],
        industry: [
            512,
            512,
            [],
            "f275",
            "M475.115 163.781L336 252.309v-68.28c0-18.916-20.931-30.399-36.885-20.248L160 252.309V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h464c13.255 0 24-10.745 24-24V184.029c0-18.917-20.931-30.399-36.885-20.248z"
        ],
        infinity: [
            640,
            512,
            [],
            "f534",
            "M471.1 96C405 96 353.3 137.3 320 174.6 286.7 137.3 235 96 168.9 96 75.8 96 0 167.8 0 256s75.8 160 168.9 160c66.1 0 117.8-41.3 151.1-78.6 33.3 37.3 85 78.6 151.1 78.6 93.1 0 168.9-71.8 168.9-160S564.2 96 471.1 96zM168.9 320c-40.2 0-72.9-28.7-72.9-64s32.7-64 72.9-64c38.2 0 73.4 36.1 94 64-20.4 27.6-55.9 64-94 64zm302.2 0c-38.2 0-73.4-36.1-94-64 20.4-27.6 55.9-64 94-64 40.2 0 72.9 28.7 72.9 64s-32.7 64-72.9 64z"
        ],
        info: [
            192,
            512,
            [],
            "f129",
            "M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"
        ],
        "info-circle": [
            512,
            512,
            [],
            "f05a",
            "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
        ],
        italic: [
            320,
            512,
            [],
            "f033",
            "M320 48v32a16 16 0 0 1-16 16h-62.76l-80 320H208a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h62.76l80-320H112a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16z"
        ],
        jedi: [
            576,
            512,
            [],
            "f669",
            "M535.95308,352c-42.64069,94.17188-137.64086,160-247.9848,160q-6.39844,0-12.84377-.29688C171.15558,506.9375,81.26481,442.23438,40.01474,352H79.93668L21.3272,293.40625a264.82522,264.82522,0,0,1-5.10938-39.42187,273.6653,273.6653,0,0,1,.5-29.98438H63.93665L22.546,182.625A269.79782,269.79782,0,0,1,130.51489,20.54688a16.06393,16.06393,0,0,1,9.28127-3,16.36332,16.36332,0,0,1,13.5,7.25,16.02739,16.02739,0,0,1,1.625,15.09374,138.387,138.387,0,0,0-9.84376,51.26563c0,45.10937,21.04691,86.57813,57.71884,113.73437a16.29989,16.29989,0,0,1,1.20313,25.39063c-26.54692,23.98437-41.17194,56.5-41.17194,91.57813,0,60.03124,42.95319,110.28124,99.89079,121.92187l2.5-65.26563L238.062,397a8.33911,8.33911,0,0,1-10-.75,8.025,8.025,0,0,1-1.39063-9.9375l20.125-33.76562-42.06257-8.73438a7.9898,7.9898,0,0,1,0-15.65625l42.06257-8.71875-20.10941-33.73438a7.99122,7.99122,0,0,1,11.35939-10.71874L268.437,295.64062,279.95265,7.67188a7.97138,7.97138,0,0,1,8-7.67188h.04687a8.02064,8.02064,0,0,1,7.95314,7.70312L307.48394,295.625l30.39068-20.67188a8.08327,8.08327,0,0,1,10,.8125,7.99866,7.99866,0,0,1,1.39062,9.90626L329.12461,319.4375l42.07819,8.73438a7.99373,7.99373,0,0,1,0,15.65624l-42.07819,8.71876,20.1094,33.73437a7.97791,7.97791,0,0,1-1.32812,9.92187A8.25739,8.25739,0,0,1,337.87462,397L310.7027,378.53125l2.5,65.34375c48.48446-9.40625,87.57828-48.15625,97.31267-96.5A123.52652,123.52652,0,0,0,371.9528,230.29688a16.30634,16.30634,0,0,1,1.20313-25.42188c36.65631-27.17188,57.6876-68.60938,57.6876-113.73438a138.01689,138.01689,0,0,0-9.85939-51.3125,15.98132,15.98132,0,0,1,1.60937-15.09374,16.36914,16.36914,0,0,1,13.5-7.23438,16.02453,16.02453,0,0,1,9.25,2.98438A271.26947,271.26947,0,0,1,553.25,182.76562L511.99992,224h46.9532C559.3125,229.76562,560,235.45312,560,241.26562a270.092,270.092,0,0,1-5.125,51.85938L495.98427,352Z"
        ],
        joint: [
            640,
            512,
            [],
            "f595",
            "M444.34 181.1c22.38 15.68 35.66 41.16 35.66 68.59V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-43.24-21.01-83.41-56.34-108.06C463.85 125.02 448 99.34 448 70.31V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v66.4c0 43.69 24.56 81.63 60.34 106.7zM194.97 358.98C126.03 370.07 59.69 394.69 0 432c83.65 52.28 180.3 80 278.94 80h88.57L254.79 380.49c-14.74-17.2-37.45-25.11-59.82-21.51zM553.28 87.09c-5.67-3.8-9.28-9.96-9.28-16.78V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v62.31c0 22.02 10.17 43.41 28.64 55.39C550.79 153.04 576 199.54 576 249.69V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-65.44-32.41-126.19-86.72-162.6zM360.89 352.05c-34.4.06-86.81.15-88.21.17l117.8 137.43A63.987 63.987 0 0 0 439.07 512h88.45L409.57 374.4a63.955 63.955 0 0 0-48.68-22.35zM616 352H432l117.99 137.65A63.987 63.987 0 0 0 598.58 512H616c13.25 0 24-10.75 24-24V376c0-13.26-10.75-24-24-24z"
        ],
        "journal-whills": [
            448,
            512,
            [],
            "f66a",
            "M438.40625,377.59375c-3.20313,12.8125-3.20313,57.60937,0,73.60937Q447.9922,460.78907,448,470.40625v16c0,16-12.79688,25.59375-25.59375,25.59375H96c-54.40625,0-96-41.59375-96-96V96C0,41.59375,41.59375,0,96,0H422.40625C438.40625,0,448,9.59375,448,25.59375v332.8125Q448,372.79688,438.40625,377.59375ZM380.79688,384H96c-16,0-32,12.79688-32,32s12.79688,32,32,32H380.79688ZM128.01562,176.01562c0,.51563.14063.98438.14063,1.5l37.10937,32.46876A7.99954,7.99954,0,0,1,160,224h-.01562a9.17678,9.17678,0,0,1-5.25-1.98438L131.14062,201.375C142.6875,250.95312,186.90625,288,240,288s97.3125-37.04688,108.875-86.625l-23.59375,20.64062a8.02516,8.02516,0,0,1-5.26563,1.96876H320a9.14641,9.14641,0,0,1-6.01562-2.71876A9.26508,9.26508,0,0,1,312,216a9.097,9.097,0,0,1,2.73438-6.01562l37.10937-32.46876c.01563-.53124.15625-1,.15625-1.51562,0-11.04688-2.09375-21.51562-5.06251-31.59375l-21.26562,21.25a8.00467,8.00467,0,0,1-11.32812-11.3125l26.42187-26.40625a111.81517,111.81517,0,0,0-46.35937-49.26562,63.02336,63.02336,0,0,1-14.0625,82.64062A55.83846,55.83846,0,0,1,251.625,254.73438l-1.42188-34.28126,12.67188,8.625a3.967,3.967,0,0,0,2.25.6875,3.98059,3.98059,0,0,0,3.43749-6.03124l-8.53124-14.3125,17.90625-3.71876a4.00647,4.00647,0,0,0,0-7.84374l-17.90625-3.71876,8.53124-14.3125a3.98059,3.98059,0,0,0-3.43749-6.03124,4.726,4.726,0,0,0-2.25.67187L248.6875,184.125,244,71.82812a4.00386,4.00386,0,0,0-8,0l-4.625,110.8125-12-8.15624a4.003,4.003,0,0,0-5.68751,5.35937l8.53126,14.3125L204.3125,197.875a3.99686,3.99686,0,0,0,0,7.82812l17.90625,3.73438-8.53126,14.29688a4.72469,4.72469,0,0,0-.56249,2.04687,4.59547,4.59547,0,0,0,1.25,2.90625,4.01059,4.01059,0,0,0,2.75,1.09375,4.09016,4.09016,0,0,0,2.25-.6875l10.35937-7.04687L228.375,254.76562a55.86414,55.86414,0,0,1-28.71875-93.45312,63.01119,63.01119,0,0,1-14.04688-82.65625,111.93158,111.93158,0,0,0-46.375,49.26563l26.42187,26.42187a7.99917,7.99917,0,0,1-11.3125,11.3125l-21.26563-21.26563C130.09375,154.48438,128,164.95312,128.01562,176.01562Z"
        ],
        kaaba: [
            576,
            512,
            [],
            "f66b",
            "M554.12 83.51L318.36 4.93a95.962 95.962 0 0 0-60.71 0L21.88 83.51A32.006 32.006 0 0 0 0 113.87v49.01l265.02-79.51c15.03-4.5 30.92-4.5 45.98 0l265 79.51v-49.01c0-13.77-8.81-26-21.88-30.36zm-279.9 30.52L0 196.3v228.38c0 15 10.42 27.98 25.06 31.24l242.12 53.8a95.937 95.937 0 0 0 41.65 0l242.12-53.8c14.64-3.25 25.06-16.24 25.06-31.24V196.29l-274.2-82.26c-9.04-2.72-18.59-2.72-27.59 0zM128 230.11c0 3.61-2.41 6.77-5.89 7.72l-80 21.82C37.02 261.03 32 257.2 32 251.93v-16.58c0-3.61 2.41-6.77 5.89-7.72l80-21.82c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm144-39.28c0 3.61-2.41 6.77-5.89 7.72l-96 26.18c-5.09 1.39-10.11-2.44-10.11-7.72v-16.58c0-3.61 2.41-6.77 5.89-7.72l96-26.18c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm176 22.7c0-5.28 5.02-9.11 10.11-7.72l80 21.82c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-80-21.82a7.997 7.997 0 0 1-5.89-7.72v-16.58zm-144-39.27c0-5.28 5.02-9.11 10.11-7.72l96 26.18c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-96-26.18a7.997 7.997 0 0 1-5.89-7.72v-16.58z"
        ],
        key: [
            512,
            512,
            [],
            "f084",
            "M512 176.001C512 273.203 433.202 352 336 352c-11.22 0-22.19-1.062-32.827-3.069l-24.012 27.014A23.999 23.999 0 0 1 261.223 384H224v40c0 13.255-10.745 24-24 24h-40v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-78.059c0-6.365 2.529-12.47 7.029-16.971l161.802-161.802C163.108 213.814 160 195.271 160 176 160 78.798 238.797.001 335.999 0 433.488-.001 512 78.511 512 176.001zM336 128c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z"
        ],
        keyboard: [
            576,
            512,
            [],
            "f11c",
            "M528 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM128 180v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"
        ],
        khanda: [
            512,
            512,
            [],
            "f66d",
            "M415.81 66c-6.37-3.5-14.37-2.33-19.36 3.02a15.974 15.974 0 0 0-1.91 19.52c16.49 26.16 25.2 56.39 25.2 87.41-.19 53.25-26.77 102.69-71.27 132.41l-76.63 53.35v-20.1l44.05-36.09c3.92-4.2 5-10.09 2.81-15.28L310.85 273c33.84-19.26 56.94-55.25 56.94-96.99 0-40.79-22.02-76.13-54.59-95.71l5.22-11.44c2.34-5.53.93-11.83-3.57-16.04L255.86 0l-58.99 52.81c-4.5 4.21-5.9 10.51-3.57 16.04l5.22 11.44c-32.57 19.58-54.59 54.93-54.59 95.72 0 41.75 23.09 77.73 56.94 96.99l-7.85 17.24c-2.19 5.18-1.1 11.07 2.81 15.28l44.05 36.09v19.9l-76.59-53.33C119.02 278.62 92.44 229.19 92.26 176c0-31.08 8.71-61.31 25.2-87.47 3.87-6.16 2.4-13.77-2.59-19.08-5-5.34-13.68-6.2-20.02-2.7C16.32 109.6-22.3 205.3 13.36 295.99c7.07 17.99 17.89 34.38 30.46 49.06l55.97 65.36c4.87 5.69 13.04 7.24 19.65 3.72l79.35-42.23L228 392.23l-47.08 32.78c-1.67-.37-3.23-1.01-5.01-1.01-13.25 0-23.99 10.74-23.99 24 0 13.25 10.74 24 23.99 24 12.1 0 21.69-9.11 23.33-20.76l40.63-28.28v29.95c-9.39 5.57-15.99 15.38-15.99 27.1 0 17.67 14.32 32 31.98 32s31.98-14.33 31.98-32c0-11.71-6.61-21.52-15.99-27.1v-30.15l40.91 28.48C314.41 462.89 324 472 336.09 472c13.25 0 23.99-10.75 23.99-24 0-13.26-10.74-24-23.99-24-1.78 0-3.34.64-5.01 1.01L284 392.23l29.21-20.34 79.35 42.23c6.61 3.52 14.78 1.97 19.65-3.71l52.51-61.31c18.87-22.02 34-47.5 41.25-75.59 21.62-83.66-16.45-167.27-90.16-207.51zm-95.99 110c0 22.3-11.49 41.92-28.83 53.38l-5.65-12.41c-8.75-24.52-8.75-51.04 0-75.56l7.83-17.18c16.07 11.65 26.65 30.45 26.65 51.77zm-127.93 0c0-21.32 10.58-40.12 26.66-51.76l7.83 17.18c8.75 24.52 8.75 51.03 0 75.56l-5.65 12.41c-17.34-11.46-28.84-31.09-28.84-53.39z"
        ],
        kiss: [
            496,
            512,
            [],
            "f596",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm136 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm24-156c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
        ],
        "kiss-beam": [
            496,
            512,
            [],
            "f597",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-39 219.9l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5zM304 396c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm65-168.1l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5z"
        ],
        "kiss-wink-heart": [
            504,
            512,
            [],
            "f598",
            "M501.1 402.5c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zm-177.6-4c-5.6-20.3-2.3-42 9-59.7 29.7-46.3 98.7-45.5 127.8 4.3 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-.3-.7-23.9-84.6-23.9-84.6zM168 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm120 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-5.7-12.3 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.8-3.7-4.6-16.6 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C274.6 368.7 288 383 288 396zm16-179c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S400 181 404 206.2c1.7 11.1-11.3 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 217z"
        ],
        "kiwi-bird": [
            576,
            512,
            [],
            "f535",
            "M575.81 217.98C572.64 157.41 518.28 112 457.63 112h-9.37c-52.82 0-104.25-16.25-147.74-46.24-41.99-28.96-96.04-41.62-153.21-28.7C129.3 41.12-.08 78.24 0 224c.04 70.95 38.68 132.8 95.99 166.01V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-54.26c15.36 3.96 31.4 6.26 48 6.26 5.44 0 10.68-.73 16-1.18V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-59.43c14.24-5.06 27.88-11.39 40.34-19.51C342.07 355.25 393.86 336 448.46 336c25.48 0 16.01-.31 23.05-.78l74.41 136.44c2.86 5.23 8.3 8.34 14.05 8.34 1.31 0 2.64-.16 3.95-.5 7.09-1.8 12.05-8.19 12.05-15.5 0 0 .14-240.24-.16-246.02zM463.97 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm80 153.25l-39.86-73.08c15.12-5.83 28.73-14.6 39.86-25.98v99.06z"
        ],
        landmark: [
            512,
            512,
            [],
            "f66f",
            "M501.62 92.11L267.24 2.04a31.958 31.958 0 0 0-22.47 0L10.38 92.11A16.001 16.001 0 0 0 0 107.09V144c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-36.91c0-6.67-4.14-12.64-10.38-14.98zM64 192v160H48c-8.84 0-16 7.16-16 16v48h448v-48c0-8.84-7.16-16-16-16h-16V192h-64v160h-96V192h-64v160h-96V192H64zm432 256H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
        ],
        language: [
            640,
            512,
            [],
            "f1ab",
            "M152.1 236.2c-3.5-12.1-7.8-33.2-7.8-33.2h-.5s-4.3 21.1-7.8 33.2l-11.1 37.5H163zM616 96H336v320h280c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm-24 120c0 6.6-5.4 12-12 12h-11.4c-6.9 23.6-21.7 47.4-42.7 69.9 8.4 6.4 17.1 12.5 26.1 18 5.5 3.4 7.3 10.5 4.1 16.2l-7.9 13.9c-3.4 5.9-10.9 7.8-16.7 4.3-12.6-7.8-24.5-16.1-35.4-24.9-10.9 8.7-22.7 17.1-35.4 24.9-5.8 3.5-13.3 1.6-16.7-4.3l-7.9-13.9c-3.2-5.6-1.4-12.8 4.2-16.2 9.3-5.7 18-11.7 26.1-18-7.9-8.4-14.9-17-21-25.7-4-5.7-2.2-13.6 3.7-17.1l6.5-3.9 7.3-4.3c5.4-3.2 12.4-1.7 16 3.4 5 7 10.8 14 17.4 20.9 13.5-14.2 23.8-28.9 30-43.2H412c-6.6 0-12-5.4-12-12v-16c0-6.6 5.4-12 12-12h64v-16c0-6.6 5.4-12 12-12h16c6.6 0 12 5.4 12 12v16h64c6.6 0 12 5.4 12 12zM0 120v272c0 13.3 10.7 24 24 24h280V96H24c-13.3 0-24 10.7-24 24zm58.9 216.1L116.4 167c1.7-4.9 6.2-8.1 11.4-8.1h32.5c5.1 0 9.7 3.3 11.4 8.1l57.5 169.1c2.6 7.8-3.1 15.9-11.4 15.9h-22.9a12 12 0 0 1-11.5-8.6l-9.4-31.9h-60.2l-9.1 31.8c-1.5 5.1-6.2 8.7-11.5 8.7H70.3c-8.2 0-14-8.1-11.4-15.9z"
        ],
        laptop: [
            640,
            512,
            [],
            "f109",
            "M624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
        ],
        "laptop-code": [
            640,
            512,
            [],
            "f5fc",
            "M255.03 261.65c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L253.25 192l35.71-35.72c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0l-58.34 58.34c-6.25 6.25-6.25 16.38 0 22.63l58.35 58.34zm96.01-11.3l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l58.34-58.34c6.25-6.25 6.25-16.38 0-22.63l-58.34-58.34c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L386.75 192l-35.71 35.72c-6.25 6.25-6.25 16.38 0 22.63zM624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
        ],
        "laptop-house": [
            640,
            512,
            [],
            "e066",
            "M272,288H208a16,16,0,0,1-16-16V208a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v37.12C299.11,232.24,315,224,332.8,224H469.74l6.65-7.53A16.51,16.51,0,0,0,480,207a16.31,16.31,0,0,0-4.75-10.61L416,144V48a16,16,0,0,0-16-16H368a16,16,0,0,0-16,16V87.3L263.5,8.92C258,4,247.45,0,240.05,0s-17.93,4-23.47,8.92L4.78,196.42A16.15,16.15,0,0,0,0,207a16.4,16.4,0,0,0,3.55,9.39L22.34,237.7A16.22,16.22,0,0,0,33,242.48,16.51,16.51,0,0,0,42.34,239L64,219.88V384a32,32,0,0,0,32,32H272ZM629.33,448H592V288c0-17.67-12.89-32-28.8-32H332.8c-15.91,0-28.8,14.33-28.8,32V448H266.67A10.67,10.67,0,0,0,256,458.67v10.66A42.82,42.82,0,0,0,298.6,512H597.4A42.82,42.82,0,0,0,640,469.33V458.67A10.67,10.67,0,0,0,629.33,448ZM544,448H352V304H544Z"
        ],
        "laptop-medical": [
            640,
            512,
            [],
            "f812",
            "M232 224h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8zM576 48a48.14 48.14 0 0 0-48-48H112a48.14 48.14 0 0 0-48 48v336h512zm-64 272H128V64h384zm112 96H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33-17.47-32.77-32H16a16 16 0 0 0-16 16v16a64.19 64.19 0 0 0 64 64h512a64.19 64.19 0 0 0 64-64v-16a16 16 0 0 0-16-16z"
        ],
        laugh: [
            496,
            512,
            [],
            "f599",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 152c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm88 272h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18-8.9 71-69.5 126-142.9 126z"
        ],
        "laugh-beam": [
            496,
            512,
            [],
            "f59a",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm24 199.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.8 4.1-15.1-4.5zm-160 0c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
        ],
        "laugh-squint": [
            496,
            512,
            [],
            "f59b",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 161.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 180l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
        ],
        "laugh-wink": [
            496,
            512,
            [],
            "f59c",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm20.1 198.1c4-25.2 34.2-42.1 59.9-42.1s55.9 16.9 59.9 42.1c1.7 11.1-11.4 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 217c-8.4 7.4-21.6.3-19.9-10.9zM168 160c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm230.9 146C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
        ],
        "layer-group": [
            512,
            512,
            [],
            "f5fd",
            "M12.41 148.02l232.94 105.67c6.8 3.09 14.49 3.09 21.29 0l232.94-105.67c16.55-7.51 16.55-32.52 0-40.03L266.65 2.31a25.607 25.607 0 0 0-21.29 0L12.41 107.98c-16.55 7.51-16.55 32.53 0 40.04zm487.18 88.28l-58.09-26.33-161.64 73.27c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.51 209.97l-58.1 26.33c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 276.3c16.55-7.5 16.55-32.5 0-40zm0 127.8l-57.87-26.23-161.86 73.37c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.29 337.87 12.41 364.1c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40z"
        ],
        leaf: [
            576,
            512,
            [],
            "f06c",
            "M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"
        ],
        lemon: [
            512,
            512,
            [],
            "f094",
            "M489.038 22.963C465.944-.13 434.648-5.93 413.947 6.129c-58.906 34.312-181.25-53.077-321.073 86.746S40.441 355.041 6.129 413.945c-12.059 20.702-6.26 51.999 16.833 75.093 23.095 23.095 54.392 28.891 75.095 16.832 58.901-34.31 181.246 53.079 321.068-86.743S471.56 156.96 505.871 98.056c12.059-20.702 6.261-51.999-16.833-75.093zM243.881 95.522c-58.189 14.547-133.808 90.155-148.358 148.358-1.817 7.27-8.342 12.124-15.511 12.124-1.284 0-2.59-.156-3.893-.481-8.572-2.144-13.784-10.83-11.642-19.403C81.901 166.427 166.316 81.93 236.119 64.478c8.575-2.143 17.261 3.069 19.403 11.642s-3.069 17.259-11.641 19.402z"
        ],
        "less-than": [
            384,
            512,
            [],
            "f536",
            "M365.46 357.74L147.04 255.89l218.47-101.88c16.02-7.47 22.95-26.51 15.48-42.53l-13.52-29C360 66.46 340.96 59.53 324.94 67L18.48 209.91a32.014 32.014 0 0 0-18.48 29v34.24c0 12.44 7.21 23.75 18.48 29l306.31 142.83c16.06 7.49 35.15.54 42.64-15.52l13.56-29.08c7.49-16.06.54-35.15-15.53-42.64z"
        ],
        "less-than-equal": [
            448,
            512,
            [],
            "f537",
            "M54.98 214.2l301.41 119.87c18.39 6.03 38.71-2.54 45.38-19.15l12.09-30.08c6.68-16.61-2.82-34.97-21.21-41l-175.44-68.05 175.56-68.09c18.29-6 27.74-24.27 21.1-40.79l-12.03-29.92c-6.64-16.53-26.86-25.06-45.15-19.06L54.98 137.89C41.21 142.41 32 154.5 32 168.07v15.96c0 13.56 9.21 25.65 22.98 30.17zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
        ],
        "level-down-alt": [
            320,
            512,
            [],
            "f3be",
            "M313.553 392.331L209.587 504.334c-9.485 10.214-25.676 10.229-35.174 0L70.438 392.331C56.232 377.031 67.062 352 88.025 352H152V80H68.024a11.996 11.996 0 0 1-8.485-3.515l-56-56C-4.021 12.926 1.333 0 12.024 0H208c13.255 0 24 10.745 24 24v328h63.966c20.878 0 31.851 24.969 17.587 40.331z"
        ],
        "level-up-alt": [
            320,
            512,
            [],
            "f3bf",
            "M313.553 119.669L209.587 7.666c-9.485-10.214-25.676-10.229-35.174 0L70.438 119.669C56.232 134.969 67.062 160 88.025 160H152v272H68.024a11.996 11.996 0 0 0-8.485 3.515l-56 56C-4.021 499.074 1.333 512 12.024 512H208c13.255 0 24-10.745 24-24V160h63.966c20.878 0 31.851-24.969 17.587-40.331z"
        ],
        "life-ring": [
            512,
            512,
            [],
            "f1cd",
            "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm173.696 119.559l-63.399 63.399c-10.987-18.559-26.67-34.252-45.255-45.255l63.399-63.399a218.396 218.396 0 0 1 45.255 45.255zM256 352c-53.019 0-96-42.981-96-96s42.981-96 96-96 96 42.981 96 96-42.981 96-96 96zM127.559 82.304l63.399 63.399c-18.559 10.987-34.252 26.67-45.255 45.255l-63.399-63.399a218.372 218.372 0 0 1 45.255-45.255zM82.304 384.441l63.399-63.399c10.987 18.559 26.67 34.252 45.255 45.255l-63.399 63.399a218.396 218.396 0 0 1-45.255-45.255zm302.137 45.255l-63.399-63.399c18.559-10.987 34.252-26.67 45.255-45.255l63.399 63.399a218.403 218.403 0 0 1-45.255 45.255z"
        ],
        lightbulb: [
            352,
            512,
            [],
            "f0eb",
            "M96.06 454.35c.01 6.29 1.87 12.45 5.36 17.69l17.09 25.69a31.99 31.99 0 0 0 26.64 14.28h61.71a31.99 31.99 0 0 0 26.64-14.28l17.09-25.69a31.989 31.989 0 0 0 5.36-17.69l.04-38.35H96.01l.05 38.35zM0 176c0 44.37 16.45 84.85 43.56 115.78 16.52 18.85 42.36 58.23 52.21 91.45.04.26.07.52.11.78h160.24c.04-.26.07-.51.11-.78 9.85-33.22 35.69-72.6 52.21-91.45C335.55 260.85 352 220.37 352 176 352 78.61 272.91-.3 175.45 0 73.44.31 0 82.97 0 176zm176-80c-44.11 0-80 35.89-80 80 0 8.84-7.16 16-16 16s-16-7.16-16-16c0-61.76 50.24-112 112-112 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
        ],
        link: [
            512,
            512,
            [],
            "f0c1",
            "M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"
        ],
        "lira-sign": [
            384,
            512,
            [],
            "f195",
            "M371.994 256h-48.019C317.64 256 312 260.912 312 267.246 312 368 230.179 416 144 416V256.781l134.603-29.912A12 12 0 0 0 288 215.155v-40.976c0-7.677-7.109-13.38-14.603-11.714L144 191.219V160.78l134.603-29.912A12 12 0 0 0 288 119.154V78.179c0-7.677-7.109-13.38-14.603-11.714L144 95.219V44c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v68.997L9.397 125.131A12 12 0 0 0 0 136.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 178.558v30.439L9.397 221.131A12 12 0 0 0 0 232.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 274.558V468c0 6.627 5.373 12 12 12h79.583c134.091 0 223.255-77.834 228.408-211.592.261-6.782-5.211-12.408-11.997-12.408z"
        ],
        list: [
            512,
            512,
            [],
            "f03a",
            "M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
        ],
        "list-alt": [
            512,
            512,
            [],
            "f022",
            "M464 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM128 120c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm288-136v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12z"
        ],
        "list-ol": [
            512,
            512,
            [],
            "f0cb",
            "M61.77 401l17.5-20.15a19.92 19.92 0 0 0 5.07-14.19v-3.31C84.34 356 80.5 352 73 352H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h22.83a157.41 157.41 0 0 0-11 12.31l-5.61 7c-4 5.07-5.25 10.13-2.8 14.88l1.05 1.93c3 5.76 6.29 7.88 12.25 7.88h4.73c10.33 0 15.94 2.44 15.94 9.09 0 4.72-4.2 8.22-14.36 8.22a41.54 41.54 0 0 1-15.47-3.12c-6.49-3.88-11.74-3.5-15.6 3.12l-5.59 9.31c-3.72 6.13-3.19 11.72 2.63 15.94 7.71 4.69 20.38 9.44 37 9.44 34.16 0 48.5-22.75 48.5-44.12-.03-14.38-9.12-29.76-28.73-34.88zM496 224H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h64a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H64V40a8 8 0 0 0-8-8H32a8 8 0 0 0-7.14 4.42l-8 16A8 8 0 0 0 24 64h8v64H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm-3.91 160H80a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H41.32c3.29-10.29 48.34-18.68 48.34-56.44 0-29.06-25-39.56-44.47-39.56-21.36 0-33.8 10-40.46 18.75-4.37 5.59-3 10.84 2.8 15.37l8.58 6.88c5.61 4.56 11 2.47 16.12-2.44a13.44 13.44 0 0 1 9.46-3.84c3.33 0 9.28 1.56 9.28 8.75C51 248.19 0 257.31 0 304.59v4C0 316 5.08 320 12.09 320z"
        ],
        "list-ul": [
            512,
            512,
            [],
            "f0ca",
            "M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
        ],
        "location-arrow": [
            512,
            512,
            [],
            "f124",
            "M444.52 3.52L28.74 195.42c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 51.17 70.36 67.17 92.75 19.19l191.9-415.78c15.99-38.39-25.59-79.97-63.97-63.97z"
        ],
        lock: [
            448,
            512,
            [],
            "f023",
            "M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"
        ],
        "lock-open": [
            576,
            512,
            [],
            "f3c1",
            "M423.5 0C339.5.3 272 69.5 272 153.5V224H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-48v-71.1c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-80C576 68 507.5-.3 423.5 0z"
        ],
        "long-arrow-alt-down": [
            256,
            512,
            [],
            "f309",
            "M168 345.941V44c0-6.627-5.373-12-12-12h-56c-6.627 0-12 5.373-12 12v301.941H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.569 9.373 33.941 0l86.059-86.059c15.119-15.119 4.411-40.971-16.971-40.971H168z"
        ],
        "long-arrow-alt-left": [
            448,
            512,
            [],
            "f30a",
            "M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z"
        ],
        "long-arrow-alt-right": [
            448,
            512,
            [],
            "f30b",
            "M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"
        ],
        "long-arrow-alt-up": [
            256,
            512,
            [],
            "f30c",
            "M88 166.059V468c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12V166.059h46.059c21.382 0 32.09-25.851 16.971-40.971l-86.059-86.059c-9.373-9.373-24.569-9.373-33.941 0l-86.059 86.059c-15.119 15.119-4.411 40.971 16.971 40.971H88z"
        ],
        "low-vision": [
            576,
            512,
            [],
            "f2a8",
            "M569.344 231.631C512.96 135.949 407.81 72 288 72c-28.468 0-56.102 3.619-82.451 10.409L152.778 10.24c-7.601-10.858-22.564-13.5-33.423-5.9l-13.114 9.178c-10.86 7.601-13.502 22.566-5.9 33.426l43.131 58.395C89.449 131.73 40.228 174.683 6.682 231.581c-.01.017-.023.033-.034.05-8.765 14.875-8.964 33.528 0 48.739 38.5 65.332 99.742 115.862 172.859 141.349L55.316 244.302A272.194 272.194 0 0 1 83.61 208.39l119.4 170.58h.01l40.63 58.04a330.055 330.055 0 0 0 78.94 1.17l-189.98-271.4a277.628 277.628 0 0 1 38.777-21.563l251.836 356.544c7.601 10.858 22.564 13.499 33.423 5.9l13.114-9.178c10.86-7.601 13.502-22.567 5.9-33.426l-43.12-58.377-.007-.009c57.161-27.978 104.835-72.04 136.81-126.301a47.938 47.938 0 0 0 .001-48.739zM390.026 345.94l-19.066-27.23c24.682-32.567 27.711-76.353 8.8-111.68v.03c0 23.65-19.17 42.82-42.82 42.82-23.828 0-42.82-19.349-42.82-42.82 0-23.65 19.17-42.82 42.82-42.82h.03c-24.75-13.249-53.522-15.643-79.51-7.68l-19.068-27.237C253.758 123.306 270.488 120 288 120c75.162 0 136 60.826 136 136 0 34.504-12.833 65.975-33.974 89.94z"
        ],
        "luggage-cart": [
            640,
            512,
            [],
            "f59d",
            "M224 320h32V96h-32c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32zm352-32V128c0-17.67-14.33-32-32-32h-32v224h32c17.67 0 32-14.33 32-32zm48 96H128V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h48v368c0 8.84 7.16 16 16 16h82.94c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16h197.88c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM480 96V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v272h192V96zm-48 0h-96V48h96v48z"
        ],
        lungs: [
            640,
            512,
            [],
            "f604",
            "M636.11 390.15C614.44 308.85 580.07 231 534.1 159.13 511.98 124.56 498.03 96 454.05 96 415.36 96 384 125.42 384 161.71v60.11l-32.88-21.92a15.996 15.996 0 0 1-7.12-13.31V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v170.59c0 5.35-2.67 10.34-7.12 13.31L256 221.82v-60.11C256 125.42 224.64 96 185.95 96c-43.98 0-57.93 28.56-80.05 63.13C59.93 231 25.56 308.85 3.89 390.15 1.3 399.84 0 409.79 0 419.78c0 61.23 62.48 105.44 125.24 88.62l59.5-15.95c42.18-11.3 71.26-47.47 71.26-88.62v-87.49l-85.84 57.23a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09L320 235.23l167.59 111.72a7.994 7.994 0 0 1 2.22 11.09l-8.88 13.31a7.994 7.994 0 0 1-11.09 2.22L384 316.34v87.49c0 41.15 29.08 77.31 71.26 88.62l59.5 15.95C577.52 525.22 640 481.01 640 419.78c0-9.99-1.3-19.94-3.89-29.63z"
        ],
        "lungs-virus": [
            640,
            512,
            [],
            "e067",
            "M344,150.68V16A16,16,0,0,0,328,0H312a16,16,0,0,0-16,16V150.68a46.45,46.45,0,0,1,48,0ZM195.54,444.46a48.06,48.06,0,0,1,0-67.88l8.58-8.58H192a48,48,0,0,1,0-96h12.12l-8.58-8.57a48,48,0,0,1,60.46-74V161.75C256,125.38,224.62,96,186,96c-44,0-58,28.5-80.12,63.13a819.52,819.52,0,0,0-102,231A113.16,113.16,0,0,0,0,419.75C0,481,62.5,525.26,125.25,508.38l59.5-15.87a98.51,98.51,0,0,0,52.5-34.75,46.49,46.49,0,0,1-41.71-13.3Zm226.29-22.63a16,16,0,0,0,0-22.62l-8.58-8.58C393.09,370.47,407.37,336,435.88,336H448a16,16,0,0,0,0-32H435.88c-28.51,0-42.79-34.47-22.63-54.62l8.58-8.58a16,16,0,0,0-22.63-22.63l-8.57,8.58C370.47,246.91,336,232.63,336,204.12V192a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.58c20.16,20.15,5.88,54.62-22.63,54.62H192a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.58a16,16,0,1,0,22.63,22.62l8.57-8.57C269.53,393.1,304,407.38,304,435.88V448a16,16,0,0,0,32,0V435.88c0-28.5,34.47-42.78,54.63-22.62l8.57,8.57a16,16,0,0,0,22.63,0ZM288,304a16,16,0,1,1,16-16A16,16,0,0,1,288,304Zm64,64a16,16,0,1,1,16-16A16,16,0,0,1,352,368Zm284.12,22.13a819.52,819.52,0,0,0-102-231C512,124.5,498,96,454,96c-38.62,0-70,29.38-70,65.75v27.72a48,48,0,0,1,60.46,74L435.88,272H448a48,48,0,0,1,0,96H435.88l8.58,8.58a47.7,47.7,0,0,1-41.71,81.18,98.51,98.51,0,0,0,52.5,34.75l59.5,15.87C577.5,525.26,640,481,640,419.75A113.16,113.16,0,0,0,636.12,390.13Z"
        ],
        magic: [
            512,
            512,
            [],
            "f0d0",
            "M224 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zM80 160l26.66-53.33L160 80l-53.34-26.67L80 0 53.34 53.33 0 80l53.34 26.67L80 160zm352 128l-26.66 53.33L352 368l53.34 26.67L432 448l26.66-53.33L512 368l-53.34-26.67L432 288zm70.62-193.77L417.77 9.38C411.53 3.12 403.34 0 395.15 0c-8.19 0-16.38 3.12-22.63 9.38L9.38 372.52c-12.5 12.5-12.5 32.76 0 45.25l84.85 84.85c6.25 6.25 14.44 9.37 22.62 9.37 8.19 0 16.38-3.12 22.63-9.37l363.14-363.15c12.5-12.48 12.5-32.75 0-45.24zM359.45 203.46l-50.91-50.91 86.6-86.6 50.91 50.91-86.6 86.6z"
        ],
        magnet: [
            512,
            512,
            [],
            "f076",
            "M164.07 148.1H12a12 12 0 0 1-12-12v-80a36 36 0 0 1 36-36h104a36 36 0 0 1 36 36v80a11.89 11.89 0 0 1-11.93 12zm347.93-12V56a36 36 0 0 0-36-36H372a36 36 0 0 0-36 36v80a12 12 0 0 0 12 12h152a11.89 11.89 0 0 0 12-11.9zm-164 44a12 12 0 0 0-12 12v52c0 128.1-160 127.9-160 0v-52a12 12 0 0 0-12-12H12.1a12 12 0 0 0-12 12.1c.1 21.4.6 40.3 0 53.3 0 150.6 136.17 246.6 256.75 246.6s255-96 255-246.7c-.6-12.8-.2-33 0-53.2a12 12 0 0 0-12-12.1z"
        ],
        "mail-bulk": [
            576,
            512,
            [],
            "f674",
            "M160 448c-25.6 0-51.2-22.4-64-32-64-44.8-83.2-60.8-96-70.4V480c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V345.6c-12.8 9.6-32 25.6-96 70.4-12.8 9.6-38.4 32-64 32zm128-192H32c-17.67 0-32 14.33-32 32v16c25.6 19.2 22.4 19.2 115.2 86.4 9.6 6.4 28.8 25.6 44.8 25.6s35.2-19.2 44.8-22.4c92.8-67.2 89.6-67.2 115.2-86.4V288c0-17.67-14.33-32-32-32zm256-96H224c-17.67 0-32 14.33-32 32v32h96c33.21 0 60.59 25.42 63.71 57.82l.29-.22V416h192c17.67 0 32-14.33 32-32V192c0-17.67-14.33-32-32-32zm-32 128h-64v-64h64v64zm-352-96c0-35.29 28.71-64 64-64h224V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v192h96v-32z"
        ],
        male: [
            192,
            512,
            [],
            "f183",
            "M96 0c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64S60.654 0 96 0m48 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H48c-26.51 0-48 21.49-48 48v136c0 13.255 10.745 24 24 24h16v136c0 13.255 10.745 24 24 24h64c13.255 0 24-10.745 24-24V352h16c13.255 0 24-10.745 24-24V192c0-26.51-21.49-48-48-48z"
        ],
        map: [
            576,
            512,
            [],
            "f279",
            "M0 117.66v346.32c0 11.32 11.43 19.06 21.94 14.86L160 416V32L20.12 87.95A32.006 32.006 0 0 0 0 117.66zM192 416l192 64V96L192 32v384zM554.06 33.16L416 96v384l139.88-55.95A31.996 31.996 0 0 0 576 394.34V48.02c0-11.32-11.43-19.06-21.94-14.86z"
        ],
        "map-marked": [
            576,
            512,
            [],
            "f59f",
            "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"
        ],
        "map-marked-alt": [
            576,
            512,
            [],
            "f5a0",
            "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zm0 168c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"
        ],
        "map-marker": [
            384,
            512,
            [],
            "f041",
            "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z"
        ],
        "map-marker-alt": [
            384,
            512,
            [],
            "f3c5",
            "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"
        ],
        "map-pin": [
            288,
            512,
            [],
            "f276",
            "M112 316.94v156.69l22.02 33.02c4.75 7.12 15.22 7.12 19.97 0L176 473.63V316.94c-10.39 1.92-21.06 3.06-32 3.06s-21.61-1.14-32-3.06zM144 0C64.47 0 0 64.47 0 144s64.47 144 144 144 144-64.47 144-144S223.53 0 144 0zm0 76c-37.5 0-68 30.5-68 68 0 6.62-5.38 12-12 12s-12-5.38-12-12c0-50.73 41.28-92 92-92 6.62 0 12 5.38 12 12s-5.38 12-12 12z"
        ],
        "map-signs": [
            512,
            512,
            [],
            "f277",
            "M507.31 84.69L464 41.37c-6-6-14.14-9.37-22.63-9.37H288V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v16H56c-13.25 0-24 10.75-24 24v80c0 13.25 10.75 24 24 24h385.37c8.49 0 16.62-3.37 22.63-9.37l43.31-43.31c6.25-6.26 6.25-16.38 0-22.63zM224 496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V384h-64v112zm232-272H288v-32h-64v32H70.63c-8.49 0-16.62 3.37-22.63 9.37L4.69 276.69c-6.25 6.25-6.25 16.38 0 22.63L48 342.63c6 6 14.14 9.37 22.63 9.37H456c13.25 0 24-10.75 24-24v-80c0-13.25-10.75-24-24-24z"
        ],
        marker: [
            512,
            512,
            [],
            "f5a1",
            "M93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l75.4-75.4-128.02-128.02-75.4 75.4zM485.49 26.51c-35.35-35.35-92.67-35.35-128.02 0l-21.76 21.76-36.56-36.55c-15.62-15.62-40.95-15.62-56.56 0L138.47 115.84c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0l87.15-87.15 19.59 19.59L191.98 192 320 320.02l165.49-165.49c35.35-35.35 35.35-92.66 0-128.02z"
        ],
        mars: [
            384,
            512,
            [],
            "f222",
            "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c0-6.6-5.4-12-12-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
        ],
        "mars-double": [
            512,
            512,
            [],
            "f227",
            "M340 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C198.5 72.1 172.2 64 144 64 64.5 64 0 128.5 0 208s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.5 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 288c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm356-128.1h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7c-18.2-11.4-39-18.9-61.5-21.3-2.1 21.8-8.2 43.3-18.4 63.3 1.1 0 2.2-.1 3.2-.1 44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80c0-1.1 0-2.2.1-3.2-20 10.2-41.5 16.4-63.3 18.4C168.4 455.6 229.6 512 304 512c79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12v-79c0-6.7-5.4-12.1-12-12.1z"
        ],
        "mars-stroke": [
            384,
            512,
            [],
            "f229",
            "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-17.5 17.5-14.1-14.1c-4.7-4.7-12.3-4.7-17 0L224.5 133c-4.7 4.7-4.7 12.3 0 17l14.1 14.1-18 18c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l18-18 14.1 14.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L329.2 164l17.5-17.5 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c-.1-6.6-5.5-12-12.1-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
        ],
        "mars-stroke-h": [
            480,
            512,
            [],
            "f22b",
            "M476.2 247.5l-55.9-55.9c-7.6-7.6-20.5-2.2-20.5 8.5V224H376v-20c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v20h-27.6c-5.8-25.6-18.7-49.9-38.6-69.8C189.6 98 98.4 98 42.2 154.2c-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 19.9-19.9 32.8-44.2 38.6-69.8H312v20c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-20h23.9v23.9c0 10.7 12.9 16 20.5 8.5l55.9-55.9c4.6-4.7 4.6-12.3-.1-17zm-275.6 65.1c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"
        ],
        "mars-stroke-v": [
            288,
            512,
            [],
            "f22a",
            "M245.8 234.2c-19.9-19.9-44.2-32.8-69.8-38.6v-25.4h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V81.4h23.9c10.7 0 16-12.9 8.5-20.5L152.5 5.1c-4.7-4.7-12.3-4.7-17 0L79.6 61c-7.6 7.6-2.2 20.5 8.5 20.5H112v24.7H92c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h20v25.4c-25.6 5.8-49.9 18.7-69.8 38.6-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 56.3-56.2 56.3-147.4 0-203.6zm-45.2 158.4c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"
        ],
        mask: [
            640,
            512,
            [],
            "f6fa",
            "M320.67 64c-442.6 0-357.57 384-158.46 384 39.9 0 77.47-20.69 101.42-55.86l25.73-37.79c15.66-22.99 46.97-22.99 62.63 0l25.73 37.79C401.66 427.31 439.23 448 479.13 448c189.86 0 290.63-384-158.46-384zM184 308.36c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05zm272 0c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05z"
        ],
        medal: [
            512,
            512,
            [],
            "f5a2",
            "M223.75 130.75L154.62 15.54A31.997 31.997 0 0 0 127.18 0H16.03C3.08 0-4.5 14.57 2.92 25.18l111.27 158.96c29.72-27.77 67.52-46.83 109.56-53.39zM495.97 0H384.82c-11.24 0-21.66 5.9-27.44 15.54l-69.13 115.21c42.04 6.56 79.84 25.62 109.56 53.38L509.08 25.18C516.5 14.57 508.92 0 495.97 0zM256 160c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm92.52 157.26l-37.93 36.96 8.97 52.22c1.6 9.36-8.26 16.51-16.65 12.09L256 393.88l-46.9 24.65c-8.4 4.45-18.25-2.74-16.65-12.09l8.97-52.22-37.93-36.96c-6.82-6.64-3.05-18.23 6.35-19.59l52.43-7.64 23.43-47.52c2.11-4.28 6.19-6.39 10.28-6.39 4.11 0 8.22 2.14 10.33 6.39l23.43 47.52 52.43 7.64c9.4 1.36 13.17 12.95 6.35 19.59z"
        ],
        medkit: [
            512,
            512,
            [],
            "f0fa",
            "M96 480h320V128h-32V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v48H96v352zm96-384h128v32H192V96zm320 80v256c0 26.51-21.49 48-48 48h-16V128h16c26.51 0 48 21.49 48 48zM64 480H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v352zm288-208v32c0 8.837-7.163 16-16 16h-48v48c0 8.837-7.163 16-16 16h-32c-8.837 0-16-7.163-16-16v-48h-48c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h48v-48c0-8.837 7.163-16 16-16h32c8.837 0 16 7.163 16 16v48h48c8.837 0 16 7.163 16 16z"
        ],
        meh: [
            496,
            512,
            [],
            "f11a",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm176 192H152c-21.2 0-21.2-32 0-32h192c21.2 0 21.2 32 0 32zm-16-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
        ],
        "meh-blank": [
            496,
            512,
            [],
            "f5a4",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
        ],
        "meh-rolling-eyes": [
            496,
            512,
            [],
            "f5a5",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 224c0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64s-64-28.7-64-64zm224 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-112c-35.3 0-64-28.7-64-64 0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64z"
        ],
        memory: [
            640,
            512,
            [],
            "f538",
            "M640 130.94V96c0-17.67-14.33-32-32-32H32C14.33 64 0 78.33 0 96v34.94c18.6 6.61 32 24.19 32 45.06s-13.4 38.45-32 45.06V320h640v-98.94c-18.6-6.61-32-24.19-32-45.06s13.4-38.45 32-45.06zM224 256h-64V128h64v128zm128 0h-64V128h64v128zm128 0h-64V128h64v128zM0 448h64v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h64v-96H0v96z"
        ],
        menorah: [
            640,
            512,
            [],
            "f676",
            "M144 128h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm192 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm80-32c17.67 0 32-14.33 32-32S608 0 608 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S512 0 512 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S416 0 416 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S320 0 320 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S224 0 224 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S128 0 128 0 96 46.33 96 64s14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S32 0 32 0 0 46.33 0 64s14.33 32 32 32zm544 192c0 17.67-14.33 32-32 32H352V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v176H96c-17.67 0-32-14.33-32-32V144c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v144c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v144z"
        ],
        mercury: [
            288,
            512,
            [],
            "f223",
            "M288 208c0-44.2-19.9-83.7-51.2-110.1 2.5-1.8 4.9-3.8 7.2-5.8 24.7-21.2 39.8-48.8 43.2-78.8.9-7.1-4.7-13.3-11.9-13.3h-40.5C229 0 224.1 4.1 223 9.8c-2.4 12.5-9.6 24.3-20.7 33.8C187 56.8 166.3 64 144 64s-43-7.2-58.4-20.4C74.5 34.1 67.4 22.3 64.9 9.8 63.8 4.1 58.9 0 53.2 0H12.7C5.5 0-.1 6.2.8 13.3 4.2 43.4 19.2 71 44 92.2c2.3 2 4.7 3.9 7.2 5.8C19.9 124.3 0 163.8 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
        ],
        meteor: [
            512,
            512,
            [],
            "f753",
            "M511.328,20.8027c-11.60759,38.70264-34.30724,111.70173-61.30311,187.70077,6.99893,2.09372,13.4042,4,18.60653,5.59368a16.06158,16.06158,0,0,1,9.49854,22.906c-22.106,42.29635-82.69047,152.795-142.47819,214.40356-.99984,1.09373-1.99969,2.5-2.99954,3.49995A194.83046,194.83046,0,1,1,57.085,179.41009c.99985-1,2.40588-2,3.49947-3,61.59994-59.90549,171.97367-120.40473,214.37343-142.4982a16.058,16.058,0,0,1,22.90274,9.49988c1.59351,5.09368,3.49947,11.5936,5.5929,18.59351C379.34818,35.00565,452.43074,12.30281,491.12794.70921A16.18325,16.18325,0,0,1,511.328,20.8027ZM319.951,320.00207A127.98041,127.98041,0,1,0,191.97061,448.00046,127.97573,127.97573,0,0,0,319.951,320.00207Zm-127.98041-31.9996a31.9951,31.9951,0,1,1-31.9951-31.9996A31.959,31.959,0,0,1,191.97061,288.00247Zm31.9951,79.999a15.99755,15.99755,0,1,1-15.99755-15.9998A16.04975,16.04975,0,0,1,223.96571,368.00147Z"
        ],
        microchip: [
            512,
            512,
            [],
            "f2db",
            "M416 48v416c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h224c26.51 0 48 21.49 48 48zm96 58v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42V88h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zM30 376h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6z"
        ],
        microphone: [
            352,
            512,
            [],
            "f130",
            "M176 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96zm160-160h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16z"
        ],
        "microphone-alt": [
            352,
            512,
            [],
            "f3c9",
            "M336 192h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16zM176 352c53.02 0 96-42.98 96-96h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96z"
        ],
        "microphone-alt-slash": [
            640,
            512,
            [],
            "f539",
            "M633.82 458.1L476.26 336.33C488.74 312.21 496 284.98 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67h-43.67l-41.4-32H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.78c11.71-1.62 23.1-4.28 33.96-8.08l-50.4-38.96c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
        ],
        "microphone-slash": [
            640,
            512,
            [],
            "f131",
            "M633.82 458.1l-157.8-121.96C488.61 312.13 496 285.01 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67V96c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.77c11.66-1.6 22.85-4.54 33.67-8.31l-50.11-38.73c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
        ],
        microscope: [
            512,
            512,
            [],
            "f610",
            "M160 320h12v16c0 8.84 7.16 16 16 16h40c8.84 0 16-7.16 16-16v-16h12c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32V16c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v16c-17.67 0-32 14.33-32 32v224c0 17.67 14.33 32 32 32zm304 128h-1.29C493.24 413.99 512 369.2 512 320c0-105.88-86.12-192-192-192v64c70.58 0 128 57.42 128 128s-57.42 128-128 128H48c-26.51 0-48 21.49-48 48 0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48zm-360-32h208c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8z"
        ],
        minus: [
            448,
            512,
            [],
            "f068",
            "M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
        ],
        "minus-circle": [
            512,
            512,
            [],
            "f056",
            "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z"
        ],
        "minus-square": [
            448,
            512,
            [],
            "f146",
            "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM92 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H92z"
        ],
        mitten: [
            448,
            512,
            [],
            "f7b5",
            "M368 416H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16zm57-209.1c-27.2-22.6-67.5-19-90.1 8.2l-20.9 25-29.6-128.4c-18-77.5-95.4-125.9-172.8-108C34.2 21.6-14.2 98.9 3.7 176.4L51.6 384h309l72.5-87c22.7-27.2 19-67.5-8.1-90.1z"
        ],
        mobile: [
            320,
            512,
            [],
            "f10b",
            "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
        ],
        "mobile-alt": [
            320,
            512,
            [],
            "f3cd",
            "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z"
        ],
        "money-bill": [
            640,
            512,
            [],
            "f0d6",
            "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 176c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 48h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"
        ],
        "money-bill-alt": [
            640,
            512,
            [],
            "f3d1",
            "M352 288h-16v-88c0-4.42-3.58-8-8-8h-13.58c-4.74 0-9.37 1.4-13.31 4.03l-15.33 10.22a7.994 7.994 0 0 0-2.22 11.09l8.88 13.31a7.994 7.994 0 0 0 11.09 2.22l.47-.31V288h-16c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h64c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 192c-53.02 0-96-50.15-96-112 0-61.86 42.98-112 96-112s96 50.14 96 112c0 61.87-43 112-96 112zm272 32h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"
        ],
        "money-bill-wave": [
            640,
            512,
            [],
            "f53a",
            "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM48 132.22c20.12 5.04 41.12 7.57 62.72 8.93C104.84 170.54 79 192.69 48 192.69v-60.47zm0 285v-47.78c34.37 0 62.18 27.27 63.71 61.4-22.53-1.81-43.59-6.31-63.71-13.62zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 27.78c-17.52-4.39-35.71-6.85-54.32-8.44 5.87-26.08 27.5-45.88 54.32-49.28v57.72zm0-236.11c-30.89-3.91-54.86-29.7-55.81-61.55 19.54 2.17 38.09 6.23 55.81 12.66v48.89z"
        ],
        "money-bill-wave-alt": [
            640,
            512,
            [],
            "f53b",
            "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96z"
        ],
        "money-check": [
            640,
            512,
            [],
            "f53c",
            "M0 448c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128H0v320zm448-208c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-32zm0 120c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H456c-4.42 0-8-3.58-8-8v-16zM64 264c0-4.42 3.58-8 8-8h304c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm0 96c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zM624 32H16C7.16 32 0 39.16 0 48v48h640V48c0-8.84-7.16-16-16-16z"
        ],
        "money-check-alt": [
            640,
            512,
            [],
            "f53d",
            "M608 32H32C14.33 32 0 46.33 0 64v384c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM176 327.88V344c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V152c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07zM416 312c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm160 0c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h272c4.42 0 8 3.58 8 8v16z"
        ],
        monument: [
            384,
            512,
            [],
            "f5a6",
            "M368 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-78.86-347.26a31.97 31.97 0 0 0-9.21-19.44L203.31 4.69c-6.25-6.25-16.38-6.25-22.63 0l-76.6 76.61a31.97 31.97 0 0 0-9.21 19.44L64 416h256l-30.86-315.26zM240 307.2c0 6.4-6.4 12.8-12.8 12.8h-70.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h70.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"
        ],
        moon: [
            512,
            512,
            [],
            "f186",
            "M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"
        ],
        "mortar-pestle": [
            512,
            512,
            [],
            "f5a7",
            "M501.54 60.91c17.22-17.22 12.51-46.25-9.27-57.14a35.696 35.696 0 0 0-37.37 3.37L251.09 160h151.37l99.08-99.09zM496 192H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c0 80.98 50.2 150.11 121.13 178.32-12.76 16.87-21.72 36.8-24.95 58.69-1.46 9.92 6.04 18.98 16.07 18.98h223.5c10.03 0 17.53-9.06 16.07-18.98-3.22-21.89-12.18-41.82-24.95-58.69C429.8 406.11 480 336.98 480 256h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
        ],
        mosque: [
            640,
            512,
            [],
            "f678",
            "M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z"
        ],
        motorcycle: [
            640,
            512,
            [],
            "f21c",
            "M512.9 192c-14.9-.1-29.1 2.3-42.4 6.9L437.6 144H520c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24h-45.3c-6.8 0-13.3 2.9-17.8 7.9l-37.5 41.7-22.8-38C392.2 68.4 384.4 64 376 64h-80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h66.4l19.2 32H227.9c-17.7-23.1-44.9-40-99.9-40H72.5C59 104 47.7 115 48 128.5c.2 13 10.9 23.5 24 23.5h56c24.5 0 38.7 10.9 47.8 24.8l-11.3 20.5c-13-3.9-26.9-5.7-41.3-5.2C55.9 194.5 1.6 249.6 0 317c-1.6 72.1 56.3 131 128 131 59.6 0 109.7-40.8 124-96h84.2c13.7 0 24.6-11.4 24-25.1-2.1-47.1 17.5-93.7 56.2-125l12.5 20.8c-27.6 23.7-45.1 58.9-44.8 98.2.5 69.6 57.2 126.5 126.8 127.1 71.6.7 129.8-57.5 129.2-129.1-.7-69.6-57.6-126.4-127.2-126.9zM128 400c-44.1 0-80-35.9-80-80s35.9-80 80-80c4.2 0 8.4.3 12.5 1L99 316.4c-8.8 16 2.8 35.6 21 35.6h81.3c-12.4 28.2-40.6 48-73.3 48zm463.9-75.6c-2.2 40.6-35 73.4-75.5 75.5-46.1 2.5-84.4-34.3-84.4-79.9 0-21.4 8.4-40.8 22.1-55.1l49.4 82.4c4.5 7.6 14.4 10 22 5.5l13.7-8.2c7.6-4.5 10-14.4 5.5-22l-48.6-80.9c5.2-1.1 10.5-1.6 15.9-1.6 45.6-.1 82.3 38.2 79.9 84.3z"
        ],
        mountain: [
            640,
            512,
            [],
            "f6fc",
            "M634.92 462.7l-288-448C341.03 5.54 330.89 0 320 0s-21.03 5.54-26.92 14.7l-288 448a32.001 32.001 0 0 0-1.17 32.64A32.004 32.004 0 0 0 32 512h576c11.71 0 22.48-6.39 28.09-16.67a31.983 31.983 0 0 0-1.17-32.63zM320 91.18L405.39 224H320l-64 64-38.06-38.06L320 91.18z"
        ],
        mouse: [
            384,
            512,
            [],
            "f8cc",
            "M0 352a160 160 0 0 0 160 160h64a160 160 0 0 0 160-160V224H0zM176 0h-16A160 160 0 0 0 0 160v32h176zm48 0h-16v192h176v-32A160 160 0 0 0 224 0z"
        ],
        "mouse-pointer": [
            320,
            512,
            [],
            "f245",
            "M302.189 329.126H196.105l55.831 135.993c3.889 9.428-.555 19.999-9.444 23.999l-49.165 21.427c-9.165 4-19.443-.571-23.332-9.714l-53.053-129.136-86.664 89.138C18.729 472.71 0 463.554 0 447.977V18.299C0 1.899 19.921-6.096 30.277 5.443l284.412 292.542c11.472 11.179 3.007 31.141-12.5 31.141z"
        ],
        "mug-hot": [
            512,
            512,
            [],
            "f7b6",
            "M127.1 146.5c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C111.8 5.9 105 0 96.8 0H80.4C70.6 0 63 8.5 64.1 18c3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zm112 0c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C223.8 5.9 217 0 208.8 0h-16.4c-9.8 0-17.5 8.5-16.3 18 3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zM400 192H32c-17.7 0-32 14.3-32 32v192c0 53 43 96 96 96h192c53 0 96-43 96-96h16c61.8 0 112-50.2 112-112s-50.2-112-112-112zm0 160h-16v-96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
        ],
        music: [
            512,
            512,
            [],
            "f001",
            "M470.38 1.51L150.41 96A32 32 0 0 0 128 126.51v261.41A139 139 0 0 0 96 384c-53 0-96 28.66-96 64s43 64 96 64 96-28.66 96-64V214.32l256-75v184.61a138.4 138.4 0 0 0-32-3.93c-53 0-96 28.66-96 64s43 64 96 64 96-28.65 96-64V32a32 32 0 0 0-41.62-30.49z"
        ],
        "network-wired": [
            640,
            512,
            [],
            "f6ff",
            "M640 264v-16c0-8.84-7.16-16-16-16H344v-40h72c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H224c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h72v40H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h104v40H64c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h304v40h-56c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h104c8.84 0 16-7.16 16-16zM256 128V64h128v64H256zm-64 320H96v-64h96v64zm352 0h-96v-64h96v64z"
        ],
        neuter: [
            288,
            512,
            [],
            "f22c",
            "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V468c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V316.4c64.1-14.5 112-71.9 112-140.4zm-144 80c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
        ],
        newspaper: [
            576,
            512,
            [],
            "f1ea",
            "M552 64H88c-13.255 0-24 10.745-24 24v8H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h472c26.51 0 48-21.49 48-48V88c0-13.255-10.745-24-24-24zM56 400a8 8 0 0 1-8-8V144h16v248a8 8 0 0 1-8 8zm236-16H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm-208-96H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm0-96H140c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12z"
        ],
        "not-equal": [
            448,
            512,
            [],
            "f53e",
            "M416 208c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32h-23.88l51.87-66.81c5.37-7.02 4.04-17.06-2.97-22.43L415.61 3.3c-7.02-5.38-17.06-4.04-22.44 2.97L311.09 112H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h204.56l-74.53 96H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h55.49l-51.87 66.81c-5.37 7.01-4.04 17.05 2.97 22.43L64 508.7c7.02 5.38 17.06 4.04 22.43-2.97L168.52 400H416c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32H243.05l74.53-96H416z"
        ],
        "notes-medical": [
            384,
            512,
            [],
            "f481",
            "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm96 304c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm0-192c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16z"
        ],
        "object-group": [
            512,
            512,
            [],
            "f247",
            "M480 128V96h20c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v20H64V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v40c0 6.627 5.373 12 12 12h20v320H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-20h384v20c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-20V128zM96 276V140c0-6.627 5.373-12 12-12h168c6.627 0 12 5.373 12 12v136c0 6.627-5.373 12-12 12H108c-6.627 0-12-5.373-12-12zm320 96c0 6.627-5.373 12-12 12H236c-6.627 0-12-5.373-12-12v-52h72c13.255 0 24-10.745 24-24v-72h84c6.627 0 12 5.373 12 12v136z"
        ],
        "object-ungroup": [
            576,
            512,
            [],
            "f248",
            "M64 320v26a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6v-52a6 6 0 0 1 6-6h26V96H6a6 6 0 0 1-6-6V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v26h288V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-26v192h26a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-52a6 6 0 0 1-6-6v-26H64zm480-64v-32h26a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-52a6 6 0 0 0-6 6v26H408v72h8c13.255 0 24 10.745 24 24v64c0 13.255-10.745 24-24 24h-64c-13.255 0-24-10.745-24-24v-8H192v72h-26a6 6 0 0 0-6 6v52a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-26h288v26a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-26V256z"
        ],
        "oil-can": [
            640,
            512,
            [],
            "f613",
            "M629.8 160.31L416 224l-50.49-25.24a64.07 64.07 0 0 0-28.62-6.76H280v-48h56c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h56v48h-56L37.72 166.86a31.9 31.9 0 0 0-5.79-.53C14.67 166.33 0 180.36 0 198.34v94.95c0 15.46 11.06 28.72 26.28 31.48L96 337.46V384c0 17.67 14.33 32 32 32h274.63c8.55 0 16.75-3.42 22.76-9.51l212.26-214.75c1.5-1.5 2.34-3.54 2.34-5.66V168c.01-5.31-5.08-9.15-10.19-7.69zM96 288.67l-48-8.73v-62.43l48 8.73v62.43zm453.33 84.66c0 23.56 19.1 42.67 42.67 42.67s42.67-19.1 42.67-42.67S592 288 592 288s-42.67 61.77-42.67 85.33z"
        ],
        om: [
            512,
            512,
            [],
            "f679",
            "M360.6 60.94a10.43 10.43 0 0 0 14.76 0l21.57-21.56a10.43 10.43 0 0 0 0-14.76L375.35 3.06c-4.08-4.07-10.68-4.07-14.76 0l-21.57 21.56a10.43 10.43 0 0 0 0 14.76l21.58 21.56zM412.11 192c-26.69 0-51.77 10.39-70.64 29.25l-24.25 24.25c-6.78 6.77-15.78 10.5-25.38 10.5H245c10.54-22.1 14.17-48.11 7.73-75.23-10.1-42.55-46.36-76.11-89.52-83.19-36.15-5.93-70.9 5.04-96.01 28.78-7.36 6.96-6.97 18.85 1.12 24.93l26.15 19.63c5.72 4.3 13.66 4.32 19.2-.21 8.45-6.9 19.02-10.71 30.27-10.71 26.47 0 48.01 21.53 48.01 48s-21.54 48-48.01 48h-31.9c-11.96 0-19.74 12.58-14.39 23.28l16.09 32.17c2.53 5.06 7.6 8.1 13.17 8.55h33.03c35.3 0 64.01 28.7 64.01 64s-28.71 64-64.01 64c-96.02 0-122.35-54.02-145.15-92.03-4.53-7.55-14.77-3.58-14.79 5.22C-.09 416 41.13 512 159.94 512c70.59 0 128.02-57.42 128.02-128 0-23.42-6.78-45.1-17.81-64h21.69c26.69 0 51.77-10.39 70.64-29.25l24.25-24.25c6.78-6.77 15.78-10.5 25.38-10.5 19.78 0 35.88 16.09 35.88 35.88V392c0 13.23-18.77 24-32.01 24-39.4 0-66.67-24.24-81.82-42.89-4.77-5.87-14.2-2.54-14.2 5.02V416s0 64 96.02 64c48.54 0 96.02-39.47 96.02-88V291.88c0-55.08-44.8-99.88-99.89-99.88zm42.18-124.73c-85.55 65.12-169.05 2.75-172.58.05-6.02-4.62-14.44-4.38-20.14.55-5.74 4.92-7.27 13.17-3.66 19.8 1.61 2.95 40.37 72.34 118.8 72.34 79.92 0 98.78-31.36 101.75-37.66 1.02-2.12 1.53-4.47 1.53-6.83V80c0-13.22-15.14-20.69-25.7-12.73z"
        ],
        otter: [
            640,
            512,
            [],
            "f700",
            "M608 32h-32l-13.25-13.25A63.97 63.97 0 0 0 517.49 0H497c-11.14 0-22.08 2.91-31.75 8.43L312 96h-56C149.96 96 64 181.96 64 288v1.61c0 32.75-16 62.14-39.56 84.89-18.19 17.58-28.1 43.68-23.19 71.8 6.76 38.8 42.9 65.7 82.28 65.7H192c17.67 0 32-14.33 32-32s-14.33-32-32-32H80c-8.83 0-16-7.17-16-16s7.17-16 16-16h224c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-64l149.49-80.5L448 416h80c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-28.22l-55.11-110.21L521.14 192H544c53.02 0 96-42.98 96-96V64c0-17.67-14.33-32-32-32zm-96 16c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16zm32 96h-34.96L407.2 198.84l-13.77-27.55L512 112h77.05c-6.62 18.58-24.22 32-45.05 32z"
        ],
        outdent: [
            448,
            512,
            [],
            "f03b",
            "M100.69 363.29c10 10 27.31 2.93 27.31-11.31V160c0-14.32-17.33-21.31-27.31-11.31l-96 96a16 16 0 0 0 0 22.62zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
        ],
        pager: [
            512,
            512,
            [],
            "f815",
            "M448 64H64a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64zM160 368H80a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h80zm128-16a16 16 0 0 1-16 16h-80v-48h80a16 16 0 0 1 16 16zm160-128a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32v-64a32 32 0 0 1 32-32h320a32 32 0 0 1 32 32z"
        ],
        "paint-brush": [
            512,
            512,
            [],
            "f1fc",
            "M167.02 309.34c-40.12 2.58-76.53 17.86-97.19 72.3-2.35 6.21-8 9.98-14.59 9.98-11.11 0-45.46-27.67-55.25-34.35C0 439.62 37.93 512 128 512c75.86 0 128-43.77 128-120.19 0-3.11-.65-6.08-.97-9.13l-88.01-73.34zM457.89 0c-15.16 0-29.37 6.71-40.21 16.45C213.27 199.05 192 203.34 192 257.09c0 13.7 3.25 26.76 8.73 38.7l63.82 53.18c7.21 1.8 14.64 3.03 22.39 3.03 62.11 0 98.11-45.47 211.16-256.46 7.38-14.35 13.9-29.85 13.9-45.99C512 20.64 486 0 457.89 0z"
        ],
        "paint-roller": [
            512,
            512,
            [],
            "f5aa",
            "M416 128V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32zm32-64v128c0 17.67-14.33 32-32 32H256c-35.35 0-64 28.65-64 64v32c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32v-32h160c53.02 0 96-42.98 96-96v-64c0-35.35-28.65-64-64-64z"
        ],
        palette: [
            512,
            512,
            [],
            "f53f",
            "M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
        ],
        pallet: [
            640,
            512,
            [],
            "f482",
            "M144 256h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H384v128l-64-32-64 32V0H144c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zm480 128c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v64H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-64h48zm-336 64H128v-64h160v64zm224 0H352v-64h160v64z"
        ],
        "paper-plane": [
            512,
            512,
            [],
            "f1d8",
            "M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"
        ],
        paperclip: [
            448,
            512,
            [],
            "f0c6",
            "M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"
        ],
        "parachute-box": [
            512,
            512,
            [],
            "f4cd",
            "M511.9 175c-9.1-75.6-78.4-132.4-158.3-158.7C390 55.7 416 116.9 416 192h28.1L327.5 321.5c-2.5-.6-4.8-1.5-7.5-1.5h-48V192h112C384 76.8 315.1 0 256 0S128 76.8 128 192h112v128h-48c-2.7 0-5 .9-7.5 1.5L67.9 192H96c0-75.1 26-136.3 62.4-175.7C78.5 42.7 9.2 99.5.1 175c-1.1 9.1 6.8 17 16 17h8.7l136.7 151.9c-.7 2.6-1.6 5.2-1.6 8.1v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V352c0-2.9-.9-5.4-1.6-8.1L487.1 192h8.7c9.3 0 17.2-7.8 16.1-17z"
        ],
        paragraph: [
            448,
            512,
            [],
            "f1dd",
            "M448 48v32a16 16 0 0 1-16 16h-48v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V96h-32v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V352h-32a160 160 0 0 1 0-320h240a16 16 0 0 1 16 16z"
        ],
        parking: [
            448,
            512,
            [],
            "f540",
            "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM240 320h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h96c52.9 0 96 43.1 96 96s-43.1 96-96 96zm0-128h-48v64h48c17.6 0 32-14.4 32-32s-14.4-32-32-32z"
        ],
        passport: [
            448,
            512,
            [],
            "f5ab",
            "M129.62 176h39.09c1.49-27.03 6.54-51.35 14.21-70.41-27.71 13.24-48.02 39.19-53.3 70.41zm0 32c5.29 31.22 25.59 57.17 53.3 70.41-7.68-19.06-12.72-43.38-14.21-70.41h-39.09zM224 286.69c7.69-7.45 20.77-34.42 23.43-78.69h-46.87c2.67 44.26 15.75 71.24 23.44 78.69zM200.57 176h46.87c-2.66-44.26-15.74-71.24-23.43-78.69-7.7 7.45-20.78 34.43-23.44 78.69zm64.51 102.41c27.71-13.24 48.02-39.19 53.3-70.41h-39.09c-1.49 27.03-6.53 51.35-14.21 70.41zM416 0H64C28.65 0 0 28.65 0 64v384c0 35.35 28.65 64 64 64h352c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zm-80 416H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-112-96c-70.69 0-128-57.31-128-128S153.31 64 224 64s128 57.31 128 128-57.31 128-128 128zm41.08-214.41c7.68 19.06 12.72 43.38 14.21 70.41h39.09c-5.28-31.22-25.59-57.17-53.3-70.41z"
        ],
        pastafarianism: [
            640,
            512,
            [],
            "f67b",
            "M624.54 347.67c-32.7-12.52-57.36 4.25-75.37 16.45-17.06 11.53-23.25 14.42-31.41 11.36-8.12-3.09-10.83-9.38-15.89-29.38-3.33-13.15-7.44-29.32-17.95-42.65 2.24-2.91 4.43-5.79 6.38-8.57C500.47 304.45 513.71 312 532 312c33.95 0 50.87-25.78 62.06-42.83 10.59-16.14 15-21.17 21.94-21.17 13.25 0 24-10.75 24-24s-10.75-24-24-24c-33.95 0-50.87 25.78-62.06 42.83-10.6 16.14-15 21.17-21.94 21.17-17.31 0-37.48-61.43-97.26-101.91l17.25-34.5C485.43 125.5 512 97.98 512 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 13.02 3.94 25.1 10.62 35.21l-18.15 36.3c-16.98-4.6-35.6-7.51-56.46-7.51s-39.49 2.91-56.46 7.51l-18.15-36.3C252.06 89.1 256 77.02 256 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 33.98 26.56 61.5 60.02 63.6l17.25 34.5C145.68 202.44 125.15 264 108 264c-6.94 0-11.34-5.03-21.94-21.17C74.88 225.78 57.96 200 24 200c-13.25 0-24 10.75-24 24s10.75 24 24 24c6.94 0 11.34 5.03 21.94 21.17C57.13 286.22 74.05 312 108 312c18.29 0 31.53-7.55 41.7-17.11 1.95 2.79 4.14 5.66 6.38 8.57-10.51 13.33-14.62 29.5-17.95 42.65-5.06 20-7.77 26.28-15.89 29.38-8.11 3.06-14.33.17-31.41-11.36-18.03-12.2-42.72-28.92-75.37-16.45-12.39 4.72-18.59 18.58-13.87 30.97 4.72 12.41 18.61 18.61 30.97 13.88 8.16-3.09 14.34-.19 31.39 11.36 13.55 9.16 30.83 20.86 52.42 20.84 7.17 0 14.83-1.28 22.97-4.39 32.66-12.44 39.98-41.33 45.33-62.44 2.21-8.72 3.99-14.49 5.95-18.87 16.62 13.61 36.95 25.88 61.64 34.17-9.96 37-32.18 90.8-60.26 90.8-13.25 0-24 10.75-24 24s10.75 24 24 24c66.74 0 97.05-88.63 107.42-129.14 6.69.6 13.42 1.14 20.58 1.14s13.89-.54 20.58-1.14C350.95 423.37 381.26 512 448 512c13.25 0 24-10.75 24-24s-10.75-24-24-24c-27.94 0-50.21-53.81-60.22-90.81 24.69-8.29 45-20.56 61.62-34.16 1.96 4.38 3.74 10.15 5.95 18.87 5.34 21.11 12.67 50 45.33 62.44 8.14 3.11 15.8 4.39 22.97 4.39 21.59 0 38.87-11.69 52.42-20.84 17.05-11.55 23.28-14.45 31.39-11.36 12.39 4.75 26.27-1.47 30.97-13.88 4.71-12.4-1.49-26.26-13.89-30.98zM448 48c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zm-256 0c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16z"
        ],
        paste: [
            448,
            512,
            [],
            "f0ea",
            "M128 184c0-30.879 25.122-56 56-56h136V56c0-13.255-10.745-24-24-24h-80.61C204.306 12.89 183.637 0 160 0s-44.306 12.89-55.39 32H24C10.745 32 0 42.745 0 56v336c0 13.255 10.745 24 24 24h104V184zm32-144c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24zm184 248h104v200c0 13.255-10.745 24-24 24H184c-13.255 0-24-10.745-24-24V184c0-13.255 10.745-24 24-24h136v104c0 13.2 10.8 24 24 24zm104-38.059V256h-96v-96h6.059a24 24 0 0 1 16.97 7.029l65.941 65.941a24.002 24.002 0 0 1 7.03 16.971z"
        ],
        pause: [
            448,
            512,
            [],
            "f04c",
            "M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"
        ],
        "pause-circle": [
            512,
            512,
            [],
            "f28b",
            "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-16 328c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160zm112 0c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160z"
        ],
        paw: [
            512,
            512,
            [],
            "f1b0",
            "M256 224c-79.41 0-192 122.76-192 200.25 0 34.9 26.81 55.75 71.74 55.75 48.84 0 81.09-25.08 120.26-25.08 39.51 0 71.85 25.08 120.26 25.08 44.93 0 71.74-20.85 71.74-55.75C448 346.76 335.41 224 256 224zm-147.28-12.61c-10.4-34.65-42.44-57.09-71.56-50.13-29.12 6.96-44.29 40.69-33.89 75.34 10.4 34.65 42.44 57.09 71.56 50.13 29.12-6.96 44.29-40.69 33.89-75.34zm84.72-20.78c30.94-8.14 46.42-49.94 34.58-93.36s-46.52-72.01-77.46-63.87-46.42 49.94-34.58 93.36c11.84 43.42 46.53 72.02 77.46 63.87zm281.39-29.34c-29.12-6.96-61.15 15.48-71.56 50.13-10.4 34.65 4.77 68.38 33.89 75.34 29.12 6.96 61.15-15.48 71.56-50.13 10.4-34.65-4.77-68.38-33.89-75.34zm-156.27 29.34c30.94 8.14 65.62-20.45 77.46-63.87 11.84-43.42-3.64-85.21-34.58-93.36s-65.62 20.45-77.46 63.87c-11.84 43.42 3.64 85.22 34.58 93.36z"
        ],
        peace: [
            496,
            512,
            [],
            "f67c",
            "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm184 248c0 31.93-8.2 61.97-22.57 88.17L280 240.63V74.97c86.23 15.21 152 90.5 152 181.03zM216 437.03c-33.86-5.97-64.49-21.2-89.29-43.02L216 322.57v114.46zm64-114.46L369.29 394c-24.8 21.82-55.43 37.05-89.29 43.02V322.57zm-64-247.6v165.66L86.57 344.17C72.2 317.97 64 287.93 64 256c0-90.53 65.77-165.82 152-181.03z"
        ],
        pen: [
            512,
            512,
            [],
            "f304",
            "M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"
        ],
        "pen-alt": [
            512,
            512,
            [],
            "f305",
            "M497.94 74.17l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91zm-246.8-20.53c-15.62-15.62-40.94-15.62-56.56 0L75.8 172.43c-6.25 6.25-6.25 16.38 0 22.62l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l101.82-101.82 22.63 22.62L93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l196.79-196.79-82.77-82.77-84.85-84.85z"
        ],
        "pen-fancy": [
            512,
            512,
            [],
            "f5ac",
            "M79.18 282.94a32.005 32.005 0 0 0-20.24 20.24L0 480l4.69 4.69 92.89-92.89c-.66-2.56-1.57-5.03-1.57-7.8 0-17.67 14.33-32 32-32s32 14.33 32 32-14.33 32-32 32c-2.77 0-5.24-.91-7.8-1.57l-92.89 92.89L32 512l176.82-58.94a31.983 31.983 0 0 0 20.24-20.24l33.07-84.07-98.88-98.88-84.07 33.07zM369.25 28.32L186.14 227.81l97.85 97.85 199.49-183.11C568.4 67.48 443.73-55.94 369.25 28.32z"
        ],
        "pen-nib": [
            512,
            512,
            [],
            "f5ad",
            "M136.6 138.79a64.003 64.003 0 0 0-43.31 41.35L0 460l14.69 14.69L164.8 324.58c-2.99-6.26-4.8-13.18-4.8-20.58 0-26.51 21.49-48 48-48s48 21.49 48 48-21.49 48-48 48c-7.4 0-14.32-1.81-20.58-4.8L37.31 497.31 52 512l279.86-93.29a64.003 64.003 0 0 0 41.35-43.31L416 224 288 96l-151.4 42.79zm361.34-64.62l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91z"
        ],
        "pen-square": [
            448,
            512,
            [],
            "f14b",
            "M400 480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zM238.1 177.9L102.4 313.6l-6.3 57.1c-.8 7.6 5.6 14.1 13.3 13.3l57.1-6.3L302.2 242c2.3-2.3 2.3-6.1 0-8.5L246.7 178c-2.5-2.4-6.3-2.4-8.6-.1zM345 165.1L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9z"
        ],
        "pencil-alt": [
            512,
            512,
            [],
            "f303",
            "M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
        ],
        "pencil-ruler": [
            512,
            512,
            [],
            "f5ae",
            "M109.46 244.04l134.58-134.56-44.12-44.12-61.68 61.68a7.919 7.919 0 0 1-11.21 0l-11.21-11.21c-3.1-3.1-3.1-8.12 0-11.21l61.68-61.68-33.64-33.65C131.47-3.1 111.39-3.1 99 9.29L9.29 99c-12.38 12.39-12.39 32.47 0 44.86l100.17 100.18zm388.47-116.8c18.76-18.76 18.75-49.17 0-67.93l-45.25-45.25c-18.76-18.76-49.18-18.76-67.95 0l-46.02 46.01 113.2 113.2 46.02-46.03zM316.08 82.71l-297 296.96L.32 487.11c-2.53 14.49 10.09 27.11 24.59 24.56l107.45-18.84L429.28 195.9 316.08 82.71zm186.63 285.43l-33.64-33.64-61.68 61.68c-3.1 3.1-8.12 3.1-11.21 0l-11.21-11.21c-3.09-3.1-3.09-8.12 0-11.21l61.68-61.68-44.14-44.14L267.93 402.5l100.21 100.2c12.39 12.39 32.47 12.39 44.86 0l89.71-89.7c12.39-12.39 12.39-32.47 0-44.86z"
        ],
        "people-arrows": [
            576,
            512,
            [],
            "e068",
            "M96,128A64,64,0,1,0,32,64,64,64,0,0,0,96,128Zm0,176.08a44.11,44.11,0,0,1,13.64-32L181.77,204c1.65-1.55,3.77-2.31,5.61-3.57A63.91,63.91,0,0,0,128,160H64A64,64,0,0,0,0,224v96a32,32,0,0,0,32,32V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V383.61l-50.36-47.53A44.08,44.08,0,0,1,96,304.08ZM480,128a64,64,0,1,0-64-64A64,64,0,0,0,480,128Zm32,32H448a63.91,63.91,0,0,0-59.38,40.42c1.84,1.27,4,2,5.62,3.59l72.12,68.06a44.37,44.37,0,0,1,0,64L416,383.62V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V352a32,32,0,0,0,32-32V224A64,64,0,0,0,512,160ZM444.4,295.34l-72.12-68.06A12,12,0,0,0,352,236v36H224V236a12,12,0,0,0-20.28-8.73L131.6,295.34a12.4,12.4,0,0,0,0,17.47l72.12,68.07A12,12,0,0,0,224,372.14V336H352v36.14a12,12,0,0,0,20.28,8.74l72.12-68.07A12.4,12.4,0,0,0,444.4,295.34Z"
        ],
        "people-carry": [
            640,
            512,
            [],
            "f4ce",
            "M128 96c26.5 0 48-21.5 48-48S154.5 0 128 0 80 21.5 80 48s21.5 48 48 48zm384 0c26.5 0 48-21.5 48-48S538.5 0 512 0s-48 21.5-48 48 21.5 48 48 48zm125.7 372.1l-44-110-41.1 46.4-2 18.2 27.7 69.2c5 12.5 17 20.1 29.7 20.1 4 0 8-.7 11.9-2.3 16.4-6.6 24.4-25.2 17.8-41.6zm-34.2-209.8L585 178.1c-4.6-20-18.6-36.8-37.5-44.9-18.5-8-39-6.7-56.1 3.3-22.7 13.4-39.7 34.5-48.1 59.4L432 229.8 416 240v-96c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v96l-16.1-10.2-11.3-33.9c-8.3-25-25.4-46-48.1-59.4-17.2-10-37.6-11.3-56.1-3.3-18.9 8.1-32.9 24.9-37.5 44.9l-18.4 80.2c-4.6 20 .7 41.2 14.4 56.7l67.2 75.9 10.1 92.6C130 499.8 143.8 512 160 512c1.2 0 2.3-.1 3.5-.2 17.6-1.9 30.2-17.7 28.3-35.3l-10.1-92.8c-1.5-13-6.9-25.1-15.6-35l-43.3-49 17.6-70.3 6.8 20.4c4.1 12.5 11.9 23.4 24.5 32.6l51.1 32.5c4.6 2.9 12.1 4.6 17.2 5h160c5.1-.4 12.6-2.1 17.2-5l51.1-32.5c12.6-9.2 20.4-20 24.5-32.6l6.8-20.4 17.6 70.3-43.3 49c-8.7 9.9-14.1 22-15.6 35l-10.1 92.8c-1.9 17.6 10.8 33.4 28.3 35.3 1.2.1 2.3.2 3.5.2 16.1 0 30-12.1 31.8-28.5l10.1-92.6 67.2-75.9c13.6-15.5 19-36.7 14.4-56.7zM46.3 358.1l-44 110c-6.6 16.4 1.4 35 17.8 41.6 16.8 6.6 35.1-1.7 41.6-17.8l27.7-69.2-2-18.2-41.1-46.4z"
        ],
        "pepper-hot": [
            512,
            512,
            [],
            "f816",
            "M330.67 263.12V173.4l-52.75-24.22C219.44 218.76 197.58 400 56 400a56 56 0 0 0 0 112c212.64 0 370.65-122.87 419.18-210.34l-37.05-38.54zm131.09-128.37C493.92 74.91 477.18 26.48 458.62 3a8 8 0 0 0-11.93-.59l-22.9 23a8.06 8.06 0 0 0-.89 10.23c6.86 10.36 17.05 35.1-1.4 72.32A142.85 142.85 0 0 0 364.34 96c-28 0-54 8.54-76.34 22.59l74.67 34.29v78.24h89.09L506.44 288c3.26-12.62 5.56-25.63 5.56-39.31a154 154 0 0 0-50.24-113.94z"
        ],
        percent: [
            448,
            512,
            [],
            "f295",
            "M112 224c61.9 0 112-50.1 112-112S173.9 0 112 0 0 50.1 0 112s50.1 112 112 112zm0-160c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm224 224c-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112-50.1-112-112-112zm0 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM392.3.2l31.6-.1c19.4-.1 30.9 21.8 19.7 37.8L77.4 501.6a23.95 23.95 0 0 1-19.6 10.2l-33.4.1c-19.5 0-30.9-21.9-19.7-37.8l368-463.7C377.2 4 384.5.2 392.3.2z"
        ],
        percentage: [
            384,
            512,
            [],
            "f541",
            "M109.25 173.25c24.99-24.99 24.99-65.52 0-90.51-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 25 25 65.52 25 90.51 0zm256 165.49c-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 24.99 24.99 65.52 24.99 90.51 0 25-24.99 25-65.51 0-90.51zm-1.94-231.43l-22.62-22.62c-12.5-12.5-32.76-12.5-45.25 0L20.69 359.44c-12.5 12.5-12.5 32.76 0 45.25l22.62 22.62c12.5 12.5 32.76 12.5 45.25 0l274.75-274.75c12.5-12.49 12.5-32.75 0-45.25z"
        ],
        "person-booth": [
            576,
            512,
            [],
            "f756",
            "M192 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h-64v176zm32-272h-50.9l-45.2-45.3C115.8 166.6 99.7 160 82.7 160H64c-17.1 0-33.2 6.7-45.3 18.8C6.7 190.9 0 207 0 224.1L.2 320 0 480c0 17.7 14.3 32 31.9 32 17.6 0 32-14.3 32-32l.1-100.7c.9.5 1.6 1.3 2.5 1.7l29.1 43v56c0 17.7 14.3 32 32 32s32-14.3 32-32v-56.5c0-9.9-2.3-19.8-6.7-28.6l-41.2-61.3V253l20.9 20.9c9.1 9.1 21.1 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32zM64 128c26.5 0 48-21.5 48-48S90.5 32 64 32 16 53.5 16 80s21.5 48 48 48zm224-96l31.5 223.1-30.9 154.6c-4.3 21.6 13 38.3 31.4 38.3 15.2 0 28-9.1 32.3-30.4.9 16.9 14.6 30.4 31.7 30.4 17.7 0 32-14.3 32-32 0 17.7 14.3 32 32 32s32-14.3 32-32V0H288v32zm-96 0v160h64V0h-32c-17.7 0-32 14.3-32 32zM544 0h-32v496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32c0-17.7-14.3-32-32-32z"
        ],
        phone: [
            512,
            512,
            [],
            "f095",
            "M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"
        ],
        "phone-alt": [
            512,
            512,
            [],
            "f879",
            "M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"
        ],
        "phone-slash": [
            640,
            512,
            [],
            "f3dd",
            "M268.2 381.4l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48c-10.7 4.6-16.5 16.1-13.9 27.5l24 104c2.5 10.8 12.1 18.6 23.4 18.6 100.7 0 193.7-32.4 269.7-86.9l-80-61.8c-10.9 6.5-22.1 12.7-33.6 18.1zm365.6 76.7L475.1 335.5C537.9 256.4 576 156.9 576 48c0-11.2-7.7-20.9-18.6-23.4l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-12.2 26.1-27.9 50.3-46 72.8L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"
        ],
        "phone-square": [
            448,
            512,
            [],
            "f098",
            "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM94 416c-7.033 0-13.057-4.873-14.616-11.627l-14.998-65a15 15 0 0 1 8.707-17.16l69.998-29.999a15 15 0 0 1 17.518 4.289l30.997 37.885c48.944-22.963 88.297-62.858 110.781-110.78l-37.886-30.997a15.001 15.001 0 0 1-4.289-17.518l30-69.998a15 15 0 0 1 17.16-8.707l65 14.998A14.997 14.997 0 0 1 384 126c0 160.292-129.945 290-290 290z"
        ],
        "phone-square-alt": [
            448,
            512,
            [],
            "f87b",
            "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-16.39 307.37l-15 65A15 15 0 0 1 354 416C194 416 64 286.29 64 126a15.7 15.7 0 0 1 11.63-14.61l65-15A18.23 18.23 0 0 1 144 96a16.27 16.27 0 0 1 13.79 9.09l30 70A17.9 17.9 0 0 1 189 181a17 17 0 0 1-5.5 11.61l-37.89 31a231.91 231.91 0 0 0 110.78 110.78l31-37.89A17 17 0 0 1 299 291a17.85 17.85 0 0 1 5.91 1.21l70 30A16.25 16.25 0 0 1 384 336a17.41 17.41 0 0 1-.39 3.37z"
        ],
        "phone-volume": [
            384,
            512,
            [],
            "f2a0",
            "M97.333 506.966c-129.874-129.874-129.681-340.252 0-469.933 5.698-5.698 14.527-6.632 21.263-2.422l64.817 40.513a17.187 17.187 0 0 1 6.849 20.958l-32.408 81.021a17.188 17.188 0 0 1-17.669 10.719l-55.81-5.58c-21.051 58.261-20.612 122.471 0 179.515l55.811-5.581a17.188 17.188 0 0 1 17.669 10.719l32.408 81.022a17.188 17.188 0 0 1-6.849 20.958l-64.817 40.513a17.19 17.19 0 0 1-21.264-2.422zM247.126 95.473c11.832 20.047 11.832 45.008 0 65.055-3.95 6.693-13.108 7.959-18.718 2.581l-5.975-5.726c-3.911-3.748-4.793-9.622-2.261-14.41a32.063 32.063 0 0 0 0-29.945c-2.533-4.788-1.65-10.662 2.261-14.41l5.975-5.726c5.61-5.378 14.768-4.112 18.718 2.581zm91.787-91.187c60.14 71.604 60.092 175.882 0 247.428-4.474 5.327-12.53 5.746-17.552.933l-5.798-5.557c-4.56-4.371-4.977-11.529-.93-16.379 49.687-59.538 49.646-145.933 0-205.422-4.047-4.85-3.631-12.008.93-16.379l5.798-5.557c5.022-4.813 13.078-4.394 17.552.933zm-45.972 44.941c36.05 46.322 36.108 111.149 0 157.546-4.39 5.641-12.697 6.251-17.856 1.304l-5.818-5.579c-4.4-4.219-4.998-11.095-1.285-15.931 26.536-34.564 26.534-82.572 0-117.134-3.713-4.836-3.115-11.711 1.285-15.931l5.818-5.579c5.159-4.947 13.466-4.337 17.856 1.304z"
        ],
        "photo-video": [
            640,
            512,
            [],
            "f87c",
            "M608 0H160a32 32 0 0 0-32 32v96h160V64h192v320h128a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zM232 103a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm352 208a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm-168 57H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM96 224a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm288 224H64v-32l64-64 32 32 128-128 96 96z"
        ],
        "piggy-bank": [
            576,
            512,
            [],
            "f4d3",
            "M560 224h-29.5c-8.8-20-21.6-37.7-37.4-52.5L512 96h-32c-29.4 0-55.4 13.5-73 34.3-7.6-1.1-15.1-2.3-23-2.3H256c-77.4 0-141.9 55-156.8 128H56c-14.8 0-26.5-13.5-23.5-28.8C34.7 215.8 45.4 208 57 208h1c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6-28.5 0-53.9 20.4-57.5 48.6C-3.9 258.8 22.7 288 56 288h40c0 52.2 25.4 98.1 64 127.3V496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-48h128v48c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80.7c11.8-8.9 22.3-19.4 31.3-31.3H560c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16zm-128 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM256 96h128c5.4 0 10.7.4 15.9.8 0-.3.1-.5.1-.8 0-53-43-96-96-96s-96 43-96 96c0 2.1.5 4.1.6 6.2 15.2-3.9 31-6.2 47.4-6.2z"
        ],
        pills: [
            576,
            512,
            [],
            "f484",
            "M112 32C50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112zm48 224H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm139.7-29.7c-3.5-3.5-9.4-3.1-12.3.8-45.3 62.5-40.4 150.1 15.9 206.4 56.3 56.3 143.9 61.2 206.4 15.9 4-2.9 4.3-8.8.8-12.3L299.7 226.3zm229.8-19c-56.3-56.3-143.9-61.2-206.4-15.9-4 2.9-4.3 8.8-.8 12.3l210.8 210.8c3.5 3.5 9.4 3.1 12.3-.8 45.3-62.6 40.5-150.1-15.9-206.4z"
        ],
        "pizza-slice": [
            512,
            512,
            [],
            "f818",
            "M158.87.15c-16.16-1.52-31.2 8.42-35.33 24.12l-14.81 56.27c187.62 5.49 314.54 130.61 322.48 317l56.94-15.78c15.72-4.36 25.49-19.68 23.62-35.9C490.89 165.08 340.78 17.32 158.87.15zm-58.47 112L.55 491.64a16.21 16.21 0 0 0 20 19.75l379-105.1c-4.27-174.89-123.08-292.14-299.15-294.1zM128 416a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm48-152a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm104 104a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
        ],
        "place-of-worship": [
            640,
            512,
            [],
            "f67f",
            "M620.61 366.55L512 320v192h112c8.84 0 16-7.16 16-16V395.96a32 32 0 0 0-19.39-29.41zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.55A32 32 0 0 0 0 395.96zm464.46-149.28L416 217.6V102.63c0-8.49-3.37-16.62-9.38-22.63L331.31 4.69c-6.25-6.25-16.38-6.25-22.62 0L233.38 80c-6 6-9.38 14.14-9.38 22.63V217.6l-48.46 29.08A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.66-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44z"
        ],
        plane: [
            576,
            512,
            [],
            "f072",
            "M480 192H365.71L260.61 8.06A16.014 16.014 0 0 0 246.71 0h-65.5c-10.63 0-18.3 10.17-15.38 20.39L214.86 192H112l-43.2-57.6c-3.02-4.03-7.77-6.4-12.8-6.4H16.01C5.6 128-2.04 137.78.49 147.88L32 256 .49 364.12C-2.04 374.22 5.6 384 16.01 384H56c5.04 0 9.78-2.37 12.8-6.4L112 320h102.86l-49.03 171.6c-2.92 10.22 4.75 20.4 15.38 20.4h65.5c5.74 0 11.04-3.08 13.89-8.06L365.71 320H480c35.35 0 96-28.65 96-64s-60.65-64-96-64z"
        ],
        "plane-arrival": [
            640,
            512,
            [],
            "f5af",
            "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM44.81 205.66l88.74 80a62.607 62.607 0 0 0 25.47 13.93l287.6 78.35c26.48 7.21 54.56 8.72 81 1.36 29.67-8.27 43.44-21.21 47.25-35.71 3.83-14.5-1.73-32.71-23.37-54.96-19.28-19.82-44.35-32.79-70.83-40l-97.51-26.56L282.8 30.22c-1.51-5.81-5.95-10.35-11.66-11.91L206.05.58c-10.56-2.88-20.9 5.32-20.71 16.44l47.92 164.21-102.2-27.84-27.59-67.88c-1.93-4.89-6.01-8.57-11.02-9.93L52.72 64.75c-10.34-2.82-20.53 5-20.72 15.88l.23 101.78c.19 8.91 6.03 17.34 12.58 23.25z"
        ],
        "plane-departure": [
            640,
            512,
            [],
            "f5b0",
            "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM80.55 341.27c6.28 6.84 15.1 10.72 24.33 10.71l130.54-.18a65.62 65.62 0 0 0 29.64-7.12l290.96-147.65c26.74-13.57 50.71-32.94 67.02-58.31 18.31-28.48 20.3-49.09 13.07-63.65-7.21-14.57-24.74-25.27-58.25-27.45-29.85-1.94-59.54 5.92-86.28 19.48l-98.51 49.99-218.7-82.06a17.799 17.799 0 0 0-18-1.11L90.62 67.29c-10.67 5.41-13.25 19.65-5.17 28.53l156.22 98.1-103.21 52.38-72.35-36.47a17.804 17.804 0 0 0-16.07.02L9.91 230.22c-10.44 5.3-13.19 19.12-5.57 28.08l76.21 82.97z"
        ],
        "plane-slash": [
            640,
            512,
            [],
            "e069",
            "M32.48,147.88,64,256,32.48,364.13A16,16,0,0,0,48,384H88a16,16,0,0,0,12.8-6.41L144,320H246.85l-49,171.59A16,16,0,0,0,213.2,512h65.5a16,16,0,0,0,13.89-8.06l66.6-116.54L34.35,136.34A15.47,15.47,0,0,0,32.48,147.88ZM633.82,458.09,455.14,320H512c35.34,0,96-28.66,96-64s-60.66-64-96-64H397.7L292.61,8.06C290.06,3.61,283.84,0,278.71,0H213.2a16,16,0,0,0-15.38,20.39l36.94,129.29L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09Z"
        ],
        play: [
            448,
            512,
            [],
            "f04b",
            "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"
        ],
        "play-circle": [
            512,
            512,
            [],
            "f144",
            "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z"
        ],
        plug: [
            384,
            512,
            [],
            "f1e6",
            "M320,32a32,32,0,0,0-64,0v96h64Zm48,128H16A16,16,0,0,0,0,176v32a16,16,0,0,0,16,16H32v32A160.07,160.07,0,0,0,160,412.8V512h64V412.8A160.07,160.07,0,0,0,352,256V224h16a16,16,0,0,0,16-16V176A16,16,0,0,0,368,160ZM128,32a32,32,0,0,0-64,0v96h64Z"
        ],
        plus: [
            448,
            512,
            [],
            "f067",
            "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
        ],
        "plus-circle": [
            512,
            512,
            [],
            "f055",
            "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
        ],
        "plus-square": [
            448,
            512,
            [],
            "f0fe",
            "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-32 252c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92H92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
        ],
        podcast: [
            448,
            512,
            [],
            "f2ce",
            "M267.429 488.563C262.286 507.573 242.858 512 224 512c-18.857 0-38.286-4.427-43.428-23.437C172.927 460.134 160 388.898 160 355.75c0-35.156 31.142-43.75 64-43.75s64 8.594 64 43.75c0 32.949-12.871 104.179-20.571 132.813zM156.867 288.554c-18.693-18.308-29.958-44.173-28.784-72.599 2.054-49.724 42.395-89.956 92.124-91.881C274.862 121.958 320 165.807 320 220c0 26.827-11.064 51.116-28.866 68.552-2.675 2.62-2.401 6.986.628 9.187 9.312 6.765 16.46 15.343 21.234 25.363 1.741 3.654 6.497 4.66 9.449 1.891 28.826-27.043 46.553-65.783 45.511-108.565-1.855-76.206-63.595-138.208-139.793-140.369C146.869 73.753 80 139.215 80 220c0 41.361 17.532 78.7 45.55 104.989 2.953 2.771 7.711 1.77 9.453-1.887 4.774-10.021 11.923-18.598 21.235-25.363 3.029-2.2 3.304-6.566.629-9.185zM224 0C100.204 0 0 100.185 0 224c0 89.992 52.602 165.647 125.739 201.408 4.333 2.118 9.267-1.544 8.535-6.31-2.382-15.512-4.342-30.946-5.406-44.339-.146-1.836-1.149-3.486-2.678-4.512-47.4-31.806-78.564-86.016-78.187-147.347.592-96.237 79.29-174.648 175.529-174.899C320.793 47.747 400 126.797 400 224c0 61.932-32.158 116.49-80.65 147.867-.999 14.037-3.069 30.588-5.624 47.23-.732 4.767 4.203 8.429 8.535 6.31C395.227 389.727 448 314.187 448 224 448 100.205 347.815 0 224 0zm0 160c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64z"
        ],
        poll: [
            448,
            512,
            [],
            "f681",
            "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM160 368c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V240c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v128zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V144c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v224zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-64c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v64z"
        ],
        "poll-h": [
            448,
            512,
            [],
            "f682",
            "M448 432V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zM112 192c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h128c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-64z"
        ],
        poo: [
            512,
            512,
            [],
            "f2fe",
            "M451.4 369.1C468.7 356 480 335.4 480 312c0-39.8-32.2-72-72-72h-14.1c13.4-11.7 22.1-28.8 22.1-48 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C250.3 14.6 256 30.6 256 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 19.2 8.7 36.3 22.1 48H104c-39.8 0-72 32.2-72 72 0 23.4 11.3 44 28.6 57.1C26.3 374.6 0 404.1 0 440c0 39.8 32.2 72 72 72h368c39.8 0 72-32.2 72-72 0-35.9-26.3-65.4-60.6-70.9zM192 256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm159.5 139C341 422.9 293 448 256 448s-85-25.1-95.5-53c-2-5.3 2-11 7.8-11h175.4c5.8 0 9.8 5.7 7.8 11zM320 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
        ],
        "poo-storm": [
            448,
            512,
            [],
            "f75a",
            "M308 336h-57.7l17.3-64.9c2-7.6-3.7-15.1-11.6-15.1h-68c-6 0-11.1 4.5-11.9 10.4l-16 120c-1 7.2 4.6 13.6 11.9 13.6h59.3l-23 97.2c-1.8 7.6 4 14.8 11.7 14.8 4.2 0 8.2-2.2 10.4-6l88-152c4.6-8-1.2-18-10.4-18zm66.4-111.3c5.9-9.6 9.6-20.6 9.6-32.7 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C218.3 14.6 224 30.6 224 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 12.1 3.7 23.1 9.6 32.7C32.6 228 0 262.2 0 304c0 44 36 80 80 80h48.3c.1-.6 0-1.2 0-1.8l16-120c3-21.8 21.7-38.2 43.7-38.2h68c13.8 0 26.5 6.3 34.9 17.2s11.2 24.8 7.6 38.1l-6.6 24.7h16c15.7 0 30.3 8.4 38.1 22 7.8 13.6 7.8 30.5 0 44l-8.1 14h30c44 0 80-36 80-80 .1-41.8-32.5-76-73.5-79.3z"
        ],
        poop: [
            512,
            512,
            [],
            "f619",
            "M451.36 369.14C468.66 355.99 480 335.41 480 312c0-39.77-32.24-72-72-72h-14.07c13.42-11.73 22.07-28.78 22.07-48 0-35.35-28.65-64-64-64h-5.88c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96-5.17 0-10.15.74-15.11 1.52C250.31 14.64 256 30.62 256 48c0 44.18-35.82 80-80 80h-16c-35.35 0-64 28.65-64 64 0 19.22 8.65 36.27 22.07 48H104c-39.76 0-72 32.23-72 72 0 23.41 11.34 43.99 28.64 57.14C26.31 374.62 0 404.12 0 440c0 39.76 32.24 72 72 72h368c39.76 0 72-32.24 72-72 0-35.88-26.31-65.38-60.64-70.86z"
        ],
        portrait: [
            384,
            512,
            [],
            "f3e0",
            "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM192 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 384 80 375.4 80 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
        ],
        "pound-sign": [
            320,
            512,
            [],
            "f154",
            "M308 352h-45.495c-6.627 0-12 5.373-12 12v50.848H128V288h84c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-84v-63.556c0-32.266 24.562-57.086 61.792-57.086 23.658 0 45.878 11.505 57.652 18.849 5.151 3.213 11.888 2.051 15.688-2.685l28.493-35.513c4.233-5.276 3.279-13.005-2.119-17.081C273.124 54.56 236.576 32 187.931 32 106.026 32 48 84.742 48 157.961V224H20c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h28v128H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h296c6.627 0 12-5.373 12-12V364c0-6.627-5.373-12-12-12z"
        ],
        "power-off": [
            512,
            512,
            [],
            "f011",
            "M400 54.1c63 45 104 118.6 104 201.9 0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 173.1 48.9 99.3 111.8 54.2c11.7-8.3 28-4.8 35 7.7L162.6 90c5.9 10.5 3.1 23.8-6.6 31-41.5 30.8-68 79.6-68 134.9-.1 92.3 74.5 168.1 168 168.1 91.6 0 168.6-74.2 168-169.1-.3-51.8-24.7-101.8-68.1-134-9.7-7.2-12.4-20.5-6.5-30.9l15.8-28.1c7-12.4 23.2-16.1 34.8-7.8zM296 264V24c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24z"
        ],
        pray: [
            384,
            512,
            [],
            "f683",
            "M256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-30.63 169.75c14.06 16.72 39 19.09 55.97 5.22l88-72.02c17.09-13.98 19.59-39.19 5.62-56.28-13.97-17.11-39.19-19.59-56.31-5.62l-57.44 47-38.91-46.31c-15.44-18.39-39.22-27.92-64-25.33-24.19 2.48-45.25 16.27-56.37 36.92l-49.37 92.03c-23.4 43.64-8.69 96.37 34.19 123.75L131.56 432H40c-22.09 0-40 17.91-40 40s17.91 40 40 40h208c34.08 0 53.77-42.79 28.28-68.28L166.42 333.86l34.8-64.87 24.15 28.76z"
        ],
        "praying-hands": [
            640,
            512,
            [],
            "f684",
            "M272 191.91c-17.6 0-32 14.4-32 32v80c0 8.84-7.16 16-16 16s-16-7.16-16-16v-76.55c0-17.39 4.72-34.47 13.69-49.39l77.75-129.59c9.09-15.16 4.19-34.81-10.97-43.91-14.45-8.67-32.72-4.3-42.3 9.21-.2.23-.62.21-.79.48l-117.26 175.9C117.56 205.9 112 224.31 112 243.29v80.23l-90.12 30.04A31.974 31.974 0 0 0 0 383.91v96c0 10.82 8.52 32 32 32 2.69 0 5.41-.34 8.06-1.03l179.19-46.62C269.16 449.99 304 403.8 304 351.91v-128c0-17.6-14.4-32-32-32zm346.12 161.73L528 323.6v-80.23c0-18.98-5.56-37.39-16.12-53.23L394.62 14.25c-.18-.27-.59-.24-.79-.48-9.58-13.51-27.85-17.88-42.3-9.21-15.16 9.09-20.06 28.75-10.97 43.91l77.75 129.59c8.97 14.92 13.69 32 13.69 49.39V304c0 8.84-7.16 16-16 16s-16-7.16-16-16v-80c0-17.6-14.4-32-32-32s-32 14.4-32 32v128c0 51.89 34.84 98.08 84.75 112.34l179.19 46.62c2.66.69 5.38 1.03 8.06 1.03 23.48 0 32-21.18 32-32v-96c0-13.77-8.81-25.99-21.88-30.35z"
        ],
        prescription: [
            384,
            512,
            [],
            "f5b1",
            "M301.26 352l78.06-78.06c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0L256 306.74l-83.96-83.96C219.31 216.8 256 176.89 256 128c0-53.02-42.98-96-96-96H16C7.16 32 0 39.16 0 48v256c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-80h18.75l128 128-78.06 78.06c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0L256 397.25l78.06 78.06c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63L301.26 352zM64 96h96c17.64 0 32 14.36 32 32s-14.36 32-32 32H64V96z"
        ],
        "prescription-bottle": [
            384,
            512,
            [],
            "f485",
            "M32 192h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v64zM360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24z"
        ],
        "prescription-bottle-alt": [
            384,
            512,
            [],
            "f486",
            "M360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24zM32 480c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v352zm64-184c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48z"
        ],
        print: [
            512,
            512,
            [],
            "f02f",
            "M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
        ],
        procedures: [
            640,
            512,
            [],
            "f487",
            "M528 224H272c-8.8 0-16 7.2-16 16v144H64V144c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h512v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-61.9-50.1-112-112-112zM136 96h126.1l27.6 55.2c5.9 11.8 22.7 11.8 28.6 0L368 51.8 390.1 96H512c8.8 0 16-7.2 16-16s-7.2-16-16-16H409.9L382.3 8.8C376.4-3 359.6-3 353.7 8.8L304 108.2l-19.9-39.8c-1.4-2.7-4.1-4.4-7.2-4.4H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm24 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"
        ],
        "project-diagram": [
            640,
            512,
            [],
            "f542",
            "M384 320H256c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM192 32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C211.98 300.98 232.4 288 256 288h.28L192 175.51V128h224V64H192V32zM608 0H480c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32z"
        ],
        "pump-medical": [
            384,
            512,
            [],
            "e06a",
            "M235.51,159.82H84.24A64,64,0,0,0,20.51,218L.14,442a64,64,0,0,0,63.74,69.8h192A64,64,0,0,0,319.61,442L299.24,218A64,64,0,0,0,235.51,159.82Zm4.37,173.33a13.35,13.35,0,0,1-13.34,13.34h-40v40a13.33,13.33,0,0,1-13.33,13.33H146.54a13.33,13.33,0,0,1-13.33-13.33v-40h-40a13.34,13.34,0,0,1-13.33-13.34V306.49a13.33,13.33,0,0,1,13.33-13.34h40v-40a13.33,13.33,0,0,1,13.33-13.33h26.67a13.33,13.33,0,0,1,13.33,13.33v40h40a13.34,13.34,0,0,1,13.34,13.34ZM379.19,93.88,335.87,50.56a64,64,0,0,0-45.24-18.74H223.88a32,32,0,0,0-32-32h-64a32,32,0,0,0-32,32v96h128v-32h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.19,93.88Z"
        ],
        "pump-soap": [
            384,
            512,
            [],
            "e06b",
            "M235.63,160H84.37a64,64,0,0,0-63.74,58.21L.27,442.21A64,64,0,0,0,64,512H256a64,64,0,0,0,63.74-69.79l-20.36-224A64,64,0,0,0,235.63,160ZM160,416c-33.12,0-60-26.33-60-58.75,0-25,35.7-75.47,52-97.27A10,10,0,0,1,168,260c16.33,21.8,52,72.27,52,97.27C220,389.67,193.12,416,160,416ZM379.31,94.06,336,50.74A64,64,0,0,0,290.75,32H224A32,32,0,0,0,192,0H128A32,32,0,0,0,96,32v96H224V96h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.31,94.06Z"
        ],
        "puzzle-piece": [
            576,
            512,
            [],
            "f12e",
            "M519.442 288.651c-41.519 0-59.5 31.593-82.058 31.593C377.409 320.244 432 144 432 144s-196.288 80-196.288-3.297c0-35.827 36.288-46.25 36.288-85.985C272 19.216 243.885 0 210.539 0c-34.654 0-66.366 18.891-66.366 56.346 0 41.364 31.711 59.277 31.711 81.75C175.885 207.719 0 166.758 0 166.758v333.237s178.635 41.047 178.635-28.662c0-22.473-40-40.107-40-81.471 0-37.456 29.25-56.346 63.577-56.346 33.673 0 61.788 19.216 61.788 54.717 0 39.735-36.288 50.158-36.288 85.985 0 60.803 129.675 25.73 181.23 25.73 0 0-34.725-120.101 25.827-120.101 35.962 0 46.423 36.152 86.308 36.152C556.712 416 576 387.99 576 354.443c0-34.199-18.962-65.792-56.558-65.792z"
        ],
        qrcode: [
            448,
            512,
            [],
            "f029",
            "M0 224h192V32H0v192zM64 96h64v64H64V96zm192-64v192h192V32H256zm128 128h-64V96h64v64zM0 480h192V288H0v192zm64-128h64v64H64v-64zm352-64h32v128h-96v-32h-32v96h-64V288h96v32h64v-32zm0 160h32v32h-32v-32zm-64 0h32v32h-32v-32z"
        ],
        question: [
            384,
            512,
            [],
            "f128",
            "M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z"
        ],
        "question-circle": [
            512,
            512,
            [],
            "f059",
            "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z"
        ],
        quidditch: [
            640,
            512,
            [],
            "f458",
            "M256.5 216.8L343.2 326s-16.6 102.4-76.6 150.1C206.7 523.8 0 510.2 0 510.2s3.8-23.1 11-55.4l94.6-112.2c4-4.7-.9-11.6-6.6-9.5l-60.4 22.1c14.4-41.7 32.7-80 54.6-97.5 59.9-47.8 163.3-40.9 163.3-40.9zm238 135c-44 0-79.8 35.8-79.8 79.9 0 44.1 35.7 79.9 79.8 79.9 44.1 0 79.8-35.8 79.8-79.9 0-44.2-35.8-79.9-79.8-79.9zM636.5 31L616.7 6c-5.5-6.9-15.5-8-22.4-2.6L361.8 181.3l-34.1-43c-5.1-6.4-15.1-5.2-18.6 2.2l-25.3 54.6 86.7 109.2 58.8-12.4c8-1.7 11.4-11.2 6.3-17.6l-34.1-42.9L634 53.5c6.9-5.5 8-15.6 2.5-22.5z"
        ],
        "quote-left": [
            512,
            512,
            [],
            "f10d",
            "M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
        ],
        "quote-right": [
            512,
            512,
            [],
            "f10e",
            "M464 32H336c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48zm-288 0H48C21.5 32 0 53.5 0 80v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48z"
        ],
        quran: [
            448,
            512,
            [],
            "f687",
            "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM301.08 145.82c.6-1.21 1.76-1.82 2.92-1.82s2.32.61 2.92 1.82l11.18 22.65 25 3.63c2.67.39 3.74 3.67 1.81 5.56l-18.09 17.63 4.27 24.89c.36 2.11-1.31 3.82-3.21 3.82-.5 0-1.02-.12-1.52-.38L304 211.87l-22.36 11.75c-.5.26-1.02.38-1.52.38-1.9 0-3.57-1.71-3.21-3.82l4.27-24.89-18.09-17.63c-1.94-1.89-.87-5.17 1.81-5.56l24.99-3.63 11.19-22.65zm-57.89-69.01c13.67 0 27.26 2.49 40.38 7.41a6.775 6.775 0 1 1-2.38 13.12c-.67 0-3.09-.21-4.13-.21-52.31 0-94.86 42.55-94.86 94.86 0 52.3 42.55 94.86 94.86 94.86 1.03 0 3.48-.21 4.13-.21 3.93 0 6.8 3.14 6.8 6.78 0 2.98-1.94 5.51-4.62 6.42-13.07 4.87-26.59 7.34-40.19 7.34C179.67 307.19 128 255.51 128 192c0-63.52 51.67-115.19 115.19-115.19zM380.8 448H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"
        ],
        radiation: [
            496,
            512,
            [],
            "f7b9",
            "M328.2 255.8h151.6c9.1 0 16.8-7.7 16.2-16.8-5.1-75.8-44.4-142.2-102.5-184.2-7.4-5.3-17.9-2.9-22.7 4.8L290.4 188c22.6 14.3 37.8 39.2 37.8 67.8zm-37.8 67.7c-12.3 7.7-26.8 12.4-42.4 12.4-15.6 0-30-4.7-42.4-12.4L125.2 452c-4.8 7.7-2.4 18.1 5.6 22.4C165.7 493.2 205.6 504 248 504s82.3-10.8 117.2-29.6c8-4.3 10.4-14.8 5.6-22.4l-80.4-128.5zM248 303.8c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm-231.8-48h151.6c0-28.6 15.2-53.5 37.8-67.7L125.2 59.7c-4.8-7.7-15.3-10.2-22.7-4.8C44.4 96.9 5.1 163.3 0 239.1c-.6 9 7.1 16.7 16.2 16.7z"
        ],
        "radiation-alt": [
            496,
            512,
            [],
            "f7ba",
            "M312 256h79.1c9.2 0 16.9-7.7 16-16.8-4.6-43.6-27-81.8-59.5-107.8-7.6-6.1-18.8-4.5-24 3.8L281.9 202c18 11.2 30.1 31.2 30.1 54zm-97.8 54.1L172.4 377c-4.9 7.8-2.4 18.4 5.8 22.5 21.1 10.4 44.7 16.5 69.8 16.5s48.7-6.1 69.9-16.5c8.2-4.1 10.6-14.7 5.8-22.5l-41.8-66.9c-9.8 6.2-21.4 9.9-33.8 9.9s-24.1-3.7-33.9-9.9zM104.9 256H184c0-22.8 12.1-42.8 30.2-54.1l-41.7-66.8c-5.2-8.3-16.4-9.9-24-3.8-32.6 26-54.9 64.2-59.5 107.8-1.1 9.2 6.7 16.9 15.9 16.9zM248 504c137 0 248-111 248-248S385 8 248 8 0 119 0 256s111 248 248 248zm0-432c101.5 0 184 82.5 184 184s-82.5 184-184 184S64 357.5 64 256 146.5 72 248 72zm0 216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
        ],
        rainbow: [
            576,
            512,
            [],
            "f75b",
            "M268.3 32.7C115.4 42.9 0 176.9 0 330.2V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C64 186.8 180.9 80.3 317.5 97.9 430.4 112.4 512 214 512 327.8V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-165.3-140-298.6-307.7-287.3zm-5.6 96.9C166 142 96 229.1 96 326.7V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-74.8 64.5-134.8 140.8-127.4 66.5 6.5 115.2 66.2 115.2 133.1V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-114.2-100.2-205.4-217.3-190.4zm6.2 96.3c-45.6 8.9-76.9 51.5-76.9 97.9V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-17.6 14.3-32 32-32s32 14.4 32 32v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-59.2-53.8-106-115.1-94.1z"
        ],
        random: [
            512,
            512,
            [],
            "f074",
            "M504.971 359.029c9.373 9.373 9.373 24.569 0 33.941l-80 79.984c-15.01 15.01-40.971 4.49-40.971-16.971V416h-58.785a12.004 12.004 0 0 1-8.773-3.812l-70.556-75.596 53.333-57.143L352 336h32v-39.981c0-21.438 25.943-31.998 40.971-16.971l80 79.981zM12 176h84l52.781 56.551 53.333-57.143-70.556-75.596A11.999 11.999 0 0 0 122.785 96H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12zm372 0v39.984c0 21.46 25.961 31.98 40.971 16.971l80-79.984c9.373-9.373 9.373-24.569 0-33.941l-80-79.981C409.943 24.021 384 34.582 384 56.019V96h-58.785a12.004 12.004 0 0 0-8.773 3.812L96 336H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h110.785c3.326 0 6.503-1.381 8.773-3.812L352 176h32z"
        ],
        receipt: [
            384,
            512,
            [],
            "f543",
            "M358.4 3.2L320 48 265.6 3.2a15.9 15.9 0 0 0-19.2 0L192 48 137.6 3.2a15.9 15.9 0 0 0-19.2 0L64 48 25.6 3.2C15-4.7 0 2.8 0 16v480c0 13.2 15 20.7 25.6 12.8L64 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L192 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L320 464l38.4 44.8c10.5 7.9 25.6.4 25.6-12.8V16c0-13.2-15-20.7-25.6-12.8zM320 360c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16z"
        ],
        "record-vinyl": [
            512,
            512,
            [],
            "f8d9",
            "M256 152a104 104 0 1 0 104 104 104 104 0 0 0-104-104zm0 128a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm0-272C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 376a128 128 0 1 1 128-128 128 128 0 0 1-128 128z"
        ],
        recycle: [
            512,
            512,
            [],
            "f1b8",
            "M184.561 261.903c3.232 13.997-12.123 24.635-24.068 17.168l-40.736-25.455-50.867 81.402C55.606 356.273 70.96 384 96.012 384H148c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12H96.115c-75.334 0-121.302-83.048-81.408-146.88l50.822-81.388-40.725-25.448c-12.081-7.547-8.966-25.961 4.879-29.158l110.237-25.45c8.611-1.988 17.201 3.381 19.189 11.99l25.452 110.237zm98.561-182.915l41.289 66.076-40.74 25.457c-12.051 7.528-9 25.953 4.879 29.158l110.237 25.45c8.672 1.999 17.215-3.438 19.189-11.99l25.45-110.237c3.197-13.844-11.99-24.719-24.068-17.168l-40.687 25.424-41.263-66.082c-37.521-60.033-125.209-60.171-162.816 0l-17.963 28.766c-3.51 5.62-1.8 13.021 3.82 16.533l33.919 21.195c5.62 3.512 13.024 1.803 16.536-3.817l17.961-28.743c12.712-20.341 41.973-19.676 54.257-.022zM497.288 301.12l-27.515-44.065c-3.511-5.623-10.916-7.334-16.538-3.821l-33.861 21.159c-5.62 3.512-7.33 10.915-3.818 16.536l27.564 44.112c13.257 21.211-2.057 48.96-27.136 48.96H320V336.02c0-14.213-17.242-21.383-27.313-11.313l-80 79.981c-6.249 6.248-6.249 16.379 0 22.627l80 79.989C302.689 517.308 320 510.3 320 495.989V448h95.88c75.274 0 121.335-82.997 81.408-146.88z"
        ],
        redo: [
            512,
            512,
            [],
            "f01e",
            "M500.33 0h-47.41a12 12 0 0 0-12 12.57l4 82.76A247.42 247.42 0 0 0 256 8C119.34 8 7.9 119.53 8 256.19 8.1 393.07 119.1 504 256 504a247.1 247.1 0 0 0 166.18-63.91 12 12 0 0 0 .48-17.43l-34-34a12 12 0 0 0-16.38-.55A176 176 0 1 1 402.1 157.8l-101.53-4.87a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12h200.33a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12z"
        ],
        "redo-alt": [
            512,
            512,
            [],
            "f2f9",
            "M256.455 8c66.269.119 126.437 26.233 170.859 68.685l35.715-35.715C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.75c-30.864-28.899-70.801-44.907-113.23-45.273-92.398-.798-170.283 73.977-169.484 169.442C88.764 348.009 162.184 424 256 424c41.127 0 79.997-14.678 110.629-41.556 4.743-4.161 11.906-3.908 16.368.553l39.662 39.662c4.872 4.872 4.631 12.815-.482 17.433C378.202 479.813 319.926 504 256 504 119.034 504 8.001 392.967 8 256.002 7.999 119.193 119.646 7.755 256.455 8z"
        ],
        registered: [
            512,
            512,
            [],
            "f25d",
            "M285.363 207.475c0 18.6-9.831 28.431-28.431 28.431h-29.876v-56.14h23.378c28.668 0 34.929 8.773 34.929 27.709zM504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM363.411 360.414c-46.729-84.825-43.299-78.636-44.702-80.98 23.432-15.172 37.945-42.979 37.945-74.486 0-54.244-31.5-89.252-105.498-89.252h-70.667c-13.255 0-24 10.745-24 24V372c0 13.255 10.745 24 24 24h22.567c13.255 0 24-10.745 24-24v-71.663h25.556l44.129 82.937a24.001 24.001 0 0 0 21.188 12.727h24.464c18.261-.001 29.829-19.591 21.018-35.587z"
        ],
        "remove-format": [
            640,
            512,
            [],
            "f87d",
            "M336 416h-11.17l9.26-27.77L267 336.4 240.49 416H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm297.82 42.1L377 259.59 426.17 112H544v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H176a16 16 0 0 0-16 16v43.9L45.46 3.38A16 16 0 0 0 23 6.19L3.37 31.46a16 16 0 0 0 2.81 22.45l588.36 454.72a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zM309.91 207.76L224 141.36V112h117.83z"
        ],
        reply: [
            512,
            512,
            [],
            "f3e5",
            "M8.309 189.836L184.313 37.851C199.719 24.546 224 35.347 224 56.015v80.053c160.629 1.839 288 34.032 288 186.258 0 61.441-39.581 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 45.344-145.012-21.507-183.51-176.59-185.742V360c0 20.7-24.3 31.453-39.687 18.164l-176.004-152c-11.071-9.562-11.086-26.753 0-36.328z"
        ],
        "reply-all": [
            576,
            512,
            [],
            "f122",
            "M136.309 189.836L312.313 37.851C327.72 24.546 352 35.348 352 56.015v82.763c129.182 10.231 224 52.212 224 183.548 0 61.441-39.582 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 38.512-123.162-3.922-169.482-112.59-182.015v84.175c0 20.701-24.3 31.453-39.687 18.164L136.309 226.164c-11.071-9.561-11.086-26.753 0-36.328zm-128 36.328L184.313 378.15C199.7 391.439 224 380.687 224 359.986v-15.818l-108.606-93.785A55.96 55.96 0 0 1 96 207.998a55.953 55.953 0 0 1 19.393-42.38L224 71.832V56.015c0-20.667-24.28-31.469-39.687-18.164L8.309 189.836c-11.086 9.575-11.071 26.767 0 36.328z"
        ],
        republican: [
            640,
            512,
            [],
            "f75e",
            "M544 192c0-88.4-71.6-160-160-160H160C71.6 32 0 103.6 0 192v64h544v-64zm-367.7-21.6l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L128 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L272 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L416 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zM624 320h-32c-8.8 0-16 7.2-16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H0v176c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-80h192v80c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V352h32v43.3c0 41.8 30 80.1 71.6 84.3 47.8 4.9 88.4-32.7 88.4-79.6v-64c0-8.8-7.2-16-16-16z"
        ],
        restroom: [
            640,
            512,
            [],
            "f7bd",
            "M128 128c35.3 0 64-28.7 64-64S163.3 0 128 0 64 28.7 64 64s28.7 64 64 64zm384 0c35.3 0 64-28.7 64-64S547.3 0 512 0s-64 28.7-64 64 28.7 64 64 64zm127.3 226.5l-45.6-185.8c-3.3-13.5-15.5-23-29.8-24.2-15 9.7-32.8 15.5-52 15.5-19.2 0-37-5.8-52-15.5-14.3 1.2-26.5 10.7-29.8 24.2l-45.6 185.8C381 369.6 393 384 409.2 384H464v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V384h54.8c16.2 0 28.2-14.4 24.5-29.5zM336 0h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zM180.1 144.4c-15 9.8-32.9 15.6-52.1 15.6-19.2 0-37.1-5.8-52.1-15.6C51.3 146.5 32 166.9 32 192v136c0 13.3 10.7 24 24 24h8v136c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V352h8c13.3 0 24-10.7 24-24V192c0-25.1-19.3-45.5-43.9-47.6z"
        ],
        retweet: [
            640,
            512,
            [],
            "f079",
            "M629.657 343.598L528.971 444.284c-9.373 9.372-24.568 9.372-33.941 0L394.343 343.598c-9.373-9.373-9.373-24.569 0-33.941l10.823-10.823c9.562-9.562 25.133-9.34 34.419.492L480 342.118V160H292.451a24.005 24.005 0 0 1-16.971-7.029l-16-16C244.361 121.851 255.069 96 276.451 96H520c13.255 0 24 10.745 24 24v222.118l40.416-42.792c9.285-9.831 24.856-10.054 34.419-.492l10.823 10.823c9.372 9.372 9.372 24.569-.001 33.941zm-265.138 15.431A23.999 23.999 0 0 0 347.548 352H160V169.881l40.416 42.792c9.286 9.831 24.856 10.054 34.419.491l10.822-10.822c9.373-9.373 9.373-24.569 0-33.941L144.971 67.716c-9.373-9.373-24.569-9.373-33.941 0L10.343 168.402c-9.373 9.373-9.373 24.569 0 33.941l10.822 10.822c9.562 9.562 25.133 9.34 34.419-.491L96 169.881V392c0 13.255 10.745 24 24 24h243.549c21.382 0 32.09-25.851 16.971-40.971l-16.001-16z"
        ],
        ribbon: [
            448,
            512,
            [],
            "f4d6",
            "M6.1 444.3c-9.6 10.8-7.5 27.6 4.5 35.7l68.8 27.9c9.9 6.7 23.3 5 31.3-3.8l91.8-101.9-79.2-87.9-117.2 130zm435.8 0s-292-324.6-295.4-330.1c15.4-8.4 40.2-17.9 77.5-17.9s62.1 9.5 77.5 17.9c-3.3 5.6-56 64.6-56 64.6l79.1 87.7 34.2-38c28.7-31.9 33.3-78.6 11.4-115.5l-43.7-73.5c-4.3-7.2-9.9-13.3-16.8-18-40.7-27.6-127.4-29.7-171.4 0-6.9 4.7-12.5 10.8-16.8 18l-43.6 73.2c-1.5 2.5-37.1 62.2 11.5 116L337.5 504c8 8.9 21.4 10.5 31.3 3.8l68.8-27.9c11.9-8 14-24.8 4.3-35.6z"
        ],
        ring: [
            512,
            512,
            [],
            "f70b",
            "M256 64C110.06 64 0 125.91 0 208v98.13C0 384.48 114.62 448 256 448s256-63.52 256-141.87V208c0-82.09-110.06-144-256-144zm0 64c106.04 0 192 35.82 192 80 0 9.26-3.97 18.12-10.91 26.39C392.15 208.21 328.23 192 256 192s-136.15 16.21-181.09 42.39C67.97 226.12 64 217.26 64 208c0-44.18 85.96-80 192-80zM120.43 264.64C155.04 249.93 201.64 240 256 240s100.96 9.93 135.57 24.64C356.84 279.07 308.93 288 256 288s-100.84-8.93-135.57-23.36z"
        ],
        road: [
            576,
            512,
            [],
            "f018",
            "M573.19 402.67l-139.79-320C428.43 71.29 417.6 64 405.68 64h-97.59l2.45 23.16c.5 4.72-3.21 8.84-7.96 8.84h-29.16c-4.75 0-8.46-4.12-7.96-8.84L267.91 64h-97.59c-11.93 0-22.76 7.29-27.73 18.67L2.8 402.67C-6.45 423.86 8.31 448 30.54 448h196.84l10.31-97.68c.86-8.14 7.72-14.32 15.91-14.32h68.8c8.19 0 15.05 6.18 15.91 14.32L348.62 448h196.84c22.23 0 36.99-24.14 27.73-45.33zM260.4 135.16a8 8 0 0 1 7.96-7.16h39.29c4.09 0 7.53 3.09 7.96 7.16l4.6 43.58c.75 7.09-4.81 13.26-11.93 13.26h-40.54c-7.13 0-12.68-6.17-11.93-13.26l4.59-43.58zM315.64 304h-55.29c-9.5 0-16.91-8.23-15.91-17.68l5.07-48c.86-8.14 7.72-14.32 15.91-14.32h45.15c8.19 0 15.05 6.18 15.91 14.32l5.07 48c1 9.45-6.41 17.68-15.91 17.68z"
        ],
        robot: [
            640,
            512,
            [],
            "f544",
            "M32,224H64V416H32A31.96166,31.96166,0,0,1,0,384V256A31.96166,31.96166,0,0,1,32,224Zm512-48V448a64.06328,64.06328,0,0,1-64,64H160a64.06328,64.06328,0,0,1-64-64V176a79.974,79.974,0,0,1,80-80H288V32a32,32,0,0,1,64,0V96H464A79.974,79.974,0,0,1,544,176ZM264,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,264,256Zm-8,128H192v32h64Zm96,0H288v32h64ZM456,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,456,256Zm-8,128H384v32h64ZM640,256V384a31.96166,31.96166,0,0,1-32,32H576V224h32A31.96166,31.96166,0,0,1,640,256Z"
        ],
        rocket: [
            512,
            512,
            [],
            "f135",
            "M505.12019,19.09375c-1.18945-5.53125-6.65819-11-12.207-12.1875C460.716,0,435.507,0,410.40747,0,307.17523,0,245.26909,55.20312,199.05238,128H94.83772c-16.34763.01562-35.55658,11.875-42.88664,26.48438L2.51562,253.29688A28.4,28.4,0,0,0,0,264a24.00867,24.00867,0,0,0,24.00582,24H127.81618l-22.47457,22.46875c-11.36521,11.36133-12.99607,32.25781,0,45.25L156.24582,406.625c11.15623,11.1875,32.15619,13.15625,45.27726,0l22.47457-22.46875V488a24.00867,24.00867,0,0,0,24.00581,24,28.55934,28.55934,0,0,0,10.707-2.51562l98.72834-49.39063c14.62888-7.29687,26.50776-26.5,26.50776-42.85937V312.79688c72.59753-46.3125,128.03493-108.40626,128.03493-211.09376C512.07526,76.5,512.07526,51.29688,505.12019,19.09375ZM384.04033,168A40,40,0,1,1,424.05,128,40.02322,40.02322,0,0,1,384.04033,168Z"
        ],
        route: [
            512,
            512,
            [],
            "f4d7",
            "M416 320h-96c-17.6 0-32-14.4-32-32s14.4-32 32-32h96s96-107 96-160-43-96-96-96-96 43-96 96c0 25.5 22.2 63.4 45.3 96H320c-52.9 0-96 43.1-96 96s43.1 96 96 96h96c17.6 0 32 14.4 32 32s-14.4 32-32 32H185.5c-16 24.8-33.8 47.7-47.3 64H416c52.9 0 96-43.1 96-96s-43.1-96-96-96zm0-256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM96 256c-53 0-96 43-96 96s96 160 96 160 96-107 96-160-43-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
        ],
        rss: [
            448,
            512,
            [],
            "f09e",
            "M128.081 415.959c0 35.369-28.672 64.041-64.041 64.041S0 451.328 0 415.959s28.672-64.041 64.041-64.041 64.04 28.673 64.04 64.041zm175.66 47.25c-8.354-154.6-132.185-278.587-286.95-286.95C7.656 175.765 0 183.105 0 192.253v48.069c0 8.415 6.49 15.472 14.887 16.018 111.832 7.284 201.473 96.702 208.772 208.772.547 8.397 7.604 14.887 16.018 14.887h48.069c9.149.001 16.489-7.655 15.995-16.79zm144.249.288C439.596 229.677 251.465 40.445 16.503 32.01 7.473 31.686 0 38.981 0 48.016v48.068c0 8.625 6.835 15.645 15.453 15.999 191.179 7.839 344.627 161.316 352.465 352.465.353 8.618 7.373 15.453 15.999 15.453h48.068c9.034-.001 16.329-7.474 16.005-16.504z"
        ],
        "rss-square": [
            448,
            512,
            [],
            "f143",
            "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM112 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm157.533 0h-34.335c-6.011 0-11.051-4.636-11.442-10.634-5.214-80.05-69.243-143.92-149.123-149.123-5.997-.39-10.633-5.431-10.633-11.441v-34.335c0-6.535 5.468-11.777 11.994-11.425 110.546 5.974 198.997 94.536 204.964 204.964.352 6.526-4.89 11.994-11.425 11.994zm103.027 0h-34.334c-6.161 0-11.175-4.882-11.427-11.038-5.598-136.535-115.204-246.161-251.76-251.76C68.882 152.949 64 147.935 64 141.774V107.44c0-6.454 5.338-11.664 11.787-11.432 167.83 6.025 302.21 141.191 308.205 308.205.232 6.449-4.978 11.787-11.432 11.787z"
        ],
        "ruble-sign": [
            384,
            512,
            [],
            "f158",
            "M239.36 320C324.48 320 384 260.542 384 175.071S324.48 32 239.36 32H76c-6.627 0-12 5.373-12 12v206.632H12c-6.627 0-12 5.373-12 12V308c0 6.627 5.373 12 12 12h52v32H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v52c0 6.627 5.373 12 12 12h58.56c6.627 0 12-5.373 12-12v-52H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H146.56v-32h92.8zm-92.8-219.252h78.72c46.72 0 74.88 29.11 74.88 74.323 0 45.832-28.16 75.561-76.16 75.561h-77.44V100.748z"
        ],
        ruler: [
            640,
            512,
            [],
            "f545",
            "M635.7 167.2L556.1 31.7c-8.8-15-28.3-20.1-43.5-11.5l-69 39.1L503.3 161c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L416 75l-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L333.2 122 278 153.3 337.8 255c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-59.7-101.7-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-27.9-47.5-55.2 31.3 59.7 101.7c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L84.9 262.9l-69 39.1C.7 310.7-4.6 329.8 4.2 344.8l79.6 135.6c8.8 15 28.3 20.1 43.5 11.5L624.1 210c15.2-8.6 20.4-27.8 11.6-42.8z"
        ],
        "ruler-combined": [
            512,
            512,
            [],
            "f546",
            "M160 288h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56v-64h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56V96h-56c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8h56V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 2.77.91 5.24 1.57 7.8L160 329.38V288zm320 64h-32v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-41.37L24.2 510.43c2.56.66 5.04 1.57 7.8 1.57h448c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
        ],
        "ruler-horizontal": [
            576,
            512,
            [],
            "f547",
            "M544 128h-48v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8H88c-4.42 0-8-3.58-8-8v-88H32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h512c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32z"
        ],
        "ruler-vertical": [
            256,
            512,
            [],
            "f548",
            "M168 416c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 17.67 14.33 32 32 32h192c17.67 0 32-14.33 32-32v-64h-88z"
        ],
        running: [
            416,
            512,
            [],
            "f70c",
            "M272 96c26.51 0 48-21.49 48-48S298.51 0 272 0s-48 21.49-48 48 21.49 48 48 48zM113.69 317.47l-14.8 34.52H32c-17.67 0-32 14.33-32 32s14.33 32 32 32h77.45c19.25 0 36.58-11.44 44.11-29.09l8.79-20.52-10.67-6.3c-17.32-10.23-30.06-25.37-37.99-42.61zM384 223.99h-44.03l-26.06-53.25c-12.5-25.55-35.45-44.23-61.78-50.94l-71.08-21.14c-28.3-6.8-57.77-.55-80.84 17.14l-39.67 30.41c-14.03 10.75-16.69 30.83-5.92 44.86s30.84 16.66 44.86 5.92l39.69-30.41c7.67-5.89 17.44-8 25.27-6.14l14.7 4.37-37.46 87.39c-12.62 29.48-1.31 64.01 26.3 80.31l84.98 50.17-27.47 87.73c-5.28 16.86 4.11 34.81 20.97 40.09 3.19 1 6.41 1.48 9.58 1.48 13.61 0 26.23-8.77 30.52-22.45l31.64-101.06c5.91-20.77-2.89-43.08-21.64-54.39l-61.24-36.14 31.31-78.28 20.27 41.43c8 16.34 24.92 26.89 43.11 26.89H384c17.67 0 32-14.33 32-32s-14.33-31.99-32-31.99z"
        ],
        "rupee-sign": [
            320,
            512,
            [],
            "f156",
            "M308 96c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v44.748c0 6.627 5.373 12 12 12h85.28c27.308 0 48.261 9.958 60.97 27.252H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h158.757c-6.217 36.086-32.961 58.632-74.757 58.632H12c-6.627 0-12 5.373-12 12v53.012c0 3.349 1.4 6.546 3.861 8.818l165.052 152.356a12.001 12.001 0 0 0 8.139 3.182h82.562c10.924 0 16.166-13.408 8.139-20.818L116.871 319.906c76.499-2.34 131.144-53.395 138.318-127.906H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-58.69c-3.486-11.541-8.28-22.246-14.252-32H308z"
        ],
        "sad-cry": [
            496,
            512,
            [],
            "f5b3",
            "M248 8C111 8 0 119 0 256c0 90.1 48.2 168.7 120 212.1V288c0-8.8 7.2-16 16-16s16 7.2 16 16v196.7c29.5 12.4 62 19.3 96 19.3s66.5-6.9 96-19.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v180.1C447.8 424.7 496 346 496 256 496 119 385 8 248 8zm-65.5 216.5c-14.8-13.2-46.2-13.2-61 0L112 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c.8 5-1.7 10-6.1 12.4-5.8 3.1-11.2.7-13.7-1.6l-9.7-8.5zM248 416c-26.5 0-48-28.7-48-64s21.5-64 48-64 48 28.7 48 64-21.5 64-48 64zm149.8-181.5c-5.8 3.1-11.2.7-13.7-1.6l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S400 197 404 222.2c.6 4.9-1.8 9.9-6.2 12.3z"
        ],
        "sad-tear": [
            496,
            512,
            [],
            "f5b4",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM152 416c-26.5 0-48-21-48-47 0-20 28.5-60.4 41.6-77.8 3.2-4.3 9.6-4.3 12.8 0C171.5 308.6 200 349 200 369c0 26-21.5 47-48 47zm16-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm170.2 154.2C315.8 367.4 282.9 352 248 352c-21.2 0-21.2-32 0-32 44.4 0 86.3 19.6 114.7 53.8 13.8 16.4-11.2 36.5-24.5 20.4z"
        ],
        satellite: [
            512,
            512,
            [],
            "f7bf",
            "M502.60969,310.04206l-96.70393,96.71625a31.88151,31.88151,0,0,1-45.00765,0L280.572,326.34115l-9.89231,9.90759a190.56343,190.56343,0,0,1-5.40716,168.52287c-4.50077,8.50115-16.39342,9.59505-23.20707,2.79725L134.54715,400.05428l-17.7999,17.79929c.70324,2.60972,1.60965,5.00067,1.60965,7.79793a32.00544,32.00544,0,1,1-32.00544-32.00434c2.79735,0,5.18838.90637,7.7982,1.60959l17.7999-17.79929L4.43129,269.94287c-6.798-6.81342-5.70409-18.6119,2.79735-23.20627a190.58161,190.58161,0,0,1,168.52864-5.407l9.79854-9.79821-80.31053-80.41716a32.002,32.002,0,0,1,0-45.09987L201.96474,9.29814A31.62639,31.62639,0,0,1,224.46868,0a31.99951,31.99951,0,0,1,22.59759,9.29814l80.32615,80.30777,47.805-47.89713a33.6075,33.6075,0,0,1,47.50808,0l47.50807,47.50645a33.63308,33.63308,0,0,1,0,47.50644l-47.805,47.89713L502.71908,265.036A31.78938,31.78938,0,0,1,502.60969,310.04206ZM219.56159,197.433l73.82505-73.82252-68.918-68.9-73.80942,73.80689Zm237.74352,90.106-68.90233-68.9156-73.825,73.82252,68.918,68.9Z"
        ],
        "satellite-dish": [
            512,
            512,
            [],
            "f7c0",
            "M305.44954,462.59c7.39157,7.29792,6.18829,20.09661-3.00038,25.00356-77.713,41.80281-176.72559,29.9105-242.34331-35.7082C-5.49624,386.28227-17.404,287.362,24.41381,209.554c4.89125-9.095,17.68975-10.29834,25.00318-3.00043L166.22872,323.36708l27.39411-27.39452c-.68759-2.60974-1.594-5.00071-1.594-7.81361a32.00407,32.00407,0,1,1,32.00407,32.00455c-2.79723,0-5.20378-.89075-7.79786-1.594l-27.40974,27.41015ZM511.9758,303.06732a16.10336,16.10336,0,0,1-16.002,17.00242H463.86031a15.96956,15.96956,0,0,1-15.89265-15.00213C440.46671,175.5492,336.45348,70.53427,207.03078,63.53328a15.84486,15.84486,0,0,1-15.00191-15.90852V16.02652A16.09389,16.09389,0,0,1,209.031.02425C372.25491,8.61922,503.47472,139.841,511.9758,303.06732Zm-96.01221-.29692a16.21093,16.21093,0,0,1-16.11142,17.29934H367.645a16.06862,16.06862,0,0,1-15.89265-14.70522c-6.90712-77.01094-68.118-138.91037-144.92467-145.22376a15.94,15.94,0,0,1-14.79876-15.89289V112.13393a16.134,16.134,0,0,1,17.29908-16.096C319.45132,104.5391,407.55627,192.64538,415.96359,302.7704Z"
        ],
        save: [
            448,
            512,
            [],
            "f0c7",
            "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z"
        ],
        school: [
            640,
            512,
            [],
            "f549",
            "M0 224v272c0 8.84 7.16 16 16 16h80V192H32c-17.67 0-32 14.33-32 32zm360-48h-24v-40c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v64c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm137.75-63.96l-160-106.67a32.02 32.02 0 0 0-35.5 0l-160 106.67A32.002 32.002 0 0 0 128 138.66V512h128V368c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v144h128V138.67c0-10.7-5.35-20.7-14.25-26.63zM320 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm288-64h-64v320h80c8.84 0 16-7.16 16-16V224c0-17.67-14.33-32-32-32z"
        ],
        screwdriver: [
            512,
            512,
            [],
            "f54a",
            "M448 0L320 96v62.06l-83.03 83.03c6.79 4.25 13.27 9.06 19.07 14.87 5.8 5.8 10.62 12.28 14.87 19.07L353.94 192H416l96-128-64-64zM128 278.59L10.92 395.67c-14.55 14.55-14.55 38.15 0 52.71l52.7 52.7c14.56 14.56 38.15 14.56 52.71 0L233.41 384c29.11-29.11 29.11-76.3 0-105.41s-76.3-29.11-105.41 0z"
        ],
        scroll: [
            640,
            512,
            [],
            "f70e",
            "M48 0C21.53 0 0 21.53 0 48v64c0 8.84 7.16 16 16 16h80V48C96 21.53 74.47 0 48 0zm208 412.57V352h288V96c0-52.94-43.06-96-96-96H111.59C121.74 13.41 128 29.92 128 48v368c0 38.87 34.65 69.65 74.75 63.12C234.22 474 256 444.46 256 412.57zM288 384v32c0 52.93-43.06 96-96 96h336c61.86 0 112-50.14 112-112 0-8.84-7.16-16-16-16H288z"
        ],
        "sd-card": [
            384,
            512,
            [],
            "f7c2",
            "M320 0H128L0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 160h-48V64h48v96zm80 0h-48V64h48v96zm80 0h-48V64h48v96z"
        ],
        search: [
            512,
            512,
            [],
            "f002",
            "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
        ],
        "search-dollar": [
            512,
            512,
            [],
            "f688",
            "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm27.11-152.54l-45.01-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V112c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v16.12c-23.63.63-42.68 20.55-42.68 45.07 0 19.97 12.99 37.81 31.58 43.39l45.01 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.1c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V304c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16.12c23.63-.63 42.68-20.54 42.68-45.07 0-19.97-12.99-37.81-31.59-43.39z"
        ],
        "search-location": [
            512,
            512,
            [],
            "f689",
            "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm.02-239.96c-40.78 0-73.84 33.05-73.84 73.83 0 32.96 48.26 93.05 66.75 114.86a9.24 9.24 0 0 0 14.18 0c18.49-21.81 66.75-81.89 66.75-114.86 0-40.78-33.06-73.83-73.84-73.83zm0 96c-13.26 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
        ],
        "search-minus": [
            512,
            512,
            [],
            "f010",
            "M304 192v32c0 6.6-5.4 12-12 12H124c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"
        ],
        "search-plus": [
            512,
            512,
            [],
            "f00e",
            "M304 192v32c0 6.6-5.4 12-12 12h-56v56c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-56h-56c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h56v-56c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v56h56c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"
        ],
        seedling: [
            512,
            512,
            [],
            "f4d8",
            "M64 96H0c0 123.7 100.3 224 224 224v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C288 196.3 187.7 96 64 96zm384-64c-84.2 0-157.4 46.5-195.7 115.2 27.7 30.2 48.2 66.9 59 107.6C424 243.1 512 147.9 512 32h-64z"
        ],
        server: [
            512,
            512,
            [],
            "f233",
            "M480 160H32c-17.673 0-32-14.327-32-32V64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24z"
        ],
        shapes: [
            512,
            512,
            [],
            "f61f",
            "M128,256A128,128,0,1,0,256,384,128,128,0,0,0,128,256Zm379-54.86L400.07,18.29a37.26,37.26,0,0,0-64.14,0L229,201.14C214.76,225.52,232.58,256,261.09,256H474.91C503.42,256,521.24,225.52,507,201.14ZM480,288H320a32,32,0,0,0-32,32V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V320A32,32,0,0,0,480,288Z"
        ],
        share: [
            512,
            512,
            [],
            "f064",
            "M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z"
        ],
        "share-alt": [
            448,
            512,
            [],
            "f1e0",
            "M352 320c-22.608 0-43.387 7.819-59.79 20.895l-102.486-64.054a96.551 96.551 0 0 0 0-41.683l102.486-64.054C308.613 184.181 329.392 192 352 192c53.019 0 96-42.981 96-96S405.019 0 352 0s-96 42.981-96 96c0 7.158.79 14.13 2.276 20.841L155.79 180.895C139.387 167.819 118.608 160 96 160c-53.019 0-96 42.981-96 96s42.981 96 96 96c22.608 0 43.387-7.819 59.79-20.895l102.486 64.054A96.301 96.301 0 0 0 256 416c0 53.019 42.981 96 96 96s96-42.981 96-96-42.981-96-96-96z"
        ],
        "share-alt-square": [
            448,
            512,
            [],
            "f1e1",
            "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zM304 296c-14.562 0-27.823 5.561-37.783 14.671l-67.958-40.775a56.339 56.339 0 0 0 0-27.793l67.958-40.775C276.177 210.439 289.438 216 304 216c30.928 0 56-25.072 56-56s-25.072-56-56-56-56 25.072-56 56c0 4.797.605 9.453 1.74 13.897l-67.958 40.775C171.823 205.561 158.562 200 144 200c-30.928 0-56 25.072-56 56s25.072 56 56 56c14.562 0 27.823-5.561 37.783-14.671l67.958 40.775a56.088 56.088 0 0 0-1.74 13.897c0 30.928 25.072 56 56 56s56-25.072 56-56C360 321.072 334.928 296 304 296z"
        ],
        "share-square": [
            576,
            512,
            [],
            "f14d",
            "M568.482 177.448L424.479 313.433C409.3 327.768 384 317.14 384 295.985v-71.963c-144.575.97-205.566 35.113-164.775 171.353 4.483 14.973-12.846 26.567-25.006 17.33C155.252 383.105 120 326.488 120 269.339c0-143.937 117.599-172.5 264-173.312V24.012c0-21.174 25.317-31.768 40.479-17.448l144.003 135.988c10.02 9.463 10.028 25.425 0 34.896zM384 379.128V448H64V128h50.916a11.99 11.99 0 0 0 8.648-3.693c14.953-15.568 32.237-27.89 51.014-37.676C185.708 80.83 181.584 64 169.033 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48v-88.806c0-8.288-8.197-14.066-16.011-11.302a71.83 71.83 0 0 1-34.189 3.377c-7.27-1.046-13.8 4.514-13.8 11.859z"
        ],
        "shekel-sign": [
            448,
            512,
            [],
            "f20b",
            "M248 168v168c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V168c0-75.11-60.89-136-136-136H24C10.75 32 0 42.74 0 56v408c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112h112c30.93 0 56 25.07 56 56zM432 32h-48c-8.84 0-16 7.16-16 16v296c0 30.93-25.07 56-56 56H200V176c0-8.84-7.16-16-16-16h-48c-8.84 0-16 7.16-16 16v280c0 13.25 10.75 24 24 24h168c75.11 0 136-60.89 136-136V48c0-8.84-7.16-16-16-16z"
        ],
        "shield-alt": [
            512,
            512,
            [],
            "f3ed",
            "M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z"
        ],
        "shield-virus": [
            512,
            512,
            [],
            "e06c",
            "M224,192a16,16,0,1,0,16,16A16,16,0,0,0,224,192ZM466.5,83.68l-192-80A57.4,57.4,0,0,0,256.05,0a57.4,57.4,0,0,0-18.46,3.67l-192,80A47.93,47.93,0,0,0,16,128C16,326.5,130.5,463.72,237.5,508.32a48.09,48.09,0,0,0,36.91,0C360.09,472.61,496,349.3,496,128A48,48,0,0,0,466.5,83.68ZM384,256H371.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C306.47,313.09,272,327.37,272,355.88V368a16,16,0,0,1-32,0V355.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H128a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V112a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C329.09,189.53,343.37,224,371.88,224H384a16,16,0,0,1,0,32Zm-96,0a16,16,0,1,0,16,16A16,16,0,0,0,288,256Z"
        ],
        ship: [
            640,
            512,
            [],
            "f21a",
            "M496.616 372.639l70.012-70.012c16.899-16.9 9.942-45.771-12.836-53.092L512 236.102V96c0-17.673-14.327-32-32-32h-64V24c0-13.255-10.745-24-24-24H248c-13.255 0-24 10.745-24 24v40h-64c-17.673 0-32 14.327-32 32v140.102l-41.792 13.433c-22.753 7.313-29.754 36.173-12.836 53.092l70.012 70.012C125.828 416.287 85.587 448 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24 61.023 0 107.499-20.61 143.258-59.396C181.677 487.432 216.021 512 256 512h128c39.979 0 74.323-24.568 88.742-59.396C508.495 491.384 554.968 512 616 512c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24-60.817 0-101.542-31.001-119.384-75.361zM192 128h256v87.531l-118.208-37.995a31.995 31.995 0 0 0-19.584 0L192 215.531V128z"
        ],
        "shipping-fast": [
            640,
            512,
            [],
            "f48b",
            "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
        ],
        "shoe-prints": [
            640,
            512,
            [],
            "f54b",
            "M192 160h32V32h-32c-35.35 0-64 28.65-64 64s28.65 64 64 64zM0 416c0 35.35 28.65 64 64 64h32V352H64c-35.35 0-64 28.65-64 64zm337.46-128c-34.91 0-76.16 13.12-104.73 32-24.79 16.38-44.52 32-104.73 32v128l57.53 15.97c26.21 7.28 53.01 13.12 80.31 15.05 32.69 2.31 65.6.67 97.58-6.2C472.9 481.3 512 429.22 512 384c0-64-84.18-96-174.54-96zM491.42 7.19C459.44.32 426.53-1.33 393.84.99c-27.3 1.93-54.1 7.77-80.31 15.04L256 32v128c60.2 0 79.94 15.62 104.73 32 28.57 18.88 69.82 32 104.73 32C555.82 224 640 192 640 128c0-45.22-39.1-97.3-148.58-120.81z"
        ],
        "shopping-bag": [
            448,
            512,
            [],
            "f290",
            "M352 160v-32C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128v32H0v272c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V160h-96zm-192-32c0-35.29 28.71-64 64-64s64 28.71 64 64v32H160v-32zm160 120c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm-192 0c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24z"
        ],
        "shopping-basket": [
            576,
            512,
            [],
            "f291",
            "M576 216v16c0 13.255-10.745 24-24 24h-8l-26.113 182.788C514.509 462.435 494.257 480 470.37 480H105.63c-23.887 0-44.139-17.565-47.518-41.212L32 256h-8c-13.255 0-24-10.745-24-24v-16c0-13.255 10.745-24 24-24h67.341l106.78-146.821c10.395-14.292 30.407-17.453 44.701-7.058 14.293 10.395 17.453 30.408 7.058 44.701L170.477 192h235.046L326.12 82.821c-10.395-14.292-7.234-34.306 7.059-44.701 14.291-10.395 34.306-7.235 44.701 7.058L484.659 192H552c13.255 0 24 10.745 24 24zM312 392V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm112 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm-224 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24z"
        ],
        "shopping-cart": [
            576,
            512,
            [],
            "f07a",
            "M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"
        ],
        shower: [
            512,
            512,
            [],
            "f2cc",
            "M304,320a16,16,0,1,0,16,16A16,16,0,0,0,304,320Zm32-96a16,16,0,1,0,16,16A16,16,0,0,0,336,224Zm32,64a16,16,0,1,0-16-16A16,16,0,0,0,368,288Zm-32,32a16,16,0,1,0-16-16A16,16,0,0,0,336,320Zm-32-64a16,16,0,1,0,16,16A16,16,0,0,0,304,256Zm128-32a16,16,0,1,0-16-16A16,16,0,0,0,432,224Zm-48,16a16,16,0,1,0,16-16A16,16,0,0,0,384,240Zm-16-48a16,16,0,1,0,16,16A16,16,0,0,0,368,192Zm96,32a16,16,0,1,0,16,16A16,16,0,0,0,464,224Zm32-32a16,16,0,1,0,16,16A16,16,0,0,0,496,192Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,432,256Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,400,288Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,336,352Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,304,384Zm64-64a16,16,0,1,0,16,16A16,16,0,0,0,368,320Zm21.65-218.35-11.3-11.31a16,16,0,0,0-22.63,0L350.05,96A111.19,111.19,0,0,0,272,64c-19.24,0-37.08,5.3-52.9,13.85l-10-10A121.72,121.72,0,0,0,123.44,32C55.49,31.5,0,92.91,0,160.85V464a16,16,0,0,0,16,16H48a16,16,0,0,0,16-16V158.4c0-30.15,21-58.2,51-61.93a58.38,58.38,0,0,1,48.93,16.67l10,10C165.3,138.92,160,156.76,160,176a111.23,111.23,0,0,0,32,78.05l-5.66,5.67a16,16,0,0,0,0,22.62l11.3,11.31a16,16,0,0,0,22.63,0L389.65,124.28A16,16,0,0,0,389.65,101.65Z"
        ],
        "shuttle-van": [
            640,
            512,
            [],
            "f5b6",
            "M628.88 210.65L494.39 49.27A48.01 48.01 0 0 0 457.52 32H32C14.33 32 0 46.33 0 64v288c0 17.67 14.33 32 32 32h32c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h32c17.67 0 32-14.33 32-32V241.38c0-11.23-3.94-22.1-11.12-30.73zM64 192V96h96v96H64zm96 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm160-240h-96V96h96v96zm160 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-96-240V96h66.02l80 96H384z"
        ],
        sign: [
            512,
            512,
            [],
            "f4d9",
            "M496 64H128V16c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v48H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V128h368c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM160 384h320V160H160v224z"
        ],
        "sign-in-alt": [
            512,
            512,
            [],
            "f2f6",
            "M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zm-47-201L201 79c-15-15-41-4.5-41 17v96H24c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h136v96c0 21.5 26 32 41 17l168-168c9.3-9.4 9.3-24.6 0-34z"
        ],
        "sign-language": [
            448,
            512,
            [],
            "f2a7",
            "M91.434 483.987c-.307-16.018 13.109-29.129 29.13-29.129h62.293v-5.714H56.993c-16.021 0-29.437-13.111-29.13-29.129C28.16 404.491 40.835 392 56.428 392h126.429v-5.714H29.136c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h154.286v-5.714H57.707c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h168.566l-31.085-22.606c-12.762-9.281-15.583-27.149-6.302-39.912 9.281-12.761 27.15-15.582 39.912-6.302l123.361 89.715a34.287 34.287 0 0 1 14.12 27.728v141.136c0 15.91-10.946 29.73-26.433 33.374l-80.471 18.934a137.16 137.16 0 0 1-31.411 3.646H120c-15.593-.001-28.269-12.492-28.566-28.014zm73.249-225.701h36.423l-11.187-8.136c-18.579-13.511-20.313-40.887-3.17-56.536l-13.004-16.7c-9.843-12.641-28.43-15.171-40.88-5.088-12.065 9.771-14.133 27.447-4.553 39.75l36.371 46.71zm283.298-2.103l-5.003-152.452c-.518-15.771-13.722-28.136-29.493-27.619-15.773.518-28.137 13.722-27.619 29.493l1.262 38.415L283.565 11.019c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l76.889 98.745-4.509 3.511-94.79-121.734c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l94.443 121.288-4.509 3.511-77.675-99.754c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l52.053 66.849c12.497-8.257 29.055-8.285 41.69.904l123.36 89.714c10.904 7.93 17.415 20.715 17.415 34.198v16.999l61.064-47.549a34.285 34.285 0 0 0 13.202-28.177z"
        ],
        "sign-out-alt": [
            512,
            512,
            [],
            "f2f5",
            "M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"
        ],
        signal: [
            640,
            512,
            [],
            "f012",
            "M216 288h-48c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V304c0-8.84-7.16-16-16-16zM88 384H40c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16zm256-192h-48c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm128-96h-48c-8.84 0-16 7.16-16 16v384c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112c0-8.84-7.16-16-16-16zM600 0h-48c-8.84 0-16 7.16-16 16v480c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"
        ],
        signature: [
            640,
            512,
            [],
            "f5b7",
            "M623.2 192c-51.8 3.5-125.7 54.7-163.1 71.5-29.1 13.1-54.2 24.4-76.1 24.4-22.6 0-26-16.2-21.3-51.9 1.1-8 11.7-79.2-42.7-76.1-25.1 1.5-64.3 24.8-169.5 126L192 182.2c30.4-75.9-53.2-151.5-129.7-102.8L7.4 116.3C0 121-2.2 130.9 2.5 138.4l17.2 27c4.7 7.5 14.6 9.7 22.1 4.9l58-38.9c18.4-11.7 40.7 7.2 32.7 27.1L34.3 404.1C27.5 421 37 448 64 448c8.3 0 16.5-3.2 22.6-9.4 42.2-42.2 154.7-150.7 211.2-195.8-2.2 28.5-2.1 58.9 20.6 83.8 15.3 16.8 37.3 25.3 65.5 25.3 35.6 0 68-14.6 102.3-30 33-14.8 99-62.6 138.4-65.8 8.5-.7 15.2-7.3 15.2-15.8v-32.1c.2-9.1-7.5-16.8-16.6-16.2z"
        ],
        "sim-card": [
            384,
            512,
            [],
            "f7c4",
            "M0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128L256 0H64C28.7 0 0 28.7 0 64zm224 192h-64v-64h64v64zm96 0h-64v-64h32c17.7 0 32 14.3 32 32v32zm-64 128h64v32c0 17.7-14.3 32-32 32h-32v-64zm-96 0h64v64h-64v-64zm-96 0h64v64H96c-17.7 0-32-14.3-32-32v-32zm0-96h256v64H64v-64zm0-64c0-17.7 14.3-32 32-32h32v64H64v-32z"
        ],
        sink: [
            512,
            512,
            [],
            "e06d",
            "M32,416a96,96,0,0,0,96,96H384a96,96,0,0,0,96-96V384H32ZM496,288H400V256h64a16,16,0,0,0,16-16V224a16,16,0,0,0-16-16H384a32,32,0,0,0-32,32v48H288V96a32,32,0,0,1,64,0v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V96A96.16,96.16,0,0,0,300.87,1.86C255.29,10.71,224,53.36,224,99.79V288H160V240a32,32,0,0,0-32-32H48a16,16,0,0,0-16,16v16a16,16,0,0,0,16,16h64v32H16A16,16,0,0,0,0,304v32a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V304A16,16,0,0,0,496,288Z"
        ],
        sitemap: [
            640,
            512,
            [],
            "f0e8",
            "M128 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-24-80h192v48h48v-48h192v48h48v-57.59c0-21.17-17.23-38.41-38.41-38.41H344v-64h40c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H256c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h40v64H94.41C73.23 224 56 241.23 56 262.41V320h48v-48zm264 80h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm240 0h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
        ],
        skating: [
            448,
            512,
            [],
            "f7c5",
            "M400 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 448c-8.8 0-16 7.2-16 16s-7.2 16-16 16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16zm-282.2 8.6c-6.2 6.2-16.4 6.3-22.6 0l-67.9-67.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l67.9 67.9c9.4 9.4 21.7 14 34 14s24.6-4.7 33.9-14c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.3-22.7 0zm56.1-179.8l-93.7 93.7c-12.5 12.5-12.5 32.8 0 45.2 6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l91.9-91.9-30.2-30.2c-5-5-9.4-10.7-13.2-16.8zM128 160h105.5l-20.1 17.2c-13.5 11.5-21.6 28.4-22.3 46.1-.7 17.8 6.1 35.2 18.7 47.7l78.2 78.2V432c0 17.7 14.3 32 32 32s32-14.3 32-32v-89.4c0-12.6-5.1-25-14.1-33.9l-61-61c.5-.4 1.2-.6 1.7-1.1l82.3-82.3c11.5-11.5 14.9-28.6 8.7-43.6-6.2-15-20.7-24.7-37-24.7H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
        ],
        skiing: [
            512,
            512,
            [],
            "f7c9",
            "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm73 356.1c-9.4-9.4-24.6-9.4-33.9 0-12.1 12.1-30.5 15.4-45.1 8.7l-135.8-70.2 49.2-73.8c12.7-19 10.2-44.5-6-60.6L293 215.7l-107-53.1c-2.9 19.9 3.4 40 17.7 54.4l75.1 75.2-45.9 68.8L35 258.7c-11.7-6-26.2-1.5-32.3 10.3-6.1 11.8-1.5 26.3 10.3 32.3l391.9 202.5c11.9 5.5 24.5 8.1 37.1 8.1 23.2 0 46-9 63-26 9.3-9.3 9.3-24.5 0-33.8zM120 91.6l-11.5 22.5c14.4 7.3 31.2 4.9 42.8-4.8l47.2 23.4c-.1.1-.1.2-.2.3l114.5 56.8 32.4-13 6.4 19.1c4 12.1 12.6 22 24 27.7l58.1 29c15.9 7.9 35 1.5 42.9-14.3 7.9-15.8 1.5-35-14.3-42.9l-52.1-26.1-17.1-51.2c-8.1-24.2-40.9-56.6-84.5-39.2l-81.2 32.5-62.5-31c.3-14.5-7.2-28.6-20.9-35.6l-11.1 21.7h-.2l-34.4-7c-1.8-.4-3.7.2-5 1.7-1.9 2.2-1.7 5.5.5 7.4l26.2 23z"
        ],
        "skiing-nordic": [
            576,
            512,
            [],
            "f7ca",
            "M336 96c26.5 0 48-21.5 48-48S362.5 0 336 0s-48 21.5-48 48 21.5 48 48 48zm216 320c-13.2 0-24 10.7-24 24 0 13.2-10.8 24-24 24h-69.5L460 285.6c11.7-4.7 20.1-16.2 20.1-29.6 0-17.7-14.3-32-32-32h-44L378 170.8c-12.5-25.5-35.5-44.2-61.8-50.9L245 98.7c-28.3-6.8-57.8-.5-80.8 17.1l-39.7 30.4c-14 10.7-16.7 30.8-5.9 44.9.7.9 1.7 1.3 2.4 2.1L66.9 464H24c-13.2 0-24 10.7-24 24s10.8 24 24 24h480c39.7 0 72-32.3 72-72 0-13.2-10.8-24-24-24zm-260.5 48h-96.9l43.1-91-22-13c-12.1-7.2-21.9-16.9-29.5-27.8L123.7 464H99.5l52.3-261.4c4.1-1 8.1-2.9 11.7-5.6l39.7-30.4c7.7-5.9 17.4-8 25.3-6.1l14.7 4.4-37.5 87.4c-12.6 29.5-1.3 64 26.3 80.3l85 50.2-25.5 81.2zm110.6 0h-43.6l23.6-75.5c5.9-20.8-2.9-43.1-21.6-54.4L299.3 298l31.3-78.3 20.3 41.4c8 16.3 24.9 26.9 43.1 26.9h33.3l-25.2 176z"
        ],
        skull: [
            512,
            512,
            [],
            "f54c",
            "M256 0C114.6 0 0 100.3 0 224c0 70.1 36.9 132.6 94.5 173.7 9.6 6.9 15.2 18.1 13.5 29.9l-9.4 66.2c-1.4 9.6 6 18.2 15.7 18.2H192v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h64v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h77.7c9.7 0 17.1-8.6 15.7-18.2l-9.4-66.2c-1.7-11.7 3.8-23 13.5-29.9C475.1 356.6 512 294.1 512 224 512 100.3 397.4 0 256 0zm-96 320c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm192 0c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"
        ],
        "skull-crossbones": [
            448,
            512,
            [],
            "f714",
            "M439.15 453.06L297.17 384l141.99-69.06c7.9-3.95 11.11-13.56 7.15-21.46L432 264.85c-3.95-7.9-13.56-11.11-21.47-7.16L224 348.41 37.47 257.69c-7.9-3.95-17.51-.75-21.47 7.16L1.69 293.48c-3.95 7.9-.75 17.51 7.15 21.46L150.83 384 8.85 453.06c-7.9 3.95-11.11 13.56-7.15 21.47l14.31 28.63c3.95 7.9 13.56 11.11 21.47 7.15L224 419.59l186.53 90.72c7.9 3.95 17.51.75 21.47-7.15l14.31-28.63c3.95-7.91.74-17.52-7.16-21.47zM150 237.28l-5.48 25.87c-2.67 12.62 5.42 24.85 16.45 24.85h126.08c11.03 0 19.12-12.23 16.45-24.85l-5.5-25.87c41.78-22.41 70-62.75 70-109.28C368 57.31 303.53 0 224 0S80 57.31 80 128c0 46.53 28.22 86.87 70 109.28zM280 112c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32zm-112 0c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32z"
        ],
        slash: [
            640,
            512,
            [],
            "f715",
            "M594.53 508.63L6.18 53.9c-6.97-5.42-8.23-15.47-2.81-22.45L23.01 6.18C28.43-.8 38.49-2.06 45.47 3.37L633.82 458.1c6.97 5.42 8.23 15.47 2.81 22.45l-19.64 25.27c-5.42 6.98-15.48 8.23-22.46 2.81z"
        ],
        sleigh: [
            640,
            512,
            [],
            "f7cc",
            "M612.7 350.7l-9.3-7.4c-6.9-5.5-17-4.4-22.5 2.5l-10 12.5c-5.5 6.9-4.4 17 2.5 22.5l9.3 7.4c5.9 4.7 9.2 11.7 9.2 19.2 0 13.6-11 24.6-24.6 24.6H48c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h516c39 0 73.7-29.3 75.9-68.3 1.4-23.8-8.7-46.3-27.2-61zM32 224c0 59.6 40.9 109.2 96 123.5V400h64v-48h192v48h64v-48c53 0 96-43 96-96v-96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96v64c0 35.3-28.7 64-64 64h-20.7c-65.8 0-125.9-37.2-155.3-96-29.4-58.8-89.6-96-155.3-96H32C14.3 32 0 46.3 0 64s14.3 32 32 32v128z"
        ],
        "sliders-h": [
            512,
            512,
            [],
            "f1de",
            "M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"
        ],
        smile: [
            496,
            512,
            [],
            "f118",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm194.8 170.2C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.6-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.4-16.2 38.1 4.2 24.6 20.5z"
        ],
        "smile-beam": [
            496,
            512,
            [],
            "f5b8",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM112 223.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zm250.8 122.8C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.3 24.6 20.5zm6.2-118.3l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.6 8.6-11 11.9-15.1 4.5z"
        ],
        "smile-wink": [
            496,
            512,
            [],
            "f4da",
            "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm158.5 16.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.7 11.1-11.4 18.3-19.8 10.8l-9.7-8.5zM157.8 325.8C180.2 352.7 213 368 248 368s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.2 24.6 20.5C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11.2-36.7 24.6-20.4z"
        ],
        smog: [
            640,
            512,
            [],
            "f75f",
            "M624 368H80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-480 96H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm416 0H224c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM144 288h156.1c22.5 19.7 51.6 32 83.9 32s61.3-12.3 83.9-32H528c61.9 0 112-50.1 112-112S589.9 64 528 64c-18 0-34.7 4.6-49.7 12.1C454 31 406.8 0 352 0c-41 0-77.8 17.3-104 44.8C221.8 17.3 185 0 144 0 64.5 0 0 64.5 0 144s64.5 144 144 144z"
        ],
        smoking: [
            640,
            512,
            [],
            "f48d",
            "M632 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zM553.3 87.1c-5.7-3.8-9.3-10-9.3-16.8V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v62.3c0 22 10.2 43.4 28.6 55.4 42.2 27.3 67.4 73.8 67.4 124V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-65.5-32.4-126.2-86.7-162.6zM432 352H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h384c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zm-32 112H224v-64h176v64zm87.7-322.4C463.8 125 448 99.3 448 70.3V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v66.4c0 43.7 24.6 81.6 60.3 106.7 22.4 15.7 35.7 41.2 35.7 68.6V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-43.3-21-83.4-56.3-108.1zM536 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z"
        ],
        "smoking-ban": [
            512,
            512,
            [],
            "f54d",
            "M96 304c0 8.8 7.2 16 16 16h117.5l-96-96H112c-8.8 0-16 7.2-16 16v64zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 448c-105.9 0-192-86.1-192-192 0-41.4 13.3-79.7 35.7-111.1l267.4 267.4C335.7 434.7 297.4 448 256 448zm45.2-192H384v32h-50.8l-32-32zm111.1 111.1L365.2 320H400c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H269.2L144.9 99.7C176.3 77.3 214.6 64 256 64c105.9 0 192 86.1 192 192 0 41.4-13.3 79.7-35.7 111.1zM320.6 128c-15.6 0-28.6-11.2-31.4-25.9-.7-3.6-4-6.1-7.7-6.1h-16.2c-5 0-8.7 4.5-8 9.4 4.6 30.9 31.2 54.6 63.3 54.6 15.6 0 28.6 11.2 31.4 25.9.7 3.6 4 6.1 7.7 6.1h16.2c5 0 8.7-4.5 8-9.4-4.6-30.9-31.2-54.6-63.3-54.6z"
        ],
        sms: [
            512,
            512,
            [],
            "f7cd",
            "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7 1.3 3 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128.2 304H116c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H156c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-19 38.6-42.4 38.6zm191.8-8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-68.2l-24.8 55.8c-2.9 5.9-11.4 5.9-14.3 0L224 227.8V296c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V192c0-8.8 7.2-16 16-16h16c6.1 0 11.6 3.4 14.3 8.8l17.7 35.4 17.7-35.4c2.7-5.4 8.3-8.8 14.3-8.8h16c8.8 0 16 7.2 16 16v104zm48.3 8H356c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H396c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-18.9 38.6-42.3 38.6z"
        ],
        snowboarding: [
            512,
            512,
            [],
            "f7ce",
            "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm28.8 153.6c5.8 4.3 12.5 6.4 19.2 6.4 9.7 0 19.3-4.4 25.6-12.8 10.6-14.1 7.8-34.2-6.4-44.8l-111.4-83.5c-13.8-10.3-29.1-18.4-45.4-23.8l-63.7-21.2-26.1-52.1C244.7 2 225.5-4.4 209.7 3.5c-15.8 7.9-22.2 27.1-14.3 42.9l29.1 58.1c5.7 11.4 15.6 19.9 27.7 24l16.4 5.5-41.2 20.6c-21.8 10.9-35.4 32.8-35.4 57.2v53.1l-74.1 24.7c-16.8 5.6-25.8 23.7-20.2 40.5 1.7 5.2 4.9 9.4 8.7 12.9l-38.7-14.1c-9.7-3.5-17.4-10.6-21.8-20-5.6-12-19.9-17.2-31.9-11.6s-17.2 19.9-11.6 31.9c9.8 21 27.1 36.9 48.9 44.8l364.8 132.7c9.7 3.5 19.7 5.3 29.7 5.3 12.5 0 24.9-2.7 36.5-8.2 12-5.6 17.2-19.9 11.6-31.9S474 454.7 462 460.3c-9.3 4.4-19.8 4.8-29.5 1.3l-90.8-33.1c8.7-4.1 15.6-11.8 17.8-21.9l21.9-102c3.9-18.2-3.2-37.2-18.1-48.4l-52-39 66-30.5 83.5 62.9zm-144.4 51.7l-19.7 92c-1.5 7.1-.1 13.9 2.8 20l-169.4-61.6c2.7-.2 5.4-.4 8-1.3l85-28.4c19.6-6.5 32.8-24.8 32.8-45.5V256l60.5 45.3z"
        ],
        snowflake: [
            448,
            512,
            [],
            "f2dc",
            "M440.3 345.2l-33.8-19.5 26-7c8.2-2.2 13.1-10.7 10.9-18.9l-4-14.9c-2.2-8.2-10.7-13.1-18.9-10.9l-70.8 19-63.9-37 63.8-36.9 70.8 19c8.2 2.2 16.7-2.7 18.9-10.9l4-14.9c2.2-8.2-2.7-16.7-10.9-18.9l-26-7 33.8-19.5c7.4-4.3 9.9-13.7 5.7-21.1L430.4 119c-4.3-7.4-13.7-9.9-21.1-5.7l-33.8 19.5 7-26c2.2-8.2-2.7-16.7-10.9-18.9l-14.9-4c-8.2-2.2-16.7 2.7-18.9 10.9l-19 70.8-62.8 36.2v-77.5l53.7-53.7c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0L256 56.4V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v40.4l-19.7-19.7c-6.2-6.2-16.4-6.2-22.6 0L138.3 48c-6.3 6.2-6.3 16.4 0 22.6l53.7 53.7v77.5l-62.8-36.2-19-70.8c-2.2-8.2-10.7-13.1-18.9-10.9l-14.9 4c-8.2 2.2-13.1 10.7-10.9 18.9l7 26-33.8-19.5c-7.4-4.3-16.8-1.7-21.1 5.7L2.1 145.7c-4.3 7.4-1.7 16.8 5.7 21.1l33.8 19.5-26 7c-8.3 2.2-13.2 10.7-11 19l4 14.9c2.2 8.2 10.7 13.1 18.9 10.9l70.8-19 63.8 36.9-63.8 36.9-70.8-19c-8.2-2.2-16.7 2.7-18.9 10.9l-4 14.9c-2.2 8.2 2.7 16.7 10.9 18.9l26 7-33.8 19.6c-7.4 4.3-9.9 13.7-5.7 21.1l15.5 26.8c4.3 7.4 13.7 9.9 21.1 5.7l33.8-19.5-7 26c-2.2 8.2 2.7 16.7 10.9 18.9l14.9 4c8.2 2.2 16.7-2.7 18.9-10.9l19-70.8 62.8-36.2v77.5l-53.7 53.7c-6.3 6.2-6.3 16.4 0 22.6l11.3 11.3c6.2 6.2 16.4 6.2 22.6 0l19.7-19.7V496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-40.4l19.7 19.7c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L256 387.7v-77.5l62.8 36.2 19 70.8c2.2 8.2 10.7 13.1 18.9 10.9l14.9-4c8.2-2.2 13.1-10.7 10.9-18.9l-7-26 33.8 19.5c7.4 4.3 16.8 1.7 21.1-5.7l15.5-26.8c4.3-7.3 1.8-16.8-5.6-21z"
        ],
        snowman: [
            512,
            512,
            [],
            "f7d0",
            "M510.9 152.3l-5.9-14.5c-3.3-8-12.6-11.9-20.8-8.7L456 140.6v-29c0-8.6-7.2-15.6-16-15.6h-16c-8.8 0-16 7-16 15.6v46.9c0 .5.3 1 .3 1.5l-56.4 23c-5.9-10-13.3-18.9-22-26.6 13.6-16.6 22-37.4 22-60.5 0-53-43-96-96-96s-96 43-96 96c0 23.1 8.5 43.9 22 60.5-8.7 7.7-16 16.6-22 26.6l-56.4-23c.1-.5.3-1 .3-1.5v-46.9C104 103 96.8 96 88 96H72c-8.8 0-16 7-16 15.6v29l-28.1-11.5c-8.2-3.2-17.5.7-20.8 8.7l-5.9 14.5c-3.3 8 .7 17.1 8.9 20.3l135.2 55.2c-.4 4-1.2 8-1.2 12.2 0 10.1 1.7 19.6 4.2 28.9C120.9 296.4 104 334.2 104 376c0 54 28.4 100.9 70.8 127.8 9.3 5.9 20.3 8.2 31.3 8.2h99.2c13.3 0 26.3-4.1 37.2-11.7 46.5-32.3 74.4-89.4 62.9-152.6-5.5-30.2-20.5-57.6-41.6-79 2.5-9.2 4.2-18.7 4.2-28.7 0-4.2-.8-8.1-1.2-12.2L502 172.6c8.1-3.1 12.1-12.2 8.9-20.3zM224 96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-88s-16-23.2-16-32 7.2-16 16-16 16 7.2 16 16-16 32-16 32zm32-56c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
        ],
        snowplow: [
            640,
            512,
            [],
            "f7d2",
            "M120 376c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm238.6 49.4c-14.5-14.5-22.6-34.1-22.6-54.6V269.2c0-20.5 8.1-40.1 22.6-54.6l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0l-36.7 36.7c-26.5 26.5-41.4 62.4-41.4 99.9V288h-64v-50.9c0-8.7-1.8-17.2-5.2-25.2L364.5 29.1C356.9 11.4 339.6 0 320.3 0H176c-26.5 0-48 21.5-48 48v112h-16c-26.5 0-48 21.5-48 48v91.2C26.3 317.2 0 355.4 0 400c0 61.9 50.1 112 112 112h256c61.9 0 112-50.1 112-112 0-17.3-4.2-33.4-11.2-48H512v18.7c0 37.5 14.9 73.4 41.4 99.9l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6l-36.7-36.7zM192 64h117.8l68.6 160H256l-64-64V64zm176 384H112c-26.5 0-48-21.5-48-48s21.5-48 48-48h256c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
        ],
        soap: [
            512,
            512,
            [],
            "e06e",
            "M416,192a95.42,95.42,0,0,1-30.94,70.21A95.8,95.8,0,0,1,352,448H160a96,96,0,0,1,0-192h88.91A95.3,95.3,0,0,1,224,192H96A96,96,0,0,0,0,288V416a96,96,0,0,0,96,96H416a96,96,0,0,0,96-96V288A96,96,0,0,0,416,192Zm-96,64a64,64,0,1,0-64-64A64,64,0,0,0,320,256ZM208,96a48,48,0,1,0-48-48A48,48,0,0,0,208,96ZM384,64a32,32,0,1,0-32-32A32,32,0,0,0,384,64ZM160,288a64,64,0,0,0,0,128H352a64,64,0,0,0,0-128Z"
        ],
        socks: [
            512,
            512,
            [],
            "f696",
            "M214.66 311.01L288 256V96H128v176l-86.65 64.61c-39.4 29.56-53.86 84.42-29.21 127.06C30.39 495.25 63.27 512 96.08 512c20.03 0 40.25-6.25 57.52-19.2l21.86-16.39c-29.85-55.38-13.54-125.84 39.2-165.4zM288 32c0-11.05 3.07-21.3 8.02-30.38C293.4.92 290.85 0 288 0H160c-17.67 0-32 14.33-32 32v32h160V32zM480 0H352c-17.67 0-32 14.33-32 32v32h192V32c0-17.67-14.33-32-32-32zM320 272l-86.13 64.61c-39.4 29.56-53.86 84.42-29.21 127.06 18.25 31.58 50.61 48.33 83.42 48.33 20.03 0 40.25-6.25 57.52-19.2l115.2-86.4A127.997 127.997 0 0 0 512 304V96H320v176z"
        ],
        "solar-panel": [
            640,
            512,
            [],
            "f5ba",
            "M431.98 448.01l-47.97.05V416h-128v32.21l-47.98.05c-8.82.01-15.97 7.16-15.98 15.99l-.05 31.73c-.01 8.85 7.17 16.03 16.02 16.02l223.96-.26c8.82-.01 15.97-7.16 15.98-15.98l.04-31.73c.01-8.85-7.17-16.03-16.02-16.02zM585.2 26.74C582.58 11.31 568.99 0 553.06 0H86.93C71 0 57.41 11.31 54.79 26.74-3.32 369.16.04 348.08.03 352c-.03 17.32 14.29 32 32.6 32h574.74c18.23 0 32.51-14.56 32.59-31.79.02-4.08 3.35 16.95-54.76-325.47zM259.83 64h120.33l9.77 96H250.06l9.77-96zm-75.17 256H71.09L90.1 208h105.97l-11.41 112zm16.29-160H98.24l16.29-96h96.19l-9.77 96zm32.82 160l11.4-112h149.65l11.4 112H233.77zm195.5-256h96.19l16.29 96H439.04l-9.77-96zm26.06 256l-11.4-112H549.9l19.01 112H455.33z"
        ],
        sort: [
            320,
            512,
            [],
            "f0dc",
            "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"
        ],
        "sort-alpha-down": [
            448,
            512,
            [],
            "f15d",
            "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm240-64H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"
        ],
        "sort-alpha-down-alt": [
            448,
            512,
            [],
            "f881",
            "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm112-128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"
        ],
        "sort-alpha-up": [
            448,
            512,
            [],
            "f15e",
            "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm400 128H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"
        ],
        "sort-alpha-up-alt": [
            448,
            512,
            [],
            "f882",
            "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm272 64h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"
        ],
        "sort-amount-down": [
            512,
            512,
            [],
            "f160",
            "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-128-64h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm256-192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
        ],
        "sort-amount-down-alt": [
            512,
            512,
            [],
            "f884",
            "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm-64 0h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
        ],
        "sort-amount-up": [
            512,
            512,
            [],
            "f161",
            "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.77 160 16 160zm416 0H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
        ],
        "sort-amount-up-alt": [
            512,
            512,
            [],
            "f885",
            "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.39-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160z"
        ],
        "sort-down": [
            320,
            512,
            [],
            "f0dd",
            "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"
        ],
        "sort-numeric-down": [
            448,
            512,
            [],
            "f162",
            "M304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zm26.15 162.91a79 79 0 0 0-55 54.17c-14.25 51.05 21.21 97.77 68.85 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zm-176-4h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
        ],
        "sort-numeric-down-alt": [
            448,
            512,
            [],
            "f886",
            "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm224 64h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
        ],
        "sort-numeric-up": [
            448,
            512,
            [],
            "f163",
            "M330.17 258.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zM304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zM107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31z"
        ],
        "sort-numeric-up-alt": [
            448,
            512,
            [],
            "f887",
            "M107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31zM400 416h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
        ],
        "sort-up": [
            320,
            512,
            [],
            "f0de",
            "M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"
        ],
        spa: [
            576,
            512,
            [],
            "f5bb",
            "M568.25 192c-29.04.13-135.01 6.16-213.84 83-33.12 29.63-53.36 63.3-66.41 94.86-13.05-31.56-33.29-65.23-66.41-94.86-78.83-76.84-184.8-82.87-213.84-83-4.41-.02-7.79 3.4-7.75 7.82.23 27.92 7.14 126.14 88.77 199.3C172.79 480.94 256 480 288 480s115.19.95 199.23-80.88c81.64-73.17 88.54-171.38 88.77-199.3.04-4.42-3.34-7.84-7.75-7.82zM287.98 302.6c12.82-18.85 27.6-35.78 44.09-50.52 19.09-18.61 39.58-33.3 60.26-45.18-16.44-70.5-51.72-133.05-96.73-172.22-4.11-3.58-11.02-3.58-15.14 0-44.99 39.14-80.27 101.63-96.74 172.07 20.37 11.7 40.5 26.14 59.22 44.39a282.768 282.768 0 0 1 45.04 51.46z"
        ],
        "space-shuttle": [
            640,
            512,
            [],
            "f197",
            "M592.604 208.244C559.735 192.836 515.777 184 472 184H186.327c-4.952-6.555-10.585-11.978-16.72-16H376C229.157 137.747 219.403 32 96.003 32H96v128H80V32c-26.51 0-48 28.654-48 64v64c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v16c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v64c0 35.346 21.49 64 48 64V352h16v128h.003c123.4 0 133.154-105.747 279.997-136H169.606c6.135-4.022 11.768-9.445 16.72-16H472c43.777 0 87.735-8.836 120.604-24.244C622.282 289.845 640 271.992 640 256s-17.718-33.845-47.396-47.756zM488 296a8 8 0 0 1-8-8v-64a8 8 0 0 1 8-8c31.909 0 31.942 80 0 80z"
        ],
        "spell-check": [
            576,
            512,
            [],
            "f891",
            "M272 256h91.36c43.2 0 82-32.2 84.51-75.34a79.82 79.82 0 0 0-25.26-63.07 79.81 79.81 0 0 0 9.06-44.91C427.9 30.57 389.3 0 347 0h-75a16 16 0 0 0-16 16v224a16 16 0 0 0 16 16zm40-200h40a24 24 0 0 1 0 48h-40zm0 96h56a24 24 0 0 1 0 48h-56zM155.12 22.25A32 32 0 0 0 124.64 0H99.36a32 32 0 0 0-30.48 22.25L.59 235.73A16 16 0 0 0 16 256h24.93a16 16 0 0 0 15.42-11.73L68.29 208h87.42l11.94 36.27A16 16 0 0 0 183.07 256H208a16 16 0 0 0 15.42-20.27zM89.37 144L112 75.3l22.63 68.7zm482 132.48l-45.21-45.3a15.88 15.88 0 0 0-22.59 0l-151.5 151.5-55.41-55.5a15.88 15.88 0 0 0-22.59 0l-45.3 45.3a16 16 0 0 0 0 22.59l112 112.21a15.89 15.89 0 0 0 22.6 0l208-208.21a16 16 0 0 0-.02-22.59z"
        ],
        spider: [
            576,
            512,
            [],
            "f717",
            "M151.17 167.35L177.1 176h4.67l5.22-26.12c.72-3.58 1.8-7.58 3.21-11.79l-20.29-40.58 23.8-71.39c2.79-8.38-1.73-17.44-10.12-20.24L168.42.82c-8.38-2.8-17.45 1.73-20.24 10.12l-25.89 77.68a32.04 32.04 0 0 0 1.73 24.43l27.15 54.3zm422.14 182.03l-52.75-79.12a32.002 32.002 0 0 0-26.62-14.25H416l68.99-24.36a32.03 32.03 0 0 0 16.51-12.61l53.6-80.41c4.9-7.35 2.91-17.29-4.44-22.19l-13.31-8.88c-7.35-4.9-17.29-2.91-22.19 4.44l-50.56 75.83L404.1 208H368l-10.37-51.85C355.44 145.18 340.26 96 288 96c-52.26 0-67.44 49.18-69.63 60.15L208 208h-36.1l-60.49-20.17L60.84 112c-4.9-7.35-14.83-9.34-22.19-4.44l-13.31 8.88c-7.35 4.9-9.34 14.83-4.44 22.19l53.6 80.41a32.03 32.03 0 0 0 16.51 12.61L160 256H82.06a32.02 32.02 0 0 0-26.63 14.25L2.69 349.38c-4.9 7.35-2.92 17.29 4.44 22.19l13.31 8.88c7.35 4.9 17.29 2.91 22.19-4.44l48-72h47.06l-60.83 97.33A31.988 31.988 0 0 0 72 418.3V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-73.11l74.08-118.53c-1.01 14.05-2.08 28.11-2.08 42.21C192 399.64 232.76 448 288 448s96-48.36 96-101.43c0-14.1-1.08-28.16-2.08-42.21L456 422.89V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-77.71c0-6-1.69-11.88-4.86-16.96L438.31 304h47.06l48 72c4.9 7.35 14.84 9.34 22.19 4.44l13.31-8.88c7.36-4.9 9.34-14.83 4.44-22.18zM406.09 97.51l-20.29 40.58c1.41 4.21 2.49 8.21 3.21 11.79l5.22 26.12h4.67l25.93-8.65 27.15-54.3a31.995 31.995 0 0 0 1.73-24.43l-25.89-77.68C425.03 2.56 415.96-1.98 407.58.82l-15.17 5.06c-8.38 2.8-12.91 11.86-10.12 20.24l23.8 71.39z"
        ],
        spinner: [
            512,
            512,
            [],
            "f110",
            "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
        ],
        splotch: [
            512,
            512,
            [],
            "f5bc",
            "M472.29 195.89l-67.06-22.95c-19.28-6.6-33.54-20.92-38.14-38.3L351.1 74.19c-11.58-43.77-76.57-57.13-109.98-22.62l-46.14 47.67c-13.26 13.71-33.54 20.93-54.2 19.31l-71.88-5.62c-52.05-4.07-86.93 44.88-59.03 82.83l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24L24.62 355.4c-20.59 41.25 22.84 84.87 73.49 73.81l69.96-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101.04 7.57 104.45-37.22l4.7-61.86c1.35-17.79 12.8-33.86 30.63-42.99l62-31.74c44.88-22.96 39.59-80.17-8.95-96.79z"
        ],
        "spray-can": [
            512,
            512,
            [],
            "f5bd",
            "M224 32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96h128V32zm256 96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-256 32H96c-53.02 0-96 42.98-96 96v224c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V256c0-53.02-42.98-96-96-96zm-64 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zM480 96c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm-96 32c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-96-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 0c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
        ],
        square: [
            448,
            512,
            [],
            "f0c8",
            "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
        ],
        "square-full": [
            512,
            512,
            [],
            "f45c",
            "M512 512H0V0h512v512z"
        ],
        "square-root-alt": [
            576,
            512,
            [],
            "f698",
            "M571.31 251.31l-22.62-22.62c-6.25-6.25-16.38-6.25-22.63 0L480 274.75l-46.06-46.06c-6.25-6.25-16.38-6.25-22.63 0l-22.62 22.62c-6.25 6.25-6.25 16.38 0 22.63L434.75 320l-46.06 46.06c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L480 365.25l46.06 46.06c6.25 6.25 16.38 6.25 22.63 0l22.62-22.62c6.25-6.25 6.25-16.38 0-22.63L525.25 320l46.06-46.06c6.25-6.25 6.25-16.38 0-22.63zM552 0H307.65c-14.54 0-27.26 9.8-30.95 23.87l-84.79 322.8-58.41-106.1A32.008 32.008 0 0 0 105.47 224H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h43.62l88.88 163.73C168.99 503.5 186.3 512 204.94 512c17.27 0 44.44-9 54.28-41.48L357.03 96H552c13.25 0 24-10.75 24-24V24c0-13.26-10.75-24-24-24z"
        ],
        stamp: [
            512,
            512,
            [],
            "f5bf",
            "M32 512h448v-64H32v64zm384-256h-66.56c-16.26 0-29.44-13.18-29.44-29.44v-9.46c0-27.37 8.88-53.41 21.46-77.72 9.11-17.61 12.9-38.39 9.05-60.42-6.77-38.78-38.47-70.7-77.26-77.45C212.62-9.04 160 37.33 160 96c0 14.16 3.12 27.54 8.69 39.58C182.02 164.43 192 194.7 192 226.49v.07c0 16.26-13.18 29.44-29.44 29.44H96c-53.02 0-96 42.98-96 96v32c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-32c0-53.02-42.98-96-96-96z"
        ],
        star: [
            576,
            512,
            [],
            "f005",
            "M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
        ],
        "star-and-crescent": [
            512,
            512,
            [],
            "f699",
            "M340.47 466.36c-1.45 0-6.89.46-9.18.46-116.25 0-210.82-94.57-210.82-210.82S215.04 45.18 331.29 45.18c2.32 0 7.7.46 9.18.46 7.13 0 13.33-5.03 14.75-12.07 1.46-7.25-2.55-14.49-9.47-17.09C316.58 5.54 286.39 0 256 0 114.84 0 0 114.84 0 256s114.84 256 256 256c30.23 0 60.28-5.49 89.32-16.32 5.96-2.02 10.28-7.64 10.28-14.26 0-8.09-6.39-15.06-15.13-15.06zm162.99-252.5l-76.38-11.1-34.16-69.21c-1.83-3.7-5.38-5.55-8.93-5.55s-7.1 1.85-8.93 5.55l-34.16 69.21-76.38 11.1c-8.17 1.18-11.43 11.22-5.52 16.99l55.27 53.87-13.05 76.07c-1.11 6.44 4.01 11.66 9.81 11.66 1.53 0 3.11-.36 4.64-1.17L384 335.37l68.31 35.91c1.53.8 3.11 1.17 4.64 1.17 5.8 0 10.92-5.23 9.81-11.66l-13.05-76.07 55.27-53.87c5.91-5.77 2.65-15.81-5.52-16.99z"
        ],
        "star-half": [
            576,
            512,
            [],
            "f089",
            "M288 0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6V0z"
        ],
        "star-half-alt": [
            536,
            512,
            [],
            "f5c0",
            "M508.55 171.51L362.18 150.2 296.77 17.81C290.89 5.98 279.42 0 267.95 0c-11.4 0-22.79 5.9-28.69 17.81l-65.43 132.38-146.38 21.29c-26.25 3.8-36.77 36.09-17.74 54.59l105.89 103-25.06 145.48C86.98 495.33 103.57 512 122.15 512c4.93 0 10-1.17 14.87-3.75l130.95-68.68 130.94 68.7c4.86 2.55 9.92 3.71 14.83 3.71 18.6 0 35.22-16.61 31.66-37.4l-25.03-145.49 105.91-102.98c19.04-18.5 8.52-50.8-17.73-54.6zm-121.74 123.2l-18.12 17.62 4.28 24.88 19.52 113.45-102.13-53.59-22.38-11.74.03-317.19 51.03 103.29 11.18 22.63 25.01 3.64 114.23 16.63-82.65 80.38z"
        ],
        "star-of-david": [
            464,
            512,
            [],
            "f69a",
            "M405.68 256l53.21-89.39C473.3 142.4 455.48 112 426.88 112H319.96l-55.95-93.98C256.86 6.01 244.43 0 232 0s-24.86 6.01-32.01 18.02L144.04 112H37.11c-28.6 0-46.42 30.4-32.01 54.61L58.32 256 5.1 345.39C-9.31 369.6 8.51 400 37.11 400h106.93l55.95 93.98C207.14 505.99 219.57 512 232 512s24.86-6.01 32.01-18.02L319.96 400h106.93c28.6 0 46.42-30.4 32.01-54.61L405.68 256zm-12.78-88l-19.8 33.26L353.3 168h39.6zm-52.39 88l-52.39 88H175.88l-52.39-88 52.38-88h112.25l52.39 88zM232 73.72L254.79 112h-45.57L232 73.72zM71.1 168h39.6l-19.8 33.26L71.1 168zm0 176l19.8-33.26L110.7 344H71.1zM232 438.28L209.21 400h45.57L232 438.28zM353.29 344l19.8-33.26L392.9 344h-39.61z"
        ],
        "star-of-life": [
            480,
            512,
            [],
            "f621",
            "M471.99 334.43L336.06 256l135.93-78.43c7.66-4.42 10.28-14.2 5.86-21.86l-32.02-55.43c-4.42-7.65-14.21-10.28-21.87-5.86l-135.93 78.43V16c0-8.84-7.17-16-16.01-16h-64.04c-8.84 0-16.01 7.16-16.01 16v156.86L56.04 94.43c-7.66-4.42-17.45-1.79-21.87 5.86L2.15 155.71c-4.42 7.65-1.8 17.44 5.86 21.86L143.94 256 8.01 334.43c-7.66 4.42-10.28 14.21-5.86 21.86l32.02 55.43c4.42 7.65 14.21 10.27 21.87 5.86l135.93-78.43V496c0 8.84 7.17 16 16.01 16h64.04c8.84 0 16.01-7.16 16.01-16V339.14l135.93 78.43c7.66 4.42 17.45 1.8 21.87-5.86l32.02-55.43c4.42-7.65 1.8-17.43-5.86-21.85z"
        ],
        "step-backward": [
            448,
            512,
            [],
            "f048",
            "M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12z"
        ],
        "step-forward": [
            448,
            512,
            [],
            "f051",
            "M384 44v424c0 6.6-5.4 12-12 12h-48c-6.6 0-12-5.4-12-12V291.6l-195.5 181C95.9 489.7 64 475.4 64 448V64c0-27.4 31.9-41.7 52.5-24.6L312 219.3V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12z"
        ],
        stethoscope: [
            512,
            512,
            [],
            "f0f1",
            "M447.1 112c-34.2.5-62.3 28.4-63 62.6-.5 24.3 12.5 45.6 32 56.8V344c0 57.3-50.2 104-112 104-60 0-109.2-44.1-111.9-99.2C265 333.8 320 269.2 320 192V36.6c0-11.4-8.1-21.3-19.3-23.5L237.8.5c-13-2.6-25.6 5.8-28.2 18.8L206.4 35c-2.6 13 5.8 25.6 18.8 28.2l30.7 6.1v121.4c0 52.9-42.2 96.7-95.1 97.2-53.4.5-96.9-42.7-96.9-96V69.4l30.7-6.1c13-2.6 21.4-15.2 18.8-28.2l-3.1-15.7C107.7 6.4 95.1-2 82.1.6L19.3 13C8.1 15.3 0 25.1 0 36.6V192c0 77.3 55.1 142 128.1 156.8C130.7 439.2 208.6 512 304 512c97 0 176-75.4 176-168V231.4c19.1-11.1 32-31.7 32-55.4 0-35.7-29.2-64.5-64.9-64zm.9 80c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
        ],
        "sticky-note": [
            448,
            512,
            [],
            "f249",
            "M312 320h136V56c0-13.3-10.7-24-24-24H24C10.7 32 0 42.7 0 56v400c0 13.3 10.7 24 24 24h264V344c0-13.2 10.8-24 24-24zm129 55l-98 98c-4.5 4.5-10.6 7-17 7h-6V352h128v6.1c0 6.3-2.5 12.4-7 16.9z"
        ],
        stop: [
            448,
            512,
            [],
            "f04d",
            "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
        ],
        "stop-circle": [
            512,
            512,
            [],
            "f28d",
            "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm96 328c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v160z"
        ],
        stopwatch: [
            448,
            512,
            [],
            "f2f2",
            "M432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-104 76.3-190.2 176-205.5V64h-28c-6.6 0-12-5.4-12-12V12c0-6.6 5.4-12 12-12h120c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-28v34.5c37.5 5.8 71.7 21.6 99.7 44.6l27.5-27.5c4.7-4.7 12.3-4.7 17 0l28.3 28.3c4.7 4.7 4.7 12.3 0 17l-29.4 29.4-.6.6C419.7 223.3 432 262.2 432 304zm-176 36V188.5c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12V340c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"
        ],
        "stopwatch-20": [
            448,
            512,
            [],
            "e06f",
            "M398.5,190.91l.59-.61,26.59-26.58a16,16,0,0,0,0-22.63L403,118.41a16,16,0,0,0-22.63,0l-24.68,24.68A206.68,206.68,0,0,0,256,98.5V64h32a16,16,0,0,0,16-16V16A16,16,0,0,0,288,0H160a16.05,16.05,0,0,0-16,16V48a16.05,16.05,0,0,0,16,16h32V98.5A207.92,207.92,0,0,0,16.09,297.57C12.64,411.5,106.76,510.22,220.72,512,337.13,513.77,432,420,432,304A206,206,0,0,0,398.5,190.91ZM204.37,377.55a8.2,8.2,0,0,1,8.32,8.07v22.31a8.2,8.2,0,0,1-8.32,8.07H121.52a16.46,16.46,0,0,1-16.61-17.62c2.78-35.22,14.67-57.41,38.45-91.37,20.42-29.19,27.1-37.32,27.1-62.34,0-16.92-1.79-24.27-12.21-24.27-9.39,0-12.69,7.4-12.69,22.68v5.23a8.2,8.2,0,0,1-8.33,8.07h-24.9a8.2,8.2,0,0,1-8.33-8.07v-4.07c0-27.3,8.48-60.24,56.43-60.24,43,0,55.57,25.85,55.57,61,0,35.58-12.44,51.21-34.35,81.31-11.56,15-24.61,35.57-26.41,51.2ZM344,352.32c0,35.16-12.3,63.68-57.23,63.68C243.19,416,232,386.48,232,352.55V247.22c0-40.73,19.58-63.22,56.2-63.22C325,184,344,206.64,344,245.3ZM287.87,221.73c-9.41,0-13.23,7.5-13.23,20V357.68c0,13.11,3.59,20.59,13.23,20.59s13-8,13-21.27V241.06C300.89,229.79,297.88,221.73,287.87,221.73Z"
        ],
        store: [
            616,
            512,
            [],
            "f54e",
            "M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6c-33.5 53.5-3.8 127.9 58.8 136.4 4.5.6 9.1.9 13.7.9 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18.1 20.1 44.3 33.1 73.8 33.1 4.7 0 9.2-.3 13.7-.9 62.8-8.4 92.6-82.8 59-136.4zM529.5 288c-10 0-19.9-1.5-29.5-3.8V384H116v-99.8c-9.6 2.2-19.5 3.8-29.5 3.8-6 0-12.1-.4-18-1.2-5.6-.8-11.1-2.1-16.4-3.6V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V283.2c-5.4 1.6-10.8 2.9-16.4 3.6-6.1.8-12.1 1.2-18.2 1.2z"
        ],
        "store-alt": [
            640,
            512,
            [],
            "f54f",
            "M320 384H128V224H64v256c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V224h-64v160zm314.6-241.8l-85.3-128c-6-8.9-16-14.2-26.7-14.2H117.4c-10.7 0-20.7 5.3-26.6 14.2l-85.3 128c-14.2 21.3 1 49.8 26.6 49.8H608c25.5 0 40.7-28.5 26.6-49.8zM512 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h-64v272z"
        ],
        "store-alt-slash": [
            640,
            512,
            [],
            "e070",
            "M17.89,123.62,5.51,142.2c-14.2,21.3,1,49.8,26.59,49.8h74.26ZM576,413.42V224H512V364L384,265V224H330.92l-41.4-32H608c25.5,0,40.7-28.5,26.59-49.8l-85.29-128A32.18,32.18,0,0,0,522.6,0H117.42A31.87,31.87,0,0,0,90.81,14.2l-10.66,16L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.81l19.64-25.26a16,16,0,0,0-2.81-22.45ZM320,384H128V224H64V480a32,32,0,0,0,32,32H352a32,32,0,0,0,32-32V406.59l-64-49.47Z"
        ],
        "store-slash": [
            640,
            512,
            [],
            "e071",
            "M121.51,384V284.2a119.43,119.43,0,0,1-28,3.8,123.46,123.46,0,0,1-17.1-1.2,114.88,114.88,0,0,1-15.58-3.6V480c0,17.7,13.59,32,30.4,32H505.75L348.42,384Zm-28-128.09c25.1,0,47.29-10.72,64-27.24L24,120.05c-30.52,53.39-2.45,126.53,56.49,135A95.68,95.68,0,0,0,93.48,255.91ZM602.13,458.09,547.2,413.41V283.2a93.5,93.5,0,0,1-15.57,3.6,127.31,127.31,0,0,1-17.29,1.2,114.89,114.89,0,0,1-28-3.8v79.68L348.52,251.77a88.06,88.06,0,0,0,25.41,4.14c28.11,0,53-13,70.11-33.11,17.19,20.11,42.08,33.11,70.11,33.11a94.31,94.31,0,0,0,13-.91c59.66-8.41,88-82.8,56.06-136.4L521.55,15A30.1,30.1,0,0,0,495.81,0H112A30.11,30.11,0,0,0,86.27,15L76.88,30.78,43.19,3.38A14.68,14.68,0,0,0,21.86,6.19L3.2,31.45A16.58,16.58,0,0,0,5.87,53.91L564.81,508.63a14.69,14.69,0,0,0,21.33-2.82l18.66-25.26A16.58,16.58,0,0,0,602.13,458.09Z"
        ],
        stream: [
            512,
            512,
            [],
            "f550",
            "M16 128h416c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H16C7.16 32 0 39.16 0 48v64c0 8.84 7.16 16 16 16zm480 80H80c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm-64 176H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16z"
        ],
        "street-view": [
            512,
            512,
            [],
            "f21d",
            "M367.9 329.76c-4.62 5.3-9.78 10.1-15.9 13.65v22.94c66.52 9.34 112 28.05 112 49.65 0 30.93-93.12 56-208 56S48 446.93 48 416c0-21.6 45.48-40.3 112-49.65v-22.94c-6.12-3.55-11.28-8.35-15.9-13.65C58.87 345.34 0 378.05 0 416c0 53.02 114.62 96 256 96s256-42.98 256-96c0-37.95-58.87-70.66-144.1-86.24zM256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-64 192v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96c17.67 0 32-14.33 32-32v-96c0-26.51-21.49-48-48-48h-11.8c-11.07 5.03-23.26 8-36.2 8s-25.13-2.97-36.2-8H208c-26.51 0-48 21.49-48 48v96c0 17.67 14.33 32 32 32z"
        ],
        strikethrough: [
            512,
            512,
            [],
            "f0cc",
            "M496 224H293.9l-87.17-26.83A43.55 43.55 0 0 1 219.55 112h66.79A49.89 49.89 0 0 1 331 139.58a16 16 0 0 0 21.46 7.15l42.94-21.47a16 16 0 0 0 7.16-21.46l-.53-1A128 128 0 0 0 287.51 32h-68a123.68 123.68 0 0 0-123 135.64c2 20.89 10.1 39.83 21.78 56.36H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-180.24 96A43 43 0 0 1 336 356.45 43.59 43.59 0 0 1 292.45 400h-66.79A49.89 49.89 0 0 1 181 372.42a16 16 0 0 0-21.46-7.15l-42.94 21.47a16 16 0 0 0-7.16 21.46l.53 1A128 128 0 0 0 224.49 480h68a123.68 123.68 0 0 0 123-135.64 114.25 114.25 0 0 0-5.34-24.36z"
        ],
        stroopwafel: [
            512,
            512,
            [],
            "f551",
            "M188.12 210.74L142.86 256l45.25 45.25L233.37 256l-45.25-45.26zm113.13-22.62L256 142.86l-45.25 45.25L256 233.37l45.25-45.25zm-90.5 135.76L256 369.14l45.26-45.26L256 278.63l-45.25 45.25zM256 0C114.62 0 0 114.62 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0zm186.68 295.6l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-28.29-28.29-45.25 45.25 33.94 33.94 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-33.94-33.94-45.26 45.26 28.29 28.29c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0L256 414.39l-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l28.29-28.29-45.25-45.26-33.94 33.94 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 33.94-33.94-45.25-45.25-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0L69.32 295.6c-3.12-3.12-3.12-8.19 0-11.31L97.61 256l-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l28.29 28.29 45.25-45.26-33.94-33.94-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 33.94 33.94 45.26-45.25-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0L256 97.61l28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-28.29 28.29 45.26 45.25 33.94-33.94-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-33.94 33.94 45.25 45.26 28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31L414.39 256l28.29 28.28a8.015 8.015 0 0 1 0 11.32zM278.63 256l45.26 45.25L369.14 256l-45.25-45.26L278.63 256z"
        ],
        subscript: [
            512,
            512,
            [],
            "f12c",
            "M496 448h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 352h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"
        ],
        subway: [
            448,
            512,
            [],
            "f239",
            "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zM200 232V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm200 0V120c0-13.255-10.745-24-24-24H272c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm-48 56c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm-256 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
        ],
        suitcase: [
            512,
            512,
            [],
            "f0f2",
            "M128 480h256V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v400zm64-384h128v32H192V96zm320 80v256c0 26.5-21.5 48-48 48h-48V128h48c26.5 0 48 21.5 48 48zM96 480H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h48v352z"
        ],
        "suitcase-rolling": [
            384,
            512,
            [],
            "f5c1",
            "M336 160H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h16v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h128v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h16c26.51 0 48-21.49 48-48V208c0-26.51-21.49-48-48-48zm-16 216c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zM144 48h96v80h48V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v80h48V48z"
        ],
        sun: [
            512,
            512,
            [],
            "f185",
            "M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181 49.9-49.9 131.1-49.9 181 0 49.9 49.9 49.9 131.1 0 181z"
        ],
        superscript: [
            512,
            512,
            [],
            "f12b",
            "M496 160h-16V16a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 64h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"
        ],
        surprise: [
            496,
            512,
            [],
            "f5c2",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm112 208c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm80-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
        ],
        swatchbook: [
            512,
            512,
            [],
            "f5c3",
            "M434.66,167.71h0L344.5,77.36a31.83,31.83,0,0,0-45-.07h0l-.07.07L224,152.88V424L434.66,212.9A32,32,0,0,0,434.66,167.71ZM480,320H373.09L186.68,506.51c-2.06,2.07-4.5,3.58-6.68,5.49H480a32,32,0,0,0,32-32V352A32,32,0,0,0,480,320ZM192,32A32,32,0,0,0,160,0H32A32,32,0,0,0,0,32V416a96,96,0,0,0,192,0ZM96,440a24,24,0,1,1,24-24A24,24,0,0,1,96,440Zm32-184H64V192h64Zm0-128H64V64h64Z"
        ],
        swimmer: [
            640,
            512,
            [],
            "f5c4",
            "M189.61 310.58c3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c16.02-14.77 34.5-22.58 53.46-22.58h16.3c18.96 0 37.45 7.81 53.46 22.58 3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c14.86-13.71 31.88-21.12 49.39-22.16l-112.84-80.6 18-12.86c3.64-2.58 8.28-3.52 12.62-2.61l100.35 21.53c25.91 5.53 51.44-10.97 57-36.88 5.55-25.92-10.95-51.44-36.88-57L437.68 98.47c-30.73-6.58-63.02.12-88.56 18.38l-80.02 57.17c-10.38 7.39-19.36 16.44-26.72 26.94L173.75 299c5.47 3.23 10.82 6.93 15.86 11.58zM624 352h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 343.58 442.04 352 416 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 343.58 250.04 352 224 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 343.58 58.04 352 32 352H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-512-96c44.18 0 80-35.82 80-80s-35.82-80-80-80-80 35.82-80 80 35.82 80 80 80z"
        ],
        "swimming-pool": [
            640,
            512,
            [],
            "f5c5",
            "M624 416h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 407.58 442.04 416 416 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 407.58 250.04 416 224 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 407.58 58.04 416 32 416H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-400-32v-96h192v96c19.12 0 30.86-6.16 34.39-9.42 9.17-8.46 19.2-14.34 29.61-18.07V128c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v96H224v-96c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v228.5c10.41 3.73 20.44 9.62 29.61 18.07 3.53 3.27 15.27 9.43 34.39 9.43z"
        ],
        synagogue: [
            640,
            512,
            [],
            "f69b",
            "M70 196.51L6.67 268.29A26.643 26.643 0 0 0 0 285.93V512h128V239.58l-38-43.07c-5.31-6.01-14.69-6.01-20 0zm563.33 71.78L570 196.51c-5.31-6.02-14.69-6.02-20 0l-38 43.07V512h128V285.93c0-6.5-2.37-12.77-6.67-17.64zM339.99 7.01c-11.69-9.35-28.29-9.35-39.98 0l-128 102.4A32.005 32.005 0 0 0 160 134.4V512h96v-92.57c0-31.88 21.78-61.43 53.25-66.55C349.34 346.35 384 377.13 384 416v96h96V134.4c0-9.72-4.42-18.92-12.01-24.99l-128-102.4zm52.07 215.55c1.98 3.15-.29 7.24-4 7.24h-38.94L324 269.79c-1.85 2.95-6.15 2.95-8 0l-25.12-39.98h-38.94c-3.72 0-5.98-4.09-4-7.24l19.2-30.56-19.2-30.56c-1.98-3.15.29-7.24 4-7.24h38.94l25.12-40c1.85-2.95 6.15-2.95 8 0l25.12 39.98h38.95c3.71 0 5.98 4.09 4 7.24L372.87 192l19.19 30.56z"
        ],
        sync: [
            512,
            512,
            [],
            "f021",
            "M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z"
        ],
        "sync-alt": [
            512,
            512,
            [],
            "f2f1",
            "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328 53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933 94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382 0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144 162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187 504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"
        ],
        syringe: [
            512,
            512,
            [],
            "f48e",
            "M201.5 174.8l55.7 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-55.7-55.8-45.3 45.3 55.8 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L111 265.2l-26.4 26.4c-17.3 17.3-25.6 41.1-23 65.4l7.1 63.6L2.3 487c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l66.3-66.3 63.6 7.1c23.9 2.6 47.9-5.4 65.4-23l181.9-181.9-135.7-135.7-64.9 65zm308.2-93.3L430.5 2.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l28.3 28.3-45.3 45.3-56.6-56.6-17-17c-3.1-3.1-8.2-3.1-11.3 0l-33.9 33.9c-3.1 3.1-3.1 8.2 0 11.3l17 17L424.8 223l17 17c3.1 3.1 8.2 3.1 11.3 0l33.9-34c3.1-3.1 3.1-8.2 0-11.3l-73.5-73.5 45.3-45.3 28.3 28.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.2 3.1-8.2 0-11.4z"
        ],
        table: [
            512,
            512,
            [],
            "f0ce",
            "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z"
        ],
        "table-tennis": [
            512,
            512,
            [],
            "f45d",
            "M496.2 296.5C527.7 218.7 512 126.2 449 63.1 365.1-21 229-21 145.1 63.1l-56 56.1 211.5 211.5c46.1-62.1 131.5-77.4 195.6-34.2zm-217.9 79.7L57.9 155.9c-27.3 45.3-21.7 105 17.3 144.1l34.5 34.6L6.7 424c-8.6 7.5-9.1 20.7-1 28.8l53.4 53.5c8 8.1 21.2 7.6 28.7-1L177.1 402l35.7 35.7c19.7 19.7 44.6 30.5 70.3 33.3-7.1-17-11-35.6-11-55.1-.1-13.8 2.5-27 6.2-39.7zM416 320c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96z"
        ],
        tablet: [
            448,
            512,
            [],
            "f10a",
            "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
        ],
        "tablet-alt": [
            448,
            512,
            [],
            "f3fa",
            "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm176-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h328c6.6 0 12 5.4 12 12v312z"
        ],
        tablets: [
            640,
            512,
            [],
            "f490",
            "M160 192C78.9 192 12.5 250.5.1 326.7c-.8 4.8 3.3 9.3 8.3 9.3h303.3c5 0 9.1-4.5 8.3-9.3C307.5 250.5 241.1 192 160 192zm151.6 176H8.4c-5 0-9.1 4.5-8.3 9.3C12.5 453.5 78.9 512 160 512s147.5-58.5 159.9-134.7c.8-4.8-3.3-9.3-8.3-9.3zM593.4 46.6c-56.5-56.5-144.2-61.4-206.9-16-4 2.9-4.3 8.9-.8 12.3L597 254.3c3.5 3.5 9.5 3.2 12.3-.8 45.5-62.7 40.6-150.4-15.9-206.9zM363 65.7c-3.5-3.5-9.5-3.2-12.3.8-45.4 62.7-40.5 150.4 15.9 206.9 56.5 56.5 144.2 61.4 206.9 15.9 4-2.9 4.3-8.9.8-12.3L363 65.7z"
        ],
        "tachometer-alt": [
            576,
            512,
            [],
            "f3fd",
            "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm0 64c14.71 0 26.58 10.13 30.32 23.65-1.11 2.26-2.64 4.23-3.45 6.67l-9.22 27.67c-5.13 3.49-10.97 6.01-17.64 6.01-17.67 0-32-14.33-32-32S270.33 96 288 96zM96 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm48-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm246.77-72.41l-61.33 184C343.13 347.33 352 364.54 352 384c0 11.72-3.38 22.55-8.88 32H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-33.94 26.5-61.43 59.9-63.59l61.34-184.01c4.17-12.56 17.73-19.45 30.36-15.17 12.57 4.19 19.35 17.79 15.17 30.36zm14.66 57.2l15.52-46.55c3.47-1.29 7.13-2.23 11.05-2.23 17.67 0 32 14.33 32 32s-14.33 32-32 32c-11.38-.01-20.89-6.28-26.57-15.22zM480 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        tag: [
            512,
            512,
            [],
            "f02b",
            "M0 252.118V48C0 21.49 21.49 0 48 0h204.118a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882L293.823 497.941c-18.745 18.745-49.137 18.745-67.882 0L14.059 286.059A48 48 0 0 1 0 252.118zM112 64c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
        ],
        tags: [
            640,
            512,
            [],
            "f02c",
            "M497.941 225.941L286.059 14.059A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v204.118a48 48 0 0 0 14.059 33.941l211.882 211.882c18.744 18.745 49.136 18.746 67.882 0l204.118-204.118c18.745-18.745 18.745-49.137 0-67.882zM112 160c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm513.941 133.823L421.823 497.941c-18.745 18.745-49.137 18.745-67.882 0l-.36-.36L527.64 323.522c16.999-16.999 26.36-39.6 26.36-63.64s-9.362-46.641-26.36-63.64L331.397 0h48.721a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882z"
        ],
        tape: [
            640,
            512,
            [],
            "f4db",
            "M224 192c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm400 224H380.6c41.5-40.7 67.4-97.3 67.4-160 0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h400c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400-64c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
        ],
        tasks: [
            512,
            512,
            [],
            "f0ae",
            "M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
        ],
        taxi: [
            512,
            512,
            [],
            "f1ba",
            "M462 241.64l-22-84.84c-9.6-35.2-41.6-60.8-76.8-60.8H352V64c0-17.67-14.33-32-32-32H192c-17.67 0-32 14.33-32 32v32h-11.2c-35.2 0-67.2 25.6-76.8 60.8l-22 84.84C21.41 248.04 0 273.47 0 304v48c0 23.63 12.95 44.04 32 55.12V448c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-40.88c19.05-11.09 32-31.5 32-55.12v-48c0-30.53-21.41-55.96-50-62.36zM96 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm20.55-112l17.2-66.36c2.23-8.16 9.59-13.64 15.06-13.64h214.4c5.47 0 12.83 5.48 14.85 12.86L395.45 240h-278.9zM416 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        teeth: [
            640,
            512,
            [],
            "f62e",
            "M544 0H96C42.98 0 0 42.98 0 96v320c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96zM160 368c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm128 128c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64z"
        ],
        "teeth-open": [
            640,
            512,
            [],
            "f62f",
            "M544 0H96C42.98 0 0 42.98 0 96v64c0 35.35 28.66 64 64 64h512c35.34 0 64-28.65 64-64V96c0-53.02-42.98-96-96-96zM160 176c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm128 0c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm0 144H64c-35.34 0-64 28.65-64 64v32c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96v-32c0-35.35-28.66-64-64-64zm-416 80c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32zm144-8c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm144 0c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm128 8c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32z"
        ],
        "temperature-high": [
            512,
            512,
            [],
            "f769",
            "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
        ],
        "temperature-low": [
            512,
            512,
            [],
            "f76b",
            "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v18.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
        ],
        tenge: [
            384,
            512,
            [],
            "f7d7",
            "M372 160H12c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12h140v228c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12V240h140c6.6 0 12-5.4 12-12v-56c0-6.6-5.4-12-12-12zm0-128H12C5.4 32 0 37.4 0 44v56c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12V44c0-6.6-5.4-12-12-12z"
        ],
        terminal: [
            640,
            512,
            [],
            "f120",
            "M257.981 272.971L63.638 467.314c-9.373 9.373-24.569 9.373-33.941 0L7.029 444.647c-9.357-9.357-9.375-24.522-.04-33.901L161.011 256 6.99 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L257.981 239.03c9.373 9.372 9.373 24.568 0 33.941zM640 456v-32c0-13.255-10.745-24-24-24H312c-13.255 0-24 10.745-24 24v32c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24z"
        ],
        "text-height": [
            576,
            512,
            [],
            "f034",
            "M304 32H16A16 16 0 0 0 0 48v96a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32h56v304H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-40V112h56v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm256 336h-48V144h48c14.31 0 21.33-17.31 11.31-27.31l-80-80a16 16 0 0 0-22.62 0l-80 80C379.36 126 384.36 144 400 144h48v224h-48c-14.31 0-21.32 17.31-11.31 27.31l80 80a16 16 0 0 0 22.62 0l80-80C580.64 386 575.64 368 560 368z"
        ],
        "text-width": [
            448,
            512,
            [],
            "f035",
            "M432 32H16A16 16 0 0 0 0 48v80a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16h120v112h-24a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-24V112h120v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm-68.69 260.69C354 283.36 336 288.36 336 304v48H112v-48c0-14.31-17.31-21.32-27.31-11.31l-80 80a16 16 0 0 0 0 22.62l80 80C94 484.64 112 479.64 112 464v-48h224v48c0 14.31 17.31 21.33 27.31 11.31l80-80a16 16 0 0 0 0-22.62z"
        ],
        th: [
            512,
            512,
            [],
            "f00a",
            "M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z"
        ],
        "th-large": [
            512,
            512,
            [],
            "f009",
            "M296 32h192c13.255 0 24 10.745 24 24v160c0 13.255-10.745 24-24 24H296c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24zm-80 0H24C10.745 32 0 42.745 0 56v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zM0 296v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm296 184h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H296c-13.255 0-24 10.745-24 24v160c0 13.255 10.745 24 24 24z"
        ],
        "th-list": [
            512,
            512,
            [],
            "f00b",
            "M149.333 216v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-80c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zM125.333 32H24C10.745 32 0 42.745 0 56v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zm80 448H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm-24-424v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24zm24 264H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24z"
        ],
        "theater-masks": [
            640,
            512,
            [],
            "f630",
            "M206.86 245.15c-35.88 10.45-59.95 41.2-57.53 74.1 11.4-12.72 28.81-23.7 49.9-30.92l7.63-43.18zM95.81 295L64.08 115.49c-.29-1.62.28-2.62.24-2.65 57.76-32.06 123.12-49.01 189.01-49.01 1.61 0 3.23.17 4.85.19 13.95-13.47 31.73-22.83 51.59-26 18.89-3.02 38.05-4.55 57.18-5.32-9.99-13.95-24.48-24.23-41.77-27C301.27 1.89 277.24 0 253.32 0 176.66 0 101.02 19.42 33.2 57.06 9.03 70.48-3.92 98.48 1.05 126.58l31.73 179.51c14.23 80.52 136.33 142.08 204.45 142.08 3.59 0 6.75-.46 10.01-.8-13.52-17.08-28.94-40.48-39.5-67.58-47.61-12.98-106.06-51.62-111.93-84.79zm97.55-137.46c-.73-4.12-2.23-7.87-4.07-11.4-8.25 8.91-20.67 15.75-35.32 18.32-14.65 2.58-28.67.4-39.48-5.17-.52 3.94-.64 7.98.09 12.1 3.84 21.7 24.58 36.19 46.34 32.37 21.75-3.82 36.28-24.52 32.44-46.22zM606.8 120.9c-88.98-49.38-191.43-67.41-291.98-51.35-27.31 4.36-49.08 26.26-54.04 54.36l-31.73 179.51c-15.39 87.05 95.28 196.27 158.31 207.35 63.03 11.09 204.47-53.79 219.86-140.84l31.73-179.51c4.97-28.11-7.98-56.11-32.15-69.52zm-273.24 96.8c3.84-21.7 24.58-36.19 46.34-32.36 21.76 3.83 36.28 24.52 32.45 46.22-.73 4.12-2.23 7.87-4.07 11.4-8.25-8.91-20.67-15.75-35.32-18.32-14.65-2.58-28.67-.4-39.48 5.17-.53-3.95-.65-7.99.08-12.11zm70.47 198.76c-55.68-9.79-93.52-59.27-89.04-112.9 20.6 25.54 56.21 46.17 99.49 53.78 43.28 7.61 83.82.37 111.93-16.6-14.18 51.94-66.71 85.51-122.38 75.72zm130.3-151.34c-8.25-8.91-20.68-15.75-35.33-18.32-14.65-2.58-28.67-.4-39.48 5.17-.52-3.94-.64-7.98.09-12.1 3.84-21.7 24.58-36.19 46.34-32.37 21.75 3.83 36.28 24.52 32.45 46.22-.73 4.13-2.23 7.88-4.07 11.4z"
        ],
        thermometer: [
            512,
            512,
            [],
            "f491",
            "M476.8 20.4c-37.5-30.7-95.5-26.3-131.9 10.2l-45.7 46 50.5 50.5c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.4-50.5-45.1 45.4 50.3 50.4c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L209 167.4l-45.1 45.4L214 263c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.1-50.2L96 281.1V382L7 471c-9.4 9.4-9.4 24.6 0 33.9 9.4 9.4 24.6 9.4 33.9 0l89-89h99.9L484 162.6c34.9-34.9 42.2-101.5-7.2-142.2z"
        ],
        "thermometer-empty": [
            256,
            512,
            [],
            "f2cb",
            "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
        ],
        "thermometer-full": [
            256,
            512,
            [],
            "f2c7",
            "M224 96c0-53.019-42.981-96-96-96S32 42.981 32 96v203.347C12.225 321.756.166 351.136.002 383.333c-.359 70.303 56.787 128.176 127.089 128.664.299.002.61.003.909.003 70.698 0 128-57.304 128-128 0-32.459-12.088-62.09-32-84.653V96zm-96 368l-.576-.002c-43.86-.304-79.647-36.544-79.423-80.42.173-33.98 19.266-51.652 31.999-66.08V96c0-26.467 21.533-48 48-48s48 21.533 48 48v221.498c12.63 14.312 32 32.164 32 66.502 0 44.112-35.888 80-80 80zm64-80c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V96c0-17.673 14.327-32 32-32s32 14.327 32 32v232.583c19.124 11.068 32 31.732 32 55.417z"
        ],
        "thermometer-half": [
            256,
            512,
            [],
            "f2c9",
            "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V224c0-17.673 14.327-32 32-32s32 14.327 32 32v104.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
        ],
        "thermometer-quarter": [
            256,
            512,
            [],
            "f2ca",
            "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V288c0-17.673 14.327-32 32-32s32 14.327 32 32v40.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
        ],
        "thermometer-three-quarters": [
            256,
            512,
            [],
            "f2c8",
            "M192 384c0 35.346-28.654 64-64 64-35.346 0-64-28.654-64-64 0-23.685 12.876-44.349 32-55.417V160c0-17.673 14.327-32 32-32s32 14.327 32 32v168.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
        ],
        "thumbs-down": [
            512,
            512,
            [],
            "f165",
            "M0 56v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56zm40 200c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24zm272 256c-20.183 0-29.485-39.293-33.931-57.795-5.206-21.666-10.589-44.07-25.393-58.902-32.469-32.524-49.503-73.967-89.117-113.111a11.98 11.98 0 0 1-3.558-8.521V59.901c0-6.541 5.243-11.878 11.783-11.998 15.831-.29 36.694-9.079 52.651-16.178C256.189 17.598 295.709.017 343.995 0h2.844c42.777 0 93.363.413 113.774 29.737 8.392 12.057 10.446 27.034 6.148 44.632 16.312 17.053 25.063 48.863 16.382 74.757 17.544 23.432 19.143 56.132 9.308 79.469l.11.11c11.893 11.949 19.523 31.259 19.439 49.197-.156 30.352-26.157 58.098-59.553 58.098H350.723C358.03 364.34 384 388.132 384 430.548 384 504 336 512 312 512z"
        ],
        "thumbs-up": [
            512,
            512,
            [],
            "f164",
            "M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z"
        ],
        thumbtack: [
            384,
            512,
            [],
            "f08d",
            "M298.028 214.267L285.793 96H328c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v48c0 13.255 10.745 24 24 24h42.207L85.972 214.267C37.465 236.82 0 277.261 0 328c0 13.255 10.745 24 24 24h136v104.007c0 1.242.289 2.467.845 3.578l24 48c2.941 5.882 11.364 5.893 14.311 0l24-48a8.008 8.008 0 0 0 .845-3.578V352h136c13.255 0 24-10.745 24-24-.001-51.183-37.983-91.42-85.973-113.733z"
        ],
        "ticket-alt": [
            576,
            512,
            [],
            "f3ff",
            "M128 160h320v192H128V160zm400 96c0 26.51 21.49 48 48 48v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c26.51 0 48-21.49 48-48s-21.49-48-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v96c-26.51 0-48 21.49-48 48zm-48-104c0-13.255-10.745-24-24-24H120c-13.255 0-24 10.745-24 24v208c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V152z"
        ],
        times: [
            352,
            512,
            [],
            "f00d",
            "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
        ],
        "times-circle": [
            512,
            512,
            [],
            "f057",
            "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
        ],
        tint: [
            352,
            512,
            [],
            "f043",
            "M205.22 22.09c-7.94-28.78-49.44-30.12-58.44 0C100.01 179.85 0 222.72 0 333.91 0 432.35 78.72 512 176 512s176-79.65 176-178.09c0-111.75-99.79-153.34-146.78-311.82zM176 448c-61.75 0-112-50.25-112-112 0-8.84 7.16-16 16-16s16 7.16 16 16c0 44.11 35.89 80 80 80 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
        ],
        "tint-slash": [
            640,
            512,
            [],
            "f5c7",
            "M633.82 458.1L494.97 350.78c.52-5.57 1.03-11.16 1.03-16.87 0-111.76-99.79-153.34-146.78-311.82-7.94-28.78-49.44-30.12-58.44 0-15.52 52.34-36.87 91.96-58.49 125.68L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM144 333.91C144 432.35 222.72 512 320 512c44.71 0 85.37-16.96 116.4-44.7L162.72 255.78c-11.41 23.5-18.72 48.35-18.72 78.13z"
        ],
        tired: [
            496,
            512,
            [],
            "f5c8",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 288c51.9 0 115.3 43.8 123.2 106.7 1.7 13.6-8 24.6-17.7 20.4-25.9-11.1-64.4-17.4-105.5-17.4s-79.6 6.3-105.5 17.4c-9.8 4.2-19.4-7-17.7-20.4C132.7 331.8 196.1 288 248 288z"
        ],
        "toggle-off": [
            576,
            512,
            [],
            "f204",
            "M384 64H192C85.961 64 0 149.961 0 256s85.961 192 192 192h192c106.039 0 192-85.961 192-192S490.039 64 384 64zM64 256c0-70.741 57.249-128 128-128 70.741 0 128 57.249 128 128 0 70.741-57.249 128-128 128-70.741 0-128-57.249-128-128zm320 128h-48.905c65.217-72.858 65.236-183.12 0-256H384c70.741 0 128 57.249 128 128 0 70.74-57.249 128-128 128z"
        ],
        "toggle-on": [
            576,
            512,
            [],
            "f205",
            "M384 64H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64zm0 320c-70.8 0-128-57.3-128-128 0-70.8 57.3-128 128-128 70.8 0 128 57.3 128 128 0 70.8-57.3 128-128 128z"
        ],
        toilet: [
            384,
            512,
            [],
            "f7d8",
            "M368 48c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v16c0 8.8 7.2 16 16 16h16v156.7C11.8 214.8 0 226.9 0 240c0 67.2 34.6 126.2 86.8 160.5l-21.4 70.2C59.1 491.2 74.5 512 96 512h192c21.5 0 36.9-20.8 30.6-41.3l-21.4-70.2C349.4 366.2 384 307.2 384 240c0-13.1-11.8-25.2-32-35.3V48h16zM80 72c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V72zm112 200c-77.1 0-139.6-14.3-139.6-32s62.5-32 139.6-32 139.6 14.3 139.6 32-62.5 32-139.6 32z"
        ],
        "toilet-paper": [
            576,
            512,
            [],
            "f71e",
            "M128 0C74.98 0 32 85.96 32 192v172.07c0 41.12-9.8 62.77-31.17 126.87C-2.62 501.3 5.09 512 16.01 512h280.92c13.77 0 26-8.81 30.36-21.88 12.83-38.48 24.71-72.4 24.71-126.05V192c0-83.6 23.67-153.52 60.44-192H128zM96 224c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zM480 0c-53.02 0-96 85.96-96 192s42.98 192 96 192 96-85.96 96-192S533.02 0 480 0zm0 256c-17.67 0-32-28.65-32-64s14.33-64 32-64 32 28.65 32 64-14.33 64-32 64z"
        ],
        "toilet-paper-slash": [
            640,
            512,
            [],
            "e072",
            "M64,192V364.13c0,41.12-9.75,62.75-31.12,126.87A16,16,0,0,0,48,512H328.86a31.87,31.87,0,0,0,30.38-21.87c9.31-27.83,18-53.35,22.18-85.55l-316-244.25C64.53,170.66,64,181.19,64,192ZM633.82,458.09l-102-78.81C575.28,360.91,608,284.32,608,192,608,86,565,0,512,0s-96,86-96,192c0,42,7,80.4,18.43,112L384,265V192c0-83.62,23.63-153.5,60.5-192H160c-23.33,0-44.63,16.83-61.26,44.53L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09ZM512,256c-17.63,0-32-28.62-32-64s14.37-64,32-64,32,28.63,32,64S529.62,256,512,256Z"
        ],
        toolbox: [
            512,
            512,
            [],
            "f552",
            "M502.63 214.63l-45.25-45.25c-6-6-14.14-9.37-22.63-9.37H384V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v80H77.25c-8.49 0-16.62 3.37-22.63 9.37L9.37 214.63c-6 6-9.37 14.14-9.37 22.63V320h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-82.75c0-8.48-3.37-16.62-9.37-22.62zM320 160H192V96h128v64zm64 208c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H192v16c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H0v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96H384v16z"
        ],
        tools: [
            512,
            512,
            [],
            "f7d9",
            "M501.1 395.7L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7zM331.7 225c28.3 0 54.9 11 74.9 31l19.4 19.4c15.8-6.9 30.8-16.5 43.8-29.5 37.1-37.1 49.7-89.3 37.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4 74.4-67.9-11.3L334 98.9l74.4-74.4c6.6-6.6 3.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6 37.9-28.5 28.5-41.9 66.1-41.2 103.6l82.1 82.1c8.1-1.9 16.5-2.9 24.7-2.9zm-103.9 82l-56.7-56.7L18.7 402.8c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zM64 472c-13.2 0-24-10.8-24-24 0-13.3 10.7-24 24-24s24 10.7 24 24c0 13.2-10.7 24-24 24z"
        ],
        tooth: [
            448,
            512,
            [],
            "f5c9",
            "M443.98 96.25c-11.01-45.22-47.11-82.06-92.01-93.72-32.19-8.36-63 5.1-89.14 24.33-3.25 2.39-6.96 3.73-10.5 5.48l28.32 18.21c7.42 4.77 9.58 14.67 4.8 22.11-4.46 6.95-14.27 9.86-22.11 4.8L162.83 12.84c-20.7-10.85-43.38-16.4-66.81-10.31-44.9 11.67-81 48.5-92.01 93.72-10.13 41.62-.42 80.81 21.5 110.43 23.36 31.57 32.68 68.66 36.29 107.35 4.4 47.16 10.33 94.16 20.94 140.32l7.8 33.95c3.19 13.87 15.49 23.7 29.67 23.7 13.97 0 26.15-9.55 29.54-23.16l34.47-138.42c4.56-18.32 20.96-31.16 39.76-31.16s35.2 12.85 39.76 31.16l34.47 138.42c3.39 13.61 15.57 23.16 29.54 23.16 14.18 0 26.48-9.83 29.67-23.7l7.8-33.95c10.61-46.15 16.53-93.16 20.94-140.32 3.61-38.7 12.93-75.78 36.29-107.35 21.95-29.61 31.66-68.8 21.53-110.43z"
        ],
        torah: [
            640,
            512,
            [],
            "f6a0",
            "M320.05 366.48l17.72-29.64h-35.46zm99.21-166H382.4l18.46 30.82zM48 0C21.49 0 0 14.33 0 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32C96 14.33 74.51 0 48 0zm172.74 311.5h36.85l-18.46-30.82zm161.71 0h36.86l-18.45-30.8zM128 464h384V48H128zm66.77-278.13a21.22 21.22 0 0 1 18.48-10.71h59.45l29.13-48.71a21.13 21.13 0 0 1 18.22-10.37A20.76 20.76 0 0 1 338 126.29l29.25 48.86h59.52a21.12 21.12 0 0 1 18.1 32L415.63 256 445 305a20.69 20.69 0 0 1 .24 21.12 21.25 21.25 0 0 1-18.48 10.72h-59.47l-29.13 48.7a21.13 21.13 0 0 1-18.16 10.4 20.79 20.79 0 0 1-18-10.22l-29.25-48.88h-59.5a21.11 21.11 0 0 1-18.1-32L224.36 256 195 207a20.7 20.7 0 0 1-.23-21.13zM592 0c-26.51 0-48 14.33-48 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32c0-17.67-21.49-32-48-32zM320 145.53l-17.78 29.62h35.46zm-62.45 55h-36.81l18.44 30.8zm29.58 111h65.79L386.09 256l-33.23-55.52h-65.79L253.9 256z"
        ],
        "torii-gate": [
            512,
            512,
            [],
            "f6a1",
            "M376.45 32h-240.9A303.17 303.17 0 0 1 0 0v96c0 17.67 14.33 32 32 32h32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h256v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h48c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-48v-64h32c17.67 0 32-14.33 32-32V0a303.17 303.17 0 0 1-135.55 32zM128 128h96v64h-96v-64zm256 64h-96v-64h96v64z"
        ],
        tractor: [
            640,
            512,
            [],
            "f722",
            "M528 336c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 112c-13.23 0-24-10.77-24-24s10.77-24 24-24 24 10.77 24 24-10.77 24-24 24zm80-288h-64v-40.2c0-14.12 4.7-27.76 13.15-38.84 4.42-5.8 3.55-14.06-1.32-19.49L534.2 37.3c-6.66-7.45-18.32-6.92-24.7.78C490.58 60.9 480 89.81 480 119.8V160H377.67L321.58 29.14A47.914 47.914 0 0 0 277.45 0H144c-26.47 0-48 21.53-48 48v146.52c-8.63-6.73-20.96-6.46-28.89 1.47L36 227.1c-8.59 8.59-8.59 22.52 0 31.11l5.06 5.06c-4.99 9.26-8.96 18.82-11.91 28.72H22c-12.15 0-22 9.85-22 22v44c0 12.15 9.85 22 22 22h7.14c2.96 9.91 6.92 19.46 11.91 28.73l-5.06 5.06c-8.59 8.59-8.59 22.52 0 31.11L67.1 476c8.59 8.59 22.52 8.59 31.11 0l5.06-5.06c9.26 4.99 18.82 8.96 28.72 11.91V490c0 12.15 9.85 22 22 22h44c12.15 0 22-9.85 22-22v-7.14c9.9-2.95 19.46-6.92 28.72-11.91l5.06 5.06c8.59 8.59 22.52 8.59 31.11 0l31.11-31.11c8.59-8.59 8.59-22.52 0-31.11l-5.06-5.06c4.99-9.26 8.96-18.82 11.91-28.72H330c12.15 0 22-9.85 22-22v-6h80.54c21.91-28.99 56.32-48 95.46-48 18.64 0 36.07 4.61 51.8 12.2l50.82-50.82c6-6 9.37-14.14 9.37-22.63V192c.01-17.67-14.32-32-31.99-32zM176 416c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm22-256h-38V64h106.89l41.15 96H198z"
        ],
        trademark: [
            640,
            512,
            [],
            "f25c",
            "M260.6 96H12c-6.6 0-12 5.4-12 12v43.1c0 6.6 5.4 12 12 12h85.1V404c0 6.6 5.4 12 12 12h54.3c6.6 0 12-5.4 12-12V163.1h85.1c6.6 0 12-5.4 12-12V108c.1-6.6-5.3-12-11.9-12zM640 403l-24-296c-.5-6.2-5.7-11-12-11h-65.4c-5.1 0-9.7 3.3-11.3 8.1l-43.8 127.1c-7.2 20.6-16.1 52.8-16.1 52.8h-.9s-8.9-32.2-16.1-52.8l-43.8-127.1c-1.7-4.8-6.2-8.1-11.3-8.1h-65.4c-6.2 0-11.4 4.8-12 11l-24.4 296c-.6 7 4.9 13 12 13H360c6.3 0 11.5-4.9 12-11.2l9.1-132.9c1.8-24.2 0-53.7 0-53.7h.9s10.7 33.6 17.9 53.7l30.7 84.7c1.7 4.7 6.2 7.9 11.3 7.9h50.3c5.1 0 9.6-3.2 11.3-7.9l30.7-84.7c7.2-20.1 17.9-53.7 17.9-53.7h.9s-1.8 29.5 0 53.7l9.1 132.9c.4 6.3 5.7 11.2 12 11.2H628c7 0 12.5-6 12-13z"
        ],
        "traffic-light": [
            384,
            512,
            [],
            "f637",
            "M384 192h-64v-37.88c37.2-13.22 64-48.38 64-90.12h-64V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v32H0c0 41.74 26.8 76.9 64 90.12V192H0c0 41.74 26.8 76.9 64 90.12V320H0c0 42.84 28.25 78.69 66.99 91.05C79.42 468.72 130.6 512 192 512s112.58-43.28 125.01-100.95C355.75 398.69 384 362.84 384 320h-64v-37.88c37.2-13.22 64-48.38 64-90.12zM192 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"
        ],
        trailer: [
            640,
            512,
            [],
            "e041",
            "M624,320H544V80a16,16,0,0,0-16-16H16A16,16,0,0,0,0,80V368a16,16,0,0,0,16,16H65.61c7.83-54.21,54-96,110.39-96s102.56,41.79,110.39,96H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM96,243.68a176.29,176.29,0,0,0-32,20.71V136a8,8,0,0,1,8-8H88a8,8,0,0,1,8,8Zm96-18.54c-5.31-.49-10.57-1.14-16-1.14s-10.69.65-16,1.14V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,39.25a176.29,176.29,0,0,0-32-20.71V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8ZM384,320H352V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,0H448V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm-304,0a80,80,0,1,0,80,80A80,80,0,0,0,176,320Zm0,112a32,32,0,1,1,32-32A32,32,0,0,1,176,432Z"
        ],
        train: [
            448,
            512,
            [],
            "f238",
            "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zm-48 136V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24zm-176 64c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56z"
        ],
        tram: [
            512,
            512,
            [],
            "f7da",
            "M288 64c17.7 0 32-14.3 32-32S305.7 0 288 0s-32 14.3-32 32 14.3 32 32 32zm223.5-12.1c-2.3-8.6-11-13.6-19.6-11.3l-480 128c-8.5 2.3-13.6 11-11.3 19.6C2.5 195.3 8.9 200 16 200c1.4 0 2.8-.2 4.1-.5L240 140.8V224H64c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H272v-91.7l228.1-60.8c8.6-2.3 13.6-11.1 11.4-19.6zM176 384H80v-96h96v96zm160-96h96v96h-96v-96zm-32 0v96h-96v-96h96zM192 96c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
        ],
        transgender: [
            384,
            512,
            [],
            "f224",
            "M372 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C198.5 104.1 172.2 96 144 96 64.5 96 0 160.5 0 240c0 68.5 47.9 125.9 112 140.4V408H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM144 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
        ],
        "transgender-alt": [
            480,
            512,
            [],
            "f225",
            "M468 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C294.5 104.1 268.2 96 240 96c-28.2 0-54.5 8.1-76.7 22.1l-16.5-16.5 19.8-19.8c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0l-19.8 19.8-19-19 16.9-16.9C107.1 12.9 101.7 0 91 0H12C5.4 0 0 5.4 0 12v79c0 10.7 12.9 16 20.5 8.5l16.9-16.9 19 19-19.8 19.8c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l19.8-19.8 16.5 16.5C104.1 185.5 96 211.8 96 240c0 68.5 47.9 125.9 112 140.4V408h-36c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM240 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
        ],
        trash: [
            448,
            512,
            [],
            "f1f8",
            "M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"
        ],
        "trash-alt": [
            448,
            512,
            [],
            "f2ed",
            "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
        ],
        "trash-restore": [
            448,
            512,
            [],
            "f829",
            "M53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32zm70.11-175.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
        ],
        "trash-restore-alt": [
            448,
            512,
            [],
            "f82a",
            "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm91.31-172.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
        ],
        tree: [
            384,
            512,
            [],
            "f1bb",
            "M378.31 378.49L298.42 288h30.63c9.01 0 16.98-5 20.78-13.06 3.8-8.04 2.55-17.26-3.28-24.05L268.42 160h28.89c9.1 0 17.3-5.35 20.86-13.61 3.52-8.13 1.86-17.59-4.24-24.08L203.66 4.83c-6.03-6.45-17.28-6.45-23.32 0L70.06 122.31c-6.1 6.49-7.75 15.95-4.24 24.08C69.38 154.65 77.59 160 86.69 160h28.89l-78.14 90.91c-5.81 6.78-7.06 15.99-3.27 24.04C37.97 283 45.93 288 54.95 288h30.63L5.69 378.49c-6 6.79-7.36 16.09-3.56 24.26 3.75 8.05 12 13.25 21.01 13.25H160v24.45l-30.29 48.4c-5.32 10.64 2.42 23.16 14.31 23.16h95.96c11.89 0 19.63-12.52 14.31-23.16L224 440.45V416h136.86c9.01 0 17.26-5.2 21.01-13.25 3.8-8.17 2.44-17.47-3.56-24.26z"
        ],
        trophy: [
            576,
            512,
            [],
            "f091",
            "M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"
        ],
        truck: [
            640,
            512,
            [],
            "f0d1",
            "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
        ],
        "truck-loading": [
            640,
            512,
            [],
            "f4de",
            "M50.2 375.6c2.3 8.5 11.1 13.6 19.6 11.3l216.4-58c8.5-2.3 13.6-11.1 11.3-19.6l-49.7-185.5c-2.3-8.5-11.1-13.6-19.6-11.3L151 133.3l24.8 92.7-61.8 16.5-24.8-92.7-77.3 20.7C3.4 172.8-1.7 181.6.6 190.1l49.6 185.5zM384 0c-17.7 0-32 14.3-32 32v323.6L5.9 450c-4.3 1.2-6.8 5.6-5.6 9.8l12.6 46.3c1.2 4.3 5.6 6.8 9.8 5.6l393.7-107.4C418.8 464.1 467.6 512 528 512c61.9 0 112-50.1 112-112V0H384zm144 448c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
        ],
        "truck-monster": [
            640,
            512,
            [],
            "f63b",
            "M624 224h-16v-64c0-17.67-14.33-32-32-32h-73.6L419.22 24.02A64.025 64.025 0 0 0 369.24 0H256c-17.67 0-32 14.33-32 32v96H48c-8.84 0-16 7.16-16 16v80H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16.72c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64h65.45c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-336-96V64h81.24l51.2 64H288zm304 224h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 512 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67A110.85 110.85 0 0 0 373.2 352H368c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32c-.02-8.84-7.18-16-16.02-16zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-208-80h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 192 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0L58.18 304.8c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67a110.85 110.85 0 0 0-8.65 20.89H48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32C288 359.16 280.84 352 272 352zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"
        ],
        "truck-moving": [
            640,
            512,
            [],
            "f4df",
            "M621.3 237.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7H480V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v336c0 44.2 35.8 80 80 80 26.3 0 49.4-12.9 64-32.4 14.6 19.6 37.7 32.4 64 32.4 44.2 0 80-35.8 80-80 0-5.5-.6-10.8-1.6-16h163.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H624c8.8 0 16-7.2 16-16v-85.5c0-17-6.7-33.2-18.7-45.2zM80 432c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm128 0c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm272-224h37.5c4.3 0 8.3 1.7 11.3 4.7l43.3 43.3H480v-48zm48 224c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z"
        ],
        "truck-pickup": [
            640,
            512,
            [],
            "f63c",
            "M624 288h-16v-64c0-17.67-14.33-32-32-32h-48L419.22 56.02A64.025 64.025 0 0 0 369.24 32H256c-17.67 0-32 14.33-32 32v128H64c-17.67 0-32 14.33-32 32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h49.61c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16h67.23c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM288 96h81.24l76.8 96H288V96zM176 416c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm288 0c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
        ],
        tshirt: [
            640,
            512,
            [],
            "f553",
            "M631.2 96.5L436.5 0C416.4 27.8 371.9 47.2 320 47.2S223.6 27.8 203.5 0L8.8 96.5c-7.9 4-11.1 13.6-7.2 21.5l57.2 114.5c4 7.9 13.6 11.1 21.5 7.2l56.6-27.7c10.6-5.2 23 2.5 23 14.4V480c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V226.3c0-11.8 12.4-19.6 23-14.4l56.6 27.7c7.9 4 17.5.8 21.5-7.2L638.3 118c4-7.9.8-17.6-7.1-21.5z"
        ],
        tty: [
            512,
            512,
            [],
            "f1e4",
            "M5.37 103.822c138.532-138.532 362.936-138.326 501.262 0 6.078 6.078 7.074 15.496 2.583 22.681l-43.214 69.138a18.332 18.332 0 0 1-22.356 7.305l-86.422-34.569a18.335 18.335 0 0 1-11.434-18.846L351.741 90c-62.145-22.454-130.636-21.986-191.483 0l5.953 59.532a18.331 18.331 0 0 1-11.434 18.846l-86.423 34.568a18.334 18.334 0 0 1-22.356-7.305L2.787 126.502a18.333 18.333 0 0 1 2.583-22.68zM96 308v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H92c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zM96 500v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H140c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"
        ],
        tv: [
            640,
            512,
            [],
            "f26c",
            "M592 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h240v32H112a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H352v-32h240a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm-16 352H64V64h512z"
        ],
        umbrella: [
            576,
            512,
            [],
            "f0e9",
            "M575.7 280.8C547.1 144.5 437.3 62.6 320 49.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v17.9C138.3 62.6 29.5 144.5.3 280.8c-2.2 10.1 8.5 21.3 18.7 11.4 52-55 107.7-52.4 158.6 37 5.3 9.5 14.9 8.6 19.7 0 20.2-35.4 44.9-73.2 90.7-73.2 58.5 0 88.2 68.8 90.7 73.2 4.8 8.6 14.4 9.5 19.7 0 51-89.5 107.1-91.4 158.6-37 10.3 10 20.9-1.3 18.7-11.4zM256 301.7V432c0 8.8-7.2 16-16 16-7.8 0-13.2-5.3-15.1-10.7-5.9-16.7-24.1-25.4-40.8-19.5-16.7 5.9-25.4 24.2-19.5 40.8 11.2 31.9 41.6 53.3 75.4 53.3 44.1 0 80-35.9 80-80V301.6c-9.1-7.9-19.8-13.6-32-13.6-12.3.1-22.4 4.8-32 13.7z"
        ],
        "umbrella-beach": [
            640,
            512,
            [],
            "f5ca",
            "M115.38 136.9l102.11 37.18c35.19-81.54 86.21-144.29 139-173.7-95.88-4.89-188.78 36.96-248.53 111.8-6.69 8.4-2.66 21.05 7.42 24.72zm132.25 48.16l238.48 86.83c35.76-121.38 18.7-231.66-42.63-253.98-7.4-2.7-15.13-4-23.09-4-58.02.01-128.27 69.17-172.76 171.15zM521.48 60.5c6.22 16.3 10.83 34.6 13.2 55.19 5.74 49.89-1.42 108.23-18.95 166.98l102.62 37.36c10.09 3.67 21.31-3.43 21.57-14.17 2.32-95.69-41.91-187.44-118.44-245.36zM560 447.98H321.06L386 269.5l-60.14-21.9-72.9 200.37H16c-8.84 0-16 7.16-16 16.01v32.01C0 504.83 7.16 512 16 512h544c8.84 0 16-7.17 16-16.01v-32.01c0-8.84-7.16-16-16-16z"
        ],
        underline: [
            448,
            512,
            [],
            "f0cd",
            "M32 64h32v160c0 88.22 71.78 160 160 160s160-71.78 160-160V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H272a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32v160a80 80 0 0 1-160 0V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm400 384H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
        ],
        undo: [
            512,
            512,
            [],
            "f0e2",
            "M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z"
        ],
        "undo-alt": [
            512,
            512,
            [],
            "f2ea",
            "M255.545 8c-66.269.119-126.438 26.233-170.86 68.685L48.971 40.971C33.851 25.851 8 36.559 8 57.941V192c0 13.255 10.745 24 24 24h134.059c21.382 0 32.09-25.851 16.971-40.971l-41.75-41.75c30.864-28.899 70.801-44.907 113.23-45.273 92.398-.798 170.283 73.977 169.484 169.442C423.236 348.009 349.816 424 256 424c-41.127 0-79.997-14.678-110.63-41.556-4.743-4.161-11.906-3.908-16.368.553L89.34 422.659c-4.872 4.872-4.631 12.815.482 17.433C133.798 479.813 192.074 504 256 504c136.966 0 247.999-111.033 248-247.998C504.001 119.193 392.354 7.755 255.545 8z"
        ],
        "universal-access": [
            512,
            512,
            [],
            "f29a",
            "M256 48c114.953 0 208 93.029 208 208 0 114.953-93.029 208-208 208-114.953 0-208-93.029-208-208 0-114.953 93.029-208 208-208m0-40C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 56C149.961 64 64 149.961 64 256s85.961 192 192 192 192-85.961 192-192S362.039 64 256 64zm0 44c19.882 0 36 16.118 36 36s-16.118 36-36 36-36-16.118-36-36 16.118-36 36-36zm117.741 98.023c-28.712 6.779-55.511 12.748-82.14 15.807.851 101.023 12.306 123.052 25.037 155.621 3.617 9.26-.957 19.698-10.217 23.315-9.261 3.617-19.699-.957-23.316-10.217-8.705-22.308-17.086-40.636-22.261-78.549h-9.686c-5.167 37.851-13.534 56.208-22.262 78.549-3.615 9.255-14.05 13.836-23.315 10.217-9.26-3.617-13.834-14.056-10.217-23.315 12.713-32.541 24.185-54.541 25.037-155.621-26.629-3.058-53.428-9.027-82.141-15.807-8.6-2.031-13.926-10.648-11.895-19.249s10.647-13.926 19.249-11.895c96.686 22.829 124.283 22.783 220.775 0 8.599-2.03 17.218 3.294 19.249 11.895 2.029 8.601-3.297 17.219-11.897 19.249z"
        ],
        university: [
            512,
            512,
            [],
            "f19c",
            "M496 128v16a8 8 0 0 1-8 8h-24v12c0 6.627-5.373 12-12 12H60c-6.627 0-12-5.373-12-12v-12H24a8 8 0 0 1-8-8v-16a8 8 0 0 1 4.941-7.392l232-88a7.996 7.996 0 0 1 6.118 0l232 88A8 8 0 0 1 496 128zm-24 304H40c-13.255 0-24 10.745-24 24v16a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-16c0-13.255-10.745-24-24-24zM96 192v192H60c-6.627 0-12 5.373-12 12v20h416v-20c0-6.627-5.373-12-12-12h-36V192h-64v192h-64V192h-64v192h-64V192H96z"
        ],
        unlink: [
            512,
            512,
            [],
            "f127",
            "M304.083 405.907c4.686 4.686 4.686 12.284 0 16.971l-44.674 44.674c-59.263 59.262-155.693 59.266-214.961 0-59.264-59.265-59.264-155.696 0-214.96l44.675-44.675c4.686-4.686 12.284-4.686 16.971 0l39.598 39.598c4.686 4.686 4.686 12.284 0 16.971l-44.675 44.674c-28.072 28.073-28.072 73.75 0 101.823 28.072 28.072 73.75 28.073 101.824 0l44.674-44.674c4.686-4.686 12.284-4.686 16.971 0l39.597 39.598zm-56.568-260.216c4.686 4.686 12.284 4.686 16.971 0l44.674-44.674c28.072-28.075 73.75-28.073 101.824 0 28.072 28.073 28.072 73.75 0 101.823l-44.675 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.598 39.598c4.686 4.686 12.284 4.686 16.971 0l44.675-44.675c59.265-59.265 59.265-155.695 0-214.96-59.266-59.264-155.695-59.264-214.961 0l-44.674 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.597 39.598zm234.828 359.28l22.627-22.627c9.373-9.373 9.373-24.569 0-33.941L63.598 7.029c-9.373-9.373-24.569-9.373-33.941 0L7.029 29.657c-9.373 9.373-9.373 24.569 0 33.941l441.373 441.373c9.373 9.372 24.569 9.372 33.941 0z"
        ],
        unlock: [
            448,
            512,
            [],
            "f09c",
            "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
        ],
        "unlock-alt": [
            448,
            512,
            [],
            "f13e",
            "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zM264 408c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48z"
        ],
        upload: [
            512,
            512,
            [],
            "f093",
            "M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
        ],
        user: [
            448,
            512,
            [],
            "f007",
            "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
        ],
        "user-alt": [
            512,
            512,
            [],
            "f406",
            "M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0 112 64.5 112 144s64.5 144 144 144zm128 32h-55.1c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16H128C57.3 320 0 377.3 0 448v16c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128z"
        ],
        "user-alt-slash": [
            640,
            512,
            [],
            "f4fa",
            "M633.8 458.1L389.6 269.3C433.8 244.7 464 198.1 464 144 464 64.5 399.5 0 320 0c-67.1 0-123 46.1-139 108.2L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM198.4 320C124.2 320 64 380.2 64 454.4v9.6c0 26.5 21.5 48 48 48h382.2L245.8 320h-47.4z"
        ],
        "user-astronaut": [
            448,
            512,
            [],
            "f4fb",
            "M64 224h13.5c24.7 56.5 80.9 96 146.5 96s121.8-39.5 146.5-96H384c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-13.5C345.8 39.5 289.6 0 224 0S102.2 39.5 77.5 96H64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zm40-88c0-22.1 21.5-40 48-40h144c26.5 0 48 17.9 48 40v24c0 53-43 96-96 96h-48c-53 0-96-43-96-96v-24zm72 72l12-36 36-12-36-12-12-36-12 36-36 12 36 12 12 36zm151.6 113.4C297.7 340.7 262.2 352 224 352s-73.7-11.3-103.6-30.6C52.9 328.5 0 385 0 454.4v9.6c0 26.5 21.5 48 48 48h80v-64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64h80c26.5 0 48-21.5 48-48v-9.6c0-69.4-52.9-125.9-120.4-133zM272 448c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-96 0c-8.8 0-16 7.2-16 16v48h32v-48c0-8.8-7.2-16-16-16z"
        ],
        "user-check": [
            640,
            512,
            [],
            "f4fc",
            "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zm323-128.4l-27.8-28.1c-4.6-4.7-12.1-4.7-16.8-.1l-104.8 104-45.5-45.8c-4.6-4.7-12.1-4.7-16.8-.1l-28.1 27.9c-4.7 4.6-4.7 12.1-.1 16.8l81.7 82.3c4.6 4.7 12.1 4.7 16.8.1l141.3-140.2c4.6-4.7 4.7-12.2.1-16.8z"
        ],
        "user-circle": [
            496,
            512,
            [],
            "f2bd",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
        ],
        "user-clock": [
            640,
            512,
            [],
            "f4fd",
            "M496 224c-79.6 0-144 64.4-144 144s64.4 144 144 144 144-64.4 144-144-64.4-144-144-144zm64 150.3c0 5.3-4.4 9.7-9.7 9.7h-60.6c-5.3 0-9.7-4.4-9.7-9.7v-76.6c0-5.3 4.4-9.7 9.7-9.7h12.6c5.3 0 9.7 4.4 9.7 9.7V352h38.3c5.3 0 9.7 4.4 9.7 9.7v12.6zM320 368c0-27.8 6.7-54.1 18.2-77.5-8-1.5-16.2-2.5-24.6-2.5h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h347.1c-45.3-31.9-75.1-84.5-75.1-144zm-96-112c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128z"
        ],
        "user-cog": [
            640,
            512,
            [],
            "f4fe",
            "M610.5 373.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 400.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm201.2 226.5c-2.3-1.2-4.6-2.6-6.8-3.9l-7.9 4.6c-6 3.4-12.8 5.3-19.6 5.3-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-5.5-17.7 1.9-36.4 17.9-45.7l7.9-4.6c-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-16-9.2-23.4-28-17.9-45.7.9-2.9 2.2-5.8 3.2-8.7-3.8-.3-7.5-1.2-11.4-1.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c10.1 0 19.5-3.2 27.2-8.5-1.2-3.8-2-7.7-2-11.8v-9.2z"
        ],
        "user-edit": [
            640,
            512,
            [],
            "f4ff",
            "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h274.9c-2.4-6.8-3.4-14-2.6-21.3l6.8-60.9 1.2-11.1 7.9-7.9 77.3-77.3c-24.5-27.7-60-45.5-99.9-45.5zm45.3 145.3l-6.8 61c-1.1 10.2 7.5 18.8 17.6 17.6l60.9-6.8 137.9-137.9-71.7-71.7-137.9 137.8zM633 268.9L595.1 231c-9.3-9.3-24.5-9.3-33.8 0l-37.8 37.8-4.1 4.1 71.8 71.7 41.8-41.8c9.3-9.4 9.3-24.5 0-33.9z"
        ],
        "user-friends": [
            640,
            512,
            [],
            "f500",
            "M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z"
        ],
        "user-graduate": [
            448,
            512,
            [],
            "f501",
            "M319.4 320.6L224 416l-95.4-95.4C57.1 323.7 0 382.2 0 454.4v9.6c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-9.6c0-72.2-57.1-130.7-128.6-133.8zM13.6 79.8l6.4 1.5v58.4c-7 4.2-12 11.5-12 20.3 0 8.4 4.6 15.4 11.1 19.7L3.5 242c-1.7 6.9 2.1 14 7.6 14h41.8c5.5 0 9.3-7.1 7.6-14l-15.6-62.3C51.4 175.4 56 168.4 56 160c0-8.8-5-16.1-12-20.3V87.1l66 15.9c-8.6 17.2-14 36.4-14 57 0 70.7 57.3 128 128 128s128-57.3 128-128c0-20.6-5.3-39.8-14-57l96.3-23.2c18.2-4.4 18.2-27.1 0-31.5l-190.4-46c-13-3.1-26.7-3.1-39.7 0L13.6 48.2c-18.1 4.4-18.1 27.2 0 31.6z"
        ],
        "user-injured": [
            448,
            512,
            [],
            "f728",
            "M277.37 11.98C261.08 4.47 243.11 0 224 0c-53.69 0-99.5 33.13-118.51 80h81.19l90.69-68.02zM342.51 80c-7.9-19.47-20.67-36.2-36.49-49.52L239.99 80h102.52zM224 256c70.69 0 128-57.31 128-128 0-5.48-.95-10.7-1.61-16H97.61c-.67 5.3-1.61 10.52-1.61 16 0 70.69 57.31 128 128 128zM80 299.7V512h128.26l-98.45-221.52A132.835 132.835 0 0 0 80 299.7zM0 464c0 26.51 21.49 48 48 48V320.24C18.88 344.89 0 381.26 0 422.4V464zm256-48h-55.38l42.67 96H256c26.47 0 48-21.53 48-48s-21.53-48-48-48zm57.6-128h-16.71c-22.24 10.18-46.88 16-72.89 16s-50.65-5.82-72.89-16h-7.37l42.67 96H256c44.11 0 80 35.89 80 80 0 18.08-6.26 34.59-16.41 48H400c26.51 0 48-21.49 48-48v-41.6c0-74.23-60.17-134.4-134.4-134.4z"
        ],
        "user-lock": [
            640,
            512,
            [],
            "f502",
            "M224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm96 64a63.08 63.08 0 0 1 8.1-30.5c-4.8-.5-9.5-1.5-14.5-1.5h-16.7a174.08 174.08 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h280.9a63.54 63.54 0 0 1-8.9-32zm288-32h-32v-80a80 80 0 0 0-160 0v80h-32a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V320a32 32 0 0 0-32-32zM496 432a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm32-144h-64v-80a32 32 0 0 1 64 0z"
        ],
        "user-md": [
            448,
            512,
            [],
            "f0f0",
            "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zM104 424c0 13.3 10.7 24 24 24s24-10.7 24-24-10.7-24-24-24-24 10.7-24 24zm216-135.4v49c36.5 7.4 64 39.8 64 78.4v41.7c0 7.6-5.4 14.2-12.9 15.7l-32.2 6.4c-4.3.9-8.5-1.9-9.4-6.3l-3.1-15.7c-.9-4.3 1.9-8.6 6.3-9.4l19.3-3.9V416c0-62.8-96-65.1-96 1.9v26.7l19.3 3.9c4.3.9 7.1 5.1 6.3 9.4l-3.1 15.7c-.9 4.3-5.1 7.1-9.4 6.3l-31.2-4.2c-7.9-1.1-13.8-7.8-13.8-15.9V416c0-38.6 27.5-70.9 64-78.4v-45.2c-2.2.7-4.4 1.1-6.6 1.9-18 6.3-37.3 9.8-57.4 9.8s-39.4-3.5-57.4-9.8c-7.4-2.6-14.9-4.2-22.6-5.2v81.6c23.1 6.9 40 28.1 40 53.4 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.3 16.9-46.5 40-53.4v-80.4C48.5 301 0 355.8 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-72-56.8-130.3-128-133.8z"
        ],
        "user-minus": [
            640,
            512,
            [],
            "f503",
            "M624 208H432c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
        ],
        "user-ninja": [
            448,
            512,
            [],
            "f504",
            "M325.4 289.2L224 390.6 122.6 289.2C54 295.3 0 352.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-70.2-54-127.1-122.6-133.2zM32 192c27.3 0 51.8-11.5 69.2-29.7 15.1 53.9 64 93.7 122.8 93.7 70.7 0 128-57.3 128-128S294.7 0 224 0c-50.4 0-93.6 29.4-114.5 71.8C92.1 47.8 64 32 32 32c0 33.4 17.1 62.8 43.1 80-26 17.2-43.1 46.6-43.1 80zm144-96h96c17.7 0 32 14.3 32 32H144c0-17.7 14.3-32 32-32z"
        ],
        "user-nurse": [
            448,
            512,
            [],
            "f82f",
            "M319.41,320,224,415.39,128.59,320C57.1,323.1,0,381.6,0,453.79A58.21,58.21,0,0,0,58.21,512H389.79A58.21,58.21,0,0,0,448,453.79C448,381.6,390.9,323.1,319.41,320ZM224,304A128,128,0,0,0,352,176V65.82a32,32,0,0,0-20.76-30L246.47,4.07a64,64,0,0,0-44.94,0L116.76,35.86A32,32,0,0,0,96,65.82V176A128,128,0,0,0,224,304ZM184,71.67a5,5,0,0,1,5-5h21.67V45a5,5,0,0,1,5-5h16.66a5,5,0,0,1,5,5V66.67H259a5,5,0,0,1,5,5V88.33a5,5,0,0,1-5,5H237.33V115a5,5,0,0,1-5,5H215.67a5,5,0,0,1-5-5V93.33H189a5,5,0,0,1-5-5ZM144,160H304v16a80,80,0,0,1-160,0Z"
        ],
        "user-plus": [
            640,
            512,
            [],
            "f234",
            "M624 208h-64v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v64h-64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
        ],
        "user-secret": [
            448,
            512,
            [],
            "f21b",
            "M383.9 308.3l23.9-62.6c4-10.5-3.7-21.7-15-21.7h-58.5c11-18.9 17.8-40.6 17.8-64v-.3c39.2-7.8 64-19.1 64-31.7 0-13.3-27.3-25.1-70.1-33-9.2-32.8-27-65.8-40.6-82.8-9.5-11.9-25.9-15.6-39.5-8.8l-27.6 13.8c-9 4.5-19.6 4.5-28.6 0L182.1 3.4c-13.6-6.8-30-3.1-39.5 8.8-13.5 17-31.4 50-40.6 82.8-42.7 7.9-70 19.7-70 33 0 12.6 24.8 23.9 64 31.7v.3c0 23.4 6.8 45.1 17.8 64H56.3c-11.5 0-19.2 11.7-14.7 22.3l25.8 60.2C27.3 329.8 0 372.7 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-48.4-25.8-90.4-64.1-114.1zM176 480l-41.6-192 49.6 32 24 40-32 120zm96 0l-32-120 24-40 49.6-32L272 480zm41.7-298.5c-3.9 11.9-7 24.6-16.5 33.4-10.1 9.3-48 22.4-64-25-2.8-8.4-15.4-8.4-18.3 0-17 50.2-56 32.4-64 25-9.5-8.8-12.7-21.5-16.5-33.4-.8-2.5-6.3-5.7-6.3-5.8v-10.8c28.3 3.6 61 5.8 96 5.8s67.7-2.1 96-5.8v10.8c-.1.1-5.6 3.2-6.4 5.8z"
        ],
        "user-shield": [
            640,
            512,
            [],
            "f505",
            "M622.3 271.1l-115.2-45c-4.1-1.6-12.6-3.7-22.2 0l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 9.6 3.7 18 1.6 22.2 0C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM496 462.4V273.3l95.5 37.3c-5.6 87.1-60.9 135.4-95.5 151.8zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm96 40c0-2.5.8-4.8 1.1-7.2-2.5-.1-4.9-.8-7.5-.8h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c6.8 0 13.3-1.5 19.2-4-54-42.9-99.2-116.7-99.2-212z"
        ],
        "user-slash": [
            640,
            512,
            [],
            "f506",
            "M633.8 458.1L362.3 248.3C412.1 230.7 448 183.8 448 128 448 57.3 390.7 0 320 0c-67.1 0-121.5 51.8-126.9 117.4L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM96 422.4V464c0 26.5 21.5 48 48 48h350.2L207.4 290.3C144.2 301.3 96 356 96 422.4z"
        ],
        "user-tag": [
            640,
            512,
            [],
            "f507",
            "M630.6 364.9l-90.3-90.2c-12-12-28.3-18.7-45.3-18.7h-79.3c-17.7 0-32 14.3-32 32v79.2c0 17 6.7 33.2 18.7 45.2l90.3 90.2c12.5 12.5 32.8 12.5 45.3 0l92.5-92.5c12.6-12.5 12.6-32.7.1-45.2zm-182.8-21c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24c0 13.2-10.7 24-24 24zm-223.8-88c70.7 0 128-57.3 128-128C352 57.3 294.7 0 224 0S96 57.3 96 128c0 70.6 57.3 127.9 128 127.9zm127.8 111.2V294c-12.2-3.6-24.9-6.2-38.2-6.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 287.9 0 348.1 0 422.3v41.6c0 26.5 21.5 48 48 48h352c15.5 0 29.1-7.5 37.9-18.9l-58-58c-18.1-18.1-28.1-42.2-28.1-67.9z"
        ],
        "user-tie": [
            448,
            512,
            [],
            "f508",
            "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm95.8 32.6L272 480l-32-136 32-56h-96l32 56-32 136-47.8-191.4C56.9 292 0 350.3 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-72.1-56.9-130.4-128.2-133.8z"
        ],
        "user-times": [
            640,
            512,
            [],
            "f235",
            "M589.6 240l45.6-45.6c6.3-6.3 6.3-16.5 0-22.8l-22.8-22.8c-6.3-6.3-16.5-6.3-22.8 0L544 194.4l-45.6-45.6c-6.3-6.3-16.5-6.3-22.8 0l-22.8 22.8c-6.3 6.3-6.3 16.5 0 22.8l45.6 45.6-45.6 45.6c-6.3 6.3-6.3 16.5 0 22.8l22.8 22.8c6.3 6.3 16.5 6.3 22.8 0l45.6-45.6 45.6 45.6c6.3 6.3 16.5 6.3 22.8 0l22.8-22.8c6.3-6.3 6.3-16.5 0-22.8L589.6 240zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
        ],
        users: [
            640,
            512,
            [],
            "f0c0",
            "M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
        ],
        "users-cog": [
            640,
            512,
            [],
            "f509",
            "M610.5 341.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 368.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm224 32c1.9 0 3.7-.5 5.6-.6 8.3-21.7 20.5-42.1 36.3-59.2 7.4-8 17.9-12.6 28.9-12.6 6.9 0 13.7 1.8 19.6 5.3l7.9 4.6c.8-.5 1.6-.9 2.4-1.4 7-14.6 11.2-30.8 11.2-48 0-61.9-50.1-112-112-112S208 82.1 208 144c0 61.9 50.1 112 112 112zm105.2 194.5c-2.3-1.2-4.6-2.6-6.8-3.9-8.2 4.8-15.3 9.8-27.5 9.8-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-10.7-34.5 24.9-49.7 25.8-50.3-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-3.8-2.2-7-5-9.8-8.1-3.3.2-6.5.6-9.8.6-24.6 0-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h255.4c-3.7-6-6.2-12.8-6.2-20.3v-9.2zM173.1 274.6C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
        ],
        "users-slash": [
            640,
            512,
            [],
            "e073",
            "M132.65,212.32,36.21,137.78A63.4,63.4,0,0,0,32,160a63.84,63.84,0,0,0,100.65,52.32Zm40.44,62.28A63.79,63.79,0,0,0,128,256H64A64.06,64.06,0,0,0,0,320v32a32,32,0,0,0,32,32H97.91A146.62,146.62,0,0,1,173.09,274.6ZM544,224a64,64,0,1,0-64-64A64.06,64.06,0,0,0,544,224ZM500.56,355.11a114.24,114.24,0,0,0-84.47-65.28L361,247.23c41.46-16.3,71-55.92,71-103.23A111.93,111.93,0,0,0,320,32c-57.14,0-103.69,42.83-110.6,98.08L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM128,403.21V432a48,48,0,0,0,48,48H464a47.45,47.45,0,0,0,12.57-1.87L232,289.13C173.74,294.83,128,343.42,128,403.21ZM576,256H512a63.79,63.79,0,0,0-45.09,18.6A146.29,146.29,0,0,1,542,384h66a32,32,0,0,0,32-32V320A64.06,64.06,0,0,0,576,256Z"
        ],
        "utensil-spoon": [
            512,
            512,
            [],
            "f2e5",
            "M480.1 31.9c-55-55.1-164.9-34.5-227.8 28.5-49.3 49.3-55.1 110-28.8 160.4L9 413.2c-11.6 10.5-12.1 28.5-1 39.5L59.3 504c11 11 29.1 10.5 39.5-1.1l192.4-214.4c50.4 26.3 111.1 20.5 160.4-28.8 63-62.9 83.6-172.8 28.5-227.8z"
        ],
        utensils: [
            416,
            512,
            [],
            "f2e7",
            "M207.9 15.2c.8 4.7 16.1 94.5 16.1 128.8 0 52.3-27.8 89.6-68.9 104.6L168 486.7c.7 13.7-10.2 25.3-24 25.3H80c-13.7 0-24.7-11.5-24-25.3l12.9-238.1C27.7 233.6 0 196.2 0 144 0 109.6 15.3 19.9 16.1 15.2 19.3-5.1 61.4-5.4 64 16.3v141.2c1.3 3.4 15.1 3.2 16 0 1.4-25.3 7.9-139.2 8-141.8 3.3-20.8 44.7-20.8 47.9 0 .2 2.7 6.6 116.5 8 141.8.9 3.2 14.8 3.4 16 0V16.3c2.6-21.6 44.8-21.4 48-1.1zm119.2 285.7l-15 185.1c-1.2 14 9.9 26 23.9 26h56c13.3 0 24-10.7 24-24V24c0-13.2-10.7-24-24-24-82.5 0-221.4 178.5-64.9 300.9z"
        ],
        "vector-square": [
            512,
            512,
            [],
            "f5cb",
            "M512 128V32c0-17.67-14.33-32-32-32h-96c-17.67 0-32 14.33-32 32H160c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32v192c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32h192c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32V160c17.67 0 32-14.33 32-32zm-96-64h32v32h-32V64zM64 64h32v32H64V64zm32 384H64v-32h32v32zm352 0h-32v-32h32v32zm-32-96h-32c-17.67 0-32 14.33-32 32v32H160v-32c0-17.67-14.33-32-32-32H96V160h32c17.67 0 32-14.33 32-32V96h192v32c0 17.67 14.33 32 32 32h32v192z"
        ],
        venus: [
            288,
            512,
            [],
            "f221",
            "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
        ],
        "venus-double": [
            512,
            512,
            [],
            "f226",
            "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80zm336 140.4V368h36c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-36v36c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-36h-36c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h36v-51.6c-21.2-4.8-40.6-14.3-57.2-27.3 14-16.7 25-36 32.1-57.1 14.5 14.8 34.7 24 57.1 24 44.1 0 80-35.9 80-80s-35.9-80-80-80c-22.3 0-42.6 9.2-57.1 24-7.1-21.1-18-40.4-32.1-57.1C303.4 43.6 334.3 32 368 32c79.5 0 144 64.5 144 144 0 68.5-47.9 125.9-112 140.4z"
        ],
        "venus-mars": [
            576,
            512,
            [],
            "f228",
            "M564 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C422.5 72.1 396.2 64 368 64c-33.7 0-64.6 11.6-89.2 30.9 14 16.7 25 36 32.1 57.1 14.5-14.8 34.7-24 57.1-24 44.1 0 80 35.9 80 80s-35.9 80-80 80c-22.3 0-42.6-9.2-57.1-24-7.1 21.1-18 40.4-32.1 57.1 24.5 19.4 55.5 30.9 89.2 30.9 79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 64C64.5 64 0 128.5 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.6 112-71.9 112-140.4 0-79.5-64.5-144-144-144zm0 224c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
        ],
        vest: [
            448,
            512,
            [],
            "e085",
            "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a24.021,24.021,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A24.021,24.021,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.564A151.518,151.518,0,0,0,224,86.234a151.55,151.55,0,0,0,73.812-19.672L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM131.312,371.312l-48,48a16,16,0,0,1-22.624-22.624l48-48a16,16,0,0,1,22.624,22.624Zm256,48a15.992,15.992,0,0,1-22.624,0l-48-48a16,16,0,0,1,22.624-22.624l48,48A15.993,15.993,0,0,1,387.312,419.312Z"
        ],
        "vest-patches": [
            448,
            512,
            [],
            "e086",
            "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a23.982,23.982,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A23.982,23.982,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.561A151.579,151.579,0,0,0,224,86.234a151.565,151.565,0,0,0,73.811-19.668L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM63.5,272.484a12.01,12.01,0,0,1,17-16.968l15.5,15.5,15.5-15.5a12.01,12.01,0,0,1,17,16.968L112.984,288,128.5,303.516a12.01,12.01,0,0,1-17,16.968L96,304.984l-15.5,15.5a12.01,12.01,0,0,1-17-16.968L79.016,288ZM96,456a40,40,0,1,1,40-40A40,40,0,0,1,96,456ZM359.227,335.785,310.7,336a6.671,6.671,0,0,1-6.7-6.7l.215-48.574A24.987,24.987,0,0,1,331.43,256.1c12.789,1.162,22.129,12.619,22.056,25.419l-.037,5.057,5.051-.037c12.826-.035,24.236,9.275,25.4,22.076A24.948,24.948,0,0,1,359.227,335.785Z"
        ],
        vial: [
            480,
            512,
            [],
            "f492",
            "M477.7 186.1L309.5 18.3c-3.1-3.1-8.2-3.1-11.3 0l-34 33.9c-3.1 3.1-3.1 8.2 0 11.3l11.2 11.1L33 316.5c-38.8 38.7-45.1 102-9.4 143.5 20.6 24 49.5 36 78.4 35.9 26.4 0 52.8-10 72.9-30.1l246.3-245.7 11.2 11.1c3.1 3.1 8.2 3.1 11.3 0l34-33.9c3.1-3 3.1-8.1 0-11.2zM318 256H161l148-147.7 78.5 78.3L318 256z"
        ],
        vials: [
            640,
            512,
            [],
            "f493",
            "M72 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64zm480 384H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM360 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64z"
        ],
        video: [
            576,
            512,
            [],
            "f03d",
            "M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"
        ],
        "video-slash": [
            640,
            512,
            [],
            "f4e2",
            "M633.8 458.1l-55-42.5c15.4-1.4 29.2-13.7 29.2-31.1v-257c0-25.5-29.1-40.4-50.4-25.8L448 177.3v137.2l-32-24.7v-178c0-26.4-21.4-47.8-47.8-47.8H123.9L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4L42.7 82 416 370.6l178.5 138c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.5-6.9 4.2-17-2.8-22.4zM32 400.2c0 26.4 21.4 47.8 47.8 47.8h288.4c11.2 0 21.4-4 29.6-10.5L32 154.7v245.5z"
        ],
        vihara: [
            640,
            512,
            [],
            "f6a7",
            "M632.88 400.71L544 352v-64l55.16-17.69c11.79-5.9 11.79-22.72 0-28.62L480 192v-64l27.31-16.3c7.72-7.72 5.61-20.74-4.16-25.62L320 0 136.85 86.07c-9.77 4.88-11.88 17.9-4.16 25.62L160 128v64L40.84 241.69c-11.79 5.9-11.79 22.72 0 28.62L96 288v64L7.12 400.71c-5.42 3.62-7.7 9.63-7 15.29.62 5.01 3.57 9.75 8.72 12.33L64 448v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48l55.15-19.67c5.16-2.58 8.1-7.32 8.72-12.33.71-5.67-1.57-11.68-6.99-15.29zM224 128h192v64H224v-64zm-64 224v-64h320v64H160z"
        ],
        virus: [
            512,
            512,
            [],
            "e074",
            "M483.55,227.55H462c-50.68,0-76.07-61.27-40.23-97.11L437,115.19A28.44,28.44,0,0,0,396.8,75L381.56,90.22c-35.84,35.83-97.11,10.45-97.11-40.23V28.44a28.45,28.45,0,0,0-56.9,0V50c0,50.68-61.27,76.06-97.11,40.23L115.2,75A28.44,28.44,0,0,0,75,115.19l15.25,15.25c35.84,35.84,10.45,97.11-40.23,97.11H28.45a28.45,28.45,0,1,0,0,56.89H50c50.68,0,76.07,61.28,40.23,97.12L75,396.8A28.45,28.45,0,0,0,115.2,437l15.24-15.25c35.84-35.84,97.11-10.45,97.11,40.23v21.54a28.45,28.45,0,0,0,56.9,0V462c0-50.68,61.27-76.07,97.11-40.23L396.8,437A28.45,28.45,0,0,0,437,396.8l-15.25-15.24c-35.84-35.84-10.45-97.12,40.23-97.12h21.54a28.45,28.45,0,1,0,0-56.89ZM224,272a48,48,0,1,1,48-48A48,48,0,0,1,224,272Zm80,56a24,24,0,1,1,24-24A24,24,0,0,1,304,328Z"
        ],
        "virus-slash": [
            640,
            512,
            [],
            "e075",
            "M114,227.6H92.4C76.7,227.6,64,240.3,64,256s12.7,28.4,28.4,28.4H114c50.7,0,76.1,61.3,40.2,97.1L139,396.8 c-11.5,10.7-12.2,28.7-1.6,40.2s28.7,12.2,40.2,1.6c0.5-0.5,1.1-1,1.6-1.6l15.2-15.2c35.8-35.8,97.1-10.5,97.1,40.2v21.5 c0,15.7,12.8,28.4,28.5,28.4c15.7,0,28.4-12.7,28.4-28.4V462c0-26.6,17-45.9,38.2-53.4l-244.5-189 C133.7,224.7,123.9,227.5,114,227.6z M617,505.8l19.6-25.3c5.4-7,4.2-17-2.8-22.5L470.6,332c4.2-25.4,24.9-47.5,55.4-47.5h21.5 c15.7,0,28.4-12.7,28.4-28.4s-12.7-28.4-28.4-28.4H526c-50.7,0-76.1-61.3-40.2-97.1l15.2-15.3c10.7-11.5,10-29.5-1.6-40.2 c-10.9-10.1-27.7-10.1-38.6,0l-15.2,15.2c-35.8,35.8-97.1,10.5-97.1-40.2V28.5C348.4,12.7,335.7,0,320,0 c-15.7,0-28.4,12.7-28.4,28.4V50c0,50.7-61.3,76.1-97.1,40.2L179.2,75c-11.1-11.1-29.4-10.6-40.5,0.5L45.5,3.4 c-7-5.4-17-4.2-22.5,2.8L3.4,31.5c-5.4,7-4.2,17,2.8,22.5l588.4,454.7C601.5,514.1,611.6,512.8,617,505.8z M335.4,227.5l-62.9-48.6 c4.9-1.8,10.2-2.8,15.4-2.9c26.5,0,48,21.5,48,48C336,225.2,335.5,226.3,335.4,227.5z"
        ],
        viruses: [
            640,
            512,
            [],
            "e076",
            "M624,352H611.88c-28.51,0-42.79-34.47-22.63-54.63l8.58-8.57a16,16,0,1,0-22.63-22.63l-8.57,8.58C546.47,294.91,512,280.63,512,252.12V240a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.57c20.16,20.16,5.88,54.63-22.63,54.63H368a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.57a16,16,0,1,0,22.63,22.63l8.57-8.58c20.16-20.16,54.63-5.88,54.63,22.63V496a16,16,0,0,0,32,0V483.88c0-28.51,34.47-42.79,54.63-22.63l8.57,8.58a16,16,0,1,0,22.63-22.63l-8.58-8.57C569.09,418.47,583.37,384,611.88,384H624a16,16,0,0,0,0-32ZM480,384a32,32,0,1,1,32-32A32,32,0,0,1,480,384ZM346.51,213.33h16.16a21.33,21.33,0,0,0,0-42.66H346.51c-38,0-57.05-46-30.17-72.84l11.43-11.44A21.33,21.33,0,0,0,297.6,56.23L286.17,67.66c-26.88,26.88-72.84,7.85-72.84-30.17V21.33a21.33,21.33,0,0,0-42.66,0V37.49c0,38-46,57.05-72.84,30.17L86.4,56.23A21.33,21.33,0,0,0,56.23,86.39L67.66,97.83c26.88,26.88,7.85,72.84-30.17,72.84H21.33a21.33,21.33,0,0,0,0,42.66H37.49c38,0,57.05,46,30.17,72.84L56.23,297.6A21.33,21.33,0,1,0,86.4,327.77l11.43-11.43c26.88-26.88,72.84-7.85,72.84,30.17v16.16a21.33,21.33,0,0,0,42.66,0V346.51c0-38,46-57.05,72.84-30.17l11.43,11.43a21.33,21.33,0,0,0,30.17-30.17l-11.43-11.43C289.46,259.29,308.49,213.33,346.51,213.33ZM160,192a32,32,0,1,1,32-32A32,32,0,0,1,160,192Zm80,32a16,16,0,1,1,16-16A16,16,0,0,1,240,224Z"
        ],
        voicemail: [
            640,
            512,
            [],
            "f897",
            "M496 128a144 144 0 0 0-119.74 224H263.74A144 144 0 1 0 144 416h352a144 144 0 0 0 0-288zM64 272a80 80 0 1 1 80 80 80 80 0 0 1-80-80zm432 80a80 80 0 1 1 80-80 80 80 0 0 1-80 80z"
        ],
        "volleyball-ball": [
            512,
            512,
            [],
            "f45f",
            "M231.39 243.48a285.56 285.56 0 0 0-22.7-105.7c-90.8 42.4-157.5 122.4-180.3 216.8a249 249 0 0 0 56.9 81.1 333.87 333.87 0 0 1 146.1-192.2zm-36.9-134.4a284.23 284.23 0 0 0-57.4-70.7c-91 49.8-144.8 152.9-125 262.2 33.4-83.1 98.4-152 182.4-191.5zm187.6 165.1c8.6-99.8-27.3-197.5-97.5-264.4-14.7-1.7-51.6-5.5-98.9 8.5A333.87 333.87 0 0 1 279.19 241a285 285 0 0 0 102.9 33.18zm-124.7 9.5a286.33 286.33 0 0 0-80.2 72.6c82 57.3 184.5 75.1 277.5 47.8a247.15 247.15 0 0 0 42.2-89.9 336.1 336.1 0 0 1-80.9 10.4c-54.6-.1-108.9-14.1-158.6-40.9zm-98.3 99.7c-15.2 26-25.7 54.4-32.1 84.2a247.07 247.07 0 0 0 289-22.1c-112.9 16.1-203.3-24.8-256.9-62.1zm180.3-360.6c55.3 70.4 82.5 161.2 74.6 253.6a286.59 286.59 0 0 0 89.7-14.2c0-2 .3-4 .3-6 0-107.8-68.7-199.1-164.6-233.4z"
        ],
        "volume-down": [
            384,
            512,
            [],
            "f027",
            "M215.03 72.04L126.06 161H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V89.02c0-21.47-25.96-31.98-40.97-16.98zm123.2 108.08c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 229.28 336 242.62 336 257c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.87z"
        ],
        "volume-mute": [
            512,
            512,
            [],
            "f6a9",
            "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zM461.64 256l45.64-45.64c6.3-6.3 6.3-16.52 0-22.82l-22.82-22.82c-6.3-6.3-16.52-6.3-22.82 0L416 210.36l-45.64-45.64c-6.3-6.3-16.52-6.3-22.82 0l-22.82 22.82c-6.3 6.3-6.3 16.52 0 22.82L370.36 256l-45.63 45.63c-6.3 6.3-6.3 16.52 0 22.82l22.82 22.82c6.3 6.3 16.52 6.3 22.82 0L416 301.64l45.64 45.64c6.3 6.3 16.52 6.3 22.82 0l22.82-22.82c6.3-6.3 6.3-16.52 0-22.82L461.64 256z"
        ],
        "volume-off": [
            256,
            512,
            [],
            "f026",
            "M215 71l-89 89H24a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24h102.06L215 441c15 15 41 4.47 41-17V88c0-21.47-26-32-41-17z"
        ],
        "volume-up": [
            576,
            512,
            [],
            "f028",
            "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zm233.32-51.08c-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51 66.27 43.49 105.82 116.6 105.82 195.58 0 78.98-39.55 152.09-105.82 195.58-11.17 7.32-14.29 22.34-6.95 33.5 7.04 10.71 21.93 14.56 33.51 6.95C528.27 439.58 576 351.33 576 256S528.27 72.43 448.35 19.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.54 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z"
        ],
        "vote-yea": [
            640,
            512,
            [],
            "f772",
            "M608 320h-64v64h22.4c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8H96v-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32zm-96 64V64.3c0-17.9-14.5-32.3-32.3-32.3H160.4C142.5 32 128 46.5 128 64.3V384h384zM211.2 202l25.5-25.3c4.2-4.2 11-4.2 15.2.1l41.3 41.6 95.2-94.4c4.2-4.2 11-4.2 15.2.1l25.3 25.5c4.2 4.2 4.2 11-.1 15.2L300.5 292c-4.2 4.2-11 4.2-15.2-.1l-74.1-74.7c-4.3-4.2-4.2-11 0-15.2z"
        ],
        "vr-cardboard": [
            640,
            512,
            [],
            "f729",
            "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h160.22c25.19 0 48.03-14.77 58.36-37.74l27.74-61.64C286.21 331.08 302.35 320 320 320s33.79 11.08 41.68 28.62l27.74 61.64C399.75 433.23 422.6 448 447.78 448H608c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM160 304c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm320 0c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64z"
        ],
        walking: [
            320,
            512,
            [],
            "f554",
            "M208 96c26.5 0 48-21.5 48-48S234.5 0 208 0s-48 21.5-48 48 21.5 48 48 48zm94.5 149.1l-23.3-11.8-9.7-29.4c-14.7-44.6-55.7-75.8-102.2-75.9-36-.1-55.9 10.1-93.3 25.2-21.6 8.7-39.3 25.2-49.7 46.2L17.6 213c-7.8 15.8-1.5 35 14.2 42.9 15.6 7.9 34.6 1.5 42.5-14.3L81 228c3.5-7 9.3-12.5 16.5-15.4l26.8-10.8-15.2 60.7c-5.2 20.8.4 42.9 14.9 58.8l59.9 65.4c7.2 7.9 12.3 17.4 14.9 27.7l18.3 73.3c4.3 17.1 21.7 27.6 38.8 23.3 17.1-4.3 27.6-21.7 23.3-38.8l-22.2-89c-2.6-10.3-7.7-19.9-14.9-27.7l-45.5-49.7 17.2-68.7 5.5 16.5c5.3 16.1 16.7 29.4 31.7 37l23.3 11.8c15.6 7.9 34.6 1.5 42.5-14.3 7.7-15.7 1.4-35.1-14.3-43zM73.6 385.8c-3.2 8.1-8 15.4-14.2 21.5l-50 50.1c-12.5 12.5-12.5 32.8 0 45.3s32.7 12.5 45.2 0l59.4-59.4c6.1-6.1 10.9-13.4 14.2-21.5l13.5-33.8c-55.3-60.3-38.7-41.8-47.4-53.7l-20.7 51.5z"
        ],
        wallet: [
            512,
            512,
            [],
            "f555",
            "M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        warehouse: [
            640,
            512,
            [],
            "f494",
            "M504 352H136.4c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 96H136.1c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0-192H136.6c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm106.5-139L338.4 3.7a48.15 48.15 0 0 0-36.9 0L29.5 117C11.7 124.5 0 141.9 0 161.3V504c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V256c0-17.6 14.6-32 32.6-32h382.8c18 0 32.6 14.4 32.6 32v248c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V161.3c0-19.4-11.7-36.8-29.5-44.3z"
        ],
        water: [
            576,
            512,
            [],
            "f773",
            "M562.1 383.9c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144C540.6 93.4 520 85.4 504.2 73 490.1 61.9 470 61.7 456 73c-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3z"
        ],
        "wave-square": [
            640,
            512,
            [],
            "f83e",
            "M476 480H324a36 36 0 0 1-36-36V96h-96v156a36 36 0 0 1-36 36H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h112V68a36 36 0 0 1 36-36h152a36 36 0 0 1 36 36v348h96V260a36 36 0 0 1 36-36h140a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H512v156a36 36 0 0 1-36 36z"
        ],
        weight: [
            512,
            512,
            [],
            "f496",
            "M448 64h-25.98C438.44 92.28 448 125.01 448 160c0 105.87-86.13 192-192 192S64 265.87 64 160c0-34.99 9.56-67.72 25.98-96H64C28.71 64 0 92.71 0 128v320c0 35.29 28.71 64 64 64h384c35.29 0 64-28.71 64-64V128c0-35.29-28.71-64-64-64zM256 320c88.37 0 160-71.63 160-160S344.37 0 256 0 96 71.63 96 160s71.63 160 160 160zm-.3-151.94l33.58-78.36c3.5-8.17 12.94-11.92 21.03-8.41 8.12 3.48 11.88 12.89 8.41 21l-33.67 78.55C291.73 188 296 197.45 296 208c0 22.09-17.91 40-40 40s-40-17.91-40-40c0-21.98 17.76-39.77 39.7-39.94z"
        ],
        "weight-hanging": [
            512,
            512,
            [],
            "f5cd",
            "M510.28 445.86l-73.03-292.13c-3.8-15.19-16.44-25.72-30.87-25.72h-60.25c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96s-96 42.98-96 96c0 11.28 2.3 21.95 5.88 32h-60.25c-14.43 0-27.08 10.54-30.87 25.72L1.72 445.86C-6.61 479.17 16.38 512 48.03 512h415.95c31.64 0 54.63-32.83 46.3-66.14zM256 128c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"
        ],
        wheelchair: [
            512,
            512,
            [],
            "f193",
            "M496.101 385.669l14.227 28.663c3.929 7.915.697 17.516-7.218 21.445l-65.465 32.886c-16.049 7.967-35.556 1.194-43.189-15.055L331.679 320H192c-15.925 0-29.426-11.71-31.679-27.475C126.433 55.308 128.38 70.044 128 64c0-36.358 30.318-65.635 67.052-63.929 33.271 1.545 60.048 28.905 60.925 62.201.868 32.933-23.152 60.423-54.608 65.039l4.67 32.69H336c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H215.182l4.572 32H352a32 32 0 0 1 28.962 18.392L438.477 396.8l36.178-18.349c7.915-3.929 17.517-.697 21.446 7.218zM311.358 352h-24.506c-7.788 54.204-54.528 96-110.852 96-61.757 0-112-50.243-112-112 0-41.505 22.694-77.809 56.324-97.156-3.712-25.965-6.844-47.86-9.488-66.333C45.956 198.464 0 261.963 0 336c0 97.047 78.953 176 176 176 71.87 0 133.806-43.308 161.11-105.192L311.358 352z"
        ],
        wifi: [
            640,
            512,
            [],
            "f1eb",
            "M634.91 154.88C457.74-8.99 182.19-8.93 5.09 154.88c-6.66 6.16-6.79 16.59-.35 22.98l34.24 33.97c6.14 6.1 16.02 6.23 22.4.38 145.92-133.68 371.3-133.71 517.25 0 6.38 5.85 16.26 5.71 22.4-.38l34.24-33.97c6.43-6.39 6.3-16.82-.36-22.98zM320 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm202.67-83.59c-115.26-101.93-290.21-101.82-405.34 0-6.9 6.1-7.12 16.69-.57 23.15l34.44 33.99c6 5.92 15.66 6.32 22.05.8 83.95-72.57 209.74-72.41 293.49 0 6.39 5.52 16.05 5.13 22.05-.8l34.44-33.99c6.56-6.46 6.33-17.06-.56-23.15z"
        ],
        wind: [
            512,
            512,
            [],
            "f72e",
            "M156.7 256H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h142.2c15.9 0 30.8 10.9 33.4 26.6 3.3 20-12.1 37.4-31.6 37.4-14.1 0-26.1-9.2-30.4-21.9-2.1-6.3-8.6-10.1-15.2-10.1H81.6c-9.8 0-17.7 8.8-15.9 18.4 8.6 44.1 47.6 77.6 94.2 77.6 57.1 0 102.7-50.1 95.2-108.6C249 291 205.4 256 156.7 256zM16 224h336c59.7 0 106.8-54.8 93.8-116.7-7.6-36.2-36.9-65.5-73.1-73.1-55.4-11.6-105.1 24.9-114.9 75.5-1.9 9.6 6.1 18.3 15.8 18.3h32.8c6.7 0 13.1-3.8 15.2-10.1C325.9 105.2 337.9 96 352 96c19.4 0 34.9 17.4 31.6 37.4-2.6 15.7-17.4 26.6-33.4 26.6H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm384 32H243.7c19.3 16.6 33.2 38.8 39.8 64H400c26.5 0 48 21.5 48 48s-21.5 48-48 48c-17.9 0-33.3-9.9-41.6-24.4-2.9-5-8.7-7.6-14.5-7.6h-33.8c-10.9 0-19 10.8-15.3 21.1 17.8 50.6 70.5 84.8 129.4 72.3 41.2-8.7 75.1-41.6 84.7-82.7C526 321.5 470.5 256 400 256z"
        ],
        "window-close": [
            512,
            512,
            [],
            "f410",
            "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-83.6 290.5c4.8 4.8 4.8 12.6 0 17.4l-40.5 40.5c-4.8 4.8-12.6 4.8-17.4 0L256 313.3l-66.5 67.1c-4.8 4.8-12.6 4.8-17.4 0l-40.5-40.5c-4.8-4.8-4.8-12.6 0-17.4l67.1-66.5-67.1-66.5c-4.8-4.8-4.8-12.6 0-17.4l40.5-40.5c4.8-4.8 12.6-4.8 17.4 0l66.5 67.1 66.5-67.1c4.8-4.8 12.6-4.8 17.4 0l40.5 40.5c4.8 4.8 4.8 12.6 0 17.4L313.3 256l67.1 66.5z"
        ],
        "window-maximize": [
            512,
            512,
            [],
            "f2d0",
            "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16 160H64v-84c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12v84z"
        ],
        "window-minimize": [
            512,
            512,
            [],
            "f2d1",
            "M464 352H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48z"
        ],
        "window-restore": [
            512,
            512,
            [],
            "f2d2",
            "M512 48v288c0 26.5-21.5 48-48 48h-48V176c0-44.1-35.9-80-80-80H128V48c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zM384 176v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zm-68 28c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12v52h252v-52z"
        ],
        "wine-bottle": [
            512,
            512,
            [],
            "f72f",
            "M507.31 72.57L439.43 4.69c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l-76.67 76.67c-46.58-19.7-102.4-10.73-140.37 27.23L18.75 312.23c-24.99 24.99-24.99 65.52 0 90.51l90.51 90.51c24.99 24.99 65.52 24.99 90.51 0l158.39-158.39c37.96-37.96 46.93-93.79 27.23-140.37l76.67-76.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.24-6.24 6.24-16.37-.01-22.62zM179.22 423.29l-90.51-90.51 122.04-122.04 90.51 90.51-122.04 122.04z"
        ],
        "wine-glass": [
            288,
            512,
            [],
            "f4e3",
            "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40z"
        ],
        "wine-glass-alt": [
            288,
            512,
            [],
            "f5ce",
            "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM61.75 48h164.5l7.17 80H54.58l7.17-80z"
        ],
        "won-sign": [
            576,
            512,
            [],
            "f159",
            "M564 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-48l18.6-80.6c1.7-7.5-4-14.7-11.7-14.7h-46.1c-5.7 0-10.6 4-11.7 9.5L450.7 128H340.8l-19.7-86c-1.3-5.5-6.1-9.3-11.7-9.3h-44c-5.6 0-10.4 3.8-11.7 9.3l-20 86H125l-17.5-85.7c-1.1-5.6-6.1-9.6-11.8-9.6H53.6c-7.7 0-13.4 7.1-11.7 14.6L60 128H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h62.3l7.2 32H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h83.9l40.9 182.6c1.2 5.5 6.1 9.4 11.7 9.4h56.8c5.6 0 10.4-3.9 11.7-9.3L259.3 288h55.1l42.4 182.7c1.3 5.4 6.1 9.3 11.7 9.3h56.8c5.6 0 10.4-3.9 11.7-9.3L479.1 288H564c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-70.1l7.4-32zM183.8 342c-6.2 25.8-6.8 47.2-7.3 47.2h-1.1s-1.7-22-6.8-47.2l-11-54h38.8zm27.5-118h-66.8l-6.5-32h80.8zm62.9 0l2-8.6c1.9-8 3.5-16 4.8-23.4h11.8c1.3 7.4 2.9 15.4 4.8 23.4l2 8.6zm130.9 118c-5.1 25.2-6.8 47.2-6.8 47.2h-1.1c-.6 0-1.1-21.4-7.3-47.2l-12.4-54h39.1zm25.2-118h-67.4l-7.3-32h81.6z"
        ],
        wrench: [
            512,
            512,
            [],
            "f0ad",
            "M507.73 109.1c-2.24-9.03-13.54-12.09-20.12-5.51l-74.36 74.36-67.88-11.31-11.31-67.88 74.36-74.36c6.62-6.62 3.43-17.9-5.66-20.16-47.38-11.74-99.55.91-136.58 37.93-39.64 39.64-50.55 97.1-34.05 147.2L18.74 402.76c-24.99 24.99-24.99 65.51 0 90.5 24.99 24.99 65.51 24.99 90.5 0l213.21-213.21c50.12 16.71 107.47 5.68 147.37-34.22 37.07-37.07 49.7-89.32 37.91-136.73zM64 472c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
        ],
        "x-ray": [
            640,
            512,
            [],
            "f497",
            "M240 384c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm160 32c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM624 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zm0 448h-48V96H64v352H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM480 248c0 4.4-3.6 8-8 8H336v32h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h64c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48v-16h-64v16c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48h64v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-32H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h136v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-24c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v24h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h136c4.4 0 8 3.6 8 8v16z"
        ],
        "yen-sign": [
            384,
            512,
            [],
            "f157",
            "M351.2 32h-65.3c-4.6 0-8.8 2.6-10.8 6.7l-55.4 113.2c-14.5 34.7-27.1 71.9-27.1 71.9h-1.3s-12.6-37.2-27.1-71.9L108.8 38.7c-2-4.1-6.2-6.7-10.8-6.7H32.8c-9.1 0-14.8 9.7-10.6 17.6L102.3 200H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h88.2l19.8 37.2V320H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h108v92c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12v-92h108c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12H232v-26.8l19.8-37.2H340c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12h-58.3l80.1-150.4c4.3-7.9-1.5-17.6-10.6-17.6z"
        ],
        "yin-yang": [
            496,
            512,
            [],
            "f6ad",
            "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 376c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-128c-53.02 0-96 42.98-96 96s42.98 96 96 96c-106.04 0-192-85.96-192-192S141.96 64 248 64c53.02 0 96 42.98 96 96s-42.98 96-96 96zm0-128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
        ]
    };
    bunker(function() {
        defineIcons('fas', icons);
    });
})();



var $1X8yh = parcelRequire("1X8yh");
window.$ = window.jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)));
(0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))(document).ready(function() {
    iFrameResize({}, document.querySelector('#contactform'));
    (0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))('.doc table').each(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))(this).wrap('<div class="table-wrapper">');
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))(document).on('click', 'figure.can-fullscreen', function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))(this).toggleClass('is-fullscreen');
    });
    // Scroll animation effects
    $195ce12f58f56e1b$export$2cd8252107eb640b();
    // n8n Chat
    var i18n;
    var initialMessages;
    if (document.documentElement.lang === 'de') {
        i18n = {
            en: {
                title: 'integraid Chat',
                subtitle: '',
                footer: '',
                getStarted: 'Klicke hier, um unsere Datenschutzbestimmungen zu akzeptieren. Wir nutzen KI, um Deine Fragen zu beantworten.',
                inputPlaceholder: 'Gib deine Frage ein..'
            }
        };
        initialMessages = [
            "\uD83D\uDC4B Hallo! Wie k\xf6nnen wir Dir helfen?"
        ];
    } else {
        i18n = {
            en: {
                title: 'integraid Chat',
                subtitle: '',
                footer: '',
                getStarted: 'Click here to accept our privacy policy. We use AI to answer your questions.',
                inputPlaceholder: 'Type your question..'
            }
        };
        initialMessages = [
            "\uD83D\uDC4B Hello! How can we assist you?"
        ];
    }
    (0, $1X8yh.createChat)({
        webhookUrl: 'https://cloudworx.app.n8n.cloud/webhook/4aaac05d-418e-4927-a97a-584a98e571f9/chat',
        showWelcomeScreen: true,
        defaultLanguage: 'en',
        i18n: i18n,
        initialMessages: initialMessages,
        metadata: {
            initialLanguage: document.documentElement.lang,
            pageUrl: window.location.href,
            pageDomain: window.location.hostname
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))('.slick').each(function() {
        var slider = (0, (/*@__PURE__*/$parcel$interopDefault($7gZDx)))(this);
        slider.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: slider.siblings('.slick-arrow-left'),
            nextArrow: slider.siblings('.slick-arrow-right'),
            draggable: true,
            speed: 750,
            autoplaySpeed: 5000
        });
    });
});

})();
//# sourceMappingURL=app.js.map
